/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(822);
	
	var _es6Promise = __webpack_require__(179);
	
	__webpack_require__(815);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(419);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	(0, _es6Promise.polyfill)();
	__webpack_require__(461).polyfill();
	// import { AppContainer } from 'react-hot-loader';
	
	var element = document.getElementById('content');
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), element);
	
	document.body.classList.remove('loading');
	
	// Hot Module Replacement API
	/*if (module.hot) {
	  module.hot.accept('./App', () => {
	    const NextApp = require('./App').default;
	    ReactDOM.render(
	      <AppContainer>
	        <NextApp/>
	      </AppContainer>,
	      element
	    );
	  });
	}*/
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(element, 'element', '/Volumes/gitws/GroGuru.git/frontyard/src/js/index.js');
	}();

	;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(79);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(585)();
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.27.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(583)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged and will be removed in an upcoming major release. Please refer to ' +
	            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.27.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isArray = exports.first = exports.overlayColors = exports.TOUCHEND = exports.TOUCHMOVE = exports.MOUSEUP = exports.MOUSEMOVE = exports.MOUSELEAVE = exports.MOUSEENTER = exports.yes = exports.PureComponent = exports.accumulatingWindow = exports.mappedSlidingWindow = exports.shallowEqual = exports.noop = exports.identity = exports.slidingWindow = exports.merge = exports.zipper = exports.rebind = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _rebind = __webpack_require__(786);
	
	Object.defineProperty(exports, "rebind", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_rebind).default;
		}
	});
	
	var _zipper = __webpack_require__(405);
	
	Object.defineProperty(exports, "zipper", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_zipper).default;
		}
	});
	
	var _merge = __webpack_require__(785);
	
	Object.defineProperty(exports, "merge", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_merge).default;
		}
	});
	
	var _slidingWindow = __webpack_require__(787);
	
	Object.defineProperty(exports, "slidingWindow", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_slidingWindow).default;
		}
	});
	
	var _identity = __webpack_require__(96);
	
	Object.defineProperty(exports, "identity", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_identity).default;
		}
	});
	
	var _noop = __webpack_require__(97);
	
	Object.defineProperty(exports, "noop", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_noop).default;
		}
	});
	
	var _shallowEqual = __webpack_require__(404);
	
	Object.defineProperty(exports, "shallowEqual", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_shallowEqual).default;
		}
	});
	
	var _mappedSlidingWindow = __webpack_require__(784);
	
	Object.defineProperty(exports, "mappedSlidingWindow", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_mappedSlidingWindow).default;
		}
	});
	
	var _accumulatingWindow = __webpack_require__(782);
	
	Object.defineProperty(exports, "accumulatingWindow", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_accumulatingWindow).default;
		}
	});
	
	var _PureComponent = __webpack_require__(167);
	
	Object.defineProperty(exports, "PureComponent", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_PureComponent).default;
		}
	});
	
	var _barWidth = __webpack_require__(783);
	
	Object.keys(_barWidth).forEach(function (key) {
		if (key === "default" || key === "__esModule") return;
		Object.defineProperty(exports, key, {
			enumerable: true,
			get: function get() {
				return _barWidth[key];
			}
		});
	});
	
	var _strokeDasharray = __webpack_require__(788);
	
	Object.keys(_strokeDasharray).forEach(function (key) {
		if (key === "default" || key === "__esModule") return;
		Object.defineProperty(exports, key, {
			enumerable: true,
			get: function get() {
				return _strokeDasharray[key];
			}
		});
	});
	exports.getLogger = getLogger;
	exports.sign = sign;
	exports.path = path;
	exports.functor = functor;
	exports.createVerticalLinearGradient = createVerticalLinearGradient;
	exports.getClosestItemIndexes2 = getClosestItemIndexes2;
	exports.degrees = degrees;
	exports.radians = radians;
	exports.getClosestValue = getClosestValue;
	exports.find = find;
	exports.d3Window = d3Window;
	exports.getTouchProps = getTouchProps;
	exports.getClosestItemIndexes = getClosestItemIndexes;
	exports.getClosestItem = getClosestItem;
	exports.head = head;
	exports.tail = tail;
	exports.last = last;
	exports.isDefined = isDefined;
	exports.isNotDefined = isNotDefined;
	exports.isObject = isObject;
	exports.touchPosition = touchPosition;
	exports.mousePosition = mousePosition;
	exports.clearCanvas = clearCanvas;
	exports.capitalizeFirst = capitalizeFirst;
	exports.hexToRGBA = hexToRGBA;
	exports.toObject = toObject;
	exports.mapValue = mapValue;
	exports.mapObject = mapObject;
	exports.replaceAtIndex = replaceAtIndex;
	exports.forOwn = forOwn;
	
	var _d3Scale = __webpack_require__(83);
	
	var _d3Array = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getLogger(prefix) {
		var logger = _noop2.default;
		if (false) {
			logger = require("debug")("react-stockcharts:" + prefix);
		}
		return logger;
	}
	
	function sign(x) {
		return (x > 0) - (x < 0);
	}
	
	var yes = exports.yes = function yes() {
		return true;
	};
	
	function path() {
		var loc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		var key = Array.isArray(loc) ? loc : [loc];
		var length = key.length;
	
		return function (obj, defaultValue) {
			if (length === 0) return isDefined(obj) ? obj : defaultValue;
	
			var index = 0;
			while (obj != null && index < length) {
				obj = obj[key[index++]];
			}
			return index === length ? obj : defaultValue;
		};
	}
	
	function functor(v) {
		return typeof v === "function" ? v : function () {
			return v;
		};
	}
	
	function createVerticalLinearGradient(stops) {
		return function (moreProps, ctx) {
			var height = moreProps.chartConfig.height;
	
	
			var grd = ctx.createLinearGradient(0, height, 0, 0);
			stops.forEach(function (each) {
				grd.addColorStop(each.stop, each.color);
			});
	
			return grd;
		};
	}
	
	function getClosestItemIndexes2(array, value, accessor) {
		var left = (0, _d3Array.bisector)(accessor).left(array, value);
		left = Math.max(left - 1, 0);
		var right = Math.min(left + 1, array.length - 1);
	
		var item = accessor(array[left]);
		if (item >= value && item <= value) right = left;
	
		return { left: left, right: right };
	}
	
	function degrees(radians) {
		return radians * 180 / Math.PI;
	}
	
	function radians(degrees) {
		return degrees * Math.PI / 180;
	}
	
	function getClosestValue(inputValue, currentValue) {
		var values = isArray(inputValue) ? inputValue : [inputValue];
	
		var diff = values.map(function (each) {
			return each - currentValue;
		}).reduce(function (diff1, diff2) {
			return Math.abs(diff1) < Math.abs(diff2) ? diff1 : diff2;
		});
		return currentValue + diff;
	}
	
	function find(list, predicate) {
		var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
	
		for (var i = 0; i < list.length; ++i) {
			if (predicate.call(context, list[i], i, list)) {
				return list[i];
			}
		}
		return undefined;
	}
	
	function d3Window(node) {
		var d3win = node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
		return d3win;
	}
	
	var MOUSEENTER = exports.MOUSEENTER = "mouseenter.interaction";
	var MOUSELEAVE = exports.MOUSELEAVE = "mouseleave.interaction";
	var MOUSEMOVE = exports.MOUSEMOVE = "mousemove.pan";
	var MOUSEUP = exports.MOUSEUP = "mouseup.pan";
	var TOUCHMOVE = exports.TOUCHMOVE = "touchmove.pan";
	var TOUCHEND = exports.TOUCHEND = "touchend.pan touchcancel.pan";
	
	function getTouchProps(touch) {
		if (!touch) return {};
		return {
			pageX: touch.pageX,
			pageY: touch.pageY,
			clientX: touch.clientX,
			clientY: touch.clientY
		};
	}
	
	function getClosestItemIndexes(array, value, accessor, log) {
		var lo = 0,
		    hi = array.length - 1;
		while (hi - lo > 1) {
			var mid = Math.round((lo + hi) / 2);
			if (accessor(array[mid]) <= value) {
				lo = mid;
			} else {
				hi = mid;
			}
		}
		// for Date object === does not work, so using the <= in combination with >=
		// the same code works for both dates and numbers
		if (accessor(array[lo]).valueOf() === value.valueOf()) hi = lo;
		if (accessor(array[hi]).valueOf() === value.valueOf()) lo = hi;
	
		if (accessor(array[lo]) < value && accessor(array[hi]) < value) lo = hi;
		if (accessor(array[lo]) > value && accessor(array[hi]) > value) hi = lo;
	
		if (log) {}
		// console.log(lo, accessor(array[lo]), value, accessor(array[hi]), hi);
		// console.log(accessor(array[lo]), lo, value, accessor(array[lo]) >= value);
		// console.log(value, hi, accessor(array[hi]), accessor(array[lo]) <= value);
	
		// var left = value > accessor(array[lo]) ? lo : lo;
		// var right = gte(value, accessor(array[hi])) ? Math.min(hi + 1, array.length - 1) : hi;
	
		// console.log(value, accessor(array[left]), accessor(array[right]));
		return { left: lo, right: hi };
	}
	
	function getClosestItem(array, value, accessor, log) {
		var _getClosestItemIndexe = getClosestItemIndexes(array, value, accessor, log),
		    left = _getClosestItemIndexe.left,
		    right = _getClosestItemIndexe.right;
	
		if (left === right) {
			return array[left];
		}
	
		var closest = Math.abs(accessor(array[left]) - value) < Math.abs(accessor(array[right]) - value) ? array[left] : array[right];
		if (log) {
			console.log(array[left], array[right], closest, left, right);
		}
		return closest;
	}
	
	var overlayColors = exports.overlayColors = (0, _d3Scale.scaleOrdinal)(_d3Scale.schemeCategory10);
	
	function head(array, accessor) {
		if (accessor && array) {
			var value = void 0;
			for (var i = 0; i < array.length; i++) {
				value = array[i];
				if (isDefined(accessor(value))) return value;
			}
			return undefined;
		}
		return array ? array[0] : undefined;
	}
	
	function tail(array, accessor) {
		if (accessor && array) {
			return array.map(accessor).slice(1);
		}
		return array ? array.slice(1) : undefined;
	}
	
	var first = exports.first = head;
	
	function last(array, accessor) {
		if (accessor && array) {
			var value = void 0;
			for (var i = array.length - 1; i >= 0; i--) {
				value = array[i];
				if (isDefined(accessor(value))) return value;
			}
			return undefined;
		}
		var length = array ? array.length : 0;
		return length ? array[length - 1] : undefined;
	}
	
	function isDefined(d) {
		return d !== null && typeof d != "undefined";
	}
	
	function isNotDefined(d) {
		return !isDefined(d);
	}
	
	function isObject(d) {
		return isDefined(d) && (typeof d === "undefined" ? "undefined" : _typeof(d)) === "object" && !Array.isArray(d);
	}
	
	var isArray = exports.isArray = Array.isArray;
	
	function touchPosition(touch, e) {
		var container = e.target,
		    rect = container.getBoundingClientRect(),
		    x = touch.clientX - rect.left - container.clientLeft,
		    y = touch.clientY - rect.top - container.clientTop,
		    xy = [Math.round(x), Math.round(y)];
		return xy;
	}
	
	function mousePosition(e, defaultRect) {
		var container = e.currentTarget;
		var rect = defaultRect || container.getBoundingClientRect(),
		    x = e.clientX - rect.left - container.clientLeft,
		    y = e.clientY - rect.top - container.clientTop,
		    xy = [Math.round(x), Math.round(y)];
		return xy;
	}
	
	function clearCanvas(canvasList, ratio) {
		canvasList.forEach(function (each) {
			each.setTransform(1, 0, 0, 1, 0, 0);
			each.clearRect(-1, -1, each.canvas.width + 2, each.canvas.height + 2);
			each.scale(ratio, ratio);
		});
	}
	
	function capitalizeFirst(str) {
		return str.charAt(0).toUpperCase() + str.substring(1);
	}
	
	function hexToRGBA(inputHex, opacity) {
		var hex = inputHex.replace("#", "");
		if (inputHex.indexOf("#") > -1 && (hex.length === 3 || hex.length === 6)) {
	
			var multiplier = hex.length === 3 ? 1 : 2;
	
			var r = parseInt(hex.substring(0, 1 * multiplier), 16);
			var g = parseInt(hex.substring(1 * multiplier, 2 * multiplier), 16);
			var b = parseInt(hex.substring(2 * multiplier, 3 * multiplier), 16);
	
			var result = "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
	
			return result;
		}
		return inputHex;
	}
	
	function toObject(array) {
		var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	
		return array.reduce(function (returnObj, a) {
			var _iteratee = iteratee(a),
			    _iteratee2 = _slicedToArray(_iteratee, 2),
			    key = _iteratee2[0],
			    value = _iteratee2[1];
	
			return _extends({}, returnObj, _defineProperty({}, key, value));
		}, {});
	}
	
	// copied from https://github.com/lodash/lodash/blob/master/mapValue.js
	function mapValue(object, iteratee) {
		object = Object(object);
		// eslint-disable-next-line prefer-const
		var result = {};
	
		Object.keys(object).forEach(function (key) {
			var mappedValue = iteratee(object[key], key, object);
	
			if (isDefined(mappedValue)) {
				result[key] = mappedValue;
			}
		});
		return result;
	}
	
	// copied from https://github.com/lodash/lodash/blob/master/mapObject.js
	function mapObject() {
		var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	
		var props = Object.keys(object);
	
		// eslint-disable-next-line prefer-const
		var result = new Array(props.length);
	
		props.forEach(function (key, index) {
			result[index] = iteratee(object[key], key, object);
		});
		return result;
	}
	
	function replaceAtIndex(array, index, value) {
		if (isDefined(array) && array.length > index) {
			return array.slice(0, index).concat(value).concat(array.slice(index + 1));
		}
		return array;
	}
	
	// copied from https://github.com/lodash/lodash/blob/master/forOwn.js
	function forOwn(obj, iteratee) {
		var object = Object(obj);
		Object.keys(object).forEach(function (key) {
			return iteratee(object[key], key, object);
		});
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2016 Hewlett Packard Enterprise Development LP
	
	var namespace = exports.namespace = 'grommetux-';
	
	exports.default = {
	  ACCORDION: namespace + 'accordion',
	  ACCORDION_PANEL: namespace + 'accordion-panel',
	  ANCHOR: namespace + 'anchor',
	  ANIMATE: namespace + 'animate',
	  APP: namespace + 'app',
	  ARTICLE: namespace + 'article',
	  ATTRIBUTE: namespace + 'attribute',
	  BACKGROUND_COLOR_INDEX: namespace + 'background-color-index',
	  BOX: namespace + 'box',
	  BORDER_COLOR_INDEX: namespace + 'border-color-index',
	  BRICK: namespace + 'brick',
	  BUTTON: namespace + 'button',
	  CALENDAR: namespace + 'calendar',
	  CARD: namespace + 'card',
	  CAROUSEL: namespace + 'carousel',
	  CAROUSEL_CONTROLS: namespace + 'carousel-controls',
	  CHART: namespace + 'chart',
	  CHART_AXIS: namespace + 'chart-axis',
	  CHART_BASE: namespace + 'chart-base',
	  CHART_GRAPH: namespace + 'chart-graph',
	  CHART_GRID: namespace + 'chart-grid',
	  CHART_HOT_SPOTS: namespace + 'chart-hot-spots',
	  CHART_LAYERS: namespace + 'chart-layers',
	  CHART_MARKER: namespace + 'chart-marker',
	  CHART_MARKER_LABEL: namespace + 'chart-marker-label',
	  CHART_RANGE: namespace + 'chart-range',
	  CHECK_BOX: namespace + 'check-box',
	  COLLAPSIBLE: namespace + 'collapsible',
	  COLOR_INDEX: namespace + 'color-index',
	  COLUMNS: namespace + 'columns',
	  CONTROL_ICON: namespace + 'control-icon',
	  DATE_TIME: namespace + 'date-time',
	  DATE_TIME_DROP: namespace + 'date-time-drop',
	  DISTRIBUTION: namespace + 'distribution',
	  DROP: namespace + 'drop',
	  FOOTER: namespace + 'footer',
	  FORM: namespace + 'form',
	  FORM_FIELD: namespace + 'form-field',
	  FORM_FIELDS: namespace + 'form-fields',
	  HEADER: namespace + 'header',
	  HEADING: namespace + 'heading',
	  HEADLINE: namespace + 'headline',
	  HERO: namespace + 'hero',
	  IMAGE: namespace + 'image',
	  IMAGE_FIELD: namespace + 'image-field',
	  INPUT: namespace + 'input',
	  LABEL: namespace + 'label',
	  LAYER: namespace + 'layer',
	  LEGEND: namespace + 'legend',
	  LIST: namespace + 'list',
	  LIST_ITEM: namespace + 'list-item',
	  LOGIN: namespace + 'login',
	  LOGIN_FORM: namespace + 'login-form',
	  LOGO_ICON: namespace + 'logo-icon',
	  MAP: namespace + 'map',
	  MENU: namespace + 'menu',
	  METER: namespace + 'meter',
	  NAMESPACE: '' + namespace,
	  NOTIFICATION: namespace + 'notification',
	  NUMBER_INPUT: namespace + 'number-input',
	  OBJECT: namespace + 'object',
	  PARAGRAPH: namespace + 'paragraph',
	  PASSWORD_INPUT: namespace + 'password-input',
	  PULSE: namespace + 'pulse',
	  QUOTE: namespace + 'quote',
	  RADIO_BUTTON: namespace + 'radio-button',
	  SEARCH: namespace + 'search',
	  SEARCH_INPUT: namespace + 'search-input',
	  SECTION: namespace + 'section',
	  SELECT: namespace + 'select',
	  SIDEBAR: namespace + 'sidebar',
	  SKIP_LINK_ANCHOR: namespace + 'skip-link-anchor',
	  SKIP_LINKS: namespace + 'skip-links',
	  SPLIT: namespace + 'split',
	  SPINNING: namespace + 'icon-spinning',
	  STATUS_ICON: namespace + 'status-icon',
	  SUN_BURST: namespace + 'sun-burst',
	  TAB: namespace + 'tab',
	  TABLE: namespace + 'table',
	  TABLE_ROW: namespace + 'table-row',
	  TABS: namespace + 'tabs',
	  TAG: namespace + 'tag',
	  TAGS: namespace + 'tags',
	  TBD: namespace + 'tbd',
	  TEXT_INPUT: namespace + 'text-input',
	  TILE: namespace + 'tile',
	  TILES: namespace + 'tiles',
	  TIMESTAMP: namespace + 'timestamp',
	  TIP: namespace + 'tip',
	  TITLE: namespace + 'title',
	  TOAST: namespace + 'toast',
	  TOPOLOGY: namespace + 'topology',
	  VALUE: namespace + 'value',
	  VIDEO: namespace + 'video',
	  WORLD_MAP: namespace + 'world-map'
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2014 Hewlett Packard Enterprise Development LP
	exports.default = {
	  getMessage: function getMessage(intl, key, values, defaultMessage) {
	    if (intl) {
	      return intl.formatMessage({
	        id: key,
	        defaultMessage: defaultMessage || key
	      }, values);
	    } else {
	      return key;
	    }
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	exports.default = {
	  pick: function pick(props, fields) {
	    var has = function has(p) {
	      return props.hasOwnProperty(p);
	    };
	    var obj = {};
	    (fields || []).forEach(function (field) {
	      if (has(field)) obj[field] = props[field];
	    });
	    return obj;
	  },
	  omit: function omit(props, fields) {
	    var obj = {};
	    Object.keys(props).forEach(function (p) {
	      if ((fields || []).indexOf(p) === -1) {
	        obj[p] = props[p];
	      }
	    });
	    return obj;
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLASS_ROOT = _CSSClassnames2.default.BUTTON;
	
	function getHoverModifier(hoverIndicator) {
	  if (hoverIndicator) {
	    if ((typeof hoverIndicator === 'undefined' ? 'undefined' : _typeof(hoverIndicator)) === 'object') {
	      if (hoverIndicator.background) {
	        if (typeof hoverIndicator.background === 'string') {
	          var prefix = _CSSClassnames.namespace + 'background-hover-color-index-';
	          return '' + prefix + hoverIndicator.background;
	        }
	        return CLASS_ROOT + '--hover-background';
	      }
	    } else if (typeof hoverIndicator === 'string') {
	      return CLASS_ROOT + '--hover-' + hoverIndicator;
	    }
	  }
	}
	
	var Button = function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onMouseDown = _this._onMouseDown.bind(_this);
	    _this._onMouseUp = _this._onMouseUp.bind(_this);
	    _this._onFocus = _this._onFocus.bind(_this);
	    _this._onBlur = _this._onBlur.bind(_this);
	    _this.state = {
	      mouseActive: false,
	      focus: false
	    };
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: '_onClick',
	    value: function _onClick(event) {
	      var _props = this.props,
	          method = _props.method,
	          onClick = _props.onClick,
	          path = _props.path;
	      var router = this.context.router;
	
	      var modifierKey = event.ctrlKey || event.metaKey;
	
	      if (modifierKey && !onClick) {
	        return true;
	      }
	
	      event.preventDefault();
	
	      if ('push' === method) {
	        (router.history || router).push(path);
	      } else if ('replace' === method) {
	        (router.history || router).replace(path);
	      }
	
	      if (onClick) {
	        onClick.apply(undefined, arguments);
	      }
	    }
	  }, {
	    key: '_onMouseDown',
	    value: function _onMouseDown(event) {
	      var onMouseDown = this.props.onMouseDown;
	
	      this.setState({ mouseActive: true });
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	    }
	  }, {
	    key: '_onMouseUp',
	    value: function _onMouseUp(event) {
	      var onMouseUp = this.props.onMouseUp;
	
	      this.setState({ mouseActive: false });
	      if (onMouseUp) {
	        onMouseUp(event);
	      }
	    }
	  }, {
	    key: '_onFocus',
	    value: function _onFocus(event) {
	      var onFocus = this.props.onFocus;
	      var mouseActive = this.state.mouseActive;
	
	      if (mouseActive === false) {
	        this.setState({ focus: true });
	      }
	      if (onFocus) {
	        onFocus(event);
	      }
	    }
	  }, {
	    key: '_onBlur',
	    value: function _onBlur(event) {
	      var onBlur = this.props.onBlur;
	
	      this.setState({ focus: false });
	      if (onBlur) {
	        onBlur(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          accent = _props2.accent,
	          align = _props2.align,
	          box = _props2.box,
	          children = _props2.children,
	          className = _props2.className,
	          critical = _props2.critical,
	          fill = _props2.fill,
	          hoverIndicator = _props2.hoverIndicator,
	          href = _props2.href,
	          icon = _props2.icon,
	          label = _props2.label,
	          onClick = _props2.onClick,
	          path = _props2.path,
	          plain = _props2.plain,
	          primary = _props2.primary,
	          reverse = _props2.reverse,
	          secondary = _props2.secondary,
	          type = _props2.type,
	          props = _objectWithoutProperties(_props2, ['a11yTitle', 'accent', 'align', 'box', 'children', 'className', 'critical', 'fill', 'hoverIndicator', 'href', 'icon', 'label', 'onClick', 'path', 'plain', 'primary', 'reverse', 'secondary', 'type']);
	
	      delete props.method;
	      var router = this.context.router;
	
	
	      var buttonIcon = void 0;
	      if (icon) {
	        buttonIcon = _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__icon' },
	          icon
	        );
	      }
	
	      var buttonLabel = void 0;
	      if (label) {
	        buttonLabel = _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__label' },
	          label
	        );
	      }
	
	      var adjustedHref = void 0;
	      if (router && router.createPath) {
	        adjustedHref = path && router ? router.createPath(path) : href;
	      } else {
	        adjustedHref = path && router && router.history ? router.history.createHref({ pathname: path }) : href;
	      }
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--box', box), _defineProperty(_classnames, CLASS_ROOT + '--critical', critical), _defineProperty(_classnames, CLASS_ROOT + '--focus', this.state.focus), _defineProperty(_classnames, CLASS_ROOT + '--primary', primary), _defineProperty(_classnames, CLASS_ROOT + '--secondary', secondary), _defineProperty(_classnames, CLASS_ROOT + '--accent', accent), _defineProperty(_classnames, CLASS_ROOT + '--disabled', !onClick && !adjustedHref && ['reset', 'submit'].indexOf(type) === -1), _defineProperty(_classnames, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames, CLASS_ROOT + '--plain', plain || box || _react.Children.count(children) > 0 || icon && !label), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, getHoverModifier(hoverIndicator), hoverIndicator), _classnames), className);
	
	      var adjustedOnClick = path && router ? this._onClick : onClick;
	
	      var Tag = adjustedHref ? 'a' : 'button';
	      var buttonType = void 0;
	      if (!adjustedHref) {
	        buttonType = type;
	      }
	
	      var boxProps = void 0;
	      if (box) {
	        // Let the root element of the Button be a Box element with tag prop
	        boxProps = {
	          tag: Tag
	        };
	        Tag = _Box2.default;
	      }
	
	      var first = reverse ? buttonLabel : buttonIcon;
	      var second = reverse ? buttonIcon : buttonLabel;
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, props, boxProps, { href: adjustedHref, type: buttonType,
	          className: classes, 'aria-label': a11yTitle,
	          onClick: adjustedOnClick,
	          disabled: !onClick && !adjustedHref && ['reset', 'submit'].indexOf(type) === -1,
	          onMouseDown: this._onMouseDown, onMouseUp: this._onMouseUp,
	          onFocus: this._onFocus, onBlur: this._onBlur }),
	        first,
	        second,
	        children
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.Component);
	
	Button.displayName = 'Button';
	exports.default = Button;
	
	
	Button.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  accent: _propTypes2.default.bool,
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  box: _propTypes2.default.bool,
	  critical: _propTypes2.default.bool,
	  fill: _propTypes2.default.bool,
	  hoverIndicator: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['background']), _propTypes2.default.shape({
	    background: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
	  })]),
	  href: _propTypes2.default.string,
	  icon: _propTypes2.default.element,
	  label: _propTypes2.default.node,
	  method: _propTypes2.default.oneOf(['push', 'replace']),
	  onClick: _propTypes2.default.func,
	  path: _propTypes2.default.string,
	  plain: _propTypes2.default.bool,
	  primary: _propTypes2.default.bool,
	  reverse: _propTypes2.default.bool,
	  secondary: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(['button', 'reset', 'submit'])
	};
	
	Button.defaultProps = {
	  method: 'push',
	  type: 'button'
	};
	
	Button.contextTypes = {
	  router: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(605);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericComponent2 = __webpack_require__(17);
	
	var _GenericComponent3 = _interopRequireDefault(_GenericComponent2);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALWAYS_TRUE_TYPES = ["drag", "dragend"];
	
	var GenericChartComponent = function (_GenericComponent) {
		_inherits(GenericChartComponent, _GenericComponent);
	
		function GenericChartComponent(props, context) {
			_classCallCheck(this, GenericChartComponent);
	
			var _this = _possibleConstructorReturn(this, (GenericChartComponent.__proto__ || Object.getPrototypeOf(GenericChartComponent)).call(this, props, context));
	
			_this.preCanvasDraw = _this.preCanvasDraw.bind(_this);
			_this.postCanvasDraw = _this.postCanvasDraw.bind(_this);
			_this.shouldTypeProceed = _this.shouldTypeProceed.bind(_this);
			_this.preEvaluate = _this.preEvaluate.bind(_this);
			return _this;
		}
	
		_createClass(GenericChartComponent, [{
			key: "preCanvasDraw",
			value: function preCanvasDraw(ctx, moreProps) {
				_get(GenericChartComponent.prototype.__proto__ || Object.getPrototypeOf(GenericChartComponent.prototype), "preCanvasDraw", this).call(this, ctx, moreProps);
				ctx.save();
				var _context = this.context,
				    margin = _context.margin,
				    ratio = _context.ratio;
				var chartConfig = moreProps.chartConfig;
	
	
				var canvasOriginX = 0.5 * ratio + chartConfig.origin[0] + margin.left;
				var canvasOriginY = 0.5 * ratio + chartConfig.origin[1] + margin.top;
	
				var _moreProps$chartConfi = moreProps.chartConfig,
				    width = _moreProps$chartConfi.width,
				    height = _moreProps$chartConfi.height;
				var _props = this.props,
				    clip = _props.clip,
				    edgeClip = _props.edgeClip;
	
	
				ctx.setTransform(1, 0, 0, 1, 0, 0);
				ctx.scale(ratio, ratio);
				if (edgeClip) {
					ctx.beginPath();
					ctx.rect(-1, canvasOriginY - 10, width + margin.left + margin.right + 1, height + 20);
					ctx.clip();
				}
	
				ctx.translate(canvasOriginX, canvasOriginY);
	
				if (clip) {
					ctx.beginPath();
					ctx.rect(-1, -1, width + 1, height + 1);
					ctx.clip();
				}
			}
		}, {
			key: "postCanvasDraw",
			value: function postCanvasDraw(ctx, moreProps) {
				_get(GenericChartComponent.prototype.__proto__ || Object.getPrototypeOf(GenericChartComponent.prototype), "postCanvasDraw", this).call(this, ctx, moreProps);
				ctx.restore();
			}
		}, {
			key: "updateMoreProps",
			value: function updateMoreProps(moreProps) {
				_get(GenericChartComponent.prototype.__proto__ || Object.getPrototypeOf(GenericChartComponent.prototype), "updateMoreProps", this).call(this, moreProps);
				var chartConfigList = moreProps.chartConfig;
	
	
				if (chartConfigList && Array.isArray(chartConfigList)) {
					var chartId = this.context.chartId;
	
					var chartConfig = (0, _utils.find)(chartConfigList, function (each) {
						return each.id === chartId;
					});
					this.moreProps.chartConfig = chartConfig;
				}
				if ((0, _utils.isDefined)(this.moreProps.chartConfig)) {
					var _moreProps$chartConfi2 = _slicedToArray(this.moreProps.chartConfig.origin, 2),
					    ox = _moreProps$chartConfi2[0],
					    oy = _moreProps$chartConfi2[1];
	
					if ((0, _utils.isDefined)(moreProps.mouseXY)) {
						var _moreProps$mouseXY = _slicedToArray(moreProps.mouseXY, 2),
						    x = _moreProps$mouseXY[0],
						    y = _moreProps$mouseXY[1];
	
						this.moreProps.mouseXY = [x - ox, y - oy];
					}
					if ((0, _utils.isDefined)(moreProps.startPos)) {
						var _moreProps$startPos = _slicedToArray(moreProps.startPos, 2),
						    _x = _moreProps$startPos[0],
						    _y = _moreProps$startPos[1];
	
						this.moreProps.startPos = [_x - ox, _y - oy];
					}
				}
			}
		}, {
			key: "preEvaluate",
			value: function preEvaluate() /* type, moreProps */{
				/* if (
	   	type === "mousemove"
	   	&& this.props.onMouseMove
	   	&& isDefined(moreProps)
	   	&& isDefined(moreProps.currentCharts)
	   ) {
	   	if (moreProps.currentCharts.indexOf(this.context.chartId) === -1) {
	   		moreProps.show = false;
	   	}
	   } */
			}
		}, {
			key: "shouldTypeProceed",
			value: function shouldTypeProceed(type, moreProps) {
				if ((type === "mousemove" || type === "click") && this.props.disablePan) {
					return true;
				}
				if (ALWAYS_TRUE_TYPES.indexOf(type) === -1 && (0, _utils.isDefined)(moreProps) && (0, _utils.isDefined)(moreProps.currentCharts)) {
					return moreProps.currentCharts.indexOf(this.context.chartId) > -1;
				}
				return true;
			}
		}]);
	
		return GenericChartComponent;
	}(_GenericComponent3.default);
	
	GenericChartComponent.propTypes = _GenericComponent3.default.propTypes;
	
	GenericChartComponent.defaultProps = _GenericComponent3.default.defaultProps;
	
	GenericChartComponent.contextTypes = _extends({}, _GenericComponent3.default.contextTypes, {
		canvasOriginX: _propTypes2.default.number,
		canvasOriginY: _propTypes2.default.number,
		chartId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
		chartConfig: _propTypes2.default.object.isRequired,
		ratio: _propTypes2.default.number.isRequired
	});
	
	exports.default = GenericChartComponent;
	//# sourceMappingURL=GenericChartComponent.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _locationView = __webpack_require__(61);
	
	Object.keys(_locationView).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locationView[key];
	    }
	  });
	});
	
	var _dashboard = __webpack_require__(170);
	
	Object.keys(_dashboard).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _dashboard[key];
	    }
	  });
	});
	
	var _nav = __webpack_require__(28);
	
	Object.keys(_nav).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _nav[key];
	    }
	  });
	});
	
	var _route = __webpack_require__(115);
	
	Object.keys(_route).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _route[key];
	    }
	  });
	});
	
	var _session = __webpack_require__(82);
	
	Object.keys(_session).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _session[key];
	    }
	  });
	});
	
	var _settings = __webpack_require__(116);
	
	Object.keys(_settings).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _settings[key];
	    }
	  });
	});
	
	var _status = __webpack_require__(65);
	
	Object.keys(_status).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _status[key];
	    }
	  });
	});
	
	var _subscriptionView = __webpack_require__(171);
	
	Object.keys(_subscriptionView).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _subscriptionView[key];
	    }
	  });
	});
	
	// export * from './software';
	
	// export * from './search';
	
	// export * from './image';
	// export * from './index';
	// export * from './item';
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	;
	// export * from './support';
	// export * from './utilization';
	// export * from './vm';
	
	// export * from './notifications';
	// export * from './restart';
	
	// export * from './backup';
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(39);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _DOM = __webpack_require__(47);
	
	var _SkipLinkAnchor = __webpack_require__(190);
	
	var _SkipLinkAnchor2 = _interopRequireDefault(_SkipLinkAnchor);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Announcer = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.BOX;
	var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;
	
	var Box = function (_Component) {
	  _inherits(Box, _Component);
	
	  function Box(props) {
	    _classCallCheck(this, Box);
	
	    var _this = _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).call(this, props));
	
	    _this.state = { mouseActive: false };
	    return _this;
	  }
	
	  _createClass(Box, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onClick = this.props.onClick;
	
	      if (onClick) {
	        var clickCallback = function clickCallback() {
	          if (_this2.boxContainerRef === document.activeElement) {
	            onClick();
	          }
	        };
	
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, {
	          enter: clickCallback,
	          space: clickCallback
	        });
	      }
	
	      this._setDarkBackground();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.colorIndex !== this.props.colorIndex) {
	        if (nextProps.colorIndex) {
	          this.setState({ updateDarkBackground: true });
	        } else {
	          this.setState({ darkBackground: undefined });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.announce) {
	        (0, _Announcer.announce)(this.boxContainerRef.textContent);
	      }
	      if (this.state.updateDarkBackground) {
	        this.setState({ updateDarkBackground: false });
	        this._setDarkBackground();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onClick) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
	      }
	      if (this._checkBackground) {
	        this._checkBackground.stop();
	      }
	    }
	  }, {
	    key: '_setDarkBackground',
	    value: function _setDarkBackground() {
	      var _this3 = this;
	
	      var colorIndex = this.props.colorIndex;
	
	      var box = (0, _reactDom.findDOMNode)(this.boxContainerRef);
	      if (this._checkBackground) {
	        this._checkBackground.stop();
	      }
	      this._checkBackground = (0, _DOM.checkDarkBackground)(colorIndex, box, function (darkBackground) {
	        return _this3.setState({ darkBackground: darkBackground });
	      });
	    }
	  }, {
	    key: '_normalize',
	    value: function _normalize(string) {
	      return string.replace('/', '-');
	    }
	  }, {
	    key: '_addPropertyClass',
	    value: function _addPropertyClass(classes, property) {
	      var _this4 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var value = (options.object || this.props)[property];
	      var elementName = options.elementName || CLASS_ROOT;
	      var prefix = options.prefix || property;
	      if (value) {
	        if (typeof value === 'string') {
	          classes.push(elementName + '--' + prefix + '-' + this._normalize(value));
	        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	          Object.keys(value).forEach(function (key) {
	            _this4._addPropertyClass(classes, key, {
	              object: value, prefix: prefix + '-' + key });
	          });
	        } else {
	          classes.push(elementName + '--' + this._normalize(prefix));
	        }
	      }
	    }
	  }, {
	    key: '_backgroundContextClass',
	    value: function _backgroundContextClass(darkBackground) {
	      var result = void 0;
	      if (undefined === darkBackground) {
	        result = BACKGROUND_COLOR_INDEX + '--pending';
	      } else if (darkBackground) {
	        result = BACKGROUND_COLOR_INDEX + '--dark';
	      } else {
	        result = BACKGROUND_COLOR_INDEX + '--light';
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          appCentered = _props.appCentered,
	          backgroundImage = _props.backgroundImage,
	          children = _props.children,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          containerClassName = _props.containerClassName,
	          focusable = _props.focusable,
	          full = _props.full,
	          id = _props.id,
	          onClick = _props.onClick,
	          _onBlur = _props.onBlur,
	          _onFocus = _props.onFocus,
	          _onMouseDown = _props.onMouseDown,
	          _onMouseUp = _props.onMouseUp,
	          pad = _props.pad,
	          primary = _props.primary,
	          role = _props.role,
	          size = _props.size,
	          tabIndex = _props.tabIndex,
	          tag = _props.tag,
	          texture = _props.texture;
	      var _state = this.state,
	          darkBackground = _state.darkBackground,
	          mouseActive = _state.mouseActive;
	
	      var classes = [CLASS_ROOT];
	      var containerClasses = [CLASS_ROOT + '__container'];
	      var restProps = _Props2.default.omit(this.props, Object.keys(Box.propTypes));
	      this._addPropertyClass(classes, 'full');
	      if (full && full.responsive === undefined) {
	        // default is true for backwards compatibility sake
	        classes.push(CLASS_ROOT + '--full-responsive');
	      }
	      this._addPropertyClass(classes, 'direction');
	      this._addPropertyClass(classes, 'justify');
	      this._addPropertyClass(classes, 'align');
	      this._addPropertyClass(classes, 'alignContent', { prefix: 'align-content' });
	      this._addPropertyClass(classes, 'alignSelf', { prefix: 'align-self' });
	      this._addPropertyClass(classes, 'reverse');
	      this._addPropertyClass(classes, 'responsive');
	      this._addPropertyClass(classes, 'basis');
	      this._addPropertyClass(classes, 'flex');
	      this._addPropertyClass(classes, 'pad');
	      this._addPropertyClass(classes, 'margin');
	      this._addPropertyClass(classes, 'separator');
	      this._addPropertyClass(classes, 'textAlign', { prefix: 'text-align' });
	      this._addPropertyClass(classes, 'wrap');
	
	      if (this.props.hasOwnProperty('flex')) {
	        if (!this.props.flex) {
	          classes.push(CLASS_ROOT + '--flex-off');
	        }
	      }
	      if (size) {
	        if ((typeof size === 'undefined' ? 'undefined' : _typeof(size)) === 'object') {
	          Object.keys(size).forEach(function (key) {
	            _this5._addPropertyClass(classes, key, { object: size });
	          });
	        } else {
	          this._addPropertyClass(classes, 'size');
	        }
	        if (size) {
	          if (!(size.width && size.width.max)) {
	            // don't apply 100% max-width when size using size.width.max option
	            classes.push(CLASS_ROOT + '--size');
	          }
	          if (size.width && size.width.max) {
	            // allow widths to shrink, apply 100% width
	            classes.push(CLASS_ROOT + '--width-max');
	          }
	        }
	      }
	
	      // needed to properly set flex-basis for 1/3 & 2/3 basis boxes
	      if (pad && pad.between && children) {
	        if (_react2.default.Children.count(children) % 3 === 0) {
	          classes.push(CLASS_ROOT + '--pad-between-thirds');
	        }
	      }
	
	      if (appCentered) {
	        this._addPropertyClass(containerClasses, 'full', { elementName: CLASS_ROOT + '__container' });
	        if (colorIndex) {
	          containerClasses.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
	          containerClasses.push(this._backgroundContextClass(darkBackground));
	        }
	        if (containerClassName) {
	          containerClasses.push(containerClassName);
	        }
	      } else if (colorIndex) {
	        classes.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
	        classes.push(this._backgroundContextClass(darkBackground));
	      }
	
	      var a11yProps = {};
	      var clickableProps = {};
	      if (onClick) {
	        classes.push(CLASS_ROOT + "--clickable");
	        clickableProps = {
	          onMouseDown: function onMouseDown(event) {
	            _this5.setState({ mouseActive: true });
	            if (_onMouseDown) {
	              _onMouseDown(event);
	            }
	          },
	          onMouseUp: function onMouseUp(event) {
	            _this5.setState({ mouseActive: false });
	            if (_onMouseUp) {
	              _onMouseUp(event);
	            }
	          },
	          onFocus: function onFocus(event) {
	            if (mouseActive === false) {
	              _this5.setState({ focus: true });
	            }
	            if (_onFocus) {
	              _onFocus(event);
	            }
	          },
	          onBlur: function onBlur(event) {
	            _this5.setState({ focus: false });
	            if (_onBlur) {
	              _onBlur(event);
	            }
	          }
	        };
	        if (focusable) {
	          if (this.state.focus) {
	            classes.push(CLASS_ROOT + '--focus');
	          }
	          var boxLabel = typeof a11yTitle !== 'undefined' ? a11yTitle : _Intl2.default.getMessage(this.context.intl, 'Box');
	          a11yProps.tabIndex = tabIndex || 0;
	          a11yProps["aria-label"] = this.props['aria-label'] || boxLabel;
	          a11yProps.role = role || 'group';
	        }
	      }
	
	      var skipLinkAnchor = void 0;
	      if (primary) {
	        var mainContentLabel = _Intl2.default.getMessage(this.context.intl, 'Main Content');
	        skipLinkAnchor = _react2.default.createElement(_SkipLinkAnchor2.default, { label: mainContentLabel });
	      }
	
	      if (className) {
	        classes.push(className);
	      }
	
	      var style = {};
	      if (texture && 'string' === typeof texture) {
	        if (texture.indexOf('url(') !== -1) {
	          style.backgroundImage = texture;
	        } else {
	          style.backgroundImage = 'url(' + texture + ')';
	        }
	      } else if (backgroundImage) {
	        style.background = backgroundImage + " no-repeat center center";
	        style.backgroundSize = "cover";
	      }
	      style = _extends({}, style, restProps.style);
	      var textureMarkup = void 0;
	      if ('object' === (typeof texture === 'undefined' ? 'undefined' : _typeof(texture))) {
	        textureMarkup = _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + "__texture" },
	          texture
	        );
	      }
	
	      var Component = tag;
	      if (appCentered) {
	        return _react2.default.createElement(
	          'div',
	          _extends({}, restProps, { ref: function ref(_ref) {
	              return _this5.boxContainerRef = _ref;
	            },
	            className: containerClasses.join(' '),
	            style: style, role: role }, a11yProps, clickableProps),
	          skipLinkAnchor,
	          _react2.default.createElement(
	            Component,
	            { id: id, className: classes.join(' ') },
	            textureMarkup,
	            children
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          Component,
	          _extends({}, restProps, { ref: function ref(_ref2) {
	              return _this5.boxContainerRef = _ref2;
	            },
	            id: id, className: classes.join(' '), style: style,
	            role: role, tabIndex: tabIndex,
	            onClick: onClick }, a11yProps, clickableProps),
	          skipLinkAnchor,
	          textureMarkup,
	          children
	        );
	      }
	    }
	  }]);
	
	  return Box;
	}(_react.Component);
	
	Box.displayName = 'Box';
	exports.default = Box;
	
	
	var FIXED_SIZES = ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];
	var RELATIVE_SIZES = ['full', '1/2', '1/3', '2/3', '1/4', '3/4'];
	var SIZES = FIXED_SIZES.concat(RELATIVE_SIZES);
	var MARGIN_SIZES = ['small', 'medium', 'large', 'none'];
	var PAD_SIZES = ['small', 'medium', 'large', 'xlarge', 'none'];
	
	Box.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  announce: _propTypes2.default.bool,
	  align: _propTypes2.default.oneOf(['start', 'center', 'end', 'baseline', 'stretch']),
	  alignContent: _propTypes2.default.oneOf(['start', 'center', 'end', 'between', 'around', 'stretch']),
	  alignSelf: _propTypes2.default.oneOf(['start', 'center', 'end', 'stretch']),
	  appCentered: _propTypes2.default.bool,
	  backgroundImage: _propTypes2.default.string,
	  basis: _propTypes2.default.oneOf(SIZES),
	  colorIndex: _propTypes2.default.string,
	  containerClassName: _propTypes2.default.string,
	  direction: _propTypes2.default.oneOf(['row', 'column']),
	  focusable: _propTypes2.default.bool,
	  flex: _propTypes2.default.oneOf(['grow', 'shrink', true, false]),
	  full: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.shape({
	    vertical: _propTypes2.default.bool,
	    horizontal: _propTypes2.default.bool,
	    responsive: _propTypes2.default.bool
	  })]),
	  // remove in 1.0?
	  onClick: _propTypes2.default.func,
	  justify: _propTypes2.default.oneOf(['start', 'center', 'between', 'end', 'around']),
	  margin: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(MARGIN_SIZES), _propTypes2.default.shape({
	    bottom: _propTypes2.default.oneOf(MARGIN_SIZES),
	    horizontal: _propTypes2.default.oneOf(MARGIN_SIZES),
	    left: _propTypes2.default.oneOf(MARGIN_SIZES),
	    right: _propTypes2.default.oneOf(MARGIN_SIZES),
	    top: _propTypes2.default.oneOf(MARGIN_SIZES),
	    vertical: _propTypes2.default.oneOf(MARGIN_SIZES)
	  })]),
	  pad: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(PAD_SIZES), _propTypes2.default.shape({
	    between: _propTypes2.default.oneOf(PAD_SIZES),
	    horizontal: _propTypes2.default.oneOf(PAD_SIZES),
	    vertical: _propTypes2.default.oneOf(PAD_SIZES)
	  })]),
	  primary: _propTypes2.default.bool,
	  reverse: _propTypes2.default.bool,
	  responsive: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  separator: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right', 'horizontal', 'vertical', 'all', 'none']),
	  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'full']), // remove in 1.0?, use basis
	  _propTypes2.default.shape({
	    height: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
	      max: _propTypes2.default.oneOf(FIXED_SIZES),
	      min: _propTypes2.default.oneOf(FIXED_SIZES)
	    })]),
	    width: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
	      max: _propTypes2.default.oneOf(FIXED_SIZES),
	      min: _propTypes2.default.oneOf(FIXED_SIZES)
	    })])
	  })]),
	  tag: _propTypes2.default.string,
	  textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
	  texture: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
	  wrap: _propTypes2.default.bool
	};
	
	Box.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Box.defaultProps = {
	  announce: false,
	  direction: 'column',
	  pad: 'none',
	  tag: 'div',
	  responsive: true,
	  focusable: true
	};
	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getAxisCanvas = getAxisCanvas;
	exports.getMouseCanvas = getMouseCanvas;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var aliases = {
		mouseleave: "mousemove", // to draw interactive after mouse exit
		panend: "pan",
		pinchzoom: "pan",
		mousedown: "mousemove",
		click: "mousemove",
		contextmenu: "mousemove",
		dblclick: "mousemove",
		dragstart: "drag",
		dragend: "drag",
		dragcancel: "drag"
	};
	
	var GenericComponent = function (_Component) {
		_inherits(GenericComponent, _Component);
	
		function GenericComponent(props, context) {
			_classCallCheck(this, GenericComponent);
	
			var _this = _possibleConstructorReturn(this, (GenericComponent.__proto__ || Object.getPrototypeOf(GenericComponent)).call(this, props, context));
	
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			_this.getMoreProps = _this.getMoreProps.bind(_this);
			_this.listener = _this.listener.bind(_this);
			_this.draw = _this.draw.bind(_this);
			_this.updateMoreProps = _this.updateMoreProps.bind(_this);
			_this.evaluateType = _this.evaluateType.bind(_this);
			_this.isHover = _this.isHover.bind(_this);
			_this.preCanvasDraw = _this.preCanvasDraw.bind(_this);
			_this.postCanvasDraw = _this.postCanvasDraw.bind(_this);
			_this.getPanConditions = _this.getPanConditions.bind(_this);
			_this.shouldTypeProceed = _this.shouldTypeProceed.bind(_this);
			_this.preEvaluate = _this.preEvaluate.bind(_this);
	
			var generateSubscriptionId = context.generateSubscriptionId;
	
			_this.suscriberId = generateSubscriptionId();
	
			_this.moreProps = {};
	
			_this.state = {
				updateCount: 0
			};
			return _this;
		}
	
		_createClass(GenericComponent, [{
			key: "updateMoreProps",
			value: function updateMoreProps(moreProps) {
				var _this2 = this;
	
				Object.keys(moreProps).forEach(function (key) {
					_this2.moreProps[key] = moreProps[key];
				});
			}
		}, {
			key: "shouldTypeProceed",
			value: function shouldTypeProceed() {
				return true;
			}
		}, {
			key: "preEvaluate",
			value: function preEvaluate() {}
		}, {
			key: "listener",
			value: function listener(type, moreProps, state, e) {
				// console.log(e.shiftKey)
				if ((0, _utils.isDefined)(moreProps)) {
					this.updateMoreProps(moreProps);
				}
				this.evaluationInProgress = true;
				this.evaluateType(type, e);
				this.evaluationInProgress = false;
			}
		}, {
			key: "evaluateType",
			value: function evaluateType(type, e) {
				var newType = aliases[type] || type;
				var proceed = this.props.drawOn.indexOf(newType) > -1;
	
				// console.log("type ->", type, proceed);
	
				if (!proceed) return;
				// const moreProps = this.getMoreProps();
				this.preEvaluate(type, this.moreProps, e);
				if (!this.shouldTypeProceed(type, this.moreProps)) return;
	
				switch (type) {
					case "zoom":
					case "mouseenter":
						// DO NOT DRAW FOR THESE EVENTS
						break;
					case "mouseleave":
						{
							this.moreProps.hovering = false;
							var moreProps = this.getMoreProps();
	
							if (this.props.onUnHover) {
								this.props.onUnHover(moreProps, e);
							}
							break;
						}
					case "contextmenu":
						{
							if (this.props.onContextMenu) {
								this.props.onContextMenu(this.getMoreProps(), e);
							}
							if (this.moreProps.hovering && this.props.onContextMenuWhenHover) {
								this.props.onContextMenuWhenHover(this.getMoreProps(), e);
							}
							break;
						}
					case "mousedown":
						{
							if (this.props.onMouseDown) {
								this.props.onMouseDown(this.getMoreProps(), e);
							}
							break;
						}
					case "click":
						{
							var _moreProps = this.getMoreProps();
							if (this.moreProps.hovering) {
								// console.error("TODO use this only for SAR, Line series")
								this.props.onClickWhenHover(_moreProps, e);
							} else {
								this.props.onClickOutside(_moreProps, e);
							}
							if (this.props.onClick) {
								this.props.onClick(_moreProps, e);
							}
							break;
						}
					case "mousemove":
						{
	
							var prevHover = this.moreProps.hovering;
							this.moreProps.hovering = this.isHover(e);
	
							var _context = this.context,
							    amIOnTop = _context.amIOnTop,
							    setCursorClass = _context.setCursorClass;
	
	
							if (this.moreProps.hovering && !this.props.selected
							/* && !prevHover */
							&& amIOnTop(this.suscriberId) && (0, _utils.isDefined)(this.props.onHover)) {
								setCursorClass("react-stockcharts-pointer-cursor");
								this.iSetTheCursorClass = true;
							} else if (this.moreProps.hovering && this.props.selected && amIOnTop(this.suscriberId)) {
								setCursorClass(this.props.interactiveCursorClass);
								this.iSetTheCursorClass = true;
							} else if (prevHover && !this.moreProps.hovering && this.iSetTheCursorClass) {
								this.iSetTheCursorClass = false;
								setCursorClass(null);
							}
							var _moreProps2 = this.getMoreProps();
	
							if (this.moreProps.hovering && !prevHover) {
								if (this.props.onHover) {
									this.props.onHover(_moreProps2, e);
								}
							}
							if (prevHover && !this.moreProps.hovering) {
								if (this.props.onUnHover) {
									this.props.onUnHover(_moreProps2, e);
								}
							}
	
							if (this.props.onMouseMove) {
								this.props.onMouseMove(_moreProps2, e);
							}
							break;
						}
					case "dblclick":
						{
							var _moreProps3 = this.getMoreProps();
	
							if (this.props.onDoubleClick) {
								this.props.onDoubleClick(_moreProps3, e);
							}
							if (this.moreProps.hovering && this.props.onDoubleClickWhenHover) {
								this.props.onDoubleClickWhenHover(_moreProps3, e);
							}
							break;
						}
					case "pan":
						{
							this.moreProps.hovering = false;
							if (this.props.onPan) {
								this.props.onPan(this.getMoreProps(), e);
							}
							break;
						}
					case "panend":
						{
							if (this.props.onPanEnd) {
								this.props.onPanEnd(this.getMoreProps(), e);
							}
							break;
						}
					case "dragstart":
						{
							if (this.getPanConditions().draggable) {
								var _amIOnTop = this.context.amIOnTop;
	
								if (_amIOnTop(this.suscriberId)) {
									this.dragInProgress = true;
									this.props.onDragStart(this.getMoreProps(), e);
								}
							}
							this.someDragInProgress = true;
							break;
						}
					case "drag":
						{
							if (this.dragInProgress && this.props.onDrag) {
								this.props.onDrag(this.getMoreProps(), e);
							}
							break;
						}
					case "dragend":
						{
							if (this.dragInProgress && this.props.onDragComplete) {
								this.props.onDragComplete(this.getMoreProps(), e);
							}
							this.dragInProgress = false;
							this.someDragInProgress = false;
							break;
						}
					case "dragcancel":
						{
							if (this.dragInProgress || this.iSetTheCursorClass) {
								var _setCursorClass = this.context.setCursorClass;
	
								_setCursorClass(null);
							}
							break;
						}
				}
			}
		}, {
			key: "isHover",
			value: function isHover(e) {
				return (0, _utils.isDefined)(this.props.isHover) ? this.props.isHover(this.getMoreProps(), e) : false;
			}
		}, {
			key: "getPanConditions",
			value: function getPanConditions() {
				var draggable = !!(this.props.selected && this.moreProps.hovering) || this.props.enableDragOnHover && this.moreProps.hovering;
	
				return {
					draggable: draggable,
					panEnabled: !this.props.disablePan
				};
			}
		}, {
			key: "draw",
			value: function draw() {
				var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { force: false },
				    trigger = _ref.trigger,
				    force = _ref.force;
	
				var type = aliases[trigger] || trigger;
				var proceed = this.props.drawOn.indexOf(type) > -1;
	
				if (proceed || this.props.selected /* this is to draw as soon as you select */
				|| force) {
					var chartCanvasType = this.context.chartCanvasType;
					var canvasDraw = this.props.canvasDraw;
	
	
					if ((0, _utils.isNotDefined)(canvasDraw) || chartCanvasType === "svg") {
						var updateCount = this.state.updateCount;
	
						this.setState({
							updateCount: updateCount + 1
						});
					} else {
						this.drawOnCanvas();
					}
				}
			}
		}, {
			key: "componentWillMount",
			value: function componentWillMount() {
				var _context2 = this.context,
				    subscribe = _context2.subscribe,
				    chartId = _context2.chartId;
				var _props = this.props,
				    clip = _props.clip,
				    edgeClip = _props.edgeClip;
	
	
				subscribe(this.suscriberId, {
					chartId: chartId, clip: clip, edgeClip: edgeClip,
					listener: this.listener,
					draw: this.draw,
					getPanConditions: this.getPanConditions
				});
				this.componentWillReceiveProps(this.props, this.context);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				var unsubscribe = this.context.unsubscribe;
	
				unsubscribe(this.suscriberId);
				if (this.iSetTheCursorClass) {
					var setCursorClass = this.context.setCursorClass;
	
					setCursorClass(null);
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.componentDidUpdate(this.props);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				var chartCanvasType = this.context.chartCanvasType;
				var _props2 = this.props,
				    canvasDraw = _props2.canvasDraw,
				    selected = _props2.selected,
				    interactiveCursorClass = _props2.interactiveCursorClass;
	
	
				if (prevProps.selected !== selected) {
					var setCursorClass = this.context.setCursorClass;
	
					if (selected && this.moreProps.hovering) {
						this.iSetTheCursorClass = true;
						setCursorClass(interactiveCursorClass);
					} else {
						this.iSetTheCursorClass = false;
						setCursorClass(null);
					}
				}
				if ((0, _utils.isDefined)(canvasDraw) && !this.evaluationInProgress
				// && !(this.someDragInProgress && this.props.selected)
				/*
	   prevent double draw of interactive elements
	   during dragging / hover / click etc.
	   */
				&& chartCanvasType !== "svg") {
	
					this.updateMoreProps(this.moreProps);
					this.drawOnCanvas();
				}
			}
		}, {
			key: "componentWillReceiveProps",
			value: function componentWillReceiveProps(nextProps, nextContext) {
				var xScale = nextContext.xScale,
				    plotData = nextContext.plotData,
				    chartConfig = nextContext.chartConfig,
				    getMutableState = nextContext.getMutableState;
	
	
				this.props.debug(nextContext);
				this.moreProps = _extends({}, this.moreProps, getMutableState(), {
					/*
	    ^ this is so
	    mouseXY, currentCharts, currentItem are available to
	    newly created components like MouseHoverText which
	    is created right after a new interactive object is drawn
	    */
					xScale: xScale, plotData: plotData, chartConfig: chartConfig
				});
			}
		}, {
			key: "getMoreProps",
			value: function getMoreProps() {
				var _context3 = this.context,
				    xScale = _context3.xScale,
				    plotData = _context3.plotData,
				    chartConfig = _context3.chartConfig,
				    morePropsDecorator = _context3.morePropsDecorator,
				    xAccessor = _context3.xAccessor,
				    displayXAccessor = _context3.displayXAccessor,
				    width = _context3.width,
				    height = _context3.height;
				var _context4 = this.context,
				    chartId = _context4.chartId,
				    fullData = _context4.fullData;
	
	
				var moreProps = _extends({
					xScale: xScale, plotData: plotData, chartConfig: chartConfig,
					xAccessor: xAccessor, displayXAccessor: displayXAccessor,
					width: width, height: height,
					chartId: chartId,
					fullData: fullData
				}, this.moreProps);
	
				return (morePropsDecorator || _utils.identity)(moreProps);
			}
		}, {
			key: "preCanvasDraw",
			value: function preCanvasDraw() {
				// do nothing
			}
		}, {
			key: "postCanvasDraw",
			value: function postCanvasDraw() {}
		}, {
			key: "drawOnCanvas",
			value: function drawOnCanvas() {
				var _props3 = this.props,
				    canvasDraw = _props3.canvasDraw,
				    canvasToDraw = _props3.canvasToDraw;
				var getCanvasContexts = this.context.getCanvasContexts;
	
	
				var moreProps = this.getMoreProps();
	
				var ctx = canvasToDraw(getCanvasContexts());
	
				this.preCanvasDraw(ctx, moreProps);
				canvasDraw(ctx, moreProps);
				this.postCanvasDraw(ctx, moreProps);
			}
		}, {
			key: "render",
			value: function render() {
				var _context5 = this.context,
				    chartCanvasType = _context5.chartCanvasType,
				    chartId = _context5.chartId;
				var _props4 = this.props,
				    canvasDraw = _props4.canvasDraw,
				    clip = _props4.clip,
				    svgDraw = _props4.svgDraw;
	
	
				if ((0, _utils.isDefined)(canvasDraw) && chartCanvasType !== "svg") {
					return null;
				}
	
				var suffix = (0, _utils.isDefined)(chartId) ? "-" + chartId : "";
	
				var style = clip ? { "clipPath": "url(#chart-area-clip" + suffix + ")" } : null;
	
				return _react2.default.createElement(
					"g",
					{ style: style },
					svgDraw(this.getMoreProps())
				);
			}
		}]);
	
		return GenericComponent;
	}(_react.Component);
	
	GenericComponent.propTypes = {
		svgDraw: _propTypes2.default.func.isRequired,
		canvasDraw: _propTypes2.default.func,
	
		drawOn: _propTypes2.default.array.isRequired,
	
		clip: _propTypes2.default.bool.isRequired,
		edgeClip: _propTypes2.default.bool.isRequired,
		interactiveCursorClass: _propTypes2.default.string,
	
		selected: _propTypes2.default.bool.isRequired,
		enableDragOnHover: _propTypes2.default.bool.isRequired,
		disablePan: _propTypes2.default.bool.isRequired,
	
		canvasToDraw: _propTypes2.default.func.isRequired,
	
		isHover: _propTypes2.default.func,
	
		onClick: _propTypes2.default.func,
		onClickWhenHover: _propTypes2.default.func,
		onClickOutside: _propTypes2.default.func,
	
		onPan: _propTypes2.default.func,
		onPanEnd: _propTypes2.default.func,
		onDragStart: _propTypes2.default.func,
		onDrag: _propTypes2.default.func,
		onDragComplete: _propTypes2.default.func,
		onDoubleClick: _propTypes2.default.func,
		onDoubleClickWhenHover: _propTypes2.default.func,
		onContextMenu: _propTypes2.default.func,
		onContextMenuWhenHover: _propTypes2.default.func,
		onMouseMove: _propTypes2.default.func,
		onMouseDown: _propTypes2.default.func,
		onHover: _propTypes2.default.func,
		onUnHover: _propTypes2.default.func,
	
		debug: _propTypes2.default.func
		// owner: PropTypes.string.isRequired,
	};
	
	GenericComponent.defaultProps = {
		svgDraw: (0, _utils.functor)(null),
		draw: [],
		canvasToDraw: function canvasToDraw(contexts) {
			return contexts.mouseCoord;
		},
		clip: true,
		edgeClip: false,
		selected: false,
		disablePan: false,
		enableDragOnHover: false,
	
		onClickWhenHover: _utils.noop,
		onClickOutside: _utils.noop,
		onDragStart: _utils.noop,
		onMouseMove: _utils.noop,
		onMouseDown: _utils.noop,
		debug: _utils.noop
	};
	
	GenericComponent.contextTypes = {
		width: _propTypes2.default.number.isRequired,
		height: _propTypes2.default.number.isRequired,
		margin: _propTypes2.default.object.isRequired,
		chartId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
		getCanvasContexts: _propTypes2.default.func,
	
		chartCanvasType: _propTypes2.default.string,
		xScale: _propTypes2.default.func.isRequired,
		xAccessor: _propTypes2.default.func.isRequired,
		displayXAccessor: _propTypes2.default.func.isRequired,
		plotData: _propTypes2.default.array.isRequired,
		fullData: _propTypes2.default.array.isRequired,
	
		chartConfig: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]).isRequired,
	
		morePropsDecorator: _propTypes2.default.func,
		generateSubscriptionId: _propTypes2.default.func,
		getMutableState: _propTypes2.default.func.isRequired,
	
		amIOnTop: _propTypes2.default.func.isRequired,
		subscribe: _propTypes2.default.func.isRequired,
		unsubscribe: _propTypes2.default.func.isRequired,
		setCursorClass: _propTypes2.default.func.isRequired
	};
	
	exports.default = GenericComponent;
	function getAxisCanvas(contexts) {
		return contexts.axes;
	}
	
	function getMouseCanvas(contexts) {
		return contexts.mouseCoord;
	}
	//# sourceMappingURL=GenericComponent.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var constants = {
	  ROUTES: {
	    DASHBOARD: 'dashboard',
	    LOCATIONVIEW: 'location',
	    SITEVIEW: 'site',
	    ADD_STEM: 'addstem',
	    SUBSCRIPTIONVIEW: 'subscription',
	    SETTINGS: 'settings',
	    TUTORIAL: 'tutorial',
	    LOGIN: 'login',
	    CHOOSE_LOCATION: 'chooselocation',
	    ALERTS: 'alerts',
	    SIGNUP: 'signup'
	  },
	  CHART_OPTIONS: {
	    // TOP: 'deepSensor1',
	    // MIDDLE: 'deepSensor2',
	    // BOTTOM: 'deepSensor3'
	    TOP: '1',
	    MIDDLE: '2',
	    BOTTOM: '3',
	    ONBOARDSENSOR: 'onboard',
	    ZOOM: 'zoom'
	  },
	  TREND_OPTIONS: {
	    RAW: 'RAW',
	    TRENDLINE: 'TRENDLINE',
	    BOTH: 'BOTH'
	  },
	  CHART_LIMIT: {
	    TOP: 'upper',
	    LOWER: 'lower'
	  },
	  DATE_RANGE: {
	    ALL: 'ALL',
	    ONE_YEAR: 'ONE_YEAR',
	    ONE_TO_ELEVAN_MONTHS: 'ONE_TO_ELEVAN_MONTHS',
	    TWO_WEEKS: 'TWO_WEEKS',
	    ONE_WEEK: 'ONE_WEEK',
	    ONE_MONTH: 'ONE_MONTH',
	    SIX_MONTHS: 'SIX_MONTHS',
	    ONE_DAY: 'ONE_DAY',
	    LAST_SIX_HOURS: 'LAST_SIX_HOURS',
	    LAST_HOUR: 'LAST_HOUR',
	    CUSTOM: 'CUSTOM',
	    NONE: 'NONE'
	  },
	  TWIG_EDIT_CONTROLS: {
	    NUMBER_ARRAY: 'numberArray',
	    STRING_ARRAY: 'stringArray',
	    SELECT: 'select',
	    NUMBER: 'number',
	    SENSOR_TYPE: 'sensorType',
	    BOOLEAN: 'boolean',
	    BOOLEAN1: 'boolean1',
	    TEXT: 'text'
	  },
	  DATE_TIMESTAMP: {
	    lastHour: '23:59:59.000Z'
	  },
	  STRIPE_PLACEHOLDER: {
	    CARD_NUMBER: 'cardNumber',
	    EXPIRY: 'expiry',
	    CVC: 'cvc'
	  },
	  STRIPE_PLANS: {
	    MONTHLY: "month"
	  },
	  MESSAGES: {
	    SUCCESS: {
	      USER_PROFILE_UPDATED: "User profile updated successfully",
	      USER_PASSWORD_UPDATED: "User profile updated successfully. Password changed. You will be logged out of the application shortly. Please login to continue"
	    },
	    ERROR: {
	      GENERAL_ERROR: "Oops!!! Something went wrong. Please try again after some time"
	    }
	  }
	};
	
	var _default = constants;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(constants, 'constants', '/Volumes/gitws/GroGuru.git/frontyard/src/js/Constants.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/Constants.js');
	}();

	;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMProperty = __webpack_require__(74);
	var ReactDOMComponentFlags = __webpack_require__(364);
	
	var invariant = __webpack_require__(9);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(662);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(382);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(663);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var BollingerBand = exports.BollingerBand = {
		windowSize: 20,
		// source: d => d.close, // "high", "low", "open", "close"
		sourcePath: "close",
		multiplier: 2,
		movingAverageType: "sma"
	};
	
	var ATR = exports.ATR = {
		windowSize: 14
	};
	
	var ForceIndex = exports.ForceIndex = {
		sourcePath: "close", // "high", "low", "open", "close"
		volumePath: "volume"
	};
	var SmoothedForceIndex = exports.SmoothedForceIndex = {
		sourcePath: "close", // "high", "low", "open", "close"
		volumePath: "volume",
		smoothingType: "ema",
		smoothingWindow: 13
	};
	var Change = exports.Change = {
		sourcePath: "close" // "high", "low", "open", "close"
	};
	var Compare = exports.Compare = {
		basePath: "close",
		mainKeys: ["open", "high", "low", "close"],
		compareKeys: []
	};
	
	var ElderRay = exports.ElderRay = {
		windowSize: 13,
		// source: d => d.close, // "high", "low", "open", "close"
		sourcePath: "close", // "high", "low", "open", "close"
		movingAverageType: "sma"
	};
	
	var ElderImpulse = exports.ElderImpulse = {
		sourcePath: "close" // "high", "low", "open", "close"
	};
	
	var SAR = exports.SAR = {
		accelerationFactor: 0.02,
		maxAccelerationFactor: 0.2
	};
	
	var MACD = exports.MACD = {
		fast: 12,
		slow: 26,
		signal: 9,
		// source: d => d.close, // "high", "low", "open", "close"
		sourcePath: "close"
	};
	
	var FullStochasticOscillator = exports.FullStochasticOscillator = {
		windowSize: 12,
		kWindowSize: 3,
		dWindowSize: 3
	};
	
	var RSI = exports.RSI = {
		windowSize: 14,
		// source: d => d.close, // "high", "low", "open", "close"
		sourcePath: "close" // "high", "low", "open", "close"
	};
	
	var EMA = exports.EMA = {
		// source: d => d.close, // "high", "low", "open", "close"
		sourcePath: "close",
		windowSize: 10
	};
	
	var SMA = exports.SMA = {
		// source: d => d.close, // "high", "low", "open", "close"
		sourcePath: "close",
		windowSize: 10
	};
	
	var WMA = exports.WMA = {
		// source: d => d.close, // "high", "low", "open", "close"
		sourcePath: "close",
		windowSize: 10
	};
	
	var TMA = exports.TMA = {
		// source: d => d.close, // "high", "low", "open", "close"
		sourcePath: "close",
		windowSize: 10
	};
	
	var Kagi = exports.Kagi = {
		reversalType: "ATR", // "ATR", "FIXED"
		windowSize: 14,
		reversal: 2,
		sourcePath: "close" // "high", "low", "open", "close"
		/* dateAccessor: d => d.date,
	 dateMutator: (d, date) => { d.date = date; }, */
	};
	
	var Renko = exports.Renko = {
		reversalType: "ATR", // "ATR", "FIXED"
		windowSize: 14,
		fixedBrickSize: 2,
		sourcePath: "high/low" // "close", "high/low"
		/* source: d => ({ high: d.high, low: d.low }),
	 dateAccessor: d => d.date,
	 dateMutator: (d, date) => { d.date = date; }, */
	};
	
	var PointAndFigure = exports.PointAndFigure = {
		boxSize: 0.5,
		reversal: 3,
		sourcePath: "high/low" // "close", "high/low"
	
		/* source: d => ({ high: d.high, low: d.low }), // "close", "hi/lo"
	 dateAccessor: d => d.date,
	 dateMutator: (d, date) => { d.date = date; }, */
	};
	//# sourceMappingURL=defaultOptionsForComputation.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var id = i++,
		    accessor = void 0,
		    stroke = void 0,
		    fill = void 0,
		    echo = void 0,
		    type = void 0;
	
		function baseIndicator() {}
	
		baseIndicator.id = function (x) {
			if (!arguments.length) return id;
			id = x;
			return baseIndicator;
		};
		baseIndicator.accessor = function (x) {
			if (!arguments.length) return accessor;
			accessor = x;
			return baseIndicator;
		};
		baseIndicator.stroke = function (x) {
			if (!arguments.length) return !stroke ? stroke = (0, _utils.overlayColors)(id) : stroke;
			stroke = x;
			return baseIndicator;
		};
		baseIndicator.fill = function (x) {
			if (!arguments.length) return !fill ? fill = (0, _utils.overlayColors)(id) : fill;
			fill = x;
			return baseIndicator;
		};
		baseIndicator.echo = function (x) {
			if (!arguments.length) return echo;
			echo = x;
			return baseIndicator;
		};
		baseIndicator.type = function (x) {
			if (!arguments.length) return type;
			type = x;
			return baseIndicator;
		};
		return baseIndicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var i = 0;
	//# sourceMappingURL=baseIndicator.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ema = __webpack_require__(94);
	
	Object.defineProperty(exports, "ema", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ema).default;
	  }
	});
	
	var _sma = __webpack_require__(398);
	
	Object.defineProperty(exports, "sma", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sma).default;
	  }
	});
	
	var _wma = __webpack_require__(715);
	
	Object.defineProperty(exports, "wma", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_wma).default;
	  }
	});
	
	var _tma = __webpack_require__(714);
	
	Object.defineProperty(exports, "tma", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_tma).default;
	  }
	});
	
	var _bollingerband = __webpack_require__(701);
	
	Object.defineProperty(exports, "bollingerband", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bollingerband).default;
	  }
	});
	
	var _heikinAshi = __webpack_require__(705);
	
	Object.defineProperty(exports, "heikinAshi", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_heikinAshi).default;
	  }
	});
	
	var _kagi = __webpack_require__(706);
	
	Object.defineProperty(exports, "kagi", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_kagi).default;
	  }
	});
	
	var _pointAndFigure = __webpack_require__(708);
	
	Object.defineProperty(exports, "pointAndFigure", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pointAndFigure).default;
	  }
	});
	
	var _renko = __webpack_require__(709);
	
	Object.defineProperty(exports, "renko", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_renko).default;
	  }
	});
	
	var _macd = __webpack_require__(707);
	
	Object.defineProperty(exports, "macd", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_macd).default;
	  }
	});
	
	var _rsi = __webpack_require__(710);
	
	Object.defineProperty(exports, "rsi", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_rsi).default;
	  }
	});
	
	var _sto = __webpack_require__(713);
	
	Object.defineProperty(exports, "sto", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sto).default;
	  }
	});
	
	var _atr = __webpack_require__(163);
	
	Object.defineProperty(exports, "atr", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_atr).default;
	  }
	});
	
	var _forceIndex = __webpack_require__(397);
	
	Object.defineProperty(exports, "forceIndex", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_forceIndex).default;
	  }
	});
	
	var _smoothedForceIndex = __webpack_require__(712);
	
	Object.defineProperty(exports, "smoothedForceIndex", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_smoothedForceIndex).default;
	  }
	});
	
	var _elderRay = __webpack_require__(704);
	
	Object.defineProperty(exports, "elderRay", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_elderRay).default;
	  }
	});
	
	var _sar = __webpack_require__(711);
	
	Object.defineProperty(exports, "sar", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sar).default;
	  }
	});
	
	var _compare = __webpack_require__(703);
	
	Object.defineProperty(exports, "compare", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_compare).default;
	  }
	});
	
	var _change = __webpack_require__(702);
	
	Object.defineProperty(exports, "change", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_change).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.5';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(169)(module)))

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.navPeek = navPeek;
	exports.navActivate = navActivate;
	exports.navEnable = navEnable;
	exports.navResponsive = navResponsive;
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	// nav
	var NAV_PEEK = exports.NAV_PEEK = 'NAV_PEEK';
	var NAV_ACTIVATE = exports.NAV_ACTIVATE = 'NAV_ACTIVATE';
	var NAV_ENABLE = exports.NAV_ENABLE = 'NAV_ENABLE';
	var NAV_RESPONSIVE = exports.NAV_RESPONSIVE = 'NAV_RESPONSIVE';
	
	function navPeek(peek) {
	  return { type: NAV_PEEK, peek: peek };
	}
	
	function navActivate(active) {
	  return { type: NAV_ACTIVATE, active: active };
	}
	
	function navEnable(enabled) {
	  return { type: NAV_ENABLE, enabled: enabled };
	}
	
	function navResponsive(responsive) {
	  return { type: NAV_RESPONSIVE, responsive: responsive };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NAV_PEEK, 'NAV_PEEK', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/nav.js');
	
	  __REACT_HOT_LOADER__.register(NAV_ACTIVATE, 'NAV_ACTIVATE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/nav.js');
	
	  __REACT_HOT_LOADER__.register(NAV_ENABLE, 'NAV_ENABLE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/nav.js');
	
	  __REACT_HOT_LOADER__.register(NAV_RESPONSIVE, 'NAV_RESPONSIVE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/nav.js');
	
	  __REACT_HOT_LOADER__.register(navPeek, 'navPeek', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/nav.js');
	
	  __REACT_HOT_LOADER__.register(navActivate, 'navActivate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/nav.js');
	
	  __REACT_HOT_LOADER__.register(navEnable, 'navEnable', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/nav.js');
	
	  __REACT_HOT_LOADER__.register(navResponsive, 'navResponsive', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/nav.js');
	}();

	;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.HEADING;
	
	var Heading = function (_Component) {
	  _inherits(Heading, _Component);
	
	  function Heading() {
	    _classCallCheck(this, Heading);
	
	    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
	  }
	
	  _createClass(Heading, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          margin = _props.margin,
	          size = _props.size,
	          strong = _props.strong,
	          Tag = _props.tag,
	          truncate = _props.truncate,
	          uppercase = _props.uppercase,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'strong', 'tag', 'truncate', 'uppercase']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--truncate', truncate), _defineProperty(_classnames, CLASS_ROOT + '--uppercase', uppercase), _classnames), className);
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, props, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Heading;
	}(_react.Component);
	
	Heading.displayName = 'Heading';
	exports.default = Heading;
	
	
	Heading.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  strong: _propTypes2.default.bool,
	  tag: _propTypes2.default.string,
	  truncate: _propTypes2.default.bool,
	  uppercase: _propTypes2.default.bool
	};
	
	Heading.defaultProps = {
	  tag: 'h1'
	};
	module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.FORM_FIELD;
	
	var FormField = function (_Component) {
	  _inherits(FormField, _Component);
	
	  function FormField(props, context) {
	    _classCallCheck(this, FormField);
	
	    var _this = _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).call(this, props, context));
	
	    _this._onFocus = _this._onFocus.bind(_this);
	    _this._onBlur = _this._onBlur.bind(_this);
	    _this._onClick = _this._onClick.bind(_this);
	
	    _this.state = { focus: false };
	    return _this;
	  }
	
	  _createClass(FormField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var contentsElement = this.contentsRef;
	      if (contentsElement) {
	        var inputElements = contentsElement.querySelectorAll('input, textarea, select');
	        if (inputElements.length === 1) {
	          this._inputElement = inputElements[0];
	          this._inputElement.addEventListener('focus', this._onFocus);
	          this._inputElement.addEventListener('blur', this._onBlur);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._inputElement) {
	        this._inputElement.removeEventListener('focus', this._onFocus);
	        this._inputElement.removeEventListener('blur', this._onBlur);
	        delete this._inputElement;
	      }
	    }
	  }, {
	    key: '_onFocus',
	    value: function _onFocus() {
	      this.setState({ focus: true });
	    }
	  }, {
	    key: '_onBlur',
	    value: function _onBlur() {
	      this.setState({ focus: false });
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick() {
	      if (this._inputElement) {
	        this._inputElement.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          help = _props.help,
	          hidden = _props.hidden,
	          htmlFor = _props.htmlFor,
	          label = _props.label,
	          size = _props.size,
	          strong = _props.strong,
	          error = _props.error,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'help', 'hidden', 'htmlFor', 'label', 'size', 'strong', 'error']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--focus', this.state.focus), _defineProperty(_classnames, CLASS_ROOT + '--hidden', hidden), _defineProperty(_classnames, CLASS_ROOT + '--text', htmlFor), _defineProperty(_classnames, CLASS_ROOT + '--size-' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _defineProperty(_classnames, CLASS_ROOT + '--error', error), _classnames), className);
	
	      var fieldError = error ? _react2.default.createElement(
	        'span',
	        { className: CLASS_ROOT + "__error" },
	        error
	      ) : undefined;
	
	      var fieldHelp = help !== null && help !== undefined ? _react2.default.createElement(
	        'span',
	        { className: CLASS_ROOT + "__help" },
	        this.props.help
	      ) : undefined;
	
	      var labelNode = label ? _react2.default.createElement(
	        'label',
	        { className: CLASS_ROOT + "__label", htmlFor: htmlFor },
	        label
	      ) : undefined;
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, props, { onClick: this._onClick }),
	        fieldError,
	        labelNode,
	        fieldHelp,
	        _react2.default.createElement(
	          'span',
	          { ref: function ref(_ref) {
	              return _this2.contentsRef = _ref;
	            },
	            className: CLASS_ROOT + "__contents" },
	          children
	        )
	      );
	    }
	  }]);
	
	  return FormField;
	}(_react.Component);
	
	FormField.displayName = 'FormField';
	exports.default = FormField;
	
	
	FormField.propTypes = {
	  error: _propTypes2.default.node,
	  help: _propTypes2.default.node,
	  hidden: _propTypes2.default.bool,
	  htmlFor: _propTypes2.default.string,
	  label: _propTypes2.default.node,
	  size: _propTypes2.default.oneOf(['medium', 'large']),
	  strong: _propTypes2.default.bool
	};
	
	FormField.defaultProps = {
	  size: 'medium',
	  strong: false
	};
	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(11);
	
	var _DOM = __webpack_require__(47);
	
	// Allow callers to use key labels instead of key code numbers.
	// This makes their code easier to read.
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var KEYS = {
	  backspace: 8,
	  tab: 9,
	  enter: 13,
	  esc: 27,
	  escape: 27,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  comma: 188,
	  shift: 16
	};
	
	var _keyboardAccelerators = {};
	var _listeners = [];
	var _isKeyboardAcceleratorListening = false;
	
	var _onKeyboardAcceleratorKeyPress = function _onKeyboardAcceleratorKeyPress(e) {
	  var key = e.keyCode ? e.keyCode : e.which;
	  _listeners.slice().reverse().some(function (listener) {
	    if (_keyboardAccelerators[listener]) {
	      var handlers = _keyboardAccelerators[listener].handlers;
	      if (handlers.hasOwnProperty(key)) {
	        if (handlers[key] && handlers[key](e)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  });
	};
	
	// KeyboardAccelerators is a utility for handling keyboard events.
	// Add listeners using startListeningToKeyboard().
	// Remove listeners using stopListeningToKeyboard().
	exports.default = {
	  _initKeyboardAccelerators: function _initKeyboardAccelerators(element) {
	    var id = (0, _DOM.generateId)(element);
	    _keyboardAccelerators[id] = {
	      handlers: {}
	    };
	  },
	  _getKeyboardAcceleratorHandlers: function _getKeyboardAcceleratorHandlers(element) {
	    var id = (0, _DOM.generateId)(element);
	    return _keyboardAccelerators[id].handlers;
	  },
	  _getDowns: function _getDowns(element) {
	    var id = (0, _DOM.generateId)(element);
	    return _keyboardAccelerators[id].downs;
	  },
	  _isComponentListening: function _isComponentListening(element) {
	    var id = (0, _DOM.generateId)(element);
	
	    return _listeners.some(function (listener) {
	      return listener === id;
	    });
	  },
	  _subscribeComponent: function _subscribeComponent(element) {
	    var id = (0, _DOM.generateId)(element);
	    _listeners.push(id);
	  },
	  _unsubscribeComponent: function _unsubscribeComponent(element) {
	    var id = (0, _DOM.generateId)(element);
	
	    var removeListenerIndex = _listeners.indexOf(id);
	    _listeners.splice(removeListenerIndex, 1);
	
	    delete _keyboardAccelerators[id];
	  },
	
	
	  // Add handlers for specific keys.
	  // This function can be called multiple times, existing handlers will
	  // be replaced, new handlers will be added.
	  startListeningToKeyboard: function startListeningToKeyboard(component, handlers) {
	    var element = (0, _reactDom.findDOMNode)(component);
	    if (element) {
	      this._initKeyboardAccelerators(element);
	      var keys = 0;
	      for (var key in handlers) {
	        if (handlers.hasOwnProperty(key)) {
	          var keyCode = key;
	          if (KEYS.hasOwnProperty(key)) {
	            keyCode = KEYS[key];
	          }
	          keys += 1;
	          this._getKeyboardAcceleratorHandlers(element)[keyCode] = handlers[key];
	        }
	      }
	
	      if (keys > 0) {
	        if (!_isKeyboardAcceleratorListening) {
	          window.addEventListener("keydown", _onKeyboardAcceleratorKeyPress);
	          _isKeyboardAcceleratorListening = true;
	        }
	        if (!this._isComponentListening(element)) {
	          this._subscribeComponent(element);
	        }
	      }
	    }
	  },
	
	
	  // Remove handlers for all keys or specific keys.
	  // If no argument is passed in, all handlers are removed.
	  // This function can be called multiple times, only the handlers
	  // specified will be removed.
	  stopListeningToKeyboard: function stopListeningToKeyboard(component, handlers) {
	    var element = (0, _reactDom.findDOMNode)(component);
	    if (!this._isComponentListening(element)) {
	      return;
	    }
	    if (handlers) {
	      for (var key in handlers) {
	        if (handlers.hasOwnProperty(key)) {
	          var keyCode = key;
	          if (KEYS.hasOwnProperty(key)) {
	            keyCode = KEYS[key];
	          }
	          delete this._getKeyboardAcceleratorHandlers(element)[keyCode];
	        }
	      }
	    }
	
	    var keyCount = 0;
	    for (var keyHandler in this._getKeyboardAcceleratorHandlers(element)) {
	      if (this._getKeyboardAcceleratorHandlers(element).hasOwnProperty(keyHandler)) {
	        keyCount += 1;
	      }
	    }
	
	    if (!handlers || 0 === keyCount) {
	      this._initKeyboardAccelerators(element);
	      this._unsubscribeComponent(element);
	    }
	
	    if (_listeners.length === 0) {
	      window.removeEventListener("keydown", _onKeyboardAcceleratorKeyPress);
	      _isKeyboardAcceleratorListening = false;
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	function formatDecimal(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  this.fill = match[1] || " ";
	  this.align = match[2] || ">";
	  this.sign = match[3] || "-";
	  this.symbol = match[4] || "";
	  this.zero = !!match[5];
	  this.width = match[6] && +match[6];
	  this.comma = !!match[7];
	  this.precision = match[8] && +match[8].slice(1);
	  this.trim = !!match[9];
	  this.type = match[10] || "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision == null && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames4 = __webpack_require__(6);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.HEADER;
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props, context) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props, context));
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this._alignMirror = _this._alignMirror.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.fixed) {
	        window.addEventListener('resize', this._onResize);
	        this._onResize();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.fixed) {
	        this._onResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.fixed) {
	        clearTimeout(this._resizeTimer);
	        window.removeEventListener('resize', this._onResize);
	      }
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      // give just a little time for the DOM to stabilize
	      clearTimeout(this._resizeTimer);
	      this._resizeTimer = setTimeout(this._alignMirror, 10);
	    }
	  }, {
	    key: '_alignMirror',
	    value: function _alignMirror() {
	      var contentElement = _reactDom2.default.findDOMNode(this.contentRef);
	      var mirrorElement = this.mirrorRef;
	
	      // constrain fixed content to the width of the mirror
	      var mirrorRect = mirrorElement.getBoundingClientRect();
	      contentElement.style.width = Math.floor(mirrorRect.width) + 'px';
	
	      // align the mirror height with the content's height
	      var contentRect = contentElement.getBoundingClientRect();
	      mirrorElement.style.height = Math.floor(contentRect.height) + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _classnames2,
	          _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          fixed = _props.fixed,
	          float = _props.float,
	          role = _props.role,
	          size = _props.size,
	          splash = _props.splash;
	
	      var classes = (0, _classnames5.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size && typeof size === 'string'), _defineProperty(_classnames, CLASS_ROOT + '--float', float), _defineProperty(_classnames, CLASS_ROOT + '--splash', splash), _classnames), className);
	      var containerClasses = (0, _classnames5.default)(CLASS_ROOT + '__container', (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '__container--fixed', fixed), _defineProperty(_classnames2, CLASS_ROOT + '__container--fill', fixed && !colorIndex), _defineProperty(_classnames2, CLASS_ROOT + '__container--float', float), _classnames2));
	      var wrapperClasses = (0, _classnames5.default)(CLASS_ROOT + '__wrapper', _defineProperty({}, CLASS_ROOT + '__wrapper--' + size, size && typeof size === 'string'));
	      var other = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	      var restProps = _Props2.default.omit(this.props, Object.keys(Header.propTypes));
	      if (size && typeof size === 'string') {
	        // don't transfer size to Box since it means something different
	        delete other.size;
	      }
	
	      if (fixed) {
	        return _react2.default.createElement(
	          'div',
	          { className: containerClasses },
	          _react2.default.createElement('div', { ref: function ref(_ref) {
	              return _this2.mirrorRef = _ref;
	            },
	            className: CLASS_ROOT + '__mirror' }),
	          _react2.default.createElement(
	            'div',
	            { className: wrapperClasses },
	            _react2.default.createElement(
	              _Box2.default,
	              { pad: 'none', flex: false },
	              _react2.default.createElement(
	                _Box2.default,
	                _extends({ ref: function ref(_ref2) {
	                    return _this2.contentRef = _ref2;
	                  }
	                }, other, restProps, { tag: 'header',
	                  className: classes }),
	                children
	              )
	            )
	          )
	        );
	      } else {
	        return (
	          // ie11 does not work with align center and min-height
	          // adding a wrapper flex div with column direction fixes the issue
	          // https://github.com/philipwalton/flexbugs
	          _react2.default.createElement(
	            _Box2.default,
	            { pad: 'none', flex: false },
	            _react2.default.createElement(
	              _Box2.default,
	              _extends({}, other, restProps, { tag: 'header', role: role,
	                className: classes,
	                containerClassName: containerClasses }),
	              children
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	Header.displayName = 'Header';
	exports.default = Header;
	
	
	Header.propTypes = _extends({
	  fixed: _propTypes2.default.bool,
	  float: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  splash: _propTypes2.default.bool
	}, _Box2.default.propTypes);
	
	Header.defaultProps = {
	  pad: { horizontal: 'none', vertical: 'none', between: 'small' },
	  direction: 'row',
	  align: 'center',
	  responsive: false
	};
	module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.announcePageLoaded = announcePageLoaded;
	exports.announce = announce;
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLASS_ROOT = _CSSClassnames2.default.APP; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	function clearAnnouncer() {
	  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
	  if (announcer) {
	    announcer.innerHTML = '';
	  }
	};
	
	function announcePageLoaded(title) {
	  announce(title + ' page was loaded');
	}
	
	function announce(message) {
	  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';
	
	  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
	  if (announcer) {
	    announcer.setAttribute('aria-live', 'off');
	    announcer.innerHTML = message;
	    setTimeout(clearAnnouncer, 500);
	    announcer.setAttribute('aria-live', mode);
	  }
	}
	
	exports.default = { announce: announce, announcePageLoaded: announcePageLoaded };

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterChart = filterChart;
	exports.saveInSession = saveInSession;
	exports.getFromSession = getFromSession;
	exports.getMapCenter = getMapCenter;
	exports.checkForNumber = checkForNumber;
	exports.loadTwigDataBasedonPreference = loadTwigDataBasedonPreference;
	exports.getDateFromDateRange = getDateFromDateRange;
	exports.getInitialFromDate = getInitialFromDate;
	exports.getSelectedTwigDetails = getSelectedTwigDetails;
	exports.convertToISO = convertToISO;
	exports.convertDate = convertDate;
	exports.roundOffDecimals = roundOffDecimals;
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // (C) Copyright 2015 Hewlett Packard Enterprise Development LP
	
	
	function filterChart(chartData, chartOptions) {
	  for (var key in chartData) {
	    /**display options */
	    chartData[key] = chartOptions.displayOptions[key] ? chartData[key] : null;
	    /*** */
	    /**Depth */
	
	    for (var depthKey in chartData[key]) {
	      var lastLetter = depthKey.substr(depthKey.length - 1, 1);
	      if (lastLetter === ")") {
	        lastLetter = depthKey.substr(depthKey.length - 2, 1);
	      }
	      if (isNaN(lastLetter)) {
	        lastLetter = extractDisplayOptionIndex(depthKey);
	      }
	
	      if (depthKey.search('onboard') == -1) {
	        chartData[key][depthKey] = chartOptions.depth[lastLetter] ? chartData[key][depthKey] : [];
	      }
	    }
	  }
	  return chartData;
	}
	
	function extractDisplayOptionIndex(depthKey) {
	  var deptOptions = ['top', 'middle', 'bottom'];
	  var selectedIndex = -2;
	  for (var index = 0; index < deptOptions.length; index++) {
	    if (depthKey.toLowerCase().indexOf(deptOptions[index]) > -1) {
	      selectedIndex = index;
	      break;
	    }
	  }
	  return selectedIndex + 1;
	}
	
	function saveInSession(key, value) {
	  sessionStorage[key] = JSON.stringify(value);
	}
	function getFromSession(key) {
	  if (sessionStorage[key]) {
	    return JSON.parse(sessionStorage[key]);
	  } else {
	    return false;
	  }
	}
	function getMapCenter() {
	  var postionObj = {};
	
	  if (navigator.geolocation) {
	    navigator.geolocation.getCurrentPosition(function (position) {
	      postionObj = {
	        lat: position.coords.latitude, lng: position.coords.longitude
	      };
	      return postionObj;
	    });
	  }
	}
	
	function checkForNumber(val) {
	
	  var re = /^([0-9]+[\.]?[0-9]?[0-9]?|[0-9]+)$/g;
	  var re1 = /^([0-9]+[\.]?[0-9]?[0-9]?|[0-9]+)/g;
	  if (re.test(val) || val == '') {
	    return true;
	  } else {
	    return false;
	  };
	}
	
	function loadTwigDataBasedonPreference(state, payload) {
	  var _Depth;
	
	  var twigIndex = 0,
	      selectedTwig = [];
	  //payload.userPreferences.preference.stem
	  state.twigsList.map(function (twig, index) {
	    if (twig.twigId == payload.UserPref.preference.stem) {
	      selectedTwig = twig;
	      twigIndex = index;
	    }
	  });
	
	  var DateRange = getDateFromDateRange(payload.UserPref.dateRange);
	  return {
	    twigIndex: twigIndex, selectedTwig: selectedTwig,
	    DateRange: {
	      type: payload.UserPref.preference.dateRange,
	      fromDate: payload.UserPref.preference.fromDate,
	      toDate: payload.UserPref.preference.toDate
	    },
	    Depth: (_Depth = {}, _defineProperty(_Depth, _Constants2.default.CHART_OPTIONS.TOP, payload.UserPref.preference.depth[_Constants2.default.CHART_OPTIONS.TOP]), _defineProperty(_Depth, _Constants2.default.CHART_OPTIONS.MIDDLE, payload.UserPref.preference.depth[_Constants2.default.CHART_OPTIONS.MIDDLE]), _defineProperty(_Depth, _Constants2.default.CHART_OPTIONS.BOTTOM, payload.UserPref.preference.depth[_Constants2.default.CHART_OPTIONS.BOTTOM]), _Depth)
	  };
	}
	
	function getDateFromDateRange(value) {
	  // let value = e.target.value;
	  var fromDate = '';
	  var now = new Date();
	  var toDate = now.getTime();
	  switch (value) {
	    case _Constants2.default.DATE_RANGE.ALL:
	      fromDate = '';
	      break;
	    case _Constants2.default.DATE_RANGE.CUSTOM:
	      fromDate = false;
	      break;
	    case _Constants2.default.DATE_RANGE.LAST_HOUR:
	      fromDate = now.setHours(now.getHours() - 1);
	      break;
	    case _Constants2.default.DATE_RANGE.LAST_SIX_HOURS:
	      fromDate = now.setHours(now.getHours() - 6);
	      break;
	    case _Constants2.default.DATE_RANGE.ONE_DAY:
	      fromDate = now.setHours(now.getHours() - 24);
	      break;
	    case _Constants2.default.DATE_RANGE.ONE_TO_ELEVAN_MONTHS:
	      fromDate = now.setMonth(now.getMonth() - 11);
	      break;
	    case _Constants2.default.DATE_RANGE.ONE_WEEK:
	      fromDate = now.setDate(now.getDate() - 7);
	      break;
	    case _Constants2.default.DATE_RANGE.ONE_YEAR:
	      fromDate = now.setYear(now.getFullYear() - 1);
	      break;
	    case _Constants2.default.DATE_RANGE.TWO_WEEKS:
	      fromDate = now.setDate(now.getDate() - 14);
	      break;
	    case _Constants2.default.DATE_RANGE.ONE_MONTH:
	      fromDate = now.setMonth(now.getMonth() - 1);
	      break;
	    case _Constants2.default.DATE_RANGE.SIX_MONTHS:
	      fromDate = now.setMonth(now.getMonth() - 6);
	      break;
	
	    default:
	      break;
	  }
	
	  return { fromDate: fromDate, toDate: toDate };
	}
	
	function getInitialFromDate() {
	  var now = new Date();
	  var fromDate = now.setDate(now.getDate() - 14);
	  return fromDate;
	}
	
	function getSelectedTwigDetails(twigId, twigList) {
	  var filteredTwig = [],
	      displayOption = {};
	  filteredTwig = twigList.filter(function (twig) {
	    return twig.twigId === twigId;
	  });
	  if (filteredTwig.length > 0) {
	    Object.keys(filteredTwig[0].details.data).map(function (key, index) {
	      displayOption[key] = true;
	    });
	    return displayOption;
	  } else {
	    return {};
	  }
	}
	
	function convertToISO(input) {
	  if (input && typeof input === "number") {
	    input = new Date(input).toISOString();
	  }
	  if (input && input.length > 0) {
	    var newDate = '';
	    try {
	      var arr = input.split('/');
	      if (arr.length === 1) {
	        newDate = convertDate(input);
	        if (newDate.length > 0) {
	          var arrDate = newDate.split('/');
	          if (arrDate.length > 1) {
	            var finalDate = new Date(arrDate[2], arrDate[0] - 1, arrDate[1], 12).toISOString();
	            return finalDate;
	          } else {
	            return arrDate[0];
	          }
	        }
	      } else {
	        newDate = new Date(arr[2], arr[0] - 1, arr[1], 12).toISOString();
	      }
	      return newDate;
	    } catch (error) {
	      return '';
	    }
	  } else {
	    return '';
	  }
	}
	
	function convertDate(inputFormat) {
	  function pad(s) {
	    return s < 10 ? '0' + s : s;
	  }
	  try {
	    if (inputFormat) {
	      var d = new Date(inputFormat);
	      return [pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/');
	    } else {
	      return '';
	    }
	  } catch (error) {
	    return '';
	  }
	}
	
	function roundOffDecimals(number) {
	  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	  return parseFloat(Math.round(number * 100) / 100).toFixed(decimals);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterChart, 'filterChart', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(extractDisplayOptionIndex, 'extractDisplayOptionIndex', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(saveInSession, 'saveInSession', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(getFromSession, 'getFromSession', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(getMapCenter, 'getMapCenter', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(checkForNumber, 'checkForNumber', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(loadTwigDataBasedonPreference, 'loadTwigDataBasedonPreference', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(getDateFromDateRange, 'getDateFromDateRange', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(getInitialFromDate, 'getInitialFromDate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(getSelectedTwigDetails, 'getSelectedTwigDetails', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(convertToISO, 'convertToISO', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(convertDate, 'convertDate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	
	  __REACT_HOT_LOADER__.register(roundOffDecimals, 'roundOffDecimals', '/Volumes/gitws/GroGuru.git/frontyard/src/js/utils/Utility.js');
	}();

	;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CHECK_BOX;
	
	var CheckBox = function (_Component) {
	  _inherits(CheckBox, _Component);
	
	  function CheckBox() {
	    _classCallCheck(this, CheckBox);
	
	    return _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).apply(this, arguments));
	  }
	
	  _createClass(CheckBox, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          checked = _props.checked,
	          className = _props.className,
	          disabled = _props.disabled,
	          label = _props.label,
	          name = _props.name,
	          onChange = _props.onChange,
	          reverse = _props.reverse,
	          toggle = _props.toggle,
	          props = _objectWithoutProperties(_props, ['checked', 'className', 'disabled', 'label', 'name', 'onChange', 'reverse', 'toggle']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--toggle', toggle), _defineProperty(_classnames, CLASS_ROOT + '--disabled', disabled), _defineProperty(_classnames, CLASS_ROOT + '--reverse', reverse), _classnames), className);
	
	      var hidden = void 0;
	      if (disabled && checked) {
	        hidden = _react2.default.createElement('input', { name: name, type: 'hidden', value: 'true' });
	      }
	
	      var children = [_react2.default.createElement(
	        'span',
	        { key: 'checkbox' },
	        _react2.default.createElement('input', _extends({}, props, { tabIndex: '0', className: CLASS_ROOT + '__input',
	          name: name, type: 'checkbox',
	          disabled: disabled,
	          checked: checked,
	          onChange: onChange })),
	        _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__control' },
	          _react2.default.createElement(
	            'svg',
	            { className: CLASS_ROOT + '__control-check', viewBox: '0 0 24 24',
	              preserveAspectRatio: 'xMidYMid meet' },
	            _react2.default.createElement('path', { fill: 'none', d: 'M6,11.3 L10.3,16 L18,6.2' })
	          )
	        )
	      ), _react2.default.createElement(
	        'span',
	        { key: 'label', className: CLASS_ROOT + '__label' },
	        label
	      )];
	
	      return _react2.default.createElement(
	        'label',
	        { className: classes, htmlFor: props.id },
	        reverse ? children.reverse() : children,
	        hidden
	      );
	    }
	  }]);
	
	  return CheckBox;
	}(_react.Component);
	
	CheckBox.displayName = 'CheckBox';
	exports.default = CheckBox;
	
	
	CheckBox.propTypes = {
	  checked: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  id: _propTypes2.default.string,
	  label: _propTypes2.default.node,
	  name: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  reverse: _propTypes2.default.bool,
	  toggle: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Close = __webpack_require__(63);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _DOM = __webpack_require__(47);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LAYER;
	var APP = _CSSClassnames2.default.APP;
	
	var LayerContents = function (_Component) {
	  _inherits(LayerContents, _Component);
	
	  function LayerContents(props, context) {
	    _classCallCheck(this, LayerContents);
	
	    var _this = _possibleConstructorReturn(this, (LayerContents.__proto__ || Object.getPrototypeOf(LayerContents)).call(this, props, context));
	
	    _this._onClickOverlay = _this._onClickOverlay.bind(_this);
	    _this._processTab = _this._processTab.bind(_this);
	
	    _this.state = {
	      dropActive: false
	    };
	    return _this;
	  }
	
	  _createClass(LayerContents, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      return {
	        history: this.props.history,
	        intl: this.props.intl,
	        onDropChange: function onDropChange(active) {
	          _this2.setState({ dropActive: active });
	        },
	        router: this.props.router,
	        store: this.props.store
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          hidden = _props.hidden,
	          onClose = _props.onClose,
	          overlayClose = _props.overlayClose;
	
	
	      if (!hidden) {
	        this.anchorStepRef.focus();
	        this.anchorStepRef.scrollIntoView();
	      }
	
	      this._keyboardHandlers = {
	        tab: this._processTab
	      };
	      if (onClose) {
	        this._keyboardHandlers.esc = onClose;
	      }
	      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	
	      if (onClose && overlayClose) {
	        var layerParent = this.containerRef.parentNode;
	        layerParent.addEventListener('click', this._onClickOverlay);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hidden = this.props.hidden;
	
	
	      if (nextProps.hidden !== hidden) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	
	        if (!nextProps.hidden) {
	          _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	        }
	      };
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props2 = this.props,
	          onClose = _props2.onClose,
	          overlayClose = _props2.overlayClose;
	
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	
	      if (onClose && overlayClose) {
	        var layerParent = this.containerRef.parentNode;
	        layerParent.removeEventListener('click', this._onClickOverlay);
	      }
	    }
	  }, {
	    key: '_processTab',
	    value: function _processTab(event) {
	      var hidden = this.props.hidden;
	
	      if (hidden) {
	        return;
	      }
	      var items = this.containerRef.getElementsByTagName('*');
	      items = (0, _DOM.filterByFocusable)(items);
	
	      if (!items || items.length === 0) {
	        event.preventDefault();
	      } else {
	        if (event.shiftKey) {
	          if (event.target === items[0]) {
	            items[items.length - 1].focus();
	            event.preventDefault();
	          }
	        } else if (event.target === items[items.length - 1]) {
	          items[0].focus();
	          event.preventDefault();
	        }
	      }
	    }
	  }, {
	    key: '_onClickOverlay',
	    value: function _onClickOverlay(event) {
	      var dropActive = this.state.dropActive;
	
	      if (!dropActive) {
	        var onClose = this.props.onClose;
	
	        var layerContents = this.containerRef;
	
	        if (layerContents && !layerContents.contains(event.target)) {
	          onClose();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          a11yTitle = _props3.a11yTitle,
	          children = _props3.children,
	          closer = _props3.closer,
	          onClose = _props3.onClose;
	      var intl = this.context.intl;
	
	
	      var closerNode = void 0;
	      if ((typeof closer === 'undefined' ? 'undefined' : _typeof(closer)) === 'object') {
	        closerNode = closer;
	      } else if (onClose && closer) {
	        var closeLabel = _Intl2.default.getMessage(intl, 'Close');
	        var layerLabel = _Intl2.default.getMessage(intl, 'Layer');
	        var closeIconTitle = closeLabel + ' ' + (a11yTitle || '') + ' ' + layerLabel;
	
	        closerNode = _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + '__closer' },
	          _react2.default.createElement(_Button2.default, { plain: true, icon: _react2.default.createElement(_Close2.default, {
	              a11yTitle: closeIconTitle }),
	            onClick: onClose })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(_ref2) {
	            return _this3.containerRef = _ref2;
	          },
	          className: CLASS_ROOT + '__container' },
	        _react2.default.createElement('a', { tabIndex: '-1', 'aria-hidden': 'true', style: { outline: 'none' },
	          ref: function ref(_ref) {
	            return _this3.anchorStepRef = _ref;
	          } }),
	        closerNode,
	        children
	      );
	    }
	  }]);
	
	  return LayerContents;
	}(_react.Component);
	
	LayerContents.displayName = 'LayerContents';
	
	
	LayerContents.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  closer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  onClose: _propTypes2.default.func,
	  overlayClose: _propTypes2.default.bool,
	  router: _propTypes2.default.any,
	  store: _propTypes2.default.any
	};
	
	// Because Layer creates a new DOM render context, the context
	// is not transfered. For now, we hard code these specific ones.
	// TODO: Either figure out how to introspect the context and transfer
	// whatever we find or have callers explicitly indicate which parts
	// of the context to transfer somehow.
	LayerContents.childContextTypes = {
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  onDropChange: _propTypes2.default.func,
	  router: _propTypes2.default.any,
	  store: _propTypes2.default.object
	};
	
	var Layer = function (_Component2) {
	  _inherits(Layer, _Component2);
	
	  function Layer() {
	    _classCallCheck(this, Layer);
	
	    return _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).apply(this, arguments));
	  }
	
	  _createClass(Layer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._originalFocusedElement = document.activeElement;
	      this._originalScrollPosition = {
	        top: window.pageYOffset,
	        left: window.pageXOffset
	      };
	      this._addLayer();
	      this._renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this5 = this;
	
	      var hidden = this.props.hidden;
	
	      if (this._originalFocusedElement && !hidden) {
	        if (this._originalFocusedElement.focus) {
	          // wait for the fixed positioning to come back to normal
	          // see layer styling for reference
	          setTimeout(function () {
	            _this5._originalFocusedElement.focus();
	            window.scrollTo(_this5._originalScrollPosition.left, _this5._originalScrollPosition.top);
	          }, 0);
	        } else if (this._originalFocusedElement.parentNode && this._originalFocusedElement.parentNode.focus) {
	          // required for IE11 and Edge
	          this._originalFocusedElement.parentNode.focus();
	          window.scrollTo(this._originalScrollPosition.left, this._originalScrollPosition.top);
	        }
	      }
	
	      this._removeLayer();
	    }
	  }, {
	    key: '_classesFromProps',
	    value: function _classesFromProps() {
	      var _classnames;
	
	      var _props4 = this.props,
	          align = _props4.align,
	          className = _props4.className,
	          closer = _props4.closer,
	          flush = _props4.flush,
	          hidden = _props4.hidden,
	          peek = _props4.peek;
	
	
	      return (0, _classnames3.default)('grommet', CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--align-' + this.props.align, align), _defineProperty(_classnames, CLASS_ROOT + '--closeable', closer), _defineProperty(_classnames, CLASS_ROOT + '--flush', flush), _defineProperty(_classnames, CLASS_ROOT + '--hidden', hidden), _defineProperty(_classnames, CLASS_ROOT + '--peek', peek), _classnames), className);
	    }
	  }, {
	    key: '_addLayer',
	    value: function _addLayer() {
	      var id = this.props.id;
	
	
	      var element = document.createElement('div');
	      if (id) {
	        element.id = id;
	      }
	      element.className = this._classesFromProps();
	      // insert before .app, if possible.
	      var appElements = document.querySelectorAll('.' + APP);
	      var beforeElement;
	      if (appElements.length > 0) {
	        beforeElement = appElements[0];
	      } else {
	        beforeElement = document.body.firstChild;
	      }
	      if (beforeElement) {
	        this._element = beforeElement.parentNode.insertBefore(element, beforeElement);
	      }
	    }
	  }, {
	    key: '_handleAriaHidden',
	    value: function _handleAriaHidden(hideOverlay) {
	      var _this6 = this;
	
	      setTimeout(function () {
	        var ariaHidden = hideOverlay || false;
	        var grommetApps = document.querySelectorAll('.' + APP);
	        var visibleLayers = document.querySelectorAll('.' + CLASS_ROOT + ':not(.' + CLASS_ROOT + '--hidden)');
	
	        if (grommetApps) {
	          Array.prototype.slice.call(grommetApps).forEach(function (grommetApp) {
	            if (ariaHidden && visibleLayers.length === 0) {
	              // make sure to only show grommet apps if there is no other layer
	              grommetApp.setAttribute('aria-hidden', false);
	              grommetApp.classList.remove(APP + '--hidden');
	              // scroll body content to the original position
	              grommetApp.style.top = '-' + _this6._originalScrollPosition.top + 'px';
	              grommetApp.style.left = '-' + _this6._originalScrollPosition.left + 'px';
	            } else {
	              grommetApp.setAttribute('aria-hidden', true);
	              grommetApp.classList.add(APP + '--hidden');
	              // this must be null to work
	              grommetApp.style.top = null;
	              grommetApp.style.left = null;
	            }
	          }, _this6);
	        }
	      }, 0);
	    }
	  }, {
	    key: '_renderLayer',
	    value: function _renderLayer() {
	      var _this7 = this;
	
	      if (this._element) {
	        this._element.className = this._classesFromProps();
	        var contents = _react2.default.createElement(LayerContents, _extends({}, this.props, {
	          history: this.context.history,
	          intl: this.context.intl,
	          router: this.context.router,
	          store: this.context.store }));
	        _reactDom2.default.render(contents, this._element, function () {
	          var hidden = _this7.props.hidden;
	
	          if (hidden) {
	            _this7._handleAriaHidden(true);
	          } else {
	            _this7._handleAriaHidden(false);
	          }
	        });
	      }
	    }
	  }, {
	    key: '_removeLayer',
	    value: function _removeLayer() {
	      if (this._element) {
	        this._element.removeEventListener('animationend', this._onAnimationEnd);
	
	        _reactDom2.default.unmountComponentAtNode(this._element);
	        this._element.parentNode.removeChild(this._element);
	        this._element = undefined;
	
	        // make sure to handle aria attributes after the layer is removed
	        this._handleAriaHidden(true);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('span', { style: { display: 'none' } });
	    }
	  }]);
	
	  return Layer;
	}(_react.Component);
	
	Layer.displayName = 'Layer';
	exports.default = Layer;
	
	
	Layer.propTypes = {
	  align: _propTypes2.default.oneOf(['center', 'top', 'bottom', 'left', 'right']),
	  closer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
	  flush: _propTypes2.default.bool,
	  hidden: _propTypes2.default.bool,
	  overlayClose: _propTypes2.default.bool,
	  peek: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func
	};
	
	Layer.contextTypes = {
	  router: _propTypes2.default.any,
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  store: _propTypes2.default.object
	};
	
	Layer.defaultProps = {
	  align: 'center'
	};
	module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(18);
	
	var CallbackQueue = __webpack_require__(362);
	var PooledClass = __webpack_require__(64);
	var ReactFeatureFlags = __webpack_require__(367);
	var ReactReconciler = __webpack_require__(75);
	var Transaction = __webpack_require__(109);
	
	var invariant = __webpack_require__(9);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(58);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(161);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(76);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(675);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(386);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(671);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(686);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(672);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(673);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(388);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(674);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(162);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(684);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(393);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(677);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(678);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(682);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(390);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Logo = __webpack_require__(98);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var NavControl = function (_Component) {
	  _inherits(NavControl, _Component);
	
	  function NavControl() {
	    _classCallCheck(this, NavControl);
	
	    return _possibleConstructorReturn(this, (NavControl.__proto__ || Object.getPrototypeOf(NavControl)).apply(this, arguments));
	  }
	
	  _createClass(NavControl, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          active = _props.nav.active,
	          title = _props.title;
	
	
	      var result = void 0;
	      if (!active) {
	        var label = void 0;
	        if (title) {
	          label = 'oo';
	        }
	        result = _react2.default.createElement(
	          _Button2.default,
	          { onClick: function onClick() {
	              return _this2.props.dispatch((0, _actions.navActivate)(true));
	            } },
	          _react2.default.createElement(_Logo2.default, null),
	          label
	        );
	      } else {
	        result = null;
	      }
	      return result;
	    }
	  }]);
	
	  return NavControl;
	}(_react.Component);
	
	;
	
	NavControl.propTypes = {
	  // instanceName: PropTypes.string,
	  nav: _react.PropTypes.object,
	  title: _react.PropTypes.bool
	};
	
	var select = function select(state, props) {
	  return {
	    // instanceName: state.settings.settings.name,
	    nav: state.nav
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(NavControl);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NavControl, 'NavControl', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/NavControl.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/NavControl.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/NavControl.js');
	}();

	;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(173);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(179).Promise;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.findScrollParents = findScrollParents;
	exports.isDescendant = isDescendant;
	exports.findAncestor = findAncestor;
	exports.filterByFocusable = filterByFocusable;
	exports.getBestFirstFocusable = getBestFirstFocusable;
	exports.isFormElement = isFormElement;
	exports.generateId = generateId;
	exports.generateUUID = generateUUID;
	exports.checkDarkBackground = checkDarkBackground;
	exports.findVisibleParent = findVisibleParent;
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var COLOR_RGB_REGEXP = /rgb\((\d+), (\d+), (\d+)\)/;
	var COLOR_RGBA_REGEXP = /rgba\((\d+), (\d+), (\d+), ([\d\.]+)\)/;
	var LIGHT_HINT_REGEXP = /^light/;
	
	function hash(input) {
	  var hash = 0,
	      i,
	      chr,
	      len;
	  if (input.length === 0) return hash;
	  for (i = 0, len = input.length; i < len; i++) {
	    chr = input.charCodeAt(i);
	    hash = (hash << 5) - hash + chr;
	    hash = hash & hash; // Convert to 32bit integer
	  }
	  return hash;
	};
	
	function findScrollParents(element, horizontal) {
	  var result = [];
	  var parent = element.parentNode;
	  while (parent && parent.getBoundingClientRect) {
	    var rect = parent.getBoundingClientRect();
	    // 10px is to account for borders and scrollbars in a lazy way
	    if (horizontal) {
	      if (rect.width && parent.scrollWidth > rect.width + 10) {
	        result.push(parent);
	      }
	    } else {
	      if (rect.height && parent.scrollHeight > rect.height + 10) {
	        result.push(parent);
	      }
	    }
	    parent = parent.parentNode;
	  }
	  // last scrollable element will be the document
	  // if nothing else is scrollable in the page
	  if (result.length === 0) {
	    result.push(document);
	  }
	  return result;
	}
	
	function isDescendant(parent, child) {
	  var node = child.parentNode;
	  while (node != null) {
	    if (node == parent) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	}
	
	function findAncestor(element, className) {
	  var node = element.parentNode;
	  while (node != null) {
	    if (node.classList && node.classList.contains(className)) {
	      break;
	    }
	    node = node.parentNode;
	  }
	  return node;
	}
	
	function filterByFocusable(elements) {
	  return Array.prototype.filter.call(elements || [], function (element) {
	    var currentTag = element.tagName.toLowerCase();
	    var validTags = /(svg|a|area|input|select|textarea|button|iframe|div)$/;
	    var isValidTag = currentTag.match(validTags) && element.focus;
	
	    if (currentTag === 'a') {
	      return isValidTag && element.childNodes.length > 0 && element.getAttribute('href');
	    } else if (currentTag === 'svg' || currentTag === 'div') {
	      return isValidTag && element.hasAttribute('tabindex');
	    }
	
	    return isValidTag;
	  });
	}
	
	function getBestFirstFocusable(elements) {
	  var bestFirstFocusable;
	
	  Array.prototype.some.call(elements || [], function (element) {
	    var currentTag = element.tagName.toLowerCase();
	    var isValidTag = currentTag.match(/(input|select|textarea)$/);
	    return isValidTag ? (bestFirstFocusable = element, true) : false;
	  });
	
	  if (!bestFirstFocusable) {
	    bestFirstFocusable = this.filterByFocusable(elements)[0];
	  }
	
	  return bestFirstFocusable;
	}
	
	function isFormElement(element) {
	  var elementType = element ? element.tagName.toLowerCase() : undefined;
	  return elementType && (elementType === 'input' || elementType === 'textarea');
	}
	
	function generateId(element) {
	  if (element && typeof element.getAttribute === 'function') {
	    var id = void 0;
	    var elementId = element.getAttribute('id');
	    if (!elementId) {
	      // IE11 fix: check for parentNode instead of parentElement
	      var parentElement = element.parentElement || element.parentNode;
	      if (parentElement) {
	        id = hash(parentElement.innerHTML);
	        element.setAttribute('id', id);
	      }
	    } else {
	      id = elementId;
	    }
	    return id;
	  }
	}
	
	function generateUUID() {
	  function S4() {
	    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
	  }
	  var uuid = '' + S4() + S4() + ('-' + S4() + '-4' + S4().substr(0, 3)) + ('-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
	  return uuid;
	}
	
	var CHECK_DARK_BACKGROUND_BACKOFFS = [0, 20, 80, 200];
	
	function hasDarkBackground(element) {
	  var result = false;
	  var color = window.getComputedStyle(element).backgroundColor;
	  var match = color.match(COLOR_RGB_REGEXP) || color.match(COLOR_RGBA_REGEXP);
	  if (match) {
	    var _match$slice$map = match.slice(1).map(function (n) {
	      return parseInt(n, 10);
	    }),
	        _match$slice$map2 = _slicedToArray(_match$slice$map, 3),
	        red = _match$slice$map2[0],
	        green = _match$slice$map2[1],
	        blue = _match$slice$map2[2];
	    // http://www.had2know.com/technology/
	    //  color-contrast-calculator-web-design.html
	
	
	    var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
	    if (0 === brightness) {
	      // Browsers return 0,0,0 when they don't know yet.
	      result = undefined;
	      // changed threshold below to accomodate the Aruba theme for now
	    } else if (brightness < 137) {
	      ///125) {
	      result = true;
	    }
	  }
	  return result;
	}
	
	function checkDarkBackgroundBackoff(element, handler, backoffDurations) {
	  return setTimeout(function () {
	    var dark = hasDarkBackground(element);
	    if (undefined === dark && backoffDurations.length > 0) {
	      checkDarkBackgroundBackoff(element, handler, backoffDurations);
	    } else {
	      handler(dark);
	    }
	  }, backoffDurations.shift());
	}
	
	function checkDarkBackground(colorIndex, element, handler) {
	  var timer = void 0;
	  if (colorIndex) {
	    if ('dark' === colorIndex) {
	      // caller knows
	      handler(true);
	    } else if (LIGHT_HINT_REGEXP.test(colorIndex)) {
	      // skip if this is a 'light-*' color index
	      handler(false);
	    } else {
	      // Measure the actual background color brightness to determine whether
	      // to set a dark or light context.
	      if (element && window.getComputedStyle) {
	        timer = checkDarkBackgroundBackoff(element, handler, CHECK_DARK_BACKGROUND_BACKOFFS);
	      }
	    }
	  }
	  return { stop: function stop() {
	      return clearTimeout(timer);
	    } };
	}
	
	function findVisibleParent(element) {
	  if (element) {
	    return element.offsetParent ? element : findVisibleParent(element.parentElement);
	  } else {
	    return null;
	  }
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(64);
	
	var emptyFunction = __webpack_require__(39);
	var warning = __webpack_require__(15);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ToolTipTSpanLabel(props) {
		return _react2.default.createElement(
			"tspan",
			_extends({ className: "react-stockcharts-tooltip-label" }, props),
			props.children
		);
	}
	
	ToolTipTSpanLabel.propTypes = {
		children: _propTypes2.default.node.isRequired,
		fill: _propTypes2.default.string.isRequired
	};
	
	ToolTipTSpanLabel.defaultProps = {
		fill: "#4682B4"
	};
	
	exports.default = ToolTipTSpanLabel;
	//# sourceMappingURL=ToolTipTSpanLabel.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolTipText = function (_Component) {
		_inherits(ToolTipText, _Component);
	
		function ToolTipText() {
			_classCallCheck(this, ToolTipText);
	
			return _possibleConstructorReturn(this, (ToolTipText.__proto__ || Object.getPrototypeOf(ToolTipText)).apply(this, arguments));
		}
	
		_createClass(ToolTipText, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"text",
					_extends({
						fontFamily: this.props.fontFamily,
						fontSize: this.props.fontSize
					}, this.props, {
						className: "react-stockcharts-tooltip" }),
					this.props.children
				);
			}
		}]);
	
		return ToolTipText;
	}(_react.Component);
	
	ToolTipText.propTypes = {
		fontFamily: _propTypes2.default.string.isRequired,
		fontSize: _propTypes2.default.number.isRequired,
		children: _propTypes2.default.node.isRequired
	};
	
	ToolTipText.defaultProps = {
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 11
	};
	
	exports.default = ToolTipText;
	//# sourceMappingURL=ToolTipText.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.urlPrefix = exports.pollingInterval = exports.pageSize = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	exports.configure = configure;
	exports.updateHeaders = updateHeaders;
	exports.head = head;
	exports.postLogin = postLogin;
	exports.getTwigs = getTwigs;
	exports.getTwigChart = getTwigChart;
	exports.getSites = getSites;
	exports.getUserProfile = getUserProfile;
	exports.updateSite = updateSite;
	exports.addSite = addSite;
	exports.getValuesFromParseClass = getValuesFromParseClass;
	exports.updateTwig = updateTwig;
	exports.updateProfileApi = updateProfileApi;
	exports.postLogout = postLogout;
	exports.getAlerts = getAlerts;
	exports.saveAlert = saveAlert;
	exports.updateAlert = updateAlert;
	exports.deleteAlert = deleteAlert;
	exports.addStemID = addStemID;
	exports.createStem = createStem;
	exports.getUserPreferences = getUserPreferences;
	exports.saveUserPreferences = saveUserPreferences;
	exports.getItems = getItems;
	exports.getSearchSuggestions = getSearchSuggestions;
	exports.getItem = getItem;
	exports.postItem = postItem;
	exports.putItem = putItem;
	exports.deleteItem = deleteItem;
	exports.watchItems = watchItems;
	exports.watchItem = watchItem;
	exports.watchAggregate = watchAggregate;
	exports.watchAssociated = watchAssociated;
	exports.stopWatching = stopWatching;
	exports.refresh = refresh;
	exports.getStatus = getStatus;
	exports.postResetPassword = postResetPassword;
	exports.getRole = getRole;
	exports.getSession = getSession;
	exports.getSettings = getSettings;
	exports.getCertificate = getCertificate;
	exports.postConnection = postConnection;
	exports.getDirectorySearch = getDirectorySearch;
	exports.putSettings = putSettings;
	exports.getSoftware = getSoftware;
	exports.postSoftwareUpload = postSoftwareUpload;
	exports.postSoftwareUpdate = postSoftwareUpdate;
	exports.delSoftware = delSoftware;
	exports.postRestart = postRestart;
	exports.getBackup = getBackup;
	exports.postBackup = postBackup;
	exports.delBackup = delBackup;
	exports.getSupport = getSupport;
	exports.postSupport = postSupport;
	exports.delSupport = delSupport;
	exports.postImage = postImage;
	exports.putImage = putImage;
	exports.postPowerOnVm = postPowerOnVm;
	exports.postPowerOffVm = postPowerOffVm;
	exports.postRestartVm = postRestartVm;
	exports.postRoute = postRoute;
	exports.initializeStripe = initializeStripe;
	exports.getSubscription = getSubscription;
	exports.createStripeSubscription = createStripeSubscription;
	exports.validateCoupon = validateCoupon;
	exports.getSubscriptionDetails = getSubscriptionDetails;
	exports.cancelStripeSubscription = cancelStripeSubscription;
	exports.getCustomerCard = getCustomerCard;
	exports.register = register;
	exports.resetPassword = resetPassword;
	
	var _Rest = __webpack_require__(543);
	
	var _Rest2 = _interopRequireDefault(_Rest);
	
	var _status = __webpack_require__(65);
	
	var _superagent = __webpack_require__(417);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//let _host = 'http://localhost:3004';
	var _host = '';
	var _headers = _extends({}, _Rest.headers, {
	    'pragma': 'no-cache',
	    'cache-control': 'no- cache'
	    // 'X-API-Version': 200
	});
	var _webSocketUrl = undefined;
	
	// XHR still for file upload progress
	
	var _timeout = 20000;
	var noOfRequests = 0;
	// 20s, up from initial 10s due to use from slow mobile devices
	
	// Configuration
	
	var pageSize = exports.pageSize = 20;
	var pollingInterval = exports.pollingInterval = 2000; // 2s
	var urlPrefix = exports.urlPrefix = '';
	
	function configure(options) {
	    _host = options.host ? 'http://' + options.host : _host;
	    exports.pageSize = pageSize = options.pageSize || pageSize;
	    exports.pollingInterval = pollingInterval = options.pollingInterval || pollingInterval;
	    _webSocketUrl = options.webSocketUrl || _webSocketUrl;
	    exports.urlPrefix = urlPrefix = options.urlPrefix || urlPrefix;
	
	    // initializeWatching(_webSocketUrl, _get);
	}
	
	function updateHeaders(headers) {
	    _headers = _extends({}, _headers, headers);
	    _Rest2.default.setHeaders(headers); ///
	}
	
	// Internal help/generic functions
	
	function _get(uri, params) {
	    var options = { method: 'GET', headers: _headers };
	    var query = (0, _Rest.buildQuery)(params);
	    window.store.dispatch((0, _status.showLoader)(true));
	    noOfRequests++;
	    return fetch('' + _host + urlPrefix + uri + query, options).then(_Rest.processStatus).then(function (response) {
	        noOfRequests--;
	        if (noOfRequests < 1) {
	            window.store.dispatch((0, _status.showLoader)(false));
	        }
	        return response.json();
	    }).catch(function (error) {
	        noOfRequests--;
	        window.store.dispatch((0, _status.showLoader)(false));
	        // console.log('There has been a problem with your fetch operation: ' + error.message);
	    });
	}
	
	function _post(uri, dataArg) {
	    var data = (typeof dataArg === 'undefined' ? 'undefined' : _typeof(dataArg)) === 'object' ? JSON.stringify(dataArg) : dataArg;
	    var options = { method: 'POST', headers: _headers, body: data };
	    window.store.dispatch((0, _status.showLoader)(true));
	    noOfRequests++;
	    return fetch('' + _host + urlPrefix + uri, options).then(_Rest.processStatus).then(function (response) {
	        noOfRequests--;
	        if (noOfRequests < 1) {
	            window.store.dispatch((0, _status.showLoader)(false));
	        }
	        return response.json();
	    }).catch(function (error) {
	        noOfRequests--;
	        window.store.dispatch((0, _status.showLoader)(false));
	        // console.log('There has been a problem with your fetch operation: ' + error.message);
	    });
	}
	
	function _put(uri, dataArg) {
	    var data = (typeof dataArg === 'undefined' ? 'undefined' : _typeof(dataArg)) === 'object' ? JSON.stringify(dataArg) : dataArg;
	    var options = { method: 'PUT', headers: _headers, body: data };
	    window.store.dispatch((0, _status.showLoader)(true));
	    noOfRequests++;
	    return fetch('' + _host + urlPrefix + uri, options).then(_Rest.processStatus).then(function (response) {
	        noOfRequests--;
	        if (noOfRequests < 1) {
	            window.store.dispatch((0, _status.showLoader)(false));
	        }
	        return response.json();
	    }).catch(function (error) {
	        noOfRequests--;
	        window.store.dispatch((0, _status.showLoader)(false));
	
	        // console.log('There has been a problem with your fetch operation: ' + error.message);
	    });
	}
	
	function _delete(uri) {
	    var options = { method: 'DELETE', headers: _headers };
	    window.store.dispatch((0, _status.showLoader)(true));
	    noOfRequests++;
	    return fetch('' + _host + urlPrefix + uri, options).then(_Rest.processStatus).then(function (response) {
	        noOfRequests--;
	        if (noOfRequests < 1) {
	            window.store.dispatch((0, _status.showLoader)(false));
	        }
	        return response.json();
	    }).catch(function (error) {
	        window.store.dispatch((0, _status.showLoader)(false));
	        // console.log('There has been a problem with your fetch operation: ' + error.message);
	    });
	}
	
	function head(url, params) {
	    var query = (0, _Rest.buildQuery)(params);
	    var options = { method: 'HEAD', headers: _headers };
	    return fetch('' + _host + urlPrefix + url + query, options);
	}
	
	// Index
	
	function postLogin(userName, password) {
	    var params = { username: userName, password: password };
	    return _post('/api/user/login', params);
	}
	
	function getTwigs(siteName) {
	    var url = '/api/stem/?isEnabled=true';
	    url = siteName ? url + '&siteName=' + encodeURIComponent(siteName) : url;
	
	    return _get(url);
	}
	
	function getTwigChart(twigId, fromDate, toDate, pageNo) {
	    var params = {
	        fromDate: fromDate,
	        toDate: toDate,
	        pageNo: pageNo
	    };
	    var url = '/api/data/stem/' + twigId;
	    // url = fromDate ? url + '?fromDate=' + fromDate : url;
	    url = url + '?fromDate=' + fromDate;
	    url = toDate ? url + '&toDate=' + toDate : url;
	    // url = url + '&pageNo=' + pageNo;
	    return _get(url);
	}
	
	function getSites() {
	    return _get('/api/site');
	}
	
	function getUserProfile(userId) {
	    return _get('/api/user/' + userId);
	}
	
	function updateSite(siteId, data) {
	    return _put('/api/site/' + siteId, data);
	}
	
	function addSite(data) {
	    return _post('/api/site', data);
	}
	
	function getValuesFromParseClass(parseClass, hasUser) {
	    return _get('/api/objects/' + parseClass + '/options?isUserRelatedOptions=' + hasUser);
	}
	
	function updateTwig(twigId, twigObj) {
	    return _put('/api/stem/' + twigId, twigObj);
	}
	
	function updateProfileApi(userId, profileData) {
	    return _put('/api/user/' + userId, profileData);
	}
	
	function postLogout() {
	    return _post('/api/user/logout', {});
	}
	
	function getAlerts(twigId) {
	    return _get('/api/alert/twig/' + twigId);
	}
	
	function saveAlert(alertData) {
	    return _post('/api/alert', alertData);
	}
	
	function updateAlert(alertId, alertData) {
	    return _put('/api/alert/' + alertId, alertData);
	}
	
	function deleteAlert(alertId) {
	    return _delete('/api/alert/' + alertId);
	}
	
	function addStemID(stemId) {
	    return _get('/api/stem/' + stemId);
	}
	
	function createStem(stemObj) {
	    return _post('/api/stem', stemObj);
	}
	
	function getUserPreferences() {
	    return _get('/api/user/preference');
	}
	
	function saveUserPreferences(saveObj) {
	    return _post('/api/user/preference', saveObj);
	}
	// ******************************
	
	
	function getItems(params) {
	    return _get('/rest/index/resources', params);
	}
	
	function getSearchSuggestions(text) {
	    var params = { start: 0, count: Math.min(10, pageSize), query: text };
	    return _get('/rest/index/search-suggestions', params);
	}
	
	// Item
	
	function getItem(uri) {
	    return _get(uri);
	}
	
	function postItem(item) {
	    return _post('/rest/' + item.category, item).then(refresh);
	}
	
	function putItem(item) {
	    return _put(item.uri, item).then(refresh);
	}
	
	function deleteItem(uri) {
	    return _delete(uri).then(refresh);
	}
	
	// Watching
	
	var watches = {};
	
	function normalizeAggregate(result, handler) {
	    handler(result[0].counts); // for now
	}
	
	function watchItems(name, params, successHandler, errorHandler) {
	    stopWatching(name, true);
	    var query = (0, _Rest.buildQuery)(params);
	    var uri = '/rest/index/resources' + query;
	    var watcher = watch(uri, successHandler, errorHandler);
	    watches[name] = watcher;
	}
	
	function watchItem(name, uri, successHandler, errorHandler) {
	    stopWatching(name, true);
	    var watcher = watch(uri, successHandler, errorHandler);
	    watches[name] = watcher;
	}
	
	function watchAggregate(name, params, successHandler, errorHandler) {
	    stopWatching(name, true);
	    var query = (0, _Rest.buildQuery)(params);
	    var uri = '/rest/index/resources/aggregated' + query;
	    var watcher = watch(uri, function (result) {
	        return normalizeAggregate(result, successHandler);
	    }, errorHandler);
	    watches[name] = watcher;
	}
	
	function watchAssociated(name, uriArg, successHandler, errorHandler) {
	    stopWatching(name, true);
	    var uri = '/rest/index/trees/aggregated' + uriArg;
	    var watcher = watch(uri, successHandler, errorHandler);
	    watches[name] = watcher;
	}
	
	function stopWatching(name, quiet) {
	    if (watches[name]) {
	        disregard(watches[name]);
	        delete watches[name];
	    } else if (!quiet) {
	        console.warn('stopWatching undefined watcher', name);
	    }
	}
	
	function refresh(response) {
	    refreshWatching();
	    return response;
	}
	
	// Status
	
	function getStatus() {
	    return _get('/rest/status');
	}
	
	// Session
	
	
	function postResetPassword(userName, password) {
	    var params = { userName: userName, password: password };
	    return _post('/rest/reset-password', params);
	}
	
	function getRole() {
	    return _get('/rest/authz/role');
	}
	
	function getSession() {
	    return _get('/rest/sessions');
	}
	
	// Settings
	
	function getSettings() {
	    return _get('/rest/settings');
	}
	
	function getCertificate(params) {
	    return _get('/rest/settings', params);
	}
	
	function postConnection(address, userName, password) {
	    // We do a post to avoid sending credentials as more visible parameters
	    var params = { address: address, userName: userName, password: password };
	    return _post('/rest/connection', params);
	}
	
	function getDirectorySearch(address, baseDn, searchText) {
	    var params = { address: address, baseDn: baseDn, searchText: searchText };
	    return _get('/rest/directory/search', params);
	}
	
	function putSettings(settings) {
	    return _put('/rest/settings', settings);
	}
	
	// export function postSettings (data) {
	//   // This is the Restore action
	//   let headers = {..._headers};
	//   delete headers['Content-Type'];
	//   const options = { method: 'POST', headers: headers, body: data };
	//   return fetch(`${_host}${urlPrefix}/rest/settings`, options)
	//   .then(processStatus)
	//   .then(response => response.json());
	// }
	
	function getSoftware() {
	    return _get('/rest/update');
	}
	
	function postSoftwareUpload(file, progressHandler, handler) {
	    // We need to keep using XHR until fetch() has a way to track long upload
	    // progress. Since we don't do file uploading from mobile platforms,
	    // we can get away with this.
	    _superagent2.default.post('' + _host + urlPrefix + '/rest/update/upload').timeout(_timeout)
	    // remove Content-Type since we're sending a file
	    .set(_extends({}, _headers, { "Content-Type": undefined })).attach('file', file).on('progress', progressHandler).end(handler);
	}
	
	function postSoftwareUpdate() {
	    return _post('/rest/update');
	}
	
	function delSoftware() {
	    return _delete('/rest/update');
	}
	
	function postRestart() {
	    return _post('/rest/restart');
	}
	
	function getBackup() {
	    return _get('/rest/backup');
	}
	
	function postBackup() {
	    return _post('/rest/backup');
	}
	
	function delBackup() {
	    return _delete('/rest/backup');
	}
	
	function getSupport() {
	    return _get('/rest/support');
	}
	
	function postSupport() {
	    return _post('/rest/support');
	}
	
	function delSupport() {
	    return _delete('/rest/support');
	}
	
	// Image
	
	function postImage(image, file, progressHandler, handler) {
	    // We need to keep using XHR until fetch() has a way to track long upload
	    // progress. Since we don't do file uploading from mobile platforms,
	    // we can get away with this.
	    _superagent2.default.post('' + _host + urlPrefix + '/rest/images').timeout(_timeout)
	    // remove Content-Type since we're sending a file
	    .set(_extends({}, _headers, { "Content-Type": undefined })).field('name', image.name).attach('file', file).on('progress', progressHandler).end(handler);
	}
	
	function putImage(image, file, progressHandler, handler) {
	    // We need to keep using Rest until fetch() has a way to track long upload
	    // progress. Since we don't do file uploading from mobile platforms,
	    // we can get away with this.
	    _superagent2.default.put('' + _host + urlPrefix + image.uri).timeout(_timeout).set(_extends({}, _headers, { "Content-Type": undefined })).field('uri', image.uri).field('name', image.name).field('status', image.status).field('state', image.state).field('created', image.created).attach('file', file).on('progress', progressHandler).end(handler);
	}
	
	// Virtual Machine
	
	function postPowerOnVm(uri) {
	    return _post(uri + '/on').then(refresh);
	}
	
	function postPowerOffVm(uri) {
	    return _post(uri + '/off').then(refresh);
	}
	
	function postRestartVm(uri) {
	    return _post(uri + '/restart').then(refresh);
	}
	
	// Route
	
	function postRoute(route) {
	    return _post('/rest/route', route);
	}
	
	// subscription
	
	function initializeStripe() {
	    return _get('/api/stripe/initializeStripe');
	}
	
	function getSubscription(stemId, showPlans) {
	    return _get('/api/subscription/getSubscription/' + stemId + '/' + showPlans);
	}
	
	function createStripeSubscription(data) {
	    return _post('/api/subscription/createSubscription', data);
	}
	
	function validateCoupon(coupon) {
	    return _get('/api/subscription/validateCoupon/' + coupon);
	}
	
	function getSubscriptionDetails() {
	    return _get('/api/subscription/getAuditdata');
	}
	
	function cancelStripeSubscription(data) {
	    return _post('/api/subscription/cancelSubscription', data);
	}
	
	function getCustomerCard() {
	    return _get('/api/subscription/getCustomerCard');
	}
	
	//sign up
	
	function register(data) {
	    return _post('/api/user/register', data);
	}
	
	function resetPassword(data) {
	    return _post('/api/user/resetPassword', data);
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(_host, '_host', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(_headers, '_headers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(_webSocketUrl, '_webSocketUrl', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(_timeout, '_timeout', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(noOfRequests, 'noOfRequests', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(pageSize, 'pageSize', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(pollingInterval, 'pollingInterval', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(urlPrefix, 'urlPrefix', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(configure, 'configure', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(updateHeaders, 'updateHeaders', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(_get, '_get', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(_post, '_post', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(_put, '_put', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(_delete, '_delete', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(head, 'head', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postLogin, 'postLogin', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getTwigs, 'getTwigs', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getTwigChart, 'getTwigChart', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getSites, 'getSites', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getUserProfile, 'getUserProfile', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(updateSite, 'updateSite', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(addSite, 'addSite', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getValuesFromParseClass, 'getValuesFromParseClass', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(updateTwig, 'updateTwig', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(updateProfileApi, 'updateProfileApi', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postLogout, 'postLogout', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getAlerts, 'getAlerts', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(saveAlert, 'saveAlert', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(updateAlert, 'updateAlert', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(deleteAlert, 'deleteAlert', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(addStemID, 'addStemID', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(createStem, 'createStem', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getUserPreferences, 'getUserPreferences', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(saveUserPreferences, 'saveUserPreferences', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getItems, 'getItems', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getSearchSuggestions, 'getSearchSuggestions', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getItem, 'getItem', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postItem, 'postItem', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(putItem, 'putItem', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(deleteItem, 'deleteItem', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(watches, 'watches', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(normalizeAggregate, 'normalizeAggregate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(watchItems, 'watchItems', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(watchItem, 'watchItem', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(watchAggregate, 'watchAggregate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(watchAssociated, 'watchAssociated', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(stopWatching, 'stopWatching', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(refresh, 'refresh', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getStatus, 'getStatus', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postResetPassword, 'postResetPassword', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getRole, 'getRole', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getSession, 'getSession', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getSettings, 'getSettings', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getCertificate, 'getCertificate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postConnection, 'postConnection', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getDirectorySearch, 'getDirectorySearch', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(putSettings, 'putSettings', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getSoftware, 'getSoftware', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postSoftwareUpload, 'postSoftwareUpload', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postSoftwareUpdate, 'postSoftwareUpdate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(delSoftware, 'delSoftware', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postRestart, 'postRestart', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getBackup, 'getBackup', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postBackup, 'postBackup', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(delBackup, 'delBackup', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getSupport, 'getSupport', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postSupport, 'postSupport', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(delSupport, 'delSupport', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postImage, 'postImage', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(putImage, 'putImage', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postPowerOnVm, 'postPowerOnVm', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postPowerOffVm, 'postPowerOffVm', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postRestartVm, 'postRestartVm', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(postRoute, 'postRoute', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(initializeStripe, 'initializeStripe', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getSubscription, 'getSubscription', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(createStripeSubscription, 'createStripeSubscription', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(validateCoupon, 'validateCoupon', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getSubscriptionDetails, 'getSubscriptionDetails', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(cancelStripeSubscription, 'cancelStripeSubscription', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(getCustomerCard, 'getCustomerCard', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(register, 'register', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	
	    __REACT_HOT_LOADER__.register(resetPassword, 'resetPassword', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/Api.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(463)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.FORM;
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
	  }
	
	  _createClass(Form, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          compact = _props.compact,
	          fill = _props.fill,
	          pad = _props.pad,
	          plain = _props.plain,
	          props = _objectWithoutProperties(_props, ['className', 'compact', 'fill', 'pad', 'plain']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--compact', compact), _defineProperty(_classnames, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames, CLASS_ROOT + '--pad-' + pad, typeof pad === 'string'), _defineProperty(_classnames, CLASS_ROOT + '--pad-horizontal-' + pad.horizontal, (typeof pad === 'undefined' ? 'undefined' : _typeof(pad)) === 'object' && 'horizontal' in pad), _defineProperty(_classnames, CLASS_ROOT + '--pad-vertical-' + pad.vertical, (typeof pad === 'undefined' ? 'undefined' : _typeof(pad)) === 'object' && 'vertical' in pad), _defineProperty(_classnames, CLASS_ROOT + '--plain', plain), _classnames), className);
	
	      return _react2.default.createElement(
	        'form',
	        _extends({}, props, { className: classes, onSubmit: this.props.onSubmit }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.displayName = 'Form';
	exports.default = Form;
	
	
	Form.propTypes = {
	  compact: _propTypes2.default.bool,
	  fill: _propTypes2.default.bool,
	  onSubmit: _propTypes2.default.func,
	  pad: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none', 'small', 'medium', 'large']), _propTypes2.default.shape({
	    horizontal: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	    vertical: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large'])
	  })]),
	  plain: _propTypes2.default.bool
	};
	
	Form.defaultProps = {
	  compact: false,
	  fill: false,
	  pad: 'none'
	};
	module.exports = exports['default'];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SECTION;
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
	  }
	
	  _createClass(Section, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, className);
	
	      return _react2.default.createElement(_Box2.default, _extends({}, props, { tag: 'section', className: classes }));
	    }
	  }]);
	
	  return Section;
	}(_react.Component);
	
	Section.displayName = 'Section';
	exports.default = Section;
	;
	
	Section.propTypes = _extends({}, _Box2.default.propTypes);
	
	Section.defaultProps = {
	  pad: { vertical: 'medium' }
	};
	module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.TITLE;
	
	var Title = function (_Component) {
	  _inherits(Title, _Component);
	
	  function Title() {
	    _classCallCheck(this, Title);
	
	    return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
	  }
	
	  _createClass(Title, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          children = _props.children,
	          className = _props.className,
	          responsive = _props.responsive,
	          truncate = _props.truncate,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'children', 'className', 'responsive', 'truncate']);
	
	      var intl = this.context.intl;
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, CLASS_ROOT + '--truncate', truncate), _defineProperty(_classnames, CLASS_ROOT + '--interactive', props.onClick), _classnames), className);
	
	      var boxTitle = a11yTitle || _Intl2.default.getMessage(intl, 'Title');
	
	      var content = void 0;
	      if (typeof children === 'string') {
	        content = _react2.default.createElement(
	          'span',
	          null,
	          children
	        );
	      } else if (Array.isArray(children)) {
	        content = children.map(function (child, index) {
	          if (child && typeof child === 'string') {
	            return _react2.default.createElement(
	              'span',
	              { key: index },
	              child
	            );
	          }
	          return child;
	        });
	      } else {
	        content = children;
	      }
	
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, props, { align: 'center', direction: 'row', responsive: false,
	          className: classes, a11yTitle: boxTitle }),
	        content
	      );
	    }
	  }]);
	
	  return Title;
	}(_react.Component);
	
	Title.displayName = 'Title';
	exports.default = Title;
	
	
	Title.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  responsive: _propTypes2.default.bool,
	  truncate: _propTypes2.default.bool
	};
	
	Title.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Title.defaultProps = {
	  responsive: true,
	  truncate: true
	};
	module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  '3d': '3d',
	  'access-accessibility': 'access accessibility',
	  'access-ad': 'access ad',
	  'access-assist-listening': 'access assist listening',
	  'access-braille': 'access braille',
	  'access-sign': 'access sign',
	  'access-tty': 'access tty',
	  'access-volume-control': 'access volume control',
	  'access-wheelchair-active': 'access wheelchair active',
	  'access-wheelchair': 'access wheelchair',
	  'achievement': 'achievement',
	  'action': 'action',
	  'actions': 'actions',
	  'add-circle': 'add circle',
	  'add': 'add',
	  'aggregate': 'aggregate',
	  'aid': 'aid',
	  'alarm': 'alarm',
	  'alert': 'alert',
	  'analytics': 'analytics',
	  'announce': 'announce',
	  'apps': 'apps',
	  'archive': 'archive',
	  'article': 'article',
	  'ascend': 'ascend',
	  'attachment': 'attachment',
	  'back-ten': 'back ten',
	  'bar-chart': 'bar chart',
	  'basket': 'basket',
	  'blog': 'blog',
	  'book': 'book',
	  'bookmark': 'bookmark',
	  'bottom-corner': 'bottom corner',
	  'brand-apple-app-store': 'brand apple app store',
	  'brand-codepen-edit': 'brand codepen edit',
	  'brand-codepen-try': 'brand codepen try',
	  'brand-google-play': 'brand google play',
	  'brand-grommet-outline': 'brand grommet outline',
	  'brand-grommet-path': 'brand grommet path',
	  'brand-hpe-element-outline': 'brand hpe element outline',
	  'brand-hpe-element-path': 'brand hpe element path',
	  'brand-hpe-labs-insignia-outline': 'brand hpe labs insignia outline',
	  'brand-hpe-labs-insignia': 'brand hpe labs insignia',
	  'brand-hpe-stack-centered': 'brand hpe stack centered',
	  'brand-hpe-stack': 'brand hpe stack',
	  'briefcase': 'briefcase',
	  'brush': 'brush',
	  'bug': 'bug',
	  'bundle': 'bundle',
	  'business-service': 'business service',
	  'calculator': 'calculator',
	  'calendar': 'calendar',
	  'camera': 'camera',
	  'capacity': 'capacity',
	  'car': 'car',
	  'caret-down': 'caret down',
	  'caret-next': 'caret next',
	  'caret-previous': 'caret previous',
	  'caret-up': 'caret up',
	  'cart': 'cart',
	  'catalog': 'catalog',
	  'chapter-add': 'chapter add',
	  'chapter-next': 'chapter next',
	  'chapter-previous': 'chapter previous',
	  'chat': 'chat',
	  'checkbox-selected': 'checkbox selected',
	  'checkbox': 'checkbox',
	  'checkmark': 'checkmark',
	  'circle-information': 'circle information',
	  'circle-play': 'circle play',
	  'circle-question': 'circle question',
	  'clear-option': 'clear option',
	  'clear': 'clear',
	  'cli': 'cli',
	  'clipboard': 'clipboard',
	  'clock': 'clock',
	  'clone': 'clone',
	  'close': 'close',
	  'closed-caption': 'closed caption',
	  'cloud-computer': 'cloud computer',
	  'cloud-download': 'cloud download',
	  'cloud-software': 'cloud software',
	  'cloud-upload': 'cloud upload',
	  'cloud': 'cloud',
	  'cluster': 'cluster',
	  'code': 'code',
	  'columns': 'columns',
	  'compare': 'compare',
	  'compass': 'compass',
	  'compliance': 'compliance',
	  'configure': 'configure',
	  'connect': 'connect',
	  'contact-info': 'contact info',
	  'contact': 'contact',
	  'contract': 'contract',
	  'copy': 'copy',
	  'credit-card': 'credit card',
	  'cube': 'cube',
	  'cubes': 'cubes',
	  'currency': 'currency',
	  'cursor': 'cursor',
	  'cut': 'cut',
	  'cycle': 'cycle',
	  'dashboard': 'dashboard',
	  'database': 'database',
	  'deliver': 'deliver',
	  'deploy': 'deploy',
	  'descend': 'descend',
	  'desktop': 'desktop',
	  'detach': 'detach',
	  'diamond': 'diamond',
	  'directions': 'directions',
	  'dislike': 'dislike',
	  'document-cloud': 'document cloud',
	  'document-config': 'document config',
	  'document-csv': 'document csv',
	  'document-download': 'document download',
	  'document-excel': 'document excel',
	  'document-exe': 'document exe',
	  'document-image': 'document image',
	  'document-locked': 'document locked',
	  'document-missing': 'document missing',
	  'document-notes': 'document notes',
	  'document-outlook': 'document outlook',
	  'document-pdf': 'document pdf',
	  'document-performance': 'document performance',
	  'document-ppt': 'document ppt',
	  'document-rtf': 'document rtf',
	  'document-sound': 'document sound',
	  'document-store': 'document store',
	  'document-test': 'document test',
	  'document-threat': 'document threat',
	  'document-time': 'document time',
	  'document-transfer': 'document transfer',
	  'document-txt': 'document txt',
	  'document-update': 'document update',
	  'document-upload': 'document upload',
	  'document-user': 'document user',
	  'document-verified': 'document verified',
	  'document-video': 'document video',
	  'document-windows': 'document windows',
	  'document-word': 'document word',
	  'document-zip': 'document zip',
	  'document': 'document',
	  'domain': 'domain',
	  'down': 'down',
	  'download': 'download',
	  'drag': 'drag',
	  'drive-cage': 'drive cage',
	  'duplicate': 'duplicate',
	  'edit': 'edit',
	  'eject': 'eject',
	  'empty-circle': 'empty circle',
	  'expand': 'expand',
	  'fan': 'fan',
	  'fast-forward': 'fast forward',
	  'favorite': 'favorite',
	  'filter': 'filter',
	  'finger-print': 'finger print',
	  'flag': 'flag',
	  'folder-cycle': 'folder cycle',
	  'folder-open': 'folder open',
	  'folder': 'folder',
	  'form-edit': 'form edit',
	  'forward-ten': 'forward ten',
	  'gallery': 'gallery',
	  'gamepad': 'gamepad',
	  'gift': 'gift',
	  'globe': 'globe',
	  'grid': 'grid',
	  'group': 'group',
	  'grow': 'grow',
	  'halt': 'halt',
	  'help': 'help',
	  'history': 'history',
	  'home': 'home',
	  'host-maintenance': 'host maintenance',
	  'host': 'host',
	  'image': 'image',
	  'impact': 'impact',
	  'in-progress': 'in progress',
	  'inbox': 'inbox',
	  'indicator': 'indicator',
	  'info': 'info',
	  'inherit': 'inherit',
	  'inspect': 'inspect',
	  'install': 'install',
	  'integration': 'integration',
	  'iteration': 'iteration',
	  'java': 'java',
	  'language': 'language',
	  'launch': 'launch',
	  'layer': 'layer',
	  'license': 'license',
	  'like': 'like',
	  'line-chart': 'line chart',
	  'link-bottom': 'link bottom',
	  'link-down': 'link down',
	  'link-next': 'link next',
	  'link-previous': 'link previous',
	  'link-top': 'link top',
	  'link-up': 'link up',
	  'link': 'link',
	  'local': 'local',
	  'location-pin': 'location pin',
	  'location': 'location',
	  'lock': 'lock',
	  'login': 'login',
	  'logout': 'logout',
	  'magic': 'magic',
	  'mail-option': 'mail option',
	  'mail': 'mail',
	  'manual': 'manual',
	  'map-location': 'map location',
	  'map': 'map',
	  'menu': 'menu',
	  'microphone': 'microphone',
	  'money': 'money',
	  'monitor': 'monitor',
	  'more': 'more',
	  'multiple': 'multiple',
	  'navigate': 'navigate',
	  'new-window': 'new window',
	  'new': 'new',
	  'next': 'next',
	  'nodes': 'nodes',
	  'note': 'note',
	  'notes': 'notes',
	  'notification': 'notification',
	  'object-group': 'object group',
	  'object-ungroup': 'object ungroup',
	  'optimize': 'optimize',
	  'organization': 'organization',
	  'overview': 'overview',
	  'pan': 'pan',
	  'pause-fill': 'pause fill',
	  'pause': 'pause',
	  'personal-computer': 'personal computer',
	  'pie-chart': 'pie chart',
	  'pin': 'pin',
	  'plan': 'plan',
	  'platform-amazon': 'platform amazon',
	  'platform-android': 'platform android',
	  'platform-apple': 'platform apple',
	  'platform-archlinux': 'platform archlinux',
	  'platform-aruba': 'platform aruba',
	  'platform-centos': 'platform centos',
	  'platform-chrome': 'platform chrome',
	  'platform-cloudlinux': 'platform cloudlinux',
	  'platform-debian': 'platform debian',
	  'platform-docker': 'platform docker',
	  'platform-dos': 'platform dos',
	  'platform-dropbox': 'platform dropbox',
	  'platform-dxc': 'platform dxc',
	  'platform-edge': 'platform edge',
	  'platform-fedora': 'platform fedora',
	  'platform-firefox': 'platform firefox',
	  'platform-freebsd': 'platform freebsd',
	  'platform-google': 'platform google',
	  'platform-hadoop': 'platform hadoop',
	  'platform-heroku': 'platform heroku',
	  'platform-horton': 'platform horton',
	  'platform-hp': 'platform hp',
	  'platform-hpi': 'platform hpi',
	  'platform-internet-explorer': 'platform internet explorer',
	  'platform-java': 'platform java',
	  'platform-mandriva': 'platform mandriva',
	  'platform-mysql': 'platform mysql',
	  'platform-norton': 'platform norton',
	  'platform-onedrive': 'platform onedrive',
	  'platform-opera': 'platform opera',
	  'platform-oracle': 'platform oracle',
	  'platform-pied-piper': 'platform pied piper',
	  'platform-raspberry': 'platform raspberry',
	  'platform-reactjs': 'platform reactjs',
	  'platform-redhat': 'platform redhat',
	  'platform-safari-option': 'platform safari option',
	  'platform-safari': 'platform safari',
	  'platform-sco': 'platform sco',
	  'platform-solaris': 'platform solaris',
	  'platform-suse': 'platform suse',
	  'platform-swift': 'platform swift',
	  'platform-turbolinux': 'platform turbolinux',
	  'platform-ubuntu': 'platform ubuntu',
	  'platform-unixware': 'platform unixware',
	  'platform-vmware': 'platform vmware',
	  'platform-windows-legacy': 'platform windows legacy',
	  'platform-windows': 'platform windows',
	  'play-fill': 'play fill',
	  'play': 'play',
	  'power': 'power',
	  'previous': 'previous',
	  'print': 'print',
	  'radial-selected': 'radial selected',
	  'radial': 'radial',
	  'refresh': 'refresh',
	  'resources': 'resources',
	  'resume': 'resume',
	  'revert': 'revert',
	  'rewind': 'rewind',
	  'risk': 'risk',
	  'robot': 'robot',
	  'rss': 'rss',
	  'run': 'run',
	  'satellite': 'satellite',
	  'save': 'save',
	  'scan': 'scan',
	  'schedule-new': 'schedule new',
	  'schedule-play': 'schedule play',
	  'schedule': 'schedule',
	  'schedules': 'schedules',
	  'scorecard': 'scorecard',
	  'search-advanced': 'search advanced',
	  'search': 'search',
	  'secure': 'secure',
	  'select': 'select',
	  'selection': 'selection',
	  'send': 'send',
	  'server-cluster': 'server cluster',
	  'server': 'server',
	  'servers': 'servers',
	  'service-play': 'service play',
	  'services': 'services',
	  'settings-option': 'settings option',
	  'share': 'share',
	  'shield-security': 'shield security',
	  'shield': 'shield',
	  'shift': 'shift',
	  'sidebar': 'sidebar',
	  'social-amazon': 'social amazon',
	  'social-amex': 'social amex',
	  'social-bitcoin': 'social bitcoin',
	  'social-codepen': 'social codepen',
	  'social-creative-commons': 'social creative commons',
	  'social-dropbox': 'social dropbox',
	  'social-facebook-option': 'social facebook option',
	  'social-facebook': 'social facebook',
	  'social-github': 'social github',
	  'social-google-plus': 'social google plus',
	  'social-google-wallet': 'social google wallet',
	  'social-instagram': 'social instagram',
	  'social-linkedin-option': 'social linkedin option',
	  'social-linkedin': 'social linkedin',
	  'social-mail': 'social mail',
	  'social-mastercard': 'social mastercard',
	  'social-medium': 'social medium',
	  'social-paypal': 'social paypal',
	  'social-pinterest': 'social pinterest',
	  'social-product-hunt': 'social product hunt',
	  'social-reddit': 'social reddit',
	  'social-skype': 'social skype',
	  'social-slack': 'social slack',
	  'social-snapchat': 'social snapchat',
	  'social-square': 'social square',
	  'social-stack-overflow': 'social stack overflow',
	  'social-stripe': 'social stripe',
	  'social-tumblr': 'social tumblr',
	  'social-twitter': 'social twitter',
	  'social-vimeo': 'social vimeo',
	  'social-vine': 'social vine',
	  'social-visa': 'social visa',
	  'social-wordpress': 'social wordpress',
	  'social-youtube': 'social youtube',
	  'sort': 'sort',
	  'split': 'split',
	  'splits': 'splits',
	  'stakeholder': 'stakeholder',
	  'standards-3d-effects': 'standards 3d effects',
	  'standards-connectivity': 'standards connectivity',
	  'standards-css3': 'standards css3',
	  'standards-device': 'standards device',
	  'standards-fireball': 'standards fireball',
	  'standards-html5': 'standards html5',
	  'standards-multimedia': 'standards multimedia',
	  'standards-offline-storage': 'standards offline storage',
	  'standards-performance': 'standards performance',
	  'standards-sematics': 'standards sematics',
	  'star-half': 'star half',
	  'star': 'star',
	  'steps': 'steps',
	  'stop-fill': 'stop fill',
	  'stop': 'stop',
	  'storage': 'storage',
	  'street-view': 'street view',
	  'subtract-circle': 'subtract circle',
	  'subtract': 'subtract',
	  'support': 'support',
	  'sync': 'sync',
	  'system': 'system',
	  'table-add': 'table add',
	  'table': 'table',
	  'tag': 'tag',
	  'target': 'target',
	  'task': 'task',
	  'tasks': 'tasks',
	  'technology': 'technology',
	  'template': 'template',
	  'terminal': 'terminal',
	  'test-desktop': 'test desktop',
	  'test': 'test',
	  'text-wrap': 'text wrap',
	  'threats': 'threats',
	  'ticket': 'ticket',
	  'tools': 'tools',
	  'tooltip': 'tooltip',
	  'top-corner': 'top corner',
	  'transaction': 'transaction',
	  'trash': 'trash',
	  'tree': 'tree',
	  'trigger': 'trigger',
	  'trophy': 'trophy',
	  'troubleshoot': 'troubleshoot',
	  'unlink': 'unlink',
	  'unlock': 'unlock',
	  'up': 'up',
	  'update': 'update',
	  'upgrade': 'upgrade',
	  'upload': 'upload',
	  'user-add': 'user add',
	  'user-admin': 'user admin',
	  'user-expert': 'user expert',
	  'user-female': 'user female',
	  'user-manager': 'user manager',
	  'user-new': 'user new',
	  'user-police': 'user police',
	  'user-settings': 'user settings',
	  'user-worker': 'user worker',
	  'user': 'user',
	  'validate': 'validate',
	  'video': 'video',
	  'view': 'view',
	  'virtual-machine': 'virtual machine',
	  'vm-maintenance': 'vm maintenance',
	  'volume-low': 'volume low',
	  'volume-mute': 'volume mute',
	  'volume': 'volume',
	  'vulnerability': 'vulnerability',
	  'waypoint': 'waypoint',
	  'workshop': 'workshop',
	  'zoom-in': 'zoom in',
	  'zoom-out': 'zoom out'
	};
	module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(60);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = displayValuesFor;
	function displayValuesFor(props, moreProps) {
		var currentItem = moreProps.currentItem;
	
		return currentItem;
	}
	//# sourceMappingURL=displayValuesFor.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.REBIND_COUPON_DATA = exports.REMEMBER_ME = exports.INIT_PAYMENT_INFO = exports.HANDLE_PAYMENT_INFO_SUBMIT = exports.SHOW_CHART_VIEW = exports.VALIDATE_COUPON = exports.CONFIRM_SUBSCRIPTION = exports.ADD_SUBSCRPTION = exports.GET_STRIPEPLANS = exports.TOGGLE_ZOOM = exports.SAVE_USER_PREFERENCES = exports.GET_USER_PREFERENCES = exports.CLEAR_TWIGS = exports.RESET_CHART = exports.GET_ALERTS = exports.TOGGLE_LOWERLIMIT = exports.TOGGLE_UPPERLIMIT = exports.CHANGE_TREND_AVERAGE = exports.SHOW_RAWGRAPH = exports.SHOW_TRENDLINE = exports.UPDATE_SELECTEDTWIG = exports.CHANGE_RESOULTION = exports.UPDATE_DATE_RANGE = exports.UPDATE_TODATE = exports.UPDATE_FROMDATE = exports.CHANGE_TWIG = exports.CHANGE_DEPTHOPTION = exports.CHANGE_DISPLAYOPTION = exports.UPDATE_CHART = exports.GET_TWIGS = undefined;
	exports.loadTwigs = loadTwigs;
	exports.getPageLoadData = getPageLoadData;
	exports.createSubscription = createSubscription;
	exports.loadChartData = loadChartData;
	exports.updateTwigApi = updateTwigApi;
	exports.getAlertsApi = getAlertsApi;
	exports.addAlertAction = addAlertAction;
	exports.updateAlertAction = updateAlertAction;
	exports.deleteAlertAction = deleteAlertAction;
	exports.getUserPreferencesAction = getUserPreferencesAction;
	exports.saveUserPreferencesAction = saveUserPreferencesAction;
	exports.updateSelectedTwig = updateSelectedTwig;
	exports.updateFromDate = updateFromDate;
	exports.updateToDate = updateToDate;
	exports.updateChart = updateChart;
	exports.updateDateRange = updateDateRange;
	exports.storeTwigs = storeTwigs;
	exports.changeDisplayOption = changeDisplayOption;
	exports.showUpperLimit = showUpperLimit;
	exports.showLowerLimit = showLowerLimit;
	exports.changeDepthOption = changeDepthOption;
	exports.changeTwig = changeTwig;
	exports.changeResolution = changeResolution;
	exports.showTrendLine = showTrendLine;
	exports.showRawGraph = showRawGraph;
	exports.changeTrendAverage = changeTrendAverage;
	exports.clearTwigsList = clearTwigsList;
	exports.changeZoomOption = changeZoomOption;
	exports.addSubscription = addSubscription;
	exports.showChartView = showChartView;
	exports.validateCouponCode = validateCouponCode;
	exports.handlePaymentInfoSubmission = handlePaymentInfoSubmission;
	exports.initializePaymentInformation = initializePaymentInformation;
	exports.rememberCardData = rememberCardData;
	exports.rebindCouponData = rebindCouponData;
	
	var _Api = __webpack_require__(52);
	
	var _Utility = __webpack_require__(37);
	
	var _d3Dispatch = __webpack_require__(118);
	
	var _actions = __webpack_require__(13);
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _ = __webpack_require__(27);
	
	var GET_TWIGS = exports.GET_TWIGS = 'GET_TWIGS';
	var UPDATE_CHART = exports.UPDATE_CHART = 'UPDATE_CHART';
	var CHANGE_DISPLAYOPTION = exports.CHANGE_DISPLAYOPTION = 'CHANGE_DISPLAYOPTION';
	var CHANGE_DEPTHOPTION = exports.CHANGE_DEPTHOPTION = 'CHANGE_DEPTHOPTION';
	var CHANGE_TWIG = exports.CHANGE_TWIG = 'CHANGE_TWIG';
	var UPDATE_FROMDATE = exports.UPDATE_FROMDATE = 'UPDATE_FROMDATE';
	var UPDATE_TODATE = exports.UPDATE_TODATE = 'UPDATE_TODATE';
	var UPDATE_DATE_RANGE = exports.UPDATE_DATE_RANGE = 'UPDATE_DATE_RANGE';
	var CHANGE_RESOULTION = exports.CHANGE_RESOULTION = 'CHANGE_RESOULTION';
	var UPDATE_SELECTEDTWIG = exports.UPDATE_SELECTEDTWIG = 'UPDATE_SELECTEDTWIG';
	var SHOW_TRENDLINE = exports.SHOW_TRENDLINE = 'SHOW_TRENDLINE';
	var SHOW_RAWGRAPH = exports.SHOW_RAWGRAPH = 'SHOW_RAWGRAPH';
	var CHANGE_TREND_AVERAGE = exports.CHANGE_TREND_AVERAGE = 'CHANGE_TREND_AVERAGE';
	var TOGGLE_UPPERLIMIT = exports.TOGGLE_UPPERLIMIT = 'TOGGLE_UPPERLIMIT';
	var TOGGLE_LOWERLIMIT = exports.TOGGLE_LOWERLIMIT = 'TOGGLE_LOWERLIMIT';
	var GET_ALERTS = exports.GET_ALERTS = 'GET_ALERTS';
	var RESET_CHART = exports.RESET_CHART = 'RESET_CHART';
	var CLEAR_TWIGS = exports.CLEAR_TWIGS = 'CLEAR_TWIGS';
	var GET_USER_PREFERENCES = exports.GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
	var SAVE_USER_PREFERENCES = exports.SAVE_USER_PREFERENCES = 'SAVE_USER_PREFERENCES';
	var TOGGLE_ZOOM = exports.TOGGLE_ZOOM = "TOGGLE_ZOOM";
	var GET_STRIPEPLANS = exports.GET_STRIPEPLANS = "GET_STRIPEPLANS";
	var ADD_SUBSCRPTION = exports.ADD_SUBSCRPTION = "ADD_SUBSCRPTION";
	var CONFIRM_SUBSCRIPTION = exports.CONFIRM_SUBSCRIPTION = "CONFIRM_SUBSCRIPTION";
	var VALIDATE_COUPON = exports.VALIDATE_COUPON = "VALIDATE_COUPON";
	var SHOW_CHART_VIEW = exports.SHOW_CHART_VIEW = "SHOW_CHART_VIEW";
	var HANDLE_PAYMENT_INFO_SUBMIT = exports.HANDLE_PAYMENT_INFO_SUBMIT = "HANDLE_PAYMENT_INFO_SUBMIT";
	var INIT_PAYMENT_INFO = exports.INIT_PAYMENT_INFO = "INIT_PAYMENT_INFO";
	var REMEMBER_ME = exports.REMEMBER_ME = "REMEMBER_ME";
	var REBIND_COUPON_DATA = exports.REBIND_COUPON_DATA = 'REBIND_COUPON_DATA';
	
	function loadTwigs(loadCharts, siteName, selectedTwigIndex) {
	    return function (dispatch) {
	        (0, _Api.getTwigs)(siteName).then(function (response) {
	            dispatch(storeTwigs(response, selectedTwigIndex));
	            if (loadCharts && response.data[selectedTwigIndex].details) {
	                var twigId = response.data[selectedTwigIndex].twigId;
	                var fromDate = new Date();
	                fromDate.setDate(fromDate.getDate() - 14);
	                var toDate = new Date();
	                dispatch(loadChartData(twigId, fromDate.toISOString(), toDate.toISOString(), '', selectedTwigIndex));
	            } else dispatch((0, _actions.showLoader)(false));
	        }).catch(function (error) {
	            dispatch(storeTwigs([], selectedTwigIndex));
	            dispatch((0, _actions.showLoader)(false));
	        });
	    };
	}
	
	function getPageLoadData(twig, showPlansView, twigIndex) {
	    return function (dispatch) {
	        (0, _Api.initializeStripe)().then(function (response) {
	            dispatch({
	                type: _actions.INITIALIZE_STRIPE,
	                result: response
	            });
	            (0, _Api.getTwigs)('').then(function (twigs) {
	                dispatch(storeTwigs(twigs, 0));
	                var displayOptions = {};
	                var stem = void 0;
	                var isStemSubscribed = false;
	                var selectedTwigIndex = void 0;
	                var subscriptionSelected = void 0;
	                var twigToSubscribe = void 0;
	                (0, _Api.getUserPreferences)().then(function (response) {
	                    if (twig && twig.twigId) {
	                        stem = twig.twigId;
	                    } else if (response && response.data && response.data.preference && response.data.preference.stem) {
	                        stem = response.data.preference.stem;
	                    } else {
	                        stem = twigs && twigs.data && twigs.data.length && twigs.data[0] ? twigs.data[0].twigId : null;
	                    }
	                    if (sessionStorage.getItem('twigToSubscribe')) {
	                        twigToSubscribe = JSON.parse(sessionStorage.getItem('twigToSubscribe'));
	                        if (twigToSubscribe && twigToSubscribe.twigId) {
	                            stem = twigToSubscribe.twigId;
	                            selectedTwigIndex = twigToSubscribe.twigIndex ? twigToSubscribe.twigIndex : '';
	                            showPlansView = twigToSubscribe.showPlans ? true : false;
	                            subscriptionSelected = twigToSubscribe.subscriptionSelected;
	                        }
	                        sessionStorage.removeItem('twigToSubscribe');
	                    }
	                    (0, _Api.getSubscription)(stem, showPlansView).then(function (data) {
	                        if (data) {
	                            if (data.plans) {
	                                if (twigIndex !== null && twigIndex !== undefined) {
	                                    dispatch(updateSelectedTwig(twigIndex));
	                                } else if (selectedTwigIndex) {
	                                    dispatch(updateSelectedTwig(selectedTwigIndex));
	                                } else {
	                                    dispatch(updateSelectedTwig(_.findIndex(twigs.data, function (twig) {
	                                        return twig.twigId === stem;
	                                    })));
	                                }
	                                if (subscriptionSelected) {
	                                    _.remove(data.plans.data, function (plan) {
	                                        return plan.id === subscriptionSelected.details.subscription.plan.id;
	                                    });
	                                }
	                                dispatch({
	                                    type: GET_STRIPEPLANS,
	                                    result: {
	                                        success: data.success,
	                                        stripePlans: data.plans,
	                                        showStripePlans: data.success
	                                    }
	                                });
	                                dispatch((0, _actions.showLoader)(false));
	                            } else {
	                                if (response && response.data && response.data.preference && Object.keys(response.data.preference).length > 0) {
	                                    if (twigToSubscribe && twigToSubscribe.twigId) {
	                                        stem = twigToSubscribe.twigId;
	                                    } else if (twig && twig.twigId && twig.twigId !== response.data.preference.stem) {
	                                        stem = twig.twigId;
	                                        response.data.preference = Object.assign({}, response.data.preference, { selectedTwig: twig, stem: stem });
	                                    } else {
	                                        stem = response.data.preference.stem;
	                                    }
	                                    var _selectedTwigIndex = void 0;
	                                    var _selectedTwig = _.find(twigs.data, function (twig, index) {
	                                        _selectedTwigIndex = index;
	                                        return twig.twigId === stem;
	                                    });
	                                    dispatch(updateSelectedTwig(_selectedTwigIndex));
	                                    (0, _Api.getTwigChart)(stem, (0, _Utility.convertToISO)(response.data.preference.fromDate), (0, _Utility.convertToISO)(response.data.preference.toDate), '').then(function (dataPref) {
	                                        dispatch({
	                                            type: GET_USER_PREFERENCES,
	                                            result: {
	                                                UserPref: response.data,
	                                                chartData: dataPref ? dataPref.data : null,
	                                                subscription: data
	                                            }
	                                        });
	                                        dispatch((0, _actions.showLoader)(false));
	                                    }).catch(function (error) {});
	                                } else {
	                                    var fromDate = new Date();
	                                    fromDate.setDate(fromDate.getDate() - 14);
	                                    var toDate = new Date();
	                                    dispatch(updateSelectedTwig(0));
	                                    dispatch(loadChartData(twigs.data[0].twigId, fromDate.toISOString(), toDate.toISOString(), '', 0));
	                                }
	                                dispatch((0, _actions.navEnable)(false));
	                                dispatch({
	                                    type: SHOW_CHART_VIEW,
	                                    result: {
	                                        showSubscriptionForm: false,
	                                        showStripePlans: false
	                                    }
	                                });
	                            }
	                        }
	                    });
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        });
	    };
	}
	
	function createSubscription(payload) {
	    return function (dispatch) {
	        (0, _Api.createStripeSubscription)(payload.paymentInformation).then(function (response) {
	            dispatch(showChartView(payload));
	        });
	    };
	}
	
	var pageNumber = 1;
	function loadChartData(twigId, fromDate, toDate, pageNo, twigIndex) {
	    return function (dispatch) {
	        (0, _Api.getSubscription)(twigId).then(function (data) {
	            if (data) {
	                if (data.plans) {
	                    if (twigIndex !== null && twigIndex !== undefined) {
	                        dispatch(updateSelectedTwig(twigIndex));
	                    }
	                    dispatch({
	                        type: GET_STRIPEPLANS,
	                        result: {
	                            success: data.success,
	                            stripePlans: data.plans,
	                            showStripePlans: data.success
	                        }
	                    });
	                    dispatch(addSubscription(false));
	                    dispatch((0, _actions.showLoader)(false));
	                } else {
	                    (0, _Api.getTwigChart)(twigId, fromDate, toDate, '').then(function (response) {
	                        // console.log('response::', response)
	                        pageNumber = pageNumber + 1;
	                        // if (!_.isEmpty(response.data)) {
	                        //   dispatch(loadChartData(twigId, fromDate, toDate, pageNumber));
	                        // }else{
	                        //   alert('done ho')
	                        // }
	                        setTimeout(function () {
	                            dispatch(updateChart(response));
	                        }, 0);
	                        dispatch({
	                            type: UPDATE_CHART,
	                            result: 'loading'
	                        });
	                        dispatch((0, _actions.navEnable)(false));
	                        dispatch({
	                            type: SHOW_CHART_VIEW,
	                            result: {
	                                showSubscriptionForm: false,
	                                showStripePlans: false
	                            }
	                        });
	                        dispatch((0, _actions.showLoader)(false));
	                    }).catch(function (error) {
	                        dispatch({
	                            type: UPDATE_CHART,
	                            result: 'loading'
	                        });
	                        // console.log('error::', error)
	                    });
	                }
	            }
	        }).catch(function (error) {
	            dispatch((0, _actions.showLoader)(false));
	            // console.log('error::', error)
	        });
	    };
	}
	
	function updateTwigApi(twigId, twigObj, siteName, selectedTwigIndex) {
	    return function (dispatch) {
	        (0, _Api.updateTwig)(twigId, twigObj).then(function (response) {
	            // console.log('updateTwig::', response)
	            dispatch(loadTwigs(false, siteName, selectedTwigIndex));
	        }).catch(function (error) {
	            // console.log('error::', error)
	        });
	    };
	}
	
	function getAlertsApi(twigId) {
	    return function (dispatch) {
	        (0, _Api.getAlerts)(twigId).then(function (response) {
	            // console.log('getAlerts::', response)
	            dispatch({
	                type: GET_ALERTS,
	                result: response.data
	            });
	        }).catch(function (error) {
	            // console.log('error::', error)
	        });
	    };
	}
	
	function addAlertAction(alertData, twigId) {
	    return function (dispatch) {
	        (0, _Api.saveAlert)(alertData).then(function (response) {
	            // console.log('saveAlert::', response)
	            dispatch(getAlertsApi(twigId));
	        }).catch(function (error) {
	            // console.log('error::', error)
	        });
	    };
	}
	
	function updateAlertAction(alertId, alertData, twigId) {
	    return function (dispatch) {
	        (0, _Api.updateAlert)(alertId, alertData).then(function (response) {
	            // console.log('updateAlert::', response)
	            dispatch(getAlertsApi(twigId));
	        }).catch(function (error) {
	            // console.log('error::', error)
	        });
	    };
	}
	
	function deleteAlertAction(alertId, twigId) {
	    return function (dispatch) {
	        (0, _Api.deleteAlert)(alertId).then(function (response) {
	            // console.log('updateAlert::', response)
	            dispatch(getAlertsApi(twigId));
	        }).catch(function (error) {
	            // console.log('error::', error)
	        });
	    };
	}
	
	function getUserPreferencesAction() {
	    return function (dispatch) {
	        (0, _Api.getUserPreferences)().then(function (response) {
	            if (response && response.data) {
	                (0, _Api.getTwigChart)(response.data.preference.stem, response.data.preference.fromDate, response.data.preference.toDate).then(function (dataPref) {
	                    dispatch({
	                        type: GET_USER_PREFERENCES,
	                        result: { UserPref: response.data, chartData: dataPref ? dataPref.data : null }
	                    });
	                });
	            }
	            // console.log('getUserPreferences::', response);
	        }).catch(function (error) {
	            // console.log('getUserPreferenceserror::', error)
	        });
	    };
	}
	
	function saveUserPreferencesAction(saveObj) {
	    return function (dispatch) {
	        (0, _Api.saveUserPreferences)(saveObj).then(function (response) {
	            // console.log('getUserPreferences::', response);
	            dispatch({
	                type: SAVE_USER_PREFERENCES,
	                result: response.data
	            });
	        }).catch(function (error) {
	            // console.log('getUserPreferenceserror::', error)
	        });
	    };
	}
	
	function updateSelectedTwig(index) {
	    return {
	        type: UPDATE_SELECTEDTWIG,
	        index: index
	    };
	}
	
	function updateFromDate(date) {
	    return {
	        type: UPDATE_FROMDATE,
	        result: date
	    };
	}
	
	function updateToDate(date) {
	    return {
	        type: UPDATE_TODATE,
	        result: date
	    };
	}
	
	function updateChart(response) {
	    return {
	        type: UPDATE_CHART,
	        result: response.data
	    };
	}
	
	function updateDateRange(range) {
	    return {
	        type: UPDATE_DATE_RANGE,
	        result: range
	    };
	}
	
	function storeTwigs(response, index) {
	    return {
	        type: GET_TWIGS,
	        result: response.data,
	        selectedIndex: index
	    };
	}
	
	function changeDisplayOption(payload) {
	    return {
	        type: CHANGE_DISPLAYOPTION,
	        result: payload
	    };
	}
	
	function showUpperLimit(payload) {
	    return {
	        type: TOGGLE_UPPERLIMIT,
	        result: payload
	    };
	}
	function showLowerLimit(payload) {
	    return {
	        type: TOGGLE_LOWERLIMIT,
	        result: payload
	    };
	}
	
	function changeDepthOption(payload) {
	    return {
	        type: CHANGE_DEPTHOPTION,
	        result: payload
	    };
	}
	
	function changeTwig(index) {
	    return {
	        type: CHANGE_TWIG,
	        result: index
	    };
	}
	
	function changeResolution(resolution) {
	    return {
	        type: CHANGE_RESOULTION,
	        result: resolution
	    };
	}
	
	function showTrendLine(payload) {
	    return {
	        type: SHOW_TRENDLINE,
	        result: payload
	    };
	}
	
	function showRawGraph(payload) {
	    return {
	        type: SHOW_RAWGRAPH,
	        result: payload
	    };
	}
	
	function changeTrendAverage(value) {
	    return {
	        type: CHANGE_TREND_AVERAGE,
	        result: value
	    };
	}
	
	function clearTwigsList() {
	    return {
	        type: CLEAR_TWIGS,
	        result: {}
	    };
	}
	
	function changeZoomOption(value) {
	    return {
	        type: TOGGLE_ZOOM,
	        result: value
	    };
	}
	
	function addSubscription(payload) {
	    return function (dispatch) {
	        (0, _Api.getCustomerCard)().then(function (savedCard) {
	            if (savedCard && savedCard.card && savedCard.stripeCustomerId) {
	                if (payload) {
	                    payload.rememberMe = true;
	                    payload.savedCard = savedCard;
	                }
	            }
	            dispatch({
	                type: ADD_SUBSCRPTION,
	                result: payload
	            });
	        }).catch(function (error) {
	            dispatch({
	                type: ADD_SUBSCRPTION,
	                result: payload
	            });
	        });
	    };
	}
	
	function showChartView(payload) {
	    return function (dispatch) {
	        dispatch(getPageLoadData(payload.selectedTwig));
	    };
	}
	
	function validateCouponCode(coupon) {
	    return function (dispatch) {
	        if (coupon) {
	            (0, _Api.validateCoupon)(coupon).then(function (response) {
	                dispatch({
	                    type: VALIDATE_COUPON,
	                    result: response
	                });
	                if (response && response.coupon && response.coupon.percent_off == 100) {
	                    var payload = {
	                        showError: false
	                    };
	                    dispatch({
	                        type: HANDLE_PAYMENT_INFO_SUBMIT,
	                        result: payload
	                    });
	                }
	                dispatch((0, _actions.showLoader)(false));
	            }).catch(function (error) {
	                // console.log('getUserPreferenceserror::', error)
	            });
	        } else {
	            dispatch({
	                type: VALIDATE_COUPON,
	                result: null
	            });
	            dispatch((0, _actions.showLoader)(false));
	        }
	    };
	}
	
	function handlePaymentInfoSubmission(payload) {
	    return function (dispatch) {
	        dispatch({
	            type: HANDLE_PAYMENT_INFO_SUBMIT,
	            result: payload
	        });
	    };
	}
	
	function initializePaymentInformation(payload) {
	    return function (dispatch) {
	        dispatch({
	            type: INIT_PAYMENT_INFO,
	            result: payload
	        });
	    };
	}
	
	function rememberCardData(value) {
	    return function (dispatch) {
	        dispatch({
	            type: REMEMBER_ME,
	            result: value
	        });
	    };
	}
	
	function rebindCouponData(value) {
	    return function (dispatch) {
	        dispatch({
	            type: REBIND_COUPON_DATA,
	            result: value
	        });
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(GET_TWIGS, 'GET_TWIGS', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(UPDATE_CHART, 'UPDATE_CHART', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(CHANGE_DISPLAYOPTION, 'CHANGE_DISPLAYOPTION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(CHANGE_DEPTHOPTION, 'CHANGE_DEPTHOPTION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(CHANGE_TWIG, 'CHANGE_TWIG', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(UPDATE_FROMDATE, 'UPDATE_FROMDATE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(UPDATE_TODATE, 'UPDATE_TODATE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(UPDATE_DATE_RANGE, 'UPDATE_DATE_RANGE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(CHANGE_RESOULTION, 'CHANGE_RESOULTION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(UPDATE_SELECTEDTWIG, 'UPDATE_SELECTEDTWIG', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(SHOW_TRENDLINE, 'SHOW_TRENDLINE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(SHOW_RAWGRAPH, 'SHOW_RAWGRAPH', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(CHANGE_TREND_AVERAGE, 'CHANGE_TREND_AVERAGE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(TOGGLE_UPPERLIMIT, 'TOGGLE_UPPERLIMIT', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(TOGGLE_LOWERLIMIT, 'TOGGLE_LOWERLIMIT', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(GET_ALERTS, 'GET_ALERTS', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(RESET_CHART, 'RESET_CHART', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(CLEAR_TWIGS, 'CLEAR_TWIGS', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(GET_USER_PREFERENCES, 'GET_USER_PREFERENCES', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(SAVE_USER_PREFERENCES, 'SAVE_USER_PREFERENCES', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(TOGGLE_ZOOM, 'TOGGLE_ZOOM', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(GET_STRIPEPLANS, 'GET_STRIPEPLANS', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(ADD_SUBSCRPTION, 'ADD_SUBSCRPTION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(CONFIRM_SUBSCRIPTION, 'CONFIRM_SUBSCRIPTION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(VALIDATE_COUPON, 'VALIDATE_COUPON', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(SHOW_CHART_VIEW, 'SHOW_CHART_VIEW', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(HANDLE_PAYMENT_INFO_SUBMIT, 'HANDLE_PAYMENT_INFO_SUBMIT', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(INIT_PAYMENT_INFO, 'INIT_PAYMENT_INFO', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(REMEMBER_ME, 'REMEMBER_ME', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(REBIND_COUPON_DATA, 'REBIND_COUPON_DATA', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(loadTwigs, 'loadTwigs', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(getPageLoadData, 'getPageLoadData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(createSubscription, 'createSubscription', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(pageNumber, 'pageNumber', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(loadChartData, 'loadChartData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(updateTwigApi, 'updateTwigApi', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(getAlertsApi, 'getAlertsApi', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(addAlertAction, 'addAlertAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(updateAlertAction, 'updateAlertAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(deleteAlertAction, 'deleteAlertAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(getUserPreferencesAction, 'getUserPreferencesAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(saveUserPreferencesAction, 'saveUserPreferencesAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(updateSelectedTwig, 'updateSelectedTwig', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(updateFromDate, 'updateFromDate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(updateToDate, 'updateToDate', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(updateChart, 'updateChart', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(updateDateRange, 'updateDateRange', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(storeTwigs, 'storeTwigs', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(changeDisplayOption, 'changeDisplayOption', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(showUpperLimit, 'showUpperLimit', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(showLowerLimit, 'showLowerLimit', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(changeDepthOption, 'changeDepthOption', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(changeTwig, 'changeTwig', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(changeResolution, 'changeResolution', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(showTrendLine, 'showTrendLine', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(showRawGraph, 'showRawGraph', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(changeTrendAverage, 'changeTrendAverage', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(clearTwigsList, 'clearTwigsList', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(changeZoomOption, 'changeZoomOption', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(addSubscription, 'addSubscription', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(showChartView, 'showChartView', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(validateCouponCode, 'validateCouponCode', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(handlePaymentInfoSubmission, 'handlePaymentInfoSubmission', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(initializePaymentInformation, 'initializePaymentInformation', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(rememberCardData, 'rememberCardData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	
	    __REACT_HOT_LOADER__.register(rebindCouponData, 'rebindCouponData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/locationView.js');
	}();

	;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _DOM = __webpack_require__(47);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Scroll = __webpack_require__(214);
	
	var _Scroll2 = _interopRequireDefault(_Scroll);
	
	var _Responsive = __webpack_require__(88);
	
	var _Responsive2 = _interopRequireDefault(_Responsive);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LinkNext = __webpack_require__(103);
	
	var _LinkNext2 = _interopRequireDefault(_LinkNext);
	
	var _LinkPrevious = __webpack_require__(125);
	
	var _LinkPrevious2 = _interopRequireDefault(_LinkPrevious);
	
	var _Up = __webpack_require__(525);
	
	var _Up2 = _interopRequireDefault(_Up);
	
	var _Down = __webpack_require__(195);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.ARTICLE;
	var DEFAULT_PLAY_INTERVAL = 10000; // 10s
	
	var Article = function (_Component) {
	  _inherits(Article, _Component);
	
	  function Article(props, context) {
	    _classCallCheck(this, Article);
	
	    var _this = _possibleConstructorReturn(this, (Article.__proto__ || Object.getPrototypeOf(Article)).call(this, props, context));
	
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onWheel = _this._onWheel.bind(_this);
	    _this._onTouchStart = _this._onTouchStart.bind(_this);
	    _this._onTouchMove = _this._onTouchMove.bind(_this);
	    _this._onResize = _this._onResize.bind(_this);
	    _this._onNext = _this._onNext.bind(_this);
	    _this._onPrevious = _this._onPrevious.bind(_this);
	    _this._onTogglePlay = _this._onTogglePlay.bind(_this);
	    _this._onSelect = _this._onSelect.bind(_this);
	    _this._checkControls = _this._checkControls.bind(_this);
	    _this._checkPreviousNextControls = _this._checkPreviousNextControls.bind(_this);
	    _this._onResponsive = _this._onResponsive.bind(_this);
	    _this._updateHiddenElements = _this._updateHiddenElements.bind(_this);
	    _this._updateProgress = _this._updateProgress.bind(_this);
	
	    // Necessary to detect for Firefox or Edge to implement accessibility
	    // tabbing
	    var accessibilityTabbingCompatible = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Firefox') === -1 && navigator.userAgent.indexOf('Edge') === -1;
	
	    _this.state = {
	      selectedIndex: props.selected || 0,
	      playing: false,
	      accessibilityTabbingCompatible: accessibilityTabbingCompatible
	    };
	    return _this;
	  }
	
	  _createClass(Article, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._propsSetup(this.props);
	      if (this.state.selectedIndex) {
	        this._onSelect(this.state.selectedIndex);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!nextProps.scrollStep && this.props.scrollStep) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keys);
	        document.removeEventListener('wheel', this._onWheel);
	        window.removeEventListener('resize', this._onResize);
	      }
	      if (!nextProps.onProgress && this.props.onProgress) {
	        if (this._responsive) {
	          this._responsive.stop();
	        }
	        if (this.props.onProgress) {
	          window.removeEventListener('scroll', this._updateProgress);
	        }
	      }
	
	      this._propsSetup(nextProps);
	
	      // allow updates to selected props to trigger new chapter select
	      if (typeof nextProps.selected !== 'undefined' && nextProps.selected !== null && nextProps.selected !== this.state.selectedIndex) {
	        this._onSelect(nextProps.selected);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.scrollStep) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keys);
	        document.removeEventListener('wheel', this._onWheel);
	        window.removeEventListener('resize', this._onResize);
	      }
	      if (this._responsive) {
	        this._responsive.stop();
	      }
	      if (this.props.onProgress) {
	        window.removeEventListener('scroll', this._updateProgress);
	      }
	    }
	  }, {
	    key: '_propsSetup',
	    value: function _propsSetup(props) {
	      var direction = props.direction,
	          full = props.full,
	          onProgress = props.onProgress,
	          scrollStep = props.scrollStep;
	
	      if (scrollStep) {
	        if (full) {
	          console.warn('Article cannot use `scrollStep` with `full`.');
	        }
	
	        this._keys = { up: this._onPrevious, down: this._onNext };
	        if ('row' === direction) {
	          this._keys = {
	            left: this._onPrevious,
	            right: this._onNext
	          };
	
	          if (this.state.accessibilityTabbingCompatible) {
	            this._updateHiddenElements();
	          }
	        }
	        //keys.space = this._onTogglePlay;
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keys);
	
	        document.addEventListener('wheel', this._onWheel);
	        window.addEventListener('resize', this._onResize);
	
	        this._checkControls();
	
	        if ('row' === direction) {
	          this._responsive = _Responsive2.default.start(this._onResponsive);
	        }
	      }
	
	      if (onProgress) {
	        window.addEventListener('scroll', this._updateProgress);
	
	        if (direction === 'row') {
	          this._responsive = _Responsive2.default.start(this._onResponsive);
	        }
	      }
	    }
	  }, {
	    key: '_childDOMNode',
	    value: function _childDOMNode(index) {
	      var componentElement = (0, _reactDom.findDOMNode)(this._componentRef);
	      return componentElement.children[index];
	    }
	  }, {
	    key: '_checkPreviousNextControls',
	    value: function _checkPreviousNextControls(currentScroll, nextProp, prevProp) {
	      var selectedIndex = this.state.selectedIndex;
	
	      if (currentScroll > 0) {
	        var nextStepNode = this._childDOMNode(selectedIndex + 1);
	        var previousStepNode = this._childDOMNode(selectedIndex - 1);
	
	        if (nextStepNode) {
	          var nextStepPosition = nextStepNode.getBoundingClientRect()[nextProp] * (selectedIndex + 1);
	
	          if (currentScroll > nextStepPosition) {
	            this.setState({ selectedIndex: selectedIndex + 1 });
	          }
	        }
	
	        if (previousStepNode) {
	          var previousStepPosition = previousStepNode.getBoundingClientRect()[prevProp] * selectedIndex;
	
	          if (currentScroll < previousStepPosition) {
	            this.setState({ selectedIndex: selectedIndex - 1 });
	          }
	        }
	      }
	    }
	  }, {
	    key: '_checkControls',
	    value: function _checkControls() {
	      var direction = this.props.direction;
	
	      if (direction === 'row') {
	        var currentScroll = this._componentRef.boxContainerRef.scrollLeft;
	        this._checkPreviousNextControls(currentScroll, 'left', 'right');
	      } else {
	        var _currentScroll = this._componentRef.boxContainerRef.scrollTop;
	        this._checkPreviousNextControls(_currentScroll, 'top', 'bottom');
	      }
	    }
	  }, {
	    key: '_visibleIndexes',
	    value: function _visibleIndexes() {
	      var _props = this.props,
	          children = _props.children,
	          direction = _props.direction;
	
	      var result = [];
	      var childCount = _react2.default.Children.count(children);
	      var limit = 'row' === direction ? window.innerWidth : window.innerHeight;
	      for (var index = 0; index < childCount; index += 1) {
	        var childElement = this._childDOMNode(index);
	        var rect = childElement.getBoundingClientRect();
	        // ignore small drifts of 10 pixels on either end
	        if ('row' === direction) {
	          if (rect.right > 10 && rect.left < limit - 10) {
	            result.push(index);
	          } else if (result.length > 0) {
	            break;
	          }
	        } else {
	          if (rect.bottom > 10 && rect.top < limit - 10) {
	            result.push(index);
	          } else if (result.length > 0) {
	            break;
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: '_shortTimer',
	    value: function _shortTimer(name, duration) {
	      var _this2 = this;
	
	      if (!this[name]) {
	        this[name] = true;
	      }
	      var timerName = this[name] + 'Timer';
	      clearTimeout(this[timerName]);
	      this[timerName] = setTimeout(function () {
	        _this2[name] = false;
	      }, duration);
	    }
	  }, {
	    key: '_onWheel',
	    value: function _onWheel(event) {
	      var _this3 = this;
	
	      var direction = this.props.direction;
	
	      if ('row' === direction) {
	        if (this._scrollingHorizontally) {
	          // no-op
	        } else if (!this._scrollingVertically) {
	          if (Math.abs(event.deltaY * 2) > Math.abs(event.deltaX)) {
	            // user is scrolling vertically
	            this._shortTimer('_scrollingVertically', 1000);
	          }
	        }
	      } else {
	        // Give the user lots of control.
	        var delta = event.deltaY;
	        if (Math.abs(delta) > 100) {
	          // The user is expressing a resolute interest in controlling the
	          // scrolling behavior. Stop doing any of our scroll step aligning
	          // until he stops expressing such interest.
	          clearInterval(this._wheelTimer);
	          clearInterval(this._wheelLongTimer);
	          this._wheelLongTimer = setTimeout(function () {
	            _this3._wheelLongTimer = undefined;
	          }, 2000);
	        } else if (!this._wheelLongTimer) {
	          if (delta > 10) {
	            clearInterval(this._wheelTimer);
	            this._wheelTimer = setTimeout(this._onNext, 200);
	          } else if (delta < -10) {
	            clearInterval(this._wheelTimer);
	            this._wheelTimer = setTimeout(this._onPrevious, 200);
	          } else {
	            clearInterval(this._controlTimer);
	            this._controlTimer = setTimeout(this._checkControls, 200);
	          }
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      var _this4 = this;
	
	      var direction = this.props.direction;
	
	      if ('row' === direction) {
	        var selectedIndex = this.state.selectedIndex;
	
	        var componentElement = (0, _reactDom.findDOMNode)(this._componentRef);
	        var childElement = this._childDOMNode(selectedIndex);
	        var rect = childElement.getBoundingClientRect();
	        if (event.target === componentElement) {
	          // scrolling Article
	          if (this._scrollingVertically) {
	            // prevent Article horizontal scrolling while scrolling vertically
	            componentElement.scrollLeft += rect.left;
	          } else {
	            var scrollingRight = this._priorScrollLeft < componentElement.scrollLeft;
	            // once we stop scrolling, align with child boundaries
	            clearTimeout(this._scrollTimer);
	            this._scrollTimer = setTimeout(function () {
	              if (!_this4._resizing) {
	                var indexes = _this4._visibleIndexes();
	                if (indexes.length > 1 && scrollingRight) {
	                  _this4._onSelect(indexes[1]);
	                } else {
	                  _this4._onSelect(indexes[0]);
	                }
	              }
	            }, 100);
	            this._priorScrollLeft = componentElement.scrollLeft;
	          }
	        } else if (event.target.parentNode === componentElement) {
	          // scrolling child
	          // Has it scrolled near the bottom?
	          if (this.state.accessibilityTabbingCompatible) {
	            // only use lastGrandChild logic if we're not using Firefox or IE.
	            // causes flashing in Firefox, but required for Safari scrolling.
	            var grandchildren = event.target.children;
	            var lastGrandChild = grandchildren[grandchildren.length - 1];
	            rect = lastGrandChild.getBoundingClientRect();
	          }
	          if (rect.bottom <= window.innerHeight + 24) {
	            // at the bottom
	            this.setState({ atBottom: true });
	          } else {
	            // not at the bottom
	            this.setState({ atBottom: false });
	          }
	        }
	      }
	    }
	  }, {
	    key: '_onTouchStart',
	    value: function _onTouchStart(event) {
	      var touched = event.changedTouches[0];
	      this._touchStartX = touched.clientX;
	      this._touchStartY = touched.clientY;
	    }
	  }, {
	    key: '_onTouchMove',
	    value: function _onTouchMove(event) {
	      var touched = event.changedTouches[0];
	      var deltaX = touched.clientX - this._touchStartX;
	      var deltaY = touched.clientY - this._touchStartY;
	      // Only step if the user isn't scrolling vertically, bias vertically
	      if (Math.abs(deltaY) < Math.abs(deltaX * 2)) {
	        if (deltaX < 0) {
	          this._onNext();
	        } else {
	          this._onPrevious();
	        }
	      }
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      var _this5 = this;
	
	      clearTimeout(this._resizeTimer);
	      this._resizeTimer = setTimeout(function () {
	        _this5._onSelect(_this5.state.selectedIndex);
	        _this5._shortTimer('_resizing', 1000);
	      }, 50);
	    }
	  }, {
	    key: '_onNext',
	    value: function _onNext(event, wrap) {
	      // only process if the focus is NOT in a form element
	      if (!(0, _DOM.isFormElement)(document.activeElement)) {
	        var children = this.props.children;
	        var selectedIndex = this.state.selectedIndex;
	
	        var childCount = _react2.default.Children.count(children);
	        if (event) {
	          this._stop();
	          event.preventDefault();
	        }
	        var targetIndex = this._visibleIndexes()[0] + 1;
	        if (targetIndex !== selectedIndex) {
	          if (targetIndex < childCount) {
	            this._onSelect(Math.min(childCount - 1, targetIndex));
	          } else if (wrap) {
	            this._onSelect(1);
	          }
	        }
	      }
	    }
	  }, {
	    key: '_onPrevious',
	    value: function _onPrevious(event) {
	      // only process if the focus is NOT in a form element
	      if (!(0, _DOM.isFormElement)(document.activeElement)) {
	        var selectedIndex = this.state.selectedIndex;
	
	        if (event) {
	          this._stop();
	          event.preventDefault();
	        }
	        var targetIndex = this._visibleIndexes()[0] - 1;
	        if (targetIndex !== selectedIndex) {
	          this._onSelect(Math.max(0, targetIndex));
	        }
	      }
	    }
	  }, {
	    key: '_start',
	    value: function _start() {
	      var _this6 = this;
	
	      this._playTimer = setInterval(function () {
	        _this6._onNext(null, true);
	      }, DEFAULT_PLAY_INTERVAL);
	      this.setState({ playing: true });
	    }
	  }, {
	    key: '_stop',
	    value: function _stop() {
	      clearInterval(this._playTimer);
	      this.setState({ playing: false });
	    }
	  }, {
	    key: '_onTogglePlay',
	    value: function _onTogglePlay(event) {
	      event.preventDefault();
	      if (this.state.playing) {
	        this._stop();
	      } else {
	        this._start();
	      }
	    }
	  }, {
	    key: '_onSelect',
	    value: function _onSelect(selectedIndex) {
	      var _this7 = this;
	
	      var _props2 = this.props,
	          direction = _props2.direction,
	          onSelect = _props2.onSelect;
	
	      var componentElement = (0, _reactDom.findDOMNode)(this._componentRef);
	      var childElement = this._childDOMNode(selectedIndex);
	      var windowHeight = window.innerHeight + 24;
	
	      if (childElement) {
	        if (selectedIndex !== this.state.selectedIndex) {
	          var parentElement = childElement.parentNode;
	          var atBottom = Math.round(parentElement.scrollTop) >= parentElement.scrollHeight - parentElement.clientHeight;
	
	          // scroll child to top
	          childElement.scrollTop = 0;
	          // ensures controls are displayed when selecting a new index and
	          // scrollbar is at bottom of article
	          this.setState({
	            selectedIndex: selectedIndex,
	            atBottom: atBottom
	          }, function () {
	            if (onSelect) {
	              onSelect(selectedIndex);
	            }
	
	            // Necessary to detect for Firefox or Edge to implement accessibility
	            // tabbing
	            if (direction === 'row' && _this7.state.accessibilityTabbingCompatible) {
	              _this7._anchorStepRef.focus();
	              _this7._updateHiddenElements();
	            }
	          });
	        } else if (childElement.scrollHeight <= windowHeight) {
	          // on initial chapter load, ensure arrows are rendered
	          // when there are no scrollbars
	          this.setState({ atBottom: true });
	        }
	
	        var rect = childElement.getBoundingClientRect();
	        if ('row' === direction) {
	          if (rect.left !== 0) {
	            this._scrollingHorizontally = true;
	            _Scroll2.default.scrollBy(componentElement, 'scrollLeft', rect.left, function () {
	              _this7._scrollingHorizontally = false;
	            });
	          }
	        } else {
	          if (rect.top !== 0) {
	            this._scrollingVertically = true;
	            _Scroll2.default.scrollBy(componentElement, 'scrollTop', rect.top, function () {
	              _this7._scrollingVertically = false;
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: '_onResponsive',
	    value: function _onResponsive(small) {
	      this.setState({ narrow: small });
	    }
	  }, {
	    key: '_toggleDisableChapter',
	    value: function _toggleDisableChapter(chapter, disabled) {
	      var elements = (0, _DOM.filterByFocusable)(chapter.getElementsByTagName('*'));
	
	      if (elements) {
	        elements.forEach(function (element) {
	          if (disabled) {
	            element.setAttribute('disabled', 'disabled');
	          } else {
	            element.removeAttribute('disabled');
	          }
	
	          element.setAttribute('tabindex', disabled ? '-1' : '0');
	        });
	      }
	    }
	  }, {
	    key: '_updateHiddenElements',
	    value: function _updateHiddenElements() {
	      var component = (0, _reactDom.findDOMNode)(this._componentRef);
	      var children = component.children;
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i];
	        if (child.getAttribute('aria-hidden')) {
	          this._toggleDisableChapter(child, true);
	        } else {
	          this._toggleDisableChapter(child, false);
	        }
	      }
	    }
	  }, {
	    key: '_updateProgress',
	    value: function _updateProgress(event) {
	      var _props3 = this.props,
	          direction = _props3.direction,
	          responsive = _props3.responsive;
	      var narrow = this.state.narrow;
	
	      var article = (0, _reactDom.findDOMNode)(this._componentRef);
	      var articleRect = article.getBoundingClientRect();
	
	      var offset = direction === 'column' ? Math.abs(articleRect.top) : Math.abs(articleRect.left);
	      var totalDistance = direction === 'column' ? window.innerHeight : this._getChildrenWidth(this._componentRef.boxContainerRef.childNodes);
	      var objectDistance = direction === 'column' ? articleRect.height : articleRect.width;
	
	      // Covers row responding to column layout.
	      if (direction === 'row' && narrow && responsive !== false) {
	        offset = Math.abs(articleRect.top);
	        totalDistance = window.innerHeight;
	        objectDistance = articleRect.height;
	      }
	
	      var progress = Math.abs(offset / (objectDistance - totalDistance));
	      var scrollPercentRounded = Math.round(progress * 100);
	      this.props.onProgress(scrollPercentRounded);
	    }
	  }, {
	    key: '_renderControls',
	    value: function _renderControls() {
	      var direction = this.props.direction;
	      var _state = this.state,
	          atBottom = _state.atBottom,
	          narrow = _state.narrow,
	          selectedIndex = _state.selectedIndex;
	
	      var CONTROL_CLASS_PREFIX = CLASS_ROOT + '__control ' + CLASS_ROOT + '__control';
	      var childCount = _react2.default.Children.count(this.props.children);
	      var controls = [];
	
	      var a11yTitle = this.props.a11yTitle || {};
	      if ('row' === direction) {
	        if (!narrow || atBottom) {
	          if (selectedIndex > 0) {
	            controls.push(_react2.default.createElement(_Button2.default, { key: 'previous',
	              plain: true, a11yTitle: a11yTitle.previous,
	              className: CONTROL_CLASS_PREFIX + '-left',
	              onClick: this._onPrevious, icon: _react2.default.createElement(_LinkPrevious2.default, {
	                a11yTitle: 'article-previous-title', size: 'large' }) }));
	          }
	          if (selectedIndex < childCount - 1) {
	            controls.push(_react2.default.createElement(_Button2.default, { key: 'next',
	              plain: true, a11yTitle: a11yTitle.next,
	              className: CONTROL_CLASS_PREFIX + '-right',
	              onClick: this._onNext, icon: _react2.default.createElement(_LinkNext2.default, {
	                size: 'large', a11yTitle: 'article-next-title' }) }));
	          }
	        }
	      } else {
	        if (selectedIndex > 0) {
	          controls.push(_react2.default.createElement(
	            _Button2.default,
	            { key: 'previous',
	              plain: true, a11yTitle: a11yTitle.previous,
	              className: CONTROL_CLASS_PREFIX + '-up',
	              onClick: this._onPrevious },
	            _react2.default.createElement(_Up2.default, null)
	          ));
	        }
	        if (selectedIndex < childCount - 1) {
	          controls.push(_react2.default.createElement(
	            _Button2.default,
	            { key: 'next', plain: true, a11yTitle: a11yTitle.next,
	              className: CONTROL_CLASS_PREFIX + '-down', onClick: this._onNext },
	            _react2.default.createElement(_Down2.default, { a11yTitle: 'article-down' })
	          ));
	        }
	      }
	
	      return controls;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props4 = this.props,
	          className = _props4.className,
	          primary = _props4.primary,
	          scrollStep = _props4.scrollStep;
	      var selectedIndex = this.state.selectedIndex;
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--scroll-step', scrollStep), className);
	
	      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	      var restProps = _Props2.default.omit(this.props, Object.keys(Article.propTypes));
	
	      var controls = void 0;
	      if (this.props.controls) {
	        controls = this._renderControls();
	      }
	
	      var anchorStepNode = void 0;
	      if (this.state.accessibilityTabbingCompatible) {
	        anchorStepNode = _react2.default.createElement('a', { tabIndex: '-1', 'aria-hidden': 'true',
	          ref: function ref(_ref) {
	            return _this8._anchorStepRef = _ref;
	          } });
	      }
	
	      var children = this.props.children;
	      if (scrollStep || controls) {
	        children = _react.Children.map(this.props.children, function (element, index) {
	          if (element) {
	
	            if (controls) {
	              var ariaHidden = void 0;
	              if (selectedIndex !== index && _this8.state.accessibilityTabbingCompatible) {
	                ariaHidden = 'true';
	              }
	
	              element = _react2.default.createElement(
	                'div',
	                { 'aria-hidden': ariaHidden },
	                element
	              );
	            }
	
	            return element;
	          }
	
	          return undefined;
	        }, this);
	      }
	
	      delete boxProps.a11yTitle;
	
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, restProps, boxProps, { ref: function ref(_ref2) {
	            return _this8._componentRef = _ref2;
	          },
	          tag: 'article', className: classes, primary: primary,
	          onScroll: this._onScroll, onTouchStart: this._onTouchStart,
	          onTouchMove: this._onTouchMove }),
	        children,
	        controls,
	        anchorStepNode
	      );
	    }
	  }]);
	
	  return Article;
	}(_react.Component);
	
	Article.displayName = 'Article';
	exports.default = Article;
	
	
	Article.propTypes = _extends({
	  controls: _propTypes2.default.bool
	}, _Box2.default.propTypes, {
	  a11yTitle: _propTypes2.default.shape({
	    next: _propTypes2.default.string,
	    previous: _propTypes2.default.string
	  }),
	  onProgress: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  scrollStep: _propTypes2.default.bool,
	  selected: _propTypes2.default.number
	});
	
	Article.defaultProps = {
	  pad: 'none',
	  direction: 'column'
	};
	module.exports = exports['default'];

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-close', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'close');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,3 L21,21 M3,21 L21,3' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Close';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showLoader = showLoader;
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	
	// status
	var SHOW_LOADER = exports.SHOW_LOADER = 'SHOW_LOADER';
	
	function showLoader(value) {
	  return { type: SHOW_LOADER, result: value };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SHOW_LOADER, 'SHOW_LOADER', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/status.js');
	
	  __REACT_HOT_LOADER__.register(showLoader, 'showLoader', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/status.js');
	}();

	;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactDesc = __webpack_require__(590);
	
	var _reactRouter = __webpack_require__(43);
	
	var _LinkNext = __webpack_require__(103);
	
	var _LinkNext2 = _interopRequireDefault(_LinkNext);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.ANCHOR;
	
	var Anchor = function (_Component) {
	  _inherits(Anchor, _Component);
	
	  function Anchor(props, context) {
	    _classCallCheck(this, Anchor);
	
	    var _this = _possibleConstructorReturn(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, props, context));
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onLocationChange = _this._onLocationChange.bind(_this);
	    _this._attachUnlisten = _this._attachUnlisten.bind(_this);
	    _this._isRouteActive = _this._isRouteActive.bind(_this);
	    var path = props.path;
	    var router = context.router;
	
	
	    var active = _this._isRouteActive(path, router);
	
	    _this.state = { active: active };
	    return _this;
	  }
	
	  _createClass(Anchor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var path = this.props.path;
	      var router = this.context.router;
	
	
	      if (path) {
	        this._attachUnlisten(router.history || router);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var path = nextProps.path;
	      var router = this.context.router;
	
	
	      if (path && path !== this.props.path) {
	        this._attachUnlisten(router.history || router);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var path = this.props.path;
	
	      if (path) {
	        this._unlisten();
	      }
	      this._unmounted = true;
	    }
	  }, {
	    key: '_isRouteActive',
	    value: function _isRouteActive(path, router) {
	      if (!path) {
	        return false;
	      }
	      var active = void 0;
	      if (router && router.isActive) {
	        active = router && router.isActive && path && router.isActive({
	          pathname: path.path || path,
	          query: { indexLink: path.index }
	        });
	      } else if (router && _reactRouter.matchPath) {
	        active = !!(0, _reactRouter.matchPath)(router.history.location.pathname, { path: path.path || path, exact: !!path.index });
	      }
	
	      return active;
	    }
	  }, {
	    key: '_attachUnlisten',
	    value: function _attachUnlisten(router) {
	      this._unlisten = router.listen(this._onLocationChange);
	    }
	  }, {
	    key: '_onLocationChange',
	    value: function _onLocationChange(location) {
	      // sometimes react router is still calling the listen callback even
	      // if we called unlisten. So we added this check here to prevent
	      // calling setState in a unmounted component
	      if (!this._unmounted) {
	        var path = this.props.path;
	        var router = this.context.router;
	
	        var active = _reactRouter.matchPath ? !!(0, _reactRouter.matchPath)(location.pathname, { path: path.path || path, exact: !!path.index }) : router && location.pathname === (path.path || path);
	        this.setState({ active: active });
	      }
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      var _props = this.props,
	          method = _props.method,
	          onClick = _props.onClick,
	          path = _props.path,
	          disabled = _props.disabled;
	      var router = this.context.router;
	
	      var modifierKey = event.ctrlKey || event.metaKey;
	
	      if (modifierKey && !disabled && !onClick) {
	        return true;
	      }
	
	      event.preventDefault();
	
	      if (!disabled) {
	        if (path) {
	          if ('push' === method) {
	            (router.history || router).push(path.path || path);
	          } else if ('replace' === method) {
	            (router.history || router).replace(path.path || path);
	          }
	        }
	
	        if (onClick) {
	          onClick.apply(undefined, arguments);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          align = _props2.align,
	          animateIcon = _props2.animateIcon,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          href = _props2.href,
	          icon = _props2.icon,
	          label = _props2.label,
	          onClick = _props2.onClick,
	          path = _props2.path,
	          primary = _props2.primary,
	          reverse = _props2.reverse,
	          tag = _props2.tag,
	          props = _objectWithoutProperties(_props2, ['a11yTitle', 'align', 'animateIcon', 'children', 'className', 'disabled', 'href', 'icon', 'label', 'onClick', 'path', 'primary', 'reverse', 'tag']);
	
	      delete props.method;
	      var active = this.state.active;
	      var router = this.context.router;
	
	
	      var anchorIcon = void 0;
	      if (icon) {
	        anchorIcon = icon;
	      } else if (primary) {
	        anchorIcon = _react2.default.createElement(_LinkNext2.default, { a11yTitle: 'link next' });
	      }
	
	      if (anchorIcon && !primary && !label) {
	        anchorIcon = _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__icon' },
	          anchorIcon
	        );
	      }
	
	      var hasIcon = anchorIcon !== undefined;
	      var anchorChildren = _react.Children.map(children, function (child) {
	        if (child && child.type && child.type.icon) {
	          hasIcon = true;
	          child = _react2.default.createElement(
	            'span',
	            { className: CLASS_ROOT + '__icon' },
	            child
	          );
	        }
	        return child;
	      });
	
	      var target = path ? path.path || path : undefined;
	      var adjustedHref = void 0;
	      if (router && router.createPath) {
	        adjustedHref = path && router ? router.createPath(target) : href;
	      } else {
	        adjustedHref = path && router && router.history ? router.history.createHref(typeof target === 'string' ? { pathname: target } : target) : href;
	      }
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--animate-icon', hasIcon && animateIcon !== false), _defineProperty(_classnames, CLASS_ROOT + '--disabled', disabled), _defineProperty(_classnames, CLASS_ROOT + '--icon', anchorIcon || hasIcon), _defineProperty(_classnames, CLASS_ROOT + '--icon-label', hasIcon && label), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--primary', primary), _defineProperty(_classnames, CLASS_ROOT + '--reverse', reverse), _defineProperty(_classnames, CLASS_ROOT + '--active', active), _classnames), className);
	
	      var adjustedOnClick = path && router ? this._onClick : onClick;
	      if (!anchorChildren) {
	        anchorChildren = label;
	      }
	
	      var first = reverse ? anchorChildren : anchorIcon;
	      var second = reverse ? anchorIcon : anchorChildren;
	
	      var Component = tag;
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { href: adjustedHref, className: classes,
	          'aria-label': a11yTitle, onClick: function onClick(event) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	              args[_key - 1] = arguments[_key];
	            }
	
	            if (disabled) {
	              event.preventDefault();
	            } else if (adjustedOnClick) {
	              adjustedOnClick.apply(undefined, [event].concat(args));
	            }
	          } }),
	        first,
	        second
	      );
	    }
	  }]);
	
	  return Anchor;
	}(_react.Component);
	
	Anchor.displayName = 'Anchor';
	exports.default = Anchor;
	;
	
	(0, _reactDesc.schema)(Anchor, {
	  description: 'A text link. We have a separate component from the browser\n  base so we can style it. You can either set the icon and/or label properties\n  or just use children.',
	  usage: 'import Anchor from \'grommet/components/Anchor\';\n  <Anchor href={location} label="Label" />',
	  props: {
	    a11yTitle: [_reactDesc.PropTypes.string, 'Accessibility title.'],
	    align: [_reactDesc.PropTypes.oneOf(['start', 'center', 'end']), 'Text alignment.'],
	    animateIcon: [_reactDesc.PropTypes.bool, 'Whether to animate the icon on hover.', {
	      defaultProp: true
	    }],
	    disabled: [_reactDesc.PropTypes.bool, 'Whether to disable the anchor.'],
	    href: [_reactDesc.PropTypes.string, 'Hyperlink reference to place in the anchor. If' + ' `path` prop is provided, `href` prop will be ignored.'],
	    icon: [_reactDesc.PropTypes.element, 'Icon element to place in the anchor.'],
	    id: [_reactDesc.PropTypes.string, 'Anchor identifier.'],
	    label: [_reactDesc.PropTypes.node, 'Label text to place in the anchor.'],
	    method: [_reactDesc.PropTypes.oneOf(['push', 'replace']), 'Valid only when used with path. Indicates whether the browser history' + ' should be appended to or replaced.', {
	      defaultProp: 'push'
	    }],
	    onClick: [_reactDesc.PropTypes.func, 'Click handler.'],
	    path: [_reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.object, _reactDesc.PropTypes.string]), 'React-router path to navigate to when clicked.' + ' Use path={{ path: \'/\', index: true }} if you want the Anchor to be' + ' active only when the index route is current.'],
	    primary: [_reactDesc.PropTypes.bool, 'Whether this is a primary anchor.'],
	    reverse: [_reactDesc.PropTypes.bool, 'Whether an icon and label should be reversed so that the icon is at ' + 'the end of the anchor.'],
	    tag: [_reactDesc.PropTypes.string, 'The DOM tag to use for the element. The default is <a>. This should be' + ' used in conjunction with components like Link from React Router. In' + ' this case, Link controls the navigation while Anchor controls the' + ' styling.', {
	      defaultProp: 'a'
	    }],
	    target: [_reactDesc.PropTypes.string, 'Target of the link.']
	  }
	});
	
	Anchor.contextTypes = {
	  router: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames4 = __webpack_require__(6);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _SkipLinkAnchor = __webpack_require__(190);
	
	var _SkipLinkAnchor2 = _interopRequireDefault(_SkipLinkAnchor);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.FOOTER;
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props, context) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props, context));
	
	    _this._alignMirror = _this._alignMirror.bind(_this);
	    _this._onResize = _this._onResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(Footer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.fixed) {
	        this._alignMirror();
	        window.addEventListener('resize', this._onResize);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.fixed) {
	        this._alignMirror();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.fixed) {
	        window.removeEventListener('resize', this._onResize);
	      }
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      this._alignMirror();
	    }
	  }, {
	    key: '_alignMirror',
	    value: function _alignMirror() {
	      var contentElement = _reactDom2.default.findDOMNode(this.contentRef);
	      var mirrorElement = this.mirrorRef;
	
	      // constrain fixed content to the width of the mirror
	      var mirrorRect = mirrorElement.getBoundingClientRect();
	      contentElement.style.width = Math.floor(mirrorRect.width) + 'px';
	
	      // align the mirror height with the content's height
	      var contentRect = contentElement.getBoundingClientRect();
	      mirrorElement.style.height = Math.floor(contentRect.height) + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _classnames2,
	          _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          fixed = _props.fixed,
	          float = _props.float,
	          primary = _props.primary,
	          size = _props.size;
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Footer.propTypes));
	      var classes = (0, _classnames5.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size && typeof size === 'string'), _defineProperty(_classnames, CLASS_ROOT + '--float', float), _classnames), className);
	
	      var containerClasses = (0, _classnames5.default)(CLASS_ROOT + '__container', (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '__container--float', float), _defineProperty(_classnames2, CLASS_ROOT + '__container--fixed', fixed), _defineProperty(_classnames2, CLASS_ROOT + '__container--fill',
	      // add default color index if none is provided
	      fixed && !colorIndex), _classnames2));
	
	      var wrapperClasses = (0, _classnames5.default)(CLASS_ROOT + '__wrapper', _defineProperty({}, CLASS_ROOT + '__wrapper--' + size, size && typeof size === 'string'));
	
	      var footerSkipLink = void 0;
	      if (primary) {
	        footerSkipLink = _react2.default.createElement(_SkipLinkAnchor2.default, { label: 'Footer' });
	      }
	
	      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	      // don't transfer size to Box since it means something different
	      delete boxProps.size;
	
	      if (fixed) {
	        return _react2.default.createElement(
	          'div',
	          _extends({ className: containerClasses }, restProps),
	          _react2.default.createElement('div', { ref: function ref(_ref) {
	              return _this2.mirrorRef = _ref;
	            },
	            className: CLASS_ROOT + '__mirror' }),
	          _react2.default.createElement(
	            'div',
	            { className: wrapperClasses },
	            _react2.default.createElement(
	              _Box2.default,
	              _extends({ ref: function ref(_ref2) {
	                  return _this2.contentRef = _ref2;
	                }
	              }, boxProps, { tag: 'footer', className: classes,
	                primary: false }),
	              footerSkipLink,
	              children
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          _Box2.default,
	          _extends({}, restProps, boxProps, { tag: 'footer', className: classes,
	            containerClassName: containerClasses,
	            primary: false }),
	          footerSkipLink,
	          children
	        );
	      }
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	Footer.displayName = 'Footer';
	exports.default = Footer;
	
	
	Footer.propTypes = _extends({
	  fixed: _propTypes2.default.bool,
	  float: _propTypes2.default.bool,
	  primary: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
	}, _Box2.default.propTypes);
	
	Footer.defaultProps = {
	  align: 'center',
	  direction: 'row',
	  responsive: false
	};
	module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.HEADLINE;
	
	var Headline = function (_Component) {
	  _inherits(Headline, _Component);
	
	  function Headline() {
	    _classCallCheck(this, Headline);
	
	    return _possibleConstructorReturn(this, (Headline.__proto__ || Object.getPrototypeOf(Headline)).apply(this, arguments));
	  }
	
	  _createClass(Headline, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          margin = _props.margin,
	          size = _props.size,
	          strong = _props.strong,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'strong']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _classnames), className);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Headline;
	}(_react.Component);
	
	Headline.displayName = 'Headline';
	exports.default = Headline;
	
	
	Headline.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge']),
	  strong: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SIDEBAR;
	
	var Sidebar = function (_Component) {
	  _inherits(Sidebar, _Component);
	
	  function Sidebar() {
	    _classCallCheck(this, Sidebar);
	
	    return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
	  }
	
	  _createClass(Sidebar, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixed = _props.fixed,
	          full = _props.full,
	          size = _props.size,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'fixed', 'full', 'size']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--fixed', fixed), _defineProperty(_classnames, CLASS_ROOT + '--full', full), _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _classnames), className);
	
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, props, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(_react.Component);
	
	Sidebar.displayName = 'Sidebar';
	exports.default = Sidebar;
	
	
	Sidebar.propTypes = _extends({
	  fixed: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large']),
	  full: _propTypes2.default.bool
	}, _Box2.default.propTypes);
	
	Sidebar.defaultProps = {
	  direction: 'column',
	  full: true
	};
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Responsive = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SPLIT;
	
	var Split = function (_Component) {
	  _inherits(Split, _Component);
	
	  function Split(props, context) {
	    _classCallCheck(this, Split);
	
	    var _this = _possibleConstructorReturn(this, (Split.__proto__ || Object.getPrototypeOf(Split)).call(this, props, context));
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this._layout = _this._layout.bind(_this);
	
	    _this.state = { responsive: undefined };
	    return _this;
	  }
	
	  _createClass(Split, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this._onResize);
	      this._layout();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If we change the number of visible children, trigger a resize event
	      // so things like Table header can adjust. This will go away once
	      // CSS supports per element media queries.
	      // The 500ms delay is loosely tied to the CSS animation duration.
	      // We want any animations to finish before triggering the resize.
	      // TODO: consider using an animation end event instead of a timer.
	      if (this._nonNullChildCount(nextProps) !== this._nonNullChildCount(this.props)) {
	        clearTimeout(this._resizeTimer);
	        this._resizeTimer = setTimeout(function () {
	          var event = document.createEvent('HTMLEvents');
	          event.initEvent('resize', true, false);
	          window.dispatchEvent(event);
	        }, 500);
	      }
	      this.setState({ relayout: true });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.relayout) {
	        this.setState({ relayout: false });
	        this._layout();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this._onResize);
	    }
	
	    // Support function for componentWillReceiveProps()
	
	  }, {
	    key: '_nonNullChildCount',
	    value: function _nonNullChildCount(props) {
	      var result = 0;
	      _react2.default.Children.forEach(props.children, function (child) {
	        if (child) result += 1;
	      });
	      return result;
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      // debounce
	      clearTimeout(this._resizeTimer);
	      this._resizeTimer = setTimeout(this._layout, 50);
	    }
	  }, {
	    key: '_setResponsive',
	    value: function _setResponsive(responsive) {
	      if (this.state.responsive !== responsive) {
	        this.setState({ responsive: responsive });
	        if (this.props.onResponsive) {
	          this.props.onResponsive(responsive);
	        }
	      }
	    }
	  }, {
	    key: '_layout',
	    value: function _layout() {
	      var splitElement = this.splitRef;
	      if (splitElement) {
	        if (splitElement.offsetWidth <= (0, _Responsive.smallSize)() && this.props.showOnResponsive === 'priority') {
	          this._setResponsive('single');
	        } else {
	          this._setResponsive('multiple');
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixed = _props.fixed,
	          flex = _props.flex,
	          priority = _props.priority,
	          separator = _props.separator,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'fixed', 'flex', 'priority', 'separator']);
	
	      delete props.onResponsive;
	      delete props.showOnResponsive;
	      var responsive = this.state.responsive;
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, className);
	
	      var boxedChildren = !Array.isArray(children) ? children : children.map(function (child, index) {
	        var _classnames;
	
	        if (!child) {
	          // skip the empty children but keep original index
	          // this avoid the right element to remount
	          return undefined;
	        }
	        var lastChild = index === children.length - 1;
	        var hidden = void 0;
	        var childFlex = true;
	        // When we only have room to show one child, hide the appropriate one
	        if ('single' === responsive && ('left' === priority && index > 0 || 'right' === priority && index === 0 && children.length > 1)) {
	          hidden = true;
	        } else if (children.length > 1 && (flex === 'right' && index === 0 || flex === 'left' && lastChild)) {
	          childFlex = false;
	        } else {
	          childFlex = true;
	        }
	        var classes = (0, _classnames3.default)(CLASS_ROOT + '__column', (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__column--fixed', fixed), _defineProperty(_classnames, CLASS_ROOT + '__column--hidden', hidden), _defineProperty(_classnames, CLASS_ROOT + '__column--flex', childFlex), _defineProperty(_classnames, CLASS_ROOT + '__column--separator', separator && !lastChild), _classnames));
	        // Don't use a Box here because we don't want to constrain the child
	        // in a flexbox container.
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: classes },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ ref: function ref(_ref) {
	            return _this2.splitRef = _ref;
	          } }, props, { className: classes }),
	        boxedChildren
	      );
	    }
	  }]);
	
	  return Split;
	}(_react.Component);
	
	Split.displayName = 'Split';
	exports.default = Split;
	
	
	Split.propTypes = {
	  children: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
	  fixed: _propTypes2.default.bool,
	  flex: _propTypes2.default.oneOf(['left', 'right', 'both']),
	  onResponsive: _propTypes2.default.func,
	  priority: _propTypes2.default.oneOf(['left', 'right']),
	  separator: _propTypes2.default.bool,
	  showOnResponsive: _propTypes2.default.oneOf(['priority', 'both'])
	};
	
	Split.defaultProps = {
	  fixed: true,
	  flex: 'both',
	  priority: 'right',
	  showOnResponsive: 'priority'
	};
	module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-caret-back', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'caret-back');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 2 18 12 6 22', transform: 'matrix(-1 0 0 1 24 0)' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'CaretBack';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(60);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(57);
	
	var _Actions = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(142);
	var setInnerHTML = __webpack_require__(111);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(150);
	var setTextContent = __webpack_require__(380);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(628);
	var ReactInstrumentation = __webpack_require__(36);
	
	var warning = __webpack_require__(15);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(60);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(99);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineSeries = function (_Component) {
		_inherits(LineSeries, _Component);
	
		function LineSeries(props) {
			_classCallCheck(this, LineSeries);
	
			var _this = _possibleConstructorReturn(this, (LineSeries.__proto__ || Object.getPrototypeOf(LineSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			_this.isHover = _this.isHover.bind(_this);
			return _this;
		}
	
		_createClass(LineSeries, [{
			key: "isHover",
			value: function isHover(moreProps) {
				// console.log("HERE")
				var _props = this.props,
				    highlightOnHover = _props.highlightOnHover,
				    yAccessor = _props.yAccessor,
				    hoverTolerance = _props.hoverTolerance;
	
	
				if (!highlightOnHover) return false;
	
				var mouseXY = moreProps.mouseXY,
				    currentItem = moreProps.currentItem,
				    xScale = moreProps.xScale,
				    plotData = moreProps.plotData;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    yScale = _moreProps$chartConfi.yScale,
				    origin = _moreProps$chartConfi.origin;
				var xAccessor = moreProps.xAccessor;
	
				var _mouseXY = _slicedToArray(mouseXY, 2),
				    x = _mouseXY[0],
				    y = _mouseXY[1];
	
				var radius = hoverTolerance;
	
				var _getClosestItemIndexe = (0, _utils.getClosestItemIndexes)(plotData, xScale.invert(x), xAccessor),
				    left = _getClosestItemIndexe.left,
				    right = _getClosestItemIndexe.right;
	
				if (left === right) {
					var cy = yScale(yAccessor(currentItem)) + origin[1];
					var cx = xScale(xAccessor(currentItem)) + origin[0];
	
					var hovering1 = Math.pow(x - cx, 2) + Math.pow(y - cy, 2) < Math.pow(radius, 2);
	
					return hovering1;
				} else {
					var l = plotData[left];
					var r = plotData[right];
					var x1 = xScale(xAccessor(l)) + origin[0];
					var y1 = yScale(yAccessor(l)) + origin[1];
					var x2 = xScale(xAccessor(r)) + origin[0];
					var y2 = yScale(yAccessor(r)) + origin[1];
	
					// y = m * x + b
					var m /* slope */ = (y2 - y1) / (x2 - x1);
					var b /* y intercept */ = -1 * m * x1 + y1;
	
					var desiredY = Math.round(m * x + b);
	
					var hovering2 = y >= desiredY - radius && y <= desiredY + radius;
	
					return hovering2;
				}
			}
		}, {
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var _props2 = this.props,
				    yAccessor = _props2.yAccessor,
				    stroke = _props2.stroke,
				    strokeOpacity = _props2.strokeOpacity,
				    strokeWidth = _props2.strokeWidth,
				    hoverStrokeWidth = _props2.hoverStrokeWidth,
				    defined = _props2.defined,
				    strokeDasharray = _props2.strokeDasharray,
				    interpolation = _props2.interpolation,
				    canvasClip = _props2.canvasClip;
				var connectNulls = this.props.connectNulls;
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData,
				    hovering = moreProps.hovering;
	
	
				if (canvasClip) {
					ctx.save();
					canvasClip(ctx, moreProps);
				}
	
				ctx.lineWidth = hovering ? hoverStrokeWidth : strokeWidth;
	
				ctx.strokeStyle = (0, _utils.hexToRGBA)(stroke, strokeOpacity);
				ctx.setLineDash((0, _utils.getStrokeDasharray)(strokeDasharray).split(","));
	
				var dataSeries = (0, _d3Shape.line)().x(function (d) {
					return Math.round(xScale(xAccessor(d)));
				}).y(function (d) {
					return Math.round(yScale(yAccessor(d)));
				});
	
				if ((0, _utils.isDefined)(interpolation)) {
					dataSeries.curve(interpolation);
				}
				if (!connectNulls) {
					dataSeries.defined(function (d) {
						return defined(yAccessor(d));
					});
				}
	
				ctx.beginPath();
				dataSeries.context(ctx)(plotData);
				ctx.stroke();
	
				if (canvasClip) {
					ctx.restore();
				}
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props3 = this.props,
				    yAccessor = _props3.yAccessor,
				    stroke = _props3.stroke,
				    strokeOpacity = _props3.strokeOpacity,
				    strokeWidth = _props3.strokeWidth,
				    hoverStrokeWidth = _props3.hoverStrokeWidth,
				    defined = _props3.defined,
				    strokeDasharray = _props3.strokeDasharray;
				var connectNulls = this.props.connectNulls;
				var _props4 = this.props,
				    interpolation = _props4.interpolation,
				    style = _props4.style;
				var xAccessor = moreProps.xAccessor,
				    chartConfig = moreProps.chartConfig;
				var xScale = moreProps.xScale,
				    plotData = moreProps.plotData,
				    hovering = moreProps.hovering;
				var yScale = chartConfig.yScale;
	
				var dataSeries = (0, _d3Shape.line)().x(function (d) {
					return Math.round(xScale(xAccessor(d)));
				}).y(function (d) {
					return Math.round(yScale(yAccessor(d)));
				});
	
				if ((0, _utils.isDefined)(interpolation)) {
					dataSeries.curve(interpolation);
				}
				if (!connectNulls) {
					dataSeries.defined(function (d) {
						return defined(yAccessor(d));
					});
				}
				var d = dataSeries(plotData);
	
				var _props5 = this.props,
				    fill = _props5.fill,
				    className = _props5.className;
	
	
				return _react2.default.createElement("path", {
					style: style,
					className: className + " " + (stroke ? "" : " line-stroke"),
					d: d,
					stroke: stroke,
					strokeOpacity: strokeOpacity,
					strokeWidth: hovering ? hoverStrokeWidth : strokeWidth,
					strokeDasharray: (0, _utils.getStrokeDasharray)(strokeDasharray),
					fill: fill
				});
			}
		}, {
			key: "render",
			value: function render() {
				var _props6 = this.props,
				    highlightOnHover = _props6.highlightOnHover,
				    onHover = _props6.onHover,
				    onUnHover = _props6.onUnHover;
	
				var hoverProps = highlightOnHover || onHover || onUnHover ? {
					isHover: this.isHover,
					drawOn: ["mousemove", "pan"],
					canvasToDraw: _GenericComponent.getMouseCanvas
				} : {
					drawOn: ["pan"],
					canvasToDraw: _GenericComponent.getAxisCanvas
				};
	
				return _react2.default.createElement(_GenericChartComponent2.default, _extends({
					svgDraw: this.renderSVG,
	
					canvasDraw: this.drawOnCanvas,
	
					onClickWhenHover: this.props.onClick,
					onDoubleClickWhenHover: this.props.onDoubleClick,
					onContextMenuWhenHover: this.props.onContextMenu,
					onHover: this.props.onHover,
					onUnHover: this.props.onUnHover
				}, hoverProps));
			}
		}]);
	
		return LineSeries;
	}(_react.Component);
	
	/*
	function segment(points, ctx) {
		ctx.beginPath();
	
		const [x, y] = first(points);
		ctx.moveTo(x, y);
		for (let i = 1; i < points.length; i++) {
			const [x1, y1] = points[i];
			ctx.lineTo(x1, y1);
		}
	
		ctx.stroke();
	}
	*/
	
	LineSeries.propTypes = {
		className: _propTypes2.default.string,
		strokeWidth: _propTypes2.default.number,
		strokeOpacity: _propTypes2.default.number,
		stroke: _propTypes2.default.string,
		hoverStrokeWidth: _propTypes2.default.number,
		fill: _propTypes2.default.string,
		defined: _propTypes2.default.func,
		hoverTolerance: _propTypes2.default.number,
		strokeDasharray: _propTypes2.default.oneOf(_utils.strokeDashTypes),
		highlightOnHover: _propTypes2.default.bool,
		onClick: _propTypes2.default.func,
		onDoubleClick: _propTypes2.default.func,
		onHover: _propTypes2.default.func,
		onUnHover: _propTypes2.default.func,
		onContextMenu: _propTypes2.default.func,
		yAccessor: _propTypes2.default.func,
		connectNulls: _propTypes2.default.bool,
		interpolation: _propTypes2.default.func,
		canvasClip: _propTypes2.default.func,
		style: _propTypes2.default.object
	};
	
	LineSeries.defaultProps = {
		className: "line ",
		strokeWidth: 1,
		strokeOpacity: 1,
		hoverStrokeWidth: 4,
		fill: "none",
		stroke: "#4682B4",
		strokeDasharray: "Solid",
		defined: function defined(d) {
			return !isNaN(d);
		},
		hoverTolerance: 6,
		highlightOnHover: false,
		connectNulls: false,
		onClick: function onClick(e) {
			console.log("Click", e);
		},
		onDoubleClick: function onDoubleClick(e) {
			console.log("Double Click", e);
		},
		onContextMenu: function onContextMenu(e) {
			console.log("Right Click", e);
		}
	};
	
	exports.default = LineSeries;
	//# sourceMappingURL=LineSeries.js.map

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactBaseClasses = __webpack_require__(408);
	var ReactChildren = __webpack_require__(796);
	var ReactDOMFactories = __webpack_require__(797);
	var ReactElement = __webpack_require__(80);
	var ReactPropTypes = __webpack_require__(798);
	var ReactVersion = __webpack_require__(799);
	
	var createReactClass = __webpack_require__(800);
	var onlyChild = __webpack_require__(804);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(51);
	
	var warning = __webpack_require__(15);
	var canDefineProperty = __webpack_require__(412);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(410);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PASSWORD_RESET_STATUS = exports.DISPLAY_PASSWORD_RESET_DAILOG = exports.INITIALIZE_STRIPE = exports.REGISTRATION_STATUS = exports.SAVE_USER_DATA = exports.SAVE_USERPROFILE = exports.SESSION_RESET_PASSWORD_FAILURE = exports.SESSION_RESET_PASSWORD_SUCCESS = exports.SESSION_RESET_PASSWORD = exports.SESSION_LOGOUT = exports.SESSION_LOGIN_FAILURE = exports.SESSION_LOGIN_SUCCESS = exports.SESSION_LOGIN = exports.SESSION_INIT = undefined;
	exports.sessionInitialize = sessionInitialize;
	exports.sessionLogin = sessionLogin;
	exports.initialGetUserProfile = initialGetUserProfile;
	exports.sessionLoginSuccess = sessionLoginSuccess;
	exports.sessionLoginFailure = sessionLoginFailure;
	exports.sessionResetPassword = sessionResetPassword;
	exports.sessionResetPasswordSuccess = sessionResetPasswordSuccess;
	exports.sessionResetPasswordFailure = sessionResetPasswordFailure;
	exports.sessionLogout = sessionLogout;
	exports.saveUserData = saveUserData;
	exports.registerUser = registerUser;
	exports.getStripeAPIKey = getStripeAPIKey;
	exports.displayPasswordResetDialog = displayPasswordResetDialog;
	exports.requestPasswordReset = requestPasswordReset;
	
	var _reactRouter = __webpack_require__(43);
	
	var _Api = __webpack_require__(52);
	
	var _status = __webpack_require__(65);
	
	var _route = __webpack_require__(115);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SESSION_INIT = exports.SESSION_INIT = 'SESSION_INIT'; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var SESSION_LOGIN = exports.SESSION_LOGIN = 'SESSION_LOGIN';
	var SESSION_LOGIN_SUCCESS = exports.SESSION_LOGIN_SUCCESS = 'SESSION_LOGIN_SUCCESS';
	var SESSION_LOGIN_FAILURE = exports.SESSION_LOGIN_FAILURE = 'SESSION_LOGIN_FAILURE';
	var SESSION_LOGOUT = exports.SESSION_LOGOUT = 'SESSION_LOGOUT';
	var SESSION_RESET_PASSWORD = exports.SESSION_RESET_PASSWORD = 'SESSION_RESET_PASSWORD';
	var SESSION_RESET_PASSWORD_SUCCESS = exports.SESSION_RESET_PASSWORD_SUCCESS = 'SESSION_RESET_PASSWORD_SUCCESS';
	var SESSION_RESET_PASSWORD_FAILURE = exports.SESSION_RESET_PASSWORD_FAILURE = 'SESSION_RESET_PASSWORD_FAILURE';
	var SAVE_USERPROFILE = exports.SAVE_USERPROFILE = 'SAVE_USERPROFILE';
	var SAVE_USER_DATA = exports.SAVE_USER_DATA = 'SAVE_USER_DATA';
	var REGISTRATION_STATUS = exports.REGISTRATION_STATUS = 'REGISTRATION_STATUS';
	var INITIALIZE_STRIPE = exports.INITIALIZE_STRIPE = 'INITIALIZE_STRIPE';
	var DISPLAY_PASSWORD_RESET_DAILOG = exports.DISPLAY_PASSWORD_RESET_DAILOG = 'DISPLAY_PASSWORD_RESET_DAILOG';
	var PASSWORD_RESET_STATUS = exports.PASSWORD_RESET_STATUS = 'PASSWORD_RESET_STATUS';
	
	var localStorage = window.localStorage;
	function sessionInitialize() {
	  if (localStorage.token && localStorage.userId) {
	    (0, _Api.updateHeaders)({ 'Authorization': localStorage.token });
	    initialGetUserProfile(localStorage.userId);
	  } else if (location.pathname.split('/')[1] === _Constants2.default.ROUTES.SIGNUP) {
	    _reactRouter.browserHistory.push(_Constants2.default.ROUTES.SIGNUP);
	  } else {
	    _reactRouter.browserHistory.push(_Constants2.default.ROUTES.LOGIN);
	  }
	}
	
	function sessionLogin(host, userName, password) {
	  var token = void 0;
	  return function (dispatch) {
	    dispatch({ type: SESSION_LOGIN, host: host, userName: userName });
	    (0, _Api.configure)({ host: host });
	    // history.push(constants.ROUTES.DASHBOARD)
	    (0, _Api.postLogin)(userName, password).then(function (response) {
	      if (response && response.success) {
	        token = response.data.sessionToken;
	        (0, _Api.updateHeaders)({ 'Authorization': token });
	        try {
	          localStorage.userName = response.data.username;
	          localStorage.token = token;
	          localStorage.userId = response.data.id;
	          localStorage.removeItem('logoutAt');
	        } catch (e) {
	          alert("Unable to preserve session, probably due to being in private" + "browsing mode.");
	        }
	        window.location.href = '/' + _Constants2.default.ROUTES.SITEVIEW;
	        // history.replace(constants.ROUTES.DASHBOARD);
	        initialGetUserProfile(response.data.id);
	      } else {
	        alert('Unauthorised user!');
	      }
	    }).catch(function (error) {
	      return dispatch(sessionLoginFailure(error));
	    });
	  };
	}
	function initialGetUserProfile(userId) {
	  (0, _Api.getUserProfile)(userId).then(function (response) {
	    // alert(response.data.profileImage)
	    window.store.dispatch({ type: SAVE_USERPROFILE, result: response.data });
	  }).catch(function (error) {
	    // console.log('error::', error)
	  });
	}
	function sessionLoginSuccess(host, userName, token, role, needPasswordReset) {
	  return {
	    type: SESSION_LOGIN_SUCCESS, host: host, userName: userName, token: token,
	    role: role, needPasswordReset: needPasswordReset
	  };
	}
	
	function sessionLoginFailure(error) {
	  // console.log('sessionLoginFailure:', sessionLoginFailure)
	  return { type: SESSION_LOGIN_FAILURE, error: error };
	}
	
	function sessionResetPassword(userName, password) {
	  return function (dispatch) {
	    dispatch({ type: SESSION_RESET_PASSWORD, userName: userName });
	    (0, _Api.postResetPassword)(userName, password).then(function () {
	      return dispatch(sessionResetPasswordSuccess());
	    }).catch(function (error) {
	      return dispatch(sessionResetPasswordFailure(error));
	    });
	  };
	}
	
	function sessionResetPasswordSuccess() {
	  return { type: SESSION_RESET_PASSWORD_SUCCESS, passwordReset: true };
	}
	
	function sessionResetPasswordFailure(error) {
	  return { type: SESSION_RESET_PASSWORD_FAILURE, error: error };
	}
	
	function sessionLogout() {
	  return function (dispatch) {
	    try {
	      sessionStorage.clear();
	      localStorage.removeItem('userName');
	      localStorage.removeItem('token');
	      localStorage.removeItem('userId');
	      // localStorage.logoutAt = (new Date()).toISOString();
	    } catch (e) {
	      // ignore
	    }
	    dispatch({ type: SESSION_LOGOUT });
	    (0, _Api.postLogout)().then(function () {
	      // alert('pp')
	      window.location.href = '/login';
	      // setTimeout(function () {
	      //    window.location.reload(true);
	      // }, 2000);
	    });
	    // dispatch(ignoreMasterRoute());
	
	  };
	}
	
	function saveUserData(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: SAVE_USER_DATA,
	      result: payload
	    });
	  };
	}
	
	function registerUser(data, userName, password) {
	  var result = void 0;
	  return function (dispatch) {
	    (0, _Api.register)(data).then(function (response) {
	
	      if (response && response.success) {
	        result = {
	          status: response.success,
	          message: "success"
	        };
	        dispatch({
	          type: REGISTRATION_STATUS,
	          result: result
	        });
	
	        (0, _Api.postLogin)(userName, password).then(function (response) {
	          if (response && response.success) {
	            var token = response.data.sessionToken;
	            (0, _Api.updateHeaders)({ 'Authorization': token });
	            try {
	              localStorage.userName = response.data.username;
	              localStorage.token = token;
	              localStorage.userId = response.data.id;
	              localStorage.removeItem('logoutAt');
	            } catch (e) {
	              alert("Unable to preserve session, probably due to being in private" + "browsing mode.");
	            }
	            window.location.href = '/' + _Constants2.default.ROUTES.SITEVIEW;
	            // history.replace(constants.ROUTES.DASHBOARD);
	            initialGetUserProfile(response.data.id);
	          } else {
	            alert('Unauthorised user!');
	          }
	        }).catch(function (error) {
	          return dispatch(sessionLoginFailure(error));
	        });
	      } else if (response && response.success === false) {
	        result = {
	          status: response.success,
	          message: response.error
	        };
	        dispatch({
	          type: REGISTRATION_STATUS,
	          result: result
	        });
	      }
	    }).catch(function (error) {
	      if (error) {
	        result = {
	          status: null,
	          message: error
	        };
	        dispatch({
	          type: REGISTRATION_STATUS,
	          result: result
	        });
	      }
	    });
	  };
	}
	
	function getStripeAPIKey() {
	  return function (dispatch) {
	    (0, _Api.initializeStripe)().then(function (response) {
	      dispatch({
	        type: INITIALIZE_STRIPE,
	        result: response
	      });
	    });
	  };
	}
	
	function displayPasswordResetDialog(value) {
	  return function (dispatch) {
	    dispatch({
	      type: DISPLAY_PASSWORD_RESET_DAILOG,
	      result: value
	    });
	    dispatch({
	      type: PASSWORD_RESET_STATUS,
	      result: ''
	    });
	  };
	}
	
	function requestPasswordReset(email) {
	  return function (dispatch) {
	    (0, _Api.resetPassword)(email).then(function (response) {
	      if (response && response.message) {
	        dispatch({
	          type: PASSWORD_RESET_STATUS,
	          result: response && response.message ? response.message : ''
	        });
	      } else {
	        dispatch({
	          type: PASSWORD_RESET_STATUS,
	          result: 'An error occurred when requesting for password reset. Please try again'
	        });
	      }
	    }).catch(function (error) {
	      dispatch({
	        type: PASSWORD_RESET_STATUS,
	        result: error && error.message ? error.message : ''
	      });
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SESSION_INIT, 'SESSION_INIT', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SESSION_LOGIN, 'SESSION_LOGIN', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SESSION_LOGIN_SUCCESS, 'SESSION_LOGIN_SUCCESS', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SESSION_LOGIN_FAILURE, 'SESSION_LOGIN_FAILURE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SESSION_LOGOUT, 'SESSION_LOGOUT', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SESSION_RESET_PASSWORD, 'SESSION_RESET_PASSWORD', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SESSION_RESET_PASSWORD_SUCCESS, 'SESSION_RESET_PASSWORD_SUCCESS', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SESSION_RESET_PASSWORD_FAILURE, 'SESSION_RESET_PASSWORD_FAILURE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_USERPROFILE, 'SAVE_USERPROFILE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_USER_DATA, 'SAVE_USER_DATA', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(REGISTRATION_STATUS, 'REGISTRATION_STATUS', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_STRIPE, 'INITIALIZE_STRIPE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(DISPLAY_PASSWORD_RESET_DAILOG, 'DISPLAY_PASSWORD_RESET_DAILOG', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(PASSWORD_RESET_STATUS, 'PASSWORD_RESET_STATUS', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(localStorage, 'localStorage', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionInitialize, 'sessionInitialize', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionLogin, 'sessionLogin', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(initialGetUserProfile, 'initialGetUserProfile', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionLoginSuccess, 'sessionLoginSuccess', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionLoginFailure, 'sessionLoginFailure', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionResetPassword, 'sessionResetPassword', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionResetPasswordSuccess, 'sessionResetPasswordSuccess', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionResetPasswordFailure, 'sessionResetPasswordFailure', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionLogout, 'sessionLogout', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(saveUserData, 'saveUserData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(registerUser, 'registerUser', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(getStripeAPIKey, 'getStripeAPIKey', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(displayPasswordResetDialog, 'displayPasswordResetDialog', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	
	  __REACT_HOT_LOADER__.register(requestPasswordReset, 'requestPasswordReset', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/session.js');
	}();

	;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(21), __webpack_require__(38), __webpack_require__(175), __webpack_require__(33), __webpack_require__(178), __webpack_require__(100), __webpack_require__(174)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.PARAGRAPH;
	
	var Paragraph = function (_Component) {
	  _inherits(Paragraph, _Component);
	
	  function Paragraph() {
	    _classCallCheck(this, Paragraph);
	
	    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
	  }
	
	  _createClass(Paragraph, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          margin = _props.margin,
	          size = _props.size,
	          width = _props.width,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'width']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--width-' + width, width), _classnames), className);
	
	      return _react2.default.createElement(
	        'p',
	        _extends({}, props, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Paragraph;
	}(_react.Component);
	
	Paragraph.displayName = 'Paragraph';
	exports.default = Paragraph;
	
	
	Paragraph.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge']),
	  width: _propTypes2.default.oneOf(['small', 'medium', 'large'])
	};
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.TILE;
	var NAMESPACE = _CSSClassnames2.default.NAMESPACE;
	
	var Tile = function (_Component) {
	  _inherits(Tile, _Component);
	
	  function Tile() {
	    _classCallCheck(this, Tile);
	
	    return _possibleConstructorReturn(this, (Tile.__proto__ || Object.getPrototypeOf(Tile)).apply(this, arguments));
	  }
	
	  _createClass(Tile, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onClick = _props.onClick,
	          wide = _props.wide,
	          status = _props.status,
	          hoverStyle = _props.hoverStyle,
	          hoverColorIndex = _props.hoverColorIndex,
	          hoverBorder = _props.hoverBorder,
	          hoverBorderSize = _props.hoverBorderSize,
	          selected = _props.selected;
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Tile.propTypes));
	
	      var statusClass = status ? status.toLowerCase() : undefined;
	      // if Tiles flush is true, default borderSize to small (1px)
	      var borderSize = hoverBorder ? hoverBorderSize ? hoverBorderSize : 'large' : 'small';
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--status-' + statusClass, status), _defineProperty(_classnames, CLASS_ROOT + '--selected', selected), _defineProperty(_classnames, CLASS_ROOT + '--wide', wide), _defineProperty(_classnames, CLASS_ROOT + '--selectable', onClick), _defineProperty(_classnames, '' + NAMESPACE + hoverStyle + (hoverStyle == 'border' ? borderSize ? '-' + borderSize : '-medium' : '') + '-hover-color-index-' + hoverColorIndex, hoverStyle), _defineProperty(_classnames, CLASS_ROOT + '--hover-border-' + borderSize, borderSize), _classnames));
	
	      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, restProps, boxProps, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Tile;
	}(_react.Component);
	
	// add a strong and more reliable link between Tiles and Tile
	
	
	Tile.displayName = 'Tile';
	exports.default = Tile;
	Tile._tile = true;
	
	Tile.propTypes = _extends({
	  hoverStyle: _propTypes2.default.oneOf(['border', 'background', 'none']),
	  hoverColorIndex: _propTypes2.default.string,
	  hoverBorder: _propTypes2.default.bool,
	  hoverBorderSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  selected: _propTypes2.default.bool,
	  wide: _propTypes2.default.bool }, _Box2.default.propTypes);
	
	Tile.defaultProps = {
	  pad: 'none',
	  direction: 'column',
	  align: 'center',
	  hoverStyle: 'none',
	  hoverColorIndex: 'disabled'
	};
	module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dropAlignPropType = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _DOM = __webpack_require__(47);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.DROP;
	var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;
	
	/*
	 * Drop is a utility for rendering components like drop down menus layered above
	 * their initiating controls.
	 */
	
	var VERTICAL_ALIGN_OPTIONS = ['top', 'bottom'];
	var HORIZONTAL_ALIGN_OPTIONS = ['right', 'left'];
	
	var DropContents = function (_Component) {
	  _inherits(DropContents, _Component);
	
	  function DropContents(props, context) {
	    _classCallCheck(this, DropContents);
	
	    var _this = _possibleConstructorReturn(this, (DropContents.__proto__ || Object.getPrototypeOf(DropContents)).call(this, props, context));
	
	    _this._processTab = _this._processTab.bind(_this);
	    return _this;
	  }
	
	  _createClass(DropContents, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var context = this.props.context;
	
	      return _extends({}, context);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var focusControl = this.props.focusControl;
	
	      if (focusControl) {
	        this._keyboardHandlers = {
	          tab: this._processTab
	        };
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var focusControl = this.props.focusControl;
	
	      if (focusControl) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: '_processTab',
	    value: function _processTab(event) {
	      var items = this._containerRef.getElementsByTagName('*');
	      items = (0, _DOM.filterByFocusable)(items);
	      if (!items || items.length === 0) {
	        event.preventDefault();
	      } else {
	        if (event.shiftKey) {
	          if (event.target === items[0]) {
	            items[items.length - 1].focus();
	            event.preventDefault();
	          }
	        } else if (event.target === items[items.length - 1]) {
	          items[0].focus();
	          event.preventDefault();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          content = _props.content,
	          focusControl = _props.focusControl;
	
	
	      var anchorStep = void 0;
	      if (focusControl) {
	        anchorStep = _react2.default.createElement('a', { tabIndex: '-1', 'aria-hidden': 'true',
	          className: CLASS_ROOT + '__anchor' });
	      }
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(_ref) {
	            return _this2._containerRef = _ref;
	          } },
	        anchorStep,
	        content
	      );
	    }
	  }]);
	
	  return DropContents;
	}(_react.Component);
	
	DropContents.displayName = 'DropContents';
	
	
	DropContents.propTypes = {
	  content: _propTypes2.default.node.isRequired,
	  context: _propTypes2.default.any,
	  focusControl: _propTypes2.default.bool
	};
	
	DropContents.childContextTypes = {
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  onDropChange: _propTypes2.default.func,
	  router: _propTypes2.default.any,
	  store: _propTypes2.default.object
	};
	
	var _normalizeOptions = function _normalizeOptions(options) {
	  var opts = _extends({}, options);
	  // normalize for older interface that just had align content
	  if (options.top || options.bottom || options.left || options.right) {
	    opts = { align: _extends({}, options) };
	  }
	  // validate align
	  if (options && options.align && options.align.top && VERTICAL_ALIGN_OPTIONS.indexOf(options.align.top) === -1) {
	    console.warn("Warning: Invalid align.top value '" + options.align.top + "' supplied to Drop," + "expected one of [" + VERTICAL_ALIGN_OPTIONS.join(',') + "]");
	  }
	  if (options.align && options.align.bottom && VERTICAL_ALIGN_OPTIONS.indexOf(options.align.bottom) === -1) {
	    console.warn("Warning: Invalid align.bottom value '" + options.align.bottom + "' supplied to Drop," + "expected one of [" + VERTICAL_ALIGN_OPTIONS.join(',') + "]");
	  }
	  if (options.align && options.align.left && HORIZONTAL_ALIGN_OPTIONS.indexOf(options.align.left) === -1) {
	    console.warn("Warning: Invalid align.left value '" + options.align.left + "' supplied to Drop," + "expected one of [" + HORIZONTAL_ALIGN_OPTIONS.join(',') + "]");
	  }
	  if (options.align && options.align.right && HORIZONTAL_ALIGN_OPTIONS.indexOf(options.align.right) === -1) {
	    console.warn("Warning: Invalid align.right value '" + options.align.right + "' supplied to Drop," + "expected one of [" + HORIZONTAL_ALIGN_OPTIONS.join(',') + "]");
	  }
	  opts.align = _extends({}, opts.align) || {};
	  if (!options.align.top && !options.align.bottom) {
	    opts.align.top = "top";
	  }
	  if (!options.align.left && !options.align.right) {
	    opts.align.left = "left";
	  }
	  opts.responsive = options.responsive !== false ? true : options.responsive;
	  return opts;
	};
	
	// Drop options:
	//
	// align: See dropAlignPropType
	// className: PropTypes.string
	// colorIndex: PropTypes.string
	//    Background color
	// context: PropTypes.object
	//    React context to pass through
	// focusControl: PropTypes.bool
	//    Whether to focus inside the dropped content when added
	// responsive: PropTypes.bool
	//    Whether to dynamically re-place when resized
	//
	
	var Drop = function () {
	  function Drop(control, content, opts) {
	    var _classnames,
	        _this3 = this;
	
	    _classCallCheck(this, Drop);
	
	    var options = _normalizeOptions(opts);
	    var context = options.context,
	        focusControl = options.focusControl;
	
	    // bind functions to instance
	
	    this.render = this.render.bind(this);
	    this.remove = this.remove.bind(this);
	    this.place = this.place.bind(this);
	    this._onResize = this._onResize.bind(this);
	    this._control = control;
	
	    // setup DOM
	    var container = document.createElement('div');
	    container.className = (0, _classnames3.default)('grommet', CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, options.className, options.className), _defineProperty(_classnames, BACKGROUND_COLOR_INDEX + '-' + options.colorIndex, options.colorIndex), _classnames));
	
	    if (opts.dropContainer) {
	      opts.dropContainer.appendChild(container);
	      this.parentContainer = opts.dropContainer;
	    } else {
	      // prepend in body to avoid browser scroll issues
	      document.body.insertBefore(container, document.body.firstChild);
	      this.parentContainer = document.body;
	    }
	
	    var scrollParents = (0, _DOM.findScrollParents)(control);
	
	    // initialize state
	    this.state = {
	      container: container, control: control, initialFocusNeeded: focusControl, options: options,
	      scrollParents: scrollParents
	    };
	
	    (0, _reactDom.render)(_react2.default.createElement(DropContents, { content: content, context: context,
	      focusControl: focusControl }), container, function () {
	      return _this3.place();
	    });
	
	    this._listen();
	  }
	
	  _createClass(Drop, [{
	    key: '_listen',
	    value: function _listen() {
	      var _this4 = this;
	
	      var scrollParents = this.state.scrollParents;
	
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.addEventListener('scroll', _this4.place);
	      });
	      // we intentionally skipped debounce as we believe resizing
	      // will not be a common action. Also the UI looks better if the Drop
	      // doesn’t lag to align with the control component.
	      window.addEventListener('resize', this._onResize);
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      var _this5 = this;
	
	      var scrollParents = this.state.scrollParents;
	      // we need to update scroll parents as Responsive options may change
	      // the parent for the target element
	
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.removeEventListener('scroll', _this5.place);
	      });
	
	      var nextScrollParents = (0, _DOM.findScrollParents)(this._control);
	
	      nextScrollParents.forEach(function (scrollParent) {
	        scrollParent.addEventListener('scroll', _this5.place);
	      });
	
	      this.state.scrollParents = nextScrollParents;
	
	      this.place();
	    }
	  }, {
	    key: 'place',
	    value: function place() {
	      var _state = this.state,
	          control = _state.control,
	          container = _state.container,
	          initialFocusNeeded = _state.initialFocusNeeded,
	          _state$options = _state.options,
	          align = _state$options.align,
	          responsive = _state$options.responsive;
	
	      var windowWidth = window.innerWidth;
	      var windowHeight = window.innerHeight;
	
	      // clear prior styling
	      container.style.left = '';
	      container.style.width = '';
	      container.style.top = '';
	      container.style.maxHeight = '';
	
	      // get bounds
	      var controlRect = (0, _DOM.findVisibleParent)(control).getBoundingClientRect();
	      var containerRect = container.getBoundingClientRect();
	
	      // determine width
	      var width = Math.min(Math.max(controlRect.width, containerRect.width), windowWidth);
	
	      // set left position
	      var left = void 0;
	      if (align.left) {
	        if ('left' === align.left) {
	          left = controlRect.left;
	        } else if ('right' === align.left) {
	          left = controlRect.left - width;
	        }
	      } else if (align.right) {
	        if ('left' === align.right) {
	          left = controlRect.left - width;
	        } else if ('right' === align.right) {
	          left = controlRect.left + controlRect.width - width;
	        }
	      }
	
	      if (left + width > windowWidth) {
	        left -= left + width - windowWidth;
	      } else if (left < 0) {
	        left = 0;
	      }
	
	      // set top position
	      var top = void 0,
	          maxHeight = void 0;
	      if (align.top) {
	        if ('top' === align.top) {
	          top = controlRect.top;
	          maxHeight = Math.min(windowHeight - controlRect.top, windowHeight);
	        } else {
	          top = controlRect.bottom;
	          maxHeight = Math.min(windowHeight - controlRect.bottom, windowHeight - controlRect.height);
	        }
	      } else if (align.bottom) {
	        if ('bottom' === align.bottom) {
	          top = controlRect.bottom - containerRect.height;
	          maxHeight = Math.max(controlRect.bottom, 0);
	        } else {
	          top = controlRect.top - containerRect.height;
	          maxHeight = Math.max(controlRect.top, 0);
	        }
	      }
	
	      // if we can't fit it all, see if there's more room the other direction
	      if (containerRect.height > maxHeight) {
	        // We need more room than we have.
	        if (align.top && top > windowHeight / 2) {
	          // We put it below, but there's more room above, put it above
	          if (align.top === 'bottom') {
	            if (responsive) {
	              top = Math.max(controlRect.top - containerRect.height, 0);
	            }
	            maxHeight = controlRect.top;
	          } else {
	            if (responsive) {
	              top = Math.max(controlRect.bottom - containerRect.height, 0);
	            }
	            maxHeight = controlRect.bottom;
	          }
	        } else if (align.bottom && maxHeight < windowHeight / 2) {
	          // We put it above but there's more room below, put it below
	          if (align.bottom === 'bottom') {
	            if (responsive) {
	              top = controlRect.top;
	            }
	            maxHeight = Math.min(windowHeight - top, windowHeight);
	          } else {
	            if (responsive) {
	              top = controlRect.bottom;
	            }
	            maxHeight = Math.min(windowHeight - top, windowHeight - controlRect.height);
	          }
	        }
	      }
	
	      container.style.left = left + 'px';
	      // offset width by 0.1 to avoid a bug in ie11 that
	      // unnecessarily wraps the text if width is the same
	      container.style.width = width + 0.1 + 'px';
	      // the (position:absolute + scrollTop)
	      // is presenting issues with desktop scroll flickering
	      container.style.top = top + 'px';
	      container.style.maxHeight = windowHeight - top + 'px';
	
	      if (initialFocusNeeded) {
	        // Now that we've placed it, focus on it
	        this._focus();
	      }
	    }
	  }, {
	    key: '_focus',
	    value: function _focus() {
	      var container = this.state.container;
	
	      this.state.originalFocusedElement = document.activeElement;
	      if (!container.contains(document.activeElement)) {
	        var anchor = container.querySelector(CLASS_ROOT + '__anchor');
	        if (anchor) {
	          anchor.focus();
	          anchor.scrollIntoView();
	        }
	      }
	      delete this.state.initialFocusNeeded;
	    }
	  }, {
	    key: 'render',
	    value: function render(content) {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          container = _state2.container,
	          _state2$options = _state2.options,
	          context = _state2$options.context,
	          focusControl = _state2$options.focusControl;
	
	      var originalScrollPosition = container.scrollTop;
	      (0, _reactDom.render)(_react2.default.createElement(DropContents, { content: content, context: context,
	        focusControl: focusControl }), container, function () {
	        _this6.place();
	        // reset container to its original scroll position
	        container.scrollTop = originalScrollPosition;
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var _this7 = this;
	
	      var _state3 = this.state,
	          container = _state3.container,
	          originalFocusedElement = _state3.originalFocusedElement,
	          scrollParents = _state3.scrollParents;
	
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.removeEventListener('scroll', _this7.place);
	      });
	      window.removeEventListener('resize', this._onResize);
	
	      (0, _reactDom.unmountComponentAtNode)(container);
	      this.parentContainer.removeChild(container);
	      // weird bug in Chrome does not remove child if
	      // document.body.insertBefore is called in another new drop.
	      // the code below will go over remaining drop that was not removed
	      [].forEach.call(document.getElementsByClassName(CLASS_ROOT), function (element) {
	        if (element.getAttribute('style') === container.getAttribute('style')) {
	          document.body.removeChild(element);
	        }
	      });
	
	      if (originalFocusedElement) {
	        originalFocusedElement.focus();
	      }
	
	      this.state = undefined;
	    }
	  }]);
	
	  return Drop;
	}();
	
	// How callers can validate a property for drop alignment which will be
	// passed to add().
	
	
	exports.default = Drop;
	var dropAlignPropType = exports.dropAlignPropType = _propTypes2.default.shape({
	  top: _propTypes2.default.oneOf(VERTICAL_ALIGN_OPTIONS),
	  bottom: _propTypes2.default.oneOf(VERTICAL_ALIGN_OPTIONS),
	  left: _propTypes2.default.oneOf(HORIZONTAL_ALIGN_OPTIONS),
	  right: _propTypes2.default.oneOf(HORIZONTAL_ALIGN_OPTIONS)
	});
	
	Drop.add = function (control, content, options) {
	  console.warn("Warning: Drop.add() is deprecated, use new Drop().");
	  return new Drop(control, content, options);
	};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.smallSize = smallSize;
	// (C) Copyright 2014 Hewlett Packard Enterprise Development LP
	
	/*
	 * Responsive is a utility for tracking the display size.
	 * It aligns with CSS media queries.
	 */
	
	var SMALL_WIDTH_EM = 44.9375; // align with _settings.responsive.scss
	
	function smallSize() {
	  var fontSize = '16px';
	  // unit tests don't have getComputedStyle
	  if (window.getComputedStyle) {
	    fontSize = window.getComputedStyle(document.documentElement).fontSize;
	  }
	  return SMALL_WIDTH_EM * parseFloat(fontSize);
	}
	
	exports.default = {
	
	  // Track responsive sizing.
	  //
	  // Example:
	  // inside componentDidMount()
	  //   this._responsive = Responsive.start(this._onResponsive);
	  // inside componentWillUnmount()
	  //   this._responsive.stop()
	
	  start: function start(func) {
	    var responsive = {
	      func: func,
	      timer: undefined,
	      small: undefined,
	      smallSize: this.smallSize()
	    };
	    responsive.onResize = this._onResize.bind(this, responsive);
	    responsive.layout = this._check.bind(this, responsive);
	    responsive.stop = this._stop.bind(this, responsive);
	    window.addEventListener('resize', responsive.onResize);
	    responsive.layout();
	    return responsive;
	  },
	  _stop: function _stop(responsive) {
	    clearTimeout(responsive.timer);
	    window.removeEventListener('resize', responsive.onResize);
	  },
	  _onResize: function _onResize(responsive) {
	    // Don't debounce so we align more closely with how the stylesheets are
	    // processed.
	    responsive.layout();
	  },
	  _check: function _check(responsive) {
	    if (window.innerWidth <= responsive.smallSize) {
	      if (!responsive.small) {
	        responsive.small = true;
	        responsive.func(true);
	      }
	    } else {
	      if (false !== responsive.small) {
	        responsive.small = false;
	        responsive.func(false);
	      }
	    }
	  },
	
	
	  smallSize: smallSize
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var EventPluginRegistry = __webpack_require__(143);
	var EventPluginUtils = __webpack_require__(144);
	var ReactErrorUtils = __webpack_require__(148);
	
	var accumulateInto = __webpack_require__(373);
	var forEachAccumulated = __webpack_require__(374);
	var invariant = __webpack_require__(9);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(89);
	var EventPluginUtils = __webpack_require__(144);
	
	var accumulateInto = __webpack_require__(373);
	var forEachAccumulated = __webpack_require__(374);
	var warning = __webpack_require__(15);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	var getEventTarget = __webpack_require__(153);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(2);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*
	https://github.com/ScottLogic/d3fc/blob/master/src/indicator/algorithm/calculator/exponentialMovingAverage.js
	
	The MIT License (MIT)
	
	Copyright (c) 2014-2015 Scott Logic Ltd.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.EMA;
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize,
			    sourcePath = _options.sourcePath;
	
	
			var source = (0, _utils.path)(sourcePath);
			var alpha = 2 / (windowSize + 1);
			var previous = void 0;
			var initialAccumulator = 0;
			var skip = 0;
	
			return data.map(function (d, i) {
				var v = source(d, i);
				if ((0, _utils.isNotDefined)(previous) && (0, _utils.isNotDefined)(v)) {
					skip++;
					return undefined;
				} else if (i < windowSize + skip - 1) {
					initialAccumulator += v;
					return undefined;
				} else if (i === windowSize + skip - 1) {
					initialAccumulator += v;
					var initialValue = initialAccumulator / windowSize;
					previous = initialValue;
					return initialValue;
				} else {
					var nextValue = v * alpha + (1 - alpha) * previous;
					previous = nextValue;
					return nextValue;
				}
			});
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize;
	
			return windowSize - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.EMA, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=ema.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(4);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StraightLine = function (_Component) {
		_inherits(StraightLine, _Component);
	
		function StraightLine(props) {
			_classCallCheck(this, StraightLine);
	
			var _this = _possibleConstructorReturn(this, (StraightLine.__proto__ || Object.getPrototypeOf(StraightLine)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(StraightLine, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var _props = this.props,
				    type = _props.type,
				    stroke = _props.stroke,
				    strokeWidth = _props.strokeWidth,
				    opacity = _props.opacity,
				    strokeDasharray = _props.strokeDasharray;
				var _props2 = this.props,
				    yValue = _props2.yValue,
				    xValue = _props2.xValue;
				var xScale = moreProps.xScale;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    yScale = _moreProps$chartConfi.yScale,
				    width = _moreProps$chartConfi.width,
				    height = _moreProps$chartConfi.height;
	
	
				ctx.beginPath();
	
				ctx.strokeStyle = (0, _utils.hexToRGBA)(stroke, opacity);
				ctx.lineWidth = strokeWidth;
	
				var _getLineCoordinates = getLineCoordinates(type, xScale, yScale, xValue, yValue, width, height),
				    x1 = _getLineCoordinates.x1,
				    y1 = _getLineCoordinates.y1,
				    x2 = _getLineCoordinates.x2,
				    y2 = _getLineCoordinates.y2;
	
				ctx.setLineDash((0, _utils.getStrokeDasharray)(strokeDasharray).split(","));
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var width = moreProps.width,
				    height = moreProps.height;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale;
				var className = this.props.className;
				var _props3 = this.props,
				    type = _props3.type,
				    stroke = _props3.stroke,
				    strokeWidth = _props3.strokeWidth,
				    opacity = _props3.opacity,
				    strokeDasharray = _props3.strokeDasharray;
				var _props4 = this.props,
				    yValue = _props4.yValue,
				    xValue = _props4.xValue;
	
	
				var lineCoordinates = getLineCoordinates(type, xScale, yScale, xValue, yValue, width, height);
	
				return _react2.default.createElement("line", _extends({
					className: className,
					strokeDasharray: (0, _utils.getStrokeDasharray)(strokeDasharray),
					stroke: stroke,
					strokeWidth: strokeWidth,
					strokeOpacity: opacity
				}, lineCoordinates));
			}
		}]);
	
		return StraightLine;
	}(_react.Component);
	
	function getLineCoordinates(type, xScale, yScale, xValue, yValue, width, height) {
		return type === "horizontal" ? { x1: 0, y1: Math.round(yScale(yValue)), x2: width, y2: Math.round(yScale(yValue)) } : { x1: Math.round(xScale(xValue)), y1: 0, x2: Math.round(xScale(xValue)), y2: height };
	}
	
	StraightLine.propTypes = {
		className: _propTypes2.default.string,
		type: _propTypes2.default.oneOf(["vertical", "horizontal"]),
		stroke: _propTypes2.default.string,
		strokeWidth: _propTypes2.default.number,
		strokeDasharray: _propTypes2.default.oneOf(_utils.strokeDashTypes),
		opacity: _propTypes2.default.number.isRequired,
		yValue: function yValue(props, propName /* , componentName */) {
			if (props.type === "vertical" && (0, _utils.isDefined)(props[propName])) return new Error("Do not define `yValue` when type is `vertical`, define the `xValue` prop");
			if (props.type === "horizontal" && (0, _utils.isNotDefined)(props[propName])) return new Error("when type = `horizontal` `yValue` is required");
			// if (isDefined(props[propName]) && typeof props[propName] !== "number") return new Error("prop `yValue` accepts a number");
		},
		xValue: function xValue(props, propName /* , componentName */) {
			if (props.type === "horizontal" && (0, _utils.isDefined)(props[propName])) return new Error("Do not define `xValue` when type is `horizontal`, define the `yValue` prop");
			if (props.type === "vertical" && (0, _utils.isNotDefined)(props[propName])) return new Error("when type = `vertical` `xValue` is required");
			// if (isDefined(props[propName]) && typeof props[propName] !== "number") return new Error("prop `xValue` accepts a number");
		}
	};
	
	StraightLine.defaultProps = {
		className: "line ",
		type: "horizontal",
		stroke: "#000000",
		opacity: 0.5,
		strokeWidth: 1,
		strokeDasharray: "Solid"
	};
	
	exports.default = StraightLine;
	//# sourceMappingURL=StraightLine.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (d) {
	  return d;
	};
	//# sourceMappingURL=identity.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {};
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SVGIcon = __webpack_require__(500);
	
	var _SVGIcon2 = _interopRequireDefault(_SVGIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = 'ferret-logo';
	
	var Logo = function (_Component) {
	  _inherits(Logo, _Component);
	
	  function Logo() {
	    _classCallCheck(this, Logo);
	
	    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
	  }
	
	  _createClass(Logo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          busy = _props.busy,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          size = _props.size,
	          props = _objectWithoutProperties(_props, ['busy', 'className', 'colorIndex', 'size']);
	
	      var classes = [CLASS_ROOT];
	      if (busy) {
	        classes.push(CLASS_ROOT + '--busy');
	      }
	      if (className) {
	        classes.push(className);
	      } /*  <SVGIcon {...props} className={classes.join('')}
	           colorIndex={colorIndex} size={size} viewBox="0 0 120 120" version='1.1'
	           type='logo' a11yTitle='Ferret Logo'>
	           <g fill='none'>
	             <rect stroke="none" x="0" y="0" width="120" height="120"></rect>
	             <g className="paths" strokeWidth="4">
	               <path d="M54,96 L54,106 L14,106 L14,66 L24,66"></path>
	               <path d="M24,36 L84,36 L84,96 L24,96 L24,36"></path>
	               <path d="M34,36 L34,18 L102,18 L102,86 L84,86"></path>
	               <rect x="34" y="66" width="20" height="20"></rect>
	             </g>
	           </g>
	         </SVGIcon>*/
	
	      var style = {
	        height: '13vw',
	        width: '432px'
	      };
	      return _react2.default.createElement('img', { src: '/img/logo.png', style: style, className: 'login-page-logo', alt: '' });
	    }
	  }]);
	
	  return Logo;
	}(_react.Component);
	
	Logo.propTypes = {
	  busy: _react.PropTypes.bool,
	  colorIndex: _react.PropTypes.string,
	  size: _react.PropTypes.oneOf(['medium', 'large'])
	};
	
	Logo.defaultProps = {
	  colorIndex: 'brand'
	};
	
	module.exports = Logo;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CLASS_ROOT, 'CLASS_ROOT', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Logo.js');
	
	  __REACT_HOT_LOADER__.register(Logo, 'Logo', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Logo.js');
	}();

	;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ v1.2.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(176)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.1.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(178)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _classnames4 = __webpack_require__(6);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Drop = __webpack_require__(87);
	
	var _Drop2 = _interopRequireDefault(_Drop);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Responsive = __webpack_require__(88);
	
	var _Responsive2 = _interopRequireDefault(_Responsive);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Search = __webpack_require__(518);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Announcer = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SEARCH;
	var INPUT = _CSSClassnames2.default.INPUT;
	var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props, context) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));
	
	    _this._onAddDrop = _this._onAddDrop.bind(_this);
	    _this._onRemoveDrop = _this._onRemoveDrop.bind(_this);
	    _this._onFocusInput = _this._onFocusInput.bind(_this);
	    _this._onChangeInput = _this._onChangeInput.bind(_this);
	    _this._onClickBody = _this._onClickBody.bind(_this);
	    _this._onNextSuggestion = _this._onNextSuggestion.bind(_this);
	    _this._onPreviousSuggestion = _this._onPreviousSuggestion.bind(_this);
	    _this._announceSuggestion = _this._announceSuggestion.bind(_this);
	    _this._onEnter = _this._onEnter.bind(_this);
	    _this._onClickSuggestion = _this._onClickSuggestion.bind(_this);
	    _this._onMouseUp = _this._onMouseUp.bind(_this);
	    _this._onInputKeyDown = _this._onInputKeyDown.bind(_this);
	    _this._onSink = _this._onSink.bind(_this);
	    _this._onResponsive = _this._onResponsive.bind(_this);
	    _this._stopPropagation = _this._stopPropagation.bind(_this);
	
	    _this.state = {
	      announceChange: false,
	      activeSuggestionIndex: -1,
	      align: 'left',
	      dropActive: false,
	      inline: props.inline,
	      small: false
	    };
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          initialFocus = _props.initialFocus,
	          inline = _props.inline,
	          responsive = _props.responsive;
	
	      if (inline && responsive) {
	        this._responsive = _Responsive2.default.start(this._onResponsive);
	      }
	      if (initialFocus) {
	        (0, _reactDom.findDOMNode)(this._inputRef).focus();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _state = this.state,
	          dropActive = _state.dropActive,
	          inline = _state.inline,
	          small = _state.small;
	
	      if (nextProps.suggestions && nextProps.suggestions.length > 0 && !dropActive && this._inputRef === document.activeElement) {
	        this.setState({ dropActive: true });
	      } else if ((!nextProps.suggestions || nextProps.suggestions.length === 0) && inline) {
	        this.setState({ dropActive: false });
	      }
	      if (!small && nextProps.inline !== this.props.inline) {
	        this.setState({ inline: nextProps.inline });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          dropAlign = _props2.dropAlign,
	          suggestions = _props2.suggestions;
	      var _state2 = this.state,
	          announceChange = _state2.announceChange,
	          dropActive = _state2.dropActive,
	          inline = _state2.inline;
	      var intl = this.context.intl;
	      // Set up keyboard listeners appropriate to the current state.
	
	      var activeKeyboardHandlers = {
	        esc: this._onRemoveDrop,
	        tab: this._onRemoveDrop,
	        up: this._onPreviousSuggestion,
	        down: this._onNextSuggestion,
	        enter: this._onEnter,
	        left: this._stopPropagation,
	        right: this._stopPropagation
	      };
	
	      if (!dropActive && prevState.dropActive) {
	        document.removeEventListener('click', this._onClickBody);
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
	        if (this._drop) {
	          this._drop.remove();
	          this._drop = undefined;
	        }
	      }
	
	      if (dropActive && !prevState.dropActive) {
	        document.addEventListener('click', this._onClickBody);
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, activeKeyboardHandlers);
	
	        var baseElement = void 0;
	        if (this._controlRef) {
	          baseElement = (0, _reactDom.findDOMNode)(this._controlRef);
	        } else {
	          baseElement = this._inputRef;
	        }
	        var align = dropAlign || {
	          top: inline ? 'bottom' : 'top',
	          left: 'left'
	        };
	        this._drop = new _Drop2.default(baseElement, this._renderDropContent(), {
	          align: align,
	          focusControl: !inline,
	          responsive: false // so suggestion changes don't re-align
	        });
	
	        if (this._inputRef) {
	          this._inputRef.focus();
	        }
	      } else if (this._drop) {
	        this._drop.render(this._renderDropContent());
	      }
	
	      if (announceChange && suggestions) {
	        var matchResultsMessage = _Intl2.default.getMessage(intl, 'Match Results', {
	          count: suggestions.length
	        });
	        var navigationHelpMessage = '';
	        if (suggestions.length) {
	          navigationHelpMessage = '(' + _Intl2.default.getMessage(intl, 'Navigation Help') + ')';
	        }
	        (0, _Announcer.announce)(matchResultsMessage + ' ' + navigationHelpMessage);
	        this.setState({ announceChange: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this._onClickBody);
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
	      if (this._responsive) {
	        this._responsive.stop();
	      }
	      if (this._drop) {
	        this._drop.remove();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var input = this._inputRef;
	      if (input) {
	        (0, _reactDom.findDOMNode)(input).focus();
	      }
	    }
	  }, {
	    key: '_stopPropagation',
	    value: function _stopPropagation() {
	      if (document.activeElement === this._inputRef) {
	        return true;
	      }
	    }
	  }, {
	    key: '_onInputKeyDown',
	    value: function _onInputKeyDown(event) {
	      var _props3 = this.props,
	          inline = _props3.inline,
	          onSelect = _props3.onSelect,
	          suggestions = _props3.suggestions,
	          onKeyDown = _props3.onKeyDown;
	
	      var enter = 13;
	      var dropActive = this.state.dropActive;
	
	      if (suggestions) {
	        var up = 38;
	        var down = 40;
	        if (event.keyCode === up || event.keyCode === down) {
	          // stop the input to move the cursor when suggestions are present
	          event.preventDefault();
	
	          if (event.keyCode === down && !dropActive && inline) {
	            this._onAddDrop();
	          }
	        }
	      }
	      if (!dropActive && onSelect && event.keyCode === enter) {
	        onSelect({
	          target: this._inputRef || this._controlRef
	        }, false);
	      }
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	    }
	  }, {
	    key: '_onClickBody',
	    value: function _onClickBody(event) {
	      // don't close drop when clicking on input
	      if (event.target !== this._inputRef) {
	        this._onRemoveDrop();
	      }
	    }
	  }, {
	    key: '_onAddDrop',
	    value: function _onAddDrop() {
	      this.setState({ dropActive: true, activeSuggestionIndex: -1 });
	    }
	  }, {
	    key: '_onRemoveDrop',
	    value: function _onRemoveDrop() {
	      this.setState({ dropActive: false });
	    }
	  }, {
	    key: '_onFocusInput',
	    value: function _onFocusInput(event) {
	      var _props4 = this.props,
	          onFocus = _props4.onFocus,
	          suggestions = _props4.suggestions;
	
	      if (onFocus) {
	        onFocus(event);
	      }
	      if (suggestions && suggestions.length > 0) {
	        this._onAddDrop();
	      }
	    }
	  }, {
	    key: '_fireDOMChange',
	    value: function _fireDOMChange() {
	      var onDOMChange = this.props.onDOMChange;
	
	      var event = void 0;
	      try {
	        event = new Event('change', {
	          'bubbles': true,
	          'cancelable': true
	        });
	      } catch (e) {
	        // IE11 workaround.
	        event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	      }
	      var target = this._inputRef;
	      target.dispatchEvent(event);
	      onDOMChange(event);
	    }
	  }, {
	    key: '_onChangeInput',
	    value: function _onChangeInput(event) {
	      var onDOMChange = this.props.onDOMChange;
	
	      this.setState({ activeSuggestionIndex: -1, announceChange: true });
	      if (onDOMChange) {
	        this._fireDOMChange();
	      }
	    }
	  }, {
	    key: '_announceSuggestion',
	    value: function _announceSuggestion(index) {
	      var intl = this.context.intl;
	
	      var labelMessage = this._renderLabel(this.props.suggestions[index]);
	      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
	      (0, _Announcer.announce)(labelMessage + ' ' + enterSelectMessage);
	    }
	  }, {
	    key: '_onNextSuggestion',
	    value: function _onNextSuggestion() {
	      var suggestions = this.props.suggestions;
	
	      if (suggestions) {
	        var index = this.state.activeSuggestionIndex;
	        index = Math.min(index + 1, suggestions.length - 1);
	        this.setState({ activeSuggestionIndex: index }, this._announceSuggestion.bind(this, index));
	      }
	    }
	  }, {
	    key: '_onPreviousSuggestion',
	    value: function _onPreviousSuggestion() {
	      var suggestions = this.props.suggestions;
	
	      if (suggestions) {
	        var index = this.state.activeSuggestionIndex;
	        index = Math.max(index - 1, 0);
	        this.setState({ activeSuggestionIndex: index }, this._announceSuggestion.bind(this, index));
	      }
	    }
	  }, {
	    key: '_onEnter',
	    value: function _onEnter(event) {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          inline = _props5.inline,
	          onSelect = _props5.onSelect,
	          suggestions = _props5.suggestions;
	      var activeSuggestionIndex = this.state.activeSuggestionIndex;
	      var intl = this.context.intl;
	      // for not inline search the enter should NOT submit the form
	      // in this case double enter is required
	
	      if (!inline) {
	        event.preventDefault(); // prevent submitting forms
	      }
	
	      if (activeSuggestionIndex >= 0) {
	        var suggestion = suggestions[activeSuggestionIndex];
	        this.setState({ value: suggestion }, function () {
	          var suggestionMessage = _this2._renderLabel(suggestion);
	          var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
	          (0, _Announcer.announce)(suggestionMessage + ' ' + selectedMessage);
	        });
	        if (onSelect) {
	          onSelect({
	            target: this._inputRef || this._controlRef,
	            suggestion: suggestion
	          }, true);
	        }
	      } else if (onSelect) {
	        onSelect({
	          target: this._inputRef || this._controlRef
	        }, false);
	      }
	
	      this._onRemoveDrop();
	    }
	  }, {
	    key: '_onClickSuggestion',
	    value: function _onClickSuggestion(suggestion) {
	      var onSelect = this.props.onSelect;
	
	      this._onRemoveDrop();
	      if (onSelect) {
	        onSelect({
	          target: this._inputRef || this._controlRef,
	          suggestion: suggestion
	        }, true);
	      }
	    }
	  }, {
	    key: '_onMouseUp',
	    value: function _onMouseUp(event) {
	      var onMouseUp = this.props.onMouseUp;
	      // This fixes a Safari bug which prevents the input
	      // text from being selected on focus.
	
	      event.preventDefault();
	      if (onMouseUp) {
	        onMouseUp(event);
	      }
	    }
	  }, {
	    key: '_onSink',
	    value: function _onSink(event) {
	      event.stopPropagation();
	      event.nativeEvent.stopImmediatePropagation();
	    }
	  }, {
	    key: '_onResponsive',
	    value: function _onResponsive(small) {
	      var inline = this.props.inline;
	
	      if (small) {
	        this.setState({ inline: false, small: small });
	      } else {
	        this.setState({ inline: inline, small: small });
	      }
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel(suggestion) {
	      if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
	        return suggestion.label || suggestion.value;
	      } else {
	        return suggestion;
	      }
	    }
	  }, {
	    key: '_renderDropContent',
	    value: function _renderDropContent() {
	      var _classnames,
	          _this3 = this;
	
	      var _props6 = this.props,
	          defaultValue = _props6.defaultValue,
	          dropAlign = _props6.dropAlign,
	          dropColorIndex = _props6.dropColorIndex,
	          suggestions = _props6.suggestions,
	          value = _props6.value;
	      var _state3 = this.state,
	          inline = _state3.inline,
	          activeSuggestionIndex = _state3.activeSuggestionIndex;
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Search.propTypes));
	      var classes = (0, _classnames5.default)(CLASS_ROOT + '__drop', (_classnames = {}, _defineProperty(_classnames, BACKGROUND_COLOR_INDEX + '-' + dropColorIndex, dropColorIndex), _defineProperty(_classnames, CLASS_ROOT + '__drop--controlled', !inline), _classnames));
	
	      var input = void 0;
	      if (!inline) {
	        input = _react2.default.createElement('input', _extends({}, restProps, { key: 'input', ref: function ref(_ref) {
	            return _this3._inputRef = _ref;
	          },
	          type: 'search', autoComplete: 'off', value: value,
	          defaultValue: defaultValue, onChange: this._onChangeInput,
	          className: INPUT + ' ' + CLASS_ROOT + '__input',
	          onKeyDown: this._onInputKeyDown }));
	      }
	
	      var suggestionsNode = void 0;
	      if (suggestions) {
	        suggestionsNode = suggestions.map(function (suggestion, index) {
	          var classes = (0, _classnames5.default)(CLASS_ROOT + '__suggestion', _defineProperty({}, CLASS_ROOT + '__suggestion--active', index === activeSuggestionIndex));
	
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: classes, tabIndex: '-1', role: 'button',
	              onClick: _this3._onClickSuggestion.bind(_this3, suggestion),
	              onFocus: function onFocus() {
	                return _this3.setState({ activeSuggestionIndex: index });
	              } },
	            _this3._renderLabel(suggestion)
	          );
	        }, this);
	        suggestionsNode = _react2.default.createElement(
	          'div',
	          { key: 'suggestions', className: CLASS_ROOT + '__suggestions' },
	          suggestionsNode
	        );
	      }
	
	      var contents = [input, suggestionsNode];
	
	      if (!inline) {
	        contents = [_react2.default.createElement(
	          'div',
	          { key: 'contents', className: CLASS_ROOT + '__drop-contents',
	            onClick: this._onSink },
	          contents
	        )];
	        if (!dropAlign || !dropAlign.top && !dropAlign.bottom) {
	          var control = _react2.default.createElement(_Button2.default, { key: 'icon', icon: _react2.default.createElement(_Search2.default, null),
	            className: CLASS_ROOT + '__drop-control',
	            onClick: this._onRemoveDrop });
	          if (!dropAlign || dropAlign.left === 'left') {
	            contents.unshift(control);
	          } else if (dropAlign.right === 'right') {
	            contents.push(control);
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        contents
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames3,
	          _this4 = this;
	
	      var _props7 = this.props,
	          className = _props7.className,
	          defaultValue = _props7.defaultValue,
	          iconAlign = _props7.iconAlign,
	          id = _props7.id,
	          fill = _props7.fill,
	          pad = _props7.pad,
	          placeHolder = _props7.placeHolder,
	          size = _props7.size,
	          value = _props7.value;
	      var inline = this.state.inline;
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Search.propTypes));
	      var classes = (0, _classnames5.default)(CLASS_ROOT, (_classnames3 = {}, _defineProperty(_classnames3, CLASS_ROOT + '--controlled', !inline), _defineProperty(_classnames3, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames3, CLASS_ROOT + '--icon-align-' + iconAlign, iconAlign), _defineProperty(_classnames3, CLASS_ROOT + '--pad-' + pad, pad), _defineProperty(_classnames3, CLASS_ROOT + '--inline', inline), _defineProperty(_classnames3, CLASS_ROOT + '--' + size, size), _classnames3), className);
	
	      if (inline) {
	        return _react2.default.createElement(
	          'div',
	          { className: classes },
	          _react2.default.createElement('input', _extends({}, restProps, { ref: function ref(_ref2) {
	              return _this4._inputRef = _ref2;
	            },
	            type: 'search', id: id, placeholder: placeHolder,
	            autoComplete: 'off',
	            defaultValue: this._renderLabel(defaultValue),
	            value: this._renderLabel(value),
	            className: INPUT + ' ' + CLASS_ROOT + '__input',
	            onFocus: this._onFocusInput,
	            onChange: this._onChangeInput,
	            onMouseUp: this._onMouseUp,
	            onKeyDown: this._onInputKeyDown })),
	          _react2.default.createElement(_Search2.default, null)
	        );
	      } else {
	        return _react2.default.createElement(_Button2.default, { ref: function ref(_ref3) {
	            return _this4._controlRef = _ref3;
	          },
	          id: id, className: className, icon: _react2.default.createElement(_Search2.default, null),
	          onClick: this._onAddDrop });
	      }
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	Search.displayName = 'Search';
	exports.default = Search;
	
	
	Search.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Search.defaultProps = {
	  align: 'left',
	  iconAlign: 'end',
	  inline: false,
	  responsive: true
	};
	
	Search.propTypes = {
	  align: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.string,
	  dropAlign: _Drop.dropAlignPropType,
	  dropColorIndex: _propTypes2.default.string,
	  fill: _propTypes2.default.bool,
	  iconAlign: _propTypes2.default.oneOf(['start', 'end']),
	  id: _propTypes2.default.string,
	  initialFocus: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  onDOMChange: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  pad: _propTypes2.default.oneOf(['small', 'medium']),
	  placeHolder: _propTypes2.default.string,
	  responsive: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  suggestions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
	    label: _propTypes2.default.node,
	    value: _propTypes2.default.any
	  }), _propTypes2.default.string])),
	  value: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link-next', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link-next');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12 M13,3 L22,12 L13,21' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'LinkNext';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  '3d': '3d',
	  'access-accessibility': 'accès accessibilité',
	  'access-ad': 'accès ad',
	  'access-assist-listening': 'accès assistance audio',
	  'access-braille': 'accès braille',
	  'access-sign': 'accès langage des signes',
	  'access-tty': 'accès tty',
	  'access-volume-control': 'accès contrôle de volume',
	  'access-wheelchair-active': 'accès chaise-roulante active',
	  'access-wheelchair': 'accès chaise-roulante',
	  'achievement': 'réussite',
	  'action': 'action',
	  'actions': 'actions',
	  'add-circle': 'cercle d\'ajout',
	  'add': 'ajout',
	  'aggregate': 'aggrégation',
	  'aid': 'soin',
	  'alarm': 'alarme',
	  'alert': 'alerte',
	  'analytics': 'analyse',
	  'announce': 'annonce',
	  'apps': 'applications',
	  'archive': 'archive',
	  'article': 'article',
	  'ascend': 'ascendant',
	  'attachment': 'joint',
	  'back-ten': 'retour dix',
	  'bar-chart': 'diagramme  à bande',
	  'basket': 'panier',
	  'blog': 'blog',
	  'book': 'livre',
	  'bookmark': 'signet',
	  'bottom-corner': 'coin inférieur',
	  'brand-apple-app-store': 'étiquette apple app store',
	  'brand-codepen-edit': 'étiquette codepen edit',
	  'brand-codepen-try': 'étiquette codepen try',
	  'brand-google-play': 'étiquette google play',
	  'brand-grommet-outline': 'étiquette grommet outline',
	  'brand-grommet-path': 'étiquette grommet path',
	  'brand-hpe-element-outline': 'étiquette hpe element outline',
	  'brand-hpe-element-path': 'étiquette hpe element path',
	  'brand-hpe-labs-insignia-outline': 'étiquette hpe labs insignia outline',
	  'brand-hpe-labs-insignia': 'étiquette hpe labs insignia',
	  'brand-hpe-stack-centered': 'étiquette hpe stack centered',
	  'brand-hpe-stack': 'étiquette hpe stack',
	  'briefcase': 'porte document',
	  'brush': 'brosse',
	  'bug': 'insecte',
	  'bundle': 'paquet',
	  'business-service': 'service d\'affaire',
	  'calculator': 'calculatrice',
	  'calendar': 'calendrier',
	  'camera': 'camera',
	  'capacity': 'capacité',
	  'car': 'voiture',
	  'caret-down': 'caret bas',
	  'caret-next': 'caret suivant',
	  'caret-previous': 'caret précédant',
	  'caret-up': 'caret haut',
	  'cart': 'panier',
	  'catalog': 'catalogue',
	  'chapter-add': 'ajout de chapitre',
	  'chapter-next': 'chapitre suivant',
	  'chapter-previous': 'chapitre précédent',
	  'chat': 'clavardage',
	  'checkbox-selected': 'case sélectionnée',
	  'checkbox': 'case de sélection',
	  'checkmark': 'crochet',
	  'circle-information': 'cercle d\'information',
	  'circle-play': 'cercle play',
	  'circle-question': 'cercle question',
	  'clear-option': 'option nettoyer',
	  'clear': 'nettoyer',
	  'cli': 'cli',
	  'clipboard': 'presse papier',
	  'clock': 'horloge',
	  'clone': 'clône',
	  'close': 'fermer',
	  'closed-caption': 'sous-titrage',
	  'cloud-computer': 'ordinateur du nuage',
	  'cloud-download': 'téléchargement du nuage',
	  'cloud-software': 'logiciel du nuage',
	  'cloud-upload': 'téléchargement sur le nuage',
	  'cloud': 'nuage',
	  'cluster': 'cluster',
	  'code': 'code',
	  'columns': 'colonnes',
	  'compare': 'comparaison',
	  'compass': 'boussole',
	  'compliance': 'conformité',
	  'configure': 'configuration',
	  'connect': 'connexion',
	  'contact-info': 'info du contact',
	  'contact': 'contact',
	  'contract': 'contrat',
	  'copy': 'copie',
	  'credit-card': 'carte de crédit',
	  'cube': 'cube',
	  'cubes': 'cubes',
	  'currency': 'monnaie',
	  'cursor': 'curseur',
	  'cut': 'couper',
	  'cycle': 'cycle',
	  'dashboard': 'tableau de bord',
	  'database': 'base de données',
	  'deliver': 'livraison',
	  'deploy': 'déployer',
	  'descend': 'descendant',
	  'desktop': 'ordinateur',
	  'detach': 'disjoint',
	  'diamond': 'diamand',
	  'directions': 'directions',
	  'dislike': 'je n\'aime pas',
	  'document-cloud': 'fichier du nuage',
	  'document-config': 'fichier de config',
	  'document-csv': 'fichier csv',
	  'document-download': 'téléchargement de fichier',
	  'document-excel': 'fichier excel',
	  'document-exe': 'fichier exe',
	  'document-image': 'fichier d\'image',
	  'document-locked': 'fichier vérouillé',
	  'document-missing': 'fichier manquant',
	  'document-notes': 'fichier de notes',
	  'document-outlook': 'fichier outlook',
	  'document-pdf': 'fichier pdf',
	  'document-performance': 'fichier de performance',
	  'document-ppt': 'fichier ppt',
	  'document-rtf': 'fichier rtf',
	  'document-sound': 'fichier audio',
	  'document-store': 'fichier de sauvegarde',
	  'document-test': 'fichier de test',
	  'document-threat': 'fichier dangereux',
	  'document-time': 'historique du fichier',
	  'document-transfer': 'transfère de fichier',
	  'document-txt': 'fichier txt',
	  'document-update': 'mise à jour de fichier',
	  'document-upload': 'téléversement de fichier',
	  'document-user': 'fichier utilisateur',
	  'document-verified': 'fichier vérifié',
	  'document-video': 'fichier video',
	  'document-windows': 'fichier windows',
	  'document-word': 'fichier word',
	  'document-zip': 'fichier zip',
	  'document': 'fichier',
	  'domain': 'domaine',
	  'down': 'bas',
	  'download': 'télécharger',
	  'drag': 'glisser',
	  'drive-cage': 'cage de disque',
	  'duplicate': 'dupliquer',
	  'edit': 'éditer',
	  'eject': 'éjecter',
	  'empty-circle': 'cercle vide',
	  'expand': 'agrandir',
	  'fan': 'ventilateur',
	  'fast-forward': 'avance rapide',
	  'favorite': 'favorie',
	  'filter': 'filtre',
	  'finger-print': 'empreinte digitale',
	  'flag': 'drapeau',
	  'folder-cycle': 'dossier cyclique',
	  'folder-open': 'dossier ouvert',
	  'folder': 'dossier',
	  'form-edit': 'éditer le formulaire',
	  'forward-ten': 'avance dix',
	  'gallery': 'galerie',
	  'gamepad': 'mannette',
	  'gift': 'cadeau',
	  'globe': 'globe',
	  'grid': 'grille',
	  'group': 'groupe',
	  'grow': 'pousser',
	  'halt': 'arrêt',
	  'help': 'aide',
	  'history': 'historique',
	  'home': 'maison',
	  'host-maintenance': 'maintenance de l\'hôte',
	  'host': 'hôte',
	  'image': 'image',
	  'impact': 'impacte',
	  'in-progress': 'en cours',
	  'inbox': 'boîte',
	  'indicator': 'indicateurr',
	  'info': 'info',
	  'inherit': 'héritage',
	  'inspect': 'inspecter',
	  'install': 'installer',
	  'integration': 'integration',
	  'iteration': 'itération',
	  'java': 'java',
	  'language': 'langue',
	  'launch': 'lancer',
	  'layer': 'calque',
	  'license': 'license',
	  'like': 'j\'aime',
	  'line-chart': 'diagramme à ligne',
	  'link-bottom': 'lien inférieur',
	  'link-down': 'lien vers le bas',
	  'link-next': 'lien suivant',
	  'link-previous': 'lien précédent',
	  'link-top': 'lien vers le haut',
	  'link-up': 'lien supérieur',
	  'link': 'lien',
	  'local': 'locale',
	  'location-pin': 'point de localisation',
	  'location': 'localisation',
	  'lock': 'verrou',
	  'login': 'connexion',
	  'logout': 'déconnexion',
	  'magic': 'magie',
	  'mail-option': 'option de courriel',
	  'mail': 'courriel',
	  'manual': 'manuel',
	  'map-location': 'carte localisation',
	  'map': 'carte',
	  'menu': 'menu',
	  'microphone': 'microphone',
	  'money': 'argent',
	  'monitor': 'moniteurr',
	  'more': 'plus',
	  'multiple': 'multiple',
	  'navigate': 'naviguer',
	  'new-window': 'nouvelle fenêtre',
	  'new': 'nouveau',
	  'next': 'suivant',
	  'nodes': 'noeuds',
	  'note': 'note',
	  'notes': 'notes',
	  'notification': 'notification',
	  'object-group': 'objet groupé',
	  'object-ungroup': 'objet séparé',
	  'optimize': 'optimiser',
	  'organization': 'organisation',
	  'overview': 'aperçu',
	  'pan': 'croix directionnelle',
	  'pause-fill': 'pause pleine',
	  'pause': 'pause',
	  'personal-computer': 'ordinateur personnel',
	  'pie-chart': 'diagramme en pointe de tarte',
	  'pin': 'point',
	  'plan': 'plan',
	  'platform-amazon': 'platforme amazon',
	  'platform-android': 'platforme android',
	  'platform-apple': 'platforme apple',
	  'platform-archlinux': 'platforme archlinux',
	  'platform-aruba': 'platforme aruba',
	  'platform-centos': 'platforme centos',
	  'platform-chrome': 'platforme chrome',
	  'platform-cloudlinux': 'platforme cloudlinux',
	  'platform-debian': 'platforme debian',
	  'platform-docker': 'platforme docker',
	  'platform-dos': 'platforme dos',
	  'platform-dropbox': 'platforme dropbox',
	  'platform-edge': 'platforme edge',
	  'platform-fedora': 'platforme fedora',
	  'platform-firefox': 'platforme firefox',
	  'platform-freebsd': 'platforme freebsd',
	  'platform-google': 'platforme google',
	  'platform-hadoop': 'platforme hadoop',
	  'platform-heroku': 'platforme heroku',
	  'platform-horton': 'platforme horton',
	  'platform-hp': 'platforme hp',
	  'platform-hpi': 'platforme hpi',
	  'platform-internet-explorer': 'platforme internet explorer',
	  'platform-java': 'platforme java',
	  'platform-mandriva': 'platforme mandriva',
	  'platform-mysql': 'platforme mysql',
	  'platform-norton': 'platforme norton',
	  'platform-onedrive': 'platforme onedrive',
	  'platform-opera': 'platforme opera',
	  'platform-oracle': 'platforme oracle',
	  'platform-pied-piper': 'platforme pied piper',
	  'platform-raspberry': 'platforme raspberry',
	  'platform-reactjs': 'platforme reactjs',
	  'platform-redhat': 'platforme redhat',
	  'platform-safari-option': 'platforme safari option',
	  'platform-safari': 'platforme safari',
	  'platform-sco': 'platforme sco',
	  'platform-solaris': 'platforme solaris',
	  'platform-suse': 'platforme suse',
	  'platform-swift': 'platforme swift',
	  'platform-turbolinux': 'platforme turbolinux',
	  'platform-ubuntu': 'platforme ubuntu',
	  'platform-unixware': 'platforme unixware',
	  'platform-vmware': 'platforme vmware',
	  'platform-windows-legacy': 'platforme windows legacy',
	  'platform-windows': 'platforme windows',
	  'play-fill': 'play plein',
	  'play': 'play',
	  'power': 'démarrer',
	  'previous': 'précédent',
	  'print': 'imprimer',
	  'radial-selected': 'sélecteur radial',
	  'radial': 'radial',
	  'refresh': 'rafraîchir',
	  'resources': 'ressources',
	  'resume': 'résumé',
	  'revert': 'inverser',
	  'rewind': 'rembobinner',
	  'risk': 'risque',
	  'robot': 'robot',
	  'rss': 'rss',
	  'run': 'course',
	  'satellite': 'satellite',
	  'save': 'sauvegarde',
	  'scan': 'scan',
	  'schedule-new': 'nouvel horaire',
	  'schedule-play': 'horaire de jeu',
	  'schedule': 'horaire',
	  'schedules': 'horaires',
	  'scorecard': 'tableau de point',
	  'search-advanced': 'recherche avancée',
	  'search': 'recherche',
	  'secure': 'sécuritaire',
	  'select': 'sélecteur',
	  'selection': 'sélection',
	  'send': 'envoie',
	  'server-cluster': 'grappe de serveur',
	  'server': 'serveur',
	  'servers': 'serveurs',
	  'service-play': 'service de jeu',
	  'services': 'services',
	  'settings-option': 'option de paramètre',
	  'share': 'partager',
	  'shield-security': 'bouclier de sécurité',
	  'shield': 'bouclier',
	  'shift': 'interchanger',
	  'sidebar': 'barre latérale',
	  'social-amazon': 'social amazon',
	  'social-amex': 'social amex',
	  'social-bitcoin': 'social bitcoin',
	  'social-codepen': 'social codepen',
	  'social-creative-commons': 'social creative commons',
	  'social-dropbox': 'social dropbox',
	  'social-facebook-option': 'social facebook option',
	  'social-facebook': 'social facebook',
	  'social-github': 'social github',
	  'social-google-plus': 'social google plus',
	  'social-google-wallet': 'social google wallet',
	  'social-instagram': 'social instagram',
	  'social-linkedin-option': 'social linkedin option',
	  'social-linkedin': 'social linkedin',
	  'social-mail': 'social mail',
	  'social-mastercard': 'social mastercard',
	  'social-medium': 'social medium',
	  'social-paypal': 'social paypal',
	  'social-pinterest': 'social pinterest',
	  'social-product-hunt': 'social product hunt',
	  'social-reddit': 'social reddit',
	  'social-skype': 'social skype',
	  'social-slack': 'social slack',
	  'social-snapchat': 'social snapchat',
	  'social-square': 'social square',
	  'social-stack-overflow': 'social stack overflow',
	  'social-stripe': 'social stripe',
	  'social-tumblr': 'social tumblr',
	  'social-twitter': 'social twitter',
	  'social-vimeo': 'social vimeo',
	  'social-vine': 'social vine',
	  'social-visa': 'social visa',
	  'social-wordpress': 'social wordpress',
	  'social-youtube': 'social youtube',
	  'sort': 'classer',
	  'split': 'division',
	  'splits': 'divisions',
	  'stakeholder': 'partenaire',
	  'standards-3d-effects': 'effets 3d standards',
	  'standards-connectivity': 'standards de connectivité',
	  'standards-css3': 'standards de css3',
	  'standards-device': 'standards d\'appariels',
	  'standards-fireball': 'standards boule de feux',
	  'standards-html5': 'standards html5',
	  'standards-multimedia': 'standards multimédia',
	  'standards-offline-storage': 'standards d\'entreposage hors ligne',
	  'standards-performance': 'standards de performances',
	  'standards-sematics': 'standards sémantique',
	  'star-half': 'demi étoile',
	  'star': 'étoile',
	  'steps': 'étape',
	  'stop-fill': 'stop plein',
	  'stop': 'stop',
	  'storage': 'entreposage',
	  'street-view': 'vue urbaine',
	  'subtract-circle': 'cercle de soustraction',
	  'subtract': 'soustraction',
	  'support': 'support',
	  'sync': 'synchroniser',
	  'system': 'système',
	  'table-add': 'ajout de tableau',
	  'table': 'tableau',
	  'tag': 'étiquette',
	  'target': 'cible',
	  'task': 'tâche',
	  'tasks': 'tâches',
	  'technology': 'technologie',
	  'template': 'modèle',
	  'terminal': 'terminale',
	  'test-desktop': 'test ordinateur',
	  'test': 'test',
	  'text-wrap': 'encadrer par le texte',
	  'threats': 'dangers',
	  'ticket': 'billets',
	  'tools': 'outils',
	  'tooltip': 'indication',
	  'top-corner': 'coin supérieur',
	  'transaction': 'transaction',
	  'trash': 'corbeille',
	  'tree': 'arbre',
	  'trigger': 'gchette',
	  'trophy': 'trophé',
	  'troubleshoot': 'dépannage',
	  'unlink': 'délier',
	  'unlock': 'déverrouiller',
	  'up': 'haut',
	  'update': 'mise à jours',
	  'upgrade': 'améliorer',
	  'upload': 'téléverser',
	  'user-add': 'ajout utilisateur',
	  'user-admin': 'utilisateur administratif',
	  'user-expert': 'utilisateur expert',
	  'user-female': 'utilisateur femelle',
	  'user-manager': 'utilisateur manager',
	  'user-new': 'nouvel utilisateur',
	  'user-police': 'utilisateur policier',
	  'user-settings': 'option d\'utilisateur',
	  'user-worker': 'utilisateur travailleur',
	  'user': 'utilisateur',
	  'validate': 'valider',
	  'video': 'vidéo',
	  'view': 'vue',
	  'virtual-machine': 'machine virtuelle',
	  'vm-maintenance': 'vm en maintenance',
	  'volume-low': 'volume bas',
	  'volume-mute': 'volume en sourdine',
	  'volume': 'volume',
	  'vulnerability': 'vulnerabilité',
	  'waypoint': 'direction',
	  'workshop': 'atelier',
	  'zoom-in': 'zoom avant',
	  'zoom-out': 'zoom arrirère'
	};
	module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var EventPluginRegistry = __webpack_require__(143);
	var ReactEventEmitterMixin = __webpack_require__(620);
	var ViewportMetrics = __webpack_require__(372);
	
	var getVendorPrefixedEventName = __webpack_require__(652);
	var isEventSupported = __webpack_require__(154);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(92);
	var ViewportMetrics = __webpack_require__(372);
	
	var getEventModifierState = __webpack_require__(152);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	var DOMNamespaces = __webpack_require__(142);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(150);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.renderSVG = renderSVG;
	exports.drawOnCanvas = drawOnCanvas;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	function renderSVG(props) {
		var className = props.className;
	
	
		var edge = helper(props);
		if (edge === null) return null;
		var line = void 0,
		    coordinateBase = void 0,
		    coordinate = void 0;
	
		if ((0, _utils.isDefined)(edge.line)) {
			line = _react2.default.createElement("line", {
				className: "react-stockcharts-cross-hair",
				strokeOpacity: edge.line.opacity,
				stroke: edge.line.stroke,
				strokeDasharray: (0, _utils.getStrokeDasharray)(edge.line.strokeDasharray),
				x1: edge.line.x1,
				y1: edge.line.y1,
				x2: edge.line.x2,
				y2: edge.line.y2
			});
		}
		if ((0, _utils.isDefined)(edge.coordinateBase)) {
			var _edge$coordinateBase = edge.coordinateBase,
			    rectWidth = _edge$coordinateBase.rectWidth,
			    rectHeight = _edge$coordinateBase.rectHeight,
			    arrowWidth = _edge$coordinateBase.arrowWidth;
	
	
			var path = edge.orient === "left" ? "M0,0L0," + rectHeight + "L" + rectWidth + "," + rectHeight + "L" + (rectWidth + arrowWidth) + ",10L" + rectWidth + ",0L0,0L0,0" : "M0," + arrowWidth + "L" + arrowWidth + "," + rectHeight + "L" + (rectWidth + arrowWidth) + "," + rectHeight + "L" + (rectWidth + arrowWidth) + ",0L" + arrowWidth + ",0L0," + arrowWidth;
	
			coordinateBase = edge.orient === "left" || edge.orient === "right" ? _react2.default.createElement(
				"g",
				{
					key: 1,
					transform: "translate(" + edge.coordinateBase.edgeXRect + "," + edge.coordinateBase.edgeYRect + ")"
				},
				_react2.default.createElement("path", {
					d: path,
					className: "react-stockchart-text-background",
					height: rectHeight,
					width: rectWidth,
					stroke: edge.coordinateBase.stroke,
					strokeLinejoin: "miter",
					strokeOpacity: edge.coordinateBase.strokeOpacity,
					strokeWidth: edge.coordinateBase.strokeWidth,
					fill: edge.coordinateBase.fill,
					fillOpacity: edge.coordinateBase.opacity
				})
			) : _react2.default.createElement("rect", {
				key: 1,
				className: "react-stockchart-text-background",
				x: edge.coordinateBase.edgeXRect,
				y: edge.coordinateBase.edgeYRect,
				height: rectHeight,
				width: rectWidth,
				fill: edge.coordinateBase.fill,
				opacity: edge.coordinateBase.opacity
			});
	
			coordinate = _react2.default.createElement(
				"text",
				{
					key: 2,
					x: edge.coordinate.edgeXText,
					y: edge.coordinate.edgeYText,
					textAnchor: edge.coordinate.textAnchor,
					fontFamily: edge.coordinate.fontFamily,
					fontSize: edge.coordinate.fontSize,
					dy: ".32em",
					fill: edge.coordinate.textFill
				},
				edge.coordinate.displayCoordinate
			);
		}
		return _react2.default.createElement(
			"g",
			{ className: className },
			line,
			coordinateBase,
			coordinate
		);
	}
	/* eslint-enable react/prop-types */
	
	function helper(props) {
		var displayCoordinate = props.coordinate,
		    show = props.show,
		    type = props.type,
		    orient = props.orient,
		    edgeAt = props.edgeAt,
		    hideLine = props.hideLine,
		    lineStrokeDasharray = props.lineStrokeDasharray;
		var fill = props.fill,
		    opacity = props.opacity,
		    fontFamily = props.fontFamily,
		    fontSize = props.fontSize,
		    textFill = props.textFill,
		    lineStroke = props.lineStroke,
		    lineOpacity = props.lineOpacity;
		var stroke = props.stroke,
		    strokeOpacity = props.strokeOpacity,
		    strokeWidth = props.strokeWidth;
		var arrowWidth = props.arrowWidth,
		    rectWidth = props.rectWidth,
		    rectHeight = props.rectHeight,
		    rectRadius = props.rectRadius;
		var x1 = props.x1,
		    y1 = props.y1,
		    x2 = props.x2,
		    y2 = props.y2,
		    dx = props.dx;
	
	
		if (!show) return null;
	
		var coordinateBase = void 0,
		    coordinate = void 0;
		if ((0, _utils.isDefined)(displayCoordinate)) {
			var textAnchor = "middle"; // TODO: Below it is necessary to implement logic for the possibility of alignment from the right or from the left.
	
			var edgeXRect = void 0,
			    edgeYRect = void 0,
			    edgeXText = void 0,
			    edgeYText = void 0;
	
			if (type === "horizontal") {
				edgeXRect = dx + (orient === "right" ? edgeAt + 1 : edgeAt - rectWidth - 1);
				edgeYRect = y1 - rectHeight / 2 - strokeWidth;
				edgeXText = dx + (orient === "right" ? edgeAt + rectWidth / 2 : edgeAt - rectWidth / 2);
				edgeYText = y1;
			} else {
				var dy = orient === "bottom" ? strokeWidth - 1 : -strokeWidth + 1;
				edgeXRect = x1 - rectWidth / 2;
				edgeYRect = (orient === "bottom" ? edgeAt : edgeAt - rectHeight) + dy;
				edgeXText = x1;
				edgeYText = (orient === "bottom" ? edgeAt + rectHeight / 2 : edgeAt - rectHeight / 2) + dy;
			}
	
			coordinateBase = {
				edgeXRect: edgeXRect,
				edgeYRect: edgeYRect,
				rectHeight: rectHeight + strokeWidth,
				rectWidth: rectWidth,
				rectRadius: rectRadius,
				fill: fill,
				opacity: opacity,
				arrowWidth: arrowWidth,
				stroke: stroke,
				strokeOpacity: strokeOpacity,
				strokeWidth: strokeWidth
			};
			coordinate = {
				edgeXText: edgeXText,
				edgeYText: edgeYText,
				textAnchor: textAnchor,
				fontFamily: fontFamily,
				fontSize: fontSize,
				textFill: textFill,
				displayCoordinate: displayCoordinate
			};
		}
	
		var line = hideLine ? undefined : {
			opacity: lineOpacity,
			stroke: lineStroke,
			strokeDasharray: lineStrokeDasharray,
			x1: x1,
			y1: y1,
			x2: x2,
			y2: y2
		};
	
		return {
			coordinateBase: coordinateBase,
			coordinate: coordinate,
			line: line,
			orient: orient
		};
	}
	
	function drawOnCanvas(ctx, props) {
		var fontSize = props.fontSize,
		    fontFamily = props.fontFamily;
	
	
		ctx.font = fontSize + "px " + fontFamily;
		ctx.textBaseline = "middle";
		var width = Math.round(ctx.measureText(props.coordinate).width + 10);
	
		var edge = helper(_extends({}, props, { rectWidth: width }));
	
		if (edge === null) return;
	
		if ((0, _utils.isDefined)(edge.line)) {
			var dashArray = (0, _utils.getStrokeDasharray)(edge.line.strokeDasharray).split(",").map(function (d) {
				return +d;
			});
			ctx.setLineDash(dashArray);
			ctx.strokeStyle = (0, _utils.hexToRGBA)(edge.line.stroke, edge.line.opacity);
			ctx.lineWidth = 1;
			ctx.beginPath();
			ctx.moveTo(edge.line.x1, edge.line.y1);
			ctx.lineTo(edge.line.x2, edge.line.y2);
			ctx.stroke();
		}
	
		ctx.setLineDash([]);
		if ((0, _utils.isDefined)(edge.coordinateBase)) {
			var _edge$coordinateBase2 = edge.coordinateBase,
			    rectWidth = _edge$coordinateBase2.rectWidth,
			    rectHeight = _edge$coordinateBase2.rectHeight,
			    rectRadius = _edge$coordinateBase2.rectRadius,
			    arrowWidth = _edge$coordinateBase2.arrowWidth;
	
	
			ctx.fillStyle = (0, _utils.hexToRGBA)(edge.coordinateBase.fill, edge.coordinateBase.opacity);
			if ((0, _utils.isDefined)(edge.coordinateBase.stroke)) {
				ctx.strokeStyle = (0, _utils.hexToRGBA)(edge.coordinateBase.stroke, edge.coordinateBase.strokeOpacity);
				ctx.lineWidth = edge.coordinateBase.strokeWidth;
			}
	
			var x = edge.coordinateBase.edgeXRect;
			var y = edge.coordinateBase.edgeYRect;
			var halfHeight = rectHeight / 2;
	
			ctx.beginPath();
			if (edge.orient === "right") {
				x -= arrowWidth;
				ctx.moveTo(x, y + halfHeight);
				ctx.lineTo(x + arrowWidth, y);
				ctx.lineTo(x + rectWidth + arrowWidth, y);
				ctx.lineTo(x + rectWidth + arrowWidth, y + rectHeight);
				ctx.lineTo(x + arrowWidth, y + rectHeight);
				ctx.closePath();
			} else if (edge.orient === "left") {
				// x += arrowWidth;
				ctx.moveTo(x, y);
				ctx.lineTo(x + rectWidth, y);
				ctx.lineTo(x + rectWidth + arrowWidth, y + halfHeight);
				ctx.lineTo(x + rectWidth, y + rectHeight);
				ctx.lineTo(x, y + rectHeight);
				ctx.closePath();
			} else {
				// console.error(x, y, rectWidth, rectHeight)
				if (rectRadius) {
					roundRect(ctx, x, y, rectWidth, rectHeight, 3);
				} else {
					ctx.rect(x, y, rectWidth, rectHeight);
				}
			}
			ctx.fill();
	
			if ((0, _utils.isDefined)(edge.coordinateBase.stroke)) {
				ctx.stroke();
			}
	
			ctx.fillStyle = edge.coordinate.textFill;
			ctx.textAlign = edge.coordinate.textAnchor === "middle" ? "center" : edge.coordinate.textAnchor;
			ctx.fillText(edge.coordinate.displayCoordinate, edge.coordinate.edgeXText, edge.coordinate.edgeYText);
		}
	}
	
	function roundRect(ctx, x, y, width, height, radius) {
		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();
	}
	
	// export default EdgeCoordinate;
	//# sourceMappingURL=EdgeCoordinateV3.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.rotateXY = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.identityStack = identityStack;
	exports.drawOnCanvasHelper = drawOnCanvasHelper;
	exports.svgHelper = svgHelper;
	exports.getBarsSVG2 = getBarsSVG2;
	exports.drawOnCanvas2 = drawOnCanvas2;
	exports.getBars = getBars;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Collection = __webpack_require__(38);
	
	var _d3Array = __webpack_require__(21);
	
	var _d3Shape = __webpack_require__(99);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StackedBarSeries = function (_Component) {
		_inherits(StackedBarSeries, _Component);
	
		function StackedBarSeries(props) {
			_classCallCheck(this, StackedBarSeries);
	
			var _this = _possibleConstructorReturn(this, (StackedBarSeries.__proto__ || Object.getPrototypeOf(StackedBarSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(StackedBarSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var xAccessor = moreProps.xAccessor;
				// var { xScale, chartConfig: { yScale }, plotData } = moreProps;
	
				drawOnCanvasHelper(ctx, this.props, moreProps, xAccessor, _d3Shape.stack);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var xAccessor = moreProps.xAccessor;
	
	
				return _react2.default.createElement(
					"g",
					null,
					svgHelper(this.props, moreProps, xAccessor, _d3Shape.stack)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var clip = this.props.clip;
	
	
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: clip,
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}]);
	
		return StackedBarSeries;
	}(_react.Component);
	
	StackedBarSeries.propTypes = {
		baseAt: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
		direction: _propTypes2.default.oneOf(["up", "down"]).isRequired,
		stroke: _propTypes2.default.bool.isRequired,
		width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
		opacity: _propTypes2.default.number.isRequired,
		fill: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
		className: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
		clip: _propTypes2.default.bool.isRequired
	};
	
	StackedBarSeries.defaultProps = {
		baseAt: function baseAt(xScale, yScale /* , d*/) {
			return (0, _utils.head)(yScale.range());
		},
		direction: "up",
		className: "bar",
		stroke: true,
		fill: "#4682B4",
		opacity: 0.5,
		width: _utils.plotDataLengthBarWidth,
		widthRatio: 0.8,
		clip: true,
		swapScales: false
	};
	
	function identityStack() {
		var keys = [];
		function stack(data) {
			var response = keys.map(function (key, i) {
				// eslint-disable-next-line prefer-const
				var arrays = data.map(function (d) {
					// eslint-disable-next-line prefer-const
					var array = [0, d[key]];
					array.data = d;
					return array;
				});
				arrays.key = key;
				arrays.index = i;
				return arrays;
			});
			return response;
		}
		stack.keys = function (x) {
			if (!arguments.length) {
				return keys;
			}
			keys = x;
			return stack;
		};
		return stack;
	}
	
	function drawOnCanvasHelper(ctx, props, moreProps, xAccessor, stackFn) {
		var defaultPostAction = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _utils.identity;
		var postRotateAction = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : rotateXY;
		var xScale = moreProps.xScale,
		    yScale = moreProps.chartConfig.yScale,
		    plotData = moreProps.plotData;
	
	
		var bars = doStuff(props, xAccessor, plotData, xScale, yScale, stackFn, postRotateAction, defaultPostAction);
	
		drawOnCanvas2(props, ctx, bars);
	}
	
	function convertToArray(item) {
		return Array.isArray(item) ? item : [item];
	}
	
	function svgHelper(props, moreProps, xAccessor, stackFn) {
		var defaultPostAction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _utils.identity;
		var postRotateAction = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : rotateXY;
		var xScale = moreProps.xScale,
		    yScale = moreProps.chartConfig.yScale,
		    plotData = moreProps.plotData;
	
		var bars = doStuff(props, xAccessor, plotData, xScale, yScale, stackFn, postRotateAction, defaultPostAction);
		return getBarsSVG2(props, bars);
	}
	
	function doStuff(props, xAccessor, plotData, xScale, yScale, stackFn, postRotateAction, defaultPostAction) {
		var yAccessor = props.yAccessor,
		    swapScales = props.swapScales;
	
	
		var modifiedYAccessor = swapScales ? convertToArray(props.xAccessor) : convertToArray(yAccessor);
		var modifiedXAccessor = swapScales ? yAccessor : xAccessor;
	
		var modifiedXScale = swapScales ? yScale : xScale;
		var modifiedYScale = swapScales ? xScale : yScale;
	
		var postProcessor = swapScales ? postRotateAction : defaultPostAction;
	
		var bars = getBars(props, modifiedXAccessor, modifiedYAccessor, modifiedXScale, modifiedYScale, plotData, stackFn, postProcessor);
	
		return bars;
	}
	
	var rotateXY = exports.rotateXY = function rotateXY(array) {
		return array.map(function (each) {
			return _extends({}, each, {
				x: each.y,
				y: each.x,
				height: each.width,
				width: each.height
			});
		});
	};
	
	function getBarsSVG2(props, bars) {
		/* eslint-disable react/prop-types */
		var opacity = props.opacity;
		/* eslint-enable react/prop-types */
	
		return bars.map(function (d, idx) {
			if (d.width <= 1) {
				return _react2.default.createElement("line", { key: idx, className: d.className,
					stroke: d.fill,
					x1: d.x, y1: d.y,
					x2: d.x, y2: d.y + d.height });
			}
			return _react2.default.createElement("rect", { key: idx, className: d.className,
				stroke: d.stroke,
				fill: d.fill,
				x: d.x,
				y: d.y,
				width: d.width,
				fillOpacity: opacity,
				height: d.height });
		});
	}
	
	function drawOnCanvas2(props, ctx, bars) {
		var stroke = props.stroke;
	
	
		var nest = (0, _d3Collection.nest)().key(function (d) {
			return d.fill;
		}).entries(bars);
	
		nest.forEach(function (outer) {
			var key = outer.key,
			    values = outer.values;
	
			if ((0, _utils.head)(values).width > 1) {
				ctx.strokeStyle = key;
			}
			var fillStyle = (0, _utils.head)(values).width <= 1 ? key : (0, _utils.hexToRGBA)(key, props.opacity);
			ctx.fillStyle = fillStyle;
	
			values.forEach(function (d) {
				if (d.width <= 1) {
					/* <line key={idx} className={d.className}
	    			stroke={stroke}
	    			fill={fill}
	    			x1={d.x} y1={d.y}
	    			x2={d.x} y2={d.y + d.height} />*/
					/*
	    ctx.beginPath();
	    ctx.moveTo(d.x, d.y);
	    ctx.lineTo(d.x, d.y + d.height);
	    ctx.stroke();
	    */
					ctx.fillRect(d.x - 0.5, d.y, 1, d.height);
				} else {
					/* <rect key={idx} className={d.className}
	    		stroke={stroke}
	    		fill={fill}
	    		x={d.x}
	    		y={d.y}
	    		width={d.width}
	    		height={d.height} /> */
					/*
	    ctx.beginPath();
	    ctx.rect(d.x, d.y, d.width, d.height);
	    ctx.fill();
	    */
					ctx.fillRect(d.x, d.y, d.width, d.height);
					if (stroke) ctx.strokeRect(d.x, d.y, d.width, d.height);
				}
			});
		});
	}
	
	function getBars(props, xAccessor, yAccessor, xScale, yScale, plotData) {
		var stack = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : identityStack;
		var after = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : _utils.identity;
		var baseAt = props.baseAt,
		    className = props.className,
		    fill = props.fill,
		    stroke = props.stroke,
		    _props$spaceBetweenBa = props.spaceBetweenBar,
		    spaceBetweenBar = _props$spaceBetweenBa === undefined ? 0 : _props$spaceBetweenBa;
	
	
		var getClassName = (0, _utils.functor)(className);
		var getFill = (0, _utils.functor)(fill);
		var getBase = (0, _utils.functor)(baseAt);
	
		var widthFunctor = (0, _utils.functor)(props.width);
		var width = widthFunctor(props, {
			xScale: xScale,
			xAccessor: xAccessor,
			plotData: plotData
		});
	
		var barWidth = Math.round(width);
	
		var eachBarWidth = (barWidth - spaceBetweenBar * (yAccessor.length - 1)) / yAccessor.length;
	
		var offset = barWidth === 1 ? 0 : 0.5 * width;
	
		var ds = plotData.map(function (each) {
			// eslint-disable-next-line prefer-const
			var d = {
				appearance: {},
				x: xAccessor(each)
			};
			yAccessor.forEach(function (eachYAccessor, i) {
				var key = "y" + i;
				d[key] = eachYAccessor(each);
				var appearance = {
					className: getClassName(each, i),
					stroke: stroke ? getFill(each, i) : "none",
					fill: getFill(each, i)
				};
				d.appearance[key] = appearance;
			});
			return d;
		});
	
		var keys = yAccessor.map(function (_, i) {
			return "y" + i;
		});
	
		// console.log(ds);
	
		var data = stack().keys(keys)(ds);
	
		// console.log(data);
	
		var newData = data.map(function (each, i) {
			var key = each.key;
			return each.map(function (d) {
				// eslint-disable-next-line prefer-const
				var array = [d[0], d[1]];
				array.data = {
					x: d.data.x,
					i: i,
					appearance: d.data.appearance[key]
				};
				return array;
			});
		});
		// console.log(newData);
		// console.log(merge(newData));
	
		var bars = (0, _d3Array.merge)(newData)
		// .filter(d => isDefined(d.y))
		.map(function (d) {
			// let baseValue = yScale.invert(getBase(xScale, yScale, d.datum));
			var y = yScale(d[1]);
			/* let h = isDefined(d.y0) && d.y0 !== 0 && !isNaN(d.y0)
	  		? yScale(d.y0) - y
	  		: getBase(xScale, yScale, d.datum) - yScale(d.y)*/
			var h = getBase(xScale, yScale, d.data) - yScale(d[1] - d[0]);
			// console.log(d.y, yScale.domain(), yScale.range())
			// let h = ;
			// if (d.y < 0) h = -h;
			// console.log(d, y, h)
			if (h < 0) {
				y = y + h;
				h = -h;
			}
			// console.log(d.data.i, Math.round(offset - (d.data.i > 0 ? (eachBarWidth + spaceBetweenBar) * d.data.i : 0)))
			/* console.log(d.series, d.datum.date, d.x,
	  		getBase(xScale, yScale, d.datum), `d.y=${d.y}, d.y0=${d.y0}, y=${y}, h=${h}`)*/
			return _extends({}, d.data.appearance, {
				// series: d.series,
				// i: d.x,
				x: Math.round(xScale(d.data.x) - width / 2),
				y: y,
				groupOffset: Math.round(offset - (d.data.i > 0 ? (eachBarWidth + spaceBetweenBar) * d.data.i : 0)),
				groupWidth: Math.round(eachBarWidth),
				offset: Math.round(offset),
				height: h,
				width: barWidth
			});
		}).filter(function (bar) {
			return !isNaN(bar.y);
		});
	
		return after(bars);
	}
	
	exports.default = StackedBarSeries;
	//# sourceMappingURL=StackedBarSeries.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.elementContextTypes = exports.injectContextTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Provider = __webpack_require__(168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var injectContextTypes = exports.injectContextTypes = {
	  getRegisteredElements: _propTypes2.default.func.isRequired
	};
	
	var elementContextTypes = exports.elementContextTypes = {
	  addElementsLoadListener: _propTypes2.default.func.isRequired,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired
	};
	
	var Elements = function (_React$Component) {
	  _inherits(Elements, _React$Component);
	
	  function Elements(props, context) {
	    _classCallCheck(this, Elements);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRegisterElement = function (type, element) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [{ type: type, element: element }])
	        };
	      });
	    };
	
	    _this.handleUnregisterElement = function (el) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: prevState.registeredElements.filter(function (_ref) {
	            var element = _ref.element;
	            return element !== el;
	          })
	        };
	      });
	    };
	
	    _this.state = {
	      registeredElements: []
	    };
	    return _this;
	  }
	
	  Elements.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    return {
	      addElementsLoadListener: function addElementsLoadListener(fn) {
	        // Return the existing elements instance if we already have one.
	        if (_this2._elements) {
	          fn(_this2._elements);
	          return;
	        }
	
	        var _props = _this2.props,
	            children = _props.children,
	            options = _objectWithoutProperties(_props, ['children']);
	
	        if (_this2.context.tag === 'sync') {
	          _this2._elements = _this2.context.stripe.elements(options);
	          fn(_this2._elements);
	        } else {
	          _this2.context.addStripeLoadListener(function (stripe) {
	            if (_this2._elements) {
	              fn(_this2._elements);
	            } else {
	              _this2._elements = stripe.elements(options);
	              fn(_this2._elements);
	            }
	          });
	        }
	      },
	      registerElement: this.handleRegisterElement,
	      unregisterElement: this.handleUnregisterElement,
	      getRegisteredElements: function getRegisteredElements() {
	        return _this2.state.registeredElements;
	      }
	    };
	  };
	
	  Elements.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Elements;
	}(_react2.default.Component);
	
	Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
	Elements.contextTypes = _Provider.providerContextTypes;
	Elements.defaultProps = {
	  children: null
	};
	exports.default = Elements;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ROUTE_STOP = exports.ROUTE_PLAY = exports.ROUTE_MASTER_UNLOAD = exports.ROUTE_MASTER_CHANGED = exports.ROUTE_CHANGED = undefined;
	exports.routeChanged = routeChanged;
	exports.watchMasterRoute = watchMasterRoute;
	exports.ignoreMasterRoute = ignoreMasterRoute;
	exports.routePlay = routePlay;
	exports.routeStop = routeStop;
	
	var _Api = __webpack_require__(52);
	
	// route
	var ROUTE_CHANGED = exports.ROUTE_CHANGED = 'ROUTE_CHANGED'; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var ROUTE_MASTER_CHANGED = exports.ROUTE_MASTER_CHANGED = 'ROUTE_MASTER_CHANGED';
	var ROUTE_MASTER_UNLOAD = exports.ROUTE_MASTER_UNLOAD = 'ROUTE_MASTER_UNLOAD';
	var ROUTE_PLAY = exports.ROUTE_PLAY = 'ROUTE_PLAY';
	var ROUTE_STOP = exports.ROUTE_STOP = 'ROUTE_STOP';
	
	var ROUTE_WATCH = 'route';
	
	function routeChanged(location, publish) {
	  return function (dispatch) {
	    // publish first to preserve order of changes
	    if (publish) {
	      (0, _Api.postRoute)({ category: 'route', pathname: location.pathname });
	    }
	    dispatch({ type: ROUTE_CHANGED, location: location, at: new Date() });
	  };
	}
	
	function watchMasterRoute() {
	  return function (dispatch) {
	    (0, _Api.watchItem)(ROUTE_WATCH, '/rest/route/1', function (masterRoute) {
	      dispatch({ type: ROUTE_MASTER_CHANGED, masterRoute: masterRoute });
	    }, function (error) {
	      return console.log('!!! watchMasterRoute catch', error);
	    });
	  };
	}
	
	function ignoreMasterRoute() {
	  return function (dispatch) {
	    (0, _Api.stopWatching)(ROUTE_WATCH, true);
	    dispatch({ type: ROUTE_MASTER_UNLOAD });
	  };
	}
	
	function routePlay() {
	  return { type: ROUTE_PLAY };
	}
	
	function routeStop() {
	  return { type: ROUTE_STOP };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ROUTE_CHANGED, 'ROUTE_CHANGED', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(ROUTE_MASTER_CHANGED, 'ROUTE_MASTER_CHANGED', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(ROUTE_MASTER_UNLOAD, 'ROUTE_MASTER_UNLOAD', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(ROUTE_PLAY, 'ROUTE_PLAY', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(ROUTE_STOP, 'ROUTE_STOP', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(ROUTE_WATCH, 'ROUTE_WATCH', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(routeChanged, 'routeChanged', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(watchMasterRoute, 'watchMasterRoute', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(ignoreMasterRoute, 'ignoreMasterRoute', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(routePlay, 'routePlay', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	
	  __REACT_HOT_LOADER__.register(routeStop, 'routeStop', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/route.js');
	}();

	;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UPDATE_SIGNUP_USER_LOCATION = exports.UPDATE_USER_LOCATION = undefined;
	exports.updateProfile = updateProfile;
	exports.updateUserLocation = updateUserLocation;
	exports.updateSignUpUserLocation = updateSignUpUserLocation;
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Api = __webpack_require__(52);
	
	var _actions = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UPDATE_USER_LOCATION = exports.UPDATE_USER_LOCATION = 'UPDATE_USER_LOCATION'; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var UPDATE_SIGNUP_USER_LOCATION = exports.UPDATE_SIGNUP_USER_LOCATION = 'UPDATE_SIGNUP_USER_LOCATION';
	// status
	
	
	function updateProfile(profileData) {
	    return function (dispatch) {
	        (0, _Api.updateProfileApi)(localStorage.userId, profileData).then(function (response) {
	            // console.log('updateProfileApi::', response)
	            if (response && response.data) {
	                dispatch({ type: _actions.SAVE_USERPROFILE, result: response.data });
	                if (response.data.passwordUpdated) {
	                    alert(_Constants2.default.MESSAGES.SUCCESS.USER_PASSWORD_UPDATED);
	                    dispatch((0, _actions.sessionLogout)());
	                } else alert(_Constants2.default.MESSAGES.SUCCESS.USER_PROFILE_UPDATED);
	            } else if (response && response.error) {
	                if (typeof response.error === "string") {
	                    alert(response.error);
	                } else {
	                    alert(_Constants2.default.MESSAGES.ERROR.GENERAL_ERROR);
	                }
	            }
	        }).catch(function (error) {
	            // console.log('error::', error)
	        });
	    };
	}
	
	function updateUserLocation(obj) {
	    return {
	        type: UPDATE_USER_LOCATION,
	        result: obj
	    };
	}
	
	function updateSignUpUserLocation(obj) {
	    return {
	        type: UPDATE_SIGNUP_USER_LOCATION,
	        result: obj
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(UPDATE_USER_LOCATION, 'UPDATE_USER_LOCATION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/settings.js');
	
	    __REACT_HOT_LOADER__.register(UPDATE_SIGNUP_USER_LOCATION, 'UPDATE_SIGNUP_USER_LOCATION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/settings.js');
	
	    __REACT_HOT_LOADER__.register(updateProfile, 'updateProfile', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/settings.js');
	
	    __REACT_HOT_LOADER__.register(updateUserLocation, 'updateUserLocation', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/settings.js');
	
	    __REACT_HOT_LOADER__.register(updateSignUpUserLocation, 'updateSignUpUserLocation', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/settings.js');
	}();

	;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _actions = __webpack_require__(13);
	
	var _Api = __webpack_require__(52);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var EditControls = function (_Component) {
	  _inherits(EditControls, _Component);
	
	  function EditControls(props) {
	    _classCallCheck(this, EditControls);
	
	    var _this = _possibleConstructorReturn(this, (EditControls.__proto__ || Object.getPrototypeOf(EditControls)).call(this, props));
	
	    _this.state = {
	      selectOptions: []
	    };
	
	    return _this;
	  }
	
	  _createClass(EditControls, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      if (this.props.controlType == _Constants2.default.TWIG_EDIT_CONTROLS.SENSOR_TYPE) {
	        var selectOptions = [];
	        for (var key in this.props.selectedTwig.details.data) {
	          selectOptions.push({
	            value: key,
	            label: this.props.selectedTwig.details.data[key].label
	          });
	        }
	        this.setState({
	          selectOptions: selectOptions
	        });
	      } else if (this.props.controlType == _Constants2.default.TWIG_EDIT_CONTROLS.SELECT) {
	        (0, _Api.getValuesFromParseClass)(this.props.parseClass, this.props.hasUser).then(function (response) {
	
	          var selectOptions = [];
	          for (var i = 0; i < response.data.length; i++) {
	            selectOptions.push({
	              value: response.data[i],
	              label: response.data[i]
	            });
	          }
	          _this2.setState({
	            selectOptions: selectOptions,
	            value: selectOptions[0].value
	          });
	          _this2.props.isCreate ? _this2.props.controlValueChange({ key: _this2.props.controlKey }, response.data[0]) : '';
	        }).catch(function (error) {
	          // console.log('error::', error)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var controlType = this.props.controlType;
	      var toRender = null;
	      var controlInfo = {
	        key: this.props.controlKey,
	        controlType: controlType
	      };
	      switch (controlType) {
	        case _Constants2.default.TWIG_EDIT_CONTROLS.BOOLEAN:
	
	          toRender = _react2.default.createElement(_CheckBox2.default, {
	            defaultChecked: this.props.value,
	            onChange: this.props.controlValueChange.bind(this, controlInfo),
	            toggle: false,
	            disabled: false,
	            reverse: false });
	
	          break;
	        case _Constants2.default.TWIG_EDIT_CONTROLS.TEXT:
	          toRender = _react2.default.createElement('input', { name: this.props.name ? this.props.name : '', className: 'maxwidth', type: _Constants2.default.TWIG_EDIT_CONTROLS.TEXT, onChange: this.props.controlValueChange.bind(this, controlInfo), value: this.props.value });
	          break;
	        case _Constants2.default.TWIG_EDIT_CONTROLS.NUMBER:
	          toRender = _react2.default.createElement('input', { className: 'maxwidth', type: 'text', onChange: this.props.controlValueChange.bind(this, controlInfo), defaultValue: this.props.value });
	          break;
	        case _Constants2.default.TWIG_EDIT_CONTROLS.SELECT:
	        case _Constants2.default.TWIG_EDIT_CONTROLS.SENSOR_TYPE:
	          toRender = _react2.default.createElement(
	            'select',
	            { className: 'maxwidth', name: '', id: '', defaultValue: this.props.value, value: this.props.value, onChange: this.props.controlValueChange.bind(this, controlInfo) },
	            this.state.selectOptions.map(function (item, index) {
	              return _react2.default.createElement(
	                'option',
	                { key: index, value: item.value },
	                item.label
	              );
	            })
	          );
	          break;
	        default:
	          break;
	
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item maxwidth' },
	        _react2.default.createElement(
	          'div',
	          { className: 'label inlineblock' },
	          this.props.label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'control inlineblock' },
	          toRender
	        )
	      );
	    }
	  }]);
	
	  return EditControls;
	}(_react.Component);
	
	// let select = (state, props) => ({
	//   twigsList: state.locationView.twigsList,
	//   selectedTwig: state.locationView.selectedTwig,
	//   selectedTwigIndex: state.locationView.selectedTwigIndex,
	// });
	
	var _default = EditControls;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditControls, 'EditControls', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Controls.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Controls.js');
	}();

	;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dispatch/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var noop = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	exports.dispatch = dispatch;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _google_map = __webpack_require__(478);
	
	var _google_map2 = _interopRequireDefault(_google_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _google_map2.default;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Drop = __webpack_require__(87);
	
	var _Drop2 = _interopRequireDefault(_Drop);
	
	var _DOM = __webpack_require__(47);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Clock = __webpack_require__(509);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Calendar = __webpack_require__(507);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _DateTimeDrop = __webpack_require__(495);
	
	var _DateTimeDrop2 = _interopRequireDefault(_DateTimeDrop);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.DATE_TIME;
	var INPUT = _CSSClassnames2.default.INPUT;
	var FORM_FIELD = _CSSClassnames2.default.FORM_FIELD;
	var DATE_TIME_DROP = _CSSClassnames2.default.DATE_TIME_DROP;
	
	var FORMATS = {
	  M: 'months',
	  D: 'days',
	  Y: 'years',
	  H: 'hours',
	  h: 'hours',
	  m: 'minutes',
	  s: 'seconds'
	};
	var TIME_REGEXP = new RegExp('[Hhmsa]');
	
	var DateTime = function (_Component) {
	  _inherits(DateTime, _Component);
	
	  function DateTime(props, context) {
	    _classCallCheck(this, DateTime);
	
	    var _this = _possibleConstructorReturn(this, (DateTime.__proto__ || Object.getPrototypeOf(DateTime)).call(this, props, context));
	
	    _this._onInputChange = _this._onInputChange.bind(_this);
	    _this._onOpen = _this._onOpen.bind(_this);
	    _this._onForceClose = _this._onForceClose.bind(_this);
	    _this._onControlClick = _this._onControlClick.bind(_this);
	    _this._onClose = _this._onClose.bind(_this);
	    _this._onNext = _this._onNext.bind(_this);
	    _this._onPrevious = _this._onPrevious.bind(_this);
	    _this._cursorScope = _this._cursorScope.bind(_this);
	    _this._notify = _this._notify.bind(_this);
	
	    _this.state = _this._stateFromProps(props);
	    _this.state.cursor = -1;
	    _this.state.dropActive = false;
	    return _this;
	  }
	
	  _createClass(DateTime, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._activation(this.state.dropActive);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      this.setState(this._stateFromProps(newProps));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _state = this.state,
	          cursor = _state.cursor,
	          dropActive = _state.dropActive;
	      // Set up keyboard listeners appropriate to the current state.
	
	      if (prevState.dropActive !== dropActive) {
	        this._activation(dropActive);
	      }
	
	      if (dropActive) {
	        this._drop.render(this._renderDrop());
	      }
	
	      if (cursor >= 0) {
	        this._inputRef.setSelectionRange(cursor, cursor);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._activation(false);
	    }
	  }, {
	    key: '_stateFromProps',
	    value: function _stateFromProps(props) {
	      var value = props.value,
	          format = props.format;
	
	      var result = { current: undefined };
	      var date = (0, _moment2.default)(value, format);
	      if (date.isValid()) {
	        result.current = date;
	        result.textValue = undefined;
	      } else {
	        result.current = (0, _moment2.default)().startOf('hour').add(1, 'hour');
	      }
	      // figure out which scope the step should apply to
	      if (format.indexOf('s') !== -1) {
	        result.stepScope = 'second';
	      } else if (format.indexOf('m') !== -1) {
	        result.stepScope = 'minute';
	      } else if (format.indexOf('h') !== -1) {
	        result.stepScope = 'hour';
	      }
	      return result;
	    }
	  }, {
	    key: '_onInputChange',
	    value: function _onInputChange(event) {
	      var onChange = this.props.onChange;
	
	      var currentValue = event.target.value;
	      // Always set textValue to what the user types.
	      // If the user subsequently passes in a value property, we will
	      // clear this textValue and use the new value.
	      this.setState({ textValue: currentValue });
	      if (onChange) {
	        onChange(currentValue);
	      }
	    }
	  }, {
	    key: '_notify',
	    value: function _notify(date, checkClose) {
	      var _props = this.props,
	          format = _props.format,
	          onChange = _props.onChange;
	
	      if (onChange) {
	        onChange(date);
	        if (checkClose && !TIME_REGEXP.test(format)) {
	          // check to close the drop only if the user selected a day
	          // and the format of the date does not include time
	          this.setState({ dropActive: false, cursor: -1 });
	        }
	      }
	    }
	  }, {
	    key: '_onControlClick',
	    value: function _onControlClick(event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (this.state.dropActive) {
	        this.setState({ dropActive: false, cursor: -1 });
	      } else {
	        this.setState({ dropActive: true });
	      }
	    }
	  }, {
	    key: '_onForceClose',
	    value: function _onForceClose() {
	      this.setState({ dropActive: false, cursor: -1 });
	    }
	  }, {
	    key: '_onOpen',
	    value: function _onOpen(event) {
	      event.preventDefault();
	      this.setState({ dropActive: true });
	    }
	  }, {
	    key: '_onClose',
	    value: function _onClose(event) {
	      var dropElement = document.querySelector('.' + DATE_TIME_DROP);
	      if (!(0, _DOM.isDescendant)(this._containerRef, event.target) && (!dropElement || !(0, _DOM.isDescendant)(dropElement, event.target))) {
	        this.setState({ dropActive: false, cursor: -1 });
	      }
	    }
	  }, {
	    key: '_onNext',
	    value: function _onNext(event) {
	      if (this._inputRef === document.activeElement) {
	        var step = this.props.step;
	        var current = this.state.current;
	
	        event.preventDefault();
	        var date = current.clone();
	        var scope = this._cursorScope();
	        if ('a' === scope) {
	          if (date.hours() < 12) {
	            date.add(12, 'hours');
	          }
	        } else if ('m' === scope) {
	          date.add(step, FORMATS[scope]);
	        } else {
	          date.add(1, FORMATS[scope]);
	        }
	        this.setState({ current: date }, this._notify(date));
	      }
	    }
	  }, {
	    key: '_onPrevious',
	    value: function _onPrevious(event) {
	      if (this._inputRef === document.activeElement) {
	        var step = this.props.step;
	        var current = this.state.current;
	
	        event.preventDefault();
	        var date = current.clone();
	        var scope = this._cursorScope();
	        if ('a' === scope) {
	          if (date.hours() >= 12) {
	            date.subtract(12, 'hours');
	          }
	        } else if ('m' === scope) {
	          date.subtract(step, FORMATS[scope]);
	        } else {
	          date.subtract(1, FORMATS[scope]);
	        }
	        this.setState({ current: date }, this._notify(date));
	      }
	    }
	  }, {
	    key: '_cursorScope',
	    value: function _cursorScope() {
	      var format = this.props.format;
	
	      var input = this._inputRef;
	      var value = input.value;
	      var end = input.selectionEnd;
	      this.setState({ cursor: end });
	      // Figure out which aspect of the date the cursor is on, so we know what
	      // to change.
	      var preDate = (0, _moment2.default)(value.slice(0, end + 1), format);
	      var formatTokens = format.split(/[^A-Za-z]/);
	      var unusedTokens = preDate.parsingFlags().unusedTokens;
	      var index = -1;
	      while (formatTokens[index + 1] !== unusedTokens[0]) {
	        index += 1;
	      }
	      return formatTokens[index][0];
	    }
	  }, {
	    key: '_activation',
	    value: function _activation(dropActive) {
	      var onDropChange = this.context.onDropChange;
	
	
	      var listeners = {
	        esc: this._onForceClose,
	        up: this._onPrevious,
	        down: this._onNext
	      };
	
	      if (dropActive) {
	
	        document.addEventListener('click', this._onClose);
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, listeners);
	
	        // If this is inside a FormField, place the drop in reference to it.
	        var control = (0, _DOM.findAncestor)(this._containerRef, '.' + FORM_FIELD) || this._containerRef;
	        this._drop = new _Drop2.default(control, this._renderDrop(), {
	          align: { top: 'bottom', left: 'left' },
	          focusControl: true,
	          context: this.context
	        });
	      } else {
	
	        document.removeEventListener('click', this._onClose);
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, listeners);
	
	        if (this._drop) {
	          this._drop.remove();
	          this._drop = undefined;
	        }
	      }
	
	      if (onDropChange) {
	        onDropChange(dropActive);
	      }
	    }
	  }, {
	    key: '_renderDrop',
	    value: function _renderDrop() {
	      var _props2 = this.props,
	          format = _props2.format,
	          step = _props2.step;
	      var current = this.state.current;
	
	      return _react2.default.createElement(_DateTimeDrop2.default, { format: format, value: current,
	        step: step, onChange: this._notify });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          className = _props3.className,
	          format = _props3.format,
	          value = _props3.value,
	          props = _objectWithoutProperties(_props3, ['className', 'format', 'value']);
	
	      delete props.onChange;
	      delete props.step;
	      var _state2 = this.state,
	          dropActive = _state2.dropActive,
	          textValue = _state2.textValue;
	      var intl = this.context.intl;
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--active', dropActive), className);
	
	      var inputValue = textValue || value;
	      if (value instanceof Date) {
	        inputValue = (0, _moment2.default)(value).format(format);
	      } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        inputValue = value.format(format);
	      }
	      var Icon = TIME_REGEXP.test(format) ? _Clock2.default : _Calendar2.default;
	
	      var dateTimeIconMessage = _Intl2.default.getMessage(intl, 'Date Time Icon');
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(_ref2) {
	            return _this2._containerRef = _ref2;
	          }, className: classes },
	        _react2.default.createElement('input', _extends({ ref: function ref(_ref) {
	            return _this2._inputRef = _ref;
	          } }, props, {
	          className: INPUT + ' ' + CLASS_ROOT + '__input', placeholder: format,
	          value: inputValue || '', onChange: this._onInputChange })),
	        _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__control', icon: _react2.default.createElement(Icon, null),
	          a11yTitle: dateTimeIconMessage,
	          onClick: this._onControlClick })
	      );
	    }
	  }]);
	
	  return DateTime;
	}(_react.Component);
	
	DateTime.displayName = 'DateTime';
	exports.default = DateTime;
	
	
	DateTime.contextTypes = {
	  intl: _propTypes2.default.object,
	  onDropChange: _propTypes2.default.func
	};
	
	DateTime.defaultProps = {
	  format: 'M/D/YYYY h:mm a',
	  step: 1
	};
	
	DateTime.propTypes = {
	  format: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  step: _propTypes2.default.number,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _classnames3 = __webpack_require__(6);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _DOM = __webpack_require__(47);
	
	var _Drop = __webpack_require__(87);
	
	var _Drop2 = _interopRequireDefault(_Drop);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Responsive = __webpack_require__(88);
	
	var _Responsive2 = _interopRequireDefault(_Responsive);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Down = __webpack_require__(195);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	var _More = __webpack_require__(512);
	
	var _More2 = _interopRequireDefault(_More);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.MENU;
	
	function isFunction(obj) {
	  return obj && obj.constructor && obj.call && obj.apply;
	}
	
	// We have a separate module for the drop component
	// so we can transfer the router context.
	
	var MenuDrop = function (_Component) {
	  _inherits(MenuDrop, _Component);
	
	  function MenuDrop(props, context) {
	    _classCallCheck(this, MenuDrop);
	
	    var _this = _possibleConstructorReturn(this, (MenuDrop.__proto__ || Object.getPrototypeOf(MenuDrop)).call(this, props, context));
	
	    _this._onUpKeyPress = _this._onUpKeyPress.bind(_this);
	    _this._onDownKeyPress = _this._onDownKeyPress.bind(_this);
	    _this._processTab = _this._processTab.bind(_this);
	    return _this;
	  }
	
	  _createClass(MenuDrop, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        intl: this.props.intl,
	        history: this.props.history,
	        router: this.props.router,
	        store: this.props.store
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._originalFocusedElement = document.activeElement;
	      this._keyboardHandlers = {
	        tab: this._processTab,
	        up: this._onUpKeyPress,
	        left: this._onUpKeyPress,
	        down: this._onDownKeyPress,
	        right: this._onDownKeyPress
	      };
	      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._originalFocusedElement.focus) {
	        this._originalFocusedElement.focus();
	      } else if (this._originalFocusedElement.parentNode && this._originalFocusedElement.parentNode.focus) {
	        // required for IE11 and Edge
	        this._originalFocusedElement.parentNode.focus();
	      }
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	    }
	  }, {
	    key: '_processTab',
	    value: function _processTab(event) {
	      var container = (0, _reactDom.findDOMNode)(this.menuDropRef);
	      var items = container.getElementsByTagName('*');
	      items = (0, _DOM.filterByFocusable)(items);
	
	      if (!items || items.length === 0) {
	        event.preventDefault();
	      } else {
	        if (event.shiftKey) {
	          if (event.target === items[0]) {
	            items[items.length - 1].focus();
	            event.preventDefault();
	          }
	        } else if (event.target === items[items.length - 1]) {
	          items[0].focus();
	          event.preventDefault();
	        }
	      }
	    }
	  }, {
	    key: '_onUpKeyPress',
	    value: function _onUpKeyPress(event) {
	      event.preventDefault();
	      var container = (0, _reactDom.findDOMNode)(this.navContainerRef);
	      var menuItems = container.childNodes;
	      if (!this.activeMenuItem) {
	        var lastMenuItem = menuItems[menuItems.length - 1];
	        this.activeMenuItem = lastMenuItem;
	      } else if (this.activeMenuItem.previousSibling) {
	        this.activeMenuItem = this.activeMenuItem.previousSibling;
	      }
	
	      var classes = this.activeMenuItem.className.split(/\s+/);
	      var tagName = this.activeMenuItem.tagName.toLowerCase();
	      // want to skip items of the menu that are not focusable.
	      if (tagName !== 'button' && tagName !== 'a' && classes.indexOf('check-box') === -1) {
	        if (this.activeMenuItem === menuItems[0]) {
	          return true;
	        } else {
	          // If this item is not focusable, check the next item.
	          return this._onUpKeyPress(event);
	        }
	      }
	
	      this.activeMenuItem.focus();
	      // Stops KeyboardAccelerators from calling the other listeners.
	      // Works limilar to event.stopPropagation().
	      return true;
	    }
	  }, {
	    key: '_onDownKeyPress',
	    value: function _onDownKeyPress(event) {
	      event.preventDefault();
	      var container = (0, _reactDom.findDOMNode)(this.navContainerRef);
	      var menuItems = container.childNodes;
	      if (!this.activeMenuItem) {
	        this.activeMenuItem = menuItems[0];
	      } else if (this.activeMenuItem.nextSibling) {
	        this.activeMenuItem = this.activeMenuItem.nextSibling;
	      }
	
	      var classes = this.activeMenuItem.className.split(/\s+/);
	      var tagName = this.activeMenuItem.tagName.toLowerCase();
	      // want to skip items of the menu that are not focusable.
	      if (tagName !== 'button' && tagName !== 'a' && classes.indexOf('check-box') === -1) {
	        if (this.activeMenuItem === menuItems[menuItems.length - 1]) {
	          return true;
	        } else {
	          // If this item is not focusable, check the next item.
	          return this._onDownKeyPress(event);
	        }
	      }
	
	      this.activeMenuItem.focus();
	      // Stops KeyboardAccelerators from calling the other listeners.
	      // Works limilar to event.stopPropagation().
	      return true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this,
	          _classnames;
	
	      var _props = this.props,
	          dropAlign = _props.dropAlign,
	          size = _props.size,
	          children = _props.children,
	          control = _props.control,
	          colorIndex = _props.colorIndex,
	          onClick = _props.onClick,
	          props = _objectWithoutProperties(_props, ['dropAlign', 'size', 'children', 'control', 'colorIndex', 'onClick']);
	
	      var restProps = _Props2.default.omit(props, [].concat(_toConsumableArray(Object.keys(MenuDrop.childContextTypes)), _toConsumableArray(Object.keys(MenuDrop.propTypes))));
	
	      // Put nested Menus inline
	      var menuDropChildren = _react2.default.Children.map(children, function (child) {
	        var result = child;
	        if (child && isFunction(child.type) && child.type.prototype._renderMenuDrop) {
	          result = _react2.default.cloneElement(child, { inline: 'expanded', direction: 'column' });
	        }
	        return result;
	      });
	
	      var contents = [_react2.default.createElement(
	        _Box2.default,
	        _extends({}, restProps, { key: 'nav', ref: function ref(_ref) {
	            return _this2.navContainerRef = _ref;
	          },
	          tag: 'nav', className: CLASS_ROOT + '__contents',
	          primary: false }),
	        menuDropChildren
	      )];
	
	      // do not show the control if menu doesn't overlap with it when expanded
	      var showControl = ('top' === dropAlign.top || 'bottom' === dropAlign.bottom) && ('left' === dropAlign.left || 'right' === dropAlign.right);
	
	      if (showControl) {
	        contents.unshift(_react2.default.cloneElement(control, { key: 'control', fill: true }));
	      }
	
	      if (dropAlign.bottom) {
	        contents.reverse();
	      }
	
	      var classes = (0, _classnames4.default)(CLASS_ROOT + '__drop', (_classnames = {}, _defineProperty(_classnames, this.props.className + '__drop', this.props.className), _defineProperty(_classnames, CLASS_ROOT + '__drop--align-right', dropAlign.right), _defineProperty(_classnames, CLASS_ROOT + '__drop--' + size, size), _classnames));
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { ref: function ref(_ref2) {
	            return _this2.menuDropRef = _ref2;
	          }, className: classes,
	          colorIndex: colorIndex, onClick: onClick, focusable: false },
	        contents
	      );
	    }
	  }]);
	
	  return MenuDrop;
	}(_react.Component);
	
	MenuDrop.displayName = 'MenuDrop';
	
	
	MenuDrop.propTypes = _extends({
	  control: _propTypes2.default.node,
	  dropAlign: _Drop.dropAlignPropType,
	  dropColorIndex: _propTypes2.default.string,
	  onClick: _propTypes2.default.func.isRequired,
	  router: _propTypes2.default.any,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  store: _propTypes2.default.any
	}, _Box2.default.propTypes);
	
	MenuDrop.childContextTypes = {
	  history: _propTypes2.default.any,
	  intl: _propTypes2.default.any,
	  router: _propTypes2.default.any,
	  store: _propTypes2.default.any
	};
	
	var Menu = function (_Component2) {
	  _inherits(Menu, _Component2);
	
	  function Menu(props, context) {
	    _classCallCheck(this, Menu);
	
	    var _this3 = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props, context));
	
	    _this3._onOpen = _this3._onOpen.bind(_this3);
	    _this3._onClose = _this3._onClose.bind(_this3);
	    _this3._checkOnClose = _this3._checkOnClose.bind(_this3);
	    _this3._onSink = _this3._onSink.bind(_this3);
	    _this3._onResponsive = _this3._onResponsive.bind(_this3);
	    _this3._onFocusControl = _this3._onFocusControl.bind(_this3);
	    _this3._onBlurControl = _this3._onBlurControl.bind(_this3);
	
	    var inline = void 0;
	    if (props.hasOwnProperty('inline')) {
	      inline = props.inline;
	    } else {
	      inline = !props.label && !props.icon;
	    }
	    var responsive = void 0;
	    if (props.hasOwnProperty('responsive')) {
	      responsive = props.responsive;
	    } else {
	      responsive = inline && 'row' === props.direction;
	    }
	    _this3.state = {
	      // state may be 'collapsed', 'focused' or 'expanded' (active).
	      state: 'collapsed',
	      initialInline: inline,
	      inline: inline,
	      responsive: responsive
	    };
	    return _this3;
	  }
	
	  _createClass(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.responsive) {
	        this._responsive = _Responsive2.default.start(this._onResponsive);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.inline !== nextProps.inline || this.props.icon !== nextProps.icon) {
	        this.setState({
	          inline: nextProps.hasOwnProperty('inline') ? nextProps.inline : !nextProps.label && !nextProps.icon
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this4 = this;
	
	      var dropContainer = this.props.dropContainer;
	
	
	      if (this.state.state !== prevState.state) {
	        var activeKeyboardHandlers = {
	          esc: this._onClose
	        };
	        var focusedKeyboardHandlers = {
	          space: this._onOpen,
	          down: this._onOpen,
	          enter: this._onOpen
	        };
	
	        switch (this.state.state) {
	          case 'collapsed':
	            _KeyboardAccelerators2.default.stopListeningToKeyboard(this, focusedKeyboardHandlers);
	            _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
	            document.removeEventListener('click', this._checkOnClose);
	            document.removeEventListener('touchstart', this._checkOnClose);
	            if (this._drop) {
	              // When Menu is used with Anchor/paths the Drop removes too quickly
	              // and react looks for a DOM element which is gone. Adding a
	              // slight delay resolves this issue.
	              setTimeout(function () {
	                _this4._drop.remove();
	                _this4._drop = undefined;
	              }, 5);
	            }
	            break;
	          case 'focused':
	            _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
	            _KeyboardAccelerators2.default.startListeningToKeyboard(this, focusedKeyboardHandlers);
	            break;
	          case 'expanded':
	            // only add the drop again if the instance is not defined
	            // see https://github.com/grommet/grommet/issues/1431
	            if (!this._drop) {
	              _KeyboardAccelerators2.default.stopListeningToKeyboard(this, focusedKeyboardHandlers);
	              _KeyboardAccelerators2.default.startListeningToKeyboard(this, activeKeyboardHandlers);
	              document.addEventListener('click', this._checkOnClose);
	              document.addEventListener('touchstart', this._checkOnClose);
	              this._drop = new _Drop2.default((0, _reactDom.findDOMNode)(this._controlRef), this._renderMenuDrop(), {
	                align: this.props.dropAlign,
	                colorIndex: this.props.dropColorIndex,
	                className: this.props.className && this.props.className + '__drop--container',
	                focusControl: true,
	                dropContainer: dropContainer
	              });
	            }
	            break;
	        }
	      } else if (this.state.state === 'expanded') {
	        this._drop.render(this._renderMenuDrop());
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this._checkOnClose);
	      document.removeEventListener('touchstart', this._checkOnClose);
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
	      if (this._drop) {
	        this._drop.remove();
	      }
	      if (this._responsive) {
	        this._responsive.stop();
	      }
	    }
	  }, {
	    key: '_onOpen',
	    value: function _onOpen() {
	      if ((0, _reactDom.findDOMNode)(this._controlRef).contains(document.activeElement)) {
	        this.setState({ state: 'expanded' });
	      }
	    }
	  }, {
	    key: '_onClose',
	    value: function _onClose() {
	      this.setState({ state: 'collapsed' });
	    }
	  }, {
	    key: '_checkOnClose',
	    value: function _checkOnClose(event) {
	      var drop = (0, _reactDom.findDOMNode)(this._menuDrop);
	      var control = (0, _reactDom.findDOMNode)(this._controlRef);
	      if (drop && !drop.contains(event.target) && !control.contains(event.target)) {
	        this._onClose();
	      }
	    }
	  }, {
	    key: '_onSink',
	    value: function _onSink(event) {
	      event.stopPropagation();
	      // need to go native to prevent closing via document
	      event.nativeEvent.stopImmediatePropagation();
	    }
	  }, {
	    key: '_onResponsive',
	    value: function _onResponsive(small) {
	      // deactivate if we change resolutions
	      var newState = this.state.state;
	      if (this.state.state === 'expanded') {
	        newState = 'focused';
	      }
	      if (small) {
	        this.setState({ inline: false, active: newState, controlCollapsed: true });
	      } else {
	        this.setState({
	          inline: this.state.initialInline,
	          active: newState,
	          state: 'collapsed',
	          controlCollapsed: false
	        });
	      }
	    }
	  }, {
	    key: '_onFocusControl',
	    value: function _onFocusControl() {
	      if (this.state.state !== 'focused') {
	        this.setState({ state: 'focused' });
	      }
	    }
	  }, {
	    key: '_onBlurControl',
	    value: function _onBlurControl() {
	      if (this.state.state === 'focused') {
	        this.setState({ state: 'collapsed' });
	      }
	    }
	  }, {
	    key: '_renderButtonProps',
	    value: function _renderButtonProps() {
	      var _props2 = this.props,
	          icon = _props2.icon,
	          label = _props2.label;
	      // Use default icon if no label or icon is provided
	
	      if (!label && !icon) {
	        return { icon: _react2.default.createElement(_More2.default, null) };
	      }
	
	      // Return provided label(if any) and provided icon, or default
	      // to DropCaretIcon
	      return {
	        label: label,
	        icon: icon || _react2.default.createElement(_Down2.default, { a11yTitle: 'menu-down' })
	      };
	    }
	  }, {
	    key: '_renderMenuDrop',
	    value: function _renderMenuDrop() {
	      var _this5 = this;
	
	      var closeLabel = _Intl2.default.getMessage(this.context.intl, 'Close');
	      var menuLabel = _Intl2.default.getMessage(this.context.intl, 'Menu');
	      var menuTitle = closeLabel + ' ' + (this.props.a11yTitle || this.props.label || '') + ' ' + ('' + menuLabel);
	
	      var control = _react2.default.createElement(_Button2.default, _extends({ className: CLASS_ROOT + '__control', plain: true,
	        a11yTitle: menuTitle, reverse: true
	      }, this._renderButtonProps(), { onClick: this._onClose }));
	
	      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	      var onClick = this.props.closeOnClick ? this._onClose : this._onSink;
	
	      return _react2.default.createElement(
	        MenuDrop,
	        _extends({}, boxProps, this.context, {
	          className: this.props.className,
	          dropAlign: this.props.dropAlign,
	          size: this.props.size,
	          onClick: onClick,
	          control: control, ref: function ref(_ref3) {
	            return _this5._menuDrop = _ref3;
	          } }),
	        this.props.children
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames2,
	          _this6 = this;
	
	      var _props3 = this.props,
	          a11yTitle = _props3.a11yTitle,
	          children = _props3.children,
	          className = _props3.className,
	          direction = _props3.direction,
	          fill = _props3.fill,
	          label = _props3.label,
	          primary = _props3.primary,
	          size = _props3.size,
	          pad = _props3.pad,
	          props = _objectWithoutProperties(_props3, ['a11yTitle', 'children', 'className', 'direction', 'fill', 'label', 'primary', 'size', 'pad']);
	
	      delete props.closeOnClick;
	      delete props.dropColorIndex;
	      delete props.dropAlign;
	      delete props.icon;
	      delete props.inline;
	      var inline = this.state.inline;
	
	      var classes = (0, _classnames4.default)(CLASS_ROOT, (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '--' + direction, direction), _defineProperty(_classnames2, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames2, CLASS_ROOT + '--primary', primary), _defineProperty(_classnames2, CLASS_ROOT + '--inline', inline), _defineProperty(_classnames2, CLASS_ROOT + '--controlled', !inline), _defineProperty(_classnames2, CLASS_ROOT + '__control', !inline), _defineProperty(_classnames2, CLASS_ROOT + '--labelled', !inline && label), _defineProperty(_classnames2, CLASS_ROOT + '--fill', fill), _classnames2), className);
	
	      if (inline) {
	        var menuLabel = void 0;
	        if ('expanded' === inline) {
	          menuLabel = _react2.default.createElement(
	            'div',
	            { className: CLASS_ROOT + '__label' },
	            label
	          );
	        }
	
	        return _react2.default.createElement(
	          _Box2.default,
	          _extends({}, props, { pad: pad, direction: direction, tag: 'nav',
	            className: classes, primary: false }),
	          menuLabel,
	          children
	        );
	      } else {
	        var openLabel = _Intl2.default.getMessage(this.context.intl, 'Open');
	        var _menuLabel = _Intl2.default.getMessage(this.context.intl, 'Menu');
	        var menuTitle = openLabel + ' ' + (a11yTitle || label || '') + ' ' + ('' + _menuLabel);
	
	        return _react2.default.createElement(
	          _Box2.default,
	          _extends({ ref: function ref(_ref4) {
	              return _this6._controlRef = _ref4;
	            } }, props, { className: classes }),
	          _react2.default.createElement(_Button2.default, _extends({ plain: true, reverse: true,
	            a11yTitle: menuTitle }, this._renderButtonProps(), {
	            onClick: function onClick() {
	              return _this6.setState({
	                state: _this6.state.state !== 'expanded' ? 'expanded' : 'collapsed'
	              });
	            },
	            onFocus: this._onFocusControl, onBlur: this._onBlurControl }))
	        );
	      }
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	Menu.displayName = 'Menu';
	exports.default = Menu;
	
	
	Menu.propTypes = _extends({
	  closeOnClick: _propTypes2.default.bool,
	  dropAlign: _Drop.dropAlignPropType,
	  dropColorIndex: _propTypes2.default.string,
	  dropContainer: _propTypes2.default.object,
	  icon: _propTypes2.default.node,
	  id: _propTypes2.default.string,
	  inline: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['expand'])]),
	  fill: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
	}, _Box2.default.propTypes);
	
	Menu.contextTypes = {
	  history: _propTypes2.default.any,
	  intl: _propTypes2.default.any,
	  router: _propTypes2.default.any,
	  store: _propTypes2.default.any
	};
	
	Menu.defaultProps = {
	  closeOnClick: true,
	  direction: 'column',
	  dropAlign: { top: 'top', left: 'left' },
	  pad: 'none',
	  dropContainer: undefined
	};
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _classnames3 = __webpack_require__(6);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Drop = __webpack_require__(87);
	
	var _Drop2 = _interopRequireDefault(_Drop);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _RadioButton = __webpack_require__(189);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _Search = __webpack_require__(102);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _CaretDown = __webpack_require__(508);
	
	var _CaretDown2 = _interopRequireDefault(_CaretDown);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Announcer = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SELECT;
	var INPUT = _CSSClassnames2.default.INPUT;
	
	var Select = function (_Component) {
	  _inherits(Select, _Component);
	
	  function Select(props, context) {
	    _classCallCheck(this, Select);
	
	    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props, context));
	
	    _this._onAddDrop = _this._onAddDrop.bind(_this);
	    _this._onRemoveDrop = _this._onRemoveDrop.bind(_this);
	    _this._onForceClose = _this._onForceClose.bind(_this);
	    _this._onSearchChange = _this._onSearchChange.bind(_this);
	    _this._onNextOption = _this._onNextOption.bind(_this);
	    _this._onPreviousOption = _this._onPreviousOption.bind(_this);
	    _this._onEnter = _this._onEnter.bind(_this);
	    _this._stopPropagation = _this._stopPropagation.bind(_this);
	    _this._onInputKeyDown = _this._onInputKeyDown.bind(_this);
	    _this._announceOptions = _this._announceOptions.bind(_this);
	
	    _this.state = {
	      announceChange: false,
	      activeOptionIndex: -1,
	      dropActive: false,
	      searchText: '',
	      value: _this._normalizeValue(props, {})
	    };
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('value')) {
	        this.setState({ value: this._normalizeValue(nextProps, this.state) });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          inline = _props.inline,
	          options = _props.options;
	      var _state = this.state,
	          announceChange = _state.announceChange,
	          dropActive = _state.dropActive;
	      var intl = this.context.intl;
	
	      // Set up keyboard listeners appropriate to the current state.
	
	      var activeKeyboardHandlers = {
	        up: this._onPreviousOption,
	        down: this._onNextOption,
	        enter: this._onEnter,
	        left: this._stopPropagation,
	        right: this._stopPropagation
	      };
	
	      if (!inline) {
	        activeKeyboardHandlers.esc = this._onForceClose;
	        activeKeyboardHandlers.tab = this._onForceClose;
	      }
	
	      // the order here is important, need to turn off keys before turning on
	      if (!dropActive && prevState.dropActive) {
	        document.removeEventListener('click', this._onRemoveDrop);
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
	        if (this._drop) {
	          this._drop.remove();
	          this._drop = undefined;
	        }
	      }
	
	      if (inline && !prevProps.inline || dropActive && !prevState.dropActive) {
	
	        if (!inline) {
	          document.addEventListener('click', this._onRemoveDrop);
	        }
	
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, activeKeyboardHandlers);
	
	        if (!inline) {
	          // If this is inside a FormField, place the drop in reference to it.
	          var control = this.valueRef || this.inputRef;
	          this._drop = new _Drop2.default(control, this._renderOptions(CLASS_ROOT + '__drop'), {
	            align: { top: 'bottom', left: 'left' },
	            context: this.context,
	            responsive: false // so suggestion changes don't re-align
	          });
	        }
	
	        if (this._searchRef) {
	          this._searchRef.focus();
	          this._searchRef._inputRef.select();
	        }
	      } else if (dropActive && prevState.dropActive) {
	        this._drop.render(this._renderOptions(CLASS_ROOT + '__drop'));
	      }
	
	      if (announceChange && options) {
	        var matchResultsMessage = _Intl2.default.getMessage(intl, 'Match Results', {
	          count: options.length
	        });
	        var navigationHelpMessage = '';
	        if (options.length) {
	          navigationHelpMessage = '(' + _Intl2.default.getMessage(intl, 'Navigation Help') + ')';
	        }
	        (0, _Announcer.announce)(matchResultsMessage + ' ' + navigationHelpMessage);
	        this.setState({ announceChange: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this._onRemoveDrop);
	      if (this._drop) {
	        this._drop.remove();
	      }
	    }
	  }, {
	    key: '_normalizeValue',
	    value: function _normalizeValue(props, state) {
	      var multiple = props.multiple,
	          value = props.value;
	
	      var normalizedValue = value;
	      if (multiple) {
	        if (value) {
	          if (!Array.isArray(value)) {
	            normalizedValue = [value];
	          }
	        } else {
	          normalizedValue = [];
	        }
	      }
	      return normalizedValue;
	    }
	  }, {
	    key: '_announceOptions',
	    value: function _announceOptions(index) {
	      var intl = this.context.intl;
	
	      var labelMessage = this._renderValue(this.props.options[index]);
	      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
	      (0, _Announcer.announce)(labelMessage + ' ' + enterSelectMessage);
	    }
	  }, {
	    key: '_onInputKeyDown',
	    value: function _onInputKeyDown(event) {
	      var up = 38;
	      var down = 40;
	      if (event.keyCode === up || event.keyCode === down) {
	        // stop the input to move the cursor when options are present
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: '_onSearchChange',
	    value: function _onSearchChange(event) {
	      var inline = this.props.inline;
	
	      this.setState({
	        announceChange: true,
	        activeOptionIndex: -1,
	        dropActive: !inline,
	        searchText: event.target.value
	      });
	      if (this.props.onSearch) {
	        this.props.onSearch(event);
	      }
	    }
	  }, {
	    key: '_onAddDrop',
	    value: function _onAddDrop(event) {
	      var _props2 = this.props,
	          options = _props2.options,
	          value = _props2.value;
	
	      event.preventDefault();
	      // Get values of options, so we can highlight selected option
	      if (options) {
	        var optionValues = options.map(function (option) {
	          if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
	            return option.value;
	          } else {
	            return option;
	          }
	        });
	        var activeOptionIndex = optionValues.indexOf(value);
	        this.setState({
	          dropActive: true,
	          activeOptionIndex: activeOptionIndex
	        });
	      }
	    }
	  }, {
	    key: '_onRemoveDrop',
	    value: function _onRemoveDrop(event) {
	      if (!this._searchRef || !(0, _reactDom.findDOMNode)(this._searchRef).contains(event.target)) {
	        this.setState({ dropActive: false });
	      }
	    }
	  }, {
	    key: '_onForceClose',
	    value: function _onForceClose() {
	      this.setState({ dropActive: false });
	    }
	  }, {
	    key: '_onNextOption',
	    value: function _onNextOption(event) {
	      event.preventDefault();
	      var index = this.state.activeOptionIndex;
	      index = Math.min(index + 1, this.props.options.length - 1);
	      this.setState({ activeOptionIndex: index }, this._announceOptions.bind(this, index));
	    }
	  }, {
	    key: '_onPreviousOption',
	    value: function _onPreviousOption(event) {
	      event.preventDefault();
	      var index = this.state.activeOptionIndex;
	      index = Math.max(index - 1, 0);
	      this.setState({ activeOptionIndex: index }, this._announceOptions.bind(this, index));
	    }
	  }, {
	    key: '_valueForSelectedOption',
	    value: function _valueForSelectedOption(option) {
	      var multiple = this.props.multiple;
	      var value = this.state.value;
	
	      var nextValue = void 0;
	      if (multiple) {
	        nextValue = value.slice(0);
	        var index = void 0;
	        for (index = 0; index < nextValue.length; index += 1) {
	          if (this._valueEqualsOption(nextValue[index], option)) {
	            break;
	          }
	        }
	        if (index < nextValue.length) {
	          // already existing, remove
	          nextValue.splice(index, 1);
	        } else {
	          // not there, add
	          nextValue.push(option);
	        }
	      } else {
	        nextValue = option;
	      }
	      return nextValue;
	    }
	  }, {
	    key: '_onEnter',
	    value: function _onEnter(event) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          onChange = _props3.onChange,
	          options = _props3.options;
	      var activeOptionIndex = this.state.activeOptionIndex;
	      var intl = this.context.intl;
	
	      if (activeOptionIndex >= 0) {
	        event.preventDefault(); // prevent submitting forms
	        var option = options[activeOptionIndex];
	        var value = this._valueForSelectedOption(option);
	        this.setState({ dropActive: false, value: value }, function () {
	          var optionMessage = _this2._renderLabel(option);
	          var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
	          (0, _Announcer.announce)(optionMessage + ' ' + selectedMessage);
	        });
	        if (onChange) {
	          onChange({ target: this.inputRef, option: option, value: value });
	        }
	      } else {
	        this.setState({ dropActive: false });
	      }
	    }
	  }, {
	    key: '_stopPropagation',
	    value: function _stopPropagation() {
	      if ((0, _reactDom.findDOMNode)(this._searchRef).contains(document.activeElement)) {
	        return true;
	      }
	    }
	  }, {
	    key: '_onClickOption',
	    value: function _onClickOption(option) {
	      var onChange = this.props.onChange;
	
	      var value = this._valueForSelectedOption(option);
	      this.setState({ dropActive: false, value: value });
	      if (onChange) {
	        onChange({ target: this.inputRef, option: option, value: value });
	      }
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel(option) {
	      if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
	        // revert for announce as label is often a complex object
	        return option.label || option.value || '';
	      } else {
	        return undefined === option || null === option ? '' : option;
	      }
	    }
	  }, {
	    key: '_renderValue',
	    value: function _renderValue(option) {
	      var intl = this.context.intl;
	
	      if (Array.isArray(option)) {
	        // Could be an Array when !inline+multiple
	        if (1 === option.length) {
	          return this._renderValue(option[0]);
	        } else if (option.length > 1) {
	          var selectedMultiple = _Intl2.default.getMessage(intl, 'Selected Multiple', {
	            count: option.length
	          });
	          return selectedMultiple;
	        }
	      } else if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
	        return option.label || option.value || '';
	      } else {
	        return undefined === option || null === option ? '' : option;
	      }
	    }
	  }, {
	    key: '_valueEqualsOption',
	    value: function _valueEqualsOption(value, option) {
	      var result = false;
	      if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
	          result = value.value === option.value;
	        } else {
	          result = value.value === option;
	        }
	      } else {
	        if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
	          result = value === option.value;
	        } else {
	          result = value === option;
	        }
	      }
	      return result;
	    }
	  }, {
	    key: '_optionSelected',
	    value: function _optionSelected(option, value) {
	      var _this3 = this;
	
	      var result = false;
	      if (value && Array.isArray(value)) {
	        result = value.some(function (val) {
	          return _this3._valueEqualsOption(val, option);
	        });
	      } else {
	        result = this._valueEqualsOption(value, option);
	      }
	      return result;
	    }
	  }, {
	    key: '_renderOptions',
	    value: function _renderOptions(className) {
	      var _this4 = this;
	
	      var restProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var intl = this.context.intl;
	      var _props4 = this.props,
	          id = _props4.id,
	          inline = _props4.inline,
	          multiple = _props4.multiple,
	          options = _props4.options,
	          onSearch = _props4.onSearch,
	          value = _props4.value,
	          _props4$searchPlaceHo = _props4.searchPlaceHolder,
	          searchPlaceHolder = _props4$searchPlaceHo === undefined ? _Intl2.default.getMessage(intl, 'Search') : _props4$searchPlaceHo;
	      var _state2 = this.state,
	          activeOptionIndex = _state2.activeOptionIndex,
	          searchText = _state2.searchText;
	
	
	      var search = void 0;
	      if (onSearch) {
	        search = _react2.default.createElement(_Search2.default, { className: CLASS_ROOT + '__search',
	          ref: function ref(_ref) {
	            return _this4._searchRef = _ref;
	          },
	          inline: true, fill: true, responsive: false, pad: 'medium',
	          placeHolder: searchPlaceHolder, value: searchText,
	          onDOMChange: this._onSearchChange,
	          onKeyDown: this._onInputKeyDown });
	      }
	
	      var items = void 0;
	      if (options) {
	        items = options.map(function (option, index) {
	          var _classnames;
	
	          var selected = _this4._optionSelected(option, value);
	          var content = _this4._renderLabel(option);
	          var classes = (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__option', true), _defineProperty(_classnames, CLASS_ROOT + '__option--element', _react2.default.isValidElement(content)), _defineProperty(_classnames, CLASS_ROOT + '__option--selected', selected), _defineProperty(_classnames, CLASS_ROOT + '__option--active', index === activeOptionIndex), _classnames));
	
	          if (option && option.icon) {
	            content = _react2.default.createElement(
	              'span',
	              null,
	              option.icon,
	              ' ',
	              content
	            );
	          }
	
	          var itemOnClick = void 0;
	          if (inline) {
	            var itemId = '' + (option ? option.value || option : index);
	            var Type = multiple ? _CheckBox2.default : _RadioButton2.default;
	            content = _react2.default.createElement(Type, {
	              key: itemId,
	              id: id ? id + '-' + itemId : undefined,
	              label: content,
	              checked: selected,
	              onChange: _this4._onClickOption.bind(_this4, option)
	            });
	          } else {
	            itemOnClick = function itemOnClick(e) {
	              e.stopPropagation();
	              _this4._onClickOption.bind(_this4, option)();
	            };
	          }
	
	          return _react2.default.createElement(
	            'li',
	            { key: index, className: classes, onClick: itemOnClick },
	            content
	          );
	        });
	      }
	
	      var onClick = void 0;
	      if (!inline) {
	        onClick = this._onRemoveDrop;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, restProps, { className: className }),
	        search,
	        _react2.default.createElement(
	          'ol',
	          { className: CLASS_ROOT + '__options', onClick: onClick },
	          items
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames2,
	          _this5 = this;
	
	      var _props5 = this.props,
	          className = _props5.className,
	          inline = _props5.inline,
	          placeHolder = _props5.placeHolder,
	          value = _props5.value;
	      var active = this.state.active;
	      var intl = this.context.intl;
	
	      var classes = (0, _classnames4.default)(CLASS_ROOT, (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '--active', active), _defineProperty(_classnames2, CLASS_ROOT + '--inline', inline), _classnames2), className);
	      var restProps = _Props2.default.omit(this.props, Object.keys(Select.propTypes));
	
	      if (inline) {
	        return this._renderOptions(classes, restProps);
	      } else {
	        var renderedValue = this._renderValue(value);
	        var shouldRenderElement = _react2.default.isValidElement(renderedValue);
	
	        return _react2.default.createElement(
	          'div',
	          { className: classes, onClick: this._onAddDrop },
	          shouldRenderElement ? _react2.default.createElement(
	            'div',
	            { ref: function ref(_ref2) {
	                return _this5.valueRef = _ref2;
	              },
	              className: CLASS_ROOT + '__value' },
	            renderedValue
	          ) : null,
	          _react2.default.createElement('input', _extends({}, restProps, { ref: function ref(_ref3) {
	              return _this5.inputRef = _ref3;
	            },
	            type: shouldRenderElement ? 'hidden' : 'text',
	            className: INPUT + ' ' + CLASS_ROOT + '__input',
	            placeholder: placeHolder, readOnly: true,
	            value: !shouldRenderElement && renderedValue || '' })),
	          _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__control',
	            a11yTitle: _Intl2.default.getMessage(intl, 'Select Icon'),
	            icon: _react2.default.createElement(_CaretDown2.default, null),
	            onClick: this._onAddDrop })
	        );
	      }
	    }
	  }]);
	
	  return Select;
	}(_react.Component);
	
	Select.displayName = 'Select';
	exports.default = Select;
	
	
	var valueType = _propTypes2.default.oneOfType([_propTypes2.default.shape({
	  label: _propTypes2.default.node,
	  value: _propTypes2.default.any
	}), _propTypes2.default.string, _propTypes2.default.number]);
	
	Select.propTypes = {
	  inline: _propTypes2.default.bool,
	  multiple: _propTypes2.default.bool,
	  onSearch: _propTypes2.default.func,
	  onChange: _propTypes2.default.func, // (value(s))
	  placeHolder: _propTypes2.default.string,
	  searchPlaceHolder: _propTypes2.default.string,
	  options: _propTypes2.default.arrayOf(valueType).isRequired,
	  value: _propTypes2.default.oneOfType([valueType, _propTypes2.default.arrayOf(valueType)])
	};
	
	Select.contextTypes = {
	  intl: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames3 = __webpack_require__(6);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Drop = __webpack_require__(87);
	
	var _Drop2 = _interopRequireDefault(_Drop);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Announcer = __webpack_require__(35);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.TEXT_INPUT;
	var INPUT = _CSSClassnames2.default.INPUT;
	
	var TextInput = function (_Component) {
	  _inherits(TextInput, _Component);
	
	  function TextInput(props, context) {
	    _classCallCheck(this, TextInput);
	
	    var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props, context));
	
	    _this.activeKeyboardHandlers = {
	      esc: _this._onRemoveDrop,
	      tab: _this._onRemoveDrop,
	      up: _this._onPreviousSuggestion,
	      down: _this._onNextSuggestion,
	      enter: _this._onEnter
	    };
	    _this.focusedKeyboardHandlers = {
	      down: _this._onAddDrop
	    };
	
	
	    _this._onInputChange = _this._onInputChange.bind(_this);
	    _this._onAddDrop = _this._onAddDrop.bind(_this);
	    _this._onRemoveDrop = _this._onRemoveDrop.bind(_this);
	    _this._onNextSuggestion = _this._onNextSuggestion.bind(_this);
	    _this._onPreviousSuggestion = _this._onPreviousSuggestion.bind(_this);
	    _this._onEnter = _this._onEnter.bind(_this);
	    _this._onClickSuggestion = _this._onClickSuggestion.bind(_this);
	    _this._onFocus = _this._onFocus.bind(_this);
	    _this._onInputKeyDown = _this._onInputKeyDown.bind(_this);
	    _this._stopPropagation = _this._stopPropagation.bind(_this);
	    _this._announceSuggestion = _this._announceSuggestion.bind(_this);
	
	    _this.state = {
	      announceChange: false,
	      dropActive: false,
	      activeSuggestionIndex: -1
	    };
	    return _this;
	  }
	
	  _createClass(TextInput, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var suggestions = this.props.suggestions;
	      var _state = this.state,
	          announceChange = _state.announceChange,
	          dropActive = _state.dropActive,
	          focused = _state.focused;
	      var intl = this.context.intl;
	      var activeKeyboardHandlers = this.activeKeyboardHandlers,
	          focusedKeyboardHandlers = this.focusedKeyboardHandlers;
	      // the order here is important, need to turn off keys before turning on
	
	      if (!focused && prevState.focused) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, focusedKeyboardHandlers);
	      }
	
	      if (!dropActive && prevState.dropActive) {
	        document.removeEventListener('click', this._onRemoveDrop);
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
	        if (this._drop) {
	          this._drop.remove();
	          this._drop = undefined;
	        }
	      }
	
	      if (focused && !prevState.focused) {
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, focusedKeyboardHandlers);
	      }
	
	      if (dropActive && !prevState.dropActive) {
	        document.addEventListener('click', this._onRemoveDrop);
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, activeKeyboardHandlers);
	
	        // If this is inside a FormField, place the drop in reference to it.
	        var control = this.componentRef;
	        this._drop = new _Drop2.default(control, this._renderDropContent(), {
	          align: { top: 'bottom', left: 'left' },
	          responsive: false // so suggestion changes don't re-align
	        });
	      } else if (dropActive && prevState.dropActive) {
	        this._drop.render(this._renderDropContent());
	      }
	
	      if (announceChange && suggestions) {
	        var matchResultsMessage = _Intl2.default.getMessage(intl, 'Match Results', {
	          count: suggestions.length
	        });
	        var navigationHelpMessage = '';
	        if (suggestions.length) {
	          navigationHelpMessage = '(' + _Intl2.default.getMessage(intl, 'Navigation Help') + ')';
	        }
	        (0, _Announcer.announce)(matchResultsMessage + ' ' + navigationHelpMessage);
	        this.setState({ announceChange: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var activeKeyboardHandlers = this.activeKeyboardHandlers,
	          focusedKeyboardHandlers = this.focusedKeyboardHandlers;
	
	
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, focusedKeyboardHandlers);
	
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
	
	      document.removeEventListener('click', this._onRemoveDrop);
	      if (this._drop) {
	        this._drop.remove();
	      }
	    }
	  }, {
	    key: '_stopPropagation',
	    value: function _stopPropagation() {
	      if (document.activeElement === this.componentRef) {
	        return true;
	      }
	    }
	  }, {
	    key: '_onInputChange',
	    value: function _onInputChange(event) {
	      var _props = this.props,
	          onDOMChange = _props.onDOMChange,
	          suggestions = _props.suggestions;
	
	
	      if (suggestions && Array.isArray(suggestions)) {
	        this.setState({
	          activeSuggestionIndex: -1, announceChange: true, dropActive: true
	        });
	      }
	
	      if (onDOMChange) {
	        onDOMChange(event);
	      }
	    }
	  }, {
	    key: '_announceSuggestion',
	    value: function _announceSuggestion(index) {
	      var suggestions = this.props.suggestions;
	      var intl = this.context.intl;
	
	      if (suggestions && suggestions.length > 0) {
	        var labelMessage = this._renderLabel(suggestions[index]);
	        var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
	        (0, _Announcer.announce)(labelMessage + ' ' + enterSelectMessage);
	      }
	    }
	  }, {
	    key: '_onAddDrop',
	    value: function _onAddDrop(event) {
	      var _props2 = this.props,
	          suggestions = _props2.suggestions,
	          value = _props2.value;
	      // Get values of suggestions, so we can highlight selected suggestion
	
	      if (suggestions) {
	        event.preventDefault();
	        var suggestionValues = suggestions.map(function (suggestion) {
	          if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
	            return suggestion.value;
	          } else {
	            return suggestion;
	          }
	        });
	        var activeSuggestionIndex = suggestionValues.indexOf(value);
	        this.setState({
	          dropActive: true,
	          activeSuggestionIndex: activeSuggestionIndex
	        });
	      }
	    }
	  }, {
	    key: '_onRemoveDrop',
	    value: function _onRemoveDrop() {
	      this.setState({ dropActive: false });
	    }
	  }, {
	    key: '_onNextSuggestion',
	    value: function _onNextSuggestion() {
	      var suggestions = this.props.suggestions;
	      var activeSuggestionIndex = this.state.activeSuggestionIndex;
	
	      var index = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
	      this.setState({ activeSuggestionIndex: index }, this._announceSuggestion.bind(this, index));
	    }
	  }, {
	    key: '_onPreviousSuggestion',
	    value: function _onPreviousSuggestion() {
	      var activeSuggestionIndex = this.state.activeSuggestionIndex;
	
	      var index = Math.max(activeSuggestionIndex - 1, 0);
	      this.setState({ activeSuggestionIndex: index }, this._announceSuggestion.bind(this, index));
	    }
	  }, {
	    key: '_onEnter',
	    value: function _onEnter(event) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          onSelect = _props3.onSelect,
	          suggestions = _props3.suggestions;
	      var activeSuggestionIndex = this.state.activeSuggestionIndex;
	      var intl = this.context.intl;
	
	      this.setState({ dropActive: false });
	      if (activeSuggestionIndex >= 0) {
	        event.preventDefault(); // prevent submitting forms
	        var suggestion = suggestions[activeSuggestionIndex];
	        this.setState({ value: suggestion }, function () {
	          var suggestionMessage = _this2._renderLabel(suggestion);
	          var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
	          (0, _Announcer.announce)(suggestionMessage + ' ' + selectedMessage);
	        });
	        if (onSelect) {
	          onSelect({
	            target: this.componentRef, suggestion: suggestion
	          });
	        }
	      }
	    }
	  }, {
	    key: '_onClickSuggestion',
	    value: function _onClickSuggestion(suggestion) {
	      var onSelect = this.props.onSelect;
	
	      this.setState({ value: suggestion, dropActive: false });
	      if (onSelect) {
	        onSelect({
	          target: this.componentRef, suggestion: suggestion
	        });
	      }
	    }
	  }, {
	    key: '_onFocus',
	    value: function _onFocus(event) {
	      var onFocus = this.props.onFocus;
	
	      this.setState({
	        focused: true,
	        activeSuggestionIndex: -1
	      });
	
	      if (onFocus) {
	        onFocus(event);
	      }
	    }
	  }, {
	    key: '_onInputKeyDown',
	    value: function _onInputKeyDown(event) {
	      var _props4 = this.props,
	          onKeyDown = _props4.onKeyDown,
	          suggestions = _props4.suggestions;
	      var dropActive = this.state.dropActive;
	
	      if (suggestions) {
	        var up = 38;
	        var down = 40;
	        var tab = 9;
	        if (event.keyCode === up || event.keyCode === down) {
	          // stop the input to move the cursor when suggestions are present
	          event.preventDefault();
	
	          if (event.keyCode === down && !dropActive) {
	            this._onAddDrop(event);
	          }
	        }
	
	        if (event.keyCode === tab) {
	          this.setState({ focused: false });
	        }
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel(suggestion) {
	      if (suggestion && (typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
	        return suggestion.label || suggestion.value;
	      } else {
	        return suggestion;
	      }
	    }
	  }, {
	    key: '_renderDropContent',
	    value: function _renderDropContent() {
	      var _this3 = this;
	
	      var suggestions = this.props.suggestions;
	      var activeSuggestionIndex = this.state.activeSuggestionIndex;
	
	      var items = void 0;
	      if (suggestions) {
	        items = suggestions.map(function (suggestion, index) {
	          var _classnames;
	
	          var classes = (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__suggestion', true), _defineProperty(_classnames, CLASS_ROOT + '__suggestion--active', index === activeSuggestionIndex), _classnames));
	          return _react2.default.createElement(
	            'li',
	            { key: index, className: classes,
	              onClick: _this3._onClickSuggestion.bind(_this3, suggestion) },
	            _this3._renderLabel(suggestion)
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'ol',
	        { className: CLASS_ROOT + '__suggestions', onClick: this._onRemoveDrop },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props5 = this.props,
	          className = _props5.className,
	          defaultValue = _props5.defaultValue,
	          value = _props5.value,
	          placeHolder = _props5.placeHolder,
	          props = _objectWithoutProperties(_props5, ['className', 'defaultValue', 'value', 'placeHolder']);
	
	      delete props.suggestions;
	      delete props.onDOMChange;
	      delete props.onSelect;
	      var classes = (0, _classnames4.default)(CLASS_ROOT, INPUT, _defineProperty({}, CLASS_ROOT + '--active', this.state.active), className);
	
	      return _react2.default.createElement('input', _extends({
	        ref: function ref(_ref) {
	          return _this4.componentRef = _ref;
	        },
	        type: 'text',
	        autoComplete: 'off'
	      }, props, {
	        className: classes,
	        defaultValue: this._renderLabel(defaultValue),
	        value: this._renderLabel(value),
	        placeholder: placeHolder,
	        onChange: this._onInputChange, onFocus: this._onFocus,
	        onKeyDown: this._onInputKeyDown }));
	    }
	  }]);
	
	  return TextInput;
	}(_react.Component);
	
	TextInput.displayName = 'TextInput';
	exports.default = TextInput;
	
	
	TextInput.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	TextInput.propTypes = {
	  defaultValue: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  onDOMChange: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  placeHolder: _propTypes2.default.string,
	  suggestions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
	    label: _propTypes2.default.node,
	    value: _propTypes2.default.any
	  }), _propTypes2.default.string])),
	  value: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Announcer = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VALUE;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Value = function (_Component) {
	  _inherits(Value, _Component);
	
	  function Value() {
	    _classCallCheck(this, Value);
	
	    return _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).apply(this, arguments));
	  }
	
	  _createClass(Value, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.announce) {
	        (0, _Announcer.announce)(this.valueRef.textContent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this2 = this;
	
	      var _props = this.props,
	          active = _props.active,
	          align = _props.align,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          icon = _props.icon,
	          label = _props.label,
	          responsive = _props.responsive,
	          size = _props.size,
	          trendIcon = _props.trendIcon,
	          units = _props.units,
	          value = _props.value,
	          reverse = _props.reverse,
	          props = _objectWithoutProperties(_props, ['active', 'align', 'className', 'colorIndex', 'icon', 'label', 'responsive', 'size', 'trendIcon', 'units', 'value', 'reverse']);
	
	      delete props.announce;
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, CLASS_ROOT + '--interactive', props.onClick), _defineProperty(_classnames, CLASS_ROOT + '--active', active), _classnames), className);
	
	      var unitsSpan = void 0;
	      if (units) {
	        unitsSpan = _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__units' },
	          units
	        );
	      }
	
	      var labelSpan = void 0;
	      if (label) {
	        labelSpan = _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__label' },
	          label
	        );
	      }
	
	      var contentNode = void 0;
	      if (reverse) {
	        contentNode = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: CLASS_ROOT + '__value' },
	            value
	          ),
	          unitsSpan,
	          icon
	        );
	      } else {
	        contentNode = _react2.default.createElement(
	          'div',
	          null,
	          icon,
	          _react2.default.createElement(
	            'span',
	            { className: CLASS_ROOT + '__value' },
	            value
	          ),
	          unitsSpan
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ ref: function ref(_ref) {
	            return _this2.valueRef = _ref;
	          } }, props, { className: classes }),
	        _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + '__annotated' },
	          contentNode,
	          trendIcon
	        ),
	        labelSpan
	      );
	    }
	  }]);
	
	  return Value;
	}(_react.Component);
	
	Value.displayName = 'Value';
	exports.default = Value;
	
	
	Value.propTypes = {
	  active: _propTypes2.default.bool,
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  announce: _propTypes2.default.bool,
	  colorIndex: _propTypes2.default.string,
	  icon: _propTypes2.default.node,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  onClick: _propTypes2.default.func,
	  responsive: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
	  trendIcon: _propTypes2.default.node,
	  reverse: _propTypes2.default.bool,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.node]),
	  units: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	};
	
	Value.defaultProps = {
	  align: 'center',
	  announce: false
	};
	module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link-previous', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link-previous');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12 M13,3 L22,12 L13,21', transform: 'matrix(-1 0 0 1 24 0)' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'LinkPrevious';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _enUS = __webpack_require__(56);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({
	  IndexFilters: {
	    filters: '{quantity, plural,\n  =0 {Filters}\n  =1 {one filter}\n  ' + 'other {# filters}\n}'
	  }
	}, _enUS2.default, {
	  Active: 'Active',
	  Activate: 'Activate',
	  Activated: 'Activated',
	  Add: 'Add',
	  add: 'add',
	  Alerts: 'Alerts',
	  All: 'All',
	  ampm: 'ampm',
	  Arc: 'Arc',
	  AxisLabel: '{orientation} Axis',
	  area: 'area',
	  Bar: 'Bar',
	  bar: 'bar',
	  Blank: 'Blank',
	  Box: 'Box',
	  Carousel: 'Carousel',
	  Category: 'Category',
	  Circle: 'Circle',
	  Chart: 'Chart',
	  Children: 'Children',
	  Clear: 'Clear',
	  Cleared: 'Cleared',
	  Close: 'Close',
	  'Close Menu': 'Close Menu',
	  Completed: 'Completed',
	  'Connects With': 'Connects With',
	  created: 'Created',
	  Critical: 'Critical',
	  'Currently Active': 'Currently Active',
	  'Date Selector': 'Date Selector',
	  'Date Time Icon': 'Open Date and Time Selector',
	  day: 'day',
	  Disabled: 'Disabled',
	  Distribution: 'Distribution',
	  Email: 'Email',
	  'Enter Select': 'Press enter to select it',
	  Error: 'Error',
	  Filter: 'Filter',
	  Footer: 'Footer',
	  Grommet: 'Grommet',
	  HotSpotsLabel: 'HotSpots: press arrow keys to interact with it',
	  'GraphValues': 'Graph has {count} items. Highest is {highest}' + ' and smallest is {smallest}',
	  hour: 'hour',
	  'Grommet Logo': 'Grommet Logo',
	  'Layer': 'Layer',
	  List: 'List',
	  line: 'line',
	  'Loading': 'Loading',
	  loginInvalidPassword: 'Please provide Username and Password.',
	  'Log In': 'Log In',
	  Logout: 'Logout',
	  'Main Content': 'Main Content',
	  Max: 'Max',
	  Menu: 'Menu',
	  Meter: 'Meter',
	  Min: 'Min',
	  minute: 'minute',
	  model: 'Model',
	  modified: 'Modified',
	  monitor: 'monitor',
	  month: 'month',
	  'Multi Select': 'Multi Select',
	  Name: 'Name',
	  'Navigation Help': 'Use arrow keys to navigate',
	  'Next Month': 'Next Month',
	  'Next Slide': 'Next Slide',
	  'No Relationship': 'No Relationship',
	  'Notification': 'Notification',
	  OK: 'OK',
	  Open: 'Open',
	  Parent: 'Parent',
	  Parents: 'Parents',
	  Parts: 'Parts',
	  Part: 'Part',
	  Password: 'Password',
	  'Previous Month': 'Previous Month',
	  'Previous Slide': 'Previous Slide',
	  'Previous Tiles': 'Previous Tiles',
	  'Remember me': 'Remember me',
	  'Range Start': 'Range Start',
	  'Range End': 'Range End',
	  Resource: 'Resource',
	  Running: 'Running',
	  Search: 'Search',
	  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
	  second: 'second',
	  'Select Icon': 'Open Select Drop',
	  Selected: 'Selected',
	  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
	  'Skip to': 'Skip to',
	  'Slide Number': 'Slide {slideNumber}',
	  Sort: 'Sort',
	  Spinning: 'Spinning',
	  Spiral: 'Spiral',
	  State: 'State',
	  Status: 'Status',
	  Subtract: 'Subtract',
	  SunBurst: 'SunBurst',
	  'Tab Contents': '{activeTitle} Tab Contents',
	  Table: 'Table',
	  Tasks: 'Tasks',
	  Tiles: 'Tiles',
	  Time: 'Time',
	  Title: 'Title',
	  Today: 'Today',
	  Topology: 'Topology',
	  Total: 'Total',
	  Threshold: 'Threshold',
	  Unknown: 'Unknown',
	  Username: 'Username',
	  uri: 'URI',
	  Value: 'Value',
	  Warning: 'Warning',
	  year: 'year'
	});
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _frFR = __webpack_require__(104);
	
	var _frFR2 = _interopRequireDefault(_frFR);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({
	  IndexFilters: {
	    filters: '{quantity, plural,\n  =0 {Filtres}\n  =1 {un filtre}\n  ' + 'other {# filtres}\n}'
	  }
	}, _frFR2.default, {
	  Active: 'Actif',
	  Activate: 'Activé',
	  Activated: 'Est Actif',
	  Add: 'Ajouter',
	  add: 'ajouter',
	  Alerts: 'Alertes',
	  All: 'Tout',
	  ampm: 'ampm',
	  Arc: 'Arc',
	  AxisLabel: '{orientation} Axe',
	  area: 'zone',
	  Bar: 'Barre',
	  bar: 'barre',
	  Blank: 'Vide',
	  Box: 'Cadre',
	  Carousel: 'Carousel',
	  Category: 'Catégorie',
	  Circle: 'Cercle',
	  Chart: 'Diagramme',
	  Children: 'Enfant',
	  Clear: 'Nettoyer',
	  Cleared: 'Nettoyé',
	  Close: 'Fermer',
	  'Close Menu': 'Fermer le menu',
	  Completed: 'Completer',
	  'Connects With': 'Se connecte avec',
	  created: 'Créer',
	  Critical: 'Critique',
	  'Currently Active': 'Actuellement Actif',
	  'Date Selector': 'Sélecteur de date',
	  'Date Time Icon': 'Ouvrir le sélecteur de date et heure',
	  day: 'jour',
	  Disabled: 'Désactivé',
	  Distribution: 'Distribution',
	  Email: 'Courriel',
	  'Enter Select': 'Appuyer sur entrer pour sélectionner',
	  Error: 'Erreur',
	  Filter: 'Filtre',
	  Footer: 'Pied de page',
	  Grommet: 'Grommet',
	  HotSpotsLabel: 'HotSpots: press arrow keys to interact with it',
	  'GraphValues': 'Le graphique a {count} articles. Le plus grand est {highest}' + ' le plus petit est {smallest}',
	  hour: 'heure',
	  'Grommet Logo': 'Logo de Grommet',
	  'Layer': 'Calque',
	  List: 'Liste',
	  line: 'ligne',
	  'Loading': 'Chargement',
	  loginInvalidPassword: 'Veuillez entrer un nom d\'utilisateur et un mot de passe.',
	  'Log In': 'Connexion',
	  Logout: 'Déconnexion',
	  'Main Content': 'Contenu principal',
	  Max: 'Max',
	  Menu: 'Menu',
	  Meter: 'Mètre',
	  Min: 'Min',
	  minute: 'minute',
	  model: 'Modèle',
	  modified: 'Modifié',
	  monitor: 'moniteur',
	  month: 'mois',
	  'Multi Select': 'Sélection multiple',
	  Name: 'Nom',
	  'Navigation Help': 'Utilisez les flèches pour naviguer',
	  'Next Month': 'Mois Suivant',
	  'Next Slide': 'Fiche Suivante',
	  'No Relationship': 'Aucun relation',
	  'Notification': 'Notification',
	  OK: 'OK',
	  Open: 'Ouvrir',
	  Parent: 'Parent',
	  Parents: 'Parents',
	  Parts: 'Parties',
	  Part: 'Partie',
	  Password: 'Mot de passe',
	  'Previous Month': 'Mois Précédent',
	  'Previous Slide': 'Fiche Précédente',
	  'Previous Tiles': 'Tuiles Précédentes',
	  'Remember me': 'Se souvenir de moi',
	  'Range Start': 'Début de l\'intervalle',
	  'Range End': 'Fin de l\'intervalle',
	  Resource: 'Ressource',
	  Running: 'En marche',
	  Search: 'Recherche',
	  'Match Results': 'Il {count, plural,\n      =0 {n\'y a aucun r\xE9sultat}\n      one {y a # r\xE9sultat}\n      other {y a # r\xE9sultats}\n  }',
	  second: 'seconde',
	  'Select Icon': 'Ouvrir le sélecteur déroulant',
	  Selected: 'Sélectionné',
	  'Selected Multiple': '{count, plural,\n      =0 {aucune}\n      one {# valeur}\n      other {# valeurs}\n  }',
	  'Skip to': 'Aller à',
	  'Slide Number': 'Fiche {slideNumber}',
	  Sort: 'Classer',
	  Spinning: 'Rotation',
	  Spiral: 'Spirale',
	  State: 'État',
	  Status: 'Status',
	  Subtract: 'Soustraire',
	  SunBurst: 'Graphique en rayons de soleil',
	  'Tab Contents': '{activeTitle} Contenu de l\'onglet',
	  Table: 'Tableau',
	  Tasks: 'Tâches',
	  Tiles: 'Tuiles',
	  Time: 'Temps',
	  Title: 'Titre',
	  Today: 'Aujourd\'hui',
	  Topology: 'Topologie',
	  Total: 'Totale',
	  Threshold: 'Seuil',
	  Unknown: 'Inconne',
	  Username: 'Nom d\'utilisateur',
	  uri: 'URI',
	  Value: 'Valeur',
	  Warning: 'Avertissement',
	  year: 'année'
	});
	module.exports = exports['default'];

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  '3d': '3D',
	  'access-accessibility': 'アクセスアクセシビリティ',
	  'access-ad': 'アクセスAD',
	  'access-assist-listening': 'アクセス聴覚支援',
	  'access-braille': 'アクセス点字',
	  'access-sign': 'アクセスサイン',
	  'access-tty': 'アクセスtty',
	  'access-volume-control': 'アクセスボリューム制御',
	  'access-wheelchair-active': 'アクセス車椅子アクティブ',
	  'access-wheelchair': 'アクセス車椅子',
	  'achievement': '達成',
	  'action': 'アクション',
	  'actions': 'アクション',
	  'add-circle': '追加円',
	  'add': '追加',
	  'aggregate': '集計',
	  'aid': '補助',
	  'alarm': 'アラーム',
	  'alert': 'アラート',
	  'analytics': '分析',
	  'announce': 'アナウンス',
	  'apps': 'アプリ',
	  'archive': 'アーカイブ',
	  'article': '記事',
	  'ascend': '昇順',
	  'attachment': '添付ファイル',
	  'back-ten': '10戻る',
	  'bar-chart': '棒グラフ',
	  'basket': 'バスケット',
	  'blog': 'ブログ',
	  'book': '書籍',
	  'bookmark': 'ブックマーク',
	  'bottom-corner': '下部コーナー',
	  'brand-apple-app-store': 'ブランドApple App Store',
	  'brand-codepen-edit': 'ブランドCodepen編集',
	  'brand-codepen-try': 'ブランドCodepen試行',
	  'brand-google-play': 'ブランドGoogle Play',
	  'brand-grommet-outline': 'ブランドGrommetアウトライン',
	  'brand-grommet-path': 'ブランドGrommetパス',
	  'brand-hpe-element-outline': 'ブランドHPEエレメントアウトライン',
	  'brand-hpe-element-path': 'ブランドHPEエレメントパス',
	  'brand-hpe-labs-insignia-outline': 'ブランドHPEラボ記章アウトライン',
	  'brand-hpe-labs-insignia': 'ブランドHPEラボ記章',
	  'brand-hpe-stack-centered': 'ブランドHPEスタック中央揃え',
	  'brand-hpe-stack': 'ブランドHPEスタック',
	  'briefcase': 'ブリーフケース',
	  'brush': 'ブラシ',
	  'bug': 'バグ',
	  'bundle': 'バンドル',
	  'business-service': 'ビジネスサービス',
	  'calculator': '計算機',
	  'calendar': 'カレンダー',
	  'camera': 'カメラ',
	  'capacity': '容量',
	  'car': '車',
	  'caret-down': 'キャレット下へ',
	  'caret-next': 'キャレット次へ',
	  'caret-previous': 'キャレット前へ',
	  'caret-up': 'キャレット上へ',
	  'cart': 'カート',
	  'catalog': 'カタログ',
	  'chapter-add': 'チャプター追加',
	  'chapter-next': 'チャプター次へ',
	  'chapter-previous': 'チャプター前へ',
	  'chat': 'チャット',
	  'checkbox-selected': 'チェックボックスオン',
	  'checkbox': 'チェックボックス',
	  'checkmark': 'チェックマーク',
	  'circle-information': '円情報',
	  'circle-play': '円再生',
	  'circle-question': '円質問',
	  'clear-option': 'クリアオプション',
	  'clear': 'クリア',
	  'CLI': 'CLI',
	  'clipboard': 'クリップボード',
	  'clock': 'クロック',
	  'clone': '複製',
	  'close': '閉じる',
	  'closed-caption': 'クローズドキャプション',
	  'cloud-computer': 'クラウドコンピューター',
	  'cloud-download': 'クラウドダウンロード',
	  'cloud-software': 'クラウドソフトウェア',
	  'cloud-upload': 'クラウドアップロード',
	  'cloud': 'クラウド',
	  'cluster': 'クラスター',
	  'code': 'コード',
	  'columns': 'カラム',
	  'compare': '比較',
	  'compass': 'コンパス',
	  'compliance': 'コンプライアンス',
	  'configure': '構成',
	  'connect': '接続',
	  'contact-info': '連絡先情報',
	  'contact': '連絡先',
	  'contract': '契約',
	  'copy': 'コピー',
	  'credit-card': 'クレジットカード',
	  'cube': '立方体',
	  'cubes': '立方体',
	  'currency': '通貨',
	  'cursor': 'カーソル',
	  'cut': '切り取り',
	  'cycle': 'サイクル',
	  'dashboard': 'ダッシュボード',
	  'database': 'データベース',
	  'deliver': '提供',
	  'deploy': 'デプロイ',
	  'descend': '下降',
	  'desktop': 'デスクトップ',
	  'detach': 'デタッチ',
	  'diamond': 'ダイヤモンド',
	  'directions': '方向',
	  'dislike': '賛同しない',
	  'document-cloud': 'ドキュメントクラウド',
	  'document-config': 'ドキュメント設定',
	  'document-csv': 'ドキュメントCSV',
	  'document-download': 'ドキュメントのダウンロード',
	  'document-excel': 'ドキュメントExcel',
	  'document-exe': 'ドキュメント実行',
	  'document-image': 'ドキュメント画像',
	  'document-locked': 'ドキュメントロック済み',
	  'document-missing': 'ドキュメント欠落',
	  'document-notes': 'ドキュメントメモ',
	  'document-outlook': 'ドキュメントOutlook',
	  'document-pdf': 'ドキュメントPDF',
	  'document-performance': 'ドキュメントパフォーマンス',
	  'document-ppt': 'ドキュメントPPT',
	  'document-rtf': 'ドキュメントRTF',
	  'document-sound': 'ドキュメントサウンド',
	  'document-store': 'ドキュメント保存',
	  'document-test': 'ドキュメントテスト',
	  'document-threat': 'ドキュメント脅威',
	  'document-time': 'ドキュメント時刻',
	  'document-transfer': 'ドキュメント転送',
	  'document-txt': 'ドキュメントtxt',
	  'document-update': 'ドキュメント更新',
	  'document-upload': 'ドキュメントアップロード',
	  'document-user': 'ドキュメントユーザー',
	  'document-verified': 'ドキュメント検証済み',
	  'document-video': 'ドキュメントビデオ',
	  'document-windows': 'ドキュメントWindows',
	  'document-word': 'ドキュメントWord',
	  'document-zip': 'ドキュメントZIP',
	  'document': 'ドキュメント',
	  'domain': 'ドメイン',
	  'down': '下へ',
	  'download': 'ダウンロード',
	  'drag': 'ドラッグ',
	  'drive-cage': 'ドライブケージ',
	  'duplicate': '重複',
	  'edit': '編集',
	  'eject': '取り出し',
	  'empty-circle': '空の円',
	  'expand': '拡大',
	  'fan': 'ファン',
	  'fast-forward': '早送り',
	  'favorite': 'お気に入り',
	  'filter': 'フィルター',
	  'finger-print': '指紋',
	  'flag': 'フラグ',
	  'folder-cycle': 'フォルダーサイクル',
	  'folder-open': 'フォルダー開く',
	  'folder': 'フォルダー',
	  'forward-ten': '10進む',
	  'gallery': 'ギャラリー',
	  'gamepad': 'ゲームパッド',
	  'gift': 'ギフト',
	  'globe': '地球',
	  'grid': 'グリッド',
	  'group': 'グループ',
	  'grow': '拡張',
	  'halt': '停止',
	  'help': 'ヘルプ',
	  'history': '履歴',
	  'home': 'ホーム',
	  'host-maintenance': 'ホストメンテナンス',
	  'host': 'ホスト',
	  'image': 'イメージ',
	  'impact': '影響',
	  'in-progress': '進行中',
	  'inbox': '受信トレイ',
	  'indicator': 'インジケーター',
	  'info': '情報',
	  'inherit': '継承',
	  'inspect': '検査',
	  'install': 'インストール',
	  'integration': '統合',
	  'iteration': '反復',
	  'java': 'Java',
	  'language': '言語',
	  'launch': '起動',
	  'layer': 'レイヤー',
	  'license': 'ライセンス',
	  'like': '賛同する',
	  'line-chart': '線グラフ',
	  'link-bottom': 'リンク末尾',
	  'link-down': 'リンク下へ',
	  'link-next': 'リンク次へ',
	  'link-previous': 'リンク前へ',
	  'link-top': 'リンクトップへ',
	  'link-up': 'リンク上へ',
	  'link': 'リンク',
	  'local': 'ローカル',
	  'location-pin': '場所ピン',
	  'location': '場所',
	  'lock': 'ロック',
	  'login': 'ログイン',
	  'logout': 'ログアウト',
	  'magic': '魔法',
	  'mail-option': 'メールオプション',
	  'mail': 'メール',
	  'manual': 'マニュアル',
	  'map-location': 'マップ位置',
	  'map': 'マップ',
	  'menu': 'メニュー',
	  'microphone': 'マイクロフォン',
	  'money': 'お金',
	  'monitor': 'モニター',
	  'more': 'その他',
	  'multiple': '複数',
	  'navigate': 'ナビゲート',
	  'new-window': '新規ウィンドウ',
	  'new': '新規',
	  'next': '次へ',
	  'nodes': 'ノード',
	  'note': 'メモ',
	  'notes': 'メモ',
	  'notification': '通知',
	  'object-group': 'オブジェクトグループ',
	  'object-ungroup': 'オブジェクトグループ解除',
	  'optimize': '最適化',
	  'organization': '組織',
	  'overview': '概要',
	  'pan': 'パン',
	  'pause-fill': '一時停止中塗り',
	  'pause': '一時停止',
	  'personal-computer': 'パーソナルコンピューター',
	  'pie-chart': '円グラフ',
	  'pin': 'ピン',
	  'plan': '計画',
	  'platform-amazon': 'プラットフォームAmazon',
	  'platform-android': 'プラットフォームAndroid',
	  'platform-apple': 'プラットフォームApple',
	  'platform-archlinux': 'プラットフォームArch Linux',
	  'platform-aruba': 'プラットフォームAruba',
	  'platform-centos': 'プラットフォームCentOS',
	  'platform-chrome': 'プラットフォームChrome',
	  'platform-cloudlinux': 'プラットフォームCloudLinux',
	  'platform-debian': 'プラットフォームDebian',
	  'platform-docker': 'プラットフォームDocker',
	  'platform-dos': 'プラットフォームDOS',
	  'platform-dropbox': 'プラットフォームDropbox',
	  'platform-edge': 'プラットフォームEdge',
	  'platform-fedora': 'プラットフォームFedora',
	  'platform-firefox': 'プラットフォームFirefox',
	  'platform-freebsd': 'プラットフォームFreeBSD',
	  'platform-google': 'プラットフォームGoogle',
	  'platform-hadoop': 'プラットフォームHadoop',
	  'platform-heroku': 'プラットフォームHeroku',
	  'platform-horton': 'プラットフォームHorton',
	  'platform-hp': 'プラットフォームHP',
	  'platform-hpi': 'プラットフォームHPI',
	  'platform-internet-explorer': 'プラットフォームInternet Explorer',
	  'platform-java': 'プラットフォームJava',
	  'platform-mandriva': 'プラットフォームMandriva',
	  'platform-mysql': 'プラットフォームMySQL',
	  'platform-norton': 'プラットフォームNorton',
	  'platform-onedrive': 'プラットフォームOneDrive',
	  'platform-opera': 'プラットフォームOpera',
	  'platform-oracle': 'プラットフォームOracle',
	  'platform-pied-piper': 'プラットフォームPied Piper',
	  'platform-raspberry': 'プラットフォームRaspberry',
	  'platform-reactjs': 'プラットフォームReact.js',
	  'platform-redhat': 'プラットフォームRed Hat',
	  'platform-safari-option': 'プラットフォームSafariオプション',
	  'platform-safari': 'プラットフォームSafari',
	  'platform-sco': 'プラットフォームSCO',
	  'platform-solaris': 'プラットフォームSolaris',
	  'platform-suse': 'プラットフォームSUSE',
	  'platform-swift': 'プラットフォームSwift',
	  'platform-turbolinux': 'プラットフォームTurbolinux',
	  'platform-ubuntu': 'プラットフォームUbuntu',
	  'platform-unixware': 'プラットフォームUnixWare',
	  'platform-vmware': 'プラットフォームVMware',
	  'platform-windows-legacy': 'プラットフォームWindowsレガシー',
	  'platform-windows': 'プラットフォームWindows',
	  'play-fill': '再生中塗り',
	  'play': '再生',
	  'power': '電源',
	  'previous': '前へ',
	  'print': '印刷',
	  'radial-selected': 'ラジアル選択',
	  'radial': 'ラジアル',
	  'refresh': '更新',
	  'resources': 'リソース',
	  'resume': '再開',
	  'revert': '戻す',
	  'rewind': '巻き戻し',
	  'risk': 'リスク',
	  'robot': 'ロボット',
	  'rss': 'RSS',
	  'run': '走る',
	  'satellite': '衛星',
	  'save': '保存',
	  'scan': 'スキャン',
	  'schedule-new': 'スケジュール新規',
	  'schedule-play': 'スケジュール再生',
	  'schedule': 'スケジュール',
	  'schedules': 'スケジュール',
	  'scorecard': 'スコアカード',
	  'search-advanced': '詳細検索',
	  'search': '検索',
	  'secure': 'セキュア',
	  'select': '選択',
	  'selection': '選択',
	  'send': '送信',
	  'server-cluster': 'サーバークラスター',
	  'server': 'サーバー',
	  'servers': 'サーバー',
	  'service-play': 'サービス再生',
	  'services': 'サービス',
	  'settings-option': '設定オプション',
	  'share': '共有',
	  'shield-security': 'シールドセキュリティ',
	  'shield': 'シールド',
	  'shift': 'シフト',
	  'sidebar': 'サイドバー',
	  'social-amazon': 'ソーシャルAmazon',
	  'social-amex': 'ソーシャルAMEX',
	  'social-bitcoin': 'ソーシャルBitcoin',
	  'social-codepen': 'ソーシャルCodepen',
	  'social-creative-commons': 'ソーシャルCreative Commons',
	  'social-dropbox': 'ソーシャルDropbox',
	  'social-facebook-option': 'ソーシャルFacebookオプション',
	  'social-facebook': 'ソーシャルFacebook',
	  'social-github': 'ソーシャルGithub',
	  'social-google-plus': 'ソーシャルGoogle+',
	  'social-google-wallet': 'ソーシャルGoogle Wallet',
	  'social-instagram': 'ソーシャルInstagram',
	  'social-linkedin-option': 'ソーシャルLinkedInオプション',
	  'social-linkedin': 'ソーシャルLinkedIn',
	  'social-mail': 'ソーシャルメール',
	  'social-mastercard': 'ソーシャルMastercard',
	  'social-medium': 'ソーシャルMedium',
	  'social-paypal': 'ソーシャルPayPal',
	  'social-pinterest': 'ソーシャルPinterest',
	  'social-product-hunt': 'ソーシャルProduct Hunt',
	  'social-reddit': 'ソーシャルReddit',
	  'social-skype': 'ソーシャルSkype',
	  'social-slack': 'ソーシャルSlack',
	  'social-snapchat': 'ソーシャルSnapchat',
	  'social-square': 'ソーシャルSquare',
	  'social-stack-overflow': 'ソーシャルStack Overflow',
	  'social-stripe': 'ソーシャルStripe',
	  'social-tumblr': 'ソーシャルTumblr',
	  'social-twitter': 'ソーシャルTwitter',
	  'social-vimeo': 'ソーシャルVimeo',
	  'social-vine': 'ソーシャルVine',
	  'social-visa': 'ソーシャルVisa',
	  'social-wordpress': 'ソーシャルWordPress',
	  'social-youtube': 'ソーシャルYouTube',
	  'sort': 'ソート',
	  'split': '分割',
	  'splits': '複数分割',
	  'stakeholder': '関係者',
	  'standards-3d-effects': '標準3Dエフェクト',
	  'standards-connectivity': '標準コネクティビティ',
	  'standards-css3': '標準CSS3',
	  'standards-device': '標準デバイス',
	  'standards-fireball': '標準ファイアボール',
	  'standards-html5': '標準HTML5',
	  'standards-multimedia': '標準マルチメディア',
	  'standards-offline-storage': '標準オフラインストレージ',
	  'standards-performance': '標準パフォーマンス',
	  'standards-sematics': '標準セマンティクス',
	  'star-half': '星半分',
	  'star': '星',
	  'steps': 'ステップ',
	  'stop-fill': '停止中塗り',
	  'stop': '停止',
	  'storage': 'ストレージ',
	  'street-view': 'ストリートビュー',
	  'subtract-circle': '減算円',
	  'subtract': '減算',
	  'support': 'サポート',
	  'sync': '同期',
	  'system': 'システム',
	  'table-add': 'テーブル追加',
	  'table': 'テーブル',
	  'tag': 'タグ',
	  'target': 'ターゲット',
	  'task': 'タスク',
	  'tasks': 'タスク',
	  'technology': 'テクノロジー',
	  'template': 'テンプレート',
	  'terminal': 'ターミナル',
	  'test-desktop': 'テストデスクトップ',
	  'test': 'テスト',
	  'text-wrap': 'テキスト折り返し',
	  'threats': '脅威',
	  'ticket': 'チケット',
	  'tools': 'ツール',
	  'tooltip': 'ツールヒント',
	  'top-corner': '上部コーナー',
	  'transaction': 'トランザクション',
	  'trash': 'ゴミ',
	  'tree': '木',
	  'trigger': 'トリガー',
	  'trophy': 'トロフィー',
	  'troubleshoot': 'トラブルシューティング',
	  'unlink': 'リンク解除',
	  'unlock': 'ロック解除',
	  'up': '上へ',
	  'update': '更新',
	  'upgrade': 'アップグレード',
	  'upload': 'アップロード',
	  'user-add': 'ユーザー追加',
	  'user-admin': 'ユーザー管理者',
	  'user-expert': 'ユーザー専門家',
	  'user-female': 'ユーザー女性',
	  'user-manager': 'ユーザーマネージャー',
	  'user-new': 'ユーザー新規',
	  'user-police': 'ユーザー警察',
	  'user-settings': 'ユーザー設定',
	  'user-worker': 'ユーザー作業者',
	  'user': 'ユーザー',
	  'validate': '検証',
	  'video': 'ビデオ',
	  'view': '表示',
	  'virtual-machine': '仮想マシン',
	  'vm-maintenance': 'VMメンテナンス',
	  'volume-low': 'ボリューム小',
	  'volume-mute': 'ボリュームミュート',
	  'volume': 'ボリューム',
	  'vulnerability': '脆弱性',
	  'waypoint': 'ウェイポイント',
	  'workshop': 'ワークショップ',
	  'zoom-in': 'ズームイン',
	  'zoom-out': 'ズームアウト'
	};
	module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  '3d': '3d',
	  'access-accessibility': 'toegang voor beperkten',
	  'access-ad': 'toegang tot AD',
	  'access-assist-listening': 'toegang tot begeleid luisteren',
	  'access-braille': 'toegang tot braille',
	  'access-sign': 'toegang tot gebarentaal',
	  'access-tty': 'toegang tot terminal',
	  'access-volume-control': 'toegang tot volumecontrole',
	  'access-wheelchair-active': 'toegang voor rolstoel is actief',
	  'access-wheelchair': 'toegang voor rolstoel',
	  'achievement': 'prestatie',
	  'action': 'actiie',
	  'actions': 'actiies',
	  'add-circle': 'voeg toe',
	  'add': 'voeg toe',
	  'aggregate': 'aggregaat',
	  'aid': 'hulp',
	  'alarm': 'alarm',
	  'alert': 'waarschuwing',
	  'analytics': 'analyze',
	  'announce': 'aankondiging',
	  'apps': 'toepassingen',
	  'archive': 'archief',
	  'article': 'artikel',
	  'ascend': 'stijging',
	  'attachment': 'bijlage',
	  'back-ten': 'tien terug',
	  'bar-chart': 'balkdiagram',
	  'basket': 'korf',
	  'blog': 'blog',
	  'book': 'boek',
	  'bookmark': 'bladwijzer',
	  'bottom-corner': 'hoek beneden',
	  'brand-apple-app-store': 'Apple AppStore',
	  'brand-codepen-edit': 'Editeer op CodePen',
	  'brand-codepen-try': 'Probeer CodePen',
	  'brand-google-play': 'Google Play',
	  'brand-grommet-outline': 'Grommet omtrek',
	  'brand-grommet-path': 'Grommet pad',
	  'brand-hpe-element-outline': 'HPE omtrek',
	  'brand-hpe-element-path': 'HPE pad',
	  'brand-hpe-labs-insignia-outline': 'HPE Labs Insignia omtrek',
	  'brand-hpe-labs-insignia': 'HPE Labs Insignia',
	  'brand-hpe-stack-centered': 'HPE stack gecentreerd',
	  'brand-hpe-stack': 'HPE stack',
	  'briefcase': 'boekentas',
	  'brush': 'borstel',
	  'bug': 'defect',
	  'bundle': 'bundel',
	  'business-service': 'zakelijke dienst',
	  'calculator': 'rekenmachine',
	  'calendar': 'kalender',
	  'camera': 'camera',
	  'capacity': 'capaciteit',
	  'car': 'wagen',
	  'caret-down': 'cursor naar beneden',
	  'caret-next': 'cursor volgende',
	  'caret-previous': 'cursor vorige',
	  'caret-up': 'cursor naar boven',
	  'cart': 'winkelkar',
	  'catalog': 'cataloog',
	  'chapter-add': 'nieuw hoofdstuk',
	  'chapter-next': 'volgend hoofdstuk',
	  'chapter-previous': 'vorig hoofdstuk',
	  'chat': 'chat',
	  'checkbox-selected': 'geselecteerde checkbox',
	  'checkbox': 'checkbox',
	  'checkmark': 'vinkje',
	  'circle-information': 'informatie in cirkel',
	  'circle-play': 'speel af in cirkel',
	  'circle-question': 'vraagteken in cirkel',
	  'clear-option': 'optie leeg maken',
	  'clear': 'leeg maken',
	  'cli': 'cli',
	  'clipboard': 'plakbord',
	  'clock': 'klok',
	  'clone': 'kloon',
	  'close': 'sluit',
	  'closed-caption': 'closed caption',
	  'cloud-computer': 'cloud computer',
	  'cloud-download': 'cloud download',
	  'cloud-software': 'cloud software',
	  'cloud-upload': 'cloud upload',
	  'cloud': 'cloud',
	  'cluster': 'cluster',
	  'code': 'code',
	  'columns': 'kolommen',
	  'compare': 'vergelijk',
	  'compass': 'kompas',
	  'compliance': 'naleving',
	  'configure': 'configureer',
	  'connect': 'verbind',
	  'contact-info': 'contact info',
	  'contact': 'contact',
	  'contract': 'contract',
	  'copy': 'kopieer',
	  'credit-card': 'credit card',
	  'cube': 'kubus',
	  'cubes': 'kubussen',
	  'currency': 'munteenheid',
	  'cursor': 'cursor',
	  'cut': 'knip',
	  'cycle': 'cyclus',
	  'dashboard': 'dashboard',
	  'database': 'database',
	  'deliver': 'leveren',
	  'deploy': 'ontplooien',
	  'descend': 'daling',
	  'desktop': 'desktop',
	  'detach': 'verbinding verbreken',
	  'diamond': 'diamand',
	  'directions': 'richtingen',
	  'dislike': 'niet leuk',
	  'document-cloud': 'document in de cloud',
	  'document-config': 'configuratie-document',
	  'document-csv': 'CSV document',
	  'document-download': 'download document',
	  'document-excel': 'Excel document',
	  'document-exe': 'uitvoerbaar bestand',
	  'document-image': 'document met afbeelding',
	  'document-locked': 'gereserveerd document',
	  'document-missing': 'ontbrekend document',
	  'document-notes': 'nota\'s',
	  'document-outlook': 'Outlook document',
	  'document-pdf': 'PDF document',
	  'document-performance': 'performantie document',
	  'document-ppt': 'Powerpoint document',
	  'document-rtf': 'RTF document',
	  'document-sound': 'document met geluid',
	  'document-store': 'opslagplaats documenten',
	  'document-test': 'test-document',
	  'document-threat': 'document bedreiging',
	  'document-time': 'document tijd',
	  'document-transfer': 'transfer-document',
	  'document-txt': 'tekst-document',
	  'document-update': 'document aanpassen',
	  'document-upload': 'document uploaden',
	  'document-user': 'document gebruiker',
	  'document-verified': 'geverifieerd document',
	  'document-video': 'video',
	  'document-windows': 'Windows document',
	  'document-word': 'Word document',
	  'document-zip': 'ZIP document',
	  'document': 'document',
	  'domain': 'domein',
	  'down': 'naar beneden',
	  'download': 'downloaden',
	  'drag': 'slepen',
	  'drive-cage': 'diskdrive-cabinet',
	  'duplicate': 'dupliceren',
	  'edit': 'editeren',
	  'eject': 'uitwerpen',
	  'empty-circle': 'lege cirkel',
	  'expand': 'expanderen',
	  'fan': 'ventilatie',
	  'fast-forward': 'snel vooruit',
	  'favorite': 'favoriet',
	  'filter': 'filter',
	  'finger-print': 'vingerafdruk',
	  'flag': 'vlag',
	  'folder-cycle': 'map met cyclus',
	  'folder-open': 'open map',
	  'folder': 'map',
	  'forward-ten': 'tien vooruit',
	  'gallery': 'galerij',
	  'gamepad': 'spelcontroller',
	  'gift': 'gift',
	  'globe': 'wereldbol',
	  'grid': 'raster',
	  'group': 'groep',
	  'grow': 'groei',
	  'halt': 'halt',
	  'help': 'help',
	  'history': 'geschiedenis',
	  'home': 'thuis',
	  'host-maintenance': 'onderhoud computer',
	  'host': 'computer',
	  'image': 'afbeelding',
	  'impact': 'impact',
	  'in-progress': 'bezig',
	  'inbox': 'inbox',
	  'indicator': 'indicator',
	  'info': 'info',
	  'inherit': 'erven',
	  'inspect': 'inspecteren',
	  'install': 'installeren',
	  'integration': 'integratie',
	  'iteration': 'iteratie',
	  'java': 'java',
	  'language': 'taal',
	  'launch': 'lancering',
	  'layer': 'laag',
	  'license': 'licentie',
	  'like': 'leuk',
	  'line-chart': 'lijndiagram',
	  'link-bottom': 'link bodem',
	  'link-down': 'link naar beneden',
	  'link-next': 'link volgende',
	  'link-previous': 'link vorige',
	  'link-top': 'link top',
	  'link-up': 'link naar boven',
	  'link': 'link',
	  'local': 'lokaal',
	  'location-pin': 'locatiepin',
	  'location': 'locatie',
	  'lock': 'slot',
	  'login': 'aanmelden',
	  'logout': 'afmelden',
	  'magic': 'magie',
	  'mail-option': 'optie mail',
	  'mail': 'mail',
	  'manual': 'manueel',
	  'map-location': 'positie op kaart',
	  'map': 'kaart',
	  'menu': 'menu',
	  'microphone': 'microfoon',
	  'money': 'geld',
	  'monitor': 'monitor',
	  'more': 'meer',
	  'multiple': 'meerdere',
	  'navigate': 'navigeren',
	  'new-window': 'nieuw venster',
	  'new': 'nieuw',
	  'next': 'volgende',
	  'nodes': 'nodes',
	  'note': 'nota',
	  'notes': 'nota\'s',
	  'notification': 'notificatie',
	  'object-group': 'groepeer objecten',
	  'object-ungroup': 'maak object-groepering ongedaan',
	  'optimize': 'optimaliseren',
	  'organization': 'organisatie',
	  'overview': 'overzicht',
	  'pan': 'verschuiven',
	  'pause-fill': 'pause vol',
	  'pause': 'pause',
	  'personal-computer': 'personal computer',
	  'pie-chart': 'taartdiagram',
	  'pin': 'pin',
	  'plan': 'plan',
	  'platform-amazon': 'Amazon',
	  'platform-android': 'Android',
	  'platform-apple': 'Apple',
	  'platform-archlinux': 'Archlinux',
	  'platform-aruba': 'Aruba',
	  'platform-centos': 'CentOS',
	  'platform-chrome': 'Chrome',
	  'platform-cloudlinux': 'CloudLinux',
	  'platform-debian': 'Debian',
	  'platform-docker': 'Docker',
	  'platform-dos': 'DOS',
	  'platform-dropbox': 'Dropbox',
	  'platform-edge': 'Edge',
	  'platform-fedora': 'Fedora',
	  'platform-firefox': 'Firefox',
	  'platform-freebsd': 'FreeBSD',
	  'platform-google': 'Google',
	  'platform-hadoop': 'Hadoop',
	  'platform-heroku': 'Heroku',
	  'platform-horton': 'Horton',
	  'platform-hp': 'HP',
	  'platform-hpi': 'HPI',
	  'platform-internet-explorer': 'Internet Explorer',
	  'platform-java': 'Java',
	  'platform-mandriva': 'Mandriva',
	  'platform-mysql': 'MySQL',
	  'platform-norton': 'Norton',
	  'platform-onedrive': 'OneDrive',
	  'platform-opera': 'Opera',
	  'platform-oracle': 'Oracle',
	  'platform-pied-piper': 'Pied Piper',
	  'platform-raspberry': 'Raspberry',
	  'platform-reactjs': 'ReactJS',
	  'platform-redhat': 'RedHat',
	  'platform-safari-option': 'Safari optie',
	  'platform-safari': 'Safari',
	  'platform-sco': 'SCO',
	  'platform-solaris': 'Solaris',
	  'platform-suse': 'SUSE',
	  'platform-swift': 'Swift',
	  'platform-turbolinux': 'TurboLinux',
	  'platform-ubuntu': 'Ubuntu',
	  'platform-unixware': 'Unixware',
	  'platform-vmware': 'VMware',
	  'platform-windows-legacy': 'Windows legacy',
	  'platform-windows': 'Windows',
	  'play-fill': 'afspelen vol',
	  'play': 'afspelen',
	  'power': 'aanzetten',
	  'previous': 'vorige',
	  'print': 'afdrukken',
	  'radial-selected': 'geselecteerde radiaal',
	  'radial': 'radiaal',
	  'refresh': 'verversen',
	  'resources': 'middelen',
	  'resume': 'verder gaan',
	  'revert': 'ongedaan maken',
	  'rewind': 'terugspoelen',
	  'risk': 'risico',
	  'robot': 'robot',
	  'rss': 'RSS',
	  'run': 'lopen',
	  'satellite': 'satelliet',
	  'save': 'bewaren',
	  'scan': 'scannen',
	  'schedule-new': 'nieuw rooster',
	  'schedule-play': 'speel rooster af',
	  'schedule': 'rooster',
	  'schedules': 'roosters',
	  'scorecard': 'score kaart',
	  'search-advanced': 'geavanceerd zoeken',
	  'search': 'zoeken',
	  'secure': 'beveiligd',
	  'select': 'selecteren',
	  'selection': 'selectie',
	  'send': 'verzenden',
	  'server-cluster': 'server cluster',
	  'server': 'server',
	  'servers': 'servers',
	  'service-play': 'dienst afspelen',
	  'services': 'diensten',
	  'settings-option': 'instellingen optie',
	  'share': 'delen',
	  'shield-security': 'veiligheidsschild',
	  'shield': 'schild',
	  'shift': 'schuif',
	  'sidebar': 'zijbalk',
	  'social-amazon': 'Amazon sociaal',
	  'social-amex': 'Amex sociaal',
	  'social-bitcoin': 'Bitcoin sociaal',
	  'social-codepen': 'CodePen sociaal',
	  'social-creative-commons': 'Creative Commons sociaal',
	  'social-dropbox': 'Dropbox sociaal',
	  'social-facebook-option': 'Facebook optie sociaal',
	  'social-facebook': 'Facebook sociaal',
	  'social-github': 'Githu sociaal',
	  'social-google-plus': 'Google Plus sociaal',
	  'social-google-wallet': 'Google Wallet sociaal',
	  'social-instagram': 'Instagram sociaal',
	  'social-linkedin-option': 'LinkedIN optie',
	  'social-linkedin': 'LinkedIN sociaal',
	  'social-mail': 'mail sociaal',
	  'social-mastercard': 'Mastercard sociaal',
	  'social-medium': 'medium sociaal',
	  'social-paypal': 'PayPal sociaal',
	  'social-pinterest': 'Pinterest sociaal',
	  'social-product-hunt': 'product Hunt sociaal',
	  'social-reddit': 'Reddit sociaal',
	  'social-skype': 'Skype sociaal',
	  'social-slack': 'Slack sociaal',
	  'social-snapchat': 'Snapchat sociaal',
	  'social-square': 'Square sociaal',
	  'social-stack-overflow': 'Stack Overflow sociaal',
	  'social-stripe': 'Stripe sociaal',
	  'social-tumblr': 'TumblR sociaal',
	  'social-twitter': 'Twitter sociaal',
	  'social-vimeo': 'Vimeo sociaal',
	  'social-vine': 'Vine sociaal',
	  'social-visa': 'Visa sociaal',
	  'social-wordpress': 'Wordpress sociaal',
	  'social-youtube': 'Youtube sociaal',
	  'sort': 'sorteren',
	  'split': 'splitsen',
	  'splits': 'splitsingen',
	  'stakeholder': 'belanghebbende',
	  'standards-3d-effects': 'standaarden 3d effecten',
	  'standards-connectivity': 'standaarden connectiviteit',
	  'standards-css3': 'standaarden CSS3',
	  'standards-device': 'standaarden toestel',
	  'standards-fireball': 'standaarden fireball',
	  'standards-html5': 'standaarden HTML5',
	  'standards-multimedia': 'standaarden multimedia',
	  'standards-offline-storage': 'standaarden offline opslag',
	  'standards-performance': 'standaarden performantie',
	  'standards-sematics': 'standaarden sematiek',
	  'star-half': 'halve ster',
	  'star': 'ster',
	  'steps': 'stappen',
	  'stop-fill': 'stoppen vol',
	  'stop': 'stoppen',
	  'storage': 'opslag',
	  'street-view': 'street view',
	  'subtract-circle': 'aftrekken met cirkel',
	  'subtract': 'aftrekken',
	  'support': 'ondersteuning',
	  'sync': 'synchroniseren',
	  'system': 'systeem',
	  'table-add': 'voeg toe in tabel',
	  'table': 'tabel',
	  'tag': 'label',
	  'target': 'doel',
	  'task': 'taak',
	  'tasks': 'taken',
	  'technology': 'technologie',
	  'template': 'sjabloon',
	  'terminal': 'terminal',
	  'test-desktop': 'test-desktop',
	  'test': 'test',
	  'text-wrap': 'tekst rondgewikkeld',
	  'threats': 'bedreigingen',
	  'ticket': 'ticket',
	  'tools': 'gereedschap',
	  'tooltip': 'tooltip',
	  'top-corner': 'hoek boven',
	  'transaction': 'transactie',
	  'trash': 'vuilbak',
	  'tree': 'boom',
	  'trigger': 'in gang zetten',
	  'trophy': 'trofee',
	  'troubleshoot': 'oplossen',
	  'unlink': 'verbinding verbreken',
	  'unlock': 'ontsluiten',
	  'up': 'naar boven',
	  'update': 'aanpassen',
	  'upgrade': 'upgraden',
	  'upload': 'uploaden',
	  'user-add': 'gebruiker toevoegen',
	  'user-admin': 'administrator',
	  'user-expert': 'expert',
	  'user-female': 'dame',
	  'user-manager': 'manager',
	  'user-new': 'nieuwe gebuiker',
	  'user-police': 'politieagent',
	  'user-settings': 'gebruikersinstellingen',
	  'user-worker': 'arbeider',
	  'user': 'gebruiker',
	  'validate': 'valideren',
	  'video': 'video',
	  'view': 'bekijken',
	  'virtual-machine': 'virtuele machine',
	  'vm-maintenance': 'onderhoud VM',
	  'volume-low': 'laag volume',
	  'volume-mute': 'volume uit',
	  'volume': 'volume',
	  'vulnerability': 'kwestbaarheid',
	  'waypoint': 'richtingsaanduiding',
	  'workshop': 'workshop',
	  'zoom-in': 'inzoomen',
	  'zoom-out': 'uitzoomen'
	};
	module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  '3d': '3d',
	  'access-accessibility': '访问辅助功能',
	  'access-ad': '访问 ad',
	  'access-assist-listening': '访问辅助听力',
	  'access-braille': '访问盲文',
	  'access-sign': '访问标志',
	  'access-tty': '访问 tty',
	  'access-volume-control': '访问音量控制',
	  'access-wheelchair-active': '访问轮椅活动',
	  'access-wheelchair': '访问轮椅',
	  'achievement': '成果',
	  'action': '操作',
	  'actions': '操作',
	  'add-circle': '添加循环',
	  'add': '添加',
	  'aggregate': '聚合',
	  'aid': '辅助',
	  'alarm': '警报',
	  'alert': '警报',
	  'analytics': '分析',
	  'announce': '通告',
	  'apps': '应用程序',
	  'archive': '存档',
	  'article': '文章',
	  'ascend': '升序',
	  'attachment': '附件',
	  'back-ten': '后退十步',
	  'bar-chart': '条形图',
	  'basket': '购物篮',
	  'blog': '博客',
	  'book': '书',
	  'bookmark': '书签',
	  'bottom-corner': '底角',
	  'brand-apple-app-store': 'apple 品牌应用商店',
	  'brand-codepen-edit': 'codepen 品牌编辑',
	  'brand-codepen-try': 'codepen 品牌尝试',
	  'brand-google-play': 'google play 品牌',
	  'brand-grommet-outline': 'grommet 品牌轮廓',
	  'brand-grommet-path': 'grommet 品牌路径',
	  'brand-hpe-element-outline': 'hpe 品牌元素轮廓',
	  'brand-hpe-element-path': 'hpe 品牌元素路径',
	  'brand-hpe-labs-insignia-outline': 'hpe 品牌实验室徽章轮廓',
	  'brand-hpe-labs-insignia': 'hpe 品牌实验室徽章',
	  'brand-hpe-stack-centered': 'hpe 品牌堆栈居中',
	  'brand-hpe-stack': 'hpe 品牌堆栈',
	  'briefcase': '公文包',
	  'brush': '刷子',
	  'bug': '缺陷',
	  'bundle': '包',
	  'business-service': '业务服务',
	  'calculator': '计算器',
	  'calendar': '日历',
	  'camera': '相机',
	  'capacity': '容量',
	  'car': 'car',
	  'caret-down': '脱字号下',
	  'caret-next': '脱字号后',
	  'caret-previous': '脱字号前',
	  'caret-up': '脱字号上',
	  'cart': '购物车',
	  'catalog': '目录',
	  'chapter-add': '添加章',
	  'chapter-next': '下一章',
	  'chapter-previous': '上一章',
	  'chat': '聊天',
	  'checkbox-selected': '复选框选中',
	  'checkbox': '复选框',
	  'checkmark': '复选标记',
	  'circle-information': '循环信息',
	  'circle-play': '循环播放',
	  'circle-question': '循环问题',
	  'clear-option': '清除选项',
	  'clear': '清除',
	  'cli': 'cli',
	  'clipboard': '剪贴板',
	  'clock': '时钟',
	  'clone': '克隆',
	  'close': '关闭',
	  'closed-caption': '隐藏字幕',
	  'cloud-computer': '云计算机',
	  'cloud-download': '云下载',
	  'cloud-software': '云软件',
	  'cloud-upload': '云上载',
	  'cloud': '云',
	  'cluster': '群集',
	  'code': '代码',
	  'columns': '列',
	  'compare': '比较',
	  'compass': '指南针',
	  'compliance': '合规性',
	  'configure': '配置',
	  'connect': '连接',
	  'contact-info': '联系人信息',
	  'contact': '联系人',
	  'contract': '合同',
	  'copy': '复制',
	  'credit-card': '信用卡',
	  'cube': '立方形',
	  'cubes': '立方形',
	  'currency': '货币',
	  'cursor': '光标',
	  'cut': '剪切',
	  'cycle': '周期',
	  'dashboard': '控制面板',
	  'database': '数据库',
	  'deliver': '提供',
	  'deploy': '部署',
	  'descend': '降序',
	  'desktop': '桌面',
	  'detach': '分离',
	  'diamond': '钻石',
	  'directions': '方向',
	  'dislike': '踩',
	  'document-cloud': '文档云',
	  'document-config': '文档配置',
	  'document-csv': 'csv 文档',
	  'document-download': '文档下载',
	  'document-excel': 'excel 文档',
	  'document-exe': 'exe 文档',
	  'document-image': '图像文档',
	  'document-locked': '文档被锁定',
	  'document-missing': '文档丢失',
	  'document-notes': '文档注释',
	  'document-outlook': 'outlook 文档',
	  'document-pdf': 'pdf 文档',
	  'document-performance': '文档性能',
	  'document-ppt': 'ppt 文档',
	  'document-rtf': 'rtf 文档',
	  'document-sound': '声音文档',
	  'document-store': '文档存储',
	  'document-test': '文档测试',
	  'document-threat': '文档威胁',
	  'document-time': '文档时间',
	  'document-transfer': '文档传输',
	  'document-txt': 'txt 文档',
	  'document-update': '文档更新',
	  'document-upload': '文档上载',
	  'document-user': '文档用户',
	  'document-verified': '已验证文档',
	  'document-video': '视频文档',
	  'document-windows': 'Windows 文档',
	  'document-word': 'word 文档',
	  'document-zip': 'zip 文档',
	  'document': '文档',
	  'domain': '域',
	  'down': '下',
	  'download': '下载',
	  'drag': '拖动',
	  'drive-cage': '驱动器固定架',
	  'duplicate': '重复',
	  'edit': '编辑',
	  'eject': '弹出',
	  'empty-circle': '空循环',
	  'expand': '展开',
	  'fan': '风扇',
	  'fast-forward': '快进',
	  'favorite': '收藏',
	  'filter': '筛选',
	  'finger-print': '指纹',
	  'flag': '标志',
	  'folder-cycle': '文件夹刷新',
	  'folder-open': '文件夹已打开',
	  'folder': '文件夹',
	  'forward-ten': '前进十步',
	  'gallery': '画廊',
	  'gamepad': '游戏板',
	  'gift': '礼物',
	  'globe': '全球',
	  'grid': '网格',
	  'group': '组',
	  'grow': '增长',
	  'halt': '停止',
	  'help': '帮助',
	  'history': '历史记录',
	  'home': '主页',
	  'host-maintenance': '主机维护',
	  'host': '主机',
	  'image': '映像',
	  'impact': '影响',
	  'in-progress': '正在进行',
	  'inbox': '收件箱',
	  'indicator': '指标',
	  'info': '信息',
	  'inherit': '继承',
	  'inspect': '检查',
	  'install': '安装',
	  'integration': '集成',
	  'iteration': '迭代',
	  'java': 'java',
	  'language': '语言',
	  'launch': '启动',
	  'layer': '层',
	  'license': '许可',
	  'like': '赞',
	  'line-chart': '折线图',
	  'link-bottom': '链接底部',
	  'link-down': '链接中断',
	  'link-next': '下一个链接',
	  'link-previous': '上一个链接',
	  'link-top': '链接顶部',
	  'link-up': '链接连通',
	  'link': '链接',
	  'local': '本地',
	  'location-pin': '定位销',
	  'location': '位置',
	  'lock': '锁',
	  'login': '登录',
	  'logout': '注销',
	  'magic': '魔力',
	  'mail-option': '邮件选项',
	  'mail': '邮件',
	  'manual': '手动',
	  'map-location': '地图位置',
	  'map': '地图',
	  'menu': '菜单',
	  'microphone': '麦克风',
	  'money': '资金',
	  'monitor': '监控',
	  'more': '更多',
	  'multiple': '多个',
	  'navigate': '导航',
	  'new-window': '新窗口',
	  'new': '新',
	  'next': '下一页',
	  'nodes': '节点',
	  'note': '注释',
	  'notes': '备注',
	  'notification': '通知',
	  'object-group': '对象分组',
	  'object-ungroup': '取消组合对象',
	  'optimize': '优化',
	  'organization': '组织',
	  'overview': '概述',
	  'pan': '平移',
	  'pause-fill': '暂停填充',
	  'pause': '暂停',
	  'personal-computer': '个人计算机',
	  'pie-chart': '饼图',
	  'pin': '大头针',
	  'plan': '计划',
	  'platform-amazon': 'amazon 平台',
	  'platform-android': 'android 平台',
	  'platform-apple': 'apple 平台',
	  'platform-archlinux': 'archlinux 平台',
	  'platform-aruba': 'aruba 平台',
	  'platform-centos': 'centos 平台',
	  'platform-chrome': 'chrome 平台',
	  'platform-cloudlinux': 'cloudlinux 平台',
	  'platform-debian': 'debian 平台',
	  'platform-docker': 'docker 平台',
	  'platform-dos': 'dos 平台',
	  'platform-dropbox': 'dropbox 平台',
	  'platform-edge': 'edge 平台',
	  'platform-fedora': 'fedora 平台',
	  'platform-firefox': 'firefox 平台',
	  'platform-freebsd': 'freebsd 平台',
	  'platform-google': 'google 平台',
	  'platform-hadoop': 'hadoop 平台',
	  'platform-heroku': 'heroku 平台',
	  'platform-horton': 'horton 平台',
	  'platform-hp': 'hp 平台',
	  'platform-hpi': 'hpi 平台',
	  'platform-internet-explorer': 'internet explorer 平台',
	  'platform-java': 'java 平台',
	  'platform-mandriva': 'mandriva 平台',
	  'platform-mysql': 'mysql 平台',
	  'platform-norton': 'norton 平台',
	  'platform-onedrive': 'onedrive 平台',
	  'platform-opera': 'opera 平台',
	  'platform-oracle': 'oracle 平台',
	  'platform-pied-piper': 'pied piper 平台',
	  'platform-raspberry': 'raspberry 平台',
	  'platform-reactjs': 'reactjs 平台',
	  'platform-redhat': 'redhat 平台',
	  'platform-safari-option': 'safari 平台选项',
	  'platform-safari': 'safari 平台',
	  'platform-sco': 'sco 平台',
	  'platform-solaris': 'solaris 平台',
	  'platform-suse': 'suse 平台',
	  'platform-swift': 'swift 平台',
	  'platform-turbolinux': 'turbolinux 平台',
	  'platform-ubuntu': 'ubuntu 平台',
	  'platform-unixware': 'unixware 平台',
	  'platform-vmware': 'vmware 平台',
	  'platform-windows-legacy': 'windows 旧版平台',
	  'platform-windows': 'windows 平台',
	  'play-fill': '播放填充',
	  'play': '播放',
	  'power': '电源',
	  'previous': '上一页',
	  'print': '打印',
	  'radial-selected': '径向选择',
	  'radial': '径向',
	  'refresh': '刷新',
	  'resources': '资源',
	  'resume': '继续',
	  'revert': '恢复',
	  'rewind': '倒带',
	  'risk': '风险',
	  'robot': '机器人',
	  'rss': 'rss',
	  'run': '运行',
	  'satellite': '卫星',
	  'save': '保存',
	  'scan': '扫描',
	  'schedule-new': '新建计划',
	  'schedule-play': '播放计划',
	  'schedule': '计划',
	  'schedules': '计划',
	  'scorecard': '记分卡',
	  'search-advanced': '高级搜索',
	  'search': '搜索',
	  'secure': '安全',
	  'select': '选择',
	  'selection': '选择',
	  'send': '发送',
	  'server-cluster': '服务器群集',
	  'server': '服务器',
	  'servers': '服务器',
	  'service-play': '播放服务',
	  'services': '服务',
	  'settings-option': '设置选项',
	  'share': '共享',
	  'shield-security': '安全防护',
	  'shield': '防护',
	  'shift': '转变',
	  'sidebar': '侧栏',
	  'social-amazon': 'amazon 社交',
	  'social-amex': 'amex 社交',
	  'social-bitcoin': 'bitcoin 社交',
	  'social-codepen': 'codepen 社交',
	  'social-creative-commons': 'creative commons 社交',
	  'social-dropbox': 'dropbox 社交',
	  'social-facebook-option': 'facebook option 社交',
	  'social-facebook': 'facebook 社交',
	  'social-github': 'github 社交',
	  'social-google-plus': 'google plus 社交',
	  'social-google-wallet': 'google wallet 社交',
	  'social-instagram': 'instagram 社交',
	  'social-linkedin-option': 'linkedin option 社交',
	  'social-linkedin': 'linkedin 社交',
	  'social-mail': 'mail 社交',
	  'social-mastercard': 'mastercard 社交',
	  'social-medium': 'medium 社交',
	  'social-paypal': 'paypal 社交',
	  'social-pinterest': 'pinterest 社交',
	  'social-product-hunt': 'product hunt 社交',
	  'social-reddit': 'reddit 社交',
	  'social-skype': 'skype 社交',
	  'social-slack': 'slack 社交',
	  'social-snapchat': 'snapchat 社交',
	  'social-square': 'square 社交',
	  'social-stack-overflow': 'stack overflow 社交',
	  'social-stripe': 'stripe 社交',
	  'social-tumblr': 'tumblr 社交',
	  'social-twitter': 'twitter 社交',
	  'social-vimeo': 'vimeo 社交',
	  'social-vine': 'vine 社交',
	  'social-visa': 'visa 社交',
	  'social-wordpress': 'wordpress 社交',
	  'social-youtube': 'youtube 社交',
	  'sort': '排序',
	  'split': '拆分',
	  'splits': '拆分',
	  'stakeholder': '利益相关者',
	  'standards-3d-effects': '3d 效果标准',
	  'standards-connectivity': '连接标准',
	  'standards-css3': 'css3 标准',
	  'standards-device': '设备标准',
	  'standards-fireball': 'fireball 标准',
	  'standards-html5': 'html5 标准',
	  'standards-multimedia': '多媒体标准',
	  'standards-offline-storage': '脱机存储标准',
	  'standards-performance': '性能标准',
	  'standards-sematics': '语义标准',
	  'star-half': '半星',
	  'star': '星级',
	  'steps': '步骤',
	  'stop-fill': '停止填充',
	  'stop': '停止',
	  'storage': '存储',
	  'street-view': '街景',
	  'subtract-circle': '减去循环',
	  'subtract': '减去',
	  'support': '支持',
	  'sync': '同步',
	  'system': '系统',
	  'table-add': '添加表',
	  'table': '表',
	  'tag': '标记',
	  'target': '目标',
	  'task': '任务',
	  'tasks': '任务',
	  'technology': '技术',
	  'template': '模板',
	  'terminal': '终端',
	  'test-desktop': '测试桌面',
	  'test': '测试',
	  'text-wrap': '文字环绕',
	  'threats': '威胁',
	  'ticket': '记录单',
	  'tools': '工具',
	  'tooltip': '工具提示',
	  'top-corner': '顶角',
	  'transaction': '交易',
	  'trash': '垃圾',
	  'tree': '树',
	  'trigger': '触发',
	  'trophy': '奖品',
	  'troubleshoot': '疑难解答',
	  'unlink': '取消链接',
	  'unlock': '解锁',
	  'up': '上',
	  'update': '更新',
	  'upgrade': '升级',
	  'upload': '上载',
	  'user-add': '添加用户',
	  'user-admin': '管理员用户',
	  'user-expert': '专家用户',
	  'user-female': '女性用户',
	  'user-manager': '用户管理器',
	  'user-new': '新用户',
	  'user-police': '警察用户',
	  'user-settings': '用户设置',
	  'user-worker': '工人用户',
	  'user': '用户',
	  'validate': '验证',
	  'video': '视频',
	  'view': '查看',
	  'virtual-machine': '虚拟机',
	  'vm-maintenance': '虚拟机维护',
	  'volume-low': '音量低',
	  'volume-mute': '静音',
	  'volume': '音量',
	  'vulnerability': '漏洞',
	  'waypoint': '路径点',
	  'workshop': '工作室',
	  'zoom-in': '放大',
	  'zoom-out': '缩小'
	};
	module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _enUS = __webpack_require__(56);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({
	  IndexFilters: {
	    filters: '{quantity, plural,\n  =0 {フィルター}\n  =1 {1つのフィルター}\n  ' + 'other {#個のフィルター}\n}'
	  }
	}, _enUS2.default, {
	  Active: 'アクティブ',
	  Activate: 'アクティブ化',
	  Activated: 'アクティブ化済み',
	  Add: '追加',
	  add: '追加',
	  Alerts: 'アラート',
	  All: 'すべて',
	  ampm: 'ampm',
	  Arc: '円弧',
	  AxisLabel: '{orientation}軸',
	  area: '領域',
	  Bar: 'バー',
	  bar: 'バー',
	  Blank: '空白',
	  Box: 'ボックス',
	  Carousel: 'カルーセル',
	  Category: 'カテゴリ',
	  Circle: '円',
	  Chart: 'グラフ',
	  Children: '子',
	  Clear: 'クリア',
	  Cleared: 'クリア済み',
	  Close: '閉じる',
	  'Close Menu': 'メニューを閉じる',
	  Completed: '完了',
	  'Connects With': '接続先',
	  created: '作成済み',
	  Critical: '重大',
	  'Currently Active': '現在アクティブ',
	  'Date Selector': '日付セレクター',
	  'Date Time Icon': '日付時刻セレクターを開く',
	  day: '日',
	  Disabled: '無効',
	  Distribution: '配布',
	  Email: '電子メール',
	  'Enter Select': 'Enterを押して選択',
	  Error: 'エラー',
	  Filter: 'フィルター',
	  Footer: 'フッター',
	  Grommet: 'Grommet',
	  HotSpotsLabel: 'ホットスポット: 矢印キーを押して対話操作する',
	  'GraphValues': 'グラフには{count}個の項目があります。最高は{highest}、' + ' 最小は{smallest}です',
	  hour: '時間',
	  'Grommet Logo': 'Grommetロゴ',
	  'Layer': 'レイヤー',
	  List: 'リスト',
	  line: '線',
	  'Loading': 'ロード中',
	  loginInvalidPassword: 'ユーザー名とパスワードを指定してください。',
	  'Log In': 'ログイン',
	  Logout: 'ログアウト',
	  'Main Content': 'メインコンテンツ',
	  Max: '最大',
	  Menu: 'メニュー',
	  Meter: 'メートル',
	  Min: '最小',
	  minute: '分',
	  model: 'モデル',
	  modified: '変更済み',
	  monitor: 'モニター',
	  month: '月',
	  'Multi Select': '複数選択',
	  Name: '名前',
	  'Navigation Help': 'ナビゲーションには矢印キーを使用します',
	  'Next Month': '次の月',
	  'Next Slide': '次のスライド',
	  'No Relationship': '関係なし',
	  'Notification': '通知',
	  OK: 'OK',
	  Open: '開く',
	  Parent: '親',
	  Parents: '親',
	  Parts: '部品',
	  Part: '部品',
	  Password: 'パスワード',
	  'Previous Month': '前の月',
	  'Previous Slide': '前のスライド',
	  'Previous Tiles': '前のタイル',
	  'Remember me': 'ユーザー名を保存する',
	  Resource: 'リソース',
	  Running: '実行中',
	  Search: '検索',
	  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
	  second: '秒',
	  'Select Icon': '選択ドロップを開く',
	  Selected: '選択済み',
	  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
	  'Skip to': 'スキップ先',
	  'Slide Number': 'スライド{slideNumber}',
	  Sort: 'ソート',
	  Spinning: '回転',
	  Spiral: 'スパイラル',
	  State: '状態',
	  Status: 'ステータス',
	  Subtract: '減算',
	  SunBurst: 'サンバースト',
	  'Tab Contents': '[{activeTitle}] タブの内容',
	  Table: 'テーブル',
	  Tasks: 'タスク',
	  Tiles: 'タイル',
	  Time: '時刻',
	  Title: 'タイトル',
	  Today: '今日',
	  Topology: 'トポロジ',
	  Total: '合計',
	  Threshold: 'しきい値',
	  Unknown: '不明',
	  Username: 'ユーザー名',
	  uri: 'URI',
	  Value: '値',
	  Warning: '警告',
	  year: '年'
	});
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	exports.default = {
	  IndexFilters: {
	    filters: '{quantity, plural,\n  =0 {Filtros}\n  =1 {um filtro}\n  ' + 'other {# filtros}\n}'
	  },
	  Active: 'Ativos',
	  Activate: 'Ativar',
	  Activated: 'Ativado',
	  Add: 'Adicionar',
	  add: 'adicionar',
	  Alerts: 'Alertas',
	  All: 'Todos',
	  AxisLabel: 'Coordenada {orientation}',
	  area: 'Área',
	  Bar: 'Bar',
	  bar: 'bar',
	  Blank: 'Em branco',
	  Box: 'Box',
	  Carousel: 'Carrossel',
	  camera: 'Câmera',
	  Category: 'Categoria',
	  Circle: 'Círculo',
	  Chart: 'Gráfico',
	  Children: 'Filho',
	  Clear: 'Limpar',
	  Cleared: 'Livre',
	  Close: 'Fechar',
	  close: 'fechar',
	  'Close Menu': 'Fechar Menu',
	  'command-line': 'linha de comando',
	  Completed: 'Completado',
	  'Connects With': 'Conecta-se com',
	  created: 'Criado',
	  Critical: 'Crítico',
	  'Currently Active': 'Ativo Atualmente',
	  'Date Selector': 'Seletor de Data',
	  'Date Time Icon': 'Abrir Seleção de Data e Hora',
	  Disabled: 'Desabilitado',
	  Distribution: 'Distribuição',
	  down: 'baixo',
	  Email: 'Email',
	  'Enter Select': 'Pressione enter para selecionar',
	  Error: 'Erro',
	  Filter: 'Filtro',
	  filter: 'filtro',
	  Footer: 'Rodapé',
	  HotSpotsLabel: 'HotSpots: pressione setas de nevegação para interagir',
	  hour: 'hora',
	  'GraphValues': 'Gráfico têm {count} itens. O maior é {highest}' + ' e o menor é {smallest}',
	  'Grommet Logo': 'Gromment Logomarca',
	  'Layer': 'Modal',
	  line: 'linha',
	  'link-next': 'link-next',
	  'link-previous': 'link-previous',
	  'Loading': 'Carregando',
	  loginInvalidPassword: 'Por favor, informe Usuário e Senha.',
	  'Log In': 'Logar',
	  Logout: 'Deslogar',
	  'Main Content': 'Conteúdo Principal',
	  Max: 'Max',
	  Menu: 'Menu',
	  menu: 'menu',
	  Meter: 'Meter',
	  Min: 'Min',
	  minute: 'minuto',
	  model: 'Modelo',
	  modified: 'Modificado',
	  monitor: 'monitor',
	  more: 'mais',
	  'Multi Select': 'Seleção Múltipla',
	  Name: 'Nome',
	  'Navigation Help': 'Use as setas para navegar',
	  'Next Month': 'Próximo Mês',
	  'Next Slide': 'Próximo Slide',
	  'No Relationship': 'Sem Relacionamento',
	  'Notification': 'Notificação',
	  OK: 'OK',
	  Open: 'Abrir',
	  Parent: 'Pai',
	  Parents: 'Pais',
	  Parts: 'Partes',
	  Part: 'Parte',
	  Password: 'Senha',
	  power: 'power',
	  'Previous Month': 'Mês Anterior',
	  'Previous Slide': 'Slide Anterior',
	  'Previous Tiles': 'Tiles Anteriores',
	  'Remember me': 'Lembrar Usuário',
	  Resource: 'Recurso',
	  Running: 'Executando',
	  Search: 'Buscar',
	  search: 'buscar',
	  'Match Results': '{count, plural,\n      =0 {N\xE3o existe sugest\xE3o}\n      one {Existe # sugest\xE3o}\n      other {Existem # sugest\xF5es}\n  }',
	  second: 'segundo',
	  'Select Icon': 'Abrir menu de seleção',
	  Selected: 'Selecionada(o)',
	  'Skip to': 'Saltar para',
	  'Slide Number': 'Slide {slideNumber}',
	  Spinning: 'Carregando',
	  State: 'Estado',
	  Status: 'Situaçāo',
	  SubBurst: 'SubBurst',
	  Subtract: 'Subtrair',
	  subtract: 'subtrair',
	  'Tab Contents': '{activeTitle} Conteúdo da Tab',
	  Table: 'Tabela',
	  Tasks: 'Tarefas',
	  Tiles: 'Tiles',
	  Time: 'Data',
	  Title: 'Título',
	  Today: 'Hoje',
	  Topology: 'Topologia',
	  Total: 'Total',
	  trash: 'lixeira',
	  Threshold: 'Limiar',
	  Unknown: 'Desconhecido',
	  user: 'user',
	  Username: 'Usuário',
	  uri: 'URI',
	  validation: 'validation',
	  Value: 'Valor',
	  Warning: 'Alerta'
	};
	module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _enUS = __webpack_require__(56);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({
	  IndexFilters: { // Did I understand the interpolation syntax?
	    filters: '{quantity, plural,\n      =0 {\u043D\u0435\u0442 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432}\n      =1 {\u043E\u0434\u0438\u043D \u0444\u0438\u043B\u044C\u0442\u0440}\n      other {# \u0444\u0438\u043B\u044C\u0442\u0440\u044B}\n    }'
	  }
	}, _enUS2.default, {
	  Active: 'Активный',
	  Activate: 'Активировать',
	  Activated: 'Активирован',
	  Add: 'Добавить',
	  add: 'добавить',
	  Alerts: 'Уведомления',
	  All: 'Все',
	  ampm: 'ампм', // context?
	  Arc: 'Дуга',
	  AxisLabel: '{orientation} Ось',
	  area: 'зона',
	  Bar: 'Бар', // context?
	  bar: 'бар', // context?
	  Blank: 'Пустой',
	  Box: 'Ящик', // context?
	  Carousel: 'Карусель',
	  Category: 'Категория',
	  Circle: 'Круг',
	  Chart: 'Диаграмма',
	  Children: 'Дети',
	  Clear: 'Очистить',
	  Cleared: 'Очищенный',
	  Close: 'Закрыть',
	  'Close Menu': 'Закрыть меню',
	  Completed: 'Завершенный',
	  'Connects With': 'Соединяется с',
	  created: 'созданный',
	  Critical: 'Критический',
	  'Currently Active': 'Активный',
	  'Date Selector': 'Выбор даты',
	  'Date Time Icon': 'Выбор даты и времени',
	  day: 'день',
	  Disabled: 'Отключен',
	  Distribution: 'Распределение',
	  Email: 'Эл. адрес',
	  'Enter Select': 'Нажмите enter чтобы выбрать его',
	  Error: 'Ошибка',
	  Filter: 'Фильтр',
	  Footer: 'Нижний колонтитул', // Not 100% sure on this one
	  Grommet: 'Громмет',
	  HotSpotsLabel: 'HotSpots: нажмите клавиши со стрелками, чтобы взаимодействовать с ним.',
	  'GraphValues': 'График имеет {count} элементы. Наивысшее - {highest}, а наименьшее - {smallest}',
	  hour: 'час',
	  'Grommet Logo': 'Громмет Лого',
	  Layer: 'Слой',
	  List: 'Список',
	  line: 'линия',
	  Loading: 'Загружается',
	  loginInvalidPassword: 'Пожалуйста, укажите имя и пароль пользователя.',
	  'Log In': 'Авторизоваться',
	  Logout: 'Выйти',
	  'Main Content': 'Основное содержание',
	  Max: 'Максимум',
	  Menu: 'Меню',
	  Meter: 'метр',
	  Min: 'Минимум', // assming 'minimum'
	  minute: 'минута',
	  model: 'модель',
	  modified: 'модифицирован',
	  monitor: 'монитор',
	  month: 'месяц',
	  'Multi Select': 'Выбор из нескольких вариантов',
	  Name: 'Имя',
	  'Navigation Help': 'Используйте клавиши со стрелками для навигации',
	  'Next Month': 'Следующий месяц',
	  'Next Slide': 'Следующий слайд',
	  'No Relationship': 'Нет отношений',
	  'Notification': 'Уведомление',
	  OK: 'ОК',
	  Open: 'Открыть',
	  Parent: 'Родитель',
	  Parents: 'Родители',
	  Parts: 'Части',
	  Part: 'Часть',
	  Password: 'Пароль',
	  'Previous Month': 'Предыдущий Месяц',
	  'Previous Slide': 'Предыдущая Слайд',
	  'Previous Tiles': 'Предыдущие Плитки',
	  'Remember me': 'Запомни меня',
	  'Range Start': 'Начало Диапазона',
	  'Range End': 'Конец Диапазона',
	  Resource: 'Ресурс',
	  Running: 'Работает', // "working" -- fitting in context?
	  Search: 'Поиск',
	  'Match Results': '{count, plural,\n      =0 {\u041D\u0435\u0442 \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F}\n      one {\u0415\u0441\u0442\u044C \u043E\u0434\u043D\u043E \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F}\n      other {\u0415\u0441\u0442\u044C # \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0439}\n  }',
	  second: 'второй', // as in sequence (number #2), not as in time (hour/minute/second) (might need conjugation based on context)
	  'Select Icon': 'Открыть селектор', // "open selector"
	  Selected: 'Selected',
	  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435}\n      other {# \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F}\n  }',
	  'Skip to': 'Перейти к',
	  'Slide Number': ' Слайд {slideNumber}',
	  Sort: 'Сортировать',
	  Spinning: 'Прядильный', // not 100% sure on this
	  Spiral: 'Спираль',
	  State: 'Состояние',
	  Status: 'Статус',
	  Subtract: 'Вычитать',
	  SunBurst: 'SunBurst', // context?
	  'Tab Contents': 'Содержимое вкладки {activeTitle}',
	  Table: 'Таблица',
	  Tasks: 'Задания',
	  Tiles: 'Плитки',
	  Time: 'Время',
	  Title: 'Заглавие',
	  Today: 'Cегодня',
	  Topology: 'Топология',
	  Total: 'Всего',
	  Threshold: 'Порог',
	  Unknown: 'Неизвестный',
	  Username: 'Имя пользователя',
	  uri: 'унифицированный идентификатор ресурса', // no common abbreviation
	  Value: 'Стоимость',
	  Warning: 'Предупреждение',
	  year: 'год'
	});
	module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _enUS = __webpack_require__(56);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({
	  IndexFilters: {
	    filters: '{quantity, plural,\n  =0 {筛选}\n  =1 {1 个筛选}\n  ' + 'other {# 筛选}\n}'
	  }
	}, _enUS2.default, {
	  Active: '活动',
	  Activate: '激活',
	  Activated: '已激活',
	  Add: '添加',
	  add: '添加',
	  Alerts: '警报',
	  All: '全部',
	  ampm: 'ampm',
	  Arc: '存档',
	  AxisLabel: '{orientation} 轴',
	  area: '区域',
	  Bar: '栏',
	  bar: '栏',
	  Blank: '空白',
	  Box: '框',
	  Carousel: '传送',
	  Category: '类别',
	  Circle: '圆',
	  Chart: '图表',
	  Children: '子项',
	  Clear: '清除',
	  Cleared: '已清除',
	  Close: '关闭',
	  'Close Menu': '关闭菜单',
	  Completed: '已完成',
	  'Connects With': '连接对象',
	  created: '已创建',
	  Critical: '严重',
	  'Currently Active': '当前处于活动状态',
	  'Date Selector': '日期选择器',
	  'Date Time Icon': '打开日期和时间选择器',
	  day: '天',
	  Disabled: '已禁用',
	  Distribution: '分布',
	  Email: '电子邮件',
	  'Enter Select': '按 Enter 进行选择',
	  Error: '错误',
	  Filter: '筛选',
	  Footer: '页脚',
	  Grommet: 'Grommet',
	  HotSpotsLabel: '热点: 按箭头键可与它进行交互',
	  'GraphValues': '图有 {count} 项。最大值为 {highest}，' + ' 最小值为 {smallest}',
	  hour: '小时',
	  'Grommet Logo': 'Grommet 徽标',
	  'Layer': '层',
	  List: '列表',
	  line: '线',
	  'Loading': '正在加载',
	  loginInvalidPassword: '请提供用户名和密码。',
	  'Log In': '登录',
	  Logout: '注销',
	  'Main Content': '主要内容',
	  Max: '最大值',
	  Menu: '菜单',
	  Meter: '度量',
	  Min: '最小值',
	  minute: '分钟',
	  model: '型号',
	  modified: '已修改',
	  monitor: '监控',
	  month: '月',
	  'Multi Select': '多重选择',
	  Name: '名称',
	  'Navigation Help': '使用箭头键导航',
	  'Next Month': '下个月',
	  'Next Slide': '下一张幻灯片',
	  'No Relationship': '无关系',
	  'Notification': '通知',
	  OK: '确定',
	  Open: '打开',
	  Parent: '父项',
	  Parents: '父项',
	  Parts: '部分',
	  Part: '部分',
	  Password: '密码',
	  'Previous Month': '上个月',
	  'Previous Slide': '上一张幻灯片',
	  'Previous Tiles': '之前的磁贴',
	  'Remember me': '记住我',
	  Resource: '资源',
	  Running: '正在运行',
	  Search: '搜索',
	  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
	  second: '秒',
	  'Select Icon': '打开选择下拉列表',
	  Selected: '已选择',
	  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
	  'Skip to': '跳转到',
	  'Slide Number': '幻灯片 {slideNumber}',
	  Sort: '排序',
	  Spinning: '旋转',
	  Spiral: '螺旋',
	  State: '状况',
	  Status: '状态',
	  Subtract: '减去',
	  SunBurst: 'SunBurst',
	  'Tab Contents': '{activeTitle} 选项卡内容',
	  Table: '表',
	  Tasks: '任务',
	  Tiles: '磁贴',
	  Time: '时间',
	  Title: '标题',
	  Today: '今天',
	  Topology: '拓扑',
	  Total: '总计',
	  Threshold: '阈值',
	  Unknown: '未知',
	  Username: '用户名',
	  uri: 'URI',
	  Value: '值',
	  Warning: '警告',
	  year: '年'
	});
	module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(72);
	
	var _DOMUtils = __webpack_require__(106);
	
	var _DOMStateStorage = __webpack_require__(216);
	
	var _PathUtils = __webpack_require__(57);
	
	var _ExecutionEnvironment = __webpack_require__(136);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(546);
	
	var _PathUtils = __webpack_require__(57);
	
	var _runTransitionHook = __webpack_require__(138);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(105);
	
	var _LocationUtils = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(60);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(575),
	    getPrototype = __webpack_require__(577),
	    isObjectLike = __webpack_require__(582);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(73);
	var Danger = __webpack_require__(597);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstrumentation = __webpack_require__(36);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(150);
	var setInnerHTML = __webpack_require__(111);
	var setTextContent = __webpack_require__(380);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactErrorUtils = __webpack_require__(148);
	
	var invariant = __webpack_require__(9);
	var warning = __webpack_require__(15);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactPropTypesSecret = __webpack_require__(626);
	var propTypesFactory = __webpack_require__(357);
	
	var React = __webpack_require__(79);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(9);
	var warning = __webpack_require__(15);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(51);
	var ReactInstanceMap = __webpack_require__(91);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(42);
	
	var invariant = __webpack_require__(9);
	var warning = __webpack_require__(15);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(39);
	var warning = __webpack_require__(15);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLatLng = exports.geocodeByPlaceId = exports.geocodeByAddress = undefined;
	
	var _PlacesAutocomplete = __webpack_require__(658);
	
	var _PlacesAutocomplete2 = _interopRequireDefault(_PlacesAutocomplete);
	
	var _utils = __webpack_require__(661);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.geocodeByAddress = _utils.geocodeByAddress;
	exports.geocodeByPlaceId = _utils.geocodeByPlaceId;
	exports.getLatLng = _utils.getLatLng;
	exports.default = _PlacesAutocomplete2.default;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _getRouteParams = __webpack_require__(681);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(160);
	
	var _RouteUtils = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.ATR;
		var source = function source(d) {
			return { open: d.open, high: d.high, low: d.low, close: d.close };
		};
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize;
	
	
			var trueRangeAlgorithm = (0, _utils.slidingWindow)().windowSize(2).source(source).undefinedValue(function (d) {
				return d.high - d.low;
			}) // the first TR value is simply the High minus the Low
			.accumulator(function (values) {
				var prev = values[0];
				var d = values[1];
				return Math.max(d.high - d.low, d.high - prev.close, d.low - prev.close);
			});
	
			var prevATR = void 0;
	
			var atrAlgorithm = (0, _utils.slidingWindow)().skipInitial(1) // trueRange starts from index 1 so ATR starts from 1
			.windowSize(windowSize).accumulator(function (values) {
				var tr = (0, _utils.last)(values);
				var atr = (0, _utils.isDefined)(prevATR) ? (prevATR * (windowSize - 1) + tr) / windowSize : (0, _d3Array.sum)(values) / windowSize;
	
				prevATR = atr;
				return atr;
			});
	
			var newData = atrAlgorithm(trueRangeAlgorithm(data));
	
			return newData;
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize;
	
			return windowSize - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.ATR, x);
			return calculator;
		};
	
		calculator.source = function (x) {
			if (!arguments.length) {
				return source;
			}
			source = x;
			return calculator;
		};
	
		return calculator;
	};
	
	var _d3Array = __webpack_require__(21);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	var _utils = __webpack_require__(4);
	//# sourceMappingURL=atr.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var themes = exports.themes = {
		light: {
			BollingerBand: {
				stroke: {
					top: "#964B00",
					middle: "#000000",
					bottom: "#964B00"
				},
				fill: "#4682B4"
			},
			ElderImpulse: {
				stroke: {
					up: "#6BA583",
					down: "#FF0000",
					neutral: "#0000FF"
				}
			},
			MACD: {
				fill: {
					divergence: "#4682B4"
				},
				stroke: {
					macd: "#FF0000",
					signal: "#00F300"
				}
			},
			FullStochasticOscillator: {
				stroke: {
					top: "#37a600",
					middle: "#b8ab00",
					bottom: "#37a600",
					dLine: "#17becf",
					kLine: "#ff7f0e"
				}
			}
		},
		dark: {
			BollingerBand: {
				stroke: {
					top: "#964B00",
					middle: "#FF6600",
					bottom: "#964B00"
				},
				fill: "#4682B4"
			},
			ElderImpulse: {
				stroke: {
					up: "#6BA583",
					down: "#FF0000",
					neutral: "#0000FF"
				}
			},
			MACD: {
				fill: {
					divergence: "#FF6600"
				},
				stroke: {
					macd: "#ea2bff",
					signal: "#74d400"
				}
			},
			FullStochasticOscillator: {
				stroke: {
					top: "#37a600",
					middle: "#b8ab00",
					bottom: "#37a600",
					dLine: "#ea2bff",
					kLine: "#74d400"
				}
			}
		}
	};
	
	var BollingerBand = exports.BollingerBand = themes.light.BollingerBand;
	var ElderImpulse = exports.ElderImpulse = themes.light.ElderImpulse;
	var MACD = exports.MACD = themes.light.MACD;
	var FullStochasticOscillator = exports.FullStochasticOscillator = themes.light.FullStochasticOscillator;
	//# sourceMappingURL=defaultOptionsForAppearance.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(99);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AreaOnlySeries = function (_Component) {
		_inherits(AreaOnlySeries, _Component);
	
		function AreaOnlySeries(props) {
			_classCallCheck(this, AreaOnlySeries);
	
			var _this = _possibleConstructorReturn(this, (AreaOnlySeries.__proto__ || Object.getPrototypeOf(AreaOnlySeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(AreaOnlySeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var _props = this.props,
				    yAccessor = _props.yAccessor,
				    defined = _props.defined,
				    base = _props.base,
				    canvasGradient = _props.canvasGradient;
				var _props2 = this.props,
				    fill = _props2.fill,
				    stroke = _props2.stroke,
				    opacity = _props2.opacity,
				    interpolation = _props2.interpolation,
				    canvasClip = _props2.canvasClip;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData,
				    xAccessor = moreProps.xAccessor;
	
	
				if (canvasClip) {
					ctx.save();
					canvasClip(ctx, moreProps);
				}
	
				if (canvasGradient != null) {
					ctx.fillStyle = canvasGradient(moreProps, ctx);
				} else {
					ctx.fillStyle = (0, _utils.hexToRGBA)(fill, opacity);
				}
				ctx.strokeStyle = stroke;
	
				ctx.beginPath();
				var newBase = (0, _utils.functor)(base);
				var areaSeries = (0, _d3Shape.area)().defined(function (d) {
					return defined(yAccessor(d));
				}).x(function (d) {
					return Math.round(xScale(xAccessor(d)));
				}).y0(function (d) {
					return newBase(yScale, d, moreProps);
				}).y1(function (d) {
					return Math.round(yScale(yAccessor(d)));
				}).context(ctx);
	
				if ((0, _utils.isDefined)(interpolation)) {
					areaSeries.curve(interpolation);
				}
				areaSeries(plotData);
				ctx.fill();
	
				if (canvasClip) {
					ctx.restore();
				}
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props3 = this.props,
				    yAccessor = _props3.yAccessor,
				    defined = _props3.defined,
				    base = _props3.base,
				    style = _props3.style;
				var _props4 = this.props,
				    stroke = _props4.stroke,
				    fill = _props4.fill,
				    className = _props4.className,
				    opacity = _props4.opacity,
				    interpolation = _props4.interpolation;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData,
				    xAccessor = moreProps.xAccessor;
	
	
				var newBase = (0, _utils.functor)(base);
				var areaSeries = (0, _d3Shape.area)().defined(function (d) {
					return defined(yAccessor(d));
				}).x(function (d) {
					return Math.round(xScale(xAccessor(d)));
				}).y0(function (d) {
					return newBase(yScale, d, moreProps);
				}).y1(function (d) {
					return Math.round(yScale(yAccessor(d)));
				});
	
				if ((0, _utils.isDefined)(interpolation)) {
					areaSeries.curve(interpolation);
				}
	
				var d = areaSeries(plotData);
				var newClassName = className.concat((0, _utils.isDefined)(stroke) ? "" : " line-stroke");
				return _react2.default.createElement("path", {
					style: style,
					d: d,
					stroke: stroke,
					fill: (0, _utils.hexToRGBA)(fill, opacity),
					className: newClassName
	
				});
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}]);
	
		return AreaOnlySeries;
	}(_react.Component);
	
	AreaOnlySeries.propTypes = {
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func.isRequired,
		stroke: _propTypes2.default.string,
		fill: _propTypes2.default.string,
		opacity: _propTypes2.default.number,
		defined: _propTypes2.default.func,
		base: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.number]),
		interpolation: _propTypes2.default.func,
		canvasClip: _propTypes2.default.func,
		style: _propTypes2.default.object,
		canvasGradient: _propTypes2.default.func
	};
	
	AreaOnlySeries.defaultProps = {
		className: "line ",
		fill: "none",
		opacity: 1,
		defined: function defined(d) {
			return !isNaN(d);
		},
		base: function base(yScale /* , d, moreProps */) {
			return (0, _utils.first)(yScale.range());
		}
	};
	
	exports.default = AreaOnlySeries;
	//# sourceMappingURL=AreaOnlySeries.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getChartOrigin = getChartOrigin;
	exports.getDimensions = getDimensions;
	exports.getNewChartConfig = getNewChartConfig;
	exports.getCurrentCharts = getCurrentCharts;
	exports.getChartConfigWithUpdatedYScales = getChartConfigWithUpdatedYScales;
	exports.getCurrentItem = getCurrentItem;
	exports.getXValue = getXValue;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Array = __webpack_require__(21);
	
	var _d3Collection = __webpack_require__(38);
	
	var _lodash = __webpack_require__(574);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Chart = __webpack_require__(394);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _index = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChartOrigin(origin, contextWidth, contextHeight) {
		var originCoordinates = typeof origin === "function" ? origin(contextWidth, contextHeight) : origin;
		return originCoordinates;
	}
	
	function getDimensions(_ref, chartProps) {
		var width = _ref.width,
		    height = _ref.height;
	
	
		var chartHeight = chartProps.height || height;
	
		return {
			availableHeight: height,
			width: width,
			height: chartHeight
		};
	}
	
	function values(func) {
		return function (d) {
			var obj = func(d);
			if ((0, _index.isObject)(obj)) {
				return (0, _index.mapObject)(obj);
			}
			return obj;
		};
	}
	
	function isArraySize2AndNumber(yExtentsProp) {
		if (Array.isArray(yExtentsProp) && yExtentsProp.length === 2) {
			var _yExtentsProp = _slicedToArray(yExtentsProp, 2),
			    a = _yExtentsProp[0],
			    b = _yExtentsProp[1];
	
			return typeof a == "number" && typeof b == "number";
		}
		return false;
	}
	
	function getNewChartConfig(innerDimension, children) {
		var existingChartConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
		return _react2.default.Children.map(children, function (each) {
			if (each && each.type.toString() === _Chart2.default.toString()) {
				var chartProps = _extends({}, _Chart2.default.defaultProps, each.props);
				var id = chartProps.id,
				    origin = chartProps.origin,
				    padding = chartProps.padding,
				    yExtentsProp = chartProps.yExtents,
				    yScaleProp = chartProps.yScale,
				    flipYScale = chartProps.flipYScale,
				    yExtentsCalculator = chartProps.yExtentsCalculator;
	
	
				var yScale = yScaleProp.copy();
	
				var _getDimensions = getDimensions(innerDimension, chartProps),
				    width = _getDimensions.width,
				    height = _getDimensions.height,
				    availableHeight = _getDimensions.availableHeight;
	
				var yPan = chartProps.yPan;
				var yPanEnabled = chartProps.yPanEnabled;
				// var { yMousePointerRectWidth: rectWidth, yMousePointerRectHeight: rectHeight, yMousePointerArrowWidth: arrowWidth } = each.props;
				// var mouseCoordinates = { at, yDisplayFormat, rectHeight, rectWidth, arrowWidth };
	
				var yExtents = (0, _index.isDefined)(yExtentsProp) ? (Array.isArray(yExtentsProp) ? yExtentsProp : [yExtentsProp]).map(_index.functor) : undefined;
	
				var prevChartConfig = (0, _index.find)(existingChartConfig, function (d) {
					return d.id === id;
				});
	
				if (isArraySize2AndNumber(yExtentsProp)) {
					if ((0, _index.isDefined)(prevChartConfig) && prevChartConfig.yPan && prevChartConfig.yPanEnabled && yPan && yPanEnabled && (0, _index.shallowEqual)(prevChartConfig.originalYExtentsProp, yExtentsProp)) {
						// console.log(prevChartConfig.originalYExtentsProp, yExtentsProp)
						// console.log(prevChartConfig.yScale.domain())
						yScale.domain(prevChartConfig.yScale.domain());
					} else {
						var _yExtentsProp2 = _slicedToArray(yExtentsProp, 2),
						    a = _yExtentsProp2[0],
						    b = _yExtentsProp2[1];
	
						yScale.domain([a, b]);
					}
				} else if ((0, _index.isDefined)(prevChartConfig) && prevChartConfig.yPanEnabled) {
					if (isArraySize2AndNumber(prevChartConfig.originalYExtentsProp)) {
						// do nothing
					} else {
						yScale.domain(prevChartConfig.yScale.domain());
						yPanEnabled = true;
					}
				}
	
				return {
					id: id,
					origin: (0, _index.functor)(origin)(width, availableHeight),
					padding: padding,
					originalYExtentsProp: yExtentsProp,
					yExtents: yExtents,
					yExtentsCalculator: yExtentsCalculator,
					flipYScale: flipYScale,
					// yScale: setRange(yScale.copy(), height, padding, flipYScale),
					yScale: yScale,
					yPan: yPan,
					yPanEnabled: yPanEnabled,
					// mouseCoordinates,
					width: width,
					height: height
				};
			}
			return undefined;
		}).filter(function (each) {
			return (0, _index.isDefined)(each);
		});
	}
	function getCurrentCharts(chartConfig, mouseXY) {
		var currentCharts = chartConfig.filter(function (eachConfig) {
			var top = eachConfig.origin[1];
			var bottom = top + eachConfig.height;
			return mouseXY[1] > top && mouseXY[1] < bottom;
		}).map(function (config) {
			return config.id;
		});
	
		return currentCharts;
	}
	
	function setRange(scale, height, padding, flipYScale) {
		if (scale.rangeRoundPoints || (0, _index.isNotDefined)(scale.invert)) {
			if (isNaN(padding)) throw new Error("padding has to be a number for ordinal scale");
			if (scale.rangeRoundPoints) scale.rangeRoundPoints(flipYScale ? [0, height] : [height, 0], padding);
			if (scale.rangeRound) scale.range(flipYScale ? [0, height] : [height, 0]).padding(padding);
		} else {
			var _ref2 = isNaN(padding) ? padding : { top: padding, bottom: padding },
			    top = _ref2.top,
			    bottom = _ref2.bottom;
	
			scale.range(flipYScale ? [top, height - bottom] : [height - bottom, top]);
		}
		return scale;
	}
	
	function yDomainFromYExtents(yExtents, yScale, plotData) {
		var yValues = yExtents.map(function (eachExtent) {
			return plotData.map(values(eachExtent));
		});
	
		var allYValues = (0, _lodash2.default)(yValues);
		// console.log(allYValues)
		var realYDomain = yScale.invert ? (0, _d3Array.extent)(allYValues) : (0, _d3Collection.set)(allYValues).values();
	
		return realYDomain;
	}
	
	function getChartConfigWithUpdatedYScales(chartConfig, _ref3, xDomain, dy, chartsToPan) {
		var plotData = _ref3.plotData,
		    xAccessor = _ref3.xAccessor,
		    displayXAccessor = _ref3.displayXAccessor,
		    fullData = _ref3.fullData;
	
		var yDomains = chartConfig.map(function (_ref4) {
			var yExtentsCalculator = _ref4.yExtentsCalculator,
			    yExtents = _ref4.yExtents,
			    yScale = _ref4.yScale;
	
	
			var realYDomain = (0, _index.isDefined)(yExtentsCalculator) ? yExtentsCalculator({ plotData: plotData, xDomain: xDomain, xAccessor: xAccessor, displayXAccessor: displayXAccessor, fullData: fullData }) : yDomainFromYExtents(yExtents, yScale, plotData);
	
			// console.log("yScale.domain() ->", yScale.domain())
	
			var yDomainDY = (0, _index.isDefined)(dy) ? yScale.range().map(function (each) {
				return each - dy;
			}).map(yScale.invert) : yScale.domain();
			return {
				realYDomain: realYDomain,
				yDomainDY: yDomainDY,
				prevYDomain: yScale.domain()
			};
		});
	
		var combine = (0, _index.zipper)().combine(function (config, _ref5) {
			var realYDomain = _ref5.realYDomain,
			    yDomainDY = _ref5.yDomainDY,
			    prevYDomain = _ref5.prevYDomain;
			var id = config.id,
			    padding = config.padding,
			    height = config.height,
			    yScale = config.yScale,
			    yPan = config.yPan,
			    flipYScale = config.flipYScale,
			    _config$yPanEnabled = config.yPanEnabled,
			    yPanEnabled = _config$yPanEnabled === undefined ? false : _config$yPanEnabled;
	
	
			var another = (0, _index.isDefined)(chartsToPan) ? chartsToPan.indexOf(id) > -1 : true;
			var domain = yPan && yPanEnabled ? another ? yDomainDY : prevYDomain : realYDomain;
	
			// console.log(id, yPan, yPanEnabled, another);
			// console.log(domain, realYDomain, prevYDomain);
			var newYScale = setRange(yScale.copy().domain(domain), height, padding, flipYScale);
			return _extends({}, config, {
				yScale: newYScale,
				realYDomain: realYDomain
			});
			// return { ...config, yScale: yScale.copy().domain(domain).range([height - padding, padding]) };
		});
	
		var updatedChartConfig = combine(chartConfig, yDomains);
		// console.error(yDomains, dy, chartsToPan, updatedChartConfig.map(d => d.yScale.domain()));
		// console.log(updatedChartConfig.map(d => ({ id: d.id, domain: d.yScale.domain() })))
	
		return updatedChartConfig;
	}
	
	function getCurrentItem(xScale, xAccessor, mouseXY, plotData) {
		var xValue = void 0,
		    item = void 0;
		if (xScale.invert) {
			xValue = xScale.invert(mouseXY[0]);
			item = (0, _index.getClosestItem)(plotData, xValue, xAccessor);
		} else {
			var d = xScale.range().map(function (d, idx) {
				return { x: Math.abs(d - mouseXY[0]), idx: idx };
			}).reduce(function (a, b) {
				return a.x < b.x ? a : b;
			});
			item = (0, _index.isDefined)(d) ? plotData[d.idx] : plotData[0];
			// console.log(d, item);
		}
		return item;
	}
	
	function getXValue(xScale, xAccessor, mouseXY, plotData) {
	
		var xValue = void 0,
		    item = void 0;
		if (xScale.invert) {
			xValue = xScale.invert(mouseXY[0]);
			if (xValue > xAccessor((0, _index.last)(plotData)) && xScale.value) {
				return Math.round(xValue);
			} else {
				item = (0, _index.getClosestItem)(plotData, xValue, xAccessor);
			}
		} else {
			var d = xScale.range().map(function (d, idx) {
				return { x: Math.abs(d - mouseXY[0]), idx: idx };
			}).reduce(function (a, b) {
				return a.x < b.x ? a : b;
			});
			item = (0, _index.isDefined)(d) ? plotData[d.idx] : plotData[0];
			// console.log(d, item);
		}
		return xAccessor(item);
	}
	//# sourceMappingURL=ChartDataUtil.js.map

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowEqual = __webpack_require__(404);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PureComponent = function (_React$Component) {
		_inherits(PureComponent, _React$Component);
	
		function PureComponent() {
			_classCallCheck(this, PureComponent);
	
			return _possibleConstructorReturn(this, (PureComponent.__proto__ || Object.getPrototypeOf(PureComponent)).apply(this, arguments));
		}
	
		_createClass(PureComponent, [{
			key: "shouldComponentUpdate",
			value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
				return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
			}
		}]);
	
		return PureComponent;
	}(_react2.default.Component);
	
	exports.default = PureComponent;
	//# sourceMappingURL=PureComponent.js.map

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.providerContextTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO(jez) 'sync' and 'async' are bad tag names.
	// TODO(jez) What if redux also uses this.context.tag?
	var providerContextTypes = exports.providerContextTypes = {
	  tag: _propTypes2.default.string.isRequired,
	  stripe: _propTypes2.default.object,
	  addStripeLoadListener: _propTypes2.default.func
	};
	
	var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
	  /**
	   * Note that this is not meant to be a generic memoization solution.
	   * This is specifically a solution for `StripeProvider`s being initialized
	   * and destroyed regularly (with the same set of props) when users only
	   * use `StripeProvider` for the subtree that contains their checkout form.
	   */
	  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
	  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);
	
	  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
	  window.Stripe.__cachedInstances[cacheKey] = stripe;
	
	  return stripe;
	};
	
	var ensureStripeShape = function ensureStripeShape(stripe) {
	  if (stripe && stripe.elements && stripe.createSource && stripe.createToken) {
	    return stripe;
	  } else {
	    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
	  }
	};
	
	var Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  // on the other hand: childContextTypes is *required* to use context.
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    if (_this.props.apiKey && _this.props.stripe) {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
	    } else if (_this.props.apiKey) {
	      if (!window.Stripe) {
	        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
	      } else {
	        var _this$props = _this.props,
	            _apiKey = _this$props.apiKey,
	            _children = _this$props.children,
	            _stripe = _this$props.stripe,
	            options = _objectWithoutProperties(_this$props, ['apiKey', 'children', 'stripe']);
	
	        _this._meta = {
	          tag: 'sync',
	          stripe: getOrCreateStripe(_apiKey, options)
	        };
	      }
	    } else if (_this.props.stripe) {
	      // If we already have a stripe instance (in the constructor), we can behave synchronously.
	      _this._meta = {
	        tag: 'sync',
	        stripe: ensureStripeShape(_this.props.stripe)
	      };
	    } else if (_this.props.stripe === null) {
	      _this._meta = {
	        tag: 'async',
	        stripe: null
	      };
	    } else {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
	    }
	
	    _this._didWarn = false;
	    _this._didWakeUpListeners = false;
	    _this._listeners = [];
	    return _this;
	  }
	  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
	
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    // getChildContext is run after the constructor, so we WILL have access to
	    // the initial state.
	    //
	    // However, context doesn't update in respnse to state changes like you
	    // might expect: context is pulled by the child, not pushed by the parent.
	    if (this._meta.tag === 'sync') {
	      return {
	        tag: 'sync',
	        stripe: this._meta.stripe
	      };
	    } else {
	      return {
	        tag: 'async',
	        addStripeLoadListener: function addStripeLoadListener(fn) {
	          if (_this2._meta.stripe) {
	            fn(_this2._meta.stripe);
	          } else {
	            _this2._listeners.push(fn);
	          }
	        }
	      };
	    }
	  };
	
	  Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var apiKeyChanged = this.props.apiKey && nextProps.apiKey && this.props.apiKey !== nextProps.apiKey;
	
	    var stripeInstanceChanged = this.props.stripe && nextProps.stripe && this.props.stripe !== nextProps.stripe;
	    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
	      this._didWarn = true;
	      // eslint-disable-next-line no-console
	      console.error('StripeProvider does not support changing the apiKey parameter.');
	      return;
	    }
	
	    if (!this._didWakeUpListeners && nextProps.stripe) {
	      // Wake up the listeners if we've finally been given a StripeShape
	      this._didWakeUpListeners = true;
	      var _stripe2 = ensureStripeShape(nextProps.stripe);
	      this._meta.stripe = _stripe2;
	      this._listeners.forEach(function (fn) {
	        fn(_stripe2);
	      });
	    }
	  };
	
	  Provider.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.propTypes = {
	  apiKey: _propTypes2.default.string,
	  // PropTypes.object is the only way we can accept a Stripe instance
	  // eslint-disable-next-line react/forbid-prop-types
	  stripe: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	Provider.childContextTypes = providerContextTypes;
	Provider.defaultProps = {
	  apiKey: undefined,
	  stripe: undefined,
	  children: null
	};
	exports.default = Provider;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HIDE_TOAST = exports.SET_STEM_LOCATION = exports.SET_STEM_NAME = exports.SHOW_ADD_STEM_ERROR = exports.CREATE_STEM = exports.ADD_STEM_ID = exports.UDPATE_SITE = exports.SAVE_SITEDATA = exports.LOAD_SITES = undefined;
	exports.loadSites = loadSites;
	exports.updateSiteAction = updateSiteAction;
	exports.addSiteAction = addSiteAction;
	exports.showAddStemError = showAddStemError;
	exports.addStemIDAction = addStemIDAction;
	exports.setStemName = setStemName;
	exports.setStemLocation = setStemLocation;
	exports.createStemAction = createStemAction;
	exports.hideToast = hideToast;
	
	var _Api = __webpack_require__(52);
	
	var _actions = __webpack_require__(13);
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var LOAD_SITES = exports.LOAD_SITES = 'DASHBOARD_LOAD';
	
	var SAVE_SITEDATA = exports.SAVE_SITEDATA = 'SAVE_SITEDATA';
	var UDPATE_SITE = exports.UDPATE_SITE = 'UDPATE_SITE';
	var ADD_STEM_ID = exports.ADD_STEM_ID = 'ADD_STEM_ID';
	var CREATE_STEM = exports.CREATE_STEM = 'CREATE_STEM';
	var SHOW_ADD_STEM_ERROR = exports.SHOW_ADD_STEM_ERROR = 'SHOW_ADD_STEM_ERROR';
	var SET_STEM_NAME = exports.SET_STEM_NAME = 'SET_STEM_NAME';
	var SET_STEM_LOCATION = exports.SET_STEM_LOCATION = 'SET_STEM_LOCATION';
	var HIDE_TOAST = exports.HIDE_TOAST = 'HIDE_TOAST';
	
	function loadSites() {
	  return function (dispatch) {
	    (0, _Api.initializeStripe)().then(function (response) {
	      dispatch({
	        type: _actions.INITIALIZE_STRIPE,
	        result: response
	      });
	      (0, _Api.getSites)().then(function (response) {
	        dispatch({ type: SAVE_SITEDATA, result: response.data });
	        // console.log('sites::', response)
	      }).catch(function (error) {
	        // console.log('error::', error)
	      });
	    });
	  };
	}
	
	function updateSiteAction(siteId, data) {
	  return function (dispatch) {
	    (0, _Api.updateSite)(siteId, data).then(function (response) {
	      dispatch(loadSites());
	    }).catch(function (error) {
	      // console.log('error::', error)
	    });
	  };
	}
	
	function addSiteAction(data) {
	  return function (dispatch) {
	    (0, _Api.addSite)(data).then(function (response) {
	      dispatch(loadSites());
	    }).catch(function (error) {
	      // console.log('error::', error)
	    });
	  };
	}
	
	function showAddStemError(data) {
	  return function (dispatch) {
	    dispatch({ type: SHOW_ADD_STEM_ERROR, result: data });
	  };
	}
	
	function addStemIDAction(data) {
	  return function (dispatch) {
	    if (data && !data.showStemAddForm) {
	      dispatch({ type: ADD_STEM_ID, result: data.data });
	    } else {
	      (0, _Api.addStemID)(data.stemID).then(function (response) {
	        if (response && response.data && response.data.error) {
	          dispatch(showAddStemError(response.data));
	        } else {
	          dispatch({ type: ADD_STEM_ID, result: response });
	        }
	      }).catch(function (error) {
	        // console.log('error::', error)
	      });
	    }
	  };
	}
	
	function setStemName(value) {
	  return function (dispatch) {
	    dispatch({ type: SET_STEM_NAME, result: value });
	  };
	}
	
	function setStemLocation(value) {
	  return function (dispatch) {
	    dispatch({ type: SET_STEM_LOCATION, result: value });
	  };
	}
	
	function createStemAction(stemObj) {
	  return function (dispatch) {
	    (0, _Api.createStem)(stemObj).then(function (response) {
	      if (response && response.duplicateStemError) {
	        dispatch({ type: SHOW_ADD_STEM_ERROR, result: response });
	      } else {
	        dispatch({ type: CREATE_STEM, result: response });
	      }
	    }).catch(function (error) {
	      // console.log('error::', error)
	    });
	  };
	}
	
	function hideToast() {
	  return function (dispatch) {
	    dispatch({ type: HIDE_TOAST, result: false });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(LOAD_SITES, 'LOAD_SITES', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_SITEDATA, 'SAVE_SITEDATA', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(UDPATE_SITE, 'UDPATE_SITE', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(ADD_STEM_ID, 'ADD_STEM_ID', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_STEM, 'CREATE_STEM', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(SHOW_ADD_STEM_ERROR, 'SHOW_ADD_STEM_ERROR', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(SET_STEM_NAME, 'SET_STEM_NAME', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(SET_STEM_LOCATION, 'SET_STEM_LOCATION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(HIDE_TOAST, 'HIDE_TOAST', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(loadSites, 'loadSites', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(updateSiteAction, 'updateSiteAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(addSiteAction, 'addSiteAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(showAddStemError, 'showAddStemError', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(addStemIDAction, 'addStemIDAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(setStemName, 'setStemName', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(setStemLocation, 'setStemLocation', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(createStemAction, 'createStemAction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(hideToast, 'hideToast', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/dashboard.js');
	}();

	;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CLOSE_CONFIRMATION = exports.CONFIRM_CANCELLATION = exports.SAVE_TWIG_IN_SESSION = exports.GET_SUBSCRIPTION_HISTORY = undefined;
	exports.getSubscriptionHistory = getSubscriptionHistory;
	exports.cancelSubscription = cancelSubscription;
	exports.saveTwigInSession = saveTwigInSession;
	exports.confirmCancellation = confirmCancellation;
	exports.closeConfirmation = closeConfirmation;
	
	var _Api = __webpack_require__(52);
	
	var _Utility = __webpack_require__(37);
	
	var _actions = __webpack_require__(13);
	
	var _ = __webpack_require__(27); // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var GET_SUBSCRIPTION_HISTORY = exports.GET_SUBSCRIPTION_HISTORY = "GET_SUBSCRIPTION_HISTORY";
	var SAVE_TWIG_IN_SESSION = exports.SAVE_TWIG_IN_SESSION = "SAVE_TWIG_IN_SESSION";
	var CONFIRM_CANCELLATION = exports.CONFIRM_CANCELLATION = "CONFIRM_CANCELLATION";
	var CLOSE_CONFIRMATION = exports.CLOSE_CONFIRMATION = "CLOSE_CONFIRMATION";
	
	function getSubscriptionHistory() {
	    return function (dispatch) {
	        (0, _Api.initializeStripe)().then(function (response) {
	            dispatch({
	                type: _actions.INITIALIZE_STRIPE,
	                result: response
	            });
	            (0, _Api.getTwigs)('').then(function (twigs) {
	                (0, _Api.getSubscriptionDetails)().then(function (data) {
	                    dispatch({
	                        type: GET_SUBSCRIPTION_HISTORY,
	                        result: { data: data, twigs: twigs }
	                    });
	                });
	            });
	        });
	    };
	}
	
	function cancelSubscription(subscription) {
	    return function (dispatch) {
	        (0, _Api.cancelStripeSubscription)(subscription).then(function (response) {
	            if (response) {
	                dispatch(getSubscriptionHistory());
	            }
	        }).catch(function (error) {
	            reject(error);
	        });
	    };
	}
	
	function saveTwigInSession(data) {
	    return function (dispatch) {
	        dispatch({
	            type: SAVE_TWIG_IN_SESSION,
	            result: data
	        });
	    };
	}
	
	function confirmCancellation(data) {
	    return function (dispatch) {
	        dispatch({
	            type: CONFIRM_CANCELLATION,
	            result: {
	                data: data,
	                success: true
	            }
	        });
	    };
	}
	
	function closeConfirmation(value) {
	    return function (dispatch) {
	        dispatch({
	            type: CLOSE_CONFIRMATION,
	            result: value
	        });
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(GET_SUBSCRIPTION_HISTORY, 'GET_SUBSCRIPTION_HISTORY', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(SAVE_TWIG_IN_SESSION, 'SAVE_TWIG_IN_SESSION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(CONFIRM_CANCELLATION, 'CONFIRM_CANCELLATION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(CLOSE_CONFIRMATION, 'CLOSE_CONFIRMATION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(getSubscriptionHistory, 'getSubscriptionHistory', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(cancelSubscription, 'cancelSubscription', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(saveTwigInSession, 'saveTwigInSession', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(confirmCancellation, 'confirmCancellation', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(closeConfirmation, 'closeConfirmation', '/Volumes/gitws/GroGuru.git/frontyard/src/js/actions/subscriptionView.js');
	}();

	;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var valueArr = [];
	
	var DeepSensorControl = function (_Component) {
	  _inherits(DeepSensorControl, _Component);
	
	  function DeepSensorControl(props) {
	    _classCallCheck(this, DeepSensorControl);
	
	    var _this = _possibleConstructorReturn(this, (DeepSensorControl.__proto__ || Object.getPrototypeOf(DeepSensorControl)).call(this, props));
	
	    _this.state = {
	      deepSensors: [],
	      valueArr: []
	    };
	    _this.valueChange = _this.valueChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DeepSensorControl, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueArr = [];
	      var deepSensors = [];
	      this.props.value.forEach(function (item, index) {
	        for (var key in item) {
	          deepSensors[index] = {
	            label: key,
	            value: item[key]
	          };
	          valueArr[index] = _defineProperty({}, key, item[key]);
	        }
	      });
	      this.setState({
	        deepSensors: deepSensors,
	        valueArr: valueArr
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'valueChange',
	    value: function valueChange(item, index, event) {
	      valueArr = this.state.valueArr;
	      valueArr[index] = _defineProperty({}, item.label, event.target.value);
	      var controlInfo = {
	        key: this.props.controlKey,
	        controlType: this.props.controlType
	      };
	      this.props.controlValueChange(controlInfo, valueArr);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item maxwidth' },
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          this.props.label
	        ),
	        this.state.deepSensors.slice(0, 3).map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'deepsensor', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'label inlineblock' },
	              item.label
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'control inlineblock' },
	              _react2.default.createElement('input', { className: 'maxwidth', type: 'text', defaultValue: item.value, onChange: _this2.valueChange.bind(_this2, item, index) })
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return DeepSensorControl;
	}(_react.Component);
	
	var _default = DeepSensorControl;
	exports.default = _default;
	
	/*<div className="deepsensor">
	          <div className="label inlineblock">Deep Sensor2</div>
	          <div className="control inlineblock">
	            <input className="maxwidth" type="text" />
	          </div>
	        </div>
	        <div className="deepsensor">
	          <div className="label inlineblock">Deep Sensor2</div>
	          <div className="control inlineblock">
	            <input className="maxwidth" type="text" />
	          </div>
	        </div>*/
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(valueArr, 'valueArr', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/DeepSensorControl.js');
	
	  __REACT_HOT_LOADER__.register(DeepSensorControl, 'DeepSensorControl', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/DeepSensorControl.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/DeepSensorControl.js');
	}();

	;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var emptyObject = __webpack_require__(101);
	var _invariant = __webpack_require__(9);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.2.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex3 = /^#([0-9a-f]{3})$/,
	    reHex6 = /^#([0-9a-f]{6})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(174)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function array(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHue = hue$1;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	function namespace(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	}
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	function creator(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	}
	
	function none() {}
	
	function selector(selector) {
	  return selector == null ? none : function() {
	    return this.querySelector(selector);
	  };
	}
	
	function selection_select(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function empty() {
	  return [];
	}
	
	function selectorAll(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	}
	
	function selection_selectAll(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	}
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	function selection_filter(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function sparse(update) {
	  return new Array(update.length);
	}
	
	function selection_enter() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	}
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	function selection_data(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	}
	
	function selection_exit() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	}
	
	function selection_merge(selection$$1) {
	
	  for (var groups0 = this._groups, groups1 = selection$$1._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	}
	
	function selection_order() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	}
	
	function selection_sort(compare) {
	  if (!compare) compare = ascending;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	}
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function selection_call() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	}
	
	function selection_nodes() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	}
	
	function selection_node() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	}
	
	function selection_size() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	}
	
	function selection_empty() {
	  return !this.node();
	}
	
	function selection_each(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	}
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	function selection_attr(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	}
	
	function defaultView(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	}
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	function selection_style(name, value, priority) {
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : styleValue(this.node(), name);
	}
	
	function styleValue(node, name) {
	  return node.style.getPropertyValue(name)
	      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
	}
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	function selection_property(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	}
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	function selection_classed(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	}
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	function selection_text(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	}
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	function selection_html(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	}
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	function selection_raise() {
	  return this.each(raise);
	}
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	function selection_lower() {
	  return this.each(lower);
	}
	
	function selection_append(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	}
	
	function constantNull() {
	  return null;
	}
	
	function selection_insert(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	}
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	function selection_remove() {
	  return this.each(remove);
	}
	
	function selection_cloneShallow() {
	  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
	}
	
	function selection_cloneDeep() {
	  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
	}
	
	function selection_clone(deep) {
	  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
	}
	
	function selection_datum(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	}
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	function selection_on(typename, value, capture) {
	  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	}
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	function dispatchEvent(node, type, params) {
	  var window = defaultView(node),
	      event = window.CustomEvent;
	
	  if (typeof event === "function") {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	function selection_dispatch(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	}
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  clone: selection_clone,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	function select(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	}
	
	function create(name) {
	  return select(creator(name).call(document.documentElement));
	}
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	function sourceEvent() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	}
	
	function point(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	}
	
	function mouse(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point(node, event);
	}
	
	function selectAll(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	}
	
	function touch(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point(node, touch);
	    }
	  }
	
	  return null;
	}
	
	function touches(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point(node, touches[i]);
	  }
	
	  return points;
	}
	
	exports.create = create;
	exports.creator = creator;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.clientPoint = point;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.style = styleValue;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = defaultView;
	exports.customEvent = customEvent;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.0.10 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.4+314e4831
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var TRY_CATCH_ERROR = { error: null };
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    TRY_CATCH_ERROR.error = error;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === TRY_CATCH_ERROR) {
	      reject(promise, TRY_CATCH_ERROR.error);
	      TRY_CATCH_ERROR.error = null;
	    } else if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = void 0,
	      failed = void 0;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value.error = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (failed) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = getThen(entry);
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        handleMaybeThenable(promise, entry, _then);
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    return promise.then(function (value) {
	      return constructor.resolve(callback()).then(function () {
	        return value;
	      });
	    }, function (reason) {
	      return constructor.resolve(callback()).then(function () {
	        throw reason;
	      });
	    });
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140), (function() { return this; }())))

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(39);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(84);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _omit = __webpack_require__(186);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/forbid-prop-types */
	
	var mainStyle = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var style = {
	  width: 0,
	  height: 0,
	  left: 0,
	  top: 0,
	  backgroundColor: 'transparent',
	  position: 'absolute'
	};
	
	var GoogleMapMarkers = function (_Component) {
	  _inherits(GoogleMapMarkers, _Component);
	
	  function GoogleMapMarkers(props) {
	    _classCallCheck(this, GoogleMapMarkers);
	
	    var _this = _possibleConstructorReturn(this, (GoogleMapMarkers.__proto__ || Object.getPrototypeOf(GoogleMapMarkers)).call(this, props));
	
	    _this._getState = function () {
	      return {
	        children: _this.props.dispatcher.getChildren(),
	        updateCounter: _this.props.dispatcher.getUpdateCounter()
	      };
	    };
	
	    _this._onChangeHandler = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var prevChildCount = (_this.state.children || []).length;
	      var state = _this._getState();
	
	      _this.setState(state, function () {
	        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
	      });
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // click works only on hovered item
	          _this.props.onChildClick(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseDown = function () {
	      if (_this.props.onChildMouseDown) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // works only on hovered item
	          _this.props.onChildMouseDown(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function (hoverKey, childProps) {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      if (_this.props.onChildMouseEnter) {
	        _this.props.onChildMouseEnter(hoverKey, childProps);
	      }
	
	      _this.hoverChildProps_ = childProps;
	      _this.hoverKey_ = hoverKey;
	      _this.setState({ hoverKey: hoverKey });
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var hoverKey = _this.hoverKey_;
	      var childProps = _this.hoverChildProps_;
	
	      if (hoverKey !== undefined && hoverKey !== null) {
	        if (_this.props.onChildMouseLeave) {
	          _this.props.onChildMouseLeave(hoverKey, childProps);
	        }
	
	        _this.hoverKey_ = null;
	        _this.hoverChildProps_ = null;
	        _this.setState({ hoverKey: null });
	      }
	    };
	
	    _this._onMouseAllow = function (value) {
	      if (!value) {
	        _this._onChildMouseLeave();
	      }
	
	      _this.allowMouse_ = value;
	    };
	
	    _this._onMouseChangeHandler = function () {
	      if (_this.allowMouse_) {
	        _this._onMouseChangeHandlerRaf();
	      }
	    };
	
	    _this._onMouseChangeHandlerRaf = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var mp = _this.props.dispatcher.getMousePosition();
	
	      if (mp) {
	        var distances = [];
	        var hoverDistance = _this.props.getHoverDistance();
	
	        _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
	          if (!child) return;
	          // layers
	          if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	            return;
	          }
	
	          var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	          var dist = _this.props.distanceToMouse(_this.dimesionsCache_[childKey], mp, child.props);
	          if (dist < hoverDistance) {
	            distances.push({
	              key: childKey,
	              dist: dist,
	              props: child.props
	            });
	          }
	        });
	
	        if (distances.length) {
	          distances.sort(function (a, b) {
	            return a.dist - b.dist;
	          });
	          var hoverKey = distances[0].key;
	          var childProps = distances[0].props;
	
	          if (_this.hoverKey_ !== hoverKey) {
	            _this._onChildMouseLeave();
	
	            _this._onChildMouseEnter(hoverKey, childProps);
	          }
	        } else {
	          _this._onChildMouseLeave();
	        }
	      } else {
	        _this._onChildMouseLeave();
	      }
	    };
	
	    _this._getDimensions = function (key) {
	      var childKey = key;
	      return _this.dimesionsCache_[childKey];
	    };
	
	    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
	    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
	    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
	    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);
	
	    _this.dimesionsCache_ = {};
	    _this.hoverKey_ = null;
	    _this.hoverChildProps_ = null;
	    _this.allowMouse_ = true;
	
	    _this.state = _extends({}, _this._getState(), { hoverKey: null });
	    return _this;
	  }
	
	  _createClass(GoogleMapMarkers, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (this.props.experimental === true) {
	        return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
	      }
	
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
	      this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
	      this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
	      this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);
	
	      this.dimesionsCache_ = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var mainElementStyle = this.props.style || mainStyle;
	      this.dimesionsCache_ = {};
	
	      var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
	        if (!child) return undefined;
	        if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	          return _react2.default.cloneElement(child, {
	            $geoService: _this2.props.geoService,
	            $onMouseAllow: _this2._onMouseAllow,
	            $prerender: _this2.props.prerender
	          });
	        }
	
	        var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };
	
	        var pt = _this2.props.geoService.project(latLng, _this2.props.projectFromLeftTop);
	
	        var stylePtPos = {
	          left: pt.x,
	          top: pt.y
	        };
	
	        var dx = 0;
	        var dy = 0;
	
	        if (!_this2.props.projectFromLeftTop) {
	          // center projection
	          if (_this2.props.geoService.hasSize()) {
	            dx = _this2.props.geoService.getWidth() / 2;
	            dy = _this2.props.geoService.getHeight() / 2;
	          }
	        }
	
	        // to prevent rerender on child element i need to pass
	        // const params $getDimensions and $dimensionKey instead of dimension object
	        var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	
	        _this2.dimesionsCache_[childKey] = _extends({
	          x: pt.x + dx,
	          y: pt.y + dy
	        }, latLng);
	
	        return _react2.default.createElement(
	          'div',
	          {
	            key: childKey,
	            style: _extends({}, style, stylePtPos),
	            className: child.props.$markerHolderClassName
	          },
	          _react2.default.cloneElement(child, {
	            $hover: childKey === _this2.state.hoverKey,
	            $getDimensions: _this2._getDimensions,
	            $dimensionKey: childKey,
	            $geoService: _this2.props.geoService,
	            $onMouseAllow: _this2._onMouseAllow,
	            $prerender: _this2.props.prerender
	          })
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: mainElementStyle },
	        markers
	      );
	    }
	  }]);
	
	  return GoogleMapMarkers;
	}(_react.Component);
	
	GoogleMapMarkers.propTypes = {
	  geoService: _propTypes2.default.any,
	  style: _propTypes2.default.any,
	  distanceToMouse: _propTypes2.default.func,
	  dispatcher: _propTypes2.default.any,
	  onChildClick: _propTypes2.default.func,
	  onChildMouseDown: _propTypes2.default.func,
	  onChildMouseLeave: _propTypes2.default.func,
	  onChildMouseEnter: _propTypes2.default.func,
	  getHoverDistance: _propTypes2.default.func,
	  projectFromLeftTop: _propTypes2.default.bool,
	  prerender: _propTypes2.default.bool
	};
	GoogleMapMarkers.defaultProps = {
	  projectFromLeftTop: false,
	  prerender: false
	};
	exports.default = GoogleMapMarkers;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _wrap2 = __webpack_require__(185);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LatLng = function () {
	  function LatLng(lat, lng) {
	    _classCallCheck(this, LatLng);
	
	    if (isNaN(lat) || isNaN(lng)) {
	      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	    }
	    this.lat = +lat;
	    this.lng = +lng;
	  }
	
	  _createClass(LatLng, [{
	    key: 'wrap',
	    value: function wrap() {
	      return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
	    }
	  }]);
	
	  return LatLng;
	}();
	
	LatLng.convert = function (a) {
	  if (a instanceof LatLng) {
	    return a;
	  }
	
	  if (Array.isArray(a)) {
	    return new LatLng(a[0], a[1]);
	  }
	
	  if ('lng' in a && 'lat' in a) {
	    return new LatLng(a.lat, a.lng);
	  }
	
	  return a;
	};
	
	exports.default = LatLng;

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wrap = wrap;
	/* eslint-disable import/prefer-default-export */
	
	function wrap(n, min, max) {
	  var d = max - min;
	  return n === max ? n : ((n - min) % d + d) % d + min;
	}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
	var omit = function omit(obj, keys) {
	  var rest = _objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (key in rest) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	exports.default = omit;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Locale = __webpack_require__(213);
	
	var _SkipLinks = __webpack_require__(501);
	
	var _SkipLinks2 = _interopRequireDefault(_SkipLinks);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.APP;
	
	var supportedLocales = ['en-US', 'pt-BR'];
	
	function localesSupported() {
	  return global.Intl && supportedLocales.every(function (locale) {
	    return Intl.NumberFormat.supportedLocalesOf(locale)[0] === locale && Intl.DateTimeFormat.supportedLocalesOf(locale)[0] === locale;
	  });
	}
	
	if (!localesSupported()) {
	  __webpack_require__(568);
	  __webpack_require__(570);
	  __webpack_require__(571);
	  Intl.NumberFormat = IntlPolyfill.NumberFormat;
	  Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
	}
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props, context) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));
	
	    _this.state = {
	      lang: 'en-US'
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var lang = this.props.lang || (0, _Locale.getCurrentLocale)();
	
	      if (!document.documentElement.getAttribute('lang')) {
	        document.documentElement.setAttribute('lang', lang);
	      }
	      this.setState({ lang: lang });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          centered = _props.centered,
	          children = _props.children,
	          className = _props.className,
	          inline = _props.inline,
	          props = _objectWithoutProperties(_props, ['centered', 'children', 'className', 'inline']);
	
	      var lang = this.state.lang;
	
	
	      var classes = (0, _classnames3.default)('grommet', CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--centered', centered), _defineProperty(_classnames, CLASS_ROOT + '--inline', inline), _classnames), className);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ lang: lang, className: classes }, props),
	        children,
	        _react2.default.createElement(_SkipLinks2.default, null),
	        _react2.default.createElement('div', { className: CLASS_ROOT + '__announcer', 'aria-live': 'polite' })
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.displayName = 'App';
	exports.default = App;
	
	
	App.propTypes = {
	  centered: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool
	};
	
	App.defaultProps = {
	  centered: true
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(655);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	// NOTE: This component is a temporary wrapper of react-intl FormattedMessage
	// to avoid errors being thrown if the context hasn't been wrapped by
	// IntlProvider. The hope is that react-intl will change to obviate the
	// need for this component.
	
	var GrommetFormattedMessage = function GrommetFormattedMessage(props, context) {
	  return context.intl ? _react2.default.createElement(_reactIntl.FormattedMessage, props) : _react2.default.createElement(
	    'span',
	    null,
	    props.defaultMessage || props.id
	  );
	};
	
	GrommetFormattedMessage.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	GrommetFormattedMessage.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  defaultMessage: _propTypes2.default.string
	};
	
	GrommetFormattedMessage.displayName = 'GrommetFormattedMessage';
	
	exports.default = GrommetFormattedMessage;
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.RADIO_BUTTON;
	
	var RadioButton = function (_Component) {
	  _inherits(RadioButton, _Component);
	
	  function RadioButton() {
	    _classCallCheck(this, RadioButton);
	
	    return _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
	  }
	
	  _createClass(RadioButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          label = _props.label,
	          props = _objectWithoutProperties(_props, ['className', 'label']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--disabled', props.disabled), className);
	
	      return _react2.default.createElement(
	        'label',
	        { htmlFor: props.id, className: classes },
	        _react2.default.createElement('input', _extends({}, props, { className: CLASS_ROOT + '__input',
	          type: 'radio' })),
	        _react2.default.createElement('span', { className: CLASS_ROOT + '__control' }),
	        _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__label' },
	          label
	        )
	      );
	    }
	  }]);
	
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.displayName = 'RadioButton';
	exports.default = RadioButton;
	
	
	RadioButton.propTypes = {
	  checked: _propTypes2.default.bool,
	  defaultChecked: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  id: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.node.isRequired,
	  name: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  value: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SKIP_LINK_ANCHOR;
	
	var SkipLinkAnchor = function (_Component) {
	  _inherits(SkipLinkAnchor, _Component);
	
	  function SkipLinkAnchor() {
	    _classCallCheck(this, SkipLinkAnchor);
	
	    return _possibleConstructorReturn(this, (SkipLinkAnchor.__proto__ || Object.getPrototypeOf(SkipLinkAnchor)).apply(this, arguments));
	  }
	
	  _createClass(SkipLinkAnchor, [{
	    key: 'render',
	    value: function render() {
	      var id = 'skip-link-' + this.props.label.toLowerCase().replace(/ /g, '_');
	
	      return _react2.default.createElement(
	        'a',
	        { tabIndex: '-1', 'aria-hidden': 'true', id: id, className: CLASS_ROOT },
	        this.props.label
	      );
	    }
	  }]);
	
	  return SkipLinkAnchor;
	}(_react.Component);
	
	SkipLinkAnchor.displayName = 'SkipLinkAnchor';
	exports.default = SkipLinkAnchor;
	
	
	SkipLinkAnchor.propTypes = {
	  label: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Spinning = __webpack_require__(192);
	
	var _Spinning2 = _interopRequireDefault(_Spinning);
	
	var _Scroll = __webpack_require__(214);
	
	var _Scroll2 = _interopRequireDefault(_Scroll);
	
	var _InfiniteScroll = __webpack_require__(212);
	
	var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);
	
	var _Selection = __webpack_require__(215);
	
	var _Selection2 = _interopRequireDefault(_Selection);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Announcer = __webpack_require__(35);
	
	var _LinkPrevious = __webpack_require__(125);
	
	var _LinkPrevious2 = _interopRequireDefault(_LinkPrevious);
	
	var _LinkNext = __webpack_require__(103);
	
	var _LinkNext2 = _interopRequireDefault(_LinkNext);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.TILES;
	var TILE = _CSSClassnames2.default.TILE;
	var SELECTED_CLASS = TILE + '--selected';
	var ACTIVE_CLASS = TILE + '--active';
	
	var Tiles = function (_Component) {
	  _inherits(Tiles, _Component);
	
	  function Tiles(props, context) {
	    _classCallCheck(this, Tiles);
	
	    var _this = _possibleConstructorReturn(this, (Tiles.__proto__ || Object.getPrototypeOf(Tiles)).call(this, props, context));
	
	    _this._onLeft = _this._onLeft.bind(_this);
	    _this._onRight = _this._onRight.bind(_this);
	    _this._onScrollHorizontal = _this._onScrollHorizontal.bind(_this);
	    _this._onWheel = _this._onWheel.bind(_this);
	    _this._onResize = _this._onResize.bind(_this);
	    _this._layout = _this._layout.bind(_this);
	    _this._onClick = _this._onClick.bind(_this);
	    _this._fireClick = _this._fireClick.bind(_this);
	    _this._announceTile = _this._announceTile.bind(_this);
	    _this._onPreviousTile = _this._onPreviousTile.bind(_this);
	    _this._onNextTile = _this._onNextTile.bind(_this);
	    _this._onEnter = _this._onEnter.bind(_this);
	
	    _this.state = {
	      activeTile: undefined,
	      mouseActive: false,
	      overflow: false,
	      selected: _Selection2.default.normalizeIndexes(props.selected)
	    };
	    return _this;
	  }
	
	  _createClass(Tiles, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          direction = _props.direction,
	          onMore = _props.onMore,
	          selectable = _props.selectable;
	
	      if (onMore) {
	        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
	      }
	      if ('row' === direction) {
	        window.addEventListener('resize', this._onResize);
	        document.addEventListener('wheel', this._onWheel, { passive: true });
	        this._trackHorizontalScroll();
	        // give browser a chance to stabilize
	        this._layoutTimer = setTimeout(this._layout, 10);
	      }
	      if (selectable) {
	        // only listen for navigation keys if the tile row can be selected
	        this._keyboardHandlers = {
	          left: this._onPreviousTile,
	          up: this._onPreviousTile,
	          right: this._onNextTile,
	          down: this._onNextTile,
	          enter: this._onEnter,
	          space: this._onEnter
	        };
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selected !== undefined) {
	        this.setState({
	          selected: _Selection2.default.normalizeIndexes(nextProps.selected)
	        });
	      }
	      if (this._scroll) {
	        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
	        this._scroll = undefined;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          direction = _props2.direction,
	          onMore = _props2.onMore,
	          selectable = _props2.selectable;
	
	      if (onMore && !this._scroll) {
	        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
	      }
	      if ('row' === direction) {
	        this._trackHorizontalScroll();
	        // give browser a chance to stabilize
	        this._layoutTimer = setTimeout(this._layout, 10);
	      }
	      if (selectable) {
	        // only listen for navigation keys if the list row can be selected
	        this._keyboardHandlers = {
	          left: this._onPreviousTile,
	          up: this._onPreviousTile,
	          right: this._onNextTile,
	          down: this._onNextTile,
	          enter: this._onEnter,
	          space: this._onEnter
	        };
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props3 = this.props,
	          direction = _props3.direction,
	          selectable = _props3.selectable;
	
	      if (this._scroll) {
	        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
	      }
	      if ('row' === direction) {
	        window.removeEventListener('resize', this._onResize);
	        document.removeEventListener('wheel', this._onWheel);
	        if (this._tracking) {
	          var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
	          tiles.removeEventListener('scroll', this._onScrollHorizontal);
	        }
	      }
	      if (selectable) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	      }
	      if (this._layoutTimer) {
	        clearTimeout(this._layoutTimer);
	      }
	    }
	  }, {
	    key: '_announceTile',
	    value: function _announceTile(label) {
	      var intl = this.context.intl;
	
	      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
	      // avoid a long text to be read by the screen reader
	      var labelMessage = label.length > 15 ? label.substring(0, 15) + '...' : label;
	      (0, _Announcer.announce)(labelMessage + ' ' + enterSelectMessage);
	    }
	  }, {
	    key: '_onPreviousTile',
	    value: function _onPreviousTile(event) {
	      var _this2 = this;
	
	      if ((0, _reactDom.findDOMNode)(this.tilesRef).contains(document.activeElement)) {
	        event.preventDefault();
	        var activeTile = this.state.activeTile;
	
	        var rows = (0, _reactDom.findDOMNode)(this.tilesRef).querySelectorAll('.' + TILE);
	        if (rows && rows.length > 0) {
	          if (activeTile === undefined) {
	            rows[0].classList.add(ACTIVE_CLASS);
	            this.setState({ activeTile: 0 }, function () {
	              _this2._announceTile(rows[_this2.state.activeTile].innerText);
	            });
	          } else if (activeTile - 1 >= 0) {
	            rows[activeTile].classList.remove(ACTIVE_CLASS);
	            rows[activeTile - 1].classList.add(ACTIVE_CLASS);
	            this.setState({ activeTile: activeTile - 1 }, function () {
	              _this2._announceTile(rows[_this2.state.activeTile].innerText);
	            });
	          }
	        }
	
	        //stop event propagation
	        return true;
	      }
	    }
	  }, {
	    key: '_onNextTile',
	    value: function _onNextTile(event) {
	      var _this3 = this;
	
	      if ((0, _reactDom.findDOMNode)(this.tilesRef).contains(document.activeElement)) {
	        event.preventDefault();
	        var activeTile = this.state.activeTile;
	
	        var rows = (0, _reactDom.findDOMNode)(this.tilesRef).querySelectorAll('.' + TILE);
	        if (rows && rows.length > 0) {
	          if (activeTile === undefined) {
	            rows[0].classList.add(ACTIVE_CLASS);
	            this.setState({ activeTile: 0 }, function () {
	              _this3._announceTile(rows[_this3.state.activeTile].innerText);
	            });
	          } else if (activeTile + 1 <= rows.length - 1) {
	            rows[activeTile].classList.remove(ACTIVE_CLASS);
	            rows[activeTile + 1].classList.add(ACTIVE_CLASS);
	            this.setState({ activeTile: activeTile + 1 }, function () {
	              _this3._announceTile(rows[_this3.state.activeTile].innerText);
	            });
	          }
	        }
	
	        //stop event propagation
	        return true;
	      }
	    }
	  }, {
	    key: '_fireClick',
	    value: function _fireClick(element, shiftKey) {
	      var event = void 0;
	      try {
	        event = new MouseEvent('click', {
	          'bubbles': true,
	          'cancelable': true,
	          'shiftKey': shiftKey
	        });
	      } catch (e) {
	        // IE11 workaround.
	        event = document.createEvent('Event');
	        event.initEvent('click', true, true);
	      }
	      // We use dispatchEvent to have the browser fill out the event fully.
	      element.dispatchEvent(event);
	    }
	  }, {
	    key: '_onEnter',
	    value: function _onEnter(event) {
	      var activeTile = this.state.activeTile;
	      var intl = this.context.intl;
	
	      if ((0, _reactDom.findDOMNode)(this.tilesRef).contains(document.activeElement) && activeTile !== undefined) {
	        var rows = (0, _reactDom.findDOMNode)(this.tilesRef).querySelectorAll('.' + TILE);
	        this._fireClick(rows[activeTile], event.shiftKey);
	        rows[activeTile].classList.remove(ACTIVE_CLASS);
	        var label = rows[activeTile].innerText;
	        // avoid a long text to be read by the screen reader
	        var labelMessage = label.length > 15 ? label.substring(0, 15) + '...' : label;
	        var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
	        (0, _Announcer.announce)(labelMessage + ' ' + selectedMessage);
	      }
	    }
	  }, {
	    key: '_onLeft',
	    value: function _onLeft() {
	      var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
	      _Scroll2.default.scrollBy(tiles, 'scrollLeft', -tiles.offsetWidth);
	    }
	  }, {
	    key: '_onRight',
	    value: function _onRight() {
	      var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
	      _Scroll2.default.scrollBy(tiles, 'scrollLeft', tiles.offsetWidth);
	    }
	  }, {
	    key: '_onScrollHorizontal',
	    value: function _onScrollHorizontal() {
	      // debounce
	      clearTimeout(this._layoutTimer);
	      this._layoutTimer = setTimeout(this._layout, 50);
	    }
	  }, {
	    key: '_onWheel',
	    value: function _onWheel(event) {
	      if (Math.abs(event.deltaX) > 100) {
	        clearInterval(this._scrollTimer);
	      } else if (event.deltaX > 5) {
	        this._onRight();
	      } else if (event.deltaX < -5) {
	        this._onLeft();
	      }
	    }
	  }, {
	    key: '_layout',
	    value: function _layout() {
	      var direction = this.props.direction;
	
	
	      if ('row' === direction) {
	        // determine if we have more tiles than room to fit
	        var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
	
	        // 20 is to allow some fuzziness as scrollbars come and go
	        var newState = {
	          overflow: tiles.scrollWidth > tiles.offsetWidth + 20,
	          overflowStart: tiles.scrollLeft <= 20,
	          overflowEnd: tiles.scrollLeft >= tiles.scrollWidth - tiles.offsetWidth,
	          scrollWidth: tiles.scrollWidth
	        };
	
	        var state = {
	          overflow: this.state.overflow,
	          overflowStart: this.state.overflowStart,
	          overflowEnd: this.state.overflowEnd,
	          scrollWidth: this.state.scrollWidth
	        };
	
	        // Shallow compare states.
	        if (JSON.stringify(newState) !== JSON.stringify(state)) {
	          this.setState(_extends({}, newState));
	        }
	
	        // mark any tiles that might be clipped
	        var rect = tiles.getBoundingClientRect();
	        var children = tiles.querySelectorAll('.' + TILE);
	
	        Array.from(children).map(function (child, index) {
	          var childRect = child.getBoundingClientRect();
	          // 12 accounts for padding
	          if (childRect.left + 12 < rect.left || childRect.right - 12 > rect.right) {
	            child.classList.add(TILE + '--eclipsed');
	          } else {
	            child.classList.remove(TILE + '--eclipsed');
	          }
	        });
	      }
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      // debounce
	      clearTimeout(this._layoutTimer);
	      this._layoutTimer = setTimeout(this._layout, 50);
	    }
	  }, {
	    key: '_trackHorizontalScroll',
	    value: function _trackHorizontalScroll() {
	      var overflow = this.state.overflow;
	
	      if (overflow && !this._tracking) {
	        var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
	        tiles.addEventListener('scroll', this._onScrollHorizontal);
	        this._tracking = true;
	      }
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      var _props4 = this.props,
	          onSelect = _props4.onSelect,
	          selectable = _props4.selectable,
	          selected = _props4.selected;
	
	      var selection = _Selection2.default.onClick(event, {
	        containerElement: (0, _reactDom.findDOMNode)(this.tilesRef),
	        childSelector: '.' + TILE,
	        selectedClass: SELECTED_CLASS,
	        multiSelect: 'multiple' === selectable,
	        priorSelectedIndexes: this.state.selected
	      });
	      // only set the selected state and classes if the caller isn't managing it.
	      if (selected === undefined) {
	        this.setState({ selected: selection });
	      }
	
	      if (onSelect) {
	        onSelect(selection.length === 1 ? selection[0] : selection);
	      }
	    }
	  }, {
	    key: '_renderChild',
	    value: function _renderChild(element, elementIndex) {
	      var flush = this.props.flush;
	      var selectedArray = this.state.selected;
	
	      var selected = element.props.selected;
	
	      if (selectedArray && selectedArray.indexOf(elementIndex) > -1) {
	        selected = true;
	      }
	
	      if (element) {
	        // only clone tile children
	        if (element.type && element.type._tile) {
	          var elementClone = _react2.default.cloneElement(element, {
	            hoverBorder: !flush,
	            selected: selected
	          });
	
	          return elementClone;
	        }
	        return element;
	      }
	
	      return undefined;
	    }
	
	    // children should be an array of Tile
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this4 = this;
	
	      var _props5 = this.props,
	          a11yTitle = _props5.a11yTitle,
	          className = _props5.className,
	          children = _props5.children,
	          direction = _props5.direction,
	          fill = _props5.fill,
	          flush = _props5.flush,
	          _onBlur = _props5.onBlur,
	          _onFocus = _props5.onFocus,
	          onMore = _props5.onMore,
	          _onMouseDown = _props5.onMouseDown,
	          _onMouseUp = _props5.onMouseUp,
	          selectable = _props5.selectable;
	      var _state = this.state,
	          activeTile = _state.activeTile,
	          focus = _state.focus,
	          mouseActive = _state.mouseActive,
	          overflow = _state.overflow,
	          overflowEnd = _state.overflowEnd,
	          overflowStart = _state.overflowStart;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames, CLASS_ROOT + '--flush', flush), _defineProperty(_classnames, CLASS_ROOT + '--focus', focus), _defineProperty(_classnames, CLASS_ROOT + '--selectable', selectable), _defineProperty(_classnames, CLASS_ROOT + '--moreable', onMore), _defineProperty(_classnames, CLASS_ROOT + '--overflowed', overflow), _classnames), className);
	
	      var other = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	
	      var more = void 0;
	      if (onMore) {
	        more = _react2.default.createElement(
	          'div',
	          { ref: function ref(_ref) {
	              return _this4.moreRef = _ref;
	            }, className: CLASS_ROOT + '__more' },
	          _react2.default.createElement(_Spinning2.default, null)
	        );
	      }
	
	      var tileContents = _react.Children.toArray(children).filter(function (child) {
	        return child;
	      }).map(function (element, index) {
	        return _this4._renderChild(element, index);
	      });
	
	      var selectableProps = void 0;
	      if (selectable) {
	        var multiSelectMessage = selectable === 'multiple' ? '(' + _Intl2.default.getMessage(intl, 'Multi Select') + ')' : '';
	        var tilesMessage = a11yTitle || _Intl2.default.getMessage(intl, 'Tiles');
	        var navigationHelpMessage = _Intl2.default.getMessage(intl, 'Navigation Help');
	        selectableProps = {
	          'aria-label': tilesMessage + ' ' + multiSelectMessage + ' ' + navigationHelpMessage,
	          tabIndex: '0',
	          onClick: this._onClick,
	          onMouseDown: function onMouseDown(event) {
	            _this4.setState({ mouseActive: true });
	            if (_onMouseDown) {
	              _onMouseDown(event);
	            }
	          },
	          onMouseUp: function onMouseUp(event) {
	            _this4.setState({ mouseActive: false });
	            if (_onMouseUp) {
	              _onMouseUp(event);
	            }
	          },
	          onFocus: function onFocus(event) {
	            if (mouseActive === false) {
	              _this4.setState({ focus: true });
	            }
	            if (_onFocus) {
	              _onFocus(event);
	            }
	          },
	          onBlur: function onBlur(event) {
	            if (activeTile) {
	              var rows = (0, _reactDom.findDOMNode)(_this4.tilesRef).querySelectorAll('.' + TILE);
	              rows[activeTile].classList.remove(ACTIVE_CLASS);
	            }
	            _this4.setState({ focus: false, activeTile: undefined });
	            if (_onBlur) {
	              _onBlur(event);
	            }
	          }
	        };
	      }
	
	      var contents = _react2.default.createElement(
	        _Box2.default,
	        _extends({ ref: function ref(_ref2) {
	            return _this4.tilesRef = _ref2;
	          } }, other, {
	          wrap: direction ? false : true,
	          direction: direction ? direction : 'row',
	          className: classes, focusable: false }, selectableProps),
	        tileContents,
	        more
	      );
	
	      if (overflow) {
	        var left = void 0;
	        var right = void 0;
	
	        if (!overflowStart) {
	          var previousTilesMessage = _Intl2.default.getMessage(intl, 'Previous Tiles');
	          left = _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__left',
	            icon: _react2.default.createElement(_LinkPrevious2.default, null),
	            a11yTitle: previousTilesMessage, onClick: this._onLeft });
	        }
	        if (!overflowEnd) {
	          var nextTilesMessage = _Intl2.default.getMessage(intl, 'Next Tiles');
	          right = _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__right',
	            icon: _react2.default.createElement(_LinkNext2.default, null),
	            a11yTitle: nextTilesMessage, onClick: this._onRight });
	        }
	
	        contents = _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + '__container' },
	          left,
	          contents,
	          right
	        );
	      }
	
	      return contents;
	    }
	  }]);
	
	  return Tiles;
	}(_react.Component);
	
	Tiles.displayName = 'Tiles';
	exports.default = Tiles;
	
	
	Tiles.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Tiles.propTypes = _extends({
	  fill: _propTypes2.default.bool,
	  flush: _propTypes2.default.bool,
	  onMore: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  selectable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['multiple'])]),
	  selected: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])
	}, _Box2.default.propTypes);
	
	Tiles.defaultProps = {
	  flush: true,
	  justify: 'start',
	  pad: 'small'
	};
	module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SPINNING;
	
	var Spinning = function (_Component) {
	  _inherits(Spinning, _Component);
	
	  function Spinning() {
	    _classCallCheck(this, Spinning);
	
	    return _possibleConstructorReturn(this, (Spinning.__proto__ || Object.getPrototypeOf(Spinning)).apply(this, arguments));
	  }
	
	  _createClass(Spinning, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          className = _props.className,
	          small = _props.small,
	          size = _props.size,
	          responsive = _props.responsive,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'className', 'small', 'size', 'responsive']);
	
	      var intl = this.context.intl;
	
	
	      var sizeOverride = small ? 'small' : size;
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + sizeOverride, sizeOverride), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _classnames), className);
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, viewBox: '0 0 48 48', version: '1.1',
	          role: 'img', 'aria-label': a11yTitle || _Intl2.default.getMessage(intl, 'Spinning') }),
	        _react2.default.createElement('circle', { cx: '24', cy: '24', r: '21',
	          stroke: '#979797', strokeWidth: '6', fill: 'none' })
	      );
	    }
	  }]);
	
	  return Spinning;
	}(_react.Component);
	
	Spinning.displayName = 'Spinning';
	exports.default = Spinning;
	
	
	Spinning.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Spinning.defaultProps = {
	  responsive: true
	};
	
	Spinning.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  small: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-caret-next', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'caret-next');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 2 18 12 6 22' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'CaretNext';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-circle-play', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'circle-play');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M9.5,15.5 L15.5,12 L9.5,8.5 L9.5,15.5 Z M10.5,13.5 L12.5,12 L10.5,10.5 L10.5,13.5 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'CirclePlay';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-down', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'down');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7.086 3.174 17.086 13.174 7.086 23.174', transform: 'scale(1 -1) rotate(-89 -1.32 0)' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Down';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-location', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'location');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C12,22 4,16 4,10 C4,5 8,2 12,2 C16,2 20,5 20,10 C20,16 12,22 12,22 Z M12,13 C13.657,13 15,11.657 15,10 C15,8.343 13.657,7 12,7 C10.343,7 9,8.343 9,10 C9,11.657 10.343,13 12,13 L12,13 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Location';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-menu', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'menu');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,19 L22,19 M2,5 L22,5 M2,12 L22,12' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Menu';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CirclePlay = __webpack_require__(194);
	
	var _CirclePlay2 = _interopRequireDefault(_CirclePlay);
	
	var _Play = __webpack_require__(515);
	
	var _Play2 = _interopRequireDefault(_Play);
	
	var _Pause = __webpack_require__(514);
	
	var _Pause2 = _interopRequireDefault(_Pause);
	
	var _Refresh = __webpack_require__(517);
	
	var _Refresh2 = _interopRequireDefault(_Refresh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BUTTON_CLASS = CLASS_ROOT + '__button';
	
	var PlayButton = function (_Component) {
	  _inherits(PlayButton, _Component);
	
	  function PlayButton() {
	    _classCallCheck(this, PlayButton);
	
	    return _possibleConstructorReturn(this, (PlayButton.__proto__ || Object.getPrototypeOf(PlayButton)).apply(this, arguments));
	  }
	
	  _createClass(PlayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          ended = _props.ended,
	          iconSize = _props.iconSize,
	          playing = _props.playing,
	          primary = _props.primary,
	          togglePlay = _props.togglePlay;
	      var intl = this.context.intl;
	
	
	      var PIcon = primary ? _CirclePlay2.default : _Play2.default;
	      var Icon = playing ? _Pause2.default : ended ? _Refresh2.default : PIcon;
	      var controlIcon = _react2.default.createElement(Icon, { className: BUTTON_CLASS + '__icon', size: iconSize,
	        colorIndex: 'brand' });
	
	      var a11yControlButtonMessage = playing ? 'Pause Video' : ended ? 'Restart Video' : 'Play Video';
	
	      var a11yControlButtonTitle = _Intl2.default.getMessage(intl, a11yControlButtonMessage);
	
	      return _react2.default.createElement(
	        _Button2.default,
	        { plain: true, className: BUTTON_CLASS, onClick: togglePlay,
	          a11yTitle: a11yControlButtonTitle },
	        controlIcon
	      );
	    }
	  }]);
	
	  return PlayButton;
	}(_react.Component);
	
	PlayButton.displayName = 'PlayButton';
	exports.default = PlayButton;
	
	
	PlayButton.propTypes = {
	  iconSize: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge', 'huge']),
	  playing: _propTypes2.default.bool,
	  primary: _propTypes2.default.bool,
	  ended: _propTypes2.default.bool,
	  togglePlay: _propTypes2.default.func
	};
	
	PlayButton.defaultProps = {
	  iconSize: 'xlarge',
	  primary: true
	};
	module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enUS = __webpack_require__(126);
	
	Object.keys(_enUS).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _enUS[key];
	    }
	  });
	});

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _frFR = __webpack_require__(127);
	
	Object.keys(_frFR).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _frFR[key];
	    }
	  });
	});

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _enUS = __webpack_require__(56);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({
	  IndexFilters: {
	    filters: '{quantity, plural,\n  =0 {מסננים}\n  =1 {מסנן\n  ' + 'other {# מסננים}\n}'
	  }
	}, _enUS2.default, {
	  Active: 'פעיל',
	  Activate: 'הפעל',
	  Activated: 'מופעל',
	  Add: 'הוסף',
	  add: 'הוסף',
	  Alerts: 'התראות',
	  All: 'הכל',
	  ampm: 'ampm',
	  Arc: 'קשת',
	  AxisLabel: '{orientation} ציר',
	  area: 'אזור',
	  Bar: 'בר',
	  bar: 'בר',
	  Blank: 'ריק',
	  Box: 'מסגרת',
	  Carousel: 'קרוסלה',
	  Category: 'קטגוריה',
	  Circle: 'מעגל',
	  Chart: 'תרשים',
	  Children: 'ילדים',
	  Clear: 'נקה טופס',
	  Cleared: 'טופס נוקה',
	  Close: 'סגור',
	  'Close Menu': 'סגור תפריט',
	  Completed: 'הושלם',
	  'Connects With': 'מתחבר',
	  created: 'נוצר',
	  Critical: 'קריטי',
	  'Currently Active': 'בחירה נוכחית',
	  'Date Selector': 'בחירת תאריך',
	  'Date Time Icon': 'פתח בחירת תאריך ושעה',
	  day: 'יום',
	  Disabled: 'לא פעיל',
	  Distribution: 'הפצה',
	  Email: 'דוא״ל',
	  'Enter Select': 'הקש Enter לבחירה',
	  Error: 'שגיאה',
	  Filter: 'סנן',
	  Footer: 'כותרת תחתונה',
	  Grommet: 'Grommet',
	  HotSpotsLabel: 'נקודות חמות: השתמש במקשי החצים לאינטרקציה',
	  'GraphValues': 'הגרף מכיל {count} ערכים, הערך הגבוה הינו {highest}' + ' והנמוך הינו {smallest}',
	  hour: 'שעה',
	  'Grommet Logo': 'Grommet לוגו',
	  'Layer': 'שכבה',
	  List: 'רשימה',
	  line: 'קו',
	  'Loading': 'טוען',
	  loginInvalidPassword: 'הכנס שם משתמש וסיסמא',
	  'Log In': 'התחבר',
	  Logout: 'התנתק',
	  'Main Content': 'תוכן עיקרי',
	  Max: 'מקסימלי',
	  Menu: 'תפריט',
	  Meter: 'מונה',
	  Min: 'מינמאלי',
	  minute: 'דקה',
	  model: 'מודל',
	  modified: 'שונה',
	  monitor: 'ניטור',
	  month: 'חודש',
	  'Multi Select': 'בחירה מרובה',
	  Name: 'שם',
	  'Navigation Help': 'התשמש בחיצים לניווט',
	  'Next Month': 'חודש הבא',
	  'Next Slide': 'שקופית הבאה',
	  'No Relationship': 'ללא קשר',
	  'Notification': 'התראה',
	  OK: 'אשר',
	  Open: 'פתח',
	  Parent: 'מקור',
	  Parents: 'מקורות',
	  Parts: 'חלקים',
	  Part: 'חלק',
	  Password: 'סיסמא',
	  'Previous Month': 'חודש קודם',
	  'Previous Slide': 'שקופית קודמת',
	  'Previous Tiles': 'אריחים קודמים',
	  'Remember me': 'זכור אותי',
	  Resource: 'משאב',
	  Running: 'הרצה',
	  Search: 'חפש',
	  'Match Results': '\u05D9\u05E9 {count, plural,\n      =0 {\u05E8\u05D9\u05E7}\n      one {\u05EA\u05D5\u05E6\u05D0\u05D4 \u05D0\u05D7\u05EA}\n      other {# \u05EA\u05D5\u05E6\u05D0\u05D5\u05EA}\n  }',
	  second: 'שנייה',
	  'Select Icon': 'פתח בחירה',
	  Selected: 'נבחר',
	  'Selected Multiple': '{count, plural,\n      =0 {\u05E8\u05D9\u05E7}\n      one {# \u05E2\u05E8\u05DA}\n      other {# \u05E2\u05E8\u05DB\u05D9\u05DD}\n  }',
	  'Skip to': 'קופץ ל',
	  'Slide Number': 'שקופית {slideNumber}',
	  Sort: 'מיין',
	  Spinning: 'מסתובב',
	  Spiral: 'ספירלי',
	  State: 'מצב',
	  Status: 'סטטוס',
	  Subtract: 'לחסר',
	  SunBurst: 'תרשים עוגה',
	  'Tab Contents': '{activeTitle} תוכן',
	  Table: 'טבלה',
	  Tasks: 'משימות',
	  Tiles: 'אריחים',
	  Time: 'שעה',
	  Title: 'כותרת',
	  Today: 'היום',
	  Topology: 'טופולוגיה',
	  Total: 'סה"כ',
	  Threshold: 'סף',
	  Unknown: 'לא ידוע',
	  Username: 'שם משתמש',
	  uri: 'URI',
	  Value: 'ערך',
	  Warning: 'אזהרה',
	  year: 'שנה'
	});
	module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enUS = __webpack_require__(56);
	
	Object.keys(_enUS).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _enUS[key];
	    }
	  });
	});

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _frFR = __webpack_require__(104);
	
	Object.keys(_frFR).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _frFR[key];
	    }
	  });
	});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jaJP = __webpack_require__(128);
	
	Object.keys(_jaJP).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _jaJP[key];
	    }
	  });
	});

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _zhCN = __webpack_require__(130);
	
	Object.keys(_zhCN).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _zhCN[key];
	    }
	  });
	});

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jaJP = __webpack_require__(131);
	
	Object.keys(_jaJP).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _jaJP[key];
	    }
	  });
	});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _nl = __webpack_require__(129);
	
	var _nl2 = _interopRequireDefault(_nl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({
	  IndexFilters: {
	    filters: '{quantity, plural,\n  =0 {Filters}\n  =1 {\xE9\xE9n filter}\n  ' + 'other {# filters}\n}'
	  }
	}, _nl2.default, {
	  Active: 'Actief',
	  Activate: 'Activeer',
	  Activated: 'Geactiveerd',
	  Add: 'Voeg toe',
	  add: 'voeg toe',
	  Alerts: 'Alarmen',
	  All: 'Alle',
	  ampm: 'ampm',
	  Arc: 'Boog',
	  AxisLabel: '{orientation} as',
	  area: 'gebied',
	  Bar: 'Balk',
	  bar: 'balk',
	  Blank: 'Blank',
	  Box: 'Box',
	  Carousel: 'Carousel',
	  Category: 'Categorie',
	  Circle: 'Circel',
	  Chart: 'Diagram',
	  Children: 'Kinderen',
	  Clear: 'Leeg maken',
	  Cleared: 'Leeg gemaakt',
	  Close: 'Sluiten',
	  'Close Menu': 'Sluitmenu',
	  Completed: 'Gereed',
	  'Connects With': 'Verbindt met',
	  created: 'Aangemaakt',
	  Critical: 'Critisch',
	  'Currently Active': 'Momenteel actief',
	  'Date Selector': 'Keuze datum',
	  'Date Time Icon': 'Open keuze datum en tijd',
	  day: 'dag',
	  Disabled: 'Uitgeschakeld',
	  Distribution: 'Distributie',
	  Email: 'E-mail',
	  'Enter Select': 'Druk op enter om het te selecteren',
	  Error: 'Fout',
	  Filter: 'Filter',
	  Footer: 'Footer',
	  Grommet: 'Grommet',
	  HotSpotsLabel: 'HotSpots: druk op de pijltjes om ermee te werken',
	  'GraphValues': 'De grafiek heeft {count} elementen. Het grootste is {highest}' + ' en het kleinste is {smallest}',
	  hour: 'uur',
	  'Grommet Logo': 'Grommet logo',
	  'Layer': 'Laag',
	  List: 'Lijst',
	  line: 'lijn',
	  'Loading': 'Aan het laden',
	  loginInvalidPassword: 'Gelieve een gebruikersnaam en wachtwoord te geven.',
	  'Log In': 'Aanmelden',
	  Logout: 'Afmelden',
	  'Main Content': 'Hoofdinhoud',
	  Max: 'Maximum',
	  Menu: 'Menu',
	  Meter: 'Meter',
	  Min: 'Mininum',
	  minute: 'minuut',
	  model: 'Model',
	  modified: 'Gewijzigd',
	  monitor: 'monitor',
	  month: 'maand',
	  'Multi Select': 'Multi-select',
	  Name: 'Naam',
	  'Navigation Help': 'Gebruik de pijltjes om te navigeren',
	  'Next Month': 'Volgende maand',
	  'Next Slide': 'Volgende dia',
	  'No Relationship': 'Geen relatie',
	  'Notification': 'Notificatie',
	  OK: 'OK',
	  Open: 'Open',
	  Parent: 'Ouder',
	  Parents: 'Ouders',
	  Parts: 'Onderdelen',
	  Part: 'Onderdeel',
	  Password: 'Wachtwoord',
	  'Previous Month': 'Vorige maand',
	  'Previous Slide': 'Vorige dia',
	  'Previous Tiles': 'Vorige tegel',
	  'Remember me': 'Onthoud mij',
	  Resource: 'Middel',
	  Running: 'Loopt',
	  Search: 'Zoek',
	  'Match Results': 'Er {count, plural,\n      =0 {is geen resultaat}\n      one {is # resultaat}\n      other {zijn # resultaten}\n  }',
	  second: 'seconde',
	  'Select Icon': 'Open selectiemenu',
	  Selected: 'Geselecteerd',
	  'Selected Multiple': '{count, plural,\n      =0 {geen}\n      one {# waarde}\n      other {# waarden}\n  }',
	  'Skip to': 'Spring naar',
	  'Slide Number': 'Dia {slideNumber}',
	  Sort: 'Sorteer',
	  Spinning: 'Aan het draaien',
	  Spiral: 'Spiraal',
	  State: 'Toestand',
	  Status: 'Status',
	  Subtract: 'Aftrekken',
	  SunBurst: 'SunBurst',
	  'Tab Contents': '{activeTitle} Tabinhoud',
	  Table: 'Tabel',
	  Tasks: 'Taken',
	  Tiles: 'Tegels',
	  Time: 'Tijd',
	  Title: 'Titel',
	  Today: 'Vandaag',
	  Topology: 'Topologie',
	  Total: 'Totaal',
	  Threshold: 'Drempel',
	  Unknown: 'Onbekend',
	  Username: 'Gebruikersnaam',
	  uri: 'URI',
	  Value: 'Waarde',
	  Warning: 'Waarschuwing',
	  year: 'jaar'
	});
	module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ptBR = __webpack_require__(132);
	
	Object.keys(_ptBR).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ptBR[key];
	    }
	  });
	});

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ruRU = __webpack_require__(133);
	
	Object.keys(_ruRU).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ruRU[key];
	    }
	  });
	});

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _zhCN = __webpack_require__(134);
	
	Object.keys(_zhCN).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _zhCN[key];
	    }
	  });
	});

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTime = formatTime;
	function formatTime(seconds) {
	  var date = new Date(null);
	  seconds = isNaN(seconds) ? 0 : Math.floor(seconds);
	  date.setSeconds(seconds);
	
	  var dateISOString = date.toISOString();
	  var time = dateISOString.substr(11, 8);
	  if (seconds < 3600) {
	    time = dateISOString.substr(14, 5);
	  }
	
	  return time;
	}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DOM = __webpack_require__(47);
	
	var SCROLL_MORE_DELAY = 500; // when the user scrolls
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var SCROLL_MORE_INITIAL_DELAY = 50; // when we start out at the bottom already
	
	function _evaluate(scrollState) {
	  (scrollState.scrollParents || []).forEach(function (scrollParent) {
	    // are we at the bottom?
	    var bottom = void 0;
	    if (scrollParent === document) {
	      bottom = window.innerHeight;
	    } else {
	      bottom = scrollParent.getBoundingClientRect().bottom;
	    }
	    if (scrollState.onEnd) {
	      var indicatorRect = scrollState.endIndicatorElement.getBoundingClientRect();
	      // Only if bottom isn't zero. This can happen when content hasn't
	      // arrived yet.
	      // 10px offset is to ensure onEnd() gets called
	      if (bottom && indicatorRect.bottom <= bottom + 10) {
	        scrollState.onEnd();
	      }
	    }
	    if (scrollState.onTop) {
	      var _indicatorRect = scrollState.startIndicatorElement.getBoundingClientRect();
	      // If the bottom position is 0 we're right at it. Below it its negative
	      // and scrolling too far up its positive.
	      if (_indicatorRect.bottom > 0) {
	        scrollState.onTop();
	      }
	    }
	  });
	}
	
	function _onScroll(scrollState) {
	  // delay a bit to ride out quick users
	  clearTimeout(scrollState.scrollTimer);
	  scrollState.scrollTimer = setTimeout(function () {
	    return _evaluate(scrollState);
	  }, SCROLL_MORE_DELAY);
	}
	
	function _onResize(scrollState) {
	  clearTimeout(scrollState.scrollTimer);
	  scrollState.scrollTimer = setTimeout(function () {
	    return _evaluate(scrollState);
	  }, SCROLL_MORE_DELAY);
	}
	
	exports.default = {
	  startListeningForScroll: function startListeningForScroll(endIndicatorElement, onEnd, startIndicatorElement, onTop) {
	
	    var scrollState = {
	      onEnd: onEnd,
	      endIndicatorElement: endIndicatorElement,
	      onTop: onTop,
	      startIndicatorElement: startIndicatorElement,
	      scrollParents: (0, _DOM.findScrollParents)(endIndicatorElement || startIndicatorElement)
	    };
	
	    scrollState._onResize = _onResize.bind(this, scrollState);
	    scrollState._onScroll = _onScroll.bind(this, scrollState);
	
	    window.addEventListener("resize", scrollState._onResize);
	    // check in case we're already at the extreme and the indicator is visible
	    (scrollState.scrollParents || []).forEach(function (scrollParent, idx) {
	      scrollParent.addEventListener("scroll", scrollState._onScroll);
	
	      if (startIndicatorElement) {
	        var scrollElement = scrollParent === document ? scrollParent.scrollingElement : scrollParent;
	
	        var rect = startIndicatorElement.getBoundingClientRect();
	
	        //If not enough data to scroll we'll need to load more...
	        if (scrollElement.getBoundingClientRect().height + rect.bottom >= scrollElement.scrollHeight) {
	          scrollState.scrollTimer = setTimeout(onTop, SCROLL_MORE_INITIAL_DELAY);
	        } else if (!idx) {
	          //If we're scrolling we need to move the scrollbar down slightly so
	          // as to not trigger the onTop() until the user needs it.
	          //Only do this for the first scrolling parent
	          scrollState.scrollTimer = setTimeout(function () {
	            var updatedRect = startIndicatorElement.getBoundingClientRect();
	            scrollElement.scrollTop = updatedRect.bottom + 10;
	          }, SCROLL_MORE_INITIAL_DELAY);
	        }
	      }
	
	      if (scrollParent === document || scrollParent === document.body) {
	        if (endIndicatorElement) {
	          var _rect = endIndicatorElement.getBoundingClientRect();
	          if (_rect.top < window.innerHeight) {
	            scrollState.scrollTimer = setTimeout(onEnd, SCROLL_MORE_INITIAL_DELAY);
	          }
	        }
	      }
	    });
	    return scrollState;
	  },
	  stopListeningForScroll: function stopListeningForScroll(scrollState) {
	    (scrollState.scrollParents || []).forEach(function (scrollParent) {
	      clearTimeout(scrollState.scrollTimer);
	      scrollParent.removeEventListener("scroll", scrollState._onScroll);
	      window.removeEventListener("resize", scrollState._onResize);
	    });
	    scrollState.scrollParents = undefined;
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	exports.setLocale = setLocale;
	exports.getCurrentLocale = getCurrentLocale;
	exports.getLocaleData = getLocaleData;
	
	var _Cookies = __webpack_require__(542);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentLocale = 'en-US';
	
	function normalizeLocale(locale) {
	  var locales = locale.replace(/_/g, '-').split('-');
	  var normalizedLocale = locales[0];
	  if (locales.length > 1) {
	    normalizedLocale += '-' + locales[1].toUpperCase();
	  }
	
	  return normalizedLocale;
	}
	
	function setLocale(locale) {
	  currentLocale = normalizeLocale(locale);
	}
	
	function getCurrentLocale() {
	  try {
	    var cookieLanguages = _Cookies2.default.get('languages');
	    var locale = cookieLanguages ? JSON.parse(cookieLanguages)[0] : undefined;
	    if (!locale) {
	      locale = window.navigator.languages ? window.navigator.languages[0] : window.navigator.language || window.navigator.userLanguage;
	    }
	
	    return normalizeLocale(locale);
	  } catch (e) {
	    return currentLocale;
	  }
	}
	
	function getLocaleData() {
	  var appMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentLocale();
	
	  var grommetMessages = void 0;
	  try {
	    grommetMessages = __webpack_require__(541)("./" + locale);
	  } catch (e) {
	    grommetMessages = {};
	  }
	
	  var messages = _extends({}, grommetMessages, appMessages);
	
	  return { locale: locale, messages: messages };
	}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	/*
	 * Scroll provides smooth scrolling.
	 */
	
	var SCROLL_STEPS = 25;
	
	function easeInOutQuad(t) {
	  return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	}
	
	exports.default = {
	
	  // component: component to scroll
	  // property: 'scrollTop' | 'scrollLeft'
	  // delta: amount to scroll
	  // doneHandler: optional function called when the scroll is done
	
	  scrollBy: function scrollBy(component, property, delta, doneHandler) {
	    var _this = this;
	
	    clearInterval(this._scrollToTimer);
	    var start = component[property];
	    var end = start + delta;
	    var step = 1;
	    this._scrollToTimer = setInterval(function () {
	      var current = component[property];
	      var next = void 0;
	      var easing = easeInOutQuad(step / SCROLL_STEPS);
	      if (end > start) {
	        next = Math.min(end, Math.max(current, Math.round(start + (end - start) * easing)));
	      } else {
	        next = Math.max(end, Math.min(current, Math.round(start - (start - end) * easing)));
	      }
	      component[property] = next;
	      step += 1;
	      if (step > SCROLL_STEPS) {
	        // we're done, but the browser/OS might still be easing from a
	        // mouse wheel interaction. So, set it one more time after a bit.
	        clearInterval(_this._scrollToTimer);
	        _this._scrollToTimer = setTimeout(function () {
	          component[property] = next;
	          if (doneHandler) {
	            doneHandler();
	          }
	        }, 200);
	      }
	    }, 8);
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2015 Hewlett Packard Enterprise Development LP
	
	// Functions to manage selection via both child index and a specific class name.
	
	// Ensures it is an array.
	function normalizeIndexes(selectedIndexes) {
	  var result = void 0;
	  if (undefined === selectedIndexes || null === selectedIndexes) {
	    result = [];
	  } else if (typeof selectedIndexes === 'number') {
	    result = [selectedIndexes];
	  } else {
	    result = selectedIndexes;
	  }
	  return result;
	}
	
	// Clears any selected items
	// options: {containerElement: , selectedClass: }
	function clearClass(options) {
	  if (options && options.containerElement) {
	    var items = options.containerElement.querySelectorAll("." + options.selectedClass);
	    for (var i = 0; i < items.length; i++) {
	      items[i].classList.remove(options.selectedClass);
	    }
	  }
	}
	
	// Sets the selectedClass on all children whose index is in selectedIndexes.
	// options: {containerElement: , childSelector: , selectedClass: ,
	//    selectedIndexes: []}
	function setClassFromIndexes(options) {
	  clearClass(options);
	  if (options && options.containerElement && options.selectedIndexes) {
	    var items = options.containerElement.querySelectorAll(options.childSelector);
	    options.selectedIndexes.forEach(function (index) {
	      if (items[index]) {
	        items[index].classList.add(options.selectedClass);
	      }
	    });
	  }
	}
	
	// Gets the selected selectedClass on all children whose index is in
	// selectedIndexes.
	// options: {containerElement: , childSelector: , selectedClass: }
	function getIndexesFromClass(options) {
	  var items = options.containerElement.querySelectorAll(options.childSelector);
	  var selectedIndexes = [];
	  for (var i = 0; i < items.length; i++) {
	    if (items[i].classList.contains(options.selectedClass)) {
	      selectedIndexes.push(i);
	    }
	  }
	  return selectedIndexes;
	}
	
	// Returns a new selectedIndexes array with the latest selected indexes
	// options: {containerElement: , childSelector: , //selectedClass: ,
	//   multiSelect: true|false, priorSelectedIndexes: []}
	function onClick(event, options) {
	
	  // Go up the DOM tree until we match the childSelector
	  var item = event.target;
	  var matchFunction = item.matches || item.matchesElement || item.msMatchesSelector;
	  while (matchFunction && item && !matchFunction.bind(item, options.childSelector)()) {
	    item = item.parentNode;
	    matchFunction = item.matches || item.matchesElement || item.msMatchesSelector;
	  }
	
	  // determine the index of the clicked element
	  var indexInContainer = 0;
	  var previousItem = item.previousSibling;
	  while (previousItem != null) {
	    previousItem = previousItem.previousSibling;
	    indexInContainer += 1;
	  }
	
	  var selectedIndexes = void 0; // what will be returned
	
	  if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
	
	    selectedIndexes = [indexInContainer];
	  } else {
	    // was it selected?
	    var indexInPrior = options.priorSelectedIndexes.indexOf(indexInContainer);
	
	    if (!options.multiSelect) {
	
	      if (-1 !== indexInPrior && (event.ctrlKey || event.metaKey)) {
	        selectedIndexes = [];
	      } else {
	        selectedIndexes = options.priorSelectedIndexes;
	      }
	    } else {
	      // multi-select
	
	      // make a copy of the prior list so we can modify it
	      selectedIndexes = options.priorSelectedIndexes.slice(0);
	
	      if (event.shiftKey) {
	
	        // select from nearest selected item to the currently selected item
	        var closestIndex = -1;
	        selectedIndexes.forEach(function (selectIndex, arrayIndex) {
	          if (-1 === closestIndex) {
	            closestIndex = selectIndex;
	          } else if (Math.abs(indexInContainer - selectIndex) < Math.abs(indexInContainer - closestIndex)) {
	            closestIndex = selectIndex;
	          }
	        });
	
	        for (var i = indexInContainer; i !== closestIndex;) {
	          selectedIndexes.push(i);
	          if (closestIndex < indexInContainer) {
	            i -= 1;
	          } else {
	            i += 1;
	          }
	        }
	
	        if (indexInPrior > -1) {
	          selectedIndexes.splice(indexInPrior, 1);
	        }
	
	        // Remove text selection. This often happens when shift multi-selecting
	        window.getSelection().removeAllRanges();
	      } else {
	        // toggle
	        if (-1 === indexInPrior) {
	          selectedIndexes.push(indexInContainer);
	        } else {
	          selectedIndexes.splice(indexInPrior, 1);
	        }
	      }
	    }
	  }
	
	  return selectedIndexes;
	}
	
	exports.default = {
	  normalizeIndexes: normalizeIndexes,
	  clearClass: clearClass,
	  getIndexesFromClass: getIndexesFromClass,
	  setClassFromIndexes: setClassFromIndexes,
	  onClick: onClick
	};
	module.exports = exports["default"];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(60);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(138);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(587);
	
	var _runTransitionHook = __webpack_require__(138);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(72);
	
	var _PathUtils = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(561)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(825);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(581);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '1',
	            '2': '2',
	            '3': '3',
	            '4': '4',
	            '5': '5',
	            '6': '6',
	            '7': '7',
	            '8': '8',
	            '9': '9',
	            '0': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'birneçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '১',
	            '2': '২',
	            '3': '৩',
	            '4': '৪',
	            '5': '৫',
	            '6': '৬',
	            '7': '৭',
	            '8': '৮',
	            '9': '৯',
	            '0': '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '༡',
	            '2': '༢',
	            '3': '༣',
	            '4': '༤',
	            '5': '༥',
	            '6': '༦',
	            '7': '༧',
	            '8': '༨',
	            '9': '༩',
	            '0': '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha invalida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '۱',
	            '2': '۲',
	            '3': '۳',
	            '4': '۴',
	            '5': '۵',
	            '6': '۶',
	            '7': '۷',
	            '8': '۸',
	            '9': '۹',
	            '0': '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split(
	            '_'
	        ),
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '១',
	            '2': '២',
	            '3': '៣',
	            '4': '៤',
	            '5': '៥',
	            '6': '៦',
	            '7': '៧',
	            '8': '៨',
	            '9': '៩',
	            '0': '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '೧',
	            '2': '೨',
	            '3': '೩',
	            '4': '೪',
	            '5': '೫',
	            '6': '೬',
	            '7': '೭',
	            '8': '೮',
	            '9': '೯',
	            '0': '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '၁',
	            '2': '၂',
	            '3': '၃',
	            '4': '၄',
	            '5': '၅',
	            '6': '၆',
	            '7': '၇',
	            '8': '၈',
	            '9': '၉',
	            '0': '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '੧',
	            '2': '੨',
	            '3': '੩',
	            '4': '੪',
	            '5': '੫',
	            '6': '੬',
	            '7': '੭',
	            '8': '੮',
	            '9': '੯',
	            '0': '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        );
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return (
	                    '(' +
	                    monthsSubjective[momentToFormat.month()] +
	                    '|' +
	                    monthsNominative[momentToFormat.month()] +
	                    ')'
	                );
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '௧',
	            '2': '௨',
	            '3': '௩',
	            '4': '௪',
	            '5': '௫',
	            '6': '௬',
	            '7': '௭',
	            '8': '௮',
	            '9': '௯',
	            '0': '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Пагоҳ соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [trk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js language configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = Point;
	
	function Point(x, y) {
	    this.x = x;
	    this.y = y;
	}
	
	Point.prototype = {
	    clone: function() { return new Point(this.x, this.y); },
	
	    add:     function(p) { return this.clone()._add(p);     },
	    sub:     function(p) { return this.clone()._sub(p);     },
	    mult:    function(k) { return this.clone()._mult(k);    },
	    div:     function(k) { return this.clone()._div(k);     },
	    rotate:  function(a) { return this.clone()._rotate(a);  },
	    matMult: function(m) { return this.clone()._matMult(m); },
	    unit:    function() { return this.clone()._unit(); },
	    perp:    function() { return this.clone()._perp(); },
	    round:   function() { return this.clone()._round(); },
	
	    mag: function() {
	        return Math.sqrt(this.x * this.x + this.y * this.y);
	    },
	
	    equals: function(p) {
	        return this.x === p.x &&
	               this.y === p.y;
	    },
	
	    dist: function(p) {
	        return Math.sqrt(this.distSqr(p));
	    },
	
	    distSqr: function(p) {
	        var dx = p.x - this.x,
	            dy = p.y - this.y;
	        return dx * dx + dy * dy;
	    },
	
	    angle: function() {
	        return Math.atan2(this.y, this.x);
	    },
	
	    angleTo: function(b) {
	        return Math.atan2(this.y - b.y, this.x - b.x);
	    },
	
	    angleWith: function(b) {
	        return this.angleWithSep(b.x, b.y);
	    },
	
	    // Find the angle of the two vectors, solving the formula for the cross product a x b = |a||b|sin(θ) for θ.
	    angleWithSep: function(x, y) {
	        return Math.atan2(
	            this.x * y - this.y * x,
	            this.x * x + this.y * y);
	    },
	
	    _matMult: function(m) {
	        var x = m[0] * this.x + m[1] * this.y,
	            y = m[2] * this.x + m[3] * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _add: function(p) {
	        this.x += p.x;
	        this.y += p.y;
	        return this;
	    },
	
	    _sub: function(p) {
	        this.x -= p.x;
	        this.y -= p.y;
	        return this;
	    },
	
	    _mult: function(k) {
	        this.x *= k;
	        this.y *= k;
	        return this;
	    },
	
	    _div: function(k) {
	        this.x /= k;
	        this.y /= k;
	        return this;
	    },
	
	    _unit: function() {
	        this._div(this.mag());
	        return this;
	    },
	
	    _perp: function() {
	        var y = this.y;
	        this.y = this.x;
	        this.x = -y;
	        return this;
	    },
	
	    _rotate: function(angle) {
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle),
	            x = cos * this.x - sin * this.y,
	            y = sin * this.x + cos * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _round: function() {
	        this.x = Math.round(this.x);
	        this.y = Math.round(this.y);
	        return this;
	    }
	};
	
	// constructs Point from an array if necessary
	Point.convert = function (a) {
	    if (a instanceof Point) {
	        return a;
	    }
	    if (Array.isArray(a)) {
	        return new Point(a[0], a[1]);
	    }
	    return a;
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(586);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = docPropType;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getArgs(args) {
	  return args.map(function (arg) {
	    if (arg.type && _propTypes2.default[arg.type]) {
	      if (arg.args) {
	        if (arg.type === 'shape') {
	          return buildShapePropType(arg);
	        }
	        return _propTypes2.default[arg.type](arg.args);
	      }
	      return _propTypes2.default[arg.type];
	    }
	    return arg;
	  });
	}
	
	function getPropType(validate) {
	  return _propTypes2.default[validate.type](validate.args.type && _propTypes2.default[validate.args.type] ? _propTypes2.default[validate.args.type] : validate.args);
	}
	
	// function to recursively build the proptype for shape
	function buildShapePropType(validate) {
	  var args = {};
	  Object.keys(validate.args).forEach(function (arg) {
	    var element = validate.args[arg];
	    if (element.type && _propTypes2.default[element.type]) {
	      if (element.args) {
	        if (element.type === 'oneOfType') {
	          var elementArgs = getArgs(element.args);
	          args[arg] = _propTypes2.default[element.type](elementArgs);
	        } else if (element.type === 'shape') {
	          args[arg] = buildShapePropType(element);
	        } else {
	          args[arg] = getPropType(element);
	        }
	      } else {
	        args[arg] = _propTypes2.default[element.type];
	      }
	    } else if (element.type) {
	      throw new Error('docPropType: unknown type ' + element.type);
	    }
	  });
	
	  return _propTypes2.default[validate.type](args);
	}
	
	function docPropType(validate, description) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!description) {
	    throw new Error('docPropType: description is required');
	  }
	  if (!validate) {
	    throw new Error('docPropType: validate is required');
	  }
	
	  var required = options.required;
	
	  var type = validate;
	  if (validate.type && _propTypes2.default[validate.type]) {
	    if (validate.args) {
	      if (validate.type === 'oneOfType') {
	        var args = getArgs(validate.args);
	        type = _propTypes2.default[validate.type](args);
	      } else if (validate.type === 'shape') {
	        type = buildShapePropType(validate);
	      } else if (validate.type === 'arrayOf' && validate.args.type === 'oneOfType') {
	        var _args = getArgs(validate.args.args);
	        var v = _extends({}, validate);
	        v.args = _propTypes2.default[validate.args.type](_args);
	        type = getPropType(v);
	      } else {
	        type = getPropType(validate);
	      }
	    } else {
	      type = _propTypes2.default[validate.type];
	    }
	  } else if (validate.type) {
	    throw new Error('docPropType: unknown type ' + validate.type);
	  }
	  // clone function
	  var propType = type.bind(null);
	  if (type.isRequired) {
	    propType.isRequired = type.isRequired.bind(null);
	  }
	  if (required && propType.isRequired) {
	    propType = propType.isRequired;
	  }
	  propType.$$reactDesc = { description: description, validate: validate, options: options };
	  return propType;
	}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDocAsJSON;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function buildShapeFormat(validate) {
	  var format = {};
	  Object.keys(validate.args).forEach(function (arg) {
	    var element = validate.args[arg];
	    if (element.type === 'shape') {
	      format[arg] = buildShapeFormat(element, true);
	    } else {
	      format[arg] = getFormat(element);
	    }
	  });
	  return format;
	}
	
	function getFormat(validate) {
	  switch (validate.type) {
	    case 'arrayOf':
	      return '[' + validate.args.type + ', ...]';
	    case 'bool':
	      return 'boolean';
	    case 'func':
	      return 'function';
	    case 'instanceOf':
	      return 'new ' + validate.args.name + '(...)';
	    case 'objectOf':
	      return '{ test: ' + validate.args.type + ', ... }';
	    case 'oneOf':
	      return validate.args;
	    case 'oneOfType':
	      return validate.args.map(function (arg) {
	        return getFormat(arg);
	      });
	    case 'shape':
	      return JSON.stringify(buildShapeFormat(validate));
	    default:
	      return validate.type ? validate.type : 'custom';
	  }
	}
	
	function getPropTypeAsJson(propType, propName, defaultValue) {
	  var _propType$$$reactDesc = propType.$$reactDesc.options,
	      deprecated = _propType$$$reactDesc.deprecated,
	      format = _propType$$$reactDesc.format,
	      required = _propType$$$reactDesc.required,
	      extras = _objectWithoutProperties(_propType$$$reactDesc, ['deprecated', 'format', 'required']);
	
	  var validate = propType.$$reactDesc.validate;
	
	  var documentation = {
	    description: propType.$$reactDesc.description,
	    name: propName
	  };
	
	  if (defaultValue) {
	    documentation.defaultValue = defaultValue;
	  }
	
	  if (deprecated) {
	    documentation.deprecated = deprecated;
	  }
	
	  if (required) {
	    documentation.required = required;
	  }
	
	  if (Object.keys(extras).length > 0) {
	    documentation.extras = extras;
	  }
	
	  documentation.format = format || getFormat(validate);
	
	  return documentation;
	}
	
	function getDocAsJSON(component) {
	  if (!component) {
	    throw new Error('getDocAsJSON: component is required');
	  }
	
	  var documentation = {
	    name: component.displayName || component.name
	  };
	  if (component.$$reactDesc) {
	    Object.assign(documentation, component.$$reactDesc);
	
	    if (component.propTypes) {
	      var propTypes = [];
	      Object.keys(component.propTypes).forEach(function (propName) {
	        var propType = component.propTypes[propName];
	        if (propType.$$reactDesc) {
	          propTypes.push(getPropTypeAsJson(propType, propName, (component.defaultProps || {})[propName]));
	        }
	      });
	      if (propTypes.length > 0) {
	        documentation.properties = propTypes;
	      }
	    }
	  }
	  return documentation;
	}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(64);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(74);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstrumentation = __webpack_require__(36);
	
	var quoteAttributeValueForBrowser = __webpack_require__(653);
	var warning = __webpack_require__(15);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var LinkedValueUtils = __webpack_require__(146);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(613);
	
	var containsNode = __webpack_require__(466);
	var focusNode = __webpack_require__(181);
	var getActiveElement = __webpack_require__(182);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(73);
	var DOMProperty = __webpack_require__(74);
	var React = __webpack_require__(79);
	var ReactBrowserEventEmitter = __webpack_require__(107);
	var ReactCurrentOwner = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMContainerInfo = __webpack_require__(607);
	var ReactDOMFeatureFlags = __webpack_require__(609);
	var ReactFeatureFlags = __webpack_require__(367);
	var ReactInstanceMap = __webpack_require__(91);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactMarkupChecksum = __webpack_require__(623);
	var ReactReconciler = __webpack_require__(75);
	var ReactUpdateQueue = __webpack_require__(149);
	var ReactUpdates = __webpack_require__(42);
	
	var emptyObject = __webpack_require__(101);
	var instantiateReactComponent = __webpack_require__(378);
	var invariant = __webpack_require__(9);
	var setInnerHTML = __webpack_require__(111);
	var shouldUpdateReactComponent = __webpack_require__(155);
	var warning = __webpack_require__(15);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var React = __webpack_require__(79);
	
	var invariant = __webpack_require__(9);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(371);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(18);
	
	var ReactCompositeComponent = __webpack_require__(604);
	var ReactEmptyComponent = __webpack_require__(366);
	var ReactHostComponent = __webpack_require__(368);
	
	var getNextDebugID = __webpack_require__(802);
	var invariant = __webpack_require__(9);
	var warning = __webpack_require__(15);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	var escapeTextContentForBrowser = __webpack_require__(110);
	var setInnerHTML = __webpack_require__(111);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(51);
	var REACT_ELEMENT_TYPE = __webpack_require__(619);
	
	var getIteratorFn = __webpack_require__(650);
	var invariant = __webpack_require__(9);
	var KeyEscapeUtils = __webpack_require__(145);
	var warning = __webpack_require__(15);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(219);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(669);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(385);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(139);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(158);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(161);
	
	var _ContextUtils = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _PatternUtils = __webpack_require__(76);
	
	var _InternalPropTypes = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(218);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(217);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(551);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(393);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(77);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(679);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(676);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(683);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(680);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(685);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(218);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(217);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Scale = __webpack_require__(83);
	
	var _PureComponent2 = __webpack_require__(167);
	
	var _PureComponent3 = _interopRequireDefault(_PureComponent2);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chart = function (_PureComponent) {
		_inherits(Chart, _PureComponent);
	
		function Chart(props, context) {
			_classCallCheck(this, Chart);
	
			var _this = _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this, props, context));
	
			_this.yScale = _this.yScale.bind(_this);
			_this.listener = _this.listener.bind(_this);
			return _this;
		}
	
		_createClass(Chart, [{
			key: "componentWillMount",
			value: function componentWillMount() {
				var id = this.props.id;
				var subscribe = this.context.subscribe;
	
				subscribe("chart_" + id, {
					listener: this.listener
				});
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				var id = this.props.id;
				var unsubscribe = this.context.unsubscribe;
	
				unsubscribe("chart_" + id);
			}
		}, {
			key: "listener",
			value: function listener(type, moreProps, state, e) {
				var _props = this.props,
				    id = _props.id,
				    onContextMenu = _props.onContextMenu;
	
	
				if (type === "contextmenu") {
					var currentCharts = moreProps.currentCharts;
	
					if (currentCharts.indexOf(id) > -1) {
						onContextMenu(moreProps, e);
					}
				}
			}
		}, {
			key: "yScale",
			value: function yScale() {
				var _this2 = this;
	
				var chartConfig = (0, _utils.find)(this.context.chartConfig, function (each) {
					return each.id === _this2.props.id;
				});
				return chartConfig.yScale.copy();
			}
		}, {
			key: "getChildContext",
			value: function getChildContext() {
				var chartId = this.props.id;
	
				var chartConfig = (0, _utils.find)(this.context.chartConfig, function (each) {
					return each.id === chartId;
				});
	
				return {
					chartId: chartId,
					chartConfig: chartConfig
				};
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				var _find = (0, _utils.find)(this.context.chartConfig, function (each) {
					return each.id === _this3.props.id;
				}),
				    origin = _find.origin;
	
				var _origin = _slicedToArray(origin, 2),
				    x = _origin[0],
				    y = _origin[1];
	
				return _react2.default.createElement(
					"g",
					{ transform: "translate(" + x + ", " + y + ")" },
					this.props.children
				);
			}
		}]);
	
		return Chart;
	}(_PureComponent3.default);
	
	Chart.propTypes = {
		height: _propTypes2.default.number,
		origin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]),
		id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
		yExtents: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]),
		yExtentsCalculator: function yExtentsCalculator(props, propName, componentName) {
			if ((0, _utils.isNotDefined)(props.yExtents) && typeof props.yExtentsCalculator !== "function") return new Error("yExtents or yExtentsCalculator must" + (" be present on " + componentName + ". Validation failed."));
		},
		onContextMenu: _propTypes2.default.func,
		yScale: _propTypes2.default.func,
	
		flipYScale: _propTypes2.default.bool,
		padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
			top: _propTypes2.default.number,
			bottom: _propTypes2.default.number
		})]),
		children: _propTypes2.default.node
	};
	
	Chart.defaultProps = {
		id: 0,
		origin: [0, 0],
		padding: 0,
		yScale: (0, _d3Scale.scaleLinear)(),
		flipYScale: false,
		yPan: true,
		yPanEnabled: false,
		onContextMenu: _utils.noop
	};
	
	Chart.contextTypes = {
		chartConfig: _propTypes2.default.array,
		subscribe: _propTypes2.default.func.isRequired,
		unsubscribe: _propTypes2.default.func.isRequired
	};
	
	Chart.childContextTypes = {
		chartConfig: _propTypes2.default.object.isRequired,
		chartId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired
	};
	
	exports.default = Chart;
	//# sourceMappingURL=Chart.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultProps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.helper = helper;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabelAnnotation = function (_Component) {
		_inherits(LabelAnnotation, _Component);
	
		function LabelAnnotation(props) {
			_classCallCheck(this, LabelAnnotation);
	
			var _this = _possibleConstructorReturn(this, (LabelAnnotation.__proto__ || Object.getPrototypeOf(LabelAnnotation)).call(this, props));
	
			_this.handleClick = _this.handleClick.bind(_this);
			return _this;
		}
	
		_createClass(LabelAnnotation, [{
			key: "handleClick",
			value: function handleClick(e) {
				var onClick = this.props.onClick;
	
	
				if (onClick) {
					var _props = this.props,
					    xScale = _props.xScale,
					    yScale = _props.yScale,
					    datum = _props.datum;
	
					onClick({ xScale: xScale, yScale: yScale, datum: datum }, e);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _props2 = this.props,
				    className = _props2.className,
				    textAnchor = _props2.textAnchor,
				    fontFamily = _props2.fontFamily,
				    fontSize = _props2.fontSize,
				    opacity = _props2.opacity,
				    rotate = _props2.rotate;
				var _props3 = this.props,
				    xAccessor = _props3.xAccessor,
				    xScale = _props3.xScale,
				    yScale = _props3.yScale;
	
				var _helper = helper(this.props, xAccessor, xScale, yScale),
				    xPos = _helper.xPos,
				    yPos = _helper.yPos,
				    fill = _helper.fill,
				    text = _helper.text,
				    tooltip = _helper.tooltip;
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					_react2.default.createElement(
						"title",
						null,
						tooltip
					),
					_react2.default.createElement(
						"text",
						{ x: xPos, y: yPos,
							fontFamily: fontFamily, fontSize: fontSize,
							fill: fill,
							opacity: opacity,
							transform: "rotate(" + rotate + ", " + xPos + ", " + yPos + ")",
							onClick: this.handleClick,
							textAnchor: textAnchor },
						text
					)
				);
			}
		}]);
	
		return LabelAnnotation;
	}(_react.Component);
	
	function helper(props, xAccessor, xScale, yScale) {
		var x = props.x,
		    y = props.y,
		    datum = props.datum,
		    fill = props.fill,
		    text = props.text,
		    tooltip = props.tooltip,
		    plotData = props.plotData;
	
	
		var xFunc = (0, _utils.functor)(x);
		var yFunc = (0, _utils.functor)(y);
	
		var _ref = [xFunc({ xScale: xScale, xAccessor: xAccessor, datum: datum, plotData: plotData }), yFunc({ yScale: yScale, datum: datum, plotData: plotData })],
		    xPos = _ref[0],
		    yPos = _ref[1];
	
	
		return {
			xPos: xPos,
			yPos: yPos,
			text: (0, _utils.functor)(text)(datum),
			fill: (0, _utils.functor)(fill)(datum),
			tooltip: (0, _utils.functor)(tooltip)(datum)
		};
	}
	
	LabelAnnotation.propTypes = {
		className: _propTypes2.default.string,
		text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
		textAnchor: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		opacity: _propTypes2.default.number,
		rotate: _propTypes2.default.number,
		onClick: _propTypes2.default.func,
		xAccessor: _propTypes2.default.func,
		xScale: _propTypes2.default.func,
		yScale: _propTypes2.default.func,
		datum: _propTypes2.default.object,
		x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func])
	};
	
	var defaultProps = exports.defaultProps = {
		textAnchor: "middle",
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 12,
		fill: "#000000",
		opacity: 1,
		rotate: 0,
		x: function x(_ref2) {
			var xScale = _ref2.xScale,
			    xAccessor = _ref2.xAccessor,
			    datum = _ref2.datum;
			return xScale(xAccessor(datum));
		}
	};
	
	LabelAnnotation.defaultProps = _extends({}, defaultProps, {
		className: "react-stockcharts-labelannotation"
	});
	
	exports.default = LabelAnnotation;
	//# sourceMappingURL=LabelAnnotation.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Force = __webpack_require__(457);
	
	var _d3Array = __webpack_require__(21);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _AxisZoomCapture = __webpack_require__(697);
	
	var _AxisZoomCapture2 = _interopRequireDefault(_AxisZoomCapture);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Axis = function (_Component) {
		_inherits(Axis, _Component);
	
		function Axis(props) {
			_classCallCheck(this, Axis);
	
			var _this = _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			_this.saveNode = _this.saveNode.bind(_this);
			_this.getMoreProps = _this.getMoreProps.bind(_this);
			return _this;
		}
	
		_createClass(Axis, [{
			key: "saveNode",
			value: function saveNode(node) {
				this.node = node;
			}
		}, {
			key: "getMoreProps",
			value: function getMoreProps() {
				return this.node.getMoreProps();
			}
		}, {
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var _props = this.props,
				    showDomain = _props.showDomain,
				    showTicks = _props.showTicks,
				    transform = _props.transform,
				    range = _props.range,
				    getScale = _props.getScale;
	
	
				ctx.save();
				ctx.translate(transform[0], transform[1]);
	
				if (showDomain) drawAxisLine(ctx, this.props, range);
				if (showTicks) {
					var tickProps = tickHelper(this.props, getScale(moreProps));
					drawTicks(ctx, tickProps);
				}
	
				ctx.restore();
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var className = this.props.className;
				var _props2 = this.props,
				    showDomain = _props2.showDomain,
				    showTicks = _props2.showTicks,
				    range = _props2.range,
				    getScale = _props2.getScale;
	
	
				var ticks = showTicks ? axisTicksSVG(this.props, getScale(moreProps)) : null;
				var domain = showDomain ? axisLineSVG(this.props, range) : null;
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					ticks,
					domain
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _props3 = this.props,
				    bg = _props3.bg,
				    axisZoomCallback = _props3.axisZoomCallback,
				    className = _props3.className,
				    zoomCursorClassName = _props3.zoomCursorClassName,
				    zoomEnabled = _props3.zoomEnabled,
				    getScale = _props3.getScale,
				    inverted = _props3.inverted;
				var _props4 = this.props,
				    transform = _props4.transform,
				    getMouseDelta = _props4.getMouseDelta,
				    edgeClip = _props4.edgeClip;
				var _props5 = this.props,
				    onContextMenu = _props5.onContextMenu,
				    onDoubleClick = _props5.onDoubleClick;
	
	
				var zoomCapture = zoomEnabled ? _react2.default.createElement(_AxisZoomCapture2.default, {
					bg: bg,
					getScale: getScale,
					getMoreProps: this.getMoreProps,
					getMouseDelta: getMouseDelta,
					axisZoomCallback: axisZoomCallback,
					className: className,
					zoomCursorClassName: zoomCursorClassName,
					inverted: inverted,
					onContextMenu: onContextMenu,
					onDoubleClick: onDoubleClick
				}) : null;
	
				return _react2.default.createElement(
					"g",
					{ transform: "translate(" + transform[0] + ", " + transform[1] + ")" },
					zoomCapture,
					_react2.default.createElement(_GenericChartComponent2.default, { ref: this.saveNode,
						canvasToDraw: _GenericComponent.getAxisCanvas,
						clip: false,
						edgeClip: edgeClip,
						svgDraw: this.renderSVG,
						canvasDraw: this.drawOnCanvas,
						drawOn: ["pan"]
					})
				);
			}
		}]);
	
		return Axis;
	}(_react.Component);
	
	Axis.propTypes = {
		innerTickSize: _propTypes2.default.number,
		outerTickSize: _propTypes2.default.number,
		tickFormat: _propTypes2.default.func,
		tickPadding: _propTypes2.default.number,
		tickSize: _propTypes2.default.number,
		ticks: _propTypes2.default.number,
		tickLabelFill: _propTypes2.default.string,
		tickStroke: _propTypes2.default.string,
		tickStrokeOpacity: _propTypes2.default.number,
		tickStrokeWidth: _propTypes2.default.number,
		tickStrokeDasharray: _propTypes2.default.oneOf(_utils.strokeDashTypes),
		tickValues: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]),
		tickInterval: _propTypes2.default.number,
		tickIntervalFunction: _propTypes2.default.func,
		showDomain: _propTypes2.default.bool,
		showTicks: _propTypes2.default.bool,
		className: _propTypes2.default.string,
		axisZoomCallback: _propTypes2.default.func,
		zoomEnabled: _propTypes2.default.bool,
		inverted: _propTypes2.default.bool,
		zoomCursorClassName: _propTypes2.default.string,
		transform: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
		range: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
		getMouseDelta: _propTypes2.default.func.isRequired,
		getScale: _propTypes2.default.func.isRequired,
		bg: _propTypes2.default.object.isRequired,
		edgeClip: _propTypes2.default.bool.isRequired,
		onContextMenu: _propTypes2.default.func,
		onDoubleClick: _propTypes2.default.func
	};
	
	Axis.defaultProps = {
		zoomEnabled: false,
		zoomCursorClassName: "",
		edgeClip: false
	};
	
	function tickHelper(props, scale) {
		var orient = props.orient,
		    innerTickSize = props.innerTickSize,
		    tickFormat = props.tickFormat,
		    tickPadding = props.tickPadding,
		    tickLabelFill = props.tickLabelFill,
		    tickStrokeWidth = props.tickStrokeWidth,
		    tickStrokeDasharray = props.tickStrokeDasharray,
		    fontSize = props.fontSize,
		    fontFamily = props.fontFamily,
		    fontWeight = props.fontWeight,
		    showTicks = props.showTicks,
		    flexTicks = props.flexTicks,
		    showTickLabel = props.showTickLabel;
		var tickArguments = props.ticks,
		    tickValuesProp = props.tickValues,
		    tickStroke = props.tickStroke,
		    tickStrokeOpacity = props.tickStrokeOpacity,
		    tickInterval = props.tickInterval,
		    tickIntervalFunction = props.tickIntervalFunction;
	
		// if (tickArguments) tickArguments = [tickArguments];
	
		var tickValues = void 0;
		if ((0, _utils.isDefined)(tickValuesProp)) {
			if (typeof tickValuesProp === "function") {
				tickValues = tickValuesProp(scale.domain());
			} else {
				tickValues = tickValuesProp;
			}
		} else if ((0, _utils.isDefined)(tickInterval)) {
			var _scale$domain = scale.domain(),
			    _scale$domain2 = _slicedToArray(_scale$domain, 2),
			    min = _scale$domain2[0],
			    max = _scale$domain2[1];
	
			var baseTickValues = (0, _d3Array.range)(min, max, (max - min) / tickInterval);
	
			tickValues = tickIntervalFunction ? tickIntervalFunction(min, max, tickInterval) : baseTickValues;
		} else if ((0, _utils.isDefined)(scale.ticks)) {
			tickValues = scale.ticks(tickArguments, flexTicks);
		} else {
			tickValues = scale.domain();
		}
	
		var baseFormat = scale.tickFormat ? scale.tickFormat(tickArguments) : _utils.identity;
	
		var format = (0, _utils.isNotDefined)(tickFormat) ? baseFormat : function (d) {
			return tickFormat(d) || "";
		};
	
		var sign = orient === "top" || orient === "left" ? -1 : 1;
		var tickSpacing = Math.max(innerTickSize, 0) + tickPadding;
	
		var ticks = void 0,
		    dy = void 0,
		    canvas_dy = void 0,
		    textAnchor = void 0;
	
		if (orient === "bottom" || orient === "top") {
			dy = sign < 0 ? "0em" : ".71em";
			canvas_dy = sign < 0 ? 0 : fontSize * .71;
			textAnchor = "middle";
	
			ticks = tickValues.map(function (d) {
				var x = Math.round(scale(d));
				return {
					value: d,
					x1: x,
					y1: 0,
					x2: x,
					y2: sign * innerTickSize,
					labelX: x,
					labelY: sign * tickSpacing
				};
			});
	
			if (showTicks && flexTicks) {
				// console.log(ticks, showTicks);
	
				var nodes = ticks.map(function (d) {
					return { id: d.value, value: d.value, fy: d.y2, origX: d.x1 };
				});
	
				var simulation = (0, _d3Force.forceSimulation)(nodes).force("x", (0, _d3Force.forceX)(function (d) {
					return d.origX;
				}).strength(1)).force("collide", (0, _d3Force.forceCollide)(22))
				// .force("center", forceCenter())
				.stop();
	
				for (var i = 0; i < 100; ++i) {
					simulation.tick();
				} // console.log(nodes);
	
				var zip = (0, _utils.zipper)().combine(function (a, b) {
					if (Math.abs(b.x - b.origX) > 0.01) {
						return _extends({}, a, {
							x2: b.x,
							labelX: b.x
						});
					}
					return a;
				});
	
				ticks = zip(ticks, nodes);
			}
		} else {
			ticks = tickValues.map(function (d) {
				var y = Math.round(scale(d));
				return {
					value: d,
					x1: 0,
					y1: y,
					x2: sign * innerTickSize,
					y2: y,
					labelX: sign * tickSpacing,
					labelY: y
				};
			});
	
			dy = ".32em";
			canvas_dy = fontSize * .32;
			textAnchor = sign < 0 ? "end" : "start";
		}
	
		return {
			ticks: ticks, scale: scale, tickStroke: tickStroke,
			tickLabelFill: tickLabelFill || tickStroke,
			tickStrokeOpacity: tickStrokeOpacity,
			tickStrokeWidth: tickStrokeWidth,
			tickStrokeDasharray: tickStrokeDasharray,
			dy: dy,
			canvas_dy: canvas_dy,
			textAnchor: textAnchor,
			fontSize: fontSize,
			fontFamily: fontFamily,
			fontWeight: fontWeight,
			format: format,
			showTickLabel: showTickLabel
		};
	}
	
	/* eslint-disable react/prop-types */
	function axisLineSVG(props, range) {
		var orient = props.orient,
		    outerTickSize = props.outerTickSize;
		var domainClassName = props.domainClassName,
		    fill = props.fill,
		    stroke = props.stroke,
		    strokeWidth = props.strokeWidth,
		    opacity = props.opacity;
	
	
		var sign = orient === "top" || orient === "left" ? -1 : 1;
	
		var d = void 0;
	
		if (orient === "bottom" || orient === "top") {
			d = "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize;
		} else {
			d = "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize;
		}
	
		return _react2.default.createElement("path", {
			className: domainClassName,
			d: d,
			fill: fill,
			opacity: opacity,
			stroke: stroke,
			strokeWidth: strokeWidth });
	}
	/* eslint-enable react/prop-types */
	
	function drawAxisLine(ctx, props, range) {
		// props = { ...AxisLine.defaultProps, ...props };
	
		var orient = props.orient,
		    outerTickSize = props.outerTickSize,
		    stroke = props.stroke,
		    strokeWidth = props.strokeWidth,
		    opacity = props.opacity;
	
	
		var sign = orient === "top" || orient === "left" ? -1 : 1;
		var xAxis = orient === "bottom" || orient === "top";
	
		// var range = d3_scaleRange(xAxis ? xScale : yScale);
	
		ctx.lineWidth = strokeWidth;
		ctx.strokeStyle = (0, _utils.hexToRGBA)(stroke, opacity);
	
		ctx.beginPath();
	
		if (xAxis) {
			ctx.moveTo((0, _utils.first)(range), sign * outerTickSize);
			ctx.lineTo((0, _utils.first)(range), 0);
			ctx.lineTo((0, _utils.last)(range), 0);
			ctx.lineTo((0, _utils.last)(range), sign * outerTickSize);
		} else {
			ctx.moveTo(sign * outerTickSize, (0, _utils.first)(range));
			ctx.lineTo(0, (0, _utils.first)(range));
			ctx.lineTo(0, (0, _utils.last)(range));
			ctx.lineTo(sign * outerTickSize, (0, _utils.last)(range));
		}
		ctx.stroke();
	}
	
	function Tick(props) {
		var tickLabelFill = props.tickLabelFill,
		    tickStroke = props.tickStroke,
		    tickStrokeOpacity = props.tickStrokeOpacity,
		    tickStrokeDasharray = props.tickStrokeDasharray,
		    tickStrokeWidth = props.tickStrokeWidth,
		    textAnchor = props.textAnchor,
		    fontSize = props.fontSize,
		    fontFamily = props.fontFamily,
		    fontWeight = props.fontWeight;
		var x1 = props.x1,
		    y1 = props.y1,
		    x2 = props.x2,
		    y2 = props.y2,
		    labelX = props.labelX,
		    labelY = props.labelY,
		    dy = props.dy;
	
		return _react2.default.createElement(
			"g",
			{ className: "tick" },
			_react2.default.createElement("line", {
				shapeRendering: "crispEdges",
				opacity: tickStrokeOpacity,
				stroke: tickStroke,
				strokeWidth: tickStrokeWidth,
				strokeDasharray: (0, _utils.getStrokeDasharray)(tickStrokeDasharray),
				x1: x1, y1: y1,
				x2: x2, y2: y2 }),
			_react2.default.createElement(
				"text",
				{
					dy: dy, x: labelX, y: labelY,
					fill: tickLabelFill,
					fontSize: fontSize,
					fontWeight: fontWeight,
					fontFamily: fontFamily,
					textAnchor: textAnchor },
				props.children
			)
		);
	}
	
	Tick.propTypes = {
		children: _propTypes2.default.string.isRequired,
		x1: _propTypes2.default.number.isRequired,
		y1: _propTypes2.default.number.isRequired,
		x2: _propTypes2.default.number.isRequired,
		y2: _propTypes2.default.number.isRequired,
		labelX: _propTypes2.default.number.isRequired,
		labelY: _propTypes2.default.number.isRequired,
		dy: _propTypes2.default.string.isRequired,
		tickStroke: _propTypes2.default.string,
		tickLabelFill: _propTypes2.default.string,
		tickStrokeWidth: _propTypes2.default.number,
		tickStrokeOpacity: _propTypes2.default.number,
		tickStrokeDasharray: _propTypes2.default.oneOf(_utils.strokeDashTypes),
		textAnchor: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		fontFamily: _propTypes2.default.string,
		fontWeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	function axisTicksSVG(props, scale) {
		var result = tickHelper(props, scale);
	
		var tickLabelFill = result.tickLabelFill,
		    tickStroke = result.tickStroke,
		    tickStrokeOpacity = result.tickStrokeOpacity,
		    tickStrokeWidth = result.tickStrokeWidth,
		    tickStrokeDasharray = result.tickStrokeDasharray,
		    textAnchor = result.textAnchor;
		var fontSize = result.fontSize,
		    fontFamily = result.fontFamily,
		    fontWeight = result.fontWeight,
		    ticks = result.ticks,
		    format = result.format;
		var dy = result.dy;
	
	
		return _react2.default.createElement(
			"g",
			null,
			ticks.map(function (tick, idx) {
				return _react2.default.createElement(
					Tick,
					{ key: idx,
						tickStroke: tickStroke,
						tickLabelFill: tickLabelFill,
						tickStrokeWidth: tickStrokeWidth,
						tickStrokeOpacity: tickStrokeOpacity,
						tickStrokeDasharray: tickStrokeDasharray,
						dy: dy,
						x1: tick.x1, y1: tick.y1,
						x2: tick.x2, y2: tick.y2,
						labelX: tick.labelX, labelY: tick.labelY,
						textAnchor: textAnchor,
						fontSize: fontSize,
						fontWeight: fontWeight,
						fontFamily: fontFamily },
					format(tick.value)
				);
			})
		);
	}
	
	function drawTicks(ctx, result) {
		var tickStroke = result.tickStroke,
		    tickStrokeOpacity = result.tickStrokeOpacity,
		    tickLabelFill = result.tickLabelFill;
		var textAnchor = result.textAnchor,
		    fontSize = result.fontSize,
		    fontFamily = result.fontFamily,
		    fontWeight = result.fontWeight,
		    ticks = result.ticks,
		    showTickLabel = result.showTickLabel;
	
	
		ctx.strokeStyle = (0, _utils.hexToRGBA)(tickStroke, tickStrokeOpacity);
	
		ctx.fillStyle = tickStroke;
		// ctx.textBaseline = 'middle';
	
		ticks.forEach(function (tick) {
			drawEachTick(ctx, tick, result);
		});
	
		ctx.font = fontWeight + " " + fontSize + "px " + fontFamily;
		ctx.fillStyle = tickLabelFill;
		ctx.textAlign = textAnchor === "middle" ? "center" : textAnchor;
	
		if (showTickLabel) {
			ticks.forEach(function (tick) {
				drawEachTickLabel(ctx, tick, result);
			});
		}
	}
	
	function drawEachTick(ctx, tick, result) {
		var tickStrokeWidth = result.tickStrokeWidth,
		    tickStrokeDasharray = result.tickStrokeDasharray;
	
	
		ctx.beginPath();
	
		ctx.moveTo(tick.x1, tick.y1);
		ctx.lineTo(tick.x2, tick.y2);
		ctx.lineWidth = tickStrokeWidth;
		ctx.setLineDash((0, _utils.getStrokeDasharray)(tickStrokeDasharray).split(","));
		ctx.stroke();
	}
	
	function drawEachTickLabel(ctx, tick, result) {
		var canvas_dy = result.canvas_dy,
		    format = result.format;
	
	
		ctx.beginPath();
		ctx.fillText(format(tick.value), tick.labelX, tick.labelY + canvas_dy);
	}
	
	exports.default = Axis;
	//# sourceMappingURL=Axis.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.ForceIndex;
	
		function calculator(data) {
			var _options = options,
			    sourcePath = _options.sourcePath,
			    volumePath = _options.volumePath;
	
	
			var source = (0, _utils.path)(sourcePath);
			var volume = (0, _utils.path)(volumePath);
	
			var forceIndexCalulator = (0, _utils.slidingWindow)().windowSize(2).accumulator(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    prev = _ref2[0],
				    curr = _ref2[1];
	
				return (source(curr) - source(prev)) * volume(curr);
			});
	
			var forceIndex = forceIndexCalulator(data);
	
			return forceIndex;
		}
		calculator.undefinedLength = function () {
			return 2;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.ForceIndex, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=forceIndex.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.SMA;
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize,
			    sourcePath = _options.sourcePath;
	
	
			var average = (0, _utils.slidingWindow)().windowSize(windowSize).sourcePath(sourcePath).accumulator(function (values) {
				return (0, _d3Array.mean)(values);
			});
	
			return average(data);
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize;
	
			return windowSize - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.SMA, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _d3Array = __webpack_require__(21);
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=sma.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = financeDiscontinuousScale;
	
	var _d3Collection = __webpack_require__(38);
	
	var _d3Array = __webpack_require__(21);
	
	var _d3Scale = __webpack_require__(83);
	
	var _utils = __webpack_require__(4);
	
	var _levels = __webpack_require__(400);
	
	var MAX_LEVEL = _levels.levelDefinition.length - 1;
	
	function financeDiscontinuousScale(index, futureProvider) {
		var backingLinearScale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _d3Scale.scaleLinear)();
	
	
		if ((0, _utils.isNotDefined)(index)) throw new Error("Use the discontinuousTimeScaleProvider to create financeDiscontinuousScale");
	
		function scale(x) {
			return backingLinearScale(x);
		}
		scale.invert = function (x) {
			var inverted = backingLinearScale.invert(x);
			return Math.round(inverted * 10000) / 10000;
		};
		scale.domain = function (x) {
			if (!arguments.length) return backingLinearScale.domain();
			backingLinearScale.domain(x);
			return scale;
		};
		scale.range = function (x) {
			if (!arguments.length) return backingLinearScale.range();
			backingLinearScale.range(x);
			return scale;
		};
		scale.rangeRound = function (x) {
			return backingLinearScale.range(x);
		};
		scale.clamp = function (x) {
			if (!arguments.length) return backingLinearScale.clamp();
			backingLinearScale.clamp(x);
			return scale;
		};
		scale.interpolate = function (x) {
			if (!arguments.length) return backingLinearScale.interpolate();
			backingLinearScale.interpolate(x);
			return scale;
		};
		scale.ticks = function (m, flexTicks) {
			var backingTicks = backingLinearScale.ticks(m);
			var ticksMap = (0, _d3Collection.map)();
	
			var _backingLinearScale$d = backingLinearScale.domain(),
			    _backingLinearScale$d2 = _slicedToArray(_backingLinearScale$d, 2),
			    domainStart = _backingLinearScale$d2[0],
			    domainEnd = _backingLinearScale$d2[1];
	
			var start = Math.max(Math.ceil(domainStart), (0, _utils.head)(index).index) + Math.abs((0, _utils.head)(index).index);
			var end = Math.min(Math.floor(domainEnd), (0, _utils.last)(index).index) + Math.abs((0, _utils.head)(index).index);
	
			if (Math.floor(domainEnd) > end) {
				// console.log(end, domainEnd, index);
			}
	
			var desiredTickCount = Math.ceil((end - start) / (domainEnd - domainStart) * backingTicks.length);
	
			for (var i = MAX_LEVEL; i >= 0; i--) {
				var ticksAtLevel = ticksMap.get(i);
				var temp = (0, _utils.isNotDefined)(ticksAtLevel) ? [] : ticksAtLevel.slice();
	
				for (var j = start; j <= end; j++) {
					if (index[j].level === i) {
						temp.push(index[j]);
					}
				}
	
				ticksMap.set(i, temp);
			}
	
			var unsortedTicks = [];
			for (var _i = MAX_LEVEL; _i >= 0; _i--) {
				if (ticksMap.get(_i).length + unsortedTicks.length > desiredTickCount * 1.5) break;
				unsortedTicks = unsortedTicks.concat(ticksMap.get(_i).map(function (d) {
					return d.index;
				}));
			}
	
			var ticks = unsortedTicks.sort(_d3Array.ascending);
	
			// console.log(backingTicks.length, desiredTickCount, ticks, ticksMap);
	
			if (!flexTicks && end - start > ticks.length) {
				var ticksSet = (0, _d3Collection.set)(ticks);
	
				var d = Math.abs((0, _utils.head)(index).index);
	
				// ignore ticks within this distance
				var distance = Math.ceil((backingTicks.length > 0 ? ((0, _utils.last)(backingTicks) - (0, _utils.head)(backingTicks)) / backingTicks.length / 4 : 1) * 1.5);
	
				for (var _i2 = 0; _i2 < ticks.length - 1; _i2++) {
					for (var _j = _i2 + 1; _j < ticks.length; _j++) {
						if (ticks[_j] - ticks[_i2] <= distance) {
							ticksSet.remove(index[ticks[_i2] + d].level >= index[ticks[_j] + d].level ? ticks[_j] : ticks[_i2]);
						}
					}
				}
	
				var tickValues = ticksSet.values().map(function (d) {
					return parseInt(d, 10);
				});
	
				// console.log(ticks.length, tickValues, level);
				// console.log(ticks, tickValues, distance);
	
				return tickValues;
			}
	
			return ticks;
		};
		scale.tickFormat = function () {
			return function (x) {
				var d = Math.abs((0, _utils.head)(index).index);
				var _index$Math$floor = index[Math.floor(x + d)],
				    format = _index$Math$floor.format,
				    date = _index$Math$floor.date;
	
				return format(date);
			};
		};
		scale.value = function (x) {
			var d = Math.abs((0, _utils.head)(index).index);
			if ((0, _utils.isDefined)(index[Math.floor(x + d)])) {
				var date = index[Math.floor(x + d)].date;
	
				return date;
			}
		};
		scale.nice = function (m) {
			backingLinearScale.nice(m);
			return scale;
		};
		scale.index = function (x) {
			if (!arguments.length) return index;
			index = x;
			return scale;
		};
		scale.copy = function () {
			return financeDiscontinuousScale(index, futureProvider, backingLinearScale.copy());
		};
		return scale;
	}
	//# sourceMappingURL=financeDiscontinuousScale.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var defaultFormatters = exports.defaultFormatters = {
		yearFormat: "%Y",
		quarterFormat: "%b %Y",
		monthFormat: "%b",
		weekFormat: "%d %b",
		dayFormat: "%a %d",
		hourFormat: "%_I %p",
		minuteFormat: "%I:%M %p",
		secondFormat: "%I:%M:%S %p",
		milliSecondFormat: "%L"
	};
	
	var levelDefinition = exports.levelDefinition = [
	/* eslint-disable no-unused-vars */
	/* 19 */function (d, date, i) {
		return d.startOfYear && date.getFullYear() % 12 === 0 && "yearFormat";
	},
	/* 18 */function (d, date, i) {
		return d.startOfYear && date.getFullYear() % 4 === 0 && "yearFormat";
	},
	/* 17 */function (d, date, i) {
		return d.startOfYear && date.getFullYear() % 2 === 0 && "yearFormat";
	},
	/* 16 */function (d, date, i) {
		return d.startOfYear && "yearFormat";
	},
	/* 15 */function (d, date, i) {
		return d.startOfQuarter && "quarterFormat";
	},
	/* 14 */function (d, date, i) {
		return d.startOfMonth && "monthFormat";
	},
	/* 13 */function (d, date, i) {
		return d.startOfWeek && "weekFormat";
	},
	/* 12 */function (d, date, i) {
		return d.startOfDay && i % 2 === 0 && "dayFormat";
	},
	/* 11 */function (d, date, i) {
		return d.startOfDay && "dayFormat";
	},
	/* 10 */function (d, date, i) {
		return d.startOfHalfDay && "hourFormat";
	}, // 12h
	/*  9 */function (d, date, i) {
		return d.startOfQuarterDay && "hourFormat";
	}, // 6h
	/*  8 */function (d, date, i) {
		return d.startOfEighthOfADay && "hourFormat";
	}, // 3h
	/*  7 */function (d, date, i) {
		return d.startOfHour && date.getHours() % 2 === 0 && "hourFormat";
	}, // 2h -- REMOVE THIS
	/*  6 */function (d, date, i) {
		return d.startOfHour && "hourFormat";
	}, // 1h
	/*  5 */function (d, date, i) {
		return d.startOf30Minutes && "minuteFormat";
	},
	/*  4 */function (d, date, i) {
		return d.startOf15Minutes && "minuteFormat";
	},
	/*  3 */function (d, date, i) {
		return d.startOf5Minutes && "minuteFormat";
	},
	/*  2 */function (d, date, i) {
		return d.startOfMinute && "minuteFormat";
	},
	/*  1 */function (d, date, i) {
		return d.startOf30Seconds && "secondFormat";
	},
	/*  0 */function (d, date, i) {
		return "secondFormat";
	}];
	//# sourceMappingURL=levels.js.map

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LineSeries = __webpack_require__(78);
	
	var _LineSeries2 = _interopRequireDefault(_LineSeries);
	
	var _AreaOnlySeries = __webpack_require__(165);
	
	var _AreaOnlySeries2 = _interopRequireDefault(_AreaOnlySeries);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AreaSeries(props) {
		var yAccessor = props.yAccessor,
		    baseAt = props.baseAt;
		var className = props.className,
		    opacity = props.opacity,
		    stroke = props.stroke,
		    strokeWidth = props.strokeWidth,
		    strokeOpacity = props.strokeOpacity,
		    strokeDasharray = props.strokeDasharray,
		    canvasGradient = props.canvasGradient,
		    fill = props.fill,
		    interpolation = props.interpolation,
		    style = props.style,
		    canvasClip = props.canvasClip;
	
	
		return _react2.default.createElement(
			"g",
			{ className: className },
			_react2.default.createElement(_AreaOnlySeries2.default, {
				yAccessor: yAccessor,
				interpolation: interpolation,
				base: baseAt,
				canvasGradient: canvasGradient,
				fill: fill,
				opacity: opacity,
				style: style,
				canvasClip: canvasClip,
				stroke: "none"
			}),
			_react2.default.createElement(_LineSeries2.default, {
				yAccessor: yAccessor,
				stroke: stroke,
				strokeWidth: strokeWidth,
				strokeOpacity: strokeOpacity,
				strokeDasharray: strokeDasharray,
				interpolation: interpolation,
				style: style,
				canvasClip: canvasClip,
				fill: "none",
				hoverHighlight: false
			})
		);
	}
	
	AreaSeries.propTypes = {
		stroke: _propTypes2.default.string,
		strokeWidth: _propTypes2.default.number,
		canvasGradient: _propTypes2.default.func,
		fill: _propTypes2.default.string.isRequired,
		strokeOpacity: _propTypes2.default.number.isRequired,
		opacity: _propTypes2.default.number.isRequired,
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func.isRequired,
		baseAt: _propTypes2.default.func,
		interpolation: _propTypes2.default.func,
		canvasClip: _propTypes2.default.func,
		style: _propTypes2.default.object,
		strokeDasharray: _propTypes2.default.oneOf(_utils.strokeDashTypes)
	};
	
	AreaSeries.defaultProps = {
		stroke: "#4682B4",
		strokeWidth: 1,
		strokeOpacity: 1,
		strokeDasharray: "Solid",
		opacity: 0.5,
		fill: "#4682B4",
		className: "react-stockcharts-area"
	};
	
	exports.default = AreaSeries;
	//# sourceMappingURL=AreaSeries.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _StackedBarSeries = __webpack_require__(113);
	
	var _StackedBarSeries2 = _interopRequireDefault(_StackedBarSeries);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BarSeries = function (_Component) {
		_inherits(BarSeries, _Component);
	
		function BarSeries(props) {
			_classCallCheck(this, BarSeries);
	
			var _this = _possibleConstructorReturn(this, (BarSeries.__proto__ || Object.getPrototypeOf(BarSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(BarSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				if (this.props.swapScales) {
					var xAccessor = moreProps.xAccessor;
	
					(0, _StackedBarSeries.drawOnCanvasHelper)(ctx, this.props, moreProps, xAccessor, _StackedBarSeries.identityStack);
				} else {
					var bars = getBars(this.props, moreProps);
					(0, _StackedBarSeries.drawOnCanvas2)(this.props, ctx, bars);
				}
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				if (this.props.swapScales) {
					var xAccessor = moreProps.xAccessor;
	
					return _react2.default.createElement(
						"g",
						null,
						(0, _StackedBarSeries.svgHelper)(this.props, moreProps, xAccessor, _StackedBarSeries.identityStack)
					);
				} else {
					var bars = getBars(this.props, moreProps);
					return _react2.default.createElement(
						"g",
						null,
						(0, _StackedBarSeries.getBarsSVG2)(this.props, bars)
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var clip = this.props.clip;
	
	
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: clip,
					svgDraw: this.renderSVG,
	
					canvasToDraw: _GenericComponent.getAxisCanvas,
					canvasDraw: this.drawOnCanvas,
	
					drawOn: ["pan"]
				});
			}
		}]);
	
		return BarSeries;
	}(_react.Component);
	
	BarSeries.propTypes = {
		baseAt: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		stroke: _propTypes2.default.bool,
		width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		yAccessor: _propTypes2.default.func.isRequired,
		opacity: _propTypes2.default.number,
		fill: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
		className: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
		clip: _propTypes2.default.bool,
		swapScales: _propTypes2.default.bool
	};
	
	BarSeries.defaultProps = _StackedBarSeries2.default.defaultProps;
	
	exports.default = BarSeries;
	
	/*
	 Initially, this program was using StackedBarSeries.getBars
	 to benefit from code reuse and having a single place that
	 contains the logic for drawing all types of bar charts
	 simple, grouped, horizontal, but turnes out
	 making it highly cuztimizable also made it slow for the
	 most simple case, a regular bar chart.
	 This function contains just the necessary logic
	 to create bars
	*/
	
	function getBars(props, moreProps) {
		var baseAt = props.baseAt,
		    fill = props.fill,
		    stroke = props.stroke,
		    yAccessor = props.yAccessor;
		var xScale = moreProps.xScale,
		    xAccessor = moreProps.xAccessor,
		    plotData = moreProps.plotData,
		    yScale = moreProps.chartConfig.yScale;
	
	
		var getFill = (0, _utils.functor)(fill);
		var getBase = (0, _utils.functor)(baseAt);
	
		var widthFunctor = (0, _utils.functor)(props.width);
	
		var width = widthFunctor(props, {
			xScale: xScale,
			xAccessor: xAccessor,
			plotData: plotData
		});
		/*
	 const barWidth = Math.round(width);
	 const offset = Math.round(barWidth === 1 ? 0 : 0.5 * barWidth);
	 */
		var offset = Math.floor(0.5 * width);
	
		var bars = plotData.filter(function (d) {
			return (0, _utils.isDefined)(yAccessor(d));
		}).map(function (d) {
			var yValue = yAccessor(d);
			var y = yScale(yValue);
	
			var x = Math.round(xScale(xAccessor(d))) - offset;
			var h = getBase(xScale, yScale, d) - yScale(yValue);
	
			if (h < 0) {
				y = y + h;
				h = -h;
			}
	
			return {
				// type: "line"
				x: x,
				y: Math.round(y),
				height: Math.round(h),
				width: offset * 2,
				fill: getFill(d, 0),
				stroke: stroke ? getFill(d, 0) : "none"
			};
		});
	
		return bars;
	}
	//# sourceMappingURL=BarSeries.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SVGComponent = function (_Component) {
		_inherits(SVGComponent, _Component);
	
		function SVGComponent() {
			_classCallCheck(this, SVGComponent);
	
			return _possibleConstructorReturn(this, (SVGComponent.__proto__ || Object.getPrototypeOf(SVGComponent)).apply(this, arguments));
		}
	
		_createClass(SVGComponent, [{
			key: "render",
			value: function render() {
				var children = this.props.children;
	
				return _react2.default.createElement(_GenericChartComponent2.default, {
					drawOn: [],
					svgDraw: children
				});
			}
		}]);
	
		return SVGComponent;
	}(_react.Component);
	
	SVGComponent.propTypes = {
		children: _propTypes2.default.func.isRequired
	};
	
	exports.default = SVGComponent;
	//# sourceMappingURL=SVGComponent.js.map

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = shallowEqual;
	// https://github.com/jonschlinkert/is-equal-shallow/
	
	/*
	The MIT License (MIT)
	
	Copyright (c) 2015, Jon Schlinkert.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	function isDate(date) {
		return Object.prototype.toString.call(date) === "[object Date]";
	}
	
	function isEqual(val1, val2) {
		return isDate(val1) && isDate(val2) ? val1.getTime() === val2.getTime() : val1 === val2;
	}
	
	function shallowEqual(a, b) {
		if (!a && !b) {
			return true;
		}
		if (!a && b || a && !b) {
			return false;
		}
	
		var numKeysA = 0,
		    numKeysB = 0,
		    key = void 0;
		for (key in b) {
			numKeysB++;
			if ( /* !isPrimitive(b[key]) || */b.hasOwnProperty(key) && !a.hasOwnProperty(key) || !isEqual(a[key], b[key])) {
				// console.log(key, a, b);
				return false;
			}
		}
		for (key in a) {
			numKeysA++;
		}
		return numKeysA === numKeysB;
	}
	//# sourceMappingURL=shallowEqual.js.map

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = zipper;
	
	var _d3Array = __webpack_require__(21);
	
	var _identity = __webpack_require__(96);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* an extension to d3.zip so we call a function instead of an array */
	
	function zipper() {
		var combine = _identity2.default;
	
		function zip() {
			var n = arguments.length;
			if (!n) return [];
			var m = (0, _d3Array.min)(arguments, d3_zipLength);
	
			// eslint-disable-next-line prefer-const
			var i = void 0,
			    zips = new Array(m);
			for (i = -1; ++i < m;) {
				for (var j = -1, _zip = zips[i] = new Array(n); ++j < n;) {
					_zip[j] = arguments[j][i];
				}
				zips[i] = combine.apply(this, zips[i]);
			}
			return zips;
		}
		function d3_zipLength(d) {
			return d.length;
		}
		zip.combine = function (x) {
			if (!arguments.length) {
				return combine;
			}
			combine = x;
			return zip;
		};
		return zip;
	}
	//# sourceMappingURL=zipper.js.map

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentRequestButtonElement = exports.PostalCodeElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;
	
	var _Provider = __webpack_require__(168);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _inject = __webpack_require__(793);
	
	var _inject2 = _interopRequireDefault(_inject);
	
	var _Elements = __webpack_require__(114);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Element = __webpack_require__(791);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _PaymentRequestButtonElement = __webpack_require__(792);
	
	var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardElement = (0, _Element2.default)('card', { sourceType: 'card' });
	
	var CardNumberElement = (0, _Element2.default)('cardNumber', { sourceType: 'card' });
	var CardExpiryElement = (0, _Element2.default)('cardExpiry');
	var CardCVCElement = (0, _Element2.default)('cardCvc');
	var PostalCodeElement = (0, _Element2.default)('postalCode');
	
	exports.StripeProvider = _Provider2.default;
	exports.injectStripe = _inject2.default;
	exports.Elements = _Elements2.default;
	exports.CardElement = CardElement;
	exports.CardNumberElement = CardNumberElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardCVCElement = CardCVCElement;
	exports.PostalCodeElement = PostalCodeElement;
	exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shallowEqual = function shallowEqual(a, b) {
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  return keysA.length === keysB.length && keysA.every(function (key) {
	    return b.hasOwnProperty(key) && b[key] === a[key];
	  });
	};
	
	exports.default = shallowEqual;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(81),
	    _assign = __webpack_require__(18);
	
	var ReactNoopUpdateQueue = __webpack_require__(411);
	
	var canDefineProperty = __webpack_require__(412);
	var emptyObject = __webpack_require__(101);
	var invariant = __webpack_require__(9);
	var lowPriorityWarning = __webpack_require__(803);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(81);
	
	var ReactCurrentOwner = __webpack_require__(51);
	
	var invariant = __webpack_require__(9);
	var warning = __webpack_require__(15);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(15);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(139);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(820);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(414);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(810);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(809);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(808);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(413);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(453);
	var RequestBase = __webpack_require__(817);
	var isObject = __webpack_require__(418);
	var ResponseBase = __webpack_require__(818);
	var Agent = __webpack_require__(816);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = exports = module.exports = function(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new exports.Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new exports.Request('GET', method);
	  }
	
	  return new exports.Request(method, url);
	}
	
	exports.Request = Request;
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only version of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	request.serializeObject = serialize;
	
	/**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'text/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	request.serialize = {
	  'application/x-www-form-urlencoded': serialize,
	  'application/json': JSON.stringify
	};
	
	/**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    if (index === -1) { // could be empty line, just skip it
	      continue;
	    }
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  // should match /json or +json
	  // but not /json-seq
	  return /[\/+]json($|[^-\w])/.test(mime);
	}
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req) {
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  var status = this.xhr.status;
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	  this._setStatusProperties(status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	
	  if (null === this.text && req._responseType) {
	    this.body = this.xhr.response;
	  } else {
	    this.body = this.req.method != 'HEAD'
	      ? this._parseBody(this.text ? this.text : this.xhr.response)
	      : null;
	  }
	}
	
	ResponseBase(Response.prototype);
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str) {
	  var parse = request.parse[this.type];
	  if (this.req._parser) {
	    return this.req._parser(this, str);
	  }
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      if (self.xhr) {
	        // ie9 doesn't have 'response' property
	        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
	        // issue #876: return the http status code if the response parsing fails
	        err.status = self.xhr.status ? self.xhr.status : null;
	        err.statusCode = err.status; // backwards-compat only
	      } else {
	        err.rawResponse = null;
	        err.status = null;
	      }
	
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (!self._isResponseOK(res)) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	      }
	    } catch(custom_err) {
	      new_err = custom_err; // ok() callback can throw
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      new_err.original = err;
	      new_err.response = res;
	      new_err.status = res.status;
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `RequestBase`.
	 */
	
	Emitter(Request.prototype);
	RequestBase(Request.prototype);
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} [pass] optional in case of using 'bearer' as type
	 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (1 === arguments.length) pass = '';
	  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
	    options = pass;
	    pass = '';
	  }
	  if (!options) {
	    options = {
	      type: 'function' === typeof btoa ? 'basic' : 'auto',
	    };
	  }
	
	  var encoder = function(string) {
	    if ('function' === typeof btoa) {
	      return btoa(string);
	    }
	    throw new Error('Cannot use basic auth, btoa is not a function');
	  };
	
	  return this._auth(user, pass, options, encoder);
	};
	
	/**
	 * Add query-string `val`.
	 *
	 * Examples:
	 *
	 *   request.get('/shoes')
	 *     .query('size=10')
	 *     .query({ color: 'blue' })
	 *
	 * @param {Object|String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `options` (or filename).
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String|Object} options
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, options){
	  if (file) {
	    if (this._data) {
	      throw Error("superagent can't mix .send() and .attach()");
	    }
	
	    this._getFormData().append(field, file, options || file.name);
	  }
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  if (this._shouldRetry(err, res)) {
	    return this._retry();
	  }
	
	  var fn = this._callback;
	  this.clearTimeout();
	
	  if (err) {
	    if (this._maxRetries) err.retries = this._retries - 1;
	    this.emit('error', err);
	  }
	
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	// This only warns, because the request is still likely to work
	Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
	  console.warn("This is not supported in browser version of superagent");
	  return this;
	};
	
	// This throws, because it can't send/receive data as expected
	Request.prototype.pipe = Request.prototype.write = function(){
	  throw Error("Streaming is not supported in browser version of superagent");
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	Request.prototype._isHost = function _isHost(obj) {
	  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
	  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
	}
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  if (this._endCalled) {
	    console.warn("Warning: .end() was called twice. This is not supported in superagent");
	  }
	  this._endCalled = true;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // querystring
	  this._finalizeQueryString();
	
	  return this._end();
	};
	
	Request.prototype._end = function() {
	  var self = this;
	  var xhr = (this.xhr = request.getXHR());
	  var data = this._formData || this._data;
	
	  this._setTimeouts();
	
	  // state change
	  xhr.onreadystatechange = function(){
	    var readyState = xhr.readyState;
	    if (readyState >= 2 && self._responseTimeoutTimer) {
	      clearTimeout(self._responseTimeoutTimer);
	    }
	    if (4 != readyState) {
	      return;
	    }
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (!status) {
	      if (self.timedout || self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // initiate request
	  try {
	    if (this.username && this.password) {
	      xhr.open(this.method, this.url, true, this.username, this.password);
	    } else {
	      xhr.open(this.method, this.url, true);
	    }
	  } catch (err) {
	    // see #1149
	    return this.callback(err);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) {
	      serialize = request.serialize['application/json'];
	    }
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	
	    if (this.header.hasOwnProperty(field))
	      xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	request.agent = function() {
	  return new Agent();
	};
	
	["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
	  Agent.prototype[method.toLowerCase()] = function(url, fn) {
	    var req = new request.Request(method, url);
	    this._setDefaults(req);
	    if (fn) {
	      req.end(fn);
	    }
	    return req;
	  };
	});
	
	Agent.prototype.del = Agent.prototype['delete'];
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn) {
	  var req = request('GET', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn) {
	  var req = request('HEAD', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn) {
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, data, fn) {
	  var req = request('DELETE', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	}
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn) {
	  var req = request('PATCH', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn) {
	  var req = request('POST', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn) {
	  var req = request('PUT', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _reactRouter = __webpack_require__(43);
	
	var _Routes = __webpack_require__(421);
	
	var _Api = __webpack_require__(52);
	
	var _session = __webpack_require__(82);
	
	var _store = __webpack_require__(452);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _route = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// let wsProtocol = 'ws';
	// if (window.location.protocol === 'https:') {
	//   wsProtocol = 'wss';
	// }
	
	// The port number needs to align with devServerProxy and websocketHost in
	// // grommet-toolbox.config.js
	// let hostName = NODE_ENV === 'development' ?
	//   'localhost:8101' : window.location.host;
	// apiConfigure({
	//   webSocketUrl: `${wsProtocol}://${hostName}/ws`
	// });
	
	// let locale = getCurrentLocale();
	// addLocaleData(en);
	
	// let messages;
	// try {
	//   // rtl driven by hardcoding languages for now
	//   if ('he' === locale || 'ar' === locale.slice(0, 2)) {
	//     document.documentElement.classList.add("rtl");
	//   } else {
	//     document.documentElement.classList.remove("rtl");
	//   }
	//   messages = require('../messages/' + locale);
	// } catch (e) {
	//   messages = require('../messages/en-US');
	// }
	// var localeData = getLocaleData(messages, locale);
	
	/****/ //store.dispatch(sessionInitialize(window.location.pathname));
	
	// listen for history changes and initiate routeChanged actions for them
	
	// import { IntlProvider } from 'react-intl';
	// import { addLocaleData } from 'react-intl';
	// import en from 'react-intl/locale-data/en';
	// import { getCurrentLocale, getLocaleData } from 'grommet/utils/Locale';
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	_reactRouter.browserHistory.listen(function (location) {
	  var publish = _store2.default.getState().session.publishRoute;
	  _store2.default.dispatch((0, _route.routeChanged)(location, publish));
	});
	window.store = _store2.default;
	(0, _session.sessionInitialize)();
	
	var _default = function _default() {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: _store2.default },
	    _react2.default.createElement(_reactRouter.Router, { routes: _Routes.routes, history: _reactRouter.browserHistory })
	  );
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/App.js');
	}();

	;

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var constants = {
	  DATEFILTER: {
	    SELECT_STARTDATE: 'Please select From date.',
	    FUTURE_DATE: 'You cannot select a date in future yet!',
	    INVALID_FROMDATE: 'Please select From date less than or same as To date',
	    INVALID_TODATE: 'Please select From date less than or same as To date'
	  },
	  NODATAFOUND: 'Data not found!'
	
	};
	
	var _default = constants;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(constants, 'constants', '/Volumes/gitws/GroGuru.git/frontyard/src/js/Messages.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/Messages.js');
	}();

	;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = undefined;
	
	var _Main = __webpack_require__(423);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Login = __webpack_require__(422);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _SiteView = __webpack_require__(440);
	
	var _SiteView2 = _interopRequireDefault(_SiteView);
	
	var _Alerts = __webpack_require__(437);
	
	var _Alerts2 = _interopRequireDefault(_Alerts);
	
	var _Dashboard = __webpack_require__(427);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _LocationView = __webpack_require__(432);
	
	var _LocationView2 = _interopRequireDefault(_LocationView);
	
	var _Settings = __webpack_require__(436);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _ChooseLocationMap = __webpack_require__(435);
	
	var _ChooseLocationMap2 = _interopRequireDefault(_ChooseLocationMap);
	
	var _AddStem = __webpack_require__(426);
	
	var _AddStem2 = _interopRequireDefault(_AddStem);
	
	var _SubscriptionView = __webpack_require__(441);
	
	var _SubscriptionView2 = _interopRequireDefault(_SubscriptionView);
	
	var _SignUp = __webpack_require__(425);
	
	var _SignUp2 = _interopRequireDefault(_SignUp);
	
	var _Tutorial = __webpack_require__(442);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import TBD from 'grommet/components/TBD';
	
	// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var routes = exports.routes = [{
	  path: '/', component: _Main2.default, indexRoute: { component: _Login2.default },
	  childRoutes: [{ path: 'login', component: _Login2.default }, { path: 'signup', component: _SignUp2.default }, { path: 'location', component: _LocationView2.default }, { path: 'site', component: _SiteView2.default },
	  // { path: 'dashboard', component: Dashboard },
	  { path: 'tutorial', component: _Tutorial2.default }, { path: 'addstem', component: _AddStem2.default }, { path: 'subscription', component: _SubscriptionView2.default }, { path: 'settings', component: _Settings2.default }, { path: 'chooselocation', component: _ChooseLocationMap2.default }, { path: 'alerts', component: _Alerts2.default }, { path: '**', component: _Login2.default }]
	}, { path: '**', component: _Login2.default }];
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(routes, 'routes', '/Volumes/gitws/GroGuru.git/frontyard/src/js/Routes.js');
	}();

	;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _session = __webpack_require__(82);
	
	var _nav = __webpack_require__(28);
	
	var _actions = __webpack_require__(13);
	
	var _Split = __webpack_require__(70);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _Sidebar = __webpack_require__(69);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _LoginForm = __webpack_require__(499);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _Footer = __webpack_require__(67);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Section = __webpack_require__(54);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Anchor = __webpack_require__(66);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Paragraph = __webpack_require__(85);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Close = __webpack_require__(63);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _Logo = __webpack_require__(98);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this._onSubmit = _this._onSubmit.bind(_this);
	    _this.displayPasswordResetDialog = _this.displayPasswordResetDialog.bind(_this);
	    _this.requestPasswordReset = _this.requestPasswordReset.bind(_this);
	    _this.showStatusAlert = _this.showStatusAlert.bind(_this);
	    // this._setDocumentTitle(props);
	    _this.state = { busy: false };
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _nav.navEnable)(false));
	      this.props.dispatch((0, _actions.getStripeAPIKey)());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // this._setDocumentTitle(nextProps);
	      // if (this.state.busy) {
	      //   this.setState({ busy: false });
	      // }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dispatch((0, _nav.navEnable)(true));
	    }
	  }, {
	    key: '_setDocumentTitle',
	    value: function _setDocumentTitle(props) {
	      // document.title = `Login - ${props.productName || ''}`;
	    }
	  }, {
	    key: '_onSubmit',
	    value: function _onSubmit(fields) {
	
	      // this.setState({ busy: true });
	      this.props.dispatch((0, _session.sessionLogin)('', fields.username, fields.password));
	    }
	  }, {
	    key: 'displayPasswordResetDialog',
	    value: function displayPasswordResetDialog() {
	      this.props.dispatch((0, _session.displayPasswordResetDialog)(!this.props.resetPassword));
	    }
	  }, {
	    key: 'requestPasswordReset',
	    value: function requestPasswordReset(ev) {
	      ev.preventDefault();
	      if (!ev.target.elements['email'].value) {
	        alert("Please enter a valid email");
	      } else {
	        var email = ev.target.elements['email'].value;
	        this.props.dispatch((0, _session.requestPasswordReset)({ email: email }));
	        this.props.dispatch((0, _session.displayPasswordResetDialog)(!this.props.resetPassword));
	      }
	    }
	  }, {
	    key: 'renderPasswordResetContent',
	    value: function renderPasswordResetContent() {
	      if (this.props.resetPassword) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          { flush: false,
	            onClose: this.displayPasswordResetDialog
	          },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.requestPasswordReset },
	            _react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Close2.default, null),
	              onClick: this.displayPasswordResetDialog,
	              plain: true, style: { position: 'absolute', float: 'right', right: '0' } }),
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: "center" }, className: 'heading confirmation-content' },
	              _react2.default.createElement(
	                _Paragraph2.default,
	                { size: 'large' },
	                'Please enter your email to receive instructions to reset password'
	              ),
	              _react2.default.createElement(
	                _Paragraph2.default,
	                { size: 'large' },
	                _react2.default.createElement('input', { type: 'email', name: 'email', placeholder: 'Please enter your email', className: 'input-email maxwidth', required: true })
	              ),
	              _react2.default.createElement(
	                _Paragraph2.default,
	                { size: 'large' },
	                _react2.default.createElement(_Button2.default, { label: 'OK',
	                  className: 'lighter-font button-margin',
	                  type: 'submit',
	                  primary: true,
	                  secondary: false,
	                  accent: false }),
	                _react2.default.createElement(_Button2.default, { label: 'Cancel',
	                  className: 'lighter-font button-margin',
	                  onClick: this.displayPasswordResetDialog,
	                  primary: true,
	                  secondary: false,
	                  accent: false })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'showStatusAlert',
	    value: function showStatusAlert() {
	      if (this.props.passwordResetStatus) {
	        alert(this.props.passwordResetStatus);
	        this.props.dispatch((0, _session.displayPasswordResetDialog)(false));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var session = this.props.session;
	
	
	      var loginError = session.error;
	
	      return _react2.default.createElement(
	        _Section2.default,
	        { align: 'center' },
	        _react2.default.createElement(_LoginForm2.default, { align: 'center',
	          logo: _react2.default.createElement(_Logo2.default, { size: 'large', busy: this.state.busy }),
	          onSubmit: this._onSubmit,
	          errors: [loginError],
	          usernameType: 'text' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'signup-nav-section login-form' },
	          _react2.default.createElement(_Button2.default, { label: 'Forgot Password',
	            className: 'forgot-password-button',
	            onClick: this.displayPasswordResetDialog,
	            primary: false,
	            plain: true }),
	          _react2.default.createElement(
	            'div',
	            { className: 'signup-content' },
	            'No Account ?',
	            _react2.default.createElement(
	              'a',
	              { className: 'login-signup-link', href: '/signup' },
	              'Sign Up'
	            )
	          )
	        ),
	        this.renderPasswordResetContent(),
	        this.showStatusAlert()
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	Login.propTypes = {
	  session: _react.PropTypes.shape({
	    error: _react.PropTypes.string
	  })
	};
	
	var select = function select(state) {
	  return {
	    // productName: state.settings.productName.short,
	    session: state.session,
	    resetPassword: state.session.resetPassword,
	    passwordResetStatus: state.session.passwordResetStatus
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(Login);
	
	exports.default = _default;
	
	/*<Split flex="left" separator={true}>
	        <Sidebar justify="between" align="center" pad="none" size="large">
	         <span />
	          <Footer direction="row" size="small"
	           pad={{horizontal: 'medium', vertical: 'small', between: 'small'}}>
	           <span className="secondary">&copy; 2016 Grommet Labs</span>
	         </Footer>
	       </Sidebar>
	     </Split>*/
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Login, 'Login', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Login.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Login.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Login.js');
	}();

	;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _App = __webpack_require__(187);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Split = __webpack_require__(70);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _NavSidebar = __webpack_require__(424);
	
	var _NavSidebar2 = _interopRequireDefault(_NavSidebar);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Sidebar = __webpack_require__(69);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Menu = __webpack_require__(197);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	// import Toast from 'grommet/components/Toast';
	// import Layer from 'grommet/layer/Layer';
	
	var loaderStyle = {
	  position: 'fixed',
	  background: 'rgba(81, 91, 69, 0.98)',
	  width: '100%',
	  height: '100%',
	  top: 0,
	  zIndex: 9999
	};
	
	var imageStyle = {
	  top: '50%',
	  left: '50%',
	  position: 'absolute',
	  width: '3%'
	};
	
	var Main = function (_Component) {
	  _inherits(Main, _Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this));
	
	    _this._onResponsive = _this._onResponsive.bind(_this);
	    _this._showLoader = _this._showLoader.bind(_this);
	    _this.state = {
	      multiple: true,
	      showLayer: false
	    };
	    return _this;
	  }
	
	  _createClass(Main, [{
	    key: '_onResponsive',
	    value: function _onResponsive(responsive) {
	      if (responsive === 'single') {
	        this.setState({ multiple: false });
	      } else {
	        this.setState({ multiple: true, showLayer: false });
	      }
	      this.props.dispatch((0, _actions.navResponsive)(responsive));
	    }
	  }, {
	    key: '_showLoader',
	    value: function _showLoader() {
	      if (this.props.showLoader) {
	        return _react2.default.createElement(
	          'div',
	          { style: loaderStyle },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { style: imageStyle, src: '/img/loader.gif', alt: '' })
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // console.log('ferret load:::', this.props)
	      var _props$nav = this.props.nav,
	          navActive = _props$nav.active,
	          navEnabled = _props$nav.enabled,
	          responsive = _props$nav.responsive;
	
	      var includeNav = navActive && navEnabled;
	      var nav = void 0;
	
	      var _state = this.state,
	          multiple = _state.multiple,
	          showLayer = _state.showLayer;
	
	
	      var content = _react2.default.createElement(_NavSidebar2.default, null);
	      var leftNode = void 0;
	      var buttonNode = void 0;
	      var layerNode = void 0;
	
	      if (multiple && navEnabled) {
	        leftNode = _react2.default.createElement(
	          _Sidebar2.default,
	          { colorIndex: 'neutral-1', fixed: true, className: 'left-menu' },
	          content
	        );
	      } else if (showLayer) {
	        layerNode = _react2.default.createElement(
	          _Layer2.default,
	          {
	            flush: true,
	            colorIndex: 'neutral-1',
	            fixed: true,
	            className: 'left-menu',
	            closer: true,
	            onClose: function onClose() {
	              return _this2.setState({ showLayer: false });
	            },
	            peek: true
	          },
	          content
	        );
	      } else if (responsive === 'single' && navEnabled) {
	        buttonNode = _react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Menu2.default, null), style: { float: 'right' }, onClick: function onClick() {
	            return _this2.setState({ showLayer: true });
	          } });
	      }
	
	      if (includeNav) {
	        nav = _react2.default.createElement(_NavSidebar2.default, null);
	      }
	      var priority = includeNav && 'single' === responsive ? 'left' : 'right';
	
	      return _react2.default.createElement(
	        _App2.default,
	        { centered: false, className: 'main' },
	        _react2.default.createElement(
	          _Split2.default,
	          {
	            priority: 'right',
	            flex: 'right', fixed: true,
	            onResponsive: this._onResponsive
	          },
	          leftNode,
	          buttonNode,
	          this.props.children,
	          layerNode
	        ),
	        this._showLoader()
	      );
	    }
	  }]);
	
	  return Main;
	}(_react.Component);
	
	var select = function select(state) {
	  return {
	    nav: state.nav,
	    showLoader: state.status.showLoader,
	    session: state.session
	    // status: state.status
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(Main);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(loaderStyle, 'loaderStyle', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Main.js');
	
	  __REACT_HOT_LOADER__.register(imageStyle, 'imageStyle', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Main.js');
	
	  __REACT_HOT_LOADER__.register(Main, 'Main', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Main.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Main.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/Main.js');
	}();

	;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _Sidebar = __webpack_require__(69);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(67);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Title = __webpack_require__(55);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Logo = __webpack_require__(98);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Menu = __webpack_require__(121);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Close = __webpack_require__(63);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _Anchor = __webpack_require__(66);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _session = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var NavSidebar = function (_Component) {
	  _inherits(NavSidebar, _Component);
	
	  function NavSidebar() {
	    _classCallCheck(this, NavSidebar);
	
	    var _this = _possibleConstructorReturn(this, (NavSidebar.__proto__ || Object.getPrototypeOf(NavSidebar)).call(this));
	
	    _this._onClose = _this._onClose.bind(_this);
	    _this.logout = _this.logout.bind(_this);
	    return _this;
	  }
	
	  _createClass(NavSidebar, [{
	    key: '_onClose',
	    value: function _onClose() {
	      this.props.dispatch((0, _actions.navActivate)(false));
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      // confirm('Are you sure want to logout ?')
	      this.props.dispatch((0, _session.sessionLogout)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log('hi im nave')
	      var items = this.props.nav.items;
	
	      var links = items.map(function (page) {
	        return _react2.default.createElement(_Anchor2.default, { key: page.label, path: page.path, label: page.label });
	      });
	      var imageStyle = {
	        width: '35%',
	        marginLeft: '30%'
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Header2.default,
	          { size: 'large', justify: 'between', pad: { horizontal: 'medium' } },
	          _react2.default.createElement(
	            _Title2.default,
	            { a11yTitle: 'Close Menu' },
	            _react2.default.createElement('img', { src: '/img/logowithtext.png', className: 'logo', alt: '' })
	          )
	        ),
	        _react2.default.createElement(
	          _Menu2.default,
	          { fill: true, primary: true },
	          links
	        ),
	        _react2.default.createElement(
	          _Footer2.default,
	          { pad: { horizontal: 'medium', vertical: 'small' } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: 'absolute', bottom: '2%' } },
	            _react2.default.createElement(_Button2.default, { label: 'Logout',
	              className: 'lighter-font',
	              onClick: this.logout,
	              primary: true,
	              secondary: false,
	              accent: false })
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavSidebar;
	}(_react.Component);
	
	NavSidebar.propTypes = {
	  nav: _react.PropTypes.shape({
	    items: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      path: _react.PropTypes.string,
	      label: _react.PropTypes.string
	    }))
	  }),
	  onClose: _react.PropTypes.func,
	  productName: _react.PropTypes.string,
	  router: _react.PropTypes.object
	};
	
	var select = function select(state) {
	  return {
	    // instanceName: state.settings.settings.name,
	    nav: state.nav
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(NavSidebar);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NavSidebar, 'NavSidebar', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/NavSidebar.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/NavSidebar.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/NavSidebar.js');
	}();

	;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _TextInput = __webpack_require__(123);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Form = __webpack_require__(53);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Section = __webpack_require__(54);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Anchor = __webpack_require__(66);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _MapLocation = __webpack_require__(511);
	
	var _MapLocation2 = _interopRequireDefault(_MapLocation);
	
	var _reactRouter = __webpack_require__(43);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _session = __webpack_require__(82);
	
	var _Logo = __webpack_require__(98);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var SignUp = function (_Component) {
	    _inherits(SignUp, _Component);
	
	    function SignUp(props) {
	        _classCallCheck(this, SignUp);
	
	        var _this = _possibleConstructorReturn(this, (SignUp.__proto__ || Object.getPrototypeOf(SignUp)).call(this, props));
	
	        _this.registerUser = _this.registerUser.bind(_this);
	        _this.chooseLocation = _this.chooseLocation.bind(_this);
	        _this.setLocationInfo = _this.setLocationInfo.bind(_this);
	        _this.createFormDataModel = _this.createFormDataModel.bind(_this);
	        _this.modifyLocation = _this.modifyLocation.bind(_this);
	        _this.showRegistrationStatus = _this.showRegistrationStatus.bind(_this);
	
	        _this.state = { busy: false };
	        return _this;
	    }
	
	    _createClass(SignUp, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setLocationInfo(this.props.signedUpLocation);
	        }
	    }, {
	        key: 'registerUser',
	        value: function registerUser(ev) {
	            ev.preventDefault();
	            var formData = {};
	            var isFormValid = true;
	            for (var field in this.refs) {
	                if ((_.isNull(this.refs[field].value) || _.isUndefined(this.refs[field].value) || this.refs[field].value.trim() === "") && this.refs[field].name !== 'gardenName' && this.refs[field].name !== 'gardenLocation') {
	                    alert("Please fill all the fields");
	                    isFormValid = false;
	                    return;
	                } else formData[field] = this.refs[field].value;
	            }
	            if (isFormValid) formData.gardenLocation = this.modifyLocation(formData.gardenLocation);
	            this.props.dispatch((0, _session.registerUser)(formData, this.refs.userName.value, this.refs.password.value));
	        }
	    }, {
	        key: 'modifyLocation',
	        value: function modifyLocation(location) {
	            if (location && location.split(',').length === 2) {
	                var cordinates = location.split(',');
	                return {
	                    latitude: cordinates[0],
	                    longitude: cordinates[1]
	                };
	            } else {
	                return '';
	            }
	        }
	    }, {
	        key: 'createFormDataModel',
	        value: function createFormDataModel() {
	            var formData = {};
	            for (var field in this.refs) {
	                formData[field] = this.refs[field].value;
	            }
	            return formData;
	        }
	    }, {
	        key: 'chooseLocation',
	        value: function chooseLocation() {
	            this.props.dispatch((0, _session.saveUserData)(this.createFormDataModel()));
	            _reactRouter.browserHistory.push({
	                pathname: _Constants2.default.ROUTES.CHOOSE_LOCATION,
	                // search: '?name=' + sitename_enc,
	                state: {
	                    loggedIn: false
	                }
	            });
	        }
	    }, {
	        key: 'setLocationInfo',
	        value: function setLocationInfo() {
	            if (!this.props.signedUpLocation || !this.props.signedUpLocation.latitude) {
	                return '';
	            } else {
	                this.refs.gardenLocation.value = this.props.signedUpLocation.latitude + ' , ' + this.props.signedUpLocation.longitude;
	            }
	        }
	    }, {
	        key: 'getInputFieldData',
	        value: function getInputFieldData(inputField) {
	            switch (inputField) {
	                case "fullName":
	                    return this.props.userInfo.fullName = this.props.userInfo && this.props.userInfo.fullName ? this.props.userInfo.fullName : '';
	                    break;
	                case "userName":
	                    return this.props.userInfo.userName = this.props.userInfo && this.props.userInfo.userName ? this.props.userInfo.userName : '';
	                    break;
	                case "password":
	                    return this.props.userInfo.password = this.props.userInfo && this.props.userInfo.password ? this.props.userInfo.password : '';
	                    break;
	                case "email":
	                    return this.props.userInfo.email = this.props.userInfo && this.props.userInfo.email ? this.props.userInfo.email : '';
	                    break;
	                case "gardenName":
	                    return this.props.userInfo.gardenName = this.props.userInfo && this.props.userInfo.gardenName ? this.props.userInfo.gardenName : '';
	                    break;
	                case "gardenLocaton":
	                    return this.props.userInfo.gardenLocaton = this.props.userInfo && this.props.userInfo.gardenLocaton ? this.props.userInfo.gardenLocaton : '';
	                    break;
	                default:
	                    return '';
	                    break;
	            }
	        }
	    }, {
	        key: 'showRegistrationStatus',
	        value: function showRegistrationStatus() {
	            if (this.props.registrationStatus && this.props.registrationMessage === "success") {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'success' },
	                    'User registered successfully. Please login to continue.'
	                );
	            } else if (this.props.registrationStatus === false && this.props.registrationMessage !== "success") {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'error' },
	                    ' ',
	                    this.props.registrationMessage,
	                    ' '
	                );
	            } else if (this.props.registrationStatus === null) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'error' },
	                    'Registeration failed.'
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Section2.default,
	                { align: 'center' },
	                _react2.default.createElement(_Logo2.default, { size: 'large', busy: this.state.busy }),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'register-form', method: 'post', onSubmit: this.registerUser },
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { label: "Username" },
	                        _react2.default.createElement('input', { type: 'text', name: 'userName', defaultValue: this.getInputFieldData("userName"), maxLength: '28', ref: 'userName', placeholder: '', required: true })
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { label: "Password" },
	                        _react2.default.createElement('input', { type: 'password', name: 'password', defaultValue: this.getInputFieldData("password"), maxLength: '28', ref: 'password', placeholder: '', required: true })
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { label: "Email" },
	                        _react2.default.createElement('input', { type: 'email', name: 'email', defaultValue: this.getInputFieldData("email"), maxLength: '96', ref: 'email', placeholder: '', required: true })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(_Button2.default, { type: 'submit', className: 'register-button', label: 'Register',
	                        primary: true })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'signup-nav-section' },
	                    'Already a member ?',
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'login-signup-link', href: '/login' },
	                        'Login'
	                    )
	                ),
	                this.showRegistrationStatus()
	            );
	        }
	    }]);
	
	    return SignUp;
	}(_react.Component);
	
	var select = function select(state) {
	    return {
	        signedUpLocation: state.user.signedUpLocation,
	        userInfo: state.user.userInfo,
	        registrationStatus: state.session.registrationStatus,
	        registrationMessage: state.session.registrationMessage
	    };
	};
	
	var _default = (0, _reactRedux.connect)(select)(SignUp);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(SignUp, 'SignUp', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/SignUp.js');
	
	    __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/SignUp.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/SignUp.js');
	}();

	;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _nav = __webpack_require__(28);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _TextInput = __webpack_require__(123);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Footer = __webpack_require__(67);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Form = __webpack_require__(53);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Headline = __webpack_require__(68);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _dashboard = __webpack_require__(170);
	
	var _Toast = __webpack_require__(503);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Controls = __webpack_require__(117);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var twigObj = {};
	var refs;
	
	var AddStems = function (_Component) {
	    _inherits(AddStems, _Component);
	
	    function AddStems(props) {
	        _classCallCheck(this, AddStems);
	
	        var _this = _possibleConstructorReturn(this, (AddStems.__proto__ || Object.getPrototypeOf(AddStems)).call(this, props));
	
	        _this.state = {
	            stemID: ''
	        };
	        _this.addStemId = _this.addStemId.bind(_this);
	        _this.onStemIDChange = _this.onStemIDChange.bind(_this);
	        _this.createStem = _this.createStem.bind(_this);
	        _this.cancelCreate = _this.cancelCreate.bind(_this);
	        _this.hideErrorDetails = _this.hideErrorDetails.bind(_this);
	        _this.controlValueChange = _this.controlValueChange.bind(_this);
	        _this.closeToast = _this.closeToast.bind(_this);
	        return _this;
	    }
	
	    _createClass(AddStems, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.dispatch((0, _nav.navEnable)(true));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            twigObj['twigId'] = nextProps.twigId;
	            this.setState({ stemID: '' });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.hideErrorDetails();
	            this.cancelCreate();
	        }
	    }, {
	        key: 'componentDidmount',
	        value: function componentDidmount() {
	            this.hideErrorDetails();
	            this.cancelCreate();
	        }
	    }, {
	        key: 'addStemId',
	        value: function addStemId() {
	            twigObj = {};
	            this.props.dispatch((0, _dashboard.setStemName)(''));
	            this.props.dispatch((0, _dashboard.setStemLocation)(''));
	            this.props.dispatch((0, _dashboard.hideToast)());
	            if (this.state.stemID && this.state.stemID.trim() !== '') {
	                this.props.dispatch((0, _dashboard.addStemIDAction)({ stemID: this.state.stemID.toLowerCase(), showStemAddForm: true }));
	            } else {
	                this.setState({ errorMessage: "Can't be blank" });
	            }
	        }
	    }, {
	        key: 'onStemIDChange',
	        value: function onStemIDChange(e) {
	            this.setState({
	                stemID: e.target.value,
	                errorMessage: ''
	            });
	        }
	    }, {
	        key: 'hideErrorDetails',
	        value: function hideErrorDetails() {
	            this.props.dispatch((0, _dashboard.showAddStemError)(null));
	        }
	    }, {
	        key: 'closeToast',
	        value: function closeToast() {
	            this.props.dispatch((0, _dashboard.hideToast)());
	        }
	    }, {
	        key: 'renderToast',
	        value: function renderToast() {
	            return _react2.default.createElement(
	                _Toast2.default,
	                { status: 'ok', onClose: this.closeToast },
	                this.props.toastMessage
	            );
	        }
	    }, {
	        key: 'controlValueChange',
	        value: function controlValueChange(controlInfo, event) {
	            this.hideErrorDetails();
	            var value = '';
	            if (controlInfo.controlType == _Constants2.default.TWIG_EDIT_CONTROLS.NUMBER_ARRAY) {
	                value = event;
	            } else if (controlInfo.key === "siteName") {
	                value = event.target ? event.target.value : event;
	            } else {
	                value = event.target ? event.target.value : event;
	                if (event.target.name === "Stem Name") {
	                    this.props.dispatch((0, _dashboard.setStemName)(value));
	                } else if (event.target.name === "Stem Location") {
	                    this.props.dispatch((0, _dashboard.setStemLocation)(value));
	                }
	            }
	            twigObj[controlInfo.key] = value;
	        }
	    }, {
	        key: 'setValue',
	        value: function setValue(label) {
	            if (label === "Stem Name") {
	                return this.props.stemName;
	            } else {
	                return this.props.stemLocation;
	            }
	        }
	    }, {
	        key: 'renderTwigControls',
	        value: function renderTwigControls() {
	            var controlsArr = [];
	            var staticControl = [{ type: 'name', key: 'name' }, { type: 'locationName', key: 'location' }];
	            for (var i = 0; i < staticControl.length; i++) {
	                var label = staticControl[i].type == 'name' ? 'Stem Name' : 'Stem Location';
	                controlsArr.push(_react2.default.createElement(_Controls2.default, { name: label, controlType: _Constants2.default.TWIG_EDIT_CONTROLS.TEXT, label: label,
	                    value: this.setValue(label), key: staticControl[i].key,
	                    controlKey: staticControl[i].key, controlValueChange: this.controlValueChange }));
	            }
	            var selectControl = [{ type: 'PlantType', key: 'plantType' }, { type: 'SiteName', key: 'siteName' }, { type: 'SoilType', key: 'soilType' }];
	            for (var _i = 0; _i < selectControl.length; _i++) {
	                controlsArr.push(_react2.default.createElement(_Controls2.default, { parseClass: selectControl[_i].type,
	                    hasUser: selectControl[_i].type == 'SiteName' ? true : false,
	                    controlType: _Constants2.default.TWIG_EDIT_CONTROLS.SELECT,
	                    label: selectControl[_i].type,
	                    key: selectControl[_i].key, controlKey: selectControl[_i].key,
	                    ref: selectControl[_i].key,
	                    controlValueChange: this.controlValueChange, isCreate: true }));
	            }
	
	            return controlsArr;
	        }
	    }, {
	        key: 'createStem',
	        value: function createStem(event) {
	            if (twigObj && (!twigObj.name || !twigObj.name.trim())) {
	                twigObj.name = twigObj.twigId ? twigObj.twigId.substr(-8) : '';
	            }
	            if (twigObj && !twigObj.location) {
	                twigObj.location = '';
	            }
	            twigObj.siteName = this.refs.siteName.state.value;
	            if (twigObj && !twigObj.siteName) {
	                twigObj.siteName = 'unknown site';
	            }
	            twigObj.plantType = this.refs.plantType.state.value;
	            if (twigObj && !twigObj.plantType) {
	                twigObj.plantType = 'Walnuts';
	            }
	            twigObj.soilType = this.refs.soilType.state.value;
	            if (twigObj && !twigObj.soilType) {
	                twigObj.soilType = 'Clay Loam';
	            }
	            this.props.dispatch((0, _dashboard.createStemAction)(twigObj));
	        }
	    }, {
	        key: 'cancelCreate',
	        value: function cancelCreate() {
	            this.props.dispatch((0, _dashboard.setStemName)(''));
	            this.props.dispatch((0, _dashboard.setStemLocation)(''));
	            this.hideErrorDetails();
	            var data = {
	                data: [{
	                    twigId: null
	                }],
	                success: false
	            };
	            this.props.dispatch((0, _dashboard.addStemIDAction)({ data: data, showStemAddForm: false }));
	        }
	    }, {
	        key: 'showError',
	        value: function showError() {
	            if (this.props.showAddStemError) {
	                if (this.props.showAddStemError.action && this.props.showAddStemError.action === "createStem") {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'error' },
	                        this.props.showAddStemError.message || "Oops!! Something went wrong. Request failed"
	                    );
	                } else if (this.props.showAddStemError.duplicateStemError) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'error' },
	                        this.props.showAddStemError.message
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'error' },
	                        this.props.showAddStemError.message || "Oops!! Something went wrong. Request failed"
	                    );
	                }
	            } else {
	                return '';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.props.showToast ? this.renderToast() : '',
	                _react2.default.createElement(
	                    _Form2.default,
	                    { pad: 'large' },
	                    _react2.default.createElement(
	                        _Header2.default,
	                        null,
	                        _react2.default.createElement(
	                            _Headline2.default,
	                            { size: 'small' },
	                            'Add Stem'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: this.props.showStemAddForm ? 'none' : '' } },
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            null,
	                            _react2.default.createElement(_TextInput2.default, { onDOMChange: this.onStemIDChange, onFocus: this.hideErrorDetails, maxLength: 8,
	                                ref: 'stem_id', value: this.state.stemID, placeHolder: "Enter stem ID" }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'error' },
	                                this.state.errorMessage
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _Footer2.default,
	                            { pad: { "vertical": "medium" } },
	                            _react2.default.createElement(_Button2.default, { label: 'Go',
	                                primary: true,
	                                onClick: this.addStemId
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'edit-twig-content',
	                            style: { display: this.props.showStemAddForm ? '' : 'none' } },
	                        this.renderTwigControls(),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'overlay-btn-container' },
	                            _react2.default.createElement(_Button2.default, { label: 'Add',
	                                primary: true,
	                                onClick: this.createStem
	                            }),
	                            _react2.default.createElement(_Button2.default, {
	                                label: 'Cancel',
	                                onClick: this.cancelCreate,
	                                primary: true, style: { maginLeft: '10px' } })
	                        )
	                    ),
	                    this.showError()
	                )
	            );
	        }
	    }]);
	
	    return AddStems;
	}(_react.Component);
	
	// AddStems.prototype = {
	
	// }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        twigId: state.dashboard.twigId,
	        showStemAddForm: state.dashboard.showStemAddForm,
	        showToast: state.dashboard.showToast,
	        toastMessage: state.dashboard.toastMessage,
	        showAddStemError: state.dashboard.showAddStemError,
	        stemName: state.dashboard.stemName,
	        stemLocation: state.dashboard.stemLocation
	    };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(AddStems);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(twigObj, 'twigObj', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/AddStem.js');
	
	    __REACT_HOT_LOADER__.register(refs, 'refs', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/AddStem.js');
	
	    __REACT_HOT_LOADER__.register(AddStems, 'AddStems', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/AddStem.js');
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/AddStem.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/AddStem.js');
	}();

	;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _Article = __webpack_require__(62);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Map = __webpack_require__(428);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Section = __webpack_require__(54);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Footer = __webpack_require__(67);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _nav = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    return _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	
	      this.props.dispatch((0, _actions.loadSites)());
	      this.props.dispatch((0, _nav.navEnable)(true));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // this.props.dispatch(unloadDashboard());
	      // this._graphicSizer.stop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.userProfile) {
	        //console.log(this.props.userProfile.username);
	        heap.identify(this.props.userProfile.username);
	      }
	      return _react2.default.createElement(_Map2.default, null);
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	Dashboard.propTypes = {
	  dashboard: _react.PropTypes.object,
	  search: _react.PropTypes.object
	};
	
	var select = function select(state, props) {
	  return {
	    dashboard: state.dashboard,
	    userProfile: state.user.profile
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(Dashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Dashboard, 'Dashboard', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Dashboard.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Dashboard.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Dashboard.js');
	}();

	;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _googleMapReact = __webpack_require__(119);
	
	var _googleMapReact2 = _interopRequireDefault(_googleMapReact);
	
	var _Location = __webpack_require__(196);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _reactPlacesAutocomplete = __webpack_require__(157);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _reactRouter = __webpack_require__(43);
	
	var _actions = __webpack_require__(13);
	
	var _nav = __webpack_require__(28);
	
	var _Utility = __webpack_require__(37);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _MapOverlay = __webpack_require__(429);
	
	var _MapOverlay2 = _interopRequireDefault(_MapOverlay);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _ = __webpack_require__(27);
	// import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
	
	
	var mapComponent;
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.closeOverlay = _this.closeOverlay.bind(_this);
	    _this.mapClick = _this.mapClick.bind(_this);
	    _this.getCenter = _this.getCenter.bind(_this);
	    _this.mapLoaded = _this.mapLoaded.bind(_this);
	    _this.addSite = _this.addSite.bind(_this);
	    _this.updateSite = _this.updateSite.bind(_this);
	    _this.updateSiteLocation = _this.updateSiteLocation.bind(_this);
	    _this.markerClick = _this.markerClick.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.placesHandleSelect = _this.placesHandleSelect.bind(_this);
	    _this.onSiteNameChange = _this.onSiteNameChange.bind(_this);
	    _this.state = {
	      center: { lat: 37.09024, lng: -95.712891 },
	      showContextMenu: false,
	      contextMenTopPos: 0,
	      contextMenuLeftPos: 0,
	      markersArr: [],
	      showModalOverlay: false,
	      address: '',
	      zoom: 12,
	      siteName: ''
	    };
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _nav.navEnable)(true));
	      // this.getCenter(this.props.userProfile);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.userProfile && nextProps.userProfile.siteLocation) {
	        this.getCenter(nextProps.userProfile);
	      }
	      var sitesLocation = 0;
	
	      if (nextProps.sites && nextProps.sites.length > 0) {
	        var bounds = new google.maps.LatLngBounds();
	        var firstItem = '';
	        nextProps.sites.filter(function (site) {
	          return site != undefined && site.location !== undefined;
	        }).forEach(function (site) {
	          sitesLocation++;
	          firstItem = site.location;
	          bounds.extend(new google.maps.LatLng(site.location.latitude, site.location.longitude));
	        });
	        if (sitesLocation == 0) {
	          this.getCenter(this.props.userProfile);
	        }
	        if (sitesLocation == 1) {
	          this.setState({
	            center: { lat: firstItem.latitude, lng: firstItem.longitude },
	            zoom: 15
	          });
	        } else if (mapComponent) {
	          mapComponent.map.fitBounds(bounds);
	          mapComponent.maps.event.addListenerOnce(mapComponent.map, 'idle', function () {
	            var currentZoomLevel = mapComponent.map.getZoom();
	            mapComponent.map.setZoom(currentZoomLevel - 1);
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      mapComponent = '';
	    }
	  }, {
	    key: 'getCenter',
	    value: function getCenter(userProfile) {
	      var _this2 = this;
	
	      if (userProfile && userProfile.siteLocation) {
	        // console.log('setting location from userProfile.siteLocation : '+ userProfile.siteLocation);
	        this.setState({
	          center: {
	            lat: userProfile.siteLocation.latitude, lng: userProfile.siteLocation.longitude
	          }
	        });
	      } else if (navigator.geolocation) {
	
	        navigator.geolocation.getCurrentPosition(function (position) {
	
	          var postionObj = {
	            lat: position.coords.latitude, lng: position.coords.longitude
	            // console.log('postionObj::-', postionObj)
	          };_this2.setState({
	            center: postionObj
	          });
	        }, function (error) {
	          //set US location if browser location not available
	          // console.log('cant get navigator.geolocation, using US location.');
	          _this2.setState({
	            center: {
	              lat: 37.09024, lng: -95.712891
	            },
	            zoom: 5
	          });
	        });
	      } else {
	
	        //set US location
	        this.setState({
	          center: {
	            lat: 37.09024, lng: -95.712891
	          },
	          zoom: 5
	        });
	      }
	    }
	  }, {
	    key: 'mapClick',
	    value: function mapClick(e) {
	      this.setState({
	        showContextMenu: false,
	        contextMenTopPos: 0,
	        contextMenuLeftPos: 0
	      });
	    }
	  }, {
	    key: 'mapLoaded',
	    value: function mapLoaded(mapObj) {
	      var _this3 = this;
	
	      mapComponent = mapObj;
	      mapObj.map.addListener('rightclick', function (event) {
	
	        _this3.setState({
	          showContextMenu: true,
	          contextMenTopPos: event.pixel.y,
	          contextMenuLeftPos: event.pixel.x,
	          markerLat: event.latLng.lat(),
	          markerLong: event.latLng.lng()
	        });
	      });
	    }
	  }, {
	    key: 'addSite',
	    value: function addSite(obj) {
	      this.setState({
	        showContextMenu: false,
	        showModalOverlay: true,
	        updateSite: false,
	        siteName: ''
	      });
	    }
	  }, {
	    key: 'updateSite',
	    value: function updateSite(obj) {
	      this.setState({
	        showContextMenu: false,
	        showModalOverlay: true,
	        updateSite: true
	      });
	    }
	  }, {
	    key: 'updateSiteLocation',
	    value: function updateSiteLocation(siteInfo) {
	      this.closeOverlay();
	      var data = {
	        location: {
	          latitude: this.state.markerLat,
	          longitude: this.state.markerLong
	        }
	      };
	      if (this.state.updateSite) {
	        this.props.dispatch((0, _actions.updateSiteAction)(siteInfo, data));
	      } else {
	        data['name'] = siteInfo;
	        this.props.dispatch((0, _actions.addSiteAction)(data));
	      }
	    }
	  }, {
	    key: 'onSiteNameChange',
	    value: function onSiteNameChange(value) {
	      this.setState({
	        siteName: value
	      });
	    }
	  }, {
	    key: 'closeOverlay',
	    value: function closeOverlay() {
	      this.setState({
	        showModalOverlay: false,
	        siteName: ''
	      });
	    }
	  }, {
	    key: 'markerClick',
	    value: function markerClick(siteInfo, event) {
	      var sitename_enc = encodeURIComponent(siteInfo.name);
	      this.props.dispatch((0, _actions.clearTwigsList)());
	      _reactRouter.browserHistory.push({
	        pathname: _Constants2.default.ROUTES.SITEVIEW,
	        // search: '?name=' + sitename_enc,
	        state: siteInfo
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(address) {
	      this.setState({
	        address: address
	      });
	    }
	  }, {
	    key: 'placesHandleSelect',
	    value: function placesHandleSelect(address) {
	      var _this4 = this;
	
	      this.setState({
	        address: address
	      });
	      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
	        return (0, _reactPlacesAutocomplete.getLatLng)(results[0]);
	      }).then(function (_ref) {
	        var lat = _ref.lat,
	            lng = _ref.lng;
	
	        // console.log('Success Yay', { lat, lng })
	        _this4.setState({
	          center: {
	            lat: lat, lng: lng
	          },
	          zoom: 20
	        });
	      }).catch(function (error) {
	        // console.log('Error:', error)
	
	      });
	    }
	  }, {
	    key: 'onContextMenu',
	    value: function onContextMenu(event) {
	      // console.log('on context menu')
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var zoom = 11;
	      var containerStyle = {
	        height: '100%',
	        overflow: 'hidden'
	      };
	      var contextMenuStyle = {
	        display: this.state.showContextMenu ? 'block' : 'none',
	        top: this.state.contextMenTopPos,
	        left: this.state.contextMenuLeftPos
	      };
	      if (this.state.center) {
	
	        var markersComponents = this.props.sites.map(function (item, index) {
	          if (item && item.location) {
	            return _react2.default.createElement(MarkerComponent, { key: index, lat: item.location.latitude,
	              lng: item.location.longitude, markerClick: _this5.markerClick, siteInfo: item });
	          } else {
	            return null;
	          }
	        });
	        // console.log('-map-key-', window.googleMapKey)
	        var inputProps = {
	          type: "text",
	          placeholder: "🔍 Enter address",
	          value: this.state.address,
	          onChange: this.onChange
	        };
	        var AutocompleteItem = function AutocompleteItem(_ref2) {
	          var suggestion = _ref2.suggestion;
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-map-marker' }),
	            suggestion
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { style: containerStyle, className: 'dashboard-map' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dashboard-info show' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Enter address below to find location on map. Then right click on map to Add or Update Site location.'
	              )
	            ),
	            _react2.default.createElement(_reactPlacesAutocomplete2.default, {
	              inputProps: inputProps,
	              onSelect: this.placesHandleSelect,
	              onEnterKeyDown: this.placesHandleSelect,
	              autocompleteItem: AutocompleteItem
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'map-content', onContextMenu: this.onContextMenu.bind(this) },
	            _react2.default.createElement(
	              'span',
	              { style: contextMenuStyle, className: 'context-menu-style' },
	              _react2.default.createElement(
	                'button',
	                { className: 'first-btn', onClick: this.addSite },
	                'Add Site'
	              ),
	              _react2.default.createElement(
	                'button',
	                { onClick: this.updateSite },
	                'Update Site'
	              )
	            ),
	            _react2.default.createElement(
	              _googleMapReact2.default,
	              {
	                defaultCenter: this.state.center,
	                center: this.state.center,
	                defaultZoom: 12,
	                zoom: this.state.zoom,
	                onClick: this.mapClick,
	                options: {
	                  rotateControl: false,
	                  zoomControlOptions: {
	                    position: google.maps.ControlPosition.RIGHT_CENTER
	                  }
	                },
	                onGoogleApiLoaded: this.mapLoaded,
	                yesIWantToUseGoogleMapApiInternals: true,
	                ref: 'googleMap',
	                bootstrapURLKeys: {
	                  key: window.googleMapKey
	                }
	
	              },
	              _react2.default.createElement(CenterMarkerComponent, { lat: this.state.center.lat,
	                lng: this.state.center.lng }),
	              markersComponents
	            )
	          ),
	          _react2.default.createElement(_MapOverlay2.default, { show: this.state.showModalOverlay, isUpdate: this.state.updateSite, lat: this.state.markerLat, lng: this.state.markerLong, sites: this.props.sites, closeOverlay: this.closeOverlay, updateSiteLocation: this.updateSiteLocation, onSiteNameChange: this.onSiteNameChange, value: this.state.siteName })
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	Dashboard.propTypes = {
	  dashboard: _react.PropTypes.object,
	  search: _react.PropTypes.object
	};
	
	var select = function select(state, props) {
	  return {
	    sites: state.dashboard.sites,
	    userProfile: state.user.profile
	  };
	};
	
	var MarkerComponent = function (_Component2) {
	  _inherits(MarkerComponent, _Component2);
	
	  function MarkerComponent(props) {
	    _classCallCheck(this, MarkerComponent);
	
	    return _possibleConstructorReturn(this, (MarkerComponent.__proto__ || Object.getPrototypeOf(MarkerComponent)).call(this, props));
	  }
	
	  _createClass(MarkerComponent, [{
	    key: 'render',
	    value: function render() {
	      var divStyle = {
	        position: 'absolute',
	        top: 0,
	        'text-align': 'left',
	        width: '150px',
	        'font-size': '18px',
	        'text-shadow': '2px 2px 10px',
	        color: 'teal'
	      };
	      return _react2.default.createElement(
	        'span',
	        { className: 'marker-translate' },
	        _react2.default.createElement('img', { onClick: this.props.markerClick.bind(this, this.props.siteInfo), src: '/img/marker.png', title: this.props.siteInfo.name, alt: this.props.siteInfo.name }),
	        _react2.default.createElement(
	          'div',
	          { style: divStyle },
	          this.props.siteInfo.name
	        )
	      );
	    }
	  }]);
	
	  return MarkerComponent;
	}(_react.Component);
	
	var CenterMarkerComponent = function (_Component3) {
	  _inherits(CenterMarkerComponent, _Component3);
	
	  function CenterMarkerComponent(props) {
	    _classCallCheck(this, CenterMarkerComponent);
	
	    return _possibleConstructorReturn(this, (CenterMarkerComponent.__proto__ || Object.getPrototypeOf(CenterMarkerComponent)).call(this, props));
	  }
	
	  _createClass(CenterMarkerComponent, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'marker-translate' },
	        _react2.default.createElement('img', { src: '/img/center_marker.png' })
	      );
	    }
	  }]);
	
	  return CenterMarkerComponent;
	}(_react.Component);
	
	var _default = (0, _reactRedux.connect)(select)(Dashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapComponent, 'mapComponent', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Map.js');
	
	  __REACT_HOT_LOADER__.register(Dashboard, 'Dashboard', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Map.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Map.js');
	
	  __REACT_HOT_LOADER__.register(MarkerComponent, 'MarkerComponent', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Map.js');
	
	  __REACT_HOT_LOADER__.register(CenterMarkerComponent, 'CenterMarkerComponent', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Map.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/Map.js');
	}();

	;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var MapOverlay = function (_Component) {
	  _inherits(MapOverlay, _Component);
	
	  function MapOverlay(props) {
	    _classCallCheck(this, MapOverlay);
	
	    var _this = _possibleConstructorReturn(this, (MapOverlay.__proto__ || Object.getPrototypeOf(MapOverlay)).call(this, props));
	
	    _this.state = {
	      show: _this.props.show
	    };
	    _this.hideOverlay = _this.hideOverlay.bind(_this);
	    _this.updateSite = _this.updateSite.bind(_this);
	    _this.handleSiteNameChange = _this.handleSiteNameChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(MapOverlay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        show: nextProps.show
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'hideOverlay',
	    value: function hideOverlay() {
	      this.props.closeOverlay();
	    }
	  }, {
	    key: 'updateSite',
	    value: function updateSite() {
	      var siteInfo = '';
	      if (this.props.isUpdate) {
	        siteInfo = this.refs.selectedSite.value;
	      } else {
	        siteInfo = this.refs.siteName.value;
	      }
	
	      this.props.updateSiteLocation(siteInfo);
	      // this.props.closeOverlay();
	    }
	  }, {
	    key: 'handleSiteNameChange',
	    value: function handleSiteNameChange() {
	      this.props.onSiteNameChange(this.refs.siteName.value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var toRender = null;
	      if (this.props.isUpdate) {
	        toRender = [_react2.default.createElement(
	          'div',
	          { key: '0.1' },
	          'Link to Site'
	        ), _react2.default.createElement(
	          'select',
	          { key: '0.2', name: '', className: 'maxwidth', ref: 'selectedSite' },
	          this.props.sites.map(function (item, index) {
	            return _react2.default.createElement(
	              'option',
	              { key: index, value: item.id },
	              item.name
	            );
	          })
	        )];
	      } else {
	        toRender = [_react2.default.createElement(
	          'div',
	          { key: '0.3' },
	          'Create Site'
	        ), _react2.default.createElement('input', { key: '0.4', type: 'text', className: 'maxwidth', ref: 'siteName', placeholder: 'Enter site name.', value: this.props.value, onChange: this.handleSiteNameChange })];
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'map-overlay ' + (this.props.show ? 'show' : 'hide') },
	        _react2.default.createElement(
	          'div',
	          { className: 'map-overlay-content' },
	          toRender,
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-btn-container' },
	            _react2.default.createElement(_Button2.default, {
	              label: this.props.isUpdate ? 'Update' : 'Create',
	              onClick: this.updateSite,
	              primary: true,
	              className: 'mr-5' }),
	            _react2.default.createElement(_Button2.default, {
	              label: 'Cancel',
	              onClick: this.hideOverlay,
	              primary: true })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MapOverlay;
	}(_react.Component);
	
	var _default = MapOverlay;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(MapOverlay, 'MapOverlay', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/MapOverlay.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/dashboard/MapOverlay.js');
	}();

	;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Article = __webpack_require__(62);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Headline = __webpack_require__(68);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Section = __webpack_require__(54);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Search = __webpack_require__(102);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Title = __webpack_require__(55);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Tile = __webpack_require__(86);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _DateTime = __webpack_require__(120);
	
	var _DateTime2 = _interopRequireDefault(_DateTime);
	
	var _Form = __webpack_require__(53);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Value = __webpack_require__(124);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Select = __webpack_require__(122);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Split = __webpack_require__(70);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _CaretBack = __webpack_require__(71);
	
	var _CaretBack2 = _interopRequireDefault(_CaretBack);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _d3TimeFormat = __webpack_require__(100);
	
	var _d3Request = __webpack_require__(459);
	
	var _d3Scale = __webpack_require__(83);
	
	var _d3Format = __webpack_require__(33);
	
	var _reactStockcharts = __webpack_require__(687);
	
	var _series = __webpack_require__(771);
	
	var _scale = __webpack_require__(751);
	
	var _indicator = __webpack_require__(738);
	
	var _coordinates = __webpack_require__(723);
	
	var _annotation = __webpack_require__(696);
	
	var _tooltip = __webpack_require__(781);
	
	var _axes = __webpack_require__(700);
	
	var _helper = __webpack_require__(728);
	
	var _nav = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _ = __webpack_require__(27);
	//import {CSVLink, CSVDownload} from 'react-csv';
	
	// import { loadTwigs, changeDisplayOption } from '../../actions/locationView';
	
	// import Label from 'grommet/components/Label';
	
	// import  from 'grommet/components/Base';
	// import Chart, { Layers, Base, Axis, Grid, Area, Bar, Line, Marker, MarkerLabel, HotSpots } from 'grommet/components/chart/Chart';
	
	
	//import { ChartCanvas, Chart, series, scale, coordinates, tooltip, axes, helper, indicator, annotation } from "react-stockcharts";
	
	//var { EdgeIndicator } = coordinates;
	
	//var { BarSeries, LineSeries, AreaSeries, ScatterSeries, CircleMarker, SquareMarker, TriangleMarker } = series;
	
	
	//var { discontinuousTimeScaleProvider } = scale;
	
	
	//var { ema, sma } = indicator;
	
	
	//var { CrossHairCursor, MouseCoordinateX, MouseCoordinateY } = coordinates;
	
	
	//var { Label } = annotation;
	
	
	//var { OHLCTooltip, HoverTooltip, MovingAverageTooltip } = tooltip;
	
	
	//var { XAxis, YAxis } = axes;
	
	
	//var { fitWidth } = helper;
	
	
	var chartOptions = {
	  height: 200,
	  width: 1000,
	  margin: { left: 130, right: 100, top: 20, bottom: 30 },
	  showGrid: false
	};
	var chartHeadingStyle = {
	  fontWeight: 'bold',
	  marginTop: '15px'
	};
	var chartSubMinMaxStyle = {
	  fontWeight: 'initial'
	};
	var gridHeight = chartOptions.height - chartOptions.margin.top - chartOptions.margin.bottom;
	var gridWidth = chartOptions.width - chartOptions.margin.left - chartOptions.margin.right;
	
	var yGrid = chartOptions.showGrid ? {
	  innerTickSize: -1 * gridWidth,
	  tickStrokeDasharray: 'Solid',
	  tickStrokeOpacity: 0.5,
	  tickStroke: "#FFFFFF",
	  tickStrokeWidth: 1
	} : {};
	var xGrid = chartOptions.showGrid ? {
	  innerTickSize: -1 * gridHeight,
	  tickStrokeDasharray: 'Solid',
	  tickStrokeOpacity: 0.2,
	  tickStrokeWidth: 1,
	  showTicks: false
	} : {};
	var smaFunction = '';
	
	var chartData = [];
	// var sma20 = sma()
	//   .windowSize(this.props.trendAverage)
	//   .sourcePath("yValue")
	//   .merge((d, c) => { d.sma20 = c })
	//   .accessor(d => d.sma20)
	//   .stroke("blue");
	
	var LocationView = function (_Component) {
	  _inherits(LocationView, _Component);
	
	  function LocationView(props) {
	    _classCallCheck(this, LocationView);
	
	    // this._onStartDateChange = this._onStartDateChange.bind(this);
	    var _this = _possibleConstructorReturn(this, (LocationView.__proto__ || Object.getPrototypeOf(LocationView)).call(this, props));
	
	    _this._onHoverChart = _this._onHoverChart.bind(_this);
	    _this.getLabelX = _this.getLabelX.bind(_this);
	    _this.getLabelY = _this.getLabelY.bind(_this);
	    _this._tickFormat = _this._tickFormat.bind(_this);
	    // this._updateChart = this._updateChart.bind(this);
	    // this._selectTwig = this._selectTwig.bind(this);
	
	    // this.renderTwigCheckboxes = this.renderTwigCheckboxes.bind(this);
	    _this.renderCharts = _this.renderCharts.bind(_this);
	    // this._changeDisplayOption = this._changeDisplayOption.bind(this);
	    // this.props.dispatch(loadTwigs())
	    // this._setDocumentTitle(props);
	    _this.state = {
	      selectedTwigIndex: 0,
	      cpuIndex: 0, memoryIndex: 0, storageIndex: 0
	    };
	    return _this;
	  }
	
	  _createClass(LocationView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // this.props.dispatch(navEnable(false));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var trendAverage = Number(nextProps.trendAverage);
	
	      smaFunction = (0, _indicator.sma)().options({ windowSize: trendAverage, sourcePath: "yValue" }).merge(function (d, c) {
	        d.smaFunction = c;
	      }).accessor(function (d) {
	        return d.smaFunction;
	      }).stroke("blue");
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var sectionElement = _reactDom2.default.findDOMNode(this.refs.sectionElement);
	      if (sectionElement) {
	        chartOptions.width = sectionElement.clientWidth - 50;
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      var sectionElement = _reactDom2.default.findDOMNode(this.refs.sectionElement);
	      if (sectionElement) {
	        chartOptions.width = sectionElement.clientWidth - 50;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: '_onHoverChart',
	    value: function _onHoverChart(e) {
	      // console.log('dateL--', e)
	    }
	  }, {
	    key: 'getLabelX',
	    value: function getLabelX() {
	      return 100;
	    }
	  }, {
	    key: 'getLabelY',
	    value: function getLabelY() {
	      return 10;
	    }
	  }, {
	    key: '_getOrderedArr',
	    value: function _getOrderedArr(obj) {
	      var arr = [];
	
	      var addToIndex = 0;
	      Object.keys(obj).map(function (key, index) {
	        // debugger
	
	        if (key.search('onboard') > -1) {
	          arr[0] = [key, obj[key]];
	          addToIndex = addToIndex + 1;
	        }
	        if (key.indexOf(_Constants2.default.CHART_OPTIONS.TOP) !== -1) {
	          arr[0 + addToIndex] = [_Constants2.default.CHART_OPTIONS.TOP, obj[key]];
	        } else if (key.indexOf(_Constants2.default.CHART_OPTIONS.MIDDLE) !== -1) {
	          arr[1 + addToIndex] = [_Constants2.default.CHART_OPTIONS.MIDDLE, obj[key]];
	        } else if (key.indexOf(_Constants2.default.CHART_OPTIONS.BOTTOM) !== -1) {
	          arr[2 + addToIndex] = [_Constants2.default.CHART_OPTIONS.BOTTOM, obj[key]];
	        }
	        // let lastLetter = key.substr(key.length - 1, 1)
	        // switch (lastLetter) {
	        //   //case constants.CHART_OPTIONS.TOP
	        //   case constants.CHART_OPTIONS.TOP:
	        //     arr[0 + addToIndex] = [lastLetter, obj[key]];
	        //     break;
	        //   case constants.CHART_OPTIONS.MIDDLE:
	        //     arr[1 + addToIndex] = [lastLetter, obj[key]];
	        //     break;
	        //   case constants.CHART_OPTIONS.BOTTOM:
	        //     arr[2 + addToIndex] = [lastLetter, obj[key]];
	        //     break;
	        //   default:
	        //     break
	        // }
	      });
	      return arr;
	    }
	
	    // _pad(number) {
	    //   if (number < 10) {
	    //     return '0' + number;
	    //   }
	    //   return number;
	    // }
	
	  }, {
	    key: '_getDateValue',
	    value: function _getDateValue(date) {
	      var MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
	      var dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	      var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
	      var mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	
	      return date.getFullYear().toString() + '-' + MM + '-' + dd + ' ' + hh + ':' + mm;
	      //return date.getFullYear().toString()+ '-' + this._pad(date.getMonth() + 1) + '-' + this._pad(date.getDate()) + ' ' + this._pad(date.getHours()) + ':' + this._pad(date.getMinutes());
	      //return (date.getMonth() + 1) + '-' + date.getDate() + '-' + date.getFullYear().toString() + ' ' + date.getHours() + ':' + date.getMinutes();
	    }
	  }, {
	    key: '_tooltipContent',
	    value: function _tooltipContent(calculators) {
	      var _this2 = this;
	
	      return function (_ref) {
	        var currentItem = _ref.currentItem,
	            xAccessor = _ref.xAccessor;
	
	        //console.log(this.props);
	        var labels = [];
	        if (_this2.props.showRawGraph) labels.push({ label: "Raw Value", value: currentItem.yValue.toFixed(4) });
	        if (_this2.props.showTrendLine) labels.push({ label: "Trend Value", value: currentItem.smaFunction ? currentItem.smaFunction.toFixed(4) : '' });
	        labels.push({ label: "Upper Limit", value: currentItem.topLine });
	        labels.push({ label: "Lower Limit", value: currentItem.bottomLine });
	
	        return {
	          x: _this2._getDateValue(currentItem.xValue),
	          y: labels
	        };
	      };
	    }
	  }, {
	    key: '_displayXValue',
	    value: function _displayXValue(a) {
	      // console.log('aaaa---', a)
	      // timeFormat("%d-%m-%y %h")
	    }
	  }, {
	    key: '_tickFormat',
	    value: function _tickFormat(e) {
	      var date = chartData[e].xValue;
	      return date.getMonth() + 1 + '-' + date.getDate() + '-' + date.getFullYear().toString().substr(-2) + ' ' + date.getHours() + 'h';
	    }
	  }, {
	    key: 'renderCharts',
	    value: function renderCharts() {
	      var _this3 = this;
	
	      // console.log('chartData::', this.props.chartData);
	      // this.props.dispatch(showLoader(true));
	      var responsive = this.props.nav.responsive;
	
	      try {
	        var chartsArr = [];
	        var chart = [];
	
	        if (this.props.chartData && this.props.chartData != 'loading' && this.props.showChart) {
	          var allObjects = Object.entries(this.props.selectedTwig.details.data);
	          var filterObjects = allObjects.sort(function (a, b) {
	            return a[1].sort_order - b[1].sort_order;
	          });
	          /*
	            --> Display order of charts based on sort_order present inside selectedTwig.
	            --> first sort array of selectedTwig details, then compare selectedTwig array to 
	                chartsData array to make it the same order.
	            --> finally remove "aw"(Available Water) present inside chartsData array.  
	          */
	          var allChartsData = Object.entries(this.props.chartData);
	          var filterChartsData = allChartsData.sort(function (a, b) {
	            return filterObjects.findIndex(function (each) {
	              return each[0] === a[0];
	            }) - filterObjects.findIndex(function (each) {
	              return each[0] === b[0];
	            });
	          }).filter(function (eachChart) {
	            return !eachChart[0].includes('aw') && !eachChart[0].includes('salinity');
	          });
	          filterChartsData.map(function (eachTwig, twigIndex) {
	            var twigKey = eachTwig[0];
	            var twigItem = eachTwig[1];
	            if (twigItem) {
	
	              var chartArrInOrder = _this3._getOrderedArr(twigItem);
	
	              chartArrInOrder.map(function (subArr, index) {
	                var key = subArr[0];
	                chart = _.cloneDeep(subArr[1]);
	                if (chart.length && chart.length > 0) {
	                  var highest = 0;
	                  var lowest = 10000;
	                  chart.forEach(function (d, i) {
	                    if (d.yValue <= lowest) {
	                      lowest = d.yValue;
	                    }
	                    if (d.yValue >= highest) {
	                      highest = d.yValue;
	                    }
	                    // d.xValue = new Date(d.xValue);
	                    d.xValue = new Date(d.xValue);
	                  });
	                  chart.reverse();
	
	                  var sensor = _this3.props.selectedTwig.details.data[twigKey];
	                  var sensorName = _this3.props.selectedTwig.settings.sensorName;
	                  var maxValue = '';
	                  var minValue = '';
	                  var lineColor = '';
	                  var subTitile = '';
	                  if (key.search('onboard') > -1) {
	                    lineColor = '#a308e6'; // green
	                    subTitile = '';
	                  }
	                  if (sensor) {
	                    switch (key) {
	                      case _Constants2.default.CHART_OPTIONS.TOP:
	                        lineColor = '#0be039'; // green
	                        subTitile = sensorName && sensorName.value[0] ? '- ' + sensorName.value[0]["1"] || '- Top' : '- ';
	                        maxValue = sensor.multivalue_max ? sensor.multivalue_max.Top : sensor.max_value;
	                        minValue = sensor.multivalue_min ? sensor.multivalue_min.Top : sensor.min_value;
	                        break;
	                      case _Constants2.default.CHART_OPTIONS.MIDDLE:
	                        lineColor = '#fce705'; //yellow
	                        subTitile = sensorName && sensorName.value[1] ? '- ' + sensorName.value[1]["2"] || '- Middle' : '- ';
	                        maxValue = sensor.multivalue_max ? sensor.multivalue_max.Middle : sensor.max_value;
	                        minValue = sensor.multivalue_min ? sensor.multivalue_min.Middle : sensor.min_value;
	                        break;
	                      case _Constants2.default.CHART_OPTIONS.BOTTOM:
	                        lineColor = '#fc0b07'; //red
	                        subTitile = sensorName && sensorName.value[2] ? '- ' + sensorName.value[2]["3"] || '- Bottom' : '- ';
	                        maxValue = sensor.multivalue_max ? sensor.multivalue_max.Bottom : sensor.max_value;
	                        minValue = sensor.multivalue_min ? sensor.multivalue_min.Bottom : sensor.min_value;
	                        break;
	                      default:
	                        maxValue = sensor.max_value;
	                        minValue = sensor.min_value;
	                        break;
	                    }
	                  } else return;
	
	                  // let maxValue = this.props.selectedTwig.details.data[twigKey].max_value != null ? this.props.selectedTwig.details.data[twigKey].max_value : false;
	                  // let minValue = this.props.selectedTwig.details.data[twigKey].min_value != null ? this.props.selectedTwig.details.data[twigKey].min_value : false;
	                  chart.forEach(function (d, i) {
	                    d['topLine'] = maxValue;
	                    d['bottomLine'] = minValue;
	                  });
	                  chartData = _.cloneDeep(chart);
	
	                  //let highestValue = ((highest > maxValue) && (this.props.showUpperLimit)) ? highest + (highest * 20 / 100) : maxValue;
	
	                  // highestValue = highestValue + (highestValue * 15 / 100);
	
	                  //let lowestValue = ((lowest < minValue) && (this.props.showLowerLimit)) ? lowest - (lowest * 20 / 100) : minValue;
	                  var highestValue = highest + highest * 5.0 / 100;
	                  var lowestValue = lowest - lowest * 5.0 / 100;
	                  if (_this3.props.showUpperLimit && maxValue != null) {
	                    highestValue = highest > maxValue ? highestValue : maxValue;
	                  }
	                  if (_this3.props.showLowerLimit && minValue != null) {
	                    lowestValue = lowest < minValue ? lowestValue : minValue;
	                  }
	                  //console.log('highest : ' + highestValue + ' lowest : ' + lowestValue );
	                  // let percentToleration = (lowestValue * 5 / 100);
	                  // percentToleration = percentToleration < 0 ? percentToleration * -1 : percentToleration;
	                  // lowestValue = lowestValue - (percentToleration)
	
	                  var yExtents = '';
	                  //{[d => [d.high, d.low], ema20.accessor(), ema50.accessor()]}
	                  if (_this3.props.showUpperLimit && maxValue != null || _this3.props.showLowerLimit && minValue != null) {
	                    yExtents = [Number(highestValue), Number(lowestValue)];
	                    // yExtents = [minValue, maxValue]
	                  } else {
	                    // yExtents = [highest, lowest]
	                    yExtents = function yExtents(d) {
	                      return [d.yValue, smaFunction.accessor()];
	                    };
	                  }
	                  //  yExtents = {[d => [d.yValue, smaFunction.accessor()], highestValue, lowestValue]}
	                  // let lastLetter = key.substr(key.length - 1, 1)
	                  // if (key.search('onboard') > -1) {
	                  //   lineColor = '#a308e6'; // green
	                  //   subTitile = '';
	                  // }
	                  // switch (key) {
	                  //   case constants.CHART_OPTIONS.TOP:
	                  //     lineColor = '#0be039'; // green
	                  //     subTitile = '- Top';
	                  //     break;
	                  //   case constants.CHART_OPTIONS.MIDDLE:
	                  //     lineColor = '#fce705'; //yellow
	                  //     subTitile = '- Middle';
	                  //     break;
	                  //   case constants.CHART_OPTIONS.BOTTOM:
	                  //     lineColor = '#fc0b07'; //red
	                  //     subTitile = '- Bottom';
	                  //     break;
	                  //   default:
	                  //     break
	                  // }
	                  var xtentArr = [chart[0].xValue, chart[chart.length - 1].xValue];
	                  // let b = new Date(chart[0].xValue)
	                  // b.setMinutes(b.getMinutes() - 1);
	                  // xtentArr.push(b);
	
	                  /**** */
	
	                  /*** */
	                  var chartsType = [];
	                  var hoverSize = 95;
	                  if (_this3.props.showRawGraph && _this3.props.showTrendLine) {
	                    chartsType.push(_react2.default.createElement(_series.LineSeries, {
	                      key: twigIndex + '_' + '001',
	                      yAccessor: function yAccessor(d) {
	                        return d.yValue;
	                      },
	                      stroke: lineColor
	                      //interpolation={curveBasis}
	                      , strokeDasharray: 'Solid' }));
	                    chartsType.push(_react2.default.createElement(_series.LineSeries, { key: twigIndex + '_' + '002', yAccessor: smaFunction.accessor(), stroke: smaFunction.stroke(), strokeDasharray: 'Solid' //interpolation={curveBasis}
	                    }));
	                  } else if (_this3.props.showTrendLine) {
	                    chartsType.push(_react2.default.createElement(_series.LineSeries, { key: twigIndex + '_' + '001', yAccessor: smaFunction.accessor(), stroke: smaFunction.stroke(), strokeDasharray: 'Solid' //interpolation={curveBasis}
	                    }));
	
	                    hoverSize = 80;
	                  } else if (_this3.props.showRawGraph) {
	                    chartsType.push(_react2.default.createElement(_series.LineSeries, { key: twigIndex + '_' + '001',
	                      yAccessor: function yAccessor(d) {
	                        return d.yValue;
	                      },
	                      stroke: lineColor
	                      // interpolation={curveBasis}
	                      , strokeDasharray: 'Solid' }));
	
	                    hoverSize = 80;
	                  }
	
	                  if (_this3.props.showUpperLimit && maxValue != null) {
	                    chartsType.push(_react2.default.createElement(_series.LineSeries, {
	                      key: twigIndex + '_' + '003',
	                      yAccessor: function yAccessor(d) {
	                        return d.topLine;
	                      },
	                      stroke: '#040404',
	                      strokeDasharray: 'Solid' }));
	                  }
	                  if (_this3.props.showLowerLimit && minValue != null) {
	                    chartsType.push(_react2.default.createElement(_series.LineSeries, {
	                      key: twigIndex + '_' + '004',
	                      yAccessor: function yAccessor(d) {
	                        return d.bottomLine;
	                      },
	                      stroke: '#ff06ad',
	                      strokeDasharray: 'Solid' }));
	                  }
	
	                  var headers = [{ label: "Time",
	                    key: "xValue"
	                  }, { label: "Value",
	                    key: "yValue"
	                  }, { label: "Maximum Threshold value",
	                    key: "topLine"
	                  }, { label: "Minimum Threshold value",
	                    key: "bottomLine"
	                  }];
	
	                  //const { type, data: chart, width, ratio } = this.props;
	
	                  var calculatedData = smaFunction(chart);
	                  var xScaleProvider = _scale.discontinuousTimeScaleProvider.inputDateAccessor(function (d) {
	                    return d.xValue;
	                  });
	
	                  var _xScaleProvider = xScaleProvider(calculatedData),
	                      data = _xScaleProvider.data,
	                      xScale = _xScaleProvider.xScale,
	                      xAccessor = _xScaleProvider.xAccessor,
	                      displayXAccessor = _xScaleProvider.displayXAccessor;
	
	                  chartsArr.push([_react2.default.createElement(
	                    'div',
	                    { style: chartHeadingStyle, key: twigIndex + '_' + '006' },
	                    sensor.label + ' ' + subTitile + ' ' + '(' + sensor.Unit + ')',
	                    _react2.default.createElement(
	                      'div',
	                      { style: chartSubMinMaxStyle },
	                      'Upper Limit: ' + maxValue + ' Lower Limit: ' + minValue
	                    )
	                  ), _react2.default.createElement(
	                    _reactStockcharts.ChartCanvas,
	                    _extends({ key: twigKey + '_' + index, ratio: 0, width: chartOptions.width, height: chartOptions.height
	                    }, responsive === 'multiple' ? { margin: chartOptions.margin } : undefined, {
	                      type: 'svg',
	                      plotFull: true,
	                      pointsPerPxThreshold: 5,
	                      seriesName: twigKey + '_' + index,
	                      data: chart,
	                      xAccessor: function xAccessor(d) {
	                        return d.xValue;
	                      }
	                      //xScaleProvider={discontinuousTimeScaleProvider}
	                      , xScale: (0, _d3Scale.scaleTime)(),
	                      calculator: [smaFunction]
	                    }),
	                    _react2.default.createElement(
	                      _reactStockcharts.Chart,
	                      { id: 1, key: twigIndex + '_' + '007',
	                        yExtents: yExtents
	                      },
	                      _react2.default.createElement(_axes.XAxis, _extends({ axisAt: 'bottom',
	                        orient: 'bottom',
	                        showTicks: true,
	                        ticks: 5
	                      }, xGrid, { key: twigIndex + '_' + '008' })),
	                      _react2.default.createElement(_axes.YAxis, _extends({
	                        axisAt: 'left',
	                        orient: 'left',
	                        ticks: 5
	                      }, yGrid, {
	                        key: twigIndex + '_' + '009' })),
	                      chartsType,
	                      _react2.default.createElement(_coordinates.MouseCoordinateX, {
	                        rectWidth: 150,
	                        at: 'bottom',
	                        orient: 'bottom',
	                        fill: "#455967",
	                        bgFill: "#455967",
	                        displayFormat: _this3._getDateValue })
	                    ),
	                    _react2.default.createElement(_tooltip.HoverTooltip, {
	                      chartId: 1,
	                      bgheight: hoverSize,
	                      bgwidth: 160,
	                      fill: "#455967",
	                      bgFill: "#455967",
	                      stroke: "white",
	                      fontFill: "white",
	                      tooltipContent: _this3._tooltipContent([]),
	                      fontSize: 15 }),
	                    _react2.default.createElement(_coordinates.CrossHairCursor, null)
	                  )]);
	                };
	                // }
	              });
	            }
	          });
	          // this.props.dispatch(showLoader(false));
	          if (chartsArr.length > 0) {
	            return chartsArr;
	          } else {
	            return _react2.default.createElement(
	              'h2',
	              null,
	              'No data'
	            );
	          }
	        } else if (this.props.chartData == 'loading') {
	          return null;
	        } else if (!this.props.showChart) {
	          // this.props.dispatch(showLoader(false));
	          return _react2.default.createElement(
	            'h2',
	            null,
	            'No data'
	          );
	        } else {
	          // this.props.dispatch(showLoader(false));
	          return null;
	        }
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.zoom && document.getElementsByClassName('stemdetails-section')[0]) {
	        chartOptions['height'] = screen.availHeight - document.getElementsByClassName('stemdetails-section')[0].clientHeight - 150;
	      } else chartOptions['height'] = 200;
	      return _react2.default.createElement(
	        _Section2.default,
	        { pad: 'small',
	          justify: 'center',
	          align: 'start',
	          ref: 'sectionElement' },
	        this.renderCharts()
	      );
	    }
	  }]);
	
	  return LocationView;
	}(_react.Component);
	
	LocationView.propTypes = {
	  twigsList: _react.PropTypes.array,
	  search: _react.PropTypes.object
	};
	
	var select = function select(state, props) {
	  return {
	    twigsList: state.locationView.twigsList,
	    selectedTwig: state.locationView.selectedTwig,
	    chartData: state.locationView.chartData,
	    resolution: state.locationView.resolution,
	    showChart: state.locationView.showChart,
	    showRawGraph: state.locationView.showRawGraph,
	    showTrendLine: state.locationView.showTrendLine,
	    trendAverage: state.locationView.trendAverage,
	    showUpperLimit: state.locationView.showUpperLimit,
	    showLowerLimit: state.locationView.showLowerLimit,
	    zoom: state.locationView.zoom,
	    chosenTwig: state.locationView.chosenTwig,
	    nav: state.nav
	    // search: state.search
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(LocationView);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(chartOptions, 'chartOptions', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(chartHeadingStyle, 'chartHeadingStyle', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(chartSubMinMaxStyle, 'chartSubMinMaxStyle', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(gridHeight, 'gridHeight', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(gridWidth, 'gridWidth', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(yGrid, 'yGrid', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(xGrid, 'xGrid', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(smaFunction, 'smaFunction', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(chartData, 'chartData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(LocationView, 'LocationView', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ChartView.js');
	}();

	;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _status = __webpack_require__(65);
	
	var _nav = __webpack_require__(28);
	
	var _locationView = __webpack_require__(61);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Utility = __webpack_require__(37);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _CaretBack = __webpack_require__(71);
	
	var _CaretBack2 = _interopRequireDefault(_CaretBack);
	
	var _Close = __webpack_require__(63);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Paragraph = __webpack_require__(85);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _reactStripeElements = __webpack_require__(406);
	
	var _reactStripeCheckout = __webpack_require__(790);
	
	var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _ = __webpack_require__(27);
	//import Form from 'grommet/components/Form';
	
	var LocationView = function (_Component) {
	  _inherits(LocationView, _Component);
	
	  function LocationView(props) {
	    _classCallCheck(this, LocationView);
	
	    var _this = _possibleConstructorReturn(this, (LocationView.__proto__ || Object.getPrototypeOf(LocationView)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.getPlaceHolder = _this.getPlaceHolder.bind(_this);
	    _this.goToSubscriptionView = _this.goToSubscriptionView.bind(_this);
	    _this.handleConfirmation = _this.handleConfirmation.bind(_this);
	    _this.validateCouponCode = _this.validateCouponCode.bind(_this);
	    _this.closeConfirmationDialog = _this.closeConfirmationDialog.bind(_this);
	    _this.showCouponDetails = _this.showCouponDetails.bind(_this);
	    _this.rememberCardData = _this.rememberCardData.bind(_this);
	    _this.paymentInformationSection = _this.paymentInformationSection.bind(_this);
	    _this.bindCouponData = _this.bindCouponData.bind(_this);
	
	    _this.state = {
	      couponDetails: null,
	      showConfirmationDialog: false,
	      paymentInformation: null,
	      showError: false,
	      selectedPlan: null
	    };
	    return _this;
	  }
	
	  _createClass(LocationView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'validateCouponCode',
	    value: function validateCouponCode() {
	      var couponCode = this.refs.couponCode.value;
	      var appliedCoupon = this.props.couponDetails;
	      if (!appliedCoupon || !appliedCoupon.coupon || appliedCoupon && (appliedCoupon.coupon.code && appliedCoupon.coupon.code !== couponCode || appliedCoupon.coupon.id && appliedCoupon.coupon.id !== couponCode)) this.props.dispatch((0, _locationView.validateCouponCode)(couponCode));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(ev) {
	      var _this2 = this;
	
	      // We don't want to let default form submission happen here, which would refresh the page.
	      ev.preventDefault();
	      var coupon = void 0;
	      var selectedPlan = this.props.selectedPlan;
	      var selectedTwig = this.props.selectedTwig;
	      var twigIndex = this.props.selectedTwigIndex;
	      var rememberMe = this.props.rememberMe ? true : false;
	
	      // Within the context of `Elements`, this call to createToken knows which Element to
	      // tokenize, since there's only one in this group.
	      var email = ev.target.elements['email'].value;
	      var name = email;
	      if (this.props.couponDetails && this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid) {
	        var isTrialCoupon = this.props.couponDetails.isTrialCoupon ? true : false;
	        coupon = {
	          code: ev.target.elements['coupon'].value,
	          isTrialCoupon: isTrialCoupon,
	          details: this.props.couponDetails.coupon
	        };
	      }
	      var tokens = void 0;
	      this.props.dispatch((0, _status.showLoader)(true));
	      // console.log(this.props);
	      if (this.props.couponDetails && this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid && this.props.couponDetails.coupon.percent_off === 100 && this.props.couponDetails.coupon.duration === "forever") /*|| this.calculateAmount() == 0*/{
	          this.props.dispatch((0, _status.showLoader)(false));
	          this.props.dispatch((0, _locationView.initializePaymentInformation)({ customerToken: null, coupon: coupon, selectedTwig: selectedTwig, selectedPlan: selectedPlan, rememberMe: rememberMe, twigIndex: twigIndex, email: email }));
	          this.props.dispatch((0, _locationView.handlePaymentInfoSubmission)({ showConfirmationDialog: !this.props.showConfirmationDialog, showError: false }));
	        } else if (!this.props.savedCard) {
	        this.props.stripe.createToken({ name: name }).then(function (customerToken) {
	          if (customerToken && !customerToken.error) {
	            customerToken.email = email;
	            _this2.props.dispatch((0, _status.showLoader)(false));
	            _this2.props.dispatch((0, _locationView.initializePaymentInformation)({ customerToken: customerToken, coupon: coupon, selectedTwig: selectedTwig, selectedPlan: selectedPlan, rememberMe: rememberMe, twigIndex: twigIndex }));
	            _this2.props.dispatch((0, _locationView.handlePaymentInfoSubmission)({ showConfirmationDialog: !_this2.props.showConfirmationDialog, showError: false }));
	          } else {
	            _this2.props.dispatch((0, _locationView.handlePaymentInfoSubmission)({ showError: true }));
	            _this2.props.dispatch((0, _status.showLoader)(false));
	          }
	        });
	      } else {
	        var savedCard = this.props.savedCard;
	        this.props.dispatch((0, _status.showLoader)(false));
	        this.props.dispatch((0, _locationView.initializePaymentInformation)({ coupon: coupon, selectedTwig: selectedTwig, selectedPlan: selectedPlan, rememberMe: rememberMe, savedCard: savedCard, twigIndex: twigIndex }));
	        this.props.dispatch((0, _locationView.handlePaymentInfoSubmission)({ showConfirmationDialog: !this.props.showConfirmationDialog, showError: false }));
	      }
	    }
	  }, {
	    key: 'getPlaceHolder',
	    value: function getPlaceHolder(type) {
	      var placeholder = void 0;
	      switch (type) {
	        case _Constants2.default.STRIPE_PLACEHOLDER.CARD_NUMBER:
	          placeholder = "Card Number *";
	          break;
	        case _Constants2.default.STRIPE_PLACEHOLDER.EXPIRY:
	          placeholder = "Expiry *";
	          break;
	        case _Constants2.default.STRIPE_PLACEHOLDER.CVC:
	          placeholder = "CVC *";
	          break;
	        default:
	          placeholder = "Please enter valid data";
	          break;
	      }
	      return placeholder;
	    }
	  }, {
	    key: 'goToSubscriptionView',
	    value: function goToSubscriptionView() {
	      this.props.dispatch((0, _locationView.addSubscription)(!this.props.showSubscriptionForm));
	    }
	  }, {
	    key: 'handleConfirmation',
	    value: function handleConfirmation() {
	      var payload = {
	        showSubscriptionForm: !this.props.showSubscriptionForm,
	        showStripePlans: !this.props.showStripePlans,
	        paymentInformation: this.props.paymentInformation,
	        selectedTwig: this.props.selectedTwig
	
	      };
	      if (this.props.paymentInformation) {
	        this.props.dispatch((0, _locationView.createSubscription)(payload));
	      }
	      this.props.dispatch((0, _locationView.handlePaymentInfoSubmission)({ showConfirmationDialog: !this.props.showConfirmationDialog }));
	      this.props.dispatch((0, _nav.navEnable)(false));
	    }
	  }, {
	    key: 'getConfirmationContent',
	    value: function getConfirmationContent() {
	      var message = void 0;
	      if (this.props.selectedPlan) {
	        var interval_count = this.props.selectedPlan.interval_count != 1 ? '' + this.props.selectedPlan.interval_count : '';
	
	        if (this.props.couponDetails && this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid) {
	          if (this.props.couponDetails.isTrialCoupon) {
	            message = 'A trial period of ' + this.props.couponDetails.coupon.duration + ' days is applied to your subscription. You will be charged $' + (0, _Utility.roundOffDecimals)(this.props.selectedPlan.amount / 100, 2) + ' every ' + count + ' ' + this.props.selectedPlan.interval + ' for Stem ' + this.props.selectedTwig.name + '/' + this.props.selectedTwig.twigId + ' starting from date ' + new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString() + '. We will auto-renew\n          subscription at the end of every ' + interval_count + ' ' + this.props.selectedPlan.interval + '. Click Submit to confirm subscription';
	          } else {
	            var discount = this.props.couponDetails.coupon.amount_off ? '$' + (0, _Utility.roundOffDecimals)(this.props.couponDetails.coupon.amount_off / 100, 2) : this.props.couponDetails.coupon.percent_off + ' %';
	            message = 'A discount of ' + discount + ' is applied to the first billing cycle of your subscription. The net amount payable for the first billing cycle of your subscription is $' + this.calculateAmount() + '. You will be charged $' + (0, _Utility.roundOffDecimals)(this.props.selectedPlan.amount / 100, 2) + ' every ' + interval_count + ' ' + this.props.selectedPlan.interval + ' for Stem ' + this.props.selectedTwig.name + '/' + this.props.selectedTwig.twigId + ' from the subsequent billing cycles. We will auto-renew subscription at the end of every ' + interval_count + ' ' + this.props.selectedPlan.interval + '. Click Submit to confirm subscription';
	          }
	        } else {
	          message = 'You will be charged $' + (0, _Utility.roundOffDecimals)(this.props.selectedPlan.amount / 100, 2) + ' every ' + interval_count + ' ' + this.props.selectedPlan.interval + ' for Stem ' + this.props.selectedTwig.name + '/' + this.props.selectedTwig.twigId + '. We will auto-renew subscription at the end of every ' + interval_count + ' ' + this.props.selectedPlan.interval + '. Click Submit to confirm subscription';
	        }
	        return _react2.default.createElement(
	          _Heading2.default,
	          { strong: false,
	            align: 'center',
	            margin: 'small',
	            tag: 'h3' },
	          message
	        );
	      }
	    }
	  }, {
	    key: 'closeConfirmationDialog',
	    value: function closeConfirmationDialog() {
	      this.props.dispatch((0, _locationView.handlePaymentInfoSubmission)(!this.props.showConfirmationDialog));
	    }
	  }, {
	    key: 'rememberCardData',
	    value: function rememberCardData() {
	      var coupon = '';
	      if (this.refs && this.refs['couponCode'].value) {
	        coupon = this.refs['couponCode'].value;
	      }
	      this.props.dispatch((0, _locationView.rememberCardData)(!this.props.rememberMe));
	      this.props.dispatch((0, _locationView.rebindCouponData)(coupon));
	    }
	  }, {
	    key: 'bindCouponData',
	    value: function bindCouponData() {
	      var coupon = '';
	      if (this.refs && this.refs['couponCode'].value) {
	        coupon = this.refs['couponCode'].value;
	      }
	      this.props.dispatch((0, _locationView.rebindCouponData)(coupon));
	    }
	  }, {
	    key: 'showConfirmation',
	    value: function showConfirmation() {
	      return this.props.showConfirmationDialog ? _react2.default.createElement(
	        _Layer2.default,
	        { flush: true,
	          onClose: this.closeConfirmationDialog },
	        _react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Close2.default, null),
	          onClick: this.closeConfirmationDialog,
	          plain: true, style: { position: 'absolute', float: 'right', right: '0' } }),
	        _react2.default.createElement(
	          'div',
	          { style: { textAlign: "center" }, className: 'heading confirmation-content' },
	          this.getConfirmationContent(),
	          _react2.default.createElement(_Button2.default, { label: 'Submit',
	            className: 'lighter-font',
	            onClick: this.handleConfirmation,
	            primary: true,
	            secondary: false,
	            accent: false })
	        )
	      ) : '';
	    }
	  }, {
	    key: 'calculateAmount',
	    value: function calculateAmount() {
	      if (this.props.selectedPlan.amount && this.props.couponDetails && this.props.couponDetails.isTrialCoupon === false && this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid) {
	        if (this.props.couponDetails.coupon.amount_off) {
	          if (this.props.couponDetails.coupon.amount_off > this.props.selectedPlan.amount) {
	            return '0.00';
	          } else {
	            return (0, _Utility.roundOffDecimals)((this.props.selectedPlan.amount - this.props.couponDetails.coupon.amount_off) / 100, 2);
	          }
	        } else {
	          return (0, _Utility.roundOffDecimals)((this.props.selectedPlan.amount - this.props.selectedPlan.amount * this.props.couponDetails.coupon.percent_off / 100) / 100, 2);
	        }
	      } else {
	        return this.props.selectedPlan.amount / 100;
	      }
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent(component) {
	      var content = void 0;
	      var interval_count = this.props.selectedPlan && this.props.selectedPlan.interval_count != 1 ? '' + this.props.selectedPlan.interval_count : '';
	
	      if (this.props.selectedPlan) {
	        switch (component) {
	          case "formHeading":
	            content = _react2.default.createElement(
	              'h3',
	              { className: 'heading plan-heading' },
	              'Add Plan ',
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                this.props.selectedPlan.name
	              ),
	              ' for ',
	              _react2.default.createElement(
	                'span',
	                null,
	                ' $',
	                this.props.selectedPlan.amount / 100
	              ),
	              ' every',
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                interval_count,
	                ' ',
	                this.props.selectedPlan.interval
	              ),
	              ' to Stem ',
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                this.props.selectedTwig.name,
	                '/',
	                this.props.selectedTwig.twigId
	              )
	            );
	            break;
	          case "submitButton":
	            content = _react2.default.createElement(
	              'span',
	              null,
	              'Pay $',
	              this.calculateAmount()
	            );
	            break;
	          default:
	            break;
	        }
	      }
	      return content;
	    }
	  }, {
	    key: 'showCouponDetails',
	    value: function showCouponDetails() {
	      if (this.props.couponDetails) {
	        if (this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid) {
	          if (this.props.couponDetails.isTrialCoupon) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'coupon-applied-success' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Coupon code applied.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'plan-details' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Subscription cost : ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '$',
	                    (0, _Utility.roundOffDecimals)(this.props.selectedPlan.amount / 100, 2)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Trial period applied : ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    this.props.couponDetails.coupon.duration,
	                    ' days'
	                  )
	                )
	              )
	            );
	          } else if (this.props.couponDetails.isTrialCoupon === false) {
	            var discount = this.props.couponDetails.coupon.amount_off ? '$' + (0, _Utility.roundOffDecimals)(this.props.couponDetails.coupon.amount_off / 100, 2) : this.props.couponDetails.coupon.percent_off + ' %';
	            return _react2.default.createElement(
	              'div',
	              { className: 'coupon-applied-success' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Coupon code applied.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'plan-details' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Subscription cost : ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '$',
	                    (0, _Utility.roundOffDecimals)(this.props.selectedPlan.amount / 100, 2)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Discount applied : ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    discount
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { borderTop: '1px solid #777777' } },
	                  ' Total payable amount : ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '$',
	                    this.calculateAmount()
	                  )
	                )
	              )
	            );
	          }
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'coupon-applied-error' },
	            'Invalid coupon'
	          );
	        }
	      } else {
	        if (this.refs && this.refs['couponCode']) {
	          this.refs['couponCode'].value = '';
	        }
	        return '';
	      }
	    }
	  }, {
	    key: 'showHideValidationErrors',
	    value: function showHideValidationErrors() {
	      return this.props.showError ? _react2.default.createElement(
	        'div',
	        { className: 'error' },
	        'Please fill all the mandatory card information'
	      ) : '';
	    }
	  }, {
	    key: 'paymentInformationSection',
	    value: function paymentInformationSection(createOptions) {
	      if (!this.props.savedCard) {
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            _FormField2.default,
	            null,
	            this.getContent("formHeading"),
	            _react2.default.createElement(
	              'div',
	              { className: 'confirm-subscription-form' },
	              _react2.default.createElement(
	                'div',
	                { className: 'subscription-element-container' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('input', { name: 'email', type: 'email', placeholder: 'Email *', className: 'input-email', required: true })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscription-element-container' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactStripeElements.CardNumberElement, createOptions(_Constants2.default.STRIPE_PLACEHOLDER.CARD_NUMBER))
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscription-element-container' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactStripeElements.CardExpiryElement, createOptions(_Constants2.default.STRIPE_PLACEHOLDER.EXPIRY))
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscription-element-container' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactStripeElements.CardCVCElement, createOptions(_Constants2.default.STRIPE_PLACEHOLDER.CVC))
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'coupon-code-section' },
	                _react2.default.createElement('input', { ref: 'couponCode', type: 'text', name: 'coupon', placeholder: 'Coupon code', className: 'coupon-code', value: this.props.couponData, onChange: this.bindCouponData }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'apply-button-container' },
	                  _react2.default.createElement(_Button2.default, { label: 'Add',
	                    onClick: this.validateCouponCode,
	                    className: 'apply-button',
	                    primary: true,
	                    secondary: false,
	                    accent: false })
	                ),
	                _react2.default.createElement(_CheckBox2.default, { label: 'Remember Me', disabled: false, checked: this.props.rememberMe ? true : false, onChange: this.rememberCardData }),
	                this.showCouponDetails()
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center' } },
	                this.showHideValidationErrors()
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'submit-button-container' },
	                _react2.default.createElement(_Button2.default, { label: this.getContent("submitButton"),
	                  type: 'submit',
	                  primary: true })
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            _FormField2.default,
	            null,
	            this.getContent("formHeading"),
	            _react2.default.createElement(
	              'div',
	              { className: 'confirm-subscription-form' },
	              _react2.default.createElement(
	                'div',
	                { className: 'subscription-element-container' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('input', { name: 'email', type: 'email', placeholder: 'Email *', className: 'input-email', required: true })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscription-element-container' },
	                _react2.default.createElement('input', { type: 'text', className: 'rememberData-autofill-input', value: '********' + this.props.savedCard.card.last4, readOnly: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscription-element-container' },
	                _react2.default.createElement('input', { type: 'text', className: 'rememberData-autofill-input', value: this.props.savedCard.card.exp_month + '/ ' + this.props.savedCard.card.exp_year, readOnly: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscription-element-container' },
	                _react2.default.createElement('input', { type: 'text', className: 'rememberData-autofill-input', value: '***', readOnly: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'coupon-code-section' },
	                _react2.default.createElement('input', { ref: 'couponCode', type: 'text', name: 'coupon', placeholder: 'Coupon code', className: 'coupon-code' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'apply-button-container' },
	                  _react2.default.createElement(_Button2.default, { label: 'Apply',
	                    onClick: this.validateCouponCode,
	                    className: 'apply-button',
	                    primary: true,
	                    secondary: false,
	                    accent: false })
	                ),
	                _react2.default.createElement(_CheckBox2.default, { label: 'Remember Me', disabled: false, checked: this.props.rememberMe ? true : false, onChange: this.rememberCardData }),
	                this.showCouponDetails()
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'submit-button-container' },
	                _react2.default.createElement(_Button2.default, { label: this.getContent("submitButton"),
	                  type: 'submit',
	                  primary: true })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var createOptions = function createOptions(type) {
	        return {
	          placeholder: _this3.getPlaceHolder(type),
	          style: {
	            base: {
	              fontSize: '24px',
	              fontStyle: 'bold',
	              color: '#424770',
	              letterSpacing: '0.025em',
	              fontFamily: '',
	              '::placeholder': {
	                color: '#AAAAAA'
	              }
	            },
	            invalid: {
	              color: '#9e2146'
	            }
	          }
	        };
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'checkout-section' },
	        _react2.default.createElement(_Button2.default, { label: 'Back',
	          icon: _react2.default.createElement(_CaretBack2.default, null),
	          onClick: this.goToSubscriptionView,
	          plain: true }),
	        _react2.default.createElement(
	          'h2',
	          { className: 'heading' },
	          'Confirm Subscription'
	        ),
	        this.paymentInformationSection(createOptions),
	        this.showConfirmation()
	      );
	    }
	  }]);
	
	  return LocationView;
	}(_react.Component);
	
	LocationView.propTypes = {
	  twigsList: _react.PropTypes.array,
	  search: _react.PropTypes.object
	};
	
	var select = function select(state, props) {
	  return {
	    selectedTwig: state.locationView.selectedTwig,
	    selectedTwigIndex: state.locationView.selectedTwigIndex,
	    stripePlans: state.locationView.stripePlans,
	    showSubscriptionForm: state.locationView.showSubscriptionForm,
	    selectedPlan: state.locationView.selectedPlan,
	    couponDetails: state.locationView.couponDetails,
	    subscriptionCreated: state.locationView.subscriptionCreated,
	    subscription: state.locationView.subscription,
	    showConfirmationDialog: state.locationView.showConfirmationDialog,
	    showError: state.locationView.showError,
	    showStripePlans: state.locationView.showStripePlans,
	    paymentInformation: state.locationView.paymentInformation,
	    rememberMe: state.locationView.rememberMe,
	    savedCard: state.locationView.savedCard,
	    couponData: state.locationView.couponData
	  };
	};
	
	var _default = (0, _reactStripeElements.injectStripe)((0, _reactRedux.connect)(select)(LocationView));
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(LocationView, 'LocationView', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ConfirmSubscription.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ConfirmSubscription.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/ConfirmSubscription.js');
	}();

	;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _reactRouter = __webpack_require__(43);
	
	var _actions = __webpack_require__(13);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Messages = __webpack_require__(420);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _Article = __webpack_require__(62);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Headline = __webpack_require__(68);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Section = __webpack_require__(54);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Search = __webpack_require__(102);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Title = __webpack_require__(55);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Tile = __webpack_require__(86);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _DateTime = __webpack_require__(120);
	
	var _DateTime2 = _interopRequireDefault(_DateTime);
	
	var _Form = __webpack_require__(53);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Value = __webpack_require__(124);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Select = __webpack_require__(122);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Sidebar = __webpack_require__(69);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Split = __webpack_require__(70);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _CaretBack = __webpack_require__(71);
	
	var _CaretBack2 = _interopRequireDefault(_CaretBack);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Menu = __webpack_require__(197);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _ChartView = __webpack_require__(430);
	
	var _ChartView2 = _interopRequireDefault(_ChartView);
	
	var _SideMenu = __webpack_require__(434);
	
	var _SideMenu2 = _interopRequireDefault(_SideMenu);
	
	var _Plans = __webpack_require__(433);
	
	var _Plans2 = _interopRequireDefault(_Plans);
	
	var _nav = __webpack_require__(28);
	
	var _Utility = __webpack_require__(37);
	
	var _locationView = __webpack_require__(61);
	
	var _status = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _ = __webpack_require__(27);
	// import Label from 'grommet/components/Label';
	
	
	// import  from 'grommet/components/Base';
	// import Chart, { Layers, Base, Axis, Grid, Area, Bar, Line, Marker, MarkerLabel, HotSpots } from 'grommet/components/chart/Chart';
	
	var dateRangeValue = _Constants2.default.DATE_RANGE.TWO_WEEKS;
	
	var LocationView = function (_Component) {
	  _inherits(LocationView, _Component);
	
	  function LocationView(props) {
	    _classCallCheck(this, LocationView);
	
	    var _this = _possibleConstructorReturn(this, (LocationView.__proto__ || Object.getPrototypeOf(LocationView)).call(this, props));
	
	    _this._onStartDateChange = _this._onStartDateChange.bind(_this);
	    _this._onToDateChange = _this._onToDateChange.bind(_this);
	    _this._updateChart = _this._updateChart.bind(_this);
	    _this._selectTwig = _this._selectTwig.bind(_this);
	    _this._dateRangeSelectChange = _this._dateRangeSelectChange.bind(_this);
	    _this.getOrientation = _this.getOrientation.bind(_this);
	    _this.onTwigChange = _this.onTwigChange.bind(_this);
	    _this.setControlData = _this.setControlData.bind(_this);
	    _this._manageLocationView = _this._manageLocationView.bind(_this);
	    _this.showSideMenu = _this.showSideMenu.bind(_this);
	    _this._onResponsive = _this._onResponsive.bind(_this);
	
	    _this._setDocumentTitle(props);
	    _this.state = {
	      selectedTwigIndex: 0,
	      dateRangeValue: _Constants2.default.DATE_RANGE.TWO_WEEKS,
	      directionForHeader: 'row',
	      chosenTwig: '-1',
	      dateRange: { Type: _Constants2.default.DATE_RANGE.NONE, FromDate: 'empty', ToDate: 'empty' },
	      stripePlans: null,
	      stripeAPIKey: "",
	      showLayer: false
	    };
	    return _this;
	  }
	
	  _createClass(LocationView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _nav.navEnable)(false));
	      this.props.dispatch((0, _locationView.getPageLoadData)(this.props.selectedTwig));
	    }
	
	    // componentWillMount() {
	    //   this.props.dispatch(navEnable(false));
	    //   if (this.props.location.state) {
	    //     // siteName = decodeURIComponent(this.props.location.query.name);
	    //     if (this.props.twigsList.length <= 0) {
	    //       // this.setState({
	    //       //   twigsList: this.props.location.state.twigsList
	    //       // })
	    //       this.props.dispatch(loadTwigs(true, '', 0));
	    //     } else {
	    //       let fromDate = new Date();
	    //       fromDate.setDate(fromDate.getDate() - 14);
	    //       let toDate = new Date();
	    //       this.props.dispatch(loadChartData(this.props.location.state.twigId, fromDate.toISOString(), toDate.toISOString(), ''))
	    //     }
	
	
	    //   } else {
	    //     this.props.dispatch(loadTwigs(true, '', 0));
	    //   }
	    //   this.getUserPreference();
	    // }
	
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      //  this.props.dispatch(showLoader(true));
	      if (this.props.location.state) {
	        this.refs.selectedTwigIndex.value = this.props.location.state.selectedTwigIndex;
	      }
	      window.addEventListener("resize", function () {
	        _this2.getOrientation();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // this.props.userPreferences.twigId = "0xffffffffffffffff";
	      // this._setDocumentTitle(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      window.removeEventListener("resize", function () {
	        _this3.getOrientation();
	      });
	      this.saveUserPreference();
	    }
	  }, {
	    key: 'saveUserPreference',
	    value: function saveUserPreference() {
	      var userPreferenceObj = {
	        zoom: this.props.zoom,
	        sensors: this.props.chartOptions.displayOptions,
	        depth: this.props.chartOptions.depth,
	        dataModel: {
	          raw: this.props.showRawGraph,
	          trend: this.props.showTrendLine,
	          trendAverage: this.props.trendAverage
	        },
	        limits: {
	          upper: this.props.showUpperLimit,
	          lower: this.props.showLowerLimit
	        },
	        stem: this.props.selectedTwig.twigId,
	        fromDate: this.props.chartOptions.fromDate,
	        toDate: this.props.chartOptions.toDate,
	        dateRange: this.props.chartOptions.dateRange,
	        selectedTwig: this.props.selectedTwig
	      };
	      this.props.dispatch((0, _locationView.saveUserPreferencesAction)(userPreferenceObj));
	    }
	  }, {
	    key: 'getOrientation',
	    value: function getOrientation() {
	      var orientation = window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";
	      this.setState({
	        directionForHeader: orientation == 'Landscape' ? 'row' : 'column'
	      });
	    }
	  }, {
	    key: '_setDocumentTitle',
	    value: function _setDocumentTitle(props) {
	      document.title = 'Dashboard ';
	    }
	  }, {
	    key: '_manageLocationView',
	    value: function _manageLocationView() {
	      return this.props.showStripePlans ? _react2.default.createElement(_Plans2.default, null) : _react2.default.createElement(_ChartView2.default, null);
	    }
	  }, {
	    key: '_onToDateChange',
	    value: function _onToDateChange(date) {
	
	      var today = new Date();
	      var selectedDate = new Date(date);
	      if (selectedDate <= today) {
	        if (this.props.chartOptions.fromDate) {
	          if (selectedDate < new Date(this.props.chartOptions.fromDate)) {
	            alert(_Messages2.default.DATEFILTER.INVALID_TODATE);
	          } else {
	            var toDate = selectedDate.getTime();
	            var dateRange = this.state.dateRange;
	            dateRange.ToDate = date;
	            dateRange.Type = _Constants2.default.DATE_RANGE.CUSTOM;
	            this.setState({ dateRange: dateRange });
	            // let fromDate = new Date(this.props.chartOptions.fromDate).getTime();
	            this.props.dispatch((0, _locationView.updateToDate)(date));
	            this.refs.dateRange.value = _Constants2.default.DATE_RANGE.CUSTOM;
	            // setTimeout(() => {
	            //   this.props.dispatch(loadChartData(this.props.selectedTwig.twigId, fromDate, toDate, ''))
	            // }, 100)
	          }
	        } else {
	          alert(_Messages2.default.DATEFILTER.SELECT_STARTDATE);
	        }
	      } else {
	        alert(_Messages2.default.DATEFILTER.FUTURE_DATE);
	      }
	    }
	  }, {
	    key: '_onStartDateChange',
	    value: function _onStartDateChange(date) {
	
	      var today = new Date();
	      var selectedDate = new Date(date);
	      if (selectedDate <= today) {
	        if (selectedDate > new Date(this.props.chartOptions.toDate)) {
	          alert(_Messages2.default.DATEFILTER.INVALID_FROMDATE);
	        } else {
	          var fromDate = selectedDate.getTime();
	          // let toDate = new Date(this.props.chartOptions.toDate).getTime();
	          this.props.dispatch((0, _locationView.updateFromDate)(date));
	          this.refs.dateRange.value = _Constants2.default.DATE_RANGE.CUSTOM;
	          var dateRange = this.state.dateRange;
	          dateRange.Type = _Constants2.default.DATE_RANGE.CUSTOM;
	          dateRange.FromDate = date;
	          this.setState({ dateRange: dateRange });
	          // setTimeout(() => {
	          //   this.props.dispatch(loadChartData(this.props.selectedTwig.twigId, fromDate, toDate, ''))
	          // }, 100)
	        }
	      } else {
	        alert(_Messages2.default.DATEFILTER.FUTURE_DATE);
	      }
	    }
	  }, {
	    key: '_updateChart',
	    value: function _updateChart(e) {
	      var _this4 = this;
	
	      var twigIndx = this.refs.selectedTwigIndex.value;
	      var timeOutValue = 0;
	      if (this.props.twigsList[twigIndx].twigId != this.props.selectedTwig.twigId) {
	        timeOutValue = 1;
	        this.props.dispatch((0, _locationView.updateSelectedTwig)(this.refs.selectedTwigIndex.value));
	      }
	      setTimeout(function () {
	        // console.log('this.props.chartOptions::', this.props.chartOptions);
	        // console.log('this.refs.dateRange::', this.refs.dateRange.value)
	        if (_this4.refs.dateRange.value == _Constants2.default.DATE_RANGE.CUSTOM) {
	          var fromDateArr = [];
	          var toDateArr = [];
	          if (_this4.props.chartOptions.fromDate) {
	            fromDateArr = _this4.props.chartOptions.fromDate.split('/');
	          } else {
	            alert('Please select from Date');
	            return false;
	          }
	          if (_this4.props.chartOptions.toDate && _this4.props.chartOptions.toDate.length > 0) {
	            toDateArr = _this4.props.chartOptions.toDate.split('/');
	          }
	          var fromDate = void 0;
	
	          // let fromDate = new Date(fromDateArr[2], fromDateArr[0], fromDateArr[1]).toISOString();
	          if (fromDateArr.length > 1) {
	            fromDate = new Date(fromDateArr[2] + '-' + fromDateArr[0] + '-' + fromDateArr[1]).toISOString();
	          } else {
	            fromDate = fromDateArr[0];
	          }
	
	          var toDate = '';
	          if (toDateArr.length > 0) {
	            var _toDate = void 0;
	            // toDate = new Date(toDateArr[2], toDateArr[0], toDateArr[1]).toISOString();
	            toDate = new Date(toDateArr[0] + '-' + toDateArr[1] + '-' + toDateArr[2]).toISOString();
	            _toDate = toDate.split('T');
	            _toDate.splice(1, 1, _Constants2.default.DATE_TIMESTAMP.lastHour);
	            toDate = _toDate.join('T');
	          } else {
	            toDate = new Date().toISOString();
	            var defaultToDate = new Date().getMonth() + 1 + '/' + new Date().getDate() + '/' + new Date().getFullYear();
	            _this4.props.dispatch((0, _locationView.updateToDate)(defaultToDate));
	          }
	          _this4.props.dispatch((0, _locationView.loadChartData)(_this4.props.selectedTwig.twigId, fromDate, toDate, '', twigIndx));
	        } else {
	          var dates = void 0;
	          if (_this4.refs.dateRange.value == _Constants2.default.DATE_RANGE.ALL) {
	            _this4.props.dispatch((0, _locationView.updateFromDate)(''));
	            _this4.props.dispatch((0, _locationView.updateToDate)(''));
	            dates = {
	              fromDate: '',
	              toDate: ''
	            };
	          } else {
	            dates = (0, _Utility.getDateFromDateRange)(_this4.refs.dateRange.value);
	
	            _this4.props.dispatch((0, _locationView.updateFromDate)(new Date(dates.fromDate)));
	            _this4.props.dispatch((0, _locationView.updateToDate)(new Date(dates.toDate)));
	          }
	          var _fromDate = '';
	          var _toDate2 = new Date();
	          var toDateUTC = _toDate2.toISOString();
	          if (dates.fromDate != '') {
	            _fromDate = new Date(dates.fromDate).toISOString();
	          }
	          _this4.props.dispatch((0, _locationView.loadChartData)(_this4.props.selectedTwig.twigId, _fromDate, toDateUTC, '', twigIndx));
	        }
	      }, timeOutValue);
	    }
	  }, {
	    key: '_selectTwig',
	    value: function _selectTwig(e) {
	      var index = e.target.value;
	      this.props.twigsList[index].twigId;
	      var fromDate = new Date(this.props.chartOptions.fromDate).getTime();
	      var toDate = new Date(this.props.chartOptions.toDate).getTime();
	      // this.props.dispatch(updateSelectedTwig(index));
	    }
	  }, {
	    key: 'clearDateRange',
	    value: function clearDateRange(dateRange) {
	      if (_Constants2.default.DATE_RANGE.CUSTOM === dateRange.Type) {
	        dateRange.FromDate = '';
	        dateRange.ToDate = '';
	      }
	      this.props.dispatch((0, _locationView.updateFromDate)(''));
	      this.props.dispatch((0, _locationView.updateToDate)(''));
	      return dateRange;
	    }
	  }, {
	    key: '_dateRangeSelectChange',
	    value: function _dateRangeSelectChange(e) {
	      var dateRange = this.state.dateRange;
	      dateRange.Type = e.target.value;
	      dateRange = this.clearDateRange(dateRange);
	      setTimeout(function (eValue, scope) {
	        scope.props.dispatch((0, _actions.updateDateRange)(eValue));
	      }, 5, e.target.value, this);
	      //this.props.dispatch(updateDateRange(e.target.value))
	      this.setState({
	        dateRangeValue: e.target.value,
	        dateRange: dateRange
	      });
	
	      // this.props.dispatch(changeResolution(e.target.value));
	    }
	  }, {
	    key: 'getUserPreference',
	    value: function getUserPreference() {
	      this.props.dispatch((0, _locationView.getUserPreferencesAction)());
	    }
	  }, {
	    key: 'onTwigChange',
	    value: function onTwigChange(e) {
	      this.setState({ chosenTwig: e.target.value });
	    }
	  }, {
	    key: 'onDateRangeChange',
	    value: function onDateRangeChange(e) {
	      var dateRange = { Type: _Constants2.default.DATE_RANGE.ALL, FromDate: '', ToDate: '' };
	      dateRange.Type = e.target.value;
	    }
	  }, {
	    key: 'setControlData',
	    value: function setControlData() {
	      var controlData = {
	        twigIndex: 0, dateRange: _Constants2.default.DATE_RANGE.ONE_WEEK,
	        fromDate: '', toDate: ''
	      };
	      if (this.state.chosenTwig === '-1') {
	        controlData.twigIndex = this.props.selectedTwigIndex;
	      } else {
	        controlData.twigIndex = this.state.chosenTwig;
	      }
	
	      if (this.state.dateRange.FromDate != 'empty') {
	        controlData.fromDate = this.state.dateRange.FromDate;
	      } else {
	        controlData.fromDate = this.props.chartOptions.fromDate;
	      }
	
	      if (this.state.dateRange.ToDate != 'empty') {
	        controlData.toDate = this.state.dateRange.ToDate;
	      } else {
	        controlData.toDate = this.props.chartOptions.toDate;
	      }
	
	      if (this.state.dateRange.Type != _Constants2.default.DATE_RANGE.NONE) {
	        controlData.dateRange = this.state.dateRange.Type;
	      } else {
	        controlData.dateRange = this.props.chartOptions.dateRange;
	      }
	      return controlData;
	    }
	  }, {
	    key: 'showSideMenu',
	    value: function showSideMenu() {
	      return !this.props.showStripePlans ? _react2.default.createElement(_SideMenu2.default, null) : '';
	    }
	  }, {
	    key: '_onResponsive',
	    value: function _onResponsive(responsive) {
	      if (responsive === 'multiple') {
	        this.setState({ showLayer: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props$nav = this.props.nav,
	          navActive = _props$nav.active,
	          navEnabled = _props$nav.enabled,
	          responsive = _props$nav.responsive;
	      var showLayer = this.state.showLayer;
	
	
	      var font12 = {
	        fontSize: '12px'
	      };
	      var font14 = {
	        fontSize: '14px'
	      };
	
	      var twigIndex = 0;
	      if (this.state.chosenTwig === '-1') {
	        twigIndex = this.props.selectedTwigIndex;
	      } else {
	        twigIndex = this.state.chosenTwig;
	      }
	
	      var controlData = this.setControlData();
	
	      var content = this.showSideMenu();
	      var leftNode = void 0;
	      var buttonNode = void 0;
	      var layerNode = void 0;
	
	      if (responsive === 'multiple' && !navEnabled) {
	        leftNode = _react2.default.createElement(
	          _Sidebar2.default,
	          { colorIndex: 'neutral-1', fixed: true },
	          content
	        );
	      } else if (showLayer) {
	        layerNode = _react2.default.createElement(
	          _Layer2.default,
	          {
	            flush: true,
	            colorIndex: 'neutral-1',
	            fixed: true,
	            className: 'charts-tab-left-menu',
	            closer: true,
	            onClose: function onClose() {
	              return _this5.setState({ showLayer: false });
	            },
	            peek: true
	          },
	          content
	        );
	      } else if (responsive === 'single' && !navEnabled) {
	        buttonNode = _react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Menu2.default, null), style: { float: 'right' }, onClick: function onClick() {
	            return _this5.setState({ showLayer: true });
	          } });
	      }
	
	      return _react2.default.createElement(
	        _Split2.default,
	        { flex: 'right', className: 'location-view', onResponsive: this._onResponsive },
	        leftNode,
	        buttonNode,
	        _react2.default.createElement(
	          _Article2.default,
	          null,
	          _react2.default.createElement(
	            _Header2.default,
	            { className: 'stemdetails-section', size: 'large', pad: { between: 'small', horizontal: 'small' }, direction: this.state.directionForHeader },
	            _react2.default.createElement(
	              _FormField2.default,
	              { label: 'Choose Stem' },
	              _react2.default.createElement(
	                'select',
	                { ref: 'selectedTwigIndex', className: 'font12', onChange: this.onTwigChange, value: controlData.twigIndex },
	                this.props.twigsList.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: index, value: index },
	                    (item.name ? item.name + '@' : '-@') + (item.locationName ? item.locationName : '-') + ' (' + item.twigId + ')'
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _FormField2.default,
	              { label: 'Date Range' },
	              _react2.default.createElement(
	                'select',
	                { ref: 'dateRange', onChange: this._dateRangeSelectChange, className: 'font12', value: controlData.dateRange, disabled: this.props.showStripePlans },
	                _react2.default.createElement(
	                  'option',
	                  { value: _Constants2.default.DATE_RANGE.ALL },
	                  'All'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: _Constants2.default.DATE_RANGE.ONE_WEEK },
	                  '1 Week'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: _Constants2.default.DATE_RANGE.TWO_WEEKS },
	                  '2 Weeks'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: _Constants2.default.DATE_RANGE.ONE_MONTH },
	                  '1 Month'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: _Constants2.default.DATE_RANGE.SIX_MONTHS },
	                  '6 Months'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: _Constants2.default.DATE_RANGE.ONE_YEAR },
	                  '1 Year'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: _Constants2.default.DATE_RANGE.CUSTOM },
	                  'Custom'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _FormField2.default,
	              { label: 'From', className: controlData.dateRange == _Constants2.default.DATE_RANGE.CUSTOM ? 'show' : 'hide' },
	              _react2.default.createElement(_DateTime2.default, { id: 'id',
	                name: 'name',
	                value: (0, _Utility.convertDate)(controlData.fromDate),
	                format: 'MM/DD/YYYY',
	                onChange: this._onStartDateChange })
	            ),
	            _react2.default.createElement(
	              _FormField2.default,
	              { label: 'To', className: controlData.dateRange == _Constants2.default.DATE_RANGE.CUSTOM ? 'show' : 'hide' },
	              _react2.default.createElement(_DateTime2.default, { id: 'id',
	                name: 'name',
	                value: (0, _Utility.convertDate)(controlData.toDate),
	                format: 'MM/DD/YYYY',
	                onChange: this._onToDateChange })
	            ),
	            _react2.default.createElement(_Button2.default, { label: 'Update Chart',
	              className: 'lighter-font',
	              onClick: this._updateChart,
	              primary: true,
	              secondary: false,
	              accent: false })
	          ),
	          this._manageLocationView()
	        ),
	        layerNode
	      );
	    }
	  }]);
	
	  return LocationView;
	}(_react.Component);
	
	LocationView.propTypes = {
	  twigsList: _react.PropTypes.array,
	  search: _react.PropTypes.object
	};
	
	var select = function select(state, props) {
	  return {
	    twigsList: state.locationView.twigsList,
	    selectedTwig: state.locationView.selectedTwig,
	    selectedTwigIndex: state.locationView.selectedTwigIndex,
	    chartData: state.locationView.chartData,
	    chartOptions: state.locationView.chartOptions,
	    search: state.search,
	    showChart: state.locationView.showChart,
	    showRawGraph: state.locationView.showRawGraph,
	    showTrendLine: state.locationView.showTrendLine,
	    trendAverage: state.locationView.trendAverage,
	    showUpperLimit: state.locationView.showUpperLimit,
	    showLowerLimit: state.locationView.showLowerLimit,
	    userPreferences: state.locationView.userPreferences,
	    zoom: state.locationView.zoom,
	    stripePlans: state.locationView.stripePlans,
	    showStripePlans: state.locationView.showStripePlans,
	    addSubscription: state.subscriptionView.addSubscription,
	    stripeAPIKey: state.session.stripeAPIKey,
	    nav: state.nav
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(LocationView);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(dateRangeValue, 'dateRangeValue', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/LocationView.js');
	
	  __REACT_HOT_LOADER__.register(LocationView, 'LocationView', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/LocationView.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/LocationView.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/LocationView.js');
	}();

	;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _locationView = __webpack_require__(61);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Utility = __webpack_require__(37);
	
	var _reactStripeElements = __webpack_require__(406);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Headline = __webpack_require__(68);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Tile = __webpack_require__(86);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Card = __webpack_require__(493);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Tiles = __webpack_require__(191);
	
	var _Tiles2 = _interopRequireDefault(_Tiles);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _nav = __webpack_require__(28);
	
	var _status = __webpack_require__(65);
	
	var _ConfirmSubscription = __webpack_require__(431);
	
	var _ConfirmSubscription2 = _interopRequireDefault(_ConfirmSubscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _ = __webpack_require__(27);
	
	var LocationView = function (_Component) {
	  _inherits(LocationView, _Component);
	
	  function LocationView(props) {
	    _classCallCheck(this, LocationView);
	
	    var _this = _possibleConstructorReturn(this, (LocationView.__proto__ || Object.getPrototypeOf(LocationView)).call(this, props));
	
	    _this.renderPlanDetails = _this.renderPlanDetails.bind(_this);
	    _this.renderSubscriptionTiles = _this.renderSubscriptionTiles.bind(_this);
	    _this.addSubscription = _this.addSubscription.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(LocationView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _nav.navEnable)(true));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _status.showLoader)(false));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'addSubscription',
	    value: function addSubscription(plan) {
	      var _this2 = this;
	
	      var togglesubscriptionForm = !this.props.showSubscriptionForm;
	      return function () {
	        _this2.props.dispatch((0, _locationView.addSubscription)({ togglesubscriptionForm: togglesubscriptionForm, plan: plan }));
	      };
	    }
	  }, {
	    key: 'renderPlanDetails',
	    value: function renderPlanDetails(plan) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'tile-header-container' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'heading' },
	          plan.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'price-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'plan-price' },
	            ' $',
	            (0, _Utility.roundOffDecimals)(plan.amount / 100, 2)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'plan-duration' },
	            'per',
	            _react2.default.createElement('br', null),
	            plan.interval_count > 1 ? _react2.default.createElement(
	              'span',
	              null,
	              plan.interval_count,
	              ' '
	            ) : '',
	            plan.interval
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDummyPlanDetails',
	    value: function renderDummyPlanDetails() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'tile-header-container' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'heading' },
	          'Enterprise Plan'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'price-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'plan-price' },
	            'Volume Discount'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getPlanFeatures',
	    value: function getPlanFeatures(plan) {
	      var styles = {};
	      var featureList = [];
	      if (plan && plan.metadata && Object.keys(plan.metadata).length > 0) {
	        for (var key in plan.metadata) {
	          featureList.push(_react2.default.createElement(
	            'li',
	            { key: plan.id + "_" + key },
	            _react2.default.createElement(
	              'span',
	              null,
	              plan.metadata[key]
	            )
	          ));
	        }
	        return _react2.default.createElement(
	          'ul',
	          { className: 'plan-features' },
	          featureList
	        );
	      } else {
	        return _react2.default.createElement(
	          'h4',
	          { className: 'plan-features' },
	          'No feature list'
	        );
	      }
	    }
	  }, {
	    key: 'getDummyPlanFeatures',
	    value: function getDummyPlanFeatures() {
	      var styles = {};
	      var featureList = [];
	      featureList.push(_react2.default.createElement(
	        'li',
	        { key: "0_0" },
	        _react2.default.createElement(
	          'span',
	          null,
	          'For more than 10 Stems'
	        )
	      ));
	      featureList.push(_react2.default.createElement(
	        'li',
	        { key: "0_1" },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Contact sales@gro.guru'
	        )
	      ));
	      featureList.push(_react2.default.createElement(
	        'li',
	        { key: "0_2" },
	        _react2.default.createElement(
	          'span',
	          null,
	          'or Call to us at +1-559-461-5705'
	        )
	      ));
	      return _react2.default.createElement(
	        'ul',
	        { className: 'plan-features' },
	        featureList
	      );
	    }
	  }, {
	    key: 'renderSubscriptionTiles',
	    value: function renderSubscriptionTiles() {
	      var _this3 = this;
	
	      var subscriptionTiles = [];
	      if (this.props.stripePlans) {
	        _.forEach(this.props.stripePlans.data, function (plan) {
	          subscriptionTiles.push(_react2.default.createElement(
	            _Tile2.default,
	            { key: plan.id },
	            _react2.default.createElement(_Card2.default, { heading: _this3.renderPlanDetails(plan),
	              link: _react2.default.createElement(
	                'div',
	                { className: 'add-subscription-button' },
	                _react2.default.createElement(_Button2.default, { label: 'Add',
	                  className: 'lighter-font',
	                  onClick: _this3.addSubscription(plan),
	                  primary: true,
	                  secondary: false,
	                  accent: false })
	              ),
	              description: _this3.getPlanFeatures(plan) })
	          ));
	        });
	
	        // dummy plan
	        var plan = {
	          id: '0'
	
	        };
	        subscriptionTiles.push(_react2.default.createElement(
	          _Tile2.default,
	          { key: plan.id },
	          _react2.default.createElement(_Card2.default, { heading: this.renderDummyPlanDetails(),
	
	            description: this.getDummyPlanFeatures() })
	        ));
	      }
	      return subscriptionTiles;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var optionStyle = {
	        color: 'black'
	      };
	
	      return _react2.default.createElement(
	        _reactStripeElements.StripeProvider,
	        { apiKey: this.props.stripeAPIKey },
	        _react2.default.createElement(
	          'div',
	          { className: 'subscription-container' },
	          _react2.default.createElement(
	            'div',
	            { style: { display: this.props.showSubscriptionForm ? 'none' : '' } },
	            _react2.default.createElement(
	              'h3',
	              { className: 'heading' },
	              'Add/Change Subscription Plan for stem ',
	              this.props.selectedTwig.name,
	              '/',
	              this.props.selectedTwig.twigId
	            ),
	            _react2.default.createElement(
	              _Tiles2.default,
	              { fill: false,
	                flush: false },
	              this.renderSubscriptionTiles()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: !this.props.showSubscriptionForm ? 'none' : '' } },
	            _react2.default.createElement(
	              _reactStripeElements.Elements,
	              null,
	              _react2.default.createElement(_ConfirmSubscription2.default, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LocationView;
	}(_react.Component);
	
	LocationView.propTypes = {
	  twigsList: _react.PropTypes.array,
	  search: _react.PropTypes.object
	};
	
	var select = function select(state, props) {
	  return {
	    selectedTwig: state.locationView.selectedTwig,
	    selectedTwigIndex: state.locationView.selectedTwigIndex,
	    stripePlans: state.locationView.stripePlans,
	    showSubscriptionForm: state.locationView.showSubscriptionForm,
	    rememberMeCardData: state.locationView.rememberMeCardData,
	    savedCard: state.locationView.savedCard,
	    stripeAPIKey: state.session.stripeAPIKey
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(LocationView);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(LocationView, 'LocationView', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/Plans.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/Plans.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/Plans.js');
	}();

	;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _locationView = __webpack_require__(61);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Article = __webpack_require__(62);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Headline = __webpack_require__(68);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Section = __webpack_require__(54);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Search = __webpack_require__(102);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Title = __webpack_require__(55);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Tile = __webpack_require__(86);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _DateTime = __webpack_require__(120);
	
	var _DateTime2 = _interopRequireDefault(_DateTime);
	
	var _Form = __webpack_require__(53);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Value = __webpack_require__(124);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Select = __webpack_require__(122);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Sidebar = __webpack_require__(69);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Split = __webpack_require__(70);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _CaretBack = __webpack_require__(71);
	
	var _CaretBack2 = _interopRequireDefault(_CaretBack);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _RadioButton = __webpack_require__(189);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _nav = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _ = __webpack_require__(27);
	// import Label from 'grommet/components/Label';
	
	// import  from 'grommet/components/Base';
	// import Chart, { Layers, Base, Axis, Grid, Area, Bar, Line, Marker, MarkerLabel, HotSpots } from 'grommet/components/chart/Chart';
	
	
	var LocationView = function (_Component) {
	  _inherits(LocationView, _Component);
	
	  function LocationView(props) {
	    _classCallCheck(this, LocationView);
	
	    var _this = _possibleConstructorReturn(this, (LocationView.__proto__ || Object.getPrototypeOf(LocationView)).call(this, props));
	
	    _this._changeDisplayOption = _this._changeDisplayOption.bind(_this);
	    _this._changeDepthOption = _this._changeDepthOption.bind(_this);
	    _this._trendOptionChange = _this._trendOptionChange.bind(_this);
	    _this._averageTrendChange = _this._averageTrendChange.bind(_this);
	    _this._changeLimitOption = _this._changeLimitOption.bind(_this);
	    _this.state = {
	      trendOption: _Constants2.default.TREND_OPTIONS.BOTH,
	      rawSelected: true,
	      trendSelected: true
	    };
	    return _this;
	  }
	
	  _createClass(LocationView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // this.props.dispatch(unloadDashboard());
	      // this._graphicSizer.stop();
	    }
	  }, {
	    key: '_changeZoomOption',
	    value: function _changeZoomOption(event) {
	      var _this2 = this;
	
	      var value = event.target.checked;
	      setTimeout(function () {
	        _this2.props.dispatch((0, _locationView.changeZoomOption)(value));
	      }, 10);
	    }
	  }, {
	    key: '_changeDepthOption',
	    value: function _changeDepthOption(key, event) {
	      var _this3 = this;
	
	      var payload = {
	        key: key,
	        value: event.target.checked
	      };
	      setTimeout(function () {
	        _this3.props.dispatch((0, _locationView.changeDepthOption)(payload));
	      }, 10);
	    }
	  }, {
	    key: '_changeDisplayOption',
	    value: function _changeDisplayOption(key, event) {
	      var _this4 = this;
	
	      var payload = {
	        key: key,
	        value: event.target.checked
	      };
	      setTimeout(function () {
	        _this4.props.dispatch((0, _locationView.changeDisplayOption)(payload));
	      }, 10);
	    }
	  }, {
	    key: '_changeLimitOption',
	    value: function _changeLimitOption(type, event) {
	      var _this5 = this;
	
	      var value = event.target.checked;
	
	      if (type == _Constants2.default.CHART_LIMIT.TOP) {
	        setTimeout(function () {
	          _this5.props.dispatch((0, _locationView.showUpperLimit)(value));
	        }, 10);
	      } else if (type == _Constants2.default.CHART_LIMIT.LOWER) {
	        setTimeout(function () {
	          _this5.props.dispatch((0, _locationView.showLowerLimit)(value));
	        }, 10);
	      }
	    }
	  }, {
	    key: '_trendOptionChange',
	    value: function _trendOptionChange(type, event) {
	      var _this6 = this;
	
	      var value = event.target.checked;
	      var callAction = false;
	      if (type == _Constants2.default.TREND_OPTIONS.RAW && this.props.showTrendLine) {
	        this.setState({
	          rawSelected: value
	        });
	        callAction = true;
	      } else if (type == _Constants2.default.TREND_OPTIONS.TRENDLINE && this.props.showRawGraph) {
	        this.setState({
	          trendSelected: value
	        });
	        callAction = true;
	      }
	      if (callAction) {
	        setTimeout(function () {
	          if (type == _Constants2.default.TREND_OPTIONS.RAW) {
	            _this6.props.dispatch((0, _locationView.showRawGraph)(value));
	          } else {
	            _this6.props.dispatch((0, _locationView.showTrendLine)(value));
	          }
	        }, 10);
	      }
	    }
	  }, {
	    key: '_averageTrendChange',
	    value: function _averageTrendChange(event) {
	      var _this7 = this;
	
	      var avgTrendValue = event.target.value;
	      setTimeout(function () {
	        _this7.props.dispatch((0, _locationView.changeTrendAverage)(avgTrendValue));
	      }, 10);
	    }
	  }, {
	    key: 'renderTwigCheckboxes',
	    value: function renderTwigCheckboxes() {
	      var _this8 = this;
	
	      var twigCheckBoxes = [];
	      if (this.props.selectedTwig && this.props.selectedTwig.details && this.props.selectedTwig.details.data) {
	        twigCheckBoxes.push(_react2.default.createElement(
	          _FormField2.default,
	          { key: 'zoom' },
	          _react2.default.createElement(_CheckBox2.default, { label: 'Zoom',
	            checked: this.props.zoom,
	            toggle: false,
	            disabled: false,
	            onChange: this._changeZoomOption.bind(this),
	            reverse: false })
	        ));
	        var allObjects = Object.entries(this.props.selectedTwig.details.data);
	        var filterObjects = allObjects.sort(function (a, b) {
	          return a[1].sort_order - b[1].sort_order;
	        }).filter(function (each) {
	          return each[1].sort_order !== 1 && each[1].sort_order !== 6;
	        });
	        filterObjects.map(function (item, index) {
	          var displayOptions = {};
	          var isChecked = false;
	          if (_this8.props.chartOptions) {
	            if (_this8.props.chartOptions.DisplayOptions) {
	              displayOptions = _this8.props.chartOptions.DisplayOptions;
	            } else if (_this8.props.chartOptions.displayOptions) {
	              displayOptions = _this8.props.chartOptions.displayOptions;
	            }
	          }
	
	          if (Object.keys(displayOptions).length > 0) {
	            isChecked = displayOptions[item[0]];
	          }
	
	          twigCheckBoxes.push(_react2.default.createElement(
	            _FormField2.default,
	            { key: index },
	            _react2.default.createElement(_CheckBox2.default, { label: item[1].label,
	              checked: isChecked,
	              toggle: false,
	              disabled: false,
	              onChange: _this8._changeDisplayOption.bind(_this8, item[0]),
	              reverse: false })
	          ));
	        });
	      }
	      return twigCheckBoxes;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var optionStyle = {
	        color: 'black'
	      };
	      var averageDropDown = {
	        display: this.props.trendOption == _Constants2.default.TREND_OPTIONS.RAW ? 'none' : 'block'
	      };
	      var top = this.props.chartOptions.depth[_Constants2.default.CHART_OPTIONS.TOP];
	      var middle = this.props.chartOptions.depth[_Constants2.default.CHART_OPTIONS.MIDDLE];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Button2.default, { label: 'Back',
	          icon: _react2.default.createElement(_CaretBack2.default, null),
	          path: '/site',
	          plain: true }),
	        _react2.default.createElement(
	          _Box2.default,
	          { flex: 'grow',
	            justify: 'start' },
	          _react2.default.createElement(
	            _Form2.default,
	            null,
	            _react2.default.createElement(
	              _Header2.default,
	              { pad: { horizontal: 'medium' } },
	              _react2.default.createElement(
	                'label',
	                null,
	                'DISPLAY OPTIONS'
	              )
	            ),
	            this.renderTwigCheckboxes()
	          ),
	          _react2.default.createElement(
	            _Form2.default,
	            null,
	            _react2.default.createElement(
	              _Header2.default,
	              { pad: { horizontal: 'medium' } },
	              _react2.default.createElement(
	                'label',
	                null,
	                'DEPTH'
	              )
	            ),
	            _react2.default.createElement(
	              _FormField2.default,
	              null,
	              _react2.default.createElement(_CheckBox2.default, { label: 'Top',
	                checked: this.props.chartOptions.depth[_Constants2.default.CHART_OPTIONS.TOP],
	                onChange: this._changeDepthOption.bind(this, _Constants2.default.CHART_OPTIONS.TOP),
	                toggle: false,
	                disabled: false,
	                reverse: false })
	            ),
	            _react2.default.createElement(
	              _FormField2.default,
	              null,
	              _react2.default.createElement(_CheckBox2.default, { label: 'Middle',
	                checked: this.props.chartOptions.depth[_Constants2.default.CHART_OPTIONS.MIDDLE],
	                onChange: this._changeDepthOption.bind(this, _Constants2.default.CHART_OPTIONS.MIDDLE),
	                toggle: false,
	                disabled: false,
	                reverse: false })
	            ),
	            _react2.default.createElement(
	              _FormField2.default,
	              null,
	              _react2.default.createElement(_CheckBox2.default, { label: 'Bottom',
	                checked: this.props.chartOptions.depth[_Constants2.default.CHART_OPTIONS.BOTTOM],
	                onChange: this._changeDepthOption.bind(this, _Constants2.default.CHART_OPTIONS.BOTTOM),
	                toggle: false,
	                disabled: false,
	                reverse: false })
	            )
	          ),
	          _react2.default.createElement(
	            _Form2.default,
	            null,
	            _react2.default.createElement(
	              _Header2.default,
	              { pad: { horizontal: 'medium' } },
	              _react2.default.createElement(
	                'label',
	                null,
	                'DATA MODEL'
	              )
	            ),
	            _react2.default.createElement(
	              _FormField2.default,
	              null,
	              _react2.default.createElement(_CheckBox2.default, { label: 'Raw',
	                checked: this.props.showRawGraph,
	                onChange: this._trendOptionChange.bind(this, _Constants2.default.TREND_OPTIONS.RAW),
	                toggle: false,
	                disabled: false,
	                reverse: false })
	            ),
	            _react2.default.createElement(
	              _FormField2.default,
	              null,
	              _react2.default.createElement(_CheckBox2.default, { label: 'Trend', key: 1,
	                checked: this.props.showTrendLine,
	                onChange: this._trendOptionChange.bind(this, _Constants2.default.TREND_OPTIONS.TRENDLINE),
	                toggle: false,
	                disabled: false,
	                reverse: false }),
	              _react2.default.createElement(
	                'select',
	                { style: averageDropDown, onChange: this._averageTrendChange, key: 2,
	                  disabled: !this.props.showTrendLine, value: this.props.trendAverage },
	                _react2.default.createElement(
	                  'option',
	                  { style: optionStyle, value: '5', key: 5 },
	                  'SMA5'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { style: optionStyle, value: '10', key: 10 },
	                  'SMA10'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { style: optionStyle, value: '20', key: 20 },
	                  'SMA20'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LocationView;
	}(_react.Component);
	
	LocationView.propTypes = {
	  twigsList: _react.PropTypes.array,
	  search: _react.PropTypes.object
	};
	
	var select = function select(state, props) {
	  return {
	    selectedTwig: state.locationView.selectedTwig,
	    showRawGraph: state.locationView.showRawGraph,
	    showTrendLine: state.locationView.showTrendLine,
	    trendAverage: state.locationView.trendAverage,
	    // chartData: state.locationView.chartData,
	    // search: state.search
	    showLowerLimit: state.locationView.showLowerLimit,
	    showUpperLimit: state.locationView.showUpperLimit,
	    chartOptions: state.locationView.chartOptions,
	    zoom: state.locationView.zoom
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(LocationView);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(LocationView, 'LocationView', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/SideMenu.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/SideMenu.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/location/SideMenu.js');
	}();

	;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _googleMapReact = __webpack_require__(119);
	
	var _googleMapReact2 = _interopRequireDefault(_googleMapReact);
	
	var _reactPlacesAutocomplete = __webpack_require__(157);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _Location = __webpack_require__(196);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _reactRouter = __webpack_require__(43);
	
	var _actions = __webpack_require__(13);
	
	var _nav = __webpack_require__(28);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _settings = __webpack_require__(116);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _ = __webpack_require__(27);
	// import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
	
	var ChooseLocationMap = function (_Component) {
	  _inherits(ChooseLocationMap, _Component);
	
	  function ChooseLocationMap(props) {
	    _classCallCheck(this, ChooseLocationMap);
	
	    var _this = _possibleConstructorReturn(this, (ChooseLocationMap.__proto__ || Object.getPrototypeOf(ChooseLocationMap)).call(this, props));
	
	    _this.mapClick = _this.mapClick.bind(_this);
	    _this.getCenter = _this.getCenter.bind(_this);
	    _this.mapLoaded = _this.mapLoaded.bind(_this);
	    _this.addSite = _this.addSite.bind(_this);
	    _this.backBtnClick = _this.backBtnClick.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.placesHandleSelect = _this.placesHandleSelect.bind(_this);
	    _this.state = {
	      center: false,
	      showContextMenu: false,
	      contextMenTopPos: 0,
	      contextMenuLeftPos: 0,
	      markersArr: [],
	      showModalOverlay: false,
	      address: ''
	    };
	    return _this;
	  }
	
	  _createClass(ChooseLocationMap, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _nav.navEnable)(false));
	      this.getCenter();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      console.log(this.props);
	      //  this.props.dispatch(navEnable(false));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'getCenter',
	    value: function getCenter() {
	      var _this2 = this;
	
	      if (this.props.userLocation && this.props.userLocation.latitude) {
	        this.setState({
	          center: {
	            lat: this.props.userLocation.latitude ? Number(this.props.userLocation.latitude) : null,
	            lng: this.props.userLocation.longitude ? Number(this.props.userLocation.longitude) : null
	          }
	        });
	      } else if (navigator.geolocation) {
	
	        navigator.geolocation.getCurrentPosition(function (position) {
	          var postionObj = {
	            lat: position.coords.latitude, lng: position.coords.longitude
	            // console.log('postionObj::-', postionObj)
	          };_this2.setState({
	            center: postionObj
	          });
	        }, function (error) {
	          _this2.setState({
	            center: {
	              lat: 37.09024, lng: -95.712891
	            },
	            zoom: 5
	          });
	        });
	      } else {
	        this.setState({
	          center: {
	            lat: 37.09024, lng: -95.712891
	          },
	          zoom: 5
	        });
	      }
	    }
	  }, {
	    key: 'mapClick',
	    value: function mapClick(e) {
	      this.setState({
	        showContextMenu: false,
	        contextMenTopPos: 0,
	        contextMenuLeftPos: 0
	      });
	    }
	  }, {
	    key: 'mapLoaded',
	    value: function mapLoaded(mapObj) {
	      var _this3 = this;
	
	      mapObj.map.addListener('rightclick', function (event) {
	        // let position = {
	        //   latitude: event.latLng.lat(),
	        //   longitude: event.latLng.lng()
	        // }
	
	        _this3.setState({
	          showContextMenu: true,
	          contextMenTopPos: event.pixel.y,
	          contextMenuLeftPos: event.pixel.x,
	          markerLat: event.latLng.lat(),
	          markerLong: event.latLng.lng()
	        });
	      });
	    }
	  }, {
	    key: 'addSite',
	    value: function addSite(obj) {
	      var position = {
	        latitude: this.state.markerLat,
	        longitude: this.state.markerLong
	      };
	      if (this.props.userProfile && this.props.userProfile.username) {
	        this.props.dispatch((0, _settings.updateUserLocation)(position));
	        _reactRouter.browserHistory.push({
	          pathname: _Constants2.default.ROUTES.SETTINGS,
	          // search: '?name=' + sitename_enc,
	          state: {}
	        });
	      } else {
	        this.props.dispatch((0, _settings.updateSignUpUserLocation)(position));
	        _reactRouter.browserHistory.push({
	          pathname: _Constants2.default.ROUTES.SIGNUP,
	          state: {}
	        });
	      }
	      this.setState({
	        showContextMenu: false,
	        showModalOverlay: true
	      });
	    }
	  }, {
	    key: 'backBtnClick',
	    value: function backBtnClick() {
	      if (!this.props.userProfile) {
	        _reactRouter.browserHistory.push({
	          pathname: _Constants2.default.ROUTES.SIGNUP,
	          state: {}
	        });
	      } else {
	        _reactRouter.browserHistory.push({
	          pathname: _Constants2.default.ROUTES.SETTINGS,
	          state: {}
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(address) {
	      this.setState({
	        address: address
	      });
	    }
	  }, {
	    key: 'placesHandleSelect',
	    value: function placesHandleSelect(address) {
	      var _this4 = this;
	
	      this.setState({
	        address: address
	      });
	      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
	        return (0, _reactPlacesAutocomplete.getLatLng)(results[0]);
	      }).then(function (_ref) {
	        var lat = _ref.lat,
	            lng = _ref.lng;
	
	        // console.log('Success Yay', { lat, lng })
	        _this4.setState({
	          center: {
	            lat: lat, lng: lng
	          },
	          zoom: 20
	        });
	      }).catch(function (error) {
	        // console.log('Error:', error)
	
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var zoom = 11;
	      var containerStyle = {
	        height: '100%'
	      };
	      var contextMenuStyle = {
	        display: this.state.showContextMenu ? 'block' : 'none',
	        top: this.state.contextMenTopPos + 45,
	        left: this.state.contextMenuLeftPos
	      };
	
	      if (this.state.center) {
	
	        var markersComponents = null;
	        if (!_.isEmpty(this.props.userLocation)) {
	          markersComponents = _react2.default.createElement(MarkerComponent, { key: 1, lat: this.props.userLocation.latitude,
	            lng: this.props.userLocation.longitude });
	        }
	        var inputProps = {
	          type: "text",
	          placeholder: "🔍 Enter address",
	          value: this.state.address,
	          onChange: this.onChange
	        };
	        var AutocompleteItem = function AutocompleteItem(_ref2) {
	          var suggestion = _ref2.suggestion;
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-map-marker' }),
	            suggestion
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { style: containerStyle, className: 'location-map' },
	          _react2.default.createElement(
	            'span',
	            { style: contextMenuStyle, className: 'context-menu-style' },
	            _react2.default.createElement(
	              'button',
	              { className: 'first-btn', onClick: this.addSite },
	              'Update Location'
	            )
	          ),
	          _react2.default.createElement(
	            'header',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'dashboard-info' },
	              _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: this.backBtnClick },
	                  'Back'
	                ),
	                '\xA0Enter address below to find location on map. Then right click on map to Add or Update location.'
	              )
	            ),
	            _react2.default.createElement(_reactPlacesAutocomplete2.default, {
	              inputProps: inputProps,
	              onSelect: this.placesHandleSelect,
	              onEnterKeyDown: this.placesHandleSelect,
	              autocompleteItem: AutocompleteItem
	            })
	          ),
	          _react2.default.createElement(
	            _googleMapReact2.default,
	            {
	              defaultCenter: this.state.center,
	              center: this.state.center,
	              defaultZoom: 18,
	              onClick: this.mapClick,
	              onGoogleApiLoaded: this.mapLoaded,
	              yesIWantToUseGoogleMapApiInternals: true,
	              ref: 'chooseLocationMap'
	            },
	            _react2.default.createElement(CenterMarkerComponent, { lat: this.state.center.lat,
	              lng: this.state.center.lng }),
	            markersComponents
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return ChooseLocationMap;
	}(_react.Component);
	
	var MarkerComponent = function (_Component2) {
	  _inherits(MarkerComponent, _Component2);
	
	  function MarkerComponent(props) {
	    _classCallCheck(this, MarkerComponent);
	
	    return _possibleConstructorReturn(this, (MarkerComponent.__proto__ || Object.getPrototypeOf(MarkerComponent)).call(this, props));
	  }
	
	  _createClass(MarkerComponent, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'marker-translate' },
	        _react2.default.createElement('img', { src: '/img/marker.png', alt: '' })
	      );
	    }
	  }]);
	
	  return MarkerComponent;
	}(_react.Component);
	
	var CenterMarkerComponent = function (_Component3) {
	  _inherits(CenterMarkerComponent, _Component3);
	
	  function CenterMarkerComponent(props) {
	    _classCallCheck(this, CenterMarkerComponent);
	
	    return _possibleConstructorReturn(this, (CenterMarkerComponent.__proto__ || Object.getPrototypeOf(CenterMarkerComponent)).call(this, props));
	  }
	
	  _createClass(CenterMarkerComponent, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'marker-translate' },
	        _react2.default.createElement('img', { src: '/img/center_marker.png' })
	      );
	    }
	  }]);
	
	  return CenterMarkerComponent;
	}(_react.Component);
	
	var select = function select(state, props) {
	  return {
	    userLocation: state.user.position,
	    userProfile: state.user.profile
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(ChooseLocationMap);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ChooseLocationMap, 'ChooseLocationMap', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/ChooseLocationMap.js');
	
	  __REACT_HOT_LOADER__.register(MarkerComponent, 'MarkerComponent', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/ChooseLocationMap.js');
	
	  __REACT_HOT_LOADER__.register(CenterMarkerComponent, 'CenterMarkerComponent', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/ChooseLocationMap.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/ChooseLocationMap.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/ChooseLocationMap.js');
	}();

	;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _Article = __webpack_require__(62);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _Footer = __webpack_require__(67);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Form = __webpack_require__(53);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _TextInput = __webpack_require__(123);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _reactRouter = __webpack_require__(43);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _nav = __webpack_require__(28);
	
	var _settings = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var profileData = {};
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this2 = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this2.imageUpload = _this2.imageUpload.bind(_this2);
	    _this2.update = _this2.update.bind(_this2);
	    _this2.cancel = _this2.cancel.bind(_this2);
	    _this2.profileDataChange = _this2.profileDataChange.bind(_this2);
	    _this2.chooseLocation = _this2.chooseLocation.bind(_this2);
	    _this2.state = {
	      display: true
	    };
	    return _this2;
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      profileData = {};
	      this.props.dispatch((0, _nav.navEnable)(true));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      profileData = {};
	      var position = this.props.userProfile.siteLocation && this.props.userProfile.siteLocation.latitude ? this.props.userProfile.siteLocation : {};
	      this.props.dispatch((0, _settings.updateUserLocation)(position));
	      // this._graphicSizer.stop();
	    }
	  }, {
	    key: 'imageUpload',
	    value: function imageUpload(event) {
	      // console.log('e', event)
	      var _this = this;
	      if (event.target.files && event.target.files[0]) {
	
	        var sizeOfImageInKb = event.target.files[0].size * 0.001;
	        if (sizeOfImageInKb > 800) {
	          alert('Image size exceeds 800 Kb!. Please select another image.');
	          _this.refs.inputFile.value = '';
	        } else {
	          var FR = new FileReader();
	
	          FR.addEventListener("load", function (e) {
	
	            var imageinBase64 = e.target.result;
	
	            var splitedArr = imageinBase64.split(',');
	            _this.refs.profilePic.src = 'data:image/jpeg;base64,' + splitedArr[1];
	            profileData['profileImage'] = splitedArr[1];
	            // document.getElementById("b64").innerHTML = e.target.result;
	          });
	
	          FR.readAsDataURL(event.target.files[0]);
	        }
	      }
	    }
	  }, {
	    key: 'profileDataChange',
	    value: function profileDataChange(key, event) {
	      profileData[key] = event.target.value;
	    }
	  }, {
	    key: 'chooseLocation',
	    value: function chooseLocation() {
	      _reactRouter.browserHistory.push({
	        pathname: _Constants2.default.ROUTES.CHOOSE_LOCATION,
	        // search: '?name=' + sitename_enc,
	        state: {}
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	
	      if (this.props.userLocation.latitude) {
	        profileData['siteLocation'] = {
	          latitude: this.props.userLocation.latitude,
	          longitude: this.props.userLocation.longitude
	        };
	      }
	      this.props.dispatch((0, _settings.updateProfile)(profileData));
	      // profileData={};
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      var _this3 = this;
	
	      // console.log('forceUpdate')
	      this.setState({
	        display: false
	      }, function () {
	        _this3.setState({
	          display: true
	        });
	      });
	      // initialGetUserProfile(localStorage.userId)
	    }
	  }, {
	    key: 'getLocation',
	    value: function getLocation() {
	      if (this.props.userProfile && this.props.userProfile.username) {
	        if (this.props.userLocation.latitude) {
	          return 'Latitude:' + this.props.userLocation.latitude.toFixed(3) + ', Longitude:' + this.props.userLocation.longitude.toFixed(3);
	        } else {
	          return '';
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.userProfile && this.state.display) {
	        // alert(this.props.userProfile.profileImage)
	        return _react2.default.createElement(
	          'div',
	          { className: 'settings' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'image-container' },
	              this.props.userProfile.profileImage && this.props.userProfile.profileImage.length > 0 ? _react2.default.createElement('img', { ref: 'profilePic', src: 'data:image/jpeg;base64,' + this.props.userProfile.profileImage, alt: '' }) : _react2.default.createElement('img', { ref: 'profilePic', src: '', alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'user-name inlineblock' },
	              this.props.userProfile.displayName
	            ),
	            _react2.default.createElement('input', { type: 'file', id: 'myFile', size: '50', accept: 'image/*', className: 'input-upload', ref: 'inputFile', onChange: this.imageUpload.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'edit-controls' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item maxwidth' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label inlineblock' },
	                'User Name'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock' },
	                _react2.default.createElement('input', { className: 'maxwidth', onChange: this.profileDataChange.bind(this, 'username'), defaultValue: this.props.userProfile.username, type: 'text' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item maxwidth' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label inlineblock' },
	                'Full Name'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock' },
	                _react2.default.createElement('input', { className: 'maxwidth', onChange: this.profileDataChange.bind(this, 'displayName'), defaultValue: this.props.userProfile.displayName, type: 'text' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item maxwidth' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label inlineblock' },
	                'Password'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock' },
	                _react2.default.createElement('input', { className: 'maxwidth', onChange: this.profileDataChange.bind(this, 'password'), type: 'password' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item maxwidth' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label inlineblock' },
	                'Email'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock' },
	                _react2.default.createElement('input', { className: 'maxwidth', onChange: this.profileDataChange.bind(this, 'email'), defaultValue: this.props.userProfile.email, type: 'text' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-btn-container' },
	            _react2.default.createElement(_Button2.default, { label: 'Update',
	              className: 'lighter-font',
	              onClick: this.update,
	              primary: true,
	              secondary: false,
	              accent: false }),
	            _react2.default.createElement(_Button2.default, { label: 'Cancel',
	              className: 'lighter-font',
	              onClick: this.cancel,
	              primary: true,
	              secondary: false,
	              accent: false })
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	Dashboard.propTypes = {
	  dashboard: _react.PropTypes.object,
	  search: _react.PropTypes.object
	};
	
	var select = function select(state, props) {
	  return {
	
	    userProfile: state.user.profile,
	    userLocation: state.user.position
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(Dashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(profileData, 'profileData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/Settings.js');
	
	  __REACT_HOT_LOADER__.register(Dashboard, 'Dashboard', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/Settings.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/Settings.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/settings/Settings.js');
	}();

	;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(43);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actions = __webpack_require__(13);
	
	var _Article = __webpack_require__(62);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Section = __webpack_require__(54);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Title = __webpack_require__(55);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CaretBack = __webpack_require__(71);
	
	var _CaretBack2 = _interopRequireDefault(_CaretBack);
	
	var _CaretNext = __webpack_require__(193);
	
	var _CaretNext2 = _interopRequireDefault(_CaretNext);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _List = __webpack_require__(497);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(498);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _EditAlert = __webpack_require__(438);
	
	var _EditAlert2 = _interopRequireDefault(_EditAlert);
	
	var _nav = __webpack_require__(28);
	
	var _locationView = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	var _ = __webpack_require__(27);
	// import { getValuesFromParseClass } from '../../actions/Api';
	
	
	var siteName = '';
	var disableAll = false;
	var selectedAlert = false;
	
	var Alerts = function (_Component) {
	  _inherits(Alerts, _Component);
	
	  function Alerts(props) {
	    _classCallCheck(this, Alerts);
	
	    // console.log('ppp', this.props);
	    var _this = _possibleConstructorReturn(this, (Alerts.__proto__ || Object.getPrototypeOf(Alerts)).call(this, props));
	
	    _this.showPopup = _this.showPopup.bind(_this);
	    _this.addAlertBtnClick = _this.addAlertBtnClick.bind(_this);
	    _this.closePopup = _this.closePopup.bind(_this);
	    _this.addAlert = _this.addAlert.bind(_this);
	    _this.deleteAlert = _this.deleteAlert.bind(_this);
	    _this.selectAlert = _this.selectAlert.bind(_this);
	    // this.closeEditPop = this.closeEditPop.bind(this);
	    // this.saveTwig = this.saveTwig.bind(this);
	    // this.loadPrevRecomnd = this.loadPrevRecomnd.bind(this);
	    // this.loadNextRecomnd = this.loadNextRecomnd.bind(this);
	    // this.gotToLocation = this.gotToLocation.bind(this);
	    // this.getLastUpdateValue = this.getLastUpdateValue.bind(this);
	    // this.gotoAlerts = this.gotoAlerts.bind(this);
	    _this.state = {
	      alertItem: '',
	      showPopup: false,
	      addMode: false
	    };
	
	    return _this;
	  }
	
	  _createClass(Alerts, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _nav.navEnable)(true));
	      this.props.dispatch((0, _locationView.getAlertsApi)(this.props.selectedTwig.twigId));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      siteName = '';
	    }
	  }, {
	    key: 'gotoAlerts',
	    value: function gotoAlerts() {
	      _reactRouter.browserHistory.push({
	        pathname: _Constants2.default.ROUTES.ALERTS
	      });
	    }
	  }, {
	    key: 'showPopup',
	    value: function showPopup(alert, alertDetails) {
	      // console.log(ReactDOM.findDOMNode(this.refs.alertPage))
	      var parentElement = _reactDom2.default.findDOMNode(this.refs.alertPage).parentElement;
	      parentElement.scrollTop = 0;
	      parentElement.style.overflow = 'hidden';
	
	      this.setState({
	        showPopup: true,
	        addMode: false,
	        alertItem: { alertDetails: alertDetails, alert: alert }
	      });
	    }
	  }, {
	    key: 'addAlertBtnClick',
	    value: function addAlertBtnClick() {
	      // let parentElement = ReactDOM.findDOMNode(this.refs.alertPage).parentElement;
	      // parentElement.scrollTop = 0;
	      // parentElement.style.overflow = 'hidden';
	      this.setState({
	        showPopup: true,
	        addMode: true
	      });
	    }
	  }, {
	    key: 'addAlert',
	    value: function addAlert(alertData, alertId) {
	      if (this.state.addMode) {
	        alertData['twigId'] = this.props.selectedTwig.twigId;
	        // console.log('alertData::', alertData)
	        this.props.dispatch((0, _locationView.addAlertAction)(alertData, this.props.selectedTwig.twigId));
	      } else {
	        this.props.dispatch((0, _locationView.updateAlertAction)(alertId, alertData, this.props.selectedTwig.twigId));
	      }
	      this.closePopup();
	    }
	  }, {
	    key: 'selectAlert',
	    value: function selectAlert(index) {
	      selectedAlert = this.props.alerts[index];
	    }
	  }, {
	    key: 'deleteAlert',
	    value: function deleteAlert() {
	      if (selectedAlert) {
	        this.props.dispatch((0, _locationView.deleteAlertAction)(selectedAlert.id, this.props.selectedTwig.twigId));
	      } else {
	        alert('Please select an Alert to delete.');
	      }
	      selectedAlert = false;
	    }
	  }, {
	    key: 'closePopup',
	    value: function closePopup() {
	      var parentElement = _reactDom2.default.findDOMNode(this.refs.alertPage).parentElement;
	      parentElement.style.scrollTop = 0;
	      parentElement.style.overflow = 'auto';
	      this.setState({
	        showPopup: false,
	        alertItem: {}
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // console.log('alerts::', this.props.alerts)
	
	      return _react2.default.createElement(
	        _Article2.default,
	        { className: 'maxheight alerts-page', ref: 'alertPage' },
	        _react2.default.createElement(
	          _Header2.default,
	          { size: 'large', pad: { between: 'small', horizontal: 'small' } },
	          _react2.default.createElement(
	            _Title2.default,
	            null,
	            'Alerts'
	          ),
	          _react2.default.createElement(_Button2.default, { label: 'Add Alert',
	            className: 'lighter-font',
	            onClick: this.addAlertBtnClick,
	            primary: true,
	            secondary: false,
	            accent: false }),
	          _react2.default.createElement(_Button2.default, { label: 'Delete Alert',
	            className: 'lighter-font',
	            onClick: this.deleteAlert,
	            primary: true,
	            secondary: false,
	            accent: false })
	        ),
	        _react2.default.createElement(
	          _List2.default,
	          { selectable: true,
	            onSelect: this.selectAlert
	          },
	          this.props.alerts.map(function (alert, index) {
	            return _react2.default.createElement(AlertListItem, { alert: alert, key: index, selectedTwig: _this2.props.selectedTwig, showPopup: _this2.showPopup, addAlert: _this2.addAlert });
	          })
	        ),
	        this.state.showPopup ? _react2.default.createElement(_EditAlert2.default, { show: this.state.showPopup, addMode: this.state.addMode, alertItem: this.state.alertItem, selectedTwig: this.props.selectedTwig, closePopup: this.closePopup, addAlert: this.addAlert }) : null
	      );
	    }
	  }]);
	
	  return Alerts;
	}(_react.Component);
	
	var select = function select(state, props) {
	  return {
	    selectedTwig: state.locationView.selectedTwig,
	    alerts: state.locationView.alerts
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(Alerts);
	
	exports.default = _default;
	
	var AlertListItem = function (_Component2) {
	  _inherits(AlertListItem, _Component2);
	
	  function AlertListItem(props) {
	    _classCallCheck(this, AlertListItem);
	
	    var _this3 = _possibleConstructorReturn(this, (AlertListItem.__proto__ || Object.getPrototypeOf(AlertListItem)).call(this, props));
	
	    _this3.updateState = _this3.updateState.bind(_this3);
	    _this3.updateAlert = _this3.updateAlert.bind(_this3);
	    _this3.toggleAlert = _this3.toggleAlert.bind(_this3);
	    _this3.state = {
	      name: _this3.props.alert.name.toUpperCase(),
	      description: _this3.props.alert.description,
	      isEnabled: _this3.props.alert.isEnabled,
	      detailLabel: '',
	      conditionLabel: '',
	      condition: '',
	      value: '',
	      unit: '',
	      alertType: '',
	      alertTypeLabel: '',
	      detailKey: ''
	    };
	
	    return _this3;
	  }
	
	  _createClass(AlertListItem, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        name: nextProps.alert.name.toUpperCase(),
	        description: nextProps.alert.description,
	        isEnabled: nextProps.alert.isEnabled
	      });
	      this.updateState();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateState();
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState() {
	      var detailKey = '';
	      var alertType = '';
	      var triggers = _.cloneDeep(this.props.alert.triggers);
	      delete triggers['leaf_id'];
	      for (var key in triggers) {
	        detailKey = key;
	        break;
	      }
	      for (var _key in this.props.alert.actions) {
	        alertType = _key;
	        break;
	      }
	      var isGreaterThan = triggers[detailKey]['gt'] != null ? true : false;
	      var isLowerThan = triggers[detailKey]['lt'] != null ? true : false;
	      var value = void 0,
	          conditionLabel = void 0,
	          condition = void 0,
	          detailLabel = '',
	          unit = '';
	      if (isGreaterThan) {
	        conditionLabel = 'Exceeds';
	        value = triggers[detailKey]['gt'];
	        condition = 'gt';
	      }
	      if (isLowerThan) {
	        conditionLabel = 'Falls below';
	        value = triggers[detailKey]['lt'];
	        condition = 'lt';
	      }
	      if (this.props.selectedTwig.details.data[detailKey] && this.props.selectedTwig.details.data[detailKey].label && this.props.selectedTwig.details.data[detailKey].Unit) {
	        detailLabel = this.props.selectedTwig.details.data[detailKey].label;
	        unit = '(' + this.props.selectedTwig.details.data[detailKey].Unit + ')';
	      }
	      this.setState({
	        detailLabel: detailLabel,
	        conditionLabel: conditionLabel,
	        condition: condition,
	        value: value,
	        unit: unit,
	        alertType: alertType,
	        alertTypeLabel: alertType.toUpperCase(),
	        detailKey: detailKey
	      });
	    }
	  }, {
	    key: 'updateAlert',
	    value: function updateAlert() {
	      var alertDetails = {
	        condition: this.state.condition,
	        detailsKey: this.state.detailKey,
	        alertType: this.state.alertType
	      };
	      this.props.showPopup(this.props.alert, alertDetails);
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(event) {
	      var alertData = {
	        isEnabled: !this.state.isEnabled
	      };
	      this.props.addAlert(alertData, this.props.alert.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log('this.state::', this.state)
	      var listClass = this.state.isEnabled ? 'list-item' : 'list-item disabled';
	
	      var enableDisableButton = void 0;
	      if (this.state.isEnabled) {
	        enableDisableButton = _react2.default.createElement(_Button2.default, { label: 'Disable',
	          className: 'lighter-font float-right mr-10',
	          onClick: this.toggleAlert,
	          primary: false,
	          accent: true
	        });
	      } else {
	        enableDisableButton = _react2.default.createElement(_Button2.default, { label: 'Enable',
	          className: 'lighter-font float-right mr-10',
	          onClick: this.toggleAlert,
	          primary: false });
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { className: listClass },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.name
	          ),
	          _react2.default.createElement(_Button2.default, { label: 'Update',
	            className: 'lighter-font float-right mr-10',
	            onClick: this.updateAlert,
	            primary: true,
	            secondary: false,
	            accent: false }),
	          enableDisableButton
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.description
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'secondary' },
	            this.state.detailLabel
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'secondary ml-3' },
	            this.state.conditionLabel + ' ' + this.state.value + ' ' + this.state.unit
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'secondary ml-3' },
	            this.state.alertTypeLabel
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlertListItem;
	}(_react.Component);
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(siteName, 'siteName', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Alerts.js');
	
	  __REACT_HOT_LOADER__.register(disableAll, 'disableAll', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Alerts.js');
	
	  __REACT_HOT_LOADER__.register(selectedAlert, 'selectedAlert', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Alerts.js');
	
	  __REACT_HOT_LOADER__.register(Alerts, 'Alerts', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Alerts.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Alerts.js');
	
	  __REACT_HOT_LOADER__.register(AlertListItem, 'AlertListItem', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Alerts.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/Alerts.js');
	}();

	;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _Controls = __webpack_require__(117);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _DeepSensorControl = __webpack_require__(172);
	
	var _DeepSensorControl2 = _interopRequireDefault(_DeepSensorControl);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Utility = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	var _ = __webpack_require__(27);
	
	var alertData = {};
	
	var EditAlert = function (_Component) {
	  _inherits(EditAlert, _Component);
	
	  function EditAlert(props) {
	    _classCallCheck(this, EditAlert);
	
	    var _this = _possibleConstructorReturn(this, (EditAlert.__proto__ || Object.getPrototypeOf(EditAlert)).call(this, props));
	
	    _this.state = {
	      show: _this.props.show,
	      cateogories: _this.getCategories(),
	      alert: '',
	      name: '',
	      description: '',
	      sensedParameter: '',
	      sensedValueKey: '',
	      sensedValue: '',
	      notificationType: 'email',
	      notificationValue: ''
	    };
	    _this.getCategories = _this.getCategories.bind(_this);
	    _this.saveAlert = _this.saveAlert.bind(_this);
	    _this.dataChange = _this.dataChange.bind(_this);
	    _this.getNameByKey = _this.getNameByKey.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditAlert, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.addMode) {
	        alertData['actions'] = { email: '' };
	        alertData['sensedValueKey'] = 'gt';
	        this.setState({
	          sensedParameter: alertData['sensedParameter']
	        });
	      } else {
	        this.setState({
	          alert: this.props.alertItem.alert,
	          name: this.props.alertItem.alert.name,
	          description: this.props.alertItem.alert.description,
	          sensedParameter: this.props.alertItem.alertDetails.detailsKey,
	          sensedValueKey: this.props.alertItem.alertDetails.condition,
	          sensedValue: this.props.alertItem.alert.triggers[this.props.alertItem.alertDetails.detailsKey][this.props.alertItem.alertDetails.condition],
	          notificationType: this.props.alertItem.alertDetails.alertType,
	          notificationValue: this.props.alertItem.alert.actions[this.props.alertItem.alertDetails.alertType]
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // ReactDOM.findDOMNode(this.refs.editTwigOverlay).scrollTop = 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        show: nextProps.show
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      alertData = {};
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var optionsArr = [];
	      for (var key in this.props.selectedTwig.details.data) {
	        var item = this.props.selectedTwig.details.data[key];
	        item['key'] = key;
	        optionsArr.push(item);
	      }
	
	      var filterObjects = optionsArr.sort(function (a, b) {
	        return a.sort_order - b.sort_order;
	      }).filter(function (each) {
	        return each.sort_order !== 1 && each.sort_order !== 6;
	      });
	      alertData['sensedParameter'] = filterObjects[0].key;
	      return filterObjects;
	    }
	  }, {
	    key: 'dataChange',
	    value: function dataChange(key, event) {
	      var _this2 = this;
	
	      var value = event.target.value;
	      if (key == 'sensedValue') {
	        var isNumber = (0, _Utility.checkForNumber)(value);
	        if (isNumber) {
	          this.setState(_defineProperty({}, key, value), function () {
	            alertData[key] = value;
	          });
	        }
	      } else {
	        this.setState(_defineProperty({}, key, value), function () {
	          if (key == 'notificationType' || key == 'notificationValue') {
	            alertData['actions'] = {};
	            if (key == 'notificationType') {
	              alertData['actions'][value] = _this2.state.notificationValue;
	            } else {
	              alertData['actions'][_this2.state.notificationType] = value;
	            }
	          } else {
	            alertData[key] = value;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'saveAlert',
	    value: function saveAlert() {
	      var alertId = '';
	      var value = void 0;
	      if (this.state.sensedValue !== '') {
	        if (this.props.addMode) {
	          alertData['isEnabled'] = true;
	        } else {
	          alertData['sensedValueKey'] = this.state.sensedValueKey;
	          alertId = this.state.alert.id;
	        }
	        var label = this.getNameByKey(this.state.sensedParameter);
	
	        alertData['name'] = 'ALERT ' + label;
	        var condition = this.state.sensedValueKey == 'gt' ? 'is above' : 'is below';
	        alertData['description'] = label + ' around Stem ' + this.props.selectedTwig.name + ' ' + condition + ' ' + this.state.sensedValue;
	        // console.log(':::::::alertData::::', alertData)
	        this.props.addAlert(alertData, alertId);
	      } else {
	        alert('Please enter alert setting value.');
	      }
	    }
	  }, {
	    key: 'getNameByKey',
	    value: function getNameByKey(key) {
	      var label = '';
	      for (var i = 0; i < this.state.cateogories.length; i++) {
	        if (this.state.cateogories[i].key == key) {
	          label = this.state.cateogories[i].label;
	          break;
	        }
	      }
	      return label.toUpperCase();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var toRender = null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'map-overlay ' + (this.props.show ? 'show' : 'hide') },
	        _react2.default.createElement(
	          'div',
	          { className: 'edit-twig-content', ref: 'editTwigOverlay' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Add/Update Alert'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'edit-controls' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item maxwidth' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label inlineblock width-30' },
	                'Alert Category'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock' },
	                _react2.default.createElement(
	                  'select',
	                  { className: 'maxwidth', value: this.state.sensedParameter, onChange: this.dataChange.bind(this, 'sensedParameter') },
	                  this.state.cateogories.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: item.key, key: index },
	                      item.label
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item maxwidth' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label inlineblock width-30' },
	                'Alert Setting'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock width-30 mr-10' },
	                _react2.default.createElement(
	                  'select',
	                  { className: 'maxwidth', value: this.state.sensedValueKey, onChange: this.dataChange.bind(this, 'sensedValueKey') },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'gt' },
	                    'EXCEEDS'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'lt' },
	                    'FALLS BELOW'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock width-30' },
	                _react2.default.createElement('input', { className: 'maxwidth', type: 'text', value: this.state.sensedValue, onChange: this.dataChange.bind(this, 'sensedValue') })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item maxwidth' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label inlineblock width-30' },
	                'Notification'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock width-30 mr-10' },
	                _react2.default.createElement(
	                  'select',
	                  { className: 'maxwidth', value: this.state.notificationType, onChange: this.dataChange.bind(this, 'notificationType') },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'email' },
	                    'EMAIL'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'sms' },
	                    'SMS'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'iftt' },
	                    'IFTT'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control inlineblock width-30' },
	                _react2.default.createElement('input', { className: 'maxwidth', type: 'text', value: this.state.notificationValue, onChange: this.dataChange.bind(this, 'notificationValue') })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-btn-container' },
	            _react2.default.createElement(_Button2.default, {
	              label: this.props.addMode ? 'Save' : 'Update',
	              onClick: this.saveAlert,
	              primary: true,
	              className: 'mr-5' }),
	            _react2.default.createElement(_Button2.default, {
	              label: 'Cancel',
	              onClick: this.props.closePopup,
	              primary: true })
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditAlert;
	}(_react.Component);
	
	var _default = EditAlert;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(alertData, 'alertData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/EditAlert.js');
	
	  __REACT_HOT_LOADER__.register(EditAlert, 'EditAlert', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/EditAlert.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/EditAlert.js');
	}();

	;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _Controls = __webpack_require__(117);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _DeepSensorControl = __webpack_require__(172);
	
	var _DeepSensorControl2 = _interopRequireDefault(_DeepSensorControl);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	var _ = __webpack_require__(27);
	
	
	var twigObject = { settings: {} };
	
	var EditTwig = function (_Component) {
	  _inherits(EditTwig, _Component);
	
	  function EditTwig(props) {
	    _classCallCheck(this, EditTwig);
	
	    var _this = _possibleConstructorReturn(this, (EditTwig.__proto__ || Object.getPrototypeOf(EditTwig)).call(this, props));
	
	    _this.state = {
	      show: _this.props.show
	    };
	    _this.saveTwig = _this.saveTwig.bind(_this);
	    _this.controlValueChange = _this.controlValueChange.bind(_this);
	    _this.renderTwigControls = _this.renderTwigControls.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditTwig, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      twigObject = { settings: {} };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var element = _reactDom2.default.findDOMNode(this.refs.editTwigContent);
	      element.scrollTop = 0;
	      this.setState({
	        show: nextProps.show
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      twigObject = { settings: {} };
	    }
	  }, {
	    key: 'saveTwig',
	    value: function saveTwig() {
	      this.props.saveTwig(twigObject);
	    }
	  }, {
	    key: 'controlValueChange',
	    value: function controlValueChange(controlInfo, event) {
	      var value = '';
	      if (controlInfo.controlType == _Constants2.default.TWIG_EDIT_CONTROLS.NUMBER_ARRAY || controlInfo.controlType == _Constants2.default.TWIG_EDIT_CONTROLS.STRING_ARRAY) {
	        value = event;
	      } else {
	        value = event.target.value;
	      }
	      if (controlInfo.key == 'name' || controlInfo.key == 'locationName') {
	        twigObject[controlInfo.key] = value;
	      } else {
	        twigObject.settings[controlInfo.key] = {
	          value: value
	        };
	      }
	      this.setState({ twigObject: twigObject });
	    }
	  }, {
	    key: 'renderTwigControls',
	    value: function renderTwigControls() {
	      if (this.props.show && this.props.selectedTwig.settings) {
	        var controlsArr = [];
	        var staticControl = ['name', 'locationName'];
	        for (var i = 0; i < staticControl.length; i++) {
	          var label = staticControl[i] == 'name' ? 'Stem Name' : 'Stem Location';
	          controlsArr.push(_react2.default.createElement(_Controls2.default, { controlType: _Constants2.default.TWIG_EDIT_CONTROLS.NUMBER, label: label, value: this.props.selectedTwig[staticControl[i]], key: staticControl[i], controlKey: staticControl[i], controlValueChange: this.controlValueChange }));
	        }
	
	        var objectToArr = [];
	        for (var key in this.props.selectedTwig.settings) {
	          var control = this.props.selectedTwig.settings[key];
	          control['key'] = key;
	          objectToArr.push(control);
	        }
	        var sortedArr = _.sortBy(objectToArr, [function (o) {
	          return o.key;
	        }]);
	
	        for (var _i = 0; _i < sortedArr.length; _i++) {
	          // for (let key in this.props.selectedTwig.settings) {
	          var _control = sortedArr[_i];
	          if (_control.key === 'sensorName' || _control.key === 'plantType' || _control.key === 'siteName' || _control.key === 'soilType') {
	            if (_control.inputType == _Constants2.default.TWIG_EDIT_CONTROLS.NUMBER_ARRAY || _control.inputType == _Constants2.default.TWIG_EDIT_CONTROLS.STRING_ARRAY) {
	              controlsArr.push(_react2.default.createElement(_DeepSensorControl2.default, { label: _control.label, controlType: _control.inputType, value: _control.value, key: _control.key, controlKey: _control.key, controlValueChange: this.controlValueChange }));
	            } else {
	              var parseClass = '';
	              var hasUser = _control.hasUser ? true : false;
	              if (_control.inputType == _Constants2.default.TWIG_EDIT_CONTROLS.SELECT) {
	                parseClass = _control.parseClass;
	              }
	
	              controlsArr.push(_react2.default.createElement(_Controls2.default, { parseClass: parseClass, hasUser: hasUser, controlType: _control.inputType, label: _control.label, selectedTwig: this.props.selectedTwig, key: _control.key, controlKey: _control.key, controlValueChange: this.controlValueChange,
	                value: twigObject.settings[_control.key] && twigObject.settings[_control.key].value ? twigObject.settings[_control.key].value : _control.value
	              }));
	            }
	          }
	        }
	        return controlsArr;
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var toRender = null;
	      var twigId = this.props.selectedTwig && this.props.selectedTwig.twigId ? this.props.selectedTwig.twigId : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'map-overlay ' + (this.props.show ? 'show' : 'hide') },
	        _react2.default.createElement(
	          'div',
	          { className: 'edit-twig-content', ref: 'editTwigContent' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Stem - ' + twigId
	          ),
	          this.renderTwigControls(),
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-btn-container' },
	            _react2.default.createElement(_Button2.default, {
	              label: 'Update',
	              onClick: this.saveTwig,
	              primary: true,
	              className: 'mr-5' }),
	            _react2.default.createElement(_Button2.default, {
	              label: 'Cancel',
	              onClick: this.props.closeEditPop,
	              primary: true })
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditTwig;
	}(_react.Component);
	
	var _default = EditTwig;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(twigObject, 'twigObject', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/EditTwig.js');
	
	  __REACT_HOT_LOADER__.register(EditTwig, 'EditTwig', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/EditTwig.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/EditTwig.js');
	}();

	;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(43);
	
	var _reactRedux = __webpack_require__(22);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _actions = __webpack_require__(13);
	
	var _Article = __webpack_require__(62);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Section = __webpack_require__(54);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Title = __webpack_require__(55);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Carousel = __webpack_require__(494);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CaretBack = __webpack_require__(71);
	
	var _CaretBack2 = _interopRequireDefault(_CaretBack);
	
	var _CaretNext = __webpack_require__(193);
	
	var _CaretNext2 = _interopRequireDefault(_CaretNext);
	
	var _googleMapReact = __webpack_require__(119);
	
	var _googleMapReact2 = _interopRequireDefault(_googleMapReact);
	
	var _reactPlacesAutocomplete = __webpack_require__(157);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _NavControl = __webpack_require__(44);
	
	var _NavControl2 = _interopRequireDefault(_NavControl);
	
	var _EditTwig = __webpack_require__(439);
	
	var _EditTwig2 = _interopRequireDefault(_EditTwig);
	
	var _nav = __webpack_require__(28);
	
	var _locationView = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	var _ = __webpack_require__(27);
	// import { getValuesFromParseClass } from '../../actions/Api';
	
	
	var siteName = '';
	var mapComponent;
	var disableAll = false;
	var twigNavigation = false;
	window.mapInstance = '';
	
	var SiteView = function (_Component) {
	  _inherits(SiteView, _Component);
	
	  function SiteView(props) {
	    _classCallCheck(this, SiteView);
	
	    var _this = _possibleConstructorReturn(this, (SiteView.__proto__ || Object.getPrototypeOf(SiteView)).call(this, props));
	
	    _this.mapLoaded = _this.mapLoaded.bind(_this);
	    _this.loadNext = _this.loadNext.bind(_this);
	    _this.loadPrev = _this.loadPrev.bind(_this);
	    _this.editTwig = _this.editTwig.bind(_this);
	    _this.getOptionsFromApi = _this.getOptionsFromApi.bind(_this);
	    _this.renderTwigDetails = _this.renderTwigDetails.bind(_this);
	    _this.closeEditPop = _this.closeEditPop.bind(_this);
	    _this.saveTwig = _this.saveTwig.bind(_this);
	    _this.loadPrevRecomnd = _this.loadPrevRecomnd.bind(_this);
	    _this.loadNextRecomnd = _this.loadNextRecomnd.bind(_this);
	    _this.gotToLocation = _this.gotToLocation.bind(_this);
	    _this.getLastUpdateValue = _this.getLastUpdateValue.bind(_this);
	    _this.gotoAlerts = _this.gotoAlerts.bind(_this);
	    _this.getCenter = _this.getCenter.bind(_this);
	    _this.updateTwigLocation = _this.updateTwigLocation.bind(_this);
	    _this.mapClick = _this.mapClick.bind(_this);
	    _this.markerClick = _this.markerClick.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.placesHandleSelect = _this.placesHandleSelect.bind(_this);
	    _this.state = {
	      center: '',
	      selectedTwig: _this.props.selectedTwig && _this.props.selectedTwig.details && _this.props.selectedTwig.details.data ? _this.props.selectedTwig : { details: { data: {} } },
	      showEditPopup: false,
	      recommendation: _this.props.selectedTwig && _this.props.selectedTwig.recommendations.length > 0 ? _this.props.selectedTwig.recommendations[0] : null,
	      recommendationIndex: 0,
	      showMarker: true,
	      showContextMenu: false,
	      contextMenTopPos: 0,
	      contextMenuLeftPos: 0,
	      address: ''
	
	    };
	
	    return _this;
	  }
	
	  _createClass(SiteView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _nav.navEnable)(true));
	      disableAll = false;
	      var _selectedTwigIndex = 0;
	      // debugger
	      // this.getCenter(this.props.selectedTwig);
	      if (this.props.selectedTwigIndex) {
	        _selectedTwigIndex = Number(this.props.selectedTwigIndex);
	      }
	      if (this.props.location.state && this.props.location.state.name) {
	        siteName = decodeURIComponent(this.props.location.state.name);
	        this.setState({
	          center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
	        });
	        this.props.dispatch((0, _locationView.loadTwigs)(false, siteName, _selectedTwigIndex));
	      } else {
	        this.props.dispatch((0, _locationView.loadTwigs)(false, '', _selectedTwigIndex));
	      }
	
	      // if (siteName.length > 0) {
	
	      // } else { }
	
	      // this.props.dispatch(navEnable(true));
	      // disableAll = false;
	      // // debugger
	      // if (this.props.location.state && this.props.location.state.name) {
	      //   siteName = decodeURIComponent(this.props.location.state.name);
	      //   this.setState({
	      //     center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
	      //   });
	      // } else {
	      //   if (this.props.sites.length > 0) {
	      //     siteName = this.props.sites[0].name;
	      //     if (this.props.sites[0].location && this.props.sites[0].location.latitude && this.props.sites[0].location.longitude) {
	      //       this.setState({
	      //         center: { lat: this.props.sites[0].location.latitude, lng: this.props.sites[0].location.longitude }
	      //       })
	      //     } else {
	      //       this.getCenter();
	      //     }
	
	      //   } else {
	      //     this.getCenter();
	      //   }
	      // }
	      // if (siteName.length > 0) {
	      //   this.props.dispatch(loadTwigs(false, siteName, 0));
	      // }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // this.promptLocationSettingsStatus()
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	
	      this.setState({
	        recommendation: nextProps.selectedTwig && nextProps.selectedTwig.recommendations.length > 0 ? nextProps.selectedTwig.recommendations[0] : null,
	        recommendationIndex: 0
	      }, function () {
	        if (twigNavigation == false) {
	          // this.getCenter(nextProps.selectedTwig);
	        }
	      });
	
	      if (twigNavigation == false) {
	        this.setMapBoundary(nextProps);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // this.setMapBoundary(this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      siteName = '';
	      mapComponent = '';
	      twigNavigation = '';
	    }
	  }, {
	    key: 'promptLocationSettingsStatus',
	    value: function promptLocationSettingsStatus() {
	      if (navigator.geolocation) {
	        navigator.geolocation.getCurrentPosition(function (position) {}, function (error) {
	          alert("Your browser has disabled location tracking. Please enable location tracking of your browser to make the application to work properly");
	        });
	      }
	    }
	  }, {
	    key: 'getCenter',
	    value: function getCenter(selectedTwig) {
	      var _this2 = this;
	
	      if (this.props.location.state && this.props.location.state.name) {
	
	        this.setState({
	          center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
	        });
	      } else if (selectedTwig.location) {
	        this.setState({
	          center: {
	            lat: selectedTwig.location.latitude,
	            lng: selectedTwig.location.longitude
	          },
	          showMarker: true
	        });
	      } else if (this.props.userProfile && this.props.userProfile.siteLocation) {
	        this.setState({
	          center: {
	            lat: this.props.userProfile.siteLocation.latitude, lng: this.props.userProfile.siteLocation.longitude
	          }
	        });
	      } else if (navigator.geolocation) {
	        navigator.geolocation.getCurrentPosition(function (position) {
	          var postionObj = {
	            lat: position.coords.latitude, lng: position.coords.longitude
	          };
	          _this2.setState({
	            center: postionObj,
	            showMarker: false
	          });
	        });
	      } else {
	        this.setState({
	          center: null
	        });
	      }
	    }
	  }, {
	    key: 'setMapBoundary',
	    value: function setMapBoundary(props) {
	
	      if (props.twigsList && props.twigsList.length > 0) {
	        var bounds = new google.maps.LatLngBounds();
	        var twigLocationSet = false;
	        props.twigsList.filter(function (item) {
	          return item != undefined && item.location !== undefined;
	        }).forEach(function (item) {
	          bounds.extend(new google.maps.LatLng(item.location.latitude, item.location.longitude));
	          twigLocationSet = true;
	        });
	        // debugger
	        if (mapComponent && twigLocationSet) {
	          mapComponent.map.fitBounds(bounds);
	        } else if (this.props.location.state && this.props.location.state.name) {
	          this.setState({
	            center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
	          });
	        }
	      } else {
	        if (this.props.location.state && this.props.location.state.name) {
	          this.setState({
	            center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'mapLoaded',
	    value: function mapLoaded(mapObj) {
	      var _this3 = this;
	
	      mapComponent = mapObj;
	      window.mapInstance = mapObj;
	      mapObj.map.setMapTypeId('satellite');
	      mapObj.map.setTilt(1);
	
	      this.setMapBoundary(this.props);
	      mapObj.map.addListener('rightclick', function (event) {
	        /*
	          markerLat: event.latLng.lat(),
	          markerLong: event.latLng.lng()*/
	        _this3.setState({
	          showContextMenu: true,
	          contextMenTopPos: event.pixel.y,
	          contextMenuLeftPos: event.pixel.x,
	          twigLocationLat: event.latLng.lat(),
	          twigLocationLng: event.latLng.lng()
	        });
	      });
	    }
	  }, {
	    key: 'updateTwigLocation',
	    value: function updateTwigLocation() {
	      var _this4 = this;
	
	      var data = {
	        location: {
	          latitude: this.state.twigLocationLat,
	          longitude: this.state.twigLocationLng
	        }
	
	        //call api
	      };this.setState({
	        showContextMenu: false
	      }, function () {
	        _this4.saveTwigLocation(data);
	      });
	    }
	  }, {
	    key: 'loadNext',
	    value: function loadNext() {
	      twigNavigation = true;
	      this.props.dispatch((0, _locationView.updateSelectedTwig)(this.props.selectedTwigIndex + 1));
	    }
	  }, {
	    key: 'loadPrev',
	    value: function loadPrev() {
	      twigNavigation = true;
	      this.props.dispatch((0, _locationView.updateSelectedTwig)(this.props.selectedTwigIndex - 1));
	    }
	  }, {
	    key: 'editTwig',
	    value: function editTwig(selectedValue, index) {
	      this.props.dispatch((0, _locationView.updateSelectedTwig)(index));
	      this.setState({
	        showEditPopup: true
	      });
	    }
	  }, {
	    key: 'closeEditPop',
	    value: function closeEditPop() {
	      this.setState({ showEditPopup: false });
	    }
	  }, {
	    key: 'saveTwigLocation',
	    value: function saveTwigLocation(data) {
	      this.props.dispatch((0, _locationView.updateTwigApi)(this.props.selectedTwig.twigId, data, siteName, this.props.selectedTwigIndex));
	    }
	  }, {
	    key: 'saveTwig',
	    value: function saveTwig(twigObject) {
	      var _this5 = this;
	
	      this.setState({
	        showEditPopup: false
	      }, function () {
	        _this5.props.dispatch((0, _locationView.updateTwigApi)(_this5.props.selectedTwig.twigId, twigObject, siteName, _this5.props.selectedTwigIndex));
	      });
	    }
	  }, {
	    key: 'getOptionsFromApi',
	    value: function getOptionsFromApi(parseClass) {
	      getValuesFromParseClass(parseClass).then(function (response) {}).catch(function (error) {});
	    }
	  }, {
	    key: 'loadNextRecomnd',
	    value: function loadNextRecomnd() {
	      if (this.state.recommendation && this.state.recommendationIndex != this.props.selectedTwig.recommendations.length - 1) {
	        var index = this.state.recommendationIndex + 1;
	        this.setState({
	          recommendation: this.props.selectedTwig.recommendations[index],
	          recommendationIndex: index
	        });
	      }
	    }
	  }, {
	    key: 'loadPrevRecomnd',
	    value: function loadPrevRecomnd() {
	      if (this.state.recommendation && this.state.recommendationIndex != 0) {
	        var index = this.state.recommendationIndex - 1;
	        this.setState({
	          recommendation: this.props.selectedTwig.recommendations[index],
	          recommendationIndex: index
	        });
	      }
	    }
	  }, {
	    key: 'gotToLocation',
	    value: function gotToLocation(selectedValue, index) {
	      this.props.dispatch((0, _locationView.updateSelectedTwig)(index));
	      // let sitename_enc = encodeURIComponent(siteInfo.name);
	      _reactRouter.browserHistory.push({
	        pathname: _Constants2.default.ROUTES.LOCATIONVIEW,
	        // search: '?twigId=' + this.props.selectedTwig.twigId,
	        state: {
	          selectedTwigIndex: index,
	          twigId: selectedValue.twigId
	          // twigsList: this.props.twigsList,
	          // showChart: this.props.showChart
	        }
	      });
	    }
	  }, {
	    key: 'gotoAlerts',
	    value: function gotoAlerts(selectedValue, index) {
	      this.props.dispatch((0, _locationView.updateSelectedTwig)(index));
	      _reactRouter.browserHistory.push({
	        pathname: _Constants2.default.ROUTES.ALERTS,
	        state: {
	          selectedTwig: selectedValue
	        }
	      });
	    }
	  }, {
	    key: 'mapClick',
	    value: function mapClick(e) {
	      this.setState({
	        showContextMenu: false,
	        contextMenTopPos: 0,
	        contextMenuLeftPos: 0
	      });
	    }
	  }, {
	    key: 'getLastUpdateValue',
	    value: function getLastUpdateValue(value) {
	      var today = new Date(new Date().toISOString());
	      var updatedAt = new Date(value);
	
	      var lastUpdatedDate = Math.floor((today.getTime() - updatedAt.getTime()) / 1000);
	
	      var label = 'secs';
	      if (lastUpdatedDate >= 31556926) {
	        lastUpdatedDate = Math.floor(lastUpdatedDate / 31556926);
	        label = lastUpdatedDate <= 1 ? 'year' : 'years';
	      }
	      if (lastUpdatedDate >= 2629744) {
	        lastUpdatedDate = Math.floor(lastUpdatedDate / 2629744);
	        label = lastUpdatedDate <= 1 ? 'month' : 'months';
	      }
	      if (lastUpdatedDate >= 86400) {
	        lastUpdatedDate = Math.floor(lastUpdatedDate / 86400);
	        label = lastUpdatedDate <= 1 ? 'day' : 'days';
	      }
	      if (lastUpdatedDate >= 3600) {
	        lastUpdatedDate = Math.floor(lastUpdatedDate / 3600);
	        label = lastUpdatedDate <= 1 ? 'hr' : 'hrs';
	      }
	      if (lastUpdatedDate >= 60) {
	        lastUpdatedDate = Math.floor(lastUpdatedDate / 60);
	        label = lastUpdatedDate <= 1 ? 'min' : 'mins';
	      }
	
	      // return lastUpdatedDate + ' ' + label;
	      _moment2.default.locale('en', {
	        relativeTime: {
	          future: 'in %s',
	          past: '%s ago',
	          s: 'few secs',
	          ss: '%s secs',
	          m: 'a min',
	          mm: '%d mins',
	          h: 'an hr',
	          hh: '%d hrs',
	          d: 'a day',
	          dd: '%d days',
	          M: 'a month',
	          MM: '%d months',
	          y: 'a year',
	          yy: '%d years'
	        }
	      });
	      return (0, _moment2.default)(value).fromNow(true);
	    }
	  }, {
	    key: 'markerClick',
	    value: function markerClick(indexOfTwig, event) {
	      // console.log(':::', indexOfTwig)
	      twigNavigation = true;
	      this.props.dispatch((0, _locationView.updateSelectedTwig)(indexOfTwig));
	    }
	  }, {
	    key: 'renderFirstContainer',
	    value: function renderFirstContainer(selectedValue, index) {
	      var _this6 = this;
	
	      if (selectedValue) {
	        var titleValue = (selectedValue.name ? selectedValue.name.toUpperCase() + ' AT ' : '- AT ') + (selectedValue.locationName ? selectedValue.locationName.toUpperCase() : '-');
	        return [_react2.default.createElement(
	          _Title2.default,
	          { title: titleValue, key: '1' },
	          (selectedValue.name ? selectedValue.name.toUpperCase() + ' AT ' : '- AT ') + (selectedValue.locationName ? selectedValue.locationName.toUpperCase() : '-')
	        ), _react2.default.createElement(
	          'div',
	          { key: '2', className: 'recommendation' },
	          _react2.default.createElement(
	            'div',
	            { className: 'btn-panel' },
	            _react2.default.createElement(
	              'button',
	              { onClick: function onClick() {
	                  _this6.gotoAlerts(selectedValue, index);
	                } },
	              'Alerts'
	            ),
	            _react2.default.createElement(
	              'button',
	              { onClick: function onClick() {
	                  _this6.editTwig(selectedValue, index);
	                } },
	              'Edit'
	            )
	          )
	        ), _react2.default.createElement(
	          'div',
	          { key: '3', className: 'info-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'value' },
	              selectedValue.recommendations.length
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'label' },
	              'Requests'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'value left-pad' },
	              this.getLastUpdateValue(selectedValue.updatedAt)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'label' },
	              'Last Updated'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'value' },
	              selectedValue.settings.deepSensorCount.value
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'label' },
	              'Sensors'
	            )
	          )
	        )];
	      } else {
	        disableAll = true;
	        return _react2.default.createElement(
	          'h4',
	          null,
	          'No data'
	        );
	      }
	    }
	  }, {
	    key: 'renderTwigDetails',
	    value: function renderTwigDetails(selectedValue, indexValue) {
	      var _this7 = this;
	
	      var itemArr = [];
	      try {
	        itemArr.push(_react2.default.createElement('div', null));
	        if (selectedValue && selectedValue.details && selectedValue.details.data) {
	          var allObjects = [];
	          for (var each in selectedValue.details.data) {
	            allObjects.push(selectedValue.details.data[each]);
	          }
	          var filterObjects = allObjects.sort(function (a, b) {
	            return a.sort_order - b.sort_order;
	          }).filter(function (each) {
	            return each.sort_order !== 1 && each.sort_order !== 6;
	          });
	
	          var sensorNames = ['', '', ''];
	          if (selectedValue.settings.sensorName && selectedValue.settings.sensorName.value) {
	            (selectedValue.settings.sensorName.value || []).map(function (eachSensor, sensorIndex) {
	              sensorNames[sensorIndex] = Object.values(eachSensor)[0];
	            });
	          }
	
	          itemArr[0] = [_react2.default.createElement(
	            'div',
	            { className: 'item', onClick: function onClick() {
	                _this7.gotToLocation(selectedValue, indexValue);
	              } },
	            _react2.default.createElement('div', { className: 'halfwidth label' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'halfwidth inlineblock value-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'values' },
	                sensorNames[0] !== '' ? sensorNames[0] : '-'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'values' },
	                sensorNames[1] !== '' ? sensorNames[1] : '-'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'values' },
	                sensorNames[2] !== '' ? sensorNames[2] : '-'
	              )
	            )
	          )];
	
	          filterObjects.map(function (item, index) {
	            var arr = ['', '', ''];
	            var arrkey = ['', '', ''];
	            if (item.multivalue && !_.isEmpty(item.multivalue)) {
	              Object.keys(item.multivalue).map(function (subkey, subindex) {
	                arr[subindex] = item.multivalue[subkey];
	                arrkey[subindex] = subkey.split(" ")[0];
	              });
	            } else if (item.value || item.value == 0) {
	              arr[0] = item.value;
	            }
	
	            itemArr.push(_react2.default.createElement(
	              'div',
	              { className: 'item', key: index, onClick: function onClick() {
	                  _this7.gotToLocation(selectedValue, indexValue);
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'halfwidth label' },
	                item.label + ' (' + item.Unit + ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'halfwidth inlineblock value-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'values' },
	                  arr[0] !== '' ? arr[0].toFixed(1) : '-'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'values' },
	                  arr[1] !== '' ? arr[1].toFixed(1) : '-'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'values' },
	                  arr[2] !== '' ? arr[2].toFixed(1) : '-'
	                )
	              )
	            ));
	          });
	        }
	      } catch (e) {
	        console.error(e);
	      }
	      return itemArr;
	    }
	  }, {
	    key: 'onContextMenu',
	    value: function onContextMenu(event) {
	      // console.log('on context menu')
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(address) {
	      this.setState({
	        address: address
	      });
	    }
	  }, {
	    key: 'placesHandleSelect',
	    value: function placesHandleSelect(address) {
	      var _this8 = this;
	
	      this.setState({
	        address: address
	      });
	      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
	        return (0, _reactPlacesAutocomplete.getLatLng)(results[0]);
	      }).then(function (_ref) {
	        var lat = _ref.lat,
	            lng = _ref.lng;
	
	        // console.log('Success Yay', { lat, lng })
	        _this8.setState({
	          center: {
	            lat: lat, lng: lng
	          },
	          zoom: 15
	        });
	      }).catch(function (error) {
	        // console.log('Error:', error)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var twigsList = this.props.twigsList;
	
	      var renderMap = null;
	      var contextMenuStyle = {
	        display: this.state.showContextMenu ? 'block' : 'none',
	        top: this.state.contextMenTopPos,
	        left: this.state.contextMenuLeftPos
	        /*options={{ mapTypeControl: true }}*/
	      };var inputProps = {
	        type: "text",
	        placeholder: "🔍 Enter address",
	        value: this.state.address,
	        onChange: this.onChange
	      };
	      var AutocompleteItem = function AutocompleteItem(_ref2) {
	        var suggestion = _ref2.suggestion;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('i', { className: 'fa fa-map-marker' }),
	          suggestion
	        );
	      };
	      if (this.state.center) {
	        // let marker = this.state.showMarker ? <MarkerComponent lat={this.state.center.lat}
	        //   lng={this.state.center.lng} twigName={this.props.selectedTwig.name} /> : null;
	
	        var marker = this.props.twigsList.map(function (item, index) {
	          if (item && item.location) {
	            return _react2.default.createElement(MarkerComponent, { key: index, lat: item.location.latitude,
	              lng: item.location.longitude, selectedTwigIndex: _this9.props.selectedTwigIndex, indexOfTwig: index, markerClick: _this9.markerClick, twigInfo: item });
	          } else {
	            return null;
	          }
	        });
	
	        renderMap = [_react2.default.createElement(
	          'span',
	          { style: contextMenuStyle, className: 'context-menu-style' },
	          _react2.default.createElement(
	            'button',
	            { onClick: this.updateTwigLocation },
	            'Update Stem Location'
	          )
	        ), _react2.default.createElement(
	          _googleMapReact2.default,
	          {
	            defaultCenter: this.state.center,
	            center: this.state.center,
	            onClick: this.mapClick,
	            defaultZoom: 19,
	            zoom: this.state.zoom,
	            options: {
	              rotateControl: true
	            },
	            onGoogleApiLoaded: this.mapLoaded,
	            yesIWantToUseGoogleMapApiInternals: true,
	            ref: 'googleMapSiteView'
	          },
	          _react2.default.createElement(CenterMarkerComponent, { lat: this.state.center.lat,
	            lng: this.state.center.lng }),
	          marker
	        )];
	      }
	
	      return _react2.default.createElement(
	        _Article2.default,
	        { className: 'maxheight site-view', style: { overflowY: 'auto' } },
	        (twigsList || []).map(function (each, index) {
	          return _react2.default.createElement(
	            _Section2.default,
	            { pad: 'none',
	              align: 'start',
	              className: 'site-control-container',
	              direction: 'row',
	              flex: false,
	              style: { borderBottom: '1px solid white' }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'container1' },
	              _this9.renderFirstContainer(each, index)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: "container2 " + (_this9.props.twigsList.length > 0 ? '' : 'hide') },
	              _react2.default.createElement(
	                'div',
	                { className: 'details-container' },
	                _this9.renderTwigDetails(each, index)
	              )
	            )
	          );
	        }),
	        this.state.showEditPopup ? _react2.default.createElement(_EditTwig2.default, { show: this.state.showEditPopup, selectedTwig: this.props.selectedTwig, getOptionsFromApi: this.getOptionsFromApi, closeEditPop: this.closeEditPop, saveTwig: this.saveTwig }) : null
	      );
	    }
	  }]);
	
	  return SiteView;
	}(_react.Component);
	
	var select = function select(state, props) {
	  return {
	    twigsList: state.locationView.twigsList,
	    selectedTwig: state.locationView.selectedTwig,
	    selectedTwigIndex: state.locationView.selectedTwigIndex,
	    sites: state.dashboard.sites
	    // showChart: state.locationView.showChart
	  };
	};
	
	var _default = (0, _reactRedux.connect)(select)(SiteView);
	
	exports.default = _default;
	
	var MarkerComponent = function (_Component2) {
	  _inherits(MarkerComponent, _Component2);
	
	  function MarkerComponent(props) {
	    _classCallCheck(this, MarkerComponent);
	
	    return _possibleConstructorReturn(this, (MarkerComponent.__proto__ || Object.getPrototypeOf(MarkerComponent)).call(this, props));
	  }
	
	  _createClass(MarkerComponent, [{
	    key: 'render',
	    value: function render() {
	      var selectedStyle = {
	        border: '2px solid #f3fa07'
	      };
	      var divStyle = {
	        position: 'absolute',
	        top: 0,
	        'text-align': 'left',
	        width: '150px',
	        'font-size': '10px',
	        'text-shadow': '2px 2px black',
	        color: 'white'
	      };
	      var imgMarkerStyle = this.props.selectedTwigIndex == this.props.indexOfTwig ? selectedStyle : {};
	      return _react2.default.createElement(
	        'span',
	        { className: 'marker-translate' },
	        _react2.default.createElement('img', { style: imgMarkerStyle, onClick: this.props.markerClick.bind(this, this.props.indexOfTwig), src: '/img/stem_marker.png', title: this.props.twigInfo.name, alt: this.props.twigInfo.name }),
	        _react2.default.createElement(
	          'div',
	          { style: divStyle },
	          this.props.twigInfo.name
	        )
	      );
	    }
	  }]);
	
	  return MarkerComponent;
	}(_react.Component);
	
	var CenterMarkerComponent = function (_Component3) {
	  _inherits(CenterMarkerComponent, _Component3);
	
	  function CenterMarkerComponent(props) {
	    _classCallCheck(this, CenterMarkerComponent);
	
	    return _possibleConstructorReturn(this, (CenterMarkerComponent.__proto__ || Object.getPrototypeOf(CenterMarkerComponent)).call(this, props));
	  }
	
	  _createClass(CenterMarkerComponent, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'marker-translate' },
	        _react2.default.createElement('img', { src: '/img/center_marker.png' })
	      );
	    }
	  }]);
	
	  return CenterMarkerComponent;
	}(_react.Component);
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(siteName, 'siteName', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	
	  __REACT_HOT_LOADER__.register(mapComponent, 'mapComponent', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	
	  __REACT_HOT_LOADER__.register(disableAll, 'disableAll', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	
	  __REACT_HOT_LOADER__.register(twigNavigation, 'twigNavigation', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	
	  __REACT_HOT_LOADER__.register(SiteView, 'SiteView', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	
	  __REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	
	  __REACT_HOT_LOADER__.register(MarkerComponent, 'MarkerComponent', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	
	  __REACT_HOT_LOADER__.register(CenterMarkerComponent, 'CenterMarkerComponent', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/site/SiteView.js');
	}();

	;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(22);
	
	var _nav = __webpack_require__(28);
	
	var _subscriptionView = __webpack_require__(171);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _actions = __webpack_require__(13);
	
	var _Close = __webpack_require__(63);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubscriptionView = function (_Component) {
		_inherits(SubscriptionView, _Component);
	
		function SubscriptionView(props) {
			_classCallCheck(this, SubscriptionView);
	
			var _this = _possibleConstructorReturn(this, (SubscriptionView.__proto__ || Object.getPrototypeOf(SubscriptionView)).call(this, props));
	
			_this._renderSubscriptionLog = _this._renderSubscriptionLog.bind(_this);
			_this._renderSubscriptions = _this._renderSubscriptions.bind(_this);
			_this.getCancellationInfo = _this.getCancellationInfo.bind(_this);
			_this.handleConfirmation = _this.handleConfirmation.bind(_this);
			_this.closeConfirmationDialog = _this.closeConfirmationDialog.bind(_this);
			_this._setDocumentTitle(props);
			_this.state = {
				subscriptionDetails: {}
			};
			return _this;
		}
	
		_createClass(SubscriptionView, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.props.dispatch((0, _nav.navEnable)(true));
				this.props.dispatch((0, _subscriptionView.getSubscriptionHistory)());
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {}
		}, {
			key: 'componentDidmount',
			value: function componentDidmount() {}
		}, {
			key: '_setDocumentTitle',
			value: function _setDocumentTitle(props) {
				document.title = 'Subscription ';
			}
		}, {
			key: '_renderSubscriptions',
			value: function _renderSubscriptions() {
				var _this2 = this;
	
				var subscriptionTable = [];
				var unsubscribed = [];
				var twigs = [];
				var subscriptions = [];
				subscriptionTable.push(_react2.default.createElement(
					'div',
					{ key: 'subscriptionsHeader', className: 'subscription-table-header' },
					_react2.default.createElement(
						'div',
						null,
						'Stem ID'
					),
					_react2.default.createElement(
						'div',
						null,
						'Stem Name'
					),
					_react2.default.createElement(
						'div',
						null,
						'Subscription'
					),
					_react2.default.createElement(
						'div',
						null,
						'Status'
					),
					_react2.default.createElement(
						'div',
						null,
						'Modify'
					)
				));
				if (this.props.subscribedTwigs && this.props.subscribedTwigs.length > 0) {
					_.forEach(this.props.subscribedTwigs, function (data, index) {
						subscriptions.push(_react2.default.createElement(
							'div',
							{ key: 'subscribed' + index + '_' + 'twigDetails', className: 'subscription-content' },
							_react2.default.createElement(
								'div',
								{ key: 'subscribed' + index + '_' + 'twigId' },
								data.twigId
							),
							_react2.default.createElement(
								'div',
								{ key: 'subscribed' + index + '_' + 'name' },
								data.twigName
							),
							_react2.default.createElement(
								'div',
								{ key: 'subscribed' + index + '_' + 'stttus' },
								data.details.subscription.plan.name
							),
							_react2.default.createElement(
								'div',
								{ key: 'subscribed' + index + '_' + 'status' },
								_react2.default.createElement(
									'span',
									null,
									'Active since ',
									new Date(data.details.subscription.created * 1000).toLocaleDateString(),
									' '
								),
								' ',
								_react2.default.createElement('br', null),
								'(renewal period ',
								data.details.subscription.items.data[0].plan.interval_count,
								' ',
								data.details.subscription.items.data[0].plan.interval,
								')'
							),
							_react2.default.createElement(
								'div',
								{ key: 'subscribed' + index + '_' + 'changeButtonContainer', className: 'button-container' },
								_react2.default.createElement(_Button2.default, { key: 'subscribed' + index + '_' + 'changeButton', label: 'Change',
									className: 'lighter-font',
									onClick: function onClick() {
										return _this2.showPlans(data, true);
									},
									primary: true,
									secondary: false,
									accent: false }),
								_react2.default.createElement('br', null),
								_react2.default.createElement(_Button2.default, { key: 'subscribed' + index + '_' + 'cancelButton', label: 'Cancel',
									className: 'lighter-font',
									onClick: _this2.cancelSubscription(data),
									primary: true,
									secondary: false,
									accent: false })
							)
						));
					});
					subscriptionTable.push.apply(subscriptionTable, subscriptions);
				}
				if (this.props.unsubscribedTwigs && this.props.unsubscribedTwigs.length > 0) {
					_.forEach(this.props.unsubscribedTwigs, function (twig, index) {
						twigs.push(_react2.default.createElement(
							'div',
							{ key: index + '_' + 'twigDetails', className: 'subscription-content unsubscribed-items' },
							_react2.default.createElement(
								'div',
								{ key: index + '_' + 'twigId' },
								twig.twigId
							),
							_react2.default.createElement(
								'div',
								{ key: index + '_' + 'name' },
								twig.name
							),
							_react2.default.createElement(
								'div',
								{ key: index + '_' + 'status' },
								'-'
							),
							_react2.default.createElement(
								'div',
								null,
								'Unsubscribed'
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(_Button2.default, { label: 'Add',
									className: 'lighter-font',
									onClick: function onClick() {
										return _this2.showPlans(twig, false);
									},
									primary: true,
									secondary: false,
									accent: false })
							)
						));
					});
					subscriptionTable.push.apply(subscriptionTable, twigs);
				}
				return subscriptionTable;
			}
		}, {
			key: 'getSubscriptionUpdatedTime',
			value: function getSubscriptionUpdatedTime(data) {
				if (data && data.subscription && data.subscription.details && data.subscription.details.subscription) {
					if (data.subscription.details.subscription.canceled_at) {
						return new Date(data.subscription.details.subscription.canceled_at * 1000).toLocaleString();
					} else {
						return new Date(data.subscription.details.subscription.created * 1000).toLocaleString();
					}
				} else {
					return '';
				}
			}
		}, {
			key: '_renderSubscriptionLog',
			value: function _renderSubscriptionLog() {
				var _this3 = this;
	
				var subscriptionHistoryTable = [];
				subscriptionHistoryTable.push(_react2.default.createElement(
					'div',
					{ key: 'subscriptionsLogHeader', className: 'subscription-log-table-header' },
					_react2.default.createElement(
						'div',
						null,
						'Date/Time'
					),
					_react2.default.createElement(
						'div',
						null,
						'Stem ID'
					),
					_react2.default.createElement(
						'div',
						null,
						'Stem Name'
					),
					_react2.default.createElement(
						'div',
						null,
						'Changes'
					)
				));
				if (this.props.subscriptionDetails && this.props.subscriptionDetails.length > 0) {
					_.forEach(this.props.subscriptionDetails, function (data, index) {
						var log = _react2.default.createElement(
							'div',
							{ key: data.subscription.twigId + '_' + index + 'container', className: 'subscription-log-content ' },
							_react2.default.createElement(
								'div',
								{ key: data.subscription.twigId + '_' + index + 'created' },
								_this3.getSubscriptionUpdatedTime(data)
							),
							_react2.default.createElement(
								'div',
								{ key: data.subscription.twigId + '_' + index + 'twig' },
								data.subscription.twigId
							),
							_react2.default.createElement(
								'div',
								{ key: data.subscription.twigId + '_' + index + 'name' },
								data.subscription.twigName
							),
							_react2.default.createElement(
								'div',
								{ key: data.subscription.twigId + '_' + index + 'plan' },
								data.action,
								' subscription for',
								_react2.default.createElement('br', null),
								data.subscription.details.subscription.plan.name ? data.subscription.details.subscription.plan.name : data.subscription.details.subscription.plan.nickname
							)
						);
						subscriptionHistoryTable.push(log);
					});
				}
				return subscriptionHistoryTable;
			}
		}, {
			key: 'showPlans',
			value: function showPlans(data, isSubscribed) {
				if (isSubscribed) {
					this.props.dispatch((0, _subscriptionView.saveTwigInSession)({ twigId: data.twigId, twigIndex: data.twigIndex, showPlans: true, subscriptionSelected: data }));
					window.location.href = '/location';
				} else {
					this.props.dispatch((0, _subscriptionView.saveTwigInSession)({ twigId: data.twigId, twigIndex: data.twigIndex, showPlans: true }));
					window.location.href = '/location';
				}
			}
		}, {
			key: 'getCancellationInfo',
			value: function getCancellationInfo() {
				if (this.props.subscriptionToCancel) {
					var data = this.props.subscriptionToCancel;
					return _react2.default.createElement(
						_Heading2.default,
						{ strong: false,
							align: 'center',
							margin: 'small',
							tag: 'h3' },
						'Do you want to unsubscribe to the plan $',
						data.details.subscription.plan.name,
						' with duration ',
						data.details.subscription.plan.interval_count,
						data.details.subscription.plan.interval,
						' for Stem ',
						data.locationName,
						'/',
						data.twigId,
						'? Click Ok to confirm.'
					);
				}
			}
		}, {
			key: 'cancelSubscription',
			value: function cancelSubscription(data) {
				var _this4 = this;
	
				return function () {
					_this4.props.dispatch((0, _subscriptionView.confirmCancellation)(data));
				};
			}
		}, {
			key: 'handleConfirmation',
			value: function handleConfirmation() {
				this.props.dispatch((0, _subscriptionView.closeConfirmation)(!this.props.showCancellationDialog));
				this.props.dispatch((0, _subscriptionView.cancelSubscription)(this.props.subscriptionToCancel));
			}
		}, {
			key: 'closeConfirmationDialog',
			value: function closeConfirmationDialog() {
				this.props.dispatch((0, _subscriptionView.closeConfirmation)(!this.props.showCancellationDialog));
			}
		}, {
			key: 'showConfirmCancellation',
			value: function showConfirmCancellation() {
				return this.props.showCancellationDialog ? _react2.default.createElement(
					_Layer2.default,
					{ flush: true,
						onClose: this.closeConfirmationDialog
					},
					_react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Close2.default, null),
						onClick: this.closeConfirmationDialog,
						plain: true, style: { position: 'absolute', float: 'right', right: '0' } }),
					_react2.default.createElement(
						'div',
						{ style: { textAlign: "center" }, className: 'heading confirmation-content' },
						this.getCancellationInfo(),
						_react2.default.createElement(_Button2.default, { label: 'OK',
							className: 'lighter-font button-margin',
							onClick: this.handleConfirmation,
							primary: true,
							secondary: false,
							accent: false }),
						_react2.default.createElement(_Button2.default, { label: 'Cancel',
							className: 'lighter-font button-margin',
							onClick: this.closeConfirmationDialog,
							primary: true,
							secondary: false,
							accent: false })
					)
				) : '';
			}
		}, {
			key: 'render',
			value: function render() {
	
				var tableStyles = {};
	
				var tableBodyStyles = {};
				return _react2.default.createElement(
					'div',
					{ className: 'subscription-view-container' },
					_react2.default.createElement(
						'h3',
						{ className: 'heading' },
						'Subscriptions'
					),
					_react2.default.createElement(
						'div',
						{ className: 'subscription-details' },
						this._renderSubscriptions()
					),
					_react2.default.createElement(
						'h3',
						{ className: 'heading' },
						'History'
					),
					_react2.default.createElement(
						'div',
						{ className: 'subscription-log' },
						this._renderSubscriptionLog()
					),
					this.showConfirmCancellation()
				);
			}
		}]);
	
		return SubscriptionView;
	}(_react.Component);
	
	var select = function select(state, props) {
		return {
			subscriptionDetails: state.subscriptionView.subscriptionDetails,
			unsubscribedTwigs: state.subscriptionView.unsubscribedTwigs,
			modifyTwigSubscription: state.subscriptionView.modifyTwigSubscription,
			subscriptionToCancel: state.subscriptionView.subscriptionToCancel,
			showCancellationDialog: state.subscriptionView.showCancellationDialog,
			subscribedTwigs: state.subscriptionView.subscribedTwigs,
			stripeAPIKey: state.session.stripeAPIKey
	
		};
	};
	
	var _default = (0, _reactRedux.connect)(select)(SubscriptionView);
	
	exports.default = _default;
	;
	
	var _temp = function () {
		if (typeof __REACT_HOT_LOADER__ === 'undefined') {
			return;
		}
	
		__REACT_HOT_LOADER__.register(SubscriptionView, 'SubscriptionView', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/subscription/SubscriptionView.js');
	
		__REACT_HOT_LOADER__.register(select, 'select', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/subscription/SubscriptionView.js');
	
		__REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/subscription/SubscriptionView.js');
	}();

	;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(55);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Paragraph = __webpack_require__(85);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(121);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Anchor = __webpack_require__(66);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _Sidebar = __webpack_require__(69);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _App = __webpack_require__(187);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Split = __webpack_require__(70);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Close = __webpack_require__(63);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tutorial = function (_Component) {
	  _inherits(Tutorial, _Component);
	
	  function Tutorial() {
	    _classCallCheck(this, Tutorial);
	
	    return _possibleConstructorReturn(this, (Tutorial.__proto__ || Object.getPrototypeOf(Tutorial)).call(this));
	  }
	
	  _createClass(Tutorial, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return Tutorial;
	}(_react.Component);
	
	var _default = Tutorial;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Tutorial, 'Tutorial', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/tutorial/Tutorial.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/components/tutorial/Tutorial.js');
	}();

	;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _handlers;
	
	exports.default = dashboardReducer;
	
	var _actions = __webpack_require__(13);
	
	var _Utility = __webpack_require__(37);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	// import convertTimestamps from '../utils/ConvertTimestamps';
	
	
	var sites = (0, _Utility.getFromSession)('sites');
	var initialState = {
	  sites: sites ? sites : [],
	  twigId: '',
	  stemDetails: '',
	  showStemAddForm: false,
	  showToast: false,
	  toastMessage: '',
	  showAddStemError: null,
	  stemName: '',
	  stemLocation: ''
	};
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.SAVE_SITEDATA, function (state, action) {
	  (0, _Utility.saveInSession)('sites', action.result);
	  return {
	    sites: action.result
	  };
	}), _defineProperty(_handlers, _actions.ADD_STEM_ID, function (state, action) {
	  return {
	    twigId: action.result.data[0].twigId,
	    showStemAddForm: action.result.success
	  };
	}), _defineProperty(_handlers, _actions.CREATE_STEM, function (state, action) {
	  return {
	    stemDetails: action.result.data,
	    showStemAddForm: !action.result.success,
	    showToast: true,
	    toastMessage: action.result.message
	  };
	}), _defineProperty(_handlers, _actions.SHOW_ADD_STEM_ERROR, function (state, action) {
	  return {
	    showAddStemError: action.result
	  };
	}), _defineProperty(_handlers, _actions.SET_STEM_NAME, function (state, action) {
	  return {
	    stemName: action.result
	  };
	}), _defineProperty(_handlers, _actions.SET_STEM_LOCATION, function (state, action) {
	  return {
	    stemLocation: action.result
	  };
	}), _defineProperty(_handlers, _actions.HIDE_TOAST, function (state, action) {
	  return {
	    showToast: false
	  };
	}), _handlers);
	
	function dashboardReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var handler = handlers[action.type];
	  if (!handler) return state;
	  return _extends({}, state, handler(state, action));
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(sites, 'sites', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/dashboard.js');
	
	  __REACT_HOT_LOADER__.register(dashboardReducer, 'dashboardReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/dashboard.js');
	}();

	;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _depth, _depth2, _handlers;
	
	exports.default = locationViewReducer;
	
	var _actions = __webpack_require__(13);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Utility = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	var _ = __webpack_require__(27);
	
	var selectedTwigFromSession = (0, _Utility.getFromSession)('selectedTwig');
	var initialState = {
	  twigsList: [],
	  selectedTwig: selectedTwigFromSession ? selectedTwigFromSession : '',
	  selectedTwigIndex: 0,
	  chartData: null,
	  resolution: 1,
	  showRawGraph: true,
	  showTrendLine: true,
	  trendAverage: 20,
	  showLowerLimit: false,
	  showUpperLimit: false,
	  userPreferences: [],
	  dateRange: { type: _Constants2.default.DATE_RANGE.TWO_WEEKS, fromDate: (0, _Utility.getInitialFromDate)(), toDate: '' },
	  chartOptions: {
	    DisplayOptions: {},
	    depth: (_depth = {}, _defineProperty(_depth, _Constants2.default.CHART_OPTIONS.TOP, true), _defineProperty(_depth, _Constants2.default.CHART_OPTIONS.MIDDLE, true), _defineProperty(_depth, _Constants2.default.CHART_OPTIONS.BOTTOM, true), _depth),
	    dateRange: _Constants2.default.DATE_RANGE.TWO_WEEKS,
	    fromDate: (0, _Utility.getInitialFromDate)(),
	    toDate: new Date(),
	    showChart: true
	  },
	  alerts: [],
	  zoom: false,
	  showStripePlans: false,
	  showSubscriptionForm: false,
	  showConfirmationDialog: false,
	  showError: false,
	  selectedPlan: null,
	  couponDetails: null,
	  subscriptionCreated: null,
	  subscription: null,
	  paymentInformation: null,
	  rememberMe: false,
	  cardInfo: null,
	  couponData: ''
	};
	var _chartData = null;
	var _chartOptions = {
	  displayOptions: {},
	  depth: (_depth2 = {}, _defineProperty(_depth2, _Constants2.default.CHART_OPTIONS.TOP, true), _defineProperty(_depth2, _Constants2.default.CHART_OPTIONS.MIDDLE, true), _defineProperty(_depth2, _Constants2.default.CHART_OPTIONS.BOTTOM, true), _depth2),
	  dateRange: _Constants2.default.DATE_RANGE.ALL,
	  fromDate: '',
	  endDate: ''
	};
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.GET_TWIGS, function (state, action) {
	
	  if (action.result && action.result.length > 0) {
	    var selectedTwig = action.result[action.selectedIndex];
	    _chartOptions.displayOptions = {};
	    var showChart = false;
	    if (selectedTwig && selectedTwig.details) {
	      showChart = true;
	      _.sortBy(selectedTwig.details.data, [function (o) {
	        return o.sort_order;
	      }]);
	      Object.keys(selectedTwig.details.data).map(function (key, index) {
	        _chartOptions.displayOptions[key] = true;
	      });
	    }
	    // sessionStorage.selectedTwig = {};
	    (0, _Utility.saveInSession)('selectedTwig', selectedTwig);
	
	    return {
	      twigsList: action.result,
	      selectedTwig: selectedTwig,
	      selectedTwigIndex: action.selectedIndex,
	      showChart: showChart
	    };
	  } else {
	    _chartOptions.displayOptions = {};
	    sessionStorage.removeItem('selectedTwig');
	    return {
	      twigsList: [],
	      selectedTwig: '',
	      selectedTwigIndex: 0,
	      showChart: false
	    };
	  }
	}), _defineProperty(_handlers, _actions.CLEAR_TWIGS, function (state, action) {
	  return {
	    twigsList: [],
	    selectedTwig: '',
	    selectedTwigIndex: 0,
	    showChart: false
	  };
	}), _defineProperty(_handlers, _actions.UPDATE_SELECTEDTWIG, function (state, action) {
	  var selectedTwig = state.twigsList[action.index];
	  var showChart = false;
	
	  if (selectedTwig.details) {
	    showChart = true;
	    _.sortBy(selectedTwig.details.data, [function (o) {
	      return o.sort_order;
	    }]);
	    Object.keys(selectedTwig.details.data).map(function (key, index) {
	      _chartOptions.displayOptions[key] = true;
	    });
	  }
	  (0, _Utility.saveInSession)('selectedTwig', selectedTwig);
	  return {
	    selectedTwig: selectedTwig,
	    selectedTwigIndex: action.index,
	    showChart: showChart
	  };
	}), _defineProperty(_handlers, _actions.UPDATE_CHART, function (state, action) {
	  _chartData = _.cloneDeep(action.result);
	  var chartData = _.cloneDeep(_chartData);
	  var chartOption = _.cloneDeep(state.chartOptions);
	  if (chartData && chartData != 'loading') {
	    var displayOptions = {};
	    if (_chartOptions.DisplayOptions) {
	      displayOptions = _.cloneDeep(_chartOptions.DisplayOptions);
	    } else if (_chartOptions.displayOptions) {
	      displayOptions = _.cloneDeep(_chartOptions.displayOptions);
	    }
	
	    if (Object.keys(displayOptions).length === 0) {
	      _chartOptions.DisplayOptions = (0, _Utility.getSelectedTwigDetails)(state.twigsList[0].twigId, state.twigsList);
	      _chartOptions.displayOptions = _.cloneDeep(_chartOptions.DisplayOptions);
	    }
	
	    if (Object.keys(chartData).length > 0) {
	      chartData = (0, _Utility.filterChart)(chartData, _chartOptions);
	    }
	    chartOption.DisplayOptions = _chartOptions.displayOptions;
	  }
	  return {
	    chartData: chartData,
	    chartOptions: chartOption
	  };
	}), _defineProperty(_handlers, _actions.CHANGE_DISPLAYOPTION, function (state, action) {
	  var chartData = _.cloneDeep(_chartData);
	  _chartOptions.displayOptions[action.result.key] = action.result.value;
	  chartData = (0, _Utility.filterChart)(chartData, _chartOptions);
	  return {
	    chartData: chartData,
	    chartOptions: _chartOptions
	  };
	}), _defineProperty(_handlers, _actions.CHANGE_DEPTHOPTION, function (state, action) {
	  var chartData = _.cloneDeep(_chartData);
	  var depth = _.cloneDeep(state.chartOptions.depth);
	  _chartOptions.depth = depth;
	  _chartOptions.depth[action.result.key] = action.result.value;
	  chartData = (0, _Utility.filterChart)(chartData, _chartOptions);
	  return {
	    chartData: chartData,
	    chartOptions: _chartOptions
	  };
	}), _defineProperty(_handlers, _actions.TOGGLE_LOWERLIMIT, function (state, action) {
	  return {
	    showLowerLimit: action.result
	  };
	}), _defineProperty(_handlers, _actions.TOGGLE_UPPERLIMIT, function (state, action) {
	  return {
	    showUpperLimit: action.result
	  };
	}), _defineProperty(_handlers, _actions.CHANGE_TWIG, function (state, action) {
	
	  var selectedTwig = state.twigsList[action.result];
	  _chartOptions.displayOptions = {};
	  _.sortBy(selectedTwig.details.data, [function (o) {
	    return o.sort_order;
	  }]);
	  Object.keys(selectedTwig.details.data).map(function (key, index) {
	    _chartOptions.displayOptions[key] = true;
	  });
	  (0, _Utility.saveInSession)('selectedTwig', selectedTwig);
	  return {
	    selectedTwig: selectedTwig
	  };
	}), _defineProperty(_handlers, _actions.UPDATE_FROMDATE, function (state, action) {
	  var chartOptions = _.cloneDeep(state.chartOptions);
	  chartOptions.fromDate = action.result;
	  return {
	    chartOptions: chartOptions
	  };
	}), _defineProperty(_handlers, _actions.UPDATE_TODATE, function (state, action) {
	  var chartOptions = _.cloneDeep(state.chartOptions);
	  chartOptions.toDate = action.result;
	  return {
	    chartOptions: chartOptions
	  };
	}), _defineProperty(_handlers, _actions.UPDATE_DATE_RANGE, function (state, action) {
	  var chartOptions = _.cloneDeep(state.chartOptions);
	  chartOptions.dateRange = action.result;
	  return {
	    chartOptions: chartOptions
	  };
	}), _defineProperty(_handlers, _actions.CHANGE_RESOULTION, function (state, action) {
	  return {
	    resolution: action.result
	  };
	}), _defineProperty(_handlers, _actions.SHOW_TRENDLINE, function (state, action) {
	  return {
	    showTrendLine: action.result
	  };
	}), _defineProperty(_handlers, _actions.SHOW_RAWGRAPH, function (state, action) {
	  return {
	    showRawGraph: action.result
	  };
	}), _defineProperty(_handlers, _actions.CHANGE_TREND_AVERAGE, function (state, action) {
	  return {
	    trendAverage: action.result
	  };
	}), _defineProperty(_handlers, _actions.GET_ALERTS, function (state, action) {
	  return {
	    alerts: action.result
	  };
	}), _defineProperty(_handlers, _actions.SESSION_LOGOUT, function (state, action) {
	  // let position = _.cloneDeep(state.position);
	  return initialState;
	}), _defineProperty(_handlers, _actions.GET_USER_PREFERENCES, function (state, action) {
	  var chartOptions = _.cloneDeep(state.chartOptions);
	  var prefData = (0, _Utility.loadTwigDataBasedonPreference)(state, action.result);
	  chartOptions.dateRange = prefData.DateRange.type;
	  chartOptions.toDate = prefData.DateRange.toDate;
	  chartOptions.fromDate = prefData.DateRange.fromDate;
	  chartOptions.depth = prefData.Depth;
	
	  _chartOptions.dateRange = prefData.DateRange.type;
	  _chartOptions.toDate = prefData.DateRange.toDate;
	  _chartOptions.fromDate = prefData.DateRange.fromDate;
	  _chartOptions.depth = prefData.Depth;
	
	  if (action.result.UserPref.preference.sensors) {
	    _chartOptions.displayOptions = action.result.UserPref.preference.sensors;
	    chartOptions.DisplayOptions = action.result.UserPref.preference.sensors;
	    chartOptions.displayOptions = action.result.UserPref.preference.sensors;
	  } else {
	    var dOption = (0, _Utility.getSelectedTwigDetails)(action.result.UserPref.preference.stem, state.twigsList);
	    chartOptions.DisplayOptions = dOption;
	    chartOptions.displayOptions = dOption;
	    _chartOptions.displayOptions = dOption;
	  }
	
	  var chartData = _.cloneDeep(action.result.chartData);
	  _chartData = _.cloneDeep(chartData);
	  if (chartData && chartData != 'loading' && Object.keys(chartData).length > 0) {
	    chartData = (0, _Utility.filterChart)(chartData, chartOptions);
	  }
	
	  return {
	    userPreferences: action.result.UserPref,
	    selectedTwig: prefData.selectedTwig,
	    selectedTwigIndex: prefData.twigIndex,
	    chartOptions: chartOptions,
	    trendAverage: action.result.UserPref.preference.dataModel.trendAverage,
	    showRawGraph: action.result.UserPref.preference.dataModel.raw,
	    showTrendLine: action.result.UserPref.preference.dataModel.trend,
	    chartData: chartData,
	    showLowerLimit: action.result.UserPref.preference.limits.lower,
	    showUpperLimit: action.result.UserPref.preference.limits.upper,
	    zoom: action.result.UserPref.preference.zoom,
	    subscription: action.result.subscription
	  };
	}), _defineProperty(_handlers, _actions.TOGGLE_ZOOM, function (state, action) {
	  return {
	    zoom: action.result
	  };
	}), _defineProperty(_handlers, _actions.GET_STRIPEPLANS, function (state, action) {
	  return {
	    stripePlans: action.result.stripePlans,
	    showStripePlans: action.result.success,
	    showSubscriptionForm: !action.result.success,
	    selectedPlan: null,
	    rememberMe: null,
	    savedCard: null,
	    couponData: '',
	    couponDetails: null
	  };
	}), _defineProperty(_handlers, _actions.ADD_SUBSCRPTION, function (state, action) {
	  return {
	    showSubscriptionForm: action.result.togglesubscriptionForm,
	    selectedPlan: action.result.plan,
	    rememberMe: action.result.rememberMe,
	    savedCard: action.result.savedCard,
	    couponData: '',
	    couponDetails: null
	  };
	}), _defineProperty(_handlers, _actions.CONFIRM_SUBSCRIPTION, function (state, action) {
	  return {
	    showConfirmationDialog: action.result.success,
	    subscriptionCreated: action.result.subscriptionCreated
	  };
	}), _defineProperty(_handlers, _actions.VALIDATE_COUPON, function (state, action) {
	  return {
	    couponDetails: action.result
	  };
	}), _defineProperty(_handlers, _actions.SHOW_CHART_VIEW, function (state, action) {
	  return {
	    showSubscriptionForm: action.result.showSubscriptionForm,
	    showStripePlans: action.result.showStripePlans
	  };
	}), _defineProperty(_handlers, _actions.HANDLE_PAYMENT_INFO_SUBMIT, function (state, action) {
	  return {
	    showConfirmationDialog: action.result.showConfirmationDialog,
	    showError: action.result.showError
	  };
	}), _defineProperty(_handlers, _actions.INIT_PAYMENT_INFO, function (state, action) {
	  return {
	    paymentInformation: action.result
	  };
	}), _defineProperty(_handlers, _actions.REMEMBER_ME, function (state, action) {
	  return {
	    rememberMe: action.result,
	    savedCard: null
	  };
	}), _defineProperty(_handlers, _actions.REBIND_COUPON_DATA, function (state, action) {
	  return {
	    couponData: action.result
	  };
	}), _handlers);
	
	function locationViewReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	
	  var handler = handlers[action.type];
	  if (!handler) return state;
	  var newState = _.cloneDeep(state);
	  return _extends({}, newState, handler(newState, action));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(selectedTwigFromSession, 'selectedTwigFromSession', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/locationView.js');
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/locationView.js');
	
	  __REACT_HOT_LOADER__.register(_chartData, '_chartData', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/locationView.js');
	
	  __REACT_HOT_LOADER__.register(_chartOptions, '_chartOptions', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/locationView.js');
	
	  __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/locationView.js');
	
	  __REACT_HOT_LOADER__.register(locationViewReducer, 'locationViewReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/locationView.js');
	}();

	;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _handlers;
	
	exports.default = navReducer;
	
	var _actions = __webpack_require__(13);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var initialState = {
	  active: true, // start with nav active
	  enabled: false, // start with nav disabled
	  responsive: 'multiple',
	  peek: false,
	  items: [
	  // { path: constants.ROUTES.DASHBOARD, label: 'Map' },
	  { path: _Constants2.default.ROUTES.SITEVIEW, label: 'Dashboard' }, { path: _Constants2.default.ROUTES.LOCATIONVIEW, label: 'Charts' }, { path: _Constants2.default.ROUTES.ADD_STEM, label: 'Add Stem' }, { path: _Constants2.default.ROUTES.SUBSCRIPTIONVIEW, label: 'Subscription' }, { path: _Constants2.default.ROUTES.SETTINGS, label: 'Settings' }, { path: _Constants2.default.ROUTES.TUTORIAL, label: 'Tutorial' }]
	};
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.SESSION_INIT, function (state, action) {
	  var result = {};
	  if (action.role) {
	    result.items = initialState.items.filter(function (item) {
	      return item.excludeRole !== action.role;
	    });
	  }
	  return result;
	}), _defineProperty(_handlers, _actions.SESSION_LOGIN_SUCCESS, function (state, action) {
	  var result = {};
	  if (action.role) {
	    result.items = initialState.items.filter(function (item) {
	      return item.excludeRole !== action.role;
	    });
	  }
	  return result;
	}), _defineProperty(_handlers, _actions.NAV_PEEK, function (_, action) {
	  return { peek: action.peek };
	}), _defineProperty(_handlers, _actions.NAV_ACTIVATE, function (_, action) {
	  return { active: action.active, activateOnMultiple: null };
	}), _defineProperty(_handlers, _actions.NAV_ENABLE, function (_, action) {
	  return { enabled: action.enabled };
	}), _defineProperty(_handlers, _actions.NAV_RESPONSIVE, function (state, action) {
	  var result = { responsive: action.responsive };
	  if ('single' === action.responsive && state.active) {
	    result.active = false;
	    result.activateOnMultiple = true;
	  } else if ('multiple' === action.responsive && state.activateOnMultiple) {
	    result.active = true;
	  }
	  return result;
	}), _defineProperty(_handlers, _actions.ROUTE_CHANGED, function (state, action) {
	  return 'single' === state.responsive && state.active ? { active: false } : {};
	}), _handlers);
	
	function navReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var handler = handlers[action.type];
	  if (!handler) return state;
	  return _extends({}, state, handler(state, action));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/nav.js');
	
	  __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/nav.js');
	
	  __REACT_HOT_LOADER__.register(navReducer, 'navReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/nav.js');
	}();

	;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _handlers;
	
	exports.default = routeReducer;
	
	var _actions = __webpack_require__(13);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var initialState = {
	  location: undefined,
	  masterRoute: undefined,
	  playing: false
	};
	
	var IGNORE_MASTER_DURATION = 1000 * 60 * 2; // 2 minutes
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.ROUTE_CHANGED, function (state, action) {
	  var ignoreMasterUntil = void 0;
	  if (state.masterRoute && state.masterRoute.pathname !== action.location.pathname) {
	    ignoreMasterUntil = new Date(action.at.getTime() + IGNORE_MASTER_DURATION);
	  }
	  return {
	    location: action.location,
	    ignoreMasterUntil: ignoreMasterUntil
	  };
	}), _defineProperty(_handlers, _actions.ROUTE_MASTER_CHANGED, function (state, action) {
	  return { masterRoute: action.masterRoute };
	}), _defineProperty(_handlers, _actions.ROUTE_MASTER_UNLOAD, function (state, action) {
	  return { masterRoute: undefined };
	}), _defineProperty(_handlers, _actions.ROUTE_PLAY, function (state, action) {
	  return { playing: true };
	}), _defineProperty(_handlers, _actions.ROUTE_STOP, function (state, action) {
	  return { playing: false };
	}), _handlers);
	
	function routeReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var handler = handlers[action.type];
	  if (!handler) return state;
	  return _extends({}, state, handler(state, action));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/route.js');
	
	  __REACT_HOT_LOADER__.register(IGNORE_MASTER_DURATION, 'IGNORE_MASTER_DURATION', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/route.js');
	
	  __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/route.js');
	
	  __REACT_HOT_LOADER__.register(routeReducer, 'routeReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/route.js');
	}();

	;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	exports.default = sessionReducer;
	
	var _actions = __webpack_require__(13);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  enableAutoPlay: false,
	  error: undefined,
	  passwordReset: false, // TODO: should come from the server
	  publishRoute: false,
	  role: undefined,
	  state: 'initial', // initial | changing | ready
	  token: undefined,
	  userName: undefined,
	  registrationStatus: undefined,
	  registrationMessage: undefined,
	  stripeAPIKey: "",
	  resetPassword: false,
	  passwordResetStatus: ''
	
	};
	
	var stateForLogin = function stateForLogin(action) {
	  return {
	    userName: action.userName,
	    role: action.role,
	    home: homeForRole(action.role),
	    token: action.token,
	    needPasswordReset: action.needPasswordReset,
	    publishRoute: 'Gru' === action.userName,
	    enableAutoPlay: action.userName && 'u' === action.userName[action.userName.length - 1]
	  };
	};
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.SESSION_INIT, function (_, action) {
	  return stateForLogin(action);
	}), _defineProperty(_handlers, _actions.SESSION_LOGIN, function (_, action) {
	  return {
	    state: 'changing',
	    userName: action.userName
	  };
	}), _defineProperty(_handlers, _actions.SESSION_LOGIN_SUCCESS, function (_, action) {
	  return _extends({}, stateForLogin(action), {
	    state: 'ready',
	    error: undefined
	  });
	}), _defineProperty(_handlers, _actions.SESSION_LOGIN_FAILURE, function (_, action) {
	  return {
	    state: 'initial',
	    error: action.error
	  };
	}), _defineProperty(_handlers, _actions.SESSION_RESET_PASSWORD, function (_, action) {
	  return {
	    state: 'changing',
	    error: undefined
	  };
	}), _defineProperty(_handlers, _actions.SESSION_RESET_PASSWORD_SUCCESS, function (_, action) {
	  return {
	    state: 'ready',
	    needPasswordReset: false
	  };
	}), _defineProperty(_handlers, _actions.SESSION_LOGOUT, function () {
	  return {
	    state: 'initial',
	    userName: null,
	    token: undefined
	  };
	}), _defineProperty(_handlers, _actions.REGISTRATION_STATUS, function (state, action) {
	  return {
	    registrationStatus: action.result.status,
	    registrationMessage: action.result.message
	  };
	}), _defineProperty(_handlers, _actions.INITIALIZE_STRIPE, function (state, action) {
	  return {
	    stripeAPIKey: action.result.stripeAPIKey
	  };
	}), _defineProperty(_handlers, _actions.DISPLAY_PASSWORD_RESET_DAILOG, function (state, action) {
	  return {
	    resetPassword: action.result
	  };
	}), _defineProperty(_handlers, _actions.PASSWORD_RESET_STATUS, function (state, action) {
	  return {
	    passwordResetStatus: action.result
	  };
	}), _handlers);
	
	function sessionReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var handler = handlers[action.type];
	  if (!handler) return state;
	  return _extends({}, state, handler(state, action));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/session.js');
	
	  __REACT_HOT_LOADER__.register(stateForLogin, 'stateForLogin', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/session.js');
	
	  __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/session.js');
	
	  __REACT_HOT_LOADER__.register(sessionReducer, 'sessionReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/session.js');
	}();

	;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	exports.default = settingsReducer;
	
	var _update = __webpack_require__(806);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _actions = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  productName: { short: 'Ferret', long: 'Ferret Virtual Machine Vending' },
	  state: 'initial',
	  settings: {
	    network: {}
	  }
	};
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.SETTINGS_LOAD, function (state, action) {
	  return {
	    state: 'loading',
	    settings: initialState.settings
	  };
	}), _defineProperty(_handlers, _actions.SETTINGS_LOAD_SUCCESS, function (state, action) {
	  return {
	    error: null,
	    state: 'loaded',
	    hypervisorState: 'loaded',
	    settings: action.settings
	  };
	}), _defineProperty(_handlers, _actions.SETTINGS_LOAD_FAILURE, function (state, action) {
	  return { messageOrTask: messageOrTask };
	}), _defineProperty(_handlers, _actions.SETTINGS_CHANGE, function (state, action) {
	  return {
	    state: 'modified',
	    settings: _extends({}, state.settings, action.settings)
	  };
	}), _defineProperty(_handlers, _actions.SETTINGS_NODES_CHANGE, function (state, action) {
	  return (0, _update2.default)(state, {
	    settings: {
	      nodes: { $set: action.nodes },
	      nodesCommonUserName: { $set: action.commonUserName },
	      nodesCommonPassword: { $set: action.commonPassword }
	    }
	  });
	}), _defineProperty(_handlers, _actions.SETTINGS_UPDATE, function (state, action) {
	  return { state: 'updating' };
	}), _defineProperty(_handlers, _actions.SETTINGS_UPDATE_SUCCESS, function (_, action) {
	  return { state: 'done',
	    settings: action.settings };
	}), _defineProperty(_handlers, _actions.SETTINGS_UPDATE_FAILURE, function (_, action) {
	  return { messageOrTask: action.messageOrTask };
	}), _defineProperty(_handlers, _actions.SETTINGS_RESPONSIVE, function (state, action) {
	  return { responsive: action.responsive };
	}), _handlers);
	
	function settingsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var handler = handlers[action.type];
	  if (!handler) return state;
	  return _extends({}, state, handler(state, action));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/settings.js');
	
	  __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/settings.js');
	
	  __REACT_HOT_LOADER__.register(settingsReducer, 'settingsReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/settings.js');
	}();

	;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = statusReducer;
	
	var _actions = __webpack_require__(13);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var initialState = {
	  showLoader: false
	};
	
	var handlers = _defineProperty({}, _actions.SHOW_LOADER, function (state, action) {
	  return {
	    showLoader: action.result
	  };
	});
	
	function statusReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var handler = handlers[action.type];
	  if (!handler) return state;
	  return _extends({}, state, handler(state, action));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/status.js');
	
	  __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/status.js');
	
	  __REACT_HOT_LOADER__.register(statusReducer, 'statusReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/status.js');
	}();

	;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _handlers;
	
	exports.default = subscriptionViewReducer;
	
	var _actions = __webpack_require__(13);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _Utility = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	var _ = __webpack_require__(27);
	
	var initialState = {
	    subscriptionDetails: null,
	    unsubscribedTwigs: null,
	    subscriptions: null,
	    modifyTwigSubscription: null,
	    twig: null,
	    isSubscribed: null,
	    showCancellationDialog: false,
	    subscriptionToCancel: null,
	    subscribedTwigs: null
	};
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.GET_SUBSCRIPTION_HISTORY, function (state, action) {
	    var unsubscribedTwigs = void 0;
	    var subscribedTwigs = [];
	    if (action && action.result && action.result.twigs) {
	        action.result.twigs.data.forEach(function (twig, index) {
	            twig.twigIndex = index;
	        });
	        if (!action.result.data.subscriptions && !action.result.data.subscriptions.length) {
	            unsubscribedTwigs = action.result.twigs.data;
	        } else {
	            _.forEach(action.result.data.subscriptions, function (subscription) {
	                _.remove(action.result.twigs.data, function (twig, index) {
	                    if (twig.twigId === subscription.twigId) {
	                        subscription.twigIndex = twig.twigIndex;
	                        subscription.twigName = twig.name;
	                        return twig;
	                    }
	                });
	            });
	            unsubscribedTwigs = action.result.twigs.data;
	        }
	        return {
	            unsubscribedTwigs: unsubscribedTwigs,
	            subscriptionDetails: action.result.data.subscriptionHistory,
	            subscribedTwigs: action.result.data.subscriptions
	        };
	    }
	}), _defineProperty(_handlers, _actions.SAVE_TWIG_IN_SESSION, function (state, action) {
	    (0, _Utility.saveInSession)('twigToSubscribe', action.result);
	    return {
	        twig: action.result.twig,
	        subscriptionSelected: action.result.subscriptionSelected
	    };
	}), _defineProperty(_handlers, _actions.CONFIRM_CANCELLATION, function (state, action) {
	    return {
	        subscriptionToCancel: action.result.data,
	        showCancellationDialog: action.result.success
	    };
	}), _defineProperty(_handlers, _actions.CLOSE_CONFIRMATION, function (state, action) {
	    return {
	        showCancellationDialog: action.result
	    };
	}), _handlers);
	
	function subscriptionViewReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	
	    var handler = handlers[action.type];
	    if (!handler) return state;
	    var newState = _.cloneDeep(state);
	    return _extends({}, newState, handler(newState, action));
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/subscriptionView.js');
	
	    __REACT_HOT_LOADER__.register(subscriptionViewReducer, 'subscriptionViewReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/subscriptionView.js');
	}();

	;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _handlers;
	
	exports.default = userReducer;
	
	var _actions = __webpack_require__(13);
	
	var _Constants = __webpack_require__(19);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	var _ = __webpack_require__(27);
	
	
	var initialState = {
	  profile: null,
	  position: {},
	  signedUpLocation: {},
	  userInfo: {}
	};
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.SAVE_USERPROFILE, function (state, action) {
	  // alert(action.result.profileImage)
	  return {
	    profile: action.result,
	    position: action.result.siteLocation ? action.result.siteLocation : {}
	  };
	}), _defineProperty(_handlers, _actions.UPDATE_USER_LOCATION, function (state, action) {
	  // let position = _.cloneDeep(state.position);
	  return {
	    position: action.result
	  };
	}), _defineProperty(_handlers, _actions.SESSION_LOGOUT, function (state, action) {
	  // let position = _.cloneDeep(state.position);
	  // alert('yes')
	  return {
	    profile: null,
	    position: {}
	  };
	}), _defineProperty(_handlers, _actions.UPDATE_SIGNUP_USER_LOCATION, function (state, action) {
	  return {
	    signedUpLocation: action.result
	  };
	}), _defineProperty(_handlers, _actions.SAVE_USER_DATA, function (state, action) {
	  return {
	    userInfo: action.result
	  };
	}), _handlers);
	
	function userReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var handler = handlers[action.type];
	  if (!handler) return state;
	  return _extends({}, state, handler(state, action));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/user.js');
	
	  __REACT_HOT_LOADER__.register(handlers, 'handlers', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/user.js');
	
	  __REACT_HOT_LOADER__.register(userReducer, 'userReducer', '/Volumes/gitws/GroGuru.git/frontyard/src/js/reducers/user.js');
	}();

	;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(415);
	
	var _reduxThunk = __webpack_require__(807);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _session = __webpack_require__(447);
	
	var _session2 = _interopRequireDefault(_session);
	
	var _locationView = __webpack_require__(444);
	
	var _locationView2 = _interopRequireDefault(_locationView);
	
	var _user = __webpack_require__(451);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _route = __webpack_require__(446);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _status = __webpack_require__(449);
	
	var _status2 = _interopRequireDefault(_status);
	
	var _settings = __webpack_require__(448);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _nav = __webpack_require__(445);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _dashboard = __webpack_require__(443);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _subscriptionView = __webpack_require__(450);
	
	var _subscriptionView2 = _interopRequireDefault(_subscriptionView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import search from './reducers/search';
	// import index from './reducers/index';
	// import item from './reducers/item';
	// import image from './reducers/image';
	// import vm from './reducers/vm';
	var _default = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default))(_redux.createStore)((0, _redux.combineReducers)({ session: _session2.default, route: _route2.default, nav: _nav2.default, locationView: _locationView2.default, status: _status2.default, user: _user2.default, dashboard: _dashboard2.default, subscriptionView: _subscriptionView2.default }));
	// import utilization from './reducers/utilization';
	// import activity from './reducers/activity';
	// import notifications from './reducers/notifications';
	
	// import software from './reducers/software';
	// import backup from './reducers/backup';
	// import support from './reducers/support';
	// import hypervisor from './reducers/hypervisor';
	// import directory from './reducers/directory';
	
	
	// TODO: fix webpack loader to allow import * from './reducers'
	// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	exports.default = _default;
	
	/*export default compose(
	  applyMiddleware(thunk)
	)(createStore)(combineReducers({session, route, nav, status,
	  settings, software, backup, support, hypervisor, directory,
	  search, index, item, image, vm, dashboard, utilization,
	  activity, notifications}));*/

	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Volumes/gitws/GroGuru.git/frontyard/src/js/store.js');
	}();

	;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(455)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Metric;src:url(\"https://hpefonts.s3.amazonaws.com/web/MetricHPE-Web-Regular.woff\") format(\"woff\")}@font-face{font-family:Metric;src:url(\"https://hpefonts.s3.amazonaws.com/web/MetricHPE-Web-Bold.woff\") format(\"woff\");font-weight:700}@font-face{font-family:Metric;src:url(\"https://hpefonts.s3.amazonaws.com/web/MetricHPE-Web-Semibold.woff\") format(\"woff\");font-weight:600}@font-face{font-family:Metric;src:url(\"https://hpefonts.s3.amazonaws.com/web/MetricHPE-Web-Light.woff\") format(\"woff\");font-weight:100}/*!\n * inuitcss, by @csswizardry\n *\n * github.com/inuitcss | inuitcss.com\n */@keyframes fadein{0%{opacity:0}to{opacity:1}}/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block}audio:not([controls]){display:none;height:0}progress{vertical-align:baseline}[hidden],template{display:none}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}svg:not(:root){overflow:hidden}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}button,input,optgroup,select,textarea{font:inherit;margin:0}optgroup{font-weight:700}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-input-placeholder{color:inherit;opacity:.54}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}blockquote,body,caption,dd,dl,fieldset,figure,form,h1,h2,h3,h4,h5,h6,hr,legend,ol,p,pre,table,td,th,ul{margin:0;padding:0}abbr[title],dfn[title]{cursor:help}ins,u{text-decoration:none}ins{border-bottom:1px solid}address,blockquote,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,ol,p,pre,table,ul{margin-bottom:24px;margin-bottom:1.5rem}dd,ol,ul{margin-left:48px;margin-left:3rem}.brand-font,.grommet{font-family:Metric,Arial,sans-serif}.grommet{box-sizing:border-box;font-size:1em;line-height:1.5;background-color:#fff;color:#333;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.grommet *{box-sizing:inherit}.grommet.rtl{direction:rtl}.grommet .large-number-font{font-family:Metric,Arial,sans-serif}.grommet .secondary{color:#666}.grommet .error{color:#f04953}.grommet .grommetux-background-color-index--dark .secondary,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark .secondary{color:hsla(0,0%,100%,.85)}.grommet .grommetux-background-color-index--dark .error,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark .error{color:#f59f9f}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light .secondary,.grommet .grommetux-background-color-index--light .secondary{color:#666}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light .error,.grommet .grommetux-background-color-index--light .error{color:#f04953}@media screen and (min-width:45em){.grommet h1:not(.grommetux-heading){font-size:48px;font-size:3rem;line-height:1.125}}@media screen and (max-width:44.9375em){.grommet h1:not(.grommetux-heading){font-size:36px;font-size:2.25rem;line-height:1.125}}@media screen and (min-width:45em){.grommet h2:not(.grommetux-heading){font-size:36px;font-size:2.25rem;line-height:1.23}}@media screen and (max-width:44.9375em){.grommet h2:not(.grommetux-heading){font-size:30px;font-size:1.875rem;line-height:1.23}}.grommet h3:not(.grommetux-heading){font-size:24px;line-height:1.333}.grommet h4:not(.grommetux-heading){font-size:18px;line-height:1.333}.grommet h5:not(.grommetux-heading),.grommet h6:not(.grommetux-heading){font-size:16px;line-height:1.375}.grommet h1:not(.grommetux-heading),.grommet h2:not(.grommetux-heading),.grommet h3:not(.grommetux-heading),.grommet h4:not(.grommetux-heading),.grommet h5:not(.grommetux-heading),.grommet h6:not(.grommetux-heading){font-weight:100;max-width:100%}.grommet h1:not(.grommetux-heading) .grommetux-anchor,.grommet h1:not(.grommetux-heading) a,.grommet h2:not(.grommetux-heading) .grommetux-anchor,.grommet h2:not(.grommetux-heading) a,.grommet h3:not(.grommetux-heading) .grommetux-anchor,.grommet h3:not(.grommetux-heading) a,.grommet h4:not(.grommetux-heading) .grommetux-anchor,.grommet h4:not(.grommetux-heading) a,.grommet h5:not(.grommetux-heading) .grommetux-anchor,.grommet h5:not(.grommetux-heading) a,.grommet h6:not(.grommetux-heading) .grommetux-anchor,.grommet h6:not(.grommetux-heading) a{color:inherit;text-decoration:none}.grommet h1:not(.grommetux-heading) .grommetux-anchor:hover,.grommet h1:not(.grommetux-heading) a:hover,.grommet h2:not(.grommetux-heading) .grommetux-anchor:hover,.grommet h2:not(.grommetux-heading) a:hover,.grommet h3:not(.grommetux-heading) .grommetux-anchor:hover,.grommet h3:not(.grommetux-heading) a:hover,.grommet h4:not(.grommetux-heading) .grommetux-anchor:hover,.grommet h4:not(.grommetux-heading) a:hover,.grommet h5:not(.grommetux-heading) .grommetux-anchor:hover,.grommet h5:not(.grommetux-heading) a:hover,.grommet h6:not(.grommetux-heading) .grommetux-anchor:hover,.grommet h6:not(.grommetux-heading) a:hover{text-decoration:none}.grommet dd,.grommet li:not([class^=grommetux-]){max-width:576px;margin-left:0;font-size:16px;font-weight:100;line-height:1.375;color:#666}.grommet dd{font-size:16px;font-weight:100;line-height:1.375;margin-bottom:12px}.grommet p:not(.grommetux-paragraph){max-width:576px;margin-left:0;margin-top:24px;margin-bottom:24px;font-size:16px;font-weight:100;line-height:1.375;color:#666}.grommet blockquote{font-size:36px;font-size:2.25rem;line-height:1.33333;margin-top:24px;margin-bottom:24px}.grommet b,.grommet strong{font-weight:600}.grommet code{font-family:Consolas,Menlo,DejaVu Sans Mono,Liberation Mono,monospace}.grommet .grommetux-background-color-index--dark dd,.grommet .grommetux-background-color-index--dark p:not(.grommetux-paragraph),.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark dd,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark p:not(.grommetux-paragraph){color:hsla(0,0%,100%,.85)}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light dd,.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light p:not(.grommetux-paragraph),.grommet .grommetux-background-color-index--light dd,.grommet .grommetux-background-color-index--light p:not(.grommetux-paragraph){color:#333}.grommet a:not(.grommetux-anchor):not(.grommetux-button){color:inherit;text-decoration:underline;cursor:pointer}.grommet a:not(.grommetux-anchor):not(.grommetux-button).plain .grommet a:not(.grommetux-anchor):not(.grommetux-button).grommetux-button,.grommet a:not(.grommetux-anchor):not(.grommetux-button).plain .grommet a:not(.grommetux-anchor):not(.grommetux-button).grommetux-button:hover{text-decoration:none}.grommet a:not(.grommetux-anchor):not(.grommetux-button):visited{color:inherit}.grommet a:not(.grommetux-anchor):not(.grommetux-button).active{color:#333}.grommet a:not(.grommetux-anchor):not(.grommetux-button):hover{color:#000;text-decoration:underline}.grommetux-background-color-index--dark .grommet a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--dark .grommet a:not(.grommetux-anchor):not(.grommetux-button):visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet a:not(.grommetux-anchor):not(.grommetux-button):visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommet a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--dark .grommet a:not(.grommetux-anchor):not(.grommetux-button):hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet a:not(.grommetux-anchor):not(.grommetux-button):hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet a:not(.grommetux-anchor):not(.grommetux-button):visited,.grommetux-background-color-index--light .grommet a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--light .grommet a:not(.grommetux-anchor):not(.grommetux-button):visited{color:inherit}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet a:not(.grommetux-anchor):not(.grommetux-button):hover,.grommetux-background-color-index--light .grommet a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--light .grommet a:not(.grommetux-anchor):not(.grommetux-button):hover{color:#000}.grommetux-background-color-index--pending .grommet a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--pending .grommet a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--pending .grommet a:not(.grommetux-anchor):not(.grommetux-button):hover,.grommetux-background-color-index--pending .grommet a:not(.grommetux-anchor):not(.grommetux-button):visited{color:transparent}.grommetux-background-color-index--dark a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--dark a:not(.grommetux-anchor):not(.grommetux-button):visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--light .grommetux-background-color-index--dark a:not(.grommetux-anchor):not(.grommetux-button):visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--dark a:not(.grommetux-anchor):not(.grommetux-button):hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--light .grommetux-background-color-index--dark a:not(.grommetux-anchor):not(.grommetux-button):hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--dark .grommetux-background-color-index--light a:not(.grommetux-anchor):not(.grommetux-button):visited,.grommetux-background-color-index--light a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--light a:not(.grommetux-anchor):not(.grommetux-button):visited{color:inherit}.grommetux-background-color-index--dark .grommetux-background-color-index--light a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--dark .grommetux-background-color-index--light a:not(.grommetux-anchor):not(.grommetux-button):hover,.grommetux-background-color-index--light a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--light a:not(.grommetux-anchor):not(.grommetux-button):hover{color:#000}.grommetux-background-color-index--pending a:not(.grommetux-anchor):not(.grommetux-button),.grommetux-background-color-index--pending a:not(.grommetux-anchor):not(.grommetux-button).active,.grommetux-background-color-index--pending a:not(.grommetux-anchor):not(.grommetux-button):hover,.grommetux-background-color-index--pending a:not(.grommetux-anchor):not(.grommetux-button):visited{color:transparent}.grommet input:not(.grommetux-input):not(.grommetux-check-box__input),.grommet select,.grommet textarea{font-size:16px;font-size:1rem;line-height:1.5;padding:11px 23px;border:1px solid rgba(0,0,0,.15);border-radius:0;outline:none;background-color:transparent;color:inherit;font:inherit;margin:0}.grommet input:not(.grommetux-input):not(.grommetux-check-box__input):focus,.grommet select:focus,.grommet textarea:focus{border-width:2px;border-color:#2ad2c9;padding:10px 22px}.grommet input:not(.grommetux-input):not(.grommetux-check-box__input)::-moz-focus-inner,.grommet select::-moz-focus-inner,.grommet textarea::-moz-focus-inner{border:none;outline:none}.grommet input:not(.grommetux-input):not(.grommetux-check-box__input)::-webkit-input-placeholder,.grommet select::-webkit-input-placeholder,.grommet textarea::-webkit-input-placeholder{color:#aaa}.grommet input:not(.grommetux-input):not(.grommetux-check-box__input)::-moz-placeholder,.grommet select::-moz-placeholder,.grommet textarea::-moz-placeholder{color:#aaa}.grommet input:not(.grommetux-input):not(.grommetux-check-box__input):-ms-input-placeholder,.grommet select:-ms-input-placeholder,.grommet textarea:-ms-input-placeholder{color:#aaa}.grommet input:not(.grommetux-input):not(.grommetux-check-box__input).error,.grommet select.error,.grommet textarea.error{border-color:#f04953}.grommet input[type=button],.grommet input[type=submit]{text-align:center;line-height:inherit}.grommet button:not(.grommetux-button),.grommet input[type=button],.grommet input[type=submit]{background-color:transparent;border:2px solid #01a982;border-radius:0;color:#333;font-size:19px;font-size:1.1875rem;line-height:24px;font-weight:600;cursor:pointer;text-align:center;outline:none;min-width:120px;max-width:384px}.grommet button:not(.grommetux-button):not(.grommetux-button--box),.grommet input[type=button]:not(.grommetux-button--box),.grommet input[type=submit]:not(.grommetux-button--box){padding:6px 22px}@media screen and (min-width:45em){.grommet button:not(.grommetux-button),.grommet input[type=button],.grommet input[type=submit]{transition:.1s ease-in-out}}.grommetux-background-color-index--dark .grommet button:not(.grommetux-button),.grommetux-background-color-index--dark .grommet input[type=button],.grommetux-background-color-index--dark .grommet input[type=submit],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet button:not(.grommetux-button),.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet input[type=button],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet input[type=submit]{border-color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet button:not(.grommetux-button),.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet input[type=button],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet input[type=submit],.grommetux-background-color-index--light .grommet button:not(.grommetux-button),.grommetux-background-color-index--light .grommet input[type=button],.grommetux-background-color-index--light .grommet input[type=submit]{border-color:#01a982}.grommet button:not(.grommetux-button):focus,.grommet input[type=button]:focus,.grommet input[type=submit]:focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommet a.grommetux-button,.grommet a.grommetux-button:hover{text-decoration:none}.grommet select{border-color:rgba(0,0,0,.15);padding-right:48px;-webkit-appearance:none;-moz-appearance:none;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAOhJREFUSA3tksENgzAMRUmrrlApuTAAxxw6QvfojYmYKtw6QpUDI1Rq6o8MStsAMT1UlbAUcMB+33FcFJttHfifDlhrT7QO31YMBlgDZw8HH5RSF3JLY0zrvX8MAZI3F1gT66y17ohz2zGgDSFc6UdF+5oDJWwUidMDXoFFfgtAfwJUjMppX7KI6CQJeOOcu48CcNaKzMFfBNaILME/BCQiOfCkQI5ILhwshceUpUAcG0/LeKEpzqwAEhIiRTSKs3Dk92MKZ8rep4vgR57zRTiYiwIIikVo29HKgiNXZGgXt0yUtwX/tgNPQqatJ1aBLFMAAAAASUVORK5CYII=) no-repeat center right 12px;cursor:pointer}.grommet select::-moz-focus-inner{border:none}.grommet select.plain{border:none}.grommet select:focus{padding-right:48px}.grommet input[type=range]{position:relative;-webkit-appearance:none;border-color:transparent;height:24px;padding:0;cursor:pointer;overflow-x:hidden}.grommet input[type=range]:focus{outline:none}.grommet input[type=range]::-moz-focus-inner,.grommet input[type=range]::-moz-focus-outer{border:none}.grommet input[type=range]::-webkit-slider-runnable-track{width:100%;height:2px;background-color:rgba(51,51,51,.2)}.grommet input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;position:relative;height:24px;width:24px;overflow:visible;margin-top:-11px;border:2px solid #01a982;border-radius:24px;background-color:#fff;cursor:pointer}.grommet input[type=range]::-webkit-slider-thumb:hover{border-color:#000}.grommet input[type=range]::-moz-range-track{width:100%;height:2px;background-color:rgba(51,51,51,.2)}.grommet input[type=range]::-moz-range-thumb{position:relative;height:24px;width:24px;overflow:visible;border:2px solid #01a982;height:20px;width:20px;border-radius:24px;background-color:#fff}.grommet input[type=range]:hover::-moz-range-thumb{border-color:#000}.grommet input[type=range]::-ms-track{width:100%;height:2px;background-color:rgba(51,51,51,.2);border-color:transparent;color:transparent}.grommet input[type=range]::-ms-fill-lower{background:#01a982;border-color:transparent}.grommet input[type=range]::-ms-fill-upper{background:rgba(51,51,51,.2);border-color:transparent}.grommet input[type=range]::-ms-thumb{height:24px;width:24px;overflow:visible;position:relative;top:6px;border:2px solid #666;height:20px;width:20px;border-radius:24px;background-color:#fff}.grommet input[type=range]:hover::-ms-thumb{border-color:#000}.grommet .grommetux-background-color-index--dark input[type=range]::-webkit-slider-runnable-track,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark input[type=range]::-webkit-slider-runnable-track{background-color:hsla(0,0%,100%,.2)}.grommet .grommetux-background-color-index--dark input[type=range]::-webkit-slider-thumb,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark input[type=range]::-webkit-slider-thumb{background-color:#fff;border:2px solid #fff}.grommet .grommetux-background-color-index--dark input[type=range]::-moz-range-thumb,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark input[type=range]::-moz-range-thumb{background-color:#fff;border:2px solid #fff}.grommet .grommetux-background-color-index--dark input[type=range]::-ms-fill-lower,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark input[type=range]::-ms-fill-lower{background:#fff}.grommet .grommetux-background-color-index--dark input[type=range]::-ms-fill-upper,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark input[type=range]::-ms-fill-upper{background:hsla(0,0%,100%,.2)}.grommet .grommetux-background-color-index--dark input[type=range]::-ms-thumb,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark input[type=range]::-ms-thumb{border-color:#fff}.grommet .grommetux-background-color-index--dark input[type=range]:hover::-ms-thumb,.grommet .grommetux-background-color-index--light .grommetux-background-color-index--dark input[type=range]:hover::-ms-thumb{border-color:#fff;background-color:#fff}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light input[type=range]::-webkit-slider-runnable-track,.grommet .grommetux-background-color-index--light input[type=range]::-webkit-slider-runnable-track{background-color:rgba(51,51,51,.2)}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light input[type=range]::-webkit-slider-thumb,.grommet .grommetux-background-color-index--light input[type=range]::-webkit-slider-thumb{background-color:#000;border:2px solid #000}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light input[type=range]::-moz-range-thumb,.grommet .grommetux-background-color-index--light input[type=range]::-moz-range-thumb{background-color:#000;border:2px solid #000}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light input[type=range]::-ms-fill-lower,.grommet .grommetux-background-color-index--light input[type=range]::-ms-fill-lower{background:#01a982}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light input[type=range]::-ms-fill-upper,.grommet .grommetux-background-color-index--light input[type=range]::-ms-fill-upper{background:rgba(51,51,51,.2)}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light input[type=range]::-ms-thumb,.grommet .grommetux-background-color-index--light input[type=range]::-ms-thumb{border-color:#666}.grommet .grommetux-background-color-index--dark .grommetux-background-color-index--light input[type=range]:hover::-ms-thumb,.grommet .grommetux-background-color-index--light input[type=range]:hover::-ms-thumb{border-color:#000;background-color:#fff}.grommet li>ol,.grommet li>ul{margin-bottom:0}.grommet img{max-width:100%;font-style:italic;vertical-align:middle}.grommetux-accordion-panel{margin:3px}.grommetux-accordion-panel__header{color:#666}.grommetux-background-color-index--dark .grommetux-accordion-panel__header,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-accordion-panel__header{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-accordion-panel__header,.grommetux-background-color-index--light .grommetux-accordion-panel__header{color:#666}.grommetux-accordion-panel__header:hover{color:#000}.grommetux-background-color-index--dark .grommetux-accordion-panel__header:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-accordion-panel__header:hover{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-accordion-panel__header:hover,.grommetux-background-color-index--light .grommetux-accordion-panel__header:hover{color:#000}.grommetux-accordion-panel--active .grommetux-accordion-panel__control{transform:rotate(90deg)}.grommetux-anchor{color:inherit;text-decoration:underline;cursor:pointer}.grommetux-anchor.plain .grommetux-anchor.grommetux-button,.grommetux-anchor.plain .grommetux-anchor.grommetux-button:hover{text-decoration:none}.grommetux-anchor:visited{color:inherit}.grommetux-anchor.active{color:#333}.grommetux-anchor:hover{color:#000;text-decoration:underline}.grommetux-background-color-index--dark .grommetux-anchor,.grommetux-background-color-index--dark .grommetux-anchor:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor:visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-anchor.active,.grommetux-background-color-index--dark .grommetux-anchor:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor:hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor:visited,.grommetux-background-color-index--light .grommetux-anchor,.grommetux-background-color-index--light .grommetux-anchor:visited{color:inherit}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor:hover,.grommetux-background-color-index--light .grommetux-anchor.active,.grommetux-background-color-index--light .grommetux-anchor:hover{color:#000}.grommetux-background-color-index--pending .grommetux-anchor,.grommetux-background-color-index--pending .grommetux-anchor.active,.grommetux-background-color-index--pending .grommetux-anchor:hover,.grommetux-background-color-index--pending .grommetux-anchor:visited{color:transparent}.grommetux-anchor__icon{display:inline-block;height:48px;padding:12px}.grommetux-anchor__icon .grommetux-control-icon{fill:#666;stroke:#666}.grommetux-anchor__icon:hover .grommetux-control-icon{fill:#000;stroke:#000}.grommetux-background-color-index--dark .grommetux-anchor__icon,.grommetux-background-color-index--dark .grommetux-anchor__icon:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor__icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor__icon:visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-anchor__icon.active,.grommetux-background-color-index--dark .grommetux-anchor__icon:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor__icon.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor__icon:hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor__icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor__icon:visited,.grommetux-background-color-index--light .grommetux-anchor__icon,.grommetux-background-color-index--light .grommetux-anchor__icon:visited{color:#666}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor__icon.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor__icon:hover,.grommetux-background-color-index--light .grommetux-anchor__icon.active,.grommetux-background-color-index--light .grommetux-anchor__icon:hover{color:#000}.grommetux-background-color-index--pending .grommetux-anchor__icon,.grommetux-background-color-index--pending .grommetux-anchor__icon.active,.grommetux-background-color-index--pending .grommetux-anchor__icon:hover,.grommetux-background-color-index--pending .grommetux-anchor__icon:visited{color:transparent}.grommetux-background-color-index--dark .grommetux-anchor__icon .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor__icon .grommetux-control-icon{fill:hsla(0,0%,100%,.7);stroke:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-anchor__icon:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor__icon:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor__icon:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor__icon:hover .grommetux-control-icon{fill:#fff;stroke:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor__icon .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor__icon .grommetux-control-icon{fill:#666;stroke:#666}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor__icon:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor__icon:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor__icon:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor__icon:hover .grommetux-control-icon{fill:#000;stroke:#000}.grommetux-anchor--animate-icon:hover .grommetux-control-icon{transform:scale(1.1)}.grommetux-anchor--icon{flex:0 0 auto}.grommetux-anchor--icon-label,.grommetux-anchor--primary{font-size:19px;font-size:1.1875rem;line-height:24px;font-weight:600;text-decoration:none}.grommetux-anchor--icon-label .grommetux-control-icon,.grommetux-anchor--primary .grommetux-control-icon{vertical-align:middle;margin-right:12px}html.rtl .grommetux-anchor--icon-label .grommetux-control-icon,html.rtl .grommetux-anchor--primary .grommetux-control-icon{margin-right:0;margin-left:12px}.grommetux-anchor--icon-label>span,.grommetux-anchor--primary>span{vertical-align:middle}.grommetux-anchor--reverse .grommetux-control-icon{margin-right:0;margin-left:12px}.grommetux-anchor--icon-label:not(.grommetux-anchor--primary),.grommetux-anchor--icon-label:not(.grommetux-anchor--primary):visited{color:#333}.grommetux-anchor--icon-label:not(.grommetux-anchor--primary) .grommetux-control-icon{fill:#666;stroke:#666}.grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover:not(.grommetux-anchor--disabled){color:#000;text-decoration:none}.grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary),.grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary),.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary).active,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary).active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary),.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):visited,.grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary),.grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):visited{color:#666}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary).active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover,.grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary).active,.grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover{color:#000}.grommetux-background-color-index--pending .grommetux-anchor--icon-label:not(.grommetux-anchor--primary),.grommetux-background-color-index--pending .grommetux-anchor--icon-label:not(.grommetux-anchor--primary).active,.grommetux-background-color-index--pending .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover,.grommetux-background-color-index--pending .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):visited{color:transparent}.grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary) .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary) .grommetux-control-icon{fill:hsla(0,0%,100%,.7);stroke:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover .grommetux-control-icon{fill:#fff;stroke:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary) .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary) .grommetux-control-icon{fill:#666;stroke:#666}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label:not(.grommetux-anchor--primary):hover .grommetux-control-icon{fill:#000;stroke:#000}.grommetux-anchor--primary{color:#049371}.grommetux-anchor--primary .grommetux-control-icon{fill:#049371;stroke:#049371}.grommetux-anchor--primary.active{color:#049371}.grommetux-anchor--primary.grommetux-anchor--animate-icon:not(.grommetux-anchor--disabled):hover{text-decoration:none}.grommetux-anchor--primary.grommetux-anchor--animate-icon:not(.grommetux-anchor--disabled):hover .grommetux-control-icon{transform:translateX(3px)}.grommetux-background-color-index--dark .grommetux-anchor--primary,.grommetux-background-color-index--dark .grommetux-anchor--primary:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-anchor--primary.active,.grommetux-background-color-index--dark .grommetux-anchor--primary:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:hover,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:visited,.grommetux-background-color-index--light .grommetux-anchor--primary,.grommetux-background-color-index--light .grommetux-anchor--primary.active,.grommetux-background-color-index--light .grommetux-anchor--primary:hover,.grommetux-background-color-index--light .grommetux-anchor--primary:visited{color:#049371}.grommetux-background-color-index--pending .grommetux-anchor--primary,.grommetux-background-color-index--pending .grommetux-anchor--primary.active,.grommetux-background-color-index--pending .grommetux-anchor--primary:hover,.grommetux-background-color-index--pending .grommetux-anchor--primary:visited{color:transparent}.grommetux-background-color-index--dark .grommetux-anchor--primary .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary .grommetux-control-icon{fill:hsla(0,0%,100%,.7);stroke:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-anchor--primary:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--primary:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:hover .grommetux-control-icon{fill:#fff;stroke:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary:hover .grommetux-control-icon{fill:#049371;stroke:#049371}.grommetux-anchor--disabled{opacity:.3;cursor:default}.grommetux-anchor--disabled .grommetux-control-icon{cursor:default}.grommetux-anchor--disabled:hover{color:inherit;text-decoration:none}.grommetux-anchor--disabled:hover.grommetux-anchor--primary{color:#049371}.grommetux-anchor--disabled:hover.grommetux-anchor:not(.grommetux-anchor--primary){color:inherit}.grommetux-background-color-index--dark .grommetux-anchor--disabled:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--disabled:hover{fill:hsla(0,0%,100%,.7);stroke:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-anchor--disabled:hover.grommetux-anchor--primary,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--disabled:hover.grommetux-anchor--primary{color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--disabled:hover,.grommetux-background-color-index--light .grommetux-anchor--disabled:hover{fill:inherit;stroke:inherit}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--disabled:hover.grommetux-anchor--primary,.grommetux-background-color-index--light .grommetux-anchor--disabled:hover.grommetux-anchor--primary{color:#049371}.grommetux-anchor--align-start{text-align:left}.grommetux-anchor--align-center{text-align:center}.grommetux-anchor--align-end{text-align:right}.grommetux-animate{max-width:100%}.grommetux-animate .grommetux-animate__child{transition:all 1s}.grommetux-animate__child--inactive{pointer-events:none}.grommetux-animate__child--fade.grommetux-animate__child--inactive,.grommetux-animate__child--fade.grommetux-animate__child--leave{opacity:0}.grommetux-animate__child--slide-up.grommetux-animate__child--inactive,.grommetux-animate__child--slide-up.grommetux-animate__child--leave{opacity:0;transform:translateY(50%)}.grommetux-animate__child--slide-down.grommetux-animate__child--inactive,.grommetux-animate__child--slide-down.grommetux-animate__child--leave{opacity:0;transform:translateY(-50%)}.grommetux-animate__child--slide-left.grommetux-animate__child--inactive,.grommetux-animate__child--slide-left.grommetux-animate__child--leave{opacity:0;transform:translateX(50%)}.grommetux-animate__child--slide-right.grommetux-animate__child--inactive,.grommetux-animate__child--slide-right.grommetux-animate__child--leave{opacity:0;transform:translateX(-50%)}@keyframes jiggle{0%,to{transform:translateX(0)}25%{transform:translateX(-.2%)}75%{transform:translateX(.2%)}}.grommetux-animate__child--jiggle.grommetux-animate__child--enter,.grommetux-animate__child--jiggle.grommetux-animate__child--leave{animation:jiggle .2s infinite alternate ease-in-out}@media screen and (min-width:45em){.grommet.grommetux-app{top:0;bottom:0;left:0;right:0;height:100%;width:100%;overflow:visible}}.grommet.grommetux-app--hidden{position:fixed}.grommet.grommetux-app--inline{position:relative}.grommet.grommetux-app--centered{width:100%;max-width:1152px;margin-left:auto;margin-right:auto}.grommet.grommetux-app .grommetux-app__announcer{left:-100%;right:100%;z-index:-1;position:fixed}.grommetux-article{position:relative}.grommetux-article>*{flex:0 0 auto}.grommetux-article--scroll-step{text-align:center;height:100vh;width:100vw;max-width:100%}.grommetux-article--scroll-step.grommetux-box--direction-column{overflow-x:hidden;overflow-y:auto}.grommetux-article--scroll-step.grommetux-box--direction-column .grommetux-article__control-carousel{top:50%;left:24px;transform:translateY(-50%)}.grommetux-article--scroll-step.grommetux-box--direction-row{overflow-x:auto;overflow-y:hidden}.grommetux-article--scroll-step.grommetux-box--direction-row>:not(.grommetux-article__controls){overflow-y:auto}@media screen and (max-width:44.9375em){.grommetux-article--scroll-step.grommetux-box--direction-row>:not(.grommetux-article__controls){overflow-y:scroll;-webkit-overflow-scrolling:touch}}.grommetux-article--scroll-step.grommetux-box--direction-row .grommetux-article__control-carousel{top:24px;left:50%;transform:translateX(-50%)}@media screen and (max-width:44.9375em){.grommetux-article--scroll-step.grommetux-box--responsive.grommetux-box--direction-row{flex-direction:row}}.grommetux-article__control{position:fixed;z-index:10;margin:24px}.grommetux-article__control.grommetux-button--plain.grommetux-button--icon{overflow:hidden}.grommetux-article__control .grommetux-button__icon{padding:0}.grommetux-article__control-up{top:0;left:50%;transform:translateX(-50%)}.grommetux-article__control-down{bottom:0;left:50%;transform:translateX(-50%)}@media screen and (min-width:45em){.grommetux-article__control-left{left:0;top:50%;transform:translateY(-50%)}}@media screen and (max-width:44.9375em){.grommetux-article__control-left{left:0;bottom:0}}@media screen and (min-width:45em){.grommetux-article__control-right{top:50%;transform:translateY(-50%);right:0}}@media screen and (max-width:44.9375em){.grommetux-article__control-right{right:0;bottom:0}}.grommet article:not(.grommetux-article){width:100%}.grommetux-box{display:flex;background-position:50%;background-size:cover;background-repeat:no-repeat}.grommetux-box--pad-none{padding:0}@media screen and (min-width:45em){.grommetux-box--pad-small{padding:12px}.grommetux-box--pad-medium{padding:24px}.grommetux-box--pad-large{padding:48px}.grommetux-box--pad-xlarge{padding:192px}}@media screen and (max-width:44.9375em){.grommetux-box--pad-small{padding:6px}.grommetux-box--pad-medium{padding:12px}.grommetux-box--pad-large{padding:24px}.grommetux-box--pad-xlarge{padding:48px}}.grommetux-box--pad-horizontal-none{padding-left:0;padding-right:0}@media screen and (min-width:45em){.grommetux-box--pad-horizontal-small{padding-left:12px;padding-right:12px}.grommetux-box--pad-horizontal-medium{padding-left:24px;padding-right:24px}.grommetux-box--pad-horizontal-large{padding-left:48px;padding-right:48px}.grommetux-box--pad-horizontal-xlarge{padding-left:192px;padding-right:192px}}@media screen and (max-width:44.9375em){.grommetux-box--pad-horizontal-small{padding-left:6px;padding-right:6px}.grommetux-box--pad-horizontal-medium{padding-left:12px;padding-right:12px}.grommetux-box--pad-horizontal-large{padding-left:24px;padding-right:24px}.grommetux-box--pad-horizontal-xlarge{padding-left:48px;padding-right:48px}}.grommetux-box--pad-vertical-none{padding-top:0;padding-bottom:0}@media screen and (min-width:45em){.grommetux-box--pad-vertical-small{padding-top:12px;padding-bottom:12px}.grommetux-box--pad-vertical-medium{padding-top:24px;padding-bottom:24px}.grommetux-box--pad-vertical-large{padding-top:48px;padding-bottom:48px}.grommetux-box--pad-vertical-xlarge{padding-top:192px;padding-bottom:192px}}@media screen and (max-width:44.9375em){.grommetux-box--pad-vertical-small{padding-top:6px;padding-bottom:6px}.grommetux-box--pad-vertical-medium{padding-top:12px;padding-bottom:12px}.grommetux-box--pad-vertical-large{padding-top:24px;padding-bottom:24px}.grommetux-box--pad-vertical-xlarge{padding-top:48px;padding-bottom:48px}}.grommetux-box--margin-none{margin:0}.grommetux-box--margin-small{margin:12px}.grommetux-box--margin-medium{margin:24px}.grommetux-box--margin-large{margin:48px}@media screen and (max-width:44.9375em){.grommetux-box--margin-small{margin:6px}.grommetux-box--margin-medium{margin:12px}.grommetux-box--margin-large{margin:24px}}.grommetux-box--margin-horizontal-none{margin-left:0;margin-right:0}.grommetux-box--margin-horizontal-small{margin-left:12px;margin-right:12px}.grommetux-box--margin-horizontal-medium{margin-left:24px;margin-right:24px}.grommetux-box--margin-horizontal-large{margin-left:48px;margin-right:48px}@media screen and (max-width:44.9375em){.grommetux-box--margin-horizontal-small{margin-left:6px;margin-right:6px}.grommetux-box--margin-horizontal-medium{margin-left:12px;margin-right:12px}.grommetux-box--margin-horizontal-large{margin-left:24px;margin-right:24px}}.grommetux-box--margin-vertical-none{margin-top:0;margin-bottom:0}.grommetux-box--margin-vertical-small{margin-top:12px;margin-bottom:12px}.grommetux-box--margin-vertical-medium{margin-top:24px;margin-bottom:24px}.grommetux-box--margin-vertical-large{margin-top:48px;margin-bottom:48px}@media screen and (max-width:44.9375em){.grommetux-box--margin-vertical-small{margin-top:6px;margin-bottom:6px}.grommetux-box--margin-vertical-medium{margin-top:12px;margin-bottom:12px}.grommetux-box--margin-vertical-large{margin-top:24px;margin-bottom:24px}}.grommetux-box--margin-left-none{margin-left:0}.grommetux-box--margin-left-small{margin-left:12px}.grommetux-box--margin-left-medium{margin-left:24px}.grommetux-box--margin-left-large{margin-left:48px}@media screen and (max-width:44.9375em){.grommetux-box--margin-left-small{margin-left:6px}.grommetux-box--margin-left-medium{margin-left:12px}.grommetux-box--margin-left-large{margin-left:24px}}.grommetux-box--margin-right-none{margin-right:0}.grommetux-box--margin-right-small{margin-right:12px}.grommetux-box--margin-right-medium{margin-right:24px}.grommetux-box--margin-right-large{margin-right:48px}@media screen and (max-width:44.9375em){.grommetux-box--margin-right-small{margin-right:6px}.grommetux-box--margin-right-medium{margin-right:12px}.grommetux-box--margin-right-large{margin-right:24px}}.grommetux-box--margin-top-none{margin-top:0}.grommetux-box--margin-top-small{margin-top:12px}.grommetux-box--margin-top-medium{margin-top:24px}.grommetux-box--margin-top-large{margin-top:48px}@media screen and (max-width:44.9375em){.grommetux-box--margin-top-small{margin-top:6px}.grommetux-box--margin-top-medium{margin-top:12px}.grommetux-box--margin-top-large{margin-top:24px}}.grommetux-box--margin-bottom-none{margin-bottom:0}.grommetux-box--margin-bottom-small{margin-bottom:12px}.grommetux-box--margin-bottom-medium{margin-bottom:24px}.grommetux-box--margin-bottom-large{margin-bottom:48px}@media screen and (max-width:44.9375em){.grommetux-box--margin-bottom-small{margin-bottom:6px}.grommetux-box--margin-bottom-medium{margin-bottom:12px}.grommetux-box--margin-bottom-large{margin-bottom:24px}}.grommetux-box__texture{position:absolute;top:0;left:0;width:100%;height:100%;z-index:-1;overflow:hidden}.grommetux-box--separator-all,.grommetux-box--separator-horizontal,.grommetux-box--separator-top{border-top:1px solid rgba(0,0,0,.15)}.grommetux-box--separator-all,.grommetux-box--separator-bottom,.grommetux-box--separator-horizontal{border-bottom:1px solid rgba(0,0,0,.15)}.grommetux-box--separator-all,.grommetux-box--separator-left,.grommetux-box--separator-vertical{border-left:1px solid rgba(0,0,0,.15)}@media screen and (max-width:44.9375em){.grommetux-box--responsive.grommetux-box--direction-row .grommetux-box--separator-all,.grommetux-box--responsive.grommetux-box--direction-row .grommetux-box--separator-left,.grommetux-box--responsive.grommetux-box--direction-row .grommetux-box--separator-vertical{border-left:none;border-top:1px solid rgba(0,0,0,.15)}}.grommetux-box--separator-all,.grommetux-box--separator-right,.grommetux-box--separator-vertical{border-right:1px solid rgba(0,0,0,.15)}@media screen and (max-width:44.9375em){.grommetux-box--responsive.grommetux-box--direction-row .grommetux-box--separator-all,.grommetux-box--responsive.grommetux-box--direction-row .grommetux-box--separator-right,.grommetux-box--responsive.grommetux-box--direction-row .grommetux-box--separator-vertical{border-right:none;border-bottom:1px solid rgba(0,0,0,.15)}}.grommetux-background-color-index--dark .grommetux-box[class*=grommetux-box--separator],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-box[class*=grommetux-box--separator]{border-color:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-box[class*=grommetux-box--separator],.grommetux-background-color-index--light .grommetux-box[class*=grommetux-box--separator]{border-color:rgba(0,0,0,.15)}.grommetux-box--clickable{cursor:pointer;outline:none}.grommetux-box--focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-box__container{padding-left:24px;padding-right:24px}.grommetux-app--centered .grommetux-box__container>.grommetux-box{width:100%;max-width:1152px;margin-left:auto;margin-right:auto}@media screen and (max-width:44.9375em){.grommetux-app--centered .grommetux-box__container>.grommetux-box{padding-left:0;padding-right:0}}.grommetux-box__container--full,.grommetux-box__container--full-horizontal{max-width:100%;width:100vw}.grommetux-box--flex{flex:1 1;min-width:0;overflow:auto}.grommetux-box--flex-off{flex:0 0 auto}.grommetux-box--flex-grow{flex:1 0;min-width:0}.grommetux-box--flex-grow:not([class*=grommetux-box--basis]){flex-basis:auto}.grommetux-box--flex-shrink{flex:0 1}.grommetux-box--basis-xsmall{flex-basis:96px}.grommetux-box--basis-small{flex-basis:192px}.grommetux-box--basis-medium{flex-basis:384px}.grommetux-box--basis-large{flex-basis:576px}.grommetux-box--basis-xlarge{flex-basis:720px}.grommetux-box--basis-xxlarge{flex-basis:960px}.grommetux-box--basis-full{flex-basis:100%}.grommetux-box--basis-1-2{flex-basis:50%}.grommetux-box--basis-1-2.grommetux-box--separator-all,.grommetux-box--basis-1-2.grommetux-box--separator-vertical{flex-basis:calc(50% - 2px)}.grommetux-box--basis-1-2.grommetux-box--separator-left,.grommetux-box--basis-1-2.grommetux-box--separator-right{flex-basis:calc(50% - 1px)}.grommetux-box--basis-1-3{flex-basis:33.33%}.grommetux-box--basis-1-3.grommetux-box--separator-all,.grommetux-box--basis-1-3.grommetux-box--separator-vertical{flex-basis:calc(33.33% - 2px)}.grommetux-box--basis-1-3.grommetux-box--separator-left,.grommetux-box--basis-1-3.grommetux-box--separator-right{flex-basis:calc(33.33% - 1px)}.grommetux-box--basis-2-3{flex-basis:66.66%}.grommetux-box--basis-2-3.grommetux-box--separator-all,.grommetux-box--basis-2-3.grommetux-box--separator-vertical{flex-basis:calc(66.66% - 2px)}.grommetux-box--basis-2-3.grommetux-box--separator-left,.grommetux-box--basis-2-3.grommetux-box--separator-right{flex-basis:calc(66.66% - 1px)}.grommetux-box--basis-1-4{flex-basis:25%}.grommetux-box--basis-1-4.grommetux-box--separator-all,.grommetux-box--basis-1-4.grommetux-box--separator-vertical{flex-basis:calc(25% - 2px)}.grommetux-box--basis-1-4.grommetux-box--separator-left,.grommetux-box--basis-1-4.grommetux-box--separator-right{flex-basis:calc(25% - 1px)}@media screen and (max-width:63.9375em){.grommetux-box--basis-1-4{flex-basis:50%}.grommetux-box--basis-1-4.grommetux-box--separator-all,.grommetux-box--basis-1-4.grommetux-box--separator-vertical{flex-basis:calc(50% - 2px)}.grommetux-box--basis-1-4.grommetux-box--separator-left,.grommetux-box--basis-1-4.grommetux-box--separator-right{flex-basis:calc(50% - 1px)}}.grommetux-box--basis-3-4{flex-basis:75%}.grommetux-box--basis-3-4.grommetux-box--separator-all,.grommetux-box--basis-3-4.grommetux-box--separator-vertical{flex-basis:calc(75% - 2px)}.grommetux-box--basis-3-4.grommetux-box--separator-left,.grommetux-box--basis-3-4.grommetux-box--separator-right{flex-basis:calc(75% - 1px)}.grommetux-box--width-xsmall{width:96px}.grommetux-box--width-small{width:192px}.grommetux-box--width-medium{width:384px}.grommetux-box--width-large{width:576px}.grommetux-box--width-xlarge{width:720px}.grommetux-box--width-xxlarge{width:960px}.grommetux-box--height-xsmall{height:96px}.grommetux-box--height-small{height:192px}.grommetux-box--height-medium{height:384px}.grommetux-box--height-large{height:576px}.grommetux-box--height-xlarge{height:720px}.grommetux-box--height-xxlarge{height:960px}.grommetux-box--width-min-xsmall{min-width:96px}.grommetux-box--width-min-small{min-width:192px}.grommetux-box--width-min-medium{min-width:384px}.grommetux-box--width-min-large{min-width:576px}.grommetux-box--width-min-xlarge{min-width:720px}.grommetux-box--width-min-xxlarge{min-width:960px}.grommetux-box--width-max-xsmall{max-width:96px}.grommetux-box--width-max-small{max-width:192px}.grommetux-box--width-max-medium{max-width:384px}.grommetux-box--width-max-large{max-width:576px}.grommetux-box--width-max-xlarge{max-width:720px}.grommetux-box--width-max-xxlarge{max-width:960px}.grommetux-box--height-max-xsmall{max-height:96px}.grommetux-box--height-max-small{max-height:192px}.grommetux-box--height-max-medium{max-height:384px}.grommetux-box--height-max-large{max-height:576px}.grommetux-box--height-max-xlarge{max-height:720px}.grommetux-box--height-max-xxlarge{max-height:960px}.grommetux-box--height-min-xsmall{min-height:96px}.grommetux-box--height-min-small{min-height:192px}.grommetux-box--height-min-medium{min-height:384px}.grommetux-box--height-min-large{min-height:576px}.grommetux-box--height-min-xlarge{min-height:720px}.grommetux-box--height-min-xxlarge{min-height:960px}.grommetux-box--full{position:relative;max-width:100%;width:100vw;height:100vh;max-height:100%;overflow:auto}@media screen and (max-width:44.9375em){.grommetux-box--full.grommetux-box--full-responsive{min-height:100vh;height:100%}}.grommetux-box--full-horizontal{max-width:100%;width:100vw}.grommetux-box--full-vertical{height:100vh;max-height:100%;overflow:auto}@media screen and (max-width:44.9375em){.grommetux-box--full-vertical.grommetux-box--full-responsive{min-height:100vh;height:100%}}.grommetux-box--size{max-width:100%;max-height:100%}.grommetux-box--size .grommet-namespaceparagraph{width:100%;max-width:100%;flex:0 0 auto}.grommetux-box--size-xsmall{width:96px}.grommetux-box--size-small{width:192px}.grommetux-box--size-medium{width:384px}.grommetux-box--size-large{width:576px}.grommetux-box--size-xlarge{width:720px}.grommetux-box--size-xxlarge{width:960px}.grommetux-box--size-auto{width:auto}.grommetux-box--text-align-left{text-align:left}.grommetux-box--text-align-center{text-align:center}.grommetux-box--text-align-right{text-align:right}.grommetux-box--wrap{flex-wrap:wrap}.grommetux-box--direction-row{flex-direction:row}.grommetux-box--direction-row.grommetux-box--reverse{flex-direction:row-reverse}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--responsive{flex-direction:column}.grommetux-box--direction-row.grommetux-box--responsive:not(.grommetux-box--justify-center){align-items:stretch}.grommetux-box--direction-row.grommetux-box--responsive.grommetux-box--reverse{flex-direction:column-reverse}.grommetux-box--direction-row.grommetux-box--responsive>.grommetux-box{flex-basis:auto}}.grommetux-box--direction-column{flex-direction:column}.grommetux-box--direction-column.grommetux-box--reverse{flex-direction:column-reverse}.grommetux-box--justify-start{justify-content:flex-start}.grommetux-box--justify-center{justify-content:center}.grommetux-box--justify-between{justify-content:space-between}.grommetux-box--justify-around{justify-content:space-around}.grommetux-box--justify-end{justify-content:flex-end}.grommetux-box--align-start{align-items:flex-start}.grommetux-box--align-center{align-items:center}.grommetux-box--align-end{align-items:flex-end}.grommetux-box--align-baseline{align-items:baseline}.grommetux-box--align-stretch{align-items:stretch}.grommetux-box--align-content-start{align-content:flex-start}.grommetux-box--align-content-end{align-content:flex-end}.grommetux-box--align-content-center{align-content:center}.grommetux-box--align-content-between{align-content:space-between}.grommetux-box--align-content-around{align-content:space-around}.grommetux-box--align-content-stretch{align-content:stretch}.grommetux-box--align-self-start{align-self:flex-start}.grommetux-box--align-self-end{align-self:flex-end}.grommetux-box--align-self-center{align-self:center}.grommetux-box--align-self-stretch{align-self:stretch}.grommetux-box--direction-row.grommetux-box--pad-between-small.grommetux-box--pad-between-thirds>.grommetux-box--basis-1-3{flex-basis:calc(33.33% - 8px)}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-small.grommetux-box--pad-between-thirds>.grommetux-box--basis-1-3{flex-basis:auto;max-width:none;width:100%}}.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-1-2{flex-basis:calc(50% - 6px)}.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-1-3{flex-basis:calc(33.33% - 6px)}.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-2-3{flex-basis:calc(66.66% - 6px)}.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-1-4{flex-basis:calc(25% - 9px)}@media screen and (max-width:63.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-1-4{flex-basis:calc(50% - 6px)}.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-1-4:nth-of-type(2){margin-right:0}}.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-3-4{flex-basis:calc(75% - 9px)}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-1-2,.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-1-3,.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-1-4,.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-2-3,.grommetux-box--direction-row.grommetux-box--pad-between-small>.grommetux-box--basis-3-4{flex-basis:auto;max-width:none;width:100%}}.grommetux-box--direction-row.grommetux-box--pad-between-small>:not(:last-child){margin-right:12px}html.rtl .grommetux-box--direction-row.grommetux-box--pad-between-small>:not(:last-child){margin-right:0;margin-left:12px}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-small>:not(:last-child){margin-right:6px}html.rtl .grommetux-box--direction-row.grommetux-box--pad-between-small>:not(:last-child){margin-right:0;margin-left:6px}}.grommetux-box--direction-row.grommetux-box--pad-between-medium.grommetux-box--pad-between-thirds>.grommetux-box--basis-1-3{flex-basis:calc(33.33% - 16px)}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-medium.grommetux-box--pad-between-thirds>.grommetux-box--basis-1-3{flex-basis:auto;max-width:none;width:100%}}.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-1-2{flex-basis:calc(50% - 12px)}.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-1-3{flex-basis:calc(33.33% - 12px)}.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-2-3{flex-basis:calc(66.66% - 12px)}.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-1-4{flex-basis:calc(25% - 18px)}@media screen and (max-width:63.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-1-4{flex-basis:calc(50% - 12px)}.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-1-4:nth-of-type(2){margin-right:0}}.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-3-4{flex-basis:calc(75% - 18px)}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-1-2,.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-1-3,.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-1-4,.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-2-3,.grommetux-box--direction-row.grommetux-box--pad-between-medium>.grommetux-box--basis-3-4{flex-basis:auto;max-width:none;width:100%}}.grommetux-box--direction-row.grommetux-box--pad-between-medium>:not(:last-child){margin-right:24px}html.rtl .grommetux-box--direction-row.grommetux-box--pad-between-medium>:not(:last-child){margin-right:0;margin-left:24px}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-medium>:not(:last-child){margin-right:12px}html.rtl .grommetux-box--direction-row.grommetux-box--pad-between-medium>:not(:last-child){margin-right:0;margin-left:12px}}.grommetux-box--direction-row.grommetux-box--pad-between-large.grommetux-box--pad-between-thirds>.grommetux-box--basis-1-3{flex-basis:calc(33.33% - 32px)}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-large.grommetux-box--pad-between-thirds>.grommetux-box--basis-1-3{flex-basis:auto;max-width:none;width:100%}}.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-1-2{flex-basis:calc(50% - 24px)}.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-1-3{flex-basis:calc(33.33% - 24px)}.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-2-3{flex-basis:calc(66.66% - 24px)}.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-1-4{flex-basis:calc(25% - 36px)}@media screen and (max-width:63.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-1-4{flex-basis:calc(50% - 24px)}.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-1-4:nth-of-type(2){margin-right:0}}.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-3-4{flex-basis:calc(75% - 36px)}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-1-2,.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-1-3,.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-1-4,.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-2-3,.grommetux-box--direction-row.grommetux-box--pad-between-large>.grommetux-box--basis-3-4{flex-basis:auto;max-width:none;width:100%}}.grommetux-box--direction-row.grommetux-box--pad-between-large>:not(:last-child){margin-right:48px}html.rtl .grommetux-box--direction-row.grommetux-box--pad-between-large>:not(:last-child){margin-right:0;margin-left:48px}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--pad-between-large>:not(:last-child){margin-right:24px}html.rtl .grommetux-box--direction-row.grommetux-box--pad-between-large>:not(:last-child){margin-right:0;margin-left:24px}}@media screen and (max-width:44.9375em){.grommetux-box--direction-row.grommetux-box--responsive.grommetux-box--pad-between-small>:not(:last-child){margin-left:0;margin-right:0;margin-bottom:6px}.grommetux-box--direction-row.grommetux-box--responsive.grommetux-box--pad-between-medium>:not(:last-child){margin-left:0;margin-right:0;margin-bottom:12px}.grommetux-box--direction-row.grommetux-box--responsive.grommetux-box--pad-between-large>:not(:last-child){margin-left:0;margin-right:0;margin-bottom:24px}}.grommetux-box--direction-column.grommetux-box--pad-between-small>:not(:last-child){margin-bottom:12px}@media screen and (max-width:44.9375em){.grommetux-box--direction-column.grommetux-box--pad-between-small>:not(:last-child){margin-bottom:6px}}.grommetux-box--direction-column.grommetux-box--pad-between-medium>:not(:last-child){margin-bottom:24px}@media screen and (max-width:44.9375em){.grommetux-box--direction-column.grommetux-box--pad-between-medium>:not(:last-child){margin-bottom:12px}}.grommetux-box--direction-column.grommetux-box--pad-between-large>:not(:last-child){margin-bottom:48px}@media screen and (max-width:44.9375em){.grommetux-box--direction-column.grommetux-box--pad-between-large>:not(:last-child){margin-bottom:24px}}.grommetux-button{background-color:transparent;border:2px solid #01a982;border-radius:0;color:#333;font-size:19px;font-size:1.1875rem;line-height:24px;font-weight:600;cursor:pointer;text-align:center;outline:none;min-width:120px;max-width:384px}.grommetux-button:not(.grommetux-button--box){padding:6px 22px}@media screen and (min-width:45em){.grommetux-button{transition:.1s ease-in-out}}.grommetux-background-color-index--dark .grommetux-button,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button{border-color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button,.grommetux-background-color-index--light .grommetux-button{border-color:#01a982}.grommetux-button--focus{border:2px solid #2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-background-color-index--dark .grommetux-button,.grommetux-background-color-index--dark .grommetux-button:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-button.active,.grommetux-background-color-index--dark .grommetux-button:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button:hover,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button:visited,.grommetux-background-color-index--light .grommetux-button,.grommetux-background-color-index--light .grommetux-button.active,.grommetux-background-color-index--light .grommetux-button:hover,.grommetux-background-color-index--light .grommetux-button:visited{color:#333}.grommetux-background-color-index--pending .grommetux-button,.grommetux-background-color-index--pending .grommetux-button.active,.grommetux-background-color-index--pending .grommetux-button:hover,.grommetux-background-color-index--pending .grommetux-button:visited{color:transparent}.grommetux-button--hover-background:hover{background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-background-color-index--dark .grommetux-button--hover-background:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button--hover-background:hover{background-color:rgba(0,0,0,.1);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button--hover-background:hover,.grommetux-background-color-index--light .grommetux-button--hover-background:hover{background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-button:hover .grommetux-control-icon{fill:#000;stroke:#000;transition:none}.grommetux-background-color-index--dark .grommetux-button:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:hover .grommetux-control-icon{fill:#fff;stroke:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-button:hover .grommetux-control-icon{fill:#000;stroke:#000}.grommetux-button__icon{display:inline-block}.grommetux-button__icon .grommetux-control-icon{vertical-align:bottom}.grommetux-button--secondary:not(.grommetux-button--focus){border-color:rgba(51,51,51,.6)}.grommetux-button--accent:not(.grommetux-button--focus){border-color:#ff8d6d}.grommetux-button--critical:not(.grommetux-button--focus){border-color:#f04953}.grommetux-button--align-start{text-align:left}html.rtl .grommetux-button--align-start{text-align:right}.grommetux-button--plain:not(.grommetux-button--box){padding:0}.grommetux-button--plain{width:auto;height:auto;min-width:0;max-width:none;text-align:inherit;font-weight:inherit}.grommetux-button--plain .grommetux-button__label{margin:0 12px}.grommetux-button--plain .grommetux-button__icon{padding:10px}.grommetux-button--plain .grommetux-button__icon+.grommetux-button__label{margin-left:0}.grommetux-button--plain:not(.grommetux-button--focus){border:2px solid transparent}.grommetux-button:not(.grommetux-button--plain) .grommetux-button__icon+.grommetux-button__label{margin-left:12px}.grommetux-button--primary{background-color:#01a982;color:#fff}.grommetux-button--primary:not(.grommetux-button--focus){border-color:#01a982}.grommetux-button--primary:hover:not(.grommetux-button--disabled){color:#fff}.grommetux-button--primary .grommetux-control-icon,.grommetux-button--primary:hover:not(.grommetux-button--disabled) .grommetux-button__icon .grommetux-control-icon{fill:#fff;stroke:#fff}.grommetux-background-color-index--dark .grommetux-button--primary,.grommetux-background-color-index--dark .grommetux-button--primary:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button--primary,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button--primary:visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button--primary,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button--primary.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button--primary:hover,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button--primary:visited,.grommetux-background-color-index--dark .grommetux-button--primary.active,.grommetux-background-color-index--dark .grommetux-button--primary:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button--primary.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button--primary:hover,.grommetux-background-color-index--light .grommetux-button--primary,.grommetux-background-color-index--light .grommetux-button--primary.active,.grommetux-background-color-index--light .grommetux-button--primary:hover,.grommetux-background-color-index--light .grommetux-button--primary:visited{color:#fff}.grommetux-background-color-index--pending .grommetux-button--primary,.grommetux-background-color-index--pending .grommetux-button--primary.active,.grommetux-background-color-index--pending .grommetux-button--primary:hover,.grommetux-background-color-index--pending .grommetux-button--primary:visited{color:transparent}.grommetux-background-color-index--dark .grommetux-button--primary .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button--primary .grommetux-control-icon{fill:hsla(0,0%,100%,.7);stroke:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button--primary .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button--primary:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button--primary:hover .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-button--primary:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-button--primary:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button--primary:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button--primary:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-button--primary .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-button--primary:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-button--primary:hover .grommetux-control-icon{fill:#fff;stroke:#fff}.grommetux-button--disabled{opacity:.3;cursor:default}.grommetux-button:not(.grommetux-button--fill){flex:0 0 auto}.grommetux-button--fill{width:100%;max-width:none;flex-grow:1}a.grommetux-button,a.grommetux-button:hover{text-decoration:none}@media screen and (max-width:44.9375em){.grommetux-card{padding:0}.grommetux-card:not(:last-child){border-bottom:1px solid rgba(0,0,0,.15)}}@media screen and (max-width:44.9375em){.grommetux-card.grommetux-box--responsive{width:auto;margin:0}}.grommetux-card a:focus,.grommetux-card div:focus{outline:none}.grommetux-card__thumbnail{min-height:192px}.grommetux-card__content--truncate .grommetux-paragraph{max-width:none;overflow:hidden;display:-webkit-box;-webkit-line-clamp:8;text-overflow:ellipsis;position:relative;max-height:176px}.grommetux-card__content--truncate .grommetux-paragraph:after{margin-top:154px}@media screen and (max-width:44.9375em){.grommetux-card__content--truncate .grommetux-paragraph{max-height:110px}.grommetux-card__content--truncate .grommetux-paragraph:after{margin-top:88px}}.grommetux-card__content--truncate .grommetux-paragraph:after{content:\"...\";text-align:right;top:0;right:0;display:block;position:absolute;background:linear-gradient(90deg,transparent,#fff 50%);width:24px}@supports (-webkit-line-clamp:1){.grommetux-card__content--truncate .grommetux-paragraph:after{display:none}}@media screen and (max-width:44.9375em){.grommetux-card__content--truncate .grommetux-paragraph{-webkit-line-clamp:4}}.grommetux-card__content--truncate .grommetux-paragraph--small{max-height:160.16px}.grommetux-card__content--truncate .grommetux-paragraph--small:after{margin-top:140.14px}@media screen and (max-width:44.9375em){.grommetux-card__content--truncate .grommetux-paragraph--small{max-height:100.1px}.grommetux-card__content--truncate .grommetux-paragraph--small:after{margin-top:80.08px}}.grommetux-card__content--truncate .grommetux-paragraph--large{max-height:224.064px}.grommetux-card__content--truncate .grommetux-paragraph--large:after{margin-top:196.056px}@media screen and (max-width:44.9375em){.grommetux-card__content--truncate .grommetux-paragraph--large{max-height:140.04px}.grommetux-card__content--truncate .grommetux-paragraph--large:after{margin-top:112.032px}}.grommetux-card__content--truncate .grommetux-paragraph--xlarge{max-height:304px}.grommetux-card__content--truncate .grommetux-paragraph--xlarge:after{margin-top:266px}@media screen and (max-width:44.9375em){.grommetux-card__content--truncate .grommetux-paragraph--xlarge{max-height:190px}.grommetux-card__content--truncate .grommetux-paragraph--xlarge:after{margin-top:152px}}@media screen and (max-width:44.9375em){.grommetux-card--direction-row .grommetux-card__thumbnail{flex-basis:192px}}.grommetux-card--selectable:hover>div{background-color:#ebebeb;color:#000;cursor:pointer}.grommetux-card--selectable:hover>div .grommetux-card__content .grommetux-paragraph:after{background:linear-gradient(90deg,transparent,#ebebeb 50%)}@keyframes carousel-reveal{0%{opacity:0}to{opacity:1}}@keyframes carousel-hide{0%{opacity:1}to{opacity:0}}.grommetux-carousel{position:relative;max-width:100%;overflow:hidden}.grommetux-carousel .grommetux-tiles.grommetux-box--direction-row>.grommetux-tile.grommetux-carousel__item{flex:1 1 100%;box-sizing:border-box}.grommetux-carousel .grommetux-tiles.grommetux-box--direction-row>.grommetux-tile.grommetux-carousel__item>*{width:100%}.grommetux-carousel .grommetux-control-icon-next{right:0}.grommetux-carousel .grommetux-control-icon-previous{left:0}.grommetux-carousel img{-webkit-user-drag:none;-khtml-user-drag:none;-moz-user-drag:none;-o-user-drag:none;user-drag:none}.grommetux-carousel-controls__control{width:36px;height:36px;stroke:#fff;fill:transparent;cursor:pointer;filter:drop-shadow(1px 1px 1px rgba(170,170,170,.5));-webkit-filter:drop-shadow(1px 1px 1px hsla(0,0%,67%,.5))}.grommetux-carousel-controls__control:hover{stroke-width:2px}.grommetux-carousel-controls__control--active{stroke:#01a982;fill:#01a982}.grommetux-carousel__track{display:flex;max-width:none}.grommetux-carousel__track--animate{transition:all .8s}.grommetux-carousel__arrow{animation:carousel-reveal 1s;z-index:1;position:absolute;top:50%;transform:translateY(-50%);cursor:pointer}.grommetux-carousel__arrow .grommetux-control-icon{filter:drop-shadow(1px 1px 1px rgba(170,170,170,.5));-webkit-filter:drop-shadow(1px 1px 1px hsla(0,0%,67%,.5))}.grommetux-carousel__arrow .grommetux-control-icon polyline{stroke:hsla(0,0%,100%,.7);stroke-width:1px}.grommetux-carousel__arrow:hover .grommetux-control-icon polyline{stroke:#fff}.grommetux-carousel__arrow--next{right:0}.grommetux-carousel__arrow--prev{left:0}.grommetux-carousel__controls{animation:carousel-reveal 1s;margin-left:50%;transform:translateX(-50%);position:absolute;bottom:12px;text-align:center;z-index:1}.grommetux-carousel__control{display:inline-block;width:36px;height:36px;stroke:hsla(0,0%,100%,.7);fill:transparent;cursor:pointer;filter:drop-shadow(1px 1px 1px rgba(170,170,170,.5));-webkit-filter:drop-shadow(1px 1px 1px hsla(0,0%,67%,.5))}.grommetux-carousel__control--active{stroke:#01a982;fill:#01a982}.grommetux-carousel--hide-controls .grommetux-carousel__controls,.grommetux-carousel--hide-controls .grommetux-control-icon-next,.grommetux-carousel--hide-controls .grommetux-control-icon-previous{opacity:0;animation:carousel-hide 1s}.grommetux-carousel__arrow .grommetux-control-icon,.grommetux-carousel__control,_::-webkit-:not(:root:root){-webkit-filter:none;-webkit-svg-shadow:1px 1px 1px hsla(0,0%,67%,.5)}.grommetux-layer .grommetux-carousel{width:100vw}@keyframes fade-in-chart{0%{opacity:0}to{opacity:1}}.grommetux-chart{position:relative;display:flex}.grommetux-chart .grommetux-chart{min-width:0;max-width:100%}.grommetux-chart--full{width:100%}.grommetux-chart--vertical{flex-direction:column}.grommetux-chart:not(.grommetux-chart--vertical){flex-direction:row}.grommetux-chart-base{display:flex}.grommetux-chart-base--vertical{flex-direction:column}.grommetux-chart-base:not(.grommetux-chart-base--vertical){flex-direction:row}.grommetux-chart-base:not(.grommetux-chart-base--vertical)>*{flex:0 0 auto}.grommetux-chart-base--width-small{width:192px}.grommetux-chart-base--width-medium{width:384px}.grommetux-chart-base--width-large{width:576px}@media screen and (max-width:44.9375em){.grommetux-chart-base--width-large{max-width:100%}}.grommetux-chart-base--width-full{width:100%}.grommetux-chart-base--height-xxsmall{height:48px}.grommetux-chart-base--height-xsmall{height:96px}.grommetux-chart-base--height-small{height:192px}.grommetux-chart-base--height-medium{height:384px}@media screen and (max-width:44.9375em){.grommetux-chart-base--height-medium{height:192px}}.grommetux-chart-base--height-large{height:576px}@media screen and (max-width:44.9375em){.grommetux-chart-base--height-large{height:384px}}.grommetux-chart-base--height-sparkline{height:24px;width:96px}.grommetux-chart-base--height-sparkline.grommetux-chart-base--width-xsmall{width:96px}.grommetux-chart-base--height-sparkline.grommetux-chart-base--width-small{width:192px}.grommetux-chart-base--height-sparkline.grommetux-chart-base--width-medium{width:384px}.grommetux-chart-base--height-sparkline.grommetux-chart-base--width-large{width:576px}@media screen and (max-width:44.9375em){.grommetux-chart-base--height-sparkline.grommetux-chart-base--width-large{max-width:100%}}.grommetux-chart-axis{flex:0 0 auto;display:flex;flex-direction:row}.grommetux-chart-axis__slot{flex:0 0;display:flex;flex-direction:column;-webkit-transform:translateZ(0)}.grommetux-chart-axis--ticks .grommetux-chart-axis__slot:after,.grommetux-chart-axis--ticks .grommetux-chart-axis__slot:before{background-color:rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-chart-axis--ticks .grommetux-chart-axis__slot:after,.grommetux-background-color-index--dark .grommetux-chart-axis--ticks .grommetux-chart-axis__slot:before,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-axis--ticks .grommetux-chart-axis__slot:after,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-axis--ticks .grommetux-chart-axis__slot:before{background-color:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-axis--ticks .grommetux-chart-axis__slot:after,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-axis--ticks .grommetux-chart-axis__slot:before,.grommetux-background-color-index--light .grommetux-chart-axis--ticks .grommetux-chart-axis__slot:after,.grommetux-background-color-index--light .grommetux-chart-axis--ticks .grommetux-chart-axis__slot:before{background-color:rgba(0,0,0,.15)}.grommetux-chart-axis--vertical{flex-direction:column-reverse;margin-left:12px;margin-right:12px}.grommetux-chart-axis--vertical .grommetux-chart-axis__slot{min-width:1em;justify-content:flex-start}.grommetux-chart-axis--vertical .grommetux-chart-axis__slot:first-child{flex-direction:column-reverse}.grommetux-chart-axis--vertical.grommetux-chart-axis--align-start,.grommetux-chart-axis--vertical.grommetux-chart-axis--align-start .grommetux-chart-axis__slot{align-items:flex-start}.grommetux-chart-axis--vertical.grommetux-chart-axis--align-end,.grommetux-chart-axis--vertical.grommetux-chart-axis--align-end .grommetux-chart-axis__slot{align-items:flex-end}.grommetux-chart-axis--vertical.grommetux-chart-axis--ticks .grommetux-chart-axis__slot:not(.grommetux-chart-axis__slot--placeholder):before{display:block;content:\"\";height:1px;width:6px}.grommetux-chart-axis--vertical.grommetux-chart-axis--ticks.grommetux-chart-axis--ticks--start .grommetux-chart-axis__slot{align-items:flex-start}.grommetux-chart-axis--vertical.grommetux-chart-axis--ticks.grommetux-chart-axis--ticks--end .grommetux-chart-axis__slot{align-items:flex-end}.grommetux-chart-axis--vertical.grommetux-chart-axis--reverse{flex-direction:column}.grommetux-chart-axis--vertical.grommetux-chart-axis--reverse .grommetux-chart-axis__slot{justify-content:flex-start;flex-direction:column-reverse}.grommetux-chart-axis--vertical.grommetux-chart-axis--reverse .grommetux-chart-axis__slot:first-child{flex-direction:column;justify-content:flex-start}.grommetux-chart-axis--vertical.grommetux-chart-axis--reverse .grommetux-chart-axis__slot:last-child{justify-content:flex-start}.grommetux-chart-axis--vertical.grommetux-chart-axis--reverse.grommetux-chart-axis--ticks--start .grommetux-chart-axis__slot{align-items:flex-start}.grommetux-chart-axis--vertical.grommetux-chart-axis--reverse.grommetux-chart-axis--ticks--end .grommetux-chart-axis__slot{align-items:flex-end}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical){flex-direction:row;margin-top:12px;margin-bottom:12px}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical) .grommetux-chart-axis__slot{min-height:24px;align-items:flex-start;justify-content:flex-end;flex-direction:row}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical) .grommetux-chart-axis__slot:first-child{align-items:flex-start;flex-direction:row-reverse;padding-left:0}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--align-start{align-items:flex-start}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--align-end{align-items:flex-end}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--align-end .grommetux-chart-axis__slot{justify-content:flex-end}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--ticks .grommetux-chart-axis__slot:after{display:block;content:\"\";height:6px;width:1px}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--ticks.grommetux-chart-axis--ticks--end .grommetux-chart-axis__slot:not(.grommetux-chart-axis__slot--placeholder){align-items:flex-end}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--ticks.grommetux-chart-axis--ticks--start .grommetux-chart-axis__slot:not(.grommetux-chart-axis__slot--placeholder){align-items:flex-start}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--ticks .grommetux-chart-axis__slot:not(.grommetux-chart-axis__slot--placeholder)>span{padding:0 6px}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--reverse{flex-direction:row-reverse}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--reverse .grommetux-chart-axis__slot{align-items:flex-start}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--reverse.grommetux-chart-axis--ticks .grommetux-chart-axis__slot{align-items:flex-start;justify-content:flex-end;flex-direction:row-reverse}.grommetux-chart-axis:not(.grommetux-chart-axis--vertical).grommetux-chart-axis--reverse.grommetux-chart-axis--ticks .grommetux-chart-axis__slot:first-child{flex-direction:row}.grommetux-chart-marker-label{flex:0 0 auto;display:flex;flex-direction:row}.grommetux-chart-marker-label__slot{flex:0 0;display:flex;flex-direction:column;-webkit-transform:translateZ(0)}.grommetux-chart-marker-label--vertical{flex-direction:column-reverse;margin-left:12px;margin-right:12px}.grommetux-chart-marker-label--vertical .grommetux-chart-marker-label__slot{min-width:1em;justify-content:flex-start}.grommetux-chart-marker-label--vertical .grommetux-chart-marker-label__slot.grommetux-chart-marker-label__slot--flip{justify-content:flex-end}.grommetux-chart-marker-label--vertical.grommetux-chart-marker-label--align-start,.grommetux-chart-marker-label--vertical.grommetux-chart-marker-label--align-start .grommetux-chart-marker-label__slot{align-items:flex-start}.grommetux-chart-marker-label--vertical.grommetux-chart-marker-label--align-end,.grommetux-chart-marker-label--vertical.grommetux-chart-marker-label--align-end .grommetux-chart-marker-label__slot{align-items:flex-end}.grommetux-chart-marker-label--vertical.grommetux-chart-marker-label--reverse{flex-direction:column}.grommetux-chart-marker-label--vertical.grommetux-chart-marker-label--reverse .grommetux-chart-marker-label__slot{justify-content:flex-end}.grommetux-chart-marker-label--vertical.grommetux-chart-marker-label--reverse .grommetux-chart-marker-label__slot.grommetux-chart-marker-label__slot--flip{justify-content:flex-start}.grommetux-chart-marker-label:not(.grommetux-chart-marker-label--vertical){flex-direction:row;margin-top:12px;margin-bottom:12px}.grommetux-chart-marker-label:not(.grommetux-chart-marker-label--vertical) .grommetux-chart-marker-label__slot{min-height:24px;align-items:flex-end}.grommetux-chart-marker-label:not(.grommetux-chart-marker-label--vertical).grommetux-chart-marker-label--align-start,.grommetux-chart-marker-label:not(.grommetux-chart-marker-label--vertical) .grommetux-chart-marker-label__slot.grommetux-chart-marker-label__slot--flip{align-items:flex-start}.grommetux-chart-marker-label:not(.grommetux-chart-marker-label--vertical).grommetux-chart-marker-label--align-start .grommetux-chart-marker-label__slot{justify-content:flex-start}.grommetux-chart-marker-label:not(.grommetux-chart-marker-label--vertical).grommetux-chart-marker-label--align-end{align-items:flex-end}.grommetux-chart-marker-label:not(.grommetux-chart-marker-label--vertical).grommetux-chart-marker-label--align-end .grommetux-chart-marker-label__slot{justify-content:flex-end}.grommetux-chart-layers{position:absolute;animation:fade-in-chart .5s}@keyframes stretch-up-chart{0%{max-height:0}to{max-height:100%}}@keyframes stretch-right-chart{0%{max-width:0}to{max-width:100%}}.grommetux-chart-graph--area,.grommetux-chart-graph--bar,.grommetux-chart-graph--line,.grommetux-chart-grid,.grommetux-chart-hot-spots,.grommetux-chart-loading,.grommetux-chart-marker,.grommetux-chart-range{position:absolute;left:0;width:100%;height:100%}.grommetux-chart-loading{top:0;stroke-width:24px;stroke:#ddd;stroke-dasharray:1 24px;stroke-dashoffset:0}.grommetux-chart-hot-spots{display:flex;width:100%}.grommetux-chart-hot-spots>*{flex:0 0}.grommetux-chart-hot-spots--vertical{flex-direction:column}.grommetux-chart-hot-spots:not(.grommetux-chart-hot-spots--vertical){flex-direction:row}.grommetux-chart-hot-spots--clickable{cursor:pointer}.grommetux-chart-range{display:flex;flex-direction:row}.grommetux-chart-range__active{position:relative;height:100%;flex:1 1;cursor:ew-resize}.grommetux-chart-range__after,.grommetux-chart-range__before{position:relative;flex:0 0;display:flex;flex-direction:row;align-items:center;background-color:hsla(0,0%,100%,.7);z-index:1}.grommetux-background-color-index--dark .grommetux-chart-range__after,.grommetux-background-color-index--dark .grommetux-chart-range__before,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-range__after,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-range__before{background-color:rgba(0,0,0,.4)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-range__after,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-range__before,.grommetux-background-color-index--light .grommetux-chart-range__after,.grommetux-background-color-index--light .grommetux-chart-range__before{background-color:hsla(0,0%,100%,.7)}.grommetux-chart-range__before{justify-content:flex-end;border-color:rgba(0,0,0,.15);border-width:1px;border-style:none solid none none}.grommetux-chart-range__before--end{z-index:2}.grommetux-chart-range__after{justify-content:flex-start;border-color:rgba(0,0,0,.15);border-width:1px;border-style:none none none solid}.grommetux-chart-range__end,.grommetux-chart-range__start{position:absolute;top:50%;transform:translateY(-50%);flex:0 1 24px;background-color:hsla(0,0%,100%,.7);border:1px solid rgba(0,0,0,.15);padding:6px 0;height:36px;cursor:col-resize;outline:none}.grommetux-background-color-index--dark .grommetux-chart-range__end,.grommetux-background-color-index--dark .grommetux-chart-range__start,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-range__end,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-range__start{background-color:rgba(0,0,0,.5);border-color:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-range__end,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-range__start,.grommetux-background-color-index--light .grommetux-chart-range__end,.grommetux-background-color-index--light .grommetux-chart-range__start{background-color:hsla(0,0%,100%,.7);border-color:rgba(0,0,0,.15)}.grommetux-chart-range__end:hover,.grommetux-chart-range__start:hover{background-color:#fff;border-color:#000}.grommetux-background-color-index--dark .grommetux-chart-range__end:hover,.grommetux-background-color-index--dark .grommetux-chart-range__start:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-range__end:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-range__start:hover{background-color:rgba(0,0,0,.5);border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-range__end:hover,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-range__start:hover,.grommetux-background-color-index--light .grommetux-chart-range__end:hover,.grommetux-background-color-index--light .grommetux-chart-range__start:hover{background-color:#fff;border-color:#000}.grommetux-chart-range__end svg,.grommetux-chart-range__start svg{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.grommetux-chart-range__start{right:-1px}.grommetux-chart-range__start--edge{right:-26px}.grommetux-chart-range__end{left:-1px}.grommetux-chart-range__end--edge{left:-26px}.grommetux-chart-range__end--focus,.grommetux-chart-range__start--focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-chart-range--vertical{flex-direction:column}.grommetux-chart-range--vertical .grommetux-chart-range__active{width:100%;cursor:ns-resize}.grommetux-chart-range--vertical .grommetux-chart-range__after,.grommetux-chart-range--vertical .grommetux-chart-range__before{flex-direction:column}.grommetux-chart-range--vertical .grommetux-chart-range__before{border-style:none none solid}.grommetux-chart-range--vertical .grommetux-chart-range__after{border-style:solid none none}.grommetux-chart-range--vertical .grommetux-chart-range__end,.grommetux-chart-range--vertical .grommetux-chart-range__start{top:auto;transform:none;padding:0 6px;height:26px;cursor:row-resize}.grommetux-chart-range--vertical .grommetux-chart-range__start{right:auto;bottom:-1px}.grommetux-chart-range--vertical .grommetux-chart-range__start--edge{bottom:-26px}.grommetux-chart-range--vertical .grommetux-chart-range__end{left:auto;top:-1px}.grommetux-chart-range--vertical .grommetux-chart-range__end--edge{top:-26px}.grommetux-chart-range--vertical svg{transform:rotate(90deg)}.grommetux-chart-grid path{stroke:rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-chart-grid path,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-grid path{stroke:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-grid path,.grommetux-background-color-index--light .grommetux-chart-grid path{stroke:rgba(0,0,0,.15)}.grommetux-chart-marker{stroke:rgba(0,0,0,.15);animation:fade-in-chart 1s}.grommetux-chart-marker.grommetux-color-index-unset{stroke:hsla(0,0%,87%,.7)}.grommetux-chart-marker.grommetux-color-index-brand{stroke:rgba(1,169,130,.7)}.grommetux-chart-marker.grommetux-color-index-critical,.grommetux-chart-marker.grommetux-color-index-error{stroke:rgba(240,73,83,.7)}.grommetux-chart-marker.grommetux-color-index-warning{stroke:rgba(255,209,68,.7)}.grommetux-chart-marker.grommetux-color-index-ok{stroke:rgba(1,169,130,.7)}.grommetux-chart-marker.grommetux-color-index-disabled,.grommetux-chart-marker.grommetux-color-index-unknown{stroke:hsla(0,0%,80%,.7)}.grommetux-chart-marker.grommetux-color-index-graph-1,.grommetux-chart-marker.grommetux-color-index-graph-5{stroke:rgba(66,85,99,.7)}.grommetux-chart-marker.grommetux-color-index-graph-2,.grommetux-chart-marker.grommetux-color-index-graph-6{stroke:rgba(95,122,118,.7)}.grommetux-chart-marker.grommetux-color-index-graph-3,.grommetux-chart-marker.grommetux-color-index-graph-7{stroke:hsla(20,8%,47%,.7)}.grommetux-chart-marker.grommetux-color-index-graph-4,.grommetux-chart-marker.grommetux-color-index-graph-8{stroke:hsla(0,0%,46%,.7)}.grommetux-chart-marker.grommetux-color-index-accent-1,.grommetux-chart-marker.grommetux-color-index-accent-4{stroke:rgba(42,210,201,.7)}.grommetux-chart-marker.grommetux-color-index-accent-2,.grommetux-chart-marker.grommetux-color-index-accent-5{stroke:rgba(97,71,103,.7)}.grommetux-chart-marker.grommetux-color-index-accent-3,.grommetux-chart-marker.grommetux-color-index-accent-6{stroke:rgba(255,141,109,.7)}.grommetux-chart-marker.color-index-grey-1,.grommetux-chart-marker.color-index-grey-6{stroke:rgba(0,0,1,.7)}.grommetux-chart-marker.color-index-grey-2,.grommetux-chart-marker.color-index-grey-7{stroke:rgba(51,51,51,.7)}.grommetux-chart-marker.color-index-grey-3,.grommetux-chart-marker.color-index-grey-8{stroke:rgba(59,59,59,.7)}.grommetux-chart-marker.color-index-grey-4,.grommetux-chart-marker.color-index-grey-9{stroke:rgba(67,67,67,.7)}.grommetux-chart-marker.color-index-grey-5,.grommetux-chart-marker.color-index-grey-10{stroke:hsla(0,0%,40%,.7)}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-loading,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-unset,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-unset{stroke:#ddd}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-brand,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-brand{stroke:#01a982}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-critical,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-error,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-critical,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-error{stroke:#f04953}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-warning,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-warning{stroke:#ffd144}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-ok,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-ok{stroke:#01a982}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-disabled,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-unknown,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-disabled,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-unknown{stroke:#ccc}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-1,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-5,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-1,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-5{stroke:#425563}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-2,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-6,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-2,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-3,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-7,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-3,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-4,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-8,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-4,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-graph-8{stroke:#767676}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-1,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-6,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-1,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-6{stroke:#000001}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-2,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-7,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-2,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-7{stroke:#333}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-3,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-8,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-3,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-4,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-9,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-4,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-9{stroke:#434343}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-5,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-10,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-5,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-grey-10{stroke:#666}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-1,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-4,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-1,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-2,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-5,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-2,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-5{stroke:#614767}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-3,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-6,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-3,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-1,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-5,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-1,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-2,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-6,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-2,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-3,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-7,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-3,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-4,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-8,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-4,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-light-1,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-light-3,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-light-1,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-light-3{stroke:#fff}.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-light-2,.grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-light-4,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-light-2,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-marker.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-unset,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-unset{stroke:hsla(0,0%,87%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-brand,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-brand{stroke:rgba(1,169,130,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-critical,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-error,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-critical,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-error{stroke:rgba(240,73,83,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-warning,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-warning{stroke:rgba(255,209,68,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-ok,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-ok{stroke:rgba(1,169,130,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-disabled,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-unknown,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-disabled,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-unknown{stroke:hsla(0,0%,80%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-1,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-5,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-1,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-5{stroke:rgba(66,85,99,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-2,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-6,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-2,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-6{stroke:rgba(95,122,118,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-3,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-7,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-3,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-7{stroke:hsla(20,8%,47%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-4,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-8,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-4,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-graph-8{stroke:hsla(0,0%,46%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-1,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-4,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-1,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-4{stroke:rgba(42,210,201,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-2,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-5,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-2,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-5{stroke:rgba(97,71,103,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-3,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-6,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-3,.grommetux-background-color-index--light .grommetux-chart-marker.grommetux-color-index-accent-6{stroke:rgba(255,141,109,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-1,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-6,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-1,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-6{stroke:rgba(0,0,1,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-2,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-7,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-2,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-7{stroke:rgba(51,51,51,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-3,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-8,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-3,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-8{stroke:rgba(59,59,59,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-4,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-9,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-4,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-9{stroke:rgba(67,67,67,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-5,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-10,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-5,.grommetux-background-color-index--light .grommetux-chart-marker.color-index-grey-10{stroke:hsla(0,0%,40%,.7)}.grommetux-chart-graph--line{stroke-width:3px}.grommetux-chart-graph--line.grommetux-color-index-unset{stroke:hsla(0,0%,87%,.7)}.grommetux-chart-graph--line.grommetux-color-index-brand{stroke:rgba(1,169,130,.7)}.grommetux-chart-graph--line.grommetux-color-index-critical,.grommetux-chart-graph--line.grommetux-color-index-error{stroke:rgba(240,73,83,.7)}.grommetux-chart-graph--line.grommetux-color-index-warning{stroke:rgba(255,209,68,.7)}.grommetux-chart-graph--line.grommetux-color-index-ok{stroke:rgba(1,169,130,.7)}.grommetux-chart-graph--line.grommetux-color-index-disabled,.grommetux-chart-graph--line.grommetux-color-index-unknown{stroke:hsla(0,0%,80%,.7)}.grommetux-chart-graph--line.grommetux-color-index-graph-1,.grommetux-chart-graph--line.grommetux-color-index-graph-5{stroke:rgba(66,85,99,.7)}.grommetux-chart-graph--line.grommetux-color-index-graph-2,.grommetux-chart-graph--line.grommetux-color-index-graph-6{stroke:rgba(95,122,118,.7)}.grommetux-chart-graph--line.grommetux-color-index-graph-3,.grommetux-chart-graph--line.grommetux-color-index-graph-7{stroke:hsla(20,8%,47%,.7)}.grommetux-chart-graph--line.grommetux-color-index-graph-4,.grommetux-chart-graph--line.grommetux-color-index-graph-8{stroke:hsla(0,0%,46%,.7)}.grommetux-chart-graph--line.grommetux-color-index-accent-1,.grommetux-chart-graph--line.grommetux-color-index-accent-4{stroke:rgba(42,210,201,.7)}.grommetux-chart-graph--line.grommetux-color-index-accent-2,.grommetux-chart-graph--line.grommetux-color-index-accent-5{stroke:rgba(97,71,103,.7)}.grommetux-chart-graph--line.grommetux-color-index-accent-3,.grommetux-chart-graph--line.grommetux-color-index-accent-6{stroke:rgba(255,141,109,.7)}.grommetux-chart-graph--line.color-index-grey-1,.grommetux-chart-graph--line.color-index-grey-6{stroke:rgba(0,0,1,.7)}.grommetux-chart-graph--line.color-index-grey-2,.grommetux-chart-graph--line.color-index-grey-7{stroke:rgba(51,51,51,.7)}.grommetux-chart-graph--line.color-index-grey-3,.grommetux-chart-graph--line.color-index-grey-8{stroke:rgba(59,59,59,.7)}.grommetux-chart-graph--line.color-index-grey-4,.grommetux-chart-graph--line.color-index-grey-9{stroke:rgba(67,67,67,.7)}.grommetux-chart-graph--line.color-index-grey-5,.grommetux-chart-graph--line.color-index-grey-10{stroke:hsla(0,0%,40%,.7)}.grommetux-chart-graph--bar{stroke-width:4px}.grommetux-chart-graph--bar.grommetux-color-index-unset{stroke:hsla(0,0%,87%,.7)}.grommetux-chart-graph--bar.grommetux-color-index-brand{stroke:rgba(1,169,130,.7)}.grommetux-chart-graph--bar.grommetux-color-index-critical,.grommetux-chart-graph--bar.grommetux-color-index-error{stroke:rgba(240,73,83,.7)}.grommetux-chart-graph--bar.grommetux-color-index-warning{stroke:rgba(255,209,68,.7)}.grommetux-chart-graph--bar.grommetux-color-index-ok{stroke:rgba(1,169,130,.7)}.grommetux-chart-graph--bar.grommetux-color-index-disabled,.grommetux-chart-graph--bar.grommetux-color-index-unknown{stroke:hsla(0,0%,80%,.7)}.grommetux-chart-graph--bar.grommetux-color-index-graph-1,.grommetux-chart-graph--bar.grommetux-color-index-graph-5{stroke:rgba(66,85,99,.7)}.grommetux-chart-graph--bar.grommetux-color-index-graph-2,.grommetux-chart-graph--bar.grommetux-color-index-graph-6{stroke:rgba(95,122,118,.7)}.grommetux-chart-graph--bar.grommetux-color-index-graph-3,.grommetux-chart-graph--bar.grommetux-color-index-graph-7{stroke:hsla(20,8%,47%,.7)}.grommetux-chart-graph--bar.grommetux-color-index-graph-4,.grommetux-chart-graph--bar.grommetux-color-index-graph-8{stroke:hsla(0,0%,46%,.7)}.grommetux-chart-graph--bar.grommetux-color-index-accent-1,.grommetux-chart-graph--bar.grommetux-color-index-accent-4{stroke:rgba(42,210,201,.7)}.grommetux-chart-graph--bar.grommetux-color-index-accent-2,.grommetux-chart-graph--bar.grommetux-color-index-accent-5{stroke:rgba(97,71,103,.7)}.grommetux-chart-graph--bar.grommetux-color-index-accent-3,.grommetux-chart-graph--bar.grommetux-color-index-accent-6{stroke:rgba(255,141,109,.7)}.grommetux-chart-graph--bar.color-index-grey-1,.grommetux-chart-graph--bar.color-index-grey-6{stroke:rgba(0,0,1,.7)}.grommetux-chart-graph--bar.color-index-grey-2,.grommetux-chart-graph--bar.color-index-grey-7{stroke:rgba(51,51,51,.7)}.grommetux-chart-graph--bar.color-index-grey-3,.grommetux-chart-graph--bar.color-index-grey-8{stroke:rgba(59,59,59,.7)}.grommetux-chart-graph--bar.color-index-grey-4,.grommetux-chart-graph--bar.color-index-grey-9{stroke:rgba(67,67,67,.7)}.grommetux-chart-graph--bar.color-index-grey-5,.grommetux-chart-graph--bar.color-index-grey-10{stroke:hsla(0,0%,40%,.7)}.grommetux-chart-graph--bar.grommetux-chart-graph--vertical{animation:stretch-right-chart 1.5s}.grommetux-chart-graph--bar:not(.grommetux-chart-graph--vertical){bottom:0;animation:stretch-up-chart 1.5s}.grommetux-chart-graph--area{stroke-width:3px}.grommetux-chart-graph--area.grommetux-color-index-unset{fill:hsla(0,0%,87%,.7)}.grommetux-chart-graph--area.grommetux-color-index-brand{fill:rgba(1,169,130,.7)}.grommetux-chart-graph--area.grommetux-color-index-critical,.grommetux-chart-graph--area.grommetux-color-index-error{fill:rgba(240,73,83,.7)}.grommetux-chart-graph--area.grommetux-color-index-warning{fill:rgba(255,209,68,.7)}.grommetux-chart-graph--area.grommetux-color-index-ok{fill:rgba(1,169,130,.7)}.grommetux-chart-graph--area.grommetux-color-index-disabled,.grommetux-chart-graph--area.grommetux-color-index-unknown{fill:hsla(0,0%,80%,.7)}.grommetux-chart-graph--area.grommetux-color-index-graph-1,.grommetux-chart-graph--area.grommetux-color-index-graph-5{fill:rgba(66,85,99,.7)}.grommetux-chart-graph--area.grommetux-color-index-graph-2,.grommetux-chart-graph--area.grommetux-color-index-graph-6{fill:rgba(95,122,118,.7)}.grommetux-chart-graph--area.grommetux-color-index-graph-3,.grommetux-chart-graph--area.grommetux-color-index-graph-7{fill:hsla(20,8%,47%,.7)}.grommetux-chart-graph--area.grommetux-color-index-graph-4,.grommetux-chart-graph--area.grommetux-color-index-graph-8{fill:hsla(0,0%,46%,.7)}.grommetux-chart-graph--area.grommetux-color-index-accent-1,.grommetux-chart-graph--area.grommetux-color-index-accent-4{fill:rgba(42,210,201,.7)}.grommetux-chart-graph--area.grommetux-color-index-accent-2,.grommetux-chart-graph--area.grommetux-color-index-accent-5{fill:rgba(97,71,103,.7)}.grommetux-chart-graph--area.grommetux-color-index-accent-3,.grommetux-chart-graph--area.grommetux-color-index-accent-6{fill:rgba(255,141,109,.7)}.grommetux-chart-graph--area.color-index-grey-1,.grommetux-chart-graph--area.color-index-grey-6{fill:rgba(0,0,1,.7)}.grommetux-chart-graph--area.color-index-grey-2,.grommetux-chart-graph--area.color-index-grey-7{fill:rgba(51,51,51,.7)}.grommetux-chart-graph--area.color-index-grey-3,.grommetux-chart-graph--area.color-index-grey-8{fill:rgba(59,59,59,.7)}.grommetux-chart-graph--area.color-index-grey-4,.grommetux-chart-graph--area.color-index-grey-9{fill:rgba(67,67,67,.7)}.grommetux-chart-graph--area.color-index-grey-5,.grommetux-chart-graph--area.color-index-grey-10{fill:hsla(0,0%,40%,.7)}.grommetux-chart-graph--area.grommetux-chart-graph--vertical{animation:stretch-right-chart 1.5s}.grommetux-chart-graph--area:not(.grommetux-chart-graph--vertical){bottom:0;animation:stretch-up-chart 1.5s}.grommetux-chart-graph--area .grommetux-chart-graph__point{stroke:#fff}.grommetux-chart-graph__point{stroke:none;transition:r .3s;animation:fade-in-chart .3s}.grommetux-chart-graph__point.grommetux-color-index-unset{fill:hsla(0,0%,87%,.9)}.grommetux-chart-graph__point.grommetux-color-index-brand{fill:rgba(1,169,130,.9)}.grommetux-chart-graph__point.grommetux-color-index-critical,.grommetux-chart-graph__point.grommetux-color-index-error{fill:rgba(240,73,83,.9)}.grommetux-chart-graph__point.grommetux-color-index-warning{fill:rgba(255,209,68,.9)}.grommetux-chart-graph__point.grommetux-color-index-ok{fill:rgba(1,169,130,.9)}.grommetux-chart-graph__point.grommetux-color-index-disabled,.grommetux-chart-graph__point.grommetux-color-index-unknown{fill:hsla(0,0%,80%,.9)}.grommetux-chart-graph__point.grommetux-color-index-graph-1,.grommetux-chart-graph__point.grommetux-color-index-graph-5{fill:rgba(66,85,99,.9)}.grommetux-chart-graph__point.grommetux-color-index-graph-2,.grommetux-chart-graph__point.grommetux-color-index-graph-6{fill:rgba(95,122,118,.9)}.grommetux-chart-graph__point.grommetux-color-index-graph-3,.grommetux-chart-graph__point.grommetux-color-index-graph-7{fill:hsla(20,8%,47%,.9)}.grommetux-chart-graph__point.grommetux-color-index-graph-4,.grommetux-chart-graph__point.grommetux-color-index-graph-8{fill:hsla(0,0%,46%,.9)}.grommetux-chart-graph__point.grommetux-color-index-accent-1,.grommetux-chart-graph__point.grommetux-color-index-accent-4{fill:rgba(42,210,201,.9)}.grommetux-chart-graph__point.grommetux-color-index-accent-2,.grommetux-chart-graph__point.grommetux-color-index-accent-5{fill:rgba(97,71,103,.9)}.grommetux-chart-graph__point.grommetux-color-index-accent-3,.grommetux-chart-graph__point.grommetux-color-index-accent-6{fill:rgba(255,141,109,.9)}.grommetux-chart-graph__point.color-index-grey-1,.grommetux-chart-graph__point.color-index-grey-6{fill:rgba(0,0,1,.9)}.grommetux-chart-graph__point.color-index-grey-2,.grommetux-chart-graph__point.color-index-grey-7{fill:rgba(51,51,51,.9)}.grommetux-chart-graph__point.color-index-grey-3,.grommetux-chart-graph__point.color-index-grey-8{fill:rgba(59,59,59,.9)}.grommetux-chart-graph__point.color-index-grey-4,.grommetux-chart-graph__point.color-index-grey-9{fill:rgba(67,67,67,.9)}.grommetux-chart-graph__point.color-index-grey-5,.grommetux-chart-graph__point.color-index-grey-10{fill:hsla(0,0%,40%,.9)}.grommetux-chart-graph__point--active{stroke:#fff}.grommetux-chart-graph__point--active.grommetux-color-index-unset{fill:#ddd}.grommetux-chart-graph__point--active.grommetux-color-index-brand{fill:#01a982}.grommetux-chart-graph__point--active.grommetux-color-index-critical,.grommetux-chart-graph__point--active.grommetux-color-index-error{fill:#f04953}.grommetux-chart-graph__point--active.grommetux-color-index-warning{fill:#ffd144}.grommetux-chart-graph__point--active.grommetux-color-index-ok{fill:#01a982}.grommetux-chart-graph__point--active.grommetux-color-index-disabled,.grommetux-chart-graph__point--active.grommetux-color-index-unknown{fill:#ccc}.grommetux-chart-graph__point--active.grommetux-color-index-graph-1,.grommetux-chart-graph__point--active.grommetux-color-index-graph-5{fill:#425563}.grommetux-chart-graph__point--active.grommetux-color-index-graph-2,.grommetux-chart-graph__point--active.grommetux-color-index-graph-6{fill:#5f7a76}.grommetux-chart-graph__point--active.grommetux-color-index-graph-3,.grommetux-chart-graph__point--active.grommetux-color-index-graph-7{fill:#80746e}.grommetux-chart-graph__point--active.grommetux-color-index-graph-4,.grommetux-chart-graph__point--active.grommetux-color-index-graph-8{fill:#767676}.grommetux-chart-graph__point--active.grommetux-color-index-accent-1,.grommetux-chart-graph__point--active.grommetux-color-index-accent-4{fill:#2ad2c9}.grommetux-chart-graph__point--active.grommetux-color-index-accent-2,.grommetux-chart-graph__point--active.grommetux-color-index-accent-5{fill:#614767}.grommetux-chart-graph__point--active.grommetux-color-index-accent-3,.grommetux-chart-graph__point--active.grommetux-color-index-accent-6{fill:#ff8d6d}.grommetux-chart-graph__point--active.grommetux-color-index-grey-1,.grommetux-chart-graph__point--active.grommetux-color-index-grey-6{fill:#000001}.grommetux-chart-graph__point--active.grommetux-color-index-grey-2,.grommetux-chart-graph__point--active.grommetux-color-index-grey-7{fill:#333}.grommetux-chart-graph__point--active.grommetux-color-index-grey-3,.grommetux-chart-graph__point--active.grommetux-color-index-grey-8{fill:#3b3b3b}.grommetux-chart-graph__point--active.grommetux-color-index-grey-4,.grommetux-chart-graph__point--active.grommetux-color-index-grey-9{fill:#434343}.grommetux-chart-graph__point--active.grommetux-color-index-grey-5,.grommetux-chart-graph__point--active.grommetux-color-index-grey-10{fill:#666}.grommetux-background-color-index--dark .grommetux-chart-graph__point--active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-chart-graph__point--active{stroke:rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-chart-graph__point--active,.grommetux-background-color-index--light .grommetux-chart-graph__point--active{stroke:#fff}.grommetux-check-box{margin-right:12px;white-space:nowrap}html.rtl .grommetux-check-box{margin-right:24px;margin-left:12px}.grommetux-check-box:not(.grommetux-check-box--disabled){cursor:pointer}.grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control{border-color:#000}.grommetux-background-color-index--dark .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control{border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control,.grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control{border-color:#000}.grommetux-background-color-index--dark .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control{border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control{border-color:#000}.grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__label{color:#000}.grommetux-background-color-index--dark .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__label,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__label{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__label,.grommetux-background-color-index--light .grommetux-check-box:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__label{color:#000}.grommetux-check-box__input{opacity:0;width:0;height:0}.grommetux-check-box__input:checked+.grommetux-check-box__control{border-color:#01a982}.grommetux-background-color-index--dark .grommetux-check-box__input:checked+.grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box__input:checked+.grommetux-check-box__control{border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box__input:checked+.grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-check-box__input:checked+.grommetux-check-box__control{border-color:#01a982}.grommetux-check-box__input:checked+.grommetux-check-box__control .grommetux-check-box__control-check{display:block}.grommetux-check-box__input:checked+.grommetux-check-box__control+.grommetux-check-box__label{color:#333}.grommetux-background-color-index--dark .grommetux-check-box__input:checked+.grommetux-check-box__control+.grommetux-check-box__label,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box__input:checked+.grommetux-check-box__control+.grommetux-check-box__label{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box__input:checked+.grommetux-check-box__control+.grommetux-check-box__label,.grommetux-background-color-index--light .grommetux-check-box__input:checked+.grommetux-check-box__control+.grommetux-check-box__label{color:#333}.grommetux-check-box__input:focus+.grommetux-check-box__control{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-check-box__control{position:relative;top:-1px;display:inline-block;width:24px;height:24px;margin-right:12px;vertical-align:middle;background-color:inherit;border:2px solid #666;border-radius:0}html.rtl .grommetux-check-box__control{margin-right:0;margin-left:12px}.grommetux-background-color-index--dark .grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box__control{border-color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-check-box__control{border-color:#666}.grommetux-check-box__control-check{position:absolute;top:-2px;left:-2px;display:none;width:24px;height:24px;stroke-width:4px;stroke:#01a982}.grommetux-background-color-index--dark .grommetux-check-box__control-check,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box__control-check{stroke:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box__control-check,.grommetux-background-color-index--light .grommetux-check-box__control-check{stroke:#01a982}.grommetux-check-box__label{display:inline-block;vertical-align:middle;color:#666;white-space:normal;margin-right:24px;word-break:break-word}.grommetux-background-color-index--dark .grommetux-check-box__label,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box__label{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box__label,.grommetux-background-color-index--light .grommetux-check-box__label{color:#666}.grommetux-check-box--disabled .grommetux-check-box__control{opacity:.5}.grommetux-check-box--reverse .grommetux-check-box__control{margin-right:0;margin-left:12px}html.rtl .grommetux-check-box--reverse .grommetux-check-box__control{margin-left:0;margin-right:12px}.grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control:after{content:\"\";border-color:#000}.grommetux-background-color-index--dark .grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control:after,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control:after{background-color:#fff;border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control:after,.grommetux-background-color-index--light .grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__control:after{background-color:none;border-color:#000}.grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control:after{content:\"\";border-color:#000}.grommetux-background-color-index--dark .grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control:after,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control:after{background-color:#fff;border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control:after,.grommetux-background-color-index--light .grommetux-check-box--toggle:hover:not(.grommetux-check-box--disabled) .grommetux-check-box__input:checked+.grommetux-check-box__control:after{background-color:none;border-color:#000}.grommetux-check-box--toggle .grommetux-check-box__control{width:48px;height:24px;border-radius:24px;background-color:rgba(51,51,51,.2);border:none;transition:background-color .3s}.grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__control{background-color:hsla(0,0%,100%,.2)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box--toggle .grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-check-box--toggle .grommetux-check-box__control{background-color:rgba(51,51,51,.2)}.grommetux-check-box--toggle .grommetux-check-box__control:after{content:\"\";display:block;position:absolute;top:-2px;left:0;width:28px;height:28px;background-color:#fff;border:2px solid #666;border-radius:24px;transition:margin-left .3s;box-sizing:border-box}.grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__control:after,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__control:after{background-color:#fff;border-color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box--toggle .grommetux-check-box__control:after,.grommetux-background-color-index--light .grommetux-check-box--toggle .grommetux-check-box__control:after{border-color:#666}.grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control{background-color:#01a982}.grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control{background-color:hsla(0,0%,100%,.2)}.grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control .grommetux-check-box__control-check,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control .grommetux-check-box__control-check{stroke:transparent}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control,.grommetux-background-color-index--light .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control{background-color:#01a982}.grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control:after{content:\"\";background-color:#fff;border-color:#01a982;margin-left:24px}.grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control:after,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control:after{background-color:#fff;border-color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control:after,.grommetux-background-color-index--light .grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control:after{border-color:#01a982}.grommetux-check-box--toggle .grommetux-check-box__input:checked+.grommetux-check-box__control .grommetux-check-box__control-check{display:none}.grommetux-collapsible{overflow:hidden}.grommetux-collapsible__wrapper{width:100%}.grommetux-collapsible.animate{transition:height .5s ease-out}.grommetux-background-color-index--pending{color:transparent}.grommetux-background-color-index--dark,.grommetux-background-color-index--light .grommetux-background-color-index--dark{color:#fff}.grommetux-background-color-index--dark input::-webkit-input-placeholder,.grommetux-background-color-index--light .grommetux-background-color-index--dark input::-webkit-input-placeholder{color:#fff}.grommetux-background-color-index--dark input::-moz-placeholder,.grommetux-background-color-index--light .grommetux-background-color-index--dark input::-moz-placeholder{color:#fff}.grommetux-background-color-index--dark input:-ms-input-placeholder,.grommetux-background-color-index--light .grommetux-background-color-index--dark input:-ms-input-placeholder{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light,.grommetux-background-color-index--light{color:#333}.grommetux-background-color-index--dark .grommetux-background-color-index--light input::-webkit-input-placeholder,.grommetux-background-color-index--light input::-webkit-input-placeholder{color:#333}.grommetux-background-color-index--dark .grommetux-background-color-index--light input::-moz-placeholder,.grommetux-background-color-index--light input::-moz-placeholder{color:#333}.grommetux-background-color-index--dark .grommetux-background-color-index--light input:-ms-input-placeholder,.grommetux-background-color-index--light input:-ms-input-placeholder{color:#333}.grommetux-background-color-index-brand{background-color:#01a982}.grommetux-background-color-index-brand-a{background-color:rgba(1,169,130,.94)}.grommetux-border-color-index-brand{border-color:#01a982}.grommetux-border-color-index-brand-a{border-color:rgba(1,169,130,.94)}.grommetux-background-color-index-neutral-1,.grommetux-background-color-index-neutral-5{background-color:#425563}.grommetux-background-color-index-neutral-1-t,.grommetux-background-color-index-neutral-5-t{background-color:#4b5e6b}.grommetux-background-color-index-neutral-1-a,.grommetux-background-color-index-neutral-5-a{background-color:rgba(66,85,99,.8)}.grommetux-border-color-index-neutral-1,.grommetux-border-color-index-neutral-5{border-color:#425563}.grommetux-border-color-index-neutral-1-t,.grommetux-border-color-index-neutral-5-t{border-color:#4b5e6b}.grommetux-color-index-neutral-1,.grommetux-color-index-neutral-5{color:#425563}.grommetux-color-index-neutral-1-t,.grommetux-color-index-neutral-5-t{color:#4b5e6b}.grommetux-background-hover-color-index-neutral-1:hover,.grommetux-background-hover-color-index-neutral-5:hover{background-color:rgba(66,85,99,.3)}.grommetux-border-small-hover-color-index-neutral-1:hover,.grommetux-border-small-hover-color-index-neutral-5:hover{box-shadow:0 0 0 1px #425563}.grommetux-border-medium-hover-color-index-neutral-1:hover,.grommetux-border-medium-hover-color-index-neutral-5:hover{box-shadow:0 0 0 12px #425563}.grommetux-border-large-hover-color-index-neutral-1:hover,.grommetux-border-large-hover-color-index-neutral-5:hover{box-shadow:0 0 0 24px #425563}.grommetux-background-color-index-neutral-2,.grommetux-background-color-index-neutral-6{background-color:#5f7a76}.grommetux-background-color-index-neutral-2-t,.grommetux-background-color-index-neutral-6-t{background-color:#67817d}.grommetux-background-color-index-neutral-2-a,.grommetux-background-color-index-neutral-6-a{background-color:rgba(95,122,118,.8)}.grommetux-border-color-index-neutral-2,.grommetux-border-color-index-neutral-6{border-color:#5f7a76}.grommetux-border-color-index-neutral-2-t,.grommetux-border-color-index-neutral-6-t{border-color:#67817d}.grommetux-color-index-neutral-2,.grommetux-color-index-neutral-6{color:#5f7a76}.grommetux-color-index-neutral-2-t,.grommetux-color-index-neutral-6-t{color:#67817d}.grommetux-background-hover-color-index-neutral-2:hover,.grommetux-background-hover-color-index-neutral-6:hover{background-color:rgba(95,122,118,.3)}.grommetux-border-small-hover-color-index-neutral-2:hover,.grommetux-border-small-hover-color-index-neutral-6:hover{box-shadow:0 0 0 1px #5f7a76}.grommetux-border-medium-hover-color-index-neutral-2:hover,.grommetux-border-medium-hover-color-index-neutral-6:hover{box-shadow:0 0 0 12px #5f7a76}.grommetux-border-large-hover-color-index-neutral-2:hover,.grommetux-border-large-hover-color-index-neutral-6:hover{box-shadow:0 0 0 24px #5f7a76}.grommetux-background-color-index-neutral-3,.grommetux-background-color-index-neutral-7{background-color:#80746e}.grommetux-background-color-index-neutral-3-t,.grommetux-background-color-index-neutral-7-t{background-color:#867b75}.grommetux-background-color-index-neutral-3-a,.grommetux-background-color-index-neutral-7-a{background-color:hsla(20,8%,47%,.8)}.grommetux-border-color-index-neutral-3,.grommetux-border-color-index-neutral-7{border-color:#80746e}.grommetux-border-color-index-neutral-3-t,.grommetux-border-color-index-neutral-7-t{border-color:#867b75}.grommetux-color-index-neutral-3,.grommetux-color-index-neutral-7{color:#80746e}.grommetux-color-index-neutral-3-t,.grommetux-color-index-neutral-7-t{color:#867b75}.grommetux-background-hover-color-index-neutral-3:hover,.grommetux-background-hover-color-index-neutral-7:hover{background-color:hsla(20,8%,47%,.3)}.grommetux-border-small-hover-color-index-neutral-3:hover,.grommetux-border-small-hover-color-index-neutral-7:hover{box-shadow:0 0 0 1px #80746e}.grommetux-border-medium-hover-color-index-neutral-3:hover,.grommetux-border-medium-hover-color-index-neutral-7:hover{box-shadow:0 0 0 12px #80746e}.grommetux-border-large-hover-color-index-neutral-3:hover,.grommetux-border-large-hover-color-index-neutral-7:hover{box-shadow:0 0 0 24px #80746e}.grommetux-background-color-index-neutral-4,.grommetux-background-color-index-neutral-8{background-color:#767676}.grommetux-background-color-index-neutral-4-t,.grommetux-background-color-index-neutral-8-t{background-color:#7d7d7d}.grommetux-background-color-index-neutral-4-a,.grommetux-background-color-index-neutral-8-a{background-color:hsla(0,0%,46%,.8)}.grommetux-border-color-index-neutral-4,.grommetux-border-color-index-neutral-8{border-color:#767676}.grommetux-border-color-index-neutral-4-t,.grommetux-border-color-index-neutral-8-t{border-color:#7d7d7d}.grommetux-color-index-neutral-4,.grommetux-color-index-neutral-8{color:#767676}.grommetux-color-index-neutral-4-t,.grommetux-color-index-neutral-8-t{color:#7d7d7d}.grommetux-background-hover-color-index-neutral-4:hover,.grommetux-background-hover-color-index-neutral-8:hover{background-color:hsla(0,0%,46%,.3)}.grommetux-border-small-hover-color-index-neutral-4:hover,.grommetux-border-small-hover-color-index-neutral-8:hover{box-shadow:0 0 0 1px #767676}.grommetux-border-medium-hover-color-index-neutral-4:hover,.grommetux-border-medium-hover-color-index-neutral-8:hover{box-shadow:0 0 0 12px #767676}.grommetux-border-large-hover-color-index-neutral-4:hover,.grommetux-border-large-hover-color-index-neutral-8:hover{box-shadow:0 0 0 24px #767676}.grommetux-background-color-index-accent-1,.grommetux-background-color-index-accent-4{background-color:#2ad2c9}.grommetux-background-color-index-accent-1-t,.grommetux-background-color-index-accent-4-t{background-color:#35d4cc}.grommetux-background-color-index-accent-1-a,.grommetux-background-color-index-accent-4-a{background-color:rgba(42,210,201,.8)}.grommetux-border-color-index-accent-1,.grommetux-border-color-index-accent-4{border-color:#2ad2c9}.grommetux-border-color-index-accent-1-t,.grommetux-border-color-index-accent-4-t{border-color:#35d4cc}.grommetux-color-index-accent-1,.grommetux-color-index-accent-4{color:#2ad2c9}.grommetux-color-index-accent-1-t,.grommetux-color-index-accent-4-t{color:#35d4cc}.grommetux-background-hover-color-index-accent-1:hover,.grommetux-background-hover-color-index-accent-4:hover{background-color:rgba(42,210,201,.3)}.grommetux-border-small-hover-color-index-accent-1:hover,.grommetux-border-small-hover-color-index-accent-4:hover{box-shadow:0 0 0 1px #2ad2c9}.grommetux-border-medium-hover-color-index-accent-1:hover,.grommetux-border-medium-hover-color-index-accent-4:hover{box-shadow:0 0 0 12px #2ad2c9}.grommetux-border-large-hover-color-index-accent-1:hover,.grommetux-border-large-hover-color-index-accent-4:hover{box-shadow:0 0 0 24px #2ad2c9}.grommetux-background-color-index-accent-2,.grommetux-background-color-index-accent-5{background-color:#614767}.grommetux-background-color-index-accent-2-t,.grommetux-background-color-index-accent-5-t{background-color:#69506f}.grommetux-background-color-index-accent-2-a,.grommetux-background-color-index-accent-5-a{background-color:rgba(97,71,103,.8)}.grommetux-border-color-index-accent-2,.grommetux-border-color-index-accent-5{border-color:#614767}.grommetux-border-color-index-accent-2-t,.grommetux-border-color-index-accent-5-t{border-color:#69506f}.grommetux-color-index-accent-2,.grommetux-color-index-accent-5{color:#614767}.grommetux-color-index-accent-2-t,.grommetux-color-index-accent-5-t{color:#69506f}.grommetux-background-hover-color-index-accent-2:hover,.grommetux-background-hover-color-index-accent-5:hover{background-color:rgba(97,71,103,.3)}.grommetux-border-small-hover-color-index-accent-2:hover,.grommetux-border-small-hover-color-index-accent-5:hover{box-shadow:0 0 0 1px #614767}.grommetux-border-medium-hover-color-index-accent-2:hover,.grommetux-border-medium-hover-color-index-accent-5:hover{box-shadow:0 0 0 12px #614767}.grommetux-border-large-hover-color-index-accent-2:hover,.grommetux-border-large-hover-color-index-accent-5:hover{box-shadow:0 0 0 24px #614767}.grommetux-background-color-index-accent-3,.grommetux-background-color-index-accent-6{background-color:#ff8d6d}.grommetux-background-color-index-accent-3-t,.grommetux-background-color-index-accent-6-t{background-color:#ff9374}.grommetux-background-color-index-accent-3-a,.grommetux-background-color-index-accent-6-a{background-color:rgba(255,141,109,.8)}.grommetux-border-color-index-accent-3,.grommetux-border-color-index-accent-6{border-color:#ff8d6d}.grommetux-border-color-index-accent-3-t,.grommetux-border-color-index-accent-6-t{border-color:#ff9374}.grommetux-color-index-accent-3,.grommetux-color-index-accent-6{color:#ff8d6d}.grommetux-color-index-accent-3-t,.grommetux-color-index-accent-6-t{color:#ff9374}.grommetux-background-hover-color-index-accent-3:hover,.grommetux-background-hover-color-index-accent-6:hover{background-color:rgba(255,141,109,.3)}.grommetux-border-small-hover-color-index-accent-3:hover,.grommetux-border-small-hover-color-index-accent-6:hover{box-shadow:0 0 0 1px #ff8d6d}.grommetux-border-medium-hover-color-index-accent-3:hover,.grommetux-border-medium-hover-color-index-accent-6:hover{box-shadow:0 0 0 12px #ff8d6d}.grommetux-border-large-hover-color-index-accent-3:hover,.grommetux-border-large-hover-color-index-accent-6:hover{box-shadow:0 0 0 24px #ff8d6d}.grommetux-background-color-index-grey-1,.grommetux-background-color-index-grey-6{background-color:#000001}.grommetux-background-color-index-grey-1-a,.grommetux-background-color-index-grey-6-a{background-color:rgba(0,0,1,.8)}.grommetux-border-color-index-grey-1,.grommetux-border-color-index-grey-6{border-color:#000001}.grommetux-background-hover-color-index-grey-1:hover,.grommetux-background-hover-color-index-grey-6:hover{background-color:rgba(0,0,1,.3)}.grommetux-border-small-hover-color-index-grey-1:hover,.grommetux-border-small-hover-color-index-grey-6:hover{box-shadow:0 0 0 1px #000001}.grommetux-border-medium-hover-color-index-grey-1:hover,.grommetux-border-medium-hover-color-index-grey-6:hover{box-shadow:0 0 0 12px #000001}.grommetux-border-large-hover-color-index-grey-1:hover,.grommetux-border-large-hover-color-index-grey-6:hover{box-shadow:0 0 0 24px #000001}.grommetux-background-color-index-grey-2,.grommetux-background-color-index-grey-7{background-color:#333}.grommetux-background-color-index-grey-2-a,.grommetux-background-color-index-grey-7-a{background-color:rgba(51,51,51,.8)}.grommetux-border-color-index-grey-2,.grommetux-border-color-index-grey-7{border-color:#333}.grommetux-background-hover-color-index-grey-2:hover,.grommetux-background-hover-color-index-grey-7:hover{background-color:rgba(51,51,51,.3)}.grommetux-border-small-hover-color-index-grey-2:hover,.grommetux-border-small-hover-color-index-grey-7:hover{box-shadow:0 0 0 1px #333}.grommetux-border-medium-hover-color-index-grey-2:hover,.grommetux-border-medium-hover-color-index-grey-7:hover{box-shadow:0 0 0 12px #333}.grommetux-border-large-hover-color-index-grey-2:hover,.grommetux-border-large-hover-color-index-grey-7:hover{box-shadow:0 0 0 24px #333}.grommetux-background-color-index-grey-3,.grommetux-background-color-index-grey-8{background-color:#3b3b3b}.grommetux-background-color-index-grey-3-a,.grommetux-background-color-index-grey-8-a{background-color:rgba(59,59,59,.8)}.grommetux-border-color-index-grey-3,.grommetux-border-color-index-grey-8{border-color:#3b3b3b}.grommetux-background-hover-color-index-grey-3:hover,.grommetux-background-hover-color-index-grey-8:hover{background-color:rgba(59,59,59,.3)}.grommetux-border-small-hover-color-index-grey-3:hover,.grommetux-border-small-hover-color-index-grey-8:hover{box-shadow:0 0 0 1px #3b3b3b}.grommetux-border-medium-hover-color-index-grey-3:hover,.grommetux-border-medium-hover-color-index-grey-8:hover{box-shadow:0 0 0 12px #3b3b3b}.grommetux-border-large-hover-color-index-grey-3:hover,.grommetux-border-large-hover-color-index-grey-8:hover{box-shadow:0 0 0 24px #3b3b3b}.grommetux-background-color-index-grey-4,.grommetux-background-color-index-grey-9{background-color:#434343}.grommetux-background-color-index-grey-4-a,.grommetux-background-color-index-grey-9-a{background-color:rgba(67,67,67,.8)}.grommetux-border-color-index-grey-4,.grommetux-border-color-index-grey-9{border-color:#434343}.grommetux-background-hover-color-index-grey-4:hover,.grommetux-background-hover-color-index-grey-9:hover{background-color:rgba(67,67,67,.3)}.grommetux-border-small-hover-color-index-grey-4:hover,.grommetux-border-small-hover-color-index-grey-9:hover{box-shadow:0 0 0 1px #434343}.grommetux-border-medium-hover-color-index-grey-4:hover,.grommetux-border-medium-hover-color-index-grey-9:hover{box-shadow:0 0 0 12px #434343}.grommetux-border-large-hover-color-index-grey-4:hover,.grommetux-border-large-hover-color-index-grey-9:hover{box-shadow:0 0 0 24px #434343}.grommetux-background-color-index-grey-5,.grommetux-background-color-index-grey-10{background-color:#666}.grommetux-background-color-index-grey-5-a,.grommetux-background-color-index-grey-10-a{background-color:hsla(0,0%,40%,.8)}.grommetux-border-color-index-grey-5,.grommetux-border-color-index-grey-10{border-color:#666}.grommetux-background-hover-color-index-grey-5:hover,.grommetux-background-hover-color-index-grey-10:hover{background-color:hsla(0,0%,40%,.3)}.grommetux-border-small-hover-color-index-grey-5:hover,.grommetux-border-small-hover-color-index-grey-10:hover{box-shadow:0 0 0 1px #666}.grommetux-border-medium-hover-color-index-grey-5:hover,.grommetux-border-medium-hover-color-index-grey-10:hover{box-shadow:0 0 0 12px #666}.grommetux-border-large-hover-color-index-grey-5:hover,.grommetux-border-large-hover-color-index-grey-10:hover{box-shadow:0 0 0 24px #666}.grommetux-background-color-index-graph-1,.grommetux-background-color-index-graph-5{background-color:#425563}.grommetux-border-color-index-graph-1,.grommetux-border-color-index-graph-5{border-color:#425563}.grommetux-background-color-index-graph-2,.grommetux-background-color-index-graph-6{background-color:#5f7a76}.grommetux-border-color-index-graph-2,.grommetux-border-color-index-graph-6{border-color:#5f7a76}.grommetux-background-color-index-graph-3,.grommetux-background-color-index-graph-7{background-color:#80746e}.grommetux-border-color-index-graph-3,.grommetux-border-color-index-graph-7{border-color:#80746e}.grommetux-background-color-index-graph-4,.grommetux-background-color-index-graph-8{background-color:#767676}.grommetux-border-color-index-graph-4,.grommetux-border-color-index-graph-8{border-color:#767676}.grommetux-background-color-index-critical{background-color:#f04953}.grommetux-border-color-index-critical{border-color:#f04953}.grommetux-color-index-critical{color:#f04953}.grommetux-background-hover-color-index-critical:hover{background-color:rgba(240,73,83,.3)}.grommetux-border-small-hover-color-index-critical:hover{box-shadow:0 0 0 1px #f04953}.grommetux-border-medium-hover-color-index-critical:hover{box-shadow:0 0 0 12px #f04953}.grommetux-border-large-hover-color-index-critical:hover{box-shadow:0 0 0 24px #f04953}.grommetux-background-color-index-error{background-color:#f04953}.grommetux-border-color-index-error{border-color:#f04953}.grommetux-color-index-error{color:#f04953}.grommetux-background-hover-color-index-error:hover{background-color:rgba(240,73,83,.3)}.grommetux-border-small-hover-color-index-error:hover{box-shadow:0 0 0 1px #f04953}.grommetux-border-medium-hover-color-index-error:hover{box-shadow:0 0 0 12px #f04953}.grommetux-border-large-hover-color-index-error:hover{box-shadow:0 0 0 24px #f04953}.grommetux-background-color-index-warning{background-color:#ffd144}.grommetux-border-color-index-warning{border-color:#ffd144}.grommetux-color-index-warning{color:#ffd144}.grommetux-background-hover-color-index-warning:hover{background-color:rgba(255,209,68,.3)}.grommetux-border-small-hover-color-index-warning:hover{box-shadow:0 0 0 1px #ffd144}.grommetux-border-medium-hover-color-index-warning:hover{box-shadow:0 0 0 12px #ffd144}.grommetux-border-large-hover-color-index-warning:hover{box-shadow:0 0 0 24px #ffd144}.grommetux-background-color-index-ok{background-color:#01a982}.grommetux-border-color-index-ok{border-color:#01a982}.grommetux-color-index-ok{color:#01a982}.grommetux-background-hover-color-index-ok:hover{background-color:rgba(1,169,130,.3)}.grommetux-border-small-hover-color-index-ok:hover{box-shadow:0 0 0 1px #01a982}.grommetux-border-medium-hover-color-index-ok:hover{box-shadow:0 0 0 12px #01a982}.grommetux-border-large-hover-color-index-ok:hover{box-shadow:0 0 0 24px #01a982}.grommetux-background-color-index-unknown{background-color:#ccc}.grommetux-border-color-index-unknown{border-color:#ccc}.grommetux-color-index-unknown{color:#ccc}.grommetux-background-hover-color-index-unknown:hover{background-color:hsla(0,0%,80%,.3)}.grommetux-border-small-hover-color-index-unknown:hover{box-shadow:0 0 0 1px #ccc}.grommetux-border-medium-hover-color-index-unknown:hover{box-shadow:0 0 0 12px #ccc}.grommetux-border-large-hover-color-index-unknown:hover{box-shadow:0 0 0 24px #ccc}.grommetux-background-color-index-disabled{background-color:#ccc}.grommetux-border-color-index-disabled{border-color:#ccc}.grommetux-color-index-disabled{color:#ccc}.grommetux-background-hover-color-index-disabled:hover{background-color:hsla(0,0%,80%,.3)}.grommetux-border-small-hover-color-index-disabled:hover{box-shadow:0 0 0 1px #ccc}.grommetux-border-medium-hover-color-index-disabled:hover{box-shadow:0 0 0 12px #ccc}.grommetux-border-large-hover-color-index-disabled:hover{box-shadow:0 0 0 24px #ccc}.grommetux-background-color-index-light-1,.grommetux-background-color-index-light-3{background-color:#fff}.grommetux-background-color-index-light-1-a,.grommetux-background-color-index-light-3-a{background-color:hsla(0,0%,100%,.8)}.grommetux-border-color-index-light-1,.grommetux-border-color-index-light-3{border-color:#fff}.grommetux-background-hover-color-index-light-1:hover,.grommetux-background-hover-color-index-light-3:hover{background-color:hsla(0,0%,100%,.3)}.grommetux-border-small-hover-color-index-light-1:hover,.grommetux-border-small-hover-color-index-light-3:hover{box-shadow:0 0 0 1px #fff}.grommetux-border-medium-hover-color-index-light-1:hover,.grommetux-border-medium-hover-color-index-light-3:hover{box-shadow:0 0 0 12px #fff}.grommetux-border-large-hover-color-index-light-1:hover,.grommetux-border-large-hover-color-index-light-3:hover{box-shadow:0 0 0 24px #fff}.grommetux-background-color-index-light-2,.grommetux-background-color-index-light-4{background-color:#f5f5f5}.grommetux-background-color-index-light-2-a,.grommetux-background-color-index-light-4-a{background-color:hsla(0,0%,96%,.8)}.grommetux-border-color-index-light-2,.grommetux-border-color-index-light-4{border-color:#f5f5f5}.grommetux-background-hover-color-index-light-2:hover,.grommetux-background-hover-color-index-light-4:hover{background-color:hsla(0,0%,96%,.3)}.grommetux-border-small-hover-color-index-light-2:hover,.grommetux-border-small-hover-color-index-light-4:hover{box-shadow:0 0 0 1px #f5f5f5}.grommetux-border-medium-hover-color-index-light-2:hover,.grommetux-border-medium-hover-color-index-light-4:hover{box-shadow:0 0 0 12px #f5f5f5}.grommetux-border-large-hover-color-index-light-2:hover,.grommetux-border-large-hover-color-index-light-4:hover{box-shadow:0 0 0 24px #f5f5f5}.grommetux-background-color-index-unset{background-color:#ddd}.grommetux-columns{display:flex;flex-direction:row;width:100%}@media screen and (min-width:45em){.grommetux-columns>.grommetux-columns__column{flex-basis:384px}.grommetux-columns.grommetux-columns--margin-small>.grommetux-columns__column{flex-basis:396px}.grommetux-columns.grommetux-columns--margin-medium>.grommetux-columns__column{flex-basis:408px}.grommetux-columns.grommetux-columns--margin-large>.grommetux-columns__column{flex-basis:432px}}@media screen and (max-width:44.9375em){.grommetux-columns{flex-direction:column}}.grommetux-columns__column{flex:0 0 384px;display:flex;flex-direction:column}@media screen and (max-width:44.9375em){.grommetux-columns__column{flex-basis:auto}}@media screen and (max-width:44.9375em){.grommetux-columns--responsive.grommetux-columns--large>.grommetux-columns__column,.grommetux-columns--responsive.grommetux-columns--medium>.grommetux-columns__column,.grommetux-columns--responsive.grommetux-columns--small>.grommetux-columns__column,.grommetux-columns--responsive>.grommetux-columns__column{flex:0 1 auto}}@media screen and (min-width:45em){.grommetux-columns--small>.grommetux-columns__column{flex-basis:192px}.grommetux-columns--small.grommetux-columns--margin-small>.grommetux-columns__column{flex-basis:204px}.grommetux-columns--small.grommetux-columns--margin-medium>.grommetux-columns__column{flex-basis:216px}.grommetux-columns--small.grommetux-columns--margin-large>.grommetux-columns__column{flex-basis:240px}}@media screen and (min-width:45em){.grommetux-columns--medium>.grommetux-columns__column{flex-basis:384px}.grommetux-columns--medium.grommetux-columns--margin-small>.grommetux-columns__column{flex-basis:396px}.grommetux-columns--medium.grommetux-columns--margin-medium>.grommetux-columns__column{flex-basis:408px}.grommetux-columns--medium.grommetux-columns--margin-large>.grommetux-columns__column{flex-basis:432px}}@media screen and (min-width:45em){.grommetux-columns--large>.grommetux-columns__column{flex-basis:576px}.grommetux-columns--large.grommetux-columns--margin-small>.grommetux-columns__column{flex-basis:588px}.grommetux-columns--large.grommetux-columns--margin-medium>.grommetux-columns__column{flex-basis:600px}.grommetux-columns--large.grommetux-columns--margin-large>.grommetux-columns__column{flex-basis:624px}}.grommetux-columns--justify-start{justify-content:flex-start}.grommetux-columns--justify-center{justify-content:center}.grommetux-columns--justify-between{justify-content:space-between}.grommetux-columns--justify-end{justify-content:flex-end}.grommetux-date-time{position:relative;display:inline-block}.grommetux-date-time__input{padding:11px 23px;border:1px solid rgba(0,0,0,.15);border-radius:0;outline:none;background-color:transparent;color:inherit;font:inherit;margin:0;padding-right:60px}.grommetux-date-time__input:focus{border-width:2px;border-color:#2ad2c9;padding:10px 22px}.grommetux-date-time__input::-moz-focus-inner{border:none;outline:none}.grommetux-date-time__input::-webkit-input-placeholder{color:#aaa}.grommetux-date-time__input::-moz-placeholder{color:#aaa}.grommetux-date-time__input:-ms-input-placeholder{color:#aaa}.grommetux-date-time__input.error{border-color:#f04953}.grommetux-date-time__input:focus{padding-right:58px}.grommetux-date-time__input::-ms-clear{display:none}.grommetux-date-time__control{position:absolute;top:50%;right:12px;transform:translateY(-50%)}.grommetux-date-time-drop{border-top-left-radius:0;border-top-right-radius:0}.grommetux-date-time-drop__title{text-align:center}.grommetux-date-time-drop__grid{width:100%;padding:12px}.grommetux-date-time-drop__grid table{width:100%;margin-bottom:0;outline:none}.grommetux-date-time-drop__grid td,.grommetux-date-time-drop__grid th{text-align:center}.grommetux-date-time-drop__grid th{color:#666;font-weight:400;padding:6px}.grommetux-date-time-drop__grid--focus table{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-date-time-drop__day{display:inline-block;cursor:pointer;outline:none;width:36px;height:36px;padding:6px;transition:background-color .3s}.grommetux-date-time-drop__day--hover,.grommetux-date-time-drop__day:hover{background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-date-time-drop__day--other-month{color:#666}.grommetux-date-time-drop__day--active{background-color:#01a982;color:hsla(0,0%,100%,.85);font-weight:700}.grommetux-date-time-drop__time{font-size:18px;font-size:1.125rem;line-height:1.33333;font-weight:700}.grommetux-distribution{position:relative;width:100%}.grommetux-distribution__graphic{position:absolute;top:0;left:0;outline:none;max-width:100%}.grommetux-distribution__graphic--focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-distribution__background{fill:#f5f5f5}.grommetux-background-color-index--dark .grommetux-distribution__background,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-distribution__background{fill:rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-distribution__background,.grommetux-background-color-index--light .grommetux-distribution__background{fill:#f5f5f5}.grommetux-distribution__item--clickable{cursor:pointer;outline:none}.grommetux-distribution__item-box{transition:all .2s ease}.grommetux-distribution__item-box.grommetux-color-index-unset{fill:#ddd}.grommetux-distribution__item-box.grommetux-color-index-brand{fill:#01a982}.grommetux-distribution__item-box.grommetux-color-index-critical,.grommetux-distribution__item-box.grommetux-color-index-error{fill:#f04953}.grommetux-distribution__item-box.grommetux-color-index-warning{fill:#ffd144}.grommetux-distribution__item-box.grommetux-color-index-ok{fill:#01a982}.grommetux-distribution__item-box.grommetux-color-index-disabled,.grommetux-distribution__item-box.grommetux-color-index-unknown{fill:#ccc}.grommetux-distribution__item-box.grommetux-color-index-graph-1,.grommetux-distribution__item-box.grommetux-color-index-graph-5{fill:#425563}.grommetux-distribution__item-box.grommetux-color-index-graph-2,.grommetux-distribution__item-box.grommetux-color-index-graph-6{fill:#5f7a76}.grommetux-distribution__item-box.grommetux-color-index-graph-3,.grommetux-distribution__item-box.grommetux-color-index-graph-7{fill:#80746e}.grommetux-distribution__item-box.grommetux-color-index-graph-4,.grommetux-distribution__item-box.grommetux-color-index-graph-8{fill:#767676}.grommetux-distribution__item-box.grommetux-color-index-accent-1,.grommetux-distribution__item-box.grommetux-color-index-accent-4{fill:#2ad2c9}.grommetux-distribution__item-box.grommetux-color-index-accent-2,.grommetux-distribution__item-box.grommetux-color-index-accent-5{fill:#614767}.grommetux-distribution__item-box.grommetux-color-index-accent-3,.grommetux-distribution__item-box.grommetux-color-index-accent-6{fill:#ff8d6d}.grommetux-distribution__item-box.grommetux-color-index-grey-1,.grommetux-distribution__item-box.grommetux-color-index-grey-6{fill:#000001}.grommetux-distribution__item-box.grommetux-color-index-grey-2,.grommetux-distribution__item-box.grommetux-color-index-grey-7{fill:#333}.grommetux-distribution__item-box.grommetux-color-index-grey-3,.grommetux-distribution__item-box.grommetux-color-index-grey-8{fill:#3b3b3b}.grommetux-distribution__item-box.grommetux-color-index-grey-4,.grommetux-distribution__item-box.grommetux-color-index-grey-9{fill:#434343}.grommetux-distribution__item-box.grommetux-color-index-grey-5,.grommetux-distribution__item-box.grommetux-color-index-grey-10{fill:#666}.grommetux-distribution__item-icons.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-distribution__item-icons.grommetux-color-index-unset{stroke:#ddd}.grommetux-distribution__item-icons.grommetux-color-index-brand{stroke:#01a982}.grommetux-distribution__item-icons.grommetux-color-index-critical,.grommetux-distribution__item-icons.grommetux-color-index-error{stroke:#f04953}.grommetux-distribution__item-icons.grommetux-color-index-warning{stroke:#ffd144}.grommetux-distribution__item-icons.grommetux-color-index-ok{stroke:#01a982}.grommetux-distribution__item-icons.grommetux-color-index-disabled,.grommetux-distribution__item-icons.grommetux-color-index-unknown{stroke:#ccc}.grommetux-distribution__item-icons.grommetux-color-index-graph-1,.grommetux-distribution__item-icons.grommetux-color-index-graph-5{stroke:#425563}.grommetux-distribution__item-icons.grommetux-color-index-graph-2,.grommetux-distribution__item-icons.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-distribution__item-icons.grommetux-color-index-graph-3,.grommetux-distribution__item-icons.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-distribution__item-icons.grommetux-color-index-graph-4,.grommetux-distribution__item-icons.grommetux-color-index-graph-8{stroke:#767676}.grommetux-distribution__item-icons.grommetux-color-index-grey-1,.grommetux-distribution__item-icons.grommetux-color-index-grey-6{stroke:#000001}.grommetux-distribution__item-icons.grommetux-color-index-grey-2,.grommetux-distribution__item-icons.grommetux-color-index-grey-7{stroke:#333}.grommetux-distribution__item-icons.grommetux-color-index-grey-3,.grommetux-distribution__item-icons.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-distribution__item-icons.grommetux-color-index-grey-4,.grommetux-distribution__item-icons.grommetux-color-index-grey-9{stroke:#434343}.grommetux-distribution__item-icons.grommetux-color-index-grey-5,.grommetux-distribution__item-icons.grommetux-color-index-grey-10{stroke:#666}.grommetux-distribution__item-icons.grommetux-color-index-accent-1,.grommetux-distribution__item-icons.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-distribution__item-icons.grommetux-color-index-accent-2,.grommetux-distribution__item-icons.grommetux-color-index-accent-5{stroke:#614767}.grommetux-distribution__item-icons.grommetux-color-index-accent-3,.grommetux-distribution__item-icons.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-distribution__item-icons.grommetux-color-index-neutral-1,.grommetux-distribution__item-icons.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-distribution__item-icons.grommetux-color-index-neutral-2,.grommetux-distribution__item-icons.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-distribution__item-icons.grommetux-color-index-neutral-3,.grommetux-distribution__item-icons.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-distribution__item-icons.grommetux-color-index-neutral-4,.grommetux-distribution__item-icons.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-distribution__item-icons.grommetux-color-index-light-1,.grommetux-distribution__item-icons.grommetux-color-index-light-3{stroke:#fff}.grommetux-distribution__item-icons.grommetux-color-index-light-2,.grommetux-distribution__item-icons.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-distribution__label{position:absolute;background-color:transparent;padding:6px 12px;font-family:Metric,Arial,sans-serif;overflow:hidden;text-align:left;pointer-events:none;transition:all .2s ease}.grommetux-distribution__label.grommetux-background-color-index-accent-1,.grommetux-distribution__label.grommetux-background-color-index-accent-2,.grommetux-distribution__label.grommetux-background-color-index-accent-4,.grommetux-distribution__label.grommetux-background-color-index-accent-5,.grommetux-distribution__label.grommetux-background-color-index-brand,.grommetux-distribution__label.grommetux-background-color-index-critical,.grommetux-distribution__label.grommetux-background-color-index-error,.grommetux-distribution__label.grommetux-background-color-index-graph-1,.grommetux-distribution__label.grommetux-background-color-index-graph-2,.grommetux-distribution__label.grommetux-background-color-index-graph-3,.grommetux-distribution__label.grommetux-background-color-index-graph-4,.grommetux-distribution__label.grommetux-background-color-index-graph-5,.grommetux-distribution__label.grommetux-background-color-index-graph-6,.grommetux-distribution__label.grommetux-background-color-index-graph-7,.grommetux-distribution__label.grommetux-background-color-index-graph-8,.grommetux-distribution__label.grommetux-background-color-index-grey-1,.grommetux-distribution__label.grommetux-background-color-index-grey-2,.grommetux-distribution__label.grommetux-background-color-index-grey-3,.grommetux-distribution__label.grommetux-background-color-index-grey-4,.grommetux-distribution__label.grommetux-background-color-index-grey-5,.grommetux-distribution__label.grommetux-background-color-index-grey-6,.grommetux-distribution__label.grommetux-background-color-index-grey-7,.grommetux-distribution__label.grommetux-background-color-index-grey-8,.grommetux-distribution__label.grommetux-background-color-index-grey-9,.grommetux-distribution__label.grommetux-background-color-index-grey-10,.grommetux-distribution__label.grommetux-background-color-index-neutral-1,.grommetux-distribution__label.grommetux-background-color-index-neutral-2,.grommetux-distribution__label.grommetux-background-color-index-neutral-3,.grommetux-distribution__label.grommetux-background-color-index-neutral-4,.grommetux-distribution__label.grommetux-background-color-index-neutral-5,.grommetux-distribution__label.grommetux-background-color-index-neutral-6,.grommetux-distribution__label.grommetux-background-color-index-neutral-7,.grommetux-distribution__label.grommetux-background-color-index-neutral-8,.grommetux-distribution__label.grommetux-background-color-index-ok{color:#fff}.grommetux-distribution__label-value{display:block;font-size:36px;font-size:2.25rem;line-height:1.33333;font-weight:600}.grommetux-distribution__label-units{font-size:24px;font-size:1.5rem;line-height:inherit;margin-left:6px;font-weight:100}.grommetux-distribution__label-label{display:block}.grommetux-distribution__label--active{z-index:10;color:#333;border-right:2px solid #f5f5f5;border-left:2px solid #f5f5f5;opacity:.9}.grommetux-distribution__label--thin .grommetux-distribution__label-label,.grommetux-distribution__label--thin .grommetux-distribution__label-value{display:inline-block}.grommetux-distribution__label--small .grommetux-distribution__label-units,.grommetux-distribution__label--small .grommetux-distribution__label-value{font-size:20px;font-size:1.25rem;line-height:1;margin-right:4px}.grommetux-distribution__label--icons{padding:0 12px 12px 0;background-color:hsla(0,0%,100%,.8);color:#333}.grommetux-background-color-index--dark .grommetux-distribution__label--icons,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-distribution__label--icons{background-color:rgba(0,0,0,.15);color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-distribution__label--icons,.grommetux-background-color-index--light .grommetux-distribution__label--icons{background-color:hsla(0,0%,100%,.8);color:#333}.grommetux-distribution__label--icons .label-value{line-height:1}.grommetux-distribution__label--icons .label-units{color:#666}.grommetux-distribution__label--icons .label-label{display:block}.grommetux-distribution__loading-indicator{stroke-width:24px}.grommetux-distribution__loading-indicator.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-distribution__loading-indicator.grommetux-color-index-unset{stroke:#ddd}.grommetux-distribution__loading-indicator.grommetux-color-index-brand{stroke:#01a982}.grommetux-distribution__loading-indicator.grommetux-color-index-critical,.grommetux-distribution__loading-indicator.grommetux-color-index-error{stroke:#f04953}.grommetux-distribution__loading-indicator.grommetux-color-index-warning{stroke:#ffd144}.grommetux-distribution__loading-indicator.grommetux-color-index-ok{stroke:#01a982}.grommetux-distribution__loading-indicator.grommetux-color-index-disabled,.grommetux-distribution__loading-indicator.grommetux-color-index-unknown{stroke:#ccc}.grommetux-distribution__loading-indicator.grommetux-color-index-graph-1,.grommetux-distribution__loading-indicator.grommetux-color-index-graph-5{stroke:#425563}.grommetux-distribution__loading-indicator.grommetux-color-index-graph-2,.grommetux-distribution__loading-indicator.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-distribution__loading-indicator.grommetux-color-index-graph-3,.grommetux-distribution__loading-indicator.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-distribution__loading-indicator.grommetux-color-index-graph-4,.grommetux-distribution__loading-indicator.grommetux-color-index-graph-8{stroke:#767676}.grommetux-distribution__loading-indicator.grommetux-color-index-grey-1,.grommetux-distribution__loading-indicator.grommetux-color-index-grey-6{stroke:#000001}.grommetux-distribution__loading-indicator.grommetux-color-index-grey-2,.grommetux-distribution__loading-indicator.grommetux-color-index-grey-7{stroke:#333}.grommetux-distribution__loading-indicator.grommetux-color-index-grey-3,.grommetux-distribution__loading-indicator.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-distribution__loading-indicator.grommetux-color-index-grey-4,.grommetux-distribution__loading-indicator.grommetux-color-index-grey-9{stroke:#434343}.grommetux-distribution__loading-indicator.grommetux-color-index-grey-5,.grommetux-distribution__loading-indicator.grommetux-color-index-grey-10{stroke:#666}.grommetux-distribution__loading-indicator.grommetux-color-index-accent-1,.grommetux-distribution__loading-indicator.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-distribution__loading-indicator.grommetux-color-index-accent-2,.grommetux-distribution__loading-indicator.grommetux-color-index-accent-5{stroke:#614767}.grommetux-distribution__loading-indicator.grommetux-color-index-accent-3,.grommetux-distribution__loading-indicator.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-distribution__loading-indicator.grommetux-color-index-neutral-1,.grommetux-distribution__loading-indicator.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-distribution__loading-indicator.grommetux-color-index-neutral-2,.grommetux-distribution__loading-indicator.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-distribution__loading-indicator.grommetux-color-index-neutral-3,.grommetux-distribution__loading-indicator.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-distribution__loading-indicator.grommetux-color-index-neutral-4,.grommetux-distribution__loading-indicator.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-distribution__loading-indicator.grommetux-color-index-light-1,.grommetux-distribution__loading-indicator.grommetux-color-index-light-3{stroke:#fff}.grommetux-distribution__loading-indicator.grommetux-color-index-light-2,.grommetux-distribution__loading-indicator.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-distribution--icons .grommetux-distribution__label{padding:0 12px 12px 0}.grommetux-distribution--icons .grommetux-distribution__label-value{line-height:1}.grommetux-distribution--small{height:192px}.grommetux-distribution--medium{height:384px}.grommetux-distribution--large{height:576px}.grommetux-distribution--full{height:100%;flex:1 1}.grommetux-distribution--full .grommetux-distribution__graphic{width:auto;height:auto;max-height:100%;max-width:100%}.grommet.grommetux-drop{position:fixed;z-index:20;border-radius:0;overflow:auto}.grommet.grommetux-drop:not([class*=background-color-index-]){background-color:hsla(0,0%,97%,.95);border:none;box-shadow:none}.grommetux-footer{min-height:36px;width:100%}.grommetux-footer--small{min-height:24px}.grommetux-footer--large{min-height:96px}.grommetux-footer__content{display:flex;justify-content:space-between;width:100%;padding-left:24px;padding-right:24px}.grommetux-footer__content>*{margin-right:48px}.grommetux-footer__content>:last-child{margin-right:0;text-align:left}.grommetux-footer--primary{height:auto;padding:24px}.grommetux-footer--primary .grommetux-footer__content{position:relative;color:#666;display:block}.grommetux-footer--centered .grommetux-footer__content{display:block;text-align:center}.grommetux-footer--centered .grommetux-footer__content>*{margin-right:auto;margin-left:auto;text-align:center}.grommetux-footer--flush .grommetux-footer__content,.grommetux-footer--flush .grommetux-footer__wrapper{padding-left:0;padding-right:0}.grommetux-footer--fixed .grommetux-footer__wrapper{position:absolute;bottom:0;left:0;right:0;z-index:3}.grommetux-footer--fixed .grommetux-footer__wrapper--fill .grommetux-footer__wrapper{background-color:hsla(0,0%,100%,.9)}.grommetux-footer--fixed.grommetux-footer--primary .grommetux-footer__wrapper{position:fixed}.grommetux-footer--fixed.grommetux-footer--primary .grommetux-footer__wrapper--fill .grommetux-footer__wrapper{background-color:hsla(0,0%,100%,.9)}.grommetux-footer--fixed.grommetux-footer--primary .grommetux-footer__content{position:static;background-color:transparent}.grommetux-footer__container{flex-shrink:0}.grommetux-footer__container--float{position:absolute;bottom:0;left:0;right:0}.grommetux-footer__container--fill .grommetux-footer{background-color:hsla(0,0%,100%,.9)}.grommetux-footer__container--fixed{position:relative;width:100%}.grommetux-footer__container--fixed .grommetux-footer__wrapper{position:absolute;bottom:0;left:0;right:0;z-index:3}.grommetux-footer__wrapper{height:36px}.grommetux-footer__wrapper--large{height:96px}.grommetux-footer__wrapper--small{height:24px}:not(.grommetux-footer__container--float)>.grommetux-footer--float{position:fixed;bottom:0;left:0;right:0}.grommetux-form{position:relative;max-width:100%}@media screen and (min-width:45em){.grommetux-form .grommetux-form-field .grommetux-tiles__container{max-width:480px}}.grommetux-form--pad-none{padding:0}@media screen and (min-width:45em){.grommetux-form--pad-small{padding:12px}.grommetux-form--pad-medium{padding:24px}.grommetux-form--pad-large{padding:48px}.grommetux-form--pad-xlarge{padding:192px}}@media screen and (max-width:44.9375em){.grommetux-form--pad-small{padding:6px}.grommetux-form--pad-medium{padding:12px}.grommetux-form--pad-large{padding:24px}.grommetux-form--pad-xlarge{padding:48px}}.grommetux-form--pad-horizontal-none{padding-left:0;padding-right:0}@media screen and (min-width:45em){.grommetux-form--pad-horizontal-small{padding-left:12px;padding-right:12px}.grommetux-form--pad-horizontal-medium{padding-left:24px;padding-right:24px}.grommetux-form--pad-horizontal-large{padding-left:48px;padding-right:48px}.grommetux-form--pad-horizontal-xlarge{padding-left:192px;padding-right:192px}}@media screen and (max-width:44.9375em){.grommetux-form--pad-horizontal-small{padding-left:6px;padding-right:6px}.grommetux-form--pad-horizontal-medium{padding-left:12px;padding-right:12px}.grommetux-form--pad-horizontal-large{padding-left:24px;padding-right:24px}.grommetux-form--pad-horizontal-xlarge{padding-left:48px;padding-right:48px}}.grommetux-form--pad-vertical-none{padding-top:0;padding-bottom:0}@media screen and (min-width:45em){.grommetux-form--pad-vertical-small{padding-top:12px;padding-bottom:12px}.grommetux-form--pad-vertical-medium{padding-top:24px;padding-bottom:24px}.grommetux-form--pad-vertical-large{padding-top:48px;padding-bottom:48px}.grommetux-form--pad-vertical-xlarge{padding-top:192px;padding-bottom:192px}}@media screen and (max-width:44.9375em){.grommetux-form--pad-vertical-small{padding-top:6px;padding-bottom:6px}.grommetux-form--pad-vertical-medium{padding-top:12px;padding-bottom:12px}.grommetux-form--pad-vertical-large{padding-top:24px;padding-bottom:24px}.grommetux-form--pad-vertical-xlarge{padding-top:48px;padding-bottom:48px}}.grommetux-form>.grommetux-header .grommetux-header__wrapper{background-color:inherit}.grommetux-form fieldset{min-width:0;border:none;margin:0;margin-bottom:2rem;margin-top:24px}.grommetux-form fieldset:first-child{margin-top:0}.grommetux-form fieldset:last-child{margin-bottom:0}.grommetux-form fieldset>legend{font-size:24px;font-size:1.5rem;line-height:1;font-weight:600;margin-bottom:12px}.grommetux-form fieldset>:not(.grommetux-form-field)+.grommetux-form-field{margin-top:12px}.grommetux-form fieldset>.grommetux-form-field+:not(.grommetux-form-field):not(.grommetux-form-fields){margin-top:24px}.grommetux-form fieldset>.grommetux-form-fields{display:flex;flex-direction:row}.grommetux-form fieldset>.grommetux-form-fields .grommetux-form-field{margin-bottom:-1px}.grommetux-form fieldset>.grommetux-form-fields>.grommetux-button{flex:0 0 auto}.grommetux-form:not(.grommetux-form--plain){width:480px}.grommetux-form--fill{min-width:0}.grommetux-form--compact{max-width:288px}.grommetux-form-field{position:relative;padding:5px 24px;border:1px solid rgba(0,0,0,.15);margin-bottom:-1px;background-color:#fff;color:#333;opacity:1}@media screen and (min-width:45em){.grommetux-form-field{width:100%;overflow:auto;transition:all .4s,padding-top .3s .1s,padding-bottom .3s .1s}}@media screen and (max-width:44.9375em){.grommetux-form-field{display:block}}.grommetux-background-color-index--dark .grommetux-form-field,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-form-field{background-color:transparent;color:hsla(0,0%,100%,.85);border-color:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-form-field,.grommetux-background-color-index--light .grommetux-form-field{background-color:#fff;color:#333;border-color:rgba(0,0,0,.15)}.grommetux-form--fill .grommetux-form-field{width:100%}.grommetux-form-field:last-child{margin-bottom:0}.grommetux-form-field__label{display:block;font-size:14px;font-size:.875rem;line-height:24px;color:#666}.grommetux-background-color-index--dark .grommetux-form-field__label,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-form-field__label{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-form-field__label,.grommetux-background-color-index--light .grommetux-form-field__label{color:#666}.grommetux-form-field__contents{display:block;margin-left:-24px;margin-right:-24px}.grommetux-form-field__contents>.grommetux-box input{border:none;padding:0}.grommetux-form-field__contents>.grommetux-box .grommetux-anchor{color:#049371;text-decoration:none}.grommet .grommetux-form-field__contents>input:not([type]),.grommet .grommetux-form-field__contents>input[type=color],.grommet .grommetux-form-field__contents>input[type=email],.grommet .grommetux-form-field__contents>input[type=file],.grommet .grommetux-form-field__contents>input[type=number],.grommet .grommetux-form-field__contents>input[type=password],.grommet .grommetux-form-field__contents>input[type=range],.grommet .grommetux-form-field__contents>input[type=tel],.grommet .grommetux-form-field__contents>input[type=text],.grommet .grommetux-form-field__contents>input[type=url],.grommet .grommetux-form-field__contents>select,.grommet .grommetux-form-field__contents>textarea{display:block;width:100%;border:none;border-radius:0;font-size:16px;font-size:1rem;line-height:1.5;padding:6px 24px 11px;margin-bottom:-5px}.grommet .grommetux-form-field__contents>input:not([type]):focus,.grommet .grommetux-form-field__contents>input[type=color]:focus,.grommet .grommetux-form-field__contents>input[type=email]:focus,.grommet .grommetux-form-field__contents>input[type=file]:focus,.grommet .grommetux-form-field__contents>input[type=number]:focus,.grommet .grommetux-form-field__contents>input[type=password]:focus,.grommet .grommetux-form-field__contents>input[type=range]:focus,.grommet .grommetux-form-field__contents>input[type=tel]:focus,.grommet .grommetux-form-field__contents>input[type=text]:focus,.grommet .grommetux-form-field__contents>input[type=url]:focus,.grommet .grommetux-form-field__contents>select:focus,.grommet .grommetux-form-field__contents>textarea:focus{padding:6px 24px 11px}.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input:not([type]),.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=color],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=email],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=file],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=number],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=password],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=range],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=tel],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=text],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=url],.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>select,.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>textarea,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input:not([type]),.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=color],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=email],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=file],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=number],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=password],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=range],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=tel],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=text],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>input[type=url],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>select,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>textarea{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input:not([type]),.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=color],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=email],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=file],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=number],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=password],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=range],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=tel],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=text],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=url],.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>select,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>textarea,.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input:not([type]),.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=color],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=email],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=file],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=number],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=password],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=range],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=tel],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=text],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>input[type=url],.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>select,.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>textarea{color:#333}.grommet .grommetux-form-field__contents>.grommetux-calendar input,.grommet .grommetux-form-field__contents>.grommetux-date-time input,.grommet .grommetux-form-field__contents>.grommetux-password-input input,.grommet .grommetux-form-field__contents>.grommetux-search-input input,.grommet .grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input{display:block;width:100%;border:none;border-radius:0;font-size:16px;font-size:1rem;line-height:1.5;padding:6px 24px 11px;margin-bottom:-5px;padding-left:24px;padding-bottom:11px}.grommet .grommetux-form-field__contents>.grommetux-calendar input:focus,.grommet .grommetux-form-field__contents>.grommetux-date-time input:focus,.grommet .grommetux-form-field__contents>.grommetux-password-input input:focus,.grommet .grommetux-form-field__contents>.grommetux-search-input input:focus,.grommet .grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input:focus{padding:6px 24px 11px}.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-calendar input,.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-date-time input,.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-password-input input,.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-search-input input,.grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-calendar input,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-date-time input,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-password-input input,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-search-input input,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommet .grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-calendar input,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-date-time input,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-password-input input,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-search-input input,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input,.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-calendar input,.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-date-time input,.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-password-input input,.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-search-input input,.grommetux-background-color-index--light .grommet .grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input{color:#333}.grommet .grommetux-form-field__contents>.grommetux-calendar input:focus,.grommet .grommetux-form-field__contents>.grommetux-date-time input:focus,.grommet .grommetux-form-field__contents>.grommetux-password-input input:focus,.grommet .grommetux-form-field__contents>.grommetux-search-input input:focus,.grommet .grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input:focus{padding-bottom:11px}.grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) .grommetux-select__value{border:none}.grommetux-form-field__contents>.grommetux-calendar input,.grommetux-form-field__contents>.grommetux-date-time input,.grommetux-form-field__contents>.grommetux-password-input input,.grommetux-form-field__contents>.grommetux-search-input input,.grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input,.grommetux-form-field__contents>.grommetux-text-input,.grommetux-form-field__contents>input:not([type]),.grommetux-form-field__contents>input[type=color],.grommetux-form-field__contents>input[type=email],.grommetux-form-field__contents>input[type=file],.grommetux-form-field__contents>input[type=number],.grommetux-form-field__contents>input[type=password],.grommetux-form-field__contents>input[type=range],.grommetux-form-field__contents>input[type=tel],.grommetux-form-field__contents>input[type=text],.grommetux-form-field__contents>input[type=url],.grommetux-form-field__contents>select{height:41px}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-form-field__contents>.grommetux-calendar input,.grommetux-form-field__contents>.grommetux-date-time input,.grommetux-form-field__contents>.grommetux-password-input input,.grommetux-form-field__contents>.grommetux-search-input input,.grommetux-form-field__contents>.grommetux-select:not(.grommetux-select--inline) input,.grommetux-form-field__contents>.grommetux-text-input,.grommetux-form-field__contents>input:not([type]),.grommetux-form-field__contents>input[type=color],.grommetux-form-field__contents>input[type=email],.grommetux-form-field__contents>input[type=file],.grommetux-form-field__contents>input[type=number],.grommetux-form-field__contents>input[type=password],.grommetux-form-field__contents>input[type=range],.grommetux-form-field__contents>input[type=tel],.grommetux-form-field__contents>input[type=text],.grommetux-form-field__contents>input[type=url],.grommetux-form-field__contents>select{line-height:normal}}.grommetux-form-field__contents>input[type=range]{width:calc(100% - 48px);margin-left:24px;margin-right:24px;padding-left:0;padding-right:0}.grommetux-form-field__contents>input::-ms-clear{display:none}.grommetux-form-field__contents>select{display:block;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAcBJREFUSA3tUz9IAmEU9+7gNv8MLo7NrXpwYFtLhrQWbQWpoEuRs2MZNYnoUHNES0RNLS0hhxANzkFBLg5Jk4ee/X7iF+d5lyIIBX5wfO99v9/vve/ee5/Pt1iLCvz5CkipVOqu3+8n5nFTSZLuZVVVtxC8MYcEjWAwuCkxcDabXTJN04AZRtazarV6MEtCVOMU1diHtoWLa6VS6VVhIMMwPjVNqwHchhuPxWLv9Xr9mdi0K51O70B/BL6pKMp6uVx+oXaQgAYCviHwB0gb+NaQ8JFnxCatTCazYlnWFXiKLMt7lUrlRmh+EvCAt45GowGYcSRJ6rp+zb8TZLed5e12uw/A/MPyHtt5st2hHYlEDtl9mGH05Tafz/udHOETI4dcaqgVmNjHEhQKBYvdB4GTtdxuty9x5saTiZFDLjXUwh5ZY0KixWLxC1OQhNlCqRLNZvNkRAWHZ8TIIZcaJ4f+SA/shN8my2ti7HphD96BcNx2BsOEnAPj+K2S0+v12FQVE7OLibngmdeamIBC+wMaBpr6Qbr2wHkb+2QB85wYp47+VH9AYi6XC3Q6nSfaoVBI92oq8ZkXHxW/mQP8S+E3ZIDJn85FDg8AAAAASUVORK5CYII=);padding-right:48px;background-position:center right 18px}.grommetux-form-field__contents>select:focus{padding-right:48px}.grommetux-form-field__contents>select,.grommetux-form-field__contents>select:focus,.grommetux-form-field__contents>select _:-moz-tree-row(hover){padding-left:21px}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-form-field__contents>select,.grommetux-form-field__contents>select:focus{padding-left:22px}.grommetux-background-color-index--dark .grommetux-form-field__contents>select:focus option,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-form-field__contents>select:focus option{color:#333}}html.rtl .grommetux-form-field__contents>select{background-position:center left 18px}.grommetux-background-color-index--dark .grommetux-form-field__contents>select,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-form-field__contents>select{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAASVJREFUSA3tlDGOwjAQRWNKCmoqLpByz0DPFVbcgQ4JiW77LREVNUicg0vsESi2JLwfDcramQQLCWmFsPRDZub/b8ceUxTv8d6Bf78DoaqqFav8eNJKTwOMv8DPEyaQp7yLgq8Ygx04gnmdfOAhrXnIaxxZkCjB3gjTqJgRoJuaVh6lK8kiOUoZgrzFQez+TN+8d3t1yOnYkjiBEVgy4TAl3GKrLY0rjbTRaE0QQrjAuHXWhPcFRi2e5RbUxak7xrSEzWgJVYL4y88anIHuyCdIh3KqibM2Tcrpj1mle3jk73dMv3VTTc26Jm0U8VuIQz/CVJdvBrQdGmqAA9uyqaOeh3sGDv9vZ8nc7RhHl5/iK4bg29DZuvmODhNzXar4P8bhvVbqCvor5P4CpWjxAAAAAElFTkSuQmCC)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-form-field__contents>select,.grommetux-background-color-index--light .grommetux-form-field__contents>select{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAcBJREFUSA3tUz9IAmEU9+7gNv8MLo7NrXpwYFtLhrQWbQWpoEuRs2MZNYnoUHNES0RNLS0hhxANzkFBLg5Jk4ee/X7iF+d5lyIIBX5wfO99v9/vve/ee5/Pt1iLCvz5CkipVOqu3+8n5nFTSZLuZVVVtxC8MYcEjWAwuCkxcDabXTJN04AZRtazarV6MEtCVOMU1diHtoWLa6VS6VVhIMMwPjVNqwHchhuPxWLv9Xr9mdi0K51O70B/BL6pKMp6uVx+oXaQgAYCviHwB0gb+NaQ8JFnxCatTCazYlnWFXiKLMt7lUrlRmh+EvCAt45GowGYcSRJ6rp+zb8TZLed5e12uw/A/MPyHtt5st2hHYlEDtl9mGH05Tafz/udHOETI4dcaqgVmNjHEhQKBYvdB4GTtdxuty9x5saTiZFDLjXUwh5ZY0KixWLxC1OQhNlCqRLNZvNkRAWHZ8TIIZcaJ4f+SA/shN8my2ti7HphD96BcNx2BsOEnAPj+K2S0+v12FQVE7OLibngmdeamIBC+wMaBpr6Qbr2wHkb+2QB85wYp47+VH9AYi6XC3Q6nSfaoVBI92oq8ZkXHxW/mQP8S+E3ZIDJn85FDg8AAAAASUVORK5CYII=)}.grommetux-form-field__contents>select:-moz-focusring{color:transparent;text-shadow:0 0 0 #000}.grommetux-form-field__contents>select::-ms-expand{display:none}.grommetux-form-field__contents>select::-ms-value{background:none;color:inherit}.grommetux-form-field__contents>.grommetux-select .grommetux-select__options{margin-left:24px;margin-right:24px}.grommetux-form-field__contents>textarea{vertical-align:top;height:auto;resize:vertical}.grommetux-form-field__contents>.grommetux-check-box,.grommetux-form-field__contents>.grommetux-radio-button{display:block;font-size:16px;font-size:1rem;line-height:1.5;margin:5px 24px}.grommetux-form-field__contents>.grommetux-calendar,.grommetux-form-field__contents>.grommetux-date-time,.grommetux-form-field__contents>.grommetux-search-input{display:block}.grommetux-form-field__contents>.grommetux-calendar input,.grommetux-form-field__contents>.grommetux-date-time input,.grommetux-form-field__contents>.grommetux-search-input input{margin-left:0;margin-right:0}.grommetux-form-field__contents>.grommetux-calendar .grommetux-calendar__control,.grommetux-form-field__contents>.grommetux-calendar .grommetux-date-time__control,.grommetux-form-field__contents>.grommetux-calendar .grommetux-search-input__control,.grommetux-form-field__contents>.grommetux-date-time .grommetux-calendar__control,.grommetux-form-field__contents>.grommetux-date-time .grommetux-date-time__control,.grommetux-form-field__contents>.grommetux-date-time .grommetux-search-input__control,.grommetux-form-field__contents>.grommetux-search-input .grommetux-calendar__control,.grommetux-form-field__contents>.grommetux-search-input .grommetux-date-time__control,.grommetux-form-field__contents>.grommetux-search-input .grommetux-search-input__control{top:auto;right:6px;transform:none;bottom:0}html.rtl .grommetux-form-field__contents>.grommetux-calendar .grommetux-calendar__control,html.rtl .grommetux-form-field__contents>.grommetux-calendar .grommetux-date-time__control,html.rtl .grommetux-form-field__contents>.grommetux-calendar .grommetux-search-input__control,html.rtl .grommetux-form-field__contents>.grommetux-date-time .grommetux-calendar__control,html.rtl .grommetux-form-field__contents>.grommetux-date-time .grommetux-date-time__control,html.rtl .grommetux-form-field__contents>.grommetux-date-time .grommetux-search-input__control,html.rtl .grommetux-form-field__contents>.grommetux-search-input .grommetux-calendar__control,html.rtl .grommetux-form-field__contents>.grommetux-search-input .grommetux-date-time__control,html.rtl .grommetux-form-field__contents>.grommetux-search-input .grommetux-search-input__control{right:auto;left:6px}.grommetux-form-field__contents>.grommetux-calendar .grommetux-calendar__control>.grommetux-button__icon,.grommetux-form-field__contents>.grommetux-calendar .grommetux-date-time__control>.grommetux-button__icon,.grommetux-form-field__contents>.grommetux-calendar .grommetux-search-input__control>.grommetux-button__icon,.grommetux-form-field__contents>.grommetux-date-time .grommetux-calendar__control>.grommetux-button__icon,.grommetux-form-field__contents>.grommetux-date-time .grommetux-date-time__control>.grommetux-button__icon,.grommetux-form-field__contents>.grommetux-date-time .grommetux-search-input__control>.grommetux-button__icon,.grommetux-form-field__contents>.grommetux-search-input .grommetux-calendar__control>.grommetux-button__icon,.grommetux-form-field__contents>.grommetux-search-input .grommetux-date-time__control>.grommetux-button__icon,.grommetux-form-field__contents>.grommetux-search-input .grommetux-search-input__control>.grommetux-button__icon{padding:9px}.grommetux-form-field__contents>.grommetux-number-input{display:flex;padding-right:6px}html.rtl .grommetux-form-field__contents>.grommetux-number-input{padding-right:0;padding-left:6px}.grommetux-form-field__contents>.grommetux-number-input input[type=number]{display:inline-block;flex:1;flex-basis:inherit;width:0;border:none;padding:0 24px}.grommetux-form-field__contents>.grommetux-number-input input[type=number]:focus{padding:0 24px}.grommetux-form--compact .grommetux-form-field__contents>.grommetux-number-input input[type=number]{min-width:72px}.grommetux-form-field__contents>input[type=file]{display:inline-block}.grommetux-form-field__contents>.grommetux-table--selectable{font-size:16px;font-size:1rem;line-height:1.5}.grommetux-form-field__contents>.grommetux-table--selectable table{margin-bottom:0}.grommetux-form-field__contents>.grommetux-table--selectable table td:first-child,.grommetux-form-field__contents>.grommetux-table--selectable table th:first-child{padding-left:24px}.grommetux-form-field__contents>.grommetux-form-field{width:auto;margin-top:12px;border:none}.grommetux-form-field__contents>.grommetux-form-field>.grommetux-form-field__label{border-top:1px solid rgba(0,0,0,.15);padding-top:5px}.grommetux-form-field__contents--hidden{margin-top:0}.grommetux-form-field__help{display:block;font-size:14px;font-size:.875rem;line-height:1.71429;color:#666}.grommetux-background-color-index--dark .grommetux-form-field__help,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-form-field__help{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-form-field__help,.grommetux-background-color-index--light .grommetux-form-field__help{color:#666}.grommetux-form-field__error{display:block;float:right;color:#f04953;line-height:24px}html.rtl .grommetux-form-field__error{float:left}.grommetux-background-color-index--dark .grommetux-form-field__error,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-form-field__error{color:#f59f9f}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-form-field__error,.grommetux-background-color-index--light .grommetux-form-field__error{color:#f04953}.grommetux-form-field--text,.grommetux-form-field--text .grommetux-form-field__label{cursor:pointer}@media screen and (max-width:44.9375em){.grommetux-form-field--hidden{display:none}}@media screen and (min-width:45em){.grommetux-form-field--hidden{border:none;margin-bottom:0;padding-top:0;padding-bottom:0;opacity:0;overflow:hidden;max-height:0;transition:max-height .2s,all .4s}}.grommetux-form-field--error{z-index:1;border-color:#f04953}.grommetux-background-color-index--dark .grommetux-form-field--error,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-form-field--error{border-color:#f59f9f}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-form-field--error,.grommetux-background-color-index--light .grommetux-form-field--error{border-color:#f04953}.grommetux-form-field--focus{z-index:2;border-color:#2ad2c9}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-form-field--focus,.grommetux-background-color-index--dark .grommetux-form-field--focus,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-form-field--focus,.grommetux-background-color-index--light .grommetux-form-field--focus{border-color:#2ad2c9}.grommetux-form-field--size-large{font-size:24px}.grommetux-form-field--size-large input:not([type]),.grommetux-form-field--size-large input[type=text]{font-size:24px;height:auto}.grommetux-form-field--strong input:not([type]),.grommetux-form-field--strong input[type=text]{font-weight:600}.grommetux-header{min-height:72px;width:100%;margin-bottom:0}.grommetux-header .grommetux-status-icon{flex-grow:0;flex-shrink:0}.grommetux-header--large{min-height:96px}.grommetux-header--small{min-height:48px}.grommetux-header--splash{transform:translateY(40vh)}:not(.grommetux-header__container--float)>header.grommetux-header--float{position:absolute;top:0;left:0;right:0}header.grommetux-header--primary .grommetux-header__wrapper{border-bottom:none}.grommetux-header:not(header).grommetux-box--separator-top{padding-top:6px}.grommetux-header:not(header).grommetux-box--separator-bottom{padding-bottom:6px}.grommetux-header__container{flex-shrink:0}.grommetux-header__container--fill .grommetux-header{background-color:hsla(0,0%,100%,.9)}.grommetux-header__container--fixed{position:relative}.grommetux-header__container--fixed .grommetux-header__wrapper{position:absolute;top:0;left:0;right:0;z-index:50}@media screen and (min-width:45em){.grommetux-header__container--fixed .grommetux-header__wrapper .grommetux-header{position:fixed}}.grommetux-header__container--float{position:absolute;top:0;left:0;right:0}.grommetux-header__wrapper{height:72px}.grommetux-header__wrapper--large{height:96px}.grommetux-header__wrapper--small{height:48px}.grommetux-header--fixed .grommetux-header__wrapper{position:absolute;top:0;left:0;right:0;background-color:hsla(0,0%,100%,.9);z-index:3}.grommetux-header--fixed.grommetux-header--primary .grommetux-header__wrapper{position:fixed;background-color:hsla(0,0%,100%,.9)}.grommetux-header--fixed.grommetux-header--primary .grommetux-header__content{position:static;background-color:transparent}.grommetux-header--flush .grommetux-header__wrapper{padding-left:0;padding-right:0}@media screen and (min-width:45em){h1.grommetux-heading{font-size:48px;font-size:3rem;line-height:1.125}}@media screen and (max-width:44.9375em){h1.grommetux-heading{font-size:36px;font-size:2.25rem;line-height:1.125}}@media screen and (min-width:45em){h2.grommetux-heading{font-size:36px;font-size:2.25rem;line-height:1.23}}@media screen and (max-width:44.9375em){h2.grommetux-heading{font-size:30px;font-size:1.875rem;line-height:1.23}}h3.grommetux-heading{font-size:24px;line-height:1.333}h4.grommetux-heading{font-size:18px;line-height:1.333}h5.grommetux-heading,h6.grommetux-heading{font-size:16px;line-height:1.375}.grommetux-heading{font-weight:100;max-width:100%;margin-bottom:12px}.grommetux-heading .grommetux-anchor,.grommetux-heading a{color:inherit;text-decoration:none}.grommetux-heading .grommetux-anchor:hover,.grommetux-heading a:hover{text-decoration:none}.grommetux-heading--align-start{text-align:left}html.rtl .grommetux-heading--align-start{text-align:right}.grommetux-heading--align-center{text-align:center}.grommetux-heading--align-end{text-align:right}html.rtl .grommetux-heading--align-end{text-align:left}.grommetux-heading--margin-none{margin-top:0;margin-bottom:0}.grommetux-heading--margin-small{margin-top:12px;margin-bottom:12px}.grommetux-heading--margin-medium{margin-top:24px;margin-bottom:24px}.grommetux-heading--margin-large{margin-top:48px;margin-bottom:48px}.grommetux-heading--large{font-size:125%}.grommetux-heading--small{font-size:75%}.grommetux-heading--strong{font-weight:600}.grommetux-heading--truncate{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.grommetux-heading--uppercase{text-transform:uppercase;letter-spacing:.2em}.grommetux-headline{font-weight:100;margin-bottom:24px;max-width:100%}.grommetux-headline--align-start{text-align:left}html.rtl .grommetux-headline--align-start{text-align:right}.grommetux-headline--align-center{text-align:center}.grommetux-headline--align-end{text-align:right}html.rtl .grommetux-headline--align-end{text-align:left}.grommetux-headline--margin-none{margin-top:0;margin-bottom:0}.grommetux-headline--margin-small{margin-top:12px;margin-bottom:12px}.grommetux-headline--margin-medium{margin-top:24px;margin-bottom:24px}.grommetux-headline--margin-large{margin-top:48px;margin-bottom:48px}@media screen and (min-width:45em){.grommetux-headline{font-size:64px;font-size:4rem;line-height:1}}@media screen and (max-width:44.9375em){.grommetux-headline{font-size:48px;font-size:3rem;line-height:1}}.grommetux-headline--small{font-size:30px;font-size:1.875rem;line-height:1}@media screen and (min-width:45em){.grommetux-headline--large{font-size:96px;font-size:6rem;line-height:1}}@media screen and (max-width:44.9375em){.grommetux-headline--large{font-size:60px;font-size:3.75rem;line-height:1}}@media screen and (min-width:45em){.grommetux-headline--xlarge{font-size:192px;font-size:12rem;line-height:1}}@media screen and (max-width:44.9375em){.grommetux-headline--xlarge{font-size:72px;font-size:4.5rem;line-height:1}}.grommetux-headline--strong{font-weight:600}.grommetux-hero:not(.grommetux-hero--stack){position:relative;overflow:hidden;display:flex;flex-direction:row;align-items:center}.grommetux-hero:not(.grommetux-hero--stack) .grommetux-hero__background{position:absolute;top:0;left:0;bottom:0;right:0;z-index:0}.grommetux-hero:not(.grommetux-hero--stack) .grommetux-hero__foreground{z-index:1;flex:1 1}.grommetux-hero:not(.grommetux-hero--stack).grommetux-hero--small{min-height:40vh}.grommetux-hero:not(.grommetux-hero--stack).grommetux-hero--small .grommetux-hero__overlay.grommetux-box{height:60vh}.grommetux-hero:not(.grommetux-hero--stack).grommetux-hero--medium{min-height:60vh}.grommetux-hero:not(.grommetux-hero--stack).grommetux-hero--large{min-height:75vh}.grommetux-hero:not(.grommetux-hero--stack).grommetux-hero--large .grommetux-hero__overlay.grommetux-box{height:75vh}.grommetux-hero.grommetux-hero--stack .grommetux-hero__background{position:relative;overflow:hidden}.grommetux-hero.grommetux-hero--stack .grommetux-hero--small .grommetux-hero__background{height:20vh}.grommetux-hero.grommetux-hero--stack .grommetux-hero--small .grommetux-hero__image{height:270px}.grommetux-hero.grommetux-hero--stack.grommetux-hero--medium .grommetux-hero__background{height:40vh}.grommetux-hero.grommetux-hero--stack.grommetux-hero--large .grommetux-hero__background{height:60vh}.grommetux-hero.grommetux-hero--stack.grommetux-hero--large .grommetux-hero__image{height:300px}.grommetux-hero__background-video{overflow:hidden}.grommetux-hero__background-video .grommetux-video{min-height:100%;position:absolute;left:0;right:0;top:50%;transform:translateY(-50%)}.grommetux-hero__background-video .grommetux-video:before{content:\"\";display:block;height:0;padding-bottom:57%}.grommetux-hero__background-video .grommetux-video video{width:auto;height:100%;position:absolute;top:0;left:50%;transform:translate(-50%)}@media screen and (max-width:44.9375em){.grommetux-hero--bg-left>.grommetux-hero__background{background-position:0 0}}@media screen and (max-width:44.9375em){.grommetux-hero--bg-right>.grommetux-hero__background{background-position:100% 0}}.grommetux-hero__overlay.grommetux-box{z-index:1}.grommetux-hero__overlay.grommetux-box>.grommetux-box{width:50%}@media screen and (max-width:44.9375em){.grommetux-hero__overlay.grommetux-box>.grommetux-box{width:100%}}@media screen and (max-width:44.9375em){.grommetux-hero--mobile-separator{border-bottom:1px solid rgba(0,0,0,.15);margin-bottom:24px}}.grommetux-control-icon{display:inline-block;width:24px;height:24px;fill:#666;stroke:#666;flex:0 0 auto}.grommetux-control-icon g{fill:inherit}.grommetux-control-icon:not([class*=color-index-plain]) :not([stroke])[fill=none]{stroke-width:0}.grommetux-control-icon:not([class*=color-index-plain]) [stroke*=\"#\"],.grommetux-control-icon:not([class*=color-index-plain]) [STROKE*=\"#\"]{stroke:inherit}.grommetux-control-icon:not([class*=color-index-plain]) [fill*=\"#\"],.grommetux-control-icon:not([class*=color-index-plain]) [FILL*=\"#\"]{fill:inherit}.grommetux-control-icon:not([class*=color-index-plain]) [fill-rule]{stroke:none}.grommetux-background-color-index--dark .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-control-icon{fill:hsla(0,0%,100%,.7);stroke:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-control-icon{fill:#666;stroke:#666}.grommetux-control-icon.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-control-icon.grommetux-color-index-unset{stroke:#ddd}.grommetux-control-icon.grommetux-color-index-brand{stroke:#01a982}.grommetux-control-icon.grommetux-color-index-critical,.grommetux-control-icon.grommetux-color-index-error{stroke:#f04953}.grommetux-control-icon.grommetux-color-index-warning{stroke:#ffd144}.grommetux-control-icon.grommetux-color-index-ok{stroke:#01a982}.grommetux-control-icon.grommetux-color-index-disabled,.grommetux-control-icon.grommetux-color-index-unknown{stroke:#ccc}.grommetux-control-icon.grommetux-color-index-graph-1,.grommetux-control-icon.grommetux-color-index-graph-5{stroke:#425563}.grommetux-control-icon.grommetux-color-index-graph-2,.grommetux-control-icon.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-control-icon.grommetux-color-index-graph-3,.grommetux-control-icon.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-control-icon.grommetux-color-index-graph-4,.grommetux-control-icon.grommetux-color-index-graph-8{stroke:#767676}.grommetux-control-icon.grommetux-color-index-grey-1,.grommetux-control-icon.grommetux-color-index-grey-6{stroke:#000001}.grommetux-control-icon.grommetux-color-index-grey-2,.grommetux-control-icon.grommetux-color-index-grey-7{stroke:#333}.grommetux-control-icon.grommetux-color-index-grey-3,.grommetux-control-icon.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-control-icon.grommetux-color-index-grey-4,.grommetux-control-icon.grommetux-color-index-grey-9{stroke:#434343}.grommetux-control-icon.grommetux-color-index-grey-5,.grommetux-control-icon.grommetux-color-index-grey-10{stroke:#666}.grommetux-control-icon.grommetux-color-index-accent-1,.grommetux-control-icon.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-control-icon.grommetux-color-index-accent-2,.grommetux-control-icon.grommetux-color-index-accent-5{stroke:#614767}.grommetux-control-icon.grommetux-color-index-accent-3,.grommetux-control-icon.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-control-icon.grommetux-color-index-neutral-1,.grommetux-control-icon.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-control-icon.grommetux-color-index-neutral-2,.grommetux-control-icon.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-control-icon.grommetux-color-index-neutral-3,.grommetux-control-icon.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-control-icon.grommetux-color-index-neutral-4,.grommetux-control-icon.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-control-icon.grommetux-color-index-light-1,.grommetux-control-icon.grommetux-color-index-light-3{stroke:#fff}.grommetux-control-icon.grommetux-color-index-light-2,.grommetux-control-icon.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-control-icon.grommetux-color-index-unset{fill:#ddd}.grommetux-control-icon.grommetux-color-index-brand{fill:#01a982}.grommetux-control-icon.grommetux-color-index-critical,.grommetux-control-icon.grommetux-color-index-error{fill:#f04953}.grommetux-control-icon.grommetux-color-index-warning{fill:#ffd144}.grommetux-control-icon.grommetux-color-index-ok{fill:#01a982}.grommetux-control-icon.grommetux-color-index-disabled,.grommetux-control-icon.grommetux-color-index-unknown{fill:#ccc}.grommetux-control-icon.grommetux-color-index-graph-1,.grommetux-control-icon.grommetux-color-index-graph-5{fill:#425563}.grommetux-control-icon.grommetux-color-index-graph-2,.grommetux-control-icon.grommetux-color-index-graph-6{fill:#5f7a76}.grommetux-control-icon.grommetux-color-index-graph-3,.grommetux-control-icon.grommetux-color-index-graph-7{fill:#80746e}.grommetux-control-icon.grommetux-color-index-graph-4,.grommetux-control-icon.grommetux-color-index-graph-8{fill:#767676}.grommetux-control-icon.grommetux-color-index-accent-1,.grommetux-control-icon.grommetux-color-index-accent-4{fill:#2ad2c9}.grommetux-control-icon.grommetux-color-index-accent-2,.grommetux-control-icon.grommetux-color-index-accent-5{fill:#614767}.grommetux-control-icon.grommetux-color-index-accent-3,.grommetux-control-icon.grommetux-color-index-accent-6{fill:#ff8d6d}.grommetux-control-icon.grommetux-color-index-grey-1,.grommetux-control-icon.grommetux-color-index-grey-6{fill:#000001}.grommetux-control-icon.grommetux-color-index-grey-2,.grommetux-control-icon.grommetux-color-index-grey-7{fill:#333}.grommetux-control-icon.grommetux-color-index-grey-3,.grommetux-control-icon.grommetux-color-index-grey-8{fill:#3b3b3b}.grommetux-control-icon.grommetux-color-index-grey-4,.grommetux-control-icon.grommetux-color-index-grey-9{fill:#434343}.grommetux-control-icon.grommetux-color-index-grey-5,.grommetux-control-icon.grommetux-color-index-grey-10{fill:#666}@media screen and (min-width:45em){.grommetux-control-icon{transition:all .3s ease-in-out}}.grommetux-control-icon__badge circle{fill:#2ad2c9}.grommetux-control-icon__badge text{stroke:#333;fill:#333}.grommetux-control-icon--active{fill:#000;stroke:#000}.grommetux-control-icon--xsmall{width:12px;height:12px}.grommetux-control-icon--medium{width:36px;height:36px}.grommetux-control-icon--large{width:48px;height:48px}.grommetux-control-icon--xlarge{width:144px;height:144px}.grommetux-control-icon--huge{width:288px;height:288px}@media screen and (max-width:44.9375em){.grommetux-control-icon--responsive.grommetux-control-icon--huge,.grommetux-control-icon--responsive.grommetux-control-icon--large,.grommetux-control-icon--responsive.grommetux-control-icon--xlarge{width:24px;height:24px}}.grommetux-status-icon{width:24px;height:24px;vertical-align:middle;flex:0 0 auto}.grommetux-status-icon .grommetux-status-icon__base{fill:#ccc}.grommetux-background-color-index--dark .grommetux-status-icon .grommetux-status-icon__base,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-status-icon .grommetux-status-icon__base{fill:icon-color(hsla(0,0%,100%,.9))}.grommetux-status-icon .grommetux-status-icon__detail{fill:#fff;stroke:#fff}.grommetux-status-icon .grommetux-status-icon__small{display:none;stroke:#ccc}.grommetux-background-color-index--dark .grommetux-status-icon .grommetux-status-icon__small,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-status-icon .grommetux-status-icon__small{stroke:hsla(0,0%,100%,.9)}.grommetux-status-icon-label .grommetux-status-icon__base{fill:#ccc}.grommetux-status-icon-unknown .grommetux-status-icon__detail{fill:#ccc;stroke:#ccc}.grommetux-status-icon--xsmall{width:12px;height:12px}.grommetux-status-icon--medium{width:36px;height:36px}.grommetux-status-icon--large{width:48px;height:48px}.grommetux-status-icon--xlarge{width:144px;height:144px}.grommetux-status-icon--huge{width:288px;height:288px}.grommetux-status-icon--small{width:12px;height:12px;margin-top:6px;margin-bottom:6px}.grommetux-status-icon--small .grommetux-status-icon__base{mask:none}.grommetux-status-icon--small .grommetux-status-icon__detail,.grommetux-status-icon--small .grommetux-status-icon__normal{display:none}.grommetux-status-icon--small .grommetux-status-icon__small{display:block}.grommetux-status-icon-critical .grommetux-status-icon__base,.grommetux-status-icon-error .grommetux-status-icon__base{fill:#f04953}.grommetux-status-icon-warning .grommetux-status-icon__base{fill:#ffd144}.grommetux-status-icon-ok .grommetux-status-icon__base{fill:#01a982}.grommetux-status-icon-disabled .grommetux-status-icon__base,.grommetux-status-icon-unknown .grommetux-status-icon__base{fill:#ccc}@keyframes drawAndReverse{0%{stroke-dashoffset:151px}to{stroke-dashoffset:-131px}}@keyframes fadeOut{0%{opacity:1;transform:rotate(0deg)}50%{opacity:.75}to{opacity:1;transform:rotate(1turn)}}.grommetux-icon-spinning{width:24px;height:24px;stroke-dasharray:151px 151px;stroke-dashoffset:0;transform:rotate(90deg);animation:drawAndReverse 4s alternate infinite ease-in-out}@media (-ms-high-contrast:none){.grommetux-icon-spinning{transform:rotate(0deg);stroke-dashoffset:50;animation:fadeOut 3s infinite linear}}.grommetux-icon-spinning--xsmall{width:12px;height:12px}.grommetux-icon-spinning--medium{width:36px;height:36px}.grommetux-icon-spinning--large{width:48px;height:48px}.grommetux-icon-spinning--xlarge{width:144px;height:144px}.grommetux-icon-spinning--huge{width:288px;height:288px}@media screen and (max-width:44.9375em){.grommetux-icon-spinning--huge.grommetux-icon-spinning--responsive,.grommetux-icon-spinning--xlarge.grommetux-icon-spinning--responsive{width:48px;height:48px}}@keyframes draw-logo{0%{stroke-dashoffset:768px}to{stroke-dashoffset:0}}.grommetux-logo-icon{width:48px;height:48px}.grommetux-logo-icon.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-logo-icon.grommetux-color-index-unset{stroke:#ddd}.grommetux-logo-icon.grommetux-color-index-brand{stroke:#01a982}.grommetux-logo-icon.grommetux-color-index-critical,.grommetux-logo-icon.grommetux-color-index-error{stroke:#f04953}.grommetux-logo-icon.grommetux-color-index-warning{stroke:#ffd144}.grommetux-logo-icon.grommetux-color-index-ok{stroke:#01a982}.grommetux-logo-icon.grommetux-color-index-disabled,.grommetux-logo-icon.grommetux-color-index-unknown{stroke:#ccc}.grommetux-logo-icon.grommetux-color-index-graph-1,.grommetux-logo-icon.grommetux-color-index-graph-5{stroke:#425563}.grommetux-logo-icon.grommetux-color-index-graph-2,.grommetux-logo-icon.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-logo-icon.grommetux-color-index-graph-3,.grommetux-logo-icon.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-logo-icon.grommetux-color-index-graph-4,.grommetux-logo-icon.grommetux-color-index-graph-8{stroke:#767676}.grommetux-logo-icon.grommetux-color-index-grey-1,.grommetux-logo-icon.grommetux-color-index-grey-6{stroke:#000001}.grommetux-logo-icon.grommetux-color-index-grey-2,.grommetux-logo-icon.grommetux-color-index-grey-7{stroke:#333}.grommetux-logo-icon.grommetux-color-index-grey-3,.grommetux-logo-icon.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-logo-icon.grommetux-color-index-grey-4,.grommetux-logo-icon.grommetux-color-index-grey-9{stroke:#434343}.grommetux-logo-icon.grommetux-color-index-grey-5,.grommetux-logo-icon.grommetux-color-index-grey-10{stroke:#666}.grommetux-logo-icon.grommetux-color-index-accent-1,.grommetux-logo-icon.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-logo-icon.grommetux-color-index-accent-2,.grommetux-logo-icon.grommetux-color-index-accent-5{stroke:#614767}.grommetux-logo-icon.grommetux-color-index-accent-3,.grommetux-logo-icon.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-logo-icon.grommetux-color-index-neutral-1,.grommetux-logo-icon.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-logo-icon.grommetux-color-index-neutral-2,.grommetux-logo-icon.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-logo-icon.grommetux-color-index-neutral-3,.grommetux-logo-icon.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-logo-icon.grommetux-color-index-neutral-4,.grommetux-logo-icon.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-logo-icon.grommetux-color-index-light-1,.grommetux-logo-icon.grommetux-color-index-light-3{stroke:#fff}.grommetux-logo-icon.grommetux-color-index-light-2,.grommetux-logo-icon.grommetux-color-index-light-4{stroke:#f5f5f5}@media screen and (min-width:45em){.grommetux-logo-icon path{stroke-dasharray:768px 768px;stroke-dashoffset:0;animation:draw-logo 2.5s linear}}.grommetux-logo-icon--small{width:24px;height:24px}.grommetux-logo-icon--large{width:96px;height:96px}.grommetux-logo-icon--xlarge{width:192px;height:192px}.grommetux-logo-icon--huge{width:384px;height:384px}.right-left-icon--left{display:none}html.rtl .right-left-icon--left{display:inline}html.rtl .right-left-icon--right{display:none}.grommetux-image{max-width:100%}.grommetux-image--small{width:192px}.grommetux-image--medium{width:384px}.grommetux-image--large{width:576px}.grommetux-image--thumb{width:48px;height:48px;flex:0 0 auto;object-fit:cover}.grommetux-image--thumb.grommetux-image--mask{border-radius:24px}.grommetux-image--cover{object-fit:cover}.grommetux-image--contain{object-fit:contain}.grommetux-image--full{width:100%;height:100%;min-width:100%;min-height:100%}.grommetux-image--align-top.grommetux-image--align-left{object-position:0 0}.grommetux-image--align-top.grommetux-image--align-right{object-position:100% 0}.grommetux-image--align-top:not(.grommetux-image--align-left):not(.grommetux-image--align-right){object-position:50% 0}.grommetux-image--align-bottom.grommetux-image--align-left{object-position:0 100%}.grommetux-image--align-bottom.grommetux-image--align-right{object-position:100% 100%}.grommetux-image--align-bottom:not(.grommetux-image--align-left):not(.grommetux-image--align-right){object-position:50% 100%}.grommetux-image--align-left:not(.grommetux-image--align-top):not(.grommetux-image--align-bottom){object-position:0 50%}.grommetux-image--align-right:not(.grommetux-image--align-top):not(.grommetux-image--align-bottom){object-position:100% 50%}.grommetux-image--full-horizontal{width:100%}.grommetux-image--full-vertical{height:100%}.grommetux-image__container{display:flex;flex-direction:column}.grommetux-image__caption{text-align:center;padding:12px}.grommetux-image__caption--small{max-width:192px}.grommetux-image__caption--medium{max-width:384px}.grommetux-image__caption--large{max-width:576px}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-image--full{width:auto;height:auto;max-width:none;position:relative;top:50%;left:50%;transform:translate(-50%,-50%)}.grommetux-image--align-top.grommetux-image--align-left{top:0;left:0;transform:none}.grommetux-image--align-top.grommetux-image--align-right{top:0;left:100%;transform:translate(-100%)}.grommetux-image--align-top:not(.grommetux-image--align-left):not(.grommetux-image--align-right){top:0;left:50%;transform:translateX(-50%)}.grommetux-image--align-bottom.grommetux-image--align-left{top:100%;left:0;transform:translateY(-100%)}.grommetux-image--align-bottom.grommetux-image--align-right{top:100%;left:100%;transform:translate(-100%,-100%)}.grommetux-image--align-bottom:not(.grommetux-image--align-left):not(.grommetux-image--align-right){top:100%;left:50%;transform:translate(-50%,-100%)}.grommetux-image--align-left:not(.grommetux-image--align-top):not(.grommetux-image--align-bottom){top:50%;left:0;transform:translateY(-50%)}.grommetux-image--align-right:not(.grommetux-image--align-top):not(.grommetux-image--align-bottom){top:50%;left:100%;transform:translate(-100%,-50%)}}@supports (-ms-ime-align:auto){.grommetux-image--full{width:auto;height:auto;max-width:none;position:relative;top:50%;left:50%;transform:translate(-50%,-50%)}.grommetux-image--align-top.grommetux-image--align-left{top:0;left:0;transform:none}.grommetux-image--align-top.grommetux-image--align-right{top:0;left:100%;transform:translate(-100%)}.grommetux-image--align-top:not(.grommetux-image--align-left):not(.grommetux-image--align-right){top:0;left:50%;transform:translateX(-50%)}.grommetux-image--align-bottom.grommetux-image--align-left{top:100%;left:0;transform:translateY(-100%)}.grommetux-image--align-bottom.grommetux-image--align-right{top:100%;left:100%;transform:translate(-100%,-100%)}.grommetux-image--align-bottom:not(.grommetux-image--align-left):not(.grommetux-image--align-right){top:100%;left:50%;transform:translate(-50%,-100%)}.grommetux-image--align-left:not(.grommetux-image--align-top):not(.grommetux-image--align-bottom){top:50%;left:0;transform:translateY(-50%)}.grommetux-image--align-right:not(.grommetux-image--align-top):not(.grommetux-image--align-bottom){top:50%;left:100%;transform:translate(-100%,-50%)}}.grommetux-label{font-size:19px;font-size:1.1875rem;line-height:1.26316;font-weight:100;cursor:inherit}.grommetux-label--align-start{text-align:left}html.rtl .grommetux-label--align-start{text-align:right}.grommetux-label--align-center{text-align:center}.grommetux-label--align-end{text-align:right}html.rtl .grommetux-label--align-end{text-align:left}.grommetux-label--margin-none{margin-top:0;margin-bottom:0}.grommetux-label--margin-small{margin-top:12px;margin-bottom:12px}.grommetux-label--margin-medium{margin-top:24px;margin-bottom:24px}.grommetux-label--margin-large{margin-top:48px;margin-bottom:48px}.grommetux-label--truncate{display:inline-block;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.grommetux-label--uppercase{text-transform:uppercase;letter-spacing:.2em}.grommetux-label--small{font-size:14px;font-size:.875rem;line-height:1.71429;color:#666}.grommetux-background-color-index--dark .grommetux-label--small,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-label--small{color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-label--small,.grommetux-background-color-index--light .grommetux-label--small{color:#666}.grommetux-label--large{font-size:24px;font-size:1.5rem;line-height:1}.grommetux-layer{position:relative;z-index:10;background-color:rgba(0,0,0,.5);height:100vh;overflow:auto}@media screen and (min-width:45em){.grommetux-layer{position:fixed;top:0;left:0;right:0;bottom:0}}@media screen and (max-width:44.9375em){.grommetux-layer:not(.grommetux-layer--hidden)+.grommetux-app{left:-100%;right:100%;z-index:-1;position:fixed}}.grommetux-layer .grommetux-layer__container{display:flex;flex-direction:column;background-color:#fff}@media screen and (max-width:44.9375em){.grommetux-layer .grommetux-layer__container{padding:0 24px;min-height:100%;min-width:100%}}@media screen and (min-width:45em){.grommetux-layer .grommetux-layer__container{position:absolute;max-height:100%;max-width:100%;overflow:auto;padding:0 48px;border-radius:0;box-shadow:none}}@media screen and (min-width:45em) and (-ms-high-contrast:active),screen and (min-width:45em) and (-ms-high-contrast:none){.grommetux-layer .grommetux-layer__container .grommetux-form{max-width:100vw}.grommetux-layer .grommetux-layer__container .grommetux-sidebar .grommetux-form{max-width:100%}}.grommetux-layer .grommetux-layer__closer{position:absolute;top:0;right:0;z-index:1}.grommet.rtl .grommetux-layer .grommetux-layer__closer{right:auto;left:0}.grommetux-layer.grommetux-layer--flush .grommetux-layer__container{padding:0}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-layer.grommetux-layer--flush .grommetux-layer__container .grommetux-form{max-width:100vw}.grommetux-layer.grommetux-layer--flush .grommetux-layer__container .grommetux-sidebar .grommetux-form{max-width:100%}}@media screen and (min-width:45em){.grommetux-layer--align-center:not(.grommetux-layer--hidden) .grommetux-layer__container{bottom:50%;right:50%;max-height:calc(100vh - 48px);max-width:calc(100vw - 48px);transform:translate(50%,50%)}}.grommetux-layer--align-left:not(.grommetux-layer--hidden) .grommetux-layer__container{top:0;bottom:0;left:0}@media screen and (min-width:45em){.grommetux-layer--align-left:not(.grommetux-layer--hidden) .grommetux-layer__container{animation:slide-right .2s ease-in-out forwards}}.grommet.rtl .grommetux-layer--align-left:not(.grommetux-layer--hidden) .grommetux-layer__container{left:auto;right:0}@media screen and (min-width:45em){.grommet.rtl .grommetux-layer--align-left:not(.grommetux-layer--hidden) .grommetux-layer__container{animation:slide-left .2s ease-in-out forwards}}.grommetux-layer--align-right:not(.grommetux-layer--hidden) .grommetux-layer__container{top:0;bottom:0;right:0}@media screen and (min-width:45em){.grommetux-layer--align-right:not(.grommetux-layer--hidden) .grommetux-layer__container{animation:slide-left .2s ease-in-out forwards}}.grommet.rtl .grommetux-layer--align-right:not(.grommetux-layer--hidden) .grommetux-layer__container{right:auto;left:0}@media screen and (min-width:45em){.grommet.rtl .grommetux-layer--align-right:not(.grommetux-layer--hidden) .grommetux-layer__container{animation:slide-right .2s ease-in-out forwards}}@media screen and (min-width:45em){.grommetux-layer--align-top:not(.grommetux-layer--hidden) .grommetux-layer__container{left:50%;transform:translateX(-50%)}}@media screen and (min-width:45em) and (min-width:45em){.grommetux-layer--align-top:not(.grommetux-layer--hidden) .grommetux-layer__container{animation:slide-down .2s ease-in-out forwards}}.grommetux-layer--align-bottom:not(.grommetux-layer--hidden) .grommetux-layer__container{bottom:0}.grommetux-layer.grommetux-layer--hidden{left:-100%;right:100%;z-index:-1;position:fixed}.grommetux-layer.grommetux-layer--hidden.grommetux-layer--align-left{right:auto}.grommetux-layer.grommetux-layer--hidden.grommetux-layer--align-left .grommetux-layer__container{left:-100vw}@media screen and (min-width:45em){.grommetux-layer.grommetux-layer--hidden.grommetux-layer--peek{left:0;z-index:10}.grommetux-layer.grommetux-layer--hidden.grommetux-layer--peek.grommetux-layer--align-left{right:auto}.grommetux-layer.grommetux-layer--hidden.grommetux-layer--peek.grommetux-layer--align-left .grommetux-layer__container{left:auto;right:-12px;border-right:10px solid #01a982;animation:peek-right .5s ease-in-out alternate 5}}@keyframes peek-right{0%{right:-6px}to{right:-12px}}@keyframes slide-right{0%{left:-100%}to{left:0}}@keyframes slide-left{0%{right:-100%}to{right:0}}@keyframes slide-down{0%{top:-100vh}to{top:0}}.grommetux-list{list-style-type:none;margin:0;padding:0;overflow:auto}.grommetux-list--focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-list__empty,.grommetux-list__more{padding:12px 24px}.grommetux-list__empty{color:#666;font-style:italic}.grommetux-list-item{max-width:none}.grommetux-list-item:focus{outline:1px solid #2ad2c9}.grommetux-list-item__image{height:24px;width:24px;margin-right:24px;overflow:hidden;flex:0 0 auto}.grommetux-list-item__image img{height:100%;width:100%;max-width:none;object-fit:cover}.grommetux-list-item__annotation,.grommetux-list-item__label{flex:1}.grommetux-list-item__annotation{margin-left:24px;color:#666}.grommetux-list-item--selectable{cursor:pointer;outline:none}.grommetux-list-item--selectable:hover{background-color:hsla(0,0%,87%,.5)}.grommetux-list-item--selected{background-color:#d0f3eb;color:#333}.grommetux-background-color-index--dark .grommetux-list-item--selected,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-list-item--selected{background-color:rgba(0,0,0,.15);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-list-item--selected,.grommetux-background-color-index--light .grommetux-list-item--selected{background-color:#d0f3eb;color:#333}.grommetux-list-item--row .grommetux-list-item__annotation{text-align:right}.grommetux-list--selectable{outline:none}.grommetux-list--selectable .grommetux-list-item{cursor:pointer;outline:none;transition:background-color .2s}.grommetux-list--selectable .grommetux-list-item--active,.grommetux-list--selectable .grommetux-list-item:hover{background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-background-color-index--dark .grommetux-list--selectable .grommetux-list-item--active,.grommetux-background-color-index--dark .grommetux-list--selectable .grommetux-list-item:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-list--selectable .grommetux-list-item--active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-list--selectable .grommetux-list-item:hover{background-color:rgba(0,0,0,.1);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-list--selectable .grommetux-list-item--active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-list--selectable .grommetux-list-item:hover,.grommetux-background-color-index--light .grommetux-list--selectable .grommetux-list-item--active,.grommetux-background-color-index--light .grommetux-list--selectable .grommetux-list-item:hover{background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-list--small .grommetux-list-item__image,.grommetux-list--small .grommetux-list__more__image{height:12px;width:12px}.grommetux-list--large .grommetux-list-item__image,.grommetux-list--large .grommetux-list__more__image{height:48px;width:48px}.grommetux-legend{text-align:left;white-space:normal;display:inline-block;line-height:24px}html.rtl .grommetux-legend{text-align:right}.grommetux-legend__item,.grommetux-legend__total{color:#666}.grommetux-background-color-index--dark .grommetux-legend__item,.grommetux-background-color-index--dark .grommetux-legend__total,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-legend__item,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-legend__total{color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-legend__item,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-legend__total,.grommetux-background-color-index--light .grommetux-legend__item,.grommetux-background-color-index--light .grommetux-legend__total{color:#666}.grommetux-legend__item-label{margin-right:12px}.grommetux-legend__item-units,.grommetux-legend__total-units{display:inline-block;margin-left:6px}html.rtl .grommetux-legend__item-units,html.rtl .grommetux-legend__total-units{margin-left:0;margin-right:6px}.grommetux-legend__item-swatch{width:12px;height:12px;margin-right:12px;overflow:visible}.grommetux-legend__item-swatch.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-legend__item-swatch.grommetux-color-index-unset{stroke:#ddd}.grommetux-legend__item-swatch.grommetux-color-index-brand{stroke:#01a982}.grommetux-legend__item-swatch.grommetux-color-index-critical,.grommetux-legend__item-swatch.grommetux-color-index-error{stroke:#f04953}.grommetux-legend__item-swatch.grommetux-color-index-warning{stroke:#ffd144}.grommetux-legend__item-swatch.grommetux-color-index-ok{stroke:#01a982}.grommetux-legend__item-swatch.grommetux-color-index-disabled,.grommetux-legend__item-swatch.grommetux-color-index-unknown{stroke:#ccc}.grommetux-legend__item-swatch.grommetux-color-index-graph-1,.grommetux-legend__item-swatch.grommetux-color-index-graph-5{stroke:#425563}.grommetux-legend__item-swatch.grommetux-color-index-graph-2,.grommetux-legend__item-swatch.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-legend__item-swatch.grommetux-color-index-graph-3,.grommetux-legend__item-swatch.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-legend__item-swatch.grommetux-color-index-graph-4,.grommetux-legend__item-swatch.grommetux-color-index-graph-8{stroke:#767676}.grommetux-legend__item-swatch.grommetux-color-index-grey-1,.grommetux-legend__item-swatch.grommetux-color-index-grey-6{stroke:#000001}.grommetux-legend__item-swatch.grommetux-color-index-grey-2,.grommetux-legend__item-swatch.grommetux-color-index-grey-7{stroke:#333}.grommetux-legend__item-swatch.grommetux-color-index-grey-3,.grommetux-legend__item-swatch.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-legend__item-swatch.grommetux-color-index-grey-4,.grommetux-legend__item-swatch.grommetux-color-index-grey-9{stroke:#434343}.grommetux-legend__item-swatch.grommetux-color-index-grey-5,.grommetux-legend__item-swatch.grommetux-color-index-grey-10{stroke:#666}.grommetux-legend__item-swatch.grommetux-color-index-accent-1,.grommetux-legend__item-swatch.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-legend__item-swatch.grommetux-color-index-accent-2,.grommetux-legend__item-swatch.grommetux-color-index-accent-5{stroke:#614767}.grommetux-legend__item-swatch.grommetux-color-index-accent-3,.grommetux-legend__item-swatch.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-legend__item-swatch.grommetux-color-index-neutral-1,.grommetux-legend__item-swatch.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-legend__item-swatch.grommetux-color-index-neutral-2,.grommetux-legend__item-swatch.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-legend__item-swatch.grommetux-color-index-neutral-3,.grommetux-legend__item-swatch.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-legend__item-swatch.grommetux-color-index-neutral-4,.grommetux-legend__item-swatch.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-legend__item-swatch.grommetux-color-index-light-1,.grommetux-legend__item-swatch.grommetux-color-index-light-3{stroke:#fff}.grommetux-legend__item-swatch.grommetux-color-index-light-2,.grommetux-legend__item-swatch.grommetux-color-index-light-4{stroke:#f5f5f5}html.rtl .grommetux-legend__item-swatch{margin-right:0;margin-left:12px}.grommetux-legend__item-swatch path{stroke-width:12px;transition-property:stroke-width;transition-duration:.3s;transition-timing-function:ease-in-out}.grommetux-legend__item--clickable{cursor:pointer}.grommetux-legend__item--active{color:#333}.grommetux-legend__item--active svg.grommetux-legend__item-swatch path{stroke-width:12px}.grommetux-background-color-index--dark .grommetux-legend__item--active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-legend__item--active{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-legend__item--active,.grommetux-background-color-index--light .grommetux-legend__item--active{color:#333}.grommetux-legend__total{margin-left:24px;margin-top:6px;padding-top:6px;border-top:1px dotted rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-legend__total,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-legend__total{border-color:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-legend__total,.grommetux-background-color-index--light .grommetux-legend__total{border-color:rgba(0,0,0,.15)}html.rtl .grommetux-legend__total{margin-left:0;margin-right:24px}.grommetux-legend--large{font-size:24px;line-height:32px}.grommetux-legend--large .grommetux-legend__item{margin-bottom:6px}.grommetux-legend--large .grommetux-legend__item-label{margin-right:24px}.grommetux-legend--large .grommetux-legend__item-swatch{position:relative;top:3px;width:24px;height:24px}.grommetux-legend--large .grommetux-legend__total{margin-left:36px}.grommetux-map{position:relative;z-index:0}.grommetux-map__links{position:absolute;top:0;left:0;z-index:-1}.grommetux-map__path{stroke-width:2px}.grommetux-map__path.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-map__path.grommetux-color-index-unset{stroke:#ddd}.grommetux-map__path.grommetux-color-index-brand{stroke:#01a982}.grommetux-map__path.grommetux-color-index-critical,.grommetux-map__path.grommetux-color-index-error{stroke:#f04953}.grommetux-map__path.grommetux-color-index-warning{stroke:#ffd144}.grommetux-map__path.grommetux-color-index-ok{stroke:#01a982}.grommetux-map__path.grommetux-color-index-disabled,.grommetux-map__path.grommetux-color-index-unknown{stroke:#ccc}.grommetux-map__path.grommetux-color-index-graph-1,.grommetux-map__path.grommetux-color-index-graph-5{stroke:#425563}.grommetux-map__path.grommetux-color-index-graph-2,.grommetux-map__path.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-map__path.grommetux-color-index-graph-3,.grommetux-map__path.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-map__path.grommetux-color-index-graph-4,.grommetux-map__path.grommetux-color-index-graph-8{stroke:#767676}.grommetux-map__path.grommetux-color-index-grey-1,.grommetux-map__path.grommetux-color-index-grey-6{stroke:#000001}.grommetux-map__path.grommetux-color-index-grey-2,.grommetux-map__path.grommetux-color-index-grey-7{stroke:#333}.grommetux-map__path.grommetux-color-index-grey-3,.grommetux-map__path.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-map__path.grommetux-color-index-grey-4,.grommetux-map__path.grommetux-color-index-grey-9{stroke:#434343}.grommetux-map__path.grommetux-color-index-grey-5,.grommetux-map__path.grommetux-color-index-grey-10{stroke:#666}.grommetux-map__path.grommetux-color-index-accent-1,.grommetux-map__path.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-map__path.grommetux-color-index-accent-2,.grommetux-map__path.grommetux-color-index-accent-5{stroke:#614767}.grommetux-map__path.grommetux-color-index-accent-3,.grommetux-map__path.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-map__path.grommetux-color-index-neutral-1,.grommetux-map__path.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-map__path.grommetux-color-index-neutral-2,.grommetux-map__path.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-map__path.grommetux-color-index-neutral-3,.grommetux-map__path.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-map__path.grommetux-color-index-neutral-4,.grommetux-map__path.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-map__path.grommetux-color-index-light-1,.grommetux-map__path.grommetux-color-index-light-3{stroke:#fff}.grommetux-map__path.grommetux-color-index-light-2,.grommetux-map__path.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-map__path--active{stroke-width:6px}.grommetux-map__categories{margin:0;list-style-type:none}.grommetux-map__category{position:relative;margin-bottom:12px;max-width:none}.grommetux-map__category-label{font-size:14px;font-size:.875rem;line-height:1.71429;margin-bottom:12px}.grommetux-map__category-items{margin:0;list-style-type:none;overflow:hidden;text-align:center}.grommetux-map__item{display:inline-block;margin-right:12px;margin-bottom:12px}.grommetux-background-color-index--dark .grommetux-map__item,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-map__item{color:#333}.grommetux-map__item:not(.grommetux-map__item--plain){width:192px;border:1px solid rgba(0,0,0,.15);padding:6px 12px;background-color:#fff;font-size:16px;font-size:1rem;line-height:1.5}.grommetux-map__item:not(.grommetux-map__item--plain)>a{display:block;padding:6px 12px;transition:background-color .2s}.grommetux-map__item:not(.grommetux-map__item--plain)>a>*{display:inline-block}.grommetux-map__item:not(.grommetux-map__item--plain)>a:hover{background-color:hsla(0,0%,87%,.5)}.grommetux-map__item:not(.grommetux-map__item--plain) .grommetux-status-icon{margin-right:6px}.grommetux-map__item--active:not(.grommetux-map__item--plain){border-color:#000;border-width:2px;padding:5px 11px}.grommetux-map--vertical .grommetux-map__categories{display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap}.grommetux-map--vertical .grommetux-map__category-items{text-align:left}.grommetux-map--vertical .grommetux-map__item{display:block;margin-right:0}.grommetux-menu{position:relative;white-space:nowrap;font-size:19px;font-size:1.1875rem;line-height:1.26316}.grommetux-menu>*{flex:0 0 auto}.grommetux-menu .grommetux-anchor,.grommetux-menu .grommetux-anchor:hover,.grommetux-menu a:not(.grommetux-button),.grommetux-menu a:not(.grommetux-button):hover{text-decoration:none}.grommetux-menu.grommetux-menu--controlled{display:inline-block;cursor:pointer}.grommetux-menu--fill{flex:1 1 auto;overflow:auto}.grommetux-menu__control .grommetux-control-icon-down{width:12px}.grommetux-menu__control .grommetux-control-icon-down path,.grommetux-menu__control .grommetux-control-icon-down polyline{stroke-width:4px}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-menu__control.grommetux-menu--labelled{line-height:24px}}@media screen and (min-width:45em){.grommetux-menu__control.grommetux-menu--labelled .grommetux-control-icon{transition:none}}.grommetux-menu__drop{font-size:19px;font-size:1.1875rem;line-height:1.26316;max-height:100vh}.grommetux-menu__drop>*{flex-shrink:0}.grommetux-menu__drop a:not(.grommetux-anchor--disabled),.grommetux-menu__drop a:not(.grommetux-anchor--disabled):hover{text-decoration:none}.grommetux-menu__drop .grommetux-anchor{padding:12px 24px;white-space:nowrap;display:block;text-decoration:none}.grommetux-menu__drop .grommetux-anchor.active,.grommetux-menu__drop .grommetux-anchor:focus,.grommetux-menu__drop .grommetux-anchor:hover{text-decoration:none;color:#000;background-color:hsla(0,0%,87%,.5)}.grommetux-menu__drop .grommetux-menu__control{text-align:left}.grommet.rtl .grommetux-menu__drop .grommetux-menu__control{text-align:right}.grommetux-menu__drop .grommetux-menu__label{padding:12px 24px;font-weight:600}.grommetux-menu__drop.grommetux-menu__drop--align-right{text-align:right}.grommet.rtl .grommetux-menu__drop.grommetux-menu__drop--align-right{text-align:left}.grommetux-menu__drop.grommetux-menu__drop--align-right .grommetux-menu__control{text-align:right}.grommet.rtl .grommetux-menu__drop.grommetux-menu__drop--align-right .grommetux-menu__control,.grommetux-menu__drop.grommetux-menu__drop--align-right .grommetux-menu__contents{text-align:left}.grommet.rtl .grommetux-menu__drop.grommetux-menu__drop--align-right .grommetux-menu__contents{text-align:right}.grommetux-menu__drop .grommetux-anchor__icon{padding-left:0;vertical-align:middle;height:inherit}.grommetux-menu__drop .grommetux-anchor--reverse .grommetux-anchor__icon{padding-right:0}.grommetux-menu__drop.grommetux-menu__drop--small{font-size:16px;font-size:1rem;line-height:1.5}.grommetux-menu__drop.grommetux-menu__drop--small .grommetux-anchor__icon{padding-top:0;padding-bottom:0}.grommetux-menu__drop.grommetux-menu__drop--large{font-size:24px;font-size:1.5rem;line-height:1}.grommetux-background-color-index--light .grommetux-menu__drop.grommetux-background-color-index--dark .grommetux-anchor.active,.grommetux-menu__drop.grommetux-background-color-index--dark .grommetux-anchor.active{color:#fff;background-color:rgba(0,0,0,.15)}.grommetux-background-color-index--light .grommetux-menu__drop.grommetux-background-color-index--dark .grommetux-anchor:focus,.grommetux-background-color-index--light .grommetux-menu__drop.grommetux-background-color-index--dark .grommetux-anchor:hover,.grommetux-menu__drop.grommetux-background-color-index--dark .grommetux-anchor:focus,.grommetux-menu__drop.grommetux-background-color-index--dark .grommetux-anchor:hover{color:#fff;background-color:rgba(0,0,0,.1)}.grommetux-background-color-index--dark .grommetux-menu__drop.grommetux-background-color-index--light .grommetux-anchor.active,.grommetux-background-color-index--dark .grommetux-menu__drop.grommetux-background-color-index--light .grommetux-anchor:focus,.grommetux-background-color-index--dark .grommetux-menu__drop.grommetux-background-color-index--light .grommetux-anchor:hover,.grommetux-menu__drop.grommetux-background-color-index--light .grommetux-anchor.active,.grommetux-menu__drop.grommetux-background-color-index--light .grommetux-anchor:focus,.grommetux-menu__drop.grommetux-background-color-index--light .grommetux-anchor:hover{color:#000;background-color:hsla(0,0%,87%,.5)}.grommetux-menu--inline.grommetux-menu--row{line-height:48px}.grommetux-menu--inline.grommetux-menu--row.grommetux-box--justify-end>:not(.grommetux-control-icon){margin-left:24px;margin-right:0}.grommetux-menu--inline.grommetux-menu--row.grommetux-box--justify-end>:not(.grommetux-control-icon):first-child{margin-left:0}.grommet.rtl .grommetux-menu--inline.grommetux-menu--row.grommetux-box--justify-end>:not(.grommetux-control-icon){margin-right:24px;margin-left:0}.grommet.rtl .grommetux-menu--inline.grommetux-menu--row.grommetux-box--justify-end>:not(.grommetux-control-icon):first-child{margin-right:0}.grommetux-menu--inline.grommetux-menu--row>:not(.grommetux-control-icon):not(.grommetux-button){margin-left:0;margin-right:24px}.grommetux-menu--inline.grommetux-menu--row>:not(.grommetux-control-icon):not(.grommetux-button):last-child{margin-right:0}.grommet.rtl .grommetux-menu--inline.grommetux-menu--row>:not(.grommetux-control-icon):not(.grommetux-button){margin-right:0;margin-left:24px}.grommet.rtl .grommetux-menu--inline.grommetux-menu--row>:not(.grommetux-control-icon):not(.grommetux-button):last-child{margin-left:0}@media screen and (max-width:44.9375em){.grommetux-menu--inline.grommetux---direction-row.grommetux-box--responsive>*{margin-right:0}.grommet.rtl .grommetux-menu--inline.grommetux---direction-row.grommetux-box--responsive>*{margin-left:0}}.grommetux-menu--inline.grommetux-menu--small{font-size:16px;font-size:1rem;line-height:inherit}.grommetux-menu--inline.grommetux-menu--large{font-size:24px;font-size:1.5rem;line-height:inherit}.grommetux-menu--primary,.grommetux-menu--primary>.grommetux-menu{width:100%}.grommetux-menu--primary>a:not(.grommetux-button){padding:12px 24px 12px 20px;margin-bottom:0;width:100%;border-width:4px;border-color:transparent;border-left-style:solid}.grommet.rtl .grommetux-menu--primary>a:not(.grommetux-button){border-right-style:none;border-left-style:solid}.grommetux-menu--primary>a:not(.grommetux-button):hover{text-decoration:none}.grommetux-menu--primary>a:not(.grommetux-button):hover:not(.active){background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-background-color-index--dark .grommetux-menu--primary>a:not(.grommetux-button):hover:not(.active),.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-menu--primary>a:not(.grommetux-button):hover:not(.active){background-color:rgba(0,0,0,.1);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-menu--primary>a:not(.grommetux-button):hover:not(.active),.grommetux-background-color-index--light .grommetux-menu--primary>a:not(.grommetux-button):hover:not(.active){background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-menu--primary>a:not(.grommetux-button).active,.grommetux-menu--primary>a:not(.grommetux-button).grommetux-anchor--active{border-color:#01a982}.grommetux-background-color-index--dark .grommetux-menu--primary>a:not(.grommetux-button).active,.grommetux-background-color-index--dark .grommetux-menu--primary>a:not(.grommetux-button).grommetux-anchor--active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-menu--primary>a:not(.grommetux-button).active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-menu--primary>a:not(.grommetux-button).grommetux-anchor--active{border-color:transparent;background-color:rgba(0,0,0,.15);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-menu--primary>a:not(.grommetux-button).active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-menu--primary>a:not(.grommetux-button).grommetux-anchor--active,.grommetux-background-color-index--light .grommetux-menu--primary>a:not(.grommetux-button).active,.grommetux-background-color-index--light .grommetux-menu--primary>a:not(.grommetux-button).grommetux-anchor--active{border-color:#01a982}@media screen and (max-width:44.9375em){.grommetux-menu--primary.grommetux-menu--down,.grommetux-menu--primary.grommetux-menu--down>*{display:block}}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row)>hr,.grommetux-menu__drop>hr{margin:12px 24px 18px;height:1px;background-color:rgba(0,0,0,.15);border:none}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row) a,.grommetux-menu__drop a{text-decoration:none}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-box--direction-column>.grommetux-menu:not(:first-of-type) h2,.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-box--direction-column>.grommetux-menu:not(:first-of-type) h3,.grommetux-menu__drop.grommetux-box--direction-column>.grommetux-menu:not(:first-of-type) h2,.grommetux-menu__drop.grommetux-box--direction-column>.grommetux-menu:not(:first-of-type) h3{margin-top:24px}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-box.grommetux-box--separator-top,.grommetux-menu__drop.grommetux-box.grommetux-box--separator-top{border-color:transparent}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-box.grommetux-box--separator-top:before,.grommetux-menu__drop.grommetux-box.grommetux-box--separator-top:before{content:\"\";margin:12px 24px 18px;height:1px;background-color:rgba(0,0,0,.15)}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-menu--small>a,.grommetux-menu__drop.grommetux-menu--small>a{padding:6px 0}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-menu--small.grommetux-menu--primary>a,.grommetux-menu__drop.grommetux-menu--small.grommetux-menu--primary>a{padding:6px 24px 6px 20px}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-menu--large>a,.grommetux-menu__drop.grommetux-menu--large>a{padding:24px 0}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-menu--large.grommetux-menu--primary>a,.grommetux-menu__drop.grommetux-menu--large.grommetux-menu--primary>a{padding:12px 24px 12px 20px}@media screen and (max-width:44.9375em){.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-box--responsive>*,.grommetux-menu__drop.grommetux-box--responsive>*{margin-left:0;margin-right:0}.grommetux-menu--inline.grommetux-menu:not(.grommetux-box--direction-row).grommetux-box--responsive .grommetux-button,.grommetux-menu__drop.grommetux-box--responsive .grommetux-button{width:100%;margin-bottom:12px}}@media screen and (max-width:44.9375em){.grommetux-menu__drop{max-width:100%}.grommetux-menu__drop.grommetux-box--responsive .grommetux-button{margin-bottom:0}}.grommetux-meter{display:inline-block;position:relative}.grommetux-meter__slice{stroke-width:4px;fill:none;stroke:rgba(0,0,0,.1)}.grommetux-meter__hot{cursor:pointer;stroke-width:24px;stroke:rgba(0,0,0,.001)}.grommetux-meter__threshold{stroke:rgba(51,51,51,.2)}.grommetux-meter__value-container{position:relative;display:inline-block;white-space:nowrap}.grommetux-meter__graphic-container{white-space:normal}.grommetux-meter__graphic-container>a{text-decoration:none}.grommetux-meter__graphic{max-width:100%}.grommetux-meter__graphic:focus{outline:1px solid #2ad2c9}.grommetux-meter__graphic text{fill:#666}.grommetux-meter:not(.grommetux-meter--vertical) .grommetux-meter__graphic-container{display:inline-block}.grommetux-meter--vertical .grommetux-meter__graphic-container{display:inline-block;white-space:nowrap}.grommetux-meter--active .grommetux-meter__values .grommetux-meter__slice,.grommetux-meter__values .grommetux-meter__slice--active{stroke-width:12px}@keyframes draw-meter-bar-small{0%{stroke-dashoffset:192px}to{stroke-dashoffset:0}}.grommetux-meter--bar{line-height:0}.grommetux-meter--bar .grommetux-meter__slice{stroke-linecap:butt}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-unset{stroke:#ddd}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-brand{stroke:#01a982}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-error{stroke:#f04953}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-warning{stroke:#ffd144}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-ok{stroke:#01a982}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-unknown{stroke:#ccc}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-5{stroke:#425563}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-8{stroke:#767676}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-1,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-6{stroke:#000001}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-2,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-7{stroke:#333}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-3,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-4,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-9{stroke:#434343}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-5,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-10{stroke:#666}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-5{stroke:#614767}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-1,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-2,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-3,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-4,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-1,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-3{stroke:#fff}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-2,.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice--clickable{cursor:pointer}@media screen and (min-width:45em){.grommetux-meter--bar .grommetux-meter__values .grommetux-meter__slice{stroke-dasharray:192px 192px;stroke-dashoffset:0;transition:stroke-width .2s;animation:draw-meter-bar-small 1s ease-in}}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-unset,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-unset{stroke:hsla(0,0%,87%,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-brand,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-brand{stroke:rgba(1,169,130,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-error,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-error{stroke:rgba(240,73,83,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-warning,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-warning{stroke:rgba(255,209,68,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-ok,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-ok{stroke:rgba(1,169,130,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-unknown,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-unknown{stroke:hsla(0,0%,80%,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-5,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-5{stroke:rgba(66,85,99,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-6,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-6{stroke:rgba(95,122,118,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-7,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-7{stroke:hsla(20,8%,47%,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-8,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-8{stroke:hsla(0,0%,46%,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-4,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-4{stroke:rgba(42,210,201,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-5,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-5{stroke:rgba(97,71,103,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-6,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-6{stroke:rgba(255,141,109,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-1,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-6,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-1,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-6{stroke:rgba(0,0,1,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-2,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-7,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-2,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-7{stroke:rgba(51,51,51,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-3,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-8,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-3,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-8{stroke:rgba(59,59,59,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-4,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-9,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-4,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-9{stroke:rgba(67,67,67,.5)}.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-5,.grommetux-meter--bar .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-10,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-5,.grommetux-meter--bar .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-10{stroke:hsla(0,0%,40%,.5)}.grommetux-meter--bar.grommetux-meter--vertical{white-space:nowrap}.grommetux-meter--bar.grommetux-meter--vertical .grommetux-meter__graphic{height:192px;width:24px}.grommetux-meter--bar.grommetux-meter--vertical:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{width:48px}.grommetux-meter--bar.grommetux-meter--vertical:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{width:72px}.grommetux-meter--bar.grommetux-meter--vertical:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{width:96px}.grommetux-meter--bar.grommetux-meter--vertical .grommetux-meter__labeled-graphic{display:inline-block}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--xsmall .grommetux-meter__graphic{height:96px;width:12px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--xsmall:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{width:24px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--xsmall:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{width:36px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--xsmall:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{width:48px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--small .grommetux-meter__graphic{height:192px;width:24px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--small:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{width:48px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--small:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{width:72px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--small:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{width:96px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--medium .grommetux-meter__graphic{height:384px;width:48px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--medium:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{width:96px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--medium:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{width:144px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--medium:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{width:192px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--large .grommetux-meter__graphic{height:576px;width:72px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--large:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{width:144px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--large:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{width:216px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--large:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{width:288px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--xlarge .grommetux-meter__graphic{height:720px;width:90px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--xlarge:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{width:180px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--xlarge:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{width:270px}.grommetux-meter--bar.grommetux-meter--vertical.grommetux-meter--xlarge:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{width:360px}.grommetux-meter--bar:not(.grommetux-meter--vertical) .grommetux-meter__graphic{width:192px;min-width:96px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xsmall .grommetux-meter__graphic{width:96px;height:12px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xsmall.grommetux-meter--single .grommetux-meter__graphic,.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xsmall.grommetux-meter--stacked .grommetux-meter__graphic{height:12px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xsmall:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{height:24px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xsmall:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{height:36px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xsmall:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{height:48px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--small .grommetux-meter__graphic{width:192px;height:24px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--small.grommetux-meter--single .grommetux-meter__graphic,.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--small.grommetux-meter--stacked .grommetux-meter__graphic{height:24px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--small:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{height:48px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--small:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{height:72px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--small:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{height:96px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--medium .grommetux-meter__graphic{height:48px}@media screen and (max-width:44.9375em){.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--medium .grommetux-meter__graphic{width:192px}}@media screen and (min-width:45em){.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--medium .grommetux-meter__graphic{width:384px}}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--medium:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{height:96px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--medium:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{height:144px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--medium:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{height:192px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--large .grommetux-meter__graphic{height:72px}@media screen and (max-width:44.9375em){.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--large .grommetux-meter__graphic{width:192px}}@media screen and (min-width:45em){.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--large .grommetux-meter__graphic{width:576px}}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--large:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{height:144px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--large:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{height:216px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--large:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{height:288px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xlarge .grommetux-meter__graphic{height:90px}@media screen and (max-width:44.9375em){.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xlarge .grommetux-meter__graphic{width:192px}}@media screen and (min-width:45em){.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xlarge .grommetux-meter__graphic{width:720px}}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xlarge:not(.grommetux-meter--stacked).grommetux-meter--count-2 .grommetux-meter__graphic{height:180px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xlarge:not(.grommetux-meter--stacked).grommetux-meter--count-3 .grommetux-meter__graphic{height:270px}.grommetux-meter--bar:not(.grommetux-meter--vertical).grommetux-meter--xlarge:not(.grommetux-meter--stacked).grommetux-meter--count-4 .grommetux-meter__graphic{height:360px}@keyframes draw-meter-circle{0%{stroke-dashoffset:-614px}to{stroke-dashoffset:0}}@media screen and (max-width:44.9375em){.grommetux-meter--arc,.grommetux-meter--circle,.grommetux-meter--spiral{margin:0 auto}}.grommetux-meter--arc .grommetux-meter.series-pre path,.grommetux-meter--circle .grommetux-meter.series-pre path,.grommetux-meter--spiral .grommetux-meter.series-pre path{stroke-dashoffset:768px}.grommetux-meter--arc .grommetux-meter__slice,.grommetux-meter--circle .grommetux-meter__slice,.grommetux-meter--spiral .grommetux-meter__slice{stroke-linecap:butt}.grommetux-meter--arc .grommetux-meter__slice-indicator,.grommetux-meter--circle .grommetux-meter__slice-indicator,.grommetux-meter--spiral .grommetux-meter__slice-indicator{stroke-linecap:square;stroke-width:4px;stroke:rgba(51,51,51,.2)}.grommetux-background-color-index--dark .grommetux-meter--arc .grommetux-meter__slice-indicator,.grommetux-background-color-index--dark .grommetux-meter--circle .grommetux-meter__slice-indicator,.grommetux-background-color-index--dark .grommetux-meter--spiral .grommetux-meter__slice-indicator,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-meter--arc .grommetux-meter__slice-indicator,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-meter--circle .grommetux-meter__slice-indicator,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-meter--spiral .grommetux-meter__slice-indicator{stroke:hsla(0,0%,100%,.2)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-meter--arc .grommetux-meter__slice-indicator,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-meter--circle .grommetux-meter__slice-indicator,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-meter--spiral .grommetux-meter__slice-indicator,.grommetux-background-color-index--light .grommetux-meter--arc .grommetux-meter__slice-indicator,.grommetux-background-color-index--light .grommetux-meter--circle .grommetux-meter__slice-indicator,.grommetux-background-color-index--light .grommetux-meter--spiral .grommetux-meter__slice-indicator{stroke:rgba(51,51,51,.2)}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-loading,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-loading,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-unset,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-unset,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-unset{stroke:#ddd}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-brand,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-brand,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-brand{stroke:#01a982}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-error,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-error,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-error{stroke:#f04953}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-warning,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-warning,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-warning{stroke:#ffd144}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-ok,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-ok,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-ok{stroke:#01a982}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-unknown,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-unknown,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-unknown{stroke:#ccc}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-5,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-5,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-5{stroke:#425563}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-6,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-6,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-7,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-7,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-8,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-8,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-graph-8{stroke:#767676}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-1,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-6,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-1,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-6,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-1,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-6{stroke:#000001}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-2,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-7,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-2,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-7,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-2,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-7{stroke:#333}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-3,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-8,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-3,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-8,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-3,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-4,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-9,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-4,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-9,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-4,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-9{stroke:#434343}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-5,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-10,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-5,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-10,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-5,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-grey-10{stroke:#666}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-4,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-4,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-5,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-5,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-5{stroke:#614767}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-6,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-6,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-1,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-5,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-1,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-5,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-1,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-2,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-6,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-2,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-6,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-2,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-3,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-7,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-3,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-7,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-3,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-4,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-8,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-4,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-8,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-4,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-1,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-3,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-1,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-3,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-1,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-3{stroke:#fff}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-2,.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-4,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-2,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-4,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-2,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice--clickable,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice--clickable,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice--clickable{cursor:pointer}@media screen and (min-width:45em){.grommetux-meter--arc .grommetux-meter__values .grommetux-meter__slice,.grommetux-meter--circle .grommetux-meter__values .grommetux-meter__slice,.grommetux-meter--spiral .grommetux-meter__values .grommetux-meter__slice{stroke-dasharray:614px 614px;stroke-dashoffset:0;transition:stroke-width .2s;animation:draw-meter-circle 1s ease-in}}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-unset,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-unset,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-unset,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-unset,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-unset,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-unset{stroke:hsla(0,0%,87%,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-brand,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-brand,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-brand,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-brand,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-brand,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-brand{stroke:rgba(1,169,130,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-error,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-error,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-error,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-error,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-error,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-critical,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-error{stroke:rgba(240,73,83,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-warning,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-warning,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-warning,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-warning,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-warning,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-warning{stroke:rgba(255,209,68,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-ok,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-ok,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-ok,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-ok,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-ok,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-ok{stroke:rgba(1,169,130,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-unknown,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-unknown,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-unknown,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-unknown,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-unknown,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-disabled,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-unknown{stroke:hsla(0,0%,80%,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-5,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-5,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-5,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-5,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-5,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-1,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-5{stroke:rgba(66,85,99,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-6,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-6,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-6,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-6,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-6,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-2,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-6{stroke:rgba(95,122,118,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-7,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-7,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-7,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-7,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-7,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-3,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-7{stroke:hsla(20,8%,47%,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-8,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-8,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-8,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-8,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-graph-8,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-4,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-graph-8{stroke:hsla(0,0%,46%,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-4,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-4,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-4,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-4,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-4,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-1,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-4{stroke:rgba(42,210,201,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-5,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-5,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-5,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-5,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-5,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-2,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-5{stroke:rgba(97,71,103,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-6,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-6,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-6,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-6,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.grommetux-color-index-accent-6,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-3,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.grommetux-color-index-accent-6{stroke:rgba(255,141,109,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-1,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-6,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-1,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-6,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-1,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-6,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-1,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-6,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-1,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-6,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-1,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-6{stroke:rgba(0,0,1,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-2,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-7,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-2,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-7,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-2,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-7,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-2,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-7,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-2,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-7,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-2,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-7{stroke:rgba(51,51,51,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-3,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-8,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-3,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-8,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-3,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-8,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-3,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-8,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-3,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-8,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-3,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-8{stroke:rgba(59,59,59,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-4,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-9,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-4,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-9,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-4,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-9,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-4,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-9,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-4,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-9,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-4,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-9{stroke:rgba(67,67,67,.5)}.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-5,.grommetux-meter--arc .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-10,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-5,.grommetux-meter--arc .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-10,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-5,.grommetux-meter--circle .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-10,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-5,.grommetux-meter--circle .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-10,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-5,.grommetux-meter--spiral .grommetux-meter__thresholds .grommetux-meter__slice.color-index-grey-10,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-5,.grommetux-meter--spiral .grommetux-meter__tracks .grommetux-meter__slice.color-index-grey-10{stroke:hsla(0,0%,40%,.5)}.grommetux-meter--arc .grommetux-meter__threshold,.grommetux-meter--circle .grommetux-meter__threshold,.grommetux-meter--spiral .grommetux-meter__threshold{stroke-linecap:butt}.grommetux-meter--circle .grommetux-meter__graphic{width:192px;min-width:96px;height:auto}.grommetux-meter--circle .grommetux-meter__label{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.grommetux-meter--circle.grommetux-meter--xsmall .grommetux-meter__graphic{width:96px;height:96px}.grommetux-meter--circle.grommetux-meter--small .grommetux-meter__graphic{width:192px;height:192px}@media screen and (max-width:44.9375em){.grommetux-meter--circle.grommetux-meter--medium .grommetux-meter__graphic{width:192px;height:192px}}@media screen and (min-width:45em){.grommetux-meter--circle.grommetux-meter--medium .grommetux-meter__graphic{width:384px;height:384px}}@media screen and (max-width:44.9375em){.grommetux-meter--circle.grommetux-meter--large .grommetux-meter__graphic{width:192px;height:192px}}@media screen and (min-width:45em){.grommetux-meter--circle.grommetux-meter--large .grommetux-meter__graphic{width:576px;height:576px}}@media screen and (max-width:44.9375em){.grommetux-meter--circle.grommetux-meter--xlarge .grommetux-meter__graphic{width:192px;height:192px}}@media screen and (min-width:45em){.grommetux-meter--circle.grommetux-meter--xlarge .grommetux-meter__graphic{width:720px;height:720px}}.grommetux-meter--arc:not(.grommetux-meter--vertical) .grommetux-meter__graphic{width:192px;min-width:96px;height:auto}.grommetux-meter--arc:not(.grommetux-meter--vertical).grommetux-meter--xsmall .grommetux-meter__graphic{width:96px;height:72px}.grommetux-meter--arc:not(.grommetux-meter--vertical).grommetux-meter--small .grommetux-meter__graphic{width:192px;height:144px}@media screen and (max-width:44.9375em){.grommetux-meter--arc:not(.grommetux-meter--vertical).grommetux-meter--medium .grommetux-meter__graphic{width:192px;height:144px}}@media screen and (min-width:45em){.grommetux-meter--arc:not(.grommetux-meter--vertical).grommetux-meter--medium .grommetux-meter__graphic{width:384px;height:288px}}@media screen and (max-width:44.9375em){.grommetux-meter--arc:not(.grommetux-meter--vertical).grommetux-meter--large .grommetux-meter__graphic{width:192px;height:144px}}@media screen and (min-width:45em){.grommetux-meter--arc:not(.grommetux-meter--vertical).grommetux-meter--large .grommetux-meter__graphic{width:576px;height:432px}}@media screen and (max-width:44.9375em){.grommetux-meter--arc:not(.grommetux-meter--vertical).grommetux-meter--xlarge .grommetux-meter__graphic{width:192px;height:144px}}@media screen and (min-width:45em){.grommetux-meter--arc:not(.grommetux-meter--vertical).grommetux-meter--xlarge .grommetux-meter__graphic{width:720px;height:540px}}.grommetux-meter--arc.grommetux-meter--vertical .grommetux-meter__graphic{display:inline;width:144px;height:192px}.grommetux-meter--arc.grommetux-meter--vertical.grommetux-meter--xsmall .grommetux-meter__graphic{width:72px;height:96px}.grommetux-meter--arc.grommetux-meter--vertical.grommetux-meter--small .grommetux-meter__graphic{width:144px;height:192px}@media screen and (max-width:44.9375em){.grommetux-meter--arc.grommetux-meter--vertical.grommetux-meter--medium .grommetux-meter__graphic{width:144px;height:192px}}@media screen and (min-width:45em){.grommetux-meter--arc.grommetux-meter--vertical.grommetux-meter--medium .grommetux-meter__graphic{width:288px;height:384px}}@media screen and (max-width:44.9375em){.grommetux-meter--arc.grommetux-meter--vertical.grommetux-meter--large .grommetux-meter__graphic{width:144px;height:192px}}@media screen and (min-width:45em){.grommetux-meter--arc.grommetux-meter--vertical.grommetux-meter--large .grommetux-meter__graphic{width:432px;height:576px}}@media screen and (max-width:44.9375em){.grommetux-meter--arc.grommetux-meter--vertical.grommetux-meter--xlarge .grommetux-meter__graphic{width:144px;height:192px}}@media screen and (min-width:45em){.grommetux-meter--arc.grommetux-meter--vertical.grommetux-meter--xlarge .grommetux-meter__graphic{width:540px;height:720px}}.grommetux-meter--spiral .grommetux-meter__graphic-container{vertical-align:top}.grommetux-notification{font-size:19px;font-size:1.1875rem;line-height:24px}.grommetux-notification--status-critical .grommetux-notification__status .grommetux-status-icon__base,.grommetux-notification--status-critical .grommetux-notification__status .grommetux-status-icon__base .grommetux-status-icon__small{fill:#fff}.grommetux-notification--status-critical .grommetux-notification__status .grommetux-status-icon__detail{stroke:#f04953;fill:#f04953}.grommetux-notification--status-critical .grommetux-notification__close,.grommetux-notification--status-critical .grommetux-notification__status.grommetux-status-icon-unknown .grommetux-status-icon__detail{stroke:#fff;fill:#fff}.grommetux-notification--status-error .grommetux-notification__status .grommetux-status-icon__base,.grommetux-notification--status-error .grommetux-notification__status .grommetux-status-icon__base .grommetux-status-icon__small{fill:#fff}.grommetux-notification--status-error .grommetux-notification__status .grommetux-status-icon__detail{stroke:#f04953;fill:#f04953}.grommetux-notification--status-error .grommetux-notification__close,.grommetux-notification--status-error .grommetux-notification__status.grommetux-status-icon-unknown .grommetux-status-icon__detail{stroke:#fff;fill:#fff}.grommetux-notification--status-warning .grommetux-notification__status .grommetux-status-icon__base,.grommetux-notification--status-warning .grommetux-notification__status .grommetux-status-icon__base .grommetux-status-icon__small{fill:#fff}.grommetux-notification--status-warning .grommetux-notification__status .grommetux-status-icon__detail{stroke:#ffd144;fill:#ffd144}.grommetux-notification--status-warning .grommetux-notification__close,.grommetux-notification--status-warning .grommetux-notification__status.grommetux-status-icon-unknown .grommetux-status-icon__detail{stroke:#fff;fill:#fff}.grommetux-notification--status-ok .grommetux-notification__status .grommetux-status-icon__base,.grommetux-notification--status-ok .grommetux-notification__status .grommetux-status-icon__base .grommetux-status-icon__small{fill:#fff}.grommetux-notification--status-ok .grommetux-notification__status .grommetux-status-icon__detail{stroke:#01a982;fill:#01a982}.grommetux-notification--status-ok .grommetux-notification__close,.grommetux-notification--status-ok .grommetux-notification__status.grommetux-status-icon-unknown .grommetux-status-icon__detail{stroke:#fff;fill:#fff}.grommetux-notification--status-unknown .grommetux-notification__status .grommetux-status-icon__base,.grommetux-notification--status-unknown .grommetux-notification__status .grommetux-status-icon__base .grommetux-status-icon__small{fill:#fff}.grommetux-notification--status-unknown .grommetux-notification__status .grommetux-status-icon__detail{stroke:#ccc;fill:#ccc}.grommetux-notification--status-unknown .grommetux-notification__close,.grommetux-notification--status-unknown .grommetux-notification__status.grommetux-status-icon-unknown .grommetux-status-icon__detail{stroke:#fff;fill:#fff}.grommetux-notification--status-disabled .grommetux-notification__status .grommetux-status-icon__base,.grommetux-notification--status-disabled .grommetux-notification__status .grommetux-status-icon__base .grommetux-status-icon__small{fill:#fff}.grommetux-notification--status-disabled .grommetux-notification__status .grommetux-status-icon__detail{stroke:#ccc;fill:#ccc}.grommetux-notification--status-disabled .grommetux-notification__close,.grommetux-notification--status-disabled .grommetux-notification__status.grommetux-status-icon-unknown .grommetux-status-icon__detail{stroke:#fff;fill:#fff}.grommetux-notification__message{font-size:24px;font-size:1.5rem;line-height:24px}.grommetux-notification__message+*{margin-top:24px}.grommetux-notification__status{flex:0 0 auto;margin-right:24px}html.rtl .grommetux-notification__status{margin-right:0;margin-left:24px}.grommetux-notification--small .grommetux-notification__message{font-size:19px;font-size:1.1875rem;line-height:24px}.grommetux-number-input__input{padding:11px 23px;border:1px solid rgba(0,0,0,.15);border-radius:0;outline:none;background-color:transparent;color:inherit;font:inherit;margin:0;-moz-appearance:textfield}.grommetux-number-input__input:focus{border-width:2px;border-color:#2ad2c9;padding:10px 22px}.grommetux-number-input__input::-moz-focus-inner{border:none;outline:none}.grommetux-number-input__input::-webkit-input-placeholder{color:#aaa}.grommetux-number-input__input::-moz-placeholder{color:#aaa}.grommetux-number-input__input:-ms-input-placeholder{color:#aaa}.grommetux-number-input__input.error{border-color:#f04953}.grommetux-number-input__input::-webkit-inner-spin-button,.grommetux-number-input__input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.grommetux-number-input__input:invalid{box-shadow:none}.grommetux-number-input__input::-ms-clear{display:none}.grommetux-object{overflow:auto}.grommetux-object ol,.grommetux-object ul{margin:0;list-style-type:none}.grommetux-object li{width:auto}.grommetux-object__container{padding:24px}.grommetux-object__attribute{margin-bottom:12px}.grommetux-object__attribute-name{display:block;color:#666;font-size:14px;font-size:.875rem;line-height:1.71429}.grommetux-object__attribute-value{display:block;font-size:16px;font-size:1rem;line-height:1.5}.grommetux-object__attribute-value ol,.grommetux-object__attribute-value ul{margin-left:24px;padding-top:24px;padding-bottom:24px}.grommetux-object__attribute--container>.grommetux-object__attribute-name{font-weight:600}.grommetux-object__attribute--unset .grommetux-object__attribute-value{font-style:italic;color:#666}.grommetux-object__attribute--array>.grommetux-object__attribute-value>ol>li{border-top:1px solid rgba(0,0,0,.15)}.grommetux-object__attribute--array>.grommetux-object__attribute-value>ol>li:last-child{border-bottom:1px solid rgba(0,0,0,.15)}.grommetux-object__attribute--array>.grommetux-object__attribute-value>ol>li>ul{padding-top:0;padding-bottom:0}.grommetux-paragraph{max-width:576px;margin-left:0;margin-top:24px;margin-bottom:24px;font-size:16px;font-weight:100;line-height:1.375;color:#666}.grommetux-paragraph--align-start{text-align:left}html.rtl .grommetux-paragraph--align-start{text-align:right}.grommetux-paragraph--align-center{text-align:center}.grommetux-paragraph--align-end{text-align:right}html.rtl .grommetux-paragraph--align-end{text-align:left}.grommetux-paragraph--margin-none{margin-top:0;margin-bottom:0}.grommetux-paragraph--margin-small{margin-top:12px;margin-bottom:12px}.grommetux-paragraph--margin-medium{margin-top:24px;margin-bottom:24px}.grommetux-paragraph--margin-large{margin-top:48px;margin-bottom:48px}.grommetux-background-color-index--dark .grommetux-paragraph,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-paragraph{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-paragraph,.grommetux-background-color-index--light .grommetux-paragraph{color:#333}.grommetux-paragraph--small{font-size:14px;line-height:1.43}.grommetux-paragraph--large{font-size:24px;line-height:1.167}.grommetux-paragraph--large a{color:#01a982;font-weight:600}.grommetux-paragraph--xlarge{font-size:32px;line-height:1.1875}.grommetux-paragraph--xlarge a{color:#01a982;font-weight:600}.grommetux-paragraph--width-large{max-width:100%}@media screen and (min-width:45em){.grommetux-paragraph--width-large{width:720px}}.grommetux-password-input{position:relative;cursor:pointer;overflow:hidden}.grommetux-password-input__input{padding:11px 23px;border:1px solid rgba(0,0,0,.15);border-radius:0;outline:none;background-color:transparent;color:inherit;font:inherit;margin:0;width:100%;padding-right:60px}.grommetux-password-input__input:focus{border-width:2px;border-color:#2ad2c9;padding:10px 22px}.grommetux-password-input__input::-moz-focus-inner{border:none;outline:none}.grommetux-password-input__input::-webkit-input-placeholder{color:#aaa}.grommetux-password-input__input::-moz-placeholder{color:#aaa}.grommetux-password-input__input:-ms-input-placeholder{color:#aaa}.grommetux-password-input__input.error{border-color:#f04953}.grommetux-password-input__input:focus{padding-right:58px}.grommetux-password-input__control{position:absolute;top:50%;transform:translateY(-50%);right:6px}@keyframes scale-up-fade-out{0%{transform:scale(1);opacity:1}15%{opacity:1}to{transform:scale(1.4);opacity:0}}.grommetux-pulse{display:inline-block;height:48px;width:48px;position:relative;line-height:0;transition:transform .25s ease-out;transform-origin:center}.grommetux-pulse:hover{transform:scale(1.2) rotate(.0001deg);cursor:pointer}.grommetux-pulse:hover .grommetux-pulse__icon-anim{animation:none}.grommetux-pulse__icon svg{width:48px;height:48px;border-radius:48px;padding:12px;background-color:#2ad2c9;stroke:#000001}.grommetux-pulse__icon-anim{display:block;width:48px;height:48px;position:absolute;top:0;left:0;box-sizing:border-box;transform-origin:center;border:1px solid;border-color:#2ad2c9;border-radius:48px;-webkit-animation-name:scale-up-fade-out;-webkit-animation-duration:1.5s;-webkit-animation-iteration-count:infinite;-webkit-animation-delay:.2s;animation-name:scale-up-fade-out;animation-duration:1.5s;animation-iteration-count:infinite;animation-delay:.2s}.grommetux-quote{border-width:24px;border-style:solid;max-width:100%}.grommetux-quote--small{border-width:12px}.grommetux-radio-button{margin-right:24px;white-space:nowrap}.grommetux-radio-button:not(.grommetux-radio-button--disabled){cursor:pointer}.grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__control{border-color:#000}.grommetux-background-color-index--dark .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__control{border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__control,.grommetux-background-color-index--light .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__control,.grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__input:checked+.grommetux-radio-button__control{border-color:#000}.grommetux-background-color-index--dark .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__input:checked+.grommetux-radio-button__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__input:checked+.grommetux-radio-button__control{border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__input:checked+.grommetux-radio-button__control,.grommetux-background-color-index--light .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__input:checked+.grommetux-radio-button__control{border-color:#000}.grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__label{color:#000}.grommetux-background-color-index--dark .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__label,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__label{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__label,.grommetux-background-color-index--light .grommetux-radio-button:hover:not(.grommetux-radio-button--disabled) .grommetux-radio-button__label{color:#000}.grommetux-radio-button__input{opacity:0;position:absolute}.grommetux-radio-button__input:checked+.grommetux-radio-button__control{border-color:#01a982}.grommetux-background-color-index--dark .grommetux-radio-button__input:checked+.grommetux-radio-button__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-radio-button__input:checked+.grommetux-radio-button__control{border-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-radio-button__input:checked+.grommetux-radio-button__control,.grommetux-background-color-index--light .grommetux-radio-button__input:checked+.grommetux-radio-button__control{border-color:#01a982}.grommetux-radio-button__input:checked+.grommetux-radio-button__control+.grommetux-radio-button__label{color:#333}.grommetux-background-color-index--dark .grommetux-radio-button__input:checked+.grommetux-radio-button__control+.grommetux-radio-button__label,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-radio-button__input:checked+.grommetux-radio-button__control+.grommetux-radio-button__label{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-radio-button__input:checked+.grommetux-radio-button__control+.grommetux-radio-button__label,.grommetux-background-color-index--light .grommetux-radio-button__input:checked+.grommetux-radio-button__control+.grommetux-radio-button__label{color:#333}.grommetux-radio-button__input:checked+.grommetux-radio-button__control:after{content:\"\";display:block;position:absolute;top:5px;left:5px;width:10px;height:10px;background-color:#01a982;border-radius:12px}.grommetux-background-color-index--dark .grommetux-radio-button__input:checked+.grommetux-radio-button__control:after,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-radio-button__input:checked+.grommetux-radio-button__control:after{background-color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-radio-button__input:checked+.grommetux-radio-button__control:after,.grommetux-background-color-index--light .grommetux-radio-button__input:checked+.grommetux-radio-button__control:after{background-color:#01a982}.grommetux-radio-button__input:focus+.grommetux-radio-button__control{content:\"\";border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-radio-button__control{position:relative;display:inline-block;width:24px;height:24px;margin-right:12px;vertical-align:middle;background-color:inherit;color:#017b5f;border:2px solid #666;border-radius:24px}html.rtl .grommetux-radio-button__control{margin-right:0;margin-left:12px}.grommetux-background-color-index--dark .grommetux-radio-button__control,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-radio-button__control{border-color:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-radio-button__control,.grommetux-background-color-index--light .grommetux-radio-button__control{border-color:#666}.grommetux-radio-button__label{display:inline-block;vertical-align:middle;color:#666;white-space:normal;margin-right:24px;word-break:break-word}.grommetux-background-color-index--dark .grommetux-radio-button__label,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-radio-button__label{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-radio-button__label,.grommetux-background-color-index--light .grommetux-radio-button__label{color:#666}.grommetux-radio-button--disabled .grommetux-radio-button__control{opacity:.5}.grommetux-search{display:inline-block}.grommetux-search:focus{outline:none;margin:-1px;border:1px solid #2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-search--controlled{cursor:pointer}.grommetux-search__input{margin-right:0;padding:11px 23px;border:1px solid rgba(0,0,0,.15);border-radius:0;outline:none;background-color:transparent;color:inherit;font:inherit;margin:0}.grommetux-search__input:focus{border-width:2px;border-color:#2ad2c9;padding:10px 22px}.grommetux-search__input::-moz-focus-inner{border:none;outline:none}.grommetux-search__input::-webkit-input-placeholder{color:#aaa}.grommetux-search__input::-moz-placeholder{color:#aaa}.grommetux-search__input:-ms-input-placeholder{color:#aaa}.grommetux-search__input.error{border-color:#f04953}.grommetux-search__input::-ms-clear{display:none}.grommetux-background-color-index--dark .grommetux-search__input,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-search__input{border-color:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-search__input:focus,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-search__input:focus{border-color:#2ad2c9}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-search__input,.grommetux-background-color-index--light .grommetux-search__input{border-color:rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-search__input:focus,.grommetux-background-color-index--light .grommetux-search__input:focus{border-color:#2ad2c9}.grommetux-search__drop{font-size:18px;font-size:1.125rem;line-height:inherit}@media screen and (max-width:44.9375em){.grommetux-search__drop{max-width:100%;width:100vw}}.grommetux-search__drop input{margin-right:0;box-sizing:border-box;width:100%;padding:12px}@media screen and (max-width:44.9375em){.grommetux-search__drop input{width:calc(100vw - 72px)}}.grommetux-search__drop input:focus{padding:11px}.grommetux-search__drop .grommetux-search__suggestion{padding:6px 24px;cursor:pointer;outline:none}@media screen and (max-width:44.9375em){.grommetux-search__drop .grommetux-search__suggestion{width:100vw}}.grommetux-search__drop .grommetux-search__suggestion--active,.grommetux-search__drop .grommetux-search__suggestion:hover{background-color:hsla(0,0%,87%,.5)}.grommetux-search__drop-control{vertical-align:top;height:48px}.grommetux-search__drop--controlled .grommetux-search__drop-contents{display:inline-block}.grommetux-search__drop--large{line-height:96px}.grommetux-search--inline{position:relative}.grommetux-search--inline .grommetux-search__input{width:100%;box-sizing:border-box;padding:12px 47px 12px 11px;border-radius:0;-webkit-appearance:none}.grommetux-search--inline .grommetux-search__input:focus{padding:11px 46px 11px 10px}html.rtl .grommetux-search--inline .grommetux-search__input{padding-right:11px;padding-left:47px}html.rtl .grommetux-search--inline .grommetux-search__input:focus{padding-right:11px;padding-left:46px}.grommetux-header .grommetux-search--inline .grommetux-search__input:not(:focus){border-color:transparent}.grommetux-search--inline .grommetux-control-icon-search{position:absolute;right:12px;top:50%;transform:translateY(-50%);pointer-events:none}html.rtl .grommetux-search--inline .grommetux-control-icon-search{right:auto;left:12px}.grommetux-search--small .grommetux-search__input{font-size:16px;font-size:1rem;line-height:normal;padding:4px 18px;padding-right:23px}.grommetux-search--small .grommetux-search__input:focus{padding:3px 17px;padding-right:22px}.grommetux-search--medium .grommetux-search__input{font-size:24px;font-size:1.5rem;line-height:normal}.grommetux-search--large .grommetux-search__input{font-size:54px;font-size:3.375rem;line-height:normal;padding:12px 24px;padding-right:72px}.grommetux-search--large .grommetux-search__input:focus{padding:11px 71px;padding-left:23px}@media screen and (max-width:44.9375em){.grommetux-search--large .grommetux-search__input:focus{padding:10px 22px;padding-right:46px}}@media screen and (max-width:44.9375em){.grommetux-search--large .grommetux-search__input{font-size:inherit;padding:11px 23px;padding-right:47px;line-height:1.5}}.grommetux-search--large .grommetux-control-icon-search{right:24px;width:48px;height:48px}@media screen and (max-width:44.9375em){.grommetux-search--large .grommetux-control-icon-search{right:12px;width:24px;height:24px}}@media screen and (min-width:45em){.grommetux-search--large .grommetux-control-icon-search{transition:none}}.grommetux-search--icon-align-start.grommetux-search--inline .grommetux-search__input{padding-left:47px;padding-right:23px}.grommetux-search--icon-align-start.grommetux-search--inline .grommetux-search__input:focus{padding-left:46px;padding-right:23px}.grommetux-search--icon-align-start.grommetux-search--inline .grommetux-control-icon-search{left:12px}.grommetux-search--icon-align-start.grommetux-search--large .grommetux-search__input{padding-left:72px;padding-right:24px}.grommetux-search--icon-align-start.grommetux-search--large .grommetux-search__input:focus{padding-left:71px;padding-right:23px}@media screen and (max-width:44.9375em){.grommetux-search--icon-align-start.grommetux-search--large .grommetux-search__input:focus{padding:10px 22px;padding-left:46px}}@media screen and (max-width:44.9375em){.grommetux-search--icon-align-start.grommetux-search--large .grommetux-search__input{padding:11px 23px;padding-left:47px}}.grommetux-search--fill{max-width:none;flex-grow:1}.grommetux-search--pad-medium.grommetux-search--inline .grommetux-search__input{padding-left:23px;padding-right:23px}.grommetux-search--pad-medium.grommetux-search--inline .grommetux-control-icon-search{right:24px}.grommetux-search-input{position:relative;display:inline-block}.grommetux-search-input__input{padding:11px 23px;border:1px solid rgba(0,0,0,.15);border-radius:0;outline:none;background-color:transparent;color:inherit;font:inherit;margin:0;padding-right:60px}.grommetux-search-input__input:focus{border-width:2px;border-color:#2ad2c9;padding:10px 22px}.grommetux-search-input__input::-moz-focus-inner{border:none;outline:none}.grommetux-search-input__input::-webkit-input-placeholder{color:#aaa}.grommetux-search-input__input::-moz-placeholder{color:#aaa}.grommetux-search-input__input:-ms-input-placeholder{color:#aaa}.grommetux-search-input__input.error{border-color:#f04953}.grommetux-search-input__input:focus{padding-right:58px}.grommetux-search-input__input::-ms-clear{display:none}.grommetux-search-input__control{position:absolute;top:50%;transform:translateY(-50%);right:6px}.grommetux-search-input__suggestions{border-top-left-radius:0;border-top-right-radius:0;margin:0;list-style-type:none}.grommetux-search-input__suggestion{padding:6px 24px;cursor:pointer}.grommetux-search-input__suggestion--active,.grommetux-search-input__suggestion:hover{background-color:hsla(0,0%,87%,.5)}.grommetux-search-input--active .grommetux-search-input__input{border-bottom-left-radius:0;border-bottom-right-radius:0}section:not(.grommetux-section){padding-top:24px;padding-bottom:24px}section:not(.grommetux-section):first-of-type{margin-top:0;padding-top:0}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.layer .grommet section,.layer .grommetux-section{height:100%}}.grommet section>img,.grommetux-section>img{margin-top:24px;margin-bottom:24px;display:block;height:auto}@media screen and (max-width:44.9375em){.grommet section>img,.grommetux-section>img{max-width:100%}}.grommet section>iframe,.grommetux-section>iframe{width:100%;max-width:576px}@media screen and (max-width:44.9375em){.grommet section>ol,.grommet section>ul:not([class^=grommetux-]),.grommetux-section>ol,.grommetux-section>ul:not([class^=grommetux-]){margin-left:2rem}}.grommet section>dl>dt,.grommetux-section>dl>dt{margin-top:24px;margin-bottom:6px}.grommet section>dl>dt code,.grommetux-section>dl>dt code{text-transform:none;white-space:pre-wrap}.grommet section>dl>dd,.grommetux-section>dl>dd{margin-left:0}@media screen and (max-width:44.9375em){.grommet section>dl>dd,.grommetux-section>dl>dd{padding-right:24px}}.grommetux-select{position:relative;cursor:pointer;overflow:hidden}.grommetux-select__input{padding:11px 23px;border:1px solid rgba(0,0,0,.15);border-radius:0;outline:none;background-color:transparent;font:inherit;margin:0;width:100%;padding-right:60px;cursor:inherit;color:inherit;pointer-events:none}.grommetux-select__input:focus{border-width:2px;border-color:#2ad2c9;padding:10px 22px}.grommetux-select__input::-moz-focus-inner{border:none;outline:none}.grommetux-select__input::-webkit-input-placeholder{color:#aaa}.grommetux-select__input::-moz-placeholder{color:#aaa}.grommetux-select__input:-ms-input-placeholder{color:#aaa}.grommetux-select__input.error{border-color:#f04953}.grommetux-select__input[readonly]{color:#333}.grommetux-background-color-index--dark .grommetux-select__input[readonly],.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-select__input[readonly]{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-select__input[readonly],.grommetux-background-color-index--light .grommetux-select__input[readonly]{color:#333}.grommetux-select__input:focus{padding-right:58px}.grommetux-select__input::-ms-clear{display:none}.grommetux-select__value{padding:6px 48px 6px 0;border:1px solid rgba(0,0,0,.15);border-radius:0}.grommetux-select__control{position:absolute;top:50%;transform:translateY(-50%);right:6px}.grommetux-select__control svg{background-color:#fff}.grommetux-select__search{width:100%}.grommetux-select__options{margin:0;list-style-type:none}.grommetux-select__option{min-height:36px;padding:6px 0;cursor:pointer}.grommetux-select__drop{border-top-left-radius:0;border-top-right-radius:0}.grommetux-select__drop .grommetux-select__option{font-size:16px;font-weight:100;line-height:1.375;color:#666;color:#333;padding:6px 24px}.grommetux-select__drop .grommetux-select__option.grommetux-select__option--element{padding:6px 0}.grommetux-select__drop .grommetux-select__option--active,.grommetux-select__drop .grommetux-select__option:hover{background-color:hsla(0,0%,87%,.5)}.grommetux-select__drop .grommetux-select__option--selected{color:#000;background-color:hsla(0,0%,87%,.5)}@media screen and (max-width:44.9375em){.grommetux-sidebar{max-width:100%;width:100vw}}@media screen and (min-width:45em){.grommetux-sidebar{width:336px}}.grommetux-sidebar--fixed{display:flex;flex-direction:column;max-height:100vh}@media screen and (min-width:45em){.grommetux-sidebar--xsmall{width:144px}}@media screen and (min-width:45em){.grommetux-sidebar--small{width:240px}}@media screen and (min-width:45em){.grommetux-sidebar--large{width:480px}}.grommetux-sidebar--full{height:100vh;overflow:auto}.grommetux-split{position:relative;overflow:visible}@media screen and (min-width:45em){.grommetux-split{display:flex;flex-direction:row}}.grommetux-split__column{flex:0 0 auto}.grommetux-split__column--hidden{display:none}@media screen and (min-width:45em){.grommetux-split__column--fixed{position:relative;height:100vh;overflow:auto;-ms-overflow-style:-ms-autohiding-scrollbar}}@media screen and (min-width:45em){.grommetux-split__column--flex{flex:1 1}}@media screen and (min-width:45em){.grommetux-split__column--separator{border-right:1px solid #000}}@media screen and (max-width:44.9375em){.grommetux-split__column--separator{border-bottom:1px solid #000}}.grommetux-skip-link-anchor{width:0;height:0;overflow:hidden;position:absolute}@keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes draw-arc{0%{stroke-dashoffset:-384px}to{stroke-dashoffset:0}}.grommetux-sun-burst{position:relative;height:384px;width:384px;max-width:100%}.grommetux-sun-burst__graphic{animation:fade-in 2.5s;outline:none}.grommetux-sun-burst__graphic--focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-sun-burst__label{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none}.grommetux-sun-burst__slice{stroke-linecap:butt;stroke-dasharray:1536px 1536px;stroke-dashoffset:0;stroke:rgba(0,0,0,.1);animation:draw-arc 1.5s linear;transition:opacity .3s}.grommetux-sun-burst__slice.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-sun-burst__slice.grommetux-color-index-unset{stroke:#ddd}.grommetux-sun-burst__slice.grommetux-color-index-brand{stroke:#01a982}.grommetux-sun-burst__slice.grommetux-color-index-critical,.grommetux-sun-burst__slice.grommetux-color-index-error{stroke:#f04953}.grommetux-sun-burst__slice.grommetux-color-index-warning{stroke:#ffd144}.grommetux-sun-burst__slice.grommetux-color-index-ok{stroke:#01a982}.grommetux-sun-burst__slice.grommetux-color-index-disabled,.grommetux-sun-burst__slice.grommetux-color-index-unknown{stroke:#ccc}.grommetux-sun-burst__slice.grommetux-color-index-graph-1,.grommetux-sun-burst__slice.grommetux-color-index-graph-5{stroke:#425563}.grommetux-sun-burst__slice.grommetux-color-index-graph-2,.grommetux-sun-burst__slice.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-sun-burst__slice.grommetux-color-index-graph-3,.grommetux-sun-burst__slice.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-sun-burst__slice.grommetux-color-index-graph-4,.grommetux-sun-burst__slice.grommetux-color-index-graph-8{stroke:#767676}.grommetux-sun-burst__slice.grommetux-color-index-grey-1,.grommetux-sun-burst__slice.grommetux-color-index-grey-6{stroke:#000001}.grommetux-sun-burst__slice.grommetux-color-index-grey-2,.grommetux-sun-burst__slice.grommetux-color-index-grey-7{stroke:#333}.grommetux-sun-burst__slice.grommetux-color-index-grey-3,.grommetux-sun-burst__slice.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-sun-burst__slice.grommetux-color-index-grey-4,.grommetux-sun-burst__slice.grommetux-color-index-grey-9{stroke:#434343}.grommetux-sun-burst__slice.grommetux-color-index-grey-5,.grommetux-sun-burst__slice.grommetux-color-index-grey-10{stroke:#666}.grommetux-sun-burst__slice.grommetux-color-index-accent-1,.grommetux-sun-burst__slice.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-sun-burst__slice.grommetux-color-index-accent-2,.grommetux-sun-burst__slice.grommetux-color-index-accent-5{stroke:#614767}.grommetux-sun-burst__slice.grommetux-color-index-accent-3,.grommetux-sun-burst__slice.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-sun-burst__slice.grommetux-color-index-neutral-1,.grommetux-sun-burst__slice.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-sun-burst__slice.grommetux-color-index-neutral-2,.grommetux-sun-burst__slice.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-sun-burst__slice.grommetux-color-index-neutral-3,.grommetux-sun-burst__slice.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-sun-burst__slice.grommetux-color-index-neutral-4,.grommetux-sun-burst__slice.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-sun-burst__slice.grommetux-color-index-light-1,.grommetux-sun-burst__slice.grommetux-color-index-light-3{stroke:#fff}.grommetux-sun-burst__slice.grommetux-color-index-light-2,.grommetux-sun-burst__slice.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-sun-burst__slice--hot{cursor:pointer;outline:none}.grommetux-sun-burst--active .grommetux-sun-burst__slice{opacity:.7}.grommetux-sun-burst--active .grommetux-sun-burst__slice--active{opacity:1}.grommetux-sun-burst--small{height:192px;width:192px}.grommetux-sun-burst--large{height:576px;width:576px}.grommetux-sun-burst--xlarge{height:720px;width:720px}.grommetux-sun-burst--full{width:100%}.grommetux-tab{padding:0 12px}@media screen and (max-width:44.9375em){.grommetux-tab{padding:6px}}.grommetux-tabs--justify-end .grommetux-tab:first-of-type,.grommetux-tabs--justify-start .grommetux-tab:first-of-type{padding-left:0}.grommetux-tabs--justify-end .grommetux-tab:last-of-type,.grommetux-tabs--justify-start .grommetux-tab:last-of-type{padding-right:0}@media screen and (max-width:44.9375em){.grommetux-tabs--responsive .grommetux-tab:first-of-type,.grommetux-tabs--responsive .grommetux-tab:last-of-type{padding-left:12px;padding-right:12px}}.grommetux-tab__label{display:inline-block;cursor:pointer;padding-bottom:10px;color:#666;border-bottom:4px solid transparent}@media screen and (max-width:44.9375em){.grommetux-tab__label{padding-bottom:6px}}.grommetux-tab--active .grommetux-tab__label{color:#000;border-color:#000}.grommetux-tab:hover:not(.grommetux-tab--active) .grommetux-tab__label{border-color:rgba(0,0,0,.15)}.grommetux-tabs{margin:12px 0;padding:0;display:flex;flex-wrap:wrap;align-items:center;list-style:none;border-bottom:1px solid rgba(0,0,0,.15)}.grommetux-tabs+div:focus{outline:none}.grommetux-tabs--justify-center{justify-content:center}.grommetux-tabs--justify-start{justify-content:flex-start}.grommetux-tabs--justify-end{justify-content:flex-end}@media screen and (max-width:44.9375em){.grommetux-tabs--justify-center.grommetux-tabs--responsive,.grommetux-tabs--justify-end.grommetux-tabs--responsive,.grommetux-tabs--justify-start.grommetux-tabs--responsive{flex-direction:column;text-align:center}}.grommetux-table,.grommetux-table table{width:100%;max-width:100%}.grommetux-table table{border-collapse:collapse}.grommetux-table td,.grommetux-table th{padding:11px 12px;text-align:left}.grommetux-table td:first-child,.grommetux-table th:first-child{padding-left:24px}.grommetux-table td:last-child,.grommetux-table th:last-child{padding-right:24px}.grommetux-table th{font-weight:100;border-bottom:1px solid rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-table th,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-table th{border-color:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-table th,.grommetux-background-color-index--light .grommetux-table th{border-color:rgba(0,0,0,.15)}.grommetux-table__mirror{position:absolute;top:0;left:0;right:0}.grommetux-table__mirror>thead{position:fixed;background-color:hsla(0,0%,100%,.9)}.grommetux-table__more{margin-top:24px;text-align:center}.grommetux-table--scrollable{position:relative}.grommetux-table--scrollable .grommetux-table__table thead{visibility:hidden}.grommetux-table--scrollable .grommetux-table__table th{border-bottom:none}.grommetux-table--selectable .grommetux-table__table{outline:none}.grommetux-table--selectable .grommetux-table__table--focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-table--selectable tbody tr{cursor:pointer;outline:none}.grommetux-table--selectable tbody tr td{transition:background-color .2s}.grommetux-table--selectable tbody tr.grommetux-table-row--selected td{background-color:#d0f3eb;color:#333}.grommetux-background-color-index--dark .grommetux-table--selectable tbody tr.grommetux-table-row--selected td,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-table--selectable tbody tr.grommetux-table-row--selected td{background-color:rgba(0,0,0,.15);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-table--selectable tbody tr.grommetux-table-row--selected td,.grommetux-background-color-index--light .grommetux-table--selectable tbody tr.grommetux-table-row--selected td{background-color:#d0f3eb;color:#333}.grommetux-table--selectable tbody tr.grommetux-table-row--active td,.grommetux-table--selectable tbody tr:hover td{background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-background-color-index--dark .grommetux-table--selectable tbody tr.grommetux-table-row--active td,.grommetux-background-color-index--dark .grommetux-table--selectable tbody tr:hover td,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-table--selectable tbody tr.grommetux-table-row--active td,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-table--selectable tbody tr:hover td{background-color:rgba(0,0,0,.1);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-table--selectable tbody tr.grommetux-table-row--active td,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-table--selectable tbody tr:hover td,.grommetux-background-color-index--light .grommetux-table--selectable tbody tr.grommetux-table-row--active td,.grommetux-background-color-index--light .grommetux-table--selectable tbody tr:hover td{background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-table--small thead{display:none}.grommetux-table--small td{display:block}.grommetux-table--small td:before{font-weight:100;font-size:19px;font-size:1.1875rem;line-height:24px;content:attr(data-th);display:block;padding-right:12px}.grommetux-table--small tr{border-bottom:1px solid rgba(0,0,0,.15)}.grommetux-table--small td,.grommetux-table--small th{padding-left:24px}.grommetux-tbd{text-align:center;padding:96px;font-size:96px;font-size:6rem;line-height:1;font-style:italic;background-color:rgba(0,0,0,.15);color:#fff}.grommetux-text-input{padding:11px 23px;border:1px solid rgba(0,0,0,.15);border-radius:0;outline:none;background-color:transparent;color:inherit;font:inherit;margin:0}.grommetux-text-input:focus{border-width:2px;border-color:#2ad2c9;padding:10px 22px}.grommetux-text-input::-moz-focus-inner{border:none;outline:none}.grommetux-text-input::-webkit-input-placeholder{color:#aaa}.grommetux-text-input::-moz-placeholder{color:#aaa}.grommetux-text-input:-ms-input-placeholder{color:#aaa}.grommetux-text-input.error{border-color:#f04953}.grommetux-text-input--active{border-bottom-left-radius:0;border-bottom-right-radius:0}.grommetux-text-input__suggestions{border-top-left-radius:0;border-top-right-radius:0;margin:0;list-style-type:none}.grommetux-text-input__suggestion{padding:6px 24px;cursor:pointer}.grommetux-text-input__suggestion--active,.grommetux-text-input__suggestion:hover{background-color:hsla(0,0%,87%,.5)}.grommetux-tiles{width:100%}.grommetux-tiles--pad-none{padding:0}@media screen and (min-width:45em){.grommetux-tiles--pad-small{padding:12px}.grommetux-tiles--pad-medium{padding:24px}.grommetux-tiles--pad-large{padding:48px}.grommetux-tiles--pad-xlarge{padding:192px}}@media screen and (max-width:44.9375em){.grommetux-tiles--pad-small{padding:6px}.grommetux-tiles--pad-medium{padding:12px}.grommetux-tiles--pad-large{padding:24px}.grommetux-tiles--pad-xlarge{padding:48px}}.grommetux-tiles--pad-horizontal-none{padding-left:0;padding-right:0}@media screen and (min-width:45em){.grommetux-tiles--pad-horizontal-small{padding-left:12px;padding-right:12px}.grommetux-tiles--pad-horizontal-medium{padding-left:24px;padding-right:24px}.grommetux-tiles--pad-horizontal-large{padding-left:48px;padding-right:48px}.grommetux-tiles--pad-horizontal-xlarge{padding-left:192px;padding-right:192px}}@media screen and (max-width:44.9375em){.grommetux-tiles--pad-horizontal-small{padding-left:6px;padding-right:6px}.grommetux-tiles--pad-horizontal-medium{padding-left:12px;padding-right:12px}.grommetux-tiles--pad-horizontal-large{padding-left:24px;padding-right:24px}.grommetux-tiles--pad-horizontal-xlarge{padding-left:48px;padding-right:48px}}.grommetux-tiles--pad-vertical-none{padding-top:0;padding-bottom:0}@media screen and (min-width:45em){.grommetux-tiles--pad-vertical-small{padding-top:12px;padding-bottom:12px}.grommetux-tiles--pad-vertical-medium{padding-top:24px;padding-bottom:24px}.grommetux-tiles--pad-vertical-large{padding-top:48px;padding-bottom:48px}.grommetux-tiles--pad-vertical-xlarge{padding-top:192px;padding-bottom:192px}}@media screen and (max-width:44.9375em){.grommetux-tiles--pad-vertical-small{padding-top:6px;padding-bottom:6px}.grommetux-tiles--pad-vertical-medium{padding-top:12px;padding-bottom:12px}.grommetux-tiles--pad-vertical-large{padding-top:24px;padding-bottom:24px}.grommetux-tiles--pad-vertical-xlarge{padding-top:48px;padding-bottom:48px}}.grommetux-tiles--focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-tiles__container{display:flex;flex-direction:row;align-items:center;width:100%}.grommetux-tiles__container .grommetux-tiles__left,.grommetux-tiles__container .grommetux-tiles__right{flex:0 0 auto}.grommetux-tiles__container .grommetux-tiles{flex:1;margin:0}.grommetux-tiles__container .grommetux-tiles.grommetux-box--direction-row{width:100%;overflow:hidden}.grommetux-tiles:not(.grommetux-tiles--flush)>.grommetux-tile{margin:12px}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-tiles:not(.grommetux-tiles--flush)>.grommetux-tile{margin:24px}}.grommetux-tiles:not(.grommetux-tiles--flush)>.grommetux-tile--wide{flex-basis:calc(100% - 24px)}.grommetux-tiles:not(.grommetux-tiles--flush)>.grommetux-tile.grommetux-tile--hover-border-medium{margin:6px}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-tiles:not(.grommetux-tiles--flush)>.grommetux-tile.grommetux-tile--hover-border-medium{margin:12px}}.grommetux-tiles:not(.grommetux-tiles--flush)>.grommetux-tile.grommetux-tile--hover-border-large{margin:12px}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-tiles:not(.grommetux-tiles--flush)>.grommetux-tile.grommetux-tile--hover-border-large{margin:24px}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-tiles--fill{height:100%}}.grommetux-tiles--fill.grommetux-box--wrap{justify-content:space-around}.grommetux-tiles--fill.grommetux-box--wrap>.grommetux-tile{flex-grow:1}.grommetux-tiles--flush{padding:0}.grommetux-tiles--flush>.grommetux-tile{margin:0}.grommetux-tiles--flush>.grommetux-tile--wide{flex-basis:100%}.grommetux-tiles__more{flex:1 1 100%;text-align:center}.grommetux-tiles--selectable{outline:none}.grommetux-tiles--selectable .grommetux-tile{cursor:pointer;outline:none;transition:all .2s}.grommetux-tiles--selectable .grommetux-tile--selected{background-color:#d0f3eb;color:#333}.grommetux-background-color-index--dark .grommetux-tiles--selectable .grommetux-tile--selected,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-tiles--selectable .grommetux-tile--selected{background-color:rgba(0,0,0,.15);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-tiles--selectable .grommetux-tile--selected,.grommetux-background-color-index--light .grommetux-tiles--selectable .grommetux-tile--selected{background-color:#d0f3eb;color:#333}.grommetux-tiles--selectable .grommetux-tile--active,.grommetux-tiles--selectable .grommetux-tile:hover:not([class*=background-hover-color-index-]){background-color:hsla(0,0%,87%,.5);color:#000}.grommetux-background-color-index--dark .grommetux-tiles--selectable .grommetux-tile--active,.grommetux-background-color-index--dark .grommetux-tiles--selectable .grommetux-tile:hover:not([class*=background-hover-color-index-]),.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-tiles--selectable .grommetux-tile--active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-tiles--selectable .grommetux-tile:hover:not([class*=background-hover-color-index-]){background-color:rgba(0,0,0,.1);color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-tiles--selectable .grommetux-tile--active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-tiles--selectable .grommetux-tile:hover:not([class*=background-hover-color-index-]),.grommetux-background-color-index--light .grommetux-tiles--selectable .grommetux-tile--active,.grommetux-background-color-index--light .grommetux-tiles--selectable .grommetux-tile:hover:not([class*=background-hover-color-index-]){background-color:hsla(0,0%,87%,.5);color:#000}@media screen and (min-width:45em){.grommetux-tiles--small>.grommetux-tile:not(.grommetux-box--size){flex-basis:192px}}@media screen and (min-width:45em){.grommetux-tiles--large>.grommetux-tile:not(.grommetux-box--size){flex-basis:576px}}.grommetux-tile{overflow:hidden;transition:all .2s}.grommetux-tile .grommetux-status-icon{margin-right:6px}html.rtl .grommetux-tile .grommetux-status-icon{margin-right:0;margin-left:6px}.grommetux-tile--selectable{cursor:pointer;transition:background-color .2s}.grommetux-tile--eclipsed{opacity:.2}.grommetux-timestamp--center{text-align:center}.grommetux-timestamp--end{text-align:right}.grommetux-timestamp__date{white-space:nowrap}.grommetux-timestamp__date+.grommetux-timestamp__time{margin-left:.2em}.grommetux-timestamp__time{text-transform:lowercase;white-space:nowrap}.grommet.grommetux-tip__drop{overflow:visible;max-width:384px}.grommetux-tip__drop:after{content:\"\";position:absolute;width:0;height:0;border-left:12px solid transparent;border-right:12px solid transparent}.grommetux-tip__drop--top{transform:translateY(12px)}.grommetux-tip__drop--top:after{content:\"\";top:-12px;border-bottom:12px solid rgba(0,0,0,.15)}.grommetux-tip__drop--top.grommetux-background-color-index-accent-1:after,.grommetux-tip__drop--top.grommetux-background-color-index-accent-4:after{content:\"\";border-bottom-color:#2ad2c9}.grommetux-tip__drop--top.grommetux-background-color-index-accent-2:after,.grommetux-tip__drop--top.grommetux-background-color-index-accent-5:after{content:\"\";border-bottom-color:#614767}.grommetux-tip__drop--top.grommetux-background-color-index-accent-3:after,.grommetux-tip__drop--top.grommetux-background-color-index-accent-6:after{content:\"\";border-bottom-color:#ff8d6d}.grommetux-tip__drop--bottom{transform:translateY(-12px)}.grommetux-tip__drop--bottom:after{content:\"\";bottom:-12px;border-top:12px solid rgba(0,0,0,.15)}.grommetux-tip__drop--bottom.grommetux-background-color-index-accent-1:after,.grommetux-tip__drop--bottom.grommetux-background-color-index-accent-4:after{content:\"\";border-top-color:#2ad2c9}.grommetux-tip__drop--bottom.grommetux-background-color-index-accent-2:after,.grommetux-tip__drop--bottom.grommetux-background-color-index-accent-5:after{content:\"\";border-top-color:#614767}.grommetux-tip__drop--bottom.grommetux-background-color-index-accent-3:after,.grommetux-tip__drop--bottom.grommetux-background-color-index-accent-6:after{content:\"\";border-top-color:#ff8d6d}.grommetux-tip__drop--left:after{content:\"\";left:12px}.grommetux-tip__drop--right:after{content:\"\";right:12px}.grommetux-tip{overflow:hidden}.grommetux-title{max-height:100%;font-weight:100;font-size:24px;font-size:1.5rem;line-height:1;line-height:normal;margin-right:12px}@media screen and (min-width:45em){.grommetux-title{font-weight:600}}.grommetux-title>:not(:last-child){margin-right:12px}html.rtl .grommetux-title>:not(:last-child){margin-right:0;margin-left:12px}.grommetux-title a{color:inherit}.grommetux-title a,.grommetux-title a:hover{text-decoration:none}[class*=background-color-index-] .grommetux-title a:hover{text-decoration:underline}.grommetux-title span{overflow:hidden;text-overflow:ellipsis}.grommetux-title img,.grommetux-title svg{max-width:384px;flex:0 0 auto}.grommetux-title img:not(:last-child),.grommetux-title svg:not(:last-child){margin-right:12px}.grommetux-title--interactive{cursor:pointer}@media screen and (min-width:45em){.grommetux-title--interactive{transition:color .3s ease-in-out}}.grommetux-title--interactive:hover{color:#01a982;cursor:pointer}.grommetux-background-color-index--dark .grommetux-title--interactive:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-title--interactive:hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-title--interactive:hover,.grommetux-background-color-index--light .grommetux-title--interactive:hover{color:#01a982}@media screen and (max-width:44.9375em){.grommetux-title--responsive img,.grommetux-title--responsive svg{margin-right:0}.grommetux-title--responsive>:not(:first-child){display:none}}.grommetux-title--truncate{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.grommetux-toast__container{position:fixed;top:0;left:0;right:0;z-index:100}@keyframes toast-lower{0%{transform:translateY(-100%)}to{transform:translateY(0)}}@keyframes toast-raise{0%{transform:translateY(0)}to{transform:translateY(-100%)}}.grommetux-toast{display:flex;flex-direction:row;align-items:center;min-height:72px;background-color:hsla(0,0%,93%,.9);animation:toast-lower 1s}.grommetux-toast--closing{animation:toast-raise 1s;animation-fill-mode:forwards}.grommetux-toast__closer{flex:0 0 auto}.grommetux-toast__status{flex:0 0 auto;margin-left:24px}.grommetux-toast__contents{flex:1;padding:6px 24px}.grommetux-toast--small{min-height:48px}.grommetux-toast--medium{min-height:72px}.grommetux-toast--large{min-height:96px}.grommetux-topology{position:relative;outline:none}.grommetux-topology .grommetux-status-icon{position:relative;z-index:2}.grommetux-topology--focus{border-color:#2ad2c9;box-shadow:0 0 1px 1px #2ad2c9}.grommetux-topology__links{position:absolute;top:0;left:0;z-index:1;pointer-events:none}.grommetux-topology__path{stroke-width:2px}.grommetux-topology__path.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-topology__path.grommetux-color-index-unset{stroke:#ddd}.grommetux-topology__path.grommetux-color-index-brand{stroke:#01a982}.grommetux-topology__path.grommetux-color-index-critical,.grommetux-topology__path.grommetux-color-index-error{stroke:#f04953}.grommetux-topology__path.grommetux-color-index-warning{stroke:#ffd144}.grommetux-topology__path.grommetux-color-index-ok{stroke:#01a982}.grommetux-topology__path.grommetux-color-index-disabled,.grommetux-topology__path.grommetux-color-index-unknown{stroke:#ccc}.grommetux-topology__path.grommetux-color-index-graph-1,.grommetux-topology__path.grommetux-color-index-graph-5{stroke:#425563}.grommetux-topology__path.grommetux-color-index-graph-2,.grommetux-topology__path.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-topology__path.grommetux-color-index-graph-3,.grommetux-topology__path.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-topology__path.grommetux-color-index-graph-4,.grommetux-topology__path.grommetux-color-index-graph-8{stroke:#767676}.grommetux-topology__path.grommetux-color-index-grey-1,.grommetux-topology__path.grommetux-color-index-grey-6{stroke:#000001}.grommetux-topology__path.grommetux-color-index-grey-2,.grommetux-topology__path.grommetux-color-index-grey-7{stroke:#333}.grommetux-topology__path.grommetux-color-index-grey-3,.grommetux-topology__path.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-topology__path.grommetux-color-index-grey-4,.grommetux-topology__path.grommetux-color-index-grey-9{stroke:#434343}.grommetux-topology__path.grommetux-color-index-grey-5,.grommetux-topology__path.grommetux-color-index-grey-10{stroke:#666}.grommetux-topology__path.grommetux-color-index-accent-1,.grommetux-topology__path.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-topology__path.grommetux-color-index-accent-2,.grommetux-topology__path.grommetux-color-index-accent-5{stroke:#614767}.grommetux-topology__path.grommetux-color-index-accent-3,.grommetux-topology__path.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-topology__path.grommetux-color-index-neutral-1,.grommetux-topology__path.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-topology__path.grommetux-color-index-neutral-2,.grommetux-topology__path.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-topology__path.grommetux-color-index-neutral-3,.grommetux-topology__path.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-topology__path.grommetux-color-index-neutral-4,.grommetux-topology__path.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-topology__path.grommetux-color-index-light-1,.grommetux-topology__path.grommetux-color-index-light-3{stroke:#fff}.grommetux-topology__path.grommetux-color-index-light-2,.grommetux-topology__path.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-topology__path--active{stroke-width:6px}@media screen and (min-width:45em){.grommetux-topology__contents>.grommetux-topology__parts--direction-row>.grommetux-topology__part{margin-right:48px}.grommetux-topology__contents>.grommetux-topology__parts--direction-row>.grommetux-topology__part:last-child{margin-right:0}}@media screen and (max-width:44.9375em){.grommetux-topology__contents>.grommetux-topology__parts--direction-row>.grommetux-topology__part{margin-bottom:48px}.grommetux-topology__contents>.grommetux-topology__parts--direction-row>.grommetux-topology__part:last-child{margin-bottom:0}}.grommetux-topology__contents>.grommetux-topology__parts--direction-column>.grommetux-topology__part{margin-bottom:48px}.grommetux-topology__contents>.grommetux-topology__parts--direction-column>.grommetux-topology__part:last-child{margin-bottom:0}.grommetux-topology__parts{display:flex;align-items:stretch;outline:none}.grommetux-topology__parts--direction-row{flex-direction:row;flex-grow:1}.grommetux-topology__parts--direction-column{flex-direction:column;flex-grow:1}.grommetux-topology__parts--align-start{align-items:flex-start}.grommetux-topology__parts--align-center{align-items:center}.grommetux-topology__parts--align-end{align-items:flex-end}.grommetux-topology__parts--align-stretch{align-items:stretch}.grommetux-topology__part{display:flex;justify-content:center;align-items:stretch;overflow:hidden;outline:none}.grommetux-topology__part>.grommetux-topology__parts .grommetux-topology__part{flex:1}.grommetux-topology__part--demarcate{border:1px solid rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-topology__part--demarcate,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-topology__part--demarcate{border-color:hsla(0,0%,100%,.5)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-topology__part--demarcate,.grommetux-background-color-index--light .grommetux-topology__part--demarcate{border-color:rgba(0,0,0,.15)}.grommetux-topology__part--demarcate.grommetux-topology__part--empty{background-color:#f5f5f5;min-width:24px;min-height:24px}.grommetux-background-color-index--dark .grommetux-topology__part--demarcate.grommetux-topology__part--empty,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-topology__part--demarcate.grommetux-topology__part--empty{background-color:rgba(0,0,0,.15)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-topology__part--demarcate.grommetux-topology__part--empty,.grommetux-background-color-index--light .grommetux-topology__part--demarcate.grommetux-topology__part--empty{background-color:#f5f5f5}.grommetux-topology__part--justify-start{justify-content:flex-start}.grommetux-topology__part--justify-center{justify-content:center}.grommetux-topology__part--justify-between{justify-content:space-between}.grommetux-topology__part--justify-end{justify-content:flex-end}.grommetux-topology__part--align-start{align-items:flex-start}.grommetux-topology__part--align-center{align-items:center}.grommetux-topology__part--align-end{align-items:flex-end}.grommetux-topology__part--align-stretch{align-items:stretch}.grommetux-topology__part--direction-row{flex-direction:row}.grommetux-topology__part--direction-row.grommetux-topology__part--reverse{flex-direction:row-reverse}.grommetux-topology__part--direction-row>:not(.grommetux-topology__parts):not(.grommetux-topology__part){margin:6px}.grommetux-topology__part--direction-column{flex-direction:column}.grommetux-topology__part--direction-column.grommetux-topology__part--reverse{flex-direction:column-reverse}.grommetux-topology__part--direction-column>:not(.grommetux-topology__parts):not(.grommetux-topology__part){margin:6px}.grommetux-topology__label{font-size:14px;margin-left:12px;margin-right:12px}.grommetux-value{display:inline-block}.grommetux-value--align-start{text-align:left}html.rtl .grommetux-value--align-start{text-align:right}.grommetux-value--align-center{text-align:center}.grommetux-value--align-end{text-align:right}html.rtl .grommetux-value--align-end{text-align:left}.grommetux-value--active{color:#000}.grommetux-background-color-index--dark .grommetux-value--active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-value--active{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-value--active,.grommetux-background-color-index--light .grommetux-value--active{color:#000}.grommetux-value__annotated{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:center;font-size:36px;font-size:2.25rem;line-height:1.33333}.grommetux-value__annotated .grommetux-control-icon:first-child{margin-right:6px}.grommetux-value__annotated .grommetux-control-icon:last-child{margin-left:6px}.grommetux-value__label{display:inline-block;margin-top:6px;font-size:19px;font-size:1.1875rem;line-height:1.26316}.grommetux-value__value{font-weight:600}.grommetux-value__units{margin-left:.5rem;font-weight:100}.grommetux-value--align-start .grommetux-value__annotated{justify-content:flex-start}.grommetux-value--align-end .grommetux-value__annotated{justify-content:flex-end}.grommetux-value--xsmall .grommetux-value__annotated{font-size:20px;font-size:1.25rem;line-height:1.2}.grommetux-value--xsmall .grommetux-value__label{margin-top:6px;font-size:14px;font-size:.875rem;line-height:1.71429}.grommetux-value--small .grommetux-value__annotated{font-size:24px;font-size:1.5rem;line-height:1}.grommetux-value--small .grommetux-value__label{margin-top:6px;font-size:14px;font-size:.875rem;line-height:1.71429}.grommetux-value--large .grommetux-value__annotated{font-size:72px;font-size:4.5rem;line-height:1}.grommetux-value--large .grommetux-value__annotated .grommetux-control-icon:first-child{margin-right:12px}.grommetux-value--large .grommetux-value__annotated .grommetux-control-icon:last-child{margin-left:12px}.grommetux-value--large .grommetux-value__label{margin-top:12px;font-size:24px;font-size:1.5rem;line-height:1}.grommetux-value--align-center,.grommetux-value--align-center .grommetux-value__annotated{justify-content:center}@media screen and (max-width:44.9375em){.grommetux-value--xlarge .grommetux-value__annotated{font-size:72px;font-size:4.5rem;line-height:1}.grommetux-value--xlarge .grommetux-value__annotated .grommetux-control-icon:first-child{margin-right:12px}.grommetux-value--xlarge .grommetux-value__annotated .grommetux-control-icon:last-child{margin-left:12px}.grommetux-value--xlarge .grommetux-value__label{margin-top:12px;font-size:24px;font-size:1.5rem;line-height:1}.grommetux-value--responsive.grommetux-value--large .grommetux-value__annotated,.grommetux-value--responsive.grommetux-value--xlarge .grommetux-value__annotated{font-size:36px;font-size:2.25rem;line-height:1.33333}.grommetux-value--responsive.grommetux-value--large .grommetux-value__annotated .grommetux-control-icon:first-child,.grommetux-value--responsive.grommetux-value--xlarge .grommetux-value__annotated .grommetux-control-icon:first-child{margin-right:6px}.grommetux-value--responsive.grommetux-value--large .grommetux-value__annotated .grommetux-control-icon:last-child,.grommetux-value--responsive.grommetux-value--xlarge .grommetux-value__annotated .grommetux-control-icon:last-child{margin-left:6px}.grommetux-value--responsive.grommetux-value--large .grommetux-value__label,.grommetux-value--responsive.grommetux-value--xlarge .grommetux-value__label{margin-top:6px;font-size:19px;font-size:1.1875rem;line-height:1.26316}}@media screen and (min-width:45em){.grommetux-value--xlarge .grommetux-value__annotated{font-size:192px;font-size:12rem;line-height:1}.grommetux-value--xlarge .grommetux-value__annotated .grommetux-control-icon:first-child{margin-right:24px}.grommetux-value--xlarge .grommetux-value__annotated .grommetux-control-icon:last-child{margin-left:24px}.grommetux-value--xlarge .grommetux-value__label{margin-top:24px;font-size:36px;font-size:2.25rem;line-height:1.33333}}.grommetux-video{position:relative;max-width:100%;height:auto}@media screen and (max-width:44.9375em){.grommetux-video{max-width:100%;width:100vw}}.grommetux-video video{max-width:100%;display:block}.grommetux-video--small,.grommetux-video--small video{width:192px}.grommetux-video--medium,.grommetux-video--medium video{width:384px}.grommetux-video--large,.grommetux-video--large video{width:576px}.grommetux-video--full,.grommetux-video--full video{width:100%;height:100%;min-width:100%;min-height:100%}.grommetux-video--align-top.grommetux-video--align-left video{object-position:0 0}.grommetux-video--align-top.grommetux-video--align-right video{object-position:100% 0}.grommetux-video--align-top:not(.grommetux-video--align-left):not(.grommetux-video--align-right) video{object-position:50% 0}.grommetux-video--align-bottom.grommetux-video--align-left video{object-position:0 100%}.grommetux-video--align-bottom.grommetux-video--align-right video{object-position:100% 100%}.grommetux-video--align-bottom:not(.grommetux-video--align-left):not(.grommetux-video--align-right) video{object-position:50% 100%}.grommetux-video--align-left:not(.grommetux-video--align-top):not(.grommetux-video--align-bottom) video{object-position:0 50%}.grommetux-video--align-right:not(.grommetux-video--align-top):not(.grommetux-video--align-bottom) video{object-position:100% 50%}.grommetux-video--cover video{object-fit:cover}.grommetux-video--contain video{object-fit:contain}.grommetux-video__button:hover .grommetux-video__button__icon{fill:#01a982;stroke:#01a982}@media screen and (max-width:44.9375em){.grommetux-video__timeline{visibility:hidden}.grommetux-video--has-timeline,.grommetux-video__progress{bottom:0}.grommetux-video__controls,.grommetux-video__replay{display:none}}@media screen and (min-width:45em){.grommetux-video--has-timeline{bottom:72px}.grommetux-video--has-played:not(.grommetux-video--small):not(.grommetux-video--ended) .grommetux-video__play,.grommetux-video--small .grommetux-video__controls,.grommetux-video--small .grommetux-video__replay{display:none}}.grommetux-video__overlay{position:absolute;top:0;width:100%;height:100%;display:flex;align-items:center;padding:24px}.grommetux-video__controls{position:absolute;bottom:0;left:0;right:0}.grommetux-video__controls-primary{height:72px;background-color:rgba(0,0,1,.9);color:#fff}.grommetux-video__controls-primary h3{font-weight:600}.grommetux-video__progress{position:absolute;left:0;right:0;bottom:72px;height:6px;background-color:hsla(0,0%,43%,.7);transition:height .3s}.grommetux-video__progress+.grommetux-video__chapter-labels,.grommetux-video__progress~.grommetux-video__controls-primary{transition:.3s ease-in-out}.grommetux-video__progress input[type=range]{opacity:0;position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;padding:0;margin:0;border:none;cursor:pointer;outline:none;z-index:30}.grommetux-video--interacting .grommetux-video__progress:hover{height:12px}.grommetux-video--interacting .grommetux-video__progress:hover .grommetux-video__progress-bar-fill:after{opacity:1}.grommetux-video--interacting .grommetux-video__progress:hover+.grommetux-video__chapter-labels{visibility:visible}.grommetux-video__progress-bar-fill{width:100%;height:100%;background-color:#01a982;position:absolute;bottom:0;left:0;transition:width .3s;z-index:10}.grommetux-video__progress-bar-fill:after{content:\"\";display:block;position:absolute;right:-12px;top:-6px;width:24px;height:24px;background-color:#01a982;border-radius:48px;opacity:0;transition:opacity .4s ease-in-out;z-index:20}.grommetux-video__chapter-labels{position:absolute;bottom:0;width:100%;height:72px;visibility:hidden;background-color:rgba(0,0,1,.9);transition:.4s ease-in-out}.grommetux-video__chapter-labels span{display:block;color:hsla(0,0%,100%,.85)}.grommetux-video__chapter-label{position:absolute;top:12px}.grommetux-video__chapter-label-start span{margin-left:12px}.grommetux-video__chapter-label-active span{color:#ff8d6d;transition:.3s ease-in-out}.grommetux-video__chapter-marker{position:absolute;height:100%;left:0}.grommetux-video__chapter-marker-track{position:absolute;width:100%;height:100%;transition:.3s ease-in-out}.grommetux-video__chapter-marker-tick:hover+.grommetux-video__chapter-marker-track{background-color:hsla(0,0%,63%,.7)}.grommetux-video__chapter-marker-tick{position:absolute;right:-3px;width:3px;height:100%;z-index:40;transition:.3s ease-in-out;cursor:pointer;background-color:#ff8d6d}.grommetux-video__chapter-marker-tick-start{right:auto;left:0}.grommetux-video__chapter-marker-tickhover{width:8px;right:-8px}.grommetux-video--playing:not(.grommetux-video--interacting) .grommetux-video__chapter-labels,.grommetux-video--playing:not(.grommetux-video--interacting) .grommetux-video__controls-primary,.grommetux-video--playing:not(.grommetux-video--interacting) .grommetux-video__overlay{opacity:0;transition:opacity 1s ease-in-out}.grommetux-video--playing:not(.grommetux-video--interacting) .grommetux-video__progress{bottom:0;transition:1s ease-in-out}.grommetux-video--ended:not(.grommetux-video--interacting) .grommetux-video__chapter-labels,.grommetux-video--ended:not(.grommetux-video--interacting) .grommetux-video__controls-primary{opacity:0;transition:opacity 1s ease-in-out}.grommetux-video--ended:not(.grommetux-video--interacting) .grommetux-video__progress{bottom:0;transition:1s ease-in-out}.grommetux-video--ended .grommetux-video__overlay{background-color:rgba(0,0,1,.7);color:hsla(0,0%,100%,.85)}.grommetux-video--ended .grommetux-video__overlay .grommetux-form{width:auto}.grommetux-video--ended .grommetux-video__overlay .grommetux-form-field{background-color:transparent;border:2px solid hsla(0,0%,100%,.5)}.grommetux-video--ended .grommetux-video__overlay .grommetux-form-field__contents input{font-size:19px;font-size:1.1875rem;line-height:1.26316;color:hsla(0,0%,100%,.85);text-align:center}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-video--full video{width:auto;height:auto;max-width:none;position:relative;top:50%;left:50%;transform:translate(-50%,-50%)}.grommetux-video--align-top.grommetux-video--align-left video{top:0;left:0;transform:none}.grommetux-video--align-top.grommetux-video--align-right video{top:0;left:100%;transform:translate(-100%)}.grommetux-video--align-top:not(.grommetux-video--align-left):not(.grommetux-video--align-right) video{top:0;left:50%;transform:translateX(-50%)}.grommetux-video--align-bottom.grommetux-video--align-left video{top:100%;left:0;transform:translateY(-100%)}.grommetux-video--align-bottom.grommetux-video--align-right video{top:100%;left:100%;transform:translate(-100%,-100%)}.grommetux-video--align-bottom:not(.grommetux-video--align-left):not(.grommetux-video--align-right) video{top:100%;left:50%;transform:translate(-50%,-100%)}.grommetux-video--align-left:not(.grommetux-video--align-top):not(.grommetux-video--align-bottom) video{top:50%;left:0;transform:translateY(-50%)}.grommetux-video--align-right:not(.grommetux-video--align-top):not(.grommetux-video--align-bottom) video{top:50%;left:100%;transform:translate(-100%,-50%)}}@supports (-ms-ime-align:auto){.grommetux-video--full video{width:auto;height:auto;max-width:none;position:relative;top:50%;left:50%;transform:translate(-50%,-50%)}.grommetux-video--align-top.grommetux-video--align-left video{top:0;left:0;transform:none}.grommetux-video--align-top.grommetux-video--align-right video{top:0;left:100%;transform:translate(-100%)}.grommetux-video--align-top:not(.grommetux-video--align-left):not(.grommetux-video--align-right) video{top:0;left:50%;transform:translateX(-50%)}.grommetux-video--align-bottom.grommetux-video--align-left video{top:100%;left:0;transform:translateY(-100%)}.grommetux-video--align-bottom.grommetux-video--align-right video{top:100%;left:100%;transform:translate(-100%,-100%)}.grommetux-video--align-bottom:not(.grommetux-video--align-left):not(.grommetux-video--align-right) video{top:100%;left:50%;transform:translate(-50%,-100%)}.grommetux-video--align-left:not(.grommetux-video--align-top):not(.grommetux-video--align-bottom) video{top:50%;left:0;transform:translateY(-50%)}.grommetux-video--align-right:not(.grommetux-video--align-top):not(.grommetux-video--align-bottom) video{top:50%;left:100%;transform:translate(-100%,-50%)}}.grommetux-world-map{width:100%}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.grommetux-world-map{padding-bottom:49%;height:1px}}.grommetux-world-map__container{position:relative;width:100%}.grommetux-world-map__flag{position:absolute;top:0;left:0}.grommetux-world-map__continent,.grommetux-world-map__place{stroke-linecap:round;transition:stroke-width .3s;outline:none}.grommetux-world-map__continent.grommetux-color-index-loading,.grommetux-world-map__place.grommetux-color-index-loading{stroke:#ddd;stroke-dasharray:1px 10px;stroke-dashoffset:0}.grommetux-world-map__continent.grommetux-color-index-unset,.grommetux-world-map__place.grommetux-color-index-unset{stroke:#ddd}.grommetux-world-map__continent.grommetux-color-index-brand,.grommetux-world-map__place.grommetux-color-index-brand{stroke:#01a982}.grommetux-world-map__continent.grommetux-color-index-critical,.grommetux-world-map__continent.grommetux-color-index-error,.grommetux-world-map__place.grommetux-color-index-critical,.grommetux-world-map__place.grommetux-color-index-error{stroke:#f04953}.grommetux-world-map__continent.grommetux-color-index-warning,.grommetux-world-map__place.grommetux-color-index-warning{stroke:#ffd144}.grommetux-world-map__continent.grommetux-color-index-ok,.grommetux-world-map__place.grommetux-color-index-ok{stroke:#01a982}.grommetux-world-map__continent.grommetux-color-index-disabled,.grommetux-world-map__continent.grommetux-color-index-unknown,.grommetux-world-map__place.grommetux-color-index-disabled,.grommetux-world-map__place.grommetux-color-index-unknown{stroke:#ccc}.grommetux-world-map__continent.grommetux-color-index-graph-1,.grommetux-world-map__continent.grommetux-color-index-graph-5,.grommetux-world-map__place.grommetux-color-index-graph-1,.grommetux-world-map__place.grommetux-color-index-graph-5{stroke:#425563}.grommetux-world-map__continent.grommetux-color-index-graph-2,.grommetux-world-map__continent.grommetux-color-index-graph-6,.grommetux-world-map__place.grommetux-color-index-graph-2,.grommetux-world-map__place.grommetux-color-index-graph-6{stroke:#5f7a76}.grommetux-world-map__continent.grommetux-color-index-graph-3,.grommetux-world-map__continent.grommetux-color-index-graph-7,.grommetux-world-map__place.grommetux-color-index-graph-3,.grommetux-world-map__place.grommetux-color-index-graph-7{stroke:#80746e}.grommetux-world-map__continent.grommetux-color-index-graph-4,.grommetux-world-map__continent.grommetux-color-index-graph-8,.grommetux-world-map__place.grommetux-color-index-graph-4,.grommetux-world-map__place.grommetux-color-index-graph-8{stroke:#767676}.grommetux-world-map__continent.grommetux-color-index-grey-1,.grommetux-world-map__continent.grommetux-color-index-grey-6,.grommetux-world-map__place.grommetux-color-index-grey-1,.grommetux-world-map__place.grommetux-color-index-grey-6{stroke:#000001}.grommetux-world-map__continent.grommetux-color-index-grey-2,.grommetux-world-map__continent.grommetux-color-index-grey-7,.grommetux-world-map__place.grommetux-color-index-grey-2,.grommetux-world-map__place.grommetux-color-index-grey-7{stroke:#333}.grommetux-world-map__continent.grommetux-color-index-grey-3,.grommetux-world-map__continent.grommetux-color-index-grey-8,.grommetux-world-map__place.grommetux-color-index-grey-3,.grommetux-world-map__place.grommetux-color-index-grey-8{stroke:#3b3b3b}.grommetux-world-map__continent.grommetux-color-index-grey-4,.grommetux-world-map__continent.grommetux-color-index-grey-9,.grommetux-world-map__place.grommetux-color-index-grey-4,.grommetux-world-map__place.grommetux-color-index-grey-9{stroke:#434343}.grommetux-world-map__continent.grommetux-color-index-grey-5,.grommetux-world-map__continent.grommetux-color-index-grey-10,.grommetux-world-map__place.grommetux-color-index-grey-5,.grommetux-world-map__place.grommetux-color-index-grey-10{stroke:#666}.grommetux-world-map__continent.grommetux-color-index-accent-1,.grommetux-world-map__continent.grommetux-color-index-accent-4,.grommetux-world-map__place.grommetux-color-index-accent-1,.grommetux-world-map__place.grommetux-color-index-accent-4{stroke:#2ad2c9}.grommetux-world-map__continent.grommetux-color-index-accent-2,.grommetux-world-map__continent.grommetux-color-index-accent-5,.grommetux-world-map__place.grommetux-color-index-accent-2,.grommetux-world-map__place.grommetux-color-index-accent-5{stroke:#614767}.grommetux-world-map__continent.grommetux-color-index-accent-3,.grommetux-world-map__continent.grommetux-color-index-accent-6,.grommetux-world-map__place.grommetux-color-index-accent-3,.grommetux-world-map__place.grommetux-color-index-accent-6{stroke:#ff8d6d}.grommetux-world-map__continent.grommetux-color-index-neutral-1,.grommetux-world-map__continent.grommetux-color-index-neutral-5,.grommetux-world-map__place.grommetux-color-index-neutral-1,.grommetux-world-map__place.grommetux-color-index-neutral-5{stroke:#425563}.grommetux-world-map__continent.grommetux-color-index-neutral-2,.grommetux-world-map__continent.grommetux-color-index-neutral-6,.grommetux-world-map__place.grommetux-color-index-neutral-2,.grommetux-world-map__place.grommetux-color-index-neutral-6{stroke:#5f7a76}.grommetux-world-map__continent.grommetux-color-index-neutral-3,.grommetux-world-map__continent.grommetux-color-index-neutral-7,.grommetux-world-map__place.grommetux-color-index-neutral-3,.grommetux-world-map__place.grommetux-color-index-neutral-7{stroke:#80746e}.grommetux-world-map__continent.grommetux-color-index-neutral-4,.grommetux-world-map__continent.grommetux-color-index-neutral-8,.grommetux-world-map__place.grommetux-color-index-neutral-4,.grommetux-world-map__place.grommetux-color-index-neutral-8{stroke:#767676}.grommetux-world-map__continent.grommetux-color-index-light-1,.grommetux-world-map__continent.grommetux-color-index-light-3,.grommetux-world-map__place.grommetux-color-index-light-1,.grommetux-world-map__place.grommetux-color-index-light-3{stroke:#fff}.grommetux-world-map__continent.grommetux-color-index-light-2,.grommetux-world-map__continent.grommetux-color-index-light-4,.grommetux-world-map__place.grommetux-color-index-light-2,.grommetux-world-map__place.grommetux-color-index-light-4{stroke:#f5f5f5}.grommetux-world-map__continent{stroke-width:6px}.grommetux-world-map__place{stroke-width:8px}.grommetux-world-map__continent--active{stroke-width:8px;cursor:pointer}.grommetux-world-map__place--active{stroke-width:20px;cursor:pointer}.grommetux-button{letter-spacing:.04167em}.grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--primary:hover,.grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill):hover{box-shadow:0 0 0 2px #01a982}.grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary:hover{box-shadow:0 0 0 2px rgba(51,51,51,.6)}.grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--accent:hover{box-shadow:0 0 0 2px #ff8d6d}.grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--critical:hover{box-shadow:0 0 0 2px #f04953}.grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill):hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill):hover{box-shadow:0 0 0 2px hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--primary:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--primary:hover{box-shadow:0 0 0 2px #01a982}.grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary{border-color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary:hover{box-shadow:0 0 0 2px hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--accent:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--accent:hover{box-shadow:0 0 0 2px #ff8d6d}.grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--critical,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--critical{border-color:#f04953}.grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--critical:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--critical:hover{box-shadow:0 0 0 2px #f04953}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary,.grommetux-background-color-index--light .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary{border-color:rgba(51,51,51,.6)}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary:hover,.grommetux-background-color-index--light .grommetux-button:not(.grommetux-button--disabled):not(.grommetux-button--plain):not(.grommetux-button--fill).grommetux-button--secondary:hover{box-shadow:0 0 0 2px rgba(51,51,51,.6)}.grommetux-button--fill:not(.grommetux-button--disabled):not(.grommetux-button--plain):hover{padding:4px 20px;border-width:4px}@media screen and (min-width:45em){.grommetux-button--fill:not(.grommetux-button--disabled):not(.grommetux-button--plain){transition:none}}.grommetux-anchor--icon-label,.grommetux-anchor--icon-label:visited,.grommetux-anchor--primary,.grommetux-anchor--primary:visited{color:#01a982}.grommetux-background-color-index--dark .grommetux-anchor--icon-label,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited:visited,.grommetux-background-color-index--dark .grommetux-anchor--primary,.grommetux-background-color-index--dark .grommetux-anchor--primary:visited,.grommetux-background-color-index--dark .grommetux-anchor--primary:visited:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:visited,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:visited:visited{color:hsla(0,0%,100%,.85)}.grommetux-background-color-index--dark .grommetux-anchor--icon-label.active,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:hover,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited.active,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited:hover,.grommetux-background-color-index--dark .grommetux-anchor--primary.active,.grommetux-background-color-index--dark .grommetux-anchor--primary:hover,.grommetux-background-color-index--dark .grommetux-anchor--primary:visited.active,.grommetux-background-color-index--dark .grommetux-anchor--primary:visited:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:hover,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:visited.active,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:visited:hover{color:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:hover,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:visited,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:visited.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:visited:hover,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:visited:visited,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:hover,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:visited,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:visited.active,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:visited:hover,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:visited:visited,.grommetux-background-color-index--light .grommetux-anchor--icon-label,.grommetux-background-color-index--light .grommetux-anchor--icon-label.active,.grommetux-background-color-index--light .grommetux-anchor--icon-label:hover,.grommetux-background-color-index--light .grommetux-anchor--icon-label:visited,.grommetux-background-color-index--light .grommetux-anchor--icon-label:visited.active,.grommetux-background-color-index--light .grommetux-anchor--icon-label:visited:hover,.grommetux-background-color-index--light .grommetux-anchor--icon-label:visited:visited,.grommetux-background-color-index--light .grommetux-anchor--primary,.grommetux-background-color-index--light .grommetux-anchor--primary.active,.grommetux-background-color-index--light .grommetux-anchor--primary:hover,.grommetux-background-color-index--light .grommetux-anchor--primary:visited,.grommetux-background-color-index--light .grommetux-anchor--primary:visited.active,.grommetux-background-color-index--light .grommetux-anchor--primary:visited:hover,.grommetux-background-color-index--light .grommetux-anchor--primary:visited:visited{color:#01a982}.grommetux-background-color-index--pending .grommetux-anchor--icon-label,.grommetux-background-color-index--pending .grommetux-anchor--icon-label.active,.grommetux-background-color-index--pending .grommetux-anchor--icon-label:hover,.grommetux-background-color-index--pending .grommetux-anchor--icon-label:visited,.grommetux-background-color-index--pending .grommetux-anchor--icon-label:visited.active,.grommetux-background-color-index--pending .grommetux-anchor--icon-label:visited:hover,.grommetux-background-color-index--pending .grommetux-anchor--icon-label:visited:visited,.grommetux-background-color-index--pending .grommetux-anchor--primary,.grommetux-background-color-index--pending .grommetux-anchor--primary.active,.grommetux-background-color-index--pending .grommetux-anchor--primary:hover,.grommetux-background-color-index--pending .grommetux-anchor--primary:visited,.grommetux-background-color-index--pending .grommetux-anchor--primary:visited.active,.grommetux-background-color-index--pending .grommetux-anchor--primary:visited:hover,.grommetux-background-color-index--pending .grommetux-anchor--primary:visited:visited{color:transparent}.grommetux-background-color-index--dark .grommetux-anchor--icon-label .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--primary .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--primary:visited .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:visited .grommetux-control-icon{fill:hsla(0,0%,100%,.7);stroke:hsla(0,0%,100%,.7)}.grommetux-background-color-index--dark .grommetux-anchor--icon-label:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:hover .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited:hover .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--primary:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--primary:hover .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--primary:visited:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-anchor--primary:visited:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--icon-label:visited:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:visited:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-background-color-index--dark .grommetux-anchor--primary:visited:hover .grommetux-control-icon{fill:#fff;stroke:#fff}.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:hover .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:visited .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:visited:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--icon-label:visited:hover .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:hover .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:visited .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:visited:active .grommetux-control-icon,.grommetux-background-color-index--dark .grommetux-background-color-index--light .grommetux-anchor--primary:visited:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label:visited .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label:visited:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--icon-label:visited:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary:hover .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary:visited .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary:visited:active .grommetux-control-icon,.grommetux-background-color-index--light .grommetux-anchor--primary:visited:hover .grommetux-control-icon{fill:#01a982;stroke:#01a982}.ferret-logo--busy{animation:crawl 4s .1s infinite linear alternate}@keyframes crawl{0%{stroke-dasharray:95px 1px}20%{stroke-dasharray:90px 6px;stroke-dashoffset:96px}80%{stroke-dasharray:90px 6px;stroke-dashoffset:0}to{stroke-dasharray:95px 1px}}.title .ferret-logo{transition:all .2s}.title:hover .ferret-logo{transform:translateX(2px)}.message{max-width:576px}@media screen and (min-width:45em){.grommetux-sidebar{animation:slide-sidebar .2s}}@keyframes slide-sidebar{0%{width:0}to{width:336px}}.hide{display:none!important}.show{display:block}.location-view .font12,.location-view .grommetux-form-field__label,.location-view .grommetux-input.grommetux-date-time__input{font-size:12px}.location-view select option{font-size:14px}span.context-menu-style{position:absolute;z-index:1;background:#455967;border:none}span.context-menu-style button{border:none!important;color:#fff!important;font-weight:lighter!important}.marker-translate img{transform:translate(-50%,-100%);cursor:pointer}span.context-menu-style button.first-btn{display:block;border-bottom:1px solid #fff!important;width:100%}.map-overlay{position:fixed;width:100%;height:100%;z-index:2;background:rgba(115,167,140,.57);bottom:50%;right:50%;transform:translate(50%,50%);-webkit-transform:translate(50%,50%);-moz-transform:translate(50%,50%);-ms-transform:translate(50%,50%);-o-transform:translate(50%,50%)}.map-overlay .map-overlay-content{background:#fff;width:40%;left:30%;position:absolute;top:30%;padding:2%}.map-overlay .edit-twig-content{background:#fff;width:70%;left:15%;position:absolute;top:2%;padding:2%;max-height:90%;overflow-y:auto}.maxwidth{width:100%}.maxheight{height:100%}.halfheight{height:50%}.siteviewheight{height:60%}.stemviewheight{height:40%}.halfwidth{width:50%}.inlineblock{display:inline-block}.float-right{float:right}.float-left{float:left}.mr-10{margin-right:10px}.main .left-menu.grommetux-sidebar .logo{width:35%;margin-left:30%}.grommetux-split__column.grommetux-split__column--fixed.grommetux-split__column--flex{overflow:hidden}.grommetux-split .location-view .grommetux-split__column.grommetux-split__column--fixed.grommetux-split__column--flex{overflow:auto}.overlay-btn-container{margin-top:15px;margin-bottom:35px;display:flex;align-items:center;justify-content:center}.mr-5{margin-right:5px}.lighter-font{font-weight:lighter!important}.dashboard-info{background:rgba(66,85,99,.76);width:100%;color:#fff;left:0}.dashboard-info div{padding-left:2%}.dashboard-map .header{width:100%;height:70px}.dashboard-map .header .dashboard-info{height:24px}.dashboard-map .header #PlacesAutocomplete__root{height:46px}.dashboard-map .header #PlacesAutocomplete__root input{border:none!important}.dashboard-map .map-content{height:100%;position:relative}.site-view .site-view-header{width:100%;height:10%}.site-view .site-view-header .dashboard-info{height:24px}.site-view .site-view-header .info-text{background:rgba(66,85,99,.76)}.site-view .site-view-header #PlacesAutocomplete__root{height:46px}.site-view .site-view-header #PlacesAutocomplete__root input{border:none!important}.site-view .map-container{width:100%;height:90%;position:relative}.site-control-container{background:#787979;color:#fff!important}.site-control-container .container1,.site-control-container .container2{height:100%;width:50%;display:inline-block;padding:1%}.site-control-container .details-container{overflow-y:auto}.site-control-container .recommendation{border-top:1px solid #584e4e;border-bottom:1px solid #584e4e;margin-top:15px;margin-bottom:15px;padding:10px;min-height:70px}.site-control-container .recommendation .grommetux-button__icon .grommetux-control-icon{stroke:#1d1d1f!important}.site-control-container .recommendation .grommetux-button.disabled .grommetux-button__icon .grommetux-control-icon{stroke:rgba(0,0,0,.21)!important;cursor:auto}.site-control-container .recommendation .content{width:72%;word-wrap:break-word;max-height:100px;overflow:auto}.site-control-container .recommendation .btn-panel{height:17%}.site-control-container .recommendation .btn-panel button{min-width:20%;text-align:center;font-size:20px;background:#425563;border:none;color:#fff;margin-left:5%;margin-bottom:2%;font-weight:400}.site-control-container .recommendation .btn-panel button:disabled{pointer-events:none;color:hsla(0,0%,100%,.17)}.site-control-container .recommendation .btn-panel button:hover{border:1px solid #fff}.site-control-container .info-container{font-size:12px}.site-control-container .info-container .box{display:inline-block;margin-left:25px;width:100px}.site-control-container .info-container .box .value{width:50px;height:50px;background:#545a57;padding-left:20%;padding-top:17%}.site-control-container .info-container .box .value.left-pad{padding-left:11%}.site-control-container .container2 .label{display:inline-block}.site-control-container .container2 .values{display:inline-block;width:30%;padding-left:2px;overflow-wrap:break-word}.site-control-container .container2 .item{padding:2%;background:#545a57;margin-top:10px;cursor:pointer}.site-control-container .container2 .btn-panel{height:17%}.site-control-container .container2 .btn-panel button{float:right;width:20%;min-width:20%;text-align:center;font-size:20px;background:#425563;border:none;color:#fff;margin-left:4px;font-weight:400}.site-control-container .container2 .btn-panel button:disabled{pointer-events:none;color:hsla(0,0%,100%,.17)}.site-control-container .container2 .btn-panel button:hover{border:1px solid #fff}.edit-twig-content .item{margin-top:3px;border-bottom:1px solid #d7c9c9;min-height:40px;padding-bottom:2px}.edit-twig-content .item .label{width:40%}.edit-twig-content .item .control{width:60%}.edit-twig-content .item .deepsensor{margin-top:2px}.edit-twig-content .item input,.edit-twig-content .item input:focus,.edit-twig-content .item select{padding:5px!important}.edit-twig-content .item .width-30{width:30%}.settings{padding:2%}.settings .header{border-bottom:1px solid}.settings .header .image-container{height:150px;width:150px;display:inline-block;border:1px solid}.settings .header .image-container img{max-height:100%}.settings .header .user-name{margin-left:10px;font-size:22px;font-weight:700}.settings .header .input-upload{display:block;width:300px}.settings .item{margin-top:3px;border-bottom:1px solid #d7c9c9;min-height:40px;padding-bottom:2px}.settings .item .label{width:40%;padding-left:10px}.settings .item .control{width:60%}.settings .item .control .location-text{margin-top:0;margin-bottom:0;font-weight:500;color:#101010}.settings .item .control .location-text .location-btn{margin-left:5%;padding:0;background-color:#425563;color:#fff;font-size:13px;border:none}.settings .item .deepsensor{margin-top:2px}.settings .item input,.settings .item input:focus,.settings .item select{padding:5px!important}.settings .overlay-btn-container button{margin-left:5px}.location-map .dashboard-info .container{height:45px;background:rgba(66,85,99,.76)}.location-map .dashboard-info .container button{margin:4px;background:#3fa260;border:none;color:#fff}.alerts-page .grommetux-box.grommetux-list-item.list-item{display:block!important}.alerts-page .list-item div{display:block}.alerts-page .list-item .secondary{margin-left:10px;color:#e01b1b}.alerts-page .list-item.disabled{color:rgba(0,0,0,.4)}.alerts-page .list-item.disabled .secondary{margin-left:10px;color:rgba(224,27,27,.4)}#PlacesAutocomplete__root{z-index:1;width:100%;background:#fff;border:1px solid aqua}.subscription-container{margin:20px;width:85%!important}.subscription-container .grommetux-tile{margin:20px 7%!important;width:35%!important;min-height:400px;box-shadow:1px 1px 13px 2px #e0e0e0}.subscription-container .tile-header-container{margin-bottom:25px!important;border-bottom:1px solid #e0e0e0;color:#4caa82}.subscription-container .tile-header-container .heading{text-transform:capitalize}.subscription-container .price-content{text-align:center}.subscription-container .price-content .plan-price{display:inline-block;position:relative;font-size:3em;font-weight:700;padding-left:27px}.subscription-container .price-content .plan-duration{float:right;margin-top:13px;color:#9b9b9b}.subscription-container .plan-features{min-height:130px;font-weight:400px}.subscription-container .add-subscription-button{text-align:center}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.main .left-menu.grommetux-sidebar{width:180px!important}.main .left-menu.grommetux-sidebar .logo{width:60%;margin-left:23%}.grommetux-split.location-view .grommetux-sidebar{width:180px!important}.site-control-container{font-size:12px}.site-control-container .recommendation .content{width:55%}.site-control-container .recommendation .btn-panel button{width:20%;text-align:start;font-size:12px}.site-control-container .container2 .value-container .values{display:inline-block;width:30%;padding-left:2px;margin:1px;overflow-wrap:break-word}.site-control-container .container2 .btn-panel button{width:20%;text-align:start;font-size:12px}}@media only screen and (min-device-width:768px) and (max-device-width:1024px) and (orientation:portrait){.site-control-container .info-container .box{display:block}.site-control-container .details-container{overflow-y:auto;height:90%}.site-control-container .container2 .btn-panel{height:10%}}@media only screen and (max-device-width:720px){.left-menu .logo{width:35%;margin-left:30%;margin-top:10%}.left-menu .grommetux-layer__container{background-color:#425563;color:#fff}.left-menu .grommetux-layer__container .grommetux-control-icon{stroke:#fdfafa}.charts-tab-left-menu .grommetux-layer__container{background-color:#425563;color:#fff}.charts-tab-left-menu .grommetux-layer__container .grommetux-button,.charts-tab-left-menu .grommetux-layer__container .grommetux-button:visited{color:hsla(0,0%,100%,.85)}.charts-tab-left-menu .grommetux-layer__container .grommetux-control-icon{stroke:#fdfafa}.charts-tab-left-menu .grommetux-form-field{background-color:transparent;color:hsla(0,0%,100%,.85);border-color:hsla(0,0%,100%,.5)}.charts-tab-left-menu .grommetux-form-field .grommetux-check-box .grommetux-check-box__control,.charts-tab-left-menu .grommetux-form-field .grommetux-check-box .grommetux-check-box__label{color:#fff!important;border-color:hsla(0,0%,100%,.7)}.charts-tab-left-menu .grommetux-form-field .grommetux-check-box .grommetux-check-box__control .grommetux-check-box__control-check,.charts-tab-left-menu .grommetux-form-field .grommetux-check-box .grommetux-check-box__label .grommetux-check-box__control-check{stroke:#fff}.site-control-container .container1,.site-control-container .container2{width:100%}.site-control-container .info-container .box{margin-left:15px}.login-page-logo{height:20vw!important;width:200px!important}.subscription-container .grommetux-tile{width:100%!important}}.grommet select::-ms-expand{display:none}.grommetux-form-field{overflow:hidden!important}.grommetux-form-field .grommetux-form-field__contents input{padding-bottom:5px!important;padding-top:5px!important}.heading{text-align:center;font-weight:400!important;margin-bottom:10px!important}.heading-em{font-weight:700!important}.checkout-section{margin:0 50px}.checkout-section .grommetux-form-field{padding-bottom:10px!important;padding-top:10px!important}.checkout-section .confirm-subscription-form>div{padding:5px 20px}.checkout-section .confirm-subscription-form input{font-size:26px!important;padding:5px!important}.checkout-section .confirm-subscription-form input::-webkit-input-placeholder{color:#767676!important}.checkout-section .confirm-subscription-form input:-moz-placeholder,.checkout-section .confirm-subscription-form input::-moz-placeholder{color:#767676!important}.checkout-section .confirm-subscription-form input:-ms-input-placeholder{color:#767676!important}.checkout-section .confirm-subscription-form .input-email{border:none!important;border-bottom:1px solid #d0d0d0!important;width:100%}.checkout-section .confirm-subscription-form .rememberData-autofill-input{border:none!important;width:100%}.checkout-section .confirm-subscription-form .grommetux-check-box{padding-left:40px;font-size:26px}.checkout-section .confirm-subscription-form .grommetux-check-box .grommetux-check-box__control,.checkout-section .confirm-subscription-form .grommetux-check-box .grommetux-check-box__label{color:#777!important}.checkout-section .confirm-subscription-form .submit-button-container{text-align:center;padding:20px 0 15px!important}.checkout-section .confirm-subscription-form input.coupon-code{height:40px!important}.checkout-section .confirm-subscription-form .apply-button-container{top:-3px;position:relative}.checkout-section .confirm-subscription-form .coupon-applied-success{color:#4caa82;font-size:18px;width:50%}.checkout-section .confirm-subscription-form .coupon-applied-success .plan-details span{position:relative;float:right}.checkout-section .confirm-subscription-form .coupon-applied-error{color:red;font-size:18px}.subscription-view-container{height:100%;width:100%;overflow:hidden;padding:5px 40px 5px 20px;font-size:16px}.subscription-view-container .heading{font-size:20px!important;margin-bottom:5px!important}.subscription-view-container .subscription-details{height:285px;margin-bottom:5px;padding:5px 10px 5px 20px;overflow:auto;box-shadow:1px 1px 13px 2px #e0e0e0}.subscription-view-container .subscription-log{height:285px;padding:5px 10px 5px 0;overflow:auto;box-shadow:1px 1px 13px 2px #e0e0e0}.subscription-view-container .subscription-table-header{display:flex}.subscription-view-container .subscription-table-header div{font-weight:700;text-align:center;width:20%;float:left;height:30px;border-bottom:1px solid #777}.subscription-view-container .subscription-content div{height:87px;width:20%;float:left;text-align:center;min-height:45px;overflow:hidden;word-break:break-all;padding:10px 0;border-bottom:1px solid #777}.subscription-view-container .subscription-content .button-container{padding:10px 0}.subscription-view-container .subscription-content .button-container button:first-child{margin-top:-5px}.subscription-view-container .subscription-content .button-container button:nth-child(n+2){margin-top:10px}.subscription-view-container .subscription-content.unsubscribed-items div{height:45px;width:20%;float:left;text-align:center;min-height:45px;overflow:hidden;word-break:break-all;padding:5px 0;border-bottom:1px solid #777}.subscription-view-container .subscription-log-table-header{display:flex}.subscription-view-container .subscription-log-table-header div{height:30px;font-weight:700;text-align:center;width:25%;float:left;border-bottom:1px solid #777}.subscription-view-container .subscription-log-content div{height:55px;width:25%;float:left;text-align:center;min-height:45px;overflow:auto;word-break:break-word;padding:3px 0;border-bottom:1px solid #777}.subscription-view-container button{padding:2px!important;font-size:16px;font-weight:700!important}.confirmation-content{text-align:center;padding:35px 10px 15px}.plan-heading{color:#4caa82}.button-margin{margin:0 10px}.register-form{min-width:432px;width:432px;font-size:18px}.register-form input{min-height:40px}.register-form .grommetux-form-field{padding-top:0;padding-bottom:0}.register-form .register-button{min-width:432px;display:block}.register-form .garden-location-input{width:auto}.register-form .garden-location-button{padding-top:2px!important;padding-bottom:1px!important;position:absolute!important}.signup-nav-section{font-size:18px}.login-signup-link{display:inline;color:#01a982!important;text-decoration:none!important;padding-left:10px}.login-form .signup-nav-section{width:432px;padding:0 24px;margin-top:-10px}.login-form .signup-nav-section div{display:inline-block}.login-form .signup-nav-section .forgot-password-button{color:#01a982!important;text-decoration:none!important;float:left}.login-form .signup-nav-section .forgot-password-button .grommetux-button__label{margin:0!important}.login-form .signup-nav-section .signup-content{float:right}.success{color:#01a982}.error{color:red;font-size:18px;padding:15px;text-align:center}.download-graph-button{float:right;position:absolute;right:26px;margin-top:-20px;background-color:#01a982;min-width:320px;text-align:center}.download-graph-button a{text-decoration:none!important;padding:6px 22px;display:block;color:#fff!important;font-weight:400}", ""]);
	
	// exports


/***/ }),
/* 455 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dsv/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var EOL = {};
	var EOF = {};
	var QUOTE = 34;
	var NEWLINE = 10;
	var RETURN = 13;
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	var dsv = function(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
	      DELIMITER = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns || [];
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // current line number
	        t, // current token
	        eof = N <= 0, // current token followed by EOF?
	        eol = false; // current token followed by EOL?
	
	    // Strip the trailing newline.
	    if (text.charCodeAt(N - 1) === NEWLINE) --N;
	    if (text.charCodeAt(N - 1) === RETURN) --N;
	
	    function token() {
	      if (eof) return EOF;
	      if (eol) return eol = false, EOL;
	
	      // Unescape quotes.
	      var i, j = I, c;
	      if (text.charCodeAt(j) === QUOTE) {
	        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
	        if ((i = I) >= N) eof = true;
	        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
	        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
	        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
	      }
	
	      // Find next delimiter or newline.
	      while (I < N) {
	        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
	        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
	        else if (c !== DELIMITER) continue;
	        return text.slice(j, i);
	      }
	
	      // Return last token before EOF.
	      return eof = true, text.slice(j, N);
	    }
	
	    while ((t = token()) !== EOF) {
	      var row = [];
	      while (t !== EOL && t !== EOF) row.push(t), t = token();
	      if (f && (row = f(row, n++)) == null) continue;
	      rows.push(row);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	};
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-force/ v1.1.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(458), __webpack_require__(38), __webpack_require__(118), __webpack_require__(460)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-quadtree', 'd3-collection', 'd3-dispatch', 'd3-timer'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Quadtree,d3Collection,d3Dispatch,d3Timer) { 'use strict';
	
	function center(x, y) {
	  var nodes;
	
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force() {
	    var i,
	        n = nodes.length,
	        node,
	        sx = 0,
	        sy = 0;
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], sx += node.x, sy += node.y;
	    }
	
	    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	      node = nodes[i], node.x -= sx, node.y -= sy;
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function jiggle() {
	  return (Math.random() - 0.5) * 1e-6;
	}
	
	function x(d) {
	  return d.x + d.vx;
	}
	
	function y(d) {
	  return d.y + d.vy;
	}
	
	function collide(radius) {
	  var nodes,
	      radii,
	      strength = 1,
	      iterations = 1;
	
	  if (typeof radius !== "function") radius = constant(radius == null ? 1 : +radius);
	
	  function force() {
	    var i, n = nodes.length,
	        tree,
	        node,
	        xi,
	        yi,
	        ri,
	        ri2;
	
	    for (var k = 0; k < iterations; ++k) {
	      tree = d3Quadtree.quadtree(nodes, x, y).visitAfter(prepare);
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        ri = radii[node.index], ri2 = ri * ri;
	        xi = node.x + node.vx;
	        yi = node.y + node.vy;
	        tree.visit(apply);
	      }
	    }
	
	    function apply(quad, x0, y0, x1, y1) {
	      var data = quad.data, rj = quad.r, r = ri + rj;
	      if (data) {
	        if (data.index > node.index) {
	          var x = xi - data.x - data.vx,
	              y = yi - data.y - data.vy,
	              l = x * x + y * y;
	          if (l < r * r) {
	            if (x === 0) x = jiggle(), l += x * x;
	            if (y === 0) y = jiggle(), l += y * y;
	            l = (r - (l = Math.sqrt(l))) / l * strength;
	            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	            node.vy += (y *= l) * r;
	            data.vx -= x * (r = 1 - r);
	            data.vy -= y * r;
	          }
	        }
	        return;
	      }
	      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	    }
	  }
	
	  function prepare(quad) {
	    if (quad.data) return quad.r = radii[quad.data.index];
	    for (var i = quad.r = 0; i < 4; ++i) {
	      if (quad[i] && quad[i].r > quad.r) {
	        quad.r = quad[i].r;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    radii = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = +_, force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
	  };
	
	  return force;
	}
	
	function index(d) {
	  return d.index;
	}
	
	function find(nodeById, nodeId) {
	  var node = nodeById.get(nodeId);
	  if (!node) throw new Error("missing: " + nodeId);
	  return node;
	}
	
	function link(links) {
	  var id = index,
	      strength = defaultStrength,
	      strengths,
	      distance = constant(30),
	      distances,
	      nodes,
	      count,
	      bias,
	      iterations = 1;
	
	  if (links == null) links = [];
	
	  function defaultStrength(link) {
	    return 1 / Math.min(count[link.source.index], count[link.target.index]);
	  }
	
	  function force(alpha) {
	    for (var k = 0, n = links.length; k < iterations; ++k) {
	      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	        link = links[i], source = link.source, target = link.target;
	        x = target.x + target.vx - source.x - source.vx || jiggle();
	        y = target.y + target.vy - source.y - source.vy || jiggle();
	        l = Math.sqrt(x * x + y * y);
	        l = (l - distances[i]) / l * alpha * strengths[i];
	        x *= l, y *= l;
	        target.vx -= x * (b = bias[i]);
	        target.vy -= y * b;
	        source.vx += x * (b = 1 - b);
	        source.vy += y * b;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	
	    var i,
	        n = nodes.length,
	        m = links.length,
	        nodeById = d3Collection.map(nodes, id),
	        link;
	
	    for (i = 0, count = new Array(n); i < m; ++i) {
	      link = links[i], link.index = i;
	      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
	      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
	      count[link.source.index] = (count[link.source.index] || 0) + 1;
	      count[link.target.index] = (count[link.target.index] || 0) + 1;
	    }
	
	    for (i = 0, bias = new Array(m); i < m; ++i) {
	      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	    }
	
	    strengths = new Array(m), initializeStrength();
	    distances = new Array(m), initializeDistance();
	  }
	
	  function initializeStrength() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      strengths[i] = +strength(links[i], i, links);
	    }
	  }
	
	  function initializeDistance() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      distances[i] = +distance(links[i], i, links);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.links = function(_) {
	    return arguments.length ? (links = _, initialize(), force) : links;
	  };
	
	  force.id = function(_) {
	    return arguments.length ? (id = _, force) : id;
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initializeStrength(), force) : strength;
	  };
	
	  force.distance = function(_) {
	    return arguments.length ? (distance = typeof _ === "function" ? _ : constant(+_), initializeDistance(), force) : distance;
	  };
	
	  return force;
	}
	
	function x$1(d) {
	  return d.x;
	}
	
	function y$1(d) {
	  return d.y;
	}
	
	var initialRadius = 10,
	    initialAngle = Math.PI * (3 - Math.sqrt(5));
	
	function simulation(nodes) {
	  var simulation,
	      alpha = 1,
	      alphaMin = 0.001,
	      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
	      alphaTarget = 0,
	      velocityDecay = 0.6,
	      forces = d3Collection.map(),
	      stepper = d3Timer.timer(step),
	      event = d3Dispatch.dispatch("tick", "end");
	
	  if (nodes == null) nodes = [];
	
	  function step() {
	    tick();
	    event.call("tick", simulation);
	    if (alpha < alphaMin) {
	      stepper.stop();
	      event.call("end", simulation);
	    }
	  }
	
	  function tick() {
	    var i, n = nodes.length, node;
	
	    alpha += (alphaTarget - alpha) * alphaDecay;
	
	    forces.each(function(force) {
	      force(alpha);
	    });
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i];
	      if (node.fx == null) node.x += node.vx *= velocityDecay;
	      else node.x = node.fx, node.vx = 0;
	      if (node.fy == null) node.y += node.vy *= velocityDecay;
	      else node.y = node.fy, node.vy = 0;
	    }
	  }
	
	  function initializeNodes() {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.index = i;
	      if (isNaN(node.x) || isNaN(node.y)) {
	        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	        node.x = radius * Math.cos(angle);
	        node.y = radius * Math.sin(angle);
	      }
	      if (isNaN(node.vx) || isNaN(node.vy)) {
	        node.vx = node.vy = 0;
	      }
	    }
	  }
	
	  function initializeForce(force) {
	    if (force.initialize) force.initialize(nodes);
	    return force;
	  }
	
	  initializeNodes();
	
	  return simulation = {
	    tick: tick,
	
	    restart: function() {
	      return stepper.restart(step), simulation;
	    },
	
	    stop: function() {
	      return stepper.stop(), simulation;
	    },
	
	    nodes: function(_) {
	      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
	    },
	
	    alpha: function(_) {
	      return arguments.length ? (alpha = +_, simulation) : alpha;
	    },
	
	    alphaMin: function(_) {
	      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
	    },
	
	    alphaDecay: function(_) {
	      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
	    },
	
	    alphaTarget: function(_) {
	      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
	    },
	
	    velocityDecay: function(_) {
	      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
	    },
	
	    force: function(name, _) {
	      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
	    },
	
	    find: function(x, y, radius) {
	      var i = 0,
	          n = nodes.length,
	          dx,
	          dy,
	          d2,
	          node,
	          closest;
	
	      if (radius == null) radius = Infinity;
	      else radius *= radius;
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        dx = x - node.x;
	        dy = y - node.y;
	        d2 = dx * dx + dy * dy;
	        if (d2 < radius) closest = node, radius = d2;
	      }
	
	      return closest;
	    },
	
	    on: function(name, _) {
	      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	    }
	  };
	}
	
	function manyBody() {
	  var nodes,
	      node,
	      alpha,
	      strength = constant(-30),
	      strengths,
	      distanceMin2 = 1,
	      distanceMax2 = Infinity,
	      theta2 = 0.81;
	
	  function force(_) {
	    var i, n = nodes.length, tree = d3Quadtree.quadtree(nodes, x$1, y$1).visitAfter(accumulate);
	    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    strengths = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
	  }
	
	  function accumulate(quad) {
	    var strength = 0, q, c, weight = 0, x, y, i;
	
	    // For internal nodes, accumulate forces from child quadrants.
	    if (quad.length) {
	      for (x = y = i = 0; i < 4; ++i) {
	        if ((q = quad[i]) && (c = Math.abs(q.value))) {
	          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
	        }
	      }
	      quad.x = x / weight;
	      quad.y = y / weight;
	    }
	
	    // For leaf nodes, accumulate forces from coincident quadrants.
	    else {
	      q = quad;
	      q.x = q.data.x;
	      q.y = q.data.y;
	      do strength += strengths[q.data.index];
	      while (q = q.next);
	    }
	
	    quad.value = strength;
	  }
	
	  function apply(quad, x1, _, x2) {
	    if (!quad.value) return true;
	
	    var x = quad.x - node.x,
	        y = quad.y - node.y,
	        w = x2 - x1,
	        l = x * x + y * y;
	
	    // Apply the Barnes-Hut approximation if possible.
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (w * w / theta2 < l) {
	      if (l < distanceMax2) {
	        if (x === 0) x = jiggle(), l += x * x;
	        if (y === 0) y = jiggle(), l += y * y;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	        node.vx += x * quad.value * alpha / l;
	        node.vy += y * quad.value * alpha / l;
	      }
	      return true;
	    }
	
	    // Otherwise, process points directly.
	    else if (quad.length || l >= distanceMax2) return;
	
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (quad.data !== node || quad.next) {
	      if (x === 0) x = jiggle(), l += x * x;
	      if (y === 0) y = jiggle(), l += y * y;
	      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	    }
	
	    do if (quad.data !== node) {
	      w = strengths[quad.data.index] * alpha / l;
	      node.vx += x * w;
	      node.vy += y * w;
	    } while (quad = quad.next);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.distanceMin = function(_) {
	    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	  };
	
	  force.distanceMax = function(_) {
	    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	  };
	
	  force.theta = function(_) {
	    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	  };
	
	  return force;
	}
	
	function radial(radius, x, y) {
	  var nodes,
	      strength = constant(0.1),
	      strengths,
	      radiuses;
	
	  if (typeof radius !== "function") radius = constant(+radius);
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length; i < n; ++i) {
	      var node = nodes[i],
	          dx = node.x - x || 1e-6,
	          dy = node.y - y || 1e-6,
	          r = Math.sqrt(dx * dx + dy * dy),
	          k = (radiuses[i] - r) * strengths[i] * alpha / r;
	      node.vx += dx * k;
	      node.vy += dy * k;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    radiuses = new Array(n);
	    for (i = 0; i < n; ++i) {
	      radiuses[i] = +radius(nodes[i], i, nodes);
	      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _, initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	}
	
	function x$2(x) {
	  var strength = constant(0.1),
	      nodes,
	      strengths,
	      xz;
	
	  if (typeof x !== "function") x = constant(x == null ? 0 : +x);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    xz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), initialize(), force) : x;
	  };
	
	  return force;
	}
	
	function y$2(y) {
	  var strength = constant(0.1),
	      nodes,
	      strengths,
	      yz;
	
	  if (typeof y !== "function") y = constant(y == null ? 0 : +y);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    yz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), initialize(), force) : y;
	  };
	
	  return force;
	}
	
	exports.forceCenter = center;
	exports.forceCollide = collide;
	exports.forceLink = link;
	exports.forceManyBody = manyBody;
	exports.forceRadial = radial;
	exports.forceSimulation = simulation;
	exports.forceX = x$2;
	exports.forceY = y$2;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-quadtree/ v1.0.5 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function tree_add(d) {
	  var x = +this._x.call(null, d),
	      y = +this._y.call(null, d);
	  return add(this.cover(x, y), x, y, d);
	}
	
	function add(tree, x, y, d) {
	  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	  var parent,
	      node = tree._root,
	      leaf = {data: d},
	      x0 = tree._x0,
	      y0 = tree._y0,
	      x1 = tree._x1,
	      y1 = tree._y1,
	      xm,
	      ym,
	      xp,
	      yp,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return tree._root = leaf, tree;
	
	  // Find the existing leaf for the new point, or add it.
	  while (node.length) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	  }
	
	  // Is the new point is exactly coincident with the existing point?
	  xp = +tree._x.call(null, node.data);
	  yp = +tree._y.call(null, node.data);
	  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	  // Otherwise, split the leaf node until the old and new point are separated.
	  do {
	    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
	  return parent[j] = node, parent[i] = leaf, tree;
	}
	
	function addAll(data) {
	  var d, i, n = data.length,
	      x,
	      y,
	      xz = new Array(n),
	      yz = new Array(n),
	      x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  // Compute the points and their extent.
	  for (i = 0; i < n; ++i) {
	    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	    xz[i] = x;
	    yz[i] = y;
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  // If there were no (valid) points, inherit the existing extent.
	  if (x1 < x0) x0 = this._x0, x1 = this._x1;
	  if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	  // Expand the tree to cover the new points.
	  this.cover(x0, y0).cover(x1, y1);
	
	  // Add the new points.
	  for (i = 0; i < n; ++i) {
	    add(this, xz[i], yz[i], data[i]);
	  }
	
	  return this;
	}
	
	function tree_cover(x, y) {
	  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	  var x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1;
	
	  // If the quadtree has no extent, initialize them.
	  // Integer extent are necessary so that if we later double the extent,
	  // the existing quadrant boundaries don’t change due to floating point error!
	  if (isNaN(x0)) {
	    x1 = (x0 = Math.floor(x)) + 1;
	    y1 = (y0 = Math.floor(y)) + 1;
	  }
	
	  // Otherwise, double repeatedly to cover.
	  else if (x0 > x || x > x1 || y0 > y || y > y1) {
	    var z = x1 - x0,
	        node = this._root,
	        parent,
	        i;
	
	    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
	      case 0: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
	        break;
	      }
	      case 1: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
	        break;
	      }
	      case 2: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
	        break;
	      }
	      case 3: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
	        break;
	      }
	    }
	
	    if (this._root && this._root.length) this._root = node;
	  }
	
	  // If the quadtree covers the point already, just return.
	  else return this;
	
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  return this;
	}
	
	function tree_data() {
	  var data = [];
	  this.visit(function(node) {
	    if (!node.length) do data.push(node.data); while (node = node.next)
	  });
	  return data;
	}
	
	function tree_extent(_) {
	  return arguments.length
	      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
	      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	}
	
	function Quad(node, x0, y0, x1, y1) {
	  this.node = node;
	  this.x0 = x0;
	  this.y0 = y0;
	  this.x1 = x1;
	  this.y1 = y1;
	}
	
	function tree_find(x, y, radius) {
	  var data,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1,
	      y1,
	      x2,
	      y2,
	      x3 = this._x1,
	      y3 = this._y1,
	      quads = [],
	      node = this._root,
	      q,
	      i;
	
	  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
	  if (radius == null) radius = Infinity;
	  else {
	    x0 = x - radius, y0 = y - radius;
	    x3 = x + radius, y3 = y + radius;
	    radius *= radius;
	  }
	
	  while (q = quads.pop()) {
	
	    // Stop searching if this quadrant can’t contain a closer node.
	    if (!(node = q.node)
	        || (x1 = q.x0) > x3
	        || (y1 = q.y0) > y3
	        || (x2 = q.x1) < x0
	        || (y2 = q.y1) < y0) continue;
	
	    // Bisect the current quadrant.
	    if (node.length) {
	      var xm = (x1 + x2) / 2,
	          ym = (y1 + y2) / 2;
	
	      quads.push(
	        new Quad(node[3], xm, ym, x2, y2),
	        new Quad(node[2], x1, ym, xm, y2),
	        new Quad(node[1], xm, y1, x2, ym),
	        new Quad(node[0], x1, y1, xm, ym)
	      );
	
	      // Visit the closest quadrant first.
	      if (i = (y >= ym) << 1 | (x >= xm)) {
	        q = quads[quads.length - 1];
	        quads[quads.length - 1] = quads[quads.length - 1 - i];
	        quads[quads.length - 1 - i] = q;
	      }
	    }
	
	    // Visit this point. (Visiting coincident points isn’t necessary!)
	    else {
	      var dx = x - +this._x.call(null, node.data),
	          dy = y - +this._y.call(null, node.data),
	          d2 = dx * dx + dy * dy;
	      if (d2 < radius) {
	        var d = Math.sqrt(radius = d2);
	        x0 = x - d, y0 = y - d;
	        x3 = x + d, y3 = y + d;
	        data = node.data;
	      }
	    }
	  }
	
	  return data;
	}
	
	function tree_remove(d) {
	  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	  var parent,
	      node = this._root,
	      retainer,
	      previous,
	      next,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1,
	      x,
	      y,
	      xm,
	      ym,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return this;
	
	  // Find the leaf node for the point.
	  // While descending, also retain the deepest parent with a non-removed sibling.
	  if (node.length) while (true) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	    if (!node.length) break;
	    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
	  }
	
	  // Find the point to remove.
	  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	  if (next = node.next) delete node.next;
	
	  // If there are multiple coincident points, remove just the point.
	  if (previous) return (next ? previous.next = next : delete previous.next), this;
	
	  // If this is the root point, remove it.
	  if (!parent) return this._root = next, this;
	
	  // Remove this leaf.
	  next ? parent[i] = next : delete parent[i];
	
	  // If the parent now contains exactly one leaf, collapse superfluous parents.
	  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
	      && node === (parent[3] || parent[2] || parent[1] || parent[0])
	      && !node.length) {
	    if (retainer) retainer[j] = node;
	    else this._root = node;
	  }
	
	  return this;
	}
	
	function removeAll(data) {
	  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
	  return this;
	}
	
	function tree_root() {
	  return this._root;
	}
	
	function tree_size() {
	  var size = 0;
	  this.visit(function(node) {
	    if (!node.length) do ++size; while (node = node.next)
	  });
	  return size;
	}
	
	function tree_visit(callback) {
	  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	    }
	  }
	  return this;
	}
	
	function tree_visitAfter(callback) {
	  var quads = [], next = [], q;
	  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    var node = q.node;
	    if (node.length) {
	      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	    }
	    next.push(q);
	  }
	  while (q = next.pop()) {
	    callback(q.node, q.x0, q.y0, q.x1, q.y1);
	  }
	  return this;
	}
	
	function defaultX(d) {
	  return d[0];
	}
	
	function tree_x(_) {
	  return arguments.length ? (this._x = _, this) : this._x;
	}
	
	function defaultY(d) {
	  return d[1];
	}
	
	function tree_y(_) {
	  return arguments.length ? (this._y = _, this) : this._y;
	}
	
	function quadtree(nodes, x, y) {
	  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
	  return nodes == null ? tree : tree.addAll(nodes);
	}
	
	function Quadtree(x, y, x0, y0, x1, y1) {
	  this._x = x;
	  this._y = y;
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  this._root = undefined;
	}
	
	function leaf_copy(leaf) {
	  var copy = {data: leaf.data}, next = copy;
	  while (leaf = leaf.next) next = next.next = {data: leaf.data};
	  return copy;
	}
	
	var treeProto = quadtree.prototype = Quadtree.prototype;
	
	treeProto.copy = function() {
	  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	      node = this._root,
	      nodes,
	      child;
	
	  if (!node) return copy;
	
	  if (!node.length) return copy._root = leaf_copy(node), copy;
	
	  nodes = [{source: node, target: copy._root = new Array(4)}];
	  while (node = nodes.pop()) {
	    for (var i = 0; i < 4; ++i) {
	      if (child = node.source[i]) {
	        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
	        else node.target[i] = leaf_copy(child);
	      }
	    }
	  }
	
	  return copy;
	};
	
	treeProto.add = tree_add;
	treeProto.addAll = addAll;
	treeProto.cover = tree_cover;
	treeProto.data = tree_data;
	treeProto.extent = tree_extent;
	treeProto.find = tree_find;
	treeProto.remove = tree_remove;
	treeProto.removeAll = removeAll;
	treeProto.root = tree_root;
	treeProto.size = tree_size;
	treeProto.visit = tree_visit;
	treeProto.visitAfter = tree_visitAfter;
	treeProto.x = tree_x;
	treeProto.y = tree_y;
	
	exports.quadtree = quadtree;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var XMLHttpRequest = __webpack_require__(823).XMLHttpRequest;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var d3Collection = __webpack_require__(38);
	var d3Dispatch = __webpack_require__(118);
	var d3Dsv = __webpack_require__(456);
	
	var request = function(url, callback) {
	  var request,
	      event = d3Dispatch.dispatch("beforesend", "progress", "load", "error"),
	      mimeType,
	      headers = d3Collection.map(),
	      xhr = new XMLHttpRequest,
	      user = null,
	      password = null,
	      response,
	      responseType,
	      timeout = 0;
	
	  // If IE does not support CORS, use XDomainRequest.
	  if (typeof XDomainRequest !== "undefined"
	      && !("withCredentials" in xhr)
	      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
	
	  "onload" in xhr
	      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
	      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };
	
	  function respond(o) {
	    var status = xhr.status, result;
	    if (!status && hasResponse(xhr)
	        || status >= 200 && status < 300
	        || status === 304) {
	      if (response) {
	        try {
	          result = response.call(request, xhr);
	        } catch (e) {
	          event.call("error", request, e);
	          return;
	        }
	      } else {
	        result = xhr;
	      }
	      event.call("load", request, result);
	    } else {
	      event.call("error", request, o);
	    }
	  }
	
	  xhr.onprogress = function(e) {
	    event.call("progress", request, e);
	  };
	
	  request = {
	    header: function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers.get(name);
	      if (value == null) headers.remove(name);
	      else headers.set(name, value + "");
	      return request;
	    },
	
	    // If mimeType is non-null and no Accept header is set, a default is used.
	    mimeType: function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return request;
	    },
	
	    // Specifies what type the response value should take;
	    // for instance, arraybuffer, blob, document, or text.
	    responseType: function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return request;
	    },
	
	    timeout: function(value) {
	      if (!arguments.length) return timeout;
	      timeout = +value;
	      return request;
	    },
	
	    user: function(value) {
	      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
	    },
	
	    password: function(value) {
	      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
	    },
	
	    // Specify how to convert the response content to a specific type;
	    // changes the callback value on "load" events.
	    response: function(value) {
	      response = value;
	      return request;
	    },
	
	    // Alias for send("GET", …).
	    get: function(data, callback) {
	      return request.send("GET", data, callback);
	    },
	
	    // Alias for send("POST", …).
	    post: function(data, callback) {
	      return request.send("POST", data, callback);
	    },
	
	    // If callback is non-null, it will be used for error and load events.
	    send: function(method, data, callback) {
	      xhr.open(method, url, true, user, password);
	      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
	      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
	      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
	      if (responseType != null) xhr.responseType = responseType;
	      if (timeout > 0) xhr.timeout = timeout;
	      if (callback == null && typeof data === "function") callback = data, data = null;
	      if (callback != null && callback.length === 1) callback = fixCallback(callback);
	      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
	      event.call("beforesend", request, xhr);
	      xhr.send(data == null ? null : data);
	      return request;
	    },
	
	    abort: function() {
	      xhr.abort();
	      return request;
	    },
	
	    on: function() {
	      var value = event.on.apply(event, arguments);
	      return value === event ? request : value;
	    }
	  };
	
	  if (callback != null) {
	    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    return request.get(callback);
	  }
	
	  return request;
	};
	
	function fixCallback(callback) {
	  return function(error, xhr) {
	    callback(error == null ? xhr : null);
	  };
	}
	
	function hasResponse(xhr) {
	  var type = xhr.responseType;
	  return type && type !== "text"
	      ? xhr.response // null on error
	      : xhr.responseText; // "" on error
	}
	
	var type = function(defaultMimeType, response) {
	  return function(url, callback) {
	    var r = request(url).mimeType(defaultMimeType).response(response);
	    if (callback != null) {
	      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      return r.get(callback);
	    }
	    return r;
	  };
	};
	
	var html = type("text/html", function(xhr) {
	  return document.createRange().createContextualFragment(xhr.responseText);
	});
	
	var json = type("application/json", function(xhr) {
	  return JSON.parse(xhr.responseText);
	});
	
	var text = type("text/plain", function(xhr) {
	  return xhr.responseText;
	});
	
	var xml = type("application/xml", function(xhr) {
	  var xml = xhr.responseXML;
	  if (!xml) throw new Error("parse error");
	  return xml;
	});
	
	var dsv = function(defaultMimeType, parse) {
	  return function(url, row, callback) {
	    if (arguments.length < 3) callback = row, row = null;
	    var r = request(url).mimeType(defaultMimeType);
	    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
	    r.row(row);
	    return callback ? r.get(callback) : r;
	  };
	};
	
	function responseOf(parse, row) {
	  return function(request$$1) {
	    return parse(request$$1.responseText, row);
	  };
	}
	
	var csv = dsv("text/csv", d3Dsv.csvParse);
	
	var tsv = dsv("text/tab-separated-values", d3Dsv.tsvParse);
	
	exports.request = request;
	exports.html = html;
	exports.json = json;
	exports.text = text;
	exports.xml = xml;
	exports.csv = csv;
	exports.tsv = tsv;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ v1.0.9 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0, // is an animation frame pending?
	    timeout = 0, // is a timeout pending?
	    interval = 0, // are any timers active?
	    pokeDelay = 1000, // how frequently we check for clock skew
	    taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = typeof performance === "object" && performance.now ? performance : Date,
	    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	function timeout$1(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	function interval$1(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 461 */
/***/ (function(module, exports) {

	/**
	 * Code refactored from Mozilla Developer Network:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	 */
	
	'use strict';
	
	function assign(target, firstSource) {
	  if (target === undefined || target === null) {
	    throw new TypeError('Cannot convert first argument to object');
	  }
	
	  var to = Object(target);
	  for (var i = 1; i < arguments.length; i++) {
	    var nextSource = arguments[i];
	    if (nextSource === undefined || nextSource === null) {
	      continue;
	    }
	
	    var keysArray = Object.keys(Object(nextSource));
	    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	      var nextKey = keysArray[nextIndex];
	      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	      if (desc !== undefined && desc.enumerable) {
	        to[nextKey] = nextSource[nextKey];
	      }
	    }
	  }
	  return to;
	}
	
	function polyfill() {
	  if (!Object.assign) {
	    Object.defineProperty(Object, 'assign', {
	      enumerable: false,
	      configurable: true,
	      writable: true,
	      value: assign
	    });
	  }
	}
	
	module.exports = {
	  assign: assign,
	  polyfill: polyfill
	};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = self.fetch;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(464);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(474);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(9);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var createArrayFromMixed = __webpack_require__(467);
	var getMarkupWrap = __webpack_require__(469);
	var invariant = __webpack_require__(9);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(471);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(473);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "60e8a8323a1f5c9dc59c6783d5974123.png";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e72d1907bf5d0f6c1153e50aa7cf7f9a.png";

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(84);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _marker_dispatcher = __webpack_require__(481);
	
	var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);
	
	var _google_map_map = __webpack_require__(479);
	
	var _google_map_map2 = _interopRequireDefault(_google_map_map);
	
	var _google_map_markers = __webpack_require__(183);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	var _google_map_markers_prerender = __webpack_require__(480);
	
	var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);
	
	var _google_map_loader = __webpack_require__(489);
	
	var _google_map_loader2 = _interopRequireDefault(_google_map_loader);
	
	var _detect = __webpack_require__(483);
	
	var _detect2 = _interopRequireDefault(_detect);
	
	var _geo = __webpack_require__(485);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _array_helper = __webpack_require__(482);
	
	var _array_helper2 = _interopRequireDefault(_array_helper);
	
	var _is_plain_object = __webpack_require__(487);
	
	var _is_plain_object2 = _interopRequireDefault(_is_plain_object);
	
	var _pick = __webpack_require__(491);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _raf = __webpack_require__(492);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _log = __webpack_require__(490);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _isNumber = __webpack_require__(486);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _omit = __webpack_require__(186);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _detectElementResize = __webpack_require__(484);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies, react/forbid-prop-types, react/no-find-dom-node, no-console */
	
	
	var kEPS = 0.00001;
	var K_GOOGLE_TILE_SIZE = 256;
	// real minZoom calculated here _getMinZoom
	var K_IDLE_TIMEOUT = 100;
	var K_IDLE_CLICK_TIMEOUT = 300;
	var DEFAULT_MIN_ZOOM = 3;
	
	function defaultOptions_() /* maps */{
	  return {
	    overviewMapControl: false,
	    streetViewControl: false,
	    rotateControl: true,
	    mapTypeControl: false,
	    // disable poi
	    styles: [{
	      featureType: 'poi',
	      elementType: 'labels',
	      stylers: [{ visibility: 'off' }]
	    }],
	    minZoom: DEFAULT_MIN_ZOOM };
	}
	
	var latLng2Obj = function latLng2Obj(latLng) {
	  return (0, _is_plain_object2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
	};
	
	var _checkMinZoom = function _checkMinZoom(zoom, minZoom) {
	  if (false) {
	    if (zoom < minZoom) {
	      console.warn('GoogleMap: ' + // eslint-disable-line
	      'minZoom option is less than recommended ' + 'minZoom option for your map sizes.\n' + 'overrided to value ' + minZoom);
	    }
	  }
	
	  if (minZoom < zoom) {
	    return zoom;
	  }
	  return minZoom;
	};
	
	var GoogleMap = function (_Component) {
	  _inherits(GoogleMap, _Component);
	
	  // eslint-disable-line
	
	  function GoogleMap(props) {
	    _classCallCheck(this, GoogleMap);
	
	    var _this = _possibleConstructorReturn(this, (GoogleMap.__proto__ || Object.getPrototypeOf(GoogleMap)).call(this, props));
	
	    _this._getMinZoom = function () {
	      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
	        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
	        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
	        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
	        return Math.ceil((0, _log2.default)(maxTilesPerDim));
	      }
	      return DEFAULT_MIN_ZOOM;
	    };
	
	    _this._computeMinZoom = function (minZoomOverride, minZoom) {
	      if (minZoomOverride) {
	        return minZoom || DEFAULT_MIN_ZOOM;
	      }
	      return _this._getMinZoom();
	    };
	
	    _this._mapDomResizeCallback = function () {
	      _this.resetSizeOnIdle_ = true;
	      if (_this.maps_) {
	        var originalCenter = _this.map_.getCenter();
	        _this.maps_.event.trigger(_this.map_, 'resize');
	        _this.map_.setCenter(originalCenter);
	      }
	    };
	
	    _this._setLayers = function (layerTypes) {
	      layerTypes.forEach(function (layerType) {
	        _this.layers_[layerType] = new _this.maps_[layerType]();
	        _this.layers_[layerType].setMap(_this.map_);
	      });
	    };
	
	    _this._initMap = function () {
	      // only initialize the map once
	      if (_this.initialized_) {
	        return;
	      }
	      _this.initialized_ = true;
	
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	
	      _this._onBoundsChanged(); // now we can calculate map bounds center etc...
	
	      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);
	
	      _this.props.googleMapLoader(bootstrapURLKeys).then(function (maps) {
	        if (!_this.mounted_) {
	          return;
	        }
	
	        var centerLatLng = _this.geoService_.getCenter();
	
	        var propsOptions = {
	          zoom: _this.props.zoom || _this.props.defaultZoom,
	          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
	        };
	
	        // prevent to exapose full api
	        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
	        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
	        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
	        // "SymbolPath", "ZoomControlStyle",
	        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
	        // "DistanceMatrixStatus",
	        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
	        // "GeocoderStatus", "KmlLayerStatus",
	        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
	        // "TravelMode", "UnitSystem"
	        var mapPlainObjects = (0, _pick2.default)(maps, _is_plain_object2.default);
	        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
	        var defaultOptions = defaultOptions_(mapPlainObjects);
	
	        var draggableOptions = _this.props.draggable !== undefined && {
	          draggable: _this.props.draggable
	        };
	
	        var minZoom = _this._computeMinZoom(options.minZoomOverride, options.minZoom);
	        _this.minZoom_ = minZoom;
	
	        var preMapOptions = _extends({}, defaultOptions, {
	          minZoom: minZoom
	        }, options, propsOptions);
	
	        _this.defaultDraggableOption_ = preMapOptions.draggable !== undefined ? preMapOptions.draggable : _this.defaultDraggableOption_;
	
	        var mapOptions = _extends({}, preMapOptions, draggableOptions);
	
	        mapOptions.minZoom = _checkMinZoom(mapOptions.minZoom, minZoom);
	
	        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.googleMapDom_), mapOptions);
	
	        _this.map_ = map;
	        _this.maps_ = maps;
	
	        _this._setLayers(_this.props.layerTypes);
	
	        // render in overlay
	        var this_ = _this;
	        var overlay = Object.assign(new maps.OverlayView(), {
	          onAdd: function onAdd() {
	            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
	            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';
	
	            var div = document.createElement('div');
	            this.div = div;
	            div.style.backgroundColor = 'transparent';
	            div.style.position = 'absolute';
	            div.style.left = '0px';
	            div.style.top = '0px';
	            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
	            div.style.height = K_MAX_HEIGHT;
	
	            var panes = this.getPanes();
	            panes.overlayMouseTarget.appendChild(div);
	
	            _reactDom2.default.unstable_renderSubtreeIntoContainer(this_, _react2.default.createElement(_google_map_markers2.default, {
	              experimental: this_.props.experimental,
	              onChildClick: this_._onChildClick,
	              onChildMouseDown: this_._onChildMouseDown,
	              onChildMouseEnter: this_._onChildMouseEnter,
	              onChildMouseLeave: this_._onChildMouseLeave,
	              geoService: this_.geoService_,
	              projectFromLeftTop: true,
	              distanceToMouse: this_.props.distanceToMouse,
	              getHoverDistance: this_._getHoverDistance,
	              dispatcher: this_.markersDispatcher_
	            }), div,
	            // remove prerendered markers
	            function () {
	              return this_.setState({ overlayCreated: true });
	            });
	          },
	          onRemove: function onRemove() {
	            _reactDom2.default.unmountComponentAtNode(this.div);
	          },
	          draw: function draw() {
	            var div = overlay.div;
	            var overlayProjection = overlay.getProjection();
	            var bounds = map.getBounds();
	            var ne = bounds.getNorthEast();
	            var sw = bounds.getSouthWest();
	            var ptx = overlayProjection.fromLatLngToDivPixel(new maps.LatLng(ne.lat(), sw.lng()));
	
	            // need round for safari still can't find what need for firefox
	            var ptxRounded = (0, _detect2.default)().isSafari ? { x: Math.round(ptx.x), y: Math.round(ptx.y) } : { x: ptx.x, y: ptx.y };
	
	            this_.updateCounter_++;
	            this_._onBoundsChanged(map, maps, !this_.props.debounced);
	
	            if (!this_.googleApiLoadedCalled_) {
	              this_._onGoogleApiLoaded({ map: map, maps: maps });
	              this_.googleApiLoadedCalled_ = true;
	            }
	
	            div.style.left = ptxRounded.x + 'px';
	            div.style.top = ptxRounded.y + 'px';
	            if (this_.markersDispatcher_) {
	              this_.markersDispatcher_.emit('kON_CHANGE');
	            }
	          }
	        });
	
	        _this.overlay_ = overlay;
	
	        overlay.setMap(map);
	
	        maps.event.addListener(map, 'zoom_changed', function () {
	          // recalc position at zoom start
	          if (this_.geoService_.getZoom() !== map.getZoom()) {
	            if (!this_.zoomAnimationInProgress_) {
	              this_.zoomAnimationInProgress_ = true;
	              this_._onZoomAnimationStart();
	            }
	
	            var TIMEOUT_ZOOM = 300;
	
	            if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
	              // there is strange Google Map Api behavior in chrome when zoom animation of map
	              // is started only on second raf call, if was click on zoom control
	              // or +- keys pressed, so i wait for two rafs before change state
	
	              // this does not fully prevent animation jump
	              // but reduce it's occurence probability
	              (0, _raf2.default)(function () {
	                return (0, _raf2.default)(function () {
	                  this_.updateCounter_++;
	                  this_._onBoundsChanged(map, maps);
	                });
	              });
	            } else {
	              this_.updateCounter_++;
	              this_._onBoundsChanged(map, maps);
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'idle', function () {
	          if (_this.resetSizeOnIdle_) {
	            _this._setViewSize();
	            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoomOverride, _this.props.options.minZoom);
	
	            if (currMinZoom !== _this.minZoom_) {
	              _this.minZoom_ = currMinZoom;
	              map.setOptions({ minZoom: currMinZoom });
	            }
	
	            _this.resetSizeOnIdle_ = false;
	          }
	
	          if (this_.zoomAnimationInProgress_) {
	            this_.zoomAnimationInProgress_ = false;
	            this_._onZoomAnimationEnd();
	          }
	
	          var div = overlay.div;
	          var overlayProjection = overlay.getProjection();
	          var bounds = map.getBounds();
	          var ne = bounds.getNorthEast();
	          var sw = bounds.getSouthWest();
	          var ptx = overlayProjection.fromLatLngToDivPixel(new maps.LatLng(ne.lat(), sw.lng()));
	          // need round for safari still can't find what need for firefox
	          var ptxRounded = (0, _detect2.default)().isSafari ? { x: Math.round(ptx.x), y: Math.round(ptx.y) } : { x: ptx.x, y: ptx.y };
	
	          this_.updateCounter_++;
	          this_._onBoundsChanged(map, maps);
	
	          if (_this.mouse_) {
	            var latLng = _this.geoService_.unproject(_this.mouse_, true);
	            _this.mouse_.lat = latLng.lat;
	            _this.mouse_.lng = latLng.lng;
	          }
	
	          _this._onChildMouseMove();
	
	          this_.dragTime_ = 0;
	          div.style.left = ptxRounded.x + 'px';
	          div.style.top = ptxRounded.y + 'px';
	          if (this_.markersDispatcher_) {
	            this_.markersDispatcher_.emit('kON_CHANGE');
	            if (this_.fireMouseEventOnIdle_) {
	              this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'mouseover', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = true;
	        });
	
	        // an alternative way to know the mouse is back within the map
	        // This would not fire when clicking/interacting with google maps
	        // own on-map countrols+markers. This handles an edge case for touch devices
	        // + 'draggable:false' custom option. See #332 for more details.
	        maps.event.addListener(map, 'click', function () {
	          this_.mouseInMap_ = true;
	        });
	
	        maps.event.addListener(map, 'mouseout', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = false;
	          this_.mouse_ = null;
	          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        });
	
	        maps.event.addListener(map, 'drag', function () {
	          this_.dragTime_ = new Date().getTime();
	          this_._onDrag();
	        });
	        // user choosing satellite vs roads, etc
	        maps.event.addListener(map, 'maptypeid_changed', function () {
	          this_._onMapTypeIdChange(map.getMapTypeId());
	        });
	      }).catch(function (e) {
	        console.error(e); // eslint-disable-line no-console
	        throw e;
	      });
	    };
	
	    _this._onGoogleApiLoaded = function () {
	      if (_this.props.onGoogleApiLoaded) {
	        var _this$props;
	
	        if (false) {
	          console.warn('GoogleMap: ' + // eslint-disable-line
	          'Usage of internal api objects is dangerous ' + 'and can cause a lot of issues.\n' + 'To hide this warning add yesIWantToUseGoogleMapApiInternals={true} ' + 'to <GoogleMap instance');
	        }
	
	        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
	      }
	    };
	
	    _this._getHoverDistance = function () {
	      return _this.props.hoverDistance;
	    };
	
	    _this._onDrag = function () {
	      var _this$props2;
	
	      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
	    };
	
	    _this._onMapTypeIdChange = function () {
	      var _this$props3;
	
	      return _this.props.onMapTypeIdChange && (_this$props3 = _this.props).onMapTypeIdChange.apply(_this$props3, arguments);
	    };
	
	    _this._onZoomAnimationStart = function () {
	      var _this$props4;
	
	      return _this.props.onZoomAnimationStart && (_this$props4 = _this.props).onZoomAnimationStart.apply(_this$props4, arguments);
	    };
	
	    _this._onZoomAnimationEnd = function () {
	      var _this$props5;
	
	      return _this.props.onZoomAnimationEnd && (_this$props5 = _this.props).onZoomAnimationEnd.apply(_this$props5, arguments);
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        var _this$props6;
	
	        return (_this$props6 = _this.props).onChildClick.apply(_this$props6, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseDown = function (hoverKey, childProps) {
	      _this.childMouseDownArgs_ = [hoverKey, childProps];
	      if (_this.props.onChildMouseDown) {
	        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
	      }
	    };
	
	    _this._onChildMouseUp = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseUp) {
	          var _this$props7;
	
	          (_this$props7 = _this.props).onChildMouseUp.apply(_this$props7, _toConsumableArray(_this.childMouseDownArgs_).concat([_extends({}, _this.mouse_)]));
	        }
	        _this.childMouseDownArgs_ = null;
	        _this.childMouseUpTime_ = new Date().getTime();
	      }
	    };
	
	    _this._onChildMouseMove = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseMove) {
	          var _this$props8;
	
	          (_this$props8 = _this.props).onChildMouseMove.apply(_this$props8, _toConsumableArray(_this.childMouseDownArgs_).concat([_extends({}, _this.mouse_)]));
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function () {
	      if (_this.props.onChildMouseEnter) {
	        var _this$props9;
	
	        return (_this$props9 = _this.props).onChildMouseEnter.apply(_this$props9, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (_this.props.onChildMouseLeave) {
	        var _this$props10;
	
	        return (_this$props10 = _this.props).onChildMouseLeave.apply(_this$props10, arguments);
	      }
	      return undefined;
	    };
	
	    _this._setViewSize = function () {
	      if (!_this.mounted_) return;
	
	      var mapDom = _reactDom2.default.findDOMNode(_this.googleMapDom_);
	      _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
	      _this._onBoundsChanged();
	    };
	
	    _this._onWindowResize = function () {
	      _this.resetSizeOnIdle_ = true;
	    };
	
	    _this._onMapMouseMove = function (e) {
	      if (!_this.mouseInMap_) return;
	
	      var currTime = new Date().getTime();
	      var K_RECALC_CLIENT_RECT_MS = 50;
	
	      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
	        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
	      }
	      _this.mouseMoveTime_ = currTime;
	
	      var mousePosX = e.clientX - _this.boundingRect_.left;
	      var mousePosY = e.clientY - _this.boundingRect_.top;
	
	      if (!_this.mouse_) {
	        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
	      }
	
	      _this.mouse_.x = mousePosX;
	      _this.mouse_.y = mousePosY;
	
	      var latLng = _this.geoService_.unproject(_this.mouse_, true);
	      _this.mouse_.lat = latLng.lat;
	      _this.mouse_.lng = latLng.lng;
	
	      _this._onChildMouseMove();
	
	      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
	        _this.fireMouseEventOnIdle_ = true;
	      } else {
	        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        _this.fireMouseEventOnIdle_ = false;
	      }
	    };
	
	    _this._onClick = function () {
	      var _this$props11;
	
	      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props11 = _this.props).onClick.apply(_this$props11, arguments);
	    };
	
	    _this._onMapClick = function (event) {
	      if (_this.markersDispatcher_) {
	        // support touch events and recalculate mouse position on click
	        _this._onMapMouseMove(event);
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          if (_this.mouse_) {
	            _this._onClick(_extends({}, _this.mouse_, {
	              event: event
	            }));
	          }
	
	          _this.markersDispatcher_.emit('kON_CLICK', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownNative = function (event) {
	      if (!_this.mouseInMap_) return;
	
	      _this._onMapMouseDown(event);
	    };
	
	    _this._onMapMouseDown = function (event) {
	      if (_this.markersDispatcher_) {
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          // Hovered marker detected at mouse move could be deleted at mouse down time
	          // so it will be good to force hovered marker recalculation
	          _this._onMapMouseMove(event);
	          _this.markersDispatcher_.emit('kON_MDOWN', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        // to fix strange zoom in chrome
	        if (!_this.mouse_) {
	          _this.zoomControlClickTime_ = new Date().getTime();
	        }
	      }
	    };
	
	    _this._onKeyDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        _this.zoomControlClickTime_ = new Date().getTime();
	      }
	    };
	
	    _this._isCenterDefined = function (center) {
	      return center && ((0, _is_plain_object2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
	    };
	
	    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
	      if (map) {
	        var gmC = map.getCenter();
	        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
	      }
	
	      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
	        var zoom = _this.geoService_.getZoom();
	        var bounds = _this.geoService_.getBounds();
	        var centerLatLng = _this.geoService_.getCenter();
	
	        if (!(0, _array_helper2.default)(bounds, _this.prevBounds_, kEPS)) {
	          if (callExtBoundsChange !== false) {
	            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
	            if (_this.props.onBoundsChange) {
	              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
	            }
	
	            if (_this.props.onChange) {
	              _this.props.onChange({
	                center: _extends({}, centerLatLng),
	                zoom: zoom,
	                bounds: {
	                  nw: {
	                    lat: bounds[0],
	                    lng: bounds[1]
	                  },
	                  se: {
	                    lat: bounds[2],
	                    lng: bounds[3]
	                  },
	                  sw: {
	                    lat: bounds[4],
	                    lng: bounds[5]
	                  },
	                  ne: {
	                    lat: bounds[6],
	                    lng: bounds[7]
	                  }
	                },
	                marginBounds: {
	                  nw: {
	                    lat: marginBounds[0],
	                    lng: marginBounds[1]
	                  },
	                  se: {
	                    lat: marginBounds[2],
	                    lng: marginBounds[3]
	                  },
	                  sw: {
	                    lat: marginBounds[4],
	                    lng: marginBounds[5]
	                  },
	                  ne: {
	                    lat: marginBounds[6],
	                    lng: marginBounds[7]
	                  }
	                },
	
	                size: _this.geoService_.hasSize() ? {
	                  width: _this.geoService_.getWidth(),
	                  height: _this.geoService_.getHeight()
	                } : {
	                  width: 0,
	                  height: 0
	                }
	              });
	            }
	
	            _this.prevBounds_ = bounds;
	          }
	        }
	      }
	    };
	
	    _this._registerChild = function (ref) {
	      _this.googleMapDom_ = ref;
	    };
	
	    _this.mounted_ = false;
	    _this.initialized_ = false;
	    _this.googleApiLoadedCalled_ = false;
	
	    _this.map_ = null;
	    _this.maps_ = null;
	    _this.prevBounds_ = null;
	
	    _this.layers_ = {};
	
	    _this.mouse_ = null;
	    _this.mouseMoveTime_ = 0;
	    _this.boundingRect_ = null;
	    _this.mouseInMap_ = true;
	
	    _this.dragTime_ = 0;
	    _this.fireMouseEventOnIdle_ = false;
	    _this.updateCounter_ = 0;
	
	    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
	    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
	    _this.centerIsObject_ = (0, _is_plain_object2.default)(_this.props.center);
	
	    _this.minZoom_ = DEFAULT_MIN_ZOOM;
	    _this.defaultDraggableOption_ = true;
	
	    _this.zoomControlClickTime_ = 0;
	
	    _this.childMouseDownArgs_ = null;
	    _this.childMouseUpTime_ = 0;
	
	    _this.googleMapDom_ = null;
	
	    if (false) {
	      if (_this.props.apiKey) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'apiKey is deprecated, use ' + 'bootstrapURLKeys={{key: YOUR_API_KEY}} instead.');
	      }
	
	      if (_this.props.onBoundsChange) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'onBoundsChange is deprecated, use ' + 'onChange({center, zoom, bounds, ...other}) instead.');
	      }
	
	      if (_this.props.center === undefined && _this.props.defaultCenter === undefined) {
	        console.warn('GoogleMap: center or defaultCenter property must be defined' // eslint-disable-line no-console
	        );
	      }
	
	      if (_this.props.zoom === undefined && _this.props.defaultZoom === undefined) {
	        console.warn('GoogleMap: zoom or defaultZoom property must be defined' // eslint-disable-line no-console
	        );
	      }
	    }
	
	    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	    }
	
	    _this.zoomAnimationInProgress_ = false;
	
	    _this.state = {
	      overlayCreated: false
	    };
	    return _this;
	  }
	
	  _createClass(GoogleMap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mounted_ = true;
	      window.addEventListener('resize', this._onWindowResize);
	      window.addEventListener('keydown', this._onKeyDownCapture, true);
	      var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
	      // gmap can't prevent map drag if mousedown event already occured
	      // the only workaround I find is prevent mousedown native browser event
	      _reactDom2.default.findDOMNode(this.googleMapDom_).addEventListener('mousedown', this._onMapMouseDownNative, true);
	
	      window.addEventListener('mouseup', this._onChildMouseUp, false);
	
	      var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);
	
	      this.props.googleMapLoader(bootstrapURLKeys); // we can start load immediatly
	
	      setTimeout(function () {
	        // to detect size
	        _this2._setViewSize();
	        if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
	          _this2._initMap();
	        }
	      }, 0, this);
	      if (this.props.resetBoundsOnResize) {
	        var that = this;
	        _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (false) {
	        if (this.props.defaultCenter !== nextProps.defaultCenter) {
	          console.warn('GoogleMap: defaultCenter prop changed. ' + // eslint-disable-line
	          "You can't change default props.");
	        }
	
	        if (this.props.defaultZoom !== nextProps.defaultZoom) {
	          console.warn('GoogleMap: defaultZoom prop changed. ' + // eslint-disable-line
	          "You can't change default props.");
	        }
	      }
	
	      if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
	        setTimeout(function () {
	          return _this3._initMap();
	        }, 0);
	      }
	
	      if (this.map_) {
	        var centerLatLng = this.geoService_.getCenter();
	        if (this._isCenterDefined(nextProps.center)) {
	          var nextPropsCenter = latLng2Obj(nextProps.center);
	          var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;
	
	          if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
	            if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
	              this.map_.panTo({
	                lat: nextPropsCenter.lat,
	                lng: nextPropsCenter.lng
	              });
	            }
	          }
	        }
	
	        if (nextProps.zoom !== undefined) {
	          // if zoom chaged by user
	          if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
	            this.map_.setZoom(nextProps.zoom);
	          }
	        }
	
	        if (this.props.draggable !== undefined && nextProps.draggable === undefined) {
	          // reset to default
	          this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
	        } else if (this.props.draggable !== nextProps.draggable) {
	          // also prevent this on window 'mousedown' event to prevent map move
	          this.map_.setOptions({ draggable: nextProps.draggable });
	        }
	
	        // use shallowEqual to try avoid calling map._setOptions if only the ref changes
	        if (nextProps.options !== undefined && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
	          var mapPlainObjects = (0, _pick2.default)(this.maps_, _is_plain_object2.default);
	          var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
	          // remove zoom, center and draggable options as these are managed by google-maps-react
	          options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);
	
	          if ('minZoom' in options) {
	            var minZoom = this._computeMinZoom(options.minZoomOverride, options.minZoom);
	            options.minZoom = _checkMinZoom(options.minZoom, minZoom);
	          }
	
	          this.map_.setOptions(options);
	        }
	
	        if (nextProps.layerTypes !== this.props.layerTypes) {
	          Object.keys(this.layers_).forEach(function (layerKey) {
	            _this3.layers_[layerKey].setMap(null);
	            delete _this3.layers_[layerKey];
	          });
	          this._setLayers(nextProps.layerTypes);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // draggable does not affect inner components
	      return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.markersDispatcher_.emit('kON_CHANGE');
	
	      if (this.props.hoverDistance !== prevProps.hoverDistance) {
	        this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted_ = false;
	      var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
	      window.removeEventListener('resize', this._onWindowResize);
	      window.removeEventListener('keydown', this._onKeyDownCapture);
	      mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
	      window.removeEventListener('mouseup', this._onChildMouseUp, false);
	      if (this.props.resetBoundsOnResize) {
	        _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
	      }
	
	      if (this.overlay_) {
	        // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
	        this.overlay_.setMap(null);
	      }
	
	      if (this.maps_ && this.map_) {
	        // fix google, as otherwise listeners works even without map
	        this.map_.setOptions({ scrollwheel: false });
	        this.maps_.event.clearInstanceListeners(this.map_);
	      }
	
	      this.map_ = null;
	      this.maps_ = null;
	      this.markersDispatcher_.dispose();
	
	      this.resetSizeOnIdle_ = false;
	
	      delete this.map_;
	      delete this.markersDispatcher_;
	    }
	    // calc minZoom if map size available
	    // it's better to not set minZoom less than this calculation gives
	    // otherwise there is no homeomorphism between screen coordinates and map
	    // (one map coordinate can have different screen coordinates)
	
	
	    // this method works only if this.props.onChildMouseDown was called
	
	
	    // this method works only if this.props.onChildMouseDown was called
	
	
	    // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough
	
	
	    // gmap can't prevent map drag if mousedown event already occured
	    // the only workaround I find is prevent mousedown native browser event
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var mapMarkerPrerender = !this.state.overlayCreated ? _react2.default.createElement(_google_map_markers_prerender2.default, {
	        experimental: this.props.experimental,
	        onChildClick: this._onChildClick,
	        onChildMouseDown: this._onChildMouseDown,
	        onChildMouseEnter: this._onChildMouseEnter,
	        onChildMouseLeave: this._onChildMouseLeave,
	        geoService: this.geoService_,
	        projectFromLeftTop: false,
	        distanceToMouse: this.props.distanceToMouse,
	        getHoverDistance: this._getHoverDistance,
	        dispatcher: this.markersDispatcher_
	      }) : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: this.props.style,
	          onMouseMove: this._onMapMouseMove,
	          onMouseDownCapture: this._onMapMouseDownCapture,
	          onClick: this._onMapClick
	        },
	        _react2.default.createElement(_google_map_map2.default, { registerChild: this._registerChild }),
	        mapMarkerPrerender
	      );
	    }
	  }]);
	
	  return GoogleMap;
	}(_react.Component);
	
	GoogleMap.propTypes = {
	  apiKey: _propTypes2.default.string,
	  bootstrapURLKeys: _propTypes2.default.any,
	
	  defaultCenter: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  })]),
	  center: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  })]),
	  defaultZoom: _propTypes2.default.number,
	  zoom: _propTypes2.default.number,
	  onBoundsChange: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onChildClick: _propTypes2.default.func,
	  onChildMouseDown: _propTypes2.default.func,
	  onChildMouseUp: _propTypes2.default.func,
	  onChildMouseMove: _propTypes2.default.func,
	  onChildMouseEnter: _propTypes2.default.func,
	  onChildMouseLeave: _propTypes2.default.func,
	  onZoomAnimationStart: _propTypes2.default.func,
	  onZoomAnimationEnd: _propTypes2.default.func,
	  onDrag: _propTypes2.default.func,
	  onMapTypeIdChange: _propTypes2.default.func,
	  options: _propTypes2.default.any,
	  distanceToMouse: _propTypes2.default.func,
	  hoverDistance: _propTypes2.default.number,
	  debounced: _propTypes2.default.bool,
	  margin: _propTypes2.default.array,
	  googleMapLoader: _propTypes2.default.any,
	  onGoogleApiLoaded: _propTypes2.default.func,
	  yesIWantToUseGoogleMapApiInternals: _propTypes2.default.bool,
	  draggable: _propTypes2.default.bool,
	  style: _propTypes2.default.any,
	  resetBoundsOnResize: _propTypes2.default.bool,
	  layerTypes: _propTypes2.default.arrayOf(_propTypes2.default.string) };
	GoogleMap.defaultProps = {
	  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
	    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
	  },
	
	  hoverDistance: 30,
	  debounced: true,
	  options: defaultOptions_,
	  googleMapLoader: _google_map_loader2.default,
	  yesIWantToUseGoogleMapApiInternals: false,
	  style: {
	    width: '100%',
	    height: '100%',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	  layerTypes: []
	};
	GoogleMap.googleMapLoader = _google_map_loader2.default;
	exports.default = GoogleMap;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var GoogleMapMap = function (_Component) {
	  _inherits(GoogleMapMap, _Component);
	
	  function GoogleMapMap() {
	    _classCallCheck(this, GoogleMapMap);
	
	    return _possibleConstructorReturn(this, (GoogleMapMap.__proto__ || Object.getPrototypeOf(GoogleMapMap)).apply(this, arguments));
	  }
	
	  _createClass(GoogleMapMap, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false; // disable react on this div
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var registerChild = this.props.registerChild;
	
	      return _react2.default.createElement('div', { ref: registerChild, style: style });
	    }
	  }]);
	
	  return GoogleMapMap;
	}(_react.Component);
	
	exports.default = GoogleMapMap;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { style: style },
	    _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true }))
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _google_map_markers = __webpack_require__(183);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  width: '50%',
	  height: '50%',
	  left: '50%',
	  top: '50%',
	  // backgroundColor: 'red',
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventemitter = __webpack_require__(462);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkerDispatcher = function (_EventEmitter) {
	  _inherits(MarkerDispatcher, _EventEmitter);
	
	  function MarkerDispatcher(gmapInstance) {
	    _classCallCheck(this, MarkerDispatcher);
	
	    var _this = _possibleConstructorReturn(this, (MarkerDispatcher.__proto__ || Object.getPrototypeOf(MarkerDispatcher)).call(this));
	
	    _this.gmapInstance = gmapInstance;
	    return _this;
	  }
	
	  _createClass(MarkerDispatcher, [{
	    key: 'getChildren',
	    value: function getChildren() {
	      return this.gmapInstance.props.children;
	    }
	  }, {
	    key: 'getMousePosition',
	    value: function getMousePosition() {
	      return this.gmapInstance.mouse_;
	    }
	  }, {
	    key: 'getUpdateCounter',
	    value: function getUpdateCounter() {
	      return this.gmapInstance.updateCounter_;
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      this.gmapInstance = null;
	      this.removeAllListeners();
	    }
	  }]);
	
	  return MarkerDispatcher;
	}(_eventemitter2.default);
	
	exports.default = MarkerDispatcher;

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isArraysEqualEps;
	function isArraysEqualEps(arrayA, arrayB, eps) {
	  if (arrayA && arrayB) {
	    for (var i = 0; i !== arrayA.length; ++i) {
	      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
	        return false;
	      }
	    }
	    return true;
	  }
	  return false;
	}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = detectBrowser;
	// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
	var detectBrowserResult_ = null;
	
	function detectBrowser() {
	  if (detectBrowserResult_) {
	    return detectBrowserResult_;
	  }
	
	  if (typeof navigator !== 'undefined') {
	    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
	    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
	    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
	
	    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
	    var isSafari = navigator.userAgent.indexOf('Safari') > -1;
	
	    if (isChrome && isSafari) {
	      isSafari = false;
	    }
	
	    if (isChrome && isOpera) {
	      isChrome = false;
	    }
	
	    detectBrowserResult_ = {
	      isExplorer: isExplorer,
	      isFirefox: isFirefox,
	      isOpera: isOpera,
	      isChrome: isChrome,
	      isSafari: isSafari
	    };
	    return detectBrowserResult_;
	  }
	
	  detectBrowserResult_ = {
	    isChrome: true,
	    isExplorer: false,
	    isFirefox: false,
	    isOpera: false,
	    isSafari: false
	  };
	
	  return detectBrowserResult_;
	}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	/**
	* Detect Element Resize.
	* Forked in order to guard against unsafe 'window' and 'document' references.
	*
	* https://github.com/sdecima/javascript-detect-element-resize
	* Sebastian Decima
	*
	* version: 0.5.3
	**/
	
	// Reliable `window` and `document` detection
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Check `document` and `window` in case of server-side rendering
	var _window;
	if (canUseDOM) {
	  _window = window;
	} else if (typeof self !== 'undefined') {
	  _window = self;
	} else {
	  _window = undefined;
	}
	
	var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	var stylesCreated = false;
	
	if (canUseDOM && !attachEvent) {
	  var requestFrame = function () {
	    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	      return _window.setTimeout(fn, 20);
	    };
	    return function (fn) {
	      return raf(fn);
	    };
	  }();
	
	  var cancelFrame = function () {
	    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	    return function (id) {
	      return cancel(id);
	    };
	  }();
	
	  var resetTriggers = function resetTriggers(element) {
	    var triggers = element.__resizeTriggers__,
	        expand = triggers.firstElementChild,
	        contract = triggers.lastElementChild,
	        expandChild = expand.firstElementChild;
	    contract.scrollLeft = contract.scrollWidth;
	    contract.scrollTop = contract.scrollHeight;
	    expandChild.style.width = expand.offsetWidth + 1 + 'px';
	    expandChild.style.height = expand.offsetHeight + 1 + 'px';
	    expand.scrollLeft = expand.scrollWidth;
	    expand.scrollTop = expand.scrollHeight;
	  };
	
	  var checkTriggers = function checkTriggers(element) {
	    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	  };
	
	  var scrollListener = function scrollListener(e) {
	    var element = this;
	    resetTriggers(this);
	    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	    this.__resizeRAF__ = requestFrame(function () {
	      if (checkTriggers(element)) {
	        element.__resizeLast__.width = element.offsetWidth;
	        element.__resizeLast__.height = element.offsetHeight;
	        element.__resizeListeners__.forEach(function (fn) {
	          fn.call(element, e);
	        });
	      }
	    });
	  };
	
	  /* Detect CSS Animations support to detect element display/re-attach */
	  var animation = false,
	      animationstring = 'animation',
	      keyframeprefix = '',
	      animationstartevent = 'animationstart',
	      domPrefixes = 'Webkit Moz O ms'.split(' '),
	      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	      pfx = '';
	
	  if (canUseDOM) {
	    var elm = document.createElement('fakeelement');
	    if (elm.style.animationName !== undefined) {
	      animation = true;
	    }
	
	    if (animation === false) {
	      for (var i = 0; i < domPrefixes.length; i++) {
	        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	          pfx = domPrefixes[i];
	          animationstring = pfx + 'Animation';
	          keyframeprefix = '-' + pfx.toLowerCase() + '-';
	          animationstartevent = startEvents[i];
	          animation = true;
	          break;
	        }
	      }
	    }
	  }
	
	  var animationName = 'resizeanim';
	  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}
	
	var createStyles = function createStyles() {
	  if (!stylesCreated) {
	    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	        head = document.head || document.getElementsByTagName('head')[0],
	        style = document.createElement('style');
	
	    style.type = 'text/css';
	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	
	    head.appendChild(style);
	    stylesCreated = true;
	  }
	};
	
	var addResizeListener = function addResizeListener(element, fn) {
	  if (element.parentNode === undefined) {
	    var tempParentDiv = document.createElement('div');
	    element.parentNode = tempParentDiv;
	  }
	  element = element.parentNode;
	  if (attachEvent) element.attachEvent('onresize', fn);else {
	    if (!element.__resizeTriggers__) {
	      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
	      createStyles();
	      element.__resizeLast__ = {};
	      element.__resizeListeners__ = [];
	      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	      element.appendChild(element.__resizeTriggers__);
	      resetTriggers(element);
	      element.addEventListener('scroll', scrollListener, true);
	
	      /* Listen for a css animation to detect element display/re-attach */
	      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
	        if (e.animationName == animationName) resetTriggers(element);
	      });
	    }
	    element.__resizeListeners__.push(fn);
	  }
	};
	
	var removeResizeListener = function removeResizeListener(element, fn) {
	  element = element.parentNode;
	  if (attachEvent) element.detachEvent('onresize', fn);else {
	    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	    if (!element.__resizeListeners__.length) {
	      element.removeEventListener('scroll', scrollListener);
	      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	    }
	  }
	};
	
	module.exports = {
	  addResizeListener: addResizeListener,
	  removeResizeListener: removeResizeListener
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pointGeometry = __webpack_require__(356);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _lat_lng = __webpack_require__(184);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _transform = __webpack_require__(488);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Geo = function () {
	  function Geo(tileSize) {
	    _classCallCheck(this, Geo);
	
	    // left_top view пользует гугл
	    // super();
	    this.hasSize_ = false;
	    this.hasView_ = false;
	    this.transform_ = new _transform2.default(tileSize || 512);
	  }
	
	  _createClass(Geo, [{
	    key: 'setView',
	    value: function setView(center, zoom, bearing) {
	      this.transform_.center = _lat_lng2.default.convert(center);
	      this.transform_.zoom = +zoom;
	      this.transform_.bearing = +bearing;
	      this.hasView_ = true;
	    }
	  }, {
	    key: 'setViewSize',
	    value: function setViewSize(width, height) {
	      this.transform_.width = width;
	      this.transform_.height = height;
	      this.hasSize_ = true;
	    }
	  }, {
	    key: 'canProject',
	    value: function canProject() {
	      return this.hasSize_ && this.hasView_;
	    }
	  }, {
	    key: 'hasSize',
	    value: function hasSize() {
	      return this.hasSize_;
	    }
	  }, {
	    key: 'unproject',
	    value: function unproject(ptXY, viewFromLeftTop) {
	      var ptRes = void 0;
	      if (viewFromLeftTop) {
	        var ptxy = _extends({}, ptXY);
	        ptxy.x -= this.transform_.width / 2;
	        ptxy.y -= this.transform_.height / 2;
	        ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));
	      } else {
	        ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptXY));
	      }
	
	      ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
	      return ptRes;
	    }
	  }, {
	    key: 'project',
	    value: function project(ptLatLng, viewFromLeftTop) {
	      if (viewFromLeftTop) {
	        var pt = this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	        pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);
	
	        pt.x += this.transform_.width / 2;
	        pt.y += this.transform_.height / 2;
	
	        return pt;
	      }
	
	      return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.transform_.width;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return this.transform_.height;
	    }
	  }, {
	    key: 'getZoom',
	    value: function getZoom() {
	      return this.transform_.zoom;
	    }
	  }, {
	    key: 'getCenter',
	    value: function getCenter() {
	      var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });
	
	      return ptRes;
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(margins, roundFactor) {
	      var bndT = margins && margins[0] || 0;
	      var bndR = margins && margins[1] || 0;
	      var bndB = margins && margins[2] || 0;
	      var bndL = margins && margins[3] || 0;
	
	      if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
	        var topLeftCorner = this.unproject({
	          x: bndL - this.getWidth() / 2,
	          y: bndT - this.getHeight() / 2
	        });
	        var bottomRightCorner = this.unproject({
	          x: this.getWidth() / 2 - bndR,
	          y: this.getHeight() / 2 - bndB
	        });
	
	        var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
	        bottomRightCorner.lat, bottomRightCorner.lng, // SE
	        bottomRightCorner.lat, topLeftCorner.lng, // SW
	        topLeftCorner.lat, bottomRightCorner.lng];
	
	        if (roundFactor) {
	          res = res.map(function (r) {
	            return Math.round(r * roundFactor) / roundFactor;
	          });
	        }
	        return res;
	      }
	
	      return [0, 0, 0, 0];
	    }
	  }]);
	
	  return Geo;
	}();
	
	exports.default = Geo;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isNumber;
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	var objectToString = Object.prototype.toString;
	
	function isNumber(value) {
	  var numberTag = '[object Number]';
	  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
	}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isPlainObject;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
	}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable class-methods-use-this */
	
	
	var _pointGeometry = __webpack_require__(356);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _lat_lng = __webpack_require__(184);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _wrap = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
	var Transform = function () {
	  function Transform(tileSize, minZoom, maxZoom) {
	    _classCallCheck(this, Transform);
	
	    this.tileSize = tileSize || 512; // constant
	
	    this._minZoom = minZoom || 0;
	    this._maxZoom = maxZoom || 52;
	
	    this.latRange = [-85.05113, 85.05113];
	
	    this.width = 0;
	    this.height = 0;
	    this.zoom = 0;
	    this.center = new _lat_lng2.default(0, 0);
	    this.angle = 0;
	  }
	
	  _createClass(Transform, [{
	    key: 'zoomScale',
	    value: function zoomScale(zoom) {
	      return Math.pow(2, zoom);
	    }
	  }, {
	    key: 'scaleZoom',
	    value: function scaleZoom(scale) {
	      return Math.log(scale) / Math.LN2;
	    }
	  }, {
	    key: 'project',
	    value: function project(latlng, worldSize) {
	      return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
	    }
	  }, {
	    key: 'unproject',
	    value: function unproject(point, worldSize) {
	      return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
	    }
	  }, {
	    key: 'lngX',
	
	
	    // lat/lon <-> absolute pixel coords convertion
	    value: function lngX(lon, worldSize) {
	      return (180 + lon) * (worldSize || this.worldSize) / 360;
	    }
	
	    // latitude to absolute y coord
	
	  }, {
	    key: 'latY',
	    value: function latY(lat, worldSize) {
	      var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
	      return (180 - y) * (worldSize || this.worldSize) / 360;
	    }
	  }, {
	    key: 'xLng',
	    value: function xLng(x, worldSize) {
	      return x * 360 / (worldSize || this.worldSize) - 180;
	    }
	  }, {
	    key: 'yLat',
	    value: function yLat(y, worldSize) {
	      var y2 = 180 - y * 360 / (worldSize || this.worldSize);
	      return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
	    }
	  }, {
	    key: 'locationPoint',
	    value: function locationPoint(latlng) {
	      var p = this.project(latlng);
	      return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
	    }
	  }, {
	    key: 'pointLocation',
	    value: function pointLocation(p) {
	      var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
	      return this.unproject(this.point.sub(p2));
	    }
	  }, {
	    key: 'minZoom',
	    get: function get() {
	      return this._minZoom;
	    },
	    set: function set(zoom) {
	      this._minZoom = zoom;
	      this.zoom = Math.max(this.zoom, zoom);
	    }
	  }, {
	    key: 'maxZoom',
	    get: function get() {
	      return this._maxZoom;
	    },
	    set: function set(zoom) {
	      this._maxZoom = zoom;
	      this.zoom = Math.min(this.zoom, zoom);
	    }
	  }, {
	    key: 'worldSize',
	    get: function get() {
	      return this.tileSize * this.scale;
	    }
	  }, {
	    key: 'centerPoint',
	    get: function get() {
	      return new _pointGeometry2.default(0, 0); // this.size._div(2);
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return new _pointGeometry2.default(this.width, this.height);
	    }
	  }, {
	    key: 'bearing',
	    get: function get() {
	      return -this.angle / Math.PI * 180;
	    },
	    set: function set(bearing) {
	      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
	    }
	  }, {
	    key: 'zoom',
	    get: function get() {
	      return this._zoom;
	    },
	    set: function set(zoom) {
	      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
	      this._zoom = zoomV;
	      this.scale = this.zoomScale(zoomV);
	      this.tileZoom = Math.floor(zoomV);
	      this.zoomFraction = zoomV - this.tileZoom;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this.lngX(this.center.lng);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this.latY(this.center.lat);
	    }
	  }, {
	    key: 'point',
	    get: function get() {
	      return new _pointGeometry2.default(this.x, this.y);
	    }
	  }]);
	
	  return Transform;
	}();
	
	exports.default = Transform;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = googleMapLoader;
	/* eslint-disable no-console */
	var $script_ = null;
	
	var loadPromise_ = void 0;
	
	var resolveCustomPromise_ = void 0;
	var _customPromise = new Promise(function (resolve) {
	  resolveCustomPromise_ = resolve;
	});
	
	// TODO add libraries language and other map options
	function googleMapLoader(bootstrapURLKeys) {
	  if (!$script_) {
	    $script_ = __webpack_require__(812); // eslint-disable-line
	  }
	
	  // call from outside google-map-react
	  // will be as soon as loadPromise_ resolved
	  if (!bootstrapURLKeys) {
	    return _customPromise;
	  }
	
	  if (loadPromise_) {
	    return loadPromise_;
	  }
	
	  loadPromise_ = new Promise(function (resolve, reject) {
	    if (typeof window === 'undefined') {
	      reject(new Error('google map cannot be loaded outside browser env'));
	      return;
	    }
	
	    if (window.google && window.google.maps) {
	      resolve(window.google.maps);
	      return;
	    }
	
	    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
	      reject(new Error('google map initialization error'));
	    }
	
	    window._$_google_map_initialize_$_ = function () {
	      delete window._$_google_map_initialize_$_;
	      resolve(window.google.maps);
	    };
	
	    if (false) {
	      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
	        console.error('"callback" key in bootstrapURLKeys is not allowed, ' + // eslint-disable-line
	        'use onGoogleApiLoaded property instead');
	        throw new Error('"callback" key in bootstrapURLKeys is not allowed, ' + 'use onGoogleApiLoaded property instead');
	      }
	    }
	
	    var queryString = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
	      return r + '&' + key + '=' + bootstrapURLKeys[key];
	    }, '');
	
	    $script_('https://maps.googleapis.com/maps/api/js?callback=_$_google_map_initialize_$_' + queryString, function () {
	      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
	    });
	  });
	
	  resolveCustomPromise_(loadPromise_);
	
	  return loadPromise_;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var log2 = Math.log2 ? Math.log2 : function (x) {
	  return Math.log(x) / Math.LN2;
	};
	
	exports.default = log2;

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pick;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js
	
	function pick(obj, fn) {
	  return Object.keys(obj).reduce(function (result, key) {
	    if (fn(obj[key])) {
	      result[key] = obj[key]; // eslint-disable-line
	    }
	    return result;
	  }, {});
	}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = raf;
	function raf(callback) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(callback);
	  }
	
	  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
	
	  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
	}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames3 = __webpack_require__(6);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Label = __webpack_require__(496);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Headline = __webpack_require__(68);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Paragraph = __webpack_require__(85);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Anchor = __webpack_require__(66);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Video = __webpack_require__(504);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _CirclePlay = __webpack_require__(194);
	
	var _CirclePlay2 = _interopRequireDefault(_CirclePlay);
	
	var _Responsive = __webpack_require__(88);
	
	var _Responsive2 = _interopRequireDefault(_Responsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CARD;
	
	var LABEL_SIZES = {
	  xlarge: 'medium',
	  large: 'medium',
	  medium: 'medium',
	  small: 'medium',
	  xsmall: 'small'
	};
	
	var HEADLINE_SIZES = {
	  xlarge: 'medium',
	  large: 'medium'
	};
	
	var HEADING_TAGS = {
	  medium: 'h1',
	  small: 'h2',
	  xsmall: 'h3'
	};
	
	var PARAGRAPH_SIZES = {
	  xlarge: 'xlarge',
	  large: 'xlarge',
	  medium: 'large',
	  small: 'large',
	  xsmall: 'medium'
	};
	
	var PARAGRAPH_MARGINS = {
	  xlarge: 'large',
	  large: 'large',
	  medium: 'medium',
	  small: 'medium',
	  xsmall: 'small'
	};
	
	var Card = function (_Component) {
	  _inherits(Card, _Component);
	
	  function Card(props) {
	    _classCallCheck(this, Card);
	
	    var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onResponsive = _this._onResponsive.bind(_this);
	    _this.state = { activeVideo: false, small: false };
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._responsive = _Responsive2.default.start(this._onResponsive);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._responsive) {
	        this._responsive.stop();
	      }
	    }
	  }, {
	    key: '_onResponsive',
	    value: function _onResponsive(small) {
	      this.setState({ small: !!small });
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      var video = this.props.video;
	
	      if (video) {
	        event.preventDefault();
	        this.setState({ activeVideo: !this.state.activeVideo });
	      }
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel() {
	      var _props = this.props,
	          label = _props.label,
	          textSize = _props.textSize;
	
	      var result = label;
	      if (typeof label === 'string') {
	        result = _react2.default.createElement(
	          _Label2.default,
	          { size: LABEL_SIZES[textSize], margin: 'none', uppercase: true },
	          label
	        );
	      }
	      return result;
	    }
	  }, {
	    key: '_renderHeading',
	    value: function _renderHeading() {
	      var _props2 = this.props,
	          heading = _props2.heading,
	          headingStrong = _props2.headingStrong,
	          textSize = _props2.textSize;
	
	      var result = heading;
	      if (typeof heading === 'string') {
	        if (HEADLINE_SIZES[textSize]) {
	          result = _react2.default.createElement(
	            _Headline2.default,
	            { size: HEADLINE_SIZES[textSize], strong: headingStrong },
	            heading
	          );
	        } else {
	          result = _react2.default.createElement(
	            _Heading2.default,
	            { tag: HEADING_TAGS[textSize], strong: headingStrong },
	            heading
	          );
	        }
	      }
	      return result;
	    }
	  }, {
	    key: '_renderLink',
	    value: function _renderLink() {
	      var link = this.props.link;
	
	      return link;
	    }
	  }, {
	    key: '_renderThumbnail',
	    value: function _renderThumbnail() {
	      var _props3 = this.props,
	          direction = _props3.direction,
	          thumbnail = _props3.thumbnail,
	          video = _props3.video;
	      var small = this.state.small;
	
	      var result = thumbnail;
	      if (typeof thumbnail === 'string') {
	        var size = small ? 'large' : 'xlarge';
	        var videoIcon = video ? _react2.default.createElement(_Anchor2.default, { icon: _react2.default.createElement(_CirclePlay2.default, { responsive: false,
	            colorIndex: 'brand', size: size }) }) : undefined;
	
	        var flex = 'row' === direction ? 'grow' : undefined;
	
	        result = _react2.default.createElement(
	          _Box2.default,
	          { className: CLASS_ROOT + '__thumbnail', flex: flex,
	            backgroundImage: 'url(' + thumbnail + ')', basis: 'small',
	            justify: 'center', align: 'center' },
	          videoIcon
	        );
	      }
	      return result;
	    }
	  }, {
	    key: '_renderVideoLayer',
	    value: function _renderVideoLayer() {
	      var video = this.props.video;
	      var activeVideo = this.state.activeVideo;
	
	      var result = void 0;
	
	      if (video && activeVideo) {
	        var layerContent = void 0;
	        if (video.source) {
	          layerContent = _react2.default.createElement(
	            _Video2.default,
	            null,
	            _react2.default.createElement('source', { src: video.source, type: 'video/' + video.type })
	          );
	        } else {
	          layerContent = video;
	        }
	
	        result = _react2.default.createElement(
	          _Layer2.default,
	          { onClose: this._onClick, closer: true, flush: true },
	          layerContent
	        );
	      }
	
	      return result;
	    }
	  }, {
	    key: '_renderDescription',
	    value: function _renderDescription() {
	      var _props4 = this.props,
	          description = _props4.description,
	          textSize = _props4.textSize;
	
	      var result = description;
	      if (typeof description === 'string') {
	        result = _react2.default.createElement(
	          _Paragraph2.default,
	          {
	            margin: PARAGRAPH_MARGINS[textSize],
	            size: PARAGRAPH_SIZES[textSize]
	          },
	          description
	        );
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames2;
	
	      var _props5 = this.props,
	          a11yTitle = _props5.a11yTitle,
	          children = _props5.children,
	          className = _props5.className,
	          contentPad = _props5.contentPad,
	          onClick = _props5.onClick,
	          reverse = _props5.reverse,
	          truncate = _props5.truncate;
	
	      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	      var restProps = _Props2.default.omit(this.props, Object.keys(Card.propTypes));
	
	      var classes = (0, _classnames4.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--selectable', onClick), className);
	
	      var thumbnail = this._renderThumbnail();
	      var label = this._renderLabel();
	      var heading = this._renderHeading();
	      var description = this._renderDescription();
	      var link = this._renderLink();
	      var videoLayer = this._renderVideoLayer();
	
	      var contentClasses = (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '__content', true), _defineProperty(_classnames2, CLASS_ROOT + '__content--truncate', truncate), _classnames2));
	
	      var basis = 'row' === this.props.direction ? '2/3' : undefined;
	      var text = _react2.default.createElement(
	        _Box2.default,
	        { className: contentClasses, pad: contentPad,
	          basis: basis },
	        label,
	        heading,
	        description,
	        children,
	        link
	      );
	
	      var cardJustify = void 0;
	      if (reverse) {
	        // align thumbnail to bottom/right of card for bottom cardPlacement
	        cardJustify = 'between';
	      }
	
	      if (!this.props.size) {
	        if (this.props.direction === 'row') {
	          boxProps.size = { width: 'xlarge' };
	        } else {
	          boxProps.size = { width: 'medium' };
	        }
	      }
	
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, boxProps, restProps, { className: classes, wrap: true,
	          justify: cardJustify, onClick: onClick, a11yTitle: a11yTitle }),
	        thumbnail,
	        text,
	        videoLayer
	      );
	    }
	  }]);
	
	  return Card;
	}(_react.Component);
	
	Card.displayName = 'Card';
	exports.default = Card;
	
	
	Card.propTypes = _extends({
	  contentPad: _Box2.default.propTypes.pad,
	  description: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  heading: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  headingStrong: _propTypes2.default.bool,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  link: _propTypes2.default.element,
	  textSize: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
	  thumbnail: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  truncate: _propTypes2.default.bool,
	  video: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    source: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.string
	  }), _propTypes2.default.element])
	}, _Box2.default.propTypes);
	
	Card.defaultProps = {
	  a11yTitle: 'Card',
	  contentPad: 'medium',
	  headingStrong: true,
	  textSize: 'small'
	};
	module.exports = exports['default'];

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames4 = __webpack_require__(6);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Tiles = __webpack_require__(191);
	
	var _Tiles2 = _interopRequireDefault(_Tiles);
	
	var _Tile = __webpack_require__(86);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Previous = __webpack_require__(516);
	
	var _Previous2 = _interopRequireDefault(_Previous);
	
	var _Next = __webpack_require__(513);
	
	var _Next2 = _interopRequireDefault(_Next);
	
	var _DOM = __webpack_require__(47);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Announcer = __webpack_require__(35);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CAROUSEL;
	
	var Carousel = function (_Component) {
	  _inherits(Carousel, _Component);
	
	  function Carousel(props, context) {
	    _classCallCheck(this, Carousel);
	
	    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props, context));
	
	    _this._onSelect = _this._onSelect.bind(_this);
	    _this._stopAutoplay = _this._stopAutoplay.bind(_this);
	    _this._startAutoplay = _this._startAutoplay.bind(_this);
	    _this._onResize = _this._onResize.bind(_this);
	    _this._slidePrev = _this._slidePrev.bind(_this);
	    _this._slideNext = _this._slideNext.bind(_this);
	    _this._handleScroll = _this._handleScroll.bind(_this);
	    _this._announce = _this._announce.bind(_this);
	
	    _this.state = {
	      activeIndex: props.activeIndex || 0,
	      animate: typeof props.activeIndex == 'undefined',
	      hideControls: !props.persistentNav,
	      sequence: 1,
	      width: 0,
	      slide: false
	    };
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.carouselRef) {
	        this.setState({
	          width: this.carouselRef.offsetWidth
	        });
	
	        window.addEventListener('resize', this._onResize);
	
	        var _Hammer = __webpack_require__(545);
	        this.hammer = new _Hammer(this.carouselRef);
	        this._updateHammer();
	
	        this._handleScroll();
	        var scrollParents = (0, _DOM.findScrollParents)(this.carouselRef);
	        scrollParents.forEach(function (scrollParent) {
	          scrollParent.addEventListener('scroll', _this2._handleScroll);
	        }, this);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.activeIndex || 0 === nextProps.activeIndex) && this.state.activeIndex !== nextProps.activeIndex) {
	        this.setState({ activeIndex: nextProps.activeIndex, animate: true }, this._announce);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var autoplay = this.props.autoplay;
	
	      this._updateHammer();
	      if (autoplay) {
	        this._startAutoplay();
	      } else if (!autoplay) {
	        this._stopAutoplay();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      clearInterval(this._slideAnimation);
	
	      window.removeEventListener('resize', this._onResize);
	
	      var scrollParents = (0, _DOM.findScrollParents)(this.carouselRef);
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.removeEventListener('scroll', _this3._handleScroll);
	      }, this);
	
	      this._unmountHammer();
	    }
	  }, {
	    key: '_unmountHammer',
	    value: function _unmountHammer() {
	      if (this.hammer) {
	        this.hammer.stop();
	        this.hammer.destroy();
	      }
	      this.hammer = undefined;
	    }
	  }, {
	    key: '_updateHammer',
	    value: function _updateHammer() {
	      var _this4 = this;
	
	      if (this.hammer) {
	        this.hammer.get('swipe').set({
	          direction: Hammer.DIRECTION_HORIZONTAL
	        });
	
	        this.hammer.off('panend');
	        this.hammer.on('panend', function (event) {
	          if (event.direction === 4) {
	            _this4._slidePrev();
	          } else if (event.direction === 2) {
	            _this4._slideNext();
	          }
	        });
	      }
	    }
	  }, {
	    key: '_handleScroll',
	    value: function _handleScroll() {
	      var autoplay = this.props.autoplay;
	      var slide = this.state.slide;
	
	      var viewportHeight = document.documentElement.clientHeight;
	      var carouselTopPosition = this.carouselRef.getBoundingClientRect().top;
	      var carouselHeight = this.carouselRef.offsetHeight;
	      var startScroll = viewportHeight - carouselHeight / 2;
	
	      if (autoplay && carouselTopPosition <= startScroll && carouselTopPosition >= -carouselHeight / 2) {
	        if (slide === false) {
	          this._setSlideInterval();
	          this.setState({
	            slide: true
	          });
	        }
	      } else {
	        clearInterval(this._slideAnimation);
	        this.setState({
	          slide: false
	        });
	      }
	    }
	  }, {
	    key: '_announce',
	    value: function _announce() {
	      var intl = this.context.intl;
	
	      var slideNumber = _Intl2.default.getMessage(intl, 'Slide Number', {
	        slideNumber: this.state.activeIndex + 1
	      });
	      var activatedMessage = _Intl2.default.getMessage(intl, 'Activated');
	      (0, _Announcer.announce)(slideNumber + ' ' + activatedMessage, 'polite');
	    }
	  }, {
	    key: '_setSlideInterval',
	    value: function _setSlideInterval() {
	      var autoplaySpeed = this.props.autoplaySpeed;
	
	      clearInterval(this._slideAnimation);
	      this._slideAnimation = setInterval(function () {
	        var _props = this.props,
	            children = _props.children,
	            infinite = _props.infinite;
	        var activeIndex = this.state.activeIndex;
	
	
	        var numSlides = children.length;
	        var index = (activeIndex + 1) % numSlides;
	
	        if (!this.props.hasOwnProperty('activeIndex')) {
	          this.setState({
	            activeIndex: index
	          }, this._announce);
	        }
	        if (!infinite && activeIndex === numSlides - 1) {
	          clearInterval(this._slideAnimation);
	        }
	
	        if (this.props.onActive) {
	          this.props.onActive(index);
	        }
	      }.bind(this), autoplaySpeed);
	    }
	  }, {
	    key: '_onSelect',
	    value: function _onSelect(index) {
	      if (!this.props.hasOwnProperty('activeIndex') && index !== this.state.activeIndex) {
	        this.setState({
	          activeIndex: index
	        }, this._announce);
	      }
	
	      if (this.props.onActive) {
	        this.props.onActive(index);
	      }
	    }
	  }, {
	    key: '_stopAutoplay',
	    value: function _stopAutoplay() {
	      var persistentNav = this.props.persistentNav;
	
	      if (this._slideAnimation) {
	        clearInterval(this._slideAnimation);
	      }
	
	      if (!persistentNav) {
	        this.setState({
	          hideControls: false
	        });
	      }
	    }
	  }, {
	    key: '_startAutoplay',
	    value: function _startAutoplay() {
	      var activeIndex = this.state.activeIndex;
	      var _props2 = this.props,
	          autoplay = _props2.autoplay,
	          children = _props2.children,
	          infinite = _props2.infinite,
	          persistentNav = _props2.persistentNav;
	
	      if (autoplay && (infinite || activeIndex !== children.length - 1) &&
	      // making sure to only start autoplay if the focus is not inside
	      // the carousel
	      !this.carouselRef.contains(document.activeElement)) {
	        this._setSlideInterval();
	      }
	
	      if (!persistentNav) {
	        this.setState({
	          hideControls: true
	        });
	      }
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      this.setState({
	        width: this.carouselRef.offsetWidth
	      });
	    }
	  }, {
	    key: '_slidePrev',
	    value: function _slidePrev() {
	      var children = this.props.children;
	      var activeIndex = this.state.activeIndex;
	
	      var numSlides = children.length;
	      var index = !this.props.infinite && activeIndex === 0 ? activeIndex : (activeIndex + numSlides - 1) % numSlides;
	
	      if (!this.props.hasOwnProperty('activeIndex')) {
	        this.setState({
	          activeIndex: index
	        }, this._announce);
	      }
	
	      if (this.props.onActive) {
	        this.props.onActive(index);
	      }
	    }
	  }, {
	    key: '_slideNext',
	    value: function _slideNext() {
	      var children = this.props.children;
	      var activeIndex = this.state.activeIndex;
	
	      var numSlides = children.length;
	      var index = !this.props.infinite && activeIndex === children.length - 1 ? activeIndex : (activeIndex + 1) % numSlides;
	
	      if (!this.props.hasOwnProperty('activeIndex')) {
	        this.setState({
	          activeIndex: index
	        }, this._announce);
	      }
	
	      if (this.props.onActive) {
	        this.props.onActive(index);
	      }
	    }
	  }, {
	    key: '_renderPrevButton',
	    value: function _renderPrevButton() {
	      var infinite = this.props.infinite;
	      var activeIndex = this.state.activeIndex;
	      var intl = this.context.intl;
	
	      var prevButton = void 0;
	      if (infinite || activeIndex !== 0) {
	        var prevMessage = _Intl2.default.getMessage(intl, 'Previous Slide');
	        prevButton = _react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Previous2.default, { size: 'large' }),
	          a11yTitle: prevMessage,
	          className: CLASS_ROOT + '__arrow ' + CLASS_ROOT + '__arrow--prev',
	          onClick: this._slidePrev });
	      }
	
	      return prevButton;
	    }
	  }, {
	    key: '_renderNextButton',
	    value: function _renderNextButton() {
	      var _props3 = this.props,
	          children = _props3.children,
	          infinite = _props3.infinite;
	      var activeIndex = this.state.activeIndex;
	      var intl = this.context.intl;
	
	      var nextButton = void 0;
	      if (infinite || activeIndex !== children.length - 1) {
	        var nextMessage = _Intl2.default.getMessage(intl, 'Next Slide');
	        nextButton = _react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Next2.default, { size: 'large' }),
	          a11yTitle: nextMessage,
	          className: CLASS_ROOT + '__arrow ' + CLASS_ROOT + '__arrow--next',
	          onClick: this._slideNext });
	      }
	
	      return nextButton;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props4 = this.props,
	          a11yTitle = _props4.a11yTitle,
	          children = _props4.children,
	          className = _props4.className,
	          props = _objectWithoutProperties(_props4, ['a11yTitle', 'children', 'className']);
	
	      delete props.activeIndex;
	      delete props.onActive;
	      var restProps = _Props2.default.omit(_extends({}, props), Object.keys(Carousel.propTypes));
	      var _state = this.state,
	          activeIndex = _state.activeIndex,
	          hideControls = _state.hideControls,
	          width = _state.width;
	      var intl = this.context.intl;
	
	      var classes = (0, _classnames5.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--hide-controls', hideControls), className);
	
	      var trackWidth = width * children.length;
	      var trackOffset = width * activeIndex;
	
	      var tiles = _react2.default.Children.map(children, function (child, index) {
	        var ariaHidden = activeIndex !== index ? true : false;
	        return _react2.default.createElement(
	          _Tile2.default,
	          { className: CLASS_ROOT + '__item', 'aria-hidden': ariaHidden },
	          child
	        );
	      });
	
	      var controls = _react2.default.Children.map(children, function (child, index) {
	        var active = index === activeIndex;
	        var controlClasses = (0, _classnames5.default)(CLASS_ROOT + '__control', _defineProperty({}, CLASS_ROOT + '__control--active', active));
	        var activateMessage = _Intl2.default.getMessage(intl, 'Activate');
	        var slideNumberMessage = _Intl2.default.getMessage(intl, 'Slide Number', {
	          slideNumber: index + 1
	        });
	
	        var currentlyActiveMessage = '';
	        if (active) {
	          currentlyActiveMessage = '(' + _Intl2.default.getMessage(intl, 'Currently Active') + ')';
	        }
	        return _react2.default.createElement(
	          _Button2.default,
	          { plain: true, onClick: _this5._onSelect.bind(_this5, index),
	            a11yTitle: activateMessage + ' ' + slideNumberMessage + ' ' + currentlyActiveMessage },
	          _react2.default.createElement(
	            'svg',
	            { className: controlClasses, viewBox: '0 0 24 24', version: '1.1' },
	            _react2.default.createElement('circle', { cx: 12, cy: 12, r: 6 })
	          )
	        );
	      }, this);
	
	      var carouselMessage = a11yTitle || _Intl2.default.getMessage(intl, 'Carousel');
	      var trackClasses = (0, _classnames5.default)(CLASS_ROOT + '__track', _defineProperty({}, CLASS_ROOT + '__track--animate', this.state.animate));
	      return _react2.default.createElement(
	        'div',
	        _extends({ ref: function ref(_ref) {
	            return _this5.carouselRef = _ref;
	          } }, restProps, {
	          className: classes, role: 'group', 'aria-label': carouselMessage,
	          onFocus: this._stopAutoplay, onBlur: this._startAutoplay,
	          onMouseOver: this._stopAutoplay, onMouseOut: this._startAutoplay }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: trackClasses,
	            style: {
	              width: trackWidth && trackWidth > 0 ? trackWidth : '',
	              marginLeft: -trackOffset,
	              marginRight: -(trackWidth - trackOffset - width)
	            } },
	          _react2.default.createElement(
	            _Tiles2.default,
	            { fill: true, responsive: false, wrap: false, direction: 'row' },
	            tiles
	          )
	        ),
	        this._renderPrevButton(),
	        this._renderNextButton(),
	        _react2.default.createElement(
	          _Box2.default,
	          { className: CLASS_ROOT + "__controls", direction: 'row',
	            justify: 'center', responsive: false },
	          controls
	        )
	      );
	    }
	  }]);
	
	  return Carousel;
	}(_react.Component);
	
	Carousel.displayName = 'Carousel';
	exports.default = Carousel;
	
	
	Carousel.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Carousel.defaultProps = {
	  autoplay: true,
	  autoplaySpeed: 5000,
	  infinite: true,
	  persistentNav: true
	};
	
	Carousel.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  activeIndex: _propTypes2.default.number,
	  autoplay: _propTypes2.default.bool,
	  autoplaySpeed: _propTypes2.default.number,
	  infinite: _propTypes2.default.bool,
	  onActive: _propTypes2.default.func,
	  persistentNav: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames3 = __webpack_require__(6);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Header = __webpack_require__(34);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Title = __webpack_require__(55);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LinkPrevious = __webpack_require__(125);
	
	var _LinkPrevious2 = _interopRequireDefault(_LinkPrevious);
	
	var _LinkNext = __webpack_require__(103);
	
	var _LinkNext2 = _interopRequireDefault(_LinkNext);
	
	var _Add = __webpack_require__(506);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _Subtract = __webpack_require__(524);
	
	var _Subtract2 = _interopRequireDefault(_Subtract);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Announcer = __webpack_require__(35);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Locale = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.DATE_TIME_DROP;
	var locale = (0, _Locale.getCurrentLocale)();
	_moment2.default.locale(locale);
	var WEEK_DAYS = _moment2.default.weekdaysShort(true) || ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	// const DATE_REGEXP = new RegExp('[DMY]');
	var DAY_REGEXP = new RegExp('[D]');
	var MONTHYEAR_REGEXP = new RegExp('[MY]');
	var TIME_REGEXP = new RegExp('[hHmsa]');
	var UNITS = {
	  M: 'month',
	  D: 'day',
	  Y: 'year',
	  h: 'hour',
	  H: 'hour',
	  m: 'minute',
	  s: 'second',
	  a: 'ampm',
	  A: 'ampm'
	};
	
	var DateTimeDrop = function (_Component) {
	  _inherits(DateTimeDrop, _Component);
	
	  function DateTimeDrop(props, context) {
	    _classCallCheck(this, DateTimeDrop);
	
	    var _this = _possibleConstructorReturn(this, (DateTimeDrop.__proto__ || Object.getPrototypeOf(DateTimeDrop)).call(this, props, context));
	
	    _this._announceActiveCell = _this._announceActiveCell.bind(_this);
	    _this._buildDateRows = _this._buildDateRows.bind(_this);
	    _this._onDay = _this._onDay.bind(_this);
	    _this._onToday = _this._onToday.bind(_this);
	    _this._onPrevious = _this._onPrevious.bind(_this);
	    _this._onPreviousDay = _this._onPreviousDay.bind(_this);
	    _this._onPreviousRow = _this._onPreviousRow.bind(_this);
	    _this._onNext = _this._onNext.bind(_this);
	    _this._onNextDay = _this._onNextDay.bind(_this);
	    _this._onNextRow = _this._onNextRow.bind(_this);
	    _this._onSelectDay = _this._onSelectDay.bind(_this);
	
	    _this.state = _this._stateFromProps(props);
	    _this.state.mouseActive = false;
	
	    _this._buildDateRows(_this.state);
	    return _this;
	  }
	
	  _createClass(DateTimeDrop, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._keyboardHandlers = {
	        up: this._onPreviousRow,
	        left: this._onPreviousDay,
	        down: this._onNextRow,
	        right: this._onNextDay,
	        enter: this._onSelectDay
	      };
	      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var state = this._stateFromProps(nextProps);
	      this._buildDateRows(state);
	      this.setState(state);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	    }
	  }, {
	    key: '_buildDateRows',
	    value: function _buildDateRows(state) {
	      var timeOfDay = state.timeOfDay,
	          value = state.value;
	
	      var start = (0, _moment2.default)(value).startOf('month').startOf('week').add(timeOfDay);
	      // Always display 6 weeks in the calendar, to keep the date/time
	      // change controls from jumping around.
	      var end = (0, _moment2.default)(start).add(41, 'days').add(timeOfDay);
	      var date = (0, _moment2.default)(start);
	      var dateRows = [];
	      var activeCell = void 0;
	
	      var rowIndex = 0;
	      while (date.valueOf() <= end.valueOf()) {
	        var days = [];
	        for (var i = 0; i < 7; i += 1) {
	          if (date.isSame(value, 'day')) {
	            activeCell = [rowIndex, i];
	          }
	          days.push((0, _moment2.default)(date));
	          date = date.add(1, 'days');
	        }
	        dateRows.push(days);
	        rowIndex++;
	      }
	
	      state.dateRows = dateRows;
	      state.activeCell = activeCell;
	      state.originalActiveCell = activeCell.slice();
	    }
	  }, {
	    key: '_stateFromProps',
	    value: function _stateFromProps(props) {
	      var format = props.format;
	
	      var result = {};
	      var value = (0, _moment2.default)(props.value);
	      if (value.isValid()) {
	        result.value = value;
	        result.timeOfDay = {
	          hours: value.hours(),
	          minutes: value.minutes(),
	          seconds: value.seconds()
	        };
	      } else {
	        result.value = (0, _moment2.default)();
	      }
	      // figure out which scope the step should apply to
	      if (format.indexOf('s') !== -1) {
	        result.stepScope = 'second';
	      } else if (format.indexOf('m') !== -1) {
	        result.stepScope = 'minute';
	      } else if (format.indexOf('h') !== -1) {
	        result.stepScope = 'hour';
	      }
	      return result;
	    }
	  }, {
	    key: '_announceActiveCell',
	    value: function _announceActiveCell() {
	      var _state = this.state,
	          activeCell = _state.activeCell,
	          dateRows = _state.dateRows;
	      var intl = this.context.intl;
	
	      var weekDay = WEEK_DAYS[activeCell[1]];
	      var day = dateRows[activeCell[0]][activeCell[1]].date();
	      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
	      (0, _Announcer.announce)(weekDay + ', ' + day + ' (' + enterSelectMessage + ')');
	    }
	  }, {
	    key: '_onPreviousRow',
	    value: function _onPreviousRow(event) {
	      event.preventDefault();
	      var activeCell = this.state.activeCell;
	
	      if (this.tableRef.contains(document.activeElement)) {
	        if (activeCell[0] - 1 >= 0) {
	          activeCell[0] = activeCell[0] - 1;
	          this.setState({ activeCell: activeCell }, this._announceActiveCell);
	        }
	      }
	    }
	  }, {
	    key: '_onPreviousDay',
	    value: function _onPreviousDay(event) {
	      event.preventDefault();
	      var activeCell = this.state.activeCell;
	
	      if (this.tableRef.contains(document.activeElement)) {
	        if (activeCell[1] - 1 >= 0) {
	          activeCell[1] = activeCell[1] - 1;
	          this.setState({ activeCell: activeCell }, this._announceActiveCell);
	        }
	      }
	    }
	  }, {
	    key: '_onNextRow',
	    value: function _onNextRow(event) {
	      event.preventDefault();
	      var _state2 = this.state,
	          dateRows = _state2.dateRows,
	          activeCell = _state2.activeCell;
	
	      if (this.tableRef.contains(document.activeElement)) {
	        if (activeCell[0] + 1 <= dateRows.length - 1) {
	          activeCell[0] = activeCell[0] + 1;
	          this.setState({ activeCell: activeCell }, this._announceActiveCell);
	        }
	      }
	    }
	  }, {
	    key: '_onNextDay',
	    value: function _onNextDay(event) {
	      event.preventDefault();
	      var activeCell = this.state.activeCell;
	
	      if (this.tableRef.contains(document.activeElement)) {
	        if (activeCell[1] + 1 <= WEEK_DAYS.length - 1) {
	          activeCell[1] = activeCell[1] + 1;
	          this.setState({ activeCell: activeCell }, this._announceActiveCell);
	        }
	      }
	    }
	  }, {
	    key: '_onSelectDay',
	    value: function _onSelectDay() {
	      var _state3 = this.state,
	          activeCell = _state3.activeCell,
	          dateRows = _state3.dateRows;
	
	      if (this.tableRef.contains(document.activeElement)) {
	        var date = dateRows[activeCell[0]][activeCell[1]];
	        this._onDay(date);
	      }
	    }
	  }, {
	    key: '_onDay',
	    value: function _onDay(date, event) {
	      if (event) {
	        event.stopPropagation();
	        // using native event to avoid document click in DateTime to be invoked
	        event.nativeEvent.stopImmediatePropagation();
	      }
	      var _props = this.props,
	          format = _props.format,
	          onChange = _props.onChange;
	      var intl = this.context.intl;
	
	      this.setState({
	        value: (0, _moment2.default)(date)
	      }, function () {
	        var dateFormatted = date.format(format);
	        onChange(dateFormatted, true);
	        var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
	        (0, _Announcer.announce)(dateFormatted + ' ' + selectedMessage);
	      });
	    }
	  }, {
	    key: '_onToday',
	    value: function _onToday() {
	      var _props2 = this.props,
	          format = _props2.format,
	          onChange = _props2.onChange;
	      var timeOfDay = this.state.timeOfDay;
	      var intl = this.context.intl;
	
	      var today = (0, _moment2.default)().startOf('day').add(timeOfDay);
	      this.setState({ value: today }, function () {
	        var dateFormatted = today.format(format);
	        onChange(dateFormatted, true);
	        var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
	        (0, _Announcer.announce)(dateFormatted + ' ' + selectedMessage);
	      });
	    }
	  }, {
	    key: '_onPrevious',
	    value: function _onPrevious(scope) {
	      var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var _props3 = this.props,
	          format = _props3.format,
	          step = _props3.step,
	          onChange = _props3.onChange;
	      var _state4 = this.state,
	          stepScope = _state4.stepScope,
	          timeOfDay = _state4.timeOfDay,
	          value = _state4.value;
	
	      var delta = scope === stepScope ? step : 1;
	      if (scope === 'ampm') {
	        delta = 12;
	        scope = 'hours';
	      }
	      var newValue = (0, _moment2.default)(value).subtract(delta, scope);
	      this.setState({ value: newValue }, function () {
	        if (scope === 'month') {
	          (0, _Announcer.announce)(newValue.format('MMMM YYYY'));
	        } else {
	          (0, _Announcer.announce)(newValue.format(format));
	        }
	      });
	      if (notify) {
	        onChange(newValue.format(format));
	      } else {
	        // rebuild grid
	        var state = { timeOfDay: timeOfDay, value: newValue };
	        this._buildDateRows(state);
	        this.setState(state);
	      }
	    }
	  }, {
	    key: '_onNext',
	    value: function _onNext(scope) {
	      var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var _props4 = this.props,
	          format = _props4.format,
	          step = _props4.step,
	          onChange = _props4.onChange;
	      var _state5 = this.state,
	          stepScope = _state5.stepScope,
	          timeOfDay = _state5.timeOfDay,
	          value = _state5.value;
	
	      var delta = scope === stepScope ? step : 1;
	      if (scope === 'ampm') {
	        delta = 12;
	        scope = 'hours';
	      }
	      var newValue = (0, _moment2.default)(value).add(delta, scope);
	      this.setState({ value: newValue }, function () {
	        if (scope === 'month') {
	          (0, _Announcer.announce)(newValue.format('MMMM YYYY'));
	        } else {
	          (0, _Announcer.announce)(newValue.format(format));
	        }
	      });
	      if (notify) {
	        onChange(newValue.format(format));
	      } else {
	        // rebuild grid
	        var state = { timeOfDay: timeOfDay, value: newValue };
	        this._buildDateRows(state);
	        this.setState(state);
	      }
	    }
	  }, {
	    key: '_renderGrid',
	    value: function _renderGrid() {
	      var _this2 = this;
	
	      var propsValue = this.props.value;
	      var _state6 = this.state,
	          activeCell = _state6.activeCell,
	          dateRows = _state6.dateRows,
	          focus = _state6.focus,
	          mouseActive = _state6.mouseActive,
	          value = _state6.value;
	      var intl = this.context.intl;
	
	
	      var dateSelectorMessage = _Intl2.default.getMessage(intl, 'Date Selector');
	      var navigationHelpMessage = _Intl2.default.getMessage(intl, 'Navigation Help');
	
	      var headerCells = WEEK_DAYS.map(function (day) {
	        return _react2.default.createElement(
	          'th',
	          { key: day },
	          day
	        );
	      });
	
	      var rows = dateRows.map(function (row, rowIndex) {
	        var days = row.map(function (date, columnIndex) {
	          var _classnames;
	
	          var classes = (0, _classnames4.default)(CLASS_ROOT + '__day', (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__day--active', date.isSame(propsValue, 'day')), _defineProperty(_classnames, CLASS_ROOT + '__day--hover', !date.isSame(value, 'day') && [rowIndex, columnIndex].toString() === activeCell.toString()), _defineProperty(_classnames, CLASS_ROOT + '__day--other-month', !date.isSame(value, 'month')), _classnames));
	          var weekDay = WEEK_DAYS[columnIndex];
	          var day = dateRows[rowIndex][columnIndex].date();
	          return _react2.default.createElement(
	            'td',
	            { key: date.valueOf() },
	            _react2.default.createElement(
	              'div',
	              { className: classes, tabIndex: '-1',
	                onClick: _this2._onDay.bind(_this2, (0, _moment2.default)(date)),
	                'aria-label': weekDay + ' ' + day,
	                role: 'button',
	                onFocus: function onFocus() {
	                  return _this2.setState({
	                    activeCell: [rowIndex, columnIndex]
	                  });
	                },
	                onBlur: function onBlur() {
	                  return _this2.setState({
	                    activeCell: _this2.state.originalActiveCell
	                  });
	                } },
	              date.date()
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          'tr',
	          { key: 'date_row_' + rowIndex },
	          days
	        );
	      });
	
	      var gridClasses = (0, _classnames4.default)(CLASS_ROOT + '__grid', _defineProperty({}, CLASS_ROOT + '__grid--focus', focus));
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'grid', className: gridClasses },
	        _react2.default.createElement(
	          'table',
	          { ref: function ref(_ref) {
	              return _this2.tableRef = _ref;
	            }, tabIndex: '0',
	            'aria-label': dateSelectorMessage + ' (' + navigationHelpMessage + ')',
	            onMouseDown: function onMouseDown() {
	              return _this2.setState({ mouseActive: true });
	            },
	            onMouseUp: function onMouseUp() {
	              return _this2.setState({ mouseActive: false });
	            },
	            onFocus: function onFocus() {
	              if (mouseActive === false) {
	                _this2.setState({ focus: true });
	              }
	            },
	            onBlur: function onBlur() {
	              return _this2.setState({
	                activeCell: _this2.state.originalActiveCell,
	                focus: false
	              });
	            } },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              headerCells
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            rows
	          )
	        )
	      );
	    }
	  }, {
	    key: '_renderCalendar',
	    value: function _renderCalendar() {
	      var format = this.props.format;
	      var value = this.state.value;
	      var intl = this.context.intl;
	
	
	      var previousMonthMessage = _Intl2.default.getMessage(intl, 'Previous Month');
	      var nextMonthMessage = _Intl2.default.getMessage(intl, 'Next Month');
	      var todayMessage = _Intl2.default.getMessage(intl, 'Today');
	
	      var grid = format.match(/D/) ? this._renderGrid() : _react2.default.createElement('span', { key: 'grid' });
	
	      return [_react2.default.createElement(
	        _Header2.default,
	        { key: 'header', justify: 'between', colorIndex: 'neutral-1' },
	        _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__previous',
	          icon: _react2.default.createElement(_LinkPrevious2.default, null),
	          a11yTitle: previousMonthMessage,
	          onClick: this._onPrevious.bind(this, 'month', false) }),
	        _react2.default.createElement(
	          _Title2.default,
	          { className: CLASS_ROOT + '__title', responsive: false },
	          value.format('MMMM YYYY')
	        ),
	        _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__next', icon: _react2.default.createElement(_LinkNext2.default, null),
	          a11yTitle: nextMonthMessage,
	          onClick: this._onNext.bind(this, 'month', false) })
	      ), grid, _react2.default.createElement(
	        _Box2.default,
	        { key: 'today', alignSelf: 'center', pad: { vertical: 'small' } },
	        _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__today', label: todayMessage,
	          onClick: this._onToday })
	      )];
	    }
	  }, {
	    key: '_renderCounters',
	    value: function _renderCounters(includeDate) {
	      var _this3 = this;
	
	      var format = this.props.format;
	      var value = this.state.value;
	      var intl = this.context.intl;
	
	      // break the format up into chunks
	
	      var chunks = [];
	      var index = 0;
	      while (index < format.length) {
	        var chunk = format[index];
	        index += 1;
	        while (format[index] === chunk[0]) {
	          chunk += format[index];
	          index += 1;
	        }
	        chunks.push(chunk);
	      }
	
	      var addMessage = _Intl2.default.getMessage(intl, 'Add');
	      var subtractMessage = _Intl2.default.getMessage(intl, 'Subtract');
	
	      var elements = chunks.map(function (chunk, index) {
	        var unit = UNITS[chunk[0]];
	        if (unit) {
	          var unitMessage = _Intl2.default.getMessage(intl, unit);
	          return _react2.default.createElement(
	            _Box2.default,
	            { key: index, align: 'center' },
	            _react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Subtract2.default, null),
	              a11yTitle: subtractMessage + ' ' + unitMessage,
	              onClick: _this3._onPrevious.bind(_this3, unit) }),
	            value.format('M' === chunk ? 'MMM' : chunk),
	            _react2.default.createElement(_Button2.default, { icon: _react2.default.createElement(_Add2.default, null),
	              a11yTitle: addMessage + ' ' + unitMessage,
	              onClick: _this3._onNext.bind(_this3, unit) })
	          );
	        } else {
	          return _react2.default.createElement(
	            _Box2.default,
	            { key: index, align: 'center', justify: 'center',
	              className: 'secondary' },
	            chunk
	          );
	        }
	      });
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { className: CLASS_ROOT + '__time', direction: 'row', alignSelf: 'center',
	          responsive: false },
	        elements
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var format = this.props.format;
	
	
	      var calendar = void 0,
	          counters = void 0;
	      if (DAY_REGEXP.test(format)) {
	        calendar = this._renderCalendar();
	      }
	
	      if (TIME_REGEXP.test(format) || MONTHYEAR_REGEXP.test(format) && !DAY_REGEXP.test(format)) {
	        counters = this._renderCounters(!DAY_REGEXP.test(format));
	      }
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { className: CLASS_ROOT },
	        calendar,
	        counters
	      );
	    }
	  }]);
	
	  return DateTimeDrop;
	}(_react.Component);
	
	DateTimeDrop.displayName = 'DateTimeDrop';
	exports.default = DateTimeDrop;
	
	
	DateTimeDrop.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	DateTimeDrop.propTypes = {
	  format: _propTypes2.default.string,
	  onChange: _propTypes2.default.func.isRequired,
	  step: _propTypes2.default.number.isRequired,
	  value: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Announcer = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LABEL;
	
	var Label = function (_Component) {
	  _inherits(Label, _Component);
	
	  function Label() {
	    _classCallCheck(this, Label);
	
	    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
	  }
	
	  _createClass(Label, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.announce) {
	        (0, _Announcer.announce)(this.labelRef.textContent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this2 = this;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          labelFor = _props.labelFor,
	          margin = _props.margin,
	          size = _props.size,
	          truncate = _props.truncate,
	          uppercase = _props.uppercase,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'labelFor', 'margin', 'size', 'truncate', 'uppercase']);
	
	      delete props.announce;
	      var labelMargin = margin ? margin : 'small' === size ? 'none' : 'medium';
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--truncate', truncate), _defineProperty(_classnames, CLASS_ROOT + '--uppercase', uppercase), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + labelMargin, labelMargin), _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _classnames), className);
	
	      return _react2.default.createElement(
	        'label',
	        _extends({ ref: function ref(_ref) {
	            return _this2.labelRef = _ref;
	          } }, props, {
	          className: classes, htmlFor: labelFor }),
	        children
	      );
	    }
	  }]);
	
	  return Label;
	}(_react.Component);
	
	Label.displayName = 'Label';
	exports.default = Label;
	
	
	Label.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  announce: _propTypes2.default.bool,
	  labelFor: _propTypes2.default.string,
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  truncate: _propTypes2.default.bool,
	  uppercase: _propTypes2.default.bool
	};
	
	Label.defaultProps = {
	  size: 'medium'
	};
	module.exports = exports['default'];

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Spinning = __webpack_require__(192);
	
	var _Spinning2 = _interopRequireDefault(_Spinning);
	
	var _InfiniteScroll = __webpack_require__(212);
	
	var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);
	
	var _Selection = __webpack_require__(215);
	
	var _Selection2 = _interopRequireDefault(_Selection);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Announcer = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LIST;
	var LIST_ITEM = _CSSClassnames2.default.LIST_ITEM;
	var SELECTED_CLASS = CLASS_ROOT + '-item--selected';
	var ACTIVE_CLASS = CLASS_ROOT + '-item--active';
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props, context) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._fireClick = _this._fireClick.bind(_this);
	    _this._announceItem = _this._announceItem.bind(_this);
	    _this._onPreviousItem = _this._onPreviousItem.bind(_this);
	    _this._onNextItem = _this._onNextItem.bind(_this);
	    _this._onEnter = _this._onEnter.bind(_this);
	
	    _this.state = {
	      activeItem: undefined,
	      mouseActive: false,
	      selected: _Selection2.default.normalizeIndexes(props.selected)
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          onMore = _props.onMore,
	          selectable = _props.selectable;
	
	      this._setSelection();
	      if (onMore) {
	        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
	      }
	      if (selectable) {
	        // only listen for navigation keys if the list row can be selected
	        this._keyboardHandlers = {
	          left: this._onPreviousItem,
	          up: this._onPreviousItem,
	          right: this._onNextItem,
	          down: this._onNextItem,
	          enter: this._onEnter,
	          space: this._onEnter
	        };
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this._scroll) {
	        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
	        this._scroll = undefined;
	      }
	      if (nextProps.hasOwnProperty('selected')) {
	        this.setState({
	          selected: _Selection2.default.normalizeIndexes(nextProps.selected)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          onMore = _props2.onMore,
	          selectable = _props2.selectable;
	      var selected = this.state.selected;
	
	      if (JSON.stringify(selected) !== JSON.stringify(prevState.selected)) {
	        this._setSelection();
	      }
	      if (onMore && !this._scroll) {
	        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
	      }
	      if (selectable) {
	        // only listen for navigation keys if the list row can be selected
	        this._keyboardHandlers = {
	          left: this._onPreviousItem,
	          up: this._onPreviousItem,
	          right: this._onNextItem,
	          down: this._onNextItem,
	          enter: this._onEnter,
	          space: this._onEnter
	        };
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var selectable = this.props.selectable;
	
	      if (this._scroll) {
	        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
	      }
	      if (selectable) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: '_announceItem',
	    value: function _announceItem(label) {
	      var intl = this.context.intl;
	
	      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
	      (0, _Announcer.announce)(label + ' ' + enterSelectMessage);
	    }
	  }, {
	    key: '_setSelection',
	    value: function _setSelection() {
	      if (this.listRef) {
	        _Selection2.default.setClassFromIndexes({
	          containerElement: this.listRef,
	          childSelector: '.' + LIST_ITEM,
	          selectedClass: SELECTED_CLASS,
	          selectedIndexes: this.state.selected
	        });
	      };
	    }
	  }, {
	    key: '_onPreviousItem',
	    value: function _onPreviousItem(event) {
	      var _this2 = this;
	
	      if (this.listRef.contains(document.activeElement)) {
	        event.preventDefault();
	        var activeItem = this.state.activeItem;
	
	        var rows = this.listRef.querySelectorAll('ul li');
	        if (rows && rows.length > 0) {
	          if (activeItem === undefined) {
	            rows[0].classList.add(ACTIVE_CLASS);
	            this.setState({ activeItem: 0 }, function () {
	              _this2._announceItem(rows[_this2.state.activeItem].innerText);
	            });
	          } else if (activeItem - 1 >= 0) {
	            rows[activeItem].classList.remove(ACTIVE_CLASS);
	            rows[activeItem - 1].classList.add(ACTIVE_CLASS);
	            this.setState({ activeItem: activeItem - 1 }, function () {
	              _this2._announceItem(rows[_this2.state.activeItem].innerText);
	            });
	          }
	        }
	
	        //stop event propagation
	        return true;
	      }
	    }
	  }, {
	    key: '_onNextItem',
	    value: function _onNextItem(event) {
	      var _this3 = this;
	
	      if (this.listRef.contains(document.activeElement)) {
	        event.preventDefault();
	        var activeItem = this.state.activeItem;
	
	        var rows = this.listRef.querySelectorAll('ul li');
	        if (rows && rows.length > 0) {
	          if (activeItem === undefined) {
	            rows[0].classList.add(ACTIVE_CLASS);
	            this.setState({ activeItem: 0 }, function () {
	              _this3._announceItem(rows[_this3.state.activeItem].innerText);
	            });
	          } else if (activeItem + 1 <= rows.length - 1) {
	            rows[activeItem].classList.remove(ACTIVE_CLASS);
	            rows[activeItem + 1].classList.add(ACTIVE_CLASS);
	            this.setState({ activeItem: activeItem + 1 }, function () {
	              _this3._announceItem(rows[_this3.state.activeItem].innerText);
	            });
	          }
	        }
	
	        //stop event propagation
	        return true;
	      }
	    }
	  }, {
	    key: '_fireClick',
	    value: function _fireClick(element, shiftKey) {
	      var event = void 0;
	      try {
	        event = new MouseEvent('click', {
	          'bubbles': true,
	          'cancelable': true,
	          'shiftKey': shiftKey
	        });
	      } catch (e) {
	        // IE11 workaround.
	        event = document.createEvent('Event');
	        event.initEvent('click', true, true);
	      }
	      // We use dispatchEvent to have the browser fill out the event fully.
	      element.dispatchEvent(event);
	    }
	  }, {
	    key: '_onEnter',
	    value: function _onEnter(event) {
	      var activeItem = this.state.activeItem;
	      var intl = this.context.intl;
	
	      if (this.listRef.contains(document.activeElement) && activeItem !== undefined) {
	        var rows = this.listRef.querySelectorAll('ul li');
	        this._fireClick(rows[activeItem], event.shiftKey);
	        rows[activeItem].classList.remove(ACTIVE_CLASS);
	        var label = rows[activeItem].innerText;
	        var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
	        (0, _Announcer.announce)(label + ' ' + selectedMessage);
	      }
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      var _props3 = this.props,
	          onSelect = _props3.onSelect,
	          selectable = _props3.selectable,
	          selected = _props3.selected;
	
	      if (!this.props.selectable) {
	        return;
	      }
	
	      var selection = _Selection2.default.onClick(event, {
	        containerElement: this.listRef,
	        childSelector: '.' + LIST_ITEM,
	        selectedClass: SELECTED_CLASS,
	        multiSelect: 'multiple' === selectable,
	        priorSelectedIndexes: this.state.selected
	      });
	
	      // only set the selected state and classes if the caller isn't managing it.
	      if (selected === undefined) {
	        this.setState({ selected: selection }, this._setSelection);
	      }
	
	      if (onSelect) {
	        onSelect(selection.length === 1 ? selection[0] : selection);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this4 = this;
	
	      var _props4 = this.props,
	          a11yTitle = _props4.a11yTitle,
	          children = _props4.children,
	          className = _props4.className,
	          emptyIndicator = _props4.emptyIndicator,
	          _onBlur = _props4.onBlur,
	          _onFocus = _props4.onFocus,
	          onMore = _props4.onMore,
	          _onMouseDown = _props4.onMouseDown,
	          _onMouseUp = _props4.onMouseUp,
	          selectable = _props4.selectable,
	          props = _objectWithoutProperties(_props4, ['a11yTitle', 'children', 'className', 'emptyIndicator', 'onBlur', 'onFocus', 'onMore', 'onMouseDown', 'onMouseUp', 'selectable']);
	
	      var _state = this.state,
	          activeItem = _state.activeItem,
	          focus = _state.focus,
	          mouseActive = _state.mouseActive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--focus', focus), _defineProperty(_classnames, CLASS_ROOT + '--selectable', selectable), _defineProperty(_classnames, CLASS_ROOT + '--moreable', onMore), _classnames), className);
	
	      var empty = void 0;
	      if (emptyIndicator) {
	        empty = _react2.default.createElement(
	          'li',
	          { className: CLASS_ROOT + '__empty' },
	          emptyIndicator
	        );
	      }
	
	      var more = void 0;
	      if (onMore) {
	        more = _react2.default.createElement(
	          'li',
	          { ref: function ref(_ref) {
	              return _this4.moreRef = _ref;
	            }, className: CLASS_ROOT + '__more' },
	          _react2.default.createElement(_Spinning2.default, null)
	        );
	      }
	
	      var selectableProps = void 0;
	      if (selectable) {
	        var multiSelectMessage = selectable === 'multiple' ? '(' + _Intl2.default.getMessage(intl, 'Multi Select') + ')' : '';
	        var listMessage = a11yTitle || _Intl2.default.getMessage(intl, 'List');
	        var navigationHelpMessage = _Intl2.default.getMessage(intl, 'Navigation Help');
	        selectableProps = {
	          'aria-label': listMessage + ' ' + multiSelectMessage + ' ' + navigationHelpMessage,
	          tabIndex: '0',
	          onClick: this._onClick,
	          onMouseDown: function onMouseDown(event) {
	            _this4.setState({ mouseActive: true });
	            if (_onMouseDown) {
	              _onMouseDown(event);
	            }
	          },
	          onMouseUp: function onMouseUp(event) {
	            _this4.setState({ mouseActive: false });
	            if (_onMouseUp) {
	              _onMouseUp(event);
	            }
	          },
	          onFocus: function onFocus(event) {
	            if (mouseActive === false) {
	              _this4.setState({ focus: true });
	            }
	            if (_onFocus) {
	              _onFocus(event);
	            }
	          },
	          onBlur: function onBlur(event) {
	            if (activeItem) {
	              var rows = _this4.listRef.querySelectorAll('ul li');
	              rows[activeItem].classList.remove(ACTIVE_CLASS);
	            }
	            _this4.setState({ focus: false, activeItem: undefined });
	            if (_onBlur) {
	              _onBlur(event);
	            }
	          }
	        };
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        _extends({}, props, { ref: function ref(_ref2) {
	            return _this4.listRef = _ref2;
	          }, className: classes
	        }, selectableProps),
	        empty,
	        children,
	        more
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.displayName = 'List';
	exports.default = List;
	
	
	List.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	List.propTypes = {
	  emptyIndicator: _propTypes2.default.node,
	  onMore: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  selectable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['multiple'])]),
	  selected: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])
	};
	
	List.defaultProps = {
	  role: 'list'
	};
	module.exports = exports['default'];

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LIST_ITEM;
	
	var ListItem = function (_Component) {
	  _inherits(ListItem, _Component);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onClick = _props.onClick;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, className, _defineProperty({}, CLASS_ROOT + '--selectable', onClick));
	
	      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	      var restProps = _Props2.default.omit(this.props, Object.keys(ListItem.propTypes));
	
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, boxProps, restProps, { tag: 'li', className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.Component);
	
	ListItem.displayName = 'ListItem';
	exports.default = ListItem;
	;
	
	ListItem.propTypes = _extends({}, _Box2.default.propTypes);
	
	ListItem.defaultProps = {
	  align: 'center',
	  direction: 'row',
	  pad: { horizontal: 'medium', vertical: 'small' },
	  separator: 'bottom',
	  role: 'listitem'
	};
	module.exports = exports['default'];

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckBox = __webpack_require__(40);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _FormattedMessage = __webpack_require__(188);
	
	var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);
	
	var _Form = __webpack_require__(53);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _Footer = __webpack_require__(67);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Paragraph = __webpack_require__(85);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LOGIN_FORM;
	
	var LoginForm = function (_Component) {
	  _inherits(LoginForm, _Component);
	
	  function LoginForm(props, context) {
	    _classCallCheck(this, LoginForm);
	
	    var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props, context));
	
	    _this._onSubmit = _this._onSubmit.bind(_this);
	    _this._onUsernameChange = _this._onUsernameChange.bind(_this);
	    _this._onPasswordChange = _this._onPasswordChange.bind(_this);
	    _this._onRememberMeChange = _this._onRememberMeChange.bind(_this);
	    _this._onChange = _this._onChange.bind(_this);
	
	    _this.state = {
	      timestamp: new Date().getTime(),
	      password: '',
	      rememberMe: props.defaultValues.rememberMe,
	      username: props.defaultValues.username
	    };
	    return _this;
	  }
	
	  _createClass(LoginForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.usernameRef) {
	        this.usernameRef.focus();
	      }
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(args) {
	      var onChange = this.props.onChange;
	
	
	      if (onChange) {
	        onChange(args);
	      }
	    }
	  }, {
	    key: '_onUsernameChange',
	    value: function _onUsernameChange(event) {
	      var username = event.target.value;
	      this.setState({ username: username });
	      this._onChange({ event: event, username: username });
	    }
	  }, {
	    key: '_onPasswordChange',
	    value: function _onPasswordChange(event) {
	      var password = event.target.value;
	      this.setState({ password: password });
	      this._onChange({ event: event, password: password });
	    }
	  }, {
	    key: '_onRememberMeChange',
	    value: function _onRememberMeChange(event) {
	      var rememberMe = event.target.checked;
	      this.setState({ rememberMe: rememberMe });
	      this._onChange({ event: event, rememberMe: rememberMe });
	    }
	  }, {
	    key: '_onSubmit',
	    value: function _onSubmit(event) {
	      event.preventDefault();
	      var onSubmit = this.props.onSubmit;
	      var _state = this.state,
	          password = _state.password,
	          rememberMe = _state.rememberMe,
	          username = _state.username;
	
	
	      username = username.trim();
	
	      if (onSubmit) {
	        onSubmit({ username: username, password: password, rememberMe: rememberMe });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          align = _props.align,
	          errors = _props.errors,
	          forgotPassword = _props.forgotPassword,
	          logo = _props.logo,
	          onSubmit = _props.onSubmit,
	          rememberMe = _props.rememberMe,
	          secondaryText = _props.secondaryText,
	          title = _props.title,
	          usernameType = _props.usernameType;
	      var timestamp = this.state.timestamp;
	
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, this.props.className);
	      var center = !align || 'stretch' === align || 'center' === align;
	
	      var errorsNode = errors.map(function (error, index) {
	        if (error) {
	          var errorMessage = void 0;
	          if (_react2.default.isValidElement(error)) {
	            errorMessage = error;
	          } else {
	            errorMessage = _react2.default.createElement(_FormattedMessage2.default, { id: error, defaultMessage: error });
	          }
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: 'error' },
	            errorMessage
	          );
	        }
	        return undefined;
	      });
	
	      var titleNode = void 0;
	      if (title) {
	        titleNode = _react2.default.createElement(
	          _Heading2.default,
	          { strong: true },
	          title
	        );
	      }
	
	      var secondaryTextNode = void 0;
	      if (secondaryText) {
	        secondaryTextNode = _react2.default.createElement(
	          _Paragraph2.default,
	          { align: align, margin: 'none' },
	          secondaryText
	        );
	      }
	
	      var rememberMeNode = void 0;
	      if (rememberMe) {
	        var rememberMeLabel = _react2.default.createElement(_FormattedMessage2.default, { id: 'Remember me', defaultMessage: 'Remember me' });
	
	        rememberMeNode = _react2.default.createElement(_CheckBox2.default, { label: rememberMeLabel, checked: this.state.rememberMe,
	          onChange: this._onRememberMeChange });
	      }
	
	      var username = usernameType === 'email' ? _react2.default.createElement(_FormattedMessage2.default, { id: 'Email', defaultMessage: 'Email' }) : _react2.default.createElement(_FormattedMessage2.default, { id: 'Username', defaultMessage: 'Username' });
	
	      var password = _react2.default.createElement(_FormattedMessage2.default, { id: 'Password', defaultMessage: 'Password' });
	      var login = _react2.default.createElement(_FormattedMessage2.default, { id: 'Log In', defaultMessage: 'Log In' });
	
	      var usernameId = 'grommetux-username_' + timestamp;
	      var passwordId = 'grommetux-password_' + timestamp;
	
	      return _react2.default.createElement(
	        _Form2.default,
	        { className: classes, pad: 'medium', onSubmit: this._onSubmit },
	        _react2.default.createElement(
	          _Box2.default,
	          { align: align },
	          logo,
	          titleNode,
	          secondaryTextNode
	        ),
	        _react2.default.createElement(
	          'fieldset',
	          null,
	          _react2.default.createElement(
	            _FormField2.default,
	            { htmlFor: usernameId, label: username },
	            _react2.default.createElement('input', {
	              id: usernameId,
	              type: usernameType,
	              ref: function ref(_ref) {
	                return _this2.usernameRef = _ref;
	              },
	              value: this.state.username,
	              onChange: this._onUsernameChange
	            })
	          ),
	          _react2.default.createElement(
	            _FormField2.default,
	            { htmlFor: passwordId, label: password },
	            _react2.default.createElement('input', {
	              id: passwordId,
	              type: 'password',
	              value: this.state.password,
	              onChange: this._onPasswordChange
	            })
	          ),
	          errorsNode
	        ),
	        _react2.default.createElement(
	          _Footer2.default,
	          { size: 'small', direction: 'column',
	            align: center ? 'stretch' : 'start',
	            pad: { vertical: 'none', between: 'medium' } },
	          rememberMeNode,
	          _react2.default.createElement(_Button2.default, { primary: true, fill: center,
	            type: onSubmit ? "submit" : "button",
	            label: login,
	            onClick: onSubmit ? this._onSubmit : undefined }),
	          forgotPassword
	        )
	      );
	    }
	  }]);
	
	  return LoginForm;
	}(_react.Component);
	
	LoginForm.displayName = 'LoginForm';
	exports.default = LoginForm;
	
	
	LoginForm.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end', 'stretch']),
	  defaultValues: _propTypes2.default.shape({
	    username: _propTypes2.default.string,
	    rememberMe: _propTypes2.default.bool
	  }),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])),
	  forgotPassword: _propTypes2.default.node,
	  logo: _propTypes2.default.node,
	  onSubmit: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  rememberMe: _propTypes2.default.bool,
	  secondaryText: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  usernameType: _propTypes2.default.string
	};
	
	LoginForm.defaultProps = {
	  align: 'center',
	  defaultValues: {
	    username: '',
	    rememberMe: false
	  },
	  errors: [],
	  usernameType: 'email'
	};
	module.exports = exports['default'];

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var CLASS_ROOT = {
	  'control': _CSSClassnames2.default.CONTROL_ICON,
	  'logo': _CSSClassnames2.default.LOGO_ICON,
	  'status': _CSSClassnames2.default.STATUS_ICON
	};
	
	var SVGIcon = function (_Component) {
	  _inherits(SVGIcon, _Component);
	
	  function SVGIcon() {
	    _classCallCheck(this, SVGIcon);
	
	    return _possibleConstructorReturn(this, (SVGIcon.__proto__ || Object.getPrototypeOf(SVGIcon)).apply(this, arguments));
	  }
	
	  _createClass(SVGIcon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          children = _props.children,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          size = _props.size,
	          type = _props.type,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'children', 'className', 'colorIndex', 'size', 'type']);
	
	      var classRoot = CLASS_ROOT[type];
	      var classes = (0, _classnames3.default)(classRoot, (_classnames = {}, _defineProperty(_classnames, classRoot + '--' + size, size), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames), className);
	
	      var iconMessage = _Intl2.default.getMessage(this.context.intl, 'icon');
	      var typeMessage = _Intl2.default.getMessage(this.context.intl, type);
	      var defaultTitle = typeMessage + ' ' + iconMessage;
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, role: 'img' }),
	        _react2.default.createElement(
	          'title',
	          null,
	          a11yTitle || defaultTitle
	        ),
	        children
	      );
	    }
	  }]);
	
	  return SVGIcon;
	}(_react.Component);
	
	SVGIcon.displayName = 'SVGIcon';
	exports.default = SVGIcon;
	
	
	SVGIcon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	SVGIcon.defaultProps = {
	  type: 'control'
	};
	
	SVGIcon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  type: _propTypes2.default.oneOf(['control', 'logo', 'status'])
	};
	module.exports = exports['default'];

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FormattedMessage = __webpack_require__(188);
	
	var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Layer = __webpack_require__(41);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Menu = __webpack_require__(121);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _KeyboardAccelerators = __webpack_require__(32);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SKIP_LINK_ANCHOR;
	
	var SkipLinks = function (_Component) {
	  _inherits(SkipLinks, _Component);
	
	  function SkipLinks(props, context) {
	    _classCallCheck(this, SkipLinks);
	
	    var _this = _possibleConstructorReturn(this, (SkipLinks.__proto__ || Object.getPrototypeOf(SkipLinks)).call(this, props, context));
	
	    _this._processTab = _this._processTab.bind(_this);
	    _this._onFocus = _this._onFocus.bind(_this);
	    _this._onClick = _this._onClick.bind(_this);
	    _this._updateAnchors = _this._updateAnchors.bind(_this);
	    _this._checkForSkipLink = _this._checkForSkipLink.bind(_this);
	    _this.state = { anchors: [], showLayer: false };
	    return _this;
	  }
	
	  _createClass(SkipLinks, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updateAnchors();
	
	      this._keyboardHandlers = {
	        tab: this._processTab
	      };
	      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	
	      document.addEventListener('DOMNodeInserted', this._checkForSkipLink);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setState({ routeChanged: true });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.routeChanged) {
	        this.setState({ routeChanged: false }, this._updateAnchors);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	      document.removeEventListener('DOMNodeInserted', this._checkForSkipLink);
	    }
	  }, {
	    key: '_checkForSkipLink',
	    value: function _checkForSkipLink(event) {
	      var skipLinks = document.querySelectorAll('.' + CLASS_ROOT);
	      if (skipLinks.length > 0) {
	        this._updateAnchors();
	      } else if (this.state.anchors.length > 0) {
	        this._updateAnchors();
	      }
	    }
	  }, {
	    key: '_updateAnchors',
	    value: function _updateAnchors() {
	      var anchorElements = document.querySelectorAll('.' + CLASS_ROOT);
	
	      var anchors = Array.prototype.map.call(anchorElements, function (anchorElement) {
	        return {
	          id: anchorElement.getAttribute('id'),
	          label: anchorElement.textContent
	        };
	      });
	
	      this.setState({ anchors: anchors, routeChanged: false });
	    }
	  }, {
	    key: '_onFocus',
	    value: function _onFocus() {
	      if (!this.state.showLayer) {
	        this.setState({ showLayer: true });
	      }
	    }
	  }, {
	    key: '_processTab',
	    value: function _processTab(event) {
	      if (this.state.showLayer) {
	        var currentAnchor = document.activeElement;
	        var last = this.state.anchors.length - 1;
	
	        var achorId = event.shiftKey ? this.state.anchors[0].id : this.state.anchors[last].id;
	
	        var targetId = 'skipLayer_' + achorId;
	
	        if (currentAnchor.id === targetId) {
	          this.setState({ showLayer: false });
	        }
	      }
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(destId, event) {
	      event.preventDefault();
	      var dest = document.getElementById(destId);
	      this.setState({ showLayer: false }, function () {
	        dest.focus();
	        dest.scrollIntoView();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var anchorElements = this.state.anchors.map(function (anchor, index) {
	        var skipToLabel = _Intl2.default.getMessage(this.context.intl, 'Skip to');
	        var a11yLabel = skipToLabel + ' ' + anchor.label;
	        return _react2.default.createElement(
	          'a',
	          { href: '#' + anchor.id,
	            onFocus: this._onFocus,
	            onClick: this._onClick.bind(this, anchor.id),
	            id: 'skipLayer_' + anchor.id,
	            key: 'skipLayerItem_' + index,
	            'aria-label': a11yLabel },
	          anchor.label
	        );
	      }.bind(this));
	
	      var menuComponent = void 0;
	      if (anchorElements.length > 0) {
	        menuComponent = _react2.default.createElement(
	          _Menu2.default,
	          { direction: 'row', responsive: false, wrap: true },
	          anchorElements
	        );
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { id: 'skip-link-layer', hidden: !this.state.showLayer, align: 'top' },
	        _react2.default.createElement(
	          _Box2.default,
	          { pad: { horizontal: 'small', vertical: 'medium' } },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(_FormattedMessage2.default, { id: 'Skip to', defaultMessage: 'Skip to' })
	          ),
	          menuComponent
	        )
	      );
	    }
	  }]);
	
	  return SkipLinks;
	}(_react.Component);
	
	SkipLinks.displayName = 'SkipLinks';
	exports.default = SkipLinks;
	
	
	SkipLinks.contextTypes = {
	  intl: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Anchor = __webpack_require__(66);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _SocialTwitter = __webpack_require__(523);
	
	var _SocialTwitter2 = _interopRequireDefault(_SocialTwitter);
	
	var _SocialFacebook = __webpack_require__(519);
	
	var _SocialFacebook2 = _interopRequireDefault(_SocialFacebook);
	
	var _SocialGooglePlus = __webpack_require__(520);
	
	var _SocialGooglePlus2 = _interopRequireDefault(_SocialGooglePlus);
	
	var _SocialLinkedin = __webpack_require__(521);
	
	var _SocialLinkedin2 = _interopRequireDefault(_SocialLinkedin);
	
	var _SocialMail = __webpack_require__(522);
	
	var _SocialMail2 = _interopRequireDefault(_SocialMail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var SocialShare = function (_Component) {
	  _inherits(SocialShare, _Component);
	
	  function SocialShare() {
	    _classCallCheck(this, SocialShare);
	
	    return _possibleConstructorReturn(this, (SocialShare.__proto__ || Object.getPrototypeOf(SocialShare)).apply(this, arguments));
	  }
	
	  _createClass(SocialShare, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          type = _props.type,
	          link = _props.link,
	          text = _props.text,
	          title = _props.title,
	          a11yTitle = _props.a11yTitle,
	          props = _objectWithoutProperties(_props, ['className', 'colorIndex', 'type', 'link', 'text', 'title', 'a11yTitle']);
	
	      var socialIcon = undefined;
	      var href = '';
	      var target = '_blank';
	      var calculatedA11yTitle = a11yTitle || 'Share on ' + (type.charAt(0).toUpperCase() + type.slice(1));
	
	      var encodedLink = encodeURIComponent(link);
	      var encodedTitle = encodeURIComponent(title);
	      var encodedText = encodeURIComponent(text);
	
	      if (type === 'twitter') {
	        socialIcon = _react2.default.createElement(_SocialTwitter2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'https://twitter.com/intent/tweet?url=' + (encodedLink + '&text=' + encodedText);
	      } else if (type === 'linkedin') {
	        socialIcon = _react2.default.createElement(_SocialLinkedin2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'https://www.linkedin.com/shareArticle?mini=true&url=' + (encodedLink + '&title=' + encodedTitle + '&summary=' + encodedText);
	      } else if (type === 'google') {
	        socialIcon = _react2.default.createElement(_SocialGooglePlus2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'https://plus.google.com/share?url=' + encodedLink;
	      } else if (type === 'facebook') {
	        socialIcon = _react2.default.createElement(_SocialFacebook2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodedLink;
	      } else if (type === 'email') {
	        socialIcon = _react2.default.createElement(_SocialMail2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'mailto:?subject=' + (encodedTitle + '&body=' + encodedText + '%0D%0A' + encodedLink);
	        target = '_self';
	      }
	
	      return _react2.default.createElement(_Anchor2.default, _extends({}, props, { href: href, icon: socialIcon, target: target }));
	    }
	  }]);
	
	  return SocialShare;
	}(_react.Component);
	
	SocialShare.displayName = 'SocialShare';
	exports.default = SocialShare;
	
	
	SocialShare.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  link: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['email', 'facebook', 'twitter', 'linkedin', 'google']).isRequired
	};
	
	SocialShare.defaultProps = {
	  text: '',
	  title: ''
	};
	module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Status = __webpack_require__(505);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _Close = __webpack_require__(63);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Announcer = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.TOAST;
	var APP = _CSSClassnames2.default.APP;
	
	var DURATION = 8000;
	var ANIMATION_DURATION = 1000;
	
	var ToastContents = function (_Component) {
	  _inherits(ToastContents, _Component);
	
	  function ToastContents() {
	    _classCallCheck(this, ToastContents);
	
	    var _this = _possibleConstructorReturn(this, (ToastContents.__proto__ || Object.getPrototypeOf(ToastContents)).call(this));
	
	    _this._onClose = _this._onClose.bind(_this);
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ToastContents, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        history: this.props.history,
	        intl: this.props.intl,
	        router: this.props.router,
	        store: this.props.store
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _Announcer.announce)(this._contentsRef.innerText);
	      this._timer = setTimeout(this._onClose, this.props.duration);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._timer);
	      this._timer = undefined;
	    }
	  }, {
	    key: '_onClose',
	    value: function _onClose() {
	      var onClose = this.props.onClose;
	
	      clearTimeout(this._timer);
	      this._timer = undefined;
	      this.setState({ closing: true });
	      if (onClose) {
	        // wait for the laeve animation to finish
	        setTimeout(onClose, ANIMATION_DURATION);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          onClose = _props.onClose,
	          size = _props.size,
	          status = _props.status,
	          rest = _objectWithoutProperties(_props, ['children', 'onClose', 'size', 'status']);
	
	      var closing = this.state.closing;
	
	      // removing context props to avoid invalid html attributes on prop transfer
	
	      delete rest.duration;
	      delete rest.history;
	      delete rest.intl;
	      delete rest.router;
	      delete rest.store;
	
	      var classNames = (0, _classnames3.default)('grommet', CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--closing', closing), _classnames));
	
	      var statusIcon = void 0;
	      if (status) {
	        statusIcon = _react2.default.createElement(_Status2.default, {
	          className: CLASS_ROOT + '__status',
	          value: status,
	          size: size === 'large' ? 'medium' : size
	        });
	      }
	
	      var closeControl = void 0;
	      if (onClose) {
	        closeControl = _react2.default.createElement(_Button2.default, {
	          className: CLASS_ROOT + '__closer',
	          icon: _react2.default.createElement(_Close2.default, null),
	          onClick: this._onClose
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: classNames }, rest),
	        statusIcon,
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(_ref) {
	              return _this2._contentsRef = _ref;
	            },
	            className: CLASS_ROOT + '__contents'
	          },
	          children
	        ),
	        closeControl
	      );
	    }
	  }]);
	
	  return ToastContents;
	}(_react.Component);
	
	ToastContents.displayName = 'ToastContents';
	
	
	ToastContents.propTypes = {
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  onClose: _propTypes2.default.func,
	  router: _propTypes2.default.any,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  store: _propTypes2.default.any
	};
	
	// Because Toast creates a new DOM render context, the context
	// is not transfered. For now, we hard code these specific ones.
	// TODO: Either figure out how to introspect the context and transfer
	// whatever we find or have callers explicitly indicate which parts
	// of the context to transfer somehow.
	ToastContents.childContextTypes = {
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  router: _propTypes2.default.any,
	  store: _propTypes2.default.object
	};
	
	var Toast = function (_Component2) {
	  _inherits(Toast, _Component2);
	
	  function Toast() {
	    _classCallCheck(this, Toast);
	
	    return _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).apply(this, arguments));
	  }
	
	  _createClass(Toast, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._addLayer();
	      this._renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._removeLayer();
	    }
	  }, {
	    key: '_addLayer',
	    value: function _addLayer() {
	      var id = this.props.id;
	
	
	      var element = document.createElement('div');
	      if (id) {
	        element.id = id;
	      }
	      element.className = CLASS_ROOT + '__container';
	      // insert before .app, if possible.
	      var appElements = document.querySelectorAll('.' + APP);
	      var beforeElement;
	      if (appElements.length > 0) {
	        beforeElement = appElements[0];
	      } else {
	        beforeElement = document.body.firstChild;
	      }
	      if (beforeElement) {
	        this._element = beforeElement.parentNode.insertBefore(element, beforeElement);
	      }
	    }
	  }, {
	    key: '_renderLayer',
	    value: function _renderLayer() {
	      var _this4 = this;
	
	      if (this._element) {
	        this._element.className = CLASS_ROOT + '__container';
	        var contents = _react2.default.createElement(ToastContents, _extends({}, this.props, {
	          history: this.context.history,
	          intl: this.context.intl,
	          router: this.context.router,
	          store: this.context.store,
	          onClose: function onClose() {
	            return _this4._removeLayer();
	          }
	        }));
	        _reactDom2.default.render(contents, this._element);
	      }
	    }
	  }, {
	    key: '_removeLayer',
	    value: function _removeLayer() {
	      var onClose = this.props.onClose;
	
	      if (this._element) {
	        _reactDom2.default.unmountComponentAtNode(this._element);
	        this._element.parentNode.removeChild(this._element);
	        this._element = undefined;
	
	        if (onClose) {
	          onClose();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('span', { style: { display: 'none' } });
	    }
	  }]);
	
	  return Toast;
	}(_react.Component);
	
	Toast.displayName = 'Toast';
	exports.default = Toast;
	
	
	Toast.propTypes = {
	  onClose: _propTypes2.default.func,
	  duration: _propTypes2.default.number,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  status: _propTypes2.default.string
	};
	
	Toast.defaultProps = {
	  duration: DURATION,
	  size: 'medium'
	};
	module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Controls = __webpack_require__(535);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _Overlay = __webpack_require__(537);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Throttle = __webpack_require__(544);
	
	var _Throttle2 = _interopRequireDefault(_Throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;
	
	var Video = function (_Component) {
	  _inherits(Video, _Component);
	
	  function Video(props, context) {
	    _classCallCheck(this, Video);
	
	    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props, context));
	
	    _this._hasPlayed = false;
	    _this._play = _this._play.bind(_this);
	    _this._pause = _this._pause.bind(_this);
	    _this._togglePlay = _this._togglePlay.bind(_this);
	    _this._toggleMute = _this._toggleMute.bind(_this);
	    _this._seek = _this._seek.bind(_this);
	    _this._mute = _this._mute.bind(_this);
	    _this._unmute = _this._unmute.bind(_this);
	    _this._fullscreen = _this._fullscreen.bind(_this);
	    _this._onInterationStart = _this._onInterationStart.bind(_this);
	    _this._onInteractionOver = _this._onInteractionOver.bind(_this);
	    _this._renderControls = _this._renderControls.bind(_this);
	
	    _this.state = {
	      mouseActive: false
	    };
	    return _this;
	  }
	
	  _createClass(Video, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._update = (0, _Throttle2.default)(this._update.bind(this), 100, this);
	      this._mediaEventProps = this._injectUpdateVideoEvents();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Dynamically modifying a source element and its attribute when
	      // the element is already inserted in a video or audio element will
	      // have no effect.
	      // From HTML Specs:
	      // https://html.spec.whatwg.org/multipage/embedded-content.html
	      //   #the-source-element
	      // Using forceUpdate to force redraw of video when receiving new <source>
	      this.forceUpdate();
	    }
	  }, {
	    key: '_injectUpdateVideoEvents',
	    value: function _injectUpdateVideoEvents() {
	      var _this2 = this;
	
	      var videoEvents = ['onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting'];
	
	      return videoEvents.reduce(function (previousValue, currentValue) {
	        previousValue[currentValue] = function (e) {
	          if (currentValue in _this2.props && typeof _this2.props[currentValue] === 'function') {
	            _this2.props[currentValue](e);
	          }
	          _this2._update();
	        };
	
	        return previousValue;
	      }, {});
	    }
	  }, {
	    key: '_update',
	    value: function _update() {
	      // Set flag for Video first play
	      if (!this._hasPlayed && !this._video.paused && !this._video.loading) {
	        this._hasPlayed = true;
	      }
	
	      var interacting = this.state.interacting;
	      if (this._video.ended) {
	        interacting = false;
	      };
	
	      this.setState({
	        duration: this._video.duration,
	        currentTime: this._video.currentTime,
	        buffered: this._video.buffered,
	        paused: this._video.paused,
	        muted: this._video.muted,
	        volume: this._video.volume,
	        ended: this._video.ended,
	        readyState: this._video.readyState,
	        interacting: interacting,
	        // computed values
	        hasPlayed: this._hasPlayed,
	        playing: !this._video.paused && !this._video.loading,
	        percentageBuffered: this._video.buffered.length && this._video.buffered.end(this._video.buffered.length - 1) / this._video.duration * 100,
	        percentagePlayed: this._video.currentTime / this._video.duration * 100,
	        loading: this._video.readyState < this._video.HAVE_ENOUGH_DATA
	      });
	    }
	  }, {
	    key: '_play',
	    value: function _play() {
	      this._video.play();
	    }
	  }, {
	    key: '_pause',
	    value: function _pause() {
	      this._video.pause();
	    }
	  }, {
	    key: '_togglePlay',
	    value: function _togglePlay() {
	      if (this.state.paused) {
	        this._play();
	      } else {
	        this._pause();
	      }
	    }
	  }, {
	    key: '_seek',
	    value: function _seek(time) {
	      this._video.currentTime = typeof time !== 'undefined' ? time : this._video.currentTime;
	    }
	  }, {
	    key: '_unmute',
	    value: function _unmute() {
	      this._video.muted = false;
	    }
	  }, {
	    key: '_mute',
	    value: function _mute() {
	      this._video.muted = true;
	    }
	  }, {
	    key: '_toggleMute',
	    value: function _toggleMute() {
	      if (!this.state.muted) {
	        this._mute();
	      } else {
	        this._unmute();
	      }
	    }
	  }, {
	    key: '_fullscreen',
	    value: function _fullscreen() {
	      if (this._video.requestFullscreen) {
	        this._video.requestFullscreen();
	      } else if (this._video.msRequestFullscreen) {
	        this._video.msRequestFullscreen();
	      } else if (this._video.mozRequestFullScreen) {
	        this._video.mozRequestFullScreen();
	      } else if (this._video.webkitRequestFullscreen) {
	        this._video.webkitRequestFullscreen();
	      } else {
	        console.warn('Your browser doesn\'t support fullscreen.');
	      }
	    }
	  }, {
	    key: '_onInterationStart',
	    value: function _onInterationStart() {
	      this.setState({ interacting: true });
	    }
	  }, {
	    key: '_onInteractionOver',
	    value: function _onInteractionOver() {
	      var focus = this.state.focus;
	
	      if (!focus) {
	        this.setState({ interacting: false });
	      }
	    }
	  }, {
	    key: '_renderControls',
	    value: function _renderControls() {
	      var _this3 = this;
	
	      var extendedProps = _extends({
	        title: this.props.title,
	        togglePlay: this._togglePlay,
	        toggleMute: this._toggleMute,
	        play: this._play,
	        pause: this._pause,
	        mute: this._mute,
	        unmute: this._unmute,
	        seek: this._seek,
	        timeline: this.props.timeline,
	        fullscreen: this._fullscreen,
	        shareLink: this.props.shareLink,
	        shareHeadline: this.props.shareHeadline,
	        shareText: this.props.shareText,
	        allowFullScreen: this.props.allowFullScreen,
	        size: this.props.size
	      }, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Overlay2.default, extendedProps),
	        _react2.default.createElement(_Controls2.default, _extends({ ref: function ref(_ref) {
	            return _this3._controlRef = _ref;
	          }
	        }, extendedProps))
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this4 = this;
	
	      var _props = this.props,
	          align = _props.align,
	          autoPlay = _props.autoPlay,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          fit = _props.fit,
	          full = _props.full,
	          loop = _props.loop,
	          muted = _props.muted,
	          poster = _props.poster,
	          showControls = _props.showControls,
	          size = _props.size;
	      var _state = this.state,
	          ended = _state.ended,
	          hasPlayed = _state.hasPlayed,
	          interacting = _state.interacting,
	          mouseActive = _state.mouseActive,
	          playing = _state.playing;
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--' + fit, fit), _defineProperty(_classnames, CLASS_ROOT + '--full', fit || full), _defineProperty(_classnames, CLASS_ROOT + '--interacting', interacting), _defineProperty(_classnames, CLASS_ROOT + '--playing', playing), _defineProperty(_classnames, CLASS_ROOT + '--hasPlayed', hasPlayed), _defineProperty(_classnames, CLASS_ROOT + '--ended', ended), _defineProperty(_classnames, BACKGROUND_COLOR_INDEX + '--' + colorIndex, colorIndex), _defineProperty(_classnames, CLASS_ROOT + '--align-top', align && align.top), _defineProperty(_classnames, CLASS_ROOT + '--align-bottom', align && align.bottom), _defineProperty(_classnames, CLASS_ROOT + '--align-left', align && align.left), _defineProperty(_classnames, CLASS_ROOT + '--align-right', align && align.right), _classnames), className);
	      var restProps = _Props2.default.omit(this.props, Object.keys(Video.propTypes));
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes, ref: function ref(_ref2) {
	            return _this4._containerRef = _ref2;
	          },
	          onMouseEnter: function onMouseEnter() {
	            if (!ended) {
	              _this4._onInterationStart();
	            }
	          },
	          onMouseMove: function onMouseMove(event) {
	            // needed to avoid react synthatic event pooling
	            event.persist();
	            if (!ended || (0, _reactDom.findDOMNode)(_this4._controlRef).contains(event.target)) {
	              _this4._onInterationStart();
	            } else if (ended) {
	              _this4._onInteractionOver();
	            }
	            clearTimeout(_this4._moveTimer);
	            _this4._moveTimer = setTimeout(function () {
	              var element = (0, _reactDom.findDOMNode)(_this4._controlRef);
	              if (element && !element.contains(event.target)) {
	                _this4._onInteractionOver();
	              }
	            }, 1000);
	          },
	          onMouseLeave: this._onInteractionOver,
	          onMouseDown: function onMouseDown() {
	            _this4.setState({ mouseActive: true });
	          },
	          onMouseUp: function onMouseUp() {
	            _this4.setState({ mouseActive: false });
	          },
	          onFocus: function onFocus() {
	            if (mouseActive === false) {
	              _this4._onInterationStart();
	              _this4.setState({ focus: true });
	            }
	          },
	          onBlur: function onBlur() {
	            _this4.setState({ focus: false }, function () {
	              if (!_this4._containerRef.contains(document.activeElement)) {
	                _this4._onInteractionOver();
	              }
	            });
	          } },
	        _react2.default.createElement(
	          'video',
	          _extends({ ref: function ref(el) {
	              return _this4._video = el;
	            } }, restProps, {
	            poster: poster, autoPlay: autoPlay ? 'autoplay' : false,
	            loop: loop ? 'loop' : false, muted: muted }, this._mediaEventProps),
	          this.props.children
	        ),
	        showControls ? this._renderControls() : undefined
	      );
	    }
	  }]);
	
	  return Video;
	}(_react.Component);
	
	Video.displayName = 'Video';
	exports.default = Video;
	
	
	Video.propTypes = {
	  align: _propTypes2.default.shape({
	    bottom: _propTypes2.default.boolean,
	    left: _propTypes2.default.boolean,
	    right: _propTypes2.default.boolean,
	    top: _propTypes2.default.boolean
	  }),
	  allowFullScreen: _propTypes2.default.bool,
	  autoPlay: _propTypes2.default.bool,
	  colorIndex: _propTypes2.default.string,
	  fit: _propTypes2.default.oneOf(['contain', 'cover']),
	  full: _propTypes2.default.oneOf([true, 'horizontal', 'vertical', false]),
	  loop: _propTypes2.default.bool,
	  muted: _propTypes2.default.bool,
	  poster: _propTypes2.default.string,
	  shareLink: _propTypes2.default.string,
	  shareHeadline: _propTypes2.default.string,
	  shareText: _propTypes2.default.string,
	  showControls: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  timeline: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    label: _propTypes2.default.string,
	    time: _propTypes2.default.number
	  })),
	  title: _propTypes2.default.node
	};
	
	Video.defaultProps = {
	  allowFullScreen: true,
	  autoPlay: false,
	  loop: false,
	  muted: false,
	  size: 'medium',
	  showControls: true
	};
	module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _OK = __webpack_require__(532);
	
	var _OK2 = _interopRequireDefault(_OK);
	
	var _CriticalStatus = __webpack_require__(529);
	
	var _CriticalStatus2 = _interopRequireDefault(_CriticalStatus);
	
	var _Warning = __webpack_require__(534);
	
	var _Warning2 = _interopRequireDefault(_Warning);
	
	var _Disabled = __webpack_require__(530);
	
	var _Disabled2 = _interopRequireDefault(_Disabled);
	
	var _Unknown = __webpack_require__(533);
	
	var _Unknown2 = _interopRequireDefault(_Unknown);
	
	var _Blank = __webpack_require__(528);
	
	var _Blank2 = _interopRequireDefault(_Blank);
	
	var _Label = __webpack_require__(531);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;
	
	var Status = function (_Component) {
	  _inherits(Status, _Component);
	
	  function Status() {
	    _classCallCheck(this, Status);
	
	    return _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).apply(this, arguments));
	  }
	
	  _createClass(Status, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          size = _props.size,
	          value = _props.value,
	          props = _objectWithoutProperties(_props, ['className', 'size', 'value']);
	
	      var classes = (0, _classnames3.default)(_defineProperty({}, CLASS_ROOT + '--' + size, size), className);
	
	      var icon = _react2.default.createElement(
	        'span',
	        null,
	        '?'
	      );
	      switch (value.toLowerCase()) {
	        case 'ok':
	        case 'normal':
	          icon = _react2.default.createElement(_OK2.default, _extends({}, props, { className: classes }));
	          break;
	        case 'warning':
	          icon = _react2.default.createElement(_Warning2.default, _extends({}, props, { className: classes }));
	          break;
	        case 'critical':
	          icon = _react2.default.createElement(_CriticalStatus2.default, _extends({}, props, { className: classes }));
	          break;
	        case 'disabled':
	          icon = _react2.default.createElement(_Disabled2.default, _extends({}, props, { className: classes }));
	          break;
	        case 'unknown':
	          icon = _react2.default.createElement(_Unknown2.default, _extends({}, props, { className: classes }));
	          break;
	        case 'blank':
	          icon = _react2.default.createElement(_Blank2.default, _extends({}, props, { className: classes }));
	          break;
	        case 'label':
	          icon = _react2.default.createElement(_Label2.default, _extends({}, props, { className: classes }));
	          break;
	      }
	      return icon;
	    }
	  }]);
	
	  return Status;
	}(_react.Component);
	
	Status.displayName = 'Status';
	exports.default = Status;
	
	
	Status.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  value: _propTypes2.default.oneOf(['critical', 'warning', 'ok', 'unknown', 'disabled', 'label', 'Critical', 'Warning', 'OK', 'Unknown', 'Disabled', 'Label', 'blank'])
	};
	
	Status.defaultProps = {
	  value: 'unknown'
	};
	module.exports = exports['default'];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-add', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'add');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 L12,2 M2,12 L22,12' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Add';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-calendar', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'calendar');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,5 L22,5 L22,22 L2,22 L2,5 Z M18,5 L18,1 M6,5 L6,1 M2,10 L22,10' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Calendar';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-caret-down', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'caret-down');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '22 8 12 20 2 8' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'CaretDown';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-clock', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'clock');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,5 L12,12 L17,12' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Clock';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-expand', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'expand');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,14 L2,22 M1,15 L1,23 L9,23 M22,2 L14,10 M15,1 L23,1 L23,9' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Expand';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-map-location', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'map-location');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17.5,6.5 L23,9 L23,22 L16,19 L8,22 L1,19 L1,6 L6,8 M16,19 L16,12 M8,22 L8,12 M12,16.2727273 C12,16.2727273 6,11.5 6,7 C6,3.25 9,1 12,1 C15,1 18,3.25 18,7 C18,11.5 12,16.2727273 12,16.2727273 Z M13,7 C13,6.44766667 12.5523333,6 12,6 C11.4476667,6 11,6.44766667 11,7 C11,7.55233333 11.4476667,8 12,8 C12.5523333,8 13,7.55233333 13,7 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'MapLocation';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-more', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'more');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,13 L3,11 L5,11 L5,13 L3,13 Z M11,12.9995001 L11,11 L12.9995001,11 L12.9995001,12.9995001 L11,12.9995001 Z M19,12.9995001 L19,11 L20.9995001,11 L20.9995001,12.9995001 L19,12.9995001 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'More';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-next', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'next');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 2 17 12 7 22' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Next';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-pause', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'pause');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,21 L9,21 L9,3 L3,3 L3,21 Z M15,21 L21,21 L21,3 L15,3 L15,21 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Pause';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-play', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'play');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '3 22 21 12 3 2' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Play';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-previous', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'previous');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 2 17 12 7 22', transform: 'matrix(-1 0 0 1 24 0)' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Previous';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-refresh', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'refresh');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,8 C18.5974037,5.04031171 15.536972,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12 M21,3 L21,9 L15,9' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Refresh';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-search', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'search');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,15 L22,22 L15,15 Z M9.5,17 C13.6421356,17 17,13.6421356 17,9.5 C17,5.35786438 13.6421356,2 9.5,2 C5.35786438,2 2,5.35786438 2,9.5 C2,13.6421356 5.35786438,17 9.5,17 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Search';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-facebook', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-facebook');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: '#3B5998', fillRule: 'evenodd', d: 'M23.00025,0 L1.0005,0 C0.44775,0 0,0.44775 0,0.99975 L0,23.00025 C0,23.55225 0.44775,24 1.0005,24 L12.75,24 L12.75,15 L9.75,15 L9.75,11.25 L12.75,11.25 L12.75,8.25 C12.75,5.15025 14.71275,3.62475 17.478,3.62475 C18.8025,3.62475 19.941,3.72375 20.2725,3.76725 L20.2725,7.00725 L18.35475,7.008 C16.851,7.008 16.5,7.72275 16.5,8.77125 L16.5,11.25 L20.25,11.25 L19.5,15 L16.5,15 L16.56,24 L23.00025,24 C23.55225,24 24,23.55225 24,23.00025 L24,0.99975 C24,0.44775 23.55225,0 23.00025,0', stroke: 'none' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialFacebook';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-google-plus', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-google-plus');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: '#4285F4', fillRule: 'evenodd', d: 'M0.0202537528,11.2032618 C0.0858884305,7.29693926 3.69605513,3.87603603 7.62298049,4.00635861 C9.5045944,3.91939087 11.2733582,4.73384249 12.7144674,5.87784249 C12.0993693,6.57306829 11.4624794,7.24274571 10.7820061,7.86906829 C9.04956189,6.67810055 6.58579693,6.33771345 4.85335275,7.71345539 C2.37505996,9.41848765 2.26220982,13.4442941 4.64607169,15.2796489 C6.96429889,17.3722941 11.3459973,16.3333264 11.9865191,13.1291973 C10.534514,13.1075199 9.07861756,13.1291973 7.62661245,13.0822296 C7.62298049,12.2205522 7.61934853,11.3588747 7.62298049,10.4974554 C10.0504259,10.4902296 12.4778712,10.4863586 14.9089486,10.5046812 C15.0544863,12.532036 14.7852026,14.6897135 13.5332146,16.3658425 C11.6370729,19.0195199 7.83052098,19.7942296 4.86061667,18.6574554 C1.88007591,17.527907 -0.230870232,14.3962941 0.0202537528,11.2032618 M19.6437253,8.32145539 L21.8091508,8.32145539 C21.8127827,9.04197152 21.8164147,9.76610055 21.8236786,10.4863586 C22.5479949,10.4938425 23.2759431,10.4938425 24,10.5010683 L24,12.6551328 C23.2759431,12.6623586 22.5516269,12.6659715 21.8236786,12.6731973 C21.8164147,13.3970683 21.8127827,14.1175844 21.8091508,14.8381005 L19.6400933,14.8381005 C19.6328294,14.1175844 19.6328294,13.3970683 19.6255655,12.6768102 C18.9012492,12.6695844 18.1735604,12.6623586 17.4492441,12.6551328 L17.4492441,10.5010683 C18.1735604,10.4938425 18.8976172,10.4902296 19.6255655,10.4863586 C19.6291974,9.76248765 19.6364613,9.04197152 19.6437253,8.32145539', stroke: 'none' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialGooglePlus';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-linkedin', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-linkedin');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: '#0077B5', fillRule: 'evenodd', d: 'M20.45175,20.45025 L16.89225,20.45025 L16.89225,14.88075 C16.89225,13.5525 16.86975,11.844 15.04275,11.844 C13.191,11.844 12.90825,13.2915 12.90825,14.7855 L12.90825,20.45025 L9.3525,20.45025 L9.3525,8.997 L12.765,8.997 L12.765,10.563 L12.81375,10.563 C13.2885,9.66225 14.4495,8.71275 16.18125,8.71275 C19.78575,8.71275 20.45175,11.08425 20.45175,14.169 L20.45175,20.45025 Z M5.33925,7.4325 C4.1955,7.4325 3.27375,6.50775 3.27375,5.36775 C3.27375,4.2285 4.1955,3.30375 5.33925,3.30375 C6.47775,3.30375 7.4025,4.2285 7.4025,5.36775 C7.4025,6.50775 6.47775,7.4325 5.33925,7.4325 L5.33925,7.4325 Z M7.11975,20.45025 L3.5565,20.45025 L3.5565,8.997 L7.11975,8.997 L7.11975,20.45025 Z M23.00025,0 L1.0005,0 C0.44775,0 0,0.44775 0,0.99975 L0,22.9995 C0,23.55225 0.44775,24 1.0005,24 L23.00025,24 C23.55225,24 24,23.55225 24,22.9995 L24,0.99975 C24,0.44775 23.55225,0 23.00025,0 L23.00025,0 Z', stroke: 'none' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialLinkedin';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-mail', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-mail');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M23,20 L23,6 L12,15 L1,6 L1,20 L23,20 Z M12,12 L22,4 L2,4 L12,12 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialMail';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-twitter', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-twitter');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: '#1DA1F2', fillRule: 'evenodd', d: 'M24,4.3086 C23.117,4.7006 22.168,4.9646 21.172,5.0836 C22.188,4.4746 22.969,3.5096 23.337,2.3596 C22.386,2.9246 21.332,3.3336 20.21,3.5556 C19.312,2.5976 18.032,1.9996 16.616,1.9996 C13.897,1.9996 11.692,4.2046 11.692,6.9236 C11.692,7.3096 11.736,7.6856 11.82,8.0456 C7.728,7.8406 4.099,5.8806 1.671,2.9006 C1.247,3.6286 1.004,4.4736 1.004,5.3766 C1.004,7.0846 1.873,8.5926 3.195,9.4756 C2.388,9.4486 1.628,9.2276 0.964,8.8596 L0.964,8.9206 C0.964,11.3066 2.661,13.2966 4.914,13.7486 C4.501,13.8626 4.065,13.9216 3.617,13.9216 C3.299,13.9216 2.991,13.8906 2.69,13.8336 C3.317,15.7896 5.135,17.2136 7.29,17.2536 C5.604,18.5736 3.481,19.3606 1.175,19.3606 C0.777,19.3606 0.385,19.3376 0,19.2926 C2.179,20.6886 4.767,21.5046 7.548,21.5046 C16.605,21.5046 21.557,14.0016 21.557,7.4946 C21.557,7.2816 21.552,7.0696 21.543,6.8586 C22.505,6.1636 23.34,5.2966 24,4.3086', stroke: 'none' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialTwitter';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-subtract', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'subtract');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Subtract';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-up', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'up');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7.086 1.174 17.086 11.174 7.086 21.174', transform: 'rotate(-89 12.086 11.174)' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Up';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-volume', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'volume');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,16 C17.209,16 19,14.209 19,12 C19,9.791 17.209,8 15,8 M15,20 C20,20 23,16.411 23,12 C23,7.589 19.411,4 15,4 M1,12 L1,8 L6,8 L12,3 L12,21 L6,16 L1,16 L1,12' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Volume';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(8);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-volume-mute', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'volume-mute');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,8 L1,16 L6.09901951,16 L12,21 L12,3 L6,8 L1,8 Z M15,9 L21,15 M21,9 L15,15' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'VolumeMute';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;
	
	var Blank = function (_Component) {
	  _inherits(Blank, _Component);
	
	  function Blank() {
	    _classCallCheck(this, Blank);
	
	    return _possibleConstructorReturn(this, (Blank.__proto__ || Object.getPrototypeOf(Blank)).apply(this, arguments));
	  }
	
	  _createClass(Blank, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-blank', className);
	      return _react2.default.createElement('svg', _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
	        version: '1.1', 'aria-label': a11yTitle }));
	    }
	  }]);
	
	  return Blank;
	}(_react.Component);
	
	Blank.displayName = 'Blank';
	exports.default = Blank;
	
	
	Blank.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	Blank.defaultProps = {
	  a11yTitle: 'Blank'
	};
	module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;
	
	var _lastId = 0;
	
	var CriticalStatus = function (_Component) {
	  _inherits(CriticalStatus, _Component);
	
	  function CriticalStatus() {
	    _classCallCheck(this, CriticalStatus);
	
	    return _possibleConstructorReturn(this, (CriticalStatus.__proto__ || Object.getPrototypeOf(CriticalStatus)).apply(this, arguments));
	  }
	
	  _createClass(CriticalStatus, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-critical', className);
	      // generate an id to avoid duplication in the DOM
	      var maskId = 'mask-critical-' + _lastId++;
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
	          version: '1.1', 'aria-label': a11yTitle }),
	        _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'mask',
	            { id: maskId },
	            _react2.default.createElement(
	              'g',
	              { className: CLASS_ROOT + '__detail' },
	              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
	              _react2.default.createElement('path', { d: 'M8,8 L16,16', strokeWidth: '2', stroke: '#000', fill: 'none' }),
	              _react2.default.createElement('path', { d: 'M8,16 L16,8', strokeWidth: '2', stroke: '#000', fill: 'none' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
	          _react2.default.createElement('path', { d: 'M12,0 L24,12 L12,24 L0,12 Z', stroke: 'none' })
	        )
	      );
	    }
	  }]);
	
	  return CriticalStatus;
	}(_react.Component);
	
	CriticalStatus.displayName = 'CriticalStatus';
	exports.default = CriticalStatus;
	
	
	CriticalStatus.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	CriticalStatus.defaultProps = {
	  a11yTitle: 'Critical'
	};
	module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;
	
	var _lastId = 0;
	
	var Disabled = function (_Component) {
	  _inherits(Disabled, _Component);
	
	  function Disabled() {
	    _classCallCheck(this, Disabled);
	
	    return _possibleConstructorReturn(this, (Disabled.__proto__ || Object.getPrototypeOf(Disabled)).apply(this, arguments));
	  }
	
	  _createClass(Disabled, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-disabled', className);
	      // generate an id to avoid duplication in the DOM
	      var maskId = 'mask-disabled-' + _lastId++;
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
	          version: '1.1', 'aria-label': a11yTitle }),
	        _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'mask',
	            { id: maskId },
	            _react2.default.createElement(
	              'g',
	              { className: CLASS_ROOT + '__detail' },
	              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
	              _react2.default.createElement('path', { d: 'M6,12 L18,12', strokeWidth: '2', stroke: '#000' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
	          _react2.default.createElement('path', { stroke: 'none',
	            d: 'M21,24 L3,24 C1.3,24 0,22.7 0,21 L0,3 C0,1.3 1.3,0 3,0 ' + 'L21,0 C22.7,0 24,1.3 24,3 L24,21 C24,22.7 22.7,24 21,24 ' + 'L21,24 Z' })
	        )
	      );
	    }
	  }]);
	
	  return Disabled;
	}(_react.Component);
	
	Disabled.displayName = 'Disabled';
	exports.default = Disabled;
	
	
	Disabled.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	Disabled.defaultProps = {
	  a11yTitle: 'Disabled'
	};
	module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;
	
	var Label = function (_Component) {
	  _inherits(Label, _Component);
	
	  function Label() {
	    _classCallCheck(this, Label);
	
	    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
	  }
	
	  _createClass(Label, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-label', className);
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, viewBox: '0 0 24 24', version: '1.1' }),
	        _react2.default.createElement(
	          'g',
	          { className: CLASS_ROOT + '__base' },
	          _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', stroke: 'none' })
	        )
	      );
	    }
	  }]);
	
	  return Label;
	}(_react.Component);
	
	Label.displayName = 'Label';
	exports.default = Label;
	module.exports = exports['default'];

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;
	
	var _lastId = 0;
	
	var OK = function (_Component) {
	  _inherits(OK, _Component);
	
	  function OK() {
	    _classCallCheck(this, OK);
	
	    return _possibleConstructorReturn(this, (OK.__proto__ || Object.getPrototypeOf(OK)).apply(this, arguments));
	  }
	
	  _createClass(OK, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-ok', className);
	      // generate an id to avoid duplication in the DOM
	      var maskId = 'mask-ok-' + _lastId++;
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
	          'aria-label': a11yTitle, version: '1.1' }),
	        _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'mask',
	            { id: maskId },
	            _react2.default.createElement(
	              'g',
	              { className: CLASS_ROOT + '__detail' },
	              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
	              _react2.default.createElement('path', { d: 'M10,17.4 L5.3,12.7 L6.7,11.3 L10,14.6 L17.3,7.3 ' + 'L18.7,8.7 L10,17.4 Z', stroke: 'none', fill: '#000' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
	          _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', stroke: 'none' })
	        )
	      );
	    }
	  }]);
	
	  return OK;
	}(_react.Component);
	
	OK.displayName = 'OK';
	exports.default = OK;
	
	
	OK.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	OK.defaultProps = {
	  a11yTitle: 'OK'
	};
	module.exports = exports['default'];

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;
	
	var _lastId = 0;
	
	var Unknown = function (_Component) {
	  _inherits(Unknown, _Component);
	
	  function Unknown() {
	    _classCallCheck(this, Unknown);
	
	    return _possibleConstructorReturn(this, (Unknown.__proto__ || Object.getPrototypeOf(Unknown)).apply(this, arguments));
	  }
	
	  _createClass(Unknown, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-unknown', className);
	      // generate an id to avoid duplication in the DOM
	      var maskId = 'mask-uknown-' + _lastId++;
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
	          'aria-label': a11yTitle, version: '1.1' }),
	        _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'mask',
	            { id: maskId },
	            _react2.default.createElement(
	              'g',
	              { className: CLASS_ROOT + '__detail' },
	              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
	              _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10', stroke: 'none', fill: '#000' }),
	              _react2.default.createElement('path', {
	                d: 'M9,10.4 C9,8.8 10.4,7.6 12,7.6 C13.6,7.6 14.9,9 15,10.4 ' + 'C15,11.7 14.1,12.7 12.9,13.1 C12.4,13.2 12,13.7 12,14.2 ' + 'L12,15.5', fill: 'none', strokeWidth: '2', stroke: '#fff' }),
	              _react2.default.createElement('circle', { stroke: 'none', cx: '12', cy: '17.6', r: '1', fill: '#fff' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
	          _react2.default.createElement('circle', { className: CLASS_ROOT + '__normal',
	            cx: '12', cy: '12', r: '12', stroke: 'none' }),
	          _react2.default.createElement('circle', { className: CLASS_ROOT + '__small',
	            cx: '12', cy: '12', r: '11', strokeWidth: '3', fill: 'none' })
	        )
	      );
	    }
	  }]);
	
	  return Unknown;
	}(_react.Component);
	
	Unknown.displayName = 'Unknown';
	exports.default = Unknown;
	
	
	Unknown.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	Unknown.defaultProps = {
	  a11yTitle: 'Unknown'
	};
	module.exports = exports['default'];

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;
	
	var _lastId = 0;
	
	var Warning = function (_Component) {
	  _inherits(Warning, _Component);
	
	  function Warning() {
	    _classCallCheck(this, Warning);
	
	    return _possibleConstructorReturn(this, (Warning.__proto__ || Object.getPrototypeOf(Warning)).apply(this, arguments));
	  }
	
	  _createClass(Warning, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-warning', className);
	      // generate an id to avoid duplication in the DOM
	      var maskId = 'mask-warning-' + _lastId++;
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
	          'aria-label': a11yTitle, version: '1.1' }),
	        _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'mask',
	            { id: maskId },
	            _react2.default.createElement(
	              'g',
	              { className: CLASS_ROOT + '__detail' },
	              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
	              _react2.default.createElement(
	                'g',
	                { strokeWidth: '2', stroke: '#000',
	                  transform: 'translate(11.000000, 8.000000)' },
	                _react2.default.createElement('path', { role: 'presentation', d: 'M1,0 L1,6', fill: 'none' }),
	                _react2.default.createElement('path', { role: 'presentation', d: 'M1,8 L1,10', fill: 'none' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
	          _react2.default.createElement('path', { role: 'presentation', d: 'M12,0 L0,22 L24,22 L12,0 L12,0 Z',
	            stroke: 'none' })
	        )
	      );
	    }
	  }]);
	
	  return Warning;
	}(_react.Component);
	
	Warning.displayName = 'Warning';
	exports.default = Warning;
	
	
	Warning.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	Warning.defaultProps = {
	  a11yTitle: 'Warning'
	};
	module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Volume = __webpack_require__(526);
	
	var _Volume2 = _interopRequireDefault(_Volume);
	
	var _VolumeMute = __webpack_require__(527);
	
	var _VolumeMute2 = _interopRequireDefault(_VolumeMute);
	
	var _Time = __webpack_require__(540);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _FullscreenButton = __webpack_require__(536);
	
	var _FullscreenButton2 = _interopRequireDefault(_FullscreenButton);
	
	var _ProgressBar = __webpack_require__(538);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _PlayButton = __webpack_require__(198);
	
	var _PlayButton2 = _interopRequireDefault(_PlayButton);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _FormatTime = __webpack_require__(211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BUTTON_CLASS = CLASS_ROOT + '__button';
	
	var Controls = function (_Component) {
	  _inherits(Controls, _Component);
	
	  function Controls() {
	    _classCallCheck(this, Controls);
	
	    var _this = _possibleConstructorReturn(this, (Controls.__proto__ || Object.getPrototypeOf(Controls)).call(this));
	
	    _this._onChapterTickHover = _this._onChapterTickHover.bind(_this);
	
	    _this.state = {
	      activeChapterIndex: undefined
	    };
	    return _this;
	  }
	
	  _createClass(Controls, [{
	    key: '_onChapterTickHover',
	    value: function _onChapterTickHover(index) {
	      this.setState({ activeChapterIndex: index });
	    }
	  }, {
	    key: '_renderTitle',
	    value: function _renderTitle() {
	      var title = void 0;
	      if (this.props.title) {
	        title = _react2.default.createElement(
	          _Box2.default,
	          { pad: { horizontal: 'small', vertical: 'none' } },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3', margin: 'none' },
	            this.props.title
	          )
	        );
	      }
	
	      return title;
	    }
	  }, {
	    key: '_renderMuteButton',
	    value: function _renderMuteButton() {
	      var _props = this.props,
	          muted = _props.muted,
	          toggleMute = _props.toggleMute;
	      var intl = this.context.intl;
	
	      var buttonMessage = _Intl2.default.getMessage(intl, 'Mute');
	      var Icon = _VolumeMute2.default;
	      if (muted) {
	        Icon = _Volume2.default;
	        buttonMessage = _Intl2.default.getMessage(intl, 'Unmute');
	      }
	      return _react2.default.createElement(
	        _Button2.default,
	        { plain: true, onClick: toggleMute, className: BUTTON_CLASS,
	          a11yTitle: buttonMessage },
	        _react2.default.createElement(Icon, { className: BUTTON_CLASS + '__icon', colorIndex: 'brand' })
	      );
	    }
	  }, {
	    key: '_renderChapterLabels',
	    value: function _renderChapterLabels() {
	      var _props2 = this.props,
	          duration = _props2.duration,
	          timeline = _props2.timeline,
	          props = _objectWithoutProperties(_props2, ['duration', 'timeline']);
	
	      var activeChapterIndex = this.state.activeChapterIndex;
	
	
	      if (timeline) {
	        var chapterLabels = timeline.map(function (chapter, index, chapters) {
	          var _classnames;
	
	          var percent = chapter.time / duration * 100;
	          var classes = (0, _classnames3.default)(CLASS_ROOT + '__chapter-label', (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__chapter-label-start', percent === 0), _defineProperty(_classnames, CLASS_ROOT + '__chapter-label-active', activeChapterIndex === index), _classnames));
	
	          return _react2.default.createElement(
	            'div',
	            { className: classes, key: chapter.label,
	              style: { left: percent + '%' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              chapter.label
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _FormatTime.formatTime)(chapter.time)
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          _Box2.default,
	          _extends({}, props, { pad: 'none', className: CLASS_ROOT + '__chapter-labels',
	            direction: 'row' }),
	          chapterLabels
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          togglePlay = _props3.togglePlay,
	          hasPlayed = _props3.hasPlayed,
	          playing = _props3.playing,
	          ended = _props3.ended,
	          currentTime = _props3.currentTime,
	          duration = _props3.duration,
	          percentagePlayed = _props3.percentagePlayed,
	          seek = _props3.seek,
	          timeline = _props3.timeline,
	          allowFullScreen = _props3.allowFullScreen,
	          fullscreen = _props3.fullscreen;
	
	
	      if (!hasPlayed) {
	        return null;
	      }
	
	      var overlayContent = _react2.default.createElement(
	        _Box2.default,
	        { pad: 'none', className: CLASS_ROOT + '__controls',
	          direction: 'column', justify: 'start' },
	        _react2.default.createElement(_ProgressBar2.default, { progress: percentagePlayed,
	          onChapterHover: this._onChapterTickHover,
	          duration: duration, onChange: seek, timeline: timeline }),
	        timeline ? this._renderChapterLabels() : undefined,
	        _react2.default.createElement(
	          _Box2.default,
	          { pad: 'none', className: CLASS_ROOT + '__controls-primary',
	            direction: 'row', justify: 'between' },
	          _react2.default.createElement(
	            _Box2.default,
	            { direction: 'row', align: 'center',
	              pad: { horizontal: 'small', vertical: 'none' } },
	            _react2.default.createElement(_PlayButton2.default, { playing: playing, ended: ended, iconSize: 'medium',
	              togglePlay: togglePlay, primary: false }),
	            this._renderTitle()
	          ),
	          _react2.default.createElement(
	            _Box2.default,
	            { direction: 'row', align: 'center',
	              pad: { horizontal: 'small', vertical: 'none' } },
	            _react2.default.createElement(_Time2.default, { currentTime: currentTime, duration: duration }),
	            this._renderMuteButton(),
	            allowFullScreen ? _react2.default.createElement(_FullscreenButton2.default, { onClick: fullscreen }) : undefined
	          )
	        )
	      );
	
	      return overlayContent;
	    }
	  }]);
	
	  return Controls;
	}(_react.Component);
	
	Controls.displayName = 'Controls';
	exports.default = Controls;
	
	
	Controls.contextTypes = {
	  intl: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Intl = __webpack_require__(7);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Expand = __webpack_require__(510);
	
	var _Expand2 = _interopRequireDefault(_Expand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BUTTON_CLASS = CLASS_ROOT + '__button';
	
	var FullscreenButton = function (_Component) {
	  _inherits(FullscreenButton, _Component);
	
	  function FullscreenButton() {
	    _classCallCheck(this, FullscreenButton);
	
	    return _possibleConstructorReturn(this, (FullscreenButton.__proto__ || Object.getPrototypeOf(FullscreenButton)).apply(this, arguments));
	  }
	
	  _createClass(FullscreenButton, [{
	    key: 'shouldComponentUpdate',
	
	
	    // prevents unnecessarily updates/re-renders
	    // only update component if the onClick prop changes
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.onClick !== nextProps.onClick;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var a11yExpandButtonTitle = _Intl2.default.getMessage(this.context.intl, 'Toggle Fullscreen');
	
	      return _react2.default.createElement(
	        _Button2.default,
	        { plain: true, className: BUTTON_CLASS, onClick: this.props.onClick,
	          a11yTitle: a11yExpandButtonTitle },
	        _react2.default.createElement(_Expand2.default, { className: BUTTON_CLASS + '__icon',
	          colorIndex: 'brand' })
	      );
	    }
	  }]);
	
	  return FullscreenButton;
	}(_react.Component);
	
	FullscreenButton.displayName = 'FullscreenButton';
	exports.default = FullscreenButton;
	
	
	FullscreenButton.propTypes = {
	  onClick: _propTypes2.default.func
	};
	module.exports = exports['default'];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Share = __webpack_require__(539);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _PlayButton = __webpack_require__(198);
	
	var _PlayButton2 = _interopRequireDefault(_PlayButton);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this._onResponsive = _this._onResponsive.bind(_this);
	    _this.state = {
	      iconSize: props.size && (props.size === 'small' || props.size === 'medium') ? 'large' : 'xlarge'
	    };
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.size !== this.props.size) {
	        this.setState({
	          iconSize: newProps.size && (newProps.size === 'small' || newProps.size === 'medium') ? 'large' : 'xlarge'
	        });
	      }
	    }
	  }, {
	    key: '_onResponsive',
	    value: function _onResponsive(small) {
	      if (small) {
	        this.setState({ iconSize: 'medium' });
	      } else {
	        var iconSize = 'small' === this.props.size ? undefined : 'xlarge';
	        this.setState({ iconSize: iconSize });
	      }
	    }
	  }, {
	    key: '_renderReplayMenu',
	    value: function _renderReplayMenu() {
	      var _props = this.props,
	          ended = _props.ended,
	          shareLink = _props.shareLink,
	          shareHeadline = _props.shareHeadline,
	          shareText = _props.shareText;
	
	
	      var replayContent = void 0;
	      if (ended) {
	        replayContent = _react2.default.createElement(
	          _Box2.default,
	          { className: CLASS_ROOT + '__replay', align: 'center' },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3', strong: true, uppercase: true },
	            'Replay'
	          ),
	          _react2.default.createElement(_Share2.default, { shareLink: shareLink, shareHeadline: shareHeadline,
	            shareText: shareText })
	        );
	      }
	
	      return replayContent;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          ended = _props2.ended,
	          playing = _props2.playing,
	          togglePlay = _props2.togglePlay,
	          videoHeader = _props2.videoHeader;
	
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { pad: 'none', align: 'center', justify: 'center',
	          className: CLASS_ROOT + '__overlay' },
	        videoHeader,
	        _react2.default.createElement(
	          _Box2.default,
	          { pad: 'none', align: 'center', justify: 'center' },
	          _react2.default.createElement(_PlayButton2.default, { iconSize: this.state.iconSize,
	            playing: playing,
	            ended: ended,
	            togglePlay: togglePlay })
	        ),
	        this._renderReplayMenu()
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.displayName = 'Overlay';
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(6);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	
	var ProgressBar = function (_Component) {
	  _inherits(ProgressBar, _Component);
	
	  function ProgressBar() {
	    _classCallCheck(this, ProgressBar);
	
	    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this));
	
	    _this._onProgressBarChange = _this._onProgressBarChange.bind(_this);
	    return _this;
	  }
	
	  // prevents unnecessarily updates/re-renders
	
	
	  _createClass(ProgressBar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.progress !== nextProps.progress;
	    }
	  }, {
	    key: '_onProgressBarChange',
	    value: function _onProgressBarChange(e) {
	      this.props.onChange(e.target.value * this.props.duration / 100);
	    }
	  }, {
	    key: '_onChapterClick',
	    value: function _onChapterClick(time) {
	      this.props.onChange(time);
	    }
	  }, {
	    key: '_onMouseOver',
	    value: function _onMouseOver(index) {
	      this.props.onChapterHover(index);
	    }
	  }, {
	    key: '_renderChapterMarkers',
	    value: function _renderChapterMarkers() {
	      var _this2 = this;
	
	      var _props = this.props,
	          duration = _props.duration,
	          timeline = _props.timeline;
	
	
	      if (timeline) {
	        var chapters = timeline.map(function (chapter, index, chapters) {
	          var percent = chapter.time / duration * 100;
	          var tickClasses = (0, _classnames3.default)(CLASS_ROOT + '__chapter-marker-tick', _defineProperty({}, CLASS_ROOT + '__chapter-marker-tick-start', percent === 0));
	
	          return _react2.default.createElement(
	            'div',
	            { className: CLASS_ROOT + '__chapter-marker', key: chapter.time,
	              style: { width: percent + '%' } },
	            _react2.default.createElement('div', { className: tickClasses,
	              onMouseOver: _this2._onMouseOver.bind(_this2, index),
	              onMouseOut: _this2.props.onChapterHover,
	              onFocus: _this2._onMouseOver.bind(_this2, index),
	              onBlur: _this2.props.onChapterHover,
	              onClick: _this2._onChapterClick.bind(_this2, chapter.time) }),
	            _react2.default.createElement('div', { className: CLASS_ROOT + '__chapter-marker-track' })
	          );
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + '__chapter-markers' },
	          chapters
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          progress = _props2.progress,
	          timeline = _props2.timeline;
	
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { pad: 'none', className: CLASS_ROOT + '__progress', direction: 'row' },
	        _react2.default.createElement('div', { className: CLASS_ROOT + '__progress-bar-fill', style: {
	            width: progress + '%'
	          } }),
	        timeline ? this._renderChapterMarkers() : undefined,
	        _react2.default.createElement('input', { className: CLASS_ROOT + '__progress-bar-input',
	          onChange: this._onProgressBarChange,
	          type: 'range',
	          min: '0',
	          max: '100',
	          value: progress || '',
	          step: '0.1' })
	      );
	    }
	  }]);
	
	  return ProgressBar;
	}(_react.Component);
	
	ProgressBar.displayName = 'ProgressBar';
	exports.default = ProgressBar;
	
	
	ProgressBar.propTypes = {
	  onClick: _propTypes2.default.func,
	  duration: _propTypes2.default.number,
	  progress: _propTypes2.default.number,
	  onChapterHover: _propTypes2.default.func
	};
	
	ProgressBar.defaultProps = {
	  duration: 0,
	  progress: 0
	};
	module.exports = exports['default'];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(11);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _SocialShare = __webpack_require__(502);
	
	var _SocialShare2 = _interopRequireDefault(_SocialShare);
	
	var _Form = __webpack_require__(53);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BUTTON_CLASS = CLASS_ROOT + '__button';
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this));
	
	    _this._onClickShareLink = _this._onClickShareLink.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: '_onClickShareLink',
	    value: function _onClickShareLink() {
	      (0, _reactDom.findDOMNode)(this.shareLinkRef).select();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          shareLink = _props.shareLink,
	          shareHeadline = _props.shareHeadline,
	          shareText = _props.shareText;
	
	      // this has to be null to be a valid react children
	
	      var shareContent = null;
	      if (shareLink) {
	        shareContent = _react2.default.createElement(
	          _Box2.default,
	          { align: 'center' },
	          _react2.default.createElement(
	            _Form2.default,
	            { pad: { vertical: 'small' } },
	            _react2.default.createElement(
	              _FormField2.default,
	              { strong: true },
	              _react2.default.createElement('input', { ref: function ref(_ref) {
	                  return _this2.shareLinkRef = _ref;
	                },
	                className: 'share-link', type: 'text', value: shareLink,
	                onClick: this._onClickShareLink, readOnly: true })
	            )
	          ),
	          _react2.default.createElement(
	            _Box2.default,
	            { direction: 'row', className: BUTTON_CLASS },
	            _react2.default.createElement(_SocialShare2.default, { type: 'email', link: shareLink, colorIndex: 'brand',
	              className: BUTTON_CLASS + '__icon',
	              title: shareHeadline, text: shareText }),
	            _react2.default.createElement(_SocialShare2.default, { type: 'twitter', colorIndex: 'brand',
	              className: BUTTON_CLASS + '__icon',
	              link: shareLink, text: shareHeadline }),
	            _react2.default.createElement(_SocialShare2.default, { type: 'facebook', colorIndex: 'brand',
	              className: BUTTON_CLASS + '__icon',
	              link: shareLink }),
	            _react2.default.createElement(_SocialShare2.default, { type: 'linkedin', colorIndex: 'brand',
	              className: BUTTON_CLASS + '__icon',
	              link: shareLink, title: shareHeadline, text: shareText })
	          )
	        );
	      }
	
	      return shareContent;
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.displayName = 'Overlay';
	exports.default = Overlay;
	
	
	Overlay.propTypes = {
	  shareLink: _propTypes2.default.string,
	  shareHeadline: _propTypes2.default.string,
	  shareText: _propTypes2.default.string
	};
	
	Overlay.defaultProps = {
	  shareHeadline: '',
	  shareText: ''
	};
	module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Box = __webpack_require__(16);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Heading = __webpack_require__(30);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _CSSClassnames = __webpack_require__(5);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _FormatTime = __webpack_require__(211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	
	var Time = function (_Component) {
	  _inherits(Time, _Component);
	
	  function Time() {
	    _classCallCheck(this, Time);
	
	    return _possibleConstructorReturn(this, (Time.__proto__ || Object.getPrototypeOf(Time)).apply(this, arguments));
	  }
	
	  _createClass(Time, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          currentTime = _props.currentTime,
	          duration = _props.duration;
	
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { pad: { horizontal: 'small', vertical: 'none' } },
	        _react2.default.createElement(
	          _Heading2.default,
	          { tag: 'h3', margin: 'none', className: CLASS_ROOT + '__time' },
	          (0, _FormatTime.formatTime)(currentTime),
	          ' / ',
	          (0, _FormatTime.formatTime)(duration)
	        )
	      );
	    }
	  }]);
	
	  return Time;
	}(_react.Component);
	
	Time.displayName = 'Time';
	exports.default = Time;
	
	
	Time.propTypes = {
	  currentTime: _propTypes2.default.number,
	  duration: _propTypes2.default.number
	};
	module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en": 199,
		"./en-US": 126,
		"./en-US.js": 126,
		"./en.js": 199,
		"./fr": 200,
		"./fr-FR": 127,
		"./fr-FR.js": 127,
		"./fr.js": 200,
		"./he": 201,
		"./he.js": 201,
		"./icons/en": 202,
		"./icons/en-US": 56,
		"./icons/en-US.js": 56,
		"./icons/en.js": 202,
		"./icons/fr": 203,
		"./icons/fr-FR": 104,
		"./icons/fr-FR.js": 104,
		"./icons/fr.js": 203,
		"./icons/ja": 204,
		"./icons/ja-JP": 128,
		"./icons/ja-JP.js": 128,
		"./icons/ja.js": 204,
		"./icons/nl": 129,
		"./icons/nl.js": 129,
		"./icons/zh": 205,
		"./icons/zh-CN": 130,
		"./icons/zh-CN.js": 130,
		"./icons/zh.js": 205,
		"./ja": 206,
		"./ja-JP": 131,
		"./ja-JP.js": 131,
		"./ja.js": 206,
		"./nl": 207,
		"./nl.js": 207,
		"./pt": 208,
		"./pt-BR": 132,
		"./pt-BR.js": 132,
		"./pt.js": 208,
		"./ru": 209,
		"./ru-RU": 133,
		"./ru-RU.js": 133,
		"./ru.js": 209,
		"./zh": 210,
		"./zh-CN": 134,
		"./zh-CN.js": 134,
		"./zh.js": 210
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 541;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsCookie = __webpack_require__(572);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  get: function get(name) {
	    return _jsCookie2.default.get(name);
	  },
	  set: function set(name, value, expires, path, domain, secure) {
	    return _jsCookie2.default.set(name, value, { expires: expires, path: path, domain: domain, secure: secure });
	  },
	  remove: function remove(name, path, domain) {
	    _jsCookie2.default.remove(name, { path: path, domain: domain });
	  },
	  has: function has(name) {
	    return _jsCookie2.default.get(name) ? true : false;
	  },
	  keys: function keys() {
	    return Object.keys(_jsCookie2.default.get());
	  }
	}; // (C) Copyright 2015-2018 Hewlett Packard Enterprise Development LP
	
	module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.headers = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.buildParams = buildParams;
	exports.buildQuery = buildQuery;
	exports.processStatus = processStatus;
	
	var _superagent = __webpack_require__(417);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var headers = exports.headers = {
	  'Accept': 'application/json',
	  'Content-Type': 'application/json'
	};
	
	// converts object to parameter array, handles arrays
	function buildParams(object) {
	  var params = [];
	  if (object) {
	    for (var property in object) {
	      if (object.hasOwnProperty(property)) {
	        var value = object[property];
	        if (null !== value && undefined !== value) {
	          if (Array.isArray(value)) {
	            for (var i = 0; i < value.length; i++) {
	              params.push(property + '=' + encodeURIComponent(value[i]));
	            }
	          } else {
	            params.push(property + '=' + encodeURIComponent(value));
	          }
	        }
	      }
	    }
	  }
	  return params;
	}
	
	// joins params array and adds '?' prefix if needed
	function buildQuery(object) {
	  var params = Array.isArray(object) ? object : buildParams(object);
	  return params.length > 0 ? '?' + params.join('&') : '';
	}
	
	// reject promise of response isn't ok
	function processStatus(response) {
	  if (response.ok) {
	    return Promise.resolve(response);
	  } else {
	    return Promise.reject(response.statusText || 'Error ' + response.status);
	  }
	}
	
	// Deprecated superagent functions
	
	var _headers = _extends({}, headers);
	
	var _timeout = 10000; // 10s
	
	exports.default = {
	  setTimeout: function setTimeout(timeout) {
	    _timeout = timeout;
	  },
	  setHeaders: function setHeaders(headers) {
	    _headers = headers;
	  },
	  setHeader: function setHeader(name, value) {
	    _headers[name] = value;
	  },
	  head: function head(uri, params) {
	    var op = _superagent2.default.head(uri).query(buildParams(params).join('&'));
	    op.timeout(_timeout);
	    op.set(_headers);
	    return op;
	  },
	  get: function get(uri, params) {
	    var op = _superagent2.default.get(uri).query(buildParams(params).join('&'));
	    op.timeout(_timeout);
	    op.set(_headers);
	    return op;
	  },
	  patch: function patch(uri, data) {
	    var op = _superagent2.default.patch(uri).send(data);
	    op.timeout(_timeout);
	    op.set(_headers);
	    return op;
	  },
	  post: function post(uri, data) {
	    var op = _superagent2.default.post(uri).send(data);
	    op.timeout(_timeout);
	    op.set(_headers);
	    return op;
	  },
	  put: function put(uri, data) {
	    var op = _superagent2.default.put(uri).send(data);
	    op.timeout(_timeout);
	    op.set(_headers);
	    return op;
	  },
	  del: function del(uri) {
	    var op = _superagent2.default.del(uri);
	    op.timeout(_timeout);
	    op.set(_headers);
	    return op;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (fn) {
	  var threshhold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
	  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
	
	  var last = void 0;
	  var deferTimer = void 0;
	
	  return function () {
	    var now = Date.now();
	    if (last && now < last + threshhold) {
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(scope, arguments);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(scope, arguments);
	    }
	  };
	};
	
	module.exports = exports["default"]; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ }),
/* 546 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(135);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(60);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(72);
	
	var _DOMUtils = __webpack_require__(106);
	
	var _DOMStateStorage = __webpack_require__(216);
	
	var _PathUtils = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(135);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(72);
	
	var _PathUtils = __webpack_require__(57);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(136);
	
	var _BrowserProtocol = __webpack_require__(135);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(548);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(106);
	
	var _createHistory = __webpack_require__(137);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(60);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(136);
	
	var _DOMUtils = __webpack_require__(106);
	
	var _HashProtocol = __webpack_require__(547);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(137);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(60);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(72);
	
	var _PathUtils = __webpack_require__(57);
	
	var _createHistory = __webpack_require__(137);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(554)['default'];
	exports['default'] = exports;


/***/ }),
/* 553 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	"use strict";
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs   = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP    = function() {},
	        fBound  = function() {
	          return fToBind.apply(this instanceof fNOP
	                 ? this
	                 : oThis,
	                 aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    if (this.prototype) {
	      // native functions don't have a prototype
	      fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jshint esnext: true */
	
	"use strict";
	var src$es5$$ = __webpack_require__(553);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(556)['default'];
	exports['default'] = exports;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.location = location;
	    this.name     = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser  = this,
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements,
	                    location: location()
	                };
	            },
	        peg$c1 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c2 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText,
	                    location: location()
	                };
	            },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2],
	                    location: location()
	                };
	            },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2],
	                    location: location()
	                };
	            },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                };
	            },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                }
	            },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern,
	                    location: location()
	                };
	            },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function(number) {
	                return number;
	            },
	        peg$c34 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function() { return '\\'; },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function() { return '\\#'; },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function() { return '\u007B'; },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function() { return '\u007D'; },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c65 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$savedPos         = 0,
	        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(
	        message,
	        null,
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p, ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line:   details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails   = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line:   startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line:   endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        location
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c4); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c4); }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c6); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c8); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c13); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c15); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c17); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c20); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c37); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c37); }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c42); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c46); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c49); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c51); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c54); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c57); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c60); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(
	        null,
	        peg$maxFailExpected,
	        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	        peg$maxFailPos < input.length
	          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	      );
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse:       peg$parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(221), src$es5$$ = __webpack_require__(560), src$compiler$$ = __webpack_require__(557), intl$messageformat$parser$$ = __webpack_require__(555);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	      try {
	        return messageFormat._format(pattern, values);
	      } catch (e) {
	        if (e.variableId) {
	          throw new Error(
	            'The intl string context variable \'' + e.variableId + '\'' +
	            ' was not provided to the string \'' + message + '\''
	          );
	        } else {
	          throw e;
	        }
	      }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value, err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	          err = new Error('A value must be provided for: ' + id);
	          err.variableId = id;
	          throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(221);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(558), src$en$$ = __webpack_require__(559);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(567)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(826);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(220), src$diff$$ = __webpack_require__(564), src$es5$$ = __webpack_require__(566);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = [
	    'second', 'second-short',
	    'minute', 'minute-short',
	    'hour', 'hour-short',
	    'day', 'day-short',
	    'month', 'month-short',
	    'year', 'year-short'
	];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45, 'second-short': 45,  // seconds to minute
	        minute: 45, 'minute-short': 45, // minutes to hour
	        hour  : 22, 'hour-short': 22, // hours to day
	        day   : 26, 'day-short': 26, // days to month
	        month : 11, 'month-short': 11 // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	    var fields = FIELDS.filter(function(field) {
	        return field.indexOf('-short') < 1;
	    });
	
	    for (i = 0, l = fields.length; i < l; i += 1) {
	        units = fields[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond    : millisecond,
	        second         : second,
	        'second-short' : second,
	        minute         : minute,
	        'minute-short' : minute,
	        hour           : hour,
	        'hour-short'   : hour,
	        day            : day,
	        'day-short'    : day,
	        week           : week,
	        'week-short'   : week,
	        month          : month,
	        'month-short'  : month,
	        year           : year,
	        'year-short'   : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	"use strict";
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(563), src$en$$ = __webpack_require__(565);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = __webpack_require__(569);
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(824);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = global.IntlPolyfill;
	    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = global.IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise, global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty$1 = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty$1,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	var realDefineProp = function () {
	    var sentinel = function sentinel() {};
	    try {
	        Object.defineProperty(sentinel, 'a', {
	            get: function get() {
	                return 1;
	            }
	        });
	        Object.defineProperty(sentinel, 'prototype', { writable: false });
	        return sentinel.a === 1 && sentinel.prototype instanceof Object;
	    } catch (e) {
	        return false;
	    }
	}();
	
	// Need a workaround for getters in ES3
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	// We use this a lot (and need it for proto-less objects)
	var hop = Object.prototype.hasOwnProperty;
	
	// Naive defineProperty for compatibility
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
	};
	
	// Array.prototype.indexOf, as good as we need it to be
	var arrIndexOf = Array.prototype.indexOf || function (search) {
	    /*jshint validthis:true */
	    var t = this;
	    if (!t.length) return -1;
	
	    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	        if (t[i] === search) return i;
	    }
	
	    return -1;
	};
	
	// Create an object with the specified prototype (2nd arg required for Record)
	var objCreate = Object.create || function (proto, props) {
	    var obj = void 0;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (var k in props) {
	        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
	    }
	
	    return obj;
	};
	
	// Snapshot some (hopefully still) native built-ins
	var arrSlice = Array.prototype.slice;
	var arrConcat = Array.prototype.concat;
	var arrPush = Array.prototype.push;
	var arrJoin = Array.prototype.join;
	var arrShift = Array.prototype.shift;
	
	// Naive Function.prototype.bind for compatibility
	var fnBind = Function.prototype.bind || function (thisObj) {
	    var fn = this,
	        args = arrSlice.call(arguments, 1);
	
	    // All our (presently) bound functions have either 1 or 0 arguments. By returning
	    // different function signatures, we can pass some tests in ES3 environments
	    if (fn.length === 1) {
	        return function () {
	            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	        };
	    }
	    return function () {
	        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	    };
	};
	
	// Object housing internal properties for constructors
	var internals = objCreate(null);
	
	// Keep internal properties internal
	var secret = Math.random();
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor(n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	function Record(obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	Record.prototype = objCreate(null);
	
	/**
	 * An ordered list
	 */
	function List() {
	    defineProperty(this, 'length', { writable: true, value: 0 });
	
	    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
	}
	List.prototype = objCreate(null);
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore() {
	    if (internals.disableRegExpRestore) {
	        return function () {/* no-op */};
	    }
	
	    var regExpCache = {
	        lastMatch: RegExp.lastMatch || '',
	        leftContext: RegExp.leftContext,
	        multiline: RegExp.multiline,
	        input: RegExp.input
	    },
	        has = false;
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++) {
	        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
	    }return function () {
	        // Now we've snapshotted some properties, escape the lastMatch string
	        var esc = /[.?*+^$[\]\\(){}|-]/g,
	            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
	            reg = new List();
	
	        // If any of the captured strings were non-empty, iterate over them all
	        if (has) {
	            for (var _i = 1; _i <= 9; _i++) {
	                var m = regExpCache['$' + _i];
	
	                // If it's empty, add an empty capturing group
	                if (!m) lm = '()' + lm;
	
	                // Else find the string in lm and escape & wrap it to capture it
	                else {
	                        m = m.replace(esc, '\\$&');
	                        lm = lm.replace(m, '(' + m + ')');
	                    }
	
	                // Push it to the reg and chop lm to make sure further groups come after
	                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	                lm = lm.slice(lm.indexOf('(') + 1);
	            }
	        }
	
	        var exprStr = arrJoin.call(reg, '') + lm;
	
	        // Shorten the regex by replacing each part of the expression with a match
	        // for a string of that exact length.  This is safe for the type of
	        // expressions generated above, because the expression matches the whole
	        // match string, so we know each group and each segment between capturing
	        // groups can be matched by its length alone.
	        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
	            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
	        });
	
	        // Create the regular expression that will reconstruct the RegExp properties
	        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');
	
	        // Set the lastIndex of the generated expression to ensure that the match
	        // is found in the correct index.
	        expr.lastIndex = regExpCache.leftContext.length;
	
	        expr.exec(regExpCache.input);
	    };
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject(arg) {
	    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');
	
	    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
	    return Object(arg);
	}
	
	function toNumber(arg) {
	    if (typeof arg === 'number') return arg;
	    return Number(arg);
	}
	
	function toInteger(arg) {
	    var number = toNumber(arg);
	    if (isNaN(number)) return 0;
	    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
	    if (number < 0) return Math.floor(Math.abs(number)) * -1;
	    return Math.floor(Math.abs(number));
	}
	
	function toLength(arg) {
	    var len = toInteger(arg);
	    if (len <= 0) return 0;
	    if (len === Infinity) return Math.pow(2, 53) - 1;
	    return Math.min(len, Math.pow(2, 53) - 1);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties(obj) {
	    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);
	
	    return objCreate(null);
	}
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	// extlang       = 3ALPHA              ; selected ISO 639 codes
	//                 *2("-" 3ALPHA)      ; permanently reserved
	var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';
	
	// language      = 2*3ALPHA            ; shortest ISO 639 code
	//                 ["-" extlang]       ; sometimes followed by
	//                                     ; extended language subtags
	//               / 4ALPHA              ; or reserved for future use
	//               / 5*8ALPHA            ; or registered language subtag
	var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';
	
	// script        = 4ALPHA              ; ISO 15924 code
	var script = '[a-z]{4}';
	
	// region        = 2ALPHA              ; ISO 3166-1 code
	//               / 3DIGIT              ; UN M.49 code
	var region = '(?:[a-z]{2}|\\d{3})';
	
	// variant       = 5*8alphanum         ; registered variants
	//               / (DIGIT 3alphanum)
	var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';
	
	//                                     ; Single alphanumerics
	//                                     ; "x" reserved for private use
	// singleton     = DIGIT               ; 0 - 9
	//               / %x41-57             ; A - W
	//               / %x59-5A             ; Y - Z
	//               / %x61-77             ; a - w
	//               / %x79-7A             ; y - z
	var singleton = '[0-9a-wy-z]';
	
	// extension     = singleton 1*("-" (2*8alphanum))
	var extension = singleton + '(?:-[a-z0-9]{2,8})+';
	
	// privateuse    = "x" 1*("-" (1*8alphanum))
	var privateuse = 'x(?:-[a-z0-9]{1,8})+';
	
	// irregular     = "en-GB-oed"         ; irregular tags do not match
	//               / "i-ami"             ; the 'langtag' production and
	//               / "i-bnn"             ; would not otherwise be
	//               / "i-default"         ; considered 'well-formed'
	//               / "i-enochian"        ; These tags are all valid,
	//               / "i-hak"             ; but most are deprecated
	//               / "i-klingon"         ; in favor of more modern
	//               / "i-lux"             ; subtags or subtag
	//               / "i-mingo"           ; combination
	//               / "i-navajo"
	//               / "i-pwn"
	//               / "i-tao"
	//               / "i-tay"
	//               / "i-tsu"
	//               / "sgn-BE-FR"
	//               / "sgn-BE-NL"
	//               / "sgn-CH-DE"
	var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';
	
	// regular       = "art-lojban"        ; these tags match the 'langtag'
	//               / "cel-gaulish"       ; production, but their subtags
	//               / "no-bok"            ; are not extended language
	//               / "no-nyn"            ; or variant subtags: their meaning
	//               / "zh-guoyu"          ; is defined by their registration
	//               / "zh-hakka"          ; and all of these are deprecated
	//               / "zh-min"            ; in favor of a more modern
	//               / "zh-min-nan"        ; subtag or sequence of subtags
	//               / "zh-xiang"
	var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';
	
	// grandfathered = irregular           ; non-redundant tags registered
	//               / regular             ; during the RFC 3066 era
	var grandfathered = '(?:' + irregular + '|' + regular + ')';
	
	// langtag       = language
	//                 ["-" script]
	//                 ["-" region]
	//                 *("-" variant)
	//                 *("-" extension)
	//                 ["-" privateuse]
	var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	// Language-Tag  = langtag             ; normal language tags
	//               / privateuse          ; private use tag
	//               / grandfathered       ; grandfathered tags
	var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');
	
	// Match duplicate variants in a language tag
	var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	// Match duplicate singletons in a language tag (except in private use)
	var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	// Match all extension sequences
	var expExtSequences = RegExp('-' + extension, 'ig');
	
	// Default locale is the first-added locale data for us
	var defaultLocale = void 0;
	function setDefaultLocale(locale) {
	    defaultLocale = locale;
	}
	
	// IANA Subtag Registry redundant tag and subtag maps
	var redundantTags = {
	    tags: {
	        "art-lojban": "jbo",
	        "i-ami": "ami",
	        "i-bnn": "bnn",
	        "i-hak": "hak",
	        "i-klingon": "tlh",
	        "i-lux": "lb",
	        "i-navajo": "nv",
	        "i-pwn": "pwn",
	        "i-tao": "tao",
	        "i-tay": "tay",
	        "i-tsu": "tsu",
	        "no-bok": "nb",
	        "no-nyn": "nn",
	        "sgn-BE-FR": "sfb",
	        "sgn-BE-NL": "vgt",
	        "sgn-CH-DE": "sgg",
	        "zh-guoyu": "cmn",
	        "zh-hakka": "hak",
	        "zh-min-nan": "nan",
	        "zh-xiang": "hsn",
	        "sgn-BR": "bzs",
	        "sgn-CO": "csn",
	        "sgn-DE": "gsg",
	        "sgn-DK": "dsl",
	        "sgn-ES": "ssp",
	        "sgn-FR": "fsl",
	        "sgn-GB": "bfi",
	        "sgn-GR": "gss",
	        "sgn-IE": "isg",
	        "sgn-IT": "ise",
	        "sgn-JP": "jsl",
	        "sgn-MX": "mfs",
	        "sgn-NI": "ncs",
	        "sgn-NL": "dse",
	        "sgn-NO": "nsl",
	        "sgn-PT": "psr",
	        "sgn-SE": "swl",
	        "sgn-US": "ase",
	        "sgn-ZA": "sfs",
	        "zh-cmn": "cmn",
	        "zh-cmn-Hans": "cmn-Hans",
	        "zh-cmn-Hant": "cmn-Hant",
	        "zh-gan": "gan",
	        "zh-wuu": "wuu",
	        "zh-yue": "yue"
	    },
	    subtags: {
	        BU: "MM",
	        DD: "DE",
	        FX: "FR",
	        TP: "TL",
	        YD: "YE",
	        ZR: "CD",
	        heploc: "alalc97",
	        'in': "id",
	        iw: "he",
	        ji: "yi",
	        jw: "jv",
	        mo: "ro",
	        ayx: "nun",
	        bjd: "drl",
	        ccq: "rki",
	        cjr: "mom",
	        cka: "cmr",
	        cmk: "xch",
	        drh: "khk",
	        drw: "prs",
	        gav: "dev",
	        hrr: "jal",
	        ibi: "opa",
	        kgh: "kml",
	        lcq: "ppr",
	        mst: "mry",
	        myt: "mry",
	        sca: "hle",
	        tie: "ras",
	        tkk: "twm",
	        tlw: "weo",
	        tnf: "prs",
	        ybd: "rki",
	        yma: "lrr"
	    },
	    extLang: {
	        aao: ["aao", "ar"],
	        abh: ["abh", "ar"],
	        abv: ["abv", "ar"],
	        acm: ["acm", "ar"],
	        acq: ["acq", "ar"],
	        acw: ["acw", "ar"],
	        acx: ["acx", "ar"],
	        acy: ["acy", "ar"],
	        adf: ["adf", "ar"],
	        ads: ["ads", "sgn"],
	        aeb: ["aeb", "ar"],
	        aec: ["aec", "ar"],
	        aed: ["aed", "sgn"],
	        aen: ["aen", "sgn"],
	        afb: ["afb", "ar"],
	        afg: ["afg", "sgn"],
	        ajp: ["ajp", "ar"],
	        apc: ["apc", "ar"],
	        apd: ["apd", "ar"],
	        arb: ["arb", "ar"],
	        arq: ["arq", "ar"],
	        ars: ["ars", "ar"],
	        ary: ["ary", "ar"],
	        arz: ["arz", "ar"],
	        ase: ["ase", "sgn"],
	        asf: ["asf", "sgn"],
	        asp: ["asp", "sgn"],
	        asq: ["asq", "sgn"],
	        asw: ["asw", "sgn"],
	        auz: ["auz", "ar"],
	        avl: ["avl", "ar"],
	        ayh: ["ayh", "ar"],
	        ayl: ["ayl", "ar"],
	        ayn: ["ayn", "ar"],
	        ayp: ["ayp", "ar"],
	        bbz: ["bbz", "ar"],
	        bfi: ["bfi", "sgn"],
	        bfk: ["bfk", "sgn"],
	        bjn: ["bjn", "ms"],
	        bog: ["bog", "sgn"],
	        bqn: ["bqn", "sgn"],
	        bqy: ["bqy", "sgn"],
	        btj: ["btj", "ms"],
	        bve: ["bve", "ms"],
	        bvl: ["bvl", "sgn"],
	        bvu: ["bvu", "ms"],
	        bzs: ["bzs", "sgn"],
	        cdo: ["cdo", "zh"],
	        cds: ["cds", "sgn"],
	        cjy: ["cjy", "zh"],
	        cmn: ["cmn", "zh"],
	        coa: ["coa", "ms"],
	        cpx: ["cpx", "zh"],
	        csc: ["csc", "sgn"],
	        csd: ["csd", "sgn"],
	        cse: ["cse", "sgn"],
	        csf: ["csf", "sgn"],
	        csg: ["csg", "sgn"],
	        csl: ["csl", "sgn"],
	        csn: ["csn", "sgn"],
	        csq: ["csq", "sgn"],
	        csr: ["csr", "sgn"],
	        czh: ["czh", "zh"],
	        czo: ["czo", "zh"],
	        doq: ["doq", "sgn"],
	        dse: ["dse", "sgn"],
	        dsl: ["dsl", "sgn"],
	        dup: ["dup", "ms"],
	        ecs: ["ecs", "sgn"],
	        esl: ["esl", "sgn"],
	        esn: ["esn", "sgn"],
	        eso: ["eso", "sgn"],
	        eth: ["eth", "sgn"],
	        fcs: ["fcs", "sgn"],
	        fse: ["fse", "sgn"],
	        fsl: ["fsl", "sgn"],
	        fss: ["fss", "sgn"],
	        gan: ["gan", "zh"],
	        gds: ["gds", "sgn"],
	        gom: ["gom", "kok"],
	        gse: ["gse", "sgn"],
	        gsg: ["gsg", "sgn"],
	        gsm: ["gsm", "sgn"],
	        gss: ["gss", "sgn"],
	        gus: ["gus", "sgn"],
	        hab: ["hab", "sgn"],
	        haf: ["haf", "sgn"],
	        hak: ["hak", "zh"],
	        hds: ["hds", "sgn"],
	        hji: ["hji", "ms"],
	        hks: ["hks", "sgn"],
	        hos: ["hos", "sgn"],
	        hps: ["hps", "sgn"],
	        hsh: ["hsh", "sgn"],
	        hsl: ["hsl", "sgn"],
	        hsn: ["hsn", "zh"],
	        icl: ["icl", "sgn"],
	        ils: ["ils", "sgn"],
	        inl: ["inl", "sgn"],
	        ins: ["ins", "sgn"],
	        ise: ["ise", "sgn"],
	        isg: ["isg", "sgn"],
	        isr: ["isr", "sgn"],
	        jak: ["jak", "ms"],
	        jax: ["jax", "ms"],
	        jcs: ["jcs", "sgn"],
	        jhs: ["jhs", "sgn"],
	        jls: ["jls", "sgn"],
	        jos: ["jos", "sgn"],
	        jsl: ["jsl", "sgn"],
	        jus: ["jus", "sgn"],
	        kgi: ["kgi", "sgn"],
	        knn: ["knn", "kok"],
	        kvb: ["kvb", "ms"],
	        kvk: ["kvk", "sgn"],
	        kvr: ["kvr", "ms"],
	        kxd: ["kxd", "ms"],
	        lbs: ["lbs", "sgn"],
	        lce: ["lce", "ms"],
	        lcf: ["lcf", "ms"],
	        liw: ["liw", "ms"],
	        lls: ["lls", "sgn"],
	        lsg: ["lsg", "sgn"],
	        lsl: ["lsl", "sgn"],
	        lso: ["lso", "sgn"],
	        lsp: ["lsp", "sgn"],
	        lst: ["lst", "sgn"],
	        lsy: ["lsy", "sgn"],
	        ltg: ["ltg", "lv"],
	        lvs: ["lvs", "lv"],
	        lzh: ["lzh", "zh"],
	        max: ["max", "ms"],
	        mdl: ["mdl", "sgn"],
	        meo: ["meo", "ms"],
	        mfa: ["mfa", "ms"],
	        mfb: ["mfb", "ms"],
	        mfs: ["mfs", "sgn"],
	        min: ["min", "ms"],
	        mnp: ["mnp", "zh"],
	        mqg: ["mqg", "ms"],
	        mre: ["mre", "sgn"],
	        msd: ["msd", "sgn"],
	        msi: ["msi", "ms"],
	        msr: ["msr", "sgn"],
	        mui: ["mui", "ms"],
	        mzc: ["mzc", "sgn"],
	        mzg: ["mzg", "sgn"],
	        mzy: ["mzy", "sgn"],
	        nan: ["nan", "zh"],
	        nbs: ["nbs", "sgn"],
	        ncs: ["ncs", "sgn"],
	        nsi: ["nsi", "sgn"],
	        nsl: ["nsl", "sgn"],
	        nsp: ["nsp", "sgn"],
	        nsr: ["nsr", "sgn"],
	        nzs: ["nzs", "sgn"],
	        okl: ["okl", "sgn"],
	        orn: ["orn", "ms"],
	        ors: ["ors", "ms"],
	        pel: ["pel", "ms"],
	        pga: ["pga", "ar"],
	        pks: ["pks", "sgn"],
	        prl: ["prl", "sgn"],
	        prz: ["prz", "sgn"],
	        psc: ["psc", "sgn"],
	        psd: ["psd", "sgn"],
	        pse: ["pse", "ms"],
	        psg: ["psg", "sgn"],
	        psl: ["psl", "sgn"],
	        pso: ["pso", "sgn"],
	        psp: ["psp", "sgn"],
	        psr: ["psr", "sgn"],
	        pys: ["pys", "sgn"],
	        rms: ["rms", "sgn"],
	        rsi: ["rsi", "sgn"],
	        rsl: ["rsl", "sgn"],
	        sdl: ["sdl", "sgn"],
	        sfb: ["sfb", "sgn"],
	        sfs: ["sfs", "sgn"],
	        sgg: ["sgg", "sgn"],
	        sgx: ["sgx", "sgn"],
	        shu: ["shu", "ar"],
	        slf: ["slf", "sgn"],
	        sls: ["sls", "sgn"],
	        sqk: ["sqk", "sgn"],
	        sqs: ["sqs", "sgn"],
	        ssh: ["ssh", "ar"],
	        ssp: ["ssp", "sgn"],
	        ssr: ["ssr", "sgn"],
	        svk: ["svk", "sgn"],
	        swc: ["swc", "sw"],
	        swh: ["swh", "sw"],
	        swl: ["swl", "sgn"],
	        syy: ["syy", "sgn"],
	        tmw: ["tmw", "ms"],
	        tse: ["tse", "sgn"],
	        tsm: ["tsm", "sgn"],
	        tsq: ["tsq", "sgn"],
	        tss: ["tss", "sgn"],
	        tsy: ["tsy", "sgn"],
	        tza: ["tza", "sgn"],
	        ugn: ["ugn", "sgn"],
	        ugy: ["ugy", "sgn"],
	        ukl: ["ukl", "sgn"],
	        uks: ["uks", "sgn"],
	        urk: ["urk", "ms"],
	        uzn: ["uzn", "uz"],
	        uzs: ["uzs", "uz"],
	        vgt: ["vgt", "sgn"],
	        vkk: ["vkk", "ms"],
	        vkt: ["vkt", "ms"],
	        vsi: ["vsi", "sgn"],
	        vsl: ["vsl", "sgn"],
	        vsv: ["vsv", "sgn"],
	        wuu: ["wuu", "zh"],
	        xki: ["xki", "sgn"],
	        xml: ["xml", "sgn"],
	        xmm: ["xmm", "ms"],
	        xms: ["xms", "sgn"],
	        yds: ["yds", "sgn"],
	        ysl: ["ysl", "sgn"],
	        yue: ["yue", "zh"],
	        zib: ["zib", "sgn"],
	        zlm: ["zlm", "ms"],
	        zmi: ["zmi", "ms"],
	        zsl: ["zsl", "sgn"],
	        zsm: ["zsm", "ms"]
	    }
	};
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase(str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
	    }
	
	    return str;
	}
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!expBCP47Syntax.test(locale)) return false;
	
	    // does not include duplicate variant subtags, and
	    if (expVariantDupes.test(locale)) return false;
	
	    // does not include duplicate singleton subtags.
	    if (expSingletonDupes.test(locale)) return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
	    var match = void 0,
	        parts = void 0;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	            // Is it a singleton?
	            else if (parts[i].length === 1 && parts[i] !== 'x') break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
	        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
	            parts[_i] = redundantTags.extLang[parts[_i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, _i++);
	                _max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale() {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	var expCurrencyCode = /^[A-Z]{3}$/;
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    // 1. Let `c` be ToString(currency)
	    var c = String(currency);
	
	    // 2. Let `normalized` be the result of mapping c to upper case as described
	    //    in 6.1.
	    var normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false) return false;
	
	    // 5. Return true
	    return true;
	}
	
	var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below
	
	function /* 9.2.1 */CanonicalizeLocaleList(locales) {
	    // The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined) return new List();
	
	    // 2. Let seen be a new empty List.
	    var seen = new List();
	
	    // 3. If locales is a String value, then
	    //    a. Let locales be a new array created as if by the expression new
	    //    Array(locales) where Array is the standard built-in constructor with
	    //    that name and locales is the value of locales.
	    locales = typeof locales === 'string' ? [locales] : locales;
	
	    // 4. Let O be ToObject(locales).
	    var O = toObject(locales);
	
	    // 5. Let lenValue be the result of calling the [[Get]] internal method of
	    //    O with the argument "length".
	    // 6. Let len be ToUint32(lenValue).
	    var len = toLength(O.length);
	
	    // 7. Let k be 0.
	    var k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        // a. Let Pk be ToString(k).
	        var Pk = String(k);
	
	        // b. Let kPresent be the result of calling the [[HasProperty]] internal
	        //    method of O with argument Pk.
	        var kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            // i. Let kValue be the result of calling the [[Get]] internal
	            //     method of O with argument Pk.
	            var kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');
	
	            // iii. Let tag be ToString(kValue).
	            var tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
	    // 1. Let candidate be locale
	    var candidate = locale;
	
	    // 2. Repeat
	    while (candidate) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;
	
	        // b. Let pos be the character index of the last occurrence of "-"
	        // (U+002D) within candidate. If that character does not occur, return
	        // undefined.
	        var pos = candidate.lastIndexOf('-');
	
	        if (pos < 0) return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
	    // 1. Let i be 0.
	    var i = 0;
	
	    // 2. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	
	    // 3. Let availableLocale be undefined.
	    var availableLocale = void 0;
	
	    var locale = void 0,
	        noExtensionsLocale = void 0;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position i.
	        locale = requestedLocales[i];
	
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    // 5. Let result be a new Record.
	    var result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            // i. Let extension be the String value consisting of the first
	            //    substring of locale that is a Unicode locale extension sequence.
	            var extension = locale.match(expUnicodeExSeq)[0];
	
	            // ii. Let extensionIndex be the character position of the initial
	            //     "-" of the first Unicode locale extension sequence within locale.
	            var extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    // 1. Let matcher be the value of options.[[localeMatcher]].
	    var matcher = options['[[localeMatcher]]'];
	
	    var r = void 0;
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        // a. Let r be the result of calling the LookupMatcher abstract operation
	        //    (defined in 9.2.3) with arguments availableLocales and
	        //    requestedLocales.
	        r = LookupMatcher(availableLocales, requestedLocales);
	
	        // 3. Else
	    else
	        // a. Let r be the result of calling the BestFitMatcher abstract
	        //    operation (defined in 9.2.4) with arguments availableLocales and
	        //    requestedLocales.
	        r = BestFitMatcher(availableLocales, requestedLocales);
	
	    // 4. Let foundLocale be the value of r.[[locale]].
	    var foundLocale = r['[[locale]]'];
	
	    var extensionSubtags = void 0,
	        extensionSubtagsLength = void 0;
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]')) {
	        // a. Let extension be the value of r.[[extension]].
	        var extension = r['[[extension]]'];
	        // b. Let split be the standard built-in function object defined in ES5,
	        //    15.5.4.14.
	        var split = String.prototype.split;
	        // c. Let extensionSubtags be the result of calling the [[Call]] internal
	        //    method of split with extension as the this value and an argument
	        //    list containing the single item "-".
	        extensionSubtags = split.call(extension, '-');
	        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
	        //    internal method of extensionSubtags with argument "length".
	        extensionSubtagsLength = extensionSubtags.length;
	    }
	
	    // 6. Let result be a new Record.
	    var result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    // 8. Let supportedExtension be "-u".
	    var supportedExtension = '-u';
	    // 9. Let i be 0.
	    var i = 0;
	    // 10. Let len be the result of calling the [[Get]] internal method of
	    //     relevantExtensionKeys with argument "length".
	    var len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        // a. Let key be the result of calling the [[Get]] internal method of
	        //    relevantExtensionKeys with argument ToString(i).
	        var key = relevantExtensionKeys[i];
	        // b. Let foundLocaleData be the result of calling the [[Get]] internal
	        //    method of localeData with the argument foundLocale.
	        var foundLocaleData = localeData[foundLocale];
	        // c. Let keyLocaleData be the result of calling the [[Get]] internal
	        //    method of foundLocaleData with the argument key.
	        var keyLocaleData = foundLocaleData[key];
	        // d. Let value be the result of calling the [[Get]] internal method of
	        //    keyLocaleData with argument "0".
	        var value = keyLocaleData['0'];
	        // e. Let supportedExtensionAddition be "".
	        var supportedExtensionAddition = '';
	        // f. Let indexOf be the standard built-in function object defined in
	        //    ES5, 15.4.4.14.
	        var indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            // i. Let keyPos be the result of calling the [[Call]] internal
	            //    method of indexOf with extensionSubtags as the this value and
	            // an argument list containing the single item key.
	            var keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
	                    // a. Let requestedValue be the result of calling the [[Get]]
	                    //    internal method of extensionSubtags with argument
	                    //    ToString(keyPos + 1).
	                    var requestedValue = extensionSubtags[keyPos + 1];
	                    // b. Let valuePos be the result of calling the [[Call]]
	                    //    internal method of indexOf with keyLocaleData as the
	                    //    this value and an argument list containing the single
	                    //    item requestedValue.
	                    var valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1) {
	                        // i. Let value be requestedValue.
	                        value = requestedValue,
	                        // ii. Let supportedExtensionAddition be the
	                        //     concatenation of "-", key, "-", and value.
	                        supportedExtensionAddition = '-' + key + '-' + value;
	                    }
	                }
	                // 2. Else
	                else {
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        var _valuePos = indexOf(keyLocaleData, 'true');
	
	                        // b. If valuePos ≠ -1, then
	                        if (_valuePos !== -1)
	                            // i. Let value be "true".
	                            value = 'true';
	                    }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            // i. Let optionsValue be the value of options.[[<key>]].
	            var optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        // a.
	        var privateIndex = foundLocale.indexOf("-x-");
	        // b.
	        if (privateIndex === -1) {
	            // i.
	            foundLocale = foundLocale + supportedExtension;
	        }
	        // c.
	        else {
	                // i.
	                var preExtension = foundLocale.substring(0, privateIndex);
	                // ii.
	                var postExtension = foundLocale.substring(privateIndex);
	                // iii.
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	        // d. asserting - skipping
	        // e.
	        foundLocale = CanonicalizeLanguageTag(foundLocale);
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
	    // 1. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	    // 2. Let subset be a new empty List.
	    var subset = new List();
	    // 3. Let k be 0.
	    var k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position k.
	        var locale = requestedLocales[k];
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined) arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    // 5. Let subsetArray be a new Array object whose elements are the same
	    //    values in the same order as the elements of subset.
	    var subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = void 0,
	        subset = void 0;
	
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        // a. Let options be ToObject(options).
	        options = new Record(toObject(options));
	        // b. Let matcher be the result of calling the [[Get]] internal method of
	        //    options with argument "localeMatcher".
	        matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        // a. Let subset be the result of calling the BestFitSupportedLocales
	        //    abstract operation (defined in 9.2.7) with arguments
	        //    availableLocales and requestedLocales.
	        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	        // 3. Else
	    else
	        // a. Let subset be the result of calling the LookupSupportedLocales
	        //    abstract operation (defined in 9.2.6) with arguments
	        //    availableLocales and requestedLocales.
	        subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P)) continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption(options, property, type, values, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 8 The Intl Object
	var Intl = {};
	
	// 8.2 Function Properties of the Intl Object
	
	// 8.2.1
	// @spec[tc39/ecma402/master/spec/intl.html]
	// @clause[sec-intl.getcanonicallocales]
	function getCanonicalLocales(locales) {
	    // 1. Let ll be ? CanonicalizeLocaleList(locales).
	    var ll = CanonicalizeLocaleList(locales);
	    // 2. Return CreateArrayFromList(ll).
	    {
	        var result = [];
	
	        var len = ll.length;
	        var k = 0;
	
	        while (k < len) {
	            result[k] = ll[k];
	            k++;
	        }
	        return result;
	    }
	}
	
	Object.defineProperty(Intl, 'getCanonicalLocales', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: getCanonicalLocales
	});
	
	// Currency minor units output from get-4217 grunt task, formatted
	var currencyMinorUnits = {
	    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	};
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(numberFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	        // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    // 6. Let opt be a new Record.
	    var opt = new Record(),
	
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	    var localeData = internals.NumberFormat['[[localeData]]'];
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	    var c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');
	
	    var cDigits = void 0;
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	        cDigits = CurrencyDigits(c);
	    }
	
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;
	
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	    var mnfdDefault = s === 'currency' ? cDigits : 0;
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	    var mnsd = options.minimumSignificantDigits;
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	    var mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	    var patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	    var stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */
	defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 11.3_b
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this NumberFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 1, that takes the argument value and
	        //    performs the following steps:
	        var F = function F(value) {
	            // i. If value is not provided, then let value be undefined.
	            // ii. Let x be ToNumber(value).
	            // iii. Return the result of calling the FormatNumber abstract
	            //      operation (defined below) with arguments this and x.
	            return FormatNumber(this, /* x = */Number(value));
	        };
	
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');
	
	    var x = Number(value);
	    return FormatNumberToParts(this, x);
	}
	
	Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
	    configurable: true,
	    enumerable: false,
	    writable: true,
	    value: formatToParts
	});
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumbertoparts]
	 */
	function FormatNumberToParts(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be ArrayCreate(0).
	    var result = [];
	    // 3. Let n be 0.
	    var n = 0;
	    // 4. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Let O be ObjectCreate(%ObjectPrototype%).
	        var O = {};
	        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
	        O.type = part['[[type]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
	        O.value = part['[[value]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
	        result[n] = O;
	        // a. Increment n by 1.
	        n += 1;
	    }
	    // 5. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-partitionnumberpattern]
	 */
	function PartitionNumberPattern(numberFormat, x) {
	
	    var internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums = internal['[[numberingSystem]]'],
	        data = internals.NumberFormat['[[localeData]]'][locale],
	        ild = data.symbols[nums] || data.symbols.latn,
	        pattern = void 0;
	
	    // 1. If x is not NaN and x < 0, then:
	    if (!isNaN(x) && x < 0) {
	        // a. Let x be -x.
	        x = -x;
	        // a. Let pattern be the value of numberFormat.[[negativePattern]].
	        pattern = internal['[[negativePattern]]'];
	    }
	    // 2. Else,
	    else {
	            // a. Let pattern be the value of numberFormat.[[positivePattern]].
	            pattern = internal['[[positivePattern]]'];
	        }
	    // 3. Let result be a new empty List.
	    var result = new List();
	    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
	    var beginIndex = pattern.indexOf('{', 0);
	    // 5. Let endIndex be 0.
	    var endIndex = 0;
	    // 6. Let nextIndex be 0.
	    var nextIndex = 0;
	    // 7. Let length be the number of code units in pattern.
	    var length = pattern.length;
	    // 8. Repeat while beginIndex is an integer index into pattern:
	    while (beginIndex > -1 && beginIndex < length) {
	        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
	        endIndex = pattern.indexOf('}', beginIndex);
	        // a. If endIndex = -1, throw new Error exception.
	        if (endIndex === -1) throw new Error();
	        // a. If beginIndex is greater than nextIndex, then:
	        if (beginIndex > nextIndex) {
	            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
	            var literal = pattern.substring(nextIndex, beginIndex);
	            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
	        }
	        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // a. If p is equal "number", then:
	        if (p === "number") {
	            // i. If x is NaN,
	            if (isNaN(x)) {
	                // 1. Let n be an ILD String value indicating the NaN value.
	                var n = ild.nan;
	                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
	            }
	            // ii. Else if isFinite(x) is false,
	            else if (!isFinite(x)) {
	                    // 1. Let n be an ILD String value indicating infinity.
	                    var _n = ild.infinity;
	                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
	                }
	                // iii. Else,
	                else {
	                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
	                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;
	
	                        var _n2 = void 0;
	                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
	                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
	                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
	                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
	                        }
	                        // 3. Else,
	                        else {
	                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
	                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
	                            }
	                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
	                        if (numSys[nums]) {
	                            (function () {
	                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
	                                var digits = numSys[nums];
	                                // a. Replace each digit in n with the value of digits[digit].
	                                _n2 = String(_n2).replace(/\d/g, function (digit) {
	                                    return digits[digit];
	                                });
	                            })();
	                        }
	                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
	                        else _n2 = String(_n2); // ###TODO###
	
	                        var integer = void 0;
	                        var fraction = void 0;
	                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
	                        var decimalSepIndex = _n2.indexOf('.', 0);
	                        // 7. If decimalSepIndex > 0, then:
	                        if (decimalSepIndex > 0) {
	                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
	                            integer = _n2.substring(0, decimalSepIndex);
	                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
	                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
	                        }
	                        // 8. Else:
	                        else {
	                                // a. Let integer be n.
	                                integer = _n2;
	                                // a. Let fraction be undefined.
	                                fraction = undefined;
	                            }
	                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
	                        if (internal['[[useGrouping]]'] === true) {
	                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
	                            var groupSepSymbol = ild.group;
	                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
	                            var groups = [];
	                            // ----> implementation:
	                            // Primary group represents the group closest to the decimal
	                            var pgSize = data.patterns.primaryGroupSize || 3;
	                            // Secondary group is every other group
	                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
	                            // Group only if necessary
	                            if (integer.length > pgSize) {
	                                // Index of the primary grouping separator
	                                var end = integer.length - pgSize;
	                                // Starting index for our loop
	                                var idx = end % sgSize;
	                                var start = integer.slice(0, idx);
	                                if (start.length) arrPush.call(groups, start);
	                                // Loop to separate into secondary grouping digits
	                                while (idx < end) {
	                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
	                                    idx += sgSize;
	                                }
	                                // Add the primary grouping digits
	                                arrPush.call(groups, integer.slice(end));
	                            } else {
	                                arrPush.call(groups, integer);
	                            }
	                            // a. Assert: The number of elements in groups List is greater than 0.
	                            if (groups.length === 0) throw new Error();
	                            // a. Repeat, while groups List is not empty:
	                            while (groups.length) {
	                                // i. Remove the first element from groups and let integerGroup be the value of that element.
	                                var integerGroup = arrShift.call(groups);
	                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
	                                // iii. If groups List is not empty, then:
	                                if (groups.length) {
	                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
	                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
	                                }
	                            }
	                        }
	                        // 10. Else,
	                        else {
	                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
	                            }
	                        // 11. If fraction is not undefined, then:
	                        if (fraction !== undefined) {
	                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
	                            var decimalSepSymbol = ild.decimal;
	                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
	                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
	                        }
	                    }
	        }
	        // a. Else if p is equal "plusSign", then:
	        else if (p === "plusSign") {
	                // i. Let plusSignSymbol be the ILND String representing the plus sign.
	                var plusSignSymbol = ild.plusSign;
	                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
	            }
	            // a. Else if p is equal "minusSign", then:
	            else if (p === "minusSign") {
	                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
	                    var minusSignSymbol = ild.minusSign;
	                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
	                }
	                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
	                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
	                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
	                        var percentSignSymbol = ild.percentSign;
	                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
	                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
	                    }
	                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
	                    else if (p === "currency" && internal['[[style]]'] === "currency") {
	                            // i. Let currency be the value of numberFormat.[[currency]].
	                            var currency = internal['[[currency]]'];
	
	                            var cd = void 0;
	
	                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
	                            if (internal['[[currencyDisplay]]'] === "code") {
	                                // 1. Let cd be currency.
	                                cd = currency;
	                            }
	                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
	                            else if (internal['[[currencyDisplay]]'] === "symbol") {
	                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
	                                    cd = data.currencies[currency] || currency;
	                                }
	                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
	                                else if (internal['[[currencyDisplay]]'] === "name") {
	                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
	                                        cd = currency;
	                                    }
	                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
	                        }
	                        // a. Else,
	                        else {
	                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
	                                var _literal = pattern.substring(beginIndex, endIndex);
	                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
	                            }
	        // a. Set nextIndex to endIndex + 1.
	        nextIndex = endIndex + 1;
	        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    // 9. If nextIndex is less than length, then:
	    if (nextIndex < length) {
	        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
	        var _literal2 = pattern.substring(nextIndex, length);
	        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
	    }
	    // 10. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumber]
	 */
	function FormatNumber(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be an empty String.
	    var result = '';
	    // 3. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Set result to a String value produced by concatenating result and part.[[value]].
	        result += part['[[value]]'];
	    }
	    // 4. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    // 1. Let p be maxPrecision.
	    var p = maxPrecision;
	
	    var m = void 0,
	        e = void 0;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        // a. Let m be the String consisting of p occurrences of the character "0".
	        m = arrJoin.call(Array(p + 1), '0');
	        // b. Let e be 0.
	        e = 0;
	    }
	    // 3. Else
	    else {
	            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	            //    possible. If there are two such sets of e and n, pick the e and n for
	            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	            e = log10Floor(Math.abs(x));
	
	            // Easier to get to m from here
	            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));
	
	            // b. Let m be the String consisting of the digits of the decimal
	            //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	        }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e - p + 1 + 1), '0');
	
	        // 5. If e = p-1, then
	    else if (e === p - 1)
	            // a. Return m.
	            return m;
	
	            // 6. If e ≥ 0, then
	        else if (e >= 0)
	                // a. Let m be the concatenation of the first e+1 characters of m, the character
	                //    ".", and the remaining p–(e+1) characters of m.
	                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	                // 7. If e < 0, then
	            else if (e < 0)
	                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	                    //    character "0", and the string m.
	                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        // a. Let cut be maxPrecision – minPrecision.
	        var cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length - 1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length - 1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * @spec[tc39/ecma402/master/spec/numberformat.html]
	 * @clause[sec-torawfixed]
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed(x, minInteger, minFraction, maxFraction) {
	    // 1. Let f be maxFraction.
	    var f = maxFraction;
	    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
	    var n = Math.pow(10, f) * x; // diverging...
	    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
	    var m = n === 0 ? "0" : n.toFixed(0); // divering...
	
	    {
	        // this diversion is needed to take into consideration big numbers, e.g.:
	        // 1.2344501e+37 -> 12344501000000000000000000000000000000
	        var idx = void 0;
	        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	        if (exp) {
	            m = m.slice(0, idx).replace('.', '');
	            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
	        }
	    }
	
	    var int = void 0;
	    // 4. If f ≠ 0, then
	    if (f !== 0) {
	        // a. Let k be the number of characters in m.
	        var k = m.length;
	        // a. If k ≤ f, then
	        if (k <= f) {
	            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
	            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
	            // ii. Let m be the concatenation of Strings z and m.
	            m = z + m;
	            // iii. Let k be f+1.
	            k = f + 1;
	        }
	        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
	        var a = m.substring(0, k - f),
	            b = m.substring(k - f, m.length);
	        // a. Let m be the concatenation of the three Strings a, ".", and b.
	        m = a + "." + b;
	        // a. Let int be the number of characters in a.
	        int = a.length;
	    }
	    // 5. Else, let int be the number of characters in m.
	    else int = m.length;
	    // 6. Let cut be maxFraction – minFraction.
	    var cut = maxFraction - minFraction;
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	        // a. Decrease cut by 1.
	        cut--;
	    }
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	    }
	    // 9. If int < minInteger, then
	    if (int < minInteger) {
	        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
	        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
	        // a. Let m be the concatenation of Strings z and m.
	        m = _z + m;
	    }
	    // 10. Return m.
	    return m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
	    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
	    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
	    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
	    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
	    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
	    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
	    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
	    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
	    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
	    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
	    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
	    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
	    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
	    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
	    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
	    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
	    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
	    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
	    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
	    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	// trim patterns after transformations
	var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	// Skip over patterns with these datetime components because we don't have data
	// to back them up:
	// timezone, weekday, amoung others
	var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string
	
	var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
	var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
	    var o = { _: {} };
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (dateFormatObj[dtKeys[i]]) {
	            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
	        }
	        if (dateFormatObj._[dtKeys[i]]) {
	            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
	        }
	    }
	    for (var j = 0; j < tmKeys.length; j += 1) {
	        if (timeFormatObj[tmKeys[j]]) {
	            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
	        }
	        if (timeFormatObj._[tmKeys[j]]) {
	            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
	        }
	    }
	    return o;
	}
	
	function computeFinalPatterns(formatObj) {
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
	    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
	    return formatObj;
	}
	
	function expDTComponentsMeta($0, formatObj) {
	    switch ($0.charAt(0)) {
	        // --- Era
	        case 'G':
	            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{era}';
	
	        // --- Year
	        case 'y':
	        case 'Y':
	        case 'u':
	        case 'U':
	        case 'r':
	            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{year}';
	
	        // --- Quarter (not supported in this polyfill)
	        case 'Q':
	        case 'q':
	            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{quarter}';
	
	        // --- Month
	        case 'M':
	        case 'L':
	            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{month}';
	
	        // --- Week (not supported in this polyfill)
	        case 'w':
	            // week of the year
	            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{weekday}';
	        case 'W':
	            // week of the month
	            formatObj.week = 'numeric';
	            return '{weekday}';
	
	        // --- Day
	        case 'd':
	            // day of the month
	            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{day}';
	        case 'D': // day of the year
	        case 'F': // day of the week
	        case 'g':
	            // 1..n: Modified Julian day
	            formatObj.day = 'numeric';
	            return '{day}';
	
	        // --- Week Day
	        case 'E':
	            // day of the week
	            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'e':
	            // local day of the week
	            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'c':
	            // stand alone local day of the week
	            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	
	        // --- Period
	        case 'a': // AM, PM
	        case 'b': // am, pm, noon, midnight
	        case 'B':
	            // flexible day periods
	            formatObj.hour12 = true;
	            return '{ampm}';
	
	        // --- Hour
	        case 'h':
	        case 'H':
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	        case 'k':
	        case 'K':
	            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	
	        // --- Minute
	        case 'm':
	            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{minute}';
	
	        // --- Second
	        case 's':
	            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{second}';
	        case 'S':
	        case 'A':
	            formatObj.second = 'numeric';
	            return '{second}';
	
	        // --- Timezone
	        case 'z': // 1..3, 4: specific non-location format
	        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	        case 'O': // 1, 4: miliseconds in day short, long
	        case 'v': // 1, 4: generic non-location format
	        case 'V': // 1, 2, 3, 4: time zone ID or city
	        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	        case 'x':
	            // 1, 2, 3, 4: The ISO8601 varios formats
	            // this polyfill only supports much, for now, we are just doing something dummy
	            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	            return '{timeZoneName}';
	    }
	}
	
	/**
	 * Converts the CLDR availableFormats into the objects and patterns required by
	 * the ECMAScript Internationalization API specification.
	 */
	function createDateTimeFormat(skeleton, pattern) {
	    // we ignore certain patterns that are unsupported to avoid this expensive op.
	    if (unwantedDTCs.test(pattern)) return undefined;
	
	    var formatObj = {
	        originalPattern: pattern,
	        _: {}
	    };
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj._);
	    });
	
	    // Match the skeleton string with the one required by the specification
	    // this implementation is based on the Date Field Symbol Table:
	    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	    // Note: we are adding extra data to the formatObject even though this polyfill
	    //       might not support it.
	    skeleton.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj);
	    });
	
	    return computeFinalPatterns(formatObj);
	}
	
	/**
	 * Processes DateTime formats from CLDR to an easier-to-parse format.
	 * the result of this operation should be cached the first time a particular
	 * calendar is analyzed.
	 *
	 * The specification requires we support at least the following subsets of
	 * date/time components:
	 *
	 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
	 *   - 'weekday', 'year', 'month', 'day'
	 *   - 'year', 'month', 'day'
	 *   - 'year', 'month'
	 *   - 'month', 'day'
	 *   - 'hour', 'minute', 'second'
	 *   - 'hour', 'minute'
	 *
	 * We need to cherry pick at least these subsets from the CLDR data and convert
	 * them into the pattern objects used in the ECMA-402 API.
	 */
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var result = [];
	    var skeleton = void 0,
	        pattern = void 0,
	        computed = void 0,
	        i = void 0,
	        j = void 0;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (skeleton in availableFormats) {
	        if (availableFormats.hasOwnProperty(skeleton)) {
	            pattern = availableFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(computed);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(computed);
	                }
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (skeleton in timeFormats) {
	        if (timeFormats.hasOwnProperty(skeleton)) {
	            pattern = timeFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                timeRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (skeleton in dateFormats) {
	        if (dateFormats.hasOwnProperty(skeleton)) {
	            pattern = dateFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                dateRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by CLDR.
	    // This Algo is based on section "Missing Skeleton Fields" from:
	    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            if (dateRelatedFormats[j].month === 'long') {
	                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
	            } else if (dateRelatedFormats[j].month === 'short') {
	                pattern = formats.medium;
	            } else {
	                pattern = formats.short;
	            }
	            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
	            computed.originalPattern = pattern;
	            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
	            result.push(computeFinalPatterns(computed));
	        }
	    }
	
	    return result;
	}
	
	// this represents the exceptions of the rule that are not covered by CLDR availableFormats
	// for single property configurations, they play no role when using multiple properties, and
	// those that are not in this table, are not exceptions or are not covered by the data we
	// provide.
	var validSyntheticProps = {
	    second: {
	        numeric: 's',
	        '2-digit': 'ss'
	    },
	    minute: {
	        numeric: 'm',
	        '2-digit': 'mm'
	    },
	    year: {
	        numeric: 'y',
	        '2-digit': 'yy'
	    },
	    day: {
	        numeric: 'd',
	        '2-digit': 'dd'
	    },
	    month: {
	        numeric: 'L',
	        '2-digit': 'LL',
	        narrow: 'LLLLL',
	        short: 'LLL',
	        long: 'LLLL'
	    },
	    weekday: {
	        narrow: 'ccccc',
	        short: 'ccc',
	        long: 'cccc'
	    }
	};
	
	function generateSyntheticFormat(propName, propValue) {
	    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
	        var _ref2;
	
	        return _ref2 = {
	            originalPattern: validSyntheticProps[propName][propValue],
	            _: defineProperty$1({}, propName, propValue),
	            extendedPattern: "{" + propName + "}"
	        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
	    }
	}
	
	// An object map of date component keys, saves using a regex later
	var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],
	
	
	    // "sideways" inheritance resolves strings when a key doesn't exist
	    alts = {
	        narrow: ['short', 'long'],
	        short: ['long', 'narrow'],
	        long: ['short', 'narrow']
	    },
	
	
	    //
	    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key !== null ? resolved[key] : resolved;
	}
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(dateTimeFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	    options = ToDateTimeOptions(options, 'any', 'date');
	
	    // 5. Let opt be a new Record.
	    var opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	    var localeData = DateTimeFormat['[[localeData]]'];
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	    var tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop)) continue;
	
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[[' + prop + ']]'] = value;
	    }
	
	    // Assigned a value below
	    var bestFormat = void 0;
	
	    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 24. Let formats be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "formats".
	    //     Note: we process the CLDR formats into the spec'd structure
	    var formats = ToDateTimeFormats(dataLocaleData.formats);
	
	    // 25. Let matcher be the result of calling the GetOption abstract operation with
	    //     arguments options, "formatMatcher", "string", a List containing the two String
	    //     values "basic" and "best fit", and "best fit".
	    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic') {
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	        // 28. Else
	    } else {
	        {
	            // diverging
	            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
	        }
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	    }
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var _prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, _prop)) continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, _prop)) {
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	            var p = bestFormat[_prop];
	            {
	                // diverging
	                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
	            }
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[[' + _prop + ']]'] = p;
	        }
	    }
	
	    var pattern = void 0; // Assigned a value below
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	            var hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	    weekday: ["narrow", "short", "long"],
	    era: ["narrow", "short", "long"],
	    year: ["2-digit", "numeric"],
	    month: ["2-digit", "numeric", "narrow", "short", "long"],
	    day: ["2-digit", "numeric"],
	    hour: ["2-digit", "numeric"],
	    minute: ["2-digit", "numeric"],
	    second: ["2-digit", "numeric"],
	    timeZoneName: ["short", "long"]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions(options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined) options = null;else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2) {
	            options[k] = opt2[k];
	        }
	    }
	
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	    var create = objCreate;
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	    options = create(options);
	
	    // 4. Let needDefaults be true.
	    var needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher(options, formats) {
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        // 5. If delta = 2, decrease score by longMorePenalty.
	                        if (delta === 2) score -= longMorePenalty;
	
	                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                        else if (delta === 1) score -= shortMorePenalty;
	
	                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                            else if (delta === -1) score -= shortLessPenalty;
	
	                                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                                else if (delta === -2) score -= longLessPenalty;
	                    }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * This algo relies on the concept of closest distance matching described here:
	 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
	 * Typically a “best match” is found using a closest distance match, such as:
	 *
	 * Symbols requesting a best choice for the locale are replaced.
	 *      j → one of {H, k, h, K}; C → one of {a, b, B}
	 * -> Covered by cldr.js matching process
	 *
	 * For fields with symbols representing the same type (year, month, day, etc):
	 *     Most symbols have a small distance from each other.
	 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
	 *     -> Covered by cldr.js matching process
	 *
	 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
	 *         MMM ≅ MMMM
	 *         MM ≅ M
	 *     Numeric and text fields are given a larger distance from each other.
	 *         MMM ≈ MM
	 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
	 *         d ≋ D; ...
	 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
	 *
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher(options, formats) {
	    /** Diverging: this block implements the hack for single property configuration, eg.:
	     *
	     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
	     *
	     * should produce a single digit with the day of the month. This is needed because
	     * CLDR `availableFormats` data structure doesn't cover these cases.
	     */
	    {
	        var optionsPropNames = [];
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            if (options['[[' + property + ']]'] !== undefined) {
	                optionsPropNames.push(property);
	            }
	        }
	        if (optionsPropNames.length === 1) {
	            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
	            if (_bestFormat) {
	                return _bestFormat;
	            }
	        }
	    }
	
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    var patternPenalty = 2;
	
	    var hour12Penalty = 1;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var _property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, _property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + _property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, _property) ? format[_property] : undefined;
	
	            // Diverging: using the default properties produced by the pattern/skeleton
	            // to match it with user options, and apply a penalty
	            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
	            if (optionsProp !== patternProp) {
	                score -= patternPenalty;
	            }
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        {
	                            // diverging from spec
	                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
	                            } else {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
	                            }
	                        }
	                    }
	        }
	
	        {
	            // diverging to also take into consideration differences between 12 or 24 hours
	            // which is special for the best fit only.
	            if (format._.hour12 !== options.hour12) {
	                score -= hour12Penalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */
	defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	        var F = function F() {
	            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	            //   i. If date is not provided or is undefined, then let x be the
	            //      result as if by the expression Date.now() where Date.now is
	            //      the standard built-in function defined in ES5, 15.9.4.4.
	            //  ii. Else let x be ToNumber(date).
	            // iii. Return the result of calling the FormatDateTime abstract
	            //      operation (defined below) with arguments this and x.
	            var x = date === undefined ? Date.now() : toNumber(date);
	            return FormatDateTime(this, x);
	        };
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts$1() {
	    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');
	
	    var x = date === undefined ? Date.now() : toNumber(date);
	    return FormatToPartsDateTime(this, x);
	}
	
	Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
	    enumerable: false,
	    writable: true,
	    configurable: true,
	    value: formatToParts$1
	});
	
	function CreateDateTimeParts(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');
	
	    var internal = dateTimeFormat.__getInternalProperties(secret);
	
	    // Creating restore point for properties on the RegExp object... please wait
	    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	    var locale = internal['[[locale]]'];
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    var nf = new Intl.NumberFormat([locale], { useGrouping: false });
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	    var pattern = internal['[[pattern]]'];
	
	    // 7.
	    var result = new List();
	
	    // 8.
	    var index = 0;
	
	    // 9.
	    var beginIndex = pattern.indexOf('{');
	
	    // 10.
	    var endIndex = 0;
	
	    // Need the locale minus any extensions
	    var dataLocale = internal['[[dataLocale]]'];
	
	    // Need the calendar data from CLDR
	    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
	    var ca = internal['[[calendar]]'];
	
	    // 11.
	    while (beginIndex !== -1) {
	        var fv = void 0;
	        // a.
	        endIndex = pattern.indexOf('}', beginIndex);
	        // b.
	        if (endIndex === -1) {
	            throw new Error('Unclosed pattern');
	        }
	        // c.
	        if (beginIndex > index) {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(index, beginIndex)
	            });
	        }
	        // d.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // e.
	        if (dateTimeComponents.hasOwnProperty(p)) {
	            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	            var f = internal['[[' + p + ']]'];
	            //  ii. Let v be the value of tm.[[<p>]].
	            var v = tm['[[' + p + ']]'];
	            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0) {
	                v = 1 - v;
	            }
	            //  iv. If p is "month", then increase v by 1.
	            else if (p === 'month') {
	                    v++;
	                }
	                //   v. If p is "hour" and the value of the [[hour12]] internal property of
	                //      dateTimeFormat is true, then
	                else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                        // 1. Let v be v modulo 12.
	                        v = v % 12;
	                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
	                        //    dateTimeFormat is true, then let v be 12.
	                        if (v === 0 && internal['[[hourNo0]]'] === true) {
	                            v = 12;
	                        }
	                    }
	
	            //  vi. If f is "numeric", then
	            if (f === 'numeric') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	            }
	            // vii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                    // 1. Let fv be the result of calling the FormatNumber abstract operation
	                    //    with arguments nf2 and v.
	                    fv = FormatNumber(nf2, v);
	                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                    //    containing the last two characters.
	                    if (fv.length > 2) {
	                        fv = fv.slice(-2);
	                    }
	                }
	                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
	                //     value representing f in the desired form; the String value depends upon
	                //     the implementation and the effective locale and calendar of
	                //     dateTimeFormat. If p is "month", then the String value may also depend
	                //     on whether dateTimeFormat has a [[day]] internal property. If p is
	                //     "timeZoneName", then the String value may also depend on the value of
	                //     the [[inDST]] field of tm.
	                else if (f in dateWidths) {
	                        switch (p) {
	                            case 'month':
	                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
	                                break;
	
	                            case 'weekday':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
	                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                                } catch (e) {
	                                    throw new Error('Could not find weekday data for locale ' + locale);
	                                }
	                                break;
	
	                            case 'timeZoneName':
	                                fv = ''; // ###TODO
	                                break;
	
	                            case 'era':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
	                                } catch (e) {
	                                    throw new Error('Could not find era data for locale ' + locale);
	                                }
	                                break;
	
	                            default:
	                                fv = tm['[[' + p + ']]'];
	                        }
	                    }
	            // ix
	            arrPush.call(result, {
	                type: p,
	                value: fv
	            });
	            // f.
	        } else if (p === 'ampm') {
	            // i.
	            var _v = tm['[[hour]]'];
	            // ii./iii.
	            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
	            // iv.
	            arrPush.call(result, {
	                type: 'dayPeriod',
	                value: fv
	            });
	            // g.
	        } else {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(beginIndex, endIndex + 1)
	            });
	        }
	        // h.
	        index = endIndex + 1;
	        // i.
	        beginIndex = pattern.indexOf('{', index);
	    }
	    // 12.
	    if (endIndex < pattern.length - 1) {
	        arrPush.call(result, {
	            type: 'literal',
	            value: pattern.substr(endIndex + 1)
	        });
	    }
	    // 13.
	    return result;
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = '';
	
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result += part.value;
	    }
	    return result;
	}
	
	function FormatToPartsDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = [];
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result.push({
	            type: part.type,
	            value: part.value
	        });
	    }
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]': +(d[m + 'FullYear']() >= 0),
	        '[[year]]': d[m + 'FullYear'](),
	        '[[month]]': d[m + 'Month'](),
	        '[[day]]': d[m + 'Date'](),
	        '[[hour]]': d[m + 'Hours'](),
	        '[[minute]]': d[m + 'Minutes'](),
	        '[[second]]': d[m + 'Seconds'](),
	        '[[inDST]]': false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date: {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	    options = ToDateTimeOptions(options, 'any', 'all');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0],
	
	
	    // 4. If options is not provided, then let options be undefined.
	    options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	    options = ToDateTimeOptions(options, 'date', 'date');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	    options = ToDateTimeOptions(options, 'time', 'time');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function value(data) {
	        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData(data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale = void 0,
	        locales = [tag],
	        parts = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined) setDefaultLocale(tag);
	}
	
	defineProperty(Intl, '__disableRegExpRestore', {
	    value: function value() {
	        internals.disableRegExpRestore = true;
	    }
	});
	
	module.exports = Intl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46), (function() { return this; }())))

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	IntlPolyfill.__addLocaleData({locale:"en-US",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:true,formats:{short:"{1}, {0}",medium:"{1}, {0}",full:"{1} 'at' {0}",long:"{1} 'at' {0}",availableFormats:{"d":"d","E":"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G","h":"h a","H":"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v","M":"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss","y":"y",yM:"M/y",yMd:"M/d/y",yMEd:"E, M/d/y",yMMM:"MMM y",yMMMd:"MMM d, y",yMMMEd:"E, MMM d, y",yMMMM:"MMMM y",yQQQ:"QQQ y",yQQQQ:"QQQQ y"},dateFormats:{yMMMMEEEEd:"EEEE, MMMM d, y",yMMMMd:"MMMM d, y",yMMMd:"MMM d, y",yMd:"M/d/yy"},timeFormats:{hmmsszzzz:"h:mm:ss a zzzz",hmsz:"h:mm:ss a z",hms:"h:mm:ss a",hm:"h:mm a"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["B","A","BCE","CE"],short:["BC","AD","BCE","CE"],long:["Before Christ","Anno Domini","Before Common Era","Common Era"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Before R.O.C.","Minguo"],short:["Before R.O.C.","Minguo"],long:["Before R.O.C.","Minguo"]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"{minusSign}{currency}{number}"},percent:{positivePattern:"{number}{percentSign}",negativePattern:"{minusSign}{number}{percentSign}"}},symbols:{latn:{decimal:".",group:",",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{AUD:"A$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",TWD:"NT$",USD:"$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}});

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	IntlPolyfill.__addLocaleData({locale:"pt-BR",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:false,formats:{short:"{1} {0}",medium:"{1} {0}",full:"{1} {0}",long:"{1} {0}",availableFormats:{"d":"d","E":"ccc",Ed:"E, d",Ehm:"E, h:mm a",EHm:"E, HH:mm",Ehms:"E, h:mm:ss a",EHms:"E, HH:mm:ss",Gy:"y G",GyMMM:"MMM 'de' y G",GyMMMd:"d 'de' MMM 'de' y G",GyMMMEd:"E, d 'de' MMM 'de' y G","h":"h a","H":"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v","M":"L",Md:"d/M",MEd:"E, dd/MM",MMdd:"dd/MM",MMM:"LLL",MMMd:"d 'de' MMM",MMMEd:"E, d 'de' MMM",MMMMd:"d 'de' MMMM",MMMMEd:"E, d 'de' MMMM",ms:"mm:ss","y":"y",yM:"MM/y",yMd:"dd/MM/y",yMEd:"E, dd/MM/y",yMM:"MM/y",yMMM:"MMM 'de' y",yMMMd:"d 'de' MMM 'de' y",yMMMEd:"E, d 'de' MMM 'de' y",yMMMM:"MMMM 'de' y",yMMMMd:"d 'de' MMMM 'de' y",yMMMMEd:"E, d 'de' MMMM 'de' y",yQQQ:"y QQQ",yQQQQ:"y QQQQ"},dateFormats:{yMMMMEEEEd:"EEEE, d 'de' MMMM 'de' y",yMMMMd:"d 'de' MMMM 'de' y",yMMMd:"d 'de' MMM 'de' y",yMd:"dd/MM/yy"},timeFormats:{hmmsszzzz:"HH:mm:ss zzzz",hmsz:"HH:mm:ss z",hms:"HH:mm:ss",hm:"HH:mm"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],long:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12"],long:["Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12"],long:["Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],long:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["a.C.","d.C.","AEC","EC"],short:["a.C.","d.C.","AEC","EC"],long:["antes de Cristo","depois de Cristo","antes da Era Comum","Era Comum"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],long:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],long:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["Antes de R.O.C.","R.O.C."],short:["Antes de R.O.C.","R.O.C."],long:["Antes de R.O.C.","R.O.C."]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"{minusSign}{currency}{number}"},percent:{positivePattern:"{number}{percentSign}",negativePattern:"{minusSign}{number}{percentSign}"}},symbols:{latn:{decimal:",",group:".",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{AUD:"AU$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"JP¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",PTE:"Esc.",THB:"฿",TWD:"NT$",USD:"US$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}});

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 573 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Recursively flattens `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flattenDeep([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, 3, 4, 5]
	 */
	function flattenDeep(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, INFINITY) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flattenDeep;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(222),
	    getRawTag = __webpack_require__(578),
	    objectToString = __webpack_require__(579);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 576 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(580);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(222);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 579 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 580 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(576);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 223,
		"./af.js": 223,
		"./ar": 230,
		"./ar-dz": 224,
		"./ar-dz.js": 224,
		"./ar-kw": 225,
		"./ar-kw.js": 225,
		"./ar-ly": 226,
		"./ar-ly.js": 226,
		"./ar-ma": 227,
		"./ar-ma.js": 227,
		"./ar-sa": 228,
		"./ar-sa.js": 228,
		"./ar-tn": 229,
		"./ar-tn.js": 229,
		"./ar.js": 230,
		"./az": 231,
		"./az.js": 231,
		"./be": 232,
		"./be.js": 232,
		"./bg": 233,
		"./bg.js": 233,
		"./bm": 234,
		"./bm.js": 234,
		"./bn": 235,
		"./bn.js": 235,
		"./bo": 236,
		"./bo.js": 236,
		"./br": 237,
		"./br.js": 237,
		"./bs": 238,
		"./bs.js": 238,
		"./ca": 239,
		"./ca.js": 239,
		"./cs": 240,
		"./cs.js": 240,
		"./cv": 241,
		"./cv.js": 241,
		"./cy": 242,
		"./cy.js": 242,
		"./da": 243,
		"./da.js": 243,
		"./de": 246,
		"./de-at": 244,
		"./de-at.js": 244,
		"./de-ch": 245,
		"./de-ch.js": 245,
		"./de.js": 246,
		"./dv": 247,
		"./dv.js": 247,
		"./el": 248,
		"./el.js": 248,
		"./en-au": 249,
		"./en-au.js": 249,
		"./en-ca": 250,
		"./en-ca.js": 250,
		"./en-gb": 251,
		"./en-gb.js": 251,
		"./en-ie": 252,
		"./en-ie.js": 252,
		"./en-il": 253,
		"./en-il.js": 253,
		"./en-in": 254,
		"./en-in.js": 254,
		"./en-nz": 255,
		"./en-nz.js": 255,
		"./en-sg": 256,
		"./en-sg.js": 256,
		"./eo": 257,
		"./eo.js": 257,
		"./es": 260,
		"./es-do": 258,
		"./es-do.js": 258,
		"./es-us": 259,
		"./es-us.js": 259,
		"./es.js": 260,
		"./et": 261,
		"./et.js": 261,
		"./eu": 262,
		"./eu.js": 262,
		"./fa": 263,
		"./fa.js": 263,
		"./fi": 264,
		"./fi.js": 264,
		"./fil": 265,
		"./fil.js": 265,
		"./fo": 266,
		"./fo.js": 266,
		"./fr": 269,
		"./fr-ca": 267,
		"./fr-ca.js": 267,
		"./fr-ch": 268,
		"./fr-ch.js": 268,
		"./fr.js": 269,
		"./fy": 270,
		"./fy.js": 270,
		"./ga": 271,
		"./ga.js": 271,
		"./gd": 272,
		"./gd.js": 272,
		"./gl": 273,
		"./gl.js": 273,
		"./gom-deva": 274,
		"./gom-deva.js": 274,
		"./gom-latn": 275,
		"./gom-latn.js": 275,
		"./gu": 276,
		"./gu.js": 276,
		"./he": 277,
		"./he.js": 277,
		"./hi": 278,
		"./hi.js": 278,
		"./hr": 279,
		"./hr.js": 279,
		"./hu": 280,
		"./hu.js": 280,
		"./hy-am": 281,
		"./hy-am.js": 281,
		"./id": 282,
		"./id.js": 282,
		"./is": 283,
		"./is.js": 283,
		"./it": 285,
		"./it-ch": 284,
		"./it-ch.js": 284,
		"./it.js": 285,
		"./ja": 286,
		"./ja.js": 286,
		"./jv": 287,
		"./jv.js": 287,
		"./ka": 288,
		"./ka.js": 288,
		"./kk": 289,
		"./kk.js": 289,
		"./km": 290,
		"./km.js": 290,
		"./kn": 291,
		"./kn.js": 291,
		"./ko": 292,
		"./ko.js": 292,
		"./ku": 293,
		"./ku.js": 293,
		"./ky": 294,
		"./ky.js": 294,
		"./lb": 295,
		"./lb.js": 295,
		"./lo": 296,
		"./lo.js": 296,
		"./lt": 297,
		"./lt.js": 297,
		"./lv": 298,
		"./lv.js": 298,
		"./me": 299,
		"./me.js": 299,
		"./mi": 300,
		"./mi.js": 300,
		"./mk": 301,
		"./mk.js": 301,
		"./ml": 302,
		"./ml.js": 302,
		"./mn": 303,
		"./mn.js": 303,
		"./mr": 304,
		"./mr.js": 304,
		"./ms": 306,
		"./ms-my": 305,
		"./ms-my.js": 305,
		"./ms.js": 306,
		"./mt": 307,
		"./mt.js": 307,
		"./my": 308,
		"./my.js": 308,
		"./nb": 309,
		"./nb.js": 309,
		"./ne": 310,
		"./ne.js": 310,
		"./nl": 312,
		"./nl-be": 311,
		"./nl-be.js": 311,
		"./nl.js": 312,
		"./nn": 313,
		"./nn.js": 313,
		"./oc-lnc": 314,
		"./oc-lnc.js": 314,
		"./pa-in": 315,
		"./pa-in.js": 315,
		"./pl": 316,
		"./pl.js": 316,
		"./pt": 318,
		"./pt-br": 317,
		"./pt-br.js": 317,
		"./pt.js": 318,
		"./ro": 319,
		"./ro.js": 319,
		"./ru": 320,
		"./ru.js": 320,
		"./sd": 321,
		"./sd.js": 321,
		"./se": 322,
		"./se.js": 322,
		"./si": 323,
		"./si.js": 323,
		"./sk": 324,
		"./sk.js": 324,
		"./sl": 325,
		"./sl.js": 325,
		"./sq": 326,
		"./sq.js": 326,
		"./sr": 328,
		"./sr-cyrl": 327,
		"./sr-cyrl.js": 327,
		"./sr.js": 328,
		"./ss": 329,
		"./ss.js": 329,
		"./sv": 330,
		"./sv.js": 330,
		"./sw": 331,
		"./sw.js": 331,
		"./ta": 332,
		"./ta.js": 332,
		"./te": 333,
		"./te.js": 333,
		"./tet": 334,
		"./tet.js": 334,
		"./tg": 335,
		"./tg.js": 335,
		"./th": 336,
		"./th.js": 336,
		"./tk": 337,
		"./tk.js": 337,
		"./tl-ph": 338,
		"./tl-ph.js": 338,
		"./tlh": 339,
		"./tlh.js": 339,
		"./tr": 340,
		"./tr.js": 340,
		"./tzl": 341,
		"./tzl.js": 341,
		"./tzm": 343,
		"./tzm-latn": 342,
		"./tzm-latn.js": 342,
		"./tzm.js": 343,
		"./ug-cn": 344,
		"./ug-cn.js": 344,
		"./uk": 345,
		"./uk.js": 345,
		"./ur": 346,
		"./ur.js": 346,
		"./uz": 348,
		"./uz-latn": 347,
		"./uz-latn.js": 347,
		"./uz.js": 348,
		"./vi": 349,
		"./vi.js": 349,
		"./x-pseudo": 350,
		"./x-pseudo.js": 350,
		"./yo": 351,
		"./yo.js": 351,
		"./zh-cn": 352,
		"./zh-cn.js": 352,
		"./zh-hk": 353,
		"./zh-hk.js": 353,
		"./zh-mo": 354,
		"./zh-mo.js": 354,
		"./zh-tw": 355,
		"./zh-tw.js": 355
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 583;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(358);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(657);
	var assign = __webpack_require__(18);
	
	var ReactPropTypesSecret = __webpack_require__(358);
	var checkPropTypes = __webpack_require__(584);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(813);
	var objectAssign = __webpack_require__(18);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 588 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  any: { type: 'any' },
	  array: { type: 'array' },
	  bool: { type: 'bool' },
	  element: { type: 'element' },
	  func: { type: 'func' },
	  node: { type: 'node' },
	  number: { type: 'number' },
	  object: { type: 'object' },
	  string: { type: 'string' },
	  symbol: { type: 'symbol' },
	  arrayOf: function arrayOf(args) {
	    return { type: 'arrayOf', args: args };
	  },
	  instanceOf: function instanceOf(args) {
	    return { type: 'instanceOf', args: args };
	  },
	  objectOf: function objectOf(args) {
	    return { type: 'objectOf', args: args };
	  },
	  oneOfType: function oneOfType(args) {
	    return { type: 'oneOfType', args: args };
	  },
	  oneOf: function oneOf(args) {
	    return { type: 'oneOf', args: args };
	  },
	  shape: function shape(args) {
	    return { type: 'shape', args: args };
	  }
	};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDocAsMarkdown;
	
	var _getDocAsJSON = __webpack_require__(360);
	
	var _getDocAsJSON2 = _interopRequireDefault(_getDocAsJSON);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDocAsMarkdown(component) {
	  if (!component) {
	    throw new Error('getDocAsMarkdown: component is required');
	  }
	
	  var documentation = (0, _getDocAsJSON2.default)(component);
	  var description = '';
	  if (documentation.description) {
	    description = '\n' + documentation.description;
	  }
	  var deprecatedNote = '';
	  var deprecatedContent = '';
	  if (documentation.deprecated) {
	    deprecatedNote = '~~';
	    deprecatedContent = '\n### Deprecated: ' + documentation.deprecated;
	  }
	  var properties = '';
	  if (documentation.properties) {
	    properties = '\n\n### Properties\n\n| Property | Description | Format | Default Value | Required | Details |\n| ---- | ---- | ---- | ---- | ---- | ---- |';
	    documentation.properties.forEach(function (prop) {
	      var propDeprecatedNote = '';
	      var propDeprecatedContent = '';
	      if (prop.deprecated) {
	        propDeprecatedNote = '~~';
	        propDeprecatedContent = '**Deprecated**: ' + prop.deprecated;
	      }
	      properties += '\n| **' + propDeprecatedNote + prop.name + propDeprecatedNote + '** | ' + prop.description + ' | ' + prop.format + ' | ' + (prop.defaultValue || '') + ' | ' + (prop.required ? 'Yes' : 'No') + ' | ' + propDeprecatedContent + ' |';
	    });
	  }
	  return '## ' + deprecatedNote + documentation.name + deprecatedNote + ' Component' + deprecatedContent + description + properties;
	}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docPropType = __webpack_require__(359);
	
	var _docPropType2 = _interopRequireDefault(_docPropType);
	
	var _getDocAsJSON = __webpack_require__(360);
	
	var _getDocAsJSON2 = _interopRequireDefault(_getDocAsJSON);
	
	var _getDocAsMarkdown = __webpack_require__(589);
	
	var _getDocAsMarkdown2 = _interopRequireDefault(_getDocAsMarkdown);
	
	var _PropTypes = __webpack_require__(588);
	
	var _PropTypes2 = _interopRequireDefault(_PropTypes);
	
	var _schema = __webpack_require__(591);
	
	var _schema2 = _interopRequireDefault(_schema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.docPropType = _docPropType2.default;
	exports.getDocAsJSON = _getDocAsJSON2.default;
	exports.getDocAsMarkdown = _getDocAsMarkdown2.default;
	exports.PropTypes = _PropTypes2.default;
	exports.schema = _schema2.default;
	
	exports.default = {
	  docPropType: _docPropType2.default, getDocAsJSON: _getDocAsJSON2.default, getDocAsMarkdown: _getDocAsMarkdown2.default, PropTypes: _PropTypes2.default, schema: _schema2.default
	};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = schema;
	
	var _docPropType = __webpack_require__(359);
	
	var _docPropType2 = _interopRequireDefault(_docPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function schema(component) {
	  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (!component) {
	    throw new Error('schema: component is required');
	  }
	  if (!metadata.description) {
	    throw new Error('schema: description is required');
	  }
	
	  var reactDesc = _extends({}, metadata);
	  delete reactDesc.props;
	  var defaultProps = void 0;
	  var propTypes = void 0;
	
	  if (metadata.props) {
	    Object.keys(metadata.props).forEach(function (propName) {
	      var prop = metadata.props[propName];
	      if (!propTypes) {
	        propTypes = {};
	      }
	      // if it is an array it means that it is a react schema instance
	      if (Array.isArray(prop)) {
	        var validate = prop[0];
	        var description = prop[1];
	        var options = prop[2];
	
	        if (options && options.defaultProp) {
	          if (!defaultProps) {
	            defaultProps = {};
	          }
	          defaultProps[propName] = options.defaultProp;
	          delete options.defaultProp;
	        }
	
	        propTypes[propName] = (0, _docPropType2.default)(validate, description, options);
	      } else {
	        propTypes[propName] = prop;
	      }
	    });
	  }
	
	  /* eslint-disable no-param-reassign */
	  component.$$reactDesc = reactDesc;
	  if (propTypes) {
	    component.propTypes = propTypes;
	  }
	
	  if (!component.defaultProps && defaultProps) {
	    component.defaultProps = defaultProps;
	  }
	  /* eslint-enable no-param-reassign */
	}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var focusNode = __webpack_require__(181);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(90);
	var ExecutionEnvironment = __webpack_require__(29);
	var FallbackCompositionState = __webpack_require__(600);
	var SyntheticCompositionEvent = __webpack_require__(637);
	var SyntheticInputEvent = __webpack_require__(640);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(361);
	var ExecutionEnvironment = __webpack_require__(29);
	var ReactInstrumentation = __webpack_require__(36);
	
	var camelizeStyleName = __webpack_require__(465);
	var dangerousStyleValue = __webpack_require__(646);
	var hyphenateStyleName = __webpack_require__(472);
	var memoizeStringOnly = __webpack_require__(475);
	var warning = __webpack_require__(15);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(89);
	var EventPropagators = __webpack_require__(90);
	var ExecutionEnvironment = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	var SyntheticEvent = __webpack_require__(48);
	
	var inputValueTracking = __webpack_require__(377);
	var getEventTarget = __webpack_require__(153);
	var isEventSupported = __webpack_require__(154);
	var isTextInputElement = __webpack_require__(379);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(73);
	var ExecutionEnvironment = __webpack_require__(29);
	
	var createNodesFromMarkup = __webpack_require__(468);
	var emptyFunction = __webpack_require__(39);
	var invariant = __webpack_require__(9);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(90);
	var ReactDOMComponentTree = __webpack_require__(20);
	var SyntheticMouseEvent = __webpack_require__(108);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(64);
	
	var getTextContentAccessor = __webpack_require__(376);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(74);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(75);
	
	var instantiateReactComponent = __webpack_require__(378);
	var KeyEscapeUtils = __webpack_require__(145);
	var shouldUpdateReactComponent = __webpack_require__(155);
	var traverseAllChildren = __webpack_require__(381);
	var warning = __webpack_require__(15);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(409);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(141);
	var ReactDOMIDOperations = __webpack_require__(610);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(18);
	
	var React = __webpack_require__(79);
	var ReactComponentEnvironment = __webpack_require__(147);
	var ReactCurrentOwner = __webpack_require__(51);
	var ReactErrorUtils = __webpack_require__(148);
	var ReactInstanceMap = __webpack_require__(91);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactNodeTypes = __webpack_require__(371);
	var ReactReconciler = __webpack_require__(75);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(101);
	var invariant = __webpack_require__(9);
	var shallowEqual = __webpack_require__(84);
	var shouldUpdateReactComponent = __webpack_require__(155);
	var warning = __webpack_require__(15);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDefaultInjection = __webpack_require__(618);
	var ReactMount = __webpack_require__(370);
	var ReactReconciler = __webpack_require__(75);
	var ReactUpdates = __webpack_require__(42);
	var ReactVersion = __webpack_require__(631);
	
	var findDOMNode = __webpack_require__(647);
	var getHostComponentFromComposite = __webpack_require__(375);
	var renderSubtreeIntoContainer = __webpack_require__(654);
	var warning = __webpack_require__(15);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(18);
	
	var AutoFocusUtils = __webpack_require__(593);
	var CSSPropertyOperations = __webpack_require__(595);
	var DOMLazyTree = __webpack_require__(73);
	var DOMNamespaces = __webpack_require__(142);
	var DOMProperty = __webpack_require__(74);
	var DOMPropertyOperations = __webpack_require__(363);
	var EventPluginHub = __webpack_require__(89);
	var EventPluginRegistry = __webpack_require__(143);
	var ReactBrowserEventEmitter = __webpack_require__(107);
	var ReactDOMComponentFlags = __webpack_require__(364);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMInput = __webpack_require__(611);
	var ReactDOMOption = __webpack_require__(612);
	var ReactDOMSelect = __webpack_require__(365);
	var ReactDOMTextarea = __webpack_require__(615);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactMultiChild = __webpack_require__(624);
	var ReactServerRenderingTransaction = __webpack_require__(629);
	
	var emptyFunction = __webpack_require__(39);
	var escapeTextContentForBrowser = __webpack_require__(110);
	var invariant = __webpack_require__(9);
	var isEventSupported = __webpack_require__(154);
	var shallowEqual = __webpack_require__(84);
	var inputValueTracking = __webpack_require__(377);
	var validateDOMNesting = __webpack_require__(156);
	var warning = __webpack_require__(15);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(156);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var DOMLazyTree = __webpack_require__(73);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(141);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(18);
	
	var DOMPropertyOperations = __webpack_require__(363);
	var LinkedValueUtils = __webpack_require__(146);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	
	var invariant = __webpack_require__(9);
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var React = __webpack_require__(79);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMSelect = __webpack_require__(365);
	
	var warning = __webpack_require__(15);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var getNodeForCharacterOffset = __webpack_require__(651);
	var getTextContentAccessor = __webpack_require__(376);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(18);
	
	var DOMChildrenOperations = __webpack_require__(141);
	var DOMLazyTree = __webpack_require__(73);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var escapeTextContentForBrowser = __webpack_require__(110);
	var invariant = __webpack_require__(9);
	var validateDOMNesting = __webpack_require__(156);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(18);
	
	var LinkedValueUtils = __webpack_require__(146);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	
	var invariant = __webpack_require__(9);
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactUpdates = __webpack_require__(42);
	var Transaction = __webpack_require__(109);
	
	var emptyFunction = __webpack_require__(39);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(592);
	var BeforeInputEventPlugin = __webpack_require__(594);
	var ChangeEventPlugin = __webpack_require__(596);
	var DefaultEventPluginOrder = __webpack_require__(598);
	var EnterLeaveEventPlugin = __webpack_require__(599);
	var HTMLDOMPropertyConfig = __webpack_require__(601);
	var ReactComponentBrowserEnvironment = __webpack_require__(603);
	var ReactDOMComponent = __webpack_require__(606);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMEmptyComponent = __webpack_require__(608);
	var ReactDOMTreeTraversal = __webpack_require__(616);
	var ReactDOMTextComponent = __webpack_require__(614);
	var ReactDefaultBatchingStrategy = __webpack_require__(617);
	var ReactEventListener = __webpack_require__(621);
	var ReactInjection = __webpack_require__(622);
	var ReactReconcileTransaction = __webpack_require__(627);
	var SVGDOMPropertyConfig = __webpack_require__(632);
	var SelectEventPlugin = __webpack_require__(633);
	var SimpleEventPlugin = __webpack_require__(634);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(89);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var EventListener = __webpack_require__(180);
	var ExecutionEnvironment = __webpack_require__(29);
	var PooledClass = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	
	var getEventTarget = __webpack_require__(153);
	var getUnboundedScrollPosition = __webpack_require__(470);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(74);
	var EventPluginHub = __webpack_require__(89);
	var EventPluginUtils = __webpack_require__(144);
	var ReactComponentEnvironment = __webpack_require__(147);
	var ReactEmptyComponent = __webpack_require__(366);
	var ReactBrowserEventEmitter = __webpack_require__(107);
	var ReactHostComponent = __webpack_require__(368);
	var ReactUpdates = __webpack_require__(42);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(645);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactComponentEnvironment = __webpack_require__(147);
	var ReactInstanceMap = __webpack_require__(91);
	var ReactInstrumentation = __webpack_require__(36);
	
	var ReactCurrentOwner = __webpack_require__(51);
	var ReactReconciler = __webpack_require__(75);
	var ReactChildReconciler = __webpack_require__(602);
	
	var emptyFunction = __webpack_require__(39);
	var flattenChildren = __webpack_require__(648);
	var invariant = __webpack_require__(9);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var CallbackQueue = __webpack_require__(362);
	var PooledClass = __webpack_require__(64);
	var ReactBrowserEventEmitter = __webpack_require__(107);
	var ReactInputSelection = __webpack_require__(369);
	var ReactInstrumentation = __webpack_require__(36);
	var Transaction = __webpack_require__(109);
	var ReactUpdateQueue = __webpack_require__(149);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(625);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(64);
	var Transaction = __webpack_require__(109);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactServerUpdateQueue = __webpack_require__(630);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(149);
	
	var warning = __webpack_require__(15);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(90);
	var ExecutionEnvironment = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInputSelection = __webpack_require__(369);
	var SyntheticEvent = __webpack_require__(48);
	
	var getActiveElement = __webpack_require__(182);
	var isTextInputElement = __webpack_require__(379);
	var shallowEqual = __webpack_require__(84);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var EventListener = __webpack_require__(180);
	var EventPropagators = __webpack_require__(90);
	var ReactDOMComponentTree = __webpack_require__(20);
	var SyntheticAnimationEvent = __webpack_require__(635);
	var SyntheticClipboardEvent = __webpack_require__(636);
	var SyntheticEvent = __webpack_require__(48);
	var SyntheticFocusEvent = __webpack_require__(639);
	var SyntheticKeyboardEvent = __webpack_require__(641);
	var SyntheticMouseEvent = __webpack_require__(108);
	var SyntheticDragEvent = __webpack_require__(638);
	var SyntheticTouchEvent = __webpack_require__(642);
	var SyntheticTransitionEvent = __webpack_require__(643);
	var SyntheticUIEvent = __webpack_require__(92);
	var SyntheticWheelEvent = __webpack_require__(644);
	
	var emptyFunction = __webpack_require__(39);
	var getEventCharCode = __webpack_require__(151);
	var invariant = __webpack_require__(9);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(108);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(92);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(92);
	
	var getEventCharCode = __webpack_require__(151);
	var getEventKey = __webpack_require__(649);
	var getEventModifierState = __webpack_require__(152);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(92);
	
	var getEventModifierState = __webpack_require__(152);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(108);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(361);
	var warning = __webpack_require__(15);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstanceMap = __webpack_require__(91);
	
	var getHostComponentFromComposite = __webpack_require__(375);
	var invariant = __webpack_require__(9);
	var warning = __webpack_require__(15);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(145);
	var traverseAllChildren = __webpack_require__(381);
	var warning = __webpack_require__(15);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(409);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(151);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(110);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(370);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2017, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(827));
	var IntlMessageFormat = _interopDefault(__webpack_require__(220));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(562));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(26));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(552));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var locales = Array.isArray(data) ? data : [data];
	
	  locales.forEach(function (localeData) {
	    if (localeData && localeData.locale) {
	      IntlMessageFormat.__addLocaleData(localeData);
	      IntlRelativeFormat.__addLocaleData(localeData);
	    }
	  });
	}
	
	function hasLocaleData(locale) {
	  var localeParts = (locale || '').split('-');
	
	  while (localeParts.length > 0) {
	    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	      return true;
	    }
	
	    localeParts.pop();
	  }
	
	  return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	  var normalizedLocale = locale && locale.toLowerCase();
	
	  return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = PropTypes.bool;
	var number = PropTypes.number;
	var string = PropTypes.string;
	var func = PropTypes.func;
	var object = PropTypes.object;
	var oneOf = PropTypes.oneOf;
	var shape = PropTypes.shape;
	var any = PropTypes.any;
	var oneOfType = PropTypes.oneOfType;
	
	var localeMatcher = oneOf(['best fit', 'lookup']);
	var narrowShortLong = oneOf(['narrow', 'short', 'long']);
	var numeric2digit = oneOf(['numeric', '2-digit']);
	var funcReq = func.isRequired;
	
	var intlConfigPropTypes = {
	  locale: string,
	  formats: object,
	  messages: object,
	  textComponent: any,
	
	  defaultLocale: string,
	  defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	  formatDate: funcReq,
	  formatTime: funcReq,
	  formatRelative: funcReq,
	  formatNumber: funcReq,
	  formatPlural: funcReq,
	  formatMessage: funcReq,
	  formatHTMLMessage: funcReq
	};
	
	var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
	  formatters: object,
	  now: funcReq
	}));
	
	var messageDescriptorPropTypes = {
	  id: string.isRequired,
	  description: oneOfType([string, object]),
	  defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	  localeMatcher: localeMatcher,
	  formatMatcher: oneOf(['basic', 'best fit']),
	
	  timeZone: string,
	  hour12: bool,
	
	  weekday: narrowShortLong,
	  era: narrowShortLong,
	  year: numeric2digit,
	  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	  day: numeric2digit,
	  hour: numeric2digit,
	  minute: numeric2digit,
	  second: numeric2digit,
	  timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	  localeMatcher: localeMatcher,
	
	  style: oneOf(['decimal', 'currency', 'percent']),
	  currency: string,
	  currencyDisplay: oneOf(['symbol', 'code', 'name']),
	  useGrouping: bool,
	
	  minimumIntegerDigits: number,
	  minimumFractionDigits: number,
	  maximumFractionDigits: number,
	  minimumSignificantDigits: number,
	  maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	  style: oneOf(['best fit', 'numeric']),
	  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	  style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  "'": '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	    return ESCAPED_CHARS[match];
	  });
	}
	
	function filterProps(props, whitelist) {
	  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return whitelist.reduce(function (filtered, name) {
	    if (props.hasOwnProperty(name)) {
	      filtered[name] = props[name];
	    } else if (defaults$$1.hasOwnProperty(name)) {
	      filtered[name] = defaults$$1[name];
	    }
	
	    return filtered;
	  }, {});
	}
	
	function invariantIntlContext() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      intl = _ref.intl;
	
	  invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	  var props = _ref2.props,
	      state = _ref2.state,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === undefined ? {} : _ref2$context;
	  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var _context$intl = context.intl,
	      intl = _context$intl === undefined ? {} : _context$intl;
	  var _nextContext$intl = nextContext.intl,
	      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component$$1) {
	  return Component$$1.displayName || Component$$1.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$intlPropName = options.intlPropName,
	      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var InjectIntl = function (_Component) {
	    inherits(InjectIntl, _Component);
	
	    function InjectIntl(props, context) {
	      classCallCheck(this, InjectIntl);
	
	      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	      invariantIntlContext(context);
	      return _this;
	    }
	
	    createClass(InjectIntl, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return React__default.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	          ref: withRef ? 'wrappedInstance' : null
	        }));
	      }
	    }]);
	    return InjectIntl;
	  }(React.Component);
	
	  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	  InjectIntl.contextTypes = {
	    intl: intlShape
	  };
	  InjectIntl.WrappedComponent = WrappedComponent;
	
	
	  return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	  return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	  return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  classCallCheck(this, IntlPluralFormat);
	
	  var useOrdinal = options.style === 'ordinal';
	  var pluralFn = findPluralFunction(resolveLocale(locales));
	
	  this.format = function (value) {
	    return pluralFn(value, useOrdinal);
	  };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	  second: 60, // seconds to minute
	  minute: 60, // minutes to hour
	  hour: 24, // hours to day
	  day: 30, // days to month
	  month: 12 // months to year
	};
	
	function updateRelativeFormatThresholds(newThresholds) {
	  var thresholds = IntlRelativeFormat.thresholds;
	  thresholds.second = newThresholds.second;
	  thresholds.minute = newThresholds.minute;
	  thresholds.hour = newThresholds.hour;
	  thresholds.day = newThresholds.day;
	  thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	  var format = formats && formats[type] && formats[type][name];
	  if (format) {
	    return format;
	  }
	
	  if (false) {
	    console.error('[React Intl] No ' + type + ' format named: ' + name);
	  }
	}
	
	function formatDate(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var date = new Date(value);
	  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting date.\n' + e);
	    }
	  }
	
	  return String(date);
	}
	
	function formatTime(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var date = new Date(value);
	  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	    // Add default formatting options if hour, minute, or second isn't defined.
	    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	  }
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting time.\n' + e);
	    }
	  }
	
	  return String(date);
	}
	
	function formatRelative(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var date = new Date(value);
	  var now = new Date(options.now);
	  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
	  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
	
	  // Capture the current threshold values, then temporarily override them with
	  // specific values just for this render.
	  var oldThresholds = _extends({}, IntlRelativeFormat.thresholds);
	  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	  try {
	    return state.getRelativeFormat(locale, filteredOptions).format(date, {
	      now: isFinite(now) ? now : state.now()
	    });
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting relative time.\n' + e);
	    }
	  } finally {
	    updateRelativeFormatThresholds(oldThresholds);
	  }
	
	  return String(date);
	}
	
	function formatNumber(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
	  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getNumberFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting number.\n' + e);
	    }
	  }
	
	  return String(value);
	}
	
	function formatPlural(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale;
	
	
	  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	  try {
	    return state.getPluralFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting plural.\n' + e);
	    }
	  }
	
	  return 'other';
	}
	
	function formatMessage(config, state) {
	  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      messages = config.messages,
	      defaultLocale = config.defaultLocale,
	      defaultFormats = config.defaultFormats;
	  var id = messageDescriptor.id,
	      defaultMessage = messageDescriptor.defaultMessage;
	
	  // `id` is a required field of a Message Descriptor.
	
	  invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	  var message = messages && messages[id];
	  var hasValues = Object.keys(values).length > 0;
	
	  // Avoid expensive message formatting for simple messages without values. In
	  // development messages will always be formatted in case of missing values.
	  if (!hasValues && ("production") === 'production') {
	    return message || defaultMessage || id;
	  }
	
	  var formattedMessage = void 0;
	
	  if (message) {
	    try {
	      var formatter = state.getMessageFormat(message, locale, formats);
	
	      formattedMessage = formatter.format(values);
	    } catch (e) {
	      if (false) {
	        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	      }
	    }
	  } else {
	    if (false) {
	      // This prevents warnings from littering the console in development
	      // when no `messages` are passed into the <IntlProvider> for the
	      // default locale, and a default message is in the source.
	      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	      }
	    }
	  }
	
	  if (!formattedMessage && defaultMessage) {
	    try {
	      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	      formattedMessage = _formatter.format(values);
	    } catch (e) {
	      if (false) {
	        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	      }
	    }
	  }
	
	  if (!formattedMessage) {
	    if (false) {
	      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	    }
	  }
	
	  return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  // Process all the values before they are used when formatting the ICU
	  // Message string. Since the formatted message might be injected via
	  // `innerHTML`, all String-based values need to be HTML-escaped.
	  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	    var value = rawValues[name];
	    escaped[name] = typeof value === 'string' ? escape(value) : value;
	    return escaped;
	  }, {});
	
	  return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
		formatDate: formatDate,
		formatTime: formatTime,
		formatRelative: formatRelative,
		formatNumber: formatNumber,
		formatPlural: formatPlural,
		formatMessage: formatMessage,
		formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	  formats: {},
	  messages: {},
	  textComponent: 'span',
	
	  defaultLocale: 'en',
	  defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	  inherits(IntlProvider, _Component);
	
	  function IntlProvider(props) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, IntlProvider);
	
	    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	    invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	    var intlContext = context.intl;
	
	    // Used to stabilize time when performing an initial rendering so that
	    // all relative times use the same reference "now" time.
	
	    var initialNow = void 0;
	    if (isFinite(props.initialNow)) {
	      initialNow = Number(props.initialNow);
	    } else {
	      // When an `initialNow` isn't provided via `props`, look to see an
	      // <IntlProvider> exists in the ancestry and call its `now()`
	      // function to propagate its value for "now".
	      initialNow = intlContext ? intlContext.now() : Date.now();
	    }
	
	    // Creating `Intl*` formatters is expensive. If there's a parent
	    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	    // memoize the `Intl*` constructors and cache them for the lifecycle of
	    // this IntlProvider instance.
	
	    var _ref = intlContext || {},
	        _ref$formatters = _ref.formatters,
	        formatters = _ref$formatters === undefined ? {
	      getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	      getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	      getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	      getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	      getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	    } : _ref$formatters;
	
	    _this.state = _extends({}, formatters, {
	
	      // Wrapper to provide stable "now" time for initial render.
	      now: function now() {
	        return _this._didDisplay ? Date.now() : initialNow;
	      }
	    });
	    return _this;
	  }
	
	  createClass(IntlProvider, [{
	    key: 'getConfig',
	    value: function getConfig() {
	      var intlContext = this.context.intl;
	
	      // Build a whitelisted config object from `props`, defaults, and
	      // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	      // Apply default props. This must be applied last after the props have
	      // been resolved and inherited from any <IntlProvider> in the ancestry.
	      // This matches how React resolves `defaultProps`.
	      for (var propName in defaultProps) {
	        if (config[propName] === undefined) {
	          config[propName] = defaultProps[propName];
	        }
	      }
	
	      if (!hasLocaleData(config.locale)) {
	        var _config = config,
	            locale = _config.locale,
	            defaultLocale = _config.defaultLocale,
	            defaultFormats = _config.defaultFormats;
	
	
	        if (false) {
	          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	        }
	
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        config = _extends({}, config, {
	          locale: defaultLocale,
	          formats: defaultFormats,
	          messages: defaultProps.messages
	        });
	      }
	
	      return config;
	    }
	  }, {
	    key: 'getBoundFormatFns',
	    value: function getBoundFormatFns(config, state) {
	      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	        boundFormatFns[name] = format[name].bind(null, config, state);
	        return boundFormatFns;
	      }, {});
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var config = this.getConfig();
	
	      // Bind intl factories and current config to the format functions.
	      var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	      var _state = this.state,
	          now = _state.now,
	          formatters = objectWithoutProperties(_state, ['now']);
	
	
	      return {
	        intl: _extends({}, config, boundFormatFns, {
	          formatters: formatters,
	          now: now
	        })
	      };
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._didDisplay = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.Children.only(this.props.children);
	    }
	  }]);
	  return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	IntlProvider.contextTypes = {
	  intl: intlShape
	};
	IntlProvider.childContextTypes = {
	  intl: intlShape.isRequired
	};
	 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
	  children: PropTypes.element.isRequired,
	  initialNow: PropTypes.any
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	  inherits(FormattedDate, _Component);
	
	  function FormattedDate(props, context) {
	    classCallCheck(this, FormattedDate);
	
	    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedDate, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatDate = _context$intl.formatDate,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedDate = formatDate(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedDate);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedDate
	      );
	    }
	  }]);
	  return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	FormattedDate.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	  inherits(FormattedTime, _Component);
	
	  function FormattedTime(props, context) {
	    classCallCheck(this, FormattedTime);
	
	    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedTime, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatTime = _context$intl.formatTime,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedTime = formatTime(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedTime);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedTime
	      );
	    }
	  }]);
	  return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	FormattedTime.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	  var absDelta = Math.abs(delta);
	
	  if (absDelta < MINUTE) {
	    return 'second';
	  }
	
	  if (absDelta < HOUR) {
	    return 'minute';
	  }
	
	  if (absDelta < DAY) {
	    return 'hour';
	  }
	
	  // The maximum scheduled delay will be measured in days since the maximum
	  // timer delay is less than the number of milliseconds in 25 days.
	  return 'day';
	}
	
	function getUnitDelay(units) {
	  switch (units) {
	    case 'second':
	      return SECOND;
	    case 'minute':
	      return MINUTE;
	    case 'hour':
	      return HOUR;
	    case 'day':
	      return DAY;
	    default:
	      return MAX_TIMER_DELAY;
	  }
	}
	
	function isSameDate(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  var aTime = new Date(a).getTime();
	  var bTime = new Date(b).getTime();
	
	  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	  inherits(FormattedRelative, _Component);
	
	  function FormattedRelative(props, context) {
	    classCallCheck(this, FormattedRelative);
	
	    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	    invariantIntlContext(context);
	
	    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	    // `now` is stored as state so that `render()` remains a function of
	    // props + state, instead of accessing `Date.now()` inside `render()`.
	    _this.state = { now: now };
	    return _this;
	  }
	
	  createClass(FormattedRelative, [{
	    key: 'scheduleNextUpdate',
	    value: function scheduleNextUpdate(props, state) {
	      var _this2 = this;
	
	      // Cancel and pending update because we're scheduling a new update.
	      clearTimeout(this._timer);
	
	      var value = props.value,
	          units = props.units,
	          updateInterval = props.updateInterval;
	
	      var time = new Date(value).getTime();
	
	      // If the `updateInterval` is falsy, including `0` or we don't have a
	      // valid date, then auto updates have been turned off, so we bail and
	      // skip scheduling an update.
	      if (!updateInterval || !isFinite(time)) {
	        return;
	      }
	
	      var delta = time - state.now;
	      var unitDelay = getUnitDelay(units || selectUnits(delta));
	      var unitRemainder = Math.abs(delta % unitDelay);
	
	      // We want the largest possible timer delay which will still display
	      // accurate information while reducing unnecessary re-renders. The delay
	      // should be until the next "interesting" moment, like a tick from
	      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	      this._timer = setTimeout(function () {
	        _this2.setState({ now: _this2.context.intl.now() });
	      }, delay);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleNextUpdate(this.props, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var nextValue = _ref.value;
	
	      // When the `props.value` date changes, `state.now` needs to be updated,
	      // and the next update can be rescheduled.
	      if (!isSameDate(nextValue, this.props.value)) {
	        this.setState({ now: this.context.intl.now() });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.scheduleNextUpdate(nextProps, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatRelative = _context$intl.formatRelative,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));
	
	      if (typeof children === 'function') {
	        return children(formattedRelative);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedRelative
	      );
	    }
	  }]);
	  return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	FormattedRelative.contextTypes = {
	  intl: intlShape
	};
	FormattedRelative.defaultProps = {
	  updateInterval: 1000 * 10
	};
	 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  updateInterval: PropTypes.number,
	  initialNow: PropTypes.any,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	  inherits(FormattedNumber, _Component);
	
	  function FormattedNumber(props, context) {
	    classCallCheck(this, FormattedNumber);
	
	    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedNumber, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatNumber = _context$intl.formatNumber,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedNumber = formatNumber(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedNumber);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedNumber
	      );
	    }
	  }]);
	  return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	FormattedNumber.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	  inherits(FormattedPlural, _Component);
	
	  function FormattedPlural(props, context) {
	    classCallCheck(this, FormattedPlural);
	
	    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedPlural, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatPlural = _context$intl.formatPlural,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          other = _props.other,
	          children = _props.children;
	
	
	      var pluralCategory = formatPlural(value, this.props);
	      var formattedPlural = this.props[pluralCategory] || other;
	
	      if (typeof children === 'function') {
	        return children(formattedPlural);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedPlural
	      );
	    }
	  }]);
	  return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	FormattedPlural.contextTypes = {
	  intl: intlShape
	};
	FormattedPlural.defaultProps = {
	  style: 'cardinal'
	};
	 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	
	  other: PropTypes.node.isRequired,
	  zero: PropTypes.node,
	  one: PropTypes.node,
	  two: PropTypes.node,
	  few: PropTypes.node,
	  many: PropTypes.node,
	
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedMessage = function (_Component) {
	  inherits(FormattedMessage, _Component);
	
	  function FormattedMessage(props, context) {
	    classCallCheck(this, FormattedMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatMessage = _context$intl.formatMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          values = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var tokenDelimiter = void 0;
	      var tokenizedValues = void 0;
	      var elements = void 0;
	
	      var hasValues = values && Object.keys(values).length > 0;
	      if (hasValues) {
	        // Creates a token with a random UID that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	        var generateToken = function () {
	          var counter = 0;
	          return function () {
	            return 'ELEMENT-' + uid + '-' + (counter += 1);
	          };
	        }();
	
	        // Splitting with a delimiter to support IE8. When using a regex
	        // with a capture group IE8 does not include the capture group in
	        // the resulting array.
	        tokenDelimiter = '@__' + uid + '__@';
	        tokenizedValues = {};
	        elements = {};
	
	        // Iterates over the `props` to keep track of any React Element
	        // values so they can be represented by the `token` as a placeholder
	        // when the `message` is formatted. This allows the formatted
	        // message to then be broken-up into parts with references to the
	        // React Elements inserted back in.
	        Object.keys(values).forEach(function (name) {
	          var value = values[name];
	
	          if (React.isValidElement(value)) {
	            var token = generateToken();
	            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	            elements[token] = value;
	          } else {
	            tokenizedValues[name] = value;
	          }
	        });
	      }
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	      var nodes = void 0;
	
	      var hasElements = elements && Object.keys(elements).length > 0;
	      if (hasElements) {
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while
	        // keeping React's virtual diffing working properly.
	        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	          return !!part;
	        }).map(function (part) {
	          return elements[part] || part;
	        });
	      } else {
	        nodes = [formattedMessage];
	      }
	
	      if (typeof children === 'function') {
	        return children.apply(undefined, toConsumableArray(nodes));
	      }
	
	      // Needs to use `createElement()` instead of JSX, otherwise React will
	      // warn about a missing `key` prop with rich-text message formatting.
	      return React.createElement.apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
	    }
	  }]);
	  return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	FormattedMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	  inherits(FormattedHTMLMessage, _Component);
	
	  function FormattedHTMLMessage(props, context) {
	    classCallCheck(this, FormattedHTMLMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedHTMLMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatHTMLMessage = _context$intl.formatHTMLMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          rawValues = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	      if (typeof children === 'function') {
	        return children(formattedHTMLMessage);
	      }
	
	      // Since the message presumably has HTML in it, we need to set
	      // `innerHTML` in order for it to be rendered and not escaped by React.
	      // To be safe, all string prop values were escaped when formatting the
	      // message. It is assumed that the message is not UGC, and came from the
	      // developer making it more like a template.
	      //
	      // Note: There's a perf impact of using this component since there's no
	      // way for React to do its virtual DOM diffing.
	      var html = { __html: formattedHTMLMessage };
	      return React__default.createElement(Component$$1, { dangerouslySetInnerHTML: html });
	    }
	  }]);
	  return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	FormattedHTMLMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedHTMLMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

	/** @license React v16.13.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(656);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(573);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _defaultStyles = __webpack_require__(659);
	
	var _defaultStyles2 = _interopRequireDefault(_defaultStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (c) 2017 Ken Hibino.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Licensed under the MIT License (MIT).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * See https://kenny-hibino.github.io/react-places-autocomplete
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var PlacesAutocomplete = function (_Component) {
	  _inherits(PlacesAutocomplete, _Component);
	
	  function PlacesAutocomplete(props) {
	    _classCallCheck(this, PlacesAutocomplete);
	
	    var _this = _possibleConstructorReturn(this, (PlacesAutocomplete.__proto__ || Object.getPrototypeOf(PlacesAutocomplete)).call(this, props));
	
	    _this.state = { autocompleteItems: [] };
	
	    _this.autocompleteCallback = _this.autocompleteCallback.bind(_this);
	    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.debouncedFetchPredictions = (0, _lodash2.default)(_this.fetchPredictions, _this.props.debounce);
	    return _this;
	  }
	
	  _createClass(PlacesAutocomplete, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!window.google) {
	        throw new Error('Google Maps JavaScript API library must be loaded. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
	      }
	
	      if (!window.google.maps.places) {
	        throw new Error('Google Maps Places library must be loaded. Please add `libraries=places` to the src URL. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
	      }
	
	      this.autocompleteService = new google.maps.places.AutocompleteService();
	      this.autocompleteOK = google.maps.places.PlacesServiceStatus.OK;
	    }
	  }, {
	    key: 'autocompleteCallback',
	    value: function autocompleteCallback(predictions, status) {
	      if (status != this.autocompleteOK) {
	        this.props.onError(status);
	        if (this.props.clearItemsOnError) {
	          this.clearAutocomplete();
	        }
	        return;
	      }
	
	      // transform snake_case to camelCase
	      var formattedSuggestion = function formattedSuggestion(structured_formatting) {
	        return {
	          mainText: structured_formatting.main_text,
	          secondaryText: structured_formatting.secondary_text
	        };
	      };
	
	      var highlightFirstSuggestion = this.props.highlightFirstSuggestion;
	
	
	      this.setState({
	        autocompleteItems: predictions.map(function (p, idx) {
	          return {
	            suggestion: p.description,
	            placeId: p.place_id,
	            active: highlightFirstSuggestion && idx === 0 ? true : false,
	            index: idx,
	            formattedSuggestion: formattedSuggestion(p.structured_formatting)
	          };
	        })
	      });
	    }
	  }, {
	    key: 'fetchPredictions',
	    value: function fetchPredictions() {
	      var value = this.props.inputProps.value;
	
	      if (value.length) {
	        this.autocompleteService.getPlacePredictions(_extends({}, this.props.options, {
	          input: value
	        }), this.autocompleteCallback);
	      }
	    }
	  }, {
	    key: 'clearAutocomplete',
	    value: function clearAutocomplete() {
	      this.setState({ autocompleteItems: [] });
	    }
	  }, {
	    key: 'selectAddress',
	    value: function selectAddress(address, placeId) {
	      this.clearAutocomplete();
	      this.handleSelect(address, placeId);
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(address, placeId) {
	      this.props.onSelect ? this.props.onSelect(address, placeId) : this.props.inputProps.onChange(address);
	    }
	  }, {
	    key: 'getActiveItem',
	    value: function getActiveItem() {
	      return this.state.autocompleteItems.find(function (item) {
	        return item.active;
	      });
	    }
	  }, {
	    key: 'selectActiveItemAtIndex',
	    value: function selectActiveItemAtIndex(index) {
	      var activeName = this.state.autocompleteItems.find(function (item) {
	        return item.index === index;
	      }).suggestion;
	      this.setActiveItemAtIndex(index);
	      this.props.inputProps.onChange(activeName);
	    }
	  }, {
	    key: 'handleEnterKey',
	    value: function handleEnterKey() {
	      var activeItem = this.getActiveItem();
	      if (activeItem === undefined) {
	        this.handleEnterKeyWithoutActiveItem();
	      } else {
	        this.selectAddress(activeItem.suggestion, activeItem.placeId);
	      }
	    }
	  }, {
	    key: 'handleEnterKeyWithoutActiveItem',
	    value: function handleEnterKeyWithoutActiveItem() {
	      if (this.props.onEnterKeyDown) {
	        this.props.onEnterKeyDown(this.props.inputProps.value);
	        this.clearAutocomplete();
	      } else {
	        return; //noop
	      }
	    }
	  }, {
	    key: 'handleDownKey',
	    value: function handleDownKey() {
	      if (this.state.autocompleteItems.length === 0) {
	        return;
	      }
	
	      var activeItem = this.getActiveItem();
	      if (activeItem === undefined) {
	        this.selectActiveItemAtIndex(0);
	      } else {
	        var nextIndex = (activeItem.index + 1) % this.state.autocompleteItems.length;
	        this.selectActiveItemAtIndex(nextIndex);
	      }
	    }
	  }, {
	    key: 'handleUpKey',
	    value: function handleUpKey() {
	      if (this.state.autocompleteItems.length === 0) {
	        return;
	      }
	
	      var activeItem = this.getActiveItem();
	      if (activeItem === undefined) {
	        this.selectActiveItemAtIndex(this.state.autocompleteItems.length - 1);
	      } else {
	        var prevIndex = void 0;
	        if (activeItem.index === 0) {
	          prevIndex = this.state.autocompleteItems.length - 1;
	        } else {
	          prevIndex = (activeItem.index - 1) % this.state.autocompleteItems.length;
	        }
	        this.selectActiveItemAtIndex(prevIndex);
	      }
	    }
	  }, {
	    key: 'handleInputKeyDown',
	    value: function handleInputKeyDown(event) {
	      switch (event.key) {
	        case 'Enter':
	          event.preventDefault();
	          this.handleEnterKey();
	          break;
	        case 'ArrowDown':
	          event.preventDefault(); // prevent the cursor from moving
	          this.handleDownKey();
	          break;
	        case 'ArrowUp':
	          event.preventDefault(); // prevent the cursor from moving
	          this.handleUpKey();
	          break;
	        case 'Escape':
	          this.clearAutocomplete();
	          break;
	      }
	
	      if (this.props.inputProps.onKeyDown) {
	        this.props.inputProps.onKeyDown(event);
	      }
	    }
	  }, {
	    key: 'setActiveItemAtIndex',
	    value: function setActiveItemAtIndex(index) {
	      this.setState({
	        autocompleteItems: this.state.autocompleteItems.map(function (item, idx) {
	          if (idx === index) {
	            return _extends({}, item, { active: true });
	          } else {
	            return _extends({}, item, { active: false });
	          }
	        })
	      });
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(event) {
	      this.props.inputProps.onChange(event.target.value);
	      if (!event.target.value) {
	        this.clearAutocomplete();
	        return;
	      }
	      this.debouncedFetchPredictions();
	    }
	  }, {
	    key: 'handleInputOnBlur',
	    value: function handleInputOnBlur(event) {
	      this.clearAutocomplete();
	
	      if (this.props.inputProps.onBlur) {
	        this.props.inputProps.onBlur(event);
	      }
	    }
	  }, {
	    key: 'inlineStyleFor',
	    value: function inlineStyleFor() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          styles = _props.styles;
	      // No inline style if className is passed via props for the element.
	
	      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
	        props[_key] = arguments[_key];
	      }
	
	      if (props.some(function (prop) {
	        return classNames.hasOwnProperty(prop);
	      })) {
	        return {};
	      }
	
	      return props.reduce(function (acc, prop) {
	        return _extends({}, acc, _defaultStyles2.default[prop], styles[prop]);
	      }, {});
	    }
	  }, {
	    key: 'classNameFor',
	    value: function classNameFor() {
	      var classNames = this.props.classNames;
	
	      for (var _len2 = arguments.length, props = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        props[_key2] = arguments[_key2];
	      }
	
	      return props.reduce(function (acc, prop) {
	        var name = classNames[prop] || '';
	        return name ? acc + ' ' + name : acc;
	      }, '');
	    }
	  }, {
	    key: 'getInputProps',
	    value: function getInputProps() {
	      var _this2 = this;
	
	      var defaultInputProps = {
	        type: "text",
	        autoComplete: "off"
	      };
	
	      return _extends({}, defaultInputProps, this.props.inputProps, {
	        onChange: function onChange(event) {
	          _this2.handleInputChange(event);
	        },
	        onKeyDown: function onKeyDown(event) {
	          _this2.handleInputKeyDown(event);
	        },
	        onBlur: function onBlur(event) {
	          _this2.handleInputOnBlur(event);
	        },
	        style: this.inlineStyleFor('input'),
	        className: this.classNameFor('input')
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          classNames = _props2.classNames,
	          styles = _props2.styles;
	      var autocompleteItems = this.state.autocompleteItems;
	
	      var inputProps = this.getInputProps();
	
	      return _react2.default.createElement(
	        'div',
	        {
	          id: 'PlacesAutocomplete__root',
	          style: this.inlineStyleFor('root'),
	          className: this.classNameFor('root') },
	        _react2.default.createElement('input', inputProps),
	        autocompleteItems.length > 0 && _react2.default.createElement(
	          'div',
	          {
	            id: 'PlacesAutocomplete__autocomplete-container',
	            style: this.inlineStyleFor('autocompleteContainer'),
	            className: this.classNameFor('autocompleteContainer') },
	          autocompleteItems.map(function (p, idx) {
	            return _react2.default.createElement(
	              'div',
	              {
	                key: p.placeId,
	                onMouseOver: function onMouseOver() {
	                  return _this3.setActiveItemAtIndex(p.index);
	                },
	                onMouseDown: function onMouseDown() {
	                  return _this3.selectAddress(p.suggestion, p.placeId);
	                },
	                onTouchStart: function onTouchStart() {
	                  return _this3.setActiveItemAtIndex(p.index);
	                },
	                onTouchEnd: function onTouchEnd() {
	                  return _this3.selectAddress(p.suggestion, p.placeId);
	                },
	                style: p.active ? _this3.inlineStyleFor('autocompleteItem', 'autocompleteItemActive') : _this3.inlineStyleFor('autocompleteItem'),
	                className: p.active ? _this3.classNameFor('autocompleteItem', 'autocompleteItemActive') : _this3.classNameFor('autocompleteItem') },
	              _this3.props.autocompleteItem({ suggestion: p.suggestion, formattedSuggestion: p.formattedSuggestion })
	            );
	          }),
	          this.props.googleLogo && _react2.default.createElement(
	            'div',
	            {
	              id: 'PlacesAutocomplete__google-logo',
	              style: this.inlineStyleFor('googleLogoContainer'),
	              className: this.classNameFor('googleLogoContainer') },
	            _react2.default.createElement('img', {
	              src: __webpack_require__(660)("./powered_by_google_" + this.props.googleLogoType + '.png'),
	              style: this.inlineStyleFor('googleLogoImage'),
	              className: this.classNameFor('googleLogoImage')
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PlacesAutocomplete;
	}(_react.Component);
	
	PlacesAutocomplete.propTypes = {
	  inputProps: function inputProps(props, propName) {
	    var inputProps = props[propName];
	
	    if (!inputProps.hasOwnProperty('value')) {
	      throw new Error('\'inputProps\' must have \'value\'.');
	    }
	
	    if (!inputProps.hasOwnProperty('onChange')) {
	      throw new Error('\'inputProps\' must have \'onChange\'.');
	    }
	  },
	  onError: _propTypes2.default.func,
	  clearItemsOnError: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  autocompleteItem: _propTypes2.default.func,
	  classNames: _propTypes2.default.shape({
	    root: _propTypes2.default.string,
	    input: _propTypes2.default.string,
	    autocompleteContainer: _propTypes2.default.string,
	    autocompleteItem: _propTypes2.default.string,
	    autocompleteItemActive: _propTypes2.default.string
	  }),
	  styles: _propTypes2.default.shape({
	    root: _propTypes2.default.object,
	    input: _propTypes2.default.object,
	    autocompleteContainer: _propTypes2.default.object,
	    autocompleteItem: _propTypes2.default.object,
	    autocompleteItemActive: _propTypes2.default.object
	  }),
	  options: _propTypes2.default.shape({
	    bounds: _propTypes2.default.object,
	    componentRestrictions: _propTypes2.default.object,
	    location: _propTypes2.default.object,
	    offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    types: _propTypes2.default.array
	  }),
	  debounce: _propTypes2.default.number,
	  highlightFirstSuggestion: _propTypes2.default.bool,
	  googleLogo: _propTypes2.default.bool,
	  googleLogoType: _propTypes2.default.oneOf(["default", "inverse"])
	};
	
	PlacesAutocomplete.defaultProps = {
	  clearItemsOnError: false,
	  onError: function onError(status) {
	    return console.error('[react-places-autocomplete]: error happened when fetching data from Google Maps API.\nPlease check the docs here (https://developers.google.com/maps/documentation/javascript/places#place_details_responses)\nStatus: ', status);
	  },
	  classNames: {},
	  autocompleteItem: function autocompleteItem(_ref) {
	    var suggestion = _ref.suggestion;
	    return _react2.default.createElement(
	      'div',
	      null,
	      suggestion
	    );
	  },
	  styles: {},
	  options: {},
	  debounce: 200,
	  highlightFirstSuggestion: false,
	  googleLogo: true,
	  googleLogoType: 'default'
	};
	
	exports.default = PlacesAutocomplete;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultStyles = {
	  root: {
	    position: 'relative',
	    paddingBottom: '0px'
	  },
	  input: {
	    display: 'inline-block',
	    width: '100%',
	    padding: '10px'
	  },
	  autocompleteContainer: {
	    position: 'absolute',
	    top: '100%',
	    backgroundColor: 'white',
	    border: '1px solid #555555',
	    width: '100%'
	  },
	  autocompleteItem: {
	    backgroundColor: '#ffffff',
	    padding: '10px',
	    color: '#555555',
	    cursor: 'pointer'
	  },
	  autocompleteItemActive: {
	    backgroundColor: '#fafafa'
	  },
	  googleLogoContainer: {
	    textAlign: 'right',
	    padding: '1px',
	    backgroundColor: '#fafafa'
	  },
	  googleLogoImage: {
	    width: 150
	  }
	};
	
	exports.default = defaultStyles;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./powered_by_google_default.png": 476,
		"./powered_by_google_inverse.png": 477
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 660;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var geocodeByAddress = exports.geocodeByAddress = function geocodeByAddress(address, callback) {
	  var geocoder = new google.maps.Geocoder();
	  var OK = google.maps.GeocoderStatus.OK;
	
	  return new Promise(function (resolve, reject) {
	    geocoder.geocode({ address: address }, function (results, status) {
	      if (status !== OK) {
	
	        // TODO: Remove callback support in the next major version.
	        if (callback) {
	          console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyaddress-api"');
	          callback({ status: status }, null, results);
	          return;
	        }
	
	        reject(status);
	      }
	
	      // TODO: Remove callback support in the next major version.
	      if (callback) {
	        var latLng = {
	          lat: results[0].geometry.location.lat(),
	          lng: results[0].geometry.location.lng()
	        };
	        console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyaddress-api"');
	        callback(null, latLng, results);
	      }
	
	      resolve(results);
	    });
	  });
	};
	
	var getLatLng = exports.getLatLng = function getLatLng(result) {
	  return new Promise(function (resolve, reject) {
	    try {
	      var latLng = {
	        lat: result.geometry.location.lat(),
	        lng: result.geometry.location.lng()
	      };
	      resolve(latLng);
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	var geocodeByPlaceId = exports.geocodeByPlaceId = function geocodeByPlaceId(placeId, callback) {
	  var geocoder = new google.maps.Geocoder();
	  var OK = google.maps.GeocoderStatus.OK;
	
	  return new Promise(function (resolve, reject) {
	    geocoder.geocode({ placeId: placeId }, function (results, status) {
	      if (status !== OK) {
	
	        // TODO: Remove callback support in the next major version.
	        if (callback) {
	          console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyplaceid-api"');
	          callback({ status: status }, null, results);
	          return;
	        }
	
	        reject(status);
	      }
	
	      // TODO: Remove callback support in the next major version.
	      if (callback) {
	        var latLng = {
	          lat: results[0].geometry.location.lat(),
	          lng: results[0].geometry.location.lng()
	        };
	        console.warn('Deprecated: Passing a callback to geocodeByPlaceId is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyplaceid-api"');
	        callback(null, latLng, results);
	      }
	
	      resolve(results);
	    });
	  });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(384);
	
	var _warning = __webpack_require__(158);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(382);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(670);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(664);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(665);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(666);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(667);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(415);
	
	var _wrapMapToProps = __webpack_require__(383);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(383);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(385);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(668);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(158);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(386);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(77);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(388);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(77);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _InternalPropTypes = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _InternalPropTypes = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _createTransitionManager2 = __webpack_require__(392);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(93);
	
	var _RouterContext = __webpack_require__(162);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _RouterUtils = __webpack_require__(389);
	
	var _routerWarning = __webpack_require__(77);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	
	  /**
	   * A <Router> is a high-level API for automatically setting up
	   * a router that renders a <RouterContext> with all the props
	   * it needs each time the URL changes.
	   */
	};var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(159);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(162);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(77);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(549);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(391);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(76);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(159);
	
	var _PromiseUtils = __webpack_require__(387);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(76);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(550);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(391);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(76);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(105);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(390);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(392);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _RouterUtils = __webpack_require__(389);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(159);
	
	var _PromiseUtils = __webpack_require__(387);
	
	var _PatternUtils = __webpack_require__(76);
	
	var _routerWarning = __webpack_require__(77);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(45);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(219);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(160);
	
	var _PropTypes = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChartCanvas = __webpack_require__(690);
	
	Object.defineProperty(exports, "ChartCanvas", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChartCanvas).default;
	  }
	});
	
	var _Chart = __webpack_require__(394);
	
	Object.defineProperty(exports, "Chart", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chart).default;
	  }
	});
	
	var _GenericChartComponent = __webpack_require__(12);
	
	Object.defineProperty(exports, "GenericChartComponent", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GenericChartComponent).default;
	  }
	});
	
	var _GenericComponent = __webpack_require__(17);
	
	Object.defineProperty(exports, "GenericComponent", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GenericComponent).default;
	  }
	});
	
	var _BackgroundText = __webpack_require__(688);
	
	Object.defineProperty(exports, "BackgroundText", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BackgroundText).default;
	  }
	});
	
	var _ZoomButtons = __webpack_require__(692);
	
	Object.defineProperty(exports, "ZoomButtons", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ZoomButtons).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = exports.version = "0.7.8";
	
	/*
	// chart types & Series
	import * as series from "./lib/series";
	import * as scale from "./lib/scale";
	
	import * as coordinates from "./lib/coordinates";
	import * as indicator from "./lib/indicator";
	import * as algorithm from "./lib/algorithm";
	
	import * as annotation from "./lib/annotation";
	
	import * as axes from "./lib/axes";
	import * as tooltip from "./lib/tooltip";
	import * as helper from "./lib/helper";
	
	import * as interactive from "./lib/interactive";
	import * as utils from "./lib/utils";
	
	*/
	//# sourceMappingURL=index.js.map

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureComponent2 = __webpack_require__(167);
	
	var _PureComponent3 = _interopRequireDefault(_PureComponent2);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackgroundText = function (_PureComponent) {
		_inherits(BackgroundText, _PureComponent);
	
		function BackgroundText() {
			_classCallCheck(this, BackgroundText);
	
			return _possibleConstructorReturn(this, (BackgroundText.__proto__ || Object.getPrototypeOf(BackgroundText)).apply(this, arguments));
		}
	
		_createClass(BackgroundText, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.context.chartCanvasType !== "svg" && (0, _utils.isDefined)(this.context.getCanvasContexts)) {
					var contexts = this.context.getCanvasContexts();
					if (contexts) BackgroundText.drawOnCanvas(contexts.bg, this.props, this.context, this.props.children);
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate() {
				this.componentDidMount();
			}
		}, {
			key: "render",
			value: function render() {
				var chartCanvasType = this.context.chartCanvasType;
	
	
				if (chartCanvasType !== "svg") return null;
	
				var _props = this.props,
				    x = _props.x,
				    y = _props.y,
				    fill = _props.fill,
				    opacity = _props.opacity,
				    stroke = _props.stroke,
				    strokeOpacity = _props.strokeOpacity,
				    fontFamily = _props.fontFamily,
				    fontSize = _props.fontSize,
				    textAnchor = _props.textAnchor;
	
				var props = { x: x, y: y, fill: fill, opacity: opacity, stroke: stroke, strokeOpacity: strokeOpacity, fontFamily: fontFamily, fontSize: fontSize, textAnchor: textAnchor };
				return _react2.default.createElement(
					"text",
					props,
					"this.props.children(interval)"
				);
			}
		}]);
	
		return BackgroundText;
	}(_PureComponent3.default);
	
	BackgroundText.drawOnCanvas = function (ctx, props, _ref, getText) {
		var interval = _ref.interval;
	
		ctx.clearRect(-1, -1, ctx.canvas.width + 2, ctx.canvas.height + 2);
		ctx.save();
	
		ctx.setTransform(1, 0, 0, 1, 0, 0);
		ctx.translate(0.5, 0.5);
	
		var x = props.x,
		    y = props.y,
		    fill = props.fill,
		    opacity = props.opacity,
		    stroke = props.stroke,
		    strokeOpacity = props.strokeOpacity,
		    fontFamily = props.fontFamily,
		    fontSize = props.fontSize,
		    textAnchor = props.textAnchor;
	
	
		var text = getText(interval);
	
		ctx.strokeStyle = (0, _utils.hexToRGBA)(stroke, strokeOpacity);
	
		ctx.font = fontSize + "px " + fontFamily;
		ctx.fillStyle = (0, _utils.hexToRGBA)(fill, opacity);
		ctx.textAlign = textAnchor === "middle" ? "center" : textAnchor;
	
		if (stroke !== "none") ctx.strokeText(text, x, y);
		ctx.fillText(text, x, y);
	
		ctx.restore();
	};
	
	BackgroundText.propTypes = {
		x: _propTypes2.default.number.isRequired,
		y: _propTypes2.default.number.isRequired,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number.isRequired,
		fill: _propTypes2.default.string,
		stroke: _propTypes2.default.string,
		opacity: _propTypes2.default.number,
		strokeOpacity: _propTypes2.default.number,
		textAnchor: _propTypes2.default.string,
		children: _propTypes2.default.func
	};
	
	BackgroundText.defaultProps = {
		opacity: 0.3,
		fill: "#9E7523",
		stroke: "#9E7523",
		strokeOpacity: 1,
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 12,
		textAnchor: "middle"
	};
	
	BackgroundText.contextTypes = {
		interval: _propTypes2.default.string.isRequired,
		getCanvasContexts: _propTypes2.default.func,
		chartCanvasType: _propTypes2.default.string
	};
	
	exports.default = BackgroundText;
	//# sourceMappingURL=BackgroundText.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _utils.getLogger)("CanvasContainer");
	
	var CanvasContainer = function (_Component) {
		_inherits(CanvasContainer, _Component);
	
		function CanvasContainer(props) {
			_classCallCheck(this, CanvasContainer);
	
			var _this = _possibleConstructorReturn(this, (CanvasContainer.__proto__ || Object.getPrototypeOf(CanvasContainer)).call(this, props));
	
			_this.setDrawCanvas = _this.setDrawCanvas.bind(_this);
			_this.drawCanvas = {};
			return _this;
		}
	
		_createClass(CanvasContainer, [{
			key: "setDrawCanvas",
			value: function setDrawCanvas(node) {
				if ((0, _utils.isDefined)(node)) this.drawCanvas[node.id] = node.getContext("2d");else this.drawCanvas = {};
			}
		}, {
			key: "getCanvasContexts",
			value: function getCanvasContexts() {
				if ((0, _utils.isDefined)(this.drawCanvas.axes)) {
					return this.drawCanvas;
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _props = this.props,
				    height = _props.height,
				    width = _props.width,
				    type = _props.type,
				    zIndex = _props.zIndex,
				    ratio = _props.ratio;
	
				if (type === "svg") return null;
	
				log("using ratio ", ratio);
	
				return _react2.default.createElement(
					"div",
					{ style: { position: "absolute", zIndex: zIndex } },
					_react2.default.createElement("canvas", { id: "bg", ref: this.setDrawCanvas, width: width * ratio, height: height * ratio,
						style: { position: "absolute", width: width, height: height } }),
					_react2.default.createElement("canvas", { id: "axes", ref: this.setDrawCanvas, width: width * ratio, height: height * ratio,
						style: { position: "absolute", width: width, height: height } }),
					_react2.default.createElement("canvas", { id: "mouseCoord", ref: this.setDrawCanvas, width: width * ratio, height: height * ratio,
						style: { position: "absolute", width: width, height: height } })
				);
			}
		}]);
	
		return CanvasContainer;
	}(_react.Component);
	/*
					<canvas id="hover" ref={this.setDrawCanvas} width={width * ratio} height={height * ratio}
						style={{ position: "absolute", width: width, height: height }} />
	*/
	
	
	CanvasContainer.propTypes = {
		width: _propTypes2.default.number.isRequired,
		height: _propTypes2.default.number.isRequired,
		type: _propTypes2.default.string.isRequired,
		zIndex: _propTypes2.default.number,
		ratio: _propTypes2.default.number.isRequired
	};
	
	exports.default = CanvasContainer;
	//# sourceMappingURL=CanvasContainer.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/* eslint-disable no-unused-vars */
	
	/* eslint-enable no-unused-vars */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Array = __webpack_require__(21);
	
	var _utils = __webpack_require__(4);
	
	var _zoomBehavior = __webpack_require__(789);
	
	var _ChartDataUtil = __webpack_require__(166);
	
	var _EventCapture = __webpack_require__(691);
	
	var _EventCapture2 = _interopRequireDefault(_EventCapture);
	
	var _CanvasContainer = __webpack_require__(689);
	
	var _CanvasContainer2 = _interopRequireDefault(_CanvasContainer);
	
	var _evaluator2 = __webpack_require__(750);
	
	var _evaluator3 = _interopRequireDefault(_evaluator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _utils.getLogger)("ChartCanvas");
	
	var CANDIDATES_FOR_RESET = ["seriesName"];
	
	function shouldResetChart(thisProps, nextProps) {
		return !CANDIDATES_FOR_RESET.every(function (key) {
			var result = (0, _utils.shallowEqual)(thisProps[key], nextProps[key]);
			// console.log(key, result);
			return result;
		});
	}
	
	function getCursorStyle() {
		var tooltipStyle = "\n\t.react-stockcharts-grabbing-cursor {\n\t\tpointer-events: all;\n\t\tcursor: -moz-grabbing;\n\t\tcursor: -webkit-grabbing;\n\t\tcursor: grabbing;\n\t}\n\t.react-stockcharts-crosshair-cursor {\n\t\tpointer-events: all;\n\t\tcursor: crosshair;\n\t}\n\t.react-stockcharts-tooltip-hover {\n\t\tpointer-events: all;\n\t\tcursor: pointer;\n\t}\n\t.react-stockcharts-avoid-interaction {\n\t\tpointer-events: none;\n\t}\n\t.react-stockcharts-enable-interaction {\n\t\tpointer-events: all;\n\t}\n\t.react-stockcharts-tooltip {\n\t\tpointer-events: all;\n\t\tcursor: pointer;\n\t}\n\t.react-stockcharts-default-cursor {\n\t\tcursor: default;\n\t}\n\t.react-stockcharts-move-cursor {\n\t\tcursor: move;\n\t}\n\t.react-stockcharts-pointer-cursor {\n\t\tcursor: pointer;\n\t}\n\t.react-stockcharts-ns-resize-cursor {\n\t\tcursor: ns-resize;\n\t}\n\t.react-stockcharts-ew-resize-cursor {\n\t\tcursor: ew-resize;\n\t}";
		return _react2.default.createElement(
			"style",
			{ type: "text/css" },
			tooltipStyle
		);
	}
	
	function getDimensions(props) {
		return {
			height: props.height - props.margin.top - props.margin.bottom,
			width: props.width - props.margin.left - props.margin.right
		};
	}
	
	function getXScaleDirection(flipXScale) {
		return flipXScale ? -1 : 1;
	}
	
	function calculateFullData(props) {
		var fullData = props.data,
		    plotFull = props.plotFull,
		    xScale = props.xScale,
		    clamp = props.clamp,
		    pointsPerPxThreshold = props.pointsPerPxThreshold,
		    flipXScale = props.flipXScale;
		var xAccessor = props.xAccessor,
		    displayXAccessor = props.displayXAccessor,
		    minPointsPerPxThreshold = props.minPointsPerPxThreshold;
	
	
		var useWholeData = (0, _utils.isDefined)(plotFull) ? plotFull : xAccessor === _utils.identity;
	
		var _evaluator = (0, _evaluator3.default)({
			xScale: xScale,
			useWholeData: useWholeData,
			clamp: clamp,
			pointsPerPxThreshold: pointsPerPxThreshold,
			minPointsPerPxThreshold: minPointsPerPxThreshold,
			flipXScale: flipXScale
		}),
		    filterData = _evaluator.filterData;
	
		return {
			xAccessor: xAccessor,
			displayXAccessor: displayXAccessor || xAccessor,
			xScale: xScale.copy(),
			fullData: fullData,
			filterData: filterData
		};
	}
	function resetChart(props) {
		var firstCalculation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		if (false) {
			if (!firstCalculation) log("CHART RESET");
		}
	
		var state = calculateState(props);
		var xAccessor = state.xAccessor,
		    displayXAccessor = state.displayXAccessor,
		    fullData = state.fullData;
		var initialPlotData = state.plotData,
		    xScale = state.xScale;
		var postCalculator = props.postCalculator,
		    children = props.children;
	
	
		var plotData = postCalculator(initialPlotData);
	
		var dimensions = getDimensions(props);
		var chartConfig = (0, _ChartDataUtil.getChartConfigWithUpdatedYScales)((0, _ChartDataUtil.getNewChartConfig)(dimensions, children), { plotData: plotData, xAccessor: xAccessor, displayXAccessor: displayXAccessor, fullData: fullData }, xScale.domain());
	
		return _extends({}, state, {
			xScale: xScale,
			plotData: plotData,
			chartConfig: chartConfig
		});
	}
	
	function updateChart(newState, initialXScale, props, lastItemWasVisible, initialChartConfig) {
		var fullData = newState.fullData,
		    xScale = newState.xScale,
		    xAccessor = newState.xAccessor,
		    displayXAccessor = newState.displayXAccessor,
		    filterData = newState.filterData;
	
	
		var lastItem = (0, _utils.last)(fullData);
	
		var _initialXScale$domain = initialXScale.domain(),
		    _initialXScale$domain2 = _slicedToArray(_initialXScale$domain, 2),
		    start = _initialXScale$domain2[0],
		    end = _initialXScale$domain2[1];
	
		if (false) {
			log("TRIVIAL CHANGE");
		}
	
		var postCalculator = props.postCalculator,
		    children = props.children,
		    padding = props.padding,
		    flipXScale = props.flipXScale;
		var maintainPointsPerPixelOnResize = props.maintainPointsPerPixelOnResize;
	
		var direction = getXScaleDirection(flipXScale);
		var dimensions = getDimensions(props);
	
		var updatedXScale = setXRange(xScale, dimensions, padding, direction);
	
		// console.log("lastItemWasVisible =", lastItemWasVisible, end, xAccessor(lastItem), end >= xAccessor(lastItem));
		var initialPlotData = void 0;
		if (!lastItemWasVisible || end >= xAccessor(lastItem)) {
			// resize comes here...
			var _initialXScale$range = initialXScale.range(),
			    _initialXScale$range2 = _slicedToArray(_initialXScale$range, 2),
			    rangeStart = _initialXScale$range2[0],
			    rangeEnd = _initialXScale$range2[1];
	
			var _updatedXScale$range = updatedXScale.range(),
			    _updatedXScale$range2 = _slicedToArray(_updatedXScale$range, 2),
			    newRangeStart = _updatedXScale$range2[0],
			    newRangeEnd = _updatedXScale$range2[1];
	
			var newDomainExtent = (newRangeEnd - newRangeStart) / (rangeEnd - rangeStart) * (end - start);
			var newStart = maintainPointsPerPixelOnResize ? end - newDomainExtent : start;
	
			var lastItemX = initialXScale(xAccessor(lastItem));
			// console.log("pointsPerPixel => ", newStart, start, end, updatedXScale(end));
			var response = filterData(fullData, [newStart, end], xAccessor, updatedXScale, { fallbackStart: start, fallbackEnd: { lastItem: lastItem, lastItemX: lastItemX } });
			initialPlotData = response.plotData;
			updatedXScale.domain(response.domain);
			// console.log("HERE!!!!!", start, end);
		} else if (lastItemWasVisible && end < xAccessor(lastItem)) {
			// this is when a new item is added and last item was visible
			// so slide over and show the new item also
	
			// get plotData between [xAccessor(l) - (end - start), xAccessor(l)] and DO change the domain
			var dx = initialXScale(xAccessor(lastItem)) - initialXScale.range()[1];
	
			var _initialXScale$range$ = initialXScale.range().map(function (x) {
				return x + dx;
			}).map(initialXScale.invert),
			    _initialXScale$range$2 = _slicedToArray(_initialXScale$range$, 2),
			    _newStart = _initialXScale$range$2[0],
			    newEnd = _initialXScale$range$2[1];
	
			var _response = filterData(fullData, [_newStart, newEnd], xAccessor, updatedXScale);
			initialPlotData = _response.plotData;
			updatedXScale.domain(_response.domain); // if last item was visible, then shift
		}
		// plotData = getDataOfLength(fullData, showingInterval, plotData.length)
		var plotData = postCalculator(initialPlotData);
		var chartConfig = (0, _ChartDataUtil.getChartConfigWithUpdatedYScales)((0, _ChartDataUtil.getNewChartConfig)(dimensions, children, initialChartConfig), { plotData: plotData, xAccessor: xAccessor, displayXAccessor: displayXAccessor, fullData: fullData }, updatedXScale.domain());
	
		return {
			xScale: updatedXScale,
			xAccessor: xAccessor,
			chartConfig: chartConfig,
			plotData: plotData,
			fullData: fullData,
			filterData: filterData
		};
	}
	
	function calculateState(props) {
		var inputXAccesor = props.xAccessor,
		    xExtentsProp = props.xExtents,
		    data = props.data,
		    padding = props.padding,
		    flipXScale = props.flipXScale;
	
	
		if (false) {
			for (var i = 1; i < data.length; i++) {
				var prev = data[i - 1];
				var curr = data[i];
				if (inputXAccesor(prev) > inputXAccesor(curr)) {
					throw new Error("'data' is not sorted on 'xAccessor', send 'data' sorted in ascending order of 'xAccessor'");
				}
			}
		}
	
		var direction = getXScaleDirection(flipXScale);
		var dimensions = getDimensions(props);
	
		var extent = typeof xExtentsProp === "function" ? xExtentsProp(data) : (0, _d3Array.extent)(xExtentsProp.map(function (d) {
			return (0, _utils.functor)(d);
		}).map(function (each) {
			return each(data, inputXAccesor);
		}));
	
		var _calculateFullData = calculateFullData(props),
		    xAccessor = _calculateFullData.xAccessor,
		    displayXAccessor = _calculateFullData.displayXAccessor,
		    xScale = _calculateFullData.xScale,
		    fullData = _calculateFullData.fullData,
		    filterData = _calculateFullData.filterData;
	
		var updatedXScale = setXRange(xScale, dimensions, padding, direction);
	
		var _filterData = filterData(fullData, extent, inputXAccesor, updatedXScale),
		    plotData = _filterData.plotData,
		    domain = _filterData.domain;
	
		if (false) {
			throw new Error("Showing " + plotData.length + " datapoints, review the 'xExtents' prop of ChartCanvas");
		}
		return {
			plotData: plotData,
			xScale: updatedXScale.domain(domain),
			xAccessor: xAccessor,
			displayXAccessor: displayXAccessor,
			fullData: fullData,
			filterData: filterData
		};
	}
	
	function setXRange(xScale, dimensions, padding) {
		var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
		if (xScale.rangeRoundPoints) {
			if (isNaN(padding)) throw new Error("padding has to be a number for ordinal scale");
			xScale.rangeRoundPoints([0, dimensions.width], padding);
		} else if (xScale.padding) {
			if (isNaN(padding)) throw new Error("padding has to be a number for ordinal scale");
			xScale.range([0, dimensions.width]);
			xScale.padding(padding / 2);
		} else {
			var _ref = isNaN(padding) ? padding : { left: padding, right: padding },
			    left = _ref.left,
			    right = _ref.right;
	
			if (direction > 0) {
				xScale.range([left, dimensions.width - right]);
			} else {
				xScale.range([dimensions.width - right, left]);
			}
		}
		return xScale;
	}
	
	function pinchCoordinates(pinch) {
		var touch1Pos = pinch.touch1Pos,
		    touch2Pos = pinch.touch2Pos;
	
	
		return {
			topLeft: [Math.min(touch1Pos[0], touch2Pos[0]), Math.min(touch1Pos[1], touch2Pos[1])],
			bottomRight: [Math.max(touch1Pos[0], touch2Pos[0]), Math.max(touch1Pos[1], touch2Pos[1])]
		};
	}
	
	var ChartCanvas = function (_Component) {
		_inherits(ChartCanvas, _Component);
	
		function ChartCanvas() {
			_classCallCheck(this, ChartCanvas);
	
			var _this = _possibleConstructorReturn(this, (ChartCanvas.__proto__ || Object.getPrototypeOf(ChartCanvas)).call(this));
	
			_this.getDataInfo = _this.getDataInfo.bind(_this);
			_this.getCanvasContexts = _this.getCanvasContexts.bind(_this);
	
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
			_this.handleZoom = _this.handleZoom.bind(_this);
			_this.handlePinchZoom = _this.handlePinchZoom.bind(_this);
			_this.handlePinchZoomEnd = _this.handlePinchZoomEnd.bind(_this);
			_this.handlePan = _this.handlePan.bind(_this);
			_this.handlePanEnd = _this.handlePanEnd.bind(_this);
			_this.handleClick = _this.handleClick.bind(_this);
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleDoubleClick = _this.handleDoubleClick.bind(_this);
			_this.handleContextMenu = _this.handleContextMenu.bind(_this);
			_this.handleDragStart = _this.handleDragStart.bind(_this);
			_this.handleDrag = _this.handleDrag.bind(_this);
			_this.handleDragEnd = _this.handleDragEnd.bind(_this);
	
			_this.panHelper = _this.panHelper.bind(_this);
			_this.pinchZoomHelper = _this.pinchZoomHelper.bind(_this);
			_this.xAxisZoom = _this.xAxisZoom.bind(_this);
			_this.yAxisZoom = _this.yAxisZoom.bind(_this);
			_this.resetYDomain = _this.resetYDomain.bind(_this);
			_this.calculateStateForDomain = _this.calculateStateForDomain.bind(_this);
			_this.generateSubscriptionId = _this.generateSubscriptionId.bind(_this);
			_this.draw = _this.draw.bind(_this);
			_this.redraw = _this.redraw.bind(_this);
			_this.getAllPanConditions = _this.getAllPanConditions.bind(_this);
	
			_this.subscriptions = [];
			_this.subscribe = _this.subscribe.bind(_this);
			_this.unsubscribe = _this.unsubscribe.bind(_this);
			_this.amIOnTop = _this.amIOnTop.bind(_this);
			_this.saveEventCaptureNode = _this.saveEventCaptureNode.bind(_this);
			_this.saveCanvasContainerNode = _this.saveCanvasContainerNode.bind(_this);
			_this.setCursorClass = _this.setCursorClass.bind(_this);
			_this.getMutableState = _this.getMutableState.bind(_this);
			// this.canvasDrawCallbackList = [];
			_this.interactiveState = [];
			_this.panInProgress = false;
	
			_this.state = {};
			_this.mutableState = {};
			_this.lastSubscriptionId = 0;
			return _this;
		}
	
		_createClass(ChartCanvas, [{
			key: "saveEventCaptureNode",
			value: function saveEventCaptureNode(node) {
				this.eventCaptureNode = node;
			}
		}, {
			key: "saveCanvasContainerNode",
			value: function saveCanvasContainerNode(node) {
				this.canvasContainerNode = node;
			}
		}, {
			key: "getMutableState",
			value: function getMutableState() {
				return this.mutableState;
			}
		}, {
			key: "getDataInfo",
			value: function getDataInfo() {
				return _extends({}, this.state, {
					fullData: this.fullData
				});
			}
		}, {
			key: "getCanvasContexts",
			value: function getCanvasContexts() {
				if (this.canvasContainerNode) {
					return this.canvasContainerNode.getCanvasContexts();
				}
			}
		}, {
			key: "generateSubscriptionId",
			value: function generateSubscriptionId() {
				this.lastSubscriptionId++;
				return this.lastSubscriptionId;
			}
		}, {
			key: "clearBothCanvas",
			value: function clearBothCanvas() {
				var canvases = this.getCanvasContexts();
				if (canvases && canvases.axes) {
					(0, _utils.clearCanvas)([canvases.axes,
					// canvases.hover,
					canvases.mouseCoord], this.props.ratio);
				}
			}
		}, {
			key: "clearMouseCanvas",
			value: function clearMouseCanvas() {
				var canvases = this.getCanvasContexts();
				if (canvases && canvases.mouseCoord) {
					(0, _utils.clearCanvas)([canvases.mouseCoord], this.props.ratio);
				}
			}
		}, {
			key: "clearThreeCanvas",
			value: function clearThreeCanvas() {
				var canvases = this.getCanvasContexts();
				if (canvases && canvases.axes) {
					(0, _utils.clearCanvas)([canvases.axes,
					// canvases.hover,
					canvases.mouseCoord, canvases.bg], this.props.ratio);
				}
			}
		}, {
			key: "subscribe",
			value: function subscribe(id, rest) {
				var _rest$getPanCondition = rest.getPanConditions,
				    getPanConditions = _rest$getPanCondition === undefined ? (0, _utils.functor)({
					draggable: false,
					panEnabled: true
				}) : _rest$getPanCondition;
	
				this.subscriptions = this.subscriptions.concat(_extends({
					id: id
				}, rest, {
					getPanConditions: getPanConditions
				}));
			}
		}, {
			key: "unsubscribe",
			value: function unsubscribe(id) {
				this.subscriptions = this.subscriptions.filter(function (each) {
					return each.id !== id;
				});
			}
		}, {
			key: "getAllPanConditions",
			value: function getAllPanConditions() {
				return this.subscriptions.map(function (each) {
					return each.getPanConditions();
				});
			}
		}, {
			key: "setCursorClass",
			value: function setCursorClass(className) {
				if (this.eventCaptureNode != null) {
					this.eventCaptureNode.setCursorClass(className);
				}
			}
		}, {
			key: "amIOnTop",
			value: function amIOnTop(id) {
				var dragableComponents = this.subscriptions.filter(function (each) {
					return each.getPanConditions().draggable;
				});
	
				return dragableComponents.length > 0 && (0, _utils.last)(dragableComponents).id === id;
			}
		}, {
			key: "handleContextMenu",
			value: function handleContextMenu(mouseXY, e) {
				var _state = this.state,
				    xAccessor = _state.xAccessor,
				    chartConfig = _state.chartConfig,
				    plotData = _state.plotData,
				    xScale = _state.xScale;
	
	
				var currentCharts = (0, _ChartDataUtil.getCurrentCharts)(chartConfig, mouseXY);
				var currentItem = (0, _ChartDataUtil.getCurrentItem)(xScale, xAccessor, mouseXY, plotData);
	
				this.triggerEvent("contextmenu", {
					mouseXY: mouseXY,
					currentItem: currentItem,
					currentCharts: currentCharts
				}, e);
			}
		}, {
			key: "calculateStateForDomain",
			value: function calculateStateForDomain(newDomain) {
				var _state2 = this.state,
				    xAccessor = _state2.xAccessor,
				    displayXAccessor = _state2.displayXAccessor,
				    initialXScale = _state2.xScale,
				    initialChartConfig = _state2.chartConfig,
				    initialPlotData = _state2.plotData;
				var filterData = this.state.filterData;
				var fullData = this.fullData;
				var postCalculator = this.props.postCalculator;
	
				var _filterData2 = filterData(fullData, newDomain, xAccessor, initialXScale, {
					currentPlotData: initialPlotData,
					currentDomain: initialXScale.domain()
				}),
				    beforePlotData = _filterData2.plotData,
				    domain = _filterData2.domain;
	
				var plotData = postCalculator(beforePlotData);
				var updatedScale = initialXScale.copy().domain(domain);
				var chartConfig = (0, _ChartDataUtil.getChartConfigWithUpdatedYScales)(initialChartConfig, { plotData: plotData, xAccessor: xAccessor, displayXAccessor: displayXAccessor, fullData: fullData }, updatedScale.domain());
	
				return {
					xScale: updatedScale,
					plotData: plotData,
					chartConfig: chartConfig
				};
			}
		}, {
			key: "pinchZoomHelper",
			value: function pinchZoomHelper(initialPinch, finalPinch) {
				var initialPinchXScale = initialPinch.xScale;
				var _state3 = this.state,
				    initialXScale = _state3.xScale,
				    initialChartConfig = _state3.chartConfig,
				    initialPlotData = _state3.plotData,
				    xAccessor = _state3.xAccessor,
				    displayXAccessor = _state3.displayXAccessor;
				var filterData = this.state.filterData;
				var fullData = this.fullData;
				var postCalculator = this.props.postCalculator;
	
				var _pinchCoordinates = pinchCoordinates(initialPinch),
				    iTL = _pinchCoordinates.topLeft,
				    iBR = _pinchCoordinates.bottomRight;
	
				var _pinchCoordinates2 = pinchCoordinates(finalPinch),
				    fTL = _pinchCoordinates2.topLeft,
				    fBR = _pinchCoordinates2.bottomRight;
	
				var e = initialPinchXScale.range()[1];
	
				var xDash = Math.round(-(iBR[0] * fTL[0] - iTL[0] * fBR[0]) / (iTL[0] - iBR[0]));
				var yDash = Math.round(e + ((e - iBR[0]) * (e - fTL[0]) - (e - iTL[0]) * (e - fBR[0])) / (e - iTL[0] - (e - iBR[0])));
	
				var x = Math.round(-xDash * iTL[0] / (-xDash + fTL[0]));
				var y = Math.round(e - (yDash - e) * (e - iTL[0]) / (yDash + (e - fTL[0])));
	
				var newDomain = [x, y].map(initialPinchXScale.invert);
				// var domainR = initial.right + right;
	
				var _filterData3 = filterData(fullData, newDomain, xAccessor, initialPinchXScale, {
					currentPlotData: initialPlotData,
					currentDomain: initialXScale.domain()
				}),
				    beforePlotData = _filterData3.plotData,
				    domain = _filterData3.domain;
	
				var plotData = postCalculator(beforePlotData);
				var updatedScale = initialXScale.copy().domain(domain);
	
				var mouseXY = finalPinch.touch1Pos;
				var chartConfig = (0, _ChartDataUtil.getChartConfigWithUpdatedYScales)(initialChartConfig, { plotData: plotData, xAccessor: xAccessor, displayXAccessor: displayXAccessor, fullData: fullData }, updatedScale.domain());
				var currentItem = (0, _ChartDataUtil.getCurrentItem)(updatedScale, xAccessor, mouseXY, plotData);
	
				return {
					chartConfig: chartConfig,
					xScale: updatedScale,
					plotData: plotData,
					mouseXY: mouseXY,
					currentItem: currentItem
				};
			}
		}, {
			key: "cancelDrag",
			value: function cancelDrag() {
				this.eventCaptureNode.cancelDrag();
				this.triggerEvent("dragcancel");
			}
		}, {
			key: "handlePinchZoom",
			value: function handlePinchZoom(initialPinch, finalPinch, e) {
				var _this2 = this;
	
				if (!this.waitingForPinchZoomAnimationFrame) {
					this.waitingForPinchZoomAnimationFrame = true;
					var state = this.pinchZoomHelper(initialPinch, finalPinch);
	
					this.triggerEvent("pinchzoom", state, e);
	
					this.finalPinch = finalPinch;
	
					requestAnimationFrame(function () {
						_this2.clearBothCanvas();
						_this2.draw({ trigger: "pinchzoom" });
						_this2.waitingForPinchZoomAnimationFrame = false;
					});
				}
			}
		}, {
			key: "handlePinchZoomEnd",
			value: function handlePinchZoomEnd(initialPinch, e) {
				var xAccessor = this.state.xAccessor;
	
	
				if (this.finalPinch) {
					var state = this.pinchZoomHelper(initialPinch, this.finalPinch);
					var xScale = state.xScale;
	
					this.triggerEvent("pinchzoom", state, e);
	
					this.finalPinch = null;
	
					this.clearThreeCanvas();
	
					var fullData = this.fullData;
	
					var firstItem = (0, _utils.head)(fullData);
	
					var start = (0, _utils.head)(xScale.domain());
					var end = xAccessor(firstItem);
					var onLoadMore = this.props.onLoadMore;
	
	
					this.setState(state, function () {
						if (start < end) {
							onLoadMore(start, end);
						}
					});
				}
			}
		}, {
			key: "handleZoom",
			value: function handleZoom(zoomDirection, mouseXY, e) {
				if (this.panInProgress) return;
				// console.log("zoomDirection ", zoomDirection, " mouseXY ", mouseXY);
				var _state4 = this.state,
				    xAccessor = _state4.xAccessor,
				    initialXScale = _state4.xScale,
				    initialPlotData = _state4.plotData;
				var _props = this.props,
				    zoomMultiplier = _props.zoomMultiplier,
				    zoomAnchor = _props.zoomAnchor;
				var fullData = this.fullData;
	
				var item = zoomAnchor({
					xScale: initialXScale,
					xAccessor: xAccessor,
					mouseXY: mouseXY,
					plotData: initialPlotData,
					fullData: fullData
				});
	
				var cx = initialXScale(item);
				var c = zoomDirection > 0 ? 1 * zoomMultiplier : 1 / zoomMultiplier;
				var newDomain = initialXScale.range().map(function (x) {
					return cx + (x - cx) * c;
				}).map(initialXScale.invert);
	
				var _calculateStateForDom = this.calculateStateForDomain(newDomain),
				    xScale = _calculateStateForDom.xScale,
				    plotData = _calculateStateForDom.plotData,
				    chartConfig = _calculateStateForDom.chartConfig;
	
				var currentItem = (0, _ChartDataUtil.getCurrentItem)(xScale, xAccessor, mouseXY, plotData);
				var currentCharts = (0, _ChartDataUtil.getCurrentCharts)(chartConfig, mouseXY);
	
				this.clearThreeCanvas();
	
				var firstItem = (0, _utils.head)(fullData);
	
				var start = (0, _utils.head)(xScale.domain());
				var end = xAccessor(firstItem);
				var onLoadMore = this.props.onLoadMore;
	
	
				this.mutableState = {
					mouseXY: mouseXY,
					currentItem: currentItem,
					currentCharts: currentCharts
				};
	
				this.triggerEvent("zoom", {
					xScale: xScale,
					plotData: plotData,
					chartConfig: chartConfig,
					mouseXY: mouseXY,
					currentCharts: currentCharts,
					currentItem: currentItem,
					show: true
				}, e);
	
				this.setState({
					xScale: xScale,
					plotData: plotData,
					chartConfig: chartConfig
				}, function () {
					if (start < end) {
						onLoadMore(start, end);
					}
				});
			}
		}, {
			key: "xAxisZoom",
			value: function xAxisZoom(newDomain) {
				var _calculateStateForDom2 = this.calculateStateForDomain(newDomain),
				    xScale = _calculateStateForDom2.xScale,
				    plotData = _calculateStateForDom2.plotData,
				    chartConfig = _calculateStateForDom2.chartConfig;
	
				this.clearThreeCanvas();
	
				var xAccessor = this.state.xAccessor;
				var fullData = this.fullData;
	
				var firstItem = (0, _utils.head)(fullData);
				var start = (0, _utils.head)(xScale.domain());
				var end = xAccessor(firstItem);
				var onLoadMore = this.props.onLoadMore;
	
	
				this.setState({
					xScale: xScale,
					plotData: plotData,
					chartConfig: chartConfig
				}, function () {
					if (start < end) onLoadMore(start, end);
				});
			}
		}, {
			key: "yAxisZoom",
			value: function yAxisZoom(chartId, newDomain) {
				this.clearThreeCanvas();
				var initialChartConfig = this.state.chartConfig;
	
				var chartConfig = initialChartConfig.map(function (each) {
					if (each.id === chartId) {
						var yScale = each.yScale;
	
						return _extends({}, each, {
							yScale: yScale.copy().domain(newDomain),
							yPanEnabled: true
						});
					} else {
						return each;
					}
				});
	
				this.setState({
					chartConfig: chartConfig
				});
			}
		}, {
			key: "triggerEvent",
			value: function triggerEvent(type, props, e) {
				var _this3 = this;
	
				// console.log("triggering ->", type);
	
				this.subscriptions.forEach(function (each) {
					var state = _extends({}, _this3.state, {
						fullData: _this3.fullData,
						subscriptions: _this3.subscriptions
					});
					each.listener(type, props, state, e);
				});
			}
		}, {
			key: "draw",
			value: function draw(props) {
				this.subscriptions.forEach(function (each) {
					if ((0, _utils.isDefined)(each.draw)) each.draw(props);
				});
			}
		}, {
			key: "redraw",
			value: function redraw() {
				this.clearThreeCanvas();
				this.draw({ force: true });
			}
		}, {
			key: "panHelper",
			value: function panHelper(mouseXY, initialXScale, _ref2, chartsToPan) {
				var dx = _ref2.dx,
				    dy = _ref2.dy;
				var _state5 = this.state,
				    xAccessor = _state5.xAccessor,
				    displayXAccessor = _state5.displayXAccessor,
				    initialChartConfig = _state5.chartConfig;
				var filterData = this.state.filterData;
				var fullData = this.fullData;
				var postCalculator = this.props.postCalculator;
	
				// console.log(dx, dy);
	
				if ((0, _utils.isNotDefined)(initialXScale.invert)) throw new Error("xScale provided does not have an invert() method." + "You are likely using an ordinal scale. This scale does not support zoom, pan");
	
				var newDomain = initialXScale.range().map(function (x) {
					return x - dx;
				}).map(initialXScale.invert);
	
				var _filterData4 = filterData(fullData, newDomain, xAccessor, initialXScale, {
					currentPlotData: this.hackyWayToStopPanBeyondBounds__plotData,
					currentDomain: this.hackyWayToStopPanBeyondBounds__domain
				}),
				    beforePlotData = _filterData4.plotData,
				    domain = _filterData4.domain;
	
				var updatedScale = initialXScale.copy().domain(domain);
				var plotData = postCalculator(beforePlotData);
				// console.log(last(plotData));
	
				var currentItem = (0, _ChartDataUtil.getCurrentItem)(updatedScale, xAccessor, mouseXY, plotData);
				var chartConfig = (0, _ChartDataUtil.getChartConfigWithUpdatedYScales)(initialChartConfig, { plotData: plotData, xAccessor: xAccessor, displayXAccessor: displayXAccessor, fullData: fullData }, updatedScale.domain(), dy, chartsToPan);
				var currentCharts = (0, _ChartDataUtil.getCurrentCharts)(chartConfig, mouseXY);
	
				// console.log(initialXScale.domain(), newDomain, updatedScale.domain());
				return {
					xScale: updatedScale,
					plotData: plotData,
					chartConfig: chartConfig,
					mouseXY: mouseXY,
					currentCharts: currentCharts,
					currentItem: currentItem
				};
			}
		}, {
			key: "handlePan",
			value: function handlePan(mousePosition, panStartXScale, dxdy, chartsToPan, e) {
				var _this4 = this;
	
				if (!this.waitingForPanAnimationFrame) {
					this.waitingForPanAnimationFrame = true;
	
					this.hackyWayToStopPanBeyondBounds__plotData = this.hackyWayToStopPanBeyondBounds__plotData || this.state.plotData;
					this.hackyWayToStopPanBeyondBounds__domain = this.hackyWayToStopPanBeyondBounds__domain || this.state.xScale.domain();
	
					var state = this.panHelper(mousePosition, panStartXScale, dxdy, chartsToPan);
	
					this.hackyWayToStopPanBeyondBounds__plotData = state.plotData;
					this.hackyWayToStopPanBeyondBounds__domain = state.xScale.domain();
	
					this.panInProgress = true;
					// console.log(panStartXScale.domain(), state.xScale.domain());
	
					this.triggerEvent("pan", state, e);
	
					this.mutableState = {
						mouseXY: state.mouseXY,
						currentItem: state.currentItem,
						currentCharts: state.currentCharts
					};
					requestAnimationFrame(function () {
						_this4.waitingForPanAnimationFrame = false;
						_this4.clearBothCanvas();
						_this4.draw({ trigger: "pan" });
					});
				}
			}
		}, {
			key: "handlePanEnd",
			value: function handlePanEnd(mousePosition, panStartXScale, dxdy, chartsToPan, e) {
				var _this5 = this;
	
				var state = this.panHelper(mousePosition, panStartXScale, dxdy, chartsToPan);
				// console.log(this.canvasDrawCallbackList.map(d => d.type));
				this.hackyWayToStopPanBeyondBounds__plotData = null;
				this.hackyWayToStopPanBeyondBounds__domain = null;
	
				this.panInProgress = false;
	
				// console.log("PANEND", panEnd++);
				var xScale = state.xScale,
				    plotData = state.plotData,
				    chartConfig = state.chartConfig;
	
	
				this.triggerEvent("panend", state, e);
	
				requestAnimationFrame(function () {
					var xAccessor = _this5.state.xAccessor;
					var fullData = _this5.fullData;
	
	
					var firstItem = (0, _utils.head)(fullData);
					var start = (0, _utils.head)(xScale.domain());
					var end = xAccessor(firstItem);
					// console.log(start, end, start < end ? "Load more" : "I have it");
	
					var onLoadMore = _this5.props.onLoadMore;
	
	
					_this5.clearThreeCanvas();
	
					_this5.setState({
						xScale: xScale,
						plotData: plotData,
						chartConfig: chartConfig
					}, function () {
						if (start < end) onLoadMore(start, end);
					});
				});
			}
		}, {
			key: "handleMouseDown",
			value: function handleMouseDown(mousePosition, currentCharts, e) {
				this.triggerEvent("mousedown", this.mutableState, e);
			}
		}, {
			key: "handleMouseEnter",
			value: function handleMouseEnter(e) {
				this.triggerEvent("mouseenter", {
					show: true
				}, e);
			}
		}, {
			key: "handleMouseMove",
			value: function handleMouseMove(mouseXY, inputType, e) {
				var _this6 = this;
	
				if (!this.waitingForMouseMoveAnimationFrame) {
					this.waitingForMouseMoveAnimationFrame = true;
	
					var _state6 = this.state,
					    chartConfig = _state6.chartConfig,
					    plotData = _state6.plotData,
					    xScale = _state6.xScale,
					    xAccessor = _state6.xAccessor;
	
					var currentCharts = (0, _ChartDataUtil.getCurrentCharts)(chartConfig, mouseXY);
					var currentItem = (0, _ChartDataUtil.getCurrentItem)(xScale, xAccessor, mouseXY, plotData);
					this.triggerEvent("mousemove", {
						show: true,
						mouseXY: mouseXY,
						// prevMouseXY is used in interactive components
						prevMouseXY: this.prevMouseXY,
						currentItem: currentItem,
						currentCharts: currentCharts
					}, e);
	
					this.prevMouseXY = mouseXY;
					this.mutableState = {
						mouseXY: mouseXY,
						currentItem: currentItem,
						currentCharts: currentCharts
					};
	
					requestAnimationFrame(function () {
						_this6.clearMouseCanvas();
						_this6.draw({ trigger: "mousemove" });
						_this6.waitingForMouseMoveAnimationFrame = false;
					});
				}
			}
		}, {
			key: "handleMouseLeave",
			value: function handleMouseLeave(e) {
				this.triggerEvent("mouseleave", { show: false }, e);
				this.clearMouseCanvas();
				this.draw({ trigger: "mouseleave" });
			}
		}, {
			key: "handleDragStart",
			value: function handleDragStart(_ref3, e) {
				var startPos = _ref3.startPos;
	
				this.triggerEvent("dragstart", { startPos: startPos }, e);
			}
		}, {
			key: "handleDrag",
			value: function handleDrag(_ref4, e) {
				var _this7 = this;
	
				var startPos = _ref4.startPos,
				    mouseXY = _ref4.mouseXY;
				var _state7 = this.state,
				    chartConfig = _state7.chartConfig,
				    plotData = _state7.plotData,
				    xScale = _state7.xScale,
				    xAccessor = _state7.xAccessor;
	
				var currentCharts = (0, _ChartDataUtil.getCurrentCharts)(chartConfig, mouseXY);
				var currentItem = (0, _ChartDataUtil.getCurrentItem)(xScale, xAccessor, mouseXY, plotData);
	
				this.triggerEvent("drag", {
					startPos: startPos,
					mouseXY: mouseXY,
					currentItem: currentItem,
					currentCharts: currentCharts
				}, e);
	
				this.mutableState = {
					mouseXY: mouseXY,
					currentItem: currentItem,
					currentCharts: currentCharts
				};
	
				requestAnimationFrame(function () {
					_this7.clearMouseCanvas();
					_this7.draw({ trigger: "drag" });
				});
			}
		}, {
			key: "handleDragEnd",
			value: function handleDragEnd(_ref5, e) {
				var _this8 = this;
	
				var mouseXY = _ref5.mouseXY;
	
				this.triggerEvent("dragend", { mouseXY: mouseXY }, e);
	
				requestAnimationFrame(function () {
					_this8.clearMouseCanvas();
					_this8.draw({ trigger: "dragend" });
				});
			}
		}, {
			key: "handleClick",
			value: function handleClick(mousePosition, e) {
				var _this9 = this;
	
				this.triggerEvent("click", this.mutableState, e);
	
				requestAnimationFrame(function () {
					_this9.clearMouseCanvas();
					_this9.draw({ trigger: "click" });
				});
			}
		}, {
			key: "handleDoubleClick",
			value: function handleDoubleClick(mousePosition, e) {
				this.triggerEvent("dblclick", {}, e);
			}
		}, {
			key: "getChildContext",
			value: function getChildContext() {
				var dimensions = getDimensions(this.props);
				return {
					fullData: this.fullData,
					plotData: this.state.plotData,
					width: dimensions.width,
					height: dimensions.height,
					chartConfig: this.state.chartConfig,
					xScale: this.state.xScale,
					xAccessor: this.state.xAccessor,
					displayXAccessor: this.state.displayXAccessor,
					chartCanvasType: this.props.type,
					margin: this.props.margin,
					ratio: this.props.ratio,
					xAxisZoom: this.xAxisZoom,
					yAxisZoom: this.yAxisZoom,
					getCanvasContexts: this.getCanvasContexts,
					redraw: this.redraw,
					subscribe: this.subscribe,
					unsubscribe: this.unsubscribe,
					generateSubscriptionId: this.generateSubscriptionId,
					getMutableState: this.getMutableState,
					amIOnTop: this.amIOnTop,
					setCursorClass: this.setCursorClass
				};
			}
		}, {
			key: "componentWillMount",
			value: function componentWillMount() {
				var _resetChart = resetChart(this.props, true),
				    fullData = _resetChart.fullData,
				    state = _objectWithoutProperties(_resetChart, ["fullData"]);
	
				this.setState(state);
				this.fullData = fullData;
			}
		}, {
			key: "componentWillReceiveProps",
			value: function componentWillReceiveProps(nextProps) {
				var reset = shouldResetChart(this.props, nextProps);
	
				var interaction = isInteractionEnabled(this.state.xScale, this.state.xAccessor, this.state.plotData);
				var initialChartConfig = this.state.chartConfig;
	
	
				var newState = void 0;
				if (!interaction || reset || !(0, _utils.shallowEqual)(this.props.xExtents, nextProps.xExtents)) {
					if (false) {
						if (!interaction) log("RESET CHART, changes to a non interactive chart");else if (reset) log("RESET CHART, one or more of these props changed", CANDIDATES_FOR_RESET);else log("xExtents changed");
					}
					// do reset
					newState = resetChart(nextProps);
					this.mutableState = {};
				} else {
					var _state$xScale$domain = this.state.xScale.domain(),
					    _state$xScale$domain2 = _slicedToArray(_state$xScale$domain, 2),
					    start = _state$xScale$domain2[0],
					    end = _state$xScale$domain2[1];
	
					var prevLastItem = (0, _utils.last)(this.fullData);
	
					var calculatedState = calculateFullData(nextProps);
					var xAccessor = calculatedState.xAccessor;
	
					var lastItemWasVisible = xAccessor(prevLastItem) <= end && xAccessor(prevLastItem) >= start;
	
					if (false) {
						if (this.props.data !== nextProps.data) log("data is changed but seriesName did not, change the seriesName if you wish to reset the chart and lastItemWasVisible = ", lastItemWasVisible);else log("Trivial change, may be width/height or type changed, but that does not matter");
					}
	
					newState = updateChart(calculatedState, this.state.xScale, nextProps, lastItemWasVisible, initialChartConfig);
				}
	
				var _newState = newState,
				    fullData = _newState.fullData,
				    state = _objectWithoutProperties(_newState, ["fullData"]);
	
				if (this.panInProgress) {
					if (false) {
						log("Pan is in progress");
					}
				} else {
					/*
	    if (!reset) {
	    	state.chartConfig
	    		.forEach((each) => {
	    			// const sourceChartConfig = initialChartConfig.filter(d => d.id === each.id);
	    			const prevChartConfig = find(initialChartConfig, d => d.id === each.id);
	    			if (isDefined(prevChartConfig) && prevChartConfig.yPanEnabled) {
	    				each.yScale.domain(prevChartConfig.yScale.domain());
	    				each.yPanEnabled = prevChartConfig.yPanEnabled;
	    			}
	    		});
	    }
	    */
					this.clearThreeCanvas();
	
					this.setState(state);
				}
				this.fullData = fullData;
			}
			/*
	  componentDidUpdate(prevProps, prevState) {
	  	console.error(this.state.chartConfig, this.state.chartConfig.map(d => d.yScale.domain()));
	  }
	  */
	
		}, {
			key: "resetYDomain",
			value: function resetYDomain(chartId) {
				var chartConfig = this.state.chartConfig;
	
				var changed = false;
				var newChartConfig = chartConfig.map(function (each) {
					if (((0, _utils.isNotDefined)(chartId) || each.id === chartId) && !(0, _utils.shallowEqual)(each.yScale.domain(), each.realYDomain)) {
						changed = true;
						return _extends({}, each, {
							yScale: each.yScale.domain(each.realYDomain),
							yPanEnabled: false
						});
					}
					return each;
				});
	
				if (changed) {
					this.clearThreeCanvas();
					this.setState({
						chartConfig: newChartConfig
					});
				}
			}
		}, {
			key: "shouldComponentUpdate",
			value: function shouldComponentUpdate() {
				// console.log("Happneing.....", !this.panInProgress)
				return !this.panInProgress;
			}
		}, {
			key: "render",
			value: function render() {
				var _props2 = this.props,
				    type = _props2.type,
				    height = _props2.height,
				    width = _props2.width,
				    margin = _props2.margin,
				    className = _props2.className,
				    zIndex = _props2.zIndex,
				    defaultFocus = _props2.defaultFocus,
				    ratio = _props2.ratio,
				    mouseMoveEvent = _props2.mouseMoveEvent,
				    panEvent = _props2.panEvent,
				    zoomEvent = _props2.zoomEvent;
				var _props3 = this.props,
				    useCrossHairStyleCursor = _props3.useCrossHairStyleCursor,
				    onSelect = _props3.onSelect;
				var _state8 = this.state,
				    plotData = _state8.plotData,
				    xScale = _state8.xScale,
				    xAccessor = _state8.xAccessor,
				    chartConfig = _state8.chartConfig;
	
				var dimensions = getDimensions(this.props);
	
				var interaction = isInteractionEnabled(xScale, xAccessor, plotData);
	
				var cursorStyle = useCrossHairStyleCursor && interaction;
				var cursor = getCursorStyle();
				return _react2.default.createElement(
					"div",
					{ style: { position: "relative", width: width, height: height }, className: className, onClick: onSelect },
					_react2.default.createElement(_CanvasContainer2.default, { ref: this.saveCanvasContainerNode,
						type: type,
						ratio: ratio,
						width: width, height: height, zIndex: zIndex }),
					_react2.default.createElement(
						"svg",
						{ className: className, width: width, height: height, style: { position: "absolute", zIndex: zIndex + 5 } },
						cursor,
						_react2.default.createElement(
							"defs",
							null,
							_react2.default.createElement(
								"clipPath",
								{ id: "chart-area-clip" },
								_react2.default.createElement("rect", { x: "0", y: "0", width: dimensions.width, height: dimensions.height })
							),
							chartConfig.map(function (each, idx) {
								return _react2.default.createElement(
									"clipPath",
									{ key: idx, id: "chart-area-clip-" + each.id },
									_react2.default.createElement("rect", { x: "0", y: "0", width: each.width, height: each.height })
								);
							})
						),
						_react2.default.createElement(
							"g",
							{ transform: "translate(" + (margin.left + 0.5) + ", " + (margin.top + 0.5) + ")" },
							_react2.default.createElement(_EventCapture2.default, {
								ref: this.saveEventCaptureNode,
								useCrossHairStyleCursor: cursorStyle,
								mouseMove: mouseMoveEvent && interaction,
								zoom: zoomEvent && interaction,
								pan: panEvent && interaction,
	
								width: dimensions.width,
								height: dimensions.height,
								chartConfig: chartConfig,
								xScale: xScale,
								xAccessor: xAccessor,
								focus: defaultFocus,
								disableInteraction: this.props.disableInteraction,
	
								getAllPanConditions: this.getAllPanConditions,
								onContextMenu: this.handleContextMenu,
								onClick: this.handleClick,
								onDoubleClick: this.handleDoubleClick,
								onMouseDown: this.handleMouseDown,
								onMouseMove: this.handleMouseMove,
								onMouseEnter: this.handleMouseEnter,
								onMouseLeave: this.handleMouseLeave,
	
								onDragStart: this.handleDragStart,
								onDrag: this.handleDrag,
								onDragComplete: this.handleDragEnd,
	
								onZoom: this.handleZoom,
								onPinchZoom: this.handlePinchZoom,
								onPinchZoomEnd: this.handlePinchZoomEnd,
								onPan: this.handlePan,
								onPanEnd: this.handlePanEnd
							}),
							_react2.default.createElement(
								"g",
								{ className: "react-stockcharts-avoid-interaction" },
								this.props.children
							)
						)
					)
				);
			}
		}]);
	
		return ChartCanvas;
	}(_react.Component);
	
	function isInteractionEnabled(xScale, xAccessor, data) {
		var interaction = !isNaN(xScale(xAccessor((0, _utils.head)(data)))) && (0, _utils.isDefined)(xScale.invert);
		return interaction;
	}
	
	ChartCanvas.propTypes = {
		width: _propTypes2.default.number.isRequired,
		height: _propTypes2.default.number.isRequired,
		margin: _propTypes2.default.object,
		ratio: _propTypes2.default.number.isRequired,
		// interval: PropTypes.oneOf(["D", "W", "M"]), // ,"m1", "m5", "m15", "W", "M"
		type: _propTypes2.default.oneOf(["svg", "hybrid"]),
		pointsPerPxThreshold: _propTypes2.default.number,
		minPointsPerPxThreshold: _propTypes2.default.number,
		data: _propTypes2.default.array.isRequired,
		// initialDisplay: PropTypes.number,
		xAccessor: _propTypes2.default.func,
		xExtents: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]),
		zoomAnchor: _propTypes2.default.func,
	
		className: _propTypes2.default.string,
		seriesName: _propTypes2.default.string.isRequired,
		zIndex: _propTypes2.default.number,
		children: _propTypes2.default.node.isRequired,
		xScale: _propTypes2.default.func.isRequired,
		postCalculator: _propTypes2.default.func,
		flipXScale: _propTypes2.default.bool,
		useCrossHairStyleCursor: _propTypes2.default.bool,
		padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
			left: _propTypes2.default.number,
			right: _propTypes2.default.number
		})]),
		defaultFocus: _propTypes2.default.bool,
		zoomMultiplier: _propTypes2.default.number,
		onLoadMore: _propTypes2.default.func,
		displayXAccessor: function displayXAccessor(props, propName /* , componentName */) {
			if ((0, _utils.isNotDefined)(props[propName])) {
				console.warn("`displayXAccessor` is not defined," + " will use the value from `xAccessor` as `displayXAccessor`." + " This might be ok if you do not use a discontinuous scale" + " but if you do, provide a `displayXAccessor` prop to `ChartCanvas`");
			} else if (typeof props[propName] !== "function") {
				return new Error("displayXAccessor has to be a function");
			}
		},
		mouseMoveEvent: _propTypes2.default.bool,
		panEvent: _propTypes2.default.bool,
		clamp: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.func]),
		zoomEvent: _propTypes2.default.bool,
		onSelect: _propTypes2.default.func,
		maintainPointsPerPixelOnResize: _propTypes2.default.bool,
		disableInteraction: _propTypes2.default.bool
	};
	
	ChartCanvas.defaultProps = {
		margin: { top: 20, right: 30, bottom: 30, left: 80 },
		type: "hybrid",
		pointsPerPxThreshold: 2,
		minPointsPerPxThreshold: 1 / 100,
		className: "react-stockchart",
		zIndex: 1,
		xExtents: [_d3Array.min, _d3Array.max],
		postCalculator: _utils.identity,
		padding: 0,
		xAccessor: _utils.identity,
		flipXScale: false,
		useCrossHairStyleCursor: true,
		defaultFocus: true,
		onLoadMore: _utils.noop,
		onSelect: _utils.noop,
		mouseMoveEvent: true,
		panEvent: true,
		zoomEvent: true,
		zoomMultiplier: 1.1,
		clamp: false,
		zoomAnchor: _zoomBehavior.mouseBasedZoomAnchor,
		maintainPointsPerPixelOnResize: true,
		// ratio: 2,
		disableInteraction: false
	};
	
	ChartCanvas.childContextTypes = {
		plotData: _propTypes2.default.array,
		fullData: _propTypes2.default.array,
		chartConfig: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
			origin: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
			padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
				top: _propTypes2.default.number,
				bottom: _propTypes2.default.number
			})]),
			yExtents: _propTypes2.default.arrayOf(_propTypes2.default.func),
			yExtentsProvider: _propTypes2.default.func,
			yScale: _propTypes2.default.func.isRequired,
			mouseCoordinates: _propTypes2.default.shape({
				at: _propTypes2.default.string,
				format: _propTypes2.default.func
			}),
			width: _propTypes2.default.number.isRequired,
			height: _propTypes2.default.number.isRequired
		})).isRequired,
		xScale: _propTypes2.default.func.isRequired,
		xAccessor: _propTypes2.default.func.isRequired,
		displayXAccessor: _propTypes2.default.func.isRequired,
		width: _propTypes2.default.number.isRequired,
		height: _propTypes2.default.number.isRequired,
		chartCanvasType: _propTypes2.default.oneOf(["svg", "hybrid"]).isRequired,
		margin: _propTypes2.default.object.isRequired,
		ratio: _propTypes2.default.number.isRequired,
		getCanvasContexts: _propTypes2.default.func,
		xAxisZoom: _propTypes2.default.func,
		yAxisZoom: _propTypes2.default.func,
		amIOnTop: _propTypes2.default.func,
		redraw: _propTypes2.default.func,
		subscribe: _propTypes2.default.func,
		unsubscribe: _propTypes2.default.func,
		setCursorClass: _propTypes2.default.func,
		generateSubscriptionId: _propTypes2.default.func,
		getMutableState: _propTypes2.default.func
	};
	
	ChartCanvas.ohlcv = function (d) {
		return { date: d.date, open: d.open, high: d.high, low: d.low, close: d.close, volume: d.volume };
	};
	
	exports.default = ChartCanvas;
	//# sourceMappingURL=ChartCanvas.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Selection = __webpack_require__(177);
	
	var _utils = __webpack_require__(4);
	
	var _ChartDataUtil = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { clearTimeout, setTimeout } from "timers";
	
	var EventCapture = function (_Component) {
		_inherits(EventCapture, _Component);
	
		function EventCapture(props) {
			_classCallCheck(this, EventCapture);
	
			var _this = _possibleConstructorReturn(this, (EventCapture.__proto__ || Object.getPrototypeOf(EventCapture)).call(this, props));
	
			_this.handleEnter = _this.handleEnter.bind(_this);
			_this.handleLeave = _this.handleLeave.bind(_this);
			_this.handleWheel = _this.handleWheel.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handlePanEnd = _this.handlePanEnd.bind(_this);
			_this.handlePan = _this.handlePan.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handlePinchZoom = _this.handlePinchZoom.bind(_this);
			_this.handlePinchZoomEnd = _this.handlePinchZoomEnd.bind(_this);
	
			_this.handleClick = _this.handleClick.bind(_this);
	
			_this.handleRightClick = _this.handleRightClick.bind(_this);
			_this.handleDrag = _this.handleDrag.bind(_this);
			_this.handleDragEnd = _this.handleDragEnd.bind(_this);
	
			_this.shouldPan = _this.shouldPan.bind(_this);
			_this.canPan = _this.canPan.bind(_this);
	
			_this.setCursorClass = _this.setCursorClass.bind(_this);
			_this.saveNode = _this.saveNode.bind(_this);
	
			_this.mouseInside = false;
	
			_this.mouseInteraction = true;
			_this.state = {
				panInProgress: false
			};
			return _this;
		}
	
		_createClass(EventCapture, [{
			key: "saveNode",
			value: function saveNode(node) {
				this.node = node;
			}
		}, {
			key: "componentWillMount",
			value: function componentWillMount() {
				this.focus = this.props.focus;
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.node) {
					(0, _d3Selection.select)(this.node).on(_utils.MOUSEENTER, this.handleEnter).on(_utils.MOUSELEAVE, this.handleLeave);
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate() {
				this.componentDidMount();
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				if (this.node) {
					(0, _d3Selection.select)(this.node).on(_utils.MOUSEENTER, null).on(_utils.MOUSELEAVE, null);
					var win = (0, _utils.d3Window)(this.node);
					(0, _d3Selection.select)(win).on(_utils.MOUSEMOVE, null);
				}
			}
		}, {
			key: "handleEnter",
			value: function handleEnter() {
				var e = _d3Selection.event;
	
				var onMouseEnter = this.props.onMouseEnter;
	
				this.mouseInside = true;
				if (!this.state.panInProgress && !this.state.dragInProgress) {
					var win = (0, _utils.d3Window)(this.node);
					(0, _d3Selection.select)(win).on(_utils.MOUSEMOVE, this.handleMouseMove);
				}
				onMouseEnter(e);
			}
		}, {
			key: "handleLeave",
			value: function handleLeave(e) {
				var onMouseLeave = this.props.onMouseLeave;
	
				this.mouseInside = false;
				if (!this.state.panInProgress && !this.state.dragInProgress) {
					var win = (0, _utils.d3Window)(this.node);
					(0, _d3Selection.select)(win).on(_utils.MOUSEMOVE, null);
				}
				onMouseLeave(e);
			}
		}, {
			key: "handleWheel",
			value: function handleWheel(e) {
				var _props = this.props,
				    zoom = _props.zoom,
				    onZoom = _props.onZoom;
				var panInProgress = this.state.panInProgress;
	
	
				var yZoom = Math.abs(e.deltaY) > Math.abs(e.deltaX) && Math.abs(e.deltaY) > 0;
				// const xPan = Math.abs(e.deltaY) < Math.abs(e.deltaX) && Math.abs(e.deltaX) > 0;
				var mouseXY = (0, _utils.mousePosition)(e);
				e.preventDefault();
	
				if (zoom && this.focus && yZoom && !panInProgress) {
					var zoomDir = e.deltaY > 0 ? 1 : -1;
	
					onZoom(zoomDir, mouseXY, e);
				} else if (this.focus) {
					if (this.shouldPan()) {
						// console.log("Do pan now...")
						// pan already in progress
						var _state$panStart = this.state.panStart,
						    panStartXScale = _state$panStart.panStartXScale,
						    chartsToPan = _state$panStart.chartsToPan;
	
						this.lastNewPos = mouseXY;
						this.panHappened = true;
	
						this.dx += e.deltaX;
						this.dy += e.deltaY;
						var dxdy = { dx: this.dx, dy: this.dy };
	
						this.props.onPan(mouseXY, panStartXScale, dxdy, chartsToPan, e);
					} else {
						// console.log("Pan start...")
						// pan start
	
						var _props2 = this.props,
						    xScale = _props2.xScale,
						    chartConfig = _props2.chartConfig;
	
						var currentCharts = (0, _ChartDataUtil.getCurrentCharts)(chartConfig, mouseXY);
	
						this.dx = 0;
						this.dy = 0;
						this.setState({
							panInProgress: true,
							panStart: {
								panStartXScale: xScale,
								panOrigin: mouseXY,
								chartsToPan: currentCharts
							}
						});
					}
					this.queuePanEnd();
				}
			}
		}, {
			key: "queuePanEnd",
			value: function queuePanEnd() {
				var _this2 = this;
	
				if ((0, _utils.isDefined)(this.panEndTimeout)) {
					clearTimeout(this.panEndTimeout);
				}
				this.panEndTimeout = setTimeout(function () {
					_this2.handlePanEnd();
				}, 100);
			}
		}, {
			key: "handleMouseMove",
			value: function handleMouseMove() {
				var e = _d3Selection.event;
	
				var _props3 = this.props,
				    onMouseMove = _props3.onMouseMove,
				    mouseMove = _props3.mouseMove;
	
	
				if (this.mouseInteraction && mouseMove && !this.state.panInProgress) {
	
					var newPos = (0, _d3Selection.mouse)(this.node);
	
					onMouseMove(newPos, "mouse", e);
				}
			}
		}, {
			key: "handleClick",
			value: function handleClick(e) {
				var _this3 = this;
	
				var mouseXY = (0, _utils.mousePosition)(e);
				var _props4 = this.props,
				    onClick = _props4.onClick,
				    onDoubleClick = _props4.onDoubleClick;
	
	
				if (!this.panHappened && !this.dragHappened) {
					if (this.clicked) {
						onDoubleClick(mouseXY, e);
						this.clicked = false;
					} else {
						onClick(mouseXY, e);
						this.clicked = true;
						setTimeout(function () {
							if (_this3.clicked) {
								_this3.clicked = false;
							}
						}, 400);
					}
				}
			}
		}, {
			key: "handleRightClick",
			value: function handleRightClick(e) {
				e.stopPropagation();
				e.preventDefault();
				var _props5 = this.props,
				    onContextMenu = _props5.onContextMenu,
				    onPanEnd = _props5.onPanEnd;
	
	
				var mouseXY = (0, _utils.mousePosition)(e, this.node.getBoundingClientRect());
	
				if ((0, _utils.isDefined)(this.state.panStart)) {
					var _state$panStart2 = this.state.panStart,
					    panStartXScale = _state$panStart2.panStartXScale,
					    panOrigin = _state$panStart2.panOrigin,
					    chartsToPan = _state$panStart2.chartsToPan;
	
					if (this.panHappened) {
						onPanEnd(mouseXY, panStartXScale, panOrigin, chartsToPan, e);
					}
					var win = (0, _utils.d3Window)(this.node);
					(0, _d3Selection.select)(win).on(_utils.MOUSEMOVE, null).on(_utils.MOUSEUP, null);
	
					this.setState({
						panInProgress: false,
						panStart: null
					});
				}
	
				onContextMenu(mouseXY, e);
			}
		}, {
			key: "handleDrag",
			value: function handleDrag() {
				var e = _d3Selection.event;
				if (this.props.onDrag) {
					this.dragHappened = true;
					var mouseXY = (0, _d3Selection.mouse)(this.node);
					this.props.onDrag({
						startPos: this.state.dragStartPosition,
						mouseXY: mouseXY
					}, e);
				}
			}
		}, {
			key: "cancelDrag",
			value: function cancelDrag() {
				var win = (0, _utils.d3Window)(this.node);
				(0, _d3Selection.select)(win).on(_utils.MOUSEMOVE, this.mouseInside ? this.handleMouseMove : null).on(_utils.MOUSEUP, null);
	
				this.setState({
					dragInProgress: false
				});
				this.mouseInteraction = true;
			}
		}, {
			key: "handleDragEnd",
			value: function handleDragEnd() {
				var e = _d3Selection.event;
				var mouseXY = (0, _d3Selection.mouse)(this.node);
	
				var win = (0, _utils.d3Window)(this.node);
				(0, _d3Selection.select)(win).on(_utils.MOUSEMOVE, this.mouseInside ? this.handleMouseMove : null).on(_utils.MOUSEUP, null);
	
				if (this.dragHappened) {
					this.props.onDragComplete({
						mouseXY: mouseXY
					}, e);
				}
	
				this.setState({
					dragInProgress: false
				});
				this.mouseInteraction = true;
			}
		}, {
			key: "canPan",
			value: function canPan() {
				var getAllPanConditions = this.props.getAllPanConditions;
				var initialPanEnabled = this.props.pan;
	
				var _getAllPanConditions$ = getAllPanConditions().reduce(function (returnObj, a) {
					return {
						draggable: returnObj.draggable || a.draggable,
						panEnabled: returnObj.panEnabled && a.panEnabled
					};
				}, {
					draggable: false,
					panEnabled: initialPanEnabled
				}),
				    panEnabled = _getAllPanConditions$.panEnabled,
				    somethingSelected = _getAllPanConditions$.draggable;
	
				return {
					panEnabled: panEnabled,
					somethingSelected: somethingSelected
				};
			}
		}, {
			key: "handleMouseDown",
			value: function handleMouseDown(e) {
				if (e.button !== 0) {
					return;
				}
				var _props6 = this.props,
				    xScale = _props6.xScale,
				    chartConfig = _props6.chartConfig,
				    onMouseDown = _props6.onMouseDown;
	
	
				this.panHappened = false;
				this.dragHappened = false;
				this.focus = true;
	
				if (!this.state.panInProgress && this.mouseInteraction) {
	
					var mouseXY = (0, _utils.mousePosition)(e);
					var currentCharts = (0, _ChartDataUtil.getCurrentCharts)(chartConfig, mouseXY);
	
					var _canPan = this.canPan(),
					    panEnabled = _canPan.panEnabled,
					    somethingSelected = _canPan.somethingSelected;
	
					var pan = panEnabled && !somethingSelected;
	
					if (pan) {
						this.setState({
							panInProgress: pan,
							panStart: {
								panStartXScale: xScale,
								panOrigin: mouseXY,
								chartsToPan: currentCharts
							}
						});
	
						var win = (0, _utils.d3Window)(this.node);
						(0, _d3Selection.select)(win).on(_utils.MOUSEMOVE, this.handlePan).on(_utils.MOUSEUP, this.handlePanEnd);
					} else if (somethingSelected) {
						this.setState({
							panInProgress: false,
							dragInProgress: true,
							panStart: null,
							dragStartPosition: mouseXY
						});
						this.props.onDragStart({ startPos: mouseXY }, e);
						// this.mouseInteraction = false;
	
						var _win = (0, _utils.d3Window)(this.node);
						(0, _d3Selection.select)(_win).on(_utils.MOUSEMOVE, this.handleDrag).on(_utils.MOUSEUP, this.handleDragEnd);
					}
	
					onMouseDown(mouseXY, currentCharts, e);
				}
				e.preventDefault();
			}
		}, {
			key: "shouldPan",
			value: function shouldPan() {
				var _props7 = this.props,
				    panEnabled = _props7.pan,
				    onPan = _props7.onPan;
	
				return panEnabled && onPan && (0, _utils.isDefined)(this.state.panStart);
			}
		}, {
			key: "handlePan",
			value: function handlePan() {
				var e = _d3Selection.event;
	
				if (this.shouldPan()) {
					this.panHappened = true;
	
					var _state$panStart3 = this.state.panStart,
					    panStartXScale = _state$panStart3.panStartXScale,
					    panOrigin = _state$panStart3.panOrigin,
					    chartsToPan = _state$panStart3.chartsToPan;
	
	
					var mouseXY = this.mouseInteraction ? (0, _d3Selection.mouse)(this.node) : (0, _d3Selection.touches)(this.node)[0];
	
					this.lastNewPos = mouseXY;
					var dx = mouseXY[0] - panOrigin[0];
					var dy = mouseXY[1] - panOrigin[1];
	
					this.dx = dx;
					this.dy = dy;
	
					this.props.onPan(mouseXY, panStartXScale, { dx: dx, dy: dy }, chartsToPan, e);
				}
			}
		}, {
			key: "handlePanEnd",
			value: function handlePanEnd() {
				var e = _d3Selection.event;
				var _props8 = this.props,
				    panEnabled = _props8.pan,
				    onPanEnd = _props8.onPanEnd;
	
	
				if ((0, _utils.isDefined)(this.state.panStart)) {
					var _state$panStart4 = this.state.panStart,
					    panStartXScale = _state$panStart4.panStartXScale,
					    chartsToPan = _state$panStart4.chartsToPan;
	
	
					var win = (0, _utils.d3Window)(this.node);
					(0, _d3Selection.select)(win).on(_utils.MOUSEMOVE, this.mouseInside ? this.handleMouseMove : null).on(_utils.MOUSEUP, null).on(_utils.TOUCHMOVE, null).on(_utils.TOUCHEND, null);
	
					if (this.panHappened
					// && !this.contextMenuClicked
					&& panEnabled && onPanEnd) {
						var dx = this.dx,
						    dy = this.dy;
	
						// console.log(dx, dy)
	
						delete this.dx;
						delete this.dy;
						onPanEnd(this.lastNewPos, panStartXScale, { dx: dx, dy: dy }, chartsToPan, e);
					}
	
					this.setState({
						panInProgress: false,
						panStart: null
					});
				}
			}
		}, {
			key: "handleTouchMove",
			value: function handleTouchMove(e) {
				var onMouseMove = this.props.onMouseMove;
	
				var touchXY = (0, _utils.touchPosition)((0, _utils.getTouchProps)(e.touches[0]), e);
				onMouseMove(touchXY, "touch", e);
			}
		}, {
			key: "handleTouchStart",
			value: function handleTouchStart(e) {
				this.mouseInteraction = false;
	
				var _props9 = this.props,
				    panEnabled = _props9.pan,
				    chartConfig = _props9.chartConfig,
				    onMouseMove = _props9.onMouseMove;
				var _props10 = this.props,
				    xScale = _props10.xScale,
				    onPanEnd = _props10.onPanEnd;
	
	
				if (e.touches.length === 1) {
	
					this.panHappened = false;
					var touchXY = (0, _utils.touchPosition)((0, _utils.getTouchProps)(e.touches[0]), e);
					onMouseMove(touchXY, "touch", e);
	
					if (panEnabled) {
						var currentCharts = (0, _ChartDataUtil.getCurrentCharts)(chartConfig, touchXY);
	
						this.setState({
							panInProgress: true,
							panStart: {
								panStartXScale: xScale,
								panOrigin: touchXY,
								chartsToPan: currentCharts
							}
						});
	
						var win = (0, _utils.d3Window)(this.node);
						(0, _d3Selection.select)(win).on(_utils.TOUCHMOVE, this.handlePan, false).on(_utils.TOUCHEND, this.handlePanEnd, false);
					}
				} else if (e.touches.length === 2) {
					// pinch zoom begin
					// do nothing pinch zoom is handled in handleTouchMove
					var _state = this.state,
					    panInProgress = _state.panInProgress,
					    panStart = _state.panStart;
	
	
					if (panInProgress && panEnabled && onPanEnd) {
						var panStartXScale = panStart.panStartXScale,
						    panOrigin = panStart.panOrigin,
						    chartsToPan = panStart.chartsToPan;
	
	
						var _win2 = (0, _utils.d3Window)(this.node);
						(0, _d3Selection.select)(_win2).on(_utils.MOUSEMOVE, this.mouseInside ? this.handleMouseMove : null).on(_utils.MOUSEUP, null).on(_utils.TOUCHMOVE, this.handlePinchZoom, false).on(_utils.TOUCHEND, this.handlePinchZoomEnd, false);
	
						var touch1Pos = (0, _utils.touchPosition)((0, _utils.getTouchProps)(e.touches[0]), e);
						var touch2Pos = (0, _utils.touchPosition)((0, _utils.getTouchProps)(e.touches[1]), e);
	
						if (this.panHappened
						// && !this.contextMenuClicked
						&& panEnabled && onPanEnd) {
	
							onPanEnd(this.lastNewPos, panStartXScale, panOrigin, chartsToPan, e);
						}
	
						this.setState({
							panInProgress: false,
							pinchZoomStart: {
								xScale: xScale,
								touch1Pos: touch1Pos,
								touch2Pos: touch2Pos,
								range: xScale.range(),
								chartsToPan: chartsToPan
							}
						});
					}
				}
			}
		}, {
			key: "handlePinchZoom",
			value: function handlePinchZoom() {
				var e = _d3Selection.event;
	
				var _touches = (0, _d3Selection.touches)(this.node),
				    _touches2 = _slicedToArray(_touches, 2),
				    touch1Pos = _touches2[0],
				    touch2Pos = _touches2[1];
	
				var _props11 = this.props,
				    xScale = _props11.xScale,
				    zoomEnabled = _props11.zoom,
				    onPinchZoom = _props11.onPinchZoom;
	
				// eslint-disable-next-line no-unused-vars
	
				var _state$pinchZoomStart = this.state.pinchZoomStart,
				    chartsToPan = _state$pinchZoomStart.chartsToPan,
				    initialPinch = _objectWithoutProperties(_state$pinchZoomStart, ["chartsToPan"]);
	
				if (zoomEnabled && onPinchZoom) {
					onPinchZoom(initialPinch, {
						touch1Pos: touch1Pos,
						touch2Pos: touch2Pos,
						xScale: xScale
					}, e);
				}
			}
		}, {
			key: "handlePinchZoomEnd",
			value: function handlePinchZoomEnd() {
				var e = _d3Selection.event;
	
				var win = (0, _utils.d3Window)(this.node);
				(0, _d3Selection.select)(win).on(_utils.TOUCHMOVE, null).on(_utils.TOUCHEND, null);
	
				var _props12 = this.props,
				    zoomEnabled = _props12.zoom,
				    onPinchZoomEnd = _props12.onPinchZoomEnd;
	
				// eslint-disable-next-line no-unused-vars
	
				var _state$pinchZoomStart2 = this.state.pinchZoomStart,
				    chartsToPan = _state$pinchZoomStart2.chartsToPan,
				    initialPinch = _objectWithoutProperties(_state$pinchZoomStart2, ["chartsToPan"]);
	
				if (zoomEnabled && onPinchZoomEnd) {
					onPinchZoomEnd(initialPinch, e);
				}
	
				this.setState({
					pinchZoomStart: null
				});
			}
		}, {
			key: "setCursorClass",
			value: function setCursorClass(cursorOverrideClass) {
				if (cursorOverrideClass !== this.state.cursorOverrideClass) {
					this.setState({
						cursorOverrideClass: cursorOverrideClass
					});
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _props13 = this.props,
				    height = _props13.height,
				    width = _props13.width,
				    disableInteraction = _props13.disableInteraction,
				    useCrossHairStyleCursor = _props13.useCrossHairStyleCursor;
	
				var className = this.state.cursorOverrideClass != null ? this.state.cursorOverrideClass : !useCrossHairStyleCursor ? "" : this.state.panInProgress ? "react-stockcharts-grabbing-cursor" : "react-stockcharts-crosshair-cursor";
	
				var interactionProps = disableInteraction || {
					onWheel: this.handleWheel,
					onMouseDown: this.handleMouseDown,
					onClick: this.handleClick,
					onContextMenu: this.handleRightClick,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove
				};
	
				return _react2.default.createElement("rect", _extends({ ref: this.saveNode,
					className: className,
					width: width,
					height: height,
					style: { opacity: 0 }
				}, interactionProps));
			}
		}]);
	
		return EventCapture;
	}(_react.Component);
	
	// 				onMouseEnter={this.handleEnter}
	//				onMouseLeave={this.handleLeave}
	
	
	EventCapture.propTypes = {
		mouseMove: _propTypes2.default.bool.isRequired,
		zoom: _propTypes2.default.bool.isRequired,
		pan: _propTypes2.default.bool.isRequired,
		panSpeedMultiplier: _propTypes2.default.number.isRequired,
		focus: _propTypes2.default.bool.isRequired,
		useCrossHairStyleCursor: _propTypes2.default.bool.isRequired,
	
		width: _propTypes2.default.number.isRequired,
		height: _propTypes2.default.number.isRequired,
		chartConfig: _propTypes2.default.array,
		xScale: _propTypes2.default.func.isRequired,
		xAccessor: _propTypes2.default.func.isRequired,
		disableInteraction: _propTypes2.default.bool.isRequired,
	
		getAllPanConditions: _propTypes2.default.func.isRequired,
	
		onMouseMove: _propTypes2.default.func,
		onMouseEnter: _propTypes2.default.func,
		onMouseLeave: _propTypes2.default.func,
		onZoom: _propTypes2.default.func,
		onPinchZoom: _propTypes2.default.func,
		onPinchZoomEnd: _propTypes2.default.func.isRequired,
		onPan: _propTypes2.default.func,
		onPanEnd: _propTypes2.default.func,
		onDragStart: _propTypes2.default.func,
		onDrag: _propTypes2.default.func,
		onDragComplete: _propTypes2.default.func,
	
		onClick: _propTypes2.default.func,
		onDoubleClick: _propTypes2.default.func,
		onContextMenu: _propTypes2.default.func,
		onMouseDown: _propTypes2.default.func,
		children: _propTypes2.default.node
	};
	
	EventCapture.defaultProps = {
		mouseMove: false,
		zoom: false,
		pan: false,
		panSpeedMultiplier: 1,
		focus: false,
		onDragComplete: _utils.noop,
		disableInteraction: false
	};
	
	exports.default = EventCapture;
	//# sourceMappingURL=EventCapture.js.map

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Path = __webpack_require__(176);
	
	var _d3Interpolate = __webpack_require__(175);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { mean } from "d3-array";
	
	var ZoomButtons = function (_Component) {
		_inherits(ZoomButtons, _Component);
	
		function ZoomButtons(props) {
			_classCallCheck(this, ZoomButtons);
	
			var _this = _possibleConstructorReturn(this, (ZoomButtons.__proto__ || Object.getPrototypeOf(ZoomButtons)).call(this, props));
	
			_this.handleZoomOut = _this.handleZoomOut.bind(_this);
			_this.handleZoomIn = _this.handleZoomIn.bind(_this);
			_this.zoom = _this.zoom.bind(_this);
			return _this;
		}
	
		_createClass(ZoomButtons, [{
			key: "zoom",
			value: function zoom(direction) {
				var _this2 = this;
	
				var _context = this.context,
				    xAxisZoom = _context.xAxisZoom,
				    xScale = _context.xScale,
				    plotData = _context.plotData,
				    xAccessor = _context.xAccessor;
	
				var cx = xScale(xAccessor((0, _utils.last)(plotData)));
				// mean(xScale.range());
				var zoomMultiplier = this.props.zoomMultiplier;
	
	
				var c = direction > 0 ? 1 * zoomMultiplier : 1 / zoomMultiplier;
	
				var _xScale$domain = xScale.domain(),
				    _xScale$domain2 = _slicedToArray(_xScale$domain, 2),
				    start = _xScale$domain2[0],
				    end = _xScale$domain2[1];
	
				var _xScale$range$map$map = xScale.range().map(function (x) {
					return cx + (x - cx) * c;
				}).map(xScale.invert),
				    _xScale$range$map$map2 = _slicedToArray(_xScale$range$map$map, 2),
				    newStart = _xScale$range$map$map2[0],
				    newEnd = _xScale$range$map$map2[1];
	
				var left = (0, _d3Interpolate.interpolateNumber)(start, newStart);
				var right = (0, _d3Interpolate.interpolateNumber)(end, newEnd);
	
				var foo = [0.25, 0.3, 0.5, 0.6, 0.75, 1].map(function (i) {
					return [left(i), right(i)];
				});
	
				this.interval = setInterval(function () {
					xAxisZoom(foo.shift());
					if (foo.length === 0) {
						clearInterval(_this2.interval);
						delete _this2.interval;
					}
				}, 10);
			}
		}, {
			key: "handleZoomOut",
			value: function handleZoomOut() {
				if (this.interval) return;
				this.zoom(1);
			}
		}, {
			key: "handleZoomIn",
			value: function handleZoomIn() {
				if (this.interval) return;
				this.zoom(-1);
			}
		}, {
			key: "render",
			value: function render() {
				var chartConfig = this.context.chartConfig;
				var width = chartConfig.width,
				    height = chartConfig.height;
				var _props = this.props,
				    size = _props.size,
				    heightFromBase = _props.heightFromBase,
				    rx = _props.rx,
				    ry = _props.ry;
				var _props2 = this.props,
				    stroke = _props2.stroke,
				    strokeOpacity = _props2.strokeOpacity,
				    fill = _props2.fill,
				    strokeWidth = _props2.strokeWidth,
				    fillOpacity = _props2.fillOpacity;
				var _props3 = this.props,
				    textFill = _props3.textFill,
				    textStrokeWidth = _props3.textStrokeWidth;
				var onReset = this.props.onReset;
	
				var centerX = Math.round(width / 2);
				var y = height - heightFromBase;
	
				var _size = _slicedToArray(size, 2),
				    w = _size[0],
				    h = _size[1];
	
				var hLength = 5;
				var wLength = 6;
	
				var textY = Math.round(y + h / 2);
	
				var resetX = centerX;
	
				var zoomOut = (0, _d3Path.path)();
				var zoomOutX = centerX - w - 2 * strokeWidth;
				zoomOut.moveTo(zoomOutX - wLength, textY);
				zoomOut.lineTo(zoomOutX + wLength, textY);
				zoomOut.closePath();
	
				var zoomIn = (0, _d3Path.path)();
				var zoomInX = centerX + w + 2 * strokeWidth;
	
				zoomIn.moveTo(zoomInX - wLength, textY);
				zoomIn.lineTo(zoomInX + wLength, textY);
	
				zoomIn.moveTo(zoomInX, textY - hLength);
				zoomIn.lineTo(zoomInX, textY + hLength);
				// zoomIn.closePath();
	
				return _react2.default.createElement(
					"g",
					{ className: "react-stockcharts-zoom-button" },
					_react2.default.createElement("rect", {
						x: zoomOutX - w / 2,
						y: y,
						rx: rx,
						ry: ry,
						height: h,
						width: w,
						fill: fill,
						fillOpacity: fillOpacity,
						stroke: stroke,
						strokeOpacity: strokeOpacity,
						strokeWidth: strokeWidth
					}),
					_react2.default.createElement("path", { d: zoomOut.toString(),
						stroke: textFill,
						strokeWidth: textStrokeWidth
					}),
					_react2.default.createElement("rect", {
						x: resetX - w / 2,
						y: y,
						rx: rx,
						ry: ry,
						height: h,
						width: w,
						fill: fill,
						fillOpacity: fillOpacity,
						stroke: stroke,
						strokeOpacity: strokeOpacity,
						strokeWidth: strokeWidth
					}),
					_react2.default.createElement(
						"g",
						{ transform: "translate (" + resetX + ", " + (y + h / 4) + ") scale(.14)" },
						_react2.default.createElement("path", { d: "M31 13C23.4 5.3 12.8.5 1.1.5c-23.3 0-42.3 19-42.3 42.5s18.9 42.5 42.3 42.5c13.8 0 26-6.6 33.7-16.9l-16.5-1.8C13.5 70.4 7.5 72.5 1 72.5c-16.2 0-29.3-13.2-29.3-29.4S-15.2 13.7 1 13.7c8.1 0 15.4 3.3 20.7 8.6l-10.9 11h32.5V.5L31 13z",
							fill: textFill
						})
					),
					_react2.default.createElement("rect", {
						x: zoomInX - w / 2,
						y: y,
						rx: rx,
						ry: ry,
						height: h,
						width: w,
						fill: fill,
						fillOpacity: fillOpacity,
						stroke: stroke,
						strokeOpacity: strokeOpacity,
						strokeWidth: strokeWidth
					}),
					_react2.default.createElement("path", { d: zoomIn.toString(),
						stroke: textFill,
						strokeWidth: textStrokeWidth
					}),
					_react2.default.createElement("rect", { className: "react-stockcharts-enable-interaction out",
						onClick: this.handleZoomOut,
						x: zoomOutX - w / 2,
						y: y,
						rx: rx,
						ry: ry,
						height: h,
						width: w,
						fill: "none"
					}),
					_react2.default.createElement("rect", { className: "react-stockcharts-enable-interaction reset",
						onClick: onReset,
						x: resetX - w / 2,
						y: y,
						rx: rx,
						ry: ry,
						height: h,
						width: w,
						fill: "none"
					}),
					_react2.default.createElement("rect", { className: "react-stockcharts-enable-interaction in",
						onClick: this.handleZoomIn,
						x: zoomInX - w / 2,
						y: y,
						rx: rx,
						ry: ry,
						height: h,
						width: w,
						fill: "none"
					})
				);
			}
		}]);
	
		return ZoomButtons;
	}(_react.Component);
	
	ZoomButtons.propTypes = {
		zoomMultiplier: _propTypes2.default.number.isRequired,
		size: _propTypes2.default.array.isRequired,
		heightFromBase: _propTypes2.default.number.isRequired,
		rx: _propTypes2.default.number.isRequired,
		ry: _propTypes2.default.number.isRequired,
		stroke: _propTypes2.default.string.isRequired,
		strokeWidth: _propTypes2.default.number.isRequired,
		strokeOpacity: _propTypes2.default.number.isRequired,
		fill: _propTypes2.default.string.isRequired,
		fillOpacity: _propTypes2.default.number.isRequired,
		fontSize: _propTypes2.default.number.isRequired,
		textDy: _propTypes2.default.string.isRequired,
		textFill: _propTypes2.default.string.isRequired,
		textStrokeWidth: _propTypes2.default.number.isRequired,
		onReset: _propTypes2.default.func
	};
	
	ZoomButtons.defaultProps = {
		size: [30, 24],
		heightFromBase: 50,
		rx: 3,
		ry: 3,
		stroke: "#000000",
		strokeOpacity: 0.3,
		strokeWidth: 1,
		fill: "#D6D6D6",
		fillOpacity: 0.4,
		fontSize: 16,
		textDy: ".3em",
		textFill: "#000000",
		textStrokeWidth: 2,
		zoomMultiplier: 1.5,
		onReset: _utils.noop
	};
	
	ZoomButtons.contextTypes = {
		xScale: _propTypes2.default.func.isRequired,
		chartConfig: _propTypes2.default.object.isRequired,
		plotData: _propTypes2.default.array.isRequired,
		xAccessor: _propTypes2.default.func.isRequired,
		xAxisZoom: _propTypes2.default.func.isRequired
	};
	
	exports.default = ZoomButtons;
	//# sourceMappingURL=ZoomButtons.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Annotate = function (_Component) {
		_inherits(Annotate, _Component);
	
		function Annotate(props) {
			_classCallCheck(this, Annotate);
	
			var _this = _possibleConstructorReturn(this, (Annotate.__proto__ || Object.getPrototypeOf(Annotate)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			return _this;
		}
	
		_createClass(Annotate, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					drawOn: ["pan"]
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData;
				var _props = this.props,
				    className = _props.className,
				    usingProps = _props.usingProps,
				    Annotation = _props.with;
	
				var data = helper(this.props, plotData);
	
				return _react2.default.createElement(
					"g",
					{ className: "react-stockcharts-enable-interaction " + className },
					data.map(function (d, idx) {
						return _react2.default.createElement(Annotation, _extends({ key: idx
						}, usingProps, {
							xScale: xScale,
							yScale: yScale,
							xAccessor: xAccessor,
							plotData: plotData,
							datum: d }));
					})
				);
			}
		}]);
	
		return Annotate;
	}(_react.Component);
	
	Annotate.propTypes = {
		className: _propTypes2.default.string,
		with: _propTypes2.default.func,
		when: _propTypes2.default.func,
		usingProps: _propTypes2.default.object
	};
	
	Annotate.defaultProps = {
		className: "react-stockcharts-annotate react-stockcharts-default-cursor"
	};
	
	function helper(_ref, plotData) {
		var when = _ref.when;
	
		return plotData.filter(when);
	}
	
	exports.default = Annotate;
	//# sourceMappingURL=Annotate.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _GenericComponent2 = _interopRequireDefault(_GenericComponent);
	
	var _utils = __webpack_require__(4);
	
	var _LabelAnnotation = __webpack_require__(395);
	
	var _LabelAnnotation2 = _interopRequireDefault(_LabelAnnotation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Label = function (_Component) {
		_inherits(Label, _Component);
	
		function Label(props) {
			_classCallCheck(this, Label);
	
			var _this = _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(Label, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				drawOnCanvas2(ctx, this.props, this.context, moreProps);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericComponent2.default, {
					canvasToDraw: this.props.selectCanvas,
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					drawOn: []
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var chartConfig = moreProps.chartConfig;
	
	
				return _react2.default.createElement(_LabelAnnotation2.default, _extends({ yScale: getYScale(chartConfig) }, this.props, { text: getText(this.props) }));
			}
		}]);
	
		return Label;
	}(_react.Component);
	
	function getText(props) {
		return (0, _utils.functor)(props.text)(props);
	}
	
	function getYScale(chartConfig) {
		return Array.isArray(chartConfig) ? undefined : chartConfig.yScale;
	}
	
	Label.propTypes = {
		className: _propTypes2.default.string,
		selectCanvas: _propTypes2.default.func,
		text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
		textAnchor: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		opacity: _propTypes2.default.number,
		rotate: _propTypes2.default.number,
		onClick: _propTypes2.default.func,
		xAccessor: _propTypes2.default.func,
		xScale: _propTypes2.default.func,
		yScale: _propTypes2.default.func,
		datum: _propTypes2.default.object,
		x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func])
	};
	
	Label.contextTypes = {
		canvasOriginX: _propTypes2.default.number,
		canvasOriginY: _propTypes2.default.number,
	
		margin: _propTypes2.default.object.isRequired,
		ratio: _propTypes2.default.number.isRequired
	};
	
	Label.defaultProps = _extends({}, _LabelAnnotation.defaultProps, {
		selectCanvas: function selectCanvas(canvases) {
			return canvases.bg;
		}
	});
	
	function drawOnCanvas2(ctx, props, context, moreProps) {
		ctx.save();
	
		var canvasOriginX = context.canvasOriginX,
		    canvasOriginY = context.canvasOriginY,
		    margin = context.margin,
		    ratio = context.ratio;
	
		ctx.setTransform(1, 0, 0, 1, 0, 0);
		ctx.scale(ratio, ratio);
	
		if ((0, _utils.isDefined)(canvasOriginX)) ctx.translate(canvasOriginX, canvasOriginY);else ctx.translate(margin.left + 0.5 * ratio, margin.top + 0.5 * ratio);
	
		drawOnCanvas(ctx, props, moreProps);
	
		ctx.restore();
	}
	
	function drawOnCanvas(ctx, props, moreProps) {
		var textAnchor = props.textAnchor,
		    fontFamily = props.fontFamily,
		    fontSize = props.fontSize,
		    opacity = props.opacity,
		    rotate = props.rotate;
		var xScale = moreProps.xScale,
		    chartConfig = moreProps.chartConfig,
		    xAccessor = moreProps.xAccessor;
	
		var _helper = (0, _LabelAnnotation.helper)(props, xAccessor, xScale, getYScale(chartConfig)),
		    xPos = _helper.xPos,
		    yPos = _helper.yPos,
		    fill = _helper.fill,
		    text = _helper.text;
	
		var radians = rotate / 180 * Math.PI;
		ctx.save();
		ctx.translate(xPos, yPos);
		ctx.rotate(radians);
	
		ctx.font = fontSize + "px " + fontFamily;
		ctx.fillStyle = (0, _utils.hexToRGBA)(fill, opacity);
		ctx.textAlign = textAnchor === "middle" ? "center" : textAnchor;
	
		ctx.beginPath();
		ctx.fillText(text, 0, 0);
		ctx.restore();
	}
	
	exports.default = Label;
	//# sourceMappingURL=Label.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgPathAnnotation = function (_Component) {
		_inherits(SvgPathAnnotation, _Component);
	
		function SvgPathAnnotation(props) {
			_classCallCheck(this, SvgPathAnnotation);
	
			var _this = _possibleConstructorReturn(this, (SvgPathAnnotation.__proto__ || Object.getPrototypeOf(SvgPathAnnotation)).call(this, props));
	
			_this.handleClick = _this.handleClick.bind(_this);
			return _this;
		}
	
		_createClass(SvgPathAnnotation, [{
			key: "handleClick",
			value: function handleClick(e) {
				var onClick = this.props.onClick;
	
	
				if (onClick) {
					var _props = this.props,
					    xScale = _props.xScale,
					    yScale = _props.yScale,
					    datum = _props.datum;
	
					onClick({ xScale: xScale, yScale: yScale, datum: datum }, e);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _props2 = this.props,
				    className = _props2.className,
				    stroke = _props2.stroke,
				    opacity = _props2.opacity;
				var _props3 = this.props,
				    xAccessor = _props3.xAccessor,
				    xScale = _props3.xScale,
				    yScale = _props3.yScale,
				    path = _props3.path;
	
				var _helper = helper(this.props, xAccessor, xScale, yScale),
				    x = _helper.x,
				    y = _helper.y,
				    fill = _helper.fill,
				    tooltip = _helper.tooltip;
	
				return _react2.default.createElement(
					"g",
					{ className: className, onClick: this.handleClick },
					_react2.default.createElement(
						"title",
						null,
						tooltip
					),
					_react2.default.createElement("path", { d: path({ x: x, y: y }), stroke: stroke, fill: fill, opacity: opacity })
				);
			}
		}]);
	
		return SvgPathAnnotation;
	}(_react.Component);
	
	function helper(props, xAccessor, xScale, yScale) {
		var x = props.x,
		    y = props.y,
		    datum = props.datum,
		    fill = props.fill,
		    tooltip = props.tooltip,
		    plotData = props.plotData;
	
	
		var xFunc = (0, _utils.functor)(x);
		var yFunc = (0, _utils.functor)(y);
	
		var _ref = [xFunc({ xScale: xScale, xAccessor: xAccessor, datum: datum, plotData: plotData }), yFunc({ yScale: yScale, datum: datum, plotData: plotData })],
		    xPos = _ref[0],
		    yPos = _ref[1];
	
	
		return {
			x: xPos,
			y: yPos,
			fill: (0, _utils.functor)(fill)(datum),
			tooltip: (0, _utils.functor)(tooltip)(datum)
		};
	}
	
	SvgPathAnnotation.propTypes = {
		className: _propTypes2.default.string,
		path: _propTypes2.default.func.isRequired,
		onClick: _propTypes2.default.func,
		xAccessor: _propTypes2.default.func,
		xScale: _propTypes2.default.func,
		yScale: _propTypes2.default.func,
		datum: _propTypes2.default.object,
		stroke: _propTypes2.default.string,
		fill: _propTypes2.default.string,
		opacity: _propTypes2.default.number
	};
	
	SvgPathAnnotation.defaultProps = {
		className: "react-stockcharts-svgpathannotation",
		opacity: 1,
		x: function x(_ref2) {
			var xScale = _ref2.xScale,
			    xAccessor = _ref2.xAccessor,
			    datum = _ref2.datum;
			return xScale(xAccessor(datum));
		}
	};
	
	exports.default = SvgPathAnnotation;
	//# sourceMappingURL=SvgPathAnnotation.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Annotate = __webpack_require__(693);
	
	Object.defineProperty(exports, "Annotate", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_Annotate).default;
		}
	});
	
	var _LabelAnnotation = __webpack_require__(395);
	
	Object.defineProperty(exports, "LabelAnnotation", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_LabelAnnotation).default;
		}
	});
	
	var _SvgPathAnnotation = __webpack_require__(695);
	
	Object.defineProperty(exports, "SvgPathAnnotation", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_SvgPathAnnotation).default;
		}
	});
	
	var _Label = __webpack_require__(694);
	
	Object.defineProperty(exports, "Label", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_Label).default;
		}
	});
	exports.buyPath = buyPath;
	exports.sellPath = sellPath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = 10;
	var bottomWidth = 3;
	var height = 20;
	
	function buyPath(_ref) {
		var x = _ref.x,
		    y = _ref.y;
	
		return "M" + x + " " + y + " " + ("L" + (x + halfWidth) + " " + (y + halfWidth) + " ") + ("L" + (x + bottomWidth) + " " + (y + halfWidth) + " ") + ("L" + (x + bottomWidth) + " " + (y + height) + " ") + ("L" + (x - bottomWidth) + " " + (y + height) + " ") + ("L" + (x - bottomWidth) + " " + (y + halfWidth) + " ") + ("L" + (x - halfWidth) + " " + (y + halfWidth) + " ") + "Z";
	}
	
	function sellPath(_ref2) {
		var x = _ref2.x,
		    y = _ref2.y;
	
		return "M" + x + " " + y + " " + ("L" + (x + halfWidth) + " " + (y - halfWidth) + " ") + ("L" + (x + bottomWidth) + " " + (y - halfWidth) + " ") + ("L" + (x + bottomWidth) + " " + (y - height) + " ") + ("L" + (x - bottomWidth) + " " + (y - height) + " ") + ("L" + (x - bottomWidth) + " " + (y - halfWidth) + " ") + ("L" + (x - halfWidth) + " " + (y - halfWidth) + " ") + "Z";
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Selection = __webpack_require__(177);
	
	var _d3Array = __webpack_require__(21);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AxisZoomCapture = function (_Component) {
		_inherits(AxisZoomCapture, _Component);
	
		function AxisZoomCapture(props) {
			_classCallCheck(this, AxisZoomCapture);
	
			var _this = _possibleConstructorReturn(this, (AxisZoomCapture.__proto__ || Object.getPrototypeOf(AxisZoomCapture)).call(this, props));
	
			_this.handleDragStartMouse = _this.handleDragStartMouse.bind(_this);
			_this.handleDragStartTouch = _this.handleDragStartTouch.bind(_this);
			_this.handleDrag = _this.handleDrag.bind(_this);
			_this.handleDragEnd = _this.handleDragEnd.bind(_this);
			_this.handleRightClick = _this.handleRightClick.bind(_this);
			_this.saveNode = _this.saveNode.bind(_this);
			_this.state = {
				startPosition: null
			};
			return _this;
		}
	
		_createClass(AxisZoomCapture, [{
			key: "saveNode",
			value: function saveNode(node) {
				this.node = node;
			}
		}, {
			key: "handleRightClick",
			value: function handleRightClick(e) {
				e.stopPropagation();
				e.preventDefault();
	
				var onContextMenu = this.props.onContextMenu;
	
	
				var mouseXY = (0, _utils.mousePosition)(e, this.node.getBoundingClientRect());
	
				(0, _d3Selection.select)((0, _utils.d3Window)(this.node)).on(_utils.MOUSEMOVE, null).on(_utils.MOUSEUP, null);
				this.setState({
					startPosition: null
				});
	
				onContextMenu(mouseXY, e);
	
				this.contextMenuClicked = true;
			}
		}, {
			key: "handleDragStartMouse",
			value: function handleDragStartMouse(e) {
				this.mouseInteraction = true;
	
				var _props = this.props,
				    getScale = _props.getScale,
				    getMoreProps = _props.getMoreProps;
	
				var startScale = getScale(getMoreProps());
				this.dragHappened = false;
	
				if (startScale.invert) {
					(0, _d3Selection.select)((0, _utils.d3Window)(this.node)).on(_utils.MOUSEMOVE, this.handleDrag, false).on(_utils.MOUSEUP, this.handleDragEnd, false);
	
					var startXY = (0, _utils.mousePosition)(e);
	
					this.setState({
						startPosition: {
							startXY: startXY,
							startScale: startScale
						}
					});
				}
				e.preventDefault();
			}
		}, {
			key: "handleDragStartTouch",
			value: function handleDragStartTouch(e) {
				this.mouseInteraction = false;
	
				var _props2 = this.props,
				    getScale = _props2.getScale,
				    getMoreProps = _props2.getMoreProps;
	
				var startScale = getScale(getMoreProps());
				this.dragHappened = false;
	
				if (e.touches.length === 1 && startScale.invert) {
					(0, _d3Selection.select)((0, _utils.d3Window)(this.node)).on(_utils.TOUCHMOVE, this.handleDrag).on(_utils.TOUCHEND, this.handleDragEnd);
	
					var startXY = (0, _utils.touchPosition)((0, _utils.getTouchProps)(e.touches[0]), e);
	
					this.setState({
						startPosition: {
							startXY: startXY,
							startScale: startScale
						}
					});
				}
			}
		}, {
			key: "handleDrag",
			value: function handleDrag() {
				var startPosition = this.state.startPosition;
				var _props3 = this.props,
				    getMouseDelta = _props3.getMouseDelta,
				    inverted = _props3.inverted;
	
	
				this.dragHappened = true;
				if ((0, _utils.isDefined)(startPosition)) {
					var startScale = startPosition.startScale;
					var startXY = startPosition.startXY;
	
	
					var mouseXY = this.mouseInteraction ? (0, _d3Selection.mouse)(this.node) : (0, _d3Selection.touches)(this.node)[0];
	
					var diff = getMouseDelta(startXY, mouseXY);
	
					var center = (0, _d3Array.mean)(startScale.range());
	
					var tempRange = startScale.range().map(function (d) {
						return inverted ? d - (0, _utils.sign)(d - center) * diff : d + (0, _utils.sign)(d - center) * diff;
					});
	
					var newDomain = tempRange.map(startScale.invert);
	
					if ((0, _utils.sign)((0, _utils.last)(startScale.range()) - (0, _utils.first)(startScale.range())) === (0, _utils.sign)((0, _utils.last)(tempRange) - (0, _utils.first)(tempRange))) {
						var axisZoomCallback = this.props.axisZoomCallback;
						// console.log(startXScale.domain(), newXDomain)
	
						axisZoomCallback(newDomain);
					}
				}
			}
		}, {
			key: "handleDragEnd",
			value: function handleDragEnd() {
				var _this2 = this;
	
				if (!this.dragHappened) {
					if (this.clicked) {
						var e = _d3Selection.event;
						var mouseXY = this.mouseInteraction ? (0, _d3Selection.mouse)(this.node) : (0, _d3Selection.touches)(this.node)[0];
						var onDoubleClick = this.props.onDoubleClick;
	
	
						onDoubleClick(mouseXY, e);
					} else {
						this.clicked = true;
						setTimeout(function () {
							_this2.clicked = false;
						}, 300);
					}
				}
	
				(0, _d3Selection.select)((0, _utils.d3Window)(this.node)).on(_utils.MOUSEMOVE, null).on(_utils.MOUSEUP, null).on(_utils.TOUCHMOVE, null).on(_utils.TOUCHEND, null);
	
				this.setState({
					startPosition: null
				});
			}
		}, {
			key: "render",
			value: function render() {
				var _props4 = this.props,
				    bg = _props4.bg,
				    className = _props4.className,
				    zoomCursorClassName = _props4.zoomCursorClassName;
	
	
				var cursor = (0, _utils.isDefined)(this.state.startPosition) ? zoomCursorClassName : "react-stockcharts-default-cursor";
	
				return _react2.default.createElement("rect", {
					className: "react-stockcharts-enable-interaction " + cursor + " " + className,
					ref: this.saveNode,
					x: bg.x, y: bg.y, opacity: 0, height: bg.h, width: bg.w,
					onContextMenu: this.handleRightClick,
					onMouseDown: this.handleDragStartMouse,
					onTouchStart: this.handleDragStartTouch
				});
			}
		}]);
	
		return AxisZoomCapture;
	}(_react.Component);
	
	AxisZoomCapture.propTypes = {
		innerTickSize: _propTypes2.default.number,
		outerTickSize: _propTypes2.default.number,
		tickFormat: _propTypes2.default.func,
		tickPadding: _propTypes2.default.number,
		tickSize: _propTypes2.default.number,
		ticks: _propTypes2.default.number,
		tickValues: _propTypes2.default.array,
		showDomain: _propTypes2.default.bool,
		showTicks: _propTypes2.default.bool,
		className: _propTypes2.default.string,
		axisZoomCallback: _propTypes2.default.func,
		inverted: _propTypes2.default.bool,
		bg: _propTypes2.default.object.isRequired,
		zoomCursorClassName: _propTypes2.default.string.isRequired,
		getMoreProps: _propTypes2.default.func.isRequired,
		getScale: _propTypes2.default.func.isRequired,
		getMouseDelta: _propTypes2.default.func.isRequired,
		onDoubleClick: _propTypes2.default.func.isRequired,
		onContextMenu: _propTypes2.default.func.isRequired
	};
	
	AxisZoomCapture.defaultProps = {
		onDoubleClick: _utils.noop,
		onContextMenu: _utils.noop,
		inverted: true
	};
	
	exports.default = AxisZoomCapture;
	//# sourceMappingURL=AxisZoomCapture.js.map

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Axis = __webpack_require__(396);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XAxis = function (_Component) {
		_inherits(XAxis, _Component);
	
		function XAxis(props, context) {
			_classCallCheck(this, XAxis);
	
			var _this = _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).call(this, props, context));
	
			_this.axisZoomCallback = _this.axisZoomCallback.bind(_this);
			return _this;
		}
	
		_createClass(XAxis, [{
			key: "axisZoomCallback",
			value: function axisZoomCallback(newXDomain) {
				var xAxisZoom = this.context.xAxisZoom;
	
				xAxisZoom(newXDomain);
			}
		}, {
			key: "render",
			value: function render() {
				var showTicks = this.props.showTicks;
	
				var moreProps = helper(this.props, this.context);
	
				return _react2.default.createElement(_Axis2.default, _extends({}, this.props, moreProps, { x: true,
					zoomEnabled: this.props.zoomEnabled && showTicks,
					axisZoomCallback: this.axisZoomCallback,
					zoomCursorClassName: "react-stockcharts-ew-resize-cursor" }));
			}
		}]);
	
		return XAxis;
	}(_react.Component);
	
	XAxis.propTypes = {
		axisAt: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(["top", "bottom", "middle"]), _propTypes2.default.number]).isRequired,
		orient: _propTypes2.default.oneOf(["top", "bottom"]).isRequired,
		innerTickSize: _propTypes2.default.number,
		outerTickSize: _propTypes2.default.number,
		tickFormat: _propTypes2.default.func,
		tickPadding: _propTypes2.default.number,
		tickSize: _propTypes2.default.number,
		ticks: _propTypes2.default.number,
		tickValues: _propTypes2.default.array,
		showTicks: _propTypes2.default.bool,
		className: _propTypes2.default.string,
		zoomEnabled: _propTypes2.default.bool,
		onContextMenu: _propTypes2.default.func,
		onDoubleClick: _propTypes2.default.func
	};
	
	XAxis.defaultProps = {
		showTicks: true,
		showTickLabel: true,
		showDomain: true,
		className: "react-stockcharts-x-axis",
		ticks: 10,
		outerTickSize: 0,
		fill: "none",
		stroke: "#000000", // x axis stroke color
		strokeWidth: 1,
		opacity: 1, // x axis opacity
		domainClassName: "react-stockcharts-axis-domain",
		innerTickSize: 5,
		tickPadding: 6,
		tickStroke: "#000000", // tick/grid stroke
		tickStrokeOpacity: 1,
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 12,
		fontWeight: 400,
		xZoomHeight: 25,
		zoomEnabled: true,
		getMouseDelta: function getMouseDelta(startXY, mouseXY) {
			return startXY[0] - mouseXY[0];
		}
	};
	
	XAxis.contextTypes = {
		chartConfig: _propTypes2.default.object.isRequired,
		xAxisZoom: _propTypes2.default.func.isRequired
	};
	
	function helper(props, context) {
		var axisAt = props.axisAt,
		    xZoomHeight = props.xZoomHeight,
		    orient = props.orient;
		var _context$chartConfig = context.chartConfig,
		    width = _context$chartConfig.width,
		    height = _context$chartConfig.height;
	
	
		var axisLocation = void 0;
		var x = 0,
		    w = width,
		    h = xZoomHeight;
	
		if (axisAt === "top") axisLocation = 0;else if (axisAt === "bottom") axisLocation = height;else if (axisAt === "middle") axisLocation = height / 2;else axisLocation = axisAt;
	
		var y = orient === "top" ? -xZoomHeight : 0;
	
		return {
			transform: [0, axisLocation],
			range: [0, width],
			getScale: getXScale,
			bg: { x: x, y: y, h: h, w: w }
		};
	}
	
	function getXScale(moreProps) {
		var scale = moreProps.xScale,
		    width = moreProps.width;
	
	
		if (scale.invert) {
			var trueRange = [0, width];
			var trueDomain = trueRange.map(scale.invert);
			return scale.copy().domain(trueDomain).range(trueRange);
		}
	
		return scale;
	}
	
	exports.default = XAxis;
	//# sourceMappingURL=XAxis.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Axis = __webpack_require__(396);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YAxis = function (_Component) {
		_inherits(YAxis, _Component);
	
		function YAxis(props, context) {
			_classCallCheck(this, YAxis);
	
			var _this = _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).call(this, props, context));
	
			_this.axisZoomCallback = _this.axisZoomCallback.bind(_this);
			return _this;
		}
	
		_createClass(YAxis, [{
			key: "axisZoomCallback",
			value: function axisZoomCallback(newYDomain) {
				var _context = this.context,
				    chartId = _context.chartId,
				    yAxisZoom = _context.yAxisZoom;
	
				yAxisZoom(chartId, newYDomain);
			}
		}, {
			key: "render",
			value: function render() {
				var _helper = helper(this.props, this.context),
				    zoomEnabled = _helper.zoomEnabled,
				    moreProps = _objectWithoutProperties(_helper, ["zoomEnabled"]);
	
				return _react2.default.createElement(_Axis2.default, _extends({}, this.props, moreProps, {
					zoomEnabled: this.props.zoomEnabled && zoomEnabled,
					edgeClip: true,
					axisZoomCallback: this.axisZoomCallback,
					zoomCursorClassName: "react-stockcharts-ns-resize-cursor" }));
			}
		}]);
	
		return YAxis;
	}(_react.Component);
	
	YAxis.propTypes = {
		axisAt: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(["left", "right", "middle"]), _propTypes2.default.number]).isRequired,
		orient: _propTypes2.default.oneOf(["left", "right"]).isRequired,
		innerTickSize: _propTypes2.default.number,
		outerTickSize: _propTypes2.default.number,
		tickFormat: _propTypes2.default.func,
		tickPadding: _propTypes2.default.number,
		tickSize: _propTypes2.default.number,
		ticks: _propTypes2.default.number,
		yZoomWidth: _propTypes2.default.number,
		tickValues: _propTypes2.default.array,
		showTicks: _propTypes2.default.bool,
		className: _propTypes2.default.string,
		zoomEnabled: _propTypes2.default.bool,
		onContextMenu: _propTypes2.default.func,
		onDoubleClick: _propTypes2.default.func
	};
	
	YAxis.defaultProps = {
		showTicks: true,
		showTickLabel: true,
		showDomain: true,
		className: "react-stockcharts-y-axis",
		ticks: 10,
		outerTickSize: 0,
		domainClassName: "react-stockcharts-axis-domain",
		fill: "none",
		stroke: "#FFFFFF",
		strokeWidth: 1,
		opacity: 1,
		innerTickSize: 5,
		tickPadding: 6,
		tickStroke: "#000000",
		tickStrokeOpacity: 1,
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 12,
		fontWeight: 400,
		yZoomWidth: 40,
		zoomEnabled: true,
		getMouseDelta: function getMouseDelta(startXY, mouseXY) {
			return startXY[1] - mouseXY[1];
		}
	};
	
	YAxis.contextTypes = {
		yAxisZoom: _propTypes2.default.func.isRequired,
		chartId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
		chartConfig: _propTypes2.default.object.isRequired
	};
	
	function helper(props, context) {
		var axisAt = props.axisAt,
		    yZoomWidth = props.yZoomWidth,
		    orient = props.orient;
		var _context$chartConfig = context.chartConfig,
		    width = _context$chartConfig.width,
		    height = _context$chartConfig.height;
	
	
		var axisLocation = void 0;
		var y = 0,
		    w = yZoomWidth,
		    h = height;
	
		if (axisAt === "left") {
			axisLocation = 0;
		} else if (axisAt === "right") {
			axisLocation = width;
		} else if (axisAt === "middle") {
			axisLocation = width / 2;
		} else {
			axisLocation = axisAt;
		}
	
		var x = orient === "left" ? -yZoomWidth : 0;
	
		return {
			transform: [axisLocation, 0],
			range: [0, height],
			getScale: getYScale,
			bg: { x: x, y: y, h: h, w: w },
			zoomEnabled: context.chartConfig.yPan
		};
	}
	
	function getYScale(moreProps) {
		var _moreProps$chartConfi = moreProps.chartConfig,
		    scale = _moreProps$chartConfi.yScale,
		    flipYScale = _moreProps$chartConfi.flipYScale,
		    height = _moreProps$chartConfi.height;
	
		if (scale.invert) {
			var trueRange = flipYScale ? [0, height] : [height, 0];
			var trueDomain = trueRange.map(scale.invert);
			return scale.copy().domain(trueDomain).range(trueRange);
		}
		return scale;
	}
	
	exports.default = YAxis;
	//# sourceMappingURL=YAxis.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _XAxis = __webpack_require__(698);
	
	Object.defineProperty(exports, "XAxis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_XAxis).default;
	  }
	});
	
	var _YAxis = __webpack_require__(699);
	
	Object.defineProperty(exports, "YAxis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YAxis).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*
	https://github.com/ScottLogic/d3fc/blob/master/src/indicator/algorithm/calculator/bollingerBands.js
	
	The MIT License (MIT)
	
	Copyright (c) 2014-2015 Scott Logic Ltd.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	exports.default = function () {
		var options = _defaultOptionsForComputation.BollingerBand;
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize,
			    multiplier = _options.multiplier,
			    movingAverageType = _options.movingAverageType,
			    sourcePath = _options.sourcePath;
	
	
			var source = (0, _utils.path)(sourcePath);
			var meanAlgorithm = movingAverageType === "ema" ? (0, _ema2.default)().options({ windowSize: windowSize, sourcePath: sourcePath }) : (0, _utils.slidingWindow)().windowSize(windowSize).accumulator(function (values) {
				return (0, _d3Array.mean)(values);
			}).sourcePath(sourcePath);
	
			var bollingerBandAlgorithm = (0, _utils.slidingWindow)().windowSize(windowSize).accumulator(function (values) {
				var avg = (0, _utils.last)(values).mean;
				var stdDev = (0, _d3Array.deviation)(values, function (each) {
					return source(each.datum);
				});
				return {
					top: avg + multiplier * stdDev,
					middle: avg,
					bottom: avg - multiplier * stdDev
				};
			});
	
			var zip = (0, _utils.zipper)().combine(function (datum, mean) {
				return { datum: datum, mean: mean };
			});
	
			var tuples = zip(data, meanAlgorithm(data));
			return bollingerBandAlgorithm(tuples);
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize;
	
			return windowSize - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.BollingerBand, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _d3Array = __webpack_require__(21);
	
	var _ema = __webpack_require__(94);
	
	var _ema2 = _interopRequireDefault(_ema);
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=bollingerband.js.map

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = function () {
		var options = _defaultOptionsForComputation.Change;
	
		function calculator(data) {
			var _options = options,
			    sourcePath = _options.sourcePath;
	
	
			var algo = (0, _utils.slidingWindow)().windowSize(2).sourcePath(sourcePath).accumulator(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    prev = _ref2[0],
				    curr = _ref2[1];
	
				var absoluteChange = curr - prev;
				var percentChange = absoluteChange * 100 / prev;
				return { absoluteChange: absoluteChange, percentChange: percentChange };
			});
	
			var newData = algo(data);
	
			return newData;
		}
		calculator.undefinedLength = function () {
			return 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.Change, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=change.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function () {
		var options = _defaultOptionsForComputation.Change;
	
		function calculator(data) {
			var _options = options,
			    basePath = _options.basePath,
			    mainKeys = _options.mainKeys,
			    compareKeys = _options.compareKeys;
	
			var base = (0, _utils.path)(basePath);
	
			var first = (0, _utils.head)(data);
			var b = base(first);
	
			// eslint-disable-next-line prefer-const
			var firsts = {};
	
			var compareData = data.map(function (d) {
				// eslint-disable-next-line prefer-const
				var result = {};
	
				mainKeys.forEach(function (key) {
					if (_typeof(d[key]) === "object") {
						result[key] = {};
						Object.keys(d[key]).forEach(function (subkey) {
							result[key][subkey] = (d[key][subkey] - b) / b;
						});
					} else {
						result[key] = (d[key] - b) / b;
					}
				});
	
				compareKeys.forEach(function (key) {
					if ((0, _utils.isDefined)(d[key]) && (0, _utils.isNotDefined)(firsts[key])) {
						firsts[key] = d[key];
					}
					if ((0, _utils.isDefined)(d[key]) && (0, _utils.isDefined)(firsts[key])) {
						result[key] = (d[key] - firsts[key]) / firsts[key];
					}
				});
				return result;
			});
			// console.log(compareData[20]);
			return compareData;
		}
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.Change, x);
			return calculator;
		};
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=compare.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*
	https://github.com/ScottLogic/d3fc/blob/master/src/indicator/algorithm/calculator/elderRay.js
	
	The MIT License (MIT)
	
	Copyright (c) 2014-2015 Scott Logic Ltd.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.ElderRay;
		var ohlc = function ohlc(d) {
			return { open: d.open, high: d.high, low: d.low, close: d.close };
		};
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize,
			    sourcePath = _options.sourcePath,
			    movingAverageType = _options.movingAverageType;
	
	
			var meanAlgorithm = movingAverageType === "ema" ? (0, _ema2.default)().options({ windowSize: windowSize, sourcePath: sourcePath }) : (0, _utils.slidingWindow)().windowSize(windowSize).accumulator(function (values) {
				return (0, _d3Array.mean)(values);
			}).sourcePath(sourcePath);
	
			var zip = (0, _utils.zipper)().combine(function (datum, mean) {
				var bullPower = (0, _utils.isDefined)(mean) ? ohlc(datum).high - mean : undefined;
				var bearPower = (0, _utils.isDefined)(mean) ? ohlc(datum).low - mean : undefined;
				return { bullPower: bullPower, bearPower: bearPower };
			});
	
			var newData = zip(data, meanAlgorithm(data));
			return newData;
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize;
	
			return windowSize - 1;
		};
		calculator.ohlc = function (x) {
			if (!arguments.length) {
				return ohlc;
			}
			ohlc = x;
			return calculator;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.ElderRay, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _d3Array = __webpack_require__(21);
	
	var _ema = __webpack_require__(94);
	
	var _ema2 = _interopRequireDefault(_ema);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=elderRay.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = function () {
	
		var source = _utils.identity;
	
		function calculator(data) {
			var algorithm = (0, _utils.mappedSlidingWindow)().windowSize(2).undefinedValue(function (_ref) {
				var open = _ref.open,
				    high = _ref.high,
				    low = _ref.low,
				    close = _ref.close;
	
				close = (open + high + low + close) / 4;
				return { open: open, high: high, low: low, close: close };
			}).accumulator(function (_ref2) {
				var _ref3 = _slicedToArray(_ref2, 2),
				    prev = _ref3[0],
				    now = _ref3[1];
	
				// console.log(prev, now);
				var date = now.date,
				    volume = now.volume;
	
				var close = (now.open + now.high + now.low + now.close) / 4;
				var open = (prev.open + prev.close) / 2;
				var high = Math.max(open, now.high, close);
				var low = Math.min(open, now.low, close);
				return { date: date, open: open, high: high, low: low, close: close, volume: volume };
			});
	
			return algorithm(data);
		}
		calculator.source = function (x) {
			if (!arguments.length) {
				return source;
			}
			source = x;
			return calculator;
		};
	
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	//# sourceMappingURL=heikinAshi.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.Kagi;
		var dateAccessor = function dateAccessor(d) {
			return d.date;
		};
		var dateMutator = function dateMutator(d, date) {
			d.date = date;
		};
	
		function calculator(data) {
			var _options = options,
			    reversalType = _options.reversalType,
			    windowSize = _options.windowSize,
			    reversal = _options.reversal,
			    sourcePath = _options.sourcePath;
	
	
			var source = (0, _utils.path)(sourcePath);
			var reversalThreshold = void 0;
	
			if (reversalType === "ATR") {
				// calculateATR(rawData, period);
				var atrAlgorithm = (0, _atr2.default)().options({ windowSize: windowSize });
	
				var atrCalculator = (0, _utils.merge)().algorithm(atrAlgorithm).merge(function (d, c) {
					d["atr" + windowSize] = c;
				});
	
				atrCalculator(data);
				reversalThreshold = function reversalThreshold(d) {
					return d["atr" + windowSize];
				};
			} else {
				reversalThreshold = (0, _utils.functor)(reversal);
			}
	
			var kagiData = [];
	
			var prevPeak = void 0,
			    prevTrough = void 0,
			    direction = void 0;
			var line = {};
	
			data.forEach(function (d) {
				if ((0, _utils.isNotDefined)(line.from)) {
					dateMutator(line, dateAccessor(d));
					line.from = dateAccessor(d);
	
					if (!line.open) line.open = d.open;
					line.high = d.high;
					line.low = d.low;
					if (!line.close) line.close = source(d);
					line.startOfYear = d.startOfYear;
					line.startOfQuarter = d.startOfQuarter;
					line.startOfMonth = d.startOfMonth;
					line.startOfWeek = d.startOfWeek;
				}
	
				if (!line.startOfYear) {
					line.startOfYear = d.startOfYear;
					if (line.startOfYear) {
						line.date = d.date;
						// line.displayDate = d.displayDate;
					}
				}
	
				if (!line.startOfQuarter) {
					line.startOfQuarter = d.startOfQuarter;
					if (line.startOfQuarter && !line.startOfYear) {
						line.date = d.date;
						// line.displayDate = d.displayDate;
					}
				}
	
				if (!line.startOfMonth) {
					line.startOfMonth = d.startOfMonth;
					if (line.startOfMonth && !line.startOfQuarter) {
						line.date = d.date;
						// line.displayDate = d.displayDate;
					}
				}
				if (!line.startOfWeek) {
					line.startOfWeek = d.startOfWeek;
					if (line.startOfWeek && !line.startOfMonth) {
						line.date = d.date;
						// line.displayDate = d.displayDate;
					}
				}
				line.volume = (line.volume || 0) + d.volume;
				line.high = Math.max(line.high, d.high);
				line.low = Math.min(line.low, d.low);
				line.to = dateAccessor(d);
	
				var priceMovement = source(d) - line.close;
	
				// console.log(source(d), priceMovement)
				if (line.close >= line.open /* going up */ && priceMovement > 0 /* and moving in same direction */ || line.close < line.open /* going down */ && priceMovement < 0 /* and moving in same direction */) {
					line.close = source(d);
					if (prevTrough && line.close < prevTrough) {
						// going below the prevTrough, so change from yang to yin
						// A yin line forms when a Kagi line breaks below the prior trough.
						line.changePoint = prevTrough;
						if (line.startAs !== "yin") {
							line.changeTo = "yin";
							// line.startAs = "yang";
						}
					}
					if (prevPeak && line.close > prevPeak) {
						// going above the prevPeak, so change from yin to yang
						// A yang line forms when a Kagi line breaks above the prior peak
						line.changePoint = prevPeak;
						if (line.startAs !== "yang") {
							line.changeTo = "yang";
							// line.startAs = "yin";
						}
					}
				} else if (line.close >= line.open /* going up */
				&& priceMovement < 0 /* and moving in other direction */
				&& Math.abs(priceMovement) > reversalThreshold(d) /* and the movement is big enough for reversal */ || line.close < line.open /* going down */
				&& priceMovement > 0 /* and moving in other direction */
				&& Math.abs(priceMovement) > reversalThreshold(d) /* and the movement is big enough for reversal */) {
					// reverse direction
					var nextLineOpen = line.close;
	
					direction = (line.close - line.open) / Math.abs(line.close - line.open);
	
					var nextChangePoint = void 0,
					    nextChangeTo = void 0;
					if (direction < 0 /* if direction so far has been -ve*/) {
							// compare with line.close becomes prevTrough
							if ((0, _utils.isNotDefined)(prevPeak)) prevPeak = line.open;
							prevTrough = line.close;
							if (source(d) > prevPeak) {
								nextChangePoint = prevPeak;
								nextChangeTo = "yang";
							}
						} else {
						if ((0, _utils.isNotDefined)(prevTrough)) prevTrough = line.open;
						prevPeak = line.close;
						if (source(d) < prevTrough) {
							nextChangePoint = prevTrough;
							nextChangeTo = "yin";
						}
					}
					if ((0, _utils.isNotDefined)(line.startAs)) {
						line.startAs = direction > 0 ? "yang" : "yin";
					}
	
					var startAs = line.changeTo || line.startAs;
					line.added = true;
					kagiData.push(line);
					direction = -1 * direction; // direction is reversed
	
					line = _extends({}, line);
					line.open = nextLineOpen;
					line.close = source(d);
					line.startAs = startAs;
					line.changePoint = nextChangePoint;
					line.changeTo = nextChangeTo;
					line.added = false;
					line.from = undefined;
					line.volume = 0;
				} else {
					// console.log("MOVING IN REV DIR BUT..", line.open, line.close, source(d));
				}
				line.current = source(d);
				var dir = line.close - line.open;
				dir = dir === 0 ? 1 : dir / Math.abs(dir);
				line.reverseAt = dir > 0 ? line.close - reversalThreshold(d) : line.open - reversalThreshold(d);
			});
			if (!line.added) kagiData.push(line);
	
			return kagiData;
		}
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.Kagi, x);
			return calculator;
		};
		calculator.dateMutator = function (x) {
			if (!arguments.length) return dateMutator;
			dateMutator = x;
			return calculator;
		};
		calculator.dateAccessor = function (x) {
			if (!arguments.length) return dateAccessor;
			dateAccessor = x;
			return calculator;
		};
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _atr = __webpack_require__(163);
	
	var _atr2 = _interopRequireDefault(_atr);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=kagi.js.map

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*
	https://github.com/ScottLogic/d3fc/blob/master/src/indicator/algorithm/calculator/macd.js
	
	The MIT License (MIT)
	
	Copyright (c) 2014-2015 Scott Logic Ltd.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	exports.default = function () {
		var options = _defaultOptionsForComputation.MACD;
	
		function calculator(data) {
			var _options = options,
			    fast = _options.fast,
			    slow = _options.slow,
			    signal = _options.signal,
			    sourcePath = _options.sourcePath;
	
	
			var fastEMA = (0, _ema2.default)().options({ windowSize: fast, sourcePath: sourcePath });
	
			var slowEMA = (0, _ema2.default)().options({ windowSize: slow, sourcePath: sourcePath });
	
			var signalEMA = (0, _ema2.default)().options({ windowSize: signal, sourcePath: undefined });
	
			var macdCalculator = (0, _utils.zipper)().combine(function (fastEMA, slowEMA) {
				return (0, _utils.isDefined)(fastEMA) && (0, _utils.isDefined)(slowEMA) ? fastEMA - slowEMA : undefined;
			});
	
			var macdArray = macdCalculator(fastEMA(data), slowEMA(data));
	
			var undefinedArray = new Array(slow);
			var signalArray = undefinedArray.concat(signalEMA(macdArray.slice(slow)));
	
			var zip = (0, _utils.zipper)().combine(function (macd, signal) {
				return {
					macd: macd,
					signal: signal,
					divergence: (0, _utils.isDefined)(macd) && (0, _utils.isDefined)(signal) ? macd - signal : undefined
				};
			});
	
			var macd = zip(macdArray, signalArray);
	
			return macd;
		}
	
		calculator.undefinedLength = function () {
			var _options2 = options,
			    slow = _options2.slow,
			    signal = _options2.signal;
	
			return slow + signal - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.MACD, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _ema = __webpack_require__(94);
	
	var _ema2 = _interopRequireDefault(_ema);
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=macd.js.map

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
		var options = _defaultOptionsForComputation.PointAndFigure;
		var dateAccessor = function dateAccessor(d) {
			return d.date;
		};
		var dateMutator = function dateMutator(d, date) {
			d.date = date;
		};
	
		function calculator(rawData) {
			var _options = options,
			    reversal = _options.reversal,
			    boxSize = _options.boxSize,
			    sourcePath = _options.sourcePath;
	
	
			var source = sourcePath === "high/low" ? function (d) {
				return { high: d.high, low: d.low };
			} : function (d) {
				return { high: d.close, low: d.close };
			};
	
			var pricingMethod = source;
			var columnData = [];
	
			var column = {
				boxes: [],
				open: rawData[0].open
			},
			    box = createBox(rawData[0], dateAccessor, dateMutator);
	
			columnData.push(column);
	
			rawData.forEach(function (d) {
				column.volume = (column.volume || 0) + d.volume;
	
				if (!box.startOfYear) {
					box.startOfYear = d.startOfYear;
					if (box.startOfYear) {
						dateMutator(box, dateAccessor(d));
						// box.displayDate = d.displayDate;
					}
				}
	
				if (!box.startOfYear && !box.startOfQuarter) {
					box.startOfQuarter = d.startOfQuarter;
					if (box.startOfQuarter && !box.startOfYear) {
						dateMutator(box, dateAccessor(d));
						// box.displayDate = d.displayDate;
					}
				}
	
				if (!box.startOfQuarter && !box.startOfMonth) {
					box.startOfMonth = d.startOfMonth;
					if (box.startOfMonth && !box.startOfQuarter) {
						dateMutator(box, dateAccessor(d));
						// box.displayDate = d.displayDate;
					}
				}
				if (!box.startOfMonth && !box.startOfWeek) {
					box.startOfWeek = d.startOfWeek;
					if (box.startOfWeek && !box.startOfMonth) {
						dateMutator(box, dateAccessor(d));
						// box.displayDate = d.displayDate;
					}
				}
	
				if (columnData.length === 1 && column.boxes.length === 0) {
					var upwardMovement = Math.max(pricingMethod(d).high - column.open, 0); // upward movement
					var downwardMovement = Math.abs(Math.min(column.open - pricingMethod(d).low, 0)); // downward movement
					column.direction = upwardMovement > downwardMovement ? 1 : -1;
					if (boxSize * reversal < upwardMovement || boxSize * reversal < downwardMovement) {
						// enough movement to trigger a reversal
						box.toDate = dateAccessor(d);
						box.open = column.open;
						var noOfBoxes = column.direction > 0 ? Math.floor(upwardMovement / boxSize) : Math.floor(downwardMovement / boxSize);
						for (var i = 0; i < noOfBoxes; i++) {
							box.close = box.open + column.direction * boxSize;
							var prevBoxClose = box.close;
							column.boxes.push(box);
							box = createBox(box, dateAccessor, dateMutator);
							// box = cloneMe(box);
							box.open = prevBoxClose;
						}
						box.fromDate = dateAccessor(d);
						box.date = dateAccessor(d);
					}
				} else {
					// one or more boxes already formed in the current column
					var _upwardMovement = Math.max(pricingMethod(d).high - box.open, 0); // upward movement
					var _downwardMovement = Math.abs(Math.min(pricingMethod(d).low - box.open, 0)); // downward movement
	
					if (column.direction > 0 && _upwardMovement > boxSize || /* rising column AND box can be formed */
					column.direction < 0 && _downwardMovement > boxSize /* falling column AND box can be formed */) {
							// form another box
							box.close = box.open + column.direction * boxSize;
							box.toDate = dateAccessor(d);
							var _prevBoxClose = box.close;
							column.boxes.push(box);
							box = createBox(d, dateAccessor, dateMutator);
							box.open = _prevBoxClose;
							box.fromDate = dateAccessor(d);
							dateMutator(box, dateAccessor(d));
						} else if (column.direction > 0 && _downwardMovement > boxSize * reversal || /* rising column and there is downward movement to trigger a reversal */
					column.direction < 0 && _upwardMovement > boxSize * reversal /* falling column and there is downward movement to trigger a reversal */) {
							// reversal
	
							box.open = box.open + -1 * column.direction * boxSize;
							box.toDate = dateAccessor(d);
							// box.displayDate = d.displayDate;
							dateMutator(box, dateAccessor(d));
							// box.startOfYear = d.startOfYear;
							// box.startOfQuarter = d.startOfQuarter;
							// box.startOfMonth = d.startOfMonth;
							// box.startOfWeek = d.startOfWeek;
							// console.table(column.boxes);
							// var idx = index + 1;
							column = {
								boxes: [],
								volume: 0,
								direction: -1 * column.direction
							};
							var _noOfBoxes = column.direction > 0 ? Math.floor(_upwardMovement / boxSize) : Math.floor(_downwardMovement / boxSize);
							for (var _i = 0; _i < _noOfBoxes; _i++) {
								box.close = box.open + column.direction * boxSize;
								var _prevBoxClose2 = box.close;
								column.boxes.push(box);
								box = createBox(d, dateAccessor, dateMutator);
								box.open = _prevBoxClose2;
							}
	
							columnData.push(column);
						}
				}
			});
			updateColumns(columnData, dateAccessor, dateMutator);
	
			return columnData;
		}
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.PointAndFigure, x);
			return calculator;
		};
		calculator.dateMutator = function (x) {
			if (!arguments.length) return dateMutator;
			dateMutator = x;
			return calculator;
		};
		calculator.dateAccessor = function (x) {
			if (!arguments.length) return dateAccessor;
			dateAccessor = x;
			return calculator;
		};
	
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	function createBox(d, dateAccessor, dateMutator) {
		var box = {
			open: d.open,
			fromDate: dateAccessor(d),
			toDate: dateAccessor(d),
			startOfYear: d.startOfYear,
			startOfQuarter: d.startOfQuarter,
			startOfMonth: d.startOfMonth,
			startOfWeek: d.startOfWeek
		};
		dateMutator(box, dateAccessor(d));
		return box;
	}
	
	function updateColumns(columnData, dateAccessor, dateMutator) {
		columnData.forEach(function (d) {
			// var lastBox = d.boxes[d.boxes.length - 1];
	
			d.startOfYear = false;
			d.startOfQuarter = false;
			d.startOfMonth = false;
			d.startOfWeek = false;
	
			d.boxes.forEach(function (eachBox) {
				if ((0, _utils.isNotDefined)(d.open)) d.open = eachBox.open;
				d.close = eachBox.close;
				d.high = Math.max(d.open, d.close);
				d.low = Math.min(d.open, d.close);
	
				if ((0, _utils.isNotDefined)(d.fromDate)) d.fromDate = eachBox.fromDate;
				if ((0, _utils.isNotDefined)(d.date)) d.date = eachBox.date;
				d.toDate = eachBox.toDate;
	
				if (eachBox.startOfYear) {
					d.startOfYear = d.startOfYear || eachBox.startOfYear;
					d.startOfQuarter = eachBox.startOfQuarter;
					d.startOfMonth = eachBox.startOfMonth;
					d.startOfWeek = eachBox.startOfWeek;
	
					dateMutator(d, dateAccessor(eachBox));
				}
				if (d.startOfQuarter !== true && eachBox.startOfQuarter) {
					d.startOfQuarter = eachBox.startOfQuarter;
					d.startOfMonth = eachBox.startOfMonth;
					d.startOfWeek = eachBox.startOfWeek;
					// d.displayDate = eachBox.displayDate;
					dateMutator(d, dateAccessor(eachBox));
				}
				if (d.startOfMonth !== true && eachBox.startOfMonth) {
					d.startOfMonth = eachBox.startOfMonth;
					d.startOfWeek = eachBox.startOfWeek;
					// d.displayDate = eachBox.displayDate;
					dateMutator(d, dateAccessor(eachBox));
				}
				if (d.startOfWeek !== true && eachBox.startOfWeek) {
					d.startOfWeek = eachBox.startOfWeek;
					// d.displayDate = eachBox.displayDate;
					dateMutator(d, dateAccessor(eachBox));
				}
			});
		});
	
		// console.table(columnData);
		// console.table(rawData);
		return columnData;
	}
	//# sourceMappingURL=pointAndFigure.js.map

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
		var options = _defaultOptionsForComputation.Renko;
	
		var dateAccessor = function dateAccessor(d) {
			return d.date;
		};
		var dateMutator = function dateMutator(d, date) {
			d.date = date;
		};
	
		function calculator(rawData) {
			var _options = options,
			    reversalType = _options.reversalType,
			    fixedBrickSize = _options.fixedBrickSize,
			    sourcePath = _options.sourcePath,
			    windowSize = _options.windowSize;
	
	
			var source = sourcePath === "high/low" ? function (d) {
				return { high: d.high, low: d.low };
			} : function (d) {
				return { high: d.close, low: d.close };
			};
	
			var pricingMethod = source;
			var brickSize = void 0;
	
			if (reversalType === "ATR") {
				// calculateATR(rawData, period);
				var atrAlgorithm = (0, _atr2.default)().options({ windowSize: windowSize });
	
				var atrCalculator = (0, _utils.merge)().algorithm(atrAlgorithm).merge(function (d, c) {
					d["atr" + windowSize] = c;
				});
	
				atrCalculator(rawData);
				brickSize = function brickSize(d) {
					return d["atr" + windowSize];
				};
			} else {
				brickSize = (0, _utils.functor)(fixedBrickSize);
			}
	
			var renkoData = [];
	
			var index = 0,
			    prevBrickClose = rawData[index].open,
			    prevBrickOpen = rawData[index].open;
			var brick = {},
			    direction = 0;
	
			rawData.forEach(function (d, idx) {
				if ((0, _utils.isNotDefined)(brick.from)) {
					brick.high = d.high;
					brick.low = d.low;
					brick.startOfYear = d.startOfYear;
					brick.startOfQuarter = d.startOfQuarter;
					brick.startOfMonth = d.startOfMonth;
					brick.startOfWeek = d.startOfWeek;
	
					brick.from = idx;
					brick.fromDate = dateAccessor(d);
					// indexMutator(brick, index++);
					dateMutator(brick, dateAccessor(d));
				}
				brick.volume = (brick.volume || 0) + d.volume;
	
				var prevCloseToHigh = prevBrickClose - pricingMethod(d).high,
				    prevCloseToLow = prevBrickClose - pricingMethod(d).low,
				    prevOpenToHigh = prevBrickOpen - pricingMethod(d).high,
				    prevOpenToLow = prevBrickOpen - pricingMethod(d).low,
				    priceMovement = Math.min(Math.abs(prevCloseToHigh), Math.abs(prevCloseToLow), Math.abs(prevOpenToHigh), Math.abs(prevOpenToLow));
	
				brick.high = Math.max(brick.high, d.high);
				brick.low = Math.min(brick.low, d.low);
	
				if (!brick.startOfYear) {
					brick.startOfYear = d.startOfYear;
					if (brick.startOfYear) {
						dateMutator(brick, dateAccessor(d));
						// brick.displayDate = d.displayDate;
					}
				}
	
				if (!brick.startOfQuarter) {
					brick.startOfQuarter = d.startOfQuarter;
					if (brick.startOfQuarter && !brick.startOfYear) {
						dateMutator(brick, dateAccessor(d));
						// brick.displayDate = d.displayDate;
					}
				}
	
				if (!brick.startOfMonth) {
					brick.startOfMonth = d.startOfMonth;
					if (brick.startOfMonth && !brick.startOfQuarter) {
						dateMutator(brick, dateAccessor(d));
						// brick.displayDate = d.displayDate;
					}
				}
				if (!brick.startOfWeek) {
					brick.startOfWeek = d.startOfWeek;
					if (brick.startOfWeek && !brick.startOfMonth) {
						dateMutator(brick, dateAccessor(d));
						// brick.displayDate = d.displayDate;
					}
				}
	
				// d.brick = JSON.stringify(brick);
				if (brickSize(d)) {
					var noOfBricks = Math.floor(priceMovement / brickSize(d));
	
					brick.open = Math.abs(prevCloseToHigh) < Math.abs(prevOpenToHigh) || Math.abs(prevCloseToLow) < Math.abs(prevOpenToLow) ? prevBrickClose : prevBrickOpen;
	
					if (noOfBricks >= 1) {
						var j = 0;
						for (j = 0; j < noOfBricks; j++) {
							brick.close = brick.open < pricingMethod(d).high ?
							// if brick open is less than current price it means it is green/hollow brick
							brick.open + brickSize(d) : brick.open - brickSize(d);
							direction = brick.close > brick.open ? 1 : -1;
							brick.direction = direction;
							brick.to = idx;
							brick.toDate = dateAccessor(d);
							// brick.diff = brick.open - brick.close;
							// brick.atr = d.atr;
							brick.fullyFormed = true;
							renkoData.push(brick);
	
							prevBrickClose = brick.close;
							prevBrickOpen = brick.open;
	
							var newBrick = {
								high: brick.high,
								low: brick.low,
								open: brick.close,
								startOfYear: false,
								startOfMonth: false,
								startOfQuarter: false,
								startOfWeek: false
							};
							brick = newBrick;
							brick.from = idx;
							brick.fromDate = dateAccessor(d);
							// indexMutator(brick, index + j);
							dateMutator(brick, dateAccessor(d));
							brick.volume = (brick.volume || 0) + d.volume;
						}
						index = index + j - 1;
						brick = {};
					} else {
						if (idx === rawData.length - 1) {
							brick.close = direction > 0 ? pricingMethod(d).high : pricingMethod(d).low;
							brick.to = idx;
							brick.toDate = dateAccessor(d);
							dateMutator(brick, dateAccessor(d));
							brick.fullyFormed = false;
							renkoData.push(brick);
						}
					}
				}
			});
			return renkoData;
		}
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.Renko, x);
			return calculator;
		};
	
		calculator.dateMutator = function (x) {
			if (!arguments.length) return dateMutator;
			dateMutator = x;
			return calculator;
		};
		calculator.dateAccessor = function (x) {
			if (!arguments.length) return dateAccessor;
			dateAccessor = x;
			return calculator;
		};
	
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _atr = __webpack_require__(163);
	
	var _atr2 = _interopRequireDefault(_atr);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=renko.js.map

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*
	https://github.com/ScottLogic/d3fc/blob/master/src/indicator/algorithm/calculator/relativeStrengthIndex.js
	
	The MIT License (MIT)
	
	Copyright (c) 2014-2015 Scott Logic Ltd.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.RSI;
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize,
			    sourcePath = _options.sourcePath;
	
	
			var source = (0, _utils.path)(sourcePath);
			var prevAvgGain = void 0,
			    prevAvgLoss = void 0;
			var rsiAlgorithm = (0, _utils.slidingWindow)().windowSize(windowSize).accumulator(function (values) {
	
				var avgGain = (0, _utils.isDefined)(prevAvgGain) ? (prevAvgGain * (windowSize - 1) + (0, _utils.last)(values).gain) / windowSize : (0, _d3Array.mean)(values, function (each) {
					return each.gain;
				});
	
				var avgLoss = (0, _utils.isDefined)(prevAvgLoss) ? (prevAvgLoss * (windowSize - 1) + (0, _utils.last)(values).loss) / windowSize : (0, _d3Array.mean)(values, function (each) {
					return each.loss;
				});
	
				var relativeStrength = avgGain / avgLoss;
				var rsi = 100 - 100 / (1 + relativeStrength);
	
				prevAvgGain = avgGain;
				prevAvgLoss = avgLoss;
	
				return rsi;
			});
	
			var gainsAndLossesCalculator = (0, _utils.slidingWindow)().windowSize(2).undefinedValue(function () {
				return [0, 0];
			}).accumulator(function (tuple) {
				var prev = tuple[0];
				var now = tuple[1];
				var change = source(now) - source(prev);
				return {
					gain: Math.max(change, 0),
					loss: Math.abs(Math.min(change, 0))
				};
			});
	
			var gainsAndLosses = gainsAndLossesCalculator(data);
	
			var rsiData = rsiAlgorithm(gainsAndLosses);
	
			return rsiData;
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize;
	
	
			return windowSize - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.RSI, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _d3Array = __webpack_require__(21);
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=rsi.js.map

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.SAR;
	
		function calculator(data) {
			var _options = options,
			    accelerationFactor = _options.accelerationFactor,
			    maxAccelerationFactor = _options.maxAccelerationFactor;
	
	
			var algorithm = (0, _utils.mappedSlidingWindow)().windowSize(2).undefinedValue(function (_ref) {
				var high = _ref.high,
				    low = _ref.low;
	
				return {
					risingSar: low,
					risingEp: high,
					fallingSar: high,
					fallingEp: low,
					af: accelerationFactor
				};
			}).accumulator(function (_ref2) {
				var _ref3 = _slicedToArray(_ref2, 2),
				    prev = _ref3[0],
				    now = _ref3[1];
	
				var _calc = calc(prev, now),
				    risingSar = _calc.risingSar,
				    fallingSar = _calc.fallingSar,
				    risingEp = _calc.risingEp,
				    fallingEp = _calc.fallingEp;
	
				if ((0, _utils.isNotDefined)(prev.use) && risingSar > now.low && fallingSar < now.high) {
					return {
						risingSar: risingSar,
						fallingSar: fallingSar,
						risingEp: risingEp,
						fallingEp: fallingEp
					};
				}
	
				var use = (0, _utils.isDefined)(prev.use) ? prev.use === "rising" ? risingSar > now.low ? "falling" : "rising" : fallingSar < now.high ? "rising" : "falling" : risingSar > now.low ? "falling" : "rising";
	
				var current = prev.use === use ? {
					af: Math.min(maxAccelerationFactor, prev.af + accelerationFactor),
					fallingEp: fallingEp,
					risingEp: risingEp,
					fallingSar: fallingSar,
					risingSar: risingSar
				} : {
					af: accelerationFactor,
					fallingEp: now.low,
					risingEp: now.high,
					fallingSar: Math.max(prev.risingEp, now.high),
					risingSar: Math.min(prev.fallingEp, now.low)
				};
	
				var date = now.date,
				    high = now.high,
				    low = now.low;
	
				return _extends({
					date: date,
					high: high,
					low: low
				}, current, {
					use: use,
					sar: use === "falling" ? current.fallingSar : current.risingSar
				});
			});
	
			var calculatedData = algorithm(data).map(function (d) {
				return d.sar;
			});
			// console.log(calculatedData);
	
			return calculatedData;
		}
		calculator.undefinedLength = function () {
			return 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.SAR, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	function calc(prev, now) {
		var risingSar = prev.risingSar + prev.af * (prev.risingEp - prev.risingSar);
	
		var fallingSar = prev.fallingSar - prev.af * (prev.fallingSar - prev.fallingEp);
	
		var risingEp = Math.max(prev.risingEp, now.high);
		var fallingEp = Math.min(prev.fallingEp, now.low);
	
		return {
			risingSar: risingSar,
			fallingSar: fallingSar,
			risingEp: risingEp,
			fallingEp: fallingEp
		};
	}
	//# sourceMappingURL=sar.js.map

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	
		var underlyingAlgorithm = (0, _forceIndex2.default)();
		var merge = (0, _utils.zipper)().combine(function (force, smoothed) {
			return { force: force, smoothed: smoothed };
		});
	
		var options = _defaultOptionsForComputation.SmoothedForceIndex;
		function calculator(data) {
			var _options = options,
			    smoothingType = _options.smoothingType,
			    smoothingWindow = _options.smoothingWindow;
			var _options2 = options,
			    sourcePath = _options2.sourcePath,
			    volumePath = _options2.volumePath;
	
	
			var algo = underlyingAlgorithm.options({ sourcePath: sourcePath, volumePath: volumePath });
	
			var force = algo(data);
	
			var ma = smoothingType === "ema" ? (0, _ema2.default)() : (0, _sma2.default)();
			var forceMA = ma.options({
				windowSize: smoothingWindow,
				sourcePath: undefined
			});
	
			var smoothed = forceMA(force);
			return merge(force, smoothed);
		}
	
		calculator.undefinedLength = function () {
			var _options3 = options,
			    smoothingWindow = _options3.smoothingWindow;
	
			return underlyingAlgorithm.undefinedLength() + smoothingWindow - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.SmoothedForceIndex, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _forceIndex = __webpack_require__(397);
	
	var _forceIndex2 = _interopRequireDefault(_forceIndex);
	
	var _ema = __webpack_require__(94);
	
	var _ema2 = _interopRequireDefault(_ema);
	
	var _sma = __webpack_require__(398);
	
	var _sma2 = _interopRequireDefault(_sma);
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=smoothedForceIndex.js.map

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*
	https://github.com/ScottLogic/d3fc/blob/master/src/indicator/algorithm/calculator/stochasticOscillator.js
	
	The MIT License (MIT)
	
	Copyright (c) 2014-2015 Scott Logic Ltd.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.FullStochasticOscillator;
	
		var source = function source(d) {
			return { open: d.open, high: d.high, low: d.low, close: d.close };
		};
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize,
			    kWindowSize = _options.kWindowSize,
			    dWindowSize = _options.dWindowSize;
	
	
			var high = function high(d) {
				return source(d).high;
			},
			    low = function low(d) {
				return source(d).low;
			},
			    close = function close(d) {
				return source(d).close;
			};
	
			var kWindow = (0, _utils.slidingWindow)().windowSize(windowSize).accumulator(function (values) {
	
				var highestHigh = (0, _d3Array.max)(values, high);
				var lowestLow = (0, _d3Array.min)(values, low);
	
				var currentClose = close((0, _utils.last)(values));
				var k = (currentClose - lowestLow) / (highestHigh - lowestLow) * 100;
	
				return k;
			});
	
			var kSmoothed = (0, _utils.slidingWindow)().skipInitial(windowSize - 1).windowSize(kWindowSize).accumulator(function (values) {
				return (0, _d3Array.mean)(values);
			});
	
			var dWindow = (0, _utils.slidingWindow)().skipInitial(windowSize - 1 + kWindowSize - 1).windowSize(dWindowSize).accumulator(function (values) {
				return (0, _d3Array.mean)(values);
			});
	
			var stoAlgorithm = (0, _utils.zipper)().combine(function (K, D) {
				return { K: K, D: D };
			});
	
			var kData = kSmoothed(kWindow(data));
			var dData = dWindow(kData);
	
			var indicatorData = stoAlgorithm(kData, dData);
	
			return indicatorData;
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize,
			    kWindowSize = _options2.kWindowSize,
			    dWindowSize = _options2.dWindowSize;
	
			return windowSize + kWindowSize + dWindowSize;
		};
		calculator.source = function (x) {
			if (!arguments.length) {
				return source;
			}
			source = x;
			return calculator;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.FullStochasticOscillator, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _d3Array = __webpack_require__(21);
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=sto.js.map

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*
	 TRIMA (Triangular Moving Average).
	
	 The Triangular Moving Average can be used like any other Moving Average, to obtain a smoother representation of the underlying data.
	 It is important to note that the Triangular Moving Average is typically much smoother than other moving averages.
	
	 Triangular moving averages give greater weight to prices at the centre of the chosen period andi it is calculated as double smoothed SMA (simple moving average).
	
	 Examples:
	   For TimeSerie={a,b,c,d,e,f...} ('a' is the older price)
	
	   1st value for TMA 4-Period is:  ((1*a)+(2*b)+(2*c)+(1*d)) / 6
	   2nd value for TMA 4-Period is:  ((1*b)+(2*c)+(2*d)+(1*e)) / 6
	
	   1st value for TMA 5-Period is:  ((1*a)+(2*b)+(3*c)+(2*d)+(1*e)) / 9
	   2nd value for TMA 5-Period is:  ((1*b)+(2*c)+(3*d)+(2*e)+(1*f)) / 9
	
	 Using algebra, it can be demonstrated that the TMA is equivalent to
	 doing a SMA of a SMA. The following explain the rules:
	
	   (1) When the period is even, TMA(x,period)=SMA(SMA(x,period/2),(period/2)+1)
	   (2) When the period is odd,  TMA(x,period)=SMA(SMA(x,(period+1)/2),(period+1)/2)
	
	 In other word:
	   (1) A period of 4 becomes TMA(x,4) = SMA( SMA( x, 2), 3 )
	   (2) A period of 5 becomes TMA(x,5) = SMA( SMA( x, 3), 3 )
	
	 The SMA of a SMA is the algorithm generally found in books.
	*/
	
	exports.default = function () {
		var options = _defaultOptionsForComputation.TMA;
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize,
			    sourcePath = _options.sourcePath;
	
	
			var n = Math.floor(windowSize / 2);
			var weight = windowSize % 2 === 0 ? n * (n + 1) : (n + 1) * (n + 1);
	
			var triaverage = (0, _utils.slidingWindow)().windowSize(windowSize).sourcePath(sourcePath).accumulator(function (values) {
				var total = (0, _d3Array.sum)(values, function (v, i) {
					return i < n ? (i + 1) * v : (windowSize - i) * v;
				});
				return total / weight;
			});
	
			return triaverage(data);
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize;
	
			return windowSize - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.TMA, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _d3Array = __webpack_require__(21);
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=tma.js.map

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	
		var options = _defaultOptionsForComputation.WMA;
	
		function calculator(data) {
			var _options = options,
			    windowSize = _options.windowSize,
			    sourcePath = _options.sourcePath;
	
	
			var weight = windowSize * (windowSize + 1) / 2;
	
			var waverage = (0, _utils.slidingWindow)().windowSize(windowSize).sourcePath(sourcePath).accumulator(function (values) {
				var total = (0, _d3Array.sum)(values, function (v, i) {
					return (i + 1) * v;
				});
				return total / weight;
			});
	
			return waverage(data);
		}
		calculator.undefinedLength = function () {
			var _options2 = options,
			    windowSize = _options2.windowSize;
	
	
			return windowSize - 1;
		};
		calculator.options = function (x) {
			if (!arguments.length) {
				return options;
			}
			options = _extends({}, _defaultOptionsForComputation.WMA, x);
			return calculator;
		};
	
		return calculator;
	};
	
	var _d3Array = __webpack_require__(21);
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	//# sourceMappingURL=wma.js.map

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _GenericComponent2 = _interopRequireDefault(_GenericComponent);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CrossHairCursor = function (_Component) {
		_inherits(CrossHairCursor, _Component);
	
		function CrossHairCursor(props) {
			_classCallCheck(this, CrossHairCursor);
	
			var _this = _possibleConstructorReturn(this, (CrossHairCursor.__proto__ || Object.getPrototypeOf(CrossHairCursor)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(CrossHairCursor, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var lines = helper(this.props, moreProps);
	
				if ((0, _utils.isDefined)(lines)) {
					var _context = this.context,
					    margin = _context.margin,
					    ratio = _context.ratio;
	
					var originX = 0.5 * ratio + margin.left;
					var originY = 0.5 * ratio + margin.top;
	
					ctx.save();
					ctx.setTransform(1, 0, 0, 1, 0, 0);
					ctx.scale(ratio, ratio);
	
					ctx.translate(originX, originY);
	
					lines.forEach(function (line) {
						var dashArray = (0, _utils.getStrokeDasharray)(line.strokeDasharray).split(",").map(function (d) {
							return +d;
						});
	
						ctx.strokeStyle = (0, _utils.hexToRGBA)(line.stroke, line.opacity);
						ctx.setLineDash(dashArray);
						ctx.beginPath();
						ctx.moveTo(line.x1, line.y1);
						ctx.lineTo(line.x2, line.y2);
						ctx.stroke();
					});
	
					ctx.restore();
				}
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var className = this.props.className;
	
				var lines = helper(this.props, moreProps);
	
				if ((0, _utils.isNotDefined)(lines)) return null;
	
				return _react2.default.createElement(
					"g",
					{ className: "react-stockcharts-crosshair " + className },
					lines.map(function (_ref, idx) {
						var strokeDasharray = _ref.strokeDasharray,
						    rest = _objectWithoutProperties(_ref, ["strokeDasharray"]);
	
						return _react2.default.createElement("line", _extends({
							key: idx,
							strokeDasharray: (0, _utils.getStrokeDasharray)(strokeDasharray)
						}, rest));
					})
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericComponent2.default, {
					svgDraw: this.renderSVG,
					clip: false,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getMouseCanvas,
					drawOn: ["mousemove", "pan", "drag"]
				});
			}
		}]);
	
		return CrossHairCursor;
	}(_react.Component);
	
	CrossHairCursor.propTypes = {
		className: _propTypes2.default.string,
		strokeDasharray: _propTypes2.default.oneOf(_utils.strokeDashTypes)
	};
	
	CrossHairCursor.contextTypes = {
		margin: _propTypes2.default.object.isRequired,
		ratio: _propTypes2.default.number.isRequired
		// xScale for getting update event upon pan end, this is needed to get past the PureComponent shouldComponentUpdate
		// xScale: PropTypes.func.isRequired,
	};
	
	function customX(props, moreProps) {
		var xScale = moreProps.xScale,
		    xAccessor = moreProps.xAccessor,
		    currentItem = moreProps.currentItem,
		    mouseXY = moreProps.mouseXY;
		var snapX = props.snapX;
	
		var x = snapX ? Math.round(xScale(xAccessor(currentItem))) : mouseXY[0];
		return x;
	}
	
	CrossHairCursor.defaultProps = {
		stroke: "#000000",
		opacity: 0.3,
		strokeDasharray: "ShortDash",
		snapX: true,
		customX: customX
	};
	
	function helper(props, moreProps) {
		var mouseXY = moreProps.mouseXY,
		    currentItem = moreProps.currentItem,
		    show = moreProps.show,
		    height = moreProps.height,
		    width = moreProps.width;
		var customX = props.customX,
		    stroke = props.stroke,
		    opacity = props.opacity,
		    strokeDasharray = props.strokeDasharray;
	
	
		if (!show || (0, _utils.isNotDefined)(currentItem)) return null;
	
		var line1 = {
			x1: 0,
			x2: width,
			y1: mouseXY[1],
			y2: mouseXY[1],
			stroke: stroke, strokeDasharray: strokeDasharray, opacity: opacity
		};
		var x = customX(props, moreProps);
	
		var line2 = {
			x1: x,
			x2: x,
			y1: 0,
			y2: height,
			stroke: stroke, strokeDasharray: strokeDasharray, opacity: opacity
		};
		return [line1, line2];
	}
	
	exports.default = CrossHairCursor;
	//# sourceMappingURL=CrossHairCursor.js.map

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _utils = __webpack_require__(4);
	
	var _GenericComponent = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentCoordinate = function (_Component) {
		_inherits(CurrentCoordinate, _Component);
	
		function CurrentCoordinate(props) {
			_classCallCheck(this, CurrentCoordinate);
	
			var _this = _possibleConstructorReturn(this, (CurrentCoordinate.__proto__ || Object.getPrototypeOf(CurrentCoordinate)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(CurrentCoordinate, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var circle = helper(this.props, moreProps);
				if (!circle) return null;
	
				ctx.fillStyle = circle.fill;
				ctx.beginPath();
				ctx.arc(circle.x, circle.y, circle.r, 0, 2 * Math.PI, false);
				ctx.fill();
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var className = this.props.className;
	
	
				var circle = helper(this.props, moreProps);
				if (!circle) return null;
	
				var fillColor = circle.fill instanceof Function ? circle.fill(moreProps.currentItem) : circle.fill;
	
				return _react2.default.createElement("circle", { className: className, cx: circle.x, cy: circle.y, r: circle.r, fill: fillColor });
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getMouseCanvas,
					drawOn: ["mousemove", "pan"]
				});
			}
		}]);
	
		return CurrentCoordinate;
	}(_react.Component);
	
	CurrentCoordinate.propTypes = {
		yAccessor: _propTypes2.default.func,
		r: _propTypes2.default.number.isRequired,
		className: _propTypes2.default.string
	};
	
	CurrentCoordinate.defaultProps = {
		r: 3,
		className: "react-stockcharts-current-coordinate"
	};
	
	function helper(props, moreProps) {
		var fill = props.fill,
		    yAccessor = props.yAccessor,
		    r = props.r;
		var show = moreProps.show,
		    xScale = moreProps.xScale,
		    yScale = moreProps.chartConfig.yScale,
		    currentItem = moreProps.currentItem,
		    xAccessor = moreProps.xAccessor;
	
		// console.log(show);
	
		if (!show || (0, _utils.isNotDefined)(currentItem)) return null;
	
		var xValue = xAccessor(currentItem);
		var yValue = yAccessor(currentItem);
	
		if ((0, _utils.isNotDefined)(yValue)) return null;
	
		// console.log(chartConfig);
		var x = Math.round(xScale(xValue));
		var y = Math.round(yScale(yValue));
	
		return { x: x, y: y, r: r, fill: fill };
	}
	
	exports.default = CurrentCoordinate;
	//# sourceMappingURL=CurrentCoordinate.js.map

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(33);
	
	var _EdgeCoordinateV = __webpack_require__(112);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EdgeIndicator = function (_Component) {
		_inherits(EdgeIndicator, _Component);
	
		function EdgeIndicator(props) {
			_classCallCheck(this, EdgeIndicator);
	
			var _this = _possibleConstructorReturn(this, (EdgeIndicator.__proto__ || Object.getPrototypeOf(EdgeIndicator)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(EdgeIndicator, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var edge = helper(this.props, moreProps);
				var props = _extends({}, this.props, edge);
				(0, _EdgeCoordinateV.drawOnCanvas)(ctx, props);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var edge = helper(this.props, moreProps);
				var props = _extends({}, this.props, edge);
				return (0, _EdgeCoordinateV.renderSVG)(props);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					edgeClip: true,
					clip: false,
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}]);
	
		return EdgeIndicator;
	}(_react.Component);
	
	EdgeIndicator.propTypes = {
		yAccessor: _propTypes2.default.func,
	
		type: _propTypes2.default.oneOf(["horizontal"]),
		className: _propTypes2.default.string,
		fill: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
		lineStroke: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
		textFill: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
		itemType: _propTypes2.default.oneOf(["first", "last"]).isRequired,
		orient: _propTypes2.default.oneOf(["left", "right"]),
		edgeAt: _propTypes2.default.oneOf(["left", "right"]),
		displayFormat: _propTypes2.default.func,
		rectHeight: _propTypes2.default.number,
		rectWidth: _propTypes2.default.number,
		arrowWidth: _propTypes2.default.number,
		lineStrokeDasharray: _propTypes2.default.oneOf(_utils.strokeDashTypes)
	};
	
	EdgeIndicator.defaultProps = {
		className: "react-stockcharts-edgeindicator",
	
		type: "horizontal",
		orient: "left",
		edgeAt: "left",
		textFill: "#FFFFFF",
		displayFormat: (0, _d3Format.format)(".2f"),
		yAxisPad: 0,
		rectHeight: 20,
		rectWidth: 50,
		arrowWidth: 10,
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 13,
		dx: 0,
		hideLine: false,
		fill: "#8a8a8a",
		opacity: 1,
	
		stroke: _utils.noop,
		strokeOpacity: 1,
		strokeWidth: 3,
		lineStroke: "#000000",
		lineOpacity: 0.3,
		lineStrokeDasharray: "ShortDash"
	};
	
	function helper(props, moreProps) {
		var itemType = props.itemType,
		    yAccessor = props.yAccessor;
		var plotData = moreProps.plotData;
	
	
		var item = itemType === "first" ? (0, _utils.first)(plotData, yAccessor) : (0, _utils.last)(plotData, yAccessor);
	
		// var currentItem = ChartDataUtil.getCurrentItemForChartNew(currentItems, forChart);
		var edge = (0, _utils.isDefined)(item) ? getEdge(props, moreProps, item) : null;
	
		return edge;
	}
	
	function getEdge(props, moreProps, item) {
		var edgeType = props.type,
		    displayFormat = props.displayFormat,
		    edgeAt = props.edgeAt,
		    yAxisPad = props.yAxisPad,
		    orient = props.orient,
		    lineStroke = props.lineStroke;
		var yAccessor = props.yAccessor,
		    fill = props.fill,
		    textFill = props.textFill,
		    rectHeight = props.rectHeight,
		    rectWidth = props.rectWidth,
		    arrowWidth = props.arrowWidth;
		var fontFamily = props.fontFamily,
		    fontSize = props.fontSize;
		var stroke = props.stroke;
		var xScale = moreProps.xScale,
		    yScale = moreProps.chartConfig.yScale,
		    xAccessor = moreProps.xAccessor,
		    width = moreProps.width;
	
	
		var yValue = yAccessor(item),
		    xValue = xAccessor(item);
	
		var x1 = Math.round(xScale(xValue)),
		    y1 = Math.round(yScale(yValue));
	
		var left = 0,
		    right = width;
	
		var edgeX = edgeAt === "left" ? left - yAxisPad : right + yAxisPad;
	
		return {
			// ...props,
			coordinate: displayFormat(yValue),
			show: true,
			type: edgeType,
			orient: orient,
			edgeAt: edgeX,
			fill: (0, _utils.functor)(fill)(item),
			lineStroke: (0, _utils.functor)(lineStroke)(item),
			stroke: (0, _utils.functor)(stroke)(item),
			fontFamily: fontFamily, fontSize: fontSize,
			textFill: (0, _utils.functor)(textFill)(item),
			rectHeight: rectHeight, rectWidth: rectWidth, arrowWidth: arrowWidth,
			x1: x1,
			y1: y1,
			x2: right,
			y2: y1
		};
	}
	
	exports.default = EdgeIndicator;
	//# sourceMappingURL=EdgeIndicator.js.map

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EdgeCoordinateV = __webpack_require__(112);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MouseCoordinateX = function (_Component) {
		_inherits(MouseCoordinateX, _Component);
	
		function MouseCoordinateX(props) {
			_classCallCheck(this, MouseCoordinateX);
	
			var _this = _possibleConstructorReturn(this, (MouseCoordinateX.__proto__ || Object.getPrototypeOf(MouseCoordinateX)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(MouseCoordinateX, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var props = helper(this.props, moreProps);
				if ((0, _utils.isNotDefined)(props)) return null;
	
				(0, _EdgeCoordinateV.drawOnCanvas)(ctx, props);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var props = helper(this.props, moreProps);
				if ((0, _utils.isNotDefined)(props)) return null;
	
				return (0, _EdgeCoordinateV.renderSVG)(props);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					clip: false,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getMouseCanvas,
					drawOn: ["mousemove", "pan", "drag"]
				});
			}
		}]);
	
		return MouseCoordinateX;
	}(_react.Component);
	
	MouseCoordinateX.propTypes = {
		displayFormat: _propTypes2.default.func.isRequired,
		yAxisPad: _propTypes2.default.number,
		rectWidth: _propTypes2.default.number,
		rectHeight: _propTypes2.default.number,
		orient: _propTypes2.default.oneOf(["bottom", "top", "left", "right"]),
		at: _propTypes2.default.oneOf(["bottom", "top", "left", "right"]),
		fill: _propTypes2.default.string,
		opacity: _propTypes2.default.number,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		textFill: _propTypes2.default.string,
		snapX: _propTypes2.default.bool
	};
	
	function customX(props, moreProps) {
		var xScale = moreProps.xScale,
		    xAccessor = moreProps.xAccessor,
		    currentItem = moreProps.currentItem,
		    mouseXY = moreProps.mouseXY;
		var snapX = props.snapX;
	
		var x = snapX ? xScale(xAccessor(currentItem)) : mouseXY[0];
	
		var displayXAccessor = moreProps.displayXAccessor;
		var displayFormat = props.displayFormat;
	
		var coordinate = snapX ? displayFormat(displayXAccessor(currentItem)) : displayFormat(xScale.invert(x));
		return { x: x, coordinate: coordinate };
	}
	
	MouseCoordinateX.defaultProps = {
		yAxisPad: 0,
		rectWidth: 80,
		rectHeight: 20,
	
		// rectRadius: 5,
		// stroke: "#684F1D",
		strokeOpacity: 1,
		strokeWidth: 1,
	
		orient: "bottom",
		at: "bottom",
	
		fill: "#525252",
		opacity: 1,
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 13,
		textFill: "#FFFFFF",
		snapX: true,
		customX: customX
	};
	
	function helper(props, moreProps) {
		var show = moreProps.show,
		    currentItem = moreProps.currentItem;
		var height = moreProps.chartConfig.height;
	
	
		if ((0, _utils.isNotDefined)(currentItem)) return null;
	
		var customX = props.customX;
		var orient = props.orient,
		    at = props.at;
		var stroke = props.stroke,
		    strokeOpacity = props.strokeOpacity,
		    strokeWidth = props.strokeWidth;
		var rectRadius = props.rectRadius,
		    rectWidth = props.rectWidth,
		    rectHeight = props.rectHeight;
		var fill = props.fill,
		    opacity = props.opacity,
		    fontFamily = props.fontFamily,
		    fontSize = props.fontSize,
		    textFill = props.textFill;
	
	
		var edgeAt = at === "bottom" ? height : 0;
	
		var _customX = customX(props, moreProps),
		    x = _customX.x,
		    coordinate = _customX.coordinate;
	
		var type = "vertical";
		var y1 = 0,
		    y2 = height;
		var hideLine = true;
	
		var coordinateProps = {
			coordinate: coordinate,
			show: show,
			type: type,
			orient: orient,
			edgeAt: edgeAt,
			hideLine: hideLine,
			fill: fill, opacity: opacity, fontFamily: fontFamily, fontSize: fontSize, textFill: textFill,
			stroke: stroke, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth,
			rectWidth: rectWidth,
			rectHeight: rectHeight,
			rectRadius: rectRadius,
			arrowWidth: 0,
			x1: x,
			x2: x,
			y1: y1,
			y2: y2
		};
		return coordinateProps;
	}
	
	exports.default = MouseCoordinateX;
	//# sourceMappingURL=MouseCoordinateX.js.map

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		xPosition: _propTypes2.default.func,
		drawCoordinate: _propTypes2.default.func,
		displayFormat: _propTypes2.default.func.isRequired,
		at: _propTypes2.default.oneOf(["bottom", "top"]),
		orient: _propTypes2.default.oneOf(["bottom", "top"]),
		text: _propTypes2.default.shape({
			fontStyle: _propTypes2.default.string,
			fontWeight: _propTypes2.default.string,
			fontFamily: _propTypes2.default.string,
			fontSize: _propTypes2.default.number,
			fill: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
		}),
		bg: _propTypes2.default.shape({
			fill: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
			stroke: _propTypes2.default.string,
			strokeWidth: _propTypes2.default.number,
			padding: _propTypes2.default.shape({
				left: _propTypes2.default.number,
				right: _propTypes2.default.number,
				top: _propTypes2.default.number,
				bottom: _propTypes2.default.number
			})
		}),
		dx: _propTypes2.default.number,
		dy: _propTypes2.default.number
	};
	
	var defaultProps = {
		xPosition: xPosition,
		drawCoordinate: drawCoordinate,
		at: "bottom",
		orient: "bottom",
	
		text: {
			fontStyle: "",
			fontWeight: "",
			fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
			fontSize: 13,
			fill: "rgb(35, 35, 35)"
		},
		bg: {
			fill: "rgb(255, 255, 255)",
			stroke: "rgb(35, 35, 35)",
			strokeWidth: 1,
			padding: {
				left: 7,
				right: 7,
				top: 4,
				bottom: 4
			}
		},
		dx: 7,
		dy: 7
	};
	
	var MouseCoordinateXV2 = function (_Component) {
		_inherits(MouseCoordinateXV2, _Component);
	
		function MouseCoordinateXV2(props) {
			_classCallCheck(this, MouseCoordinateXV2);
	
			var _this = _possibleConstructorReturn(this, (MouseCoordinateXV2.__proto__ || Object.getPrototypeOf(MouseCoordinateXV2)).call(this, props));
	
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(MouseCoordinateXV2, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var show = moreProps.show,
				    currentItem = moreProps.currentItem;
				var drawCoordinate = this.props.drawCoordinate;
	
	
				if (show && currentItem != null) {
					var shape = getXCoordinateInfo(ctx, this.props, moreProps);
					drawCoordinate(ctx, shape, this.props, moreProps);
				}
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getMouseCanvas,
					drawOn: ["mousemove", "pan", "drag"]
				});
			}
		}]);
	
		return MouseCoordinateXV2;
	}(_react.Component);
	
	MouseCoordinateXV2.defaultProps = defaultProps;
	MouseCoordinateXV2.propTypes = propTypes;
	
	function xPosition(props, moreProps) {
		var currentItem = moreProps.currentItem,
		    xAccessor = moreProps.xAccessor;
	
		return xAccessor(currentItem);
	}
	function getXCoordinateInfo(ctx, props, moreProps) {
		var xPosition = props.xPosition;
	
		var xValue = xPosition(props, moreProps);
		var at = props.at,
		    displayFormat = props.displayFormat;
		var text = props.text;
		var xScale = moreProps.xScale,
		    height = moreProps.chartConfig.height;
	
		ctx.font = text.fontStyle + " " + text.fontWeight + " " + text.fontSize + "px " + text.fontFamily;
	
		var t = displayFormat(xValue);
		var textWidth = ctx.measureText(t).width;
	
		var y = at === "bottom" ? height : 0;
		var x = Math.round(xScale(xValue));
	
		return {
			x: x,
			y: y,
			textWidth: textWidth,
			text: t
		};
	}
	
	function drawCoordinate(ctx, shape, props, moreProps) {
		var x = shape.x,
		    y = shape.y,
		    textWidth = shape.textWidth,
		    text = shape.text;
		var orient = props.orient,
		    dx = props.dx,
		    dy = props.dy;
		var _props$bg = props.bg,
		    padding = _props$bg.padding,
		    fill = _props$bg.fill,
		    stroke = _props$bg.stroke,
		    strokeWidth = _props$bg.strokeWidth,
		    _props$text = props.text,
		    fontSize = _props$text.fontSize,
		    textFill = _props$text.fill;
	
	
		ctx.textAlign = "center";
	
		var sign = orient === "top" ? -1 : 1;
		var halfWidth = Math.round(textWidth / 2 + padding.right);
		var height = Math.round(fontSize + padding.top + padding.bottom);
	
		ctx.strokeStyle = typeof stroke === "function" ? stroke(moreProps, ctx) : stroke;
		ctx.fillStyle = typeof fill === "function" ? fill(moreProps, ctx) : fill;
		ctx.lineWidth = typeof strokeWidth === "function" ? strokeWidth(moreProps) : strokeWidth;
	
		ctx.beginPath();
	
		ctx.moveTo(x, y);
		ctx.lineTo(x + dx, y + sign * dy);
		ctx.lineTo(x + halfWidth, y + sign * dy);
		ctx.lineTo(x + halfWidth, y + sign * (dy + height));
		ctx.lineTo(x - halfWidth, y + sign * (dy + height));
		ctx.lineTo(x - halfWidth, y + sign * dy);
		ctx.lineTo(x - dx, y + sign * dy);
		ctx.closePath();
		ctx.stroke();
		ctx.fill();
	
		ctx.beginPath();
		ctx.fillStyle = typeof textFill === "function" ? textFill(moreProps, ctx) : textFill;
	
		ctx.textBaseline = orient === "top" ? "alphabetic" : "hanging";
		var pad = orient === "top" ? padding.bottom : padding.top;
	
		ctx.fillText(text, x, y + sign * (dy + pad + 2));
	}
	
	exports.default = MouseCoordinateXV2;
	//# sourceMappingURL=MouseCoordinateXV2.js.map

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getYCoordinate = getYCoordinate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EdgeCoordinateV = __webpack_require__(112);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MouseCoordinateY = function (_Component) {
		_inherits(MouseCoordinateY, _Component);
	
		function MouseCoordinateY(props) {
			_classCallCheck(this, MouseCoordinateY);
	
			var _this = _possibleConstructorReturn(this, (MouseCoordinateY.__proto__ || Object.getPrototypeOf(MouseCoordinateY)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(MouseCoordinateY, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var props = helper(this.props, moreProps);
				if ((0, _utils.isNotDefined)(props)) return null;
	
				(0, _EdgeCoordinateV.drawOnCanvas)(ctx, props);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var props = helper(this.props, moreProps);
				if ((0, _utils.isNotDefined)(props)) return null;
	
				return (0, _EdgeCoordinateV.renderSVG)(props);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getMouseCanvas,
					drawOn: ["mousemove", "pan", "drag"]
				});
			}
		}]);
	
		return MouseCoordinateY;
	}(_react.Component);
	
	MouseCoordinateY.propTypes = {
		displayFormat: _propTypes2.default.func.isRequired,
		yAxisPad: _propTypes2.default.number,
		rectWidth: _propTypes2.default.number,
		rectHeight: _propTypes2.default.number,
		orient: _propTypes2.default.oneOf(["bottom", "top", "left", "right"]),
		at: _propTypes2.default.oneOf(["bottom", "top", "left", "right"]),
		dx: _propTypes2.default.number,
		fill: _propTypes2.default.string,
		opacity: _propTypes2.default.number,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		textFill: _propTypes2.default.string
	};
	
	MouseCoordinateY.defaultProps = {
		yAxisPad: 0,
		rectWidth: 50,
		rectHeight: 20,
		orient: "left",
		at: "left",
		dx: 0,
		arrowWidth: 10,
		fill: "#525252",
		opacity: 1,
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 13,
		textFill: "#FFFFFF",
	
		// stroke: "#684F1D",
		strokeOpacity: 1,
		strokeWidth: 1
	};
	
	function helper(props, moreProps) {
		var chartId = moreProps.chartId;
		var currentCharts = moreProps.currentCharts,
		    mouseXY = moreProps.mouseXY;
	
	
		if ((0, _utils.isNotDefined)(mouseXY)) return null;
		if (currentCharts.indexOf(chartId) < 0) return null;
	
		var show = moreProps.show;
	
		if (!show) return null;
	
		var y = mouseXY[1];
		var yScale = moreProps.chartConfig.yScale;
		var displayFormat = props.displayFormat;
	
	
		var coordinate = displayFormat(yScale.invert(y));
	
		return getYCoordinate(y, coordinate, props, moreProps);
	}
	
	function getYCoordinate(y, displayValue, props, moreProps) {
		var width = moreProps.width;
		var orient = props.orient,
		    at = props.at,
		    rectWidth = props.rectWidth,
		    rectHeight = props.rectHeight,
		    dx = props.dx;
		var fill = props.fill,
		    opacity = props.opacity,
		    fontFamily = props.fontFamily,
		    fontSize = props.fontSize,
		    textFill = props.textFill,
		    arrowWidth = props.arrowWidth;
		var stroke = props.stroke,
		    strokeOpacity = props.strokeOpacity,
		    strokeWidth = props.strokeWidth;
	
	
		var x1 = 0,
		    x2 = width;
		var edgeAt = at === "right" ? width : 0;
	
		var type = "horizontal";
		var hideLine = true;
	
		var coordinateProps = {
			coordinate: displayValue,
			show: true,
			type: type,
			orient: orient,
			edgeAt: edgeAt,
			hideLine: hideLine,
			fill: fill,
			opacity: opacity,
	
			fontFamily: fontFamily,
			fontSize: fontSize,
			textFill: textFill,
	
			stroke: stroke,
			strokeOpacity: strokeOpacity,
			strokeWidth: strokeWidth,
	
			rectWidth: rectWidth,
			rectHeight: rectHeight,
	
			arrowWidth: arrowWidth,
			dx: dx,
			x1: x1,
			x2: x2,
			y1: y,
			y2: y
		};
		return coordinateProps;
	}
	
	exports.default = MouseCoordinateY;
	//# sourceMappingURL=MouseCoordinateY.js.map

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EdgeCoordinateV = __webpack_require__(112);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceCoordinate = function (_Component) {
		_inherits(PriceCoordinate, _Component);
	
		function PriceCoordinate(props) {
			_classCallCheck(this, PriceCoordinate);
	
			var _this = _possibleConstructorReturn(this, (PriceCoordinate.__proto__ || Object.getPrototypeOf(PriceCoordinate)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(PriceCoordinate, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var props = helper(this.props, moreProps);
				(0, _EdgeCoordinateV.drawOnCanvas)(ctx, props);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var props = helper(this.props, moreProps);
				return (0, _EdgeCoordinateV.renderSVG)(props);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}]);
	
		return PriceCoordinate;
	}(_react.Component);
	
	PriceCoordinate.propTypes = {
		displayFormat: _propTypes2.default.func.isRequired,
		yAxisPad: _propTypes2.default.number,
		rectWidth: _propTypes2.default.number,
		rectHeight: _propTypes2.default.number,
		orient: _propTypes2.default.oneOf(["bottom", "top", "left", "right"]),
		at: _propTypes2.default.oneOf(["bottom", "top", "left", "right"]),
		price: _propTypes2.default.number,
		dx: _propTypes2.default.number,
		arrowWidth: _propTypes2.default.number,
		opacity: _propTypes2.default.number,
		lineOpacity: _propTypes2.default.number,
		lineStroke: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		fill: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
		strokeDasharray: _propTypes2.default.oneOf(_utils.strokeDashTypes),
		stroke: _propTypes2.default.string,
		strokeOpacity: _propTypes2.default.number,
		strokeWidth: _propTypes2.default.number,
		textFill: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	
	PriceCoordinate.defaultProps = {
		yAxisPad: 0,
		rectWidth: 50,
		rectHeight: 20,
		orient: "left",
		at: "left",
		price: 0,
		dx: 0,
		arrowWidth: 0,
		fill: "#BAB8b8",
		opacity: 1,
		lineOpacity: 0.2,
		lineStroke: "#000000",
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 13,
		textFill: "#FFFFFF",
		strokeOpacity: 1,
		strokeWidth: 1,
		strokeDasharray: "Solid"
	};
	
	function helper(props, moreProps) {
		var width = moreProps.width;
		var yScale = moreProps.chartConfig.yScale;
	
		var _yScale$domain = yScale.domain(),
		    _yScale$domain2 = _slicedToArray(_yScale$domain, 2),
		    lowerYValue = _yScale$domain2[0],
		    upperYValue = _yScale$domain2[1];
	
		var price = props.price,
		    stroke = props.stroke,
		    strokeDasharray = props.strokeDasharray,
		    strokeOpacity = props.strokeOpacity,
		    strokeWidth = props.strokeWidth;
		var orient = props.orient,
		    at = props.at,
		    rectWidth = props.rectWidth,
		    rectHeight = props.rectHeight,
		    displayFormat = props.displayFormat,
		    dx = props.dx;
		var fill = props.fill,
		    opacity = props.opacity,
		    fontFamily = props.fontFamily,
		    fontSize = props.fontSize,
		    textFill = props.textFill,
		    arrowWidth = props.arrowWidth,
		    lineOpacity = props.lineOpacity,
		    lineStroke = props.lineStroke;
	
	
		var x1 = 0,
		    x2 = width;
		var edgeAt = at === "right" ? width : 0;
	
		var type = "horizontal";
	
		var y = yScale(price);
		var show = price <= upperYValue && price >= lowerYValue;
	
		var coordinate = displayFormat(yScale.invert(y));
		var hideLine = false;
	
		var coordinateProps = {
			coordinate: coordinate,
			show: show,
			type: type,
			orient: orient,
			edgeAt: edgeAt,
			hideLine: hideLine,
			lineOpacity: lineOpacity,
			lineStroke: lineStroke,
			lineStrokeDasharray: strokeDasharray,
			stroke: stroke,
			strokeOpacity: strokeOpacity,
			strokeWidth: strokeWidth,
			fill: (0, _utils.functor)(fill)(price),
			textFill: (0, _utils.functor)(textFill)(price),
			opacity: opacity, fontFamily: fontFamily, fontSize: fontSize,
			rectWidth: rectWidth,
			rectHeight: rectHeight,
			arrowWidth: arrowWidth,
			dx: dx,
			x1: x1,
			x2: x2,
			y1: y,
			y2: y
		};
		return coordinateProps;
	}
	
	exports.default = PriceCoordinate;
	//# sourceMappingURL=PriceCoordinate.js.map

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EdgeIndicator = __webpack_require__(718);
	
	Object.defineProperty(exports, "EdgeIndicator", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EdgeIndicator).default;
	  }
	});
	
	var _CurrentCoordinate = __webpack_require__(717);
	
	Object.defineProperty(exports, "CurrentCoordinate", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CurrentCoordinate).default;
	  }
	});
	
	var _MouseCoordinateX = __webpack_require__(719);
	
	Object.defineProperty(exports, "MouseCoordinateX", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MouseCoordinateX).default;
	  }
	});
	
	var _MouseCoordinateXV = __webpack_require__(720);
	
	Object.defineProperty(exports, "MouseCoordinateXV2", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MouseCoordinateXV).default;
	  }
	});
	
	var _MouseCoordinateY = __webpack_require__(721);
	
	Object.defineProperty(exports, "MouseCoordinateY", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MouseCoordinateY).default;
	  }
	});
	
	var _CrossHairCursor = __webpack_require__(716);
	
	Object.defineProperty(exports, "CrossHairCursor", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CrossHairCursor).default;
	  }
	});
	
	var _PriceCoordinate = __webpack_require__(722);
	
	Object.defineProperty(exports, "PriceCoordinate", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PriceCoordinate).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _saveSvgAsPng = __webpack_require__(811);
	
	var _saveSvgAsPng2 = _interopRequireDefault(_saveSvgAsPng);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dx = 0;
	var dy = 0;
	
	var SaveChartAsImage = {
		save: function save(doc, container, background, cb) {
			_saveSvgAsPng2.default.svgAsDataUri(container.getElementsByTagName("svg")[0], {}, function (uri) {
				// eslint-disable-next-line prefer-const
				var image = new Image();
				image.onload = function () {
	
					// eslint-disable-next-line prefer-const
					var canvas = doc.createElement("canvas");
					canvas.width = image.width;
					canvas.height = image.height;
	
					// eslint-disable-next-line prefer-const
					var context = canvas.getContext("2d");
	
					if ((0, _utils.isDefined)(background)) {
						context.fillStyle = background;
						context.fillRect(0, 0, canvas.width, canvas.height);
					}
					var canvasList = container.getElementsByTagName("canvas");
					for (var i = 0; i < canvasList.length; i++) {
						var each = canvasList[i];
						if ((0, _utils.isDefined)(each)) {
							var parent = each.parentNode.parentNode.getBoundingClientRect();
							var rect = each.getBoundingClientRect();
							context.drawImage(each, rect.left - parent.left + dx, rect.top - parent.top + dy);
						}
					}
	
					context.drawImage(image, dx, dy);
					cb(canvas.toDataURL("image/png"));
				};
				image.src = uri;
			});
		},
		saveWithWhiteBG: function saveWithWhiteBG(doc, container, cb) {
			return this.saveWithBG(doc, container, "white", cb);
		},
		saveWithDarkBG: function saveWithDarkBG(doc, container, cb) {
			return this.saveWithBG(doc, container, "#303030", cb);
		},
		saveWithBG: function saveWithBG(doc, container, background, cb) {
			return this.save(doc, container, background, cb);
		},
		saveChartAsImage: function saveChartAsImage(container) {
			this.saveWithWhiteBG(document, container, function (src) {
				var a = document.createElement("a");
				a.setAttribute("href", src);
				a.setAttribute("download", "Chart.png");
	
				document.body.appendChild(a);
				a.addEventListener("click", function () /* e */{
					a.parentNode.removeChild(a);
				});
	
				a.click();
			});
		}
	};
	
	exports.default = SaveChartAsImage;
	//# sourceMappingURL=SaveChartAsImage.js.map

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TypeChooser = function (_Component) {
		_inherits(TypeChooser, _Component);
	
		function TypeChooser(props) {
			_classCallCheck(this, TypeChooser);
	
			var _this = _possibleConstructorReturn(this, (TypeChooser.__proto__ || Object.getPrototypeOf(TypeChooser)).call(this, props));
	
			_this.state = {
				type: _this.props.type
			};
			_this.handleTypeChange = _this.handleTypeChange.bind(_this);
			return _this;
		}
	
		_createClass(TypeChooser, [{
			key: "handleTypeChange",
			value: function handleTypeChange(e) {
				// console.log(e.target.value);
				this.setState({
					type: e.target.value
				});
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"label",
						null,
						"Type: "
					),
					_react2.default.createElement(
						"select",
						{ name: "type", id: "type", onChange: this.handleTypeChange, value: this.state.type },
						_react2.default.createElement(
							"option",
							{ value: "svg" },
							"svg"
						),
						_react2.default.createElement(
							"option",
							{ value: "hybrid" },
							"canvas + svg"
						)
					),
					_react2.default.createElement(
						"div",
						{ style: this.props.style },
						this.props.children(this.state.type)
					)
				);
			}
		}]);
	
		return TypeChooser;
	}(_react.Component);
	
	TypeChooser.propTypes = {
		type: _propTypes2.default.oneOf(["svg", "hybrid"]),
		children: _propTypes2.default.func.isRequired,
		style: _propTypes2.default.object.isRequired
	};
	
	TypeChooser.defaultProps = {
		type: "hybrid",
		style: {}
	};
	
	exports.default = TypeChooser;
	//# sourceMappingURL=TypeChooser.js.map

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = fitDimensions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getDisplayName(Series) {
		var name = Series.displayName || Series.name || "Series";
		return name;
	}
	
	function fitDimensions(WrappedComponent) {
		var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var _props$minWidth = props.minWidth,
		    minWidth = _props$minWidth === undefined ? 100 : _props$minWidth,
		    _props$minHeight = props.minHeight,
		    minHeight = _props$minHeight === undefined ? 100 : _props$minHeight,
		    ratio = props.ratio,
		    width = props.width,
		    height = props.height;
	
	
		function getDimensions(el) {
			var w = el.parentNode.clientWidth;
			var h = el.parentNode.clientHeight;
	
			return {
				width: (0, _utils.isDefined)(width) ? width : Math.max(w, minWidth),
				height: (0, _utils.isDefined)(height) ? height : Math.max(h, minHeight)
			};
		}
	
		var ResponsiveComponent = function (_Component) {
			_inherits(ResponsiveComponent, _Component);
	
			function ResponsiveComponent(props) {
				_classCallCheck(this, ResponsiveComponent);
	
				var _this = _possibleConstructorReturn(this, (ResponsiveComponent.__proto__ || Object.getPrototypeOf(ResponsiveComponent)).call(this, props));
	
				_this.handleWindowResize = _this.handleWindowResize.bind(_this);
				_this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
				_this.saveNode = _this.saveNode.bind(_this);
				_this.setTestCanvas = _this.setTestCanvas.bind(_this);
				_this.state = {};
				return _this;
			}
	
			_createClass(ResponsiveComponent, [{
				key: "saveNode",
				value: function saveNode(node) {
					this.node = node;
				}
			}, {
				key: "setTestCanvas",
				value: function setTestCanvas(node) {
					this.testCanvas = node;
				}
			}, {
				key: "getRatio",
				value: function getRatio() {
					if ((0, _utils.isDefined)(this.testCanvas)) {
						var context = this.testCanvas.getContext("2d");
	
						var devicePixelRatio = window.devicePixelRatio || 1;
						var backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
	
						var _ratio = devicePixelRatio / backingStoreRatio;
						// console.log("ratio = ", ratio);
						return _ratio;
					}
					return 1;
				}
			}, {
				key: "componentDidMount",
				value: function componentDidMount() {
					window.addEventListener("resize", this.handleWindowResize);
					var dimensions = getDimensions(this.node);
	
					/* eslint-disable react/no-did-mount-set-state */
					this.setState(_extends({}, dimensions, {
						ratio: (0, _utils.isDefined)(ratio) ? ratio : this.getRatio()
					}));
					/* eslint-enable react/no-did-mount-set-state */
				}
			}, {
				key: "componentWillUnmount",
				value: function componentWillUnmount() {
					window.removeEventListener("resize", this.handleWindowResize);
				}
			}, {
				key: "handleWindowResize",
				value: function handleWindowResize() {
					var node = _reactDom2.default.findDOMNode(this.node); // eslint-disable-line react/no-find-dom-node
					this.setState(getDimensions(node));
				}
			}, {
				key: "getWrappedInstance",
				value: function getWrappedInstance() {
					return this.node;
				}
			}, {
				key: "render",
				value: function render() {
					var ref = { ref: this.saveNode };
	
					if (this.state.width) {
						return _react2.default.createElement(WrappedComponent, _extends({
							height: this.state.height,
							width: this.state.width,
							ratio: this.state.ratio
						}, this.props, ref));
					} else {
						return _react2.default.createElement(
							"div",
							ref,
							_react2.default.createElement("canvas", { ref: this.setTestCanvas })
						);
					}
				}
			}]);
	
			return ResponsiveComponent;
		}(_react.Component);
	
		ResponsiveComponent.displayName = "fitDimensions(" + getDisplayName(WrappedComponent) + ")";
	
		return ResponsiveComponent;
	}
	//# sourceMappingURL=fitDimensions.js.map

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = fitWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactDOM from "react-dom";
	
	function getDisplayName(Series) {
		var name = Series.displayName || Series.name || "Series";
		return name;
	}
	
	function fitWidth(WrappedComponent) {
		var withRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
		var minWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
	
		var ResponsiveComponent = function (_Component) {
			_inherits(ResponsiveComponent, _Component);
	
			function ResponsiveComponent(props) {
				_classCallCheck(this, ResponsiveComponent);
	
				var _this = _possibleConstructorReturn(this, (ResponsiveComponent.__proto__ || Object.getPrototypeOf(ResponsiveComponent)).call(this, props));
	
				_this.handleWindowResize = _this.handleWindowResize.bind(_this);
				_this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
				_this.saveNode = _this.saveNode.bind(_this);
				_this.setTestCanvas = _this.setTestCanvas.bind(_this);
				_this.state = {};
				return _this;
			}
	
			_createClass(ResponsiveComponent, [{
				key: "saveNode",
				value: function saveNode(node) {
					this.node = node;
				}
			}, {
				key: "setTestCanvas",
				value: function setTestCanvas(node) {
					this.testCanvas = node;
				}
			}, {
				key: "getRatio",
				value: function getRatio() {
					if ((0, _utils.isDefined)(this.testCanvas)) {
						var context = this.testCanvas.getContext("2d");
	
						var devicePixelRatio = window.devicePixelRatio || 1;
						var backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
	
						var ratio = devicePixelRatio / backingStoreRatio;
						// console.log("ratio = ", ratio);
						return ratio;
					}
					return 1;
				}
			}, {
				key: "componentDidMount",
				value: function componentDidMount() {
					window.addEventListener("resize", this.handleWindowResize);
					this.handleWindowResize();
					/* eslint-disable react/no-did-mount-set-state */
					this.setState({
						ratio: this.getRatio()
					});
					/* eslint-enable react/no-did-mount-set-state */
				}
			}, {
				key: "componentWillUnmount",
				value: function componentWillUnmount() {
					window.removeEventListener("resize", this.handleWindowResize);
				}
			}, {
				key: "handleWindowResize",
				value: function handleWindowResize() {
					var _this2 = this;
	
					this.setState({
						width: 0
					}, function () {
						var el = _this2.node;
	
						var _window$getComputedSt = window.getComputedStyle(el.parentNode),
						    width = _window$getComputedSt.width,
						    paddingLeft = _window$getComputedSt.paddingLeft,
						    paddingRight = _window$getComputedSt.paddingRight;
	
						var w = parseFloat(width) - (parseFloat(paddingLeft) + parseFloat(paddingRight));
	
						_this2.setState({
							width: Math.round(Math.max(w, minWidth))
						});
					});
				}
			}, {
				key: "getWrappedInstance",
				value: function getWrappedInstance() {
					return this.node;
				}
			}, {
				key: "render",
				value: function render() {
					var ref = withRef ? { ref: this.saveNode } : {};
	
					if (this.state.width) {
						return _react2.default.createElement(WrappedComponent, _extends({ width: this.state.width, ratio: this.state.ratio }, this.props, ref));
					} else {
						return _react2.default.createElement(
							"div",
							ref,
							_react2.default.createElement("canvas", { ref: this.setTestCanvas })
						);
					}
				}
			}]);
	
			return ResponsiveComponent;
		}(_react.Component);
	
		ResponsiveComponent.displayName = "fitWidth(" + getDisplayName(WrappedComponent) + ")";
	
		return ResponsiveComponent;
	}
	//# sourceMappingURL=fitWidth.js.map

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TypeChooser = __webpack_require__(725);
	
	Object.defineProperty(exports, "TypeChooser", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TypeChooser).default;
	  }
	});
	
	var _SaveChartAsImage = __webpack_require__(724);
	
	Object.defineProperty(exports, "SaveChartAsImage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SaveChartAsImage).default;
	  }
	});
	
	var _fitWidth = __webpack_require__(727);
	
	Object.defineProperty(exports, "fitWidth", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fitWidth).default;
	  }
	});
	
	var _fitDimensions = __webpack_require__(726);
	
	Object.defineProperty(exports, "fitDimensions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fitDimensions).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE);
	
		var underlyingAlgorithm = (0, _calculator.atr)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.atr = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "ATR";
	//# sourceMappingURL=atr.js.map

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE);
	
		var underlyingAlgorithm = (0, _calculator.bollingerband)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.bollingerBand = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	var _calculator = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "BollingerBand";
	//# sourceMappingURL=bollingerBand.js.map

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE);
	
		var underlyingAlgorithm = (0, _calculator.change)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.absoluteChange = indicator.absoluteChange;
			datum.percentChange = indicator.percentChange;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "Change";
	//# sourceMappingURL=change.js.map

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.compare;
		});
	
		var underlyingAlgorithm = (0, _calculator.compare)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.compare = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "Compare";
	//# sourceMappingURL=compare.js.map

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = function () {
	
		var macdSource = void 0,
		    emaSource = void 0;
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE)
		// .stroke(d => stroke[d.elderImpulse])
		.stroke(_defaultOptionsForAppearance.ElderImpulse.stroke).fill(undefined);
	
		var underlyingAlgorithm = (0, _utils.slidingWindow)().windowSize(2).undefinedValue("neutral").accumulator(function (_ref) {
			var _ref2 = _slicedToArray(_ref, 2),
			    prev = _ref2[0],
			    curr = _ref2[1];
	
			if ((0, _utils.isNotDefined)(macdSource)) throw new Error("macdSource not defined for " + ALGORITHM_TYPE + " calculator");
			if ((0, _utils.isNotDefined)(emaSource)) throw new Error("emaSource not defined for " + ALGORITHM_TYPE + " calculator");
	
			if ((0, _utils.isDefined)(macdSource(prev)) && (0, _utils.isDefined)(emaSource(prev))) {
				var prevMACDDivergence = macdSource(prev).divergence;
				var currMACDDivergence = macdSource(curr).divergence;
	
				var prevEMA = emaSource(prev);
				var currEMA = emaSource(curr);
	
				if (currMACDDivergence >= prevMACDDivergence && currEMA >= prevEMA) return "up";
	
				if (currMACDDivergence <= prevMACDDivergence && currEMA <= prevEMA) return "down";
			}
			return "neutral";
		});
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.elderImpulse = indicator;
		});
	
		// eslint-disable-next-line prefer-const
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			var newData = options.merge ? mergedAlgorithm(data) : underlyingAlgorithm(data);
	
			return newData;
		};
		indicator.macdSource = function (x) {
			if (!arguments.length) return macdSource;
			macdSource = x;
			return indicator;
		};
		indicator.emaSource = function (x) {
			if (!arguments.length) return emaSource;
			emaSource = x;
			return indicator;
		};
		(0, _utils.rebind)(indicator, base, "id", "echo", "type", "stroke");
		// rebind(indicator, underlyingAlgorithm, "windowSize", "movingAverageType", "multiplier", "source");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _defaultOptionsForAppearance = __webpack_require__(164);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "ElderImpulse";
	//# sourceMappingURL=elderImpulse.js.map

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.elderRay;
		});
	
		var underlyingAlgorithm = (0, _calculator.elderRay)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.elderRay = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "ElderRay";
	//# sourceMappingURL=elderRay.js.map

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.ema;
		});
	
		var underlyingAlgorithm = (0, _calculator.ema)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.ema = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options", "undefinedLength");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "EMA";
	//# sourceMappingURL=ema.js.map

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.forceIndex;
		});
	
		var underlyingAlgorithm = (0, _calculator.forceIndex)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.forceIndex = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "ForceIndex";
	//# sourceMappingURL=forceIndex.js.map

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.ha;
		});
	
		var underlyingAlgorithm = (0, _calculator.heikinAshi)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			return _extends({}, datum, indicator);
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "accessor", "stroke", "fill", "echo", "type");
		// rebind(indicator, underlyingAlgorithm, "windowSize", "source");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge");
	
		return indicator;
	};
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "HeikinAshi";
	//# sourceMappingURL=heikinAshi.js.map

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultOptionsForAppearance = exports.defaultOptionsForComputation = exports.compare = exports.elderImpulse = exports.change = exports.elderRay = exports.sar = exports.forceIndex = exports.stochasticOscillator = exports.atr = exports.rsi = exports.macd = exports.renko = exports.pointAndFigure = exports.kagi = exports.heikinAshi = exports.bollingerBand = exports.tma = exports.wma = exports.sma = exports.ema = undefined;
	
	var _ema = __webpack_require__(735);
	
	Object.defineProperty(exports, "ema", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_ema).default;
		}
	});
	
	var _sma = __webpack_require__(745);
	
	Object.defineProperty(exports, "sma", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_sma).default;
		}
	});
	
	var _wma = __webpack_require__(748);
	
	Object.defineProperty(exports, "wma", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_wma).default;
		}
	});
	
	var _tma = __webpack_require__(747);
	
	Object.defineProperty(exports, "tma", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_tma).default;
		}
	});
	
	var _bollingerBand = __webpack_require__(730);
	
	Object.defineProperty(exports, "bollingerBand", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_bollingerBand).default;
		}
	});
	
	var _heikinAshi = __webpack_require__(737);
	
	Object.defineProperty(exports, "heikinAshi", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_heikinAshi).default;
		}
	});
	
	var _kagi = __webpack_require__(739);
	
	Object.defineProperty(exports, "kagi", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_kagi).default;
		}
	});
	
	var _pointAndFigure = __webpack_require__(741);
	
	Object.defineProperty(exports, "pointAndFigure", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_pointAndFigure).default;
		}
	});
	
	var _renko = __webpack_require__(742);
	
	Object.defineProperty(exports, "renko", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_renko).default;
		}
	});
	
	var _macd = __webpack_require__(740);
	
	Object.defineProperty(exports, "macd", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_macd).default;
		}
	});
	
	var _rsi = __webpack_require__(743);
	
	Object.defineProperty(exports, "rsi", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_rsi).default;
		}
	});
	
	var _atr = __webpack_require__(729);
	
	Object.defineProperty(exports, "atr", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_atr).default;
		}
	});
	
	var _stochasticOscillator = __webpack_require__(746);
	
	Object.defineProperty(exports, "stochasticOscillator", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_stochasticOscillator).default;
		}
	});
	
	var _forceIndex = __webpack_require__(736);
	
	Object.defineProperty(exports, "forceIndex", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_forceIndex).default;
		}
	});
	
	var _sar = __webpack_require__(744);
	
	Object.defineProperty(exports, "sar", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_sar).default;
		}
	});
	
	var _elderRay = __webpack_require__(734);
	
	Object.defineProperty(exports, "elderRay", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_elderRay).default;
		}
	});
	
	var _change = __webpack_require__(731);
	
	Object.defineProperty(exports, "change", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_change).default;
		}
	});
	
	var _elderImpulse = __webpack_require__(733);
	
	Object.defineProperty(exports, "elderImpulse", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_elderImpulse).default;
		}
	});
	
	var _compare = __webpack_require__(732);
	
	Object.defineProperty(exports, "compare", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_compare).default;
		}
	});
	
	var _defaultOptionsForComputation = __webpack_require__(23);
	
	var defaultOptionsForComputation = _interopRequireWildcard(_defaultOptionsForComputation);
	
	var _defaultOptionsForAppearance = __webpack_require__(164);
	
	var defaultOptionsForAppearance = _interopRequireWildcard(_defaultOptionsForAppearance);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.defaultOptionsForComputation = defaultOptionsForComputation;
	exports.defaultOptionsForAppearance = defaultOptionsForAppearance;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE);
	
		var underlyingAlgorithm = (0, _calculator.kagi)();
	
		var indicator = underlyingAlgorithm;
	
		(0, _utils.rebind)(indicator, base, "id", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "dateAccessor", "dateMutator");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "Kagi";
	//# sourceMappingURL=kagi.js.map

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).fill(_defaultOptionsForAppearance.MACD.fill).stroke(_defaultOptionsForAppearance.MACD.stroke).accessor(function (d) {
			return d.macd;
		});
	
		var underlyingAlgorithm = (0, _calculator.macd)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.macd = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options", "undefinedLength");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	var _defaultOptionsForAppearance = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "MACD";
	//# sourceMappingURL=macd.js.map

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE);
	
		var underlyingAlgorithm = (0, _calculator.pointAndFigure)();
	
		var indicator = underlyingAlgorithm;
	
		(0, _utils.rebind)(indicator, base, "id", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "dateAccessor", "dateMutator");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		// rebind(indicator, mergedAlgorithm, "merge"/*, "skipUndefined"*/);
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "PointAndFigure";
	//# sourceMappingURL=pointAndFigure.js.map

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE);
	
		var underlyingAlgorithm = (0, _calculator.renko)();
	
		var indicator = underlyingAlgorithm;
	
		(0, _utils.rebind)(indicator, base, "id", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "dateAccessor", "dateMutator");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "Renko";
	//# sourceMappingURL=renko.js.map

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.rsi;
		});
	
		var underlyingAlgorithm = (0, _calculator.rsi)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.rsi = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options", "undefinedLength");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "RSI";
	//# sourceMappingURL=rsi.js.map

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.sar;
		});
	
		var underlyingAlgorithm = (0, _calculator.sar)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.sar = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "undefinedLength");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "SMA";
	//# sourceMappingURL=sar.js.map

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.sma;
		});
	
		var underlyingAlgorithm = (0, _calculator.sma)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.sma = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "undefinedLength");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "SMA";
	//# sourceMappingURL=sma.js.map

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE);
	
		var underlyingAlgorithm = (0, _calculator.sto)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.sto = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options", "undefinedLength");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "STO";
	//# sourceMappingURL=stochasticOscillator.js.map

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.tma;
		});
	
		var underlyingAlgorithm = (0, _calculator.tma)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.tma = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "undefinedLength");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "TMA";
	//# sourceMappingURL=tma.js.map

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
			return d.wma;
		});
	
		var underlyingAlgorithm = (0, _calculator.wma)();
	
		var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
			datum.wma = indicator;
		});
	
		var indicator = function indicator(data) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };
	
			if (options.merge) {
				if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
				return mergedAlgorithm(data);
			}
			return underlyingAlgorithm(data);
		};
	
		(0, _utils.rebind)(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "undefinedLength");
		(0, _utils.rebind)(indicator, underlyingAlgorithm, "options");
		(0, _utils.rebind)(indicator, mergedAlgorithm, "merge", "skipUndefined");
	
		return indicator;
	};
	
	var _utils = __webpack_require__(4);
	
	var _calculator = __webpack_require__(25);
	
	var _baseIndicator = __webpack_require__(24);
	
	var _baseIndicator2 = _interopRequireDefault(_baseIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALGORITHM_TYPE = "WMA";
	//# sourceMappingURL=wma.js.map

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// import { map as d3Map } from "d3-collection";
	
	exports.discontinuousTimeScaleProviderBuilder = discontinuousTimeScaleProviderBuilder;
	
	var _d3TimeFormat = __webpack_require__(100);
	
	var _financeDiscontinuousScale = __webpack_require__(399);
	
	var _financeDiscontinuousScale2 = _interopRequireDefault(_financeDiscontinuousScale);
	
	var _utils = __webpack_require__(4);
	
	var _levels = __webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function evaluateLevel(d, date, i, formatters) {
		return _levels.levelDefinition.map(function (eachLevel, idx) {
			return {
				level: _levels.levelDefinition.length - idx - 1,
				format: formatters[eachLevel(d, date, i)]
			};
		}).find(function (l) {
			return !!l.format;
		});
	}
	
	var discontinuousIndexCalculator = (0, _utils.slidingWindow)().windowSize(2).undefinedValue(function (d, idx, _ref) {
		var initialIndex = _ref.initialIndex,
		    formatters = _ref.formatters;
	
		var i = initialIndex;
		var row = {
			date: d.getTime(),
			startOf30Seconds: false,
			startOfMinute: false,
			startOf5Minutes: false,
			startOf15Minutes: false,
			startOf30Minutes: false,
			startOfHour: false,
			startOfEighthOfADay: false,
			startOfQuarterDay: false,
			startOfHalfDay: false,
			startOfDay: true,
			startOfWeek: false,
			startOfMonth: false,
			startOfQuarter: false,
			startOfYear: false
		};
		var level = evaluateLevel(row, d, i, formatters);
		return _extends({}, row, { index: i }, level);
	});
	
	var discontinuousIndexCalculatorLocalTime = discontinuousIndexCalculator.accumulator(function (_ref2, i, idx, _ref3) {
		var _ref4 = _slicedToArray(_ref2, 2),
		    prevDate = _ref4[0],
		    nowDate = _ref4[1];
	
		var initialIndex = _ref3.initialIndex,
		    formatters = _ref3.formatters;
	
		var startOf30Seconds = nowDate.getSeconds() % 30 === 0;
	
		var startOfMinute = nowDate.getMinutes() !== prevDate.getMinutes();
		var startOf5Minutes = startOfMinute && nowDate.getMinutes() % 5 <= prevDate.getMinutes() % 5;
		var startOf15Minutes = startOfMinute && nowDate.getMinutes() % 15 <= prevDate.getMinutes() % 15;
		var startOf30Minutes = startOfMinute && nowDate.getMinutes() % 30 <= prevDate.getMinutes() % 30;
	
		var startOfHour = nowDate.getHours() !== prevDate.getHours();
	
		var startOfEighthOfADay = startOfHour && nowDate.getHours() % 3 === 0;
		var startOfQuarterDay = startOfHour && nowDate.getHours() % 6 === 0;
		var startOfHalfDay = startOfHour && nowDate.getHours() % 12 === 0;
	
		var startOfDay = nowDate.getDay() !== prevDate.getDay();
		// According to ISO calendar
		// Sunday = 0, Monday = 1, ... Saturday = 6
		// day of week of today < day of week of yesterday then today is start of week
		var startOfWeek = nowDate.getDay() < prevDate.getDay();
		// month of today != month of yesterday then today is start of month
		var startOfMonth = nowDate.getMonth() !== prevDate.getMonth();
		// if start of month and month % 3 === 0 then it is start of quarter
		var startOfQuarter = startOfMonth && nowDate.getMonth() % 3 <= prevDate.getMonth() % 3;
		// year of today != year of yesterday then today is start of year
		var startOfYear = nowDate.getFullYear() !== prevDate.getFullYear();
	
		var row = {
			date: nowDate.getTime(),
			startOf30Seconds: startOf30Seconds,
			startOfMinute: startOfMinute,
			startOf5Minutes: startOf5Minutes,
			startOf15Minutes: startOf15Minutes,
			startOf30Minutes: startOf30Minutes,
			startOfHour: startOfHour,
			startOfEighthOfADay: startOfEighthOfADay,
			startOfQuarterDay: startOfQuarterDay,
			startOfHalfDay: startOfHalfDay,
			startOfDay: startOfDay,
			startOfWeek: startOfWeek,
			startOfMonth: startOfMonth,
			startOfQuarter: startOfQuarter,
			startOfYear: startOfYear
		};
		var level = evaluateLevel(row, nowDate, i, formatters);
		if (level == null) {
			console.log(row);
		}
		return _extends({}, row, { index: i + initialIndex }, level);
	});
	
	function doStuff(realDateAccessor, inputDateAccessor, initialIndex, formatters) {
		return function (data) {
			var dateAccessor = realDateAccessor(inputDateAccessor);
			var calculate = discontinuousIndexCalculatorLocalTime.source(dateAccessor).misc({ initialIndex: initialIndex, formatters: formatters });
	
			var index = calculate(data).map(function (each) {
				var format = each.format;
	
				return {
					// ...each,
					index: each.index,
					level: each.level,
					date: new Date(each.date),
					format: (0, _d3TimeFormat.timeFormat)(format)
				};
			});
			/*
	  var map = d3Map();
	  for (var i = 0; i < data.length - 1; i++) {
	  		var nextDate = dateAccessor(data[i + 1]);
	  	var nowDate = dateAccessor(data[i]);
	  	var diff = nextDate - nowDate;
	  		if (map.has(diff)) {
	  		var count = parseInt(map.get(diff), 10) + 1;
	  		map.set(diff, count);
	  	} else {
	  		map.set(diff, 1);
	  	}
	  }
	  	var entries = map.entries().sort((a, b) => a.value < b.value);
	  	// For Renko/p&f
	  	var interval = entries[0].value === 1
	  	? Math.round((dateAccessor(last(data)) - dateAccessor(head(data))) / data.length)
	  	: parseInt(entries[0].key, 10); */
	
			// return { index, interval };
			return { index: index };
		};
	}
	
	function discontinuousTimeScaleProviderBuilder() {
		var initialIndex = 0,
		    realDateAccessor = _utils.identity;
		var inputDateAccessor = function inputDateAccessor(d) {
			return d.date;
		},
		    indexAccessor = function indexAccessor(d) {
			return d.idx;
		},
		    indexMutator = function indexMutator(d, idx) {
			return _extends({}, d, { idx: idx });
		},
		    withIndex = void 0;
	
		var currentFormatters = _levels.defaultFormatters;
	
		// eslint-disable-next-line prefer-const
		var discontinuousTimeScaleProvider = function discontinuousTimeScaleProvider(data) {
			/*
	  console.warn("Are you sure you want to use a discontinuousTimeScale?"
	  	+ " Use this only if you have discontinuous data which"
	  	+ " needs to be displayed as continuous."
	  	+ " If you have continuous data use a d3 scale like"
	  	+ " `d3.scaleTime`"
	  );
	  */
	
			var index = withIndex;
	
			if ((0, _utils.isNotDefined)(index)) {
				var response = doStuff(realDateAccessor, inputDateAccessor, initialIndex, currentFormatters)(data);
	
				index = response.index;
			}
			// console.log(interval, entries[0].key);
	
			var inputIndex = index;
			var xScale = (0, _financeDiscontinuousScale2.default)(inputIndex);
	
			var mergedData = (0, _utils.zipper)().combine(indexMutator);
	
			var finalData = mergedData(data, inputIndex);
	
			return {
				data: finalData,
				xScale: xScale,
				xAccessor: function xAccessor(d) {
					return d && indexAccessor(d).index;
				},
				displayXAccessor: realDateAccessor(inputDateAccessor)
			};
		};
	
		discontinuousTimeScaleProvider.initialIndex = function (x) {
			if (!arguments.length) {
				return initialIndex;
			}
			initialIndex = x;
			return discontinuousTimeScaleProvider;
		};
		discontinuousTimeScaleProvider.inputDateAccessor = function (x) {
			if (!arguments.length) {
				return inputDateAccessor;
			}
			inputDateAccessor = x;
			return discontinuousTimeScaleProvider;
		};
		discontinuousTimeScaleProvider.indexAccessor = function (x) {
			if (!arguments.length) {
				return indexAccessor;
			}
			indexAccessor = x;
			return discontinuousTimeScaleProvider;
		};
		discontinuousTimeScaleProvider.indexMutator = function (x) {
			if (!arguments.length) {
				return indexMutator;
			}
			indexMutator = x;
			return discontinuousTimeScaleProvider;
		};
		discontinuousTimeScaleProvider.withIndex = function (x) {
			if (!arguments.length) {
				return withIndex;
			}
			withIndex = x;
			return discontinuousTimeScaleProvider;
		};
		discontinuousTimeScaleProvider.utc = function () {
			realDateAccessor = function realDateAccessor(dateAccessor) {
				return function (d) {
					var date = dateAccessor(d);
					// The getTimezoneOffset() method returns the time-zone offset from UTC, in minutes, for the current locale.
					var offsetInMillis = date.getTimezoneOffset() * 60 * 1000;
					return new Date(date.getTime() + offsetInMillis);
				};
			};
			return discontinuousTimeScaleProvider;
		};
		discontinuousTimeScaleProvider.setLocale = function (locale) {
			var formatters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
			if (locale) {
				(0, _d3TimeFormat.timeFormatDefaultLocale)(locale);
			}
			if (formatters) {
				currentFormatters = formatters;
			}
			return discontinuousTimeScaleProvider;
		};
	
		discontinuousTimeScaleProvider.indexCalculator = function () {
			return doStuff(realDateAccessor, inputDateAccessor, initialIndex, currentFormatters);
		};
	
		return discontinuousTimeScaleProvider;
	}
	
	/* discontinuousTimeScaleProvider.utc = function(data,
			dateAccessor,
			indexAccessor,
			indexMutator) {
		var utcDateAccessor = d => {
			var date = dateAccessor(d);
			// The getTimezoneOffset() method returns the time-zone offset from UTC, in minutes, for the current locale.
			var offsetInMillis = date.getTimezoneOffset() * 60 * 1000;
			return new Date(date.getTime() + offsetInMillis);
		};
		return discontinuousTimeScaleProvider(data, utcDateAccessor, indexAccessor, indexMutator);
	};*/
	
	exports.default = discontinuousTimeScaleProviderBuilder();
	//# sourceMappingURL=discontinuousTimeScaleProvider.js.map

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = function (_ref2) {
		var xScale = _ref2.xScale,
		    useWholeData = _ref2.useWholeData,
		    clamp = _ref2.clamp,
		    pointsPerPxThreshold = _ref2.pointsPerPxThreshold,
		    minPointsPerPxThreshold = _ref2.minPointsPerPxThreshold,
		    flipXScale = _ref2.flipXScale;
	
		return extentsWrapper(useWholeData || (0, _utils.isNotDefined)(xScale.invert), clamp, pointsPerPxThreshold, minPointsPerPxThreshold, flipXScale);
	};
	
	var _utils = __webpack_require__(4);
	
	var log = (0, _utils.getLogger)("evaluator");
	
	function getNewEnd(fallbackEnd, xAccessor, initialXScale, start) {
		var lastItem = fallbackEnd.lastItem,
		    lastItemX = fallbackEnd.lastItemX;
	
		var lastItemXValue = xAccessor(lastItem);
	
		var _initialXScale$range = initialXScale.range(),
		    _initialXScale$range2 = _slicedToArray(_initialXScale$range, 2),
		    rangeStart = _initialXScale$range2[0],
		    rangeEnd = _initialXScale$range2[1];
	
		var newEnd = (rangeEnd - rangeStart) / (lastItemX - rangeStart) * (lastItemXValue - start) + start;
		return newEnd;
	}
	
	function extentsWrapper(useWholeData, clamp, pointsPerPxThreshold, minPointsPerPxThreshold, flipXScale) {
		function filterData(data, inputDomain, xAccessor, initialXScale) {
			var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
			    currentPlotData = _ref.currentPlotData,
			    currentDomain = _ref.currentDomain,
			    fallbackStart = _ref.fallbackStart,
			    fallbackEnd = _ref.fallbackEnd;
	
			if (useWholeData) {
				return { plotData: data, domain: inputDomain };
			}
	
			var left = (0, _utils.head)(inputDomain);
			var right = (0, _utils.last)(inputDomain);
			var clampedDomain = inputDomain;
	
			var filteredData = getFilteredResponse(data, left, right, xAccessor);
	
			if (filteredData.length === 1 && (0, _utils.isDefined)(fallbackStart)) {
				left = fallbackStart;
				right = getNewEnd(fallbackEnd, xAccessor, initialXScale, left);
	
				clampedDomain = [left, right];
				filteredData = getFilteredResponse(data, left, right, xAccessor);
			}
	
			if (typeof clamp === "function") {
				clampedDomain = clamp(clampedDomain, [xAccessor((0, _utils.head)(data)), xAccessor((0, _utils.last)(data))]);
			} else {
				if (clamp === "left" || clamp === "both" || clamp === true) {
					clampedDomain = [Math.max(left, xAccessor((0, _utils.head)(data))), clampedDomain[1]];
				}
	
				if (clamp === "right" || clamp === "both" || clamp === true) {
					clampedDomain = [clampedDomain[0], Math.min(right, xAccessor((0, _utils.last)(data)))];
				}
			}
	
			if (clampedDomain !== inputDomain) {
				filteredData = getFilteredResponse(data, clampedDomain[0], clampedDomain[1], xAccessor);
			}
	
			var realInputDomain = clampedDomain;
			// [xAccessor(head(filteredData)), xAccessor(last(filteredData))];
	
			var xScale = initialXScale.copy().domain(realInputDomain);
	
			var width = Math.floor(xScale(xAccessor((0, _utils.last)(filteredData))) - xScale(xAccessor((0, _utils.head)(filteredData))));
	
			// prevent negative width when flipXScale
			if (flipXScale && width < 0) {
				width = width * -1;
			}
	
			var plotData = void 0,
			    domain = void 0;
	
			var chartWidth = (0, _utils.last)(xScale.range()) - (0, _utils.head)(xScale.range());
	
			log("Trying to show " + filteredData.length + " points in " + width + "px," + (" I can show up to " + (showMaxThreshold(width, pointsPerPxThreshold) - 1) + " points in that width. ") + ("Also FYI the entire chart width is " + chartWidth + "px and pointsPerPxThreshold is " + pointsPerPxThreshold));
	
			if (canShowTheseManyPeriods(width, filteredData.length, pointsPerPxThreshold, minPointsPerPxThreshold)) {
				plotData = filteredData;
				domain = realInputDomain;
				log("AND IT WORKED");
			} else {
				if (chartWidth > showMaxThreshold(width, pointsPerPxThreshold) && (0, _utils.isDefined)(fallbackEnd)) {
					plotData = filteredData;
					var newEnd = getNewEnd(fallbackEnd, xAccessor, initialXScale, (0, _utils.head)(realInputDomain));
					domain = [(0, _utils.head)(realInputDomain), newEnd];
					// plotData = currentPlotData || filteredData.slice(filteredData.length - showMax(width, pointsPerPxThreshold));
					// domain = currentDomain || [xAccessor(head(plotData)), xAccessor(last(plotData))];
	
					var newXScale = xScale.copy().domain(domain);
					var newWidth = Math.floor(newXScale(xAccessor((0, _utils.last)(plotData))) - newXScale(xAccessor((0, _utils.head)(plotData))));
	
					log("and ouch, that is too much, so instead showing " + plotData.length + " in " + newWidth + "px");
				} else {
					plotData = currentPlotData || filteredData.slice(filteredData.length - showMax(width, pointsPerPxThreshold));
					domain = currentDomain || [xAccessor((0, _utils.head)(plotData)), xAccessor((0, _utils.last)(plotData))];
	
					var _newXScale = xScale.copy().domain(domain);
					var _newWidth = Math.floor(_newXScale(xAccessor((0, _utils.last)(plotData))) - _newXScale(xAccessor((0, _utils.head)(plotData))));
	
					log("and ouch, that is too much, so instead showing " + plotData.length + " in " + _newWidth + "px");
				}
			}
			return { plotData: plotData, domain: domain };
		}
		return { filterData: filterData };
	}
	
	function canShowTheseManyPeriods(width, arrayLength, maxThreshold, minThreshold) {
		return arrayLength > showMinThreshold(width, minThreshold) && arrayLength < showMaxThreshold(width, maxThreshold);
	}
	
	function showMinThreshold(width, threshold) {
		return Math.max(1, Math.ceil(width * threshold));
	}
	
	function showMaxThreshold(width, threshold) {
		return Math.floor(width * threshold);
	}
	
	function showMax(width, threshold) {
		return Math.floor(showMaxThreshold(width, threshold) * 0.97);
	}
	
	function getFilteredResponse(data, left, right, xAccessor) {
		var newLeftIndex = (0, _utils.getClosestItemIndexes)(data, left, xAccessor).right;
		var newRightIndex = (0, _utils.getClosestItemIndexes)(data, right, xAccessor).left;
	
		var filteredData = data.slice(newLeftIndex, newRightIndex + 1);
		// console.log(right, newRightIndex, dataForInterval.length);
	
		return filteredData;
	}
	//# sourceMappingURL=evaluator.js.map

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _discontinuousTimeScaleProvider = __webpack_require__(749);
	
	Object.defineProperty(exports, "discontinuousTimeScaleProvider", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_discontinuousTimeScaleProvider).default;
		}
	});
	Object.defineProperty(exports, "discontinuousTimeScaleProviderBuilder", {
		enumerable: true,
		get: function get() {
			return _discontinuousTimeScaleProvider.discontinuousTimeScaleProviderBuilder;
		}
	});
	
	var _financeDiscontinuousScale = __webpack_require__(399);
	
	Object.defineProperty(exports, "financeDiscontinuousScale", {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_financeDiscontinuousScale).default;
		}
	});
	exports.defaultScaleProvider = defaultScaleProvider;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultScaleProvider(xScale) {
		return function (data, xAccessor) {
			return { data: data, xScale: xScale, xAccessor: xAccessor, displayXAccessor: xAccessor };
		};
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AreaSeries = __webpack_require__(401);
	
	var _AreaSeries2 = _interopRequireDefault(_AreaSeries);
	
	var _SVGComponent = __webpack_require__(403);
	
	var _SVGComponent2 = _interopRequireDefault(_SVGComponent);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlternatingFillAreaSeries = function (_Component) {
		_inherits(AlternatingFillAreaSeries, _Component);
	
		function AlternatingFillAreaSeries(props) {
			_classCallCheck(this, AlternatingFillAreaSeries);
	
			var _this = _possibleConstructorReturn(this, (AlternatingFillAreaSeries.__proto__ || Object.getPrototypeOf(AlternatingFillAreaSeries)).call(this, props));
	
			_this.renderClip = _this.renderClip.bind(_this);
			_this.topClip = _this.topClip.bind(_this);
			_this.bottomClip = _this.bottomClip.bind(_this);
			_this.baseAt = _this.baseAt.bind(_this);
	
			var id1 = String(Math.round(Math.random() * 10000 * 10000));
			_this.clipPathId1 = "alternating-area-clip-" + id1;
	
			var id2 = String(Math.round(Math.random() * 10000 * 10000));
			_this.clipPathId2 = "alternating-area-clip-" + id2;
			return _this;
		}
	
		_createClass(AlternatingFillAreaSeries, [{
			key: "topClip",
			value: function topClip(ctx, moreProps) {
				var chartConfig = moreProps.chartConfig;
				var baseAt = this.props.baseAt;
				var yScale = chartConfig.yScale,
				    width = chartConfig.width;
	
	
				ctx.beginPath();
				ctx.rect(0, 0, width, yScale(baseAt));
				ctx.clip();
			}
		}, {
			key: "bottomClip",
			value: function bottomClip(ctx, moreProps) {
				var chartConfig = moreProps.chartConfig;
				var baseAt = this.props.baseAt;
				var yScale = chartConfig.yScale,
				    width = chartConfig.width,
				    height = chartConfig.height;
	
	
				ctx.beginPath();
				ctx.rect(0, yScale(baseAt), width, height - yScale(baseAt));
				ctx.clip();
			}
		}, {
			key: "renderClip",
			value: function renderClip(moreProps) {
				var chartConfig = moreProps.chartConfig;
				var baseAt = this.props.baseAt;
				var yScale = chartConfig.yScale,
				    width = chartConfig.width,
				    height = chartConfig.height;
	
	
				return _react2.default.createElement(
					"defs",
					null,
					_react2.default.createElement(
						"clipPath",
						{ id: this.clipPathId1 },
						_react2.default.createElement("rect", {
							x: 0,
							y: 0,
							width: width,
							height: yScale(baseAt)
						})
					),
					_react2.default.createElement(
						"clipPath",
						{ id: this.clipPathId2 },
						_react2.default.createElement("rect", {
							x: 0,
							y: yScale(baseAt),
							width: width,
							height: height - yScale(baseAt)
						})
					)
				);
			}
		}, {
			key: "baseAt",
			value: function baseAt(yScale) {
				return yScale(this.props.baseAt);
			}
		}, {
			key: "render",
			value: function render() {
				var _props = this.props,
				    className = _props.className,
				    yAccessor = _props.yAccessor,
				    interpolation = _props.interpolation;
				var _props2 = this.props,
				    stroke = _props2.stroke,
				    strokeWidth = _props2.strokeWidth,
				    strokeOpacity = _props2.strokeOpacity,
				    strokeDasharray = _props2.strokeDasharray,
				    fill = _props2.fill,
				    fillOpacity = _props2.fillOpacity;
	
	
				var style1 = { "clipPath": "url(#" + this.clipPathId1 + ")" };
				var style2 = { "clipPath": "url(#" + this.clipPathId2 + ")" };
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					_react2.default.createElement(
						_SVGComponent2.default,
						null,
						this.renderClip
					),
					_react2.default.createElement(_AreaSeries2.default, {
						style: style1,
						canvasClip: this.topClip,
	
						yAccessor: yAccessor,
						interpolation: interpolation,
						baseAt: this.baseAt,
	
						fill: fill.top,
						opacity: fillOpacity.top,
						stroke: stroke.top,
						strokeOpacity: strokeOpacity.top,
						strokeDasharray: strokeDasharray.top,
						strokeWidth: strokeWidth.top
					}),
					_react2.default.createElement(_AreaSeries2.default, {
						style: style2,
						canvasClip: this.bottomClip,
	
						yAccessor: yAccessor,
						interpolation: interpolation,
						baseAt: this.baseAt,
	
						fill: fill.bottom,
						opacity: fillOpacity.bottom,
						stroke: stroke.bottom,
						strokeOpacity: strokeOpacity.bottom,
						strokeDasharray: strokeDasharray.bottom,
						strokeWidth: strokeWidth.bottom
					})
				);
			}
		}]);
	
		return AlternatingFillAreaSeries;
	}(_react.Component);
	
	AlternatingFillAreaSeries.propTypes = {
		stroke: _propTypes2.default.shape({
			top: _propTypes2.default.string,
			bottom: _propTypes2.default.string
		}),
	
		strokeWidth: _propTypes2.default.shape({
			top: _propTypes2.default.number,
			bottom: _propTypes2.default.number
		}),
		strokeOpacity: _propTypes2.default.shape({
			top: _propTypes2.default.number,
			bottom: _propTypes2.default.number
		}),
		fill: _propTypes2.default.shape({
			top: _propTypes2.default.string,
			bottom: _propTypes2.default.string
		}),
		fillOpacity: _propTypes2.default.shape({
			top: _propTypes2.default.number,
			bottom: _propTypes2.default.number
		}),
		strokeDasharray: _propTypes2.default.shape({
			top: _propTypes2.default.oneOf(_utils.strokeDashTypes),
			bottom: _propTypes2.default.oneOf(_utils.strokeDashTypes)
		}).isRequired,
	
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func.isRequired,
	
		baseAt: _propTypes2.default.number.isRequired,
	
		interpolation: _propTypes2.default.func
	};
	
	AlternatingFillAreaSeries.defaultProps = {
		stroke: {
			top: "#38C172",
			bottom: "#E3342F"
		},
		strokeWidth: {
			top: 2,
			bottom: 2
		},
		strokeOpacity: {
			top: 1,
			bottom: 1
		},
		fill: {
			top: "#A2F5BF",
			bottom: "#EF5753"
		},
		fillOpacity: {
			top: 0.5,
			bottom: 0.5
		},
		strokeDasharray: {
			top: "Solid",
			bottom: "Solid"
		},
		className: "react-stockcharts-alternating-area"
	};
	
	exports.default = AlternatingFillAreaSeries;
	//# sourceMappingURL=AlternatingFillAreaSeries.js.map

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LineSeries = __webpack_require__(78);
	
	var _LineSeries2 = _interopRequireDefault(_LineSeries);
	
	var _AreaOnlySeries = __webpack_require__(165);
	
	var _AreaOnlySeries2 = _interopRequireDefault(_AreaOnlySeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BollingerSeries = function (_Component) {
		_inherits(BollingerSeries, _Component);
	
		function BollingerSeries(props) {
			_classCallCheck(this, BollingerSeries);
	
			var _this = _possibleConstructorReturn(this, (BollingerSeries.__proto__ || Object.getPrototypeOf(BollingerSeries)).call(this, props));
	
			_this.yAccessorForTop = _this.yAccessorForTop.bind(_this);
			_this.yAccessorForMiddle = _this.yAccessorForMiddle.bind(_this);
			_this.yAccessorForBottom = _this.yAccessorForBottom.bind(_this);
			_this.yAccessorForScalledBottom = _this.yAccessorForScalledBottom.bind(_this);
			return _this;
		}
	
		_createClass(BollingerSeries, [{
			key: "yAccessorForTop",
			value: function yAccessorForTop(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && yAccessor(d).top;
			}
		}, {
			key: "yAccessorForMiddle",
			value: function yAccessorForMiddle(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && yAccessor(d).middle;
			}
		}, {
			key: "yAccessorForBottom",
			value: function yAccessorForBottom(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && yAccessor(d).bottom;
			}
		}, {
			key: "yAccessorForScalledBottom",
			value: function yAccessorForScalledBottom(scale, d) {
				var yAccessor = this.props.yAccessor;
	
				return scale(yAccessor(d) && yAccessor(d).bottom);
			}
		}, {
			key: "render",
			value: function render() {
				var _props = this.props,
				    areaClassName = _props.areaClassName,
				    className = _props.className,
				    opacity = _props.opacity;
				var _props2 = this.props,
				    stroke = _props2.stroke,
				    fill = _props2.fill;
	
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					_react2.default.createElement(_LineSeries2.default, { yAccessor: this.yAccessorForTop,
						stroke: stroke.top, fill: "none" }),
					_react2.default.createElement(_LineSeries2.default, { yAccessor: this.yAccessorForMiddle,
						stroke: stroke.middle, fill: "none" }),
					_react2.default.createElement(_LineSeries2.default, { yAccessor: this.yAccessorForBottom,
						stroke: stroke.bottom, fill: "none" }),
					_react2.default.createElement(_AreaOnlySeries2.default, { className: areaClassName,
						yAccessor: this.yAccessorForTop,
						base: this.yAccessorForScalledBottom,
						stroke: "none", fill: fill,
						opacity: opacity })
				);
			}
		}]);
	
		return BollingerSeries;
	}(_react.Component);
	
	BollingerSeries.propTypes = {
		yAccessor: _propTypes2.default.func.isRequired,
		className: _propTypes2.default.string,
		areaClassName: _propTypes2.default.string,
		opacity: _propTypes2.default.number,
		type: _propTypes2.default.string,
		stroke: _propTypes2.default.shape({
			top: _propTypes2.default.string.isRequired,
			middle: _propTypes2.default.string.isRequired,
			bottom: _propTypes2.default.string.isRequired
		}).isRequired,
		fill: _propTypes2.default.string.isRequired
	};
	
	BollingerSeries.defaultProps = {
		className: "react-stockcharts-bollinger-band-series",
		areaClassName: "react-stockcharts-bollinger-band-series-area",
		opacity: 0.2
	};
	
	exports.default = BollingerSeries;
	//# sourceMappingURL=BollingerSeries.js.map

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Collection = __webpack_require__(38);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CandlestickSeries = function (_Component) {
		_inherits(CandlestickSeries, _Component);
	
		function CandlestickSeries(props) {
			_classCallCheck(this, CandlestickSeries);
	
			var _this = _possibleConstructorReturn(this, (CandlestickSeries.__proto__ || Object.getPrototypeOf(CandlestickSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(CandlestickSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				_drawOnCanvas(ctx, this.props, moreProps);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    className = _props.className,
				    wickClassName = _props.wickClassName,
				    candleClassName = _props.candleClassName;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData,
				    xAccessor = moreProps.xAccessor;
	
	
				var candleData = getCandleData(this.props, xAccessor, xScale, yScale, plotData);
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					_react2.default.createElement(
						"g",
						{ className: wickClassName, key: "wicks" },
						getWicksSVG(candleData)
					),
					_react2.default.createElement(
						"g",
						{ className: candleClassName, key: "candles" },
						getCandlesSVG(this.props, candleData)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var clip = this.props.clip;
	
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: clip,
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}]);
	
		return CandlestickSeries;
	}(_react.Component);
	
	CandlestickSeries.propTypes = {
		className: _propTypes2.default.string,
		wickClassName: _propTypes2.default.string,
		candleClassName: _propTypes2.default.string,
		widthRatio: _propTypes2.default.number,
		width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		classNames: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
		fill: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
		stroke: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
		wickStroke: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
		yAccessor: _propTypes2.default.func,
		clip: _propTypes2.default.bool
	};
	
	CandlestickSeries.defaultProps = {
		className: "react-stockcharts-candlestick",
		wickClassName: "react-stockcharts-candlestick-wick",
		candleClassName: "react-stockcharts-candlestick-candle",
		yAccessor: function yAccessor(d) {
			return { open: d.open, high: d.high, low: d.low, close: d.close };
		},
		classNames: function classNames(d) {
			return d.close > d.open ? "up" : "down";
		},
		width: _utils.plotDataLengthBarWidth,
		wickStroke: "#000000",
		// wickStroke: d => d.close > d.open ? "#6BA583" : "#FF0000",
		fill: function fill(d) {
			return d.close > d.open ? "#6BA583" : "#FF0000";
		},
		// stroke: d => d.close > d.open ? "#6BA583" : "#FF0000",
		stroke: "#000000",
		candleStrokeWidth: 0.5,
		// stroke: "none",
		widthRatio: 0.8,
		opacity: 0.5,
		clip: true
	};
	
	function getWicksSVG(candleData) {
	
		var wicks = candleData.map(function (each, idx) {
			var d = each.wick;
			return _react2.default.createElement("path", { key: idx,
				className: each.className,
				stroke: d.stroke,
				d: "M" + d.x + "," + d.y1 + " L" + d.x + "," + d.y2 + " M" + d.x + "," + d.y3 + " L" + d.x + "," + d.y4 });
		});
	
		return wicks;
	}
	
	function getCandlesSVG(props, candleData) {
	
		/* eslint-disable react/prop-types */
		var opacity = props.opacity,
		    candleStrokeWidth = props.candleStrokeWidth;
		/* eslint-enable react/prop-types */
	
		var candles = candleData.map(function (d, idx) {
			if (d.width <= 1) return _react2.default.createElement("line", { className: d.className, key: idx,
				x1: d.x, y1: d.y, x2: d.x, y2: d.y + d.height,
				stroke: d.fill });else if (d.height === 0) return _react2.default.createElement("line", { key: idx,
				x1: d.x, y1: d.y, x2: d.x + d.width, y2: d.y + d.height,
				stroke: d.fill });
			return _react2.default.createElement("rect", { key: idx, className: d.className,
				fillOpacity: opacity,
				x: d.x, y: d.y, width: d.width, height: d.height,
				fill: d.fill, stroke: d.stroke, strokeWidth: candleStrokeWidth });
		});
		return candles;
	}
	
	function _drawOnCanvas(ctx, props, moreProps) {
		var opacity = props.opacity,
		    candleStrokeWidth = props.candleStrokeWidth;
		var xScale = moreProps.xScale,
		    yScale = moreProps.chartConfig.yScale,
		    plotData = moreProps.plotData,
		    xAccessor = moreProps.xAccessor;
	
		// const wickData = getWickData(props, xAccessor, xScale, yScale, plotData);
	
		var candleData = getCandleData(props, xAccessor, xScale, yScale, plotData);
	
		var wickNest = (0, _d3Collection.nest)().key(function (d) {
			return d.wick.stroke;
		}).entries(candleData);
	
		wickNest.forEach(function (outer) {
			var key = outer.key,
			    values = outer.values;
	
			ctx.strokeStyle = key;
			ctx.fillStyle = key;
			values.forEach(function (each) {
				/*
	   ctx.moveTo(d.x, d.y1);
	   ctx.lineTo(d.x, d.y2);
	   	ctx.beginPath();
	   ctx.moveTo(d.x, d.y3);
	   ctx.lineTo(d.x, d.y4);
	   ctx.stroke(); */
				var d = each.wick;
	
				ctx.fillRect(d.x - 0.5, d.y1, 1, d.y2 - d.y1);
				ctx.fillRect(d.x - 0.5, d.y3, 1, d.y4 - d.y3);
			});
		});
	
		// const candleData = getCandleData(props, xAccessor, xScale, yScale, plotData);
	
		var candleNest = (0, _d3Collection.nest)().key(function (d) {
			return d.stroke;
		}).key(function (d) {
			return d.fill;
		}).entries(candleData);
	
		candleNest.forEach(function (outer) {
			var strokeKey = outer.key,
			    strokeValues = outer.values;
	
			if (strokeKey !== "none") {
				ctx.strokeStyle = strokeKey;
				ctx.lineWidth = candleStrokeWidth;
			}
			strokeValues.forEach(function (inner) {
				var key = inner.key,
				    values = inner.values;
	
				var fillStyle = (0, _utils.head)(values).width <= 1 ? key : (0, _utils.hexToRGBA)(key, opacity);
				ctx.fillStyle = fillStyle;
	
				values.forEach(function (d) {
					if (d.width <= 1) {
						// <line className={d.className} key={idx} x1={d.x} y1={d.y} x2={d.x} y2={d.y + d.height}/>
						/*
	     ctx.beginPath();
	     ctx.moveTo(d.x, d.y);
	     ctx.lineTo(d.x, d.y + d.height);
	     ctx.stroke();
	     */
						ctx.fillRect(d.x - 0.5, d.y, 1, d.height);
					} else if (d.height === 0) {
						// <line key={idx} x1={d.x} y1={d.y} x2={d.x + d.width} y2={d.y + d.height} />
						/*
	     ctx.beginPath();
	     ctx.moveTo(d.x, d.y);
	     ctx.lineTo(d.x + d.width, d.y + d.height);
	     ctx.stroke();
	     */
						ctx.fillRect(d.x, d.y - 0.5, d.width, 1);
					} else {
						/*
	     ctx.beginPath();
	     ctx.rect(d.x, d.y, d.width, d.height);
	     ctx.closePath();
	     ctx.fill();
	     if (strokeKey !== "none") ctx.stroke();
	     */
						ctx.fillRect(d.x, d.y, d.width, d.height);
						if (strokeKey !== "none") ctx.strokeRect(d.x, d.y, d.width, d.height);
					}
				});
			});
		});
	}
	/*
	function getWickData(props, xAccessor, xScale, yScale, plotData) {
	
		const { classNames: classNameProp, wickStroke: wickStrokeProp, yAccessor } = props;
		const wickStroke = functor(wickStrokeProp);
		const className = functor(classNameProp);
		const wickData = plotData
				.filter(d => isDefined(yAccessor(d).close))
				.map(d => {
					// console.log(yAccessor);
					const ohlc = yAccessor(d);
	
					const x = Math.round(xScale(xAccessor(d))),
						y1 = yScale(ohlc.high),
						y2 = yScale(Math.max(ohlc.open, ohlc.close)),
						y3 = yScale(Math.min(ohlc.open, ohlc.close)),
						y4 = yScale(ohlc.low);
	
					return {
						x,
						y1,
						y2,
						y3,
						y4,
						className: className(ohlc),
						direction: (ohlc.close - ohlc.open),
						stroke: wickStroke(ohlc),
					};
				});
		return wickData;
	}
	*/
	
	function getCandleData(props, xAccessor, xScale, yScale, plotData) {
		var wickStrokeProp = props.wickStroke;
	
		var wickStroke = (0, _utils.functor)(wickStrokeProp);
	
		var classNames = props.classNames,
		    fillProp = props.fill,
		    strokeProp = props.stroke,
		    yAccessor = props.yAccessor;
	
		var className = (0, _utils.functor)(classNames);
	
		var fill = (0, _utils.functor)(fillProp);
		var stroke = (0, _utils.functor)(strokeProp);
	
		var widthFunctor = (0, _utils.functor)(props.width);
		var width = widthFunctor(props, {
			xScale: xScale,
			xAccessor: xAccessor,
			plotData: plotData
		});
	
		/*
	 const candleWidth = Math.round(width);
	 const offset = Math.round(candleWidth === 1 ? 0 : 0.5 * width);
	 */
		var trueOffset = 0.5 * width;
		var offset = trueOffset > 0.7 ? Math.round(trueOffset) : Math.floor(trueOffset);
	
		// eslint-disable-next-line prefer-const
		var candles = [];
	
		for (var i = 0; i < plotData.length; i++) {
			var d = plotData[i];
			if ((0, _utils.isDefined)(yAccessor(d).close)) {
				var x = Math.round(xScale(xAccessor(d)));
				// const x = Math.round(xScale(xAccessor(d)) - offset);
	
				var ohlc = yAccessor(d);
				var y = Math.round(yScale(Math.max(ohlc.open, ohlc.close)));
				var height = Math.round(Math.abs(yScale(ohlc.open) - yScale(ohlc.close)));
	
				candles.push({
					// type: "line"
					x: x - offset,
					y: y,
					wick: {
						stroke: wickStroke(ohlc),
						x: x,
						y1: Math.round(yScale(ohlc.high)),
						y2: y,
						y3: y + height, // Math.round(yScale(Math.min(ohlc.open, ohlc.close))),
						y4: Math.round(yScale(ohlc.low))
					},
					height: height,
					width: offset * 2,
					className: className(ohlc),
					fill: fill(ohlc),
					stroke: stroke(ohlc),
					direction: ohlc.close - ohlc.open
				});
			}
		}
	
		return candles;
	}
	
	exports.default = CandlestickSeries;
	//# sourceMappingURL=CandlestickSeries.js.map

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Circle(props) {
		var className = props.className,
		    stroke = props.stroke,
		    strokeWidth = props.strokeWidth,
		    opacity = props.opacity,
		    fill = props.fill,
		    point = props.point,
		    r = props.r;
	
		var radius = (0, _utils.functor)(r)(point.datum);
		return _react2.default.createElement("circle", { className: className,
			cx: point.x, cy: point.y,
			stroke: stroke, strokeWidth: strokeWidth,
			fillOpacity: opacity, fill: fill, r: radius });
	}
	
	Circle.propTypes = {
		stroke: _propTypes2.default.string,
		fill: _propTypes2.default.string.isRequired,
		opacity: _propTypes2.default.number.isRequired,
		point: _propTypes2.default.shape({
			x: _propTypes2.default.number.isRequired,
			y: _propTypes2.default.number.isRequired,
			datum: _propTypes2.default.object.isRequired
		}).isRequired,
		className: _propTypes2.default.string,
		strokeWidth: _propTypes2.default.number,
		r: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired
	};
	
	Circle.defaultProps = {
		stroke: "#4682B4",
		strokeWidth: 1,
		opacity: 0.5,
		fill: "#4682B4",
		className: "react-stockcharts-marker-circle"
	};
	
	Circle.drawOnCanvas = function (props, point, ctx) {
		var stroke = props.stroke,
		    fill = props.fill,
		    opacity = props.opacity,
		    strokeWidth = props.strokeWidth;
	
	
		ctx.strokeStyle = stroke;
		ctx.lineWidth = strokeWidth;
	
		if (fill !== "none") {
			ctx.fillStyle = (0, _utils.hexToRGBA)(fill, opacity);
		}
	
		Circle.drawOnCanvasWithNoStateChange(props, point, ctx);
	};
	
	Circle.drawOnCanvasWithNoStateChange = function (props, point, ctx) {
		var r = props.r;
	
		var radius = (0, _utils.functor)(r)(point.datum);
	
		ctx.moveTo(point.x, point.y);
		ctx.beginPath();
		ctx.arc(point.x, point.y, radius, 0, 2 * Math.PI, false);
		ctx.stroke();
		ctx.fill();
	};
	
	exports.default = Circle;
	//# sourceMappingURL=CircleMarker.js.map

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _OverlayBarSeries = __webpack_require__(761);
	
	var _OverlayBarSeries2 = _interopRequireDefault(_OverlayBarSeries);
	
	var _StraightLine = __webpack_require__(95);
	
	var _StraightLine2 = _interopRequireDefault(_StraightLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ElderRaySeries = function (_Component) {
		_inherits(ElderRaySeries, _Component);
	
		function ElderRaySeries(props) {
			_classCallCheck(this, ElderRaySeries);
	
			var _this = _possibleConstructorReturn(this, (ElderRaySeries.__proto__ || Object.getPrototypeOf(ElderRaySeries)).call(this, props));
	
			_this.fillForEachBar = _this.fillForEachBar.bind(_this);
			_this.yAccessorTop = _this.yAccessorTop.bind(_this);
			_this.yAccessorBullTop = _this.yAccessorBullTop.bind(_this);
			_this.yAccessorBearTop = _this.yAccessorBearTop.bind(_this);
			_this.yAccessorBullBottom = _this.yAccessorBullBottom.bind(_this);
			_this.yAccessorBearBottom = _this.yAccessorBearBottom.bind(_this);
			_this.yAccessorForBarBase = _this.yAccessorForBarBase.bind(_this);
			return _this;
		}
	
		_createClass(ElderRaySeries, [{
			key: "yAccessorTop",
			value: function yAccessorTop(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && Math.max(yAccessor(d).bullPower, 0);
			}
		}, {
			key: "yAccessorBullTop",
			value: function yAccessorBullTop(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && (yAccessor(d).bullPower > 0 ? yAccessor(d).bullPower : undefined);
			}
		}, {
			key: "yAccessorBearTop",
			value: function yAccessorBearTop(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && (yAccessor(d).bearPower > 0 ? yAccessor(d).bearPower : undefined);
			}
		}, {
			key: "yAccessorBullBottom",
			value: function yAccessorBullBottom(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && (yAccessor(d).bullPower < 0 ? 0 : undefined);
			}
		}, {
			key: "yAccessorBearBottom",
			value: function yAccessorBearBottom(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && (yAccessor(d).bullPower < 0 || yAccessor(d).bullPower * yAccessor(d).bearPower < 0 // bullPower is +ve and bearPower is -ve
				? Math.min(0, yAccessor(d).bullPower) : undefined);
			}
		}, {
			key: "yAccessorForBarBase",
			value: function yAccessorForBarBase(xScale, yScale, d) {
				var yAccessor = this.props.yAccessor;
	
				var y = yAccessor(d) && Math.min(yAccessor(d).bearPower, 0);
				return yScale(y);
			}
		}, {
			key: "fillForEachBar",
			value: function fillForEachBar(d, yAccessorNumber) {
				var _props = this.props,
				    bullPowerFill = _props.bullPowerFill,
				    bearPowerFill = _props.bearPowerFill;
	
				return yAccessorNumber % 2 === 0 ? bullPowerFill : bearPowerFill;
			}
		}, {
			key: "render",
			value: function render() {
				var _props2 = this.props,
				    className = _props2.className,
				    opacity = _props2.opacity,
				    stroke = _props2.stroke,
				    straightLineStroke = _props2.straightLineStroke,
				    straightLineOpacity = _props2.straightLineOpacity,
				    widthRatio = _props2.widthRatio;
				var clip = this.props.clip;
	
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					_react2.default.createElement(_OverlayBarSeries2.default, {
						baseAt: this.yAccessorForBarBase,
						className: "react-stockcharts-elderray-bar",
						stroke: stroke,
						fill: this.fillForEachBar,
						opacity: opacity,
						widthRatio: widthRatio,
						clip: clip,
						yAccessor: [this.yAccessorBullTop, this.yAccessorBearTop, this.yAccessorBullBottom, this.yAccessorBearBottom] }),
					_react2.default.createElement(_StraightLine2.default, {
						className: "react-stockcharts-elderray-straight-line",
						yValue: 0,
						stroke: straightLineStroke,
						opacity: straightLineOpacity })
				);
			}
		}]);
	
		return ElderRaySeries;
	}(_react.Component);
	
	ElderRaySeries.propTypes = {
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func,
		opacity: _propTypes2.default.number,
		stroke: _propTypes2.default.bool,
		bullPowerFill: _propTypes2.default.string,
		bearPowerFill: _propTypes2.default.string,
		straightLineStroke: _propTypes2.default.string,
		straightLineOpacity: _propTypes2.default.number,
		widthRatio: _propTypes2.default.number,
		clip: _propTypes2.default.bool.isRequired
	};
	
	ElderRaySeries.defaultProps = {
		className: "react-stockcharts-elderray-series",
		straightLineStroke: "#000000",
		straightLineOpacity: 0.3,
		opacity: 0.5,
		stroke: true,
		bullPowerFill: "#6BA583",
		bearPowerFill: "#FF0000",
		widthRatio: 0.8,
		clip: true
	};
	
	exports.default = ElderRaySeries;
	//# sourceMappingURL=ElderRaySeries.js.map

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _StackedBarSeries = __webpack_require__(113);
	
	var _StackedBarSeries2 = _interopRequireDefault(_StackedBarSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupedBarSeries = function (_Component) {
		_inherits(GroupedBarSeries, _Component);
	
		function GroupedBarSeries(props) {
			_classCallCheck(this, GroupedBarSeries);
	
			var _this = _possibleConstructorReturn(this, (GroupedBarSeries.__proto__ || Object.getPrototypeOf(GroupedBarSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(GroupedBarSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var xAccessor = moreProps.xAccessor;
	
	
				(0, _StackedBarSeries.drawOnCanvasHelper)(ctx, this.props, moreProps, xAccessor, _StackedBarSeries.identityStack, postProcessor);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var xAccessor = moreProps.xAccessor;
	
	
				return _react2.default.createElement(
					"g",
					{ className: "react-stockcharts-grouped-bar-series" },
					(0, _StackedBarSeries.svgHelper)(this.props, moreProps, xAccessor, _StackedBarSeries.identityStack, postProcessor)
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}]);
	
		return GroupedBarSeries;
	}(_react.Component);
	
	GroupedBarSeries.propTypes = {
		baseAt: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
		direction: _propTypes2.default.oneOf(["up", "down"]).isRequired,
		stroke: _propTypes2.default.bool.isRequired,
		widthRatio: _propTypes2.default.number.isRequired,
		opacity: _propTypes2.default.number.isRequired,
		fill: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
		className: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
		yAccessor: _propTypes2.default.arrayOf(_propTypes2.default.func)
	};
	
	GroupedBarSeries.defaultProps = _extends({}, _StackedBarSeries2.default.defaultProps, {
		widthRatio: 0.8,
		spaceBetweenBar: 5
	});
	
	function postProcessor(array) {
		return array.map(function (each) {
			return _extends({}, each, {
				x: each.x + each.offset - each.groupOffset,
				width: each.groupWidth
			});
		});
	}
	
	exports.default = GroupedBarSeries;
	//# sourceMappingURL=GroupedBarSeries.js.map

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(99);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KagiSeries = function (_Component) {
		_inherits(KagiSeries, _Component);
	
		function KagiSeries(props) {
			_classCallCheck(this, KagiSeries);
	
			var _this = _possibleConstructorReturn(this, (KagiSeries.__proto__ || Object.getPrototypeOf(KagiSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(KagiSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var xAccessor = moreProps.xAccessor;
	
	
				_drawOnCanvas(ctx, this.props, moreProps, xAccessor);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					canvasDraw: this.drawOnCanvas,
					drawOn: ["pan"]
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData;
				var _props = this.props,
				    className = _props.className,
				    stroke = _props.stroke,
				    fill = _props.fill,
				    strokeWidth = _props.strokeWidth;
	
	
				var paths = helper(plotData, xAccessor).map(function (each, i) {
					var dataSeries = (0, _d3Shape.line)().x(function (item) {
						return xScale(item[0]);
					}).y(function (item) {
						return yScale(item[1]);
					}).curve(_d3Shape.curveStepBefore);
	
					dataSeries(each.plot);
	
					return _react2.default.createElement("path", { key: i, d: dataSeries(each.plot), className: each.type,
						stroke: stroke[each.type], fill: fill[each.type], strokeWidth: strokeWidth });
				});
				return _react2.default.createElement(
					"g",
					{ className: className },
					paths
				);
			}
		}]);
	
		return KagiSeries;
	}(_react.Component);
	
	KagiSeries.propTypes = {
		className: _propTypes2.default.string,
		stroke: _propTypes2.default.object,
		fill: _propTypes2.default.object,
		strokeWidth: _propTypes2.default.number.isRequired
	};
	
	KagiSeries.defaultProps = {
		className: "react-stockcharts-kagi",
		strokeWidth: 2,
		stroke: {
			yang: "#6BA583",
			yin: "#E60000"
		},
		fill: {
			yang: "none",
			yin: "none"
		},
		currentValueStroke: "#000000"
	};
	
	function _drawOnCanvas(ctx, props, moreProps, xAccessor) {
		var stroke = props.stroke,
		    strokeWidth = props.strokeWidth,
		    currentValueStroke = props.currentValueStroke;
		var xScale = moreProps.xScale,
		    yScale = moreProps.chartConfig.yScale,
		    plotData = moreProps.plotData;
	
	
		var paths = helper(plotData, xAccessor);
	
		var begin = true;
	
		paths.forEach(function (each) {
			ctx.strokeStyle = stroke[each.type];
			ctx.lineWidth = strokeWidth;
	
			ctx.beginPath();
			var prevX = void 0;
			each.plot.forEach(function (d) {
				var _ref = [xScale(d[0]), yScale(d[1])],
				    x = _ref[0],
				    y = _ref[1];
	
				if (begin) {
					ctx.moveTo(x, y);
					begin = false;
				} else {
					if ((0, _utils.isDefined)(prevX)) {
						ctx.lineTo(prevX, y);
					}
					ctx.lineTo(x, y);
				}
				prevX = x;
				// console.log(d);
			});
			ctx.stroke();
		});
		var lastPlot = paths[paths.length - 1].plot;
		var last = lastPlot[lastPlot.length - 1];
		ctx.beginPath();
		// ctx.strokeStyle = "black";
		ctx.lineWidth = 1;
	
		var _ref2 = [xScale(last[0]), yScale(last[2]), yScale(last[3])],
		    x = _ref2[0],
		    y1 = _ref2[1],
		    y2 = _ref2[2];
		// console.log(last, x, y);
	
		ctx.moveTo(x, y1);
		ctx.lineTo(x + 10, y1);
		ctx.stroke();
	
		ctx.beginPath();
		ctx.strokeStyle = currentValueStroke;
		ctx.moveTo(x - 10, y2);
		ctx.lineTo(x, y2);
		ctx.stroke();
	}
	
	function helper(plotData, xAccessor) {
		var kagiLine = [];
		var kagi = {};
		var d = plotData[0];
		var idx = xAccessor(d);
	
		for (var i = 0; i < plotData.length; i++) {
			d = plotData[i];
	
			if ((0, _utils.isNotDefined)(d.close)) continue;
			if ((0, _utils.isNotDefined)(kagi.type)) kagi.type = d.startAs;
			if ((0, _utils.isNotDefined)(kagi.plot)) kagi.plot = [];
	
			idx = xAccessor(d);
			kagi.plot.push([idx, d.open]);
	
			if ((0, _utils.isDefined)(d.changeTo)) {
				kagi.plot.push([idx, d.changePoint]);
				kagi.added = true;
				kagiLine.push(kagi);
	
				kagi = {
					type: d.changeTo,
					plot: [],
					added: false
				};
				kagi.plot.push([idx, d.changePoint]);
			}
		}
	
		if (!kagi.added) {
			kagi.plot.push([idx, d.close, d.current, d.reverseAt]);
			kagiLine.push(kagi);
		}
	
		// console.log(d.reverseAt);
	
		return kagiLine;
	}
	
	exports.default = KagiSeries;
	//# sourceMappingURL=KagiSeries.js.map

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BarSeries = __webpack_require__(402);
	
	var _BarSeries2 = _interopRequireDefault(_BarSeries);
	
	var _LineSeries = __webpack_require__(78);
	
	var _LineSeries2 = _interopRequireDefault(_LineSeries);
	
	var _StraightLine = __webpack_require__(95);
	
	var _StraightLine2 = _interopRequireDefault(_StraightLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MACDSeries = function (_Component) {
		_inherits(MACDSeries, _Component);
	
		function MACDSeries(props) {
			_classCallCheck(this, MACDSeries);
	
			var _this = _possibleConstructorReturn(this, (MACDSeries.__proto__ || Object.getPrototypeOf(MACDSeries)).call(this, props));
	
			_this.yAccessorForMACD = _this.yAccessorForMACD.bind(_this);
			_this.yAccessorForSignal = _this.yAccessorForSignal.bind(_this);
			_this.yAccessorForDivergence = _this.yAccessorForDivergence.bind(_this);
			_this.yAccessorForDivergenceBase = _this.yAccessorForDivergenceBase.bind(_this);
			return _this;
		}
	
		_createClass(MACDSeries, [{
			key: "yAccessorForMACD",
			value: function yAccessorForMACD(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && yAccessor(d).macd;
			}
		}, {
			key: "yAccessorForSignal",
			value: function yAccessorForSignal(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && yAccessor(d).signal;
			}
		}, {
			key: "yAccessorForDivergence",
			value: function yAccessorForDivergence(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && yAccessor(d).divergence;
			}
		}, {
			key: "yAccessorForDivergenceBase",
			value: function yAccessorForDivergenceBase(xScale, yScale /* , d */) {
				return yScale(0);
			}
		}, {
			key: "render",
			value: function render() {
				var _props = this.props,
				    className = _props.className,
				    opacity = _props.opacity,
				    divergenceStroke = _props.divergenceStroke,
				    widthRatio = _props.widthRatio,
				    width = _props.width;
				var _props2 = this.props,
				    stroke = _props2.stroke,
				    fill = _props2.fill;
				var clip = this.props.clip;
				var _props3 = this.props,
				    zeroLineStroke = _props3.zeroLineStroke,
				    zeroLineOpacity = _props3.zeroLineOpacity;
	
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					_react2.default.createElement(_BarSeries2.default, {
						baseAt: this.yAccessorForDivergenceBase,
						className: "macd-divergence",
						width: width,
						widthRatio: widthRatio,
						stroke: divergenceStroke,
						fill: fill.divergence,
						opacity: opacity,
						clip: clip,
						yAccessor: this.yAccessorForDivergence }),
					_react2.default.createElement(_LineSeries2.default, {
						yAccessor: this.yAccessorForMACD,
						stroke: stroke.macd,
						fill: "none" }),
					_react2.default.createElement(_LineSeries2.default, {
						yAccessor: this.yAccessorForSignal,
						stroke: stroke.signal,
						fill: "none" }),
					_react2.default.createElement(_StraightLine2.default, {
						stroke: zeroLineStroke,
						opacity: zeroLineOpacity,
						yValue: 0 })
				);
			}
		}]);
	
		return MACDSeries;
	}(_react.Component);
	
	MACDSeries.propTypes = {
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func.isRequired,
		opacity: _propTypes2.default.number,
		divergenceStroke: _propTypes2.default.bool,
		zeroLineStroke: _propTypes2.default.string,
		zeroLineOpacity: _propTypes2.default.number,
		clip: _propTypes2.default.bool.isRequired,
		stroke: _propTypes2.default.shape({
			macd: _propTypes2.default.string.isRequired,
			signal: _propTypes2.default.string.isRequired
		}).isRequired,
		fill: _propTypes2.default.shape({
			divergence: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
		}).isRequired,
		widthRatio: _propTypes2.default.number,
		width: _BarSeries2.default.propTypes.width
	};
	
	MACDSeries.defaultProps = {
		className: "react-stockcharts-macd-series",
		zeroLineStroke: "#000000",
		zeroLineOpacity: 0.3,
		opacity: 0.6,
		divergenceStroke: false,
		clip: true,
		widthRatio: 0.5,
		width: _BarSeries2.default.defaultProps.width
	};
	
	exports.default = MACDSeries;
	//# sourceMappingURL=MACDSeries.js.map

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Collection = __webpack_require__(38);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OHLCSeries = function (_Component) {
		_inherits(OHLCSeries, _Component);
	
		function OHLCSeries(props) {
			_classCallCheck(this, OHLCSeries);
	
			var _this = _possibleConstructorReturn(this, (OHLCSeries.__proto__ || Object.getPrototypeOf(OHLCSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(OHLCSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var yAccessor = this.props.yAccessor;
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData;
	
	
				var barData = getOHLCBars(this.props, xAccessor, yAccessor, xScale, yScale, plotData);
				_drawOnCanvas(ctx, barData);
			}
		}, {
			key: "render",
			value: function render() {
				var clip = this.props.clip;
	
	
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					canvasDraw: this.drawOnCanvas,
					clip: clip,
					drawOn: ["pan"]
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    className = _props.className,
				    yAccessor = _props.yAccessor;
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData;
	
	
				var barData = getOHLCBars(this.props, xAccessor, yAccessor, xScale, yScale, plotData);
	
				var strokeWidth = barData.strokeWidth,
				    bars = barData.bars;
	
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					bars.map(function (d, idx) {
						return _react2.default.createElement("path", { key: idx,
							className: d.className, stroke: d.stroke, strokeWidth: strokeWidth,
							d: "M" + d.openX1 + " " + d.openY + " L" + d.openX2 + " " + d.openY + " M" + d.x + " " + d.y1 + " L" + d.x + " " + d.y2 + " M" + d.closeX1 + " " + d.closeY + " L" + d.closeX2 + " " + d.closeY });
					})
				);
			}
		}]);
	
		return OHLCSeries;
	}(_react.Component);
	
	OHLCSeries.propTypes = {
		className: _propTypes2.default.string,
		classNames: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
		stroke: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
		yAccessor: _propTypes2.default.func.isRequired,
		clip: _propTypes2.default.bool.isRequired
	};
	
	OHLCSeries.defaultProps = {
		className: "react-stockcharts-ohlc",
		yAccessor: function yAccessor(d) {
			return { open: d.open, high: d.high, low: d.low, close: d.close };
		},
		classNames: function classNames(d) {
			return (0, _utils.isDefined)(d.absoluteChange) ? d.absoluteChange > 0 ? "up" : "down" : "firstbar";
		},
		stroke: function stroke(d) {
			return (0, _utils.isDefined)(d.absoluteChange) ? d.absoluteChange > 0 ? "#6BA583" : "#FF0000" : "#000000";
		},
		clip: true
	};
	
	function _drawOnCanvas(ctx, barData) {
		var strokeWidth = barData.strokeWidth,
		    bars = barData.bars;
	
	
		var wickNest = (0, _d3Collection.nest)().key(function (d) {
			return d.stroke;
		}).entries(bars);
	
		ctx.lineWidth = strokeWidth;
	
		wickNest.forEach(function (outer) {
			var key = outer.key,
			    values = outer.values;
	
			ctx.strokeStyle = key;
			values.forEach(function (d) {
				ctx.beginPath();
				ctx.moveTo(d.x, d.y1);
				ctx.lineTo(d.x, d.y2);
	
				ctx.moveTo(d.openX1, d.openY);
				ctx.lineTo(d.openX2, d.openY);
	
				ctx.moveTo(d.closeX1, d.closeY);
				ctx.lineTo(d.closeX2, d.closeY);
	
				ctx.stroke();
			});
		});
	}
	
	function getOHLCBars(props, xAccessor, yAccessor, xScale, yScale, plotData) {
		var classNamesProp = props.classNames,
		    strokeProp = props.stroke;
	
	
		var strokeFunc = (0, _utils.functor)(strokeProp);
		var classNameFunc = (0, _utils.functor)(classNamesProp);
	
		var width = xScale(xAccessor(plotData[plotData.length - 1])) - xScale(xAccessor(plotData[0]));
	
		var barWidth = Math.max(1, Math.round(width / (plotData.length - 1) / 2) - 1.5);
		var strokeWidth = Math.min(barWidth, 6);
	
		var bars = plotData.filter(function (d) {
			return (0, _utils.isDefined)(yAccessor(d).close);
		}).map(function (d) {
			var ohlc = yAccessor(d),
			    x = Math.round(xScale(xAccessor(d))),
			    y1 = yScale(ohlc.high),
			    y2 = yScale(ohlc.low),
			    openX1 = x - barWidth,
			    openX2 = x + strokeWidth / 2,
			    openY = yScale(ohlc.open),
			    closeX1 = x - strokeWidth / 2,
			    closeX2 = x + barWidth,
			    closeY = yScale(ohlc.close),
			    className = classNameFunc(d),
			    stroke = strokeFunc(d);
	
			return { x: x, y1: y1, y2: y2, openX1: openX1, openX2: openX2, openY: openY, closeX1: closeX1, closeX2: closeX2, closeY: closeY, stroke: stroke, className: className };
		});
		return { barWidth: barWidth, strokeWidth: strokeWidth, bars: bars };
	}
	
	exports.default = OHLCSeries;
	//# sourceMappingURL=OHLCSeries.js.map

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Array = __webpack_require__(21);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _StackedBarSeries = __webpack_require__(113);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverlayBarSeries = function (_Component) {
		_inherits(OverlayBarSeries, _Component);
	
		function OverlayBarSeries(props) {
			_classCallCheck(this, OverlayBarSeries);
	
			var _this = _possibleConstructorReturn(this, (OverlayBarSeries.__proto__ || Object.getPrototypeOf(OverlayBarSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(OverlayBarSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var yAccessor = this.props.yAccessor;
	
				var bars = getBars(this.props, moreProps, yAccessor);
	
				(0, _StackedBarSeries.drawOnCanvas2)(this.props, ctx, bars);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var yAccessor = this.props.yAccessor;
	
	
				var bars = getBars(this.props, moreProps, yAccessor);
				return _react2.default.createElement(
					"g",
					{ className: "react-stockcharts-bar-series" },
					(0, _StackedBarSeries.getBarsSVG2)(this.props, bars)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var clip = this.props.clip;
	
	
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					canvasDraw: this.drawOnCanvas,
					clip: clip,
					drawOn: ["pan"]
				});
			}
		}]);
	
		return OverlayBarSeries;
	}(_react.Component);
	
	OverlayBarSeries.propTypes = {
		baseAt: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
		direction: _propTypes2.default.oneOf(["up", "down"]).isRequired,
		stroke: _propTypes2.default.bool.isRequired,
		widthRatio: _propTypes2.default.number.isRequired,
		opacity: _propTypes2.default.number.isRequired,
		fill: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
		className: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
		xAccessor: _propTypes2.default.func,
		yAccessor: _propTypes2.default.arrayOf(_propTypes2.default.func),
		xScale: _propTypes2.default.func,
		yScale: _propTypes2.default.func,
		plotData: _propTypes2.default.array,
		clip: _propTypes2.default.bool.isRequired
	};
	
	OverlayBarSeries.defaultProps = {
		baseAt: function baseAt(xScale, yScale /* , d*/) {
			return (0, _utils.first)(yScale.range());
		},
		direction: "up",
		className: "bar",
		stroke: false,
		fill: "#4682B4",
		opacity: 1,
		widthRatio: 0.5,
		width: _utils.plotDataLengthBarWidth,
		clip: true
	};
	
	function getBars(props, moreProps, yAccessor) {
		var xScale = moreProps.xScale,
		    xAccessor = moreProps.xAccessor,
		    yScale = moreProps.chartConfig.yScale,
		    plotData = moreProps.plotData;
		var baseAt = props.baseAt,
		    className = props.className,
		    fill = props.fill,
		    stroke = props.stroke;
	
	
		var getClassName = (0, _utils.functor)(className);
		var getFill = (0, _utils.functor)(fill);
		var getBase = (0, _utils.functor)(baseAt);
		var widthFunctor = (0, _utils.functor)(props.width);
	
		var width = widthFunctor(props, moreProps);
		var offset = Math.floor(0.5 * width);
	
		// console.log(xScale.domain(), yScale.domain());
	
		var bars = plotData.map(function (d) {
			// eslint-disable-next-line prefer-const
			var innerBars = yAccessor.map(function (eachYAccessor, i) {
				var yValue = eachYAccessor(d);
				if ((0, _utils.isNotDefined)(yValue)) return undefined;
	
				var xValue = xAccessor(d);
				var x = Math.round(xScale(xValue)) - offset;
				var y = yScale(yValue);
				// console.log(yValue, y, xValue, x)
				return {
					width: offset * 2,
					x: x,
					y: y,
					className: getClassName(d, i),
					stroke: stroke ? getFill(d, i) : "none",
					fill: getFill(d, i),
					i: i
				};
			}).filter(function (yValue) {
				return (0, _utils.isDefined)(yValue);
			});
	
			var b = getBase(xScale, yScale, d);
			var h = void 0;
			for (var i = innerBars.length - 1; i >= 0; i--) {
				h = b - innerBars[i].y;
				if (h < 0) {
					innerBars[i].y = b;
					h = -1 * h;
				}
				innerBars[i].height = h;
				b = innerBars[i].y;
			}
			return innerBars;
		});
	
		return (0, _d3Array.merge)(bars);
	}
	
	exports.default = OverlayBarSeries;
	//# sourceMappingURL=OverlayBarSeries.js.map

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointAndFigureSeries = function (_Component) {
		_inherits(PointAndFigureSeries, _Component);
	
		function PointAndFigureSeries(props) {
			_classCallCheck(this, PointAndFigureSeries);
	
			var _this = _possibleConstructorReturn(this, (PointAndFigureSeries.__proto__ || Object.getPrototypeOf(PointAndFigureSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(PointAndFigureSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData;
	
				var columns = getColumns(xScale, xAccessor, yScale, plotData);
	
				_drawOnCanvas(ctx, this.props, columns);
			}
		}, {
			key: "render",
			value: function render() {
				var clip = this.props.clip;
	
	
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: clip,
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData;
				var _props = this.props,
				    stroke = _props.stroke,
				    fill = _props.fill,
				    strokeWidth = _props.strokeWidth,
				    className = _props.className;
	
	
				var columns = getColumns(xScale, xAccessor, yScale, plotData);
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					columns.map(function (col, idx) {
						return _react2.default.createElement(
							"g",
							{ key: idx, className: col.className, transform: "translate(" + col.offset[0] + ", " + col.offset[1] + ")" },
							col.boxes.map(function (box, i) {
								if (col.direction > 0) {
									return _react2.default.createElement(
										"g",
										{ key: idx + "-" + i },
										_react2.default.createElement("line", { className: "up", strokeWidth: strokeWidth, stroke: stroke.up, fill: fill.up,
											x1: 0, y1: box.open, x2: box.columnWidth, y2: box.close }),
										_react2.default.createElement("line", { className: "up", strokeWidth: strokeWidth, stroke: stroke.up, fill: fill.up,
											x1: 0, y1: box.close, x2: box.columnWidth, y2: box.open })
									);
								}
								return _react2.default.createElement("ellipse", { key: idx + "-" + i,
									className: "down", strokeWidth: strokeWidth, stroke: stroke.down, fill: fill.down,
									cx: box.columnWidth / 2, cy: (box.open + box.close) / 2,
									rx: box.columnWidth / 2, ry: box.boxHeight / 2 });
							})
						);
					})
				);
			}
		}]);
	
		return PointAndFigureSeries;
	}(_react.Component);
	
	PointAndFigureSeries.propTypes = {
		className: _propTypes2.default.string,
		strokeWidth: _propTypes2.default.number.isRequired,
		stroke: _propTypes2.default.object.isRequired,
		fill: _propTypes2.default.object.isRequired,
		clip: _propTypes2.default.bool.isRequired
	};
	
	PointAndFigureSeries.defaultProps = {
		className: "react-stockcharts-point-and-figure",
		strokeWidth: 1,
		stroke: {
			up: "#6BA583",
			down: "#FF0000"
		},
		fill: {
			up: "none",
			down: "none"
		},
		clip: true
	};
	
	function _drawOnCanvas(ctx, props, columns) {
		var stroke = props.stroke,
		    fill = props.fill,
		    strokeWidth = props.strokeWidth;
	
	
		ctx.lineWidth = strokeWidth;
	
		columns.forEach(function (col) {
			var _col$offset = _slicedToArray(col.offset, 2),
			    offsetX = _col$offset[0],
			    offsetY = _col$offset[1];
	
			col.boxes.forEach(function (box) {
				if (col.direction > 0) {
					ctx.fillStyle = fill.up;
					ctx.strokeStyle = stroke.up;
	
					ctx.beginPath();
	
					ctx.moveTo(offsetX, offsetY + box.open);
					ctx.lineTo(offsetX + box.columnWidth, offsetY + box.close);
					ctx.moveTo(offsetX, offsetY + box.close);
					ctx.lineTo(offsetX + box.columnWidth, offsetY + box.open);
	
					ctx.stroke();
				} else {
					ctx.fillStyle = fill.down;
					ctx.strokeStyle = stroke.down;
	
					ctx.beginPath();
	
					var x = offsetX + box.columnWidth / 2,
					    y = offsetY + box.open + box.boxHeight / 2;
					var rx = box.columnWidth / 2,
					    ry = box.boxHeight / 2;
	
	
					ctx.ellipse(x, y, rx, ry, 0, 0, 2 * Math.PI);
					ctx.stroke();
				}
			});
		});
	
		ctx.stroke();
	}
	
	function getColumns(xScale, xAccessor, yScale, plotData) {
	
		var width = xScale(xAccessor(plotData[plotData.length - 1])) - xScale(xAccessor(plotData[0]));
	
		var columnWidth = width / (plotData.length - 1);
	
		var anyBox = void 0,
		    j = 0;
		while ((0, _utils.isNotDefined)(anyBox)) {
			if ((0, _utils.isDefined)(plotData[j].close)) {
				anyBox = plotData[j].boxes[0];
			} else {
				break;
			}
			j++;
		}
	
		var boxHeight = Math.abs(yScale(anyBox.open) - yScale(anyBox.close));
	
		var columns = plotData.filter(function (d) {
			return (0, _utils.isDefined)(d.close);
		}).map(function (d) {
			var boxes = d.boxes.map(function (box) {
				return {
					columnWidth: columnWidth,
					boxHeight: boxHeight,
					open: yScale(box.open),
					close: yScale(box.close)
				};
			});
	
			var xOffset = xScale(xAccessor(d)) - columnWidth / 2;
			return {
				boxes: boxes,
				direction: d.direction,
				offset: [xOffset, 0]
			};
		});
		return columns;
	}
	
	exports.default = PointAndFigureSeries;
	//# sourceMappingURL=PointAndFigureSeries.js.map

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LineSeries = __webpack_require__(78);
	
	var _LineSeries2 = _interopRequireDefault(_LineSeries);
	
	var _StraightLine = __webpack_require__(95);
	
	var _StraightLine2 = _interopRequireDefault(_StraightLine);
	
	var _SVGComponent = __webpack_require__(403);
	
	var _SVGComponent2 = _interopRequireDefault(_SVGComponent);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import AreaSeries from "./AreaSeries";
	
	
	var RSISeries = function (_Component) {
		_inherits(RSISeries, _Component);
	
		function RSISeries(props) {
			_classCallCheck(this, RSISeries);
	
			var _this = _possibleConstructorReturn(this, (RSISeries.__proto__ || Object.getPrototypeOf(RSISeries)).call(this, props));
	
			_this.renderClip = _this.renderClip.bind(_this);
			_this.topAndBottomClip = _this.topAndBottomClip.bind(_this);
			_this.mainClip = _this.mainClip.bind(_this);
	
			var id1 = String(Math.round(Math.random() * 10000 * 10000));
			_this.clipPathId1 = "rsi-clip-" + id1;
	
			var id2 = String(Math.round(Math.random() * 10000 * 10000));
			_this.clipPathId2 = "rsi-clip-" + id2;
			return _this;
		}
	
		_createClass(RSISeries, [{
			key: "topAndBottomClip",
			value: function topAndBottomClip(ctx, moreProps) {
				var chartConfig = moreProps.chartConfig;
				var _props = this.props,
				    overSold = _props.overSold,
				    overBought = _props.overBought;
				var yScale = chartConfig.yScale,
				    width = chartConfig.width;
	
	
				ctx.beginPath();
				ctx.rect(0, yScale(overSold), width, yScale(overBought) - yScale(overSold));
				ctx.clip();
			}
		}, {
			key: "mainClip",
			value: function mainClip(ctx, moreProps) {
				var chartConfig = moreProps.chartConfig;
				var _props2 = this.props,
				    overSold = _props2.overSold,
				    overBought = _props2.overBought;
				var yScale = chartConfig.yScale,
				    width = chartConfig.width,
				    height = chartConfig.height;
	
	
				ctx.beginPath();
				ctx.rect(0, 0, width, yScale(overSold));
				ctx.rect(0, yScale(overBought), width, height - yScale(overBought));
				ctx.clip();
			}
		}, {
			key: "renderClip",
			value: function renderClip(moreProps) {
				var chartConfig = moreProps.chartConfig;
				var _props3 = this.props,
				    overSold = _props3.overSold,
				    overBought = _props3.overBought;
				var yScale = chartConfig.yScale,
				    width = chartConfig.width,
				    height = chartConfig.height;
	
	
				return _react2.default.createElement(
					"defs",
					null,
					_react2.default.createElement(
						"clipPath",
						{ id: this.clipPathId1 },
						_react2.default.createElement("rect", {
							x: 0,
							y: yScale(overSold),
							width: width,
							height: yScale(overBought) - yScale(overSold)
						})
					),
					_react2.default.createElement(
						"clipPath",
						{ id: this.clipPathId2 },
						_react2.default.createElement("rect", {
							x: 0,
							y: 0,
							width: width,
							height: yScale(overSold)
						}),
						_react2.default.createElement("rect", {
							x: 0,
							y: yScale(overBought),
							width: width,
							height: height - yScale(overBought)
						})
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _props4 = this.props,
				    className = _props4.className,
				    stroke = _props4.stroke,
				    opacity = _props4.opacity,
				    strokeDasharray = _props4.strokeDasharray,
				    strokeWidth = _props4.strokeWidth;
				var yAccessor = this.props.yAccessor;
				var _props5 = this.props,
				    overSold = _props5.overSold,
				    middle = _props5.middle,
				    overBought = _props5.overBought;
	
	
				var style1 = { "clipPath": "url(#" + this.clipPathId1 + ")" };
				var style2 = { "clipPath": "url(#" + this.clipPathId2 + ")" };
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					_react2.default.createElement(
						_SVGComponent2.default,
						null,
						this.renderClip
					),
					_react2.default.createElement(_StraightLine2.default, {
						stroke: stroke.top,
						opacity: opacity.top,
						yValue: overSold,
						strokeDasharray: strokeDasharray.top,
						strokeWidth: strokeWidth.top
					}),
					_react2.default.createElement(_StraightLine2.default, {
						stroke: stroke.middle,
						opacity: opacity.middle,
						yValue: middle,
						strokeDasharray: strokeDasharray.middle,
						strokeWidth: strokeWidth.middle
					}),
					_react2.default.createElement(_StraightLine2.default, {
						stroke: stroke.bottom,
						opacity: opacity.bottom,
						yValue: overBought,
						strokeDasharray: strokeDasharray.bottom,
						strokeWidth: strokeWidth.bottom
					}),
					_react2.default.createElement(_LineSeries2.default, {
						style: style1,
						canvasClip: this.topAndBottomClip,
	
						className: className,
						yAccessor: yAccessor,
						stroke: stroke.insideThreshold || stroke.line,
						strokeWidth: strokeWidth.insideThreshold,
						strokeDasharray: strokeDasharray.line
					}),
					_react2.default.createElement(_LineSeries2.default, {
						style: style2,
						canvasClip: this.mainClip
						/* baseAt={yScale => yScale(middle)} */
						, className: className,
						yAccessor: yAccessor,
						stroke: stroke.outsideThreshold || stroke.line,
						strokeWidth: strokeWidth.outsideThreshold,
						strokeDasharray: strokeDasharray.line
						/* fill={stroke.outsideThreshold || stroke.line} */
					})
				);
			}
		}]);
	
		return RSISeries;
	}(_react.Component);
	
	RSISeries.propTypes = {
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func.isRequired,
		stroke: _propTypes2.default.shape({
			top: _propTypes2.default.string.isRequired,
			middle: _propTypes2.default.string.isRequired,
			bottom: _propTypes2.default.string.isRequired,
			outsideThreshold: _propTypes2.default.string.isRequired,
			insideThreshold: _propTypes2.default.string.isRequired
		}).isRequired,
		opacity: _propTypes2.default.shape({
			top: _propTypes2.default.number.isRequired,
			middle: _propTypes2.default.number.isRequired,
			bottom: _propTypes2.default.number.isRequired
		}).isRequired,
		strokeDasharray: _propTypes2.default.shape({
			line: _propTypes2.default.oneOf(_utils.strokeDashTypes),
			top: _propTypes2.default.oneOf(_utils.strokeDashTypes),
			middle: _propTypes2.default.oneOf(_utils.strokeDashTypes),
			bottom: _propTypes2.default.oneOf(_utils.strokeDashTypes)
		}).isRequired,
		strokeWidth: _propTypes2.default.shape({
			outsideThreshold: _propTypes2.default.number.isRequired,
			insideThreshold: _propTypes2.default.number.isRequired,
			top: _propTypes2.default.number.isRequired,
			middle: _propTypes2.default.number.isRequired,
			bottom: _propTypes2.default.number.isRequired
		}).isRequired,
		overSold: _propTypes2.default.number.isRequired,
		middle: _propTypes2.default.number.isRequired,
		overBought: _propTypes2.default.number.isRequired
	};
	
	RSISeries.defaultProps = {
		className: "react-stockcharts-rsi-series",
		stroke: {
			line: "#000000",
			top: "#B8C2CC",
			middle: "#8795A1",
			bottom: "#B8C2CC",
			outsideThreshold: "#b300b3",
			insideThreshold: "#ffccff"
		},
		opacity: {
			top: 1,
			middle: 1,
			bottom: 1
		},
		strokeDasharray: {
			line: "Solid",
			top: "ShortDash",
			middle: "ShortDash",
			bottom: "ShortDash"
		},
		strokeWidth: {
			outsideThreshold: 1,
			insideThreshold: 1,
			top: 1,
			middle: 1,
			bottom: 1
		},
		overSold: 70,
		middle: 50,
		overBought: 30
	};
	
	exports.default = RSISeries;
	//# sourceMappingURL=RSISeries.js.map

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RenkoSeries = function (_Component) {
		_inherits(RenkoSeries, _Component);
	
		function RenkoSeries(props) {
			_classCallCheck(this, RenkoSeries);
	
			var _this = _possibleConstructorReturn(this, (RenkoSeries.__proto__ || Object.getPrototypeOf(RenkoSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(RenkoSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData;
				var yAccessor = this.props.yAccessor;
	
	
				var candles = getRenko(this.props, plotData, xScale, xAccessor, yScale, yAccessor);
	
				_drawOnCanvas(ctx, candles);
			}
		}, {
			key: "render",
			value: function render() {
				var clip = this.props.clip;
	
	
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: clip,
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var xAccessor = moreProps.xAccessor;
				var xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    plotData = moreProps.plotData;
				var yAccessor = this.props.yAccessor;
	
	
				var candles = getRenko(this.props, plotData, xScale, xAccessor, yScale, yAccessor).map(function (each, idx) {
					return _react2.default.createElement("rect", { key: idx, className: each.className,
						fill: each.fill,
						x: each.x,
						y: each.y,
						width: each.width,
						height: each.height });
				});
	
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement(
						"g",
						{ className: "candle" },
						candles
					)
				);
			}
		}]);
	
		return RenkoSeries;
	}(_react.Component);
	
	RenkoSeries.propTypes = {
		classNames: _propTypes2.default.shape({
			up: _propTypes2.default.string,
			down: _propTypes2.default.string
		}),
		stroke: _propTypes2.default.shape({
			up: _propTypes2.default.string,
			down: _propTypes2.default.string
		}),
		fill: _propTypes2.default.shape({
			up: _propTypes2.default.string,
			down: _propTypes2.default.string,
			partial: _propTypes2.default.string
		}),
		yAccessor: _propTypes2.default.func.isRequired,
		clip: _propTypes2.default.bool.isRequired
	};
	
	RenkoSeries.defaultProps = {
		classNames: {
			up: "up",
			down: "down"
		},
		stroke: {
			up: "none",
			down: "none"
		},
		fill: {
			up: "#6BA583",
			down: "#E60000",
			partial: "#4682B4"
		},
		yAccessor: function yAccessor(d) {
			return { open: d.open, high: d.high, low: d.low, close: d.close };
		},
		clip: true
	};
	
	function _drawOnCanvas(ctx, renko) {
		renko.forEach(function (d) {
			ctx.beginPath();
	
			ctx.strokeStyle = d.stroke;
			ctx.fillStyle = d.fill;
	
			ctx.rect(d.x, d.y, d.width, d.height);
			ctx.closePath();
			ctx.fill();
		});
	}
	
	function getRenko(props, plotData, xScale, xAccessor, yScale, yAccessor) {
		var classNames = props.classNames,
		    fill = props.fill;
	
		var width = xScale(xAccessor(plotData[plotData.length - 1])) - xScale(xAccessor(plotData[0]));
	
		var candleWidth = width / (plotData.length - 1);
		var candles = plotData.filter(function (d) {
			return (0, _utils.isDefined)(yAccessor(d).close);
		}).map(function (d) {
			var ohlc = yAccessor(d);
			var x = xScale(xAccessor(d)) - 0.5 * candleWidth,
			    y = yScale(Math.max(ohlc.open, ohlc.close)),
			    height = Math.abs(yScale(ohlc.open) - yScale(ohlc.close)),
			    className = ohlc.open <= ohlc.close ? classNames.up : classNames.down;
	
			var svgfill = d.fullyFormed ? ohlc.open <= ohlc.close ? fill.up : fill.down : fill.partial;
	
			return {
				className: className,
				fill: svgfill,
				x: x,
				y: y,
				height: height,
				width: candleWidth
			};
		});
		return candles;
	}
	
	exports.default = RenkoSeries;
	//# sourceMappingURL=RenkoSeries.js.map

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SARSeries = function (_Component) {
		_inherits(SARSeries, _Component);
	
		function SARSeries(props) {
			_classCallCheck(this, SARSeries);
	
			var _this = _possibleConstructorReturn(this, (SARSeries.__proto__ || Object.getPrototypeOf(SARSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			_this.isHover = _this.isHover.bind(_this);
			return _this;
		}
	
		_createClass(SARSeries, [{
			key: "isHover",
			value: function isHover(moreProps) {
				var mouseXY = moreProps.mouseXY,
				    currentItem = moreProps.currentItem,
				    yScale = moreProps.chartConfig.yScale;
				var yAccessor = this.props.yAccessor;
	
				var y = mouseXY[1];
				var currentY = yScale(yAccessor(currentItem));
				return y < currentY + 5 && y > currentY - 5;
			}
		}, {
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var _props = this.props,
				    yAccessor = _props.yAccessor,
				    fill = _props.fill,
				    opacity = _props.opacity;
				var xAccessor = moreProps.xAccessor,
				    plotData = moreProps.plotData,
				    xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale,
				    hovering = moreProps.hovering;
	
	
				var width = xScale(xAccessor((0, _utils.last)(plotData))) - xScale(xAccessor((0, _utils.first)(plotData)));
	
				var d = width / plotData.length * 0.5 / 2;
				var radius = Math.min(2, Math.max(0.5, d)) + (hovering ? 2 : 0);
	
				plotData.forEach(function (each) {
					var centerX = xScale(xAccessor(each));
					var centerY = yScale(yAccessor(each));
					var color = yAccessor(each) > each.close ? fill.falling : fill.rising;
	
					ctx.fillStyle = (0, _utils.hexToRGBA)(color, opacity);
					ctx.strokeStyle = color;
	
					ctx.beginPath();
					ctx.ellipse(centerX, centerY, radius, radius, 0, 0, 2 * Math.PI);
					ctx.closePath();
					ctx.fill();
					ctx.stroke();
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props2 = this.props,
				    className = _props2.className,
				    yAccessor = _props2.yAccessor;
				var xAccessor = moreProps.xAccessor,
				    plotData = moreProps.plotData,
				    xScale = moreProps.xScale,
				    yScale = moreProps.chartConfig.yScale;
				// console.log(moreProps);
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					plotData.filter(function (each) {
						return (0, _utils.isDefined)(yAccessor(each));
					}).map(function (each, idx) {
						return _react2.default.createElement("circle", { key: idx, cx: xScale(xAccessor(each)),
							cy: yScale(yAccessor(each)), r: 3, fill: "green" });
					})
				);
			}
		}, {
			key: "render",
			value: function render() {
				var highlightOnHover = this.props.highlightOnHover;
	
				var hoverProps = highlightOnHover ? {
					isHover: this.isHover,
					drawOn: ["mousemove", "pan"],
					canvasToDraw: _GenericComponent.getMouseCanvas
				} : {
					drawOn: ["pan"],
					canvasToDraw: _GenericComponent.getAxisCanvas
				};
	
				return _react2.default.createElement(_GenericChartComponent2.default, _extends({
					svgDraw: this.renderSVG,
	
					canvasDraw: this.drawOnCanvas,
	
					onClickWhenHover: this.props.onClick,
					onDoubleClickWhenHover: this.props.onDoubleClick,
					onContextMenuWhenHover: this.props.onContextMenu
				}, hoverProps));
			}
		}]);
	
		return SARSeries;
	}(_react.Component);
	
	SARSeries.propTypes = {
		className: _propTypes2.default.string,
		fill: _propTypes2.default.object.isRequired,
		yAccessor: _propTypes2.default.func.isRequired,
		opacity: _propTypes2.default.number.isRequired,
		onClick: _propTypes2.default.func,
		onDoubleClick: _propTypes2.default.func,
		onContextMenu: _propTypes2.default.func,
		highlightOnHover: _propTypes2.default.bool
	};
	
	SARSeries.defaultProps = {
		className: "react-stockcharts-sar",
		fill: {
			falling: "#4682B4",
			rising: "#15EC2E"
		},
		highlightOnHover: true,
		opacity: 0.2,
		onClick: function onClick(e) {
			console.log("Click", e);
		},
		onDoubleClick: function onDoubleClick(e) {
			console.log("Double Click", e);
		},
		onContextMenu: function onContextMenu(e) {
			console.log("Right Click", e);
		}
	};
	
	exports.default = SARSeries;
	//# sourceMappingURL=SARSeries.js.map

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Collection = __webpack_require__(38);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScatterSeries = function (_Component) {
		_inherits(ScatterSeries, _Component);
	
		function ScatterSeries(props) {
			_classCallCheck(this, ScatterSeries);
	
			var _this = _possibleConstructorReturn(this, (ScatterSeries.__proto__ || Object.getPrototypeOf(ScatterSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(ScatterSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var xAccessor = moreProps.xAccessor;
	
	
				var points = helper(this.props, moreProps, xAccessor);
	
				_drawOnCanvas(ctx, this.props, points);
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    className = _props.className,
				    markerProps = _props.markerProps;
				var xAccessor = moreProps.xAccessor;
	
	
				var points = helper(this.props, moreProps, xAccessor);
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					points.map(function (point, idx) {
						var Marker = point.marker;
	
						return _react2.default.createElement(Marker, _extends({ key: idx }, markerProps, { point: point }));
					})
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}]);
	
		return ScatterSeries;
	}(_react.Component);
	
	ScatterSeries.propTypes = {
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func.isRequired,
		marker: _propTypes2.default.func,
		markerProvider: _propTypes2.default.func,
		markerProps: _propTypes2.default.object
	};
	
	ScatterSeries.defaultProps = {
		className: "react-stockcharts-scatter"
	};
	
	function helper(props, moreProps, xAccessor) {
		var yAccessor = props.yAccessor,
		    markerProvider = props.markerProvider,
		    markerProps = props.markerProps;
		var Marker = props.marker;
		var xScale = moreProps.xScale,
		    yScale = moreProps.chartConfig.yScale,
		    plotData = moreProps.plotData;
	
	
		if (!(markerProvider || Marker)) throw new Error("required prop, either marker or markerProvider missing");
	
		return plotData.map(function (d) {
	
			if (markerProvider) Marker = markerProvider(d);
	
			var mProps = _extends({}, Marker.defaultProps, markerProps);
	
			var fill = (0, _utils.functor)(mProps.fill);
			var stroke = (0, _utils.functor)(mProps.stroke);
	
			return {
				x: xScale(xAccessor(d)),
				y: yScale(yAccessor(d)),
				fill: (0, _utils.hexToRGBA)(fill(d), mProps.opacity),
				stroke: stroke(d),
				datum: d,
				marker: Marker
			};
		});
	}
	
	function _drawOnCanvas(ctx, props, points) {
		var markerProps = props.markerProps;
	
	
		var nest = (0, _d3Collection.nest)().key(function (d) {
			return d.fill;
		}).key(function (d) {
			return d.stroke;
		}).entries(points);
	
		nest.forEach(function (fillGroup) {
			var fillKey = fillGroup.key,
			    fillValues = fillGroup.values;
	
	
			if (fillKey !== "none") {
				ctx.fillStyle = fillKey;
			}
	
			fillValues.forEach(function (strokeGroup) {
				// var { key: strokeKey, values: strokeValues } = strokeGroup;
				var strokeValues = strokeGroup.values;
	
	
				strokeValues.forEach(function (point) {
					var marker = point.marker;
	
					marker.drawOnCanvas(_extends({}, marker.defaultProps, markerProps, { fill: fillKey }), point, ctx);
				});
			});
		});
	}
	
	exports.default = ScatterSeries;
	//# sourceMappingURL=ScatterSeries.js.map

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Square(props) {
		var className = props.className,
		    stroke = props.stroke,
		    strokeWidth = props.strokeWidth,
		    opacity = props.opacity,
		    fill = props.fill,
		    point = props.point,
		    width = props.width;
	
		var w = (0, _utils.functor)(width)(point.datum);
		var x = point.x - w / 2;
		var y = point.y - w / 2;
		return _react2.default.createElement("rect", {
			className: className,
			x: x,
			y: y,
			stroke: stroke,
			strokeWidth: strokeWidth,
			fillOpacity: opacity,
			fill: fill,
			width: w,
			height: w
		});
	}
	Square.propTypes = {
		stroke: _propTypes2.default.string,
		fill: _propTypes2.default.string.isRequired,
		opacity: _propTypes2.default.number.isRequired,
		point: _propTypes2.default.shape({
			x: _propTypes2.default.number.isRequired,
			y: _propTypes2.default.number.isRequired,
			datum: _propTypes2.default.object.isRequired
		}).isRequired,
		className: _propTypes2.default.string,
		strokeWidth: _propTypes2.default.number,
		width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired
	};
	Square.defaultProps = {
		stroke: "#4682B4",
		strokeWidth: 1,
		opacity: 0.5,
		fill: "#4682B4",
		className: "react-stockcharts-marker-rect"
	};
	Square.drawOnCanvas = function (props, point, ctx) {
		var stroke = props.stroke,
		    fill = props.fill,
		    opacity = props.opacity,
		    strokeWidth = props.strokeWidth;
	
		ctx.strokeStyle = stroke;
		ctx.lineWidth = strokeWidth;
		if (fill !== "none") {
			ctx.fillStyle = (0, _utils.hexToRGBA)(fill, opacity);
		}
		Square.drawOnCanvasWithNoStateChange(props, point, ctx);
	};
	Square.drawOnCanvasWithNoStateChange = function (props, point, ctx) {
		var width = props.width;
	
		var w = (0, _utils.functor)(width)(point.datum);
		var x = point.x - w / 2;
		var y = point.y - w / 2;
		ctx.beginPath();
		ctx.rect(x, y, w, w);
		ctx.stroke();
		ctx.fill();
	};
	exports.default = Square;
	//# sourceMappingURL=SquareMarker.js.map

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LineSeries = __webpack_require__(78);
	
	var _LineSeries2 = _interopRequireDefault(_LineSeries);
	
	var _StraightLine = __webpack_require__(95);
	
	var _StraightLine2 = _interopRequireDefault(_StraightLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StochasticSeries = function (_Component) {
		_inherits(StochasticSeries, _Component);
	
		function StochasticSeries(props) {
			_classCallCheck(this, StochasticSeries);
	
			var _this = _possibleConstructorReturn(this, (StochasticSeries.__proto__ || Object.getPrototypeOf(StochasticSeries)).call(this, props));
	
			_this.yAccessorForD = _this.yAccessorForD.bind(_this);
			_this.yAccessorForK = _this.yAccessorForK.bind(_this);
			return _this;
		}
	
		_createClass(StochasticSeries, [{
			key: "yAccessorForD",
			value: function yAccessorForD(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && yAccessor(d).D;
			}
		}, {
			key: "yAccessorForK",
			value: function yAccessorForK(d) {
				var yAccessor = this.props.yAccessor;
	
				return yAccessor(d) && yAccessor(d).K;
			}
		}, {
			key: "render",
			value: function render() {
				var _props = this.props,
				    className = _props.className,
				    stroke = _props.stroke,
				    refLineOpacity = _props.refLineOpacity;
				var _props2 = this.props,
				    overSold = _props2.overSold,
				    middle = _props2.middle,
				    overBought = _props2.overBought;
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					_react2.default.createElement(_LineSeries2.default, { yAccessor: this.yAccessorForD,
						stroke: stroke.dLine,
						fill: "none" }),
					_react2.default.createElement(_LineSeries2.default, { yAccessor: this.yAccessorForK,
						stroke: stroke.kLine,
						fill: "none" }),
					_react2.default.createElement(_StraightLine2.default, {
						stroke: stroke.top,
						opacity: refLineOpacity,
						yValue: overSold }),
					_react2.default.createElement(_StraightLine2.default, {
						stroke: stroke.middle,
						opacity: refLineOpacity,
						yValue: middle }),
					_react2.default.createElement(_StraightLine2.default, {
						stroke: stroke.bottom,
						opacity: refLineOpacity,
						yValue: overBought })
				);
			}
		}]);
	
		return StochasticSeries;
	}(_react.Component);
	
	StochasticSeries.propTypes = {
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func.isRequired,
		stroke: _propTypes2.default.shape({
			top: _propTypes2.default.string.isRequired,
			middle: _propTypes2.default.string.isRequired,
			bottom: _propTypes2.default.string.isRequired,
			dLine: _propTypes2.default.string.isRequired,
			kLine: _propTypes2.default.string.isRequired
		}).isRequired,
		overSold: _propTypes2.default.number.isRequired,
		middle: _propTypes2.default.number.isRequired,
		overBought: _propTypes2.default.number.isRequired,
		refLineOpacity: _propTypes2.default.number.isRequired
	};
	
	StochasticSeries.defaultProps = {
		className: "react-stockcharts-stochastic-series",
		stroke: {
			top: "#964B00",
			middle: "#000000",
			bottom: "#964B00",
			dLine: "#EA2BFF",
			kLine: "#74D400"
		},
		overSold: 80,
		middle: 50,
		overBought: 20,
		refLineOpacity: 0.3
	};
	
	exports.default = StochasticSeries;
	//# sourceMappingURL=StochasticSeries.js.map

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Triangle(props) {
		var className = props.className,
		    strokeWidth = props.strokeWidth,
		    opacity = props.opacity,
		    point = props.point,
		    width = props.width;
	
	
		var rotation = getRotationInDegrees(props, point);
		if (rotation == null) return null;
	
		var fillColor = getFillColor(props);
		var strokeColor = getStrokeColor(props);
	
		var w = (0, _utils.functor)(width)(point.datum);
		var x = point.x,
		    y = point.y;
	
		var _getTrianglePoints = getTrianglePoints(w),
		    innerOpposite = _getTrianglePoints.innerOpposite,
		    innerHypotenuse = _getTrianglePoints.innerHypotenuse;
	
		var points = "\n\t\t" + x + " " + (y - innerHypotenuse) + ",\n\t\t" + (x + w / 2) + " " + (y + innerOpposite) + ",\n\t\t" + (x - w / 2) + " " + (y + innerOpposite) + "\n\t";
	
		return _react2.default.createElement("polygon", {
			className: className,
			points: points,
			stroke: strokeColor,
			strokeWidth: strokeWidth,
			fillOpacity: opacity,
			fill: fillColor,
			transform: rotation !== 0 ? "rotate(" + rotation + ", " + x + ", " + y + ")" : null
		});
	}
	Triangle.propTypes = {
		direction: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(["top", "bottom", "left", "right", "hide"]), _propTypes2.default.func]).isRequired,
		stroke: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
		fill: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
		opacity: _propTypes2.default.number.isRequired,
		point: _propTypes2.default.shape({
			x: _propTypes2.default.number.isRequired,
			y: _propTypes2.default.number.isRequired,
			datum: _propTypes2.default.object.isRequired
		}).isRequired,
		className: _propTypes2.default.string,
		strokeWidth: _propTypes2.default.number,
		width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired
	};
	Triangle.defaultProps = {
		direction: "top",
		stroke: "#4682B4",
		strokeWidth: 1,
		opacity: 0.5,
		fill: "#4682B4",
		className: "react-stockcharts-marker-triangle"
	};
	Triangle.drawOnCanvas = function (props, point, ctx) {
		var stroke = props.stroke,
		    fill = props.fill,
		    opacity = props.opacity,
		    strokeWidth = props.strokeWidth;
	
		ctx.strokeStyle = stroke;
		ctx.lineWidth = strokeWidth;
		if (fill !== "none") {
			ctx.fillStyle = (0, _utils.hexToRGBA)(fill, opacity);
		}
		Triangle.drawOnCanvasWithNoStateChange(props, point, ctx);
	};
	Triangle.drawOnCanvasWithNoStateChange = function (props, point, ctx) {
		var width = props.width;
	
		var w = (0, _utils.functor)(width)(point.datum);
		var x = point.x,
		    y = point.y;
	
		var _getTrianglePoints2 = getTrianglePoints(w),
		    innerOpposite = _getTrianglePoints2.innerOpposite,
		    innerHypotenuse = _getTrianglePoints2.innerHypotenuse;
	
		var rotationDeg = getRotationInDegrees(props, point);
	
		ctx.beginPath();
		ctx.moveTo(x, y - innerHypotenuse);
		ctx.lineTo(x + w / 2, y + innerOpposite);
		ctx.lineTo(x - w / 2, y + innerOpposite);
		ctx.stroke();
	
		// TODO: rotation does not work
		// example: https://gist.github.com/geoffb/6392450
		if (rotationDeg !== null && rotationDeg !== 0) {
			ctx.save();
			ctx.translate(x, y);
			ctx.rotate(rotationDeg * Math.PI / 180); // 45 degrees
			ctx.fill();
			ctx.restore();
		}
		ctx.fill();
	};
	exports.default = Triangle;
	
	
	function getTrianglePoints(width) {
		var innerHypotenuse = width / 2 * (1 / Math.cos(30 * Math.PI / 180));
		var innerOpposite = width / 2 * (1 / Math.tan(60 * Math.PI / 180));
		return {
			innerOpposite: innerOpposite,
			innerHypotenuse: innerHypotenuse
		};
	}
	
	function getFillColor(props) {
		var fill = props.fill,
		    point = props.point;
	
		return fill instanceof Function ? fill(point.datum) : fill;
	}
	
	function getStrokeColor(props) {
		var stroke = props.stroke,
		    point = props.point;
	
		return stroke instanceof Function ? stroke(point.datum) : stroke;
	}
	
	function getRotationInDegrees(props, point) {
		var direction = props.direction;
	
		var directionVal = direction instanceof Function ? direction(point.datum) : direction;
		if (directionVal === "hide") return null;
	
		var rotate = 0;
		switch (directionVal) {
			case "bottom":
				rotate = 180;
				break;
			case "left":
				rotate = -90;
				break;
			case "right":
				rotate = 90;
				break;
		}
		return rotate;
	}
	//# sourceMappingURL=TriangleMarker.js.map

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Array = __webpack_require__(21);
	
	var _d3Collection = __webpack_require__(38);
	
	var _d3Scale = __webpack_require__(83);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VolumeProfileSeries = function (_Component) {
		_inherits(VolumeProfileSeries, _Component);
	
		function VolumeProfileSeries(props) {
			_classCallCheck(this, VolumeProfileSeries);
	
			var _this = _possibleConstructorReturn(this, (VolumeProfileSeries.__proto__ || Object.getPrototypeOf(VolumeProfileSeries)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(VolumeProfileSeries, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var xAccessor = moreProps.xAccessor,
				    width = moreProps.width;
	
				var _helper = helper(this.props, moreProps, xAccessor, width),
				    rects = _helper.rects,
				    sessionBg = _helper.sessionBg;
	
				_drawOnCanvas(ctx, this.props, rects, sessionBg);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					canvasToDraw: _GenericComponent.getAxisCanvas,
					drawOn: ["pan"]
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    className = _props.className,
				    opacity = _props.opacity;
				var _props2 = this.props,
				    showSessionBackground = _props2.showSessionBackground,
				    sessionBackGround = _props2.sessionBackGround,
				    sessionBackGroundOpacity = _props2.sessionBackGroundOpacity;
				var xAccessor = moreProps.xAccessor,
				    width = moreProps.width;
	
				var _helper2 = helper(this.props, moreProps, xAccessor, width),
				    rects = _helper2.rects,
				    sessionBg = _helper2.sessionBg;
	
				var sessionBgSvg = showSessionBackground ? sessionBg.map(function (d, idx) {
					return _react2.default.createElement("rect", _extends({ key: idx }, d, { opacity: sessionBackGroundOpacity, fill: sessionBackGround }));
				}) : null;
	
				return _react2.default.createElement(
					"g",
					{ className: className },
					sessionBgSvg,
					rects.map(function (d, i) {
						return _react2.default.createElement(
							"g",
							{ key: i },
							_react2.default.createElement("rect", { x: d.x, y: d.y,
								width: d.w1, height: d.height,
								fill: d.fill1, stroke: d.stroke1, fillOpacity: opacity }),
							_react2.default.createElement("rect", { x: d.x + d.w1, y: d.y,
								width: d.w2, height: d.height,
								fill: d.fill2, stroke: d.stroke2, fillOpacity: opacity })
						);
					})
				);
			}
		}]);
	
		return VolumeProfileSeries;
	}(_react.Component);
	
	VolumeProfileSeries.propTypes = {
		className: _propTypes2.default.string,
		opacity: _propTypes2.default.number,
		showSessionBackground: _propTypes2.default.bool,
		sessionBackGround: _propTypes2.default.string,
		sessionBackGroundOpacity: _propTypes2.default.number
	};
	
	VolumeProfileSeries.defaultProps = {
		className: "line ",
		bins: 20,
		opacity: 0.5,
		maxProfileWidthPercent: 50,
		fill: function fill(_ref) {
			var type = _ref.type;
			return type === "up" ? "#6BA583" : "#FF0000";
		},
		stroke: "#FFFFFF",
		showSessionBackground: false,
		sessionBackGround: "#4682B4",
		sessionBackGroundOpacity: 0.3,
	
		source: function source(d) {
			return d.close;
		},
		volume: function volume(d) {
			return d.volume;
		},
		absoluteChange: function absoluteChange(d) {
			return d.absoluteChange;
		},
		bySession: false,
		/* eslint-disable no-unused-vars */
		sessionStart: function sessionStart(_ref2) {
			var d = _ref2.d,
			    i = _ref2.i,
			    plotData = _ref2.plotData;
			return i > 0 && plotData[i - 1].date.getMonth() !== d.date.getMonth();
		},
		/* eslint-enable no-unused-vars */
		orient: "left",
		// // fill: ({ type }) => { var c = type === "up" ? "#6BA583" : "#FF0000"; console.log(type, c); return c },
		// stroke: ({ type }) =>  type === "up" ? "#6BA583" : "#FF0000",
		// stroke: "none",
		partialStartOK: true,
		partialEndOK: true
	};
	
	function helper(props, moreProps, xAccessor, width) {
		var realXScale = moreProps.xScale,
		    yScale = moreProps.chartConfig.yScale,
		    plotData = moreProps.plotData;
		var sessionStart = props.sessionStart,
		    bySession = props.bySession,
		    partialStartOK = props.partialStartOK,
		    partialEndOK = props.partialEndOK;
		var bins = props.bins,
		    maxProfileWidthPercent = props.maxProfileWidthPercent,
		    source = props.source,
		    volume = props.volume,
		    absoluteChange = props.absoluteChange,
		    orient = props.orient,
		    fill = props.fill,
		    stroke = props.stroke;
	
	
		var sessionBuilder = (0, _utils.accumulatingWindow)().discardTillStart(!partialStartOK).discardTillEnd(!partialEndOK).accumulateTill(function (d, i) {
			return sessionStart(_extends({ d: d, i: i }, moreProps));
		}).accumulator(_utils.identity);
	
		var dx = plotData.length > 1 ? realXScale(xAccessor(plotData[1])) - realXScale(xAccessor((0, _utils.head)(plotData))) : 0;
	
		var sessions = bySession ? sessionBuilder(plotData) : [plotData];
	
		var allRects = sessions.map(function (session) {
	
			var begin = bySession ? realXScale(xAccessor((0, _utils.head)(session))) : 0;
			var finish = bySession ? realXScale(xAccessor((0, _utils.last)(session))) : width;
			var sessionWidth = finish - begin + dx;
	
			// console.log(session)
	
			/* var histogram = d3.layout.histogram()
	  		.value(source)
	  		.bins(bins);*/
	
			var histogram2 = (0, _d3Array.histogram)()
			// .domain(xScale.domain())
			.value(source).thresholds(bins);
	
			// console.log(bins, histogram(session))
			// console.log(bins, histogram2(session))
			var rollup = (0, _d3Collection.nest)().key(function (d) {
				return d.direction;
			}).sortKeys(orient === "right" ? _d3Array.descending : _d3Array.ascending).rollup(function (leaves) {
				return (0, _d3Array.sum)(leaves, function (d) {
					return d.volume;
				});
			});
	
			var values = histogram2(session);
			// console.log("values", values)
	
			var volumeInBins = values.map(function (arr) {
				return arr.map(function (d) {
					return absoluteChange(d) > 0 ? { direction: "up", volume: volume(d) } : { direction: "down", volume: volume(d) };
				});
			}).map(function (arr) {
				return rollup.entries(arr);
			});
	
			// console.log("volumeInBins", volumeInBins)
			var volumeValues = volumeInBins.map(function (each) {
				return (0, _d3Array.sum)(each.map(function (d) {
					return d.value;
				}));
			});
	
			// console.log("volumeValues", volumeValues)
			var base = function base(xScale) {
				return (0, _utils.head)(xScale.range());
			};
	
			var _ref3 = orient === "right" ? [begin, begin + sessionWidth * maxProfileWidthPercent / 100] : [finish, finish - sessionWidth * (100 - maxProfileWidthPercent) / 100],
			    _ref4 = _slicedToArray(_ref3, 2),
			    start = _ref4[0],
			    end = _ref4[1];
	
			var xScale = (0, _d3Scale.scaleLinear)().domain([0, (0, _d3Array.max)(volumeValues)]).range([start, end]);
	
			// console.log(xScale.domain())
	
			var totalVolumes = volumeInBins.map(function (volumes) {
	
				var totalVolume = (0, _d3Array.sum)(volumes, function (d) {
					return d.value;
				});
				var totalVolumeX = xScale(totalVolume);
				var width = base(xScale) - totalVolumeX;
				var x = width < 0 ? totalVolumeX + width : totalVolumeX;
	
				var ws = volumes.map(function (d) {
					return {
						type: d.key,
						width: d.value * Math.abs(width) / totalVolume
					};
				});
	
				return { x: x, ws: ws, totalVolumeX: totalVolumeX };
			});
			// console.log("totalVolumes", totalVolumes)
	
			var rects = (0, _d3Array.zip)(values, totalVolumes).map(function (_ref5) {
				var _ref6 = _slicedToArray(_ref5, 2),
				    d = _ref6[0],
				    _ref6$ = _ref6[1],
				    x = _ref6$.x,
				    ws = _ref6$.ws;
	
				var w1 = ws[0] || { type: "up", width: 0 };
				var w2 = ws[1] || { type: "down", width: 0 };
	
				return {
					// y: yScale(d.x + d.dx),
					y: yScale(d.x1),
					// height: yScale(d.x - d.dx) - yScale(d.x),
					height: yScale(d.x1) - yScale(d.x0),
					x: x,
					width: width,
					w1: w1.width,
					w2: w2.width,
					stroke1: (0, _utils.functor)(stroke)(w1),
					stroke2: (0, _utils.functor)(stroke)(w2),
					fill1: (0, _utils.functor)(fill)(w1),
					fill2: (0, _utils.functor)(fill)(w2)
				};
			});
	
			// console.log("rects", rects)
	
			var sessionBg = {
				x: begin,
				y: (0, _utils.last)(rects).y,
				height: (0, _utils.head)(rects).y - (0, _utils.last)(rects).y + (0, _utils.head)(rects).height,
				width: sessionWidth
			};
	
			return { rects: rects, sessionBg: sessionBg };
		});
	
		return {
			rects: (0, _d3Array.merge)(allRects.map(function (d) {
				return d.rects;
			})),
			sessionBg: allRects.map(function (d) {
				return d.sessionBg;
			})
		};
	}
	
	function _drawOnCanvas(ctx, props, rects, sessionBg) {
		var opacity = props.opacity,
		    sessionBackGround = props.sessionBackGround,
		    sessionBackGroundOpacity = props.sessionBackGroundOpacity,
		    showSessionBackground = props.showSessionBackground;
	
		// var { rects, sessionBg } = helper(props, xScale, yScale, plotData);
	
		if (showSessionBackground) {
			ctx.fillStyle = (0, _utils.hexToRGBA)(sessionBackGround, sessionBackGroundOpacity);
	
			sessionBg.forEach(function (each) {
				var x = each.x,
				    y = each.y,
				    height = each.height,
				    width = each.width;
	
	
				ctx.beginPath();
				ctx.rect(x, y, width, height);
				ctx.closePath();
				ctx.fill();
			});
		}
	
		rects.forEach(function (each) {
			var x = each.x,
			    y = each.y,
			    height = each.height,
			    w1 = each.w1,
			    w2 = each.w2,
			    stroke1 = each.stroke1,
			    stroke2 = each.stroke2,
			    fill1 = each.fill1,
			    fill2 = each.fill2;
	
	
			if (w1 > 0) {
				ctx.fillStyle = (0, _utils.hexToRGBA)(fill1, opacity);
				if (stroke1 !== "none") ctx.strokeStyle = stroke1;
	
				ctx.beginPath();
				ctx.rect(x, y, w1, height);
				ctx.closePath();
				ctx.fill();
	
				if (stroke1 !== "none") ctx.stroke();
			}
	
			if (w2 > 0) {
				ctx.fillStyle = (0, _utils.hexToRGBA)(fill2, opacity);
				if (stroke2 !== "none") ctx.strokeStyle = stroke2;
	
				ctx.beginPath();
				ctx.rect(x + w1, y, w2, height);
				ctx.closePath();
				ctx.fill();
	
				if (stroke2 !== "none") ctx.stroke();
			}
		});
	}
	
	exports.default = VolumeProfileSeries;
	//# sourceMappingURL=VolumeProfileSeries.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AreaSeries = __webpack_require__(401);
	
	Object.defineProperty(exports, "AreaSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AreaSeries).default;
	  }
	});
	
	var _AlternatingFillAreaSeries = __webpack_require__(752);
	
	Object.defineProperty(exports, "AlternatingFillAreaSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlternatingFillAreaSeries).default;
	  }
	});
	
	var _AreaOnlySeries = __webpack_require__(165);
	
	Object.defineProperty(exports, "AreaOnlySeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AreaOnlySeries).default;
	  }
	});
	
	var _ScatterSeries = __webpack_require__(766);
	
	Object.defineProperty(exports, "ScatterSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScatterSeries).default;
	  }
	});
	
	var _CircleMarker = __webpack_require__(755);
	
	Object.defineProperty(exports, "CircleMarker", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CircleMarker).default;
	  }
	});
	
	var _TriangleMarker = __webpack_require__(769);
	
	Object.defineProperty(exports, "TriangleMarker", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TriangleMarker).default;
	  }
	});
	
	var _SquareMarker = __webpack_require__(767);
	
	Object.defineProperty(exports, "SquareMarker", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SquareMarker).default;
	  }
	});
	
	var _LineSeries = __webpack_require__(78);
	
	Object.defineProperty(exports, "LineSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LineSeries).default;
	  }
	});
	
	var _CandlestickSeries = __webpack_require__(754);
	
	Object.defineProperty(exports, "CandlestickSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CandlestickSeries).default;
	  }
	});
	
	var _OHLCSeries = __webpack_require__(760);
	
	Object.defineProperty(exports, "OHLCSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OHLCSeries).default;
	  }
	});
	
	var _BarSeries = __webpack_require__(402);
	
	Object.defineProperty(exports, "BarSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BarSeries).default;
	  }
	});
	
	var _StackedBarSeries = __webpack_require__(113);
	
	Object.defineProperty(exports, "StackedBarSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StackedBarSeries).default;
	  }
	});
	
	var _GroupedBarSeries = __webpack_require__(757);
	
	Object.defineProperty(exports, "GroupedBarSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupedBarSeries).default;
	  }
	});
	
	var _KagiSeries = __webpack_require__(758);
	
	Object.defineProperty(exports, "KagiSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KagiSeries).default;
	  }
	});
	
	var _PointAndFigureSeries = __webpack_require__(762);
	
	Object.defineProperty(exports, "PointAndFigureSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PointAndFigureSeries).default;
	  }
	});
	
	var _RenkoSeries = __webpack_require__(764);
	
	Object.defineProperty(exports, "RenkoSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenkoSeries).default;
	  }
	});
	
	var _MACDSeries = __webpack_require__(759);
	
	Object.defineProperty(exports, "MACDSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MACDSeries).default;
	  }
	});
	
	var _BollingerSeries = __webpack_require__(753);
	
	Object.defineProperty(exports, "BollingerSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BollingerSeries).default;
	  }
	});
	
	var _RSISeries = __webpack_require__(763);
	
	Object.defineProperty(exports, "RSISeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RSISeries).default;
	  }
	});
	
	var _StochasticSeries = __webpack_require__(768);
	
	Object.defineProperty(exports, "StochasticSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StochasticSeries).default;
	  }
	});
	
	var _ElderRaySeries = __webpack_require__(756);
	
	Object.defineProperty(exports, "ElderRaySeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ElderRaySeries).default;
	  }
	});
	
	var _VolumeProfileSeries = __webpack_require__(770);
	
	Object.defineProperty(exports, "VolumeProfileSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VolumeProfileSeries).default;
	  }
	});
	
	var _StraightLine = __webpack_require__(95);
	
	Object.defineProperty(exports, "StraightLine", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StraightLine).default;
	  }
	});
	
	var _SARSeries = __webpack_require__(765);
	
	Object.defineProperty(exports, "SARSeries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SARSeries).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(33);
	
	var _displayValuesFor = __webpack_require__(59);
	
	var _displayValuesFor2 = _interopRequireDefault(_displayValuesFor);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _utils = __webpack_require__(4);
	
	var _ToolTipText = __webpack_require__(50);
	
	var _ToolTipText2 = _interopRequireDefault(_ToolTipText);
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BollingerBandTooltip = function (_Component) {
		_inherits(BollingerBandTooltip, _Component);
	
		function BollingerBandTooltip(props) {
			_classCallCheck(this, BollingerBandTooltip);
	
			var _this = _possibleConstructorReturn(this, (BollingerBandTooltip.__proto__ || Object.getPrototypeOf(BollingerBandTooltip)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			return _this;
		}
	
		_createClass(BollingerBandTooltip, [{
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    onClick = _props.onClick,
				    displayFormat = _props.displayFormat,
				    yAccessor = _props.yAccessor,
				    options = _props.options,
				    textFill = _props.textFill,
				    labelFill = _props.labelFill;
				var displayValuesFor = this.props.displayValuesFor;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    width = _moreProps$chartConfi.width,
				    height = _moreProps$chartConfi.height;
	
	
				var currentItem = displayValuesFor(this.props, moreProps);
	
				var top = void 0,
				    middle = void 0,
				    bottom = void 0;
				top = middle = bottom = "n/a";
	
				if ((0, _utils.isDefined)(currentItem) && (0, _utils.isDefined)(yAccessor(currentItem))) {
					var item = yAccessor(currentItem);
					top = displayFormat(item.top);
					middle = displayFormat(item.middle);
					bottom = displayFormat(item.bottom);
				}
	
				var originProp = this.props.origin;
	
				var origin = (0, _utils.functor)(originProp);
	
				var _origin = origin(width, height),
				    _origin2 = _slicedToArray(_origin, 2),
				    x = _origin2[0],
				    y = _origin2[1];
	
				var sourcePath = options.sourcePath,
				    windowSize = options.windowSize,
				    multiplier = options.multiplier,
				    movingAverageType = options.movingAverageType;
	
				var tooltipLabel = "BB(" + sourcePath + ", " + windowSize + ", " + multiplier + ", " + movingAverageType + "): ";
				var tooltipValue = top + ", " + middle + ", " + bottom;
				return _react2.default.createElement(
					"g",
					{ transform: "translate(" + x + ", " + y + ")",
						className: this.props.className, onClick: onClick },
					_react2.default.createElement(
						_ToolTipText2.default,
						{ x: 0, y: 0,
							fontFamily: this.props.fontFamily, fontSize: this.props.fontSize },
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							tooltipLabel
						),
						_react2.default.createElement(
							"tspan",
							{ fill: textFill },
							tooltipValue
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					drawOn: ["mousemove"]
				});
			}
		}]);
	
		return BollingerBandTooltip;
	}(_react.Component);
	
	BollingerBandTooltip.propTypes = {
		className: _propTypes2.default.string,
		yAccessor: _propTypes2.default.func.isRequired,
		displayValuesFor: _propTypes2.default.func,
		displayFormat: _propTypes2.default.func.isRequired,
		origin: _propTypes2.default.array.isRequired,
		onClick: _propTypes2.default.func,
		options: _propTypes2.default.shape({
			sourcePath: _propTypes2.default.string.isRequired,
			windowSize: _propTypes2.default.number.isRequired,
			multiplier: _propTypes2.default.number.isRequired,
			movingAverageType: _propTypes2.default.string.isRequired
		}).isRequired,
		textFill: _propTypes2.default.string,
		labelFill: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number
	};
	
	BollingerBandTooltip.defaultProps = {
		className: "react-stockcharts-tooltip react-stockcharts-bollingerband-tooltip",
		displayFormat: (0, _d3Format.format)(".2f"),
		displayValuesFor: _displayValuesFor2.default,
		origin: [0, 10]
	};
	
	exports.default = BollingerBandTooltip;
	//# sourceMappingURL=BollingerBandTooltip.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(33);
	
	var _displayValuesFor = __webpack_require__(59);
	
	var _displayValuesFor2 = _interopRequireDefault(_displayValuesFor);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _ToolTipText = __webpack_require__(50);
	
	var _ToolTipText2 = _interopRequireDefault(_ToolTipText);
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VALID_LAYOUTS = ["horizontal", "horizontalRows", "horizontalInline", "vertical", "verticalRows"];
	
	var SingleTooltip = function (_Component) {
		_inherits(SingleTooltip, _Component);
	
		function SingleTooltip(props) {
			_classCallCheck(this, SingleTooltip);
	
			var _this = _possibleConstructorReturn(this, (SingleTooltip.__proto__ || Object.getPrototypeOf(SingleTooltip)).call(this, props));
	
			_this.handleClick = _this.handleClick.bind(_this);
			return _this;
		}
	
		_createClass(SingleTooltip, [{
			key: "handleClick",
			value: function handleClick(e) {
				var _props = this.props,
				    onClick = _props.onClick,
				    forChart = _props.forChart,
				    options = _props.options;
	
				onClick(_extends({ chartId: forChart }, options), e);
			}
	
			/**
	   * Renders the value next to the label.
	   */
	
		}, {
			key: "renderValueNextToLabel",
			value: function renderValueNextToLabel() {
				var _props2 = this.props,
				    origin = _props2.origin,
				    yLabel = _props2.yLabel,
				    yValue = _props2.yValue,
				    labelFill = _props2.labelFill,
				    valueFill = _props2.valueFill,
				    withShape = _props2.withShape,
				    fontSize = _props2.fontSize,
				    fontFamily = _props2.fontFamily;
	
	
				return _react2.default.createElement(
					"g",
					{ transform: "translate(" + origin[0] + ", " + origin[1] + ")", onClick: this.handleClick },
					withShape ? _react2.default.createElement("rect", { x: "0", y: "-6", width: "6", height: "6", fill: valueFill }) : null,
					_react2.default.createElement(
						_ToolTipText2.default,
						{ x: withShape ? 8 : 0, y: 0, fontFamily: fontFamily, fontSize: fontSize },
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							yLabel,
							": "
						),
						_react2.default.createElement(
							"tspan",
							{ fill: valueFill },
							yValue
						)
					)
				);
			}
	
			/**
	   * Renders the value beneath the label.
	   */
	
		}, {
			key: "renderValueBeneathToLabel",
			value: function renderValueBeneathToLabel() {
				var _props3 = this.props,
				    origin = _props3.origin,
				    yLabel = _props3.yLabel,
				    yValue = _props3.yValue,
				    labelFill = _props3.labelFill,
				    valueFill = _props3.valueFill,
				    withShape = _props3.withShape,
				    fontSize = _props3.fontSize,
				    fontFamily = _props3.fontFamily;
	
	
				return _react2.default.createElement(
					"g",
					{ transform: "translate(" + origin[0] + ", " + origin[1] + ")", onClick: this.handleClick },
					withShape ? _react2.default.createElement("line", { x1: 0, y1: 2, x2: 0, y2: 28, stroke: valueFill, strokeWidth: "4px" }) : null,
					_react2.default.createElement(
						_ToolTipText2.default,
						{ x: 5, y: 11, fontFamily: fontFamily, fontSize: fontSize },
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							yLabel
						),
						_react2.default.createElement(
							"tspan",
							{ x: "5", dy: "15", fill: valueFill },
							yValue
						)
					)
				);
			}
	
			/**
	   * Renders the value next to the label.
	   * The parent component must have a "text"-element.
	   */
	
		}, {
			key: "renderInline",
			value: function renderInline() {
				var _props4 = this.props,
				    yLabel = _props4.yLabel,
				    yValue = _props4.yValue,
				    labelFill = _props4.labelFill,
				    valueFill = _props4.valueFill,
				    fontSize = _props4.fontSize,
				    fontFamily = _props4.fontFamily;
	
	
				return _react2.default.createElement(
					"tspan",
					{ onClick: this.handleClick, fontFamily: fontFamily, fontSize: fontSize },
					_react2.default.createElement(
						_ToolTipTSpanLabel2.default,
						{ fill: labelFill },
						yLabel,
						":\xA0"
					),
					_react2.default.createElement(
						"tspan",
						{ fill: valueFill },
						yValue,
						"\xA0\xA0"
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var layout = this.props.layout;
	
				var comp = null;
	
				switch (layout) {
					case "horizontal":
						comp = this.renderValueNextToLabel();
						break;
					case "horizontalRows":
						comp = this.renderValueBeneathToLabel();
						break;
					case "horizontalInline":
						comp = this.renderInline();
						break;
					case "vertical":
						comp = this.renderValueNextToLabel();
						break;
					case "verticalRows":
						comp = this.renderValueBeneathToLabel();
						break;
					default:
						comp = this.renderValueNextToLabel();
				}
	
				return comp;
			}
		}]);
	
		return SingleTooltip;
	}(_react.Component);
	
	SingleTooltip.propTypes = {
		origin: _propTypes2.default.array.isRequired,
		yLabel: _propTypes2.default.string.isRequired,
		yValue: _propTypes2.default.string.isRequired,
		onClick: _propTypes2.default.func,
		fontFamily: _propTypes2.default.string,
		labelFill: _propTypes2.default.string.isRequired,
		valueFill: _propTypes2.default.string.isRequired,
		fontSize: _propTypes2.default.number,
		withShape: _propTypes2.default.bool,
		forChart: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
		options: _propTypes2.default.object.isRequired,
		layout: _propTypes2.default.oneOf(VALID_LAYOUTS).isRequired
	};
	
	SingleTooltip.defaultProps = {
		labelFill: "#4682B4",
		valueFill: "#000000",
		withShape: false
	};
	
	var GroupTooltip = function (_Component2) {
		_inherits(GroupTooltip, _Component2);
	
		function GroupTooltip(props) {
			_classCallCheck(this, GroupTooltip);
	
			var _this2 = _possibleConstructorReturn(this, (GroupTooltip.__proto__ || Object.getPrototypeOf(GroupTooltip)).call(this, props));
	
			_this2.renderSVG = _this2.renderSVG.bind(_this2);
			return _this2;
		}
	
		_createClass(GroupTooltip, [{
			key: "getPosition",
			value: function getPosition(moreProps) {
				var position = this.props.position;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    height = _moreProps$chartConfi.height,
				    width = _moreProps$chartConfi.width;
	
	
				var dx = 20;
				var dy = 40;
				var textAnchor = null;
				var xyPos = null;
	
				if (position !== undefined) {
					switch (position) {
						case "topRight":
							xyPos = [width - dx, null];
							textAnchor = "end";
							break;
						case "bottomLeft":
							xyPos = [null, height - dy];
							break;
						case "bottomRight":
							xyPos = [width - dx, height - dy];
							textAnchor = "end";
							break;
						default:
							xyPos = [null, null];
					}
				} else {
					xyPos = [null, null];
				}
	
				return { xyPos: xyPos, textAnchor: textAnchor };
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var displayValuesFor = this.props.displayValuesFor;
				var chartId = moreProps.chartId;
				var _props5 = this.props,
				    className = _props5.className,
				    onClick = _props5.onClick,
				    width = _props5.width,
				    verticalSize = _props5.verticalSize,
				    fontFamily = _props5.fontFamily,
				    fontSize = _props5.fontSize,
				    layout = _props5.layout;
				var _props6 = this.props,
				    origin = _props6.origin,
				    displayFormat = _props6.displayFormat,
				    options = _props6.options;
	
				var currentItem = displayValuesFor(this.props, moreProps);
	
				var _getPosition = this.getPosition(moreProps),
				    xyPos = _getPosition.xyPos,
				    textAnchor = _getPosition.textAnchor;
	
				var xPos = xyPos != null && xyPos[0] != null ? xyPos[0] : origin[0];
				var yPos = xyPos != null && xyPos[1] != null ? xyPos[1] : origin[1];
	
				var singleTooltip = options.map(function (each, idx) {
	
					var yValue = currentItem && each.yAccessor(currentItem);
					var yDisplayValue = yValue ? displayFormat(yValue) : "n/a";
	
					var orig = function orig() {
						if (layout === "horizontal" || layout === "horizontalRows") {
							return [width * idx, 0];
						}
						if (layout === "vertical") {
							return [0, verticalSize * idx];
						}
						if (layout === "verticalRows") {
							return [0, verticalSize * 2.3 * idx];
						}
						return [0, 0];
					};
	
					return _react2.default.createElement(SingleTooltip, {
						key: idx,
						layout: layout,
						origin: orig(),
						yLabel: each.yLabel,
						yValue: yDisplayValue,
						options: each,
						forChart: chartId,
						onClick: onClick,
						fontFamily: fontFamily,
						fontSize: fontSize,
						labelFill: each.labelFill,
						valueFill: each.valueFill,
						withShape: each.withShape
					});
				});
	
				return _react2.default.createElement(
					"g",
					{ transform: "translate(" + xPos + ", " + yPos + ")", className: className, textAnchor: textAnchor },
					layout === "horizontalInline" ? _react2.default.createElement(
						_ToolTipText2.default,
						{ x: 0, y: 0, fontFamily: fontFamily, fontSize: fontSize },
						singleTooltip
					) : singleTooltip
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					drawOn: ["mousemove"]
				});
			}
		}]);
	
		return GroupTooltip;
	}(_react.Component);
	
	GroupTooltip.propTypes = {
		className: _propTypes2.default.string,
		layout: _propTypes2.default.oneOf(VALID_LAYOUTS).isRequired,
		position: _propTypes2.default.oneOf(["topRight", "bottomLeft", "bottomRight"]),
		displayFormat: _propTypes2.default.func.isRequired,
		origin: _propTypes2.default.array.isRequired,
		displayValuesFor: _propTypes2.default.func,
		onClick: _propTypes2.default.func,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		width: _propTypes2.default.number, // "width" only be used, if layout is "horizontal" or "horizontalRows".
		verticalSize: _propTypes2.default.number, // "verticalSize" only be used, if layout is "vertical", "verticalRows".
		options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			yLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
			yAccessor: _propTypes2.default.func.isRequired,
			labelFill: _propTypes2.default.string,
			valueFill: _propTypes2.default.string,
			withShape: _propTypes2.default.bool // "withShape" is ignored, if layout is "horizontalInline" or "vertical".
		}))
	};
	
	GroupTooltip.defaultProps = {
		className: "react-stockcharts-tooltip react-stockcharts-group-tooltip",
		layout: "horizontal",
		displayFormat: (0, _d3Format.format)(".2f"),
		displayValuesFor: _displayValuesFor2.default,
		origin: [0, 0],
		width: 60,
		verticalSize: 13
	};
	
	exports.default = GroupTooltip;
	//# sourceMappingURL=GroupTooltip.js.map

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GenericComponent = __webpack_require__(17);
	
	var _GenericComponent2 = _interopRequireDefault(_GenericComponent);
	
	var _d3Array = __webpack_require__(21);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoverTooltip = function (_Component) {
		_inherits(HoverTooltip, _Component);
	
		function HoverTooltip(props) {
			_classCallCheck(this, HoverTooltip);
	
			var _this = _possibleConstructorReturn(this, (HoverTooltip.__proto__ || Object.getPrototypeOf(HoverTooltip)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			_this.drawOnCanvas = _this.drawOnCanvas.bind(_this);
			return _this;
		}
	
		_createClass(HoverTooltip, [{
			key: "drawOnCanvas",
			value: function drawOnCanvas(ctx, moreProps) {
				var pointer = helper(this.props, moreProps, ctx);
				var height = moreProps.height;
	
	
				if ((0, _utils.isNotDefined)(pointer)) return null;
				_drawOnCanvas(ctx, this.props, this.context, pointer, height, moreProps);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericComponent2.default, {
					svgDraw: this.renderSVG,
					canvasDraw: this.drawOnCanvas,
					drawOn: ["mousemove", "pan" /* , "mouseleave" */]
				});
			}
		}, {
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var pointer = helper(this.props, moreProps);
	
				if ((0, _utils.isNotDefined)(pointer)) return null;
	
				var _props = this.props,
				    bgFill = _props.bgFill,
				    bgOpacity = _props.bgOpacity,
				    backgroundShapeSVG = _props.backgroundShapeSVG,
				    tooltipSVG = _props.tooltipSVG;
				var _props2 = this.props,
				    bgheight = _props2.bgheight,
				    bgwidth = _props2.bgwidth;
				var height = moreProps.height;
				var x = pointer.x,
				    y = pointer.y,
				    content = pointer.content,
				    centerX = pointer.centerX,
				    pointWidth = pointer.pointWidth,
				    bgSize = pointer.bgSize;
	
	
				var bgShape = (0, _utils.isDefined)(bgwidth) && (0, _utils.isDefined)(bgheight) ? { width: bgwidth, height: bgheight } : bgSize;
	
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("rect", { x: centerX - pointWidth / 2,
						y: 0,
						width: pointWidth,
						height: height,
						fill: bgFill,
						opacity: bgOpacity }),
					_react2.default.createElement(
						"g",
						{ className: "react-stockcharts-tooltip-content", transform: "translate(" + x + ", " + y + ")" },
						backgroundShapeSVG(this.props, bgShape),
						tooltipSVG(this.props, content)
					)
				);
			}
		}]);
	
		return HoverTooltip;
	}(_react.Component);
	
	HoverTooltip.propTypes = {
		chartId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
		yAccessor: _propTypes2.default.func,
		tooltipSVG: _propTypes2.default.func,
		backgroundShapeSVG: _propTypes2.default.func,
		bgwidth: _propTypes2.default.number,
		bgheight: _propTypes2.default.number,
		bgFill: _propTypes2.default.string.isRequired,
		bgOpacity: _propTypes2.default.number.isRequired,
		tooltipContent: _propTypes2.default.func.isRequired,
		origin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]).isRequired,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number
	};
	
	HoverTooltip.contextTypes = {
		margin: _propTypes2.default.object.isRequired,
		ratio: _propTypes2.default.number.isRequired
	};
	
	HoverTooltip.defaultProps = {
		// bgwidth: 150,
		// bgheight: 50,
		tooltipSVG: tooltipSVG,
		tooltipCanvas: tooltipCanvas,
		origin: origin,
		fill: "#D4E2FD",
		bgFill: "#D4E2FD",
		bgOpacity: 0.5,
		stroke: "#9B9BFF",
		fontFill: "#000000",
		opacity: 0.8,
		backgroundShapeSVG: backgroundShapeSVG,
		backgroundShapeCanvas: backgroundShapeCanvas,
		fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
		fontSize: 12
	};
	
	var PADDING = 5;
	var X = 10;
	var Y = 10;
	
	/* eslint-disable react/prop-types */
	function backgroundShapeSVG(_ref, _ref2) {
		var fill = _ref.fill,
		    stroke = _ref.stroke,
		    opacity = _ref.opacity;
		var height = _ref2.height,
		    width = _ref2.width;
	
		return _react2.default.createElement("rect", {
			height: height,
			width: width,
			fill: fill,
			opacity: opacity,
			stroke: stroke });
	}
	
	function tooltipSVG(_ref3, content) {
		var fontFamily = _ref3.fontFamily,
		    fontSize = _ref3.fontSize,
		    fontFill = _ref3.fontFill;
	
		var tspans = [];
		var startY = Y + fontSize * 0.9;
	
		for (var i = 0; i < content.y.length; i++) {
			var y = content.y[i];
			var textY = startY + fontSize * (i + 1);
	
			tspans.push(_react2.default.createElement(
				"tspan",
				{ key: "L-" + i, x: X, y: textY, fill: y.stroke },
				y.label
			));
			tspans.push(_react2.default.createElement(
				"tspan",
				{ key: i },
				": "
			));
			tspans.push(_react2.default.createElement(
				"tspan",
				{ key: "V-" + i },
				y.value
			));
		}
		return _react2.default.createElement(
			"text",
			{ fontFamily: fontFamily, fontSize: fontSize, fill: fontFill },
			_react2.default.createElement(
				"tspan",
				{ x: X, y: startY },
				content.x
			),
			tspans
		);
	}
	/* eslint-enable react/prop-types */
	
	function backgroundShapeCanvas(props, _ref4, ctx) {
		var width = _ref4.width,
		    height = _ref4.height;
		var fill = props.fill,
		    stroke = props.stroke,
		    opacity = props.opacity;
	
	
		ctx.fillStyle = (0, _utils.hexToRGBA)(fill, opacity);
		ctx.strokeStyle = stroke;
		ctx.beginPath();
		ctx.rect(0, 0, width, height);
		ctx.fill();
		ctx.stroke();
	}
	
	function tooltipCanvas(_ref5, content, ctx) {
		var fontFamily = _ref5.fontFamily,
		    fontSize = _ref5.fontSize,
		    fontFill = _ref5.fontFill;
	
		var startY = Y + fontSize * 0.9;
		ctx.font = fontSize + "px " + fontFamily;
		ctx.fillStyle = fontFill;
		ctx.textAlign = "left";
		ctx.fillText(content.x, X, startY);
	
		for (var i = 0; i < content.y.length; i++) {
			var y = content.y[i];
			var textY = startY + fontSize * (i + 1);
			ctx.fillStyle = y.stroke || fontFill;
			ctx.fillText(y.label, X, textY);
	
			ctx.fillStyle = fontFill;
			ctx.fillText(": " + y.value, X + ctx.measureText(y.label).width, textY);
		}
	}
	
	function _drawOnCanvas(ctx, props, context, pointer, height) {
		var margin = context.margin,
		    ratio = context.ratio;
		var bgFill = props.bgFill,
		    bgOpacity = props.bgOpacity;
		var backgroundShapeCanvas = props.backgroundShapeCanvas,
		    tooltipCanvas = props.tooltipCanvas;
	
	
		var originX = 0.5 * ratio + margin.left;
		var originY = 0.5 * ratio + margin.top;
	
		ctx.save();
	
		ctx.setTransform(1, 0, 0, 1, 0, 0);
		ctx.scale(ratio, ratio);
	
		ctx.translate(originX, originY);
	
		var x = pointer.x,
		    y = pointer.y,
		    content = pointer.content,
		    centerX = pointer.centerX,
		    pointWidth = pointer.pointWidth,
		    bgSize = pointer.bgSize;
	
	
		ctx.fillStyle = (0, _utils.hexToRGBA)(bgFill, bgOpacity);
		ctx.beginPath();
		ctx.rect(centerX - pointWidth / 2, 0, pointWidth, height);
		ctx.fill();
	
		ctx.translate(x, y);
		backgroundShapeCanvas(props, bgSize, ctx);
		tooltipCanvas(props, content, ctx);
	
		ctx.restore();
	}
	
	function calculateTooltipSize(_ref6, content, ctx) {
		var fontFamily = _ref6.fontFamily,
		    fontSize = _ref6.fontSize,
		    fontFill = _ref6.fontFill;
	
		if ((0, _utils.isNotDefined)(ctx)) {
			var canvas = document.createElement("canvas");
			ctx = canvas.getContext("2d");
		}
	
		ctx.font = fontSize + "px " + fontFamily;
		ctx.fillStyle = fontFill;
		ctx.textAlign = "left";
	
		var measureText = function measureText(str) {
			return {
				width: ctx.measureText(str).width,
				height: fontSize
			};
		};
	
		var _content$y$map$reduce = content.y.map(function (_ref7) {
			var label = _ref7.label,
			    value = _ref7.value;
			return measureText(label + ": " + value);
		})
		// Sum all y and x sizes (begin with x label size)
		.reduce(function (res, size) {
			return sumSizes(res, size);
		}, measureText(String(content.x))),
		    width = _content$y$map$reduce.width,
		    height = _content$y$map$reduce.height;
	
		return {
			width: width + 2 * X,
			height: height + 2 * Y
		};
	}
	
	function sumSizes() {
		for (var _len = arguments.length, sizes = Array(_len), _key = 0; _key < _len; _key++) {
			sizes[_key] = arguments[_key];
		}
	
		return {
			width: Math.max.apply(Math, _toConsumableArray(sizes.map(function (size) {
				return size.width;
			}))),
			height: (0, _d3Array.sum)(sizes, function (d) {
				return d.height;
			})
		};
	}
	
	function normalizeX(x, bgSize, pointWidth, width) {
		// return x - bgSize.width - pointWidth / 2 - PADDING * 2 < 0
		return x < width / 2 ? x + pointWidth / 2 + PADDING : x - bgSize.width - pointWidth / 2 - PADDING;
	}
	
	function normalizeY(y, bgSize) {
		return y - bgSize.height <= 0 ? y + PADDING : y - bgSize.height - PADDING;
	}
	
	function origin(props, moreProps, bgSize, pointWidth) {
		var chartId = props.chartId,
		    yAccessor = props.yAccessor;
		var mouseXY = moreProps.mouseXY,
		    xAccessor = moreProps.xAccessor,
		    currentItem = moreProps.currentItem,
		    xScale = moreProps.xScale,
		    chartConfig = moreProps.chartConfig,
		    width = moreProps.width;
	
		var y = (0, _utils.last)(mouseXY);
	
		var xValue = xAccessor(currentItem);
		var x = Math.round(xScale(xValue));
	
		if ((0, _utils.isDefined)(chartId) && (0, _utils.isDefined)(yAccessor) && (0, _utils.isDefined)(chartConfig) && (0, _utils.isDefined)(chartConfig.findIndex)) {
			var yValue = yAccessor(currentItem);
			var chartIndex = chartConfig.findIndex(function (x) {
				return x.id === chartId;
			});
	
			y = Math.round(chartConfig[chartIndex].yScale(yValue));
		}
	
		x = normalizeX(x, bgSize, pointWidth, width);
		y = normalizeY(y, bgSize);
	
		return [x, y];
	}
	
	function helper(props, moreProps, ctx) {
		var show = moreProps.show,
		    xScale = moreProps.xScale,
		    currentItem = moreProps.currentItem,
		    plotData = moreProps.plotData;
		var origin = props.origin,
		    tooltipContent = props.tooltipContent;
		var xAccessor = moreProps.xAccessor,
		    displayXAccessor = moreProps.displayXAccessor;
	
	
		if (!show || (0, _utils.isNotDefined)(currentItem)) return;
	
		var xValue = xAccessor(currentItem);
	
		if (!show || (0, _utils.isNotDefined)(xValue)) return;
	
		var content = tooltipContent({ currentItem: currentItem, xAccessor: displayXAccessor });
		var centerX = xScale(xValue);
		var pointWidth = Math.abs(xScale(xAccessor((0, _utils.last)(plotData))) - xScale(xAccessor((0, _utils.first)(plotData)))) / (plotData.length - 1);
	
		var bgSize = calculateTooltipSize(props, content, ctx);
	
		var _origin = origin(props, moreProps, bgSize, pointWidth),
		    _origin2 = _slicedToArray(_origin, 2),
		    x = _origin2[0],
		    y = _origin2[1];
	
		return { x: x, y: y, content: content, centerX: centerX, pointWidth: pointWidth, bgSize: bgSize };
	}
	
	exports.default = HoverTooltip;
	//# sourceMappingURL=HoverTooltip.js.map

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Format = __webpack_require__(33);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _displayValuesFor = __webpack_require__(59);
	
	var _displayValuesFor2 = _interopRequireDefault(_displayValuesFor);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _ToolTipText = __webpack_require__(50);
	
	var _ToolTipText2 = _interopRequireDefault(_ToolTipText);
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MACDTooltip = function (_Component) {
		_inherits(MACDTooltip, _Component);
	
		function MACDTooltip(props) {
			_classCallCheck(this, MACDTooltip);
	
			var _this = _possibleConstructorReturn(this, (MACDTooltip.__proto__ || Object.getPrototypeOf(MACDTooltip)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			return _this;
		}
	
		_createClass(MACDTooltip, [{
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    onClick = _props.onClick,
				    fontFamily = _props.fontFamily,
				    fontSize = _props.fontSize,
				    displayFormat = _props.displayFormat,
				    className = _props.className;
				var _props2 = this.props,
				    yAccessor = _props2.yAccessor,
				    options = _props2.options,
				    appearance = _props2.appearance,
				    labelFill = _props2.labelFill;
				var displayValuesFor = this.props.displayValuesFor;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    width = _moreProps$chartConfi.width,
				    height = _moreProps$chartConfi.height;
	
	
				var currentItem = displayValuesFor(this.props, moreProps);
				var macdValue = currentItem && yAccessor(currentItem);
	
				var macd = macdValue && macdValue.macd && displayFormat(macdValue.macd) || "n/a";
				var signal = macdValue && macdValue.signal && displayFormat(macdValue.signal) || "n/a";
				var divergence = macdValue && macdValue.divergence && displayFormat(macdValue.divergence) || "n/a";
	
				var originProp = this.props.origin;
	
				var origin = (0, _utils.functor)(originProp);
	
				var _origin = origin(width, height),
				    _origin2 = _slicedToArray(_origin, 2),
				    x = _origin2[0],
				    y = _origin2[1];
	
				return _react2.default.createElement(
					"g",
					{ className: className, transform: "translate(" + x + ", " + y + ")", onClick: onClick },
					_react2.default.createElement(
						_ToolTipText2.default,
						{ x: 0, y: 0,
							fontFamily: fontFamily, fontSize: fontSize },
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							"MACD ("
						),
						_react2.default.createElement(
							"tspan",
							{ fill: appearance.stroke.macd },
							options.slow
						),
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							", "
						),
						_react2.default.createElement(
							"tspan",
							{ fill: appearance.stroke.macd },
							options.fast
						),
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							"): "
						),
						_react2.default.createElement(
							"tspan",
							{ fill: appearance.stroke.macd },
							macd
						),
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							" Signal ("
						),
						_react2.default.createElement(
							"tspan",
							{ fill: appearance.stroke.signal },
							options.signal
						),
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							"): "
						),
						_react2.default.createElement(
							"tspan",
							{ fill: appearance.stroke.signal },
							signal
						),
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							" Divergence: "
						),
						_react2.default.createElement(
							"tspan",
							{ fill: appearance.fill.divergence },
							divergence
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					drawOn: ["mousemove"]
				});
			}
		}]);
	
		return MACDTooltip;
	}(_react.Component);
	
	MACDTooltip.propTypes = {
		origin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]).isRequired,
		className: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		labelFill: _propTypes2.default.string,
	
		yAccessor: _propTypes2.default.func.isRequired,
		options: _propTypes2.default.shape({
			slow: _propTypes2.default.number.isRequired,
			fast: _propTypes2.default.number.isRequired,
			signal: _propTypes2.default.number.isRequired
		}).isRequired,
		appearance: _propTypes2.default.shape({
			stroke: {
				macd: _propTypes2.default.string.isRequired,
				signal: _propTypes2.default.string.isRequired
			}.isRequired,
			fill: _propTypes2.default.shape({
				divergence: _propTypes2.default.string.isRequired
			}).isRequired
		}).isRequired,
		displayFormat: _propTypes2.default.func.isRequired,
		displayValuesFor: _propTypes2.default.func,
		onClick: _propTypes2.default.func
	};
	
	MACDTooltip.defaultProps = {
		origin: [0, 0],
		displayFormat: (0, _d3Format.format)(".2f"),
		displayValuesFor: _displayValuesFor2.default,
		className: "react-stockcharts-tooltip"
	};
	
	exports.default = MACDTooltip;
	// export default MACDTooltip;
	//# sourceMappingURL=MACDTooltip.js.map

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(33);
	
	var _displayValuesFor = __webpack_require__(59);
	
	var _displayValuesFor2 = _interopRequireDefault(_displayValuesFor);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _ToolTipText = __webpack_require__(50);
	
	var _ToolTipText2 = _interopRequireDefault(_ToolTipText);
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleMAToolTip = function (_Component) {
		_inherits(SingleMAToolTip, _Component);
	
		function SingleMAToolTip(props) {
			_classCallCheck(this, SingleMAToolTip);
	
			var _this = _possibleConstructorReturn(this, (SingleMAToolTip.__proto__ || Object.getPrototypeOf(SingleMAToolTip)).call(this, props));
	
			_this.handleClick = _this.handleClick.bind(_this);
			return _this;
		}
	
		_createClass(SingleMAToolTip, [{
			key: "handleClick",
			value: function handleClick(e) {
				var _props = this.props,
				    onClick = _props.onClick,
				    forChart = _props.forChart,
				    options = _props.options;
	
				onClick(_extends({ chartId: forChart }, options), e);
			}
		}, {
			key: "render",
			value: function render() {
				var _props2 = this.props,
				    textFill = _props2.textFill,
				    labelFill = _props2.labelFill;
	
				var translate = "translate(" + this.props.origin[0] + ", " + this.props.origin[1] + ")";
				return _react2.default.createElement(
					"g",
					{ transform: translate },
					_react2.default.createElement("line", { x1: 0, y1: 2, x2: 0, y2: 28, stroke: this.props.color, strokeWidth: "4px" }),
					_react2.default.createElement(
						_ToolTipText2.default,
						{ x: 5, y: 11,
							fontFamily: this.props.fontFamily, fontSize: this.props.fontSize },
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							this.props.displayName
						),
						_react2.default.createElement(
							"tspan",
							{ x: "5", dy: "15", fill: textFill },
							this.props.value
						)
					),
					_react2.default.createElement("rect", { x: 0, y: 0, width: 55, height: 30,
						onClick: this.handleClick,
						fill: "none", stroke: "none" })
				);
			}
		}]);
	
		return SingleMAToolTip;
	}(_react.Component);
	
	SingleMAToolTip.propTypes = {
		origin: _propTypes2.default.array.isRequired,
		color: _propTypes2.default.string.isRequired,
		displayName: _propTypes2.default.string.isRequired,
		value: _propTypes2.default.string.isRequired,
		onClick: _propTypes2.default.func,
		fontFamily: _propTypes2.default.string,
		textFill: _propTypes2.default.string,
		labelFill: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		forChart: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
		options: _propTypes2.default.object.isRequired
	};
	
	var MovingAverageTooltip = function (_Component2) {
		_inherits(MovingAverageTooltip, _Component2);
	
		function MovingAverageTooltip(props) {
			_classCallCheck(this, MovingAverageTooltip);
	
			var _this2 = _possibleConstructorReturn(this, (MovingAverageTooltip.__proto__ || Object.getPrototypeOf(MovingAverageTooltip)).call(this, props));
	
			_this2.renderSVG = _this2.renderSVG.bind(_this2);
			return _this2;
		}
	
		_createClass(MovingAverageTooltip, [{
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var displayValuesFor = this.props.displayValuesFor;
				var chartId = moreProps.chartId;
				var chartConfig = moreProps.chartConfig;
				var _props3 = this.props,
				    className = _props3.className,
				    onClick = _props3.onClick,
				    width = _props3.width,
				    fontFamily = _props3.fontFamily,
				    fontSize = _props3.fontSize,
				    textFill = _props3.textFill,
				    labelFill = _props3.labelFill;
				var _props4 = this.props,
				    originProp = _props4.origin,
				    displayFormat = _props4.displayFormat,
				    options = _props4.options;
				var height = moreProps.chartConfig.height;
	
	
				var currentItem = displayValuesFor(this.props, moreProps);
				var config = chartConfig;
	
				var origin = (0, _utils.functor)(originProp);
	
				var _origin = origin(width, height),
				    _origin2 = _slicedToArray(_origin, 2),
				    x = _origin2[0],
				    y = _origin2[1];
	
				var _config$origin = _slicedToArray(config.origin, 2),
				    ox = _config$origin[0],
				    oy = _config$origin[1];
	
				return _react2.default.createElement(
					"g",
					{ transform: "translate(" + (ox + x) + ", " + (oy + y) + ")", className: className },
					options.map(function (each, idx) {
						var yValue = currentItem && each.yAccessor(currentItem);
	
						var tooltipLabel = each.type + " (" + each.windowSize + ")";
						var yDisplayValue = yValue ? displayFormat(yValue) : "n/a";
						return _react2.default.createElement(SingleMAToolTip, {
							key: idx,
							origin: [width * idx, 0],
							color: each.stroke,
							displayName: tooltipLabel,
							value: yDisplayValue,
							options: each,
							forChart: chartId,
							onClick: onClick,
							fontFamily: fontFamily,
							fontSize: fontSize,
							textFill: textFill,
							labelFill: labelFill
						});
					})
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					drawOn: ["mousemove"]
				});
			}
		}]);
	
		return MovingAverageTooltip;
	}(_react.Component);
	
	MovingAverageTooltip.propTypes = {
		className: _propTypes2.default.string,
		displayFormat: _propTypes2.default.func.isRequired,
		origin: _propTypes2.default.array.isRequired,
		displayValuesFor: _propTypes2.default.func,
		onClick: _propTypes2.default.func,
		textFill: _propTypes2.default.string,
		labelFill: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		width: _propTypes2.default.number,
		options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			yAccessor: _propTypes2.default.func.isRequired,
			type: _propTypes2.default.string.isRequired,
			stroke: _propTypes2.default.string.isRequired,
			windowSize: _propTypes2.default.number.isRequired,
			echo: _propTypes2.default.any
		}))
	};
	
	MovingAverageTooltip.defaultProps = {
		className: "react-stockcharts-tooltip react-stockcharts-moving-average-tooltip",
		displayFormat: (0, _d3Format.format)(".2f"),
		displayValuesFor: _displayValuesFor2.default,
		origin: [0, 10],
		width: 65
	};
	
	exports.default = MovingAverageTooltip;
	//# sourceMappingURL=MovingAverageTooltip.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(33);
	
	var _d3TimeFormat = __webpack_require__(100);
	
	var _displayValuesFor = __webpack_require__(59);
	
	var _displayValuesFor2 = _interopRequireDefault(_displayValuesFor);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _utils = __webpack_require__(4);
	
	var _ToolTipText = __webpack_require__(50);
	
	var _ToolTipText2 = _interopRequireDefault(_ToolTipText);
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OHLCTooltip = function (_Component) {
		_inherits(OHLCTooltip, _Component);
	
		function OHLCTooltip(props) {
			_classCallCheck(this, OHLCTooltip);
	
			var _this = _possibleConstructorReturn(this, (OHLCTooltip.__proto__ || Object.getPrototypeOf(OHLCTooltip)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			return _this;
		}
	
		_createClass(OHLCTooltip, [{
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var displayValuesFor = this.props.displayValuesFor;
				var _props = this.props,
				    xDisplayFormat = _props.xDisplayFormat,
				    accessor = _props.accessor,
				    volumeFormat = _props.volumeFormat,
				    ohlcFormat = _props.ohlcFormat,
				    percentFormat = _props.percentFormat,
				    displayTexts = _props.displayTexts;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    width = _moreProps$chartConfi.width,
				    height = _moreProps$chartConfi.height;
				var displayXAccessor = moreProps.displayXAccessor;
	
	
				var currentItem = displayValuesFor(this.props, moreProps);
	
				var displayDate = void 0,
				    open = void 0,
				    high = void 0,
				    low = void 0,
				    close = void 0,
				    volume = void 0,
				    percent = void 0;
				displayDate = open = high = low = close = volume = percent = displayTexts.na;
	
				if ((0, _utils.isDefined)(currentItem) && (0, _utils.isDefined)(accessor(currentItem))) {
					var item = accessor(currentItem);
					volume = (0, _utils.isDefined)(item.volume) ? volumeFormat(item.volume) : displayTexts.na;
	
					displayDate = xDisplayFormat(displayXAccessor(item));
					open = ohlcFormat(item.open);
					high = ohlcFormat(item.high);
					low = ohlcFormat(item.low);
					close = ohlcFormat(item.close);
					percent = percentFormat((item.close - item.open) / item.open);
				}
	
				var originProp = this.props.origin;
	
				var origin = (0, _utils.functor)(originProp);
	
				var _origin = origin(width, height),
				    _origin2 = _slicedToArray(_origin, 2),
				    x = _origin2[0],
				    y = _origin2[1];
	
				var itemsToDisplay = {
					displayDate: displayDate,
					open: open,
					high: high,
					low: low,
					close: close,
					percent: percent,
					volume: volume,
					x: x,
					y: y
				};
				return this.props.children(this.props, moreProps, itemsToDisplay);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					drawOn: ["mousemove"]
				});
			}
		}]);
	
		return OHLCTooltip;
	}(_react.Component);
	
	OHLCTooltip.propTypes = {
		className: _propTypes2.default.string,
		accessor: _propTypes2.default.func,
		xDisplayFormat: _propTypes2.default.func,
		children: _propTypes2.default.func,
		volumeFormat: _propTypes2.default.func,
		percentFormat: _propTypes2.default.func,
		ohlcFormat: _propTypes2.default.func,
		origin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]),
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		onClick: _propTypes2.default.func,
		displayValuesFor: _propTypes2.default.func,
		textFill: _propTypes2.default.string,
		labelFill: _propTypes2.default.string,
		displayTexts: _propTypes2.default.object
	};
	
	var displayTextsDefault = {
		d: "Date: ",
		o: " O: ",
		h: " H: ",
		l: " L: ",
		c: " C: ",
		v: " Vol: ",
		na: "n/a"
	};
	
	OHLCTooltip.defaultProps = {
		accessor: function accessor(d) {
			return {
				date: d.date,
				open: d.open,
				high: d.high,
				low: d.low,
				close: d.close,
				volume: d.volume
			};
		},
		xDisplayFormat: (0, _d3TimeFormat.timeFormat)("%Y-%m-%d"),
		volumeFormat: (0, _d3Format.format)(".4s"),
		percentFormat: (0, _d3Format.format)(".2%"),
		ohlcFormat: (0, _d3Format.format)(".2f"),
		displayValuesFor: _displayValuesFor2.default,
		origin: [0, 0],
		children: defaultDisplay,
		displayTexts: displayTextsDefault
	};
	
	function defaultDisplay(props, moreProps, itemsToDisplay) {
	
		/* eslint-disable */
		var className = props.className,
		    textFill = props.textFill,
		    labelFill = props.labelFill,
		    onClick = props.onClick,
		    fontFamily = props.fontFamily,
		    fontSize = props.fontSize,
		    displayTexts = props.displayTexts;
		/* eslint-enable */
	
		var displayDate = itemsToDisplay.displayDate,
		    open = itemsToDisplay.open,
		    high = itemsToDisplay.high,
		    low = itemsToDisplay.low,
		    close = itemsToDisplay.close,
		    volume = itemsToDisplay.volume,
		    x = itemsToDisplay.x,
		    y = itemsToDisplay.y;
	
		return _react2.default.createElement(
			"g",
			{
				className: "react-stockcharts-tooltip-hover " + className,
				transform: "translate(" + x + ", " + y + ")",
				onClick: onClick
			},
			_react2.default.createElement(
				_ToolTipText2.default,
				{
					x: 0,
					y: 0,
					fontFamily: fontFamily,
					fontSize: fontSize
				},
				_react2.default.createElement(
					_ToolTipTSpanLabel2.default,
					{
						fill: labelFill,
						key: "label",
						x: 0,
						dy: "5" },
					displayTexts.d
				),
				_react2.default.createElement(
					"tspan",
					{ key: "value", fill: textFill },
					displayDate
				),
				_react2.default.createElement(
					_ToolTipTSpanLabel2.default,
					{ fill: labelFill, key: "label_O" },
					displayTexts.o
				),
				_react2.default.createElement(
					"tspan",
					{ key: "value_O", fill: textFill },
					open
				),
				_react2.default.createElement(
					_ToolTipTSpanLabel2.default,
					{ fill: labelFill, key: "label_H" },
					displayTexts.h
				),
				_react2.default.createElement(
					"tspan",
					{ key: "value_H", fill: textFill },
					high
				),
				_react2.default.createElement(
					_ToolTipTSpanLabel2.default,
					{ fill: labelFill, key: "label_L" },
					displayTexts.l
				),
				_react2.default.createElement(
					"tspan",
					{ key: "value_L", fill: textFill },
					low
				),
				_react2.default.createElement(
					_ToolTipTSpanLabel2.default,
					{ fill: labelFill, key: "label_C" },
					displayTexts.c
				),
				_react2.default.createElement(
					"tspan",
					{ key: "value_C", fill: textFill },
					close
				),
				_react2.default.createElement(
					_ToolTipTSpanLabel2.default,
					{ fill: labelFill, key: "label_Vol" },
					displayTexts.v
				),
				_react2.default.createElement(
					"tspan",
					{ key: "value_Vol", fill: textFill },
					volume
				)
			)
		);
	}
	
	exports.default = OHLCTooltip;
	//# sourceMappingURL=OHLCTooltip.js.map

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Format = __webpack_require__(33);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _displayValuesFor = __webpack_require__(59);
	
	var _displayValuesFor2 = _interopRequireDefault(_displayValuesFor);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _utils = __webpack_require__(4);
	
	var _ToolTipText = __webpack_require__(50);
	
	var _ToolTipText2 = _interopRequireDefault(_ToolTipText);
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RSITooltip = function (_Component) {
		_inherits(RSITooltip, _Component);
	
		function RSITooltip(props) {
			_classCallCheck(this, RSITooltip);
	
			var _this = _possibleConstructorReturn(this, (RSITooltip.__proto__ || Object.getPrototypeOf(RSITooltip)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			return _this;
		}
	
		_createClass(RSITooltip, [{
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    onClick = _props.onClick,
				    fontFamily = _props.fontFamily,
				    fontSize = _props.fontSize,
				    yAccessor = _props.yAccessor,
				    displayFormat = _props.displayFormat,
				    className = _props.className;
				var _props2 = this.props,
				    options = _props2.options,
				    labelFill = _props2.labelFill,
				    textFill = _props2.textFill;
				var displayValuesFor = this.props.displayValuesFor;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    width = _moreProps$chartConfi.width,
				    height = _moreProps$chartConfi.height;
	
	
				var currentItem = displayValuesFor(this.props, moreProps);
				var rsi = (0, _utils.isDefined)(currentItem) && yAccessor(currentItem);
				var value = rsi && displayFormat(rsi) || "n/a";
	
				var originProp = this.props.origin;
	
				var origin = (0, _utils.functor)(originProp);
	
				var _origin = origin(width, height),
				    _origin2 = _slicedToArray(_origin, 2),
				    x = _origin2[0],
				    y = _origin2[1];
	
				var tooltipLabel = "RSI (" + options.windowSize + "): ";
				return _react2.default.createElement(
					"g",
					{ className: className, transform: "translate(" + x + ", " + y + ")", onClick: onClick },
					_react2.default.createElement(
						_ToolTipText2.default,
						{ x: 0, y: 0,
							fontFamily: fontFamily, fontSize: fontSize },
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							tooltipLabel
						),
						_react2.default.createElement(
							"tspan",
							{ fill: textFill },
							value
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					drawOn: ["mousemove"]
				});
			}
		}]);
	
		return RSITooltip;
	}(_react.Component);
	
	RSITooltip.propTypes = {
		origin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]).isRequired,
		options: _propTypes2.default.shape({
			windowSize: _propTypes2.default.number.isRequired
		}).isRequired,
		className: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		onClick: _propTypes2.default.func,
		yAccessor: _propTypes2.default.func.isRequired,
		displayFormat: _propTypes2.default.func.isRequired,
		displayValuesFor: _propTypes2.default.func,
		textFill: _propTypes2.default.string,
		labelFill: _propTypes2.default.string
	};
	
	RSITooltip.defaultProps = {
		displayFormat: (0, _d3Format.format)(".2f"),
		displayValuesFor: _displayValuesFor2.default,
		origin: [0, 0],
		className: "react-stockcharts-tooltip"
	};
	
	exports.default = RSITooltip;
	//# sourceMappingURL=RSITooltip.js.map

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(33);
	
	var _displayValuesFor = __webpack_require__(59);
	
	var _displayValuesFor2 = _interopRequireDefault(_displayValuesFor);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _ToolTipText = __webpack_require__(50);
	
	var _ToolTipText2 = _interopRequireDefault(_ToolTipText);
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleValueTooltip = function (_Component) {
		_inherits(SingleValueTooltip, _Component);
	
		function SingleValueTooltip(props) {
			_classCallCheck(this, SingleValueTooltip);
	
			var _this = _possibleConstructorReturn(this, (SingleValueTooltip.__proto__ || Object.getPrototypeOf(SingleValueTooltip)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			return _this;
		}
	
		_createClass(SingleValueTooltip, [{
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    onClick = _props.onClick,
				    fontFamily = _props.fontFamily,
				    fontSize = _props.fontSize,
				    labelFill = _props.labelFill,
				    valueFill = _props.valueFill,
				    className = _props.className;
				var _props2 = this.props,
				    xDisplayFormat = _props2.xDisplayFormat,
				    yDisplayFormat = _props2.yDisplayFormat,
				    xLabel = _props2.xLabel,
				    yLabel = _props2.yLabel,
				    xAccessor = _props2.xAccessor,
				    yAccessor = _props2.yAccessor;
				var displayValuesFor = this.props.displayValuesFor;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    width = _moreProps$chartConfi.width,
				    height = _moreProps$chartConfi.height;
	
				var currentItem = displayValuesFor(this.props, moreProps);
	
				var xDisplayValue = (0, _utils.isDefined)(currentItem) && (0, _utils.isDefined)(xAccessor(currentItem)) ? xDisplayFormat(xAccessor(currentItem)) : "n/a";
				var yDisplayValue = (0, _utils.isDefined)(currentItem) && (0, _utils.isDefined)(yAccessor(currentItem)) ? yDisplayFormat(yAccessor(currentItem)) : "n/a";
	
				var originProp = this.props.origin;
	
				var origin = (0, _utils.functor)(originProp);
	
				var _origin = origin(width, height),
				    _origin2 = _slicedToArray(_origin, 2),
				    x = _origin2[0],
				    y = _origin2[1];
	
				return _react2.default.createElement(
					"g",
					{ className: className, transform: "translate(" + x + ", " + y + ")", onClick: onClick },
					_react2.default.createElement(
						_ToolTipText2.default,
						{ x: 0, y: 0,
							fontFamily: fontFamily, fontSize: fontSize },
						xLabel ? _react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ x: 0, dy: "5", fill: labelFill },
							xLabel + ": "
						) : null,
						xLabel ? _react2.default.createElement(
							"tspan",
							{ fill: valueFill },
							xDisplayValue + " "
						) : null,
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							yLabel + ": "
						),
						_react2.default.createElement(
							"tspan",
							{ fill: valueFill },
							yDisplayValue
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					drawOn: ["mousemove"]
				});
			}
		}]);
	
		return SingleValueTooltip;
	}(_react.Component);
	
	SingleValueTooltip.propTypes = {
		xDisplayFormat: _propTypes2.default.func,
		yDisplayFormat: _propTypes2.default.func.isRequired,
		xLabel: _propTypes2.default.string,
		yLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
		labelFill: _propTypes2.default.string.isRequired,
		valueFill: _propTypes2.default.string,
		origin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]).isRequired,
		className: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		onClick: _propTypes2.default.func,
		displayValuesFor: _propTypes2.default.func,
		xAccessor: _propTypes2.default.func,
		yAccessor: _propTypes2.default.func
	};
	
	SingleValueTooltip.defaultProps = {
		origin: [0, 0],
		labelFill: "#4682B4",
		valueFill: "#000000",
		yDisplayFormat: (0, _d3Format.format)(".2f"),
		displayValuesFor: _displayValuesFor2.default,
		xAccessor: _utils.noop,
		yAccessor: _utils.identity,
		className: "react-stockcharts-tooltip"
	};
	
	exports.default = SingleValueTooltip;
	//# sourceMappingURL=SingleValueTooltip.js.map

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Format = __webpack_require__(33);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _displayValuesFor = __webpack_require__(59);
	
	var _displayValuesFor2 = _interopRequireDefault(_displayValuesFor);
	
	var _GenericChartComponent = __webpack_require__(12);
	
	var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);
	
	var _utils = __webpack_require__(4);
	
	var _ToolTipText = __webpack_require__(50);
	
	var _ToolTipText2 = _interopRequireDefault(_ToolTipText);
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StochasticTooltip = function (_Component) {
		_inherits(StochasticTooltip, _Component);
	
		function StochasticTooltip(props) {
			_classCallCheck(this, StochasticTooltip);
	
			var _this = _possibleConstructorReturn(this, (StochasticTooltip.__proto__ || Object.getPrototypeOf(StochasticTooltip)).call(this, props));
	
			_this.renderSVG = _this.renderSVG.bind(_this);
			return _this;
		}
	
		_createClass(StochasticTooltip, [{
			key: "renderSVG",
			value: function renderSVG(moreProps) {
				var _props = this.props,
				    onClick = _props.onClick,
				    fontFamily = _props.fontFamily,
				    fontSize = _props.fontSize,
				    yAccessor = _props.yAccessor,
				    displayFormat = _props.displayFormat,
				    label = _props.label;
				var _props2 = this.props,
				    className = _props2.className,
				    options = _props2.options,
				    appearance = _props2.appearance,
				    labelFill = _props2.labelFill;
				var displayValuesFor = this.props.displayValuesFor;
				var _moreProps$chartConfi = moreProps.chartConfig,
				    width = _moreProps$chartConfi.width,
				    height = _moreProps$chartConfi.height;
	
	
				var currentItem = displayValuesFor(this.props, moreProps);
				var stroke = appearance.stroke;
	
				var stochastic = currentItem && yAccessor(currentItem);
	
				var K = stochastic && stochastic.K && displayFormat(stochastic.K) || "n/a";
				var D = stochastic && stochastic.D && displayFormat(stochastic.D) || "n/a";
	
				var originProp = this.props.origin;
	
				var origin = (0, _utils.functor)(originProp);
	
				var _origin = origin(width, height),
				    _origin2 = _slicedToArray(_origin, 2),
				    x = _origin2[0],
				    y = _origin2[1];
	
				return _react2.default.createElement(
					"g",
					{ className: className, transform: "translate(" + x + ", " + y + ")", onClick: onClick },
					_react2.default.createElement(
						_ToolTipText2.default,
						{ x: 0, y: 0, fontFamily: fontFamily, fontSize: fontSize },
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							label + " %K("
						),
						_react2.default.createElement(
							"tspan",
							{ fill: stroke.kLine },
							options.windowSize + ", " + options.kWindowSize
						),
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							"): "
						),
						_react2.default.createElement(
							"tspan",
							{ fill: stroke.kLine },
							K
						),
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							" %D ("
						),
						_react2.default.createElement(
							"tspan",
							{ fill: stroke.dLine },
							options.dWindowSize
						),
						_react2.default.createElement(
							_ToolTipTSpanLabel2.default,
							{ fill: labelFill },
							"): "
						),
						_react2.default.createElement(
							"tspan",
							{ fill: stroke.dLine },
							D
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(_GenericChartComponent2.default, {
					clip: false,
					svgDraw: this.renderSVG,
					drawOn: ["mousemove"]
				});
			}
		}]);
	
		return StochasticTooltip;
	}(_react.Component);
	
	StochasticTooltip.propTypes = {
		origin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]).isRequired,
		className: _propTypes2.default.string,
		fontFamily: _propTypes2.default.string,
		fontSize: _propTypes2.default.number,
		labelFill: _propTypes2.default.string,
	
		onClick: _propTypes2.default.func,
		yAccessor: _propTypes2.default.func.isRequired,
		options: _propTypes2.default.shape({
			windowSize: _propTypes2.default.number.isRequired,
			kWindowSize: _propTypes2.default.number.isRequired,
			dWindowSize: _propTypes2.default.number.isRequired
		}).isRequired,
		appearance: _propTypes2.default.shape({
			stroke: {
				dLine: _propTypes2.default.string.isRequired,
				kLine: _propTypes2.default.string.isRequired
			}.isRequired
		}).isRequired,
		displayFormat: _propTypes2.default.func.isRequired,
		displayValuesFor: _propTypes2.default.func,
		label: _propTypes2.default.string.isRequired
	};
	
	StochasticTooltip.defaultProps = {
		displayFormat: (0, _d3Format.format)(".2f"),
		displayValuesFor: _displayValuesFor2.default,
		origin: [0, 0],
		className: "react-stockcharts-tooltip",
		label: "STO"
	};
	
	exports.default = StochasticTooltip;
	//# sourceMappingURL=StochasticTooltip.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MACDTooltip = __webpack_require__(775);
	
	Object.defineProperty(exports, "MACDTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MACDTooltip).default;
	  }
	});
	
	var _OHLCTooltip = __webpack_require__(777);
	
	Object.defineProperty(exports, "OHLCTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OHLCTooltip).default;
	  }
	});
	
	var _SingleValueTooltip = __webpack_require__(779);
	
	Object.defineProperty(exports, "SingleValueTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SingleValueTooltip).default;
	  }
	});
	
	var _MovingAverageTooltip = __webpack_require__(776);
	
	Object.defineProperty(exports, "MovingAverageTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MovingAverageTooltip).default;
	  }
	});
	
	var _BollingerBandTooltip = __webpack_require__(772);
	
	Object.defineProperty(exports, "BollingerBandTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BollingerBandTooltip).default;
	  }
	});
	
	var _RSITooltip = __webpack_require__(778);
	
	Object.defineProperty(exports, "RSITooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RSITooltip).default;
	  }
	});
	
	var _StochasticTooltip = __webpack_require__(780);
	
	Object.defineProperty(exports, "StochasticTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StochasticTooltip).default;
	  }
	});
	
	var _HoverTooltip = __webpack_require__(774);
	
	Object.defineProperty(exports, "HoverTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoverTooltip).default;
	  }
	});
	
	var _ToolTipText = __webpack_require__(50);
	
	Object.defineProperty(exports, "ToolTipText", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ToolTipText).default;
	  }
	});
	
	var _ToolTipTSpanLabel = __webpack_require__(49);
	
	Object.defineProperty(exports, "ToolTipTSpanLabel", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ToolTipTSpanLabel).default;
	  }
	});
	
	var _GroupTooltip = __webpack_require__(773);
	
	Object.defineProperty(exports, "GroupTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupTooltip).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var accumulateTill = (0, _index.functor)(false),
		    accumulator = _noop2.default,
		    value = _identity2.default,
		    discardTillStart = false,
		    discardTillEnd = false;
	
		// eslint-disable-next-line prefer-const
		var accumulatingWindow = function accumulatingWindow(data) {
			var accumulatedWindow = discardTillStart ? undefined : [];
			var response = [];
			var accumulatorIdx = 0;
			var i = 0;
			for (i = 0; i < data.length; i++) {
				var d = data[i];
				// console.log(d, accumulateTill(d));
				if (accumulateTill(d, i, accumulatedWindow || [])) {
					if (accumulatedWindow && accumulatedWindow.length > 0) response.push(accumulator(accumulatedWindow, i, accumulatorIdx++));
					accumulatedWindow = [value(d)];
				} else {
					if (accumulatedWindow) accumulatedWindow.push(value(d));
				}
			}
			if (!discardTillEnd) response.push(accumulator(accumulatedWindow, i, accumulatorIdx));
			return response;
		};
	
		accumulatingWindow.accumulateTill = function (x) {
			if (!arguments.length) {
				return accumulateTill;
			}
			accumulateTill = (0, _index.functor)(x);
			return accumulatingWindow;
		};
		accumulatingWindow.accumulator = function (x) {
			if (!arguments.length) {
				return accumulator;
			}
			accumulator = x;
			return accumulatingWindow;
		};
		accumulatingWindow.value = function (x) {
			if (!arguments.length) {
				return value;
			}
			value = x;
			return accumulatingWindow;
		};
		accumulatingWindow.discardTillStart = function (x) {
			if (!arguments.length) {
				return discardTillStart;
			}
			discardTillStart = x;
			return accumulatingWindow;
		};
		accumulatingWindow.discardTillEnd = function (x) {
			if (!arguments.length) {
				return discardTillEnd;
			}
			discardTillEnd = x;
			return accumulatingWindow;
		};
		return accumulatingWindow;
	};
	
	var _noop = __webpack_require__(97);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _identity = __webpack_require__(96);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _index = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=accumulatingWindow.js.map

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.plotDataLengthBarWidth = plotDataLengthBarWidth;
	exports.timeIntervalBarWidth = timeIntervalBarWidth;
	
	var _utils = __webpack_require__(4);
	
	/**
	 * Bar width is based on the amount of items in the plot data and the distance between the first and last of those
	 * items.
	 * @param props the props passed to the series.
	 * @param moreProps an object holding the xScale, xAccessor and plotData.
	 * @return {number} the bar width.
	 */
	function plotDataLengthBarWidth(props, moreProps) {
		var widthRatio = props.widthRatio;
		var xScale = moreProps.xScale;
	
		var _xScale$range = xScale.range(),
		    _xScale$range2 = _slicedToArray(_xScale$range, 2),
		    l = _xScale$range2[0],
		    r = _xScale$range2[1];
	
		var totalWidth = Math.abs(r - l);
		if (xScale.invert != null) {
			var _xScale$domain = xScale.domain(),
			    _xScale$domain2 = _slicedToArray(_xScale$domain, 2),
			    dl = _xScale$domain2[0],
			    dr = _xScale$domain2[1];
	
			var width = totalWidth / Math.abs(dl - dr);
			return width * widthRatio;
		} else {
			var _width = totalWidth / xScale.domain().length;
			return _width * widthRatio;
		}
	}
	
	/**
	 * Generates a width function that calculates the bar width based on the given time interval.
	 * @param interval a d3-time time interval.
	 * @return {Function} the width function.
	 */
	function timeIntervalBarWidth(interval) {
		return function (props, moreProps) {
			var widthRatio = props.widthRatio;
			var xScale = moreProps.xScale,
			    xAccessor = moreProps.xAccessor,
			    plotData = moreProps.plotData;
	
	
			var first = xAccessor((0, _utils.head)(plotData));
			return Math.abs(xScale(interval.offset(first, 1)) - xScale(first)) * widthRatio;
		};
	}
	//# sourceMappingURL=barWidth.js.map

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var undefinedValue = undefined,
		    windowSize = 10,
		    accumulator = _noop2.default,
		    source = _identity2.default,
		    skipInitial = 0;
	
		// eslint-disable-next-line prefer-const
		var mappedSlidingWindow = function mappedSlidingWindow(data) {
			var size = (0, _index.functor)(windowSize).apply(this, arguments);
			var windowData = [];
			var accumulatorIdx = 0;
			var undef = (0, _index.functor)(undefinedValue);
			// console.log(skipInitial, size, data.length, windowData.length);
			var result = [];
			data.forEach(function (d, i) {
				// console.log(d, i, windowData.length);
				var mapped = void 0;
				if (i < skipInitial + size - 1) {
					mapped = undef(d, i);
					result.push(mapped);
					windowData.push(mapped);
					return;
				}
				if (i >= skipInitial + size) {
					// Treat windowData as FIFO rolling buffer
					windowData.shift();
				}
				windowData.push(source(d, i));
				mapped = accumulator(windowData, i, accumulatorIdx++);
				result.push(mapped);
				windowData.pop();
				windowData.push(mapped);
				return;
			});
			return result;
		};
	
		mappedSlidingWindow.undefinedValue = function (x) {
			if (!arguments.length) {
				return undefinedValue;
			}
			undefinedValue = x;
			return mappedSlidingWindow;
		};
		mappedSlidingWindow.windowSize = function (x) {
			if (!arguments.length) {
				return windowSize;
			}
			windowSize = x;
			return mappedSlidingWindow;
		};
		mappedSlidingWindow.accumulator = function (x) {
			if (!arguments.length) {
				return accumulator;
			}
			accumulator = x;
			return mappedSlidingWindow;
		};
		mappedSlidingWindow.skipInitial = function (x) {
			if (!arguments.length) {
				return skipInitial;
			}
			skipInitial = x;
			return mappedSlidingWindow;
		};
		mappedSlidingWindow.source = function (x) {
			if (!arguments.length) {
				return source;
			}
			source = x;
			return mappedSlidingWindow;
		};
	
		return mappedSlidingWindow;
	};
	
	var _noop = __webpack_require__(97);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _identity = __webpack_require__(96);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _index = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=mappedSlidingWindow.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var algorithm = _identity2.default,
		    skipUndefined = true,
		    merge = _noop2.default;
	
		function mergeCompute(data) {
			var zip = (0, _zipper2.default)().combine(function (datum, indicator) {
				var result = skipUndefined && (0, _index.isNotDefined)(indicator) ? datum : merge(datum, indicator);
				return (0, _index.isNotDefined)(result) ? datum : result;
			});
	
			// console.log(data);
			return zip(data, algorithm(data));
		}
	
		mergeCompute.algorithm = function (x) {
			if (!arguments.length) {
				return algorithm;
			}
			algorithm = x;
			return mergeCompute;
		};
	
		mergeCompute.merge = function (x) {
			if (!arguments.length) {
				return merge;
			}
			merge = x;
			return mergeCompute;
		};
		mergeCompute.skipUndefined = function (x) {
			if (!arguments.length) {
				return skipUndefined;
			}
			skipUndefined = x;
			return mergeCompute;
		};
	
		return mergeCompute;
	};
	
	var _identity = __webpack_require__(96);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _zipper = __webpack_require__(405);
	
	var _zipper2 = _interopRequireDefault(_zipper);
	
	var _noop = __webpack_require__(97);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _index = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = rebind;
	// copied from https://github.com/d3fc/d3fc-rebind/blob/master/src/rebind.js
	
	function createReboundMethod(target, source, name) {
		var method = source[name];
		if (typeof method !== "function") {
			throw new Error("Attempt to rebind " + name + " which isn't a function on the source object");
		}
		return function () {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			var value = method.apply(source, args);
			return value === source ? target : value;
		};
	}
	
	function rebind(target, source) {
		for (var _len2 = arguments.length, names = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
			names[_key2 - 2] = arguments[_key2];
		}
	
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var name = _step.value;
	
				target[name] = createReboundMethod(target, source, name);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	
		return target;
	}
	//# sourceMappingURL=rebind.js.map

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
	
		var undefinedValue = undefined,
		    windowSize = 10,
		    accumulator = _noop2.default,
		    sourcePath = void 0,
		    source = void 0,
		    skipInitial = 0,
		    misc = void 0;
	
		// eslint-disable-next-line prefer-const
		var slidingWindow = function slidingWindow(data) {
			var sourceFunction = source || (0, _index.path)(sourcePath);
	
			var size = (0, _index.functor)(windowSize).apply(this, arguments);
			var windowData = data.slice(skipInitial, size + skipInitial).map(sourceFunction);
			var accumulatorIdx = 0;
			var undef = (0, _index.functor)(undefinedValue);
			// console.log(skipInitial, size, data.length, windowData.length);
			return data.map(function (d, i) {
				// console.log(d, i);
				if (i < skipInitial + size - 1) {
					return undef(sourceFunction(d), i, misc);
				}
				if (i >= skipInitial + size) {
					// Treat windowData as FIFO rolling buffer
					windowData.shift();
					windowData.push(sourceFunction(d, i));
				}
				return accumulator(windowData, i, accumulatorIdx++, misc);
			});
		};
	
		slidingWindow.undefinedValue = function (x) {
			if (!arguments.length) {
				return undefinedValue;
			}
			undefinedValue = x;
			return slidingWindow;
		};
		slidingWindow.windowSize = function (x) {
			if (!arguments.length) {
				return windowSize;
			}
			windowSize = x;
			return slidingWindow;
		};
		slidingWindow.misc = function (x) {
			if (!arguments.length) {
				return misc;
			}
			misc = x;
			return slidingWindow;
		};
		slidingWindow.accumulator = function (x) {
			if (!arguments.length) {
				return accumulator;
			}
			accumulator = x;
			return slidingWindow;
		};
		slidingWindow.skipInitial = function (x) {
			if (!arguments.length) {
				return skipInitial;
			}
			skipInitial = x;
			return slidingWindow;
		};
		slidingWindow.sourcePath = function (x) {
			if (!arguments.length) {
				return sourcePath;
			}
			sourcePath = x;
			return slidingWindow;
		};
		slidingWindow.source = function (x) {
			if (!arguments.length) {
				return source;
			}
			source = x;
			return slidingWindow;
		};
	
		return slidingWindow;
	};
	
	var _noop = __webpack_require__(97);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _index = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=slidingWindow.js.map

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getStrokeDasharrayCanvas = getStrokeDasharrayCanvas;
	var strokeDashTypes = exports.strokeDashTypes = ["Solid", "ShortDash", "ShortDash2", "ShortDot", "ShortDashDot", "ShortDashDotDot", "Dot", "Dash", "LongDash", "DashDot", "LongDashDot", "LongDashDotDot"];
	
	function getStrokeDasharrayCanvas(type) {
		var a = getStrokeDasharray(type).split(",");
	
		if (a.length === 1) return [];
	
		return a.map(function (d) {
			return Number(d);
		});
	}
	var getStrokeDasharray = exports.getStrokeDasharray = function getStrokeDasharray(type) {
		switch (type) {
			default:
			case "Solid":
				return "none";
			case "ShortDash":
				return "6, 2";
			case "ShortDash2":
				return "6, 3";
			case "ShortDot":
				return "2, 2";
			case "ShortDashDot":
				return "6, 2, 2, 2";
			case "ShortDashDotDot":
				return "6, 2, 2, 2, 2, 2";
			case "Dot":
				return "2, 6";
			case "Dash":
				return "8, 6";
			case "LongDash":
				return "16, 6";
			case "DashDot":
				return "8, 6, 2, 6";
			case "LongDashDot":
				return "16, 6, 2, 6";
			case "LongDashDotDot":
				return "16, 6, 2, 6, 2, 6";
		}
	};
	//# sourceMappingURL=strokeDasharray.js.map

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.mouseBasedZoomAnchor = mouseBasedZoomAnchor;
	exports.lastVisibleItemBasedZoomAnchor = lastVisibleItemBasedZoomAnchor;
	exports.rightDomainBasedZoomAnchor = rightDomainBasedZoomAnchor;
	
	var _ChartDataUtil = __webpack_require__(166);
	
	var _index = __webpack_require__(4);
	
	/* eslint-disable no-unused-vars */
	
	function mouseBasedZoomAnchor(_ref) {
		var xScale = _ref.xScale,
		    xAccessor = _ref.xAccessor,
		    mouseXY = _ref.mouseXY,
		    plotData = _ref.plotData,
		    fullData = _ref.fullData;
	
		var currentItem = (0, _ChartDataUtil.getCurrentItem)(xScale, xAccessor, mouseXY, plotData);
		return xAccessor(currentItem);
	}
	
	function lastVisibleItemBasedZoomAnchor(_ref2) {
		var xScale = _ref2.xScale,
		    xAccessor = _ref2.xAccessor,
		    mouseXY = _ref2.mouseXY,
		    plotData = _ref2.plotData,
		    fullData = _ref2.fullData;
	
		var lastItem = (0, _index.last)(plotData);
		return xAccessor(lastItem);
	}
	
	function rightDomainBasedZoomAnchor(_ref3) {
		var xScale = _ref3.xScale,
		    xAccessor = _ref3.xAccessor,
		    mouseXY = _ref3.mouseXY,
		    plotData = _ref3.plotData,
		    fullData = _ref3.fullData;
	
		var _xScale$domain = xScale.domain(),
		    _xScale$domain2 = _slicedToArray(_xScale$domain, 2),
		    end = _xScale$domain2[1];
	
		return end;
	}
	/* eslint-enable no-unused-vars */
	//# sourceMappingURL=zoomBehavior.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var scriptLoading = false;
	var scriptLoaded = false;
	var scriptDidError = false;
	
	var ReactStripeCheckout = function (_React$Component) {
	  _inherits(ReactStripeCheckout, _React$Component);
	
	  function ReactStripeCheckout(props) {
	    _classCallCheck(this, ReactStripeCheckout);
	
	    var _this = _possibleConstructorReturn(this, (ReactStripeCheckout.__proto__ || Object.getPrototypeOf(ReactStripeCheckout)).call(this, props));
	
	    _this.onScriptLoaded = function () {
	      if (!ReactStripeCheckout.stripeHandler) {
	        ReactStripeCheckout.stripeHandler = StripeCheckout.configure({
	          key: _this.props.stripeKey
	        });
	        if (_this.hasPendingClick) {
	          _this.showStripeDialog();
	        }
	      }
	    };
	
	    _this.onScriptError = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.hideLoadingDialog();
	      if (_this.props.onScriptError) {
	        _this.props.onScriptError.apply(_this, args);
	      }
	    };
	
	    _this.onClosed = function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      if (_this._isMounted) _this.setState({ open: false });
	      if (_this.props.closed) {
	        _this.props.closed.apply(_this, args);
	      }
	    };
	
	    _this.onOpened = function () {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      _this.setState({ open: true });
	      if (_this.props.opened) {
	        _this.props.opened.apply(_this, args);
	      }
	    };
	
	    _this.getConfig = function () {
	      return ['token', 'image', 'name', 'description', 'amount', 'locale', 'currency', 'panelLabel', 'zipCode', 'shippingAddress', 'billingAddress', 'email', 'allowRememberMe', 'bitcoin', 'alipay', 'alipayReusable'].reduce(function (config, key) {
	        return _extends({}, config, _this.props.hasOwnProperty(key) && _defineProperty({}, key, _this.props[key]));
	      }, {
	        opened: _this.onOpened,
	        closed: _this.onClosed
	      });
	    };
	
	    _this.onClick = function () {
	      // eslint-disable-line react/sort-comp
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (scriptDidError) {
	        try {
	          throw new Error('Tried to call onClick, but StripeCheckout failed to load');
	        } catch (x) {} // eslint-disable-line no-empty
	      } else if (ReactStripeCheckout.stripeHandler) {
	        _this.showStripeDialog();
	      } else {
	        _this.showLoadingDialog();
	        _this.hasPendingClick = true;
	      }
	    };
	
	    _this.handleOnMouseDown = function () {
	      _this.setState({
	        buttonActive: true
	      });
	    };
	
	    _this.handleOnMouseUp = function () {
	      _this.setState({
	        buttonActive: false
	      });
	    };
	
	    _this.state = {
	      open: false,
	      buttonActive: false
	    };
	    return _this;
	  }
	
	  _createClass(ReactStripeCheckout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this._isMounted = true;
	      if (scriptLoaded) {
	        return;
	      }
	
	      if (scriptLoading) {
	        return;
	      }
	
	      scriptLoading = true;
	
	      var script = document.createElement('script');
	      if (typeof this.props.onScriptTagCreated === 'function') {
	        this.props.onScriptTagCreated(script);
	      }
	
	      script.src = 'https://checkout.stripe.com/checkout.js';
	      script.async = 1;
	
	      this.loadPromise = function () {
	        var canceled = false;
	        var promise = new Promise(function (resolve, reject) {
	          script.onload = function () {
	            scriptLoaded = true;
	            scriptLoading = false;
	            resolve();
	            _this2.onScriptLoaded();
	          };
	          script.onerror = function (event) {
	            scriptDidError = true;
	            scriptLoading = false;
	            reject(event);
	            _this2.onScriptError(event);
	          };
	        });
	        var wrappedPromise = new Promise(function (accept, cancel) {
	          promise.then(function () {
	            return canceled ? cancel({ isCanceled: true }) : accept();
	          }); // eslint-disable-line no-confusing-arrow
	          promise.catch(function (error) {
	            return canceled ? cancel({ isCanceled: true }) : cancel(error);
	          }); // eslint-disable-line no-confusing-arrow
	        });
	
	        return {
	          promise: wrappedPromise,
	          cancel: function cancel() {
	            canceled = true;
	          }
	        };
	      }();
	
	      this.loadPromise.promise.then(this.onScriptLoaded).catch(this.onScriptError);
	
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!scriptLoading) {
	        this.updateStripeHandler();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      if (this.loadPromise) {
	        this.loadPromise.cancel();
	      }
	      if (ReactStripeCheckout.stripeHandler && this.state.open) {
	        ReactStripeCheckout.stripeHandler.close();
	      }
	    }
	  }, {
	    key: 'updateStripeHandler',
	    value: function updateStripeHandler() {
	      if (!ReactStripeCheckout.stripeHandler || this.props.reconfigureOnUpdate) {
	        ReactStripeCheckout.stripeHandler = StripeCheckout.configure({
	          key: this.props.stripeKey
	        });
	      }
	    }
	  }, {
	    key: 'showLoadingDialog',
	    value: function showLoadingDialog() {
	      if (this.props.showLoadingDialog) {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        this.props.showLoadingDialog.apply(this, args);
	      }
	    }
	  }, {
	    key: 'hideLoadingDialog',
	    value: function hideLoadingDialog() {
	      if (this.props.hideLoadingDialog) {
	        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	          args[_key5] = arguments[_key5];
	        }
	
	        this.props.hideLoadingDialog.apply(this, args);
	      }
	    }
	  }, {
	    key: 'showStripeDialog',
	    value: function showStripeDialog() {
	      this.hideLoadingDialog();
	      ReactStripeCheckout.stripeHandler.open(this.getConfig());
	    }
	  }, {
	    key: 'renderDefaultStripeButton',
	    value: function renderDefaultStripeButton() {
	      return _react2.default.createElement(
	        'button',
	        _extends({}, _defineProperty({}, this.props.triggerEvent, this.onClick), {
	          className: this.props.className,
	          onMouseDown: this.handleOnMouseDown,
	          onFocus: this.handleOnMouseDown,
	          onMouseUp: this.handleOnMouseUp,
	          onMouseOut: this.handleOnMouseUp,
	          onBlur: this.handleOnMouseUp,
	          style: _extends({}, {
	            overflow: 'hidden',
	            display: 'inline-block',
	            background: 'linear-gradient(#28a0e5,#015e94)',
	            border: 0,
	            padding: 1,
	            textDecoration: 'none',
	            borderRadius: 5,
	            boxShadow: '0 1px 0 rgba(0,0,0,0.2)',
	            cursor: 'pointer',
	            visibility: 'visible',
	            userSelect: 'none'
	          }, this.state.buttonActive && {
	            background: '#005d93'
	          }, this.props.style)
	        }),
	        _react2.default.createElement(
	          'span',
	          {
	            style: _extends({}, {
	              backgroundImage: 'linear-gradient(#7dc5ee,#008cdd 85%,#30a2e4)',
	              fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	              fontSize: 14,
	              position: 'relative',
	              padding: '0 12px',
	              display: 'block',
	              height: 30,
	              lineHeight: '30px',
	              color: '#fff',
	              fontWeight: 'bold',
	              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25)',
	              textShadow: '0 -1px 0 rgba(0,0,0,0.25)',
	              borderRadius: 4
	            }, this.state.buttonActive && {
	              color: '#eee',
	              boxShadow: 'inset 0 1px 0 rgba(0,0,0,0.1)',
	              backgroundImage: 'linear-gradient(#008cdd,#008cdd 85%,#239adf)'
	            }, this.props.textStyle)
	          },
	          this.props.label
	        )
	      );
	    }
	  }, {
	    key: 'renderDisabledButton',
	    value: function renderDisabledButton() {
	      return _react2.default.createElement(
	        'button',
	        {
	          disabled: true,
	          style: {
	            background: 'rgba(0,0,0,0.2)',
	            overflow: 'hidden',
	            display: 'inline-block',
	            border: 0,
	            padding: 1,
	            textDecoration: 'none',
	            borderRadius: 5,
	            userSelect: 'none'
	          }
	        },
	        _react2.default.createElement(
	          'span',
	          {
	            style: {
	              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25)',
	              fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	              fontSize: 14,
	              position: 'relative',
	              padding: '0 12px',
	              display: 'block',
	              height: 30,
	              lineHeight: '30px',
	              borderRadius: 4,
	              color: '#999',
	              background: '#f8f9fa',
	              textShadow: '0 1px 0 rgba(255,255,255,0.5)'
	            }
	          },
	          this.props.label
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.desktopShowModal === true && !this.state.open) {
	        this.onClick();
	      } else if (this.props.desktopShowModal === false && this.state.open) {
	        ReactStripeCheckout.stripeHandler.close();
	      }
	
	      var ComponentClass = this.props.ComponentClass;
	
	      if (this.props.children) {
	        return _react2.default.createElement(ComponentClass, _extends({}, _defineProperty({}, this.props.triggerEvent, this.onClick), {
	          children: this.props.children
	        }));
	      }
	      return this.props.disabled ? this.renderDisabledButton() : this.renderDefaultStripeButton();
	    }
	  }]);
	
	  return ReactStripeCheckout;
	}(_react2.default.Component);
	
	ReactStripeCheckout.defaultProps = {
	  className: 'StripeCheckout',
	  label: 'Pay With Card',
	  locale: 'auto',
	  ComponentClass: 'span',
	  reconfigureOnUpdate: false,
	  triggerEvent: 'onClick'
	};
	ReactStripeCheckout.propTypes = {
	  // Opens / closes the checkout modal by value
	  // WARNING: does not work on mobile due to browser security restrictions
	  // NOTE: Must be set to false when receiving token to prevent modal from
	  //       opening automatically after closing
	  desktopShowModal: _propTypes2.default.bool,
	
	  triggerEvent: _propTypes2.default.oneOf(['onClick', 'onTouchTap', 'onTouchStart']),
	
	  // If included, will render the default blue button with label text.
	  // (Requires including stripe-checkout.css or adding the .styl file
	  // to your pipeline)
	  label: _propTypes2.default.string,
	
	  // Custom styling for default button
	  style: _propTypes2.default.object,
	  // Custom styling for <span> tag inside default button
	  textStyle: _propTypes2.default.object,
	
	  // Prevents any events from opening the popup
	  // Adds the disabled prop to the button and adjusts the styling as well
	  disabled: _propTypes2.default.bool,
	
	  // Named component to wrap button (eg. div)
	  ComponentClass: _propTypes2.default.string,
	
	  // Show a loading indicator
	  showLoadingDialog: _propTypes2.default.func,
	  // Hide the loading indicator
	  hideLoadingDialog: _propTypes2.default.func,
	
	  // Run this method when the scrupt fails to load. Will run if the internet
	  // connection is offline when attemting to load the script.
	  onScriptError: _propTypes2.default.func,
	
	  // Runs when the script tag is created, but before it is added to the DOM
	  onScriptTagCreated: _propTypes2.default.func,
	
	  // By default, any time the React component is updated, it will call
	  // StripeCheckout.configure, which may result in additional XHR calls to the
	  // stripe API.  If you know the first configuration is all you need, you
	  // can set this to false.  Subsequent updates will affect the StripeCheckout.open
	  // (e.g. different prices)
	  reconfigureOnUpdate: _propTypes2.default.bool,
	
	  // =====================================================
	  // Required by stripe
	  // see Stripe docs for more info:
	  //   https://stripe.com/docs/checkout#integration-custom
	  // =====================================================
	
	  // Your publishable key (test or live).
	  // can't use "key" as a prop in react, so have to change the keyname
	  stripeKey: _propTypes2.default.string.isRequired,
	
	  // The callback to invoke when the Checkout process is complete.
	  //   function(token)
	  //     token is the token object created.
	  //     token.id can be used to create a charge or customer.
	  //     token.email contains the email address entered by the user.
	  token: _propTypes2.default.func.isRequired,
	
	  // ==========================
	  // Highly Recommended Options
	  // ==========================
	
	  // Name of the company or website.
	  name: _propTypes2.default.string,
	
	  // A description of the product or service being purchased.
	  description: _propTypes2.default.string,
	
	  // A relative URL pointing to a square image of your brand or product. The
	  // recommended minimum size is 128x128px. The recommended image types are
	  // .gif, .jpeg, and .png.
	  image: _propTypes2.default.string,
	
	  // The amount (in cents) that's shown to the user. Note that you will still
	  // have to explicitly include it when you create a charge using the API.
	  amount: _propTypes2.default.number,
	
	  // Specify auto to display Checkout in the user's preferred language, if
	  // available. English will be used by default.
	  //
	  // https://stripe.com/docs/checkout#supported-languages
	  // for more info.
	  locale: _propTypes2.default.oneOf(['auto', // (Default) Automatically chosen by checkout
	  'zh', // Simplified Chinese
	  'da', // Danish
	  'nl', // Dutch
	  'en', // English
	  'fr', // French
	  'de', // German
	  'it', // Italian
	  'ja', // Japanease
	  'no', // Norwegian
	  'es', // Spanish
	  'sv']),
	
	  // ==============
	  // Optional Props
	  // ==============
	
	  // The currency of the amount (3-letter ISO code). The default is USD.
	  currency: _propTypes2.default.oneOf(['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', // eslint-disable-line comma-spacing
	  'BDT', 'BGN', 'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BWP', 'BZD', 'CAD', 'CDF', // eslint-disable-line comma-spacing
	  'CHF', 'CLP', 'CNY', 'COP', 'CRC', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EEK', // eslint-disable-line comma-spacing
	  'EGP', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', // eslint-disable-line comma-spacing
	  'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'ISK', 'JMD', 'JPY', 'KES', // eslint-disable-line comma-spacing
	  'KGS', 'KHR', 'KMF', 'KRW', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LTL', // eslint-disable-line comma-spacing
	  'LVL', 'MAD', 'MDL', 'MGA', 'MKD', 'MNT', 'MOP', 'MRO', 'MUR', 'MVR', 'MWK', 'MXN', // eslint-disable-line comma-spacing
	  'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'PAB', 'PEN', 'PGK', 'PHP', // eslint-disable-line comma-spacing
	  'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SEK', // eslint-disable-line comma-spacing
	  'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'STD', 'SVC', 'SZL', 'THB', 'TJS', 'TOP', 'TRY', // eslint-disable-line comma-spacing
	  'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'UYU', 'UZS', 'VND', 'VUV', 'WST', 'XAF', // eslint-disable-line comma-spacing
	  'XCD', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMW']),
	
	  // The label of the payment button in the Checkout form (e.g. “Subscribe”,
	  // “Pay {{amount}}”, etc.). If you include {{amount}}, it will be replaced
	  // by the provided amount. Otherwise, the amount will be appended to the
	  // end of your label.
	  panelLabel: _propTypes2.default.string,
	
	  // Specify whether Checkout should validate the billing ZIP code (true or
	  // false)
	  zipCode: _propTypes2.default.bool,
	
	  // Specify whether Checkout should collect the user's billing address
	  // (true or false). The default is false.
	  billingAddress: _propTypes2.default.bool,
	
	  // Specify whether Checkout should collect the user's shipping address
	  // (true or false). The default is false.
	  shippingAddress: _propTypes2.default.bool,
	
	  // Specify whether Checkout should validate the billing ZIP code (true or
	  // false). The default is false.
	  email: _propTypes2.default.string,
	
	  // Specify whether to include the option to "Remember Me" for future
	  // purchases (true or false). The default is true.
	  allowRememberMe: _propTypes2.default.bool,
	
	  // Specify whether to accept Bitcoin in Checkout. The default is false.
	  bitcoin: _propTypes2.default.bool,
	
	  // Specify whether to accept Alipay ('auto', true, or false). The default
	  // is false.
	  alipay: _propTypes2.default.oneOf(['auto', true, false]),
	
	  // Specify if you need reusable access to the customer's Alipay account
	  // (true or false). The default is false.
	  alipayReusable: _propTypes2.default.bool,
	
	  // function() The callback to invoke when Checkout is opened (not supported
	  // in IE6 and IE7).
	  opened: _propTypes2.default.func,
	
	  // function() The callback to invoke when Checkout is closed (not supported
	  // in IE6 and IE7).
	  closed: _propTypes2.default.func
	};
	ReactStripeCheckout._isMounted = false;
	exports.default = ReactStripeCheckout;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(407);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      elementRef = props.elementRef,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      onBlur = props.onBlur,
	      onReady = props.onReady,
	      options = _objectWithoutProperties(props, ['id', 'className', 'elementRef', 'onChange', 'onFocus', 'onBlur', 'onReady']);
	
	  return options;
	};
	
	var Element = function Element(type) {
	  var _class, _temp;
	
	  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.handleRef = function (ref) {
	        _this._ref = ref;
	      };
	
	      _this._element = null;
	
	      var options = _extractOptions(_this.props);
	      // We keep track of the extracted options on this._options to avoid re-rendering.
	      // (We would unnecessarily re-render if we were tracking them with state.)
	      _this._options = options;
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.context.addElementsLoadListener(function (elements) {
	        var element = elements.create(type, _this2._options);
	        _this2._element = element;
	
	        _this2._setupEventListeners(element);
	
	        element.mount(_this2._ref);
	        if (hocOptions.sourceType) {
	          _this2.context.registerElement(hocOptions.sourceType, element);
	        }
	      });
	    };
	
	    _class.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var options = _extractOptions(nextProps);
	      if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	        this._options = options;
	        if (this._element) {
	          this._element.update(options);
	        }
	      }
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this._element) {
	        var element = this._element;
	        element.destroy();
	        this.context.unregisterElement(element);
	      }
	    };
	
	    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
	      var _this3 = this;
	
	      element.on('ready', function () {
	        if (_this3.props.elementRef) {
	          if (window.console && window.console.warn) {
	            console.warn("'elementRef()' is deprecated and will be removed in a future version of react-stripe-elements. Please use 'onReady()' instead.");
	          }
	          _this3.props.elementRef(_this3._element);
	        }
	        _this3.props.onReady(_this3._element);
	      });
	
	      element.on('change', function (change) {
	        _this3.props.onChange(change);
	      });
	
	      element.on('blur', function () {
	        var _props;
	
	        return (_props = _this3.props).onBlur.apply(_props, arguments);
	      });
	      element.on('focus', function () {
	        var _props2;
	
	        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
	      });
	    };
	
	    _class.prototype.render = function render() {
	      return _react2.default.createElement('div', {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.handleRef
	      });
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    elementRef: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onReady: _propTypes2.default.func
	  }, _class.defaultProps = {
	    id: undefined,
	    className: undefined,
	    elementRef: undefined,
	    onChange: noop,
	    onBlur: noop,
	    onFocus: noop,
	    onReady: noop
	  }, _class.contextTypes = _Elements.elementContextTypes, _temp;
	};
	
	exports.default = Element;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(407);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      elementRef = props.elementRef,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onReady = props.onReady,
	      paymentRequest = props.paymentRequest,
	      options = _objectWithoutProperties(props, ['id', 'className', 'elementRef', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);
	
	  return options;
	};
	
	var PaymentRequestButtonElement = function (_React$Component) {
	  _inherits(PaymentRequestButtonElement, _React$Component);
	
	  function PaymentRequestButtonElement(props, context) {
	    _classCallCheck(this, PaymentRequestButtonElement);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRef = function (ref) {
	      _this._ref = ref;
	    };
	
	    var options = _extractOptions(props);
	    // We keep track of the extracted options on this._options to avoid re-rendering.
	    // (We would unnecessarily re-render if we were tracking them with state.)
	    _this._options = options;
	    return _this;
	  }
	
	  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.context.addElementsLoadListener(function (elements) {
	      _this2._element = elements.create('paymentRequestButton', _extends({
	        paymentRequest: _this2.props.paymentRequest
	      }, _this2._options));
	      _this2._element.on('ready', function () {
	        if (_this2.props.elementRef) {
	          if (window.console && window.console.warn) {
	            console.warn("'elementRef()' is deprecated and will be removed in a future version of react-stripe-elements. Please use 'onReady()' instead.");
	          }
	          _this2.props.elementRef(_this2._element);
	        }
	        _this2.props.onReady(_this2._element);
	      });
	      _this2._element.on('focus', function () {
	        var _props;
	
	        return (_props = _this2.props).onFocus.apply(_props, arguments);
	      });
	      _this2._element.on('click', function () {
	        var _props2;
	
	        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
	      });
	      _this2._element.on('blur', function () {
	        var _props3;
	
	        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
	      });
	      _this2._element.mount(_this2._ref);
	    });
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.paymentRequest !== nextProps.paymentRequest) {
	      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
	    }
	    var options = _extractOptions(nextProps);
	    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	      this._options = options;
	      this._element.update(options);
	    }
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._element.destroy();
	  };
	
	  PaymentRequestButtonElement.prototype.render = function render() {
	    return _react2.default.createElement('div', {
	      id: this.props.id,
	      className: this.props.className,
	      ref: this.handleRef
	    });
	  };
	
	  return PaymentRequestButtonElement;
	}(_react2.default.Component);
	
	PaymentRequestButtonElement.propTypes = {
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  elementRef: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  paymentRequest: _propTypes2.default.shape({
	    canMakePayment: _propTypes2.default.func.isRequired,
	    on: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	PaymentRequestButtonElement.defaultProps = {
	  id: undefined,
	  className: undefined,
	  elementRef: undefined,
	  onBlur: noop,
	  onClick: noop,
	  onFocus: noop,
	  onReady: noop
	};
	PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
	exports.default = PaymentRequestButtonElement;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Elements = __webpack_require__(114);
	
	var _Provider = __webpack_require__(168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
	// not sure if we need to do the same.
	var inject = function inject(WrappedComponent) {
	  var _class, _temp;
	
	  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _componentOptions$wit = componentOptions.withRef,
	      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;
	
	
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      if (!context || !context.getRegisteredElements) {
	        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
	      }
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.findElement = function (specifiedType) {
	        var allElements = _this.context.getRegisteredElements();
	        var matchingElements = specifiedType === 'auto' ? allElements : allElements.filter(function (_ref) {
	          var type = _ref.type;
	          return type === specifiedType;
	        });
	
	        if (matchingElements.length === 1) {
	          return matchingElements[0].element;
	        } else if (matchingElements.length > 1) {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        } else {
	          return null;
	        }
	      };
	
	      _this.requireElement = function (specifiedType) {
	        var element = _this.findElement(specifiedType);
	        if (element) {
	          return element;
	        } else {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        }
	      };
	
	      _this.wrappedCreateToken = function (stripe) {
	        return function () {
	          var typeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	          if (typeOrOptions && (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) === 'object') {
	            var type = typeOrOptions.type,
	                rest = _objectWithoutProperties(typeOrOptions, ['type']);
	
	            var specifiedType = typeof type === 'string' ? type : 'auto';
	            var element = _this.requireElement(specifiedType);
	            return stripe.createToken(element, rest);
	          } else if (typeof typeOrOptions === 'string') {
	            return stripe.createToken(typeOrOptions, options);
	          } else {
	            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreateSource = function (stripe) {
	        return function () {
	          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            var type = options.type,
	                rest = _objectWithoutProperties(options, ['type']); // eslint-disable-line no-unused-vars
	
	
	            var specifiedType = typeof type === 'string' ? type : 'auto';
	            var element = _this.findElement(specifiedType);
	            if (element) {
	              return stripe.createSource(element, rest);
	            } else if (specifiedType !== 'auto') {
	              return stripe.createSource(options);
	            } else {
	              throw new Error('You did not specify the type of Source to create.\n          We also could not find any Elements in the current context.');
	            }
	          } else {
	            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
	          }
	        };
	      };
	
	      if (_this.context.tag === 'sync') {
	        _this.state = {
	          stripe: _this.stripeProps(_this.context.stripe)
	        };
	      } else {
	        _this.state = {
	          stripe: null
	        };
	      }
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (this.context.tag === 'async') {
	        this.context.addStripeLoadListener(function (stripe) {
	          _this2.setState({
	            stripe: _this2.stripeProps(stripe)
	          });
	        });
	      } else {
	        // when 'sync', it's already set in the constructor.
	      }
	    };
	
	    _class.prototype.getWrappedInstance = function getWrappedInstance() {
	      if (!withRef) {
	        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
	      }
	      return this.wrappedInstance;
	    };
	
	    _class.prototype.stripeProps = function stripeProps(stripe) {
	      return _extends({}, stripe, {
	        // These are the only functions that take elements.
	        createToken: this.wrappedCreateToken(stripe),
	        createSource: this.wrappedCreateSource(stripe)
	      });
	    };
	    // Finds the element by the specified type. Throws if multiple Elements match.
	
	    // Require that exactly one Element is found.
	
	
	    // createToken has a bit of an unusual method signature for legacy reasons
	    // -- we're allowed to pass in the token type OR the element as the first parameter,
	    // so we need to check if we're passing in a string as the first parameter and
	    // just pass through the options if that's the case.
	
	
	    _class.prototype.render = function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	        stripe: this.state.stripe,
	        ref: withRef ? function (c) {
	          _this3.wrappedInstance = c;
	        } : null
	      }));
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
	};
	
	exports.default = inject;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(81);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(795);
	var ReactElement = __webpack_require__(80);
	
	var emptyFunction = __webpack_require__(39);
	var traverseAllChildren = __webpack_require__(805);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(80);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(80),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(357);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(408),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(80),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(411);
	var factory = __webpack_require__(173);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(81);
	
	var ReactElement = __webpack_require__(80);
	
	var invariant = __webpack_require__(9);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(81);
	
	var ReactCurrentOwner = __webpack_require__(51);
	var REACT_ELEMENT_TYPE = __webpack_require__(410);
	
	var getIteratorFn = __webpack_require__(801);
	var invariant = __webpack_require__(9);
	var KeyEscapeUtils = __webpack_require__(794);
	var warning = __webpack_require__(15);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(81),
	    _assign = __webpack_require__(18);
	
	var invariant = __webpack_require__(9);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return _assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = '$push';
	var COMMAND_UNSHIFT = '$unshift';
	var COMMAND_SPLICE = '$splice';
	var COMMAND_SET = '$set';
	var COMMAND_MERGE = '$merge';
	var COMMAND_APPLY = '$apply';
	
	var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function (command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : _prodInvariant('1', command, value) : void 0;
	  var specValue = spec[command];
	  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?', command, specValue) : _prodInvariant('2', command, specValue) : void 0;
	}
	
	/**
	 * Returns a updated shallow copy of an object without mutating the original.
	 * See https://facebook.github.io/react/docs/update.html for details.
	 */
	function update(value, spec) {
	  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : _prodInvariant('3', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : void 0;
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : _prodInvariant('4', COMMAND_SET) : void 0;
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : _prodInvariant('5', COMMAND_MERGE, mergeObj) : void 0;
	    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : _prodInvariant('6', COMMAND_MERGE, nextValue) : void 0;
	    _assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function (item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function (item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : _prodInvariant('7', COMMAND_SPLICE, value) : void 0;
	    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	    spec[COMMAND_SPLICE].forEach(function (args) {
	      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : _prodInvariant('9', COMMAND_APPLY, spec[COMMAND_APPLY]) : void 0;
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(413);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(414);
	
	var _isPlainObject = __webpack_require__(139);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	(function () {
	  var out$ = typeof exports != 'undefined' && exports || "function" != 'undefined' && {} || this || window;
	  if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return out$;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  var xmlns = 'http://www.w3.org/2000/xmlns/';
	  var doctype = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [<!ENTITY nbsp "&#160;">]>';
	  var urlRegex = /url\(["']?(.+?)["']?\)/;
	  var fontFormats = {
	    woff2: 'font/woff2',
	    woff: 'font/woff',
	    otf: 'application/x-font-opentype',
	    ttf: 'application/x-font-ttf',
	    eot: 'application/vnd.ms-fontobject',
	    sfnt: 'application/font-sfnt',
	    svg: 'image/svg+xml'
	  };
	
	  var isElement = function isElement(obj) {
	    return obj instanceof HTMLElement || obj instanceof SVGElement;
	  };
	  var requireDomNode = function requireDomNode(el) {
	    if (!isElement(el)) throw new Error('an HTMLElement or SVGElement is required; got ' + el);
	  };
	  var isExternal = function isExternal(url) {
	    return url && url.lastIndexOf('http', 0) === 0 && url.lastIndexOf(window.location.host) === -1;
	  };
	
	  var getFontMimeTypeFromUrl = function getFontMimeTypeFromUrl(fontUrl) {
	    var formats = Object.keys(fontFormats).filter(function (extension) {
	      return fontUrl.indexOf('.' + extension) > 0;
	    }).map(function (extension) {
	      return fontFormats[extension];
	    });
	    if (formats) return formats[0];
	    console.error('Unknown font format for ' + fontUrl + '. Fonts may not be working correctly.');
	    return 'application/octet-stream';
	  };
	
	  var arrayBufferToBase64 = function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    for (var i = 0; i < bytes.byteLength; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }return window.btoa(binary);
	  };
	
	  var getDimension = function getDimension(el, clone, dim) {
	    var v = el.viewBox && el.viewBox.baseVal && el.viewBox.baseVal[dim] || clone.getAttribute(dim) !== null && !clone.getAttribute(dim).match(/%$/) && parseInt(clone.getAttribute(dim)) || el.getBoundingClientRect()[dim] || parseInt(clone.style[dim]) || parseInt(window.getComputedStyle(el).getPropertyValue(dim));
	    return typeof v === 'undefined' || v === null || isNaN(parseFloat(v)) ? 0 : v;
	  };
	
	  var getDimensions = function getDimensions(el, clone, width, height) {
	    if (el.tagName === 'svg') return {
	      width: width || getDimension(el, clone, 'width'),
	      height: height || getDimension(el, clone, 'height')
	    };else if (el.getBBox) {
	      var _el$getBBox = el.getBBox(),
	          x = _el$getBBox.x,
	          y = _el$getBBox.y,
	          _width = _el$getBBox.width,
	          _height = _el$getBBox.height;
	
	      return {
	        width: x + _width,
	        height: y + _height
	      };
	    }
	  };
	
	  var reEncode = function reEncode(data) {
	    return decodeURIComponent(encodeURIComponent(data).replace(/%([0-9A-F]{2})/g, function (match, p1) {
	      var c = String.fromCharCode('0x' + p1);
	      return c === '%' ? '%25' : c;
	    }));
	  };
	
	  var uriToBlob = function uriToBlob(uri) {
	    var byteString = window.atob(uri.split(',')[1]);
	    var mimeString = uri.split(',')[0].split(':')[1].split(';')[0];
	    var buffer = new ArrayBuffer(byteString.length);
	    var intArray = new Uint8Array(buffer);
	    for (var i = 0; i < byteString.length; i++) {
	      intArray[i] = byteString.charCodeAt(i);
	    }
	    return new Blob([buffer], { type: mimeString });
	  };
	
	  var query = function query(el, selector) {
	    if (!selector) return;
	    try {
	      return el.querySelector(selector) || el.parentNode && el.parentNode.querySelector(selector);
	    } catch (err) {
	      console.warn('Invalid CSS selector "' + selector + '"', err);
	    }
	  };
	
	  var detectCssFont = function detectCssFont(rule, href) {
	    // Match CSS font-face rules to external links.
	    // @font-face {
	    //   src: local('Abel'), url(https://fonts.gstatic.com/s/abel/v6/UzN-iejR1VoXU2Oc-7LsbvesZW2xOQ-xsNqO47m55DA.woff2);
	    // }
	    var match = rule.cssText.match(urlRegex);
	    var url = match && match[1] || '';
	    if (!url || url.match(/^data:/) || url === 'about:blank') return;
	    var fullUrl = url.startsWith('../') ? href + '/../' + url : url.startsWith('./') ? href + '/.' + url : url;
	    return {
	      text: rule.cssText,
	      format: getFontMimeTypeFromUrl(fullUrl),
	      url: fullUrl
	    };
	  };
	
	  var inlineImages = function inlineImages(el) {
	    return Promise.all(Array.from(el.querySelectorAll('image')).map(function (image) {
	      var href = image.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || image.getAttribute('href');
	      if (!href) return Promise.resolve(null);
	      if (isExternal(href)) {
	        href += (href.indexOf('?') === -1 ? '?' : '&') + 't=' + new Date().valueOf();
	      }
	      return new Promise(function (resolve, reject) {
	        var canvas = document.createElement('canvas');
	        var img = new Image();
	        img.crossOrigin = 'anonymous';
	        img.src = href;
	        img.onerror = function () {
	          return reject(new Error('Could not load ' + href));
	        };
	        img.onload = function () {
	          canvas.width = img.width;
	          canvas.height = img.height;
	          canvas.getContext('2d').drawImage(img, 0, 0);
	          image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', canvas.toDataURL('image/png'));
	          resolve(true);
	        };
	      });
	    }));
	  };
	
	  var cachedFonts = {};
	  var inlineFonts = function inlineFonts(fonts) {
	    return Promise.all(fonts.map(function (font) {
	      return new Promise(function (resolve, reject) {
	        if (cachedFonts[font.url]) return resolve(cachedFonts[font.url]);
	
	        var req = new XMLHttpRequest();
	        req.addEventListener('load', function () {
	          // TODO: it may also be worth it to wait until fonts are fully loaded before
	          // attempting to rasterize them. (e.g. use https://developer.mozilla.org/en-US/docs/Web/API/FontFaceSet)
	          var fontInBase64 = arrayBufferToBase64(req.response);
	          var fontUri = font.text.replace(urlRegex, 'url("data:' + font.format + ';base64,' + fontInBase64 + '")') + '\n';
	          cachedFonts[font.url] = fontUri;
	          resolve(fontUri);
	        });
	        req.addEventListener('error', function (e) {
	          console.warn('Failed to load font from: ' + font.url, e);
	          cachedFonts[font.url] = null;
	          resolve(null);
	        });
	        req.addEventListener('abort', function (e) {
	          console.warn('Aborted loading font from: ' + font.url, e);
	          resolve(null);
	        });
	        req.open('GET', font.url);
	        req.responseType = 'arraybuffer';
	        req.send();
	      });
	    })).then(function (fontCss) {
	      return fontCss.filter(function (x) {
	        return x;
	      }).join('');
	    });
	  };
	
	  var cachedRules = null;
	  var styleSheetRules = function styleSheetRules() {
	    if (cachedRules) return cachedRules;
	    return cachedRules = Array.from(document.styleSheets).map(function (sheet) {
	      try {
	        return { rules: sheet.cssRules, href: sheet.href };
	      } catch (e) {
	        console.warn('Stylesheet could not be loaded: ' + sheet.href, e);
	        return {};
	      }
	    });
	  };
	
	  var inlineCss = function inlineCss(el, options) {
	    var _ref = options || {},
	        selectorRemap = _ref.selectorRemap,
	        modifyStyle = _ref.modifyStyle,
	        modifyCss = _ref.modifyCss,
	        fonts = _ref.fonts;
	
	    var generateCss = modifyCss || function (selector, properties) {
	      var sel = selectorRemap ? selectorRemap(selector) : selector;
	      var props = modifyStyle ? modifyStyle(properties) : properties;
	      return sel + '{' + props + '}\n';
	    };
	    var css = [];
	    var detectFonts = typeof fonts === 'undefined';
	    var fontList = fonts || [];
	    styleSheetRules().forEach(function (_ref2) {
	      var rules = _ref2.rules,
	          href = _ref2.href;
	
	      if (!rules) return;
	      Array.from(rules).forEach(function (rule) {
	        if (typeof rule.style != 'undefined') {
	          if (query(el, rule.selectorText)) css.push(generateCss(rule.selectorText, rule.style.cssText));else if (detectFonts && rule.cssText.match(/^@font-face/)) {
	            var font = detectCssFont(rule, href);
	            if (font) fontList.push(font);
	          } else css.push(rule.cssText);
	        }
	      });
	    });
	
	    return inlineFonts(fontList).then(function (fontCss) {
	      return css.join('\n') + fontCss;
	    });
	  };
	
	  out$.prepareSvg = function (el, options, done) {
	    requireDomNode(el);
	
	    var _ref3 = options || {},
	        _ref3$left = _ref3.left,
	        left = _ref3$left === undefined ? 0 : _ref3$left,
	        _ref3$top = _ref3.top,
	        top = _ref3$top === undefined ? 0 : _ref3$top,
	        w = _ref3.width,
	        h = _ref3.height,
	        _ref3$scale = _ref3.scale,
	        scale = _ref3$scale === undefined ? 1 : _ref3$scale,
	        _ref3$responsive = _ref3.responsive,
	        responsive = _ref3$responsive === undefined ? false : _ref3$responsive;
	
	    return inlineImages(el).then(function () {
	      var clone = el.cloneNode(true);
	
	      var _ref4 = options || {},
	          _ref4$backgroundColor = _ref4.backgroundColor,
	          backgroundColor = _ref4$backgroundColor === undefined ? 'transparent' : _ref4$backgroundColor;
	
	      clone.style.backgroundColor = backgroundColor;
	
	      var _getDimensions = getDimensions(el, clone, w, h),
	          width = _getDimensions.width,
	          height = _getDimensions.height;
	
	      if (el.tagName !== 'svg') {
	        if (el.getBBox) {
	          clone.setAttribute('transform', clone.getAttribute('transform').replace(/translate\(.*?\)/, ''));
	          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	          svg.appendChild(clone);
	          clone = svg;
	        } else {
	          console.error('Attempted to render non-SVG element', el);
	          return;
	        }
	      }
	
	      clone.setAttribute('version', '1.1');
	      clone.setAttribute('viewBox', [left, top, width, height].join(' '));
	      if (!clone.getAttribute('xmlns')) clone.setAttributeNS(xmlns, 'xmlns', 'http://www.w3.org/2000/svg');
	      if (!clone.getAttribute('xmlns:xlink')) clone.setAttributeNS(xmlns, 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
	
	      if (responsive) {
	        clone.removeAttribute('width');
	        clone.removeAttribute('height');
	        clone.setAttribute('preserveAspectRatio', 'xMinYMin meet');
	      } else {
	        clone.setAttribute('width', width * scale);
	        clone.setAttribute('height', height * scale);
	      }
	
	      Array.from(clone.querySelectorAll('foreignObject > *')).forEach(function (foreignObject) {
	        if (!foreignObject.getAttribute('xmlns')) foreignObject.setAttributeNS(xmlns, 'xmlns', 'http://www.w3.org/1999/xhtml');
	      });
	
	      return inlineCss(el, options).then(function (css) {
	        var style = document.createElement('style');
	        style.setAttribute('type', 'text/css');
	        style.innerHTML = '<![CDATA[\n' + css + '\n]]>';
	
	        var defs = document.createElement('defs');
	        defs.appendChild(style);
	        clone.insertBefore(defs, clone.firstChild);
	
	        var outer = document.createElement('div');
	        outer.appendChild(clone);
	        var src = outer.innerHTML.replace(/NS\d+:href/gi, 'xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href');
	
	        if (typeof done === 'function') done(src, width, height);else return { src: src, width: width, height: height };
	      });
	    });
	  };
	
	  out$.svgAsDataUri = function (el, options, done) {
	    requireDomNode(el);
	    var result = out$.prepareSvg(el, options).then(function (_ref5) {
	      var src = _ref5.src;
	      return 'data:image/svg+xml;base64,' + window.btoa(reEncode(doctype + src));
	    });
	    if (typeof done === 'function') return result.then(done);
	    return result;
	  };
	
	  out$.svgAsPngUri = function (el, options, done) {
	    requireDomNode(el);
	
	    var _ref6 = options || {},
	        _ref6$encoderType = _ref6.encoderType,
	        encoderType = _ref6$encoderType === undefined ? 'image/png' : _ref6$encoderType,
	        _ref6$encoderOptions = _ref6.encoderOptions,
	        encoderOptions = _ref6$encoderOptions === undefined ? 0.8 : _ref6$encoderOptions,
	        canvg = _ref6.canvg;
	
	    var convertToPng = function convertToPng(_ref7) {
	      var src = _ref7.src,
	          width = _ref7.width,
	          height = _ref7.height;
	
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      var pixelRatio = window.devicePixelRatio || 1;
	
	      canvas.width = width * pixelRatio;
	      canvas.height = height * pixelRatio;
	      canvas.style.width = canvas.width + 'px';
	      canvas.style.height = canvas.height + 'px';
	      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
	
	      if (canvg) canvg(canvas, src);else context.drawImage(src, 0, 0);
	
	      var png = void 0;
	      try {
	        png = canvas.toDataURL(encoderType, encoderOptions);
	      } catch (e) {
	        if (typeof SecurityError !== 'undefined' && e instanceof SecurityError || e.name === 'SecurityError') {
	          console.error('Rendered SVG images cannot be downloaded in this browser.');
	          return;
	        } else throw e;
	      }
	      if (typeof done === 'function') done(png);
	      return Promise.resolve(png);
	    };
	
	    if (canvg) return out$.prepareSvg(el, options).then(convertToPng);else return out$.svgAsDataUri(el, options).then(function (uri) {
	      return new Promise(function (resolve, reject) {
	        var image = new Image();
	        image.onload = function () {
	          return resolve(convertToPng({
	            src: image,
	            width: image.width,
	            height: image.height
	          }));
	        };
	        image.onerror = function () {
	          reject('There was an error loading the data URI as an image on the following SVG\n' + window.atob(uri.slice(26)) + 'Open the following link to see browser\'s diagnosis\n' + uri);
	        };
	        image.src = uri;
	      });
	    });
	  };
	
	  out$.download = function (name, uri) {
	    if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(uriToBlob(uri), name);else {
	      var saveLink = document.createElement('a');
	      if ('download' in saveLink) {
	        saveLink.download = name;
	        saveLink.style.display = 'none';
	        document.body.appendChild(saveLink);
	        try {
	          var blob = uriToBlob(uri);
	          var url = URL.createObjectURL(blob);
	          saveLink.href = url;
	          saveLink.onclick = function () {
	            return requestAnimationFrame(function () {
	              return URL.revokeObjectURL(url);
	            });
	          };
	        } catch (e) {
	          console.warn('This browser does not support object URLs. Falling back to string URL.');
	          saveLink.href = uri;
	        }
	        saveLink.click();
	        document.body.removeChild(saveLink);
	      } else {
	        window.open(uri, '_temp', 'menubar=no,toolbar=no,status=no');
	      }
	    }
	  };
	
	  out$.saveSvg = function (el, name, options) {
	    requireDomNode(el);
	    out$.svgAsDataUri(el, options || {}, function (uri) {
	      return out$.download(name, uri);
	    });
	  };
	
	  out$.saveSvgAsPng = function (el, name, options) {
	    requireDomNode(el);
	    out$.svgAsPngUri(el, options || {}, function (uri) {
	      return out$.download(name, uri);
	    });
	  };
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),
/* 813 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(454);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(814)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=compressed&includePaths[]=%2FVolumes%2Fgitws%2FGroGuru.git%2Ffrontyard%2Fnode_modules&includePaths[]=%2FVolumes%2Fgitws%2FGroGuru.git%2Ffrontyard%2Fnode_modules%2Fgrommet%2Fnode_modules!./index.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=compressed&includePaths[]=%2FVolumes%2Fgitws%2FGroGuru.git%2Ffrontyard%2Fnode_modules&includePaths[]=%2FVolumes%2Fgitws%2FGroGuru.git%2Ffrontyard%2Fnode_modules%2Fgrommet%2Fnode_modules!./index.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	function Agent() {
	  this._defaults = [];
	}
	
	["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
	 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
	  /** Default setting for all requests from this agent */
	  Agent.prototype[fn] = function(/*varargs*/) {
	    this._defaults.push({fn:fn, arguments:arguments});
	    return this;
	  }
	});
	
	Agent.prototype._setDefaults = function(req) {
	    this._defaults.forEach(function(def) {
	      req[def.fn].apply(req, def.arguments);
	    });
	};
	
	module.exports = Agent;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(418);
	
	/**
	 * Expose `RequestBase`.
	 */
	
	module.exports = RequestBase;
	
	/**
	 * Initialize a new `RequestBase`.
	 *
	 * @api public
	 */
	
	function RequestBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in RequestBase.prototype) {
	    obj[key] = RequestBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.clearTimeout = function _clearTimeout(){
	  clearTimeout(this._timer);
	  clearTimeout(this._responseTimeoutTimer);
	  delete this._timer;
	  delete this._responseTimeoutTimer;
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set format of binary response body.
	 * In browser valid formats are 'blob' and 'arraybuffer',
	 * which return Blob and ArrayBuffer, respectively.
	 *
	 * In Node all values result in Buffer.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeouts.
	 *
	 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
	 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
	 *
	 * Value of 0 or false means no timeout.
	 *
	 * @param {Number|Object} ms or {response, deadline}
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.timeout = function timeout(options){
	  if (!options || 'object' !== typeof options) {
	    this._timeout = options;
	    this._responseTimeout = 0;
	    return this;
	  }
	
	  for(var option in options) {
	    switch(option) {
	      case 'deadline':
	        this._timeout = options.deadline;
	        break;
	      case 'response':
	        this._responseTimeout = options.response;
	        break;
	      default:
	        console.warn("Unknown timeout option", option);
	    }
	  }
	  return this;
	};
	
	/**
	 * Set number of retry attempts on error.
	 *
	 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
	 *
	 * @param {Number} count
	 * @param {Function} [fn]
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.retry = function retry(count, fn){
	  // Default to 1 if no count passed or true
	  if (arguments.length === 0 || count === true) count = 1;
	  if (count <= 0) count = 0;
	  this._maxRetries = count;
	  this._retries = 0;
	  this._retryCallback = fn;
	  return this;
	};
	
	var ERROR_CODES = [
	  'ECONNRESET',
	  'ETIMEDOUT',
	  'EADDRINFO',
	  'ESOCKETTIMEDOUT'
	];
	
	/**
	 * Determine if a request should be retried.
	 * (Borrowed from segmentio/superagent-retry)
	 *
	 * @param {Error} err
	 * @param {Response} [res]
	 * @returns {Boolean}
	 */
	RequestBase.prototype._shouldRetry = function(err, res) {
	  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
	    return false;
	  }
	  if (this._retryCallback) {
	    try {
	      var override = this._retryCallback(err, res);
	      if (override === true) return true;
	      if (override === false) return false;
	      // undefined falls back to defaults
	    } catch(e) {
	      console.error(e);
	    }
	  }
	  if (res && res.status && res.status >= 500 && res.status != 501) return true;
	  if (err) {
	    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
	    // Superagent timeout
	    if (err.timeout && err.code == 'ECONNABORTED') return true;
	    if (err.crossDomain) return true;
	  }
	  return false;
	};
	
	/**
	 * Retry request
	 *
	 * @return {Request} for chaining
	 * @api private
	 */
	
	RequestBase.prototype._retry = function() {
	
	  this.clearTimeout();
	
	  // node
	  if (this.req) {
	    this.req = null;
	    this.req = this.request();
	  }
	
	  this._aborted = false;
	  this.timedout = false;
	
	  return this._end();
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} [reject]
	 * @return {Request}
	 */
	
	RequestBase.prototype.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    if (this._endCalled) {
	      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
	    }
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
	      self.end(function(err, res) {
	        if (err) innerReject(err);
	        else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	};
	
	RequestBase.prototype['catch'] = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	RequestBase.prototype.use = function use(fn) {
	  fn(this);
	  return this;
	};
	
	RequestBase.prototype.ok = function(cb) {
	  if ('function' !== typeof cb) throw Error("Callback required");
	  this._okCallback = cb;
	  return this;
	};
	
	RequestBase.prototype._isResponseOK = function(res) {
	  if (!res) {
	    return false;
	  }
	
	  if (this._okCallback) {
	    return this._okCallback(res);
	  }
	
	  return res.status >= 200 && res.status < 300;
	};
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	RequestBase.prototype.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	RequestBase.prototype.getHeader = RequestBase.prototype.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	RequestBase.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	RequestBase.prototype.field = function(name, val) {
	  // name should be either a string or an object.
	  if (null === name || undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (this._data) {
	    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  if (Array.isArray(val)) {
	    for (var i in val) {
	      this.field(name, val[i]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  if ('boolean' === typeof val) {
	    val = '' + val;
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	RequestBase.prototype.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
	  switch (options.type) {
	    case 'basic':
	      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
	      break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	      break;
	
	    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
	      this.set('Authorization', 'Bearer ' + user);
	      break;
	  }
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	RequestBase.prototype.withCredentials = function(on) {
	  // This is browser-only functionality. Node side is no-op.
	  if (on == undefined) on = true;
	  this._withCredentials = on;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
	 * Default 200MB.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 */
	RequestBase.prototype.maxResponseSize = function(n){
	  if ('number' !== typeof n) {
	    throw TypeError("Invalid argument");
	  }
	  this._maxResponseSize = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	RequestBase.prototype.toJSON = function() {
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header,
	  };
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.send = function(data){
	  var isObj = isObject(data);
	  var type = this._header['content-type'];
	
	  if (this._formData) {
	    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObj && !this._data) {
	    if (Array.isArray(data)) {
	      this._data = [];
	    } else if (!this._isHost(data)) {
	      this._data = {};
	    }
	  } else if (data && this._data && this._isHost(this._data)) {
	    throw Error("Can't merge these send calls");
	  }
	
	  // merge
	  if (isObj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!isObj || this._isHost(data)) {
	    return this;
	  }
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Sort `querystring` by the sort function
	 *
	 *
	 * Examples:
	 *
	 *       // default order
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery()
	 *         .end(callback)
	 *
	 *       // customized sort function
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery(function(a, b){
	 *           return a.length - b.length;
	 *         })
	 *         .end(callback)
	 *
	 *
	 * @param {Function} sort
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.sortQuery = function(sort) {
	  // _sort default to true but otherwise can be a function or boolean
	  this._sort = typeof sort === 'undefined' ? true : sort;
	  return this;
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	RequestBase.prototype._finalizeQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
	  }
	  this._query.length = 0; // Makes the call idempotent
	
	  if (this._sort) {
	    var index = this.url.indexOf('?');
	    if (index >= 0) {
	      var queryArr = this.url.substring(index + 1).split('&');
	      if ('function' === typeof this._sort) {
	        queryArr.sort(this._sort);
	      } else {
	        queryArr.sort();
	      }
	      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
	    }
	  }
	};
	
	// For backwards compat only
	RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	RequestBase.prototype._timeoutError = function(reason, timeout, errno){
	  if (this._aborted) {
	    return;
	  }
	  var err = new Error(reason + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  err.code = 'ECONNABORTED';
	  err.errno = errno;
	  this.timedout = true;
	  this.abort();
	  this.callback(err);
	};
	
	RequestBase.prototype._setTimeouts = function() {
	  var self = this;
	
	  // deadline
	  if (this._timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
	    }, this._timeout);
	  }
	  // response timeout
	  if (this._responseTimeout && !this._responseTimeoutTimer) {
	    this._responseTimeoutTimer = setTimeout(function(){
	      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
	    }, this._responseTimeout);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var utils = __webpack_require__(819);
	
	/**
	 * Expose `ResponseBase`.
	 */
	
	module.exports = ResponseBase;
	
	/**
	 * Initialize a new `ResponseBase`.
	 *
	 * @api public
	 */
	
	function ResponseBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in ResponseBase.prototype) {
	    obj[key] = ResponseBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	ResponseBase.prototype.get = function(field) {
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	ResponseBase.prototype._setHeaderProperties = function(header){
	    // TODO: moar!
	    // TODO: make this a util
	
	    // content-type
	    var ct = header['content-type'] || '';
	    this.type = utils.type(ct);
	
	    // params
	    var params = utils.params(ct);
	    for (var key in params) this[key] = params[key];
	
	    this.links = {};
	
	    // links
	    try {
	        if (header.link) {
	            this.links = utils.parseLinks(header.link);
	        }
	    } catch (err) {
	        // ignore
	    }
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	ResponseBase.prototype._setStatusProperties = function(status){
	    var type = status / 100 | 0;
	
	    // status / class
	    this.status = this.statusCode = status;
	    this.statusType = type;
	
	    // basics
	    this.info = 1 == type;
	    this.ok = 2 == type;
	    this.redirect = 3 == type;
	    this.clientError = 4 == type;
	    this.serverError = 5 == type;
	    this.error = (4 == type || 5 == type)
	        ? this.toError()
	        : false;
	
	    // sugar
	    this.created = 201 == status;
	    this.accepted = 202 == status;
	    this.noContent = 204 == status;
	    this.badRequest = 400 == status;
	    this.unauthorized = 401 == status;
	    this.notAcceptable = 406 == status;
	    this.forbidden = 403 == status;
	    this.notFound = 404 == status;
	    this.unprocessableEntity = 422 == status;
	};


/***/ }),
/* 819 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	exports.type = function(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.params = function(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */);
	    var key = parts.shift();
	    var val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Parse Link header fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.parseLinks = function(str){
	  return str.split(/ *, */).reduce(function(obj, str){
	    var parts = str.split(/ *; */);
	    var url = parts[0].slice(1, -1);
	    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
	    obj[rel] = url;
	    return obj;
	  }, {});
	};
	
	/**
	 * Strip content related fields from `header`.
	 *
	 * @param {Object} header
	 * @return {Object} header
	 * @api private
	 */
	
	exports.cleanHeader = function(header, changesOrigin){
	  delete header['content-type'];
	  delete header['content-length'];
	  delete header['transfer-encoding'];
	  delete header['host'];
	  // secuirty
	  if (changesOrigin) {
	    delete header['authorization'];
	    delete header['cookie'];
	  }
	  return header;
	};


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(821);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(169)(module)))

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	module.exports = {XMLHttpRequest:XMLHttpRequest};

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js